webpackJsonp([0,2],{

/***/ "lVK7":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("O27J");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__("Vtlw");
	var App = __webpack_require__("pnOm");
	
	(0, _reactDom.render)(_react2.default.createElement(App, null), document.querySelector('#app'));

/***/ },

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("+prg");
	module.exports = __webpack_require__("lVK7");


/***/ },

/***/ "Vtlw":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Constructor = __webpack_require__("CqEj");
	
	var _Constructor2 = _interopRequireDefault(_Constructor);
	
	__webpack_require__("1Tgc");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (typeof __ == "undefined") {
		var locale = new _Constructor2.default();
		window.__ = locale.init();
		window.__addPrimary = locale.add;
		window.__localeName = locale.getLocale;
	}
	
	exports.default = window.__;
	module.exports = exports["default"];

/***/ },

/***/ "CqEj":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _objectPath = __webpack_require__("SeUI");
	
	var _objectPath2 = _interopRequireDefault(_objectPath);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stringTemplate = __webpack_require__("O7d8");
	
	var _stringTemplate2 = _interopRequireDefault(_stringTemplate);
	
	var _uniqid = __webpack_require__("2bpm");
	
	var _uniqid2 = _interopRequireDefault(_uniqid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * let Locale = require("./Constructor");
	 * let language = "CN";
	 * let locale = new Locale(language);
	 * window.__ = locale.init();
	 *
	 * __("Your number is {number}", "number", { number:123 });
	 *
	 * // in your CN.json
	 * {
	 *   number: {
	 *		"Your number is {number}": "你的号码是{number}。好吗？",
	 *   }
	 * }
	 *
	 *
	 */
	
	var DEFAULT_FIRST_LANGUAGE = 'EN';
	
	var PRIMARY_SECOND_LANGUAGE = 'CN';
	
	var LocaleConstructor = function () {
	  function LocaleConstructor(locale) {
	    _classCallCheck(this, LocaleConstructor);
	
	    var languageInUrl = this.getParam('language');
	
	    this.localeName = locale || languageInUrl || localStorage.getItem("language") || "EN";
	    this.domain = "";
	    this.domainData = {};
	    this.localeData = {};
	    this.domainIDs = {};
	    this.debug = false;
	
	    this.add = this.add.bind(this);
	    this.getLocale = this.getLocale.bind(this);
	
	    this.localeData = __webpack_require__(1)("./" + this.localeName);
	
	    for (var rootDomain in this.localeData) {
	      this.domainIDs[rootDomain] = (0, _uniqid2.default)();
	    }
	  }
	
	  LocaleConstructor.prototype.getParam = function getParam(name, url) {
	    if (!url) url = window.location.href;
	    name = name.replace(/[\[\]]/g, "\\$&");
	    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	        results = regex.exec(url);
	    if (!results) return null;
	    if (!results[2]) return '';
	    return decodeURIComponent(results[2].replace(/\+/g, " "));
	  };
	
	  LocaleConstructor.prototype.init = function init() {
	    localStorage.setItem("language", this.localeName);
	    return this.show.bind(this);
	  };
	
	  LocaleConstructor.prototype.add = function add(domain, id, mixin) {
	    var domainId = this.domainIDs[domain];
	    if (domainId && domainId !== id) {
	      throw new Error('Domain ' + domain + '[id=' + id + '] is already registered under id=' + domainId + '.');
	    }
	    this.domainIDs[domain] = id;
	    this.localeData[domain] = mixin;
	  };
	
	  LocaleConstructor.prototype.getLocale = function getLocale() {
	    return this.localeName || DEFAULT_FIRST_LANGUAGE;
	  };
	
	  LocaleConstructor.prototype.show = function show(str, domain, params) {
	    var translated = void 0;
	
	    if ((typeof domain === 'undefined' ? 'undefined' : _typeof(domain)) === 'object') {
	      if (domain.id && domain.text) {
	        // NEW IMPLEMENTATION
	        // domain has text and id
	        var texts = domain.text[str];
	
	        if (texts && domain.code === this.localeName) {
	          translated = texts;
	        } else {
	          translated = str;
	        }
	      } else {
	        var _texts = domain[str];
	        if ((typeof _texts === 'undefined' ? 'undefined' : _typeof(_texts)) === 'object') {
	          // incase of:
	          // {
	          //   "CN": ""
	          // }
	          translated = _texts[this.localeName];
	        } else if (typeof _texts === 'string' && this.localeName === PRIMARY_SECOND_LANGUAGE) {
	          // if there is a string and also the current locale is a primary second language (Chinese etc)
	          translated = _texts;
	        } else {
	          translated = str;
	        }
	      }
	    } else {
	
	      if (typeof domain !== "undefined") {
	        if (domain != this.domain) {
	          this.domain = domain;
	          this.domainData = _objectPath2.default.get(this.localeData, this.domain);
	        }
	      } else {
	        this.domainData = this.localeData;
	        this.domain = "main";
	      }
	
	      if (this.domainData) {
	        translated = this.domainData[str];
	      }
	    }
	
	    return (0, _stringTemplate2.default)(translated || str || "", params);
	  };
	
	  return LocaleConstructor;
	}();
	
	exports.default = LocaleConstructor;
	module.exports = exports['default'];

/***/ },

/***/ 1:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./CN": "ZJfI",
		"./CN.js": "ZJfI",
		"./CN_T": "QlXy",
		"./CN_T.js": "QlXy",
		"./EN": "pthn",
		"./EN.js": "pthn",
		"./FR": "P6Vt",
		"./FR.js": "P6Vt",
		"./KR": "PFVx",
		"./KR.js": "PFVx"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1;


/***/ },

/***/ "ZJfI":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _schedule, _header, _appwrapper, _class, _createnewclass, _classdetail, _teacher, _student, _studentdetail, _poster, _teacherAttendance;
	
	/**
	 * Chinese Simplified
	 */
	
	var locale = {
	    schedule: (_schedule = {
	        "Lesson Color": "课程颜色",
	        "Select": "选择",
	        "Same date will only create single lesson": '日期相同时创建单次课节',
	        'Class': '班级',
	        'Select Class To Add Lesson': '选择班级进行排课',
	        'Search Class': '搜索班级',
	        calendar: {
	            "month": "月课表",
	            "week": "周课表",
	            "day": "日课表",
	            "Attended": "已签到",
	            "Lesson": "课节",
	            "Previous Week": "上一周",
	            "Previous Month": "上一月",
	
	            "Next Week": "下一周",
	            "Next Month": "下一月",
	
	            "Yesterday": "昨天",
	            "Today": "今天",
	            "Tomorrow": "明天"
	
	        },
	        'Attended lesson cannot be moved': '已签到的课节不能被移动！',
	        '(Lesson {lesson_number})': '(课节 {lesson_number})',
	        'Time: {time}': '上课： {time}',
	        'Classroom: {classroom}': '教室： {classroom}',
	        'Student: {number}': '学员： {number} 人',
	        "Attended": "已签到",
	        'Unattended': '未签到',
	        'All Teachers': '所有老师',
	        'All Classes': '所有班级',
	        'All Classrooms': '所有教室',
	        'All Students': '所有学员',
	        'Add Lesson': '添加课程',
	
	        'Student': '学员',
	        'Select Student': '选择学员',
	        'Search Student': '搜索学员',
	        'Teacher': '老师',
	        'Select Teacher': '选择老师',
	        'Search Teacher': '搜索老师',
	        'Classroom': '教室',
	        'Select Classroom': '选择教室',
	        'Search Classroom': '搜索教室',
	        'Select Class': '选择班级'
	    }, _schedule["Search Class"] = '搜索班级', _schedule['There was a conflict while moving the lesson.'] = '移动课程时发生了冲突', _schedule['Conflicts'] = '冲突', _schedule['Print Schedule'] = '课表打印', _schedule),
	    header: (_header = {
	        "Change Language": "切换语言",
	        "Premium Version": "升级高级版",
	        "Privacy": '隐私政策',
	        "Settings": '查看资料',
	        "Switch School": '切换学校',
	        "Personal Settings": '个人设置',
	        "Sign Out": "登出",
	        "Payment Information": '支付信息',
	        "Please Enter Payment Information In Order To Upgrade To Permium Version ($79 USD per month per school), Invoice Will Be Sent Eletronically Via Email Every Month": '请填写您的支付信息以确保您能正常使用高级版 (每月每學校$79 USD), 我们会通过邮件发送每个月的帐单',
	        'You are about go over the school limit, please upgrade to higher subscription plan to add more schools': '您即将超出现计划包含的学校上限，请先升级至更高计划再创建更多学校。',
	        'You are about go over the teacher limit, please upgrade to higher subscription plan to add more teachers': '您即将超出现计划包含的老师上限，请先升级至更高计划再创建更多老师。',
	        'You are about go over the student limit, please upgrade to higher subscription plan to add more students': '您即将超出当前计划包含的学生上限，请先升级至更高计划再创建更多学生。',
	        'Upgrade Subscription Plan': '需要升级计划',
	        sidemenu: {
	            "My channels": "我的频道",
	            "Schedules": "课表",
	            "Students": "学员",
	            "Classes": "班级",
	            "Private Classes": "私课",
	            "Teachers": "老师",
	            "Classrooms": "教室",
	            "Announcements": "公告",
	            "Statement Detail": "收支明细",
	            "Monthly Summary": "月度汇总",
	            "School Management": "学校管理",
	            "School Administration": "教务权限",
	            "School Information": "学校信息",
	            "Sales Management": "销售管理",
	            'Posters': '海报',
	            'Contacts': '联系人'
	        },
	        panelmenu: {
	            "Administration Management": "教务管理",
	            "Financial Management": '财务管理',
	            "School Management": '学校管理',
	            "Sales Management": '营销管理',
	            'This feature is under development': '此功能正在开发中'
	        },
	        'Add Clients': '新增潜在客户',
	        '': ''
	    }, _header[""] = '', _header),
	    checkoutform: {
	        "Your purchase is successful!": "购买成功！",
	        "Email Address": "邮件地址",
	        "Credit Card": "信用卡资料",
	        "Submit Payment": "购买",
	        "Please Enter Email Address!": "必须填写邮件地址！",
	        "Pay": "确认付款"
	    },
	    appwrapper: (_appwrapper = {
	        "All field must be filled!": "请填写所有信息来创建学校",
	        "Please enter your phone number": "请输入您的手机号",
	        "Next ": '下一步 ',
	        "Verify your phone number": "验证您的手机号",
	        "Verification code can be resent in {counterTime} seconds ": "{counterTime}秒后可重新发送 ",
	        "Resend verification code": '重新发送验证码',
	        "Code": "验证码",
	        "Verification Code": "输入验证码",
	        "New Password": '新密码',
	        "Register": "注册",
	        "Send Verification Code": "发送验证码"
	    }, _appwrapper["Verify your phone number"] = "验证您的手机号", _appwrapper['Register Successful'] = '注册成功', _appwrapper['Create School'] = '创建学校', _appwrapper['School Information'] = '创建新学校必填内容', _appwrapper["School Name"] = '学校名字', _appwrapper["School Description"] = '学校简介', _appwrapper['School Type'] = '学校类型', _appwrapper['After School Class'] = '课后辅导班', _appwrapper['Pre School'] = '学前班', _appwrapper["Tutor"] = '家教', _appwrapper["The verification code is sent to: {phone}"] = '您的手机 {phone} 会收到验证短信', _appwrapper['Login account: {phone}'] = '登录账号： {phone}', _appwrapper['Public/Private School'] = '公校/私校', _appwrapper['Student Enrollment Age Limit'] = '招收学员年龄下限', _appwrapper['Years Old'] = '岁', _appwrapper['{age} year old'] = '{age} 岁', _appwrapper['{age} years old'] = '{age} 岁', _appwrapper['Country'] = '选择国家', _appwrapper['Province/States'] = '选择地区', _appwrapper['City'] = '输入城市', _appwrapper['Time Zone (Cannot Change After Saved)'] = '时区 (一旦保存不可更改)', _appwrapper['Currency (Cannot Change After Saved)'] = '货币种类 (一旦保存不可更改)', _appwrapper['Complete'] = '完成', _appwrapper['Sign In'] = '登入', _appwrapper['Forgot Password'] = '忘记密码', _appwrapper['Register New Account'] = '注册帐户', _appwrapper['Agent ID (Optional)'] = '销售人员号码 (选填)', _appwrapper['User already registered, please sign in or sign up with different phone number'] = '此用户已经存在，请登录，或用其他手机进行注册', _appwrapper['The Phone No./Password combination is not valid'] = '手机号/密码组合错误', _appwrapper['Password must be at least 6 characters'] = '密码需要超过6个字符', _appwrapper['Incorrect PIN'] = 'PIN 不正确', _appwrapper['PIN expired'] = 'PIN 过期', _appwrapper['By clicking Register, you agree to our '] = '点击「注册」即表示你同意我们的', _appwrapper['Terms of Service'] = '使用条款', _appwrapper['/terms-of-service/en'] = '/terms-of-service/cn', _appwrapper['https://base.classtop.com/terms-of-service-en.html'] = 'https://base.classtop.com/terms-of-service-cn.html', _appwrapper['Already a user?'] = '已经是用户？', _appwrapper["For better user experience, please use 'ClassTopBase' on computer or tablet."] = "为了更好地使用体验, 请在电脑上使用 ’ClassTopBase‘", _appwrapper['Or try our mobile app!'] = '或者尝试使用我们的手机程序', _appwrapper['Not a user?'] = '不是用户？', _appwrapper['Download admin app'] = '下载管理员 app', _appwrapper['Download teacher app'] = '下载老师 app', _appwrapper['Download student app'] = '下载学生 app', _appwrapper['Sign up'] = '注册', _appwrapper["Sign up successful, please download our app!"] = "注册成功，请下载我们的应用！", _appwrapper['Start Using'] = '开始使用', _appwrapper["Invalid email address!"] = "请填写正确格式的邮箱", _appwrapper['Resent in {counterTime} s'] = '{counterTime} 秒后可重发', _appwrapper['Invalid phone number!'] = '手机号格式错误', _appwrapper),
	    changeschool: {
	        "You are over the school limit, please upgrade to Premium Version and purchase additional schools": "您目前的校区已上限, 添加更多校区请升级为高级版并且购买更多校区",
	        "Create a new school ($79 USD per month per school), invoice will be sent eletronically via Email every month ": '创建新的一所学校 (每个月每学校$79 USD), 我们会通过邮件发送每个月的帐单',
	        "Cancel": '取消',
	        "Save": '确认',
	        ' Create New School': ' 创建新学校',
	        'Create School': '创建学校',
	        'School Created': '创建成功',
	        'Principal': '校长',
	        'Teacher': '老师',
	        'Decline': '拒绝',
	        'Accept': '接受',
	        'Delete School: {school_name}?': '确认删除学校: {school_name} ?',
	        " Delete": ' 删除',
	        "Exit School: {school_name}?": "确认退出学校: {school_name} ?",
	        " Exit": ' 退出',
	        'My School': '我的学校',
	        "Delete School": '删除学校',
	        " Back to My School": ' 返回我的学校',
	        '$79 USD / month per school': '每学校每个月 $79 USD',
	        'Please Enter Valid Information': '输入正确的资料',
	        'Payment Failed': '购买失败'
	
	    },
	    administration: {
	        "Permission Management for group": "权限管理",
	        "Read Students": "读取学员",
	        'Edit Students': '更改学员',
	        'Read Classes': '读取班级',
	        'Edit Classes': '更改班级',
	        'Read Teachers': '读取老师',
	        'Edit Teachers': '更改老师',
	        "Read Classrooms": '读取教室',
	        'Edit Classrooms': '更改教室',
	        'Read Finance': '读取财务',
	        "Edit Finance": '更改财务',
	        'Read Attendances': '读取签到',
	        "Edit Attendances": '更改签到',
	        "Read Lessons": '读取课节',
	        "Edit Lessons": '更改课节',
	        'Read Announcements': '读取公告',
	        'Edit Announcements': '更改公告',
	        'Read Permissions': '读取权限',
	        'Edit Permissions': '更改权限',
	        'Cannot delete this group': '无法删除角色组',
	        'Delete this group': '删除此角色组',
	        'Proceed to create new group? (all the unsaved data will be deleted)': '是否離開編輯此角色組（未储存的资料将会被删除）',
	        'Teacher Group cannot be deleted, but can edit persmisison and personnel': 'Teachers组为默认角色组，不可删除，您可以修改Teachers组的权限、增加或删除组内人员，或创建新的角色组',
	        'Delete Group {group_name} ?': '确认删除角色组：{group_name} ?',
	        'Create New Group': '创建新角色组',
	        " Edit": ' 编辑',
	        'Group Members': '角色组成员'
	    },
	    createadministration: {
	        'New Group Name': '新角色组名称',
	        "Add": '添加',
	        "Added": '已添加',
	        'Select Teacher': '选择老师',
	        'Search Teacher': '搜索老师',
	        "Add Member": '添加成员',
	        "Please enter a group name": '请填写角色组名称',
	        'Please select permissions': '请选择权限',
	        "Please select members": '请选择成员',
	        ' Back': ' 返回'
	    },
	    announcement: {
	        "All Classes and Students": '全体师生',
	        "Delete Announcement: {title}": '确认删除公告：{title} ？',
	        "Announcer: ": "发布者：",
	        'Date/Time: ': '发布时间：',
	        'Send To: ': '发布送至： ',
	        'Please enter announcement title': '请输入通告标题搜索',
	        'All': '全部',
	        'New Announcement': '新建公告',
	        'Edit Announcement': '编辑公告',
	        'Please Enter Announcement Title': '请填入公告标题后才可以发布',
	        'For: ': '公告对象: ',
	        'Title: ': '公告标题： ',
	        'Automatic Mailing (to students) and SMS (to teachers) Announcement System': '自动发邮件（针对学员）与短信（针对老师）的公告系统',
	        'Here you can create announcements for all teachers and students, as well as specific classes. When the announcement is published, the system will automatically send the announcement via email to students and SMS to teachers': '在这里您可以创建针对全体老师和学生的公告，也可针对指定班级发布公告。在您创建的公告发布的时候，系统会自动将公告内容给学生发邮件、给老师发手机短信。',
	        '': ''
	    },
	    attendance: {
	        " Attendance Record": " 签到记录"
	    },
	    class: (_class = {
	        'New Class: {new_cname} Has Been Created!': '新班级 {new_cname} 已创建！',
	        'Class: {cname} Has Been Updated!': '班级 {cname} 已更新！',
	        'Class: {cname} Has Been Archived': '班级 {cname} 已归档',
	        'Class: {cname} Has Been Unarchived': '班级 {cname} 已恢复归档',
	        'Class: {cname} Error': '班级 {cname} 操作失败',
	        'Class Status Update Failure: Network Connection Issue!': '班级状态更新失败：Network connection issue!',
	        'Class: {cname} Archived?': '确认对 {cname} 班级进行归档？',
	        'Lesson Scheduled': '已排课',
	        'Lesson Started': '已开始上课',
	        "Archived": '归档',
	        "Unarchive": '恢复归档',
	        'Select': '选择',
	        "View": '查看',
	        "Edit": '编辑',
	        'Close': '关闭班级',
	        'Search Class': '请输入关键词搜索',
	        'History': '历史班级',
	        'New Class': '新增班级',
	        'Class Name': '班级名称',
	        'Date': '日期',
	        'Lesson Amount': '课节数',
	        'Teachers': '老师',
	        'Price': "总价",
	        'Students': '学员',
	        'Past Students': '历史学员',
	        'Status': '状态',
	        'Settings': '操作',
	        'Lesson Status': '上课进度'
	    }, _class["View"] = '进入班级', _class['Add Lesson'] = '排课', _class['Attendance'] = '签到', _class['Scheduled'] = '已排课', _class['Not Scheduled'] = '未排课', _class['Closed Class'] = '已关闭班级', _class['Current Class'] = '当期班级', _class['Class List'] = '班级列表', _class['Proceed to restore class?'] = '确认恢复班级？', _class['Class Description'] = '班级简介', _class['Class Management is Suitable for all Teaching Scenarios'] = '适用于所有教学场景的班级体系', _class['Class Management allows you to create classes, schedule lessons, auditions. attendance, appoint teachers and classrooms. Each class can be designed to be billed by lesson, date, or hour to keep track of the class status. It will also remind you when there is conflict between different classes.'] = '创建班级，排课，补课，试听，签到，设置任课教师，教室。大到几千人，小到几个人。可按期，按次，按时等跟踪课程进度。智能冲突系统可有效的提醒学校资源的重叠使用。自由的排课系统满足任何您需要的班级体系。', _class),
	    createnewclass: (_createnewclass = {
	        'Create Class Failure': '班级创建失败',
	        'Class Teacher Update Failure': '班级老师更新失败',
	        'Class Student Update Failure': '班级学员更新失败',
	        'All Fields with * Must Be Filled': '带*号的字段必须填写',
	        '{i} Day Remaining': '剩余 {i} 天提醒',
	        'Notify me when...': '提醒时间',
	        '{i} Lesson Remaining': '剩余{i}节课提醒',
	        '{i} Hour Remaining': '剩余{i}小时提醒',
	        'Create New Class': '新增班级',
	        'Enter Class Name': '输入班级名称',
	        'Billing Types': '计费类型',
	        'Bill by date': '按日期计费',
	        'Bill by lessons': '按课次计费',
	        'Bill by hours': '按小时计费',
	        'Student Number': '招生人数',
	        '': '人',
	        'Lesson Completion Rules': '课消规则',
	        'Attending counts as completion': '按签到算课消',
	        'Absence (with reason) counts as completion': '请假算课消',
	        'Absence (without reason) counts as completion': '缺课算课消'
	    }, _createnewclass[""] = '', _createnewclass),
	    editclass: {
	        'Class Update Failure': '班级更新失败',
	        'Edit Class': '编辑班级',
	        'Class': '班级'
	    },
	    classdetail: (_classdetail = {
	        '1 week': '一周',
	        '2 weeks': '两周',
	        '3 weeks': '三周',
	        '4 weeks': '四周',
	        '5 weeks': '五周',
	        '6 weeks': '六周',
	
	        '1 day': '一天',
	        '2 days': '两天',
	        '3 days': '三天',
	        '4 days': '四天',
	        '5 days': '五天',
	        '6 days': '六天',
	
	        'By Week': '按周',
	        'By Day': '按天',
	        'By Month': '按月',
	        'Refund & Exit Class': '退款以及退班',
	        'Proceed to refund and remove the student, {student_name}, from class?': '确认退款以及退班({student_name}学员)吗？',
	        'Not Assigned': '未定',
	        'Attended': '出勤',
	        'Class: {cname} Has Been Updated!': '班级 {cname} 已更新！',
	        'Lesson Teacher Updated': '课节老师已更新',
	        'Lesson Teacher Update Failure': '课节老师更新失败',
	        'New Lesson: {new_name} Saved': '新课节 {new_name} 已保存',
	        'Lesson Name Update Failure': '课节名称更新失败',
	        'Lesson Deleted': '课节已删除',
	        'Lesson Delete Failure': '删除课节失败',
	        'Lesson: {lesson_name} Added': '课节: {lesson_name} 已添加',
	        'Add Lesson Failure': '添加课节失败',
	        'Student Has Exited Class': '学员已退班',
	        'Student Exit Class Failure': '学员退班失败',
	        'Student: {studnet_name} refunded {amount_of_money} {currency} successful!': '学员: {student_name} 退款 {amount_of_money} {currency} 成功！',
	        'Student: {studnet_name} added credit {amount_of_money} {currency} successful!': '学员 {student_name} 充值 {amount_of_money} {currency} 成功！',
	        'Student: {studnet_name} charged {amount_of_money} {currency} successful!': '学员 {student_name} 收费 {amount_of_money} {currency} 成功！',
	        "Delete {name}'s Lesson?": '确认删除 {name} 的课节?',
	        'Class Price': '课程总价',
	        'Payment Reminder': '欠费提醒',
	        'Past Lesson Counts': '已上课节',
	        'Enrollment Status': '招生情况',
	        'Checked In': '已签到',
	        'Check In': '签到',
	        'Remaining ': '余 ',
	        'Overdue ': '欠费 ',
	        'Exited Class': '已退班',
	        'Student Detail': '学员资料',
	        'Remarks': '备注',
	        'Exit Class': '退班',
	        'Exit Student: {name} From Class?': '确认对学员 {name} 进行退班?',
	        'Exit Teacher: {name} From Class?': '确认对老师 {name} 进行退班?',
	        'Refund and Exit Class': '退款并退班',
	        'Add Student': '添加学员',
	        'Search Students': '搜索学员名称...',
	        '{age} Years Old': '{age} 岁',
	        'Attendance': '出勤签到',
	        'Lesson Completion Rule: ': '课消规则：',
	        'Lesson Time: ': '上课时间：',
	        '{lsnStartDate1} - {lsnStartDate2} - {lsnStartDate3}  {lsnStartTime} - {lsnEndTime}': '{lsnStartDate1}年{lsnStartDate2}月{lsnStartDate3}日 {lsnStartTime} - {lsnEndTime}',
	        'None': '无',
	        'Leave of Absence': '请假',
	        'Late': '迟到',
	        'Absence': '旷课',
	        'Total of {total_amount} person {total_amount2} Attended': '共 {total_amount} 人 出勤 {total_amount2} 人',
	        'Lesson': '课节',
	        'Insufficient Account Balance, Please Top Up and Try Again': '当前您的钱包余额不足，请充值后再使用',
	        'Insufficient Balance. Please Top Up or Try Other Payment Options': '当使用钱包余额时，收款金额不能大于钱包余额！为了正常交易，您可以先充值在使用钱包或使用其他交易方式',
	        'Exit Class Until': '退课期至',
	        'Exit Class Number': '退课次',
	        '': '次',
	        'Account Balance: ': '钱包余额: ',
	        'Refund': '退款',
	        'Refund Tuition': '直接退学费',
	        'Refund Date': '退款日期',
	        'Class': '班级',
	        'Refund Options': '退款方式',
	        'Cash': '现金',
	        'Credit Card': '信用卡',
	        'Cheque': '支票',
	        'Bank Transfer': '转账',
	        'Account Balance': '校内钱包',
	        'Email': '邮箱',
	        'Paper Receipt Number': '纸质收据号',
	        'Send Receipt To Parents': '电子收据会通过邮件发给家长',
	        'Exit Student: {sname} From Class?': '确认对学员： {sname} 退班?',
	        'Refund Date Cannot Be Empty': '退款日期不能为空',
	        'Proceed To Refund transaction and Exit Class For Student: {sname} ?': '确认对学员 {sname} 进行退款和退班?',
	        'Same date will only create single lesson': '日期相同时创建单次课节',
	        'Start Date Must Be Earlier Than End Date': '开始日期必须早于或等于结束日期',
	        'End Date Must Be Later Than Start Date': '结束日期必须晚于或等于开始日期',
	        'End Time Must Be Later Than Start Time': '结束时间必须晚于开始时间',
	        'Please Select Lesson Date and Time': '请选择课节日期和时间',
	        'End Date/Time Must Be Later Than Start Date/Time': '结束日期或时间必须晚于开始日期或时间',
	        'Please Select Days': '请选择周中日期',
	        'Please Select Dates': '请选择月中日期',
	        'Please Select Lesson Date': '请选择课节日期',
	        'Select Student': '选择学员',
	        'Search Student': '搜索学员',
	        'Select Classroom': '选择教室',
	        'Search Classroom': '搜索教室',
	        'Every': '每',
	        '(Can Select Multiple)': '(可多选)',
	        'Frequency': '频率',
	        'Start Date': '开始日期',
	        'End Date': '结束日期',
	        'Start Time (HH:MM)': '上课时间 (HH:MM)',
	        'End Time (HH:MM)': '下课时间 (HH:MM)',
	        'Batch Scheduling': '批量排课',
	        'Lesson Has {student} Students': '班级学员 {student} 人',
	        'Student: {student}': '班级学员: {student}',
	        'Select': '选择',
	        'Classroom': '教室',
	        'Conflict': '冲突',
	        'There are conflicts while creating a lesson.': '排课时发生冲突',
	        'One or more teachers are occupied during this period.': '部分老师在这个时间段已排过课',
	        'One or more students are occupied during this period.': '部分学生在这个时间段已被排过其他课程',
	        'The classroom is in use during this period.': '教室在这个时间段已排过课',
	        'Lesson Date': '上课日期',
	        'Delete Lesson': '删除这一课节',
	        'ID': '序号',
	        'Lesson Time': '上课时间',
	        'Student Counts': '学员人数',
	        'Class Student': '班级学员',
	        'Lesson Count': '排课课次',
	        'Lesson Status': '上课进度'
	    }, _classdetail["Checked In"] = '已签到', _classdetail['Please Select'] = '请选择...', _classdetail["When 'Account Balance' reaches 0, student: {name} will automatically exit class"] = '输入‘退款金额’为0时，执行‘确定’后将学员 {name} 直接退出班级', _classdetail['Please Select Class and Enter Refund Amount'] = '请您首先选择班级，并填入退款金额', _classdetail['Proceed to delete class?'] = '确认删除班级？', _classdetail['Upcoming Lesson'] = '未来课节', _classdetail['Past Lesson'] = '过去课节', _classdetail['Remark'] = '备忘', _classdetail),
	    classone: {
	        'New class: {cname} Has Been Created': '新班级： {cname} 已创建',
	        'Class: {cname} Has Been Updated': '班级： {cname} 已更新',
	        'Class: {cname} Archived': '班级： {cname} 已归档',
	        'Class: {cname} Unarchived': '班级： {cname} 已恢复',
	        'Class: {cname} Failure': '班级： {cname} 操作失败',
	        'Class Status Update Failure': '班级状态更新失败',
	        "Proceed to delete private class?": "确认删除私课",
	        "Proceed to restore private class?": "确认恢复私课",
	        'Scheduled': '已排课',
	        'Class Started': '已开始上课',
	        'Search Students': '请输入学员名称搜索',
	        'Current': '当期私课',
	        'Closed Private Class': '已关闭私课',
	        'New Private Class': '新增私课',
	        'Student Name': '学员名称',
	        'Private Class Name': '私课名称',
	        'Enter Private Class Name': '输入私课名称',
	        'View': '进入私课',
	        'Private Class List': '私课列表',
	        'Close': '关闭私课',
	
	        'Flexible Private Class Management': '灵活多变的私课',
	        'Private Class Management is not limited to just one on one lesson, it can also be used as auditions, interviews, and more. Just like Class Management, it allows you to appoint teacher and classrooms.': '私课不仅仅指一对一的教学形式，这里还可以用于补课，试听，interview等多种应用方式。别忘了，老师，教室和授课时间也是影响私课的重要因素哦。',
	        '': ''
	    },
	    schoolInformation: {
	        "School Information": "学校基本信息",
	        "Add all information that will help your target audience better understand your school on our Yellow Pages advertisements": "填写完善的信息，将有助于您在黄页上更清晰的展现您的学校",
	        form: {
	            'Address': '地址',
	            "School Name": "学校名称",
	            "School Logo": "学校logo",
	            "About School": "学校简介",
	            "School Website": "学校官网主页",
	            "Time Zone": "时区",
	            "Currency": "货币种类",
	            "School Phone Number": "学校联系电话",
	            "School Email": "学校联系Email",
	            "School Type": "学校类型",
	            "Categories": "课程种类",
	            "Student Age": "招收学员年龄",
	            'School Address': '学校地址',
	            'Class Categories': '课程种类',
	            'Click or drag and drop image here': '点击或将图片拖放到这里',
	            'Max file size: 5 MB': '最大文件尺寸：5 MB',
	            "Open Hours": '营业时间',
	            "Update Info": '更新信息',
	            "Student Registration Agreement": "学员注册条款",
	            "Notify admin via email when contact converted to student": "联系人转化学员时通知运营人员"
	        }
	    },
	    createone: {
	        'Create Class Failure': '班级创建失败',
	        'Class Teacher Update Failure': '班级老师更新失败',
	        'Class Student Update Failure': '班级学员更新失败',
	        'Private Class': '私课',
	        'Edit Student': '编辑学员',
	        'Add New Private Class': '新增私课',
	        'Edit Teacher': '编辑老师'
	    },
	    editone: {
	        'Edit Private Class': '编辑私课',
	        'Private Class': '私课',
	        'Student Name': '学员姓名'
	    },
	    classroom: {
	        'Classroom: {classroom} Has Been Created': '教室： {classroom} 创建',
	        'Classroom: {classroom} Has Been Updated': '教室： {classroom} 已更新',
	        'Create Classroom: {classroom} Successful': '新建教室： {classroom} 成功',
	        "Classroom: {classroom}'s Info Has Been Saved'": '修改教室： {classroom} 的信息已保存',
	        'Classroom: {classroom} Deleted': '删除教室： {classroom} 完成',
	        'Proceed to delete classroom?': '确认删除教室？',
	        'Delete': '删除',
	        'Classroom ({amount})': '教室 ({amount})',
	        'New Classroom': '新增教室',
	        'Classroom Name': '教室名称',
	        'Enter Classroom Name': '输入教室名',
	        'Edit Classroom': '编辑教室',
	        'Amount': '退款金额',
	        'Classroom List': '教室列表',
	        'Classroom': '教室',
	        'Personalized Classroom Management': '个性化的教室',
	        'Effective Classroom Management allows you to manage your school for efficiently. Depends on the purpose, you can create a classroom for different events as well.': '有效的教室管理可以节省不必要的资源浪费。根据不同的用途，定制个性化的教室/场地名称。也可以在课表里根据教室来筛选课程。',
	        '': ''
	    },
	    teacher: (_teacher = {
	        'Teacher': '老师',
	        'Teacher: {tname} Has Been Created': '老师: {tname} 已创建',
	        'Create Teacher Failure': '添加老师失败',
	        'Please exit from all current classes before archiving the teacher': '请您先退出当期班级，才可在学校中删除',
	        "Teacher: {tname}'s Info Has Been Saved": '老师： {tname} 的信息已保存',
	        "Teacher: {tname}'s Unarchived Failure": '老师： {tname} 恢复失败',
	        'Send Invitation To Teacher: {tname}?': '发送邀请给老师: {tname}?',
	        'Invitation Failure: please enter a valid phone number': '邀请失败： 请输入正确的手机号码',
	        'Created': '未邀请',
	        'Invited': '邀请中',
	        'Invite': '邀请',
	        'Confirm': '已接受邀请',
	        'Declined': '已拒绝邀请',
	        'Male': '男',
	        'Female': '女',
	        'None': '无',
	        'Options': '更多',
	        'Attendance': '签到记录',
	        'Upgrade to Premium': '升级高级版',
	        'Upgrade': '升级',
	        'Current': '当期老师',
	        'Deleted': '已删除老师',
	        'History': '历史老师',
	        'New Teacher': '新增老师',
	        'Teacher Name': '老师姓名',
	        'Gender': '性别',
	        'Mobile Phone Number': '手机号',
	        'Phone Number': '手机号',
	        'Lessons Taught Count': '已教课次数',
	        'Lessons Taught Hours': '已教课时',
	        'Please enter a valid phone number': '请输入正确的手机号码'
	    }, _teacher["New Teacher"] = '新增老师', _teacher["Enter Teacher's Name"] = '输入老師姓名', _teacher['Save'] = '保存', _teacher['Save and Invite'] = '保存并邀请', _teacher['Edit Teacher'] = '编辑老师', _teacher['Date'] = '退款日期', _teacher['Amount'] = '收款金额', _teacher["Enter a phone number to invite the teacher to download the ClassTop mobile App. The teacher could then change the attendance, as well as sending and receiving announcements and schedules. You could change teacher's permissions inside the permissions settings"] = '填写手机号可以邀请老师下载手机端APP, 老师可以用APP给自己和学生签到, 接收通知和课表, 您可以在权限设置里安排老师的权限', _teacher['Phone number already existed'] = '此手机号已存在', _teacher['Phone number already existed in archived teacher'] = '此手机号已存在归档老师里', _teacher['Please enter phone number'] = '请输入手机号', _teacher['Teacher List'] = '老师列表', _teacher['Proceed to archive teacher?'] = '确认要归档老师？', _teacher['Proceed to unarchive teacher?'] = '确认要恢复老师？', _teacher["Restore"] = '恢复', _teacher['Archive'] = '归档', _teacher["Enter Teacher's Email Address"] = '输入老师邮件地址', _teacher['Administration Management'] = '多角色教务管理', _teacher['Administration Management allows you to create teachers, which you can appoint them in different classes. You could also send an invitation via text to teachers, which allows them to join this platform and help you management your school. Teachers could also download ClassTop for School Staff app on both Apple Store and Google Play to help them better manage their classes'] = '学校可直接创建并保存一个教务角色，也可以邀请一名老师加入学校的教学管理，配合着专为老师定制的APP一起用，可提高数倍教学效率。', _teacher[''] = '', _teacher['N/A'] = '未提供', _teacher),
	    finance: {
	        'Receipt Number': '输入收据号',
	        "Financial Management": '财务管理',
	        'Add Credit': '校内钱包',
	        'Showing {amount} records Total of {amount2} records': '显示 {amount} 条记录 全部 {amount2} 条记录',
	        '{transaction_date} - {transaction_date2} - {transaction_date3}': '{transaction_date} 年 {transaction_date2} 月 {transaction_date3} 日',
	        'Charge': '收费',
	        'Refund': '退费',
	        'Please enter remarks content': '请输入备注内容',
	        'Send To': '发送至',
	        'Send': '发送',
	        'Transaction Summary': '交易纪录',
	        'Student: ': '学员： ',
	        'Operator: ': '经办人： ',
	        'E-Receipt Number: ': '电子收据号： ',
	        'All': '所有',
	        'Class: ': '班级: ',
	        'Date: ': '日期: ',
	        'E-Receipt Number': '输入电子收据号',
	        'Search': '搜索',
	        'E-Receipt No.': '电子收据号',
	        'Student': '学员',
	        'Charge/Refund': '收费/退费',
	        'Amount': '金额',
	        'Payment Methods': '付款方式',
	        'Purchased Lessons': '购买课程',
	        'Operator': '经办人',
	        'Receipt No.': '收据号',
	        'Added': '创建',
	        'Date': '收款日期',
	        'Payment': '收款',
	        "Statement Detail": "收支明细",
	        'Remarks': '备注内容',
	        'To': '至'
	
	    },
	    monthlyFinance: {
	        'Search by Date': '筛选日期',
	        'Monthly Income': '该月收入',
	        'Monthly Spending': '该月支出',
	        'Net Income': '该月净收入',
	        'Monthly Summary': '月度汇总'
	    },
	    student: (_student = {
	        'Exit Class Successful': '退出班级成功',
	        'The student {student_name} has been removed from the class.': '{student_name}学员已退出班级',
	        'New Student: {name} Has Been Created': '新学员： {name} 已创建',
	        "Student: {name}'s Info Has Been Updated": '学员： {name} 信息已更新',
	        'Exited Class': '已退出班級',
	        'You Do Not Have the Permission to Visit This Page, Please Contact the School Principal/Manager for More Information': '您所在的用户组不具有此操作的权限，请联络该学校的校长或管理员授予您相应的权限',
	        'Student {name} {remarks}': '学员 {name} {remarks}',
	        'Student {name} {reason}': '学员 {name} {reason}',
	        'Student Payment Failure': '学员缴费失败',
	        'Student: {name} Archived': '学员： {name} 已归档',
	        'Student: {name} Unarchived': '学员： {name} 已恢复归档',
	        'Multiple Student Archived': '多个学员已归档',
	        'Student Info Update Failure': '学员状态更新失败',
	        'Added': '加入',
	        'Proceed to archive student {student}?': '确认归档学员？',
	        'The following students are currently enrolled in class: ': '以下的学员正在就读班级：',
	        'Archive Multiple Students': '归档多个学员',
	        'Archive Student': '归档学员',
	        'Student {student} is currently in class, proceed to archive student?': '学员 {student} 正在班级里就读, 确认归档学员吗 ?',
	        'Students {student} are currently in classes, proceed to archive students?': '学员 {student} 正在班级里就读, 确认归档学员吗 ?',
	
	        table: {
	            '{sAge} yrs old': '{sAge} 岁',
	            '{days_left} day remaining': '余 {days_left} 天',
	            '{days_left} days remaining': '余 {days_left} 天',
	            '{qty} / {total} hour': '{qty} / {total} 小时',
	            '{qty} / {total} hours': '{qty} / {total} 小时',
	            '{qty} / {total} lesson': '{qty} / {total}  次',
	            '{qty} / {total} lessons': '{qty} / {total}  次'
	        },
	
	        "Proceed to join '{className}'?": "确认加入'{className}'吗？",
	        'Please select a class and enter the amount for refund': '请您首先选择班级，并填入退款金额',
	        'Please enter the appropriate refund amount': '请您填入合适退款金额',
	        'Refund date cannot be empty': '退款日期不能为空',
	        'Please select a class and enter the amount charged': '请您首先选择班级，并填入收款金额',
	        'Please enter the appropriate charged amount': '请您填入合适收款金额',
	        'Charged date cannot be empty': '付款日期不能为空',
	
	        // Archive
	        'Proceed to archive student: {name}?': '是否将学员： {name} 归档？',
	        'Proceed to archive students: {name} and {otherStr}?': '是否将学员： {name}等{otherStr}归档？',
	        '{number} other': '{number}人',
	        '{number} others': '{number}人',
	
	        // Unarchive
	        "Unarchive": '恢复归档',
	        "View": '进入档案',
	
	        'Please exit all classes in order to archived student': '请您先在班级中归档，才可在学校中归档',
	        'Proceed to restore student: {name}？': '是否恢复学员： {name}？',
	        'Showing {amount} students Total of {amount2} students': '显示 {amount} 人 全部 {amount2} 人',
	        'Price ${fee}': '课价 ${fee}',
	        'Exit student from class?': '确认将此学生退出班级吗？',
	        'Exit Class': '退出班级',
	        'Join Class': '加入班级',
	        'Add Credit': '钱包充值',
	        'Charge': '收费',
	        "Add the credit to the student's account and can be used towards other expenses": '给此学生的校内钱包充值，并通用与任何校内费用的结算',
	        'Collecting tuition fee and renewal': '直接收取学费以及用于续费等',
	        'Account Remaining: ': '钱包余额： ',
	        'Enter recipient email': '输入收件人邮箱',
	        'Paper Receipt Number': '输入收据号',
	        'Date': '充值日期',
	        'Email': '邮箱',
	        'Amount': '充值金额',
	        'Purchased Lesson Until...': '购买课期至',
	        '': '次',
	        'Hour': '小时',
	        'Exit Lesson Until...': '退课期至',
	        'Exit Lesson Number': '退课次',
	        'Choose one...': '请选择...',
	        'Purchased Lesson': '已购买课期',
	        'Renew Lesson Until...': '续课期至',
	        'Purchased Lesson Hour': '购买课时'
	    }, _student["Hour"] = '小时', _student['Add remarks'] = '添加备注', _student['Edit Lesson Until...'] = '修改课期至', _student['Reduce Lesson Number'] = '减少课次', _student['Reduce Lesson Hour'] = '减少课时', _student['Join Current Classes'] = '加入当期班级', _student['Search Class Name'] = '搜索班级名称...', _student['Search name...'] = '搜索学员名称...', _student['Currently Enrolled'] = '正在就读', _student['Upgrade'] = '升级', _student['New Class'] = '创建班级', _student['New Student'] = '新增学员', _student['Multiple Students Has Been {action} To Class: {cname}'] = '多个学员被 {action} 到班级： {cname}', _student['View Now'] = '立即查看', _student['Failure: Students Are Already Enrolled In Class'] = '失败： 学员已经加入该班级', _student['Registered'] = '在读学员', _student['Not Enrolled'] = '未排班学员', _student['Enrolled'] = '已排班学员', _student['Pending Renewal'] = '待续费学员', _student['History'] = '历史学员', _student['Deleted'] = '已删除学员', _student['Student'] = '学员', _student['Age'] = '年龄', _student['Class'] = '班级', _student['Class Status'] = '课节消耗', _student['Refund'] = '退款', _student['Payment'] = '学费', _student['Paid Amount'] = '已缴学费', _student['Settings'] = '操作', _student['{i}'] = '{i}日', _student['Student List'] = '学员列表', _student["Archive"] = "归档", _student["New Private Class"] = "新建私课", _student["Edit"] = "编辑", _student["Attendance"] = "查看签到记录", _student['Remove "{sName}" From "{className}"?'] = '确认将此学生({sName})退出班级({className})吗？', _student['Add'] = '加入', _student['show all ({classNumber})'] = '展开所有 ({classNumber})', _student['Registration Guide'] = '自助报名设置', _student['Self-registration Setup'] = '自助报名设置', _student['Step One'] = '第一步', _student['Step Two'] = '第二步', _student['Step Three'] = '第三步', _student['Step Four'] = '第四步', _student['Enter Self-registration Address on Your Tablet Device'] = '在平板设备里输入自助报名网址', _student['Open any browser (Safari, Chrome, Firefox) on your tablet device and enter the following URL '] = '在平板设备里打开任意浏览器（Safari，Chrome，Firefox），输入地址 ', _student['Log In to Your School'] = '登录您的学校', _student['Enter phone number and password, and then select the school to enter the student registration page'] = '填写手机号与密码，登陆后请选择相应学校进入学生注册页面', _student['Enter Student Information'] = '填写学生注册信息', _student['After student registered successfully, student information will be saved and displayed on the student page'] = '学生注册成功后，信息会存入您学校的学生列表里同时为您建立新学员。', _student['Privacy Setting (only on iPad)'] = '安全设置 (仅限于 iPad)', _student['If you do not wish others to change your account information, you could setup privacy setting on your iPad by following the steps below: '] = '如果您不想学生，家长，或者其他人员乱碰您 iPad 里的其他东西，您可以使用引导式访问，具体 iPad 设置如下：', _student["On your iPad, press 'Settings' > 'General' > 'Accessibility' > 'Guided Access' to set up Guided Access, you could do the following: "] = '在iPad上轻按“设置”>“通用”>“辅助功能”>“引导式访问”以设置引导式访问。在此处，您可以执行以下操作：', _student['• Turn on/off Guided Access'] = '• 开启或关闭引导式访问', _student['• Setup passcode for Guided Access, such as preventing others from exiting the application'] = '    • 设置密码以控制引导式访问的使用，并防止有人离开活跃的会话', _student['• Setup time limits so the application will be disabled once the time expires'] = '•     设置设备是否可以在会话过程中进入睡眠状态', _student['To enable Guided Access, please follow the steps below: '] = '要启动引导式访问会话，请按照以下步骤操作：', _student['1. Open the application'] = '1. 打开想要使用的 app。', _student['2. Press Home Button three times'] = '2. 连按三次主屏幕按钮。', _student["3. Enter the passcode, set up Guided Access, and then press 'Start'"] = '3. 输入密码，调整会话的设置，然后轻按“启动”。', _student['You could use Guided Access to control the application, such as disabling areas of the screen that aren’t relevant to a task, or areas where an accidental gesture might cause a distraction. Please follow the steps below: '] = '您可以使用引导式访问来关闭 app 控件、屏幕的各个部分和动作感应功能。请按照以下步骤操作：', _student['To restrict the application and disable areas of the screen, please follow the steps below'] = '要停用 app 控件及 app 屏幕的各个区域，请按照以下步骤操作：', _student['1. Circle areas of the screen'] = '1. 在屏幕上圈出想要停用的部分。', _student['2. Adjust the areas by dragging the circle'] = '2. 使用控制柄来调整区域。', _student['To disable any screen interaction, please turn off the Touch button'] = '要忽略所有屏幕触摸，请关闭“触摸”。', _student["To disable screen lock in the application or any motion, press the 'Hardware Buttons' and turn off 'Motion' button"] = '要防止 iOS 设备从竖排切换到横排，或从响应切换到任何其他动作，请关闭“动作”。', _student["If Touch ID is enabled on your iPad, then it could be used to end Guided Access. Go to 'Settings' > 'General' > 'Accessibility' > 'Guided Access' > 'Passcode Settings'and turn on the Touch ID button. Now you could do the following steps to end Guided Access"] = '如果您正在使用 iOS 设备上的 Touch ID，则可以用它来结束引导式访问会话。首先，前往“设置”>“通用”>“辅助功能”>“引导式访问”>“密码设置”，并打开 Touch ID。现在，当您在使用引导式访问时，就可以按照以下步骤来结束会话：', _student['1. Press the Home Button'] = '1. 按一次主屏幕按钮。', _student['2. Use Touch ID'] = '2. 使用 Touch ID。', _student['If Touch ID is disabled on your iPad, you can end the Guided Access by the following steps'] = '如果未在设备上使用 Touch ID，请按照以下步骤结束引导式访问会话：', _student['1. Press the Home Button three times'] = '1. 连按三次主屏幕按钮。', _student["2. Enter the passcode and press 'End'"] = '2. 输入引导式访问密码。', _student["Add"] = '加入', _student['Proceed to exist class?'] = '确认退出班级？', _student['Student Record Documentation and Management'] = '学员档案记录与管理', _student['Student Management includes entry, search, edit multiple students, and register students through iPad. Student Management divides all students into different categories: current, not enrolled, enrolled, and past students. It allows you to enroll students, as well as payments and attendance. It also allows you to check student status.'] = '学员管理包括录入，查询，及批量学员同时操作，并可以设置前台 iPad 登记与报名。学员被划分为当期，未排班，在读，以及历史的多种状态类型。通过简单的操作给学生排班，充值，缴费，办理签到等各种事项。随时可以查询学生的上课状态，缴费，学费，退费，充值等记录。', _student[""] = '', _student),
	    createstudent: {
	        'Please enter a valid Email address': '请输入正确的邮件地址',
	        'Please enter a valid phone number': '请输入正确的手机号码',
	        'Please upgrade to premium version': '请升级高级版',
	        '{i}': '{i} 年',
	        'January': '1月',
	        'February': '2月',
	        'March': '3月',
	        'April': '4月',
	        'May': '5月',
	        'June': '6月',
	        'July': '7月',
	        'August': '8月',
	        'September': '9月',
	        'October': '10月',
	        'November': '11月',
	        'December': '12月',
	        'First Name': '名称',
	        'Last Name': '姓氏',
	        'Date of Birth': '生日',
	        'Home Phone Number': '家庭电话',
	        'Email': '邮件',
	        'Nickname': '昵称',
	        'Source': '来源',
	        'Parents Name': '家长名字',
	        'Relationship': '亲属关系',
	        'Address': '居住地址',
	        'Register Date': '注册日期',
	        'Basic Information': '基本信息',
	        'Student Birthday Incomplete': '学员生日填写不完整',
	        'Select Year': '选择年',
	        'Select Month': '选择月',
	        'Select Date': '选择日'
	    },
	    settings: {
	        'Password': ' 密码',
	        'Reset Password': '重新设置密码',
	        'Password Updated': '密码更新成功',
	        'Reset Password Failure': '密码更新失败',
	        'Enter New Password': '输入新密码',
	        'Verification Code Sent': '验证码短信发送成功，请注意查收',
	        'User does not exist, please check the phone number': '用户不存在，请检查电话号码',
	        'Account Settings': '账户设置',
	        'Plan Settings': '账单设置',
	        'Free Trial': '试用版',
	        'Discount Plan': '优惠版',
	        'Customized Plan': '定制版',
	        'Basic Plan': '基础版',
	        'Professional Plan': '专业版',
	        'Premium Plan': '高级版',
	        'Basic': ' 基础版',
	        'Customized': '定制版',
	        'Professional': '专业版',
	        'Premium': '高级版',
	        'monthly': '每月',
	        'yearly': '每年',
	        'Choose Plan': '选择计划',
	        'Current Plan': '当前计划',
	        'per month, billed monthly': '每月, 按月付',
	        'per month, billed yearly': '每月, 按年付',
	        'Unlimited': '无上限',
	        'Registered Students': '在读学生',
	        'Registered Teachers': '在职老师',
	        'Campus': '校区',
	        'USD': '美元',
	        '/month': '/每月',
	        'Congratulations!': '恭喜您',
	        'You are on {planName} now!': '您已成功更换至{planName}!',
	        'Your current account can not be changed to this plan!': '对不起, 您的账号无法更换至此计划',
	        'Failed to change plan!': '更换计划失败!',
	        'Subscribe to {name}': '订阅{name}',
	        'Per Month': '每月',
	        "Today's total": '今日扣款',
	        'Next billing date': '下次扣款日期',
	        'Monthly': '月付',
	        'Yearly': '年付',
	        '4 digits': '4位数字',
	        'show': '显示',
	        'hide': '隐藏',
	        'At least 6 characters': '至少6个字符',
	        'Send Code': '发送验证码',
	        'Unexpected errors': '操作失败',
	        'Password has to be at least 6 characters long': '密码长度至少为六位',
	        'User does not exist': '用户已存在',
	        'Invalid verification code': '验证码错误',
	        'Verification code is expired': '验证码已过期'
	    },
	    passwordsettings: {
	        "Reset Password": '重置密码',
	        "Verification Code": '验证码',
	        'Verification Code Send To ': '验证码发送至',
	        'Send Code': '获取验证码',
	        'Resend': '重新获取',
	        "New Password": '新密码',
	        'Resent in {counterTime} s': '{counterTime} 秒后可重发'
	    },
	    planDetails: {
	        'Features that are included in free trial': '免费试用版包含以下功能',
	        'All basic plan features': '所有基础版本的功能',
	        '{amount} Registered Students': '{amount}个在读学员',
	        '{amount} Registered Teachers': '{amount}个在职老师',
	        '{amount} Campus': '{amount}个校区',
	        'Features that are NOT included': '不包括以下功能',
	        'No Posters': '无海报',
	        'No Contacts': '无联系人',
	        'No Smart Check-in': '无智能签到',
	        'No Recent Activity Logs': '无操作记录查询',
	        'Start My Trial': '开始我的试用',
	        'Start your 14 days free trail now!': '开始你的14天免费试用吧!',
	        'Create your school by starting your 14 days free trail now!': '14天免费试用, 开始创建属于您的学校吧!',
	        'Create Your School': '创建你的学校'
	    },
	    studentdetail: (_studentdetail = {
	        'Paid Amount': '已缴学费',
	        'Refund Amount': '退款学费',
	        'Refund Lesson Date': '退款课期',
	        'Refund Lesson Number': '退款课次',
	        'Refund Lesson Hour': '退款课时',
	        'Send To': '发送至',
	        '{transaction_date1} - {transaction_date2} - {transaction_date3}': '{transaction_date1} 年 {transaction_date2} 月 {transaction_date3} 日',
	        'Search Class': '所有',
	        'Options': '充值方式',
	        "Amount": '充值金額',
	        'Student: {name}': '学员： {name}',
	        'Account Balance {balance} CAD': '钱包现有金额: {balance} CAD',
	        'Please enter amount': '请填入收款金额',
	        'Amount needs to be greater than 0': '金额必须大于零',
	        'Historical Class Record': '历史班级',
	        "Attendance Record": "签到记录",
	        'Tuition Record': '学费记录',
	        'Edit Basic Information': '修改基本信息',
	        'Account Balance: ': '钱包现有金额： ',
	        'Paper Receipt No': '纸质票据号',
	        "Basic Information": '基本信息',
	        "Current Classes": '当期班级',
	        "Past Classes": '历史班级'
	    }, _studentdetail["Attendance Record"] = '签到记录', _studentdetail["Tuition Record"] = '学费记录', _studentdetail),
	    UI: {
	        alert: {
	            "Confirm": "确定"
	        },
	        confirm: {
	            "Confirm": "确定",
	            "Cancel": "取消"
	        }
	    },
	    PaymentModal: {
	        'Student: {student_name} Refunded {amount} {currency} Successfully!': '学员： {student_name} 退款 {amount} {currency} 成功',
	        'Student: {student_name} Added Credit {amount} {currency} Successfully!': '学员： {student_name} 充值 {amount} {currency} 成功',
	        'Student: {student_name} Charged {amount} {currency} Successfully!': '学员： {student_name} 收费 {amount} {currency} 成功',
	
	        'Credit Added': '充值成功',
	        'Charge Successful': '收费成功',
	        'Refund Successful': '退费成功',
	
	        'Insufficient balance in your account, please add credit and try again': '当前您的钱包余额不足，请充值后再使用',
	        "Selected 'Reduce Lesson' is more than 'Purchased Lesson'": '选择的“减少课期”大于“已购买课期',
	        'When making a payment through your account, make sure you have sufficient balance. Please add credit to your account to continue': '当使用钱包余额时，收款金额不能大于钱包余额 为了正常交易，您可以先充值在使用钱包或使用其他交易方式',
	        'Charged Amount': '收款金额',
	        'Charged Date': '收款日期',
	        'Top Up Amount': '充值金额',
	        'Top Up Date': '充值日期',
	        'Payment Method': '付款方式',
	        'Email': '邮箱',
	        'Paper Receipt Number': '纸质收据号',
	        'Student Payment Failure': '学员缴费失败',
	        'Remarks': '备注',
	        'E-receipts will be sent to the parents through email': '电子收据会通过邮件发给家长',
	        'Cash': '现金',
	        'Credit Card': '信用卡',
	        'Cheque': '支票',
	        'Bank Transfer': '转帐',
	        'School Credit': '校内钱包',
	        'Class': '班级',
	        'Purchase Lesson Until...': '购买课期至',
	        'Number Of Lesson': '购买课次',
	        'Hour Of Lesson': '购买课小时',
	        'Proceed to add {amount} {currency} credit?': '确认充值 {amount} {currency}吗？',
	        'Proceed to charge {amount} {currency}?': '确认收 {amount} {currency} 吗？',
	        'WeChat Pay Transfer': '微信转账',
	        'Alipay Transfer': '支付宝转账',
	        refund: {
	            'Refund Amount': '退款金额',
	            'Tuition Fee Refund': '直接退学费',
	            'Refund the paid fee for this student': '退回此学生所缴班级学费',
	            'Refund the collected credit for this student': '退回此学生钱包余额',
	            'Refund Date': '退款日期',
	            'Refund Lesson Until...': '退课期至',
	            'Number Of Lesson': '退课次',
	            'Number Of Hour': '退课小时',
	            'Refund Method': '退款方式',
	            'Proceed to refund {amount} {currency}?': '确认进行退款 {amount} {currency} 吗?'
	        },
	        units: {
	            'HOUR': '小时',
	            'HOURS': '小时',
	            'LESSON': '次',
	            'LESSONS': '次'
	        },
	        hourPaddingRight: {
	            '52': '39',
	            '59': '39',
	            '66': '25',
	            '73': '25'
	        }
	    },
	    tutorialModal: {
	        'Video Tutorial': '视频教程',
	        'Tutorial': '使用教程',
	        'Got it': '知道了'
	    },
	    SelectItemModal: {
	        'Select': '选择',
	        'Selected': '已选择',
	        'Confirm ({number})': '确认 ({number})'
	    },
	    Table: {
	        'Showing {begin} - {end} (total {total})': '显示 {begin} - {end} 全部 {total}',
	        'No Result': '无数据'
	    },
	    ClassInfo: {},
	    TextFilter: {
	        'Search': '搜索'
	    },
	    data: {
	        'N/A': '无'
	    },
	    DateRange: {
	        'Date': '日期',
	        'Start Date': '开始日期',
	        'End Date': '结束日期'
	    },
	    TimeRange: {
	        'Time': '时间',
	        'Start Time': '开始时间',
	        'End Time': '结束时间'
	    },
	    weekdays: {
	        'Mon': '星期一',
	        'Tue': '星期二',
	        'Wed': '星期三',
	        'Thu': '星期四',
	        'Fri': '星期五',
	        'Sat': '星期六',
	        'Sun': '星期天',
	        'Monday': '星期一',
	        'Tueday': '星期二',
	        'Wednesday': '星期三',
	        'Thursday': '星期四',
	        'Friday': '星期五',
	        'Saturday': '星期六',
	        'Sunday': '星期天'
	    },
	    form: {
	        'errorMessage': {
	            'Please fill this field': '此项为必填项',
	            'Please enter a valid Email address': '请输入正确的邮件地址'
	        }
	    },
	    schoolInfo: {
	        'After-school Session': '课后辅导班',
	        'Pre-school': '学前班',
	        'Tutor': '家教',
	        'Public/Private School': '公校/私校'
	    },
	    address: {
	        'Country': '国家',
	        'Province/States': '地区',
	        'City': '城市',
	        'Street': '街道地址',
	        'Unit No.': '门牌号',
	        'Postal Code': '邮政编码'
	    },
	
	    schooltypes: {
	        'academic': '学术',
	        'after_school_care': '课后辅导',
	        "board_games": '棋牌类',
	        "college": '学院',
	        "college_prep": '大学预科',
	        "cooking": '烹饪',
	        "dance": '舞蹈',
	        "daycare_and_babysitting": '托儿所',
	        "events": '活动',
	        "fine_arts": '美术',
	        "fitness": '健身',
	        "languages": '语言',
	        "martial_arts": '武术',
	        "math": '数学',
	        "music": '音乐',
	        "outdoor_activities": '户外运动',
	        "performing_arts": '表演',
	        "photography_and_movie_making": '摄影与影视',
	        "private_school": '私校',
	        "programming": '编程',
	        "public_school": '公校',
	        "reading": '阅读',
	        "science": '科学',
	        "sports": '体育',
	        "university": '大学'
	    },
	
	    poster: (_poster = {
	        "Create a Beautiful Poster Design Is This Simple": '无需设计师也能制作精美营销海报',
	        "Not only will you be able to create a beautiful poster to share, it can also be used to sign up classes and activities, buying event tickets, and published surveys. Posters can be saved as a draft, or published and shared on WeChat, Facebook, and Twitter. Let's get started!": '不仅能排出精美的宣传海报，还附带各种报名功能，如课程/班级的报名注册，活动的报名，在线售票，以及调查问卷，制作好的海报可以存为草稿定时发布和分享到Wechat, Facebook and Twitter上。还等什么，快来体验吧',
	        "All": "全部海报",
	        "Edit": "编辑",
	        "Published": '已发布海报',
	        "Closed": "已下架海报",
	        "Draft": '草稿海报',
	        'Delete': '删除',
	        'Are you sure you want to delete the poster?': '确认删除海报？',
	        'Unlink': '下架',
	        'Are you sure you want to unlink the poster? The link will become invisible.': '确认下架海报？',
	        'New Poster': '创建海报',
	        "Select Poster Type": '选择海报类型',
	        "Basic Poster": '普通海报',
	        "Enrollment Registration": '招生注册',
	        "Event Registration": '活动门票',
	        "Survey": '调查投票',
	        "Share": '分享',
	        'Create': '创建',
	        "Create a poster that contains only texts and pictures": '创建一个仅包含图文信息的海报',
	        "Create a poster that allows users to register for classes or events": '创建一个可以让用户填写报名信息的海报',
	        "Create a poster that allows users to register tickets": '创建一个可以让设置免费或收费门票的海报',
	        "Create a poster that contains a survey or questionnaire": '创建一个带有调查问卷选项的海报',
	        'Class Registration': '课程报名'
	    }, _poster["Event Registration"] = '活动报名', _poster.type = {
	        'Enrollment Registration': '招生注册',
	        'Event Registration': '活动报名',
	        'Survey': '调查投票',
	        'Basic Poster': '普通海报'
	    }, _poster.dateCard = {
	        'Registration Start Time': '报名开始日期',
	        'Total Registered': '目前报名',
	        'Total Registered: {numberStr}': '目前报名: {numberStr}人',
	        'Course Fee: ${price}': '课程费用: ${price}'
	    }, _poster.register = {
	        'Item': '项目',
	        'Items': '项目',
	        'Register Now': '立即报名',
	        'Registered': '报名人数',
	        'Deadline': '报名结束日期',
	        'None': '无限期',
	        'Note: Currently we only accept online registration and offline payment.': '提示：报名目前只接受线上注册，线下缴费。',
	        'No Limit': '无上限'
	    }, _poster),
	    ticket: {
	        'Registration Setup': '报名设置',
	        'Registration': '报名登记',
	        'Registration with Fees': '报名并在线缴费',
	        'Registration Title': '报名标题',
	        'Amount of People': '人数',
	        'Price Description': '费用说明',
	        'Settings': '操作',
	        '': '人',
	        'Dance Class, English Class, etc': '舞蹈班，语文基础课，全年招生…',
	        'Pay Offline': '线上注册，线下缴费',
	        'Pay Online': '线上注册，线上缴费',
	        'Advance Settings': '详细设置',
	        'Registration Start Time': '报名开始时间',
	        'Registration End Time': '报名结束时间',
	        'No End Time': '无结束时间',
	        'Price': '金额',
	        'Waiting List': '等候名单',
	        'Allow Waiting List': '超出招生人数时，自动进入等候名单',
	        'No Waiting List': '超出招生人数时，报名自动关闭，无等候名单',
	        'Close Advance Settings': '收起详细设置',
	        'Other Settings': '其他设置',
	        'Registration Progress': '报名进度',
	        'Show Registration Progress on Poster': '在海报上显示报名进度，所有人可见。',
	        'Read Count': '阅读数',
	        'Show Read Count on Poster': '在海报上显示阅读数，所有人可见。',
	        ' (No limit if empty)': '（不填则无上限）',
	        'Proceed to delete this registration?': '确认删除报名？'
	    },
	    registrationTable: {
	        'Item': '项目',
	        'Applicant': '报名人',
	        'Contact Name': '联系人',
	        'Contact Email': '联系人邮箱',
	        'Contact Phone No.': '联系人电话',
	        'Status': '状态',
	        'Settings': '操作',
	        'Registration List': '报名人列表',
	        'Detail': '详情',
	        'Transfer Student': '转为学员',
	        'Transferred': '已转为学员',
	        'Success': '报名成功',
	        'Waiting List': '等候名单',
	        'Search Name, Email, or Phone No.': '搜索姓名，邮箱，电话',
	        'All Items': '全部项目',
	        'Date of Birth': '生日',
	        'Phone No.': '手机',
	        'Email': '邮箱',
	        'Close': '关闭',
	        '{student}': '{student} 学员',
	        '': '',
	        'Poster Registration List': '海报报名学员列表',
	        'Registration Status': '报名状态',
	        'Poster Title': '海报标题',
	        'All Posters': '所有海报',
	        'Select Poster': '选择海报',
	        'Sort by': '排序',
	        'Creation Time: Newest to Oldest': '按创建时间：由新到旧',
	        'Creation Time: Oldest to Newest': '按创建时间：由旧到新'
	    },
	
	    openHours: {
	        'closed': '休息'
	    },
	
	    LessonFloat: {
	        "Edit": '编辑',
	        'Attendance': '签到',
	        'Start Time': '开始时间',
	        'End Time': '结束时间',
	        'Number of Student': '学生人数',
	        'Classroom': '教室',
	        'Teacher': '老师'
	    },
	    closeClass: {
	        ' This class still has at least one unfinished lesson': ' 此班级还有未结束的课节',
	        "After closing the class, you can find it under the 'Closed Class'": "关闭班级后，此班级会显示在 '已关闭班级'",
	        'Are you sure you want to close the class below?': '确认关闭班级？',
	        'Close Class': '关闭班级',
	        'Attended': '补签'
	    },
	    teacherAttendance: (_teacherAttendance = {
	        'Teacher / {teacher}': '老师 / {teacher}',
	        "Attendance Record": "签到记录",
	        'Class Name': '班级名称',
	        'Lesson': '课节',
	        'Lesson Time': '上课时间',
	        'Attend Time': '签到时间',
	        'Status': '状态',
	        'Late': '迟到',
	        'Unattended': '未出勤',
	        'Attended': '出勤',
	        'Absent': '请假',
	        'Total Attended Count/Duration: {count}': '总出勤：{count}次',
	        'Total Unattended Count/Duration: {count}': '总缺勤：{count}次',
	        'Absent (with excuse) Count/Duration: {count} / {hour}': '请假缺勤：{count}次 / {hour}',
	        'Absent (without notice) Count/Duration: {count} / {hour}': '旷课缺勤：{count}次 / {hour}',
	        'Late Count/Duration: {count} / {hour}': '迟到：{count}次 / {hour}',
	        'On Time Count/Duration: {count} / {hour}': '正常：{count}次 / {hour}',
	        'Today': '截止今日',
	        'Attendance Status': '签到状态',
	        'Select Status': '选择状态',
	        'Export Student List to Excel': '导出学生列表至 Excel',
	        'Only search within three months period': '您每次只能查询三个月以内的记录',
	        '': ''
	    }, _teacherAttendance[""] = '', _teacherAttendance['Attendance Overview'] = '签到总汇', _teacherAttendance['Attendance Detail'] = '签到详情', _teacherAttendance['On Time Count & Duration'] = '正常出勤数&时长', _teacherAttendance['Total Attended Count & Duration'] = '总出勤数&时长', _teacherAttendance['Late Count & Duration'] = '迟到数&时长', _teacherAttendance['Total Unattended Count & Duration'] = '总缺勤数&时长', _teacherAttendance['Absent (with excuse) Count & Duration'] = '请假缺勤数&时长', _teacherAttendance['Absent (without notice) Count & Duration'] = '旷课勤数&时长', _teacherAttendance['On-Time Count'] = '正常出勤数', _teacherAttendance['Total Attended Count'] = '总出勤数', _teacherAttendance['Late Count'] = '迟到数', _teacherAttendance['Total Unattended Count'] = '总缺勤数', _teacherAttendance['Absent (with excuse) Count'] = '请假缺勤数', _teacherAttendance['Absent (without notice) Count'] = '旷课勤数', _teacherAttendance['On-Time Duration'] = '正常出勤时长', _teacherAttendance['Total Attended Duration'] = '总出勤时长', _teacherAttendance['Late Duration'] = '迟到时长', _teacherAttendance['Total Unattended Duration'] = '总缺勤时长', _teacherAttendance['Absent (with excuse) Duration'] = '请假缺勤时长', _teacherAttendance['Absent (without notice) Duration'] = '旷课勤时长', _teacherAttendance['Hourly Rate:'] = '时薪:', _teacherAttendance['Total Salary:'] = '总工资:', _teacherAttendance['Please enter value'] = '请输入数值', _teacherAttendance['Total Salary'] = '当前工资', _teacherAttendance['Calculate Salary'] = '计算工资', _teacherAttendance['Salary Calculation'] = '工资计算', _teacherAttendance['The calculated salary will not be saved to our system, please export it after the calculation'] = '工资计算完成后请及时导出, 系统不会保存计算结果', _teacherAttendance['Makeup Count: {count}'] = '补签：{count}次', _teacherAttendance['Makeup Count'] = '补签数', _teacherAttendance['Please fill the fields you need for the calculation.'] = '请输入各项工资所需金额, 如果没有该项目, 请填写零。', _teacherAttendance['Hour/Count'] = '小时/次数', _teacherAttendance['Rate'] = '单价', _teacherAttendance['Base Salary'] = '底薪', _teacherAttendance['Salary (By Hours)'] = '按小时工资', _teacherAttendance['Salary (By Counts)'] = '按课次工资', _teacherAttendance['Late Penalty (By Hours)'] = '迟到小时扣款', _teacherAttendance['Late Penalty (By Counts)'] = '迟到次数扣款', _teacherAttendance['Absent (with excuse) Penalty (By Hours)'] = '请假小时扣款', _teacherAttendance['Absent (with excuse) Penalty (By Counts)'] = '请假次数扣款', _teacherAttendance['Absent (without notice) Penalty (By Hours)'] = '旷课小时扣款', _teacherAttendance['Absent (without notice) Penalty (By Counts)'] = '旷课次数扣款', _teacherAttendance['Benefit'] = '福利', _teacherAttendance['Tax'] = '税', _teacherAttendance['Other Additions'] = '其他增项', _teacherAttendance['Other Deductions'] = '其他扣减', _teacherAttendance["Total Salary:"] = '总工资:', _teacherAttendance['Export Student List to CSV'] = '导出学生列表至 CSV', _teacherAttendance['Absent Penalty (By Hours)'] = '旷课小时扣款', _teacherAttendance['Absent Penalty (By Counts)'] = '旷课次数扣款', _teacherAttendance['Leave Early Penalty (By Hours)'] = '早退小时扣款', _teacherAttendance['Leave Early Penalty (By Counts)'] = '早退次数扣款', _teacherAttendance['Unchecked: {count}'] = '无记录次数: {count}次', _teacherAttendance['Unchecked Count & Duration'] = '无记录次数和时长', _teacherAttendance['Unchecked Count'] = '无记录次数', _teacherAttendance['Unchecked Duration'] = '无记录时长', _teacherAttendance['Unchecked Count: {count}'] = '无记录次数: {count}次', _teacherAttendance['Unchecked Duration: {hour}'] = '无记录时长: {hour}', _teacherAttendance['Absent (with excuse)'] = '请假', _teacherAttendance['Absent (without notice)'] = '旷课', _teacherAttendance['Unchecked'] = '无记录', _teacherAttendance['Export Record to Excel'] = '导出记录至 Excel', _teacherAttendance['Export Record to CSV'] = '导出记录至 CSV', _teacherAttendance['Export Record'] = '导出记录', _teacherAttendance),
	    lesson: {
	        'Lesson {lesson_amount}, {student_amount} students': '课节{lesson_amount} 学员{student_amount}名',
	        '': ''
	
	    },
	    studentTable: {
	        'Join Class': '批量加入班级',
	        'Create Class': '批量创建班级',
	        'Delete Students': '批量删除学员',
	        'Students: ': '班级学员：',
	        'Teachers: ': '班级老师：',
	        'New Teacher': '新增老师',
	        'This student has paid tuition, do you wish to refund?': '此学员已缴费，是否要退费？',
	        '': '',
	        'Export Record to Excel': '导出记录至 Excel',
	        'Export Record to CSV': '导出记录至 CSV',
	        'Student Settings': '学员设置',
	        'Student Custom Fields': '学员自定义字段',
	        'Import Students': '导入学员'
	    },
	    lessonTable: {
	        'Reset Time': '批量重置时间',
	        'Reset Teacher': '批量重置老师',
	        'Reset Classroom': '批量重置教室',
	        'Reset Students': '批量重置学员',
	        'Reset Color': '批量重置课节色',
	        'Delete Lessons': '批量删除课节',
	        'Reset Lesson Time': '重置课节时间',
	        'Reset Lesson Color': '重置课节颜色',
	        'Cancel': '取消',
	        'Save': '保存',
	        'Lesson color will be displayed in the calendar, making it organized and easy to view': '课程颜色会显示在课表日历里，帮助您分类且更直观的预览课表',
	        'Deleted lessons are unrecoverable, proceed to delete?': '删除过的课节将无法再找回，你确定要删除吗？',
	        'Lesson already exists in the selected time': '此时间段已排过课',
	        'Unable to change lesson time on the same date': '相同的日期无法修改时间',
	        'Conflict': '冲突',
	        'Reset Lesson Teacher': '重置课节老师',
	        'Reset Lesson Student': '重置课节学员',
	        'Reset Lesson Classroom': '重置课节教室',
	        'Empty': '清空',
	        '': ''
	    },
	    attendanceScan: {
	        'Smart Check In': '智能签到',
	        'Automatic Check In': '进行扫码签到',
	        'Scanning for attendance, please do not close this window': '扫码签到时，请不要关闭此窗口',
	        'Students': '用户',
	        'Class': '班级',
	        'Lesson': '课节',
	        'Time': '签到时间',
	        'Student has already checked in or has no lesson': '此学员已签到或无课节',
	        'Student does not exist in school or invalid code': '此学员不存在学校或二维码无效',
	        'Student has missed the lesson': '此学员已错过课节',
	        'Clock In/Clock Out': '上班/下班',
	        'Clock In': '上班',
	        'Clock Out': '下班'
	    },
	
	    dateFormat: {
	        'MMM DD, YYYY': 'YYYY年MM月DD日',
	        'ddd, MMM DD YYYY': 'YYYY年MM月DD日ddd'
	    },
	
	    image: {
	        'Image file must be png/jpeg under 5 MB': '图像文件必须是5 MB以下的 png/jpeg',
	        'Image not qualified': '图像不合格'
	    },
	    others: {
	        'Not Assigned': '未分配'
	    },
	
	    // ========== UNSORTED ===========
	    'Minimum': '下限',
	    'Maximum': '上限'
	};
	
	exports.default = locale;
	module.exports = exports["default"];

/***/ },

/***/ "QlXy":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _appwrapper, _classdetail;
	
	/**
	* Chinese Traditional
	*
	*/
	var locale = {
		schedule: {
			"Lesson Color": "課程顏色",
			"Select": "選擇",
			"Same date will only create single lesson": '日期相同時創建單次課節',
			'Class': '班級',
			'Select Class To Add Lesson': '選擇班級進行排課',
			'Select Class': '選擇班級',
			calendar: {
				"Attended": "已簽到",
				"Lesson": "課節"
			},
			'Attended lesson cannot be moved': '已簽到的課節不能被移動！',
			'(Lesson {lesson_number})': '(課節 {lesson_number})',
			'Time: {time}': '上課： {time}',
			'Classroom: {classroom}': '教室： {classroom}',
			'Student: {number}': '學員： {number} 人',
			"Attended": "已簽到",
			'Unattended': '未簽到',
			'All Teachers': '所有老師',
			'All Classes': '所有班級',
			'All Classrooms': '所有教室',
			'Add Lesson': '添加課程'
		},
		header: {
			"Change Language": "切換語言",
			"Premium Version": "升級高級版",
			"Privacy": '隱私政策',
			"Settings": '查看資料',
			"Switch School": '切換學校',
			"Personal Settings": '個人設置',
			"Sign Out": "登出",
			"Payment Information": '支付信息',
			"Please Enter Payment Information In Order To Upgrade To Permium Version ($79 USD per month per school), Invoice Will Be Sent Eletronically Via Email Every Month": '請填寫您的支付信息以確保您能正常使用高級版 (每月每學校$79 USD), 我们會通過郵件發送每個月的帳單',
			sidemenu: {
				"My channel": "我的頻道",
				"Class Schedule": "課表",
				"Student": "學員",
				"Class": "班級",
				"Private Class": "私課",
				"Teacher": "老師",
				"Classroom": "教室",
				"Announcement": "公告",
				"Statement Detail": "收支明细",
				"Monthly Summary": "月度匯總",
				"School Management": "學校管理",
				"School Administration": "教務權限",
				"School Information": "學校信息",
				"Sales Management": "銷售管理"
			},
			panelmenu: {
				"Teaching Management": "教學管理",
				"Financial Management": '財務管理',
				"School Management": '學校管理',
				"Sales Management": '營銷管理',
				'This feature is under development': '此功能正在開發中'
			}
		},
		checkoutform: {
			"Your purchase is successful!": "購買成功！",
			"Email Address": "郵件地址",
			"Credit or Debit Card": "信用卡或儲蓄卡資料",
			"Submit Payment": "購買",
			"Please Enter Email Address!": "必須填寫郵件地址！"
		},
		appwrapper: (_appwrapper = {
			"All field must be filled!": "必須填寫！",
			"Please enter your phone number": "請輸入您的手機號",
			"Next ": '下一步 ',
			"Verify your phone number": "驗證您的手機號",
			"Verification code not received in 60 seconds ": "60秒後還未收到 請 ",
			"Resend ": '重新發送 ',
			"code": "驗證碼",
			"Verification Code": "輸入四位驗證碼",
			"Password": '密碼',
			"Register": "註冊"
		}, _appwrapper["Verify your phone number"] = "驗證您的手機號", _appwrapper["Register successful"] = "註冊成功", _appwrapper['Create school'] = '開始創建學校', _appwrapper['School Information'] = '創建新學校必填內容', _appwrapper["School Name"] = '學校名字', _appwrapper["School Description"] = '學校描述', _appwrapper['School Type'] = '學校類型', _appwrapper['After School Class'] = '課後輔導班', _appwrapper['Pre School'] = '學前班', _appwrapper["Tutor"] = '家教', _appwrapper["The verification code is sent to: {phone}"] = '您的手機 {phone} 會收到驗證簡訊', _appwrapper['Login phone number {phone}'] = '登入手機號 {phone}', _appwrapper['Public/Private School'] = '公校/私校', _appwrapper['Student Enrollment Age Limit'] = '招收學員年齡下限', _appwrapper['Years Old'] = '歲', _appwrapper['Country'] = '選擇國家', _appwrapper['Province/States'] = '選擇地區', _appwrapper['City'] = '輸入城市', _appwrapper['Time Zone (Cannot Change After Saved)'] = '時區 (一旦保存不可更改)', _appwrapper['Currency (Cannot Change After Saved)'] = '貨幣 (一旦保存不可更改)', _appwrapper['Complete'] = '完成', _appwrapper['Sign In'] = '登入', _appwrapper['Forgot Password'] = '忘記密碼', _appwrapper['Register New Account'] = '註冊帳戶', _appwrapper),
		changeschool: {
			"You are over the school limit, please upgrade to Premium Version": "您目前的校區上限為1個校區, 添加更多校區請升級為高級版",
			"Create a new school ($79 USD per month per school), invoice will be sent eletronically via Email every month ": '創建新的1所學校 (每個月每學校 $79 USD), 我们會通過郵件發送每個月的帳單',
			"Cancel": '取消',
			"Save": '確認',
			' Create New School': ' 創建新學校',
			'Principle': '校長',
			'Teacher': '老師',
			'Decline': '拒絕',
			'Accept': '接受',
			'Delete School: {school_name}?': '確認刪除學校: {school_name} ?',
			" Delete": ' 刪除',
			"Exit School: {school_name}?": "確認退出學校: {school_name} ?",
			" Exit": ' 退出',
			'My School': '我的學校',
			"Delete School": '删除學校',
			" Back to My School": ' 返回我的學校'
		},
		administration: {
			"Permission Management": "權限管理",
			"Read Student": "讀取學員",
			'Edit Student': '更改學員',
			'Read Class': '讀取班級',
			'Edit Class': '更改班級',
			'Read Teacher': '讀取老師',
			'Edit Teacher': '更改老師',
			"Read Classroom": '讀取教室',
			'Edit Classroom': '更改教室',
			'Read Finance': '讀取財務',
			"Edit Finance": '更改財務',
			'Read Attendance': '讀取簽到',
			"Edit Attendance": '更改簽到',
			"Read Lesson": '讀取課節',
			"Edit Lesson": '更改課節',
			'Read Announcement': '讀取公告',
			'Edit Announcement': '更改公告',
			'Read Permission': '讀取權限',
			'Edit Permission': '更改權限',
			'Cannot delete this group': '無法刪除角色組',
			'Delete Group {group_name} ?': '確認刪除角色組：{group_name} ?',
			'Create New Group': '創新新角色組',
			" Edit": ' 編輯',
			'Group Members': '角色組成員'
		},
		createadministration: {
			'New Group Name': '新角色組名稱',
			"Add": '添加',
			"Added": '已添加',
			'Select Teacher': '選擇老師',
			"Add Member": '添加成員',
			"Please enter a group name": '請填寫角色組名稱',
			'Please select permissions': '請選擇權限',
			"Please select members": '請選擇成員',
			' Back': ' 返回'
		},
		announcement: {
			"All Classes and Studnets": '全體師生',
			"Delete Announcement: {title}": '確認刪除公告：{title} ？',
			"Announcer: ": "發布者：",
			'Date/Time: ': '發布時間：',
			'Send To: ': '發布送至： ',
			'Please enter announcement title': '請輸入通告標題搜索',
			'All': '全部',
			'New Announcement': '新建公告',
			'Edit Announcement': '編輯公告',
			'Please Enter Announcement Title': '請填入公告標題後才可以發布',
			'For: ': '公告對象: ',
			'Title: ': '公告標題： '
		},
		attendance: {
			" Attendance Record": " 簽到紀錄"
		},
		class: {
			'New Class: {new_cname} Has Been Created!': '新班級 {new_cname} 已創建！',
			'Class: {cname} Has Been Updated!': '班級 {cname} 已更新！',
			'Class: {cname} Has Been Archived': '班級 {cname} 已歸檔',
			'Class: {cname} Has Been Unarchived': '班級 {cname} 已恢復歸檔',
			'Class: {cname} Error': '班級 {cname} 操作失敗',
			'Class Status Update Failure: Network Connection Issue!': '班級狀態更新失敗：Network connection issue!',
			'Class: {cname} Archived?': '確認對 {cname} 班級進行歸檔？',
			'Lesson Scheduled': '已排課',
			'Lesson Started': '已開始上課',
			"Add Lesson": '增加課節',
			"Archived": '歸檔',
			"Unarchived": '恢復歸檔',
			"View": '查看',
			"Edit": '編輯',
			'Search Class': '請輸入關鍵詞搜索',
			'Current Class': '當期班級',
			'Archived Class': '歸檔班級',
			'Add Class': '新增班級',
			'Class Name': '班級名稱',
			'Date': '日期',
			'Lesson Amount': '課節數',
			'Teacher': '老師',
			'Price': "總價",
			'Students': '學員',
			'Status': '狀態',
			'Settings': '操作'
		},
		createnewclass: {
			'Create Class Failure': '班級創建失敗',
			'Class Teacher Update Failure': '班级老師更新失敗',
			'Class Student Update Failure': '班级學員更新失敗',
			'All Fields with * Must Be Filled': '带*號的字段必須填寫',
			'Remaining {i} Day': '剩餘 {i} 天提醒',
			'Reminder': '提醒時間',
			'Remaining {i} Lesson': '剩餘{i}節課提醒',
			'Create New Class': '新增班級',
			'Enter Class Name': '輸入班級名稱',
			'Charged Reminder Options': '收費提醒方式',
			'Remind at End Date': '到期日提醒',
			'Remind at Last Lesson': '課次消耗完提醒',
			'Student Number': '招生人數',
			'': '人',
			'Lesson Completion Rules': '課消規則',
			'Attending count as completion': '按簽到算課消',
			'Absence count as completion': '請假算課消',
			'Truancy count as completion': '缺課算課消'
		},
		editclass: {
			'Class Update Failure': '班級更新失敗',
			'Edit Class': '編輯班級'
		},
		classdetail: (_classdetail = {
			'Attended': '出勤',
			'Class: {cname} Has Been Updated!': '班級 {cname} 已更新！',
			'Lesson Teacher Updated': '課節老師已更新',
			'Lesson Teacher Update Failure': '課節老師更新失敗',
			'New Lesson: {new_name} Saved': '新課節 {new_name} 已保存',
			'Lesson Name Update Failure': '課節名稱更新失敗',
			'Lesson Deleted': '課節已刪除',
			'Lesson Delete Failure': '刪除課節失敗',
			'Lesson: {lesson_name} Added': '課節: {lesson_name} 已添加',
			'Add Lesson Failure': '添加課節失敗',
			'Student Has Exited Class': '學員已退班',
			'Student Exit Class Failure': '學員退班失敗',
			'Student: {studnet_name} refunded {amount_of_money} {currency} successful!': '學員: {student_name} 退款 {amount_of_money} {currency} 成功！',
			'Student: {studnet_name} added credit {amount_of_money} {currency} successful!': '學員 {student_name} 充值 {amount_of_money} {currency} 成功！',
			'Student: {studnet_name} charged {amount_of_money} {currency} successful!': '學員 {student_name} 收費 {amount_of_money} {currency} 成功！',
			"Delete {name}'s Lesson?": '確認刪除 {name} 的課節?',
			'Class Price': '課程總價',
			'Payment Reminder': '收費提醒',
			'Past Lesson Counts': '已上課節',
			'Enrollment Status': '招生情況',
			'Checked In': '已簽到',
			'Check In': '簽到',
			'Remaining': '餘',
			'Overdue ': '欠費 ',
			'Exited Class': '已退班',
			'Student Detail': '查看學員資料',
			'Remarks': '備註',
			'Exit Class': '退班',
			'Exit Student: {name} From Class?': '確認對學員 {name} 進行退班?',
			'Refund and Exit Class': '退款並退班',
			'Add Student': '添加學員',
			'Search Students': '搜索學員名稱...',
			'{age} Years Old': '{age} 歲',
			'Attendance': '出勤簽到',
			'Lesson Completion Rule: ': '課消規則：',
			'Lesson Time: ': '上課時間：',
			'{lsnStartDate1} - {lsnStartDate2} - {lsnStartDate3}  {lsnStartTime} - {lsnEndTime}': '{lsnStartDate1} 年 {lsnStartDate2} 月 {lsnStartDate3} 日 {lsnStartTime} - {lsnEndTime}',
			'None': '無',
			'Leave of Absence': '請假',
			'Late': '遲到',
			'Absence': '曠課',
			'Total of {total_amount} person {total_amount2} Attended': '共 {total_amount} 人 出勤 {total_amount2} 人',
			'Lesson': '課節',
			'Insufficient Account Balance, Please Top Up and Try Again': '當前您的錢包餘額不足，請充值後再使用',
			'Insufficient Balance. Please Top Up or Try Other Payment Options': '當使用錢包餘額時，收款金額不能大於錢包餘額！為了正常交易，您可以先充值在使用錢包或使用其他交易方式',
			'Exit Class Until': '退課期至',
			'Exit Class Number': '退課次',
			'': '次',
			'Account Balance: ': '錢包餘額: ',
			'Refund': '退款',
			'Refund Tuition': '直接退學費',
			'Refund Date': '退款日期',
			'Class': '班級',
			'Refund Options': '退款方式',
			'Cash': '現金',
			'Credit Card': '信用卡',
			'Cheque': '支票',
			'Bank Transfer': '轉帳',
			'Account Balance': '校內錢包',
			'Email': '郵箱',
			'Paper Receipt Number': '紙質收據號',
			'Send Recipt To Parents': '電子收據會通過郵件發送給家長',
			'Exit Student: {sname} From Class?': '確認對學員： {sname} 退班?',
			'Refund Date Cannot Be Empty': '退款日期不能為空',
			'Proceed To Refund transaction and Exit Class For Student: {sname} ?': '確認對學員 {sname} 進行退款和退班?',
			'Same date will only create single lesson': '日期相同時創建單次課節',
			'Start Date Must Be Earlier Than End Date': '開始日期必須早於或等於结束日期',
			'End Date Must Be Later Than Start Date': '结束日期必須晚於或等於開始日期',
			'End Time Must Be Later Than Start Time': '结束時間必須晚於開始時間',
			'Please Select Lesson Date and Time': '請選擇課節日期和時間',
			'End Date/Time Must Be Later Than Start Date/Time': '结束日期或時間必須晚於開始日期或時間',
			'Please Select Days': '請選擇周中日期',
			'Please Select Dates': '請選擇月中日期',
			'Please Select Lesson Date': '請選擇課節日期',
			'Select Student': '選擇學員',
			'Select Classroom': '選擇教室',
			'Search Classroom': '搜索教室',
			'Every': '每',
			'(Can Select Multiple)': '(可多選)',
			'Frequency': '頻率',
			'Start Date': '開始日期',
			'End Date': '结束日期',
			'Start Time (HH:MM)': '上課時間 (HH:MM)',
			'End Time (HH:MM)': '下課時間 (HH:MM)',
			'Batch Scheduling': '批量排課',
			'Lesson Has {student} Students': '班級學員 {student} 人',
			'Select': '選擇',
			'Classroom': '教室',
			'Conflict': '衝突',
			'Lesson Date': '上課日期',
			'Delete Lesson': '刪除這一課節',
			'ID': '序號',
			'Lesson Time': '上課時間',
			'Student Counts': '學員人數',
			'Class Student': '班級學員',
			'Lesson Count': '排課課次',
			'Lesson Status': '上課進度'
		}, _classdetail["Checked In"] = '已簽到', _classdetail['Please Select'] = '請選擇...', _classdetail["When 'Account Balance' reaches 0, student: {name} will automatically exit class"] = '輸入‘退款金額’為零時，執行‘確定’後將學員 {name} 直接退出班級', _classdetail['Please Select Class and Enter Refund Amount'] = '請您首先選擇班級，並填入退款金額', _classdetail),
		classone: {
			'New class: {cname} Has Been Created': '新班級： {cname} 已創建',
			'Class: {cname} Has Been Updated': '班級： {cname} 已更新',
			'Class: {cname} Archived': '班級： {cname} 已歸檔',
			'Class: {cname} Unarchived': '班級： {cname} 已恢復歸檔',
			'Class: {cname} Failure': '班級： {cname} 操作失敗',
			'Class Status Update Failure': '班級狀態更新失敗',
			"Archived {studentName}'s {cName} ?": "確認對學員 {studentName} 的 {cName} 進行歸檔？",
			'Scheduled': '已排課',
			'Class Started': '已開始上課',
			'Search Students': '請輸入學員名稱搜索',
			'Current Private Class': '當期私課',
			'Archived Private Class': '歸檔私課',
			'Add Private Class': '新增私課',
			'Student Name': '學員名稱',
			'Private Class Name': '私課名稱',
			'Enter Private Class Name': '輸入私課名稱'
		},
		schoolInformation: {
			"School Information": "學校基本信息",
			"Complete all information that helps your audience understand better on the Yellow Pages": "填寫完善的信息，將有助於您在黃頁上更清晰的展現您的學校",
			form: {
				"School Name": "學校中文名稱",
				"School Logo": "學校logo",
				"School Home Page": "學校官網主頁",
				"Time Zone": "時區",
				"Currency": "貨幣總類",
				"Phone": "學校聯繫電話",
				"Email": "學校聯繫Email",
				"School Type": "學校類型",
				"Category": "課程種類",
				"Student Age": "招收學員年齡"
			}
		},
		createone: {
			'Create Class Failure': '班級創建失敗',
			'Class Teacher Update Failure': '班級老師更新失敗',
			'Class Student Update Failure': '班級學員更新失敗',
			'Private Class': '私課',
			'Edit Student': '編輯學員',
			'Add New Private Class': '新增私課',
			'Edit Teacher': '編輯老師'
		},
		editone: {
			'Edit Private Class': '編輯私課',
			'Student Name': '學員姓名'
		},
		classroom: {
			'Classroom: {classroom} Has Been Created': '教室： {classroom} 創建',
			'Classroom: {classroom} Has Been Updated': '教室： {classroom} 已更新',
			'Create Classrom: {classroom} Successful': '新建教室： {classroom} 成功',
			"Classroom: {classroom}'s Info Has Been Saved'": '修改教室： {classroom} 的信息已保存',
			'Classroom: {classroom} Deleted': '刪除教室： {classroom} 完成',
			'Delete Classroom: {name} ?': '確認刪除： {name} 教室？',
			'Delete': '刪除',
			'Classroom ({amount})': '教室 ({amount})',
			'Create Classroom': '新增教室',
			'Classroom Name': '教室名稱',
			'Enter Classroom Name': '輸入教室名',
			'Edit Classroom': '編輯教室',
			'Amount': '退款金額'
		},
		teacher: {
			'Teacher: {tname} Has Been Created': '老師: {tname} 已創建',
			'Create Teacher Failure': '添加老師失敗',
			'Please exit from all current classes before archiving the teacher': '請您先退出當期班級，才可在學校中歸檔',
			"Teacher: {tname}'s Info Has Been Saved": '老師： {tname} 的信息已保存',
			"Teacher: {tname}'s Unarchived Failure": '老師： {tname} 恢復歸檔失敗',
			'Send Invitation To Teacher: {tname}?': '發送邀請給老師: {tname}?',
			'Created': '已創建',
			'Invited': '已邀請',
			'Confirm': '已確認',
			'Declined': '已拒絕',
			'Male': '男',
			'Female': '女',
			'Options': '更多操作',
			'Attendance': '簽到紀錄',
			'Upgrade to Premium': '升級高級版',
			'You are over the teacher limit, please upgrade to premium version': '您目前的老師上限為20個老師, 添加更多老師請升級為高級版',
			'Current Teachers': '當期老師',
			'Archived Teachers': '歸檔老師',
			'Add Teacher': '新增老師',
			'Teacher Name': '老師姓名',
			'Gender': '性別',
			'Mobile Phone Number': '手機號',
			'Lesson Taught Counts': '已教課次數',
			'Lesson Taught Hours': '已教課時',
			'Please enter a valid phone number': '請輸入正確的手機號碼',
			'Create New Teacher': '新增老師',
			"Enter Teacher's Name": '輸入老師姓名',
			'Save and Invite': '保存並邀請',
			'Edit Teacher': '編輯老師',
			'Date': '退款日期',
			'Amount': '收款金額',
			"Enter a phone number to invite teacher to download mobile App and the teacher could change attendance for themsevles and their students, as well as receiving announcement and schedule. You could change teccher's permission inside the permissions settings": '填寫手機號可以邀請老師下載手機端APP, 老師可以用APP給自己和學生簽到, 接收通知和課表, 您可以在權限設置裡安排老師的權限',
			'Phone number already existed': '此手機號已存在'
	
		},
		finance: {
			'Add Credit': '校內錢包',
			'Showing {amount} records Total of {amount2} records': '顯示 {amount} 條紀錄 全部 {amount2} 條紀錄',
			'{transaction_date} - {transaction_date2} - {transaction_date3}': '{transaction_date} 年 {transaction_date2} 月 {transaction_date3} 日',
			'Charge': '收費',
			'Refund': '退費',
			'Please enter remarks content': '請輸入備註內容',
			'Send To': '發送至',
			'Send': '發送',
			'Transaction Summary': '交易紀錄',
			'Student: ': '學員： ',
			'E-Reciept Number: ': '電子收據號： ',
			'All': '所有',
			'Class: ': '班級： ',
			'Date: ': '日期： ',
			'E-Receipt Number': '輸入電子收據號',
			'Search': '搜索',
			'E-Receipt No.': '電子收據號',
			'Student': '學員',
			'Charge/Refund': '收費/退費',
			'Amount': '金額',
			'Payment Methods': '付款方式',
			'Purchased Counts': '購買課次',
			'Operator': '經辦人',
			'Receipt No.': '收據號',
			'Added': '創建',
			'Payment': '收款',
			'Date': '收款日期'
	
		},
		monthlyFinance: {
			'Search by Date': '篩選日期',
			'Monthly Income': '本月收入',
			'Monthly Spending': '本月支出',
			'Net Income': '本月淨收入'
		},
		student: {
			'New Student: {name} Has Been Created': '新學員： {name} 已創建',
			"Student: {name}'s Info Has Been Updated": '學員： {name} 信息已更新',
			'Exited Class': '已退出班級',
			'You Do Not Have the Permission to Visit This Page, Please Contact the School Principle/Manager for More Information': '您所在的用戶組不具有此操作的權限，請聯絡該學校的校長或管理員授與您相應的權限',
			'Student {name} {remarks}': '學員 {name} {remarks}',
			'Student {name} {reason}': '學員 {name} {reason}',
			'Student Payment Failure': '學員繳費失敗',
			'Student: {name} Archived': '學員： {name} 已歸檔',
			'Student: {name} Unarchived': '學員： {name} 已恢復歸檔',
			'Multiple Student Archived': '多個學員已歸檔',
			'Student Info Update Failure': '學員狀態更新失敗',
			'Added': '加入',
			'Student: {name} Refunded {amount} {currency} Successful': '學員： {name} 退款 {amount} {currency} 成功',
			'Student: {name} Added Credit {amount} {currency} Successful': '學員： {name} 充值 {amount} {currency} 成功',
			'Student: {name} Charged {amount} {currency} Successful': '學員： {name} 收費 {amount} {currency} 成功',
			'Insufficient balance in your account, please add credit and try again': '當前您的錢包餘額不足，請充值後再使用',
			"Selected 'Reduce Lesson' is more than 'Purchased Lesson'": '選擇的“減少課期”大於“已購買課期',
			'When making a payment through your account, make sure you have sufficient balance. Please add credit to your account to continue': '當使用錢包餘額時，收款金額不能大於錢包餘額 為了正常交易，您可以先充值在使用錢包或使用其他交易方式',
			'Please select a class and enter the amount for refund': '請您首先選擇班級，並填入退款金額',
			'Please enter the appropriate refund amount': '請您填入合適退款金額',
			'Refund date cannot be empty': '退款日期不能為空',
			'Please select a class and enter the amount charged': '請您首先選擇班級，並填入收款金額',
			'Please enter the appropriate charged amount': '請您填入合適收款金額',
			'Charged date cannot be empty': '付款日期不能為空',
			'Proceed to archive student: {name} ？': '是否將學員： {name} 歸檔？',
			'Please exit all classes in order to archived student': '請您先在班級中歸檔，才可在學校中歸檔',
			'Proceed to unarchive student: {name} ？': '是否將學員： {name} 取消歸檔？',
			'Showing {amount} students Total of {amount2} students': '顯示 {amount} 人 全部 {amount2} 人',
			'Price ${fee}': '課價 ${fee}',
			'Exit student from class?': '確認將此學員退出班級？',
			'Exit Class': '退出班級',
			'Join Class': '加入班級',
			'Add Credit': '錢包充值',
			'Charged': '收費',
			'Add credit to your account and can be use to settle fees': '給此學員的校內錢包充值，並通用與任何校內費用的結算',
			'Collecting tuition fee and renewal': '直接收取學費、續費等',
			'Account Remaining: ': '錢包餘額兒： ',
			'Enter recipient email': '輸入收件人郵箱',
			'Paper Receipt Number': '輸入收據號',
			'Date': '充值日期',
			'Amount': '充值金額',
			'Purchased Lesson Until...': '購買課期至',
			'': '次',
			'Exit Lesson Until...': '退課期至',
			'Exit Lesson Number': '退課次',
			'Choose one...': '請選擇...',
			'Purchased Lesson': '已購買課期',
			'Renew Lesson Until...': '續課期至',
			'Purchased Lesson Hour': '購買課時',
			'Hour': '小時',
			'Add remarks': '添加備註',
			'Edit Lesson Until...': '修改課期至',
			'Reduce Lesson Number': '減少課次',
			'Reduce Lesson Hour': '減少課時',
			'Join Current Classes': '加入當期班級',
			'Search Class Name': '搜索班級名稱...',
			'Currently Enrolled': '正在就讀',
			'You are over the student limit, please upgrade to premium version': '您目前的學員上限為50個學員, 添加更多學員請升級為高級版',
			'Create Class': '創建班級',
			'Create Student': '新增學員',
			'Multiple Students Has Been {action} To Class: {cname}': '多個學員被 {action} 到班级： {cname}',
			'View Now': '立即查看',
			'Failure: Students Are Already Enrolled In Class': '失敗： 學員已經加入該班级',
			'Current Student': '當期學員',
			'Not Enrolled Student': '未排班學員',
			'Enrolled Student': '在讀學員',
			'Pending Renewal Student': '待續費學員',
			'Archived Student': '往期學員',
			'Student': '學員',
			'Age': '年齡',
			'Class': '班級',
			'Class Status': '學費消耗',
			'Payment': '已缴學費',
			'Settings': '操作',
			'{i}': '{i}日',
			'Student List': '學生列表',
			"Archive": "歸檔",
			"Create Private Class": "創建私課",
			"Edit": "編輯",
			"Attendance": "查看簽到紀錄",
			'Remove "{sName}" From "{className}"?': '確認將此學生({sName})退出班級({className})嗎？',
			'Registration Guide': '前台報名',
			'Self-registration Setup': '前台報名設置',
			'Step One': '第一步',
			'Step Two': '第二步',
			'Step Three': '第三步',
			'Step Four': '第四步'
	
		},
		createstudent: {
			'Please enter a valid Email address': '請輸入正確的郵件地址',
			'Please enter a valid phone number': '請輸入正確的手機號碼',
			'Please upgrade to premium version': '請升級高級版',
			'{i}': '{i} 年',
			'January': '1月',
			'February': '2月',
			'March': '3月',
			'April': '4月',
			'May': '5月',
			'June': '6月',
			'July': '7月',
			'August': '8月',
			'September': '9月',
			'October': '10月',
			'November': '11月',
			'December': '12月',
			'First Name': '名稱',
			'Last Name': '姓氏',
			'Date of Birth': '生日',
			'Home Phone Number': '家庭電話',
			'Email': '郵件',
			'Nickname': '暱稱',
			'Source': '來源',
			'Parents Name': '家長名字',
			'Relationship': '親屬關係',
			'Address': '居住地址',
			'Register Date': '註冊日期',
			'Basic Information': '基本信息'
		},
		settings: {
			' Password': ' 密碼',
			'Reset Password': '重新設置密碼'
		},
		studentdetail: {
			'Paid Amount': '已繳學費',
			'Refund Amount': '退款學費',
			'Refund Lesson Date': '退款課期',
			'Refund Lesson Number': '退款課次',
			'Refund Lesson Hour': '退款課時',
			'Send To': '發送至',
			'{transaction_date1} - {transaction_date2} - {transaction_date3}': '{transaction_date1} 年 {transaction_date2} 月 {transaction_date3} 日',
			'Search Class': '所有',
			'Options': '充值方式',
			"Amount": '充值金額',
			'Student: {name}': '學員： {name}',
			'Account Balance {balance} CAD': '錢包現有金額: {balance} CAD',
			'Please enter amount': '請填入收款金額',
			'Amount needs to Bb greater than 0': '金額必須大於零',
			'Historical Class Record': '歷史班級',
			"Attendance Record": "簽到紀錄",
			'Tuition Record': '學費紀錄',
			'Edit Basic Information': '修改基本信息',
			'Account Balance: ': '錢包現有金額： ',
			'Paper Receipt No': '紙質收據號'
		}
	};
	
	exports.default = locale;
	module.exports = exports["default"];

/***/ },

/***/ "pthn":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  schooltypes: {
	    'academic': 'Academic',
	    'after_school_care': 'After School Core',
	    "board_games": 'Board Games',
	    "college": 'College',
	    "college_prep": 'College Prop',
	    "cooking": 'Cooking',
	    "dance": 'Dance',
	    "daycare_and_babysitting": 'Daycare and Babysitting',
	    "events": 'Events',
	    "fine_arts": 'Fine Arts',
	    "fitness": 'Fitness',
	    "languages": 'Languages',
	    "martial_arts": 'Martial Arts',
	    "math": 'Math',
	    "music": 'Music',
	    "outdoor_activities": 'Outdoor Activities',
	    "performing_arts": 'Performing Arts',
	    "photography_and_movie_making": 'Photography and Movie Making',
	    "private_school": 'Private School',
	    "programming": 'Programming',
	    "public_school": 'Public School',
	    "reading": 'Reading',
	    "science": 'Science',
	    "sports": 'Sports',
	    "university": 'University'
	  },
	  settings: {
	    'monthly': 'Monthly',
	    'yearly': 'Yearly'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "P6Vt":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/**
	 * French
	 *
	 */
	
	var locale = {
		"Permission Management": "Gestion des permissions",
		header: {
			"Change Language": "Langues",
			sidemenu: {
				"My channel": "Ma Chaîne",
				"Class Schedule": "Horaire de cours",
				"Student": "étudiant",
				"Class": "classe",
				"Private Class": "私课",
				"Teacher": "老师",
				"Classroom": "教室",
				"Announcement": "公告",
				"Statement Detail": "收支明细",
				"Monthly Summary": "月度汇总",
				"School Management": "学校管理",
				"School Administration": "教务权限",
				"School Information": "学校信息",
				"Sales Management": "销售管理"
			}
		},
		schoolInformation: {
			form: {
				"School Name": "学校中文名称",
				"School Logo": "学校logo",
				"School Home Page": "学校官网主页",
				"Time Zone": "时区",
				"Currency": "货币种类"
			}
		}
	};
	
	exports.default = locale;
	module.exports = exports["default"];

/***/ },

/***/ "PFVx":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/**
	 * Korean
	 *
	 */
	
	var locale = {
		"Permission Management": "유저권한",
		header: {
			"Change Language": "언어변환",
			"Premium Version": "유료버전 전환",
			sidemenu: {
				"My channel": "나의 채널",
				"Class Schedule": "클라스 스케쥴",
				"Student": "학생",
				"Class": "클라스",
				"Private Class": "개인클라스",
				"Teacher": "교사",
				"Classroom": "교실",
				"Announcement": "공고",
				"Statement Detail": "명세서세부정보",
				"Monthly Summary": "월별개요",
				"School Management": "학교관리",
				"School Administration": "권한관리",
				"School Information": "학교정보",
				"Sales Management": "영업관리"
			}
		},
		schoolInformation: {
			"School Information": "학교기본정보",
			"Complete all information that helps your audience understand better on the Yellow Pages": "입력하신 정보는 학교 소개 웹사이트에 사용됩니다.",
			form: {
				"School Name": "학교 이름",
				"School Logo": "학교 로고",
				"School Home Page": "홈페이지",
				"Time Zone": "시간대",
				"Currency": "화폐종류",
				"Phone": "전화번호",
				"Email": "이메일",
				"School Type": "학교종류",
				"Category": "클라스종류",
				"Student Age": "학생연령대"
			}
		}
	};
	
	exports.default = locale;
	module.exports = exports["default"];

/***/ },

/***/ "1Tgc":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var momentLocaleCode = {
	  'CN': 'zh-cn'
	};
	
	var code = localStorage.getItem('language');
	
	var language = momentLocaleCode[code] || 'en';
	
	_moment2.default.locale(language);

/***/ },

/***/ 2:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": "3CJN",
		"./af.js": "3CJN",
		"./ar": "3MVc",
		"./ar-dz": "tkWw",
		"./ar-dz.js": "tkWw",
		"./ar-kw": "j8cJ",
		"./ar-kw.js": "j8cJ",
		"./ar-ly": "wPpW",
		"./ar-ly.js": "wPpW",
		"./ar-ma": "dURR",
		"./ar-ma.js": "dURR",
		"./ar-sa": "7OnE",
		"./ar-sa.js": "7OnE",
		"./ar-tn": "BEem",
		"./ar-tn.js": "BEem",
		"./ar.js": "3MVc",
		"./az": "eHwN",
		"./az.js": "eHwN",
		"./be": "3hfc",
		"./be.js": "3hfc",
		"./bg": "lOED",
		"./bg.js": "lOED",
		"./bm": "hng5",
		"./bm.js": "hng5",
		"./bn": "aM0x",
		"./bn.js": "aM0x",
		"./bo": "w2Hs",
		"./bo.js": "w2Hs",
		"./br": "OSsP",
		"./br.js": "OSsP",
		"./bs": "aqvp",
		"./bs.js": "aqvp",
		"./ca": "wIgY",
		"./ca.js": "wIgY",
		"./cs": "ssxj",
		"./cs.js": "ssxj",
		"./cv": "N3vo",
		"./cv.js": "N3vo",
		"./cy": "ZFGz",
		"./cy.js": "ZFGz",
		"./da": "YBA/",
		"./da.js": "YBA/",
		"./de": "DOkx",
		"./de-at": "8v14",
		"./de-at.js": "8v14",
		"./de-ch": "Frex",
		"./de-ch.js": "Frex",
		"./de.js": "DOkx",
		"./dv": "rIuo",
		"./dv.js": "rIuo",
		"./el": "CFqe",
		"./el.js": "CFqe",
		"./en-au": "Sjoy",
		"./en-au.js": "Sjoy",
		"./en-ca": "Tqun",
		"./en-ca.js": "Tqun",
		"./en-gb": "hPuz",
		"./en-gb.js": "hPuz",
		"./en-ie": "ALEw",
		"./en-ie.js": "ALEw",
		"./en-nz": "dyB6",
		"./en-nz.js": "dyB6",
		"./eo": "Nd3h",
		"./eo.js": "Nd3h",
		"./es": "LT9G",
		"./es-do": "7MHZ",
		"./es-do.js": "7MHZ",
		"./es-us": "INcR",
		"./es-us.js": "INcR",
		"./es.js": "LT9G",
		"./et": "XlWM",
		"./et.js": "XlWM",
		"./eu": "sqLM",
		"./eu.js": "sqLM",
		"./fa": "2pmY",
		"./fa.js": "2pmY",
		"./fi": "nS2h",
		"./fi.js": "nS2h",
		"./fo": "OVPi",
		"./fo.js": "OVPi",
		"./fr": "tzHd",
		"./fr-ca": "bXQP",
		"./fr-ca.js": "bXQP",
		"./fr-ch": "VK9h",
		"./fr-ch.js": "VK9h",
		"./fr.js": "tzHd",
		"./fy": "g7KF",
		"./fy.js": "g7KF",
		"./gd": "nLOz",
		"./gd.js": "nLOz",
		"./gl": "FuaP",
		"./gl.js": "FuaP",
		"./gom-latn": "+27R",
		"./gom-latn.js": "+27R",
		"./gu": "rtsW",
		"./gu.js": "rtsW",
		"./he": "Nzt2",
		"./he.js": "Nzt2",
		"./hi": "ETHv",
		"./hi.js": "ETHv",
		"./hr": "V4qH",
		"./hr.js": "V4qH",
		"./hu": "xne+",
		"./hu.js": "xne+",
		"./hy-am": "GrS7",
		"./hy-am.js": "GrS7",
		"./id": "yRTJ",
		"./id.js": "yRTJ",
		"./is": "upln",
		"./is.js": "upln",
		"./it": "FKXc",
		"./it.js": "FKXc",
		"./ja": "ORgI",
		"./ja.js": "ORgI",
		"./jv": "JwiF",
		"./jv.js": "JwiF",
		"./ka": "RnJI",
		"./ka.js": "RnJI",
		"./kk": "j+vx",
		"./kk.js": "j+vx",
		"./km": "5j66",
		"./km.js": "5j66",
		"./kn": "gEQe",
		"./kn.js": "gEQe",
		"./ko": "eBB/",
		"./ko.js": "eBB/",
		"./ky": "6cf8",
		"./ky.js": "6cf8",
		"./lb": "z3hR",
		"./lb.js": "z3hR",
		"./lo": "nE8X",
		"./lo.js": "nE8X",
		"./lt": "/6P1",
		"./lt.js": "/6P1",
		"./lv": "jxEH",
		"./lv.js": "jxEH",
		"./me": "svD2",
		"./me.js": "svD2",
		"./mi": "gEU3",
		"./mi.js": "gEU3",
		"./mk": "Ab7C",
		"./mk.js": "Ab7C",
		"./ml": "oo1B",
		"./ml.js": "oo1B",
		"./mr": "5vPg",
		"./mr.js": "5vPg",
		"./ms": "ooba",
		"./ms-my": "G++c",
		"./ms-my.js": "G++c",
		"./ms.js": "ooba",
		"./mt": "oCzW",
		"./mt.js": "oCzW",
		"./my": "F+2e",
		"./my.js": "F+2e",
		"./nb": "FlzV",
		"./nb.js": "FlzV",
		"./ne": "/mhn",
		"./ne.js": "/mhn",
		"./nl": "3K28",
		"./nl-be": "Bp2f",
		"./nl-be.js": "Bp2f",
		"./nl.js": "3K28",
		"./nn": "C7av",
		"./nn.js": "C7av",
		"./pa-in": "pfs9",
		"./pa-in.js": "pfs9",
		"./pl": "7LV+",
		"./pl.js": "7LV+",
		"./pt": "ZoSI",
		"./pt-br": "AoDM",
		"./pt-br.js": "AoDM",
		"./pt.js": "ZoSI",
		"./ro": "wT5f",
		"./ro.js": "wT5f",
		"./ru": "ulq9",
		"./ru.js": "ulq9",
		"./sd": "fW1y",
		"./sd.js": "fW1y",
		"./se": "5Omq",
		"./se.js": "5Omq",
		"./si": "Lgqo",
		"./si.js": "Lgqo",
		"./sk": "OUMt",
		"./sk.js": "OUMt",
		"./sl": "2s1U",
		"./sl.js": "2s1U",
		"./sq": "V0td",
		"./sq.js": "V0td",
		"./sr": "f4W3",
		"./sr-cyrl": "c1x4",
		"./sr-cyrl.js": "c1x4",
		"./sr.js": "f4W3",
		"./ss": "7Q8x",
		"./ss.js": "7Q8x",
		"./sv": "Fpqq",
		"./sv.js": "Fpqq",
		"./sw": "DSXN",
		"./sw.js": "DSXN",
		"./ta": "+7/x",
		"./ta.js": "+7/x",
		"./te": "Nlnz",
		"./te.js": "Nlnz",
		"./tet": "gUgh",
		"./tet.js": "gUgh",
		"./th": "XzD+",
		"./th.js": "XzD+",
		"./tl-ph": "3LKG",
		"./tl-ph.js": "3LKG",
		"./tlh": "m7yE",
		"./tlh.js": "m7yE",
		"./tr": "k+5o",
		"./tr.js": "k+5o",
		"./tzl": "iNtv",
		"./tzl.js": "iNtv",
		"./tzm": "FRPF",
		"./tzm-latn": "krPU",
		"./tzm-latn.js": "krPU",
		"./tzm.js": "FRPF",
		"./uk": "ntHu",
		"./uk.js": "ntHu",
		"./ur": "uSe8",
		"./ur.js": "uSe8",
		"./uz": "XU1s",
		"./uz-latn": "/bsm",
		"./uz-latn.js": "/bsm",
		"./uz.js": "XU1s",
		"./vi": "0X8Q",
		"./vi.js": "0X8Q",
		"./x-pseudo": "e/KL",
		"./x-pseudo.js": "e/KL",
		"./yo": "YXlc",
		"./yo.js": "YXlc",
		"./zh-cn": "Vz2w",
		"./zh-cn.js": "Vz2w",
		"./zh-hk": "ZUyn",
		"./zh-hk.js": "ZUyn",
		"./zh-tw": "BbgG",
		"./zh-tw.js": "BbgG"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2;


/***/ },

/***/ "pnOm":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	__webpack_require__("uSDZ");
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("g4RF");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _reactRouterRedux = __webpack_require__("jZgO");
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _routes = __webpack_require__("DP/h");
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _reactKeydown = __webpack_require__("BZBu");
	
	var _reactKeydown2 = _interopRequireDefault(_reactKeydown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// 
	// should be the only scss imported
	//
	
	
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, _store2.default);
	
	var App = function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  App.prototype.componentWillMount = function componentWillMount() {
	    document.body.className += ' locale-' + __localeName();
	  };
	
	  App.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('app-wrapper') },
	      _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: _store2.default },
	        _react2.default.createElement(_routes2.default, { history: history })
	      )
	    );
	  };
	
	  return App;
	}(_react2.default.Component);
	
	// for safari
	
	
	window.addEventListener('unhandledrejection', function (event) {
	
	  // Prevent error output on the console:
	  event.preventDefault();
	
	  console.error('Reason: ', event.reason, event);
	});
	
	exports.default = App;
	module.exports = exports['default'];

/***/ },

/***/ "BGi1":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.alert = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Alert = __webpack_require__("7+Oe");
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultConfirmation = (0, _reactConfirm.createConfirmation)(_Alert2.default);
	
	var alert = exports.alert = {
		message: function message(text, title) {
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
			return defaultConfirmation(_extends({
				text: text,
				title: title,
				alertType: "message"
			}, options));
		},
		fail: function fail(text, title) {
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
			return defaultConfirmation(_extends({
				text: text,
				title: title,
				alertType: "fail"
			}, options));
		},
		warning: function warning(text, title) {
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
			return defaultConfirmation(_extends({
				text: text,
				title: title,
				alertType: "warning"
			}, options));
		},
		success: function success(text, title) {
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
			return defaultConfirmation(_extends({
				text: text,
				title: title,
				alertType: "success"
			}, options));
		},
		error: function error(text, title) {
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
			return defaultConfirmation(_extends({
				text: text,
				title: title,
				alertType: "error"
			}, options));
		}
	};
	
	exports.default = alert;

/***/ },

/***/ "7+Oe":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Button = __webpack_require__("DoE4");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("vVJg");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_ALERT_WIDTH = 352;
	
	var Alert = function (_React$Component) {
		_inherits(Alert, _React$Component);
	
		function Alert() {
			_classCallCheck(this, Alert);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		Alert.prototype.render = function render() {
			var _props = this.props,
			    okButtonTitle = _props.okButtonTitle,
			    title = _props.title,
			    text = _props.text,
			    show = _props.show,
			    proceed = _props.proceed,
			    dismiss = _props.dismiss,
			    cancel = _props.cancel,
			    alertType = _props.alertType,
			    _props$enableEscape = _props.enableEscape,
			    enableEscape = _props$enableEscape === undefined ? true : _props$enableEscape;
	
	
			return _react2.default.createElement(
				_Modal2.default,
				{
					isShowingModal: show // if you want to show it when component mounts, set it true
					, className: (0, _classnames2.default)("alert-modal", "classtop-alert-" + alertType),
					fixedWidth: this._getAlertWidth(),
					allowCloseByClickingShadow: true
					// contentHeight={300}
	
					, hasHeader: true,
					headerType: 'bold' // default, bold
					, headerTitle: this._renderAlertTitle(),
	
					hasFooter: true,
					footerType: 'bold' // grey, transparent, bold
					, footerButtons: [{
						title: okButtonTitle || __("Confirm", "UI.alert"),
						className: "btn btn-primary pull-right",
						onClick: proceed
					}]
				},
				_react2.default.createElement(
					'div',
					{ className: 'alert-content' },
					_react2.default.createElement(
						'div',
						{ className: 'alert-text' },
						text
					)
				)
			);
		};
	
		Alert.prototype._renderAlertTitle = function _renderAlertTitle() {
			var _props2 = this.props,
			    title = _props2.title,
			    alertType = _props2.alertType;
	
	
			var icon = void 0;
	
			switch (alertType) {
				case "message":
					break;
				case "warning":
					icon = _react2.default.createElement(
						'div',
						{ className: 'alert-icon' },
						_react2.default.createElement('i', { className: 'fa icon-attention-alt' })
					);
					break;
				case "success":
					icon = _react2.default.createElement(
						'div',
						{ className: 'alert-icon' },
						_react2.default.createElement('i', { className: 'fa icon-ok' })
					);
					break;
				case "fail":
					icon = _react2.default.createElement(
						'div',
						{ className: 'alert-icon' },
						_react2.default.createElement('i', { className: 'fa icon-cancel' })
					);
					break;
				case "error":
					icon = _react2.default.createElement(
						'div',
						{ className: 'alert-icon' },
						_react2.default.createElement('i', { className: 'fa icon-attention-alt' })
					);
					break;
			}
	
			return _react2.default.createElement(
				'div',
				null,
				icon,
				_react2.default.createElement(
					'div',
					null,
					title
				)
			);
		};
	
		Alert.prototype._getAlertWidth = function _getAlertWidth() {
			var _props3 = this.props,
			    alertType = _props3.alertType,
			    fixedWidth = _props3.fixedWidth;
	
	
			var width = void 0;
	
			switch (alertType) {
				case "message":
					width = 450;
					break;
			}
	
			return fixedWidth || width || DEFAULT_ALERT_WIDTH;
		};
	
		return Alert;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(Alert);
	module.exports = exports['default'];

/***/ },

/***/ "jXlm":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _dec, _desc, _value, _class, _class2, _temp; /**
	                                                  * this is a modal
	                                                  *
	                                                  * @parent anybody
	                                                  * @stateful
	                                                  * @children Footer, Header
	                                                  */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__("ud+7");
	
	var _Header = __webpack_require__("HGyf");
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__("wWyx");
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactKeydown = __webpack_require__("BZBu");
	
	var _reactKeydown2 = _interopRequireDefault(_reactKeydown);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _Transition = __webpack_require__("X/qO");
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
			var desc = {};
			Object['ke' + 'ys'](descriptor).forEach(function (key) {
					desc[key] = descriptor[key];
			});
			desc.enumerable = !!desc.enumerable;
			desc.configurable = !!desc.configurable;
	
			if ('value' in desc || desc.initializer) {
					desc.writable = true;
			}
	
			desc = decorators.slice().reverse().reduce(function (desc, decorator) {
					return decorator(target, property, desc) || desc;
			}, desc);
	
			if (context && desc.initializer !== void 0) {
					desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
					desc.initializer = undefined;
			}
	
			if (desc.initializer === void 0) {
					Object['define' + 'Property'](target, property, desc);
					desc = null;
			}
	
			return desc;
	}
	
	var HAS_HEADER = false;
	var HAS_FOOTER = false;
	var ALLOW_CLOSE_BY_CLICKING_SHADOW = true;
	
	var CustomModal = (_dec = (0, _reactKeydown2.default)(_reactKeydown.ALL_KEYS), (_class = (_temp = _class2 = function (_React$Component) {
			_inherits(CustomModal, _React$Component);
	
			function CustomModal(props) {
					_classCallCheck(this, CustomModal);
	
					var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
					_this.state = {
							style: {},
							overlayStyle: {},
							open: false
					};
	
					_this.closeModal = _this.closeModal.bind(_this);
					_this.listenToKeys = _this.listenToKeys.bind(_this);
					_this.forceCloseModal = _this.forceCloseModal.bind(_this);
	
					_this.setActionsWhenRouteChanges(props);
					return _this;
			}
	
			CustomModal.prototype.setActionsWhenRouteChanges = function setActionsWhenRouteChanges(props) {
					var _this2 = this;
	
					_reactRouter.browserHistory.listen(function (location) {
							_this2.forceCloseModal();
					});
			};
	
			CustomModal.prototype.listenToKeys = function listenToKeys(e) {
					if (this.props.allowEscKeyToClose) {
							if (e.code === 'Escape') {
									this.closeModal();
							}
					}
			};
	
			CustomModal.prototype.forceCloseModal = function forceCloseModal() {
					if (typeof this.props.dismiss === 'function') {
							this.props.dismiss();
					}
					this.setState({
							open: false
					});
			};
	
			CustomModal.prototype.closeModal = function closeModal() {
					var onCloseModalClick = this.props.onCloseModalClick;
	
	
					if (typeof onCloseModalClick == "function") {
							onCloseModalClick();
					} else {
							this.setState({
									open: false
							});
					}
			};
	
			CustomModal.prototype.componentWillMount = function componentWillMount() {
					var style = {};
					var overlayStyle = {};
					var _props = this.props,
					    isShowingModal = _props.isShowingModal,
					    fixedHeight = _props.fixedHeight,
					    fixedWidth = _props.fixedWidth,
					    overlayColor = _props.overlayColor,
					    overlayOpacity = _props.overlayOpacity;
	
	
					if (fixedHeight) {
							style.height = fixedHeight;
					}
					if (fixedWidth) {
							style.width = fixedWidth;
					}
	
					if (overlayColor) {
							overlayStyle.backgroundColor = overlayColor;
					}
	
					if (overlayOpacity) {
							overlayStyle.opacity = overlayOpacity;
					}
	
					this.setState({
							style: style,
							overlayStyle: overlayStyle,
							open: isShowingModal
					});
			};
	
			CustomModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
					var open = this.state.open;
	
					// Note that we expect exact booleans
	
					if (nextProps.isShowingModal === false) {
							this.setState({
									open: false
							});
					}
	
					if (nextProps.isShowingModal === true) {
							this.setState({
									open: true
							});
					}
			};
	
			CustomModal.prototype.render = function render() {
					var _this3 = this;
	
					var _props2 = this.props,
					    isShowingModal = _props2.isShowingModal,
					    useDefaultCloseButton = _props2.useDefaultCloseButton,
					    hasHeader = _props2.hasHeader,
					    hasFooter = _props2.hasFooter,
					    footerType = _props2.footerType,
					    footerClassName = _props2.footerClassName,
					    height = _props2.height,
					    contentHeight = _props2.contentHeight,
					    loading = _props2.loading,
					    getContentRef = _props2.getContentRef,
					    _props2$allowCloseByC = _props2.allowCloseByClickingShadow,
					    allowCloseByClickingShadow = _props2$allowCloseByC === undefined ? ALLOW_CLOSE_BY_CLICKING_SHADOW : _props2$allowCloseByC;
					var _state = this.state,
					    style = _state.style,
					    overlayStyle = _state.overlayStyle;
	
	
					if (typeof hasHeader == "undefined") {
							hasHeader = HAS_HEADER;
					}
	
					if (typeof hasFooter == "undefined") {
							hasFooter = HAS_FOOTER;
					}
	
					var children = _react2.default.Children.map(this.props.children || this.props.modalContent, function (child) {
							return _react2.default.cloneElement(child, { contentRef: _this3.contentRef });
					});
	
					return _react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)('classtop-custom-modal', this.props.className, { 'shown': this.state.open }) },
							_react2.default.createElement('div', {
									className: 'overlay',
									onClick: allowCloseByClickingShadow && !loading && this.closeModal, style: overlayStyle }),
							this.state.open && _react2.default.createElement(
									'div',
									{ className: 'modal-float-body', style: style },
									_react2.default.createElement(
											_Transition2.default,
											{ type: 'expand' },
											_react2.default.createElement(
													'div',
													{ className: (0, _classnames2.default)("content-wrapper", { 'loading': loading }) },
													loading && _react2.default.createElement(_Loading2.default, null),
													_react2.default.createElement(
															'div',
															{ className: 'content' },
															hasHeader && _react2.default.createElement(_Header2.default, _extends({}, this.props, { closeModal: this.closeModal })),
															isShowingModal && _react2.default.createElement(
																	'div',
																	{ className: 'classtop-modal-wrapper' },
																	_react2.default.createElement(
																			'div',
																			{ style: { height: contentHeight || "auto" }, className: 'classtop-modal-content', ref: function ref(r) {
																							if (r) _this3.contentRef = r;
																							if (typeof getContentRef === 'function') {
																									getContentRef(r);
																							}
																					} },
																			children
																	)
															),
															hasFooter && _react2.default.createElement(_Footer2.default, this.props)
													)
											)
									)
							)
					);
			};
	
			return CustomModal;
	}(_react2.default.Component), _class2.defaultProps = {
			allowEscKeyToClose: true
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'listenToKeys', [_dec], Object.getOwnPropertyDescriptor(_class.prototype, 'listenToKeys'), _class.prototype)), _class));
	exports.default = CustomModal;
	module.exports = exports['default'];

/***/ },

/***/ "ud+7":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"classtop-custom-modal":"classtop-custom-modal","loading":"loading","content":"content","overlay":"overlay","modal-float-body":"modal-float-body","content-wrapper":"content-wrapper","shown":"shown","classtop-modal-wrapper":"classtop-modal-wrapper","classtop-modal-content":"classtop-modal-content","footer":"footer","button-wrapper":"button-wrapper","footer-custom-content":"footer-custom-content","type-grey":"type-grey","type-transparent":"type-transparent","header":"header","close-button":"close-button","header-title":"header-title","header-icon":"header-icon","fa":"fa"};

/***/ },

/***/ "HGyf":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Header />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var DEFAULT_USE_DEFAULT_CLOSE_BUTTON = true;
	var DEFAULT_HEADER_TYPE = "default";
	
	var Header = function (_React$Component) {
		_inherits(Header, _React$Component);
	
		function Header(props) {
			_classCallCheck(this, Header);
	
			return _possibleConstructorReturn(this, _React$Component.call(this, props));
		}
	
		Header.prototype.render = function render() {
			var _props = this.props,
			    closeModal = _props.closeModal,
			    headerIcon = _props.headerIcon,
			    headerTitle = _props.headerTitle,
			    headerType = _props.headerType,
			    headerClassName = _props.headerClassName,
			    useDefaultCloseButton = _props.useDefaultCloseButton,
			    headerCustomContent = _props.headerCustomContent;
	
	
			if (typeof useDefaultCloseButton === "undefined") {
				useDefaultCloseButton = DEFAULT_USE_DEFAULT_CLOSE_BUTTON;
			}
	
			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)("header", headerClassName, "header-type-" + (headerType || DEFAULT_HEADER_TYPE)) },
				headerIcon && _react2.default.createElement(
					'div',
					{ className: 'header-icon' },
					_react2.default.createElement('i', { className: headerIcon })
				),
				headerTitle && _react2.default.createElement(
					'div',
					{ className: 'header-title' },
					headerTitle
				),
				headerCustomContent && _react2.default.createElement(
					'div',
					{ className: 'header-custom-content' },
					headerCustomContent
				),
				useDefaultCloseButton != false && _react2.default.createElement(
					'div',
					{ className: 'close-button', onClick: closeModal },
					_react2.default.createElement('i', { className: 'fa icon-cancel' })
				)
			);
		};
	
		return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ },

/***/ "wWyx":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UI = __webpack_require__("OM1Z");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Footer />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * this is how you declare a button for footer:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               		[{
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               			title: "升级高级版",
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               			className: "btn btn-primary pull-right",
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               			onClick: ()=>{
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               				console.log("hello!");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               			}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               		},]
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * */
	
	
	var DEFAULT_FOOTER_TYPE = "grey";
	
	var Footer = function (_React$Component) {
		_inherits(Footer, _React$Component);
	
		function Footer(props) {
			_classCallCheck(this, Footer);
	
			return _possibleConstructorReturn(this, _React$Component.call(this, props));
		}
	
		Footer.prototype.render = function render() {
			var _props = this.props,
			    footerClassName = _props.footerClassName,
			    footerButtons = _props.footerButtons,
			    footerType = _props.footerType,
			    footerCustomContent = _props.footerCustomContent;
	
			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)("footer", footerClassName, "type-" + (footerType || DEFAULT_FOOTER_TYPE)) },
				footerCustomContent && _react2.default.createElement(
					'div',
					{ className: 'footer-custom-content' },
					footerCustomContent
				),
				footerButtons && footerButtons.length > 0 && _react2.default.createElement(
					'div',
					{ className: 'button-wrapper' },
					this._renderButtons()
				)
			);
		};
	
		Footer.prototype._renderButtons = function _renderButtons() {
			var _this2 = this;
	
			var footerButtons = this.props.footerButtons;
	
			return footerButtons.map(function (btn, idx) {
				var title = btn.title,
				    className = btn.className,
				    isDisabled = btn.isDisabled;
	
	
				var disabled = void 0;
				if (typeof isDisabled == 'function') {
					disabled = isDisabled(_this2.props);
				} else {
					disabled = isDisabled;
				}
				return _react2.default.createElement(
					_UI.Button,
					{ key: idx, bsClass: className, disabled: disabled, onClick: btn.onClick },
					title
				);
			});
		};
	
		return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ },

/***/ "OM1Z":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactBootstrap = __webpack_require__("3kvR");
	
	var Bootstrap = _interopRequireWildcard(_reactBootstrap);
	
	var _PanelWrapper = __webpack_require__("VPji");
	
	var _PanelWrapper2 = _interopRequireDefault(_PanelWrapper);
	
	var _Tabs = __webpack_require__("QkJj");
	
	var Tabs = _interopRequireWildcard(_Tabs);
	
	var _DropdownButton = __webpack_require__("Upq0");
	
	var _DropdownButton2 = _interopRequireDefault(_DropdownButton);
	
	var _Dock = __webpack_require__("pul5");
	
	var _Dock2 = _interopRequireDefault(_Dock);
	
	var _Form = __webpack_require__("w56F");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _SearchList = __webpack_require__("B5jL");
	
	var _SearchList2 = _interopRequireDefault(_SearchList);
	
	var _CountBadge = __webpack_require__("R/EM");
	
	var _CountBadge2 = _interopRequireDefault(_CountBadge);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	__webpack_require__("FoBU");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Table = __webpack_require__("1drC");
	
	
	var UIComponents = _extends({}, Bootstrap, Table, Tabs, {
	  Loading: _Loading2.default,
	  DropdownButton: _DropdownButton2.default,
	  PanelWrapper: _PanelWrapper2.default,
	  Dock: _Dock2.default,
	  Form: _Form2.default,
	  SearchList: _SearchList2.default,
	  CountBadge: _CountBadge2.default
	});
	
	exports.default = UIComponents;
	module.exports = exports["default"];

/***/ },

/***/ "VPji":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	exports.PanelCurtain = undefined;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__("iZYf");
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is a panel (wrapper). Anything comes inside lools like it's a panel :D
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * TODO: in the future, we can make it stateful and then add something like collapse etc and so on
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. we can also add a loading screen
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var PanelCurtain = exports.PanelCurtain = function (_React$Component) {
	  _inherits(PanelCurtain, _React$Component);
	
	  function PanelCurtain() {
	    _classCallCheck(this, PanelCurtain);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PanelCurtain.prototype.render = function render() {
	    var style = {};
	    if (global['--classtop-main-section']) {
	      var _global$ClasstopMa = global['--classtop-main-section'].getBoundingClientRect(),
	          height = _global$ClasstopMa.height;
	
	      style = { height: height };
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'panel-layer', style: style },
	      this.props.children
	    );
	  };
	
	  return PanelCurtain;
	}(_react2.default.Component);
	
	var PanelWrapper = function (_React$Component2) {
	  _inherits(PanelWrapper, _React$Component2);
	
	  function PanelWrapper() {
	    _classCallCheck(this, PanelWrapper);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  PanelWrapper.prototype.render = function render() {
	    var style = {};
	    if (global['--classtop-main-section']) {
	      var _global$ClasstopMa2 = global['--classtop-main-section'].getBoundingClientRect(),
	          height = _global$ClasstopMa2.height;
	
	      style = { minHeight: height - 170 };
	    }
	
	    var title = this.props.title;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('panel-wrapper', this.props.className) },
	      _react2.default.createElement(
	        'div',
	        { className: 'panel-wrapper-content', style: style },
	        title && _react2.default.createElement(
	          'div',
	          { className: 'panel-title' },
	          title
	        ),
	        this.props.children
	      )
	    );
	  };
	
	  return PanelWrapper;
	}(_react2.default.Component);
	
	exports.default = PanelWrapper;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "iZYf":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"panel-wrapper":"panel-wrapper","panel-title":"panel-title","panel-layer":"panel-layer","panel-wrapper-content":"panel-wrapper-content"};

/***/ },

/***/ "QkJj":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactTabs = __webpack_require__("sz6E");
	
	var ReactTabs = _interopRequireWildcard(_reactTabs);
	
	__webpack_require__("4UEG");
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__("X/qO");
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // we are going to use react-tabs
	
	
	/**
	 * <CustomTab />
	 *
	 * This is a custom wrapper for <Tab />
	 * We need this in order to RESET the scrollTop of "main-content"
	 * every time tab is switched.
	 *
	 * @parent <Tabs />
	 * @stateless
	 */
	
	
	var DEFAULT_CLASS = 'react-tabs__tab';
	
	var OriginalTab = ReactTabs.Tab,
	    OriginalTabPanel = ReactTabs.TabPanel;
	
	var CustomTab = function (_Component) {
	  _inherits(CustomTab, _Component);
	
	  function CustomTab(props) {
	    _classCallCheck(this, CustomTab);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  //
	  // when a new tab was selected which means selected == false,
	  // we make scrollTop of main-section to 0
	  //
	
	
	  CustomTab.prototype.onClick = function onClick() {
	    var _props = this.props,
	        selected = _props.selected,
	        _props$scrollMainSect = _props.scrollMainSectionToTop,
	        scrollMainSectionToTop = _props$scrollMainSect === undefined ? true : _props$scrollMainSect;
	
	
	    if (!selected && scrollMainSectionToTop) {
	      // global["--classtop-main-section"].scrollTop = 0;
	    }
	  };
	
	  CustomTab.prototype.render = function render() {
	
	    return _react2.default.createElement(OriginalTab, _extends({}, this.props, { onClick: this.onClick }));
	  };
	
	  return CustomTab;
	}(_react.Component);
	
	CustomTab.tabsRole = 'Tab';
	
	var CustomTabPanel = function (_Component2) {
	  _inherits(CustomTabPanel, _Component2);
	
	  function CustomTabPanel(props) {
	    _classCallCheck(this, CustomTabPanel);
	
	    return _possibleConstructorReturn(this, _Component2.call(this, props));
	  }
	
	  CustomTabPanel.prototype.render = function render() {
	    //
	    // it seems like TabPanel doesn't really pass className
	    //
	    return _react2.default.createElement(
	      OriginalTabPanel,
	      this.props,
	      _react2.default.createElement(
	        "div",
	        { className: "tab-panel-content" },
	        this.props.children
	      )
	    );
	  };
	
	  return CustomTabPanel;
	}(_react.Component);
	
	CustomTabPanel.tabsRole = 'TabPanel';
	
	exports.default = _extends({}, ReactTabs, {
	  Tab: CustomTab,
	  TabPanel: CustomTabPanel
	});
	module.exports = exports["default"];

/***/ },

/***/ "4UEG":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-tabs":"react-tabs","react-tabs__tab-list":"react-tabs__tab-list","react-tabs__tab":"react-tabs__tab","react-tabs__tab--disabled":"react-tabs__tab--disabled","react-tabs__tab--selected":"react-tabs__tab--selected","tab-panel-content":"tab-panel-content","student-panel":"student-panel","btn":"btn","teacher-table":"teacher-table","finance-table":"finance-table","navigate-date":"navigate-date","btn-link":"btn-link","setting-dropdown":"setting-dropdown","dropdown":"dropdown","student-dropdown":"student-dropdown"};

/***/ },

/***/ "X/qO":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <Transition />
	                    *
	                    * This is a wrapper component for ReactCSSTransitionGroup.
	                    *
	                    * @parent anybody
	                    * @children anybody
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__("S8Mv");
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	__webpack_require__("cMdt");
	
	__webpack_require__("9Okx");
	
	__webpack_require__("aXRA");
	
	__webpack_require__("3Cy/");
	
	__webpack_require__("0v/3");
	
	__webpack_require__("qQcH");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_TYPE = 'fade';
	
	var Transition = (_temp = _class = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props) {
	    _classCallCheck(this, Transition);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Transition.prototype.componentWillMount = function componentWillMount() {};
	
	  Transition.prototype.render = function render() {
	    var type = this.props.type;
	
	    return _react2.default.createElement(
	      _reactAddonsCssTransitionGroup2.default,
	      {
	        transitionName: type || DEFAULT_TYPE,
	        transitionAppear: true,
	        transitionAppearTimeout: 500,
	        transitionEnterTimeout: 500,
	        transitionLeaveTimeout: 500 },
	      this.props.children
	    );
	  };
	
	  return Transition;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = Transition;
	module.exports = exports['default'];

/***/ },

/***/ "cMdt":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"fade-appear":"fade-appear","fade-appear-active":"fade-appear-active","fade-enter":"fade-enter","fade-enter-active":"fade-enter-active","fade-leave":"fade-leave","fade-leave-active":"fade-leave-active"};

/***/ },

/***/ "9Okx":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"fade-delayed-appear":"fade-delayed-appear","fade-delayed-appear-active":"fade-delayed-appear-active","fade-delayed-enter":"fade-delayed-enter","fade-delayed-enter-active":"fade-delayed-enter-active","fade-delayed-leave":"fade-delayed-leave","fade-delayed-leave-active":"fade-delayed-leave-active"};

/***/ },

/***/ "aXRA":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"expand-appear":"expand-appear","expand-appear-active":"expand-appear-active","expand-enter":"expand-enter","expand-enter-active":"expand-enter-active","expand-leave":"expand-leave","expand-leave-active":"expand-leave-active"};

/***/ },

/***/ "3Cy/":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"expand-down-appear":"expand-down-appear","expand-down-appear-active":"expand-down-appear-active","expand-down-enter":"expand-down-enter","expand-down-enter-active":"expand-down-enter-active","expand-down-leave":"expand-down-leave","expand-down-leave-active":"expand-down-leave-active"};

/***/ },

/***/ "0v/3":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"slide-down-appear":"slide-down-appear","slide-down-appear-active":"slide-down-appear-active","slide-down-enter":"slide-down-enter","slide-down-enter-active":"slide-down-enter-active","slide-down-leave":"slide-down-leave","slide-down-leave-active":"slide-down-leave-active"};

/***/ },

/***/ "qQcH":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"slide-right-appear":"slide-right-appear","slide-right-appear-active":"slide-right-appear-active","slide-right-enter":"slide-right-enter","slide-right-enter-active":"slide-right-enter-active","slide-right-leave":"slide-right-leave","slide-right-leave-active":"slide-right-leave-active","slide-left-appear":"slide-left-appear","slide-left-appear-active":"slide-left-appear-active","slide-left-enter":"slide-left-enter","slide-left-enter-active":"slide-left-enter-active","slide-left-leave":"slide-left-leave","slide-left-leave-active":"slide-left-leave-active"};

/***/ },

/***/ "Upq0":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactBootstrap = __webpack_require__("3kvR");
	
	var _reactDom = __webpack_require__("O27J");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("ju7V");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/**
	 * <DropdownButtonWithDirection />
	 *
	 * This is simply a wrapper Component for DropdownButton in order to
	 * display the dropdown in different directions according to position of
	 * the toggle button on the screen.
	 *
	 * toggle button location | openeing direction
	 * -----------------------+-------------------
	 *    far right           |   left
	 *    far left            |   right
	 *    top                 |   down
	 *    bottom              |   up
	 *
	 * @parent anybody
	 * @stateful
	 */
	
	
	var DropdownButtonWithDirection = function (_React$Component) {
	  _inherits(DropdownButtonWithDirection, _React$Component);
	
	  function DropdownButtonWithDirection(props) {
	    _classCallCheck(this, DropdownButtonWithDirection);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._computeDirection = _this._computeDirection.bind(_this);
	
	    // default direction for dropdown is right/down
	    _this.state = {
	      vertical: "right",
	      horizontal: "down"
	    };
	    return _this;
	  }
	  // guideHeight and guideWidth roughly state the dim of an element.
	  // They are needed to calculate which direction the Dropdown should
	  // open torwards.
	
	
	  DropdownButtonWithDirection.prototype._computeDirection = function _computeDirection() {
	    var thisDom = _reactDom2.default.findDOMNode(this);
	    var _props = this.props,
	        dropdownGuideHeight = _props.dropdownGuideHeight,
	        dropdownGuideWidth = _props.dropdownGuideWidth;
	
	    if (thisDom && global['--classtop-main-section'] && dropdownGuideWidth && dropdownGuideHeight) {
	      var containerDim = global['--classtop-main-section'].getBoundingClientRect();
	      var elementDim = thisDom.getBoundingClientRect();
	
	      if (containerDim.height - (elementDim.bottom + dropdownGuideHeight) <= 0) {
	        this.setState({
	          vertical: "up"
	        });
	      } else {
	        this.setState({
	          vertical: "down"
	        });
	      }
	
	      if (containerDim.width - (elementDim.left + dropdownGuideWidth) <= 0) {
	        this.setState({
	          horizontal: "right"
	        });
	      } else {
	        this.setState({
	          horizontal: "left"
	        });
	      }
	    }
	  };
	
	  DropdownButtonWithDirection.prototype.render = function render() {
	    var _state = this.state,
	        vertical = _state.vertical,
	        horizontal = _state.horizontal;
	
	    var propsToPass = _extends({}, this.props);
	
	    delete propsToPass.dropdownGuideWidth;
	    delete propsToPass.dropdownGuideHeight;
	
	    return _react2.default.createElement(_reactBootstrap.DropdownButton, _extends({}, propsToPass, { onClick: this._computeDirection, className: (0, _classnames2.default)('expand-to-' + vertical, 'expand-to-' + horizontal) }));
	  };
	
	  return DropdownButtonWithDirection;
	}(_react2.default.Component);
	
	exports.default = DropdownButtonWithDirection;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "ju7V":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dropdown":"dropdown","expand-to-right":"expand-to-right","dropdown-menu":"dropdown-menu","expand-to-up":"expand-to-up"};

/***/ },

/***/ "pul5":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _dec, _desc, _value, _class, _class2, _temp; /**
	                                                  * <Dock />
	                                                  *
	                                                  * a customized Dock. A facade for react-dock
	                                                  *
	                                                  * @parent anybody
	                                                  * @children
	                                                  * @stateful
	                                                  * @stateless
	                                                  */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDock = __webpack_require__("6LlY");
	
	var _reactDock2 = _interopRequireDefault(_reactDock);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	__webpack_require__("wrrq");
	
	var _reactKeydown = __webpack_require__("BZBu");
	
	var _reactKeydown2 = _interopRequireDefault(_reactKeydown);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _arrow_right = __webpack_require__("jfWO");
	
	var _arrow_right2 = _interopRequireDefault(_arrow_right);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var DEFAULT_POSITON = 'right';
	
	var OPEN_DELAY = 50;
	
	var Z_INDEX = 500;
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	//
	// we're going to detect the key press with our Redux state 'Shortcut'
	//
	var CustomDock = (_dec = (0, _reactKeydown2.default)(_reactKeydown.ALL_KEYS), (_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(CustomDock, _React$Component);
	
	  function CustomDock(props) {
	    _classCallCheck(this, CustomDock);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.closeDock = _this.closeDock.bind(_this);
	    _this.listenToKeys = _this.listenToKeys.bind(_this);
	    _this.state = {
	      isVisible: false
	    };
	    _this.setActionsWhenRouteChanges(props);
	    return _this;
	  }
	
	  CustomDock.prototype.setActionsWhenRouteChanges = function setActionsWhenRouteChanges(props) {
	    _reactRouter.browserHistory.listen(function (location) {
	      if (typeof props.onCloseModalClick === 'function') {
	        props.onCloseModalClick();
	      }
	    });
	  };
	
	  CustomDock.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var isVisible = this.props.isVisible;
	
	
	    setTimeout(function () {
	      _this2.setState({
	        isVisible: isVisible
	      });
	    }, OPEN_DELAY);
	  };
	
	  CustomDock.prototype.listenToKeys = function listenToKeys(e) {
	    var _props = this.props,
	        allowEscKeyToClose = _props.allowEscKeyToClose,
	        onCloseDockClick = _props.onCloseDockClick;
	
	    // 
	    // When used with confirmable, just make the invisible is not good enough
	    // you need to actually dissmiss() it which is doneby onCloseDockClick()
	    //
	
	    if (allowEscKeyToClose) {
	      if (e.code === 'Escape') {
	        onCloseDockClick();
	      }
	    }
	  };
	
	  CustomDock.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var isVisible = _ref.isVisible;
	
	    if (isVisible === false) {
	      this.setState({
	        isVisible: false
	      });
	    }
	  };
	
	  CustomDock.prototype.closeDock = function closeDock() {
	    var onCloseDockClick = this.props.onCloseDockClick;
	
	
	    if (typeof onCloseDockClick == "function") {
	      onCloseDockClick();
	    } else {
	      this.setState({
	        isVisible: false
	      });
	    }
	  };
	
	  CustomDock.prototype.render = function render() {
	    var _props2 = this.props,
	        position = _props2.position,
	        defaultSize = _props2.defaultSize,
	        useDefaultCloseButton = _props2.useDefaultCloseButton,
	        Shortcut = _props2.Shortcut,
	        children = _props2.children,
	        dockTitle = _props2.dockTitle,
	        dockStyle = _props2.dockStyle,
	        dockIcon = _props2.dockIcon,
	        className = _props2.className,
	        useClosingTag = _props2.useClosingTag,
	        _props2$overlayOpacit = _props2.overlayOpacity,
	        overlayOpacity = _props2$overlayOpacit === undefined ? 0.2 : _props2$overlayOpacit;
	    var isVisible = this.state.isVisible;
	
	
	    var notResizable = !defaultSize;
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('classtop-custom-dock', className, { notResizable: notResizable }), style: { zIndex: Z_INDEX } },
	      _react2.default.createElement(
	        _reactDock2.default,
	        _extends({}, this.props, {
	          zindex: Z_INDEX,
	          position: position || DEFAULT_POSITION,
	          isVisible: isVisible,
	          onVisibleChange: this.closeDock,
	          dimStyle: { opacity: overlayOpacity },
	          dockStyle: _extends({ 'boxShadow': '-10px 0 30px rgba(25,25,25,0.1)' }, dockStyle)
	        }),
	        useDefaultCloseButton != false && _react2.default.createElement(
	          'div',
	          { className: 'close-button', onClick: this.closeDock },
	          _react2.default.createElement('i', { className: 'fa icon-cancel' })
	        ),
	        dockTitle !== undefined && _react2.default.createElement(
	          'div',
	          { className: 'dock-header' },
	          dockIcon !== undefined && _react2.default.createElement('i', { className: dockIcon }),
	          _react2.default.createElement(
	            'h4',
	            null,
	            dockTitle
	          )
	        ),
	        useClosingTag && _react2.default.createElement(
	          'div',
	          { className: 'closingTag', onClick: this.closeDock },
	          _react2.default.createElement(
	            'svg',
	            { xmlns: 'http://www.w3.org/2000/svg', version: '1.1', x: '0px', y: '0px', viewBox: '0 0 100 125', enableBackground: 'new 0 0 100 100' },
	            _react2.default.createElement('path', { d: 'M29.56,97.137C28.984,97.714,28.229,98,27.475,98s-1.51-0.286-2.085-0.863c-1.152-1.152-1.152-3.018,0-4.169L68.356,50  L25.39,7.031c-1.152-1.149-1.152-3.015,0-4.169c1.152-1.15,3.018-1.15,4.17,0L74.61,47.917c1.152,1.15,1.152,3.015,0,4.17  L29.56,97.137z' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'dock-body' },
	          children
	        )
	      )
	    );
	  };
	
	  return CustomDock;
	}(_react2.default.Component), _class2.defaultProps = {
	  allowEscKeyToClose: true
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'listenToKeys', [_dec], Object.getOwnPropertyDescriptor(_class.prototype, 'listenToKeys'), _class.prototype)), _class));
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(CustomDock);
	module.exports = exports['default'];

/***/ },

/***/ "wrrq":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"classtop-custom-dock":"classtop-custom-dock","classtop-table":"classtop-table","notResizable":"notResizable","action-title":"action-title","close-button":"close-button","closingTag":"closingTag","dock-content":"dock-content","dock-body":"dock-body","dock-footer":"dock-footer","dock-header":"dock-header"};

/***/ },

/***/ "jfWO":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "arrow_right.98dd38f9.svg";

/***/ },

/***/ "w56F":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactJsonschemaForm = __webpack_require__("CudC");
	
	var _reactJsonschemaForm2 = _interopRequireDefault(_reactJsonschemaForm);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	__webpack_require__("mHav");
	
	var _reactJsonschemaFormSection = __webpack_require__("NyIJ");
	
	var _reactJsonschemaFormSection2 = _interopRequireDefault(_reactJsonschemaFormSection);
	
	var _SelectStudent = __webpack_require__("BgXg");
	
	var _SelectStudent2 = _interopRequireDefault(_SelectStudent);
	
	var _SelectClassroom = __webpack_require__("wPVy");
	
	var _SelectClassroom2 = _interopRequireDefault(_SelectClassroom);
	
	var _widgets = __webpack_require__("EADx");
	
	var _widgets2 = _interopRequireDefault(_widgets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Form />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is a wrapper for react-jsonschema-form. It provides extra functionalities 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * and predefines some values.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. One of the critical function is a callback function getSubmitButton() that 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * passes the ref of a submit button which you call to trigger 'form submit.'
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. It provides custom widgets: 'datepicker', 'money', 'reactselect'
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 3. When you define uiSchema, you can pass a array of uiSchemas which will
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * wrapped in <section className={classNames}/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var fields = {
	  section: _reactJsonschemaFormSection2.default
	
	  //
	  // REFACTOR IT
	  //
	
	};
	var Form = function (_React$Component) {
	  _inherits(Form, _React$Component);
	
	  function Form(props) {
	    _classCallCheck(this, Form);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._validate = _this._validate.bind(_this);
	    _this._onFormChange = _this._onFormChange.bind(_this);
	    _this._convertJoiResultToErrors = _this._convertJoiResultToErrors.bind(_this);
	    _this._transformErrors = _this._transformErrors.bind(_this);
	
	    _this.state = {
	      formData: _this.props.formData || {}
	    };
	    return _this;
	  }
	
	  Form.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var formData = _ref.formData;
	
	    if (formData) {
	      this.setState({
	        formData: formData
	      });
	    }
	  };
	
	  Form.prototype.componentDidMount = function componentDidMount() {};
	
	  Form.prototype._onFormChange = function _onFormChange(_ref2) {
	    var _this2 = this;
	
	    var formData = _ref2.formData;
	    var onChange = this.props.onChange;
	
	
	    this.setState({
	      formData: formData
	    }, function () {
	      if (typeof onChange == 'function') {
	        onChange(_this2.state.formData);
	      }
	    });
	  };
	
	  Form.prototype._transformErrors = function _transformErrors(errors, schema) {
	    return errors.map(function (error) {
	      var name = error.property.replace('.', '');
	
	      if (error.name === "required") {
	        error.message = __('Please fill this field', 'form.errorMessage');
	      }
	
	      if (error.params && error.params.format == 'email') {
	        error.message = __('Please enter a correct email', 'form.errorMessage');
	      }
	
	      return error;
	    });
	  };
	
	  Form.prototype._validate = function _validate(formData, errors) {
	    return errors;
	  };
	
	  Form.prototype._convertJoiResultToErrors = function _convertJoiResultToErrors(errorDetails, errors) {
	    errorDetails.forEach(function (errorItem) {
	      if (errorItem.type == 'any.required') {
	        return;
	      }
	
	      var key = errorItem.context.key;
	
	
	      if (errors[key]) {
	        errors[key].addError(errorItem.type);
	      }
	    });
	
	    return errors;
	  };
	
	  Form.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        schema = _props.schema,
	        className = _props.className,
	        _props$getSubmitButto = _props.getSubmitButton,
	        getSubmitButton = _props$getSubmitButto === undefined ? function () {} : _props$getSubmitButto,
	        uiSchema = _props.uiSchema,
	        onChange = _props.onChange,
	        fetching = _props.fetching;
	
	
	    var formData = this.state.formData;
	
	    var validationError = this.state.validationError;
	
	
	    var uiSchemaSection = Array.isArray(uiSchema) ? uiSchema : [uiSchema];
	
	    return _react2.default.createElement(
	      'div',
	      { className: _classnames2.default.apply(undefined, ['classtop-form'].concat(className, [{ 'validation-error': validationError, 'fetching': fetching }])) },
	      fetching === true && _react2.default.createElement(_Loading2.default, null),
	      _react2.default.createElement(
	        _reactJsonschemaForm2.default,
	        _extends({}, this.props, {
	          formData: formData,
	          uiSchema: {
	            'ui:field': 'section',
	            'ui:section': uiSchemaSection
	          },
	          onChange: this._onFormChange,
	          noHtml5Validate: true,
	          showErrorList: false,
	          fields: fields,
	          widgets: _widgets2.default,
	          transformErrors: function transformErrors(errors) {
	            return _this3._transformErrors(errors, schema);
	          },
	          ref: function ref(r) {
	            _this3.formRef = r;
	          }
	        }),
	        this.props.children,
	        _react2.default.createElement(
	          'button',
	          { type: 'submit', style: { display: 'none' }, ref: function ref(r) {
	              getSubmitButton(r);
	            } },
	          'Submit'
	        )
	      )
	    );
	  };
	
	  return Form;
	}(_react2.default.Component);
	
	exports.default = Form;
	module.exports = exports['default'];

/***/ },

/***/ "CudC":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Form = __webpack_require__("wAkN");
	
	var _Form2 = _interopRequireDefault(_Form);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Form2.default;
	module.exports = exports["default"];

/***/ },

/***/ "wAkN":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ErrorList = __webpack_require__("L4Mm");
	
	var _ErrorList2 = _interopRequireDefault(_ErrorList);
	
	var _utils = __webpack_require__("X7Bk");
	
	var _validate = __webpack_require__("TANh");
	
	var _validate2 = _interopRequireDefault(_validate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Form = (_temp = _class = function (_Component) {
	  _inherits(Form, _Component);
	
	  function Form(props) {
	    _classCallCheck(this, Form);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.onChange = function (formData) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { validate: false };
	
	      var mustValidate = !_this.props.noValidate && (_this.props.liveValidate || options.validate);
	      var state = { formData: formData };
	      if (mustValidate) {
	        var _this$validate = _this.validate(formData),
	            errors = _this$validate.errors,
	            errorSchema = _this$validate.errorSchema;
	
	        state = _extends({}, state, { errors: errors, errorSchema: errorSchema });
	      }
	      (0, _utils.setState)(_this, state, function () {
	        if (_this.props.onChange) {
	          _this.props.onChange(_this.state);
	        }
	      });
	    };
	
	    _this.onBlur = function () {
	      if (_this.props.onBlur) {
	        var _this$props;
	
	        (_this$props = _this.props).onBlur.apply(_this$props, arguments);
	      }
	    };
	
	    _this.onFocus = function () {
	      if (_this.props.onFocus) {
	        var _this$props2;
	
	        (_this$props2 = _this.props).onFocus.apply(_this$props2, arguments);
	      }
	    };
	
	    _this.onSubmit = function (event) {
	      event.preventDefault();
	
	      if (!_this.props.noValidate) {
	        var _this$validate2 = _this.validate(_this.state.formData),
	            errors = _this$validate2.errors,
	            errorSchema = _this$validate2.errorSchema;
	
	        if (Object.keys(errors).length > 0) {
	          (0, _utils.setState)(_this, { errors: errors, errorSchema: errorSchema }, function () {
	            if (_this.props.onError) {
	              _this.props.onError(errors);
	            } else {
	              console.error("Form validation failed", errors);
	            }
	          });
	          return;
	        }
	      }
	
	      if (_this.props.onSubmit) {
	        _this.props.onSubmit(_extends({}, _this.state, { status: "submitted" }));
	      }
	      _this.setState({ errors: [], errorSchema: {} });
	    };
	
	    _this.state = _this.getStateFromProps(props);
	    return _this;
	  }
	
	  Form.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.setState(this.getStateFromProps(nextProps));
	  };
	
	  Form.prototype.getStateFromProps = function getStateFromProps(props) {
	    var state = this.state || {};
	    var schema = "schema" in props ? props.schema : this.props.schema;
	    var uiSchema = "uiSchema" in props ? props.uiSchema : this.props.uiSchema;
	    var edit = typeof props.formData !== "undefined";
	    var liveValidate = props.liveValidate || this.props.liveValidate;
	    var mustValidate = edit && !props.noValidate && liveValidate;
	    var definitions = schema.definitions;
	
	    var formData = (0, _utils.getDefaultFormState)(schema, props.formData, definitions);
	    var retrievedSchema = (0, _utils.retrieveSchema)(schema, definitions, formData);
	
	    var _ref = mustValidate ? this.validate(formData, schema) : {
	      errors: state.errors || [],
	      errorSchema: state.errorSchema || {}
	    },
	        errors = _ref.errors,
	        errorSchema = _ref.errorSchema;
	
	    var idSchema = (0, _utils.toIdSchema)(retrievedSchema, uiSchema["ui:rootFieldId"], definitions, formData, props.idPrefix);
	    return {
	      schema: schema,
	      uiSchema: uiSchema,
	      idSchema: idSchema,
	      formData: formData,
	      edit: edit,
	      errors: errors,
	      errorSchema: errorSchema
	    };
	  };
	
	  Form.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    return (0, _utils.shouldRender)(this, nextProps, nextState);
	  };
	
	  Form.prototype.validate = function validate(formData, schema) {
	    var _props = this.props,
	        validate = _props.validate,
	        transformErrors = _props.transformErrors;
	
	    return (0, _validate2.default)(formData, schema || this.props.schema, validate, transformErrors);
	  };
	
	  Form.prototype.renderErrors = function renderErrors() {
	    var _state = this.state,
	        errors = _state.errors,
	        errorSchema = _state.errorSchema,
	        schema = _state.schema,
	        uiSchema = _state.uiSchema;
	    var _props2 = this.props,
	        ErrorList = _props2.ErrorList,
	        showErrorList = _props2.showErrorList,
	        formContext = _props2.formContext;
	
	
	    if (errors.length && showErrorList != false) {
	      return _react2.default.createElement(ErrorList, {
	        errors: errors,
	        errorSchema: errorSchema,
	        schema: schema,
	        uiSchema: uiSchema,
	        formContext: formContext
	      });
	    }
	    return null;
	  };
	
	  Form.prototype.getRegistry = function getRegistry() {
	    // For BC, accept passed SchemaField and TitleField props and pass them to
	    // the "fields" registry one.
	    var _getDefaultRegistry = (0, _utils.getDefaultRegistry)(),
	        fields = _getDefaultRegistry.fields,
	        widgets = _getDefaultRegistry.widgets;
	
	    return {
	      fields: _extends({}, fields, this.props.fields),
	      widgets: _extends({}, widgets, this.props.widgets),
	      ArrayFieldTemplate: this.props.ArrayFieldTemplate,
	      ObjectFieldTemplate: this.props.ObjectFieldTemplate,
	      FieldTemplate: this.props.FieldTemplate,
	      definitions: this.props.schema.definitions || {},
	      formContext: this.props.formContext || {}
	    };
	  };
	
	  Form.prototype.render = function render() {
	    var _props3 = this.props,
	        children = _props3.children,
	        safeRenderCompletion = _props3.safeRenderCompletion,
	        id = _props3.id,
	        className = _props3.className,
	        name = _props3.name,
	        method = _props3.method,
	        target = _props3.target,
	        action = _props3.action,
	        autocomplete = _props3.autocomplete,
	        enctype = _props3.enctype,
	        acceptcharset = _props3.acceptcharset,
	        noHtml5Validate = _props3.noHtml5Validate;
	    var _state2 = this.state,
	        schema = _state2.schema,
	        uiSchema = _state2.uiSchema,
	        formData = _state2.formData,
	        errorSchema = _state2.errorSchema,
	        idSchema = _state2.idSchema;
	
	    var registry = this.getRegistry();
	    var _SchemaField = registry.fields.SchemaField;
	
	    return _react2.default.createElement(
	      "form",
	      {
	        className: className ? className : "rjsf",
	        id: id,
	        name: name,
	        method: method,
	        target: target,
	        action: action,
	        autoComplete: autocomplete,
	        encType: enctype,
	        acceptCharset: acceptcharset,
	        noValidate: noHtml5Validate,
	        onSubmit: this.onSubmit },
	      this.renderErrors(),
	      _react2.default.createElement(_SchemaField, {
	        schema: schema,
	        uiSchema: uiSchema,
	        errorSchema: errorSchema,
	        idSchema: idSchema,
	        formData: formData,
	        onChange: this.onChange,
	        onBlur: this.onBlur,
	        onFocus: this.onFocus,
	        registry: registry,
	        safeRenderCompletion: safeRenderCompletion
	      }),
	      children ? children : _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          "button",
	          { type: "submit", className: "btn btn-info" },
	          "Submit"
	        )
	      )
	    );
	  };
	
	  return Form;
	}(_react.Component), _class.defaultProps = {
	  uiSchema: {},
	  noValidate: false,
	  liveValidate: false,
	  safeRenderCompletion: false,
	  noHtml5Validate: false,
	  ErrorList: _ErrorList2.default
	}, _temp);
	exports.default = Form;
	
	
	if (false) {}
	module.exports = exports["default"];

/***/ },

/***/ "L4Mm":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ErrorList;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ErrorList(props) {
	  var errors = props.errors;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "panel panel-danger errors" },
	    _react2.default.createElement(
	      "div",
	      { className: "panel-heading" },
	      _react2.default.createElement(
	        "h3",
	        { className: "panel-title" },
	        "Errors"
	      )
	    ),
	    _react2.default.createElement(
	      "ul",
	      { className: "list-group" },
	      errors.map(function (error, i) {
	        return _react2.default.createElement(
	          "li",
	          { key: i, className: "list-group-item text-danger" },
	          error.stack
	        );
	      })
	    )
	  );
	}
	module.exports = exports["default"];

/***/ },

/***/ "X7Bk":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {"use strict";
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getDefaultRegistry = getDefaultRegistry;
	exports.getSchemaType = getSchemaType;
	exports.getWidget = getWidget;
	exports.getDefaultFormState = getDefaultFormState;
	exports.getUiOptions = getUiOptions;
	exports.isObject = isObject;
	exports.mergeObjects = mergeObjects;
	exports.asNumber = asNumber;
	exports.orderProperties = orderProperties;
	exports.isConstant = isConstant;
	exports.toConstant = toConstant;
	exports.isSelect = isSelect;
	exports.isMultiSelect = isMultiSelect;
	exports.isFilesArray = isFilesArray;
	exports.isFixedItems = isFixedItems;
	exports.allowAdditionalItems = allowAdditionalItems;
	exports.optionsList = optionsList;
	exports.retrieveSchema = retrieveSchema;
	exports.deepEquals = deepEquals;
	exports.shouldRender = shouldRender;
	exports.toIdSchema = toIdSchema;
	exports.parseDateString = parseDateString;
	exports.toDateString = toDateString;
	exports.pad = pad;
	exports.setState = setState;
	exports.dataURItoBlob = dataURItoBlob;
	exports.rangeSpec = rangeSpec;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("mypn");
	
	var _validate = __webpack_require__("TANh");
	
	var _validate2 = _interopRequireDefault(_validate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var widgetMap = {
	  boolean: {
	    checkbox: "CheckboxWidget",
	    radio: "RadioWidget",
	    select: "SelectWidget",
	    hidden: "HiddenWidget"
	  },
	  string: {
	    text: "TextWidget",
	    password: "PasswordWidget",
	    email: "EmailWidget",
	    hostname: "TextWidget",
	    ipv4: "TextWidget",
	    ipv6: "TextWidget",
	    uri: "URLWidget",
	    "data-url": "FileWidget",
	    radio: "RadioWidget",
	    select: "SelectWidget",
	    textarea: "TextareaWidget",
	    hidden: "HiddenWidget",
	    date: "DateWidget",
	    datetime: "DateTimeWidget",
	    "date-time": "DateTimeWidget",
	    "alt-date": "AltDateWidget",
	    "alt-datetime": "AltDateTimeWidget",
	    color: "ColorWidget",
	    file: "FileWidget"
	  },
	  number: {
	    text: "TextWidget",
	    select: "SelectWidget",
	    updown: "UpDownWidget",
	    range: "RangeWidget",
	    radio: "RadioWidget",
	    hidden: "HiddenWidget"
	  },
	  integer: {
	    text: "TextWidget",
	    select: "SelectWidget",
	    updown: "UpDownWidget",
	    range: "RangeWidget",
	    radio: "RadioWidget",
	    hidden: "HiddenWidget"
	  },
	  array: {
	    select: "SelectWidget",
	    checkboxes: "CheckboxesWidget",
	    files: "FileWidget"
	  }
	};
	
	function getDefaultRegistry() {
	  return {
	    fields: __webpack_require__("X0jD"),
	    widgets: __webpack_require__("k4i4"),
	    definitions: {},
	    formContext: {}
	  };
	}
	
	function getSchemaType(schema) {
	  var type = schema.type;
	
	  if (!type && schema.enum) {
	    type = "string";
	  }
	  return type;
	}
	
	function getWidget(schema, widget) {
	  var registeredWidgets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var type = getSchemaType(schema);
	
	  function mergeOptions(Widget) {
	    // cache return value as property of widget for proper react reconciliation
	    if (!Widget.MergedWidget) {
	      var defaultOptions = Widget.defaultProps && Widget.defaultProps.options || {};
	      Widget.MergedWidget = function (_ref) {
	        var _ref$options = _ref.options,
	            options = _ref$options === undefined ? {} : _ref$options,
	            props = _objectWithoutProperties(_ref, ["options"]);
	
	        return _react2.default.createElement(Widget, _extends({ options: _extends({}, defaultOptions, options) }, props));
	      };
	    }
	    return Widget.MergedWidget;
	  }
	
	  if (typeof widget === "function") {
	    return mergeOptions(widget);
	  }
	
	  if (typeof widget !== "string") {
	    throw new Error("Unsupported widget definition: " + (typeof widget === "undefined" ? "undefined" : _typeof(widget)));
	  }
	
	  if (registeredWidgets.hasOwnProperty(widget)) {
	    var registeredWidget = registeredWidgets[widget];
	    return getWidget(schema, registeredWidget, registeredWidgets);
	  }
	
	  if (!widgetMap.hasOwnProperty(type)) {
	    throw new Error("No widget for type \"" + type + "\"");
	  }
	
	  if (widgetMap[type].hasOwnProperty(widget)) {
	    var _registeredWidget = registeredWidgets[widgetMap[type][widget]];
	    return getWidget(schema, _registeredWidget, registeredWidgets);
	  }
	
	  throw new Error("No widget \"" + widget + "\" for type \"" + type + "\"");
	}
	
	function computeDefaults(schema, parentDefaults) {
	  var definitions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  // Compute the defaults recursively: give highest priority to deepest nodes.
	  var defaults = parentDefaults;
	  if (isObject(defaults) && isObject(schema.default)) {
	    // For object defaults, only override parent defaults that are defined in
	    // schema.default.
	    defaults = mergeObjects(defaults, schema.default);
	  } else if ("default" in schema) {
	    // Use schema defaults for this node.
	    defaults = schema.default;
	  } else if ("$ref" in schema) {
	    // Use referenced schema defaults for this node.
	    var refSchema = findSchemaDefinition(schema.$ref, definitions);
	    return computeDefaults(refSchema, defaults, definitions);
	  } else if (isFixedItems(schema)) {
	    defaults = schema.items.map(function (itemSchema) {
	      return computeDefaults(itemSchema, undefined, definitions);
	    });
	  }
	  // Not defaults defined for this node, fallback to generic typed ones.
	  if (typeof defaults === "undefined") {
	    defaults = schema.default;
	  }
	
	  switch (schema.type) {
	    // We need to recur for object schema inner default values.
	    case "object":
	      return Object.keys(schema.properties || {}).reduce(function (acc, key) {
	        // Compute the defaults for this node, with the parent defaults we might
	        // have from a previous run: defaults[key].
	        acc[key] = computeDefaults(schema.properties[key], (defaults || {})[key], definitions);
	        return acc;
	      }, {});
	
	    case "array":
	      if (schema.minItems) {
	        if (!isMultiSelect(schema, definitions)) {
	          var defaultsLength = defaults ? defaults.length : 0;
	          if (schema.minItems > defaultsLength) {
	            var defaultEntries = defaults || [];
	            // populate the array with the defaults
	            var fillerEntries = new Array(schema.minItems - defaultsLength).fill(computeDefaults(schema.items, schema.items.defaults, definitions));
	            // then fill up the rest with either the item default or empty, up to minItems
	
	            return defaultEntries.concat(fillerEntries);
	          }
	        } else {
	          return [];
	        }
	      }
	  }
	  return defaults;
	}
	
	function getDefaultFormState(_schema, formData) {
	  var definitions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (!isObject(_schema)) {
	    throw new Error("Invalid schema: " + _schema);
	  }
	  var schema = retrieveSchema(_schema, definitions, formData);
	  var defaults = computeDefaults(schema, _schema.default, definitions);
	  if (typeof formData === "undefined") {
	    // No form data? Use schema defaults.
	    return defaults;
	  }
	  if (isObject(formData)) {
	    // Override schema defaults with form data.
	    return mergeObjects(defaults, formData);
	  }
	  return formData || defaults;
	}
	
	function getUiOptions(uiSchema) {
	  // get all passed options from ui:widget, ui:options, and ui:<optionName>
	  return Object.keys(uiSchema).filter(function (key) {
	    return key.indexOf("ui:") === 0;
	  }).reduce(function (options, key) {
	    var _extends2;
	
	    var value = uiSchema[key];
	
	    if (key === "ui:widget" && isObject(value)) {
	      console.warn("Setting options via ui:widget object is deprecated, use ui:options instead");
	      return _extends({}, options, value.options || {}, {
	        widget: value.component
	      });
	    }
	    if (key === "ui:options" && isObject(value)) {
	      return _extends({}, options, value);
	    }
	    return _extends({}, options, (_extends2 = {}, _extends2[key.substring(3)] = value, _extends2));
	  }, {});
	}
	
	function isObject(thing) {
	  return (typeof thing === "undefined" ? "undefined" : _typeof(thing)) === "object" && thing !== null && !Array.isArray(thing);
	}
	
	function mergeObjects(obj1, obj2) {
	  var concatArrays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  // Recursively merge deeply nested objects.
	  var acc = Object.assign({}, obj1); // Prevent mutation of source object.
	  return Object.keys(obj2).reduce(function (acc, key) {
	    var left = obj1[key],
	        right = obj2[key];
	    if (obj1.hasOwnProperty(key) && isObject(right)) {
	      acc[key] = mergeObjects(left, right, concatArrays);
	    } else if (concatArrays && Array.isArray(left) && Array.isArray(right)) {
	      acc[key] = left.concat(right);
	    } else {
	      acc[key] = right;
	    }
	    return acc;
	  }, acc);
	}
	
	function asNumber(value) {
	  if (value === "") {
	    return undefined;
	  }
	  if (/\.$/.test(value)) {
	    // "3." can't really be considered a number even if it parses in js. The
	    // user is most likely entering a float.
	    return value;
	  }
	  if (/\.0$/.test(value)) {
	    // we need to return this as a string here, to allow for input like 3.07
	    return value;
	  }
	  var n = Number(value);
	  var valid = typeof n === "number" && !Number.isNaN(n);
	
	  if (/\.\d*0$/.test(value)) {
	    // It's a number, that's cool - but we need it as a string so it doesn't screw
	    // with the user when entering dollar amounts or other values (such as those with
	    // specific precision or number of significant digits)
	    return value;
	  }
	
	  return valid ? n : value;
	}
	
	function orderProperties(properties, order) {
	  if (!Array.isArray(order)) {
	    return properties;
	  }
	
	  var arrayToHash = function arrayToHash(arr) {
	    return arr.reduce(function (prev, curr) {
	      prev[curr] = true;
	      return prev;
	    }, {});
	  };
	  var errorPropList = function errorPropList(arr) {
	    return arr.length > 1 ? "properties '" + arr.join("', '") + "'" : "property '" + arr[0] + "'";
	  };
	  var propertyHash = arrayToHash(properties);
	  var orderHash = arrayToHash(order);
	  var extraneous = order.filter(function (prop) {
	    return prop !== "*" && !propertyHash[prop];
	  });
	  if (extraneous.length) {
	    throw new Error("uiSchema order list contains extraneous " + errorPropList(extraneous));
	  }
	  var rest = properties.filter(function (prop) {
	    return !orderHash[prop];
	  });
	  var restIndex = order.indexOf("*");
	  if (restIndex === -1) {
	    if (rest.length) {
	      throw new Error("uiSchema order list does not contain " + errorPropList(rest));
	    }
	    return order;
	  }
	  if (restIndex !== order.lastIndexOf("*")) {
	    throw new Error("uiSchema order list contains more than one wildcard item");
	  }
	
	  var complete = [].concat(order);
	  complete.splice.apply(complete, [restIndex, 1].concat(rest));
	  return complete;
	}
	
	/**
	 * This function checks if the given schema matches a single
	 * constant value.
	 */
	function isConstant(schema) {
	  return Array.isArray(schema.enum) && schema.enum.length === 1 || schema.hasOwnProperty("const");
	}
	
	function toConstant(schema) {
	  if (Array.isArray(schema.enum) && schema.enum.length === 1) {
	    return schema.enum[0];
	  } else if (schema.hasOwnProperty("const")) {
	    return schema.const;
	  } else {
	    throw new Error("schema cannot be inferred as a constant");
	  }
	}
	
	function isSelect(_schema) {
	  var definitions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var schema = retrieveSchema(_schema, definitions);
	  var altSchemas = schema.oneOf || schema.anyOf;
	  if (Array.isArray(schema.enum)) {
	    return true;
	  } else if (Array.isArray(altSchemas)) {
	    return altSchemas.every(function (altSchemas) {
	      return isConstant(altSchemas);
	    });
	  }
	  return false;
	}
	
	function isMultiSelect(schema) {
	  var definitions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (!schema.uniqueItems || !schema.items) {
	    return false;
	  }
	  return isSelect(schema.items, definitions);
	}
	
	function isFilesArray(schema, uiSchema) {
	  var definitions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (uiSchema["ui:widget"] === "files") {
	    return true;
	  } else if (schema.items) {
	    var itemsSchema = retrieveSchema(schema.items, definitions);
	    return itemsSchema.type === "string" && itemsSchema.format === "data-url";
	  }
	  return false;
	}
	
	function isFixedItems(schema) {
	  return Array.isArray(schema.items) && schema.items.length > 0 && schema.items.every(function (item) {
	    return isObject(item);
	  });
	}
	
	function allowAdditionalItems(schema) {
	  if (schema.additionalItems === true) {
	    console.warn("additionalItems=true is currently not supported");
	  }
	  return isObject(schema.additionalItems);
	}
	
	function optionsList(schema) {
	  if (schema.enum) {
	    return schema.enum.map(function (value, i) {
	      var label = schema.enumNames && schema.enumNames[i] || String(value);
	      return { label: label, value: value };
	    });
	  } else {
	    var altSchemas = schema.oneOf || schema.anyOf;
	    return altSchemas.map(function (schema, i) {
	      var value = toConstant(schema);
	      var label = schema.title || String(value);
	      return { label: label, value: value };
	    });
	  }
	}
	
	function findSchemaDefinition($ref) {
	  var definitions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  // Extract and use the referenced definition if we have it.
	  var match = /^#\/definitions\/(.*)$/.exec($ref);
	  if (match && match[1]) {
	    var parts = match[1].split("/");
	    var current = definitions;
	    for (var _iterator = parts, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref2;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref2 = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref2 = _i.value;
	      }
	
	      var part = _ref2;
	
	      part = part.replace(/~1/g, "/").replace(/~0/g, "~");
	      if (current.hasOwnProperty(part)) {
	        current = current[part];
	      } else {
	        // No matching definition found, that's an error (bogus schema?)
	        throw new Error("Could not find a definition for " + $ref + ".");
	      }
	    }
	    return current;
	  }
	
	  // No matching definition found, that's an error (bogus schema?)
	  throw new Error("Could not find a definition for " + $ref + ".");
	}
	
	function retrieveSchema(schema) {
	  var definitions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var formData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (schema.hasOwnProperty("$ref")) {
	    // Retrieve the referenced schema definition.
	    var $refSchema = findSchemaDefinition(schema.$ref, definitions);
	    // Drop the $ref property of the source schema.
	
	    var $ref = schema.$ref,
	        localSchema = _objectWithoutProperties(schema, ["$ref"]);
	    // Update referenced schema definition with local schema properties.
	
	
	    return retrieveSchema(_extends({}, $refSchema, localSchema), definitions, formData);
	  } else if (schema.hasOwnProperty("dependencies")) {
	    var resolvedSchema = resolveDependencies(schema, definitions, formData);
	    return retrieveSchema(resolvedSchema, definitions, formData);
	  } else {
	    // No $ref or dependencies attribute found, returning the original schema.
	    return schema;
	  }
	}
	
	function resolveDependencies(schema, definitions, formData) {
	  // Drop the dependencies from the source schema.
	  var _schema$dependencies = schema.dependencies,
	      dependencies = _schema$dependencies === undefined ? {} : _schema$dependencies,
	      resolvedSchema = _objectWithoutProperties(schema, ["dependencies"]);
	  // Process dependencies updating the local schema properties as appropriate.
	
	
	  for (var dependencyKey in dependencies) {
	    // Skip this dependency if its trigger property is not present.
	    if (formData[dependencyKey] === undefined) {
	      continue;
	    }
	    var dependencyValue = dependencies[dependencyKey];
	    if (Array.isArray(dependencyValue)) {
	      resolvedSchema = withDependentProperties(resolvedSchema, dependencyValue);
	    } else if (isObject(dependencyValue)) {
	      resolvedSchema = withDependentSchema(resolvedSchema, definitions, formData, dependencyKey, dependencyValue);
	    }
	  }
	  return resolvedSchema;
	}
	
	function withDependentProperties(schema, additionallyRequired) {
	  if (!additionallyRequired) {
	    return schema;
	  }
	  var required = Array.isArray(schema.required) ? Array.from(new Set([].concat(schema.required, additionallyRequired))) : additionallyRequired;
	  return _extends({}, schema, { required: required });
	}
	
	function withDependentSchema(schema, definitions, formData, dependencyKey, dependencyValue) {
	  var _retrieveSchema = retrieveSchema(dependencyValue, definitions, formData),
	      oneOf = _retrieveSchema.oneOf,
	      dependentSchema = _objectWithoutProperties(_retrieveSchema, ["oneOf"]);
	
	  schema = mergeSchemas(schema, dependentSchema);
	  return oneOf === undefined ? schema : withExactlyOneSubschema(schema, definitions, formData, dependencyKey, oneOf);
	}
	
	function withExactlyOneSubschema(schema, definitions, formData, dependencyKey, oneOf) {
	  if (!Array.isArray(oneOf)) {
	    throw new Error("invalid oneOf: it is some " + (typeof oneOf === "undefined" ? "undefined" : _typeof(oneOf)) + " instead of an array");
	  }
	  var validSubschemas = oneOf.filter(function (subschema) {
	    if (!subschema.properties) {
	      return false;
	    }
	    var conditionPropertySchema = subschema.properties[dependencyKey];
	
	    if (conditionPropertySchema) {
	      var _properties;
	
	      var conditionSchema = {
	        type: "object",
	        properties: (_properties = {}, _properties[dependencyKey] = conditionPropertySchema, _properties)
	      };
	
	      var _validateFormData = (0, _validate2.default)(formData, conditionSchema),
	          errors = _validateFormData.errors;
	
	      return errors.length === 0;
	    }
	  });
	  if (validSubschemas.length !== 1) {
	    console.warn("ignoring oneOf in dependencies because there isn't exactly one subschema that is valid");
	    return schema;
	  }
	  var subschema = validSubschemas[0];
	
	  var _subschema$properties = subschema.properties,
	      conditionPropertySchema = _subschema$properties[dependencyKey],
	      dependentSubschema = _objectWithoutProperties(_subschema$properties, [dependencyKey]);
	
	  var dependentSchema = _extends({}, subschema, { properties: dependentSubschema });
	  return mergeSchemas(schema, retrieveSchema(dependentSchema, definitions, formData));
	}
	
	function mergeSchemas(schema1, schema2) {
	  return mergeObjects(schema1, schema2, true);
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) === "[object Arguments]";
	}
	
	function deepEquals(a, b) {
	  var ca = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
	  // Partially extracted from node-deeper and adapted to exclude comparison
	  // checks for functions.
	  // https://github.com/othiym23/node-deeper
	  if (a === b) {
	    return true;
	  } else if (typeof a === "function" || typeof b === "function") {
	    // Assume all functions are equivalent
	    // see https://github.com/mozilla-services/react-jsonschema-form/issues/255
	    return true;
	  } else if ((typeof a === "undefined" ? "undefined" : _typeof(a)) !== "object" || (typeof b === "undefined" ? "undefined" : _typeof(b)) !== "object") {
	    return false;
	  } else if (a === null || b === null) {
	    return false;
	  } else if (a instanceof Date && b instanceof Date) {
	    return a.getTime() === b.getTime();
	  } else if (a instanceof RegExp && b instanceof RegExp) {
	    return a.source === b.source && a.global === b.global && a.multiline === b.multiline && a.lastIndex === b.lastIndex && a.ignoreCase === b.ignoreCase;
	  } else if (isArguments(a) || isArguments(b)) {
	    if (!(isArguments(a) && isArguments(b))) {
	      return false;
	    }
	    var slice = Array.prototype.slice;
	    return deepEquals(slice.call(a), slice.call(b), ca, cb);
	  } else {
	    if (a.constructor !== b.constructor) {
	      return false;
	    }
	
	    var ka = Object.keys(a);
	    var kb = Object.keys(b);
	    // don't bother with stack acrobatics if there's nothing there
	    if (ka.length === 0 && kb.length === 0) {
	      return true;
	    }
	    if (ka.length !== kb.length) {
	      return false;
	    }
	
	    var cal = ca.length;
	    while (cal--) {
	      if (ca[cal] === a) {
	        return cb[cal] === b;
	      }
	    }
	    ca.push(a);
	    cb.push(b);
	
	    ka.sort();
	    kb.sort();
	    for (var j = ka.length - 1; j >= 0; j--) {
	      if (ka[j] !== kb[j]) {
	        return false;
	      }
	    }
	
	    var key = void 0;
	    for (var k = ka.length - 1; k >= 0; k--) {
	      key = ka[k];
	      if (!deepEquals(a[key], b[key], ca, cb)) {
	        return false;
	      }
	    }
	
	    ca.pop();
	    cb.pop();
	
	    return true;
	  }
	}
	
	function shouldRender(comp, nextProps, nextState) {
	  var props = comp.props,
	      state = comp.state;
	
	  return !deepEquals(props, nextProps) || !deepEquals(state, nextState);
	}
	
	function toIdSchema(schema, id, definitions) {
	  var formData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var idPrefix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "root";
	
	  var idSchema = {
	    $id: id || idPrefix
	  };
	  if ("$ref" in schema) {
	    var _schema = retrieveSchema(schema, definitions, formData);
	    return toIdSchema(_schema, id, definitions, formData, idPrefix);
	  }
	  if ("items" in schema && !schema.items.$ref) {
	    return toIdSchema(schema.items, id, definitions, formData, idPrefix);
	  }
	  if (schema.type !== "object") {
	    return idSchema;
	  }
	  for (var name in schema.properties || {}) {
	    var field = schema.properties[name];
	    var fieldId = idSchema.$id + "_" + name;
	    idSchema[name] = toIdSchema(field, fieldId, definitions, formData[name], idPrefix);
	  }
	  return idSchema;
	}
	
	function parseDateString(dateString) {
	  var includeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  if (!dateString) {
	    return {
	      year: -1,
	      month: -1,
	      day: -1,
	      hour: includeTime ? -1 : 0,
	      minute: includeTime ? -1 : 0,
	      second: includeTime ? -1 : 0
	    };
	  }
	  var date = new Date(dateString);
	  if (Number.isNaN(date.getTime())) {
	    throw new Error("Unable to parse date " + dateString);
	  }
	  return {
	    year: date.getUTCFullYear(),
	    month: date.getUTCMonth() + 1, // oh you, javascript.
	    day: date.getUTCDate(),
	    hour: includeTime ? date.getUTCHours() : 0,
	    minute: includeTime ? date.getUTCMinutes() : 0,
	    second: includeTime ? date.getUTCSeconds() : 0
	  };
	}
	
	function toDateString(_ref3) {
	  var year = _ref3.year,
	      month = _ref3.month,
	      day = _ref3.day,
	      _ref3$hour = _ref3.hour,
	      hour = _ref3$hour === undefined ? 0 : _ref3$hour,
	      _ref3$minute = _ref3.minute,
	      minute = _ref3$minute === undefined ? 0 : _ref3$minute,
	      _ref3$second = _ref3.second,
	      second = _ref3$second === undefined ? 0 : _ref3$second;
	  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  var utcTime = Date.UTC(year, month - 1, day, hour, minute, second);
	  var datetime = new Date(utcTime).toJSON();
	  return time ? datetime : datetime.slice(0, 10);
	}
	
	function pad(num, size) {
	  var s = String(num);
	  while (s.length < size) {
	    s = "0" + s;
	  }
	  return s;
	}
	
	function setState(instance, state, callback) {
	  var safeRenderCompletion = instance.props.safeRenderCompletion;
	
	  if (safeRenderCompletion) {
	    instance.setState(state, callback);
	  } else {
	    instance.setState(state);
	    setImmediate(callback);
	  }
	}
	
	function dataURItoBlob(dataURI) {
	  // Split metadata from data
	  var splitted = dataURI.split(",");
	  // Split params
	  var params = splitted[0].split(";");
	  // Get mime-type from params
	  var type = params[0].replace("data:", "");
	  // Filter the name property from params
	  var properties = params.filter(function (param) {
	    return param.split("=")[0] === "name";
	  });
	  // Look for the name and use unknown if no name property.
	  var name = void 0;
	  if (properties.length !== 1) {
	    name = "unknown";
	  } else {
	    // Because we filtered out the other property,
	    // we only have the name case here.
	    name = properties[0].split("=")[1];
	  }
	
	  // Built the Uint8Array Blob parameter from the base64 string.
	  var binary = atob(splitted[1]);
	  var array = [];
	  for (var i = 0; i < binary.length; i++) {
	    array.push(binary.charCodeAt(i));
	  }
	  // Create the blob object
	  var blob = new window.Blob([new Uint8Array(array)], { type: type });
	
	  return { blob: blob, name: name };
	}
	
	function rangeSpec(schema) {
	  var spec = {};
	  if (schema.multipleOf) {
	    spec.step = schema.multipleOf;
	  }
	  if (schema.minimum || schema.minimum === 0) {
	    spec.min = schema.minimum;
	  }
	  if (schema.maximum || schema.maximum === 0) {
	    spec.max = schema.maximum;
	  }
	  return spec;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("162o").setImmediate))

/***/ },

/***/ "TANh":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.toErrorList = toErrorList;
	exports.default = validateFormData;
	
	var _lodash = __webpack_require__("MX5l");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ajv = __webpack_require__("6nap");
	
	var _ajv2 = _interopRequireDefault(_ajv);
	
	var _utils = __webpack_require__("X7Bk");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ajv = new _ajv2.default({
	  errorDataPath: "property",
	  allErrors: true
	});
	// add custom formats
	ajv.addFormat("data-url", /^data:([a-z]+\/[a-z0-9-+.]+)?;name=(.*);base64,(.*)$/);
	ajv.addFormat("color", /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/);
	
	function toErrorSchema(errors) {
	  // Transforms a ajv validation errors list:
	  // [
	  //   {property: ".level1.level2[2].level3", message: "err a"},
	  //   {property: ".level1.level2[2].level3", message: "err b"},
	  //   {property: ".level1.level2[4].level3", message: "err b"},
	  // ]
	  // Into an error tree:
	  // {
	  //   level1: {
	  //     level2: {
	  //       2: {level3: {errors: ["err a", "err b"]}},
	  //       4: {level3: {errors: ["err b"]}},
	  //     }
	  //   }
	  // };
	  if (!errors.length) {
	    return {};
	  }
	  return errors.reduce(function (errorSchema, error) {
	    var property = error.property,
	        message = error.message;
	
	    var path = (0, _lodash2.default)(property);
	    var parent = errorSchema;
	
	    // If the property is at the root (.level1) then toPath creates
	    // an empty array element at the first index. Remove it.
	    if (path.length > 0 && path[0] === "") {
	      path.splice(0, 1);
	    }
	
	    for (var _iterator = path.slice(0), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var segment = _ref;
	
	      if (!(segment in parent)) {
	        parent[segment] = {};
	      }
	      parent = parent[segment];
	    }
	    if (Array.isArray(parent.__errors)) {
	      // We store the list of errors for this node in a property named __errors
	      // to avoid name collision with a possible sub schema field named
	      // "errors" (see `validate.createErrorHandler`).
	      parent.__errors = parent.__errors.concat(message);
	    } else {
	      parent.__errors = [message];
	    }
	    return errorSchema;
	  }, {});
	}
	
	function toErrorList(errorSchema) {
	  var fieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "root";
	
	  // XXX: We should transform fieldName as a full field path string.
	  var errorList = [];
	  if ("__errors" in errorSchema) {
	    errorList = errorList.concat(errorSchema.__errors.map(function (stack) {
	      return {
	        stack: fieldName + ": " + stack
	      };
	    }));
	  }
	  return Object.keys(errorSchema).reduce(function (acc, key) {
	    if (key !== "__errors") {
	      acc = acc.concat(toErrorList(errorSchema[key], key));
	    }
	    return acc;
	  }, errorList);
	}
	
	function createErrorHandler(formData) {
	  var handler = {
	    // We store the list of errors for this node in a property named __errors
	    // to avoid name collision with a possible sub schema field named
	    // "errors" (see `utils.toErrorSchema`).
	    __errors: [],
	    addError: function addError(message) {
	      this.__errors.push(message);
	    }
	  };
	  if ((0, _utils.isObject)(formData)) {
	    return Object.keys(formData).reduce(function (acc, key) {
	      var _extends2;
	
	      return _extends({}, acc, (_extends2 = {}, _extends2[key] = createErrorHandler(formData[key]), _extends2));
	    }, handler);
	  }
	  if (Array.isArray(formData)) {
	    return formData.reduce(function (acc, value, key) {
	      var _extends3;
	
	      return _extends({}, acc, (_extends3 = {}, _extends3[key] = createErrorHandler(value), _extends3));
	    }, handler);
	  }
	  return handler;
	}
	
	function unwrapErrorHandler(errorHandler) {
	  return Object.keys(errorHandler).reduce(function (acc, key) {
	    var _extends5;
	
	    if (key === "addError") {
	      return acc;
	    } else if (key === "__errors") {
	      var _extends4;
	
	      return _extends({}, acc, (_extends4 = {}, _extends4[key] = errorHandler[key], _extends4));
	    }
	    return _extends({}, acc, (_extends5 = {}, _extends5[key] = unwrapErrorHandler(errorHandler[key]), _extends5));
	  }, {});
	}
	
	/**
	 * Transforming the error output from ajv to format used by jsonschema.
	 * At some point, components should be updated to support ajv.
	 */
	function transformAjvErrors() {
	  var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  if (errors === null) {
	    return [];
	  }
	
	  return errors.map(function (e) {
	    var dataPath = e.dataPath,
	        keyword = e.keyword,
	        message = e.message,
	        params = e.params;
	
	    var property = "" + dataPath;
	
	    // put data in expected format
	    return {
	      name: keyword,
	      property: property,
	      message: message,
	      params: params, // specific to ajv
	      stack: (property + " " + message).trim()
	    };
	  });
	}
	
	/**
	 * This function processes the formData with a user `validate` contributed
	 * function, which receives the form data and an `errorHandler` object that
	 * will be used to add custom validation errors for each field.
	 */
	function validateFormData(formData, schema, customValidate, transformErrors) {
	  ajv.validate(schema, formData);
	
	  var errors = transformAjvErrors(ajv.errors);
	
	  if (typeof transformErrors === "function") {
	    errors = transformErrors(errors);
	  }
	  var errorSchema = toErrorSchema(errors);
	
	  if (typeof customValidate !== "function") {
	    return { errors: errors, errorSchema: errorSchema };
	  }
	
	  var errorHandler = customValidate(formData, createErrorHandler(formData));
	  var userErrorSchema = unwrapErrorHandler(errorHandler);
	  var newErrorSchema = (0, _utils.mergeObjects)(errorSchema, userErrorSchema, true);
	  // XXX: The errors list produced is not fully compliant with the format
	  // exposed by the jsonschema lib, which contains full field paths and other
	  // properties.
	  var newErrors = toErrorList(newErrorSchema);
	
	  return { errors: newErrors, errorSchema: newErrorSchema };
	}

/***/ },

/***/ "X0jD":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _ArrayField = __webpack_require__("KEao");
	
	var _ArrayField2 = _interopRequireDefault(_ArrayField);
	
	var _BooleanField = __webpack_require__("ofhc");
	
	var _BooleanField2 = _interopRequireDefault(_BooleanField);
	
	var _DescriptionField = __webpack_require__("nqH9");
	
	var _DescriptionField2 = _interopRequireDefault(_DescriptionField);
	
	var _NumberField = __webpack_require__("UT7Q");
	
	var _NumberField2 = _interopRequireDefault(_NumberField);
	
	var _ObjectField = __webpack_require__("xhAc");
	
	var _ObjectField2 = _interopRequireDefault(_ObjectField);
	
	var _SchemaField = __webpack_require__("rbn1");
	
	var _SchemaField2 = _interopRequireDefault(_SchemaField);
	
	var _StringField = __webpack_require__("pjji");
	
	var _StringField2 = _interopRequireDefault(_StringField);
	
	var _TitleField = __webpack_require__("17AZ");
	
	var _TitleField2 = _interopRequireDefault(_TitleField);
	
	var _UnsupportedField = __webpack_require__("Qnix");
	
	var _UnsupportedField2 = _interopRequireDefault(_UnsupportedField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  ArrayField: _ArrayField2.default,
	  BooleanField: _BooleanField2.default,
	  DescriptionField: _DescriptionField2.default,
	  NumberField: _NumberField2.default,
	  ObjectField: _ObjectField2.default,
	  SchemaField: _SchemaField2.default,
	  StringField: _StringField2.default,
	  TitleField: _TitleField2.default,
	  UnsupportedField: _UnsupportedField2.default
	};
	module.exports = exports["default"];

/***/ },

/***/ "KEao":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _UnsupportedField = __webpack_require__("Qnix");
	
	var _UnsupportedField2 = _interopRequireDefault(_UnsupportedField);
	
	var _utils = __webpack_require__("X7Bk");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function ArrayFieldTitle(_ref) {
	  var TitleField = _ref.TitleField,
	      idSchema = _ref.idSchema,
	      title = _ref.title,
	      required = _ref.required;
	
	  if (!title) {
	    // See #312: Ensure compatibility with old versions of React.
	    return _react2.default.createElement("div", null);
	  }
	  var id = idSchema.$id + "__title";
	  return _react2.default.createElement(TitleField, { id: id, title: title, required: required });
	}
	
	function ArrayFieldDescription(_ref2) {
	  var DescriptionField = _ref2.DescriptionField,
	      idSchema = _ref2.idSchema,
	      description = _ref2.description;
	
	  if (!description) {
	    // See #312: Ensure compatibility with old versions of React.
	    return _react2.default.createElement("div", null);
	  }
	  var id = idSchema.$id + "__description";
	  return _react2.default.createElement(DescriptionField, { id: id, description: description });
	}
	
	function IconBtn(props) {
	  var _props$type = props.type,
	      type = _props$type === undefined ? "default" : _props$type,
	      icon = props.icon,
	      className = props.className,
	      otherProps = _objectWithoutProperties(props, ["type", "icon", "className"]);
	
	  return _react2.default.createElement(
	    "button",
	    _extends({
	      type: "button",
	      className: "btn btn-" + type + " " + className
	    }, otherProps),
	    _react2.default.createElement("i", { className: "glyphicon glyphicon-" + icon })
	  );
	}
	
	// Used in the two templates
	function DefaultArrayItem(props) {
	  var btnStyle = {
	    flex: 1,
	    paddingLeft: 6,
	    paddingRight: 6,
	    fontWeight: "bold"
	  };
	  return _react2.default.createElement(
	    "div",
	    { key: props.index, className: props.className },
	    _react2.default.createElement(
	      "div",
	      { className: props.hasToolbar ? "col-xs-9" : "col-xs-12" },
	      props.children
	    ),
	    props.hasToolbar && _react2.default.createElement(
	      "div",
	      { className: "col-xs-3 array-item-toolbox" },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "btn-group",
	          style: { display: "flex", justifyContent: "space-around" } },
	        (props.hasMoveUp || props.hasMoveDown) && _react2.default.createElement(IconBtn, {
	          icon: "arrow-up",
	          className: "array-item-move-up",
	          tabIndex: "-1",
	          style: btnStyle,
	          disabled: props.disabled || props.readonly || !props.hasMoveUp,
	          onClick: props.onReorderClick(props.index, props.index - 1)
	        }),
	        (props.hasMoveUp || props.hasMoveDown) && _react2.default.createElement(IconBtn, {
	          icon: "arrow-down",
	          className: "array-item-move-down",
	          tabIndex: "-1",
	          style: btnStyle,
	          disabled: props.disabled || props.readonly || !props.hasMoveDown,
	          onClick: props.onReorderClick(props.index, props.index + 1)
	        }),
	        props.hasRemove && _react2.default.createElement(IconBtn, {
	          type: "danger",
	          icon: "remove",
	          className: "array-item-remove",
	          tabIndex: "-1",
	          style: btnStyle,
	          disabled: props.disabled || props.readonly,
	          onClick: props.onDropIndexClick(props.index)
	        })
	      )
	    )
	  );
	}
	
	function DefaultFixedArrayFieldTemplate(props) {
	  return _react2.default.createElement(
	    "fieldset",
	    { className: props.className },
	    _react2.default.createElement(ArrayFieldTitle, {
	      key: "array-field-title-" + props.idSchema.$id,
	      TitleField: props.TitleField,
	      idSchema: props.idSchema,
	      title: props.uiSchema["ui:title"] || props.title,
	      required: props.required
	    }),
	    (props.uiSchema["ui:description"] || props.schema.description) && _react2.default.createElement(
	      "div",
	      {
	        className: "field-description",
	        key: "field-description-" + props.idSchema.$id },
	      props.uiSchema["ui:description"] || props.schema.description
	    ),
	    _react2.default.createElement(
	      "div",
	      {
	        className: "row array-item-list",
	        key: "array-item-list-" + props.idSchema.$id },
	      props.items && props.items.map(DefaultArrayItem)
	    ),
	    props.canAdd && _react2.default.createElement(AddButton, {
	      onClick: props.onAddClick,
	      disabled: props.disabled || props.readonly
	    })
	  );
	}
	
	function DefaultNormalArrayFieldTemplate(props) {
	  return _react2.default.createElement(
	    "fieldset",
	    { className: props.className },
	    _react2.default.createElement(ArrayFieldTitle, {
	      key: "array-field-title-" + props.idSchema.$id,
	      TitleField: props.TitleField,
	      idSchema: props.idSchema,
	      title: props.uiSchema["ui:title"] || props.title,
	      required: props.required
	    }),
	    (props.uiSchema["ui:description"] || props.schema.description) && _react2.default.createElement(ArrayFieldDescription, {
	      key: "array-field-description-" + props.idSchema.$id,
	      DescriptionField: props.DescriptionField,
	      idSchema: props.idSchema,
	      description: props.uiSchema["ui:description"] || props.schema.description
	    }),
	    _react2.default.createElement(
	      "div",
	      {
	        className: "row array-item-list",
	        key: "array-item-list-" + props.idSchema.$id },
	      props.items && props.items.map(function (p) {
	        return DefaultArrayItem(p);
	      })
	    ),
	    props.canAdd && _react2.default.createElement(AddButton, {
	      onClick: props.onAddClick,
	      disabled: props.disabled || props.readonly
	    })
	  );
	}
	
	var ArrayField = (_temp2 = _class = function (_Component) {
	  _inherits(ArrayField, _Component);
	
	  function ArrayField() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ArrayField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onAddClick = function (event) {
	      event.preventDefault();
	      var _this$props = _this.props,
	          schema = _this$props.schema,
	          formData = _this$props.formData,
	          _this$props$registry = _this$props.registry,
	          registry = _this$props$registry === undefined ? (0, _utils.getDefaultRegistry)() : _this$props$registry;
	      var definitions = registry.definitions;
	
	      var itemSchema = schema.items;
	      if ((0, _utils.isFixedItems)(schema) && (0, _utils.allowAdditionalItems)(schema)) {
	        itemSchema = schema.additionalItems;
	      }
	      _this.props.onChange([].concat(formData, [(0, _utils.getDefaultFormState)(itemSchema, undefined, definitions)]), { validate: false });
	    }, _this.onDropIndexClick = function (index) {
	      return function (event) {
	        if (event) {
	          event.preventDefault();
	        }
	        var _this$props2 = _this.props,
	            formData = _this$props2.formData,
	            onChange = _this$props2.onChange;
	        // refs #195: revalidate to ensure properly reindexing errors
	
	        onChange(formData.filter(function (_, i) {
	          return i !== index;
	        }), { validate: true });
	      };
	    }, _this.onReorderClick = function (index, newIndex) {
	      return function (event) {
	        if (event) {
	          event.preventDefault();
	          event.target.blur();
	        }
	        var _this$props3 = _this.props,
	            formData = _this$props3.formData,
	            onChange = _this$props3.onChange;
	
	        onChange(formData.map(function (item, i) {
	          if (i === newIndex) {
	            return formData[index];
	          } else if (i === index) {
	            return formData[newIndex];
	          } else {
	            return item;
	          }
	        }), { validate: true });
	      };
	    }, _this.onChangeForIndex = function (index) {
	      return function (value) {
	        var _this$props4 = _this.props,
	            formData = _this$props4.formData,
	            onChange = _this$props4.onChange;
	
	        var newFormData = formData.map(function (item, i) {
	          // We need to treat undefined items as nulls to have validation.
	          // See https://github.com/tdegrunt/jsonschema/issues/206
	          var jsonValue = typeof value === "undefined" ? null : value;
	          return index === i ? jsonValue : item;
	        });
	        onChange(newFormData, { validate: false });
	      };
	    }, _this.onSelectChange = function (value) {
	      _this.props.onChange(value, { validate: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ArrayField.prototype.isItemRequired = function isItemRequired(itemSchema) {
	    if (Array.isArray(itemSchema.type)) {
	      // While we don't yet support composite/nullable jsonschema types, it's
	      // future-proof to check for requirement against these.
	      return !itemSchema.type.includes("null");
	    }
	    // All non-null array item types are inherently required by design
	    return itemSchema.type !== "null";
	  };
	
	  ArrayField.prototype.canAddItem = function canAddItem(formItems) {
	    var _props = this.props,
	        schema = _props.schema,
	        uiSchema = _props.uiSchema;
	
	    var _getUiOptions = (0, _utils.getUiOptions)(uiSchema),
	        addable = _getUiOptions.addable;
	
	    if (addable !== false) {
	      // if ui:options.addable was not explicitly set to false, we can add
	      // another item if we have not exceeded maxItems yet
	      if (schema.maxItems !== undefined) {
	        addable = formItems.length < schema.maxItems;
	      } else {
	        addable = true;
	      }
	    }
	    return addable;
	  };
	
	  ArrayField.prototype.render = function render() {
	    var _props2 = this.props,
	        schema = _props2.schema,
	        uiSchema = _props2.uiSchema,
	        idSchema = _props2.idSchema,
	        _props2$registry = _props2.registry,
	        registry = _props2$registry === undefined ? (0, _utils.getDefaultRegistry)() : _props2$registry;
	    var definitions = registry.definitions;
	
	    if (!schema.hasOwnProperty("items")) {
	      return _react2.default.createElement(_UnsupportedField2.default, {
	        schema: schema,
	        idSchema: idSchema,
	        reason: "Missing items definition"
	      });
	    }
	    if ((0, _utils.isFixedItems)(schema)) {
	      return this.renderFixedArray();
	    }
	    if ((0, _utils.isFilesArray)(schema, uiSchema, definitions)) {
	      return this.renderFiles();
	    }
	    if ((0, _utils.isMultiSelect)(schema, definitions)) {
	      return this.renderMultiSelect();
	    }
	    return this.renderNormalArray();
	  };
	
	  ArrayField.prototype.renderNormalArray = function renderNormalArray() {
	    var _this2 = this;
	
	    var _props3 = this.props,
	        schema = _props3.schema,
	        uiSchema = _props3.uiSchema,
	        formData = _props3.formData,
	        errorSchema = _props3.errorSchema,
	        idSchema = _props3.idSchema,
	        name = _props3.name,
	        required = _props3.required,
	        disabled = _props3.disabled,
	        readonly = _props3.readonly,
	        autofocus = _props3.autofocus,
	        _props3$registry = _props3.registry,
	        registry = _props3$registry === undefined ? (0, _utils.getDefaultRegistry)() : _props3$registry,
	        formContext = _props3.formContext,
	        onBlur = _props3.onBlur,
	        onFocus = _props3.onFocus,
	        idPrefix = _props3.idPrefix;
	
	    var title = schema.title === undefined ? name : schema.title;
	    var ArrayFieldTemplate = registry.ArrayFieldTemplate,
	        definitions = registry.definitions,
	        fields = registry.fields;
	    var TitleField = fields.TitleField,
	        DescriptionField = fields.DescriptionField;
	
	    var itemsSchema = (0, _utils.retrieveSchema)(schema.items, definitions);
	    var arrayProps = {
	      canAdd: this.canAddItem(formData),
	      items: formData.map(function (item, index) {
	        var itemSchema = (0, _utils.retrieveSchema)(schema.items, definitions, item);
	        var itemErrorSchema = errorSchema ? errorSchema[index] : undefined;
	        var itemIdPrefix = idSchema.$id + "_" + index;
	        var itemIdSchema = (0, _utils.toIdSchema)(itemSchema, itemIdPrefix, definitions, item, idPrefix);
	        return _this2.renderArrayFieldItem({
	          index: index,
	          canMoveUp: index > 0,
	          canMoveDown: index < formData.length - 1,
	          itemSchema: itemSchema,
	          itemIdSchema: itemIdSchema,
	          itemErrorSchema: itemErrorSchema,
	          itemData: item,
	          itemUiSchema: uiSchema.items,
	          autofocus: autofocus && index === 0,
	          onBlur: onBlur,
	          onFocus: onFocus
	        });
	      }),
	      className: "field field-array field-array-of-" + itemsSchema.type,
	      DescriptionField: DescriptionField,
	      disabled: disabled,
	      idSchema: idSchema,
	      uiSchema: uiSchema,
	      onAddClick: this.onAddClick,
	      readonly: readonly,
	      required: required,
	      schema: schema,
	      title: title,
	      TitleField: TitleField,
	      formContext: formContext,
	      formData: formData
	    };
	
	    // Check if a custom render function was passed in
	    var Component = ArrayFieldTemplate || DefaultNormalArrayFieldTemplate;
	    return _react2.default.createElement(Component, arrayProps);
	  };
	
	  ArrayField.prototype.renderMultiSelect = function renderMultiSelect() {
	    var _props4 = this.props,
	        schema = _props4.schema,
	        idSchema = _props4.idSchema,
	        uiSchema = _props4.uiSchema,
	        formData = _props4.formData,
	        disabled = _props4.disabled,
	        readonly = _props4.readonly,
	        autofocus = _props4.autofocus,
	        onBlur = _props4.onBlur,
	        onFocus = _props4.onFocus,
	        _props4$registry = _props4.registry,
	        registry = _props4$registry === undefined ? (0, _utils.getDefaultRegistry)() : _props4$registry;
	
	    var items = this.props.formData;
	    var widgets = registry.widgets,
	        definitions = registry.definitions,
	        formContext = registry.formContext;
	
	    var itemsSchema = (0, _utils.retrieveSchema)(schema.items, definitions, formData);
	    var enumOptions = (0, _utils.optionsList)(itemsSchema);
	
	    var _getUiOptions$enumOpt = _extends({}, (0, _utils.getUiOptions)(uiSchema), {
	      enumOptions: enumOptions
	    }),
	        _getUiOptions$enumOpt2 = _getUiOptions$enumOpt.widget,
	        widget = _getUiOptions$enumOpt2 === undefined ? "select" : _getUiOptions$enumOpt2,
	        options = _objectWithoutProperties(_getUiOptions$enumOpt, ["widget"]);
	
	    var Widget = (0, _utils.getWidget)(schema, widget, widgets);
	    return _react2.default.createElement(Widget, {
	      id: idSchema && idSchema.$id,
	      multiple: true,
	      onChange: this.onSelectChange,
	      onBlur: onBlur,
	      onFocus: onFocus,
	      options: options,
	      schema: schema,
	      value: items,
	      disabled: disabled,
	      readonly: readonly,
	      formContext: formContext,
	      autofocus: autofocus
	    });
	  };
	
	  ArrayField.prototype.renderFiles = function renderFiles() {
	    var _props5 = this.props,
	        schema = _props5.schema,
	        uiSchema = _props5.uiSchema,
	        idSchema = _props5.idSchema,
	        name = _props5.name,
	        disabled = _props5.disabled,
	        readonly = _props5.readonly,
	        autofocus = _props5.autofocus,
	        onBlur = _props5.onBlur,
	        onFocus = _props5.onFocus,
	        _props5$registry = _props5.registry,
	        registry = _props5$registry === undefined ? (0, _utils.getDefaultRegistry)() : _props5$registry;
	
	    var title = schema.title || name;
	    var items = this.props.formData;
	    var widgets = registry.widgets,
	        formContext = registry.formContext;
	
	    var _getUiOptions2 = (0, _utils.getUiOptions)(uiSchema),
	        _getUiOptions2$widget = _getUiOptions2.widget,
	        widget = _getUiOptions2$widget === undefined ? "files" : _getUiOptions2$widget,
	        options = _objectWithoutProperties(_getUiOptions2, ["widget"]);
	
	    var Widget = (0, _utils.getWidget)(schema, widget, widgets);
	    return _react2.default.createElement(Widget, {
	      options: options,
	      id: idSchema && idSchema.$id,
	      multiple: true,
	      onChange: this.onSelectChange,
	      onBlur: onBlur,
	      onFocus: onFocus,
	      schema: schema,
	      title: title,
	      value: items,
	      disabled: disabled,
	      readonly: readonly,
	      formContext: formContext,
	      autofocus: autofocus
	    });
	  };
	
	  ArrayField.prototype.renderFixedArray = function renderFixedArray() {
	    var _this3 = this;
	
	    var _props6 = this.props,
	        schema = _props6.schema,
	        uiSchema = _props6.uiSchema,
	        formData = _props6.formData,
	        errorSchema = _props6.errorSchema,
	        idPrefix = _props6.idPrefix,
	        idSchema = _props6.idSchema,
	        name = _props6.name,
	        required = _props6.required,
	        disabled = _props6.disabled,
	        readonly = _props6.readonly,
	        autofocus = _props6.autofocus,
	        _props6$registry = _props6.registry,
	        registry = _props6$registry === undefined ? (0, _utils.getDefaultRegistry)() : _props6$registry,
	        onBlur = _props6.onBlur,
	        onFocus = _props6.onFocus;
	
	    var title = schema.title || name;
	    var items = this.props.formData;
	    var ArrayFieldTemplate = registry.ArrayFieldTemplate,
	        definitions = registry.definitions,
	        fields = registry.fields;
	    var TitleField = fields.TitleField;
	
	    var itemSchemas = schema.items.map(function (item, index) {
	      return (0, _utils.retrieveSchema)(item, definitions, formData[index]);
	    });
	    var additionalSchema = (0, _utils.allowAdditionalItems)(schema) ? (0, _utils.retrieveSchema)(schema.additionalItems, definitions, formData) : null;
	
	    if (!items || items.length < itemSchemas.length) {
	      // to make sure at least all fixed items are generated
	      items = items || [];
	      items = items.concat(new Array(itemSchemas.length - items.length));
	    }
	
	    // These are the props passed into the render function
	    var arrayProps = {
	      canAdd: this.canAddItem(items) && additionalSchema,
	      className: "field field-array field-array-fixed-items",
	      disabled: disabled,
	      idSchema: idSchema,
	      formData: formData,
	      items: items.map(function (item, index) {
	        var additional = index >= itemSchemas.length;
	        var itemSchema = additional ? (0, _utils.retrieveSchema)(schema.additionalItems, definitions, item) : itemSchemas[index];
	        var itemIdPrefix = idSchema.$id + "_" + index;
	        var itemIdSchema = (0, _utils.toIdSchema)(itemSchema, itemIdPrefix, definitions, item, idPrefix);
	        var itemUiSchema = additional ? uiSchema.additionalItems || {} : Array.isArray(uiSchema.items) ? uiSchema.items[index] : uiSchema.items || {};
	        var itemErrorSchema = errorSchema ? errorSchema[index] : undefined;
	
	        return _this3.renderArrayFieldItem({
	          index: index,
	          canRemove: additional,
	          canMoveUp: index >= itemSchemas.length + 1,
	          canMoveDown: additional && index < items.length - 1,
	          itemSchema: itemSchema,
	          itemData: item,
	          itemUiSchema: itemUiSchema,
	          itemIdSchema: itemIdSchema,
	          itemErrorSchema: itemErrorSchema,
	          autofocus: autofocus && index === 0,
	          onBlur: onBlur,
	          onFocus: onFocus
	        });
	      }),
	      onAddClick: this.onAddClick,
	      readonly: readonly,
	      required: required,
	      schema: schema,
	      uiSchema: uiSchema,
	      title: title,
	      TitleField: TitleField
	    };
	
	    // Check if a custom template template was passed in
	    var Template = ArrayFieldTemplate || DefaultFixedArrayFieldTemplate;
	    return _react2.default.createElement(Template, arrayProps);
	  };
	
	  ArrayField.prototype.renderArrayFieldItem = function renderArrayFieldItem(props) {
	    var index = props.index,
	        _props$canRemove = props.canRemove,
	        canRemove = _props$canRemove === undefined ? true : _props$canRemove,
	        _props$canMoveUp = props.canMoveUp,
	        canMoveUp = _props$canMoveUp === undefined ? true : _props$canMoveUp,
	        _props$canMoveDown = props.canMoveDown,
	        canMoveDown = _props$canMoveDown === undefined ? true : _props$canMoveDown,
	        itemSchema = props.itemSchema,
	        itemData = props.itemData,
	        itemUiSchema = props.itemUiSchema,
	        itemIdSchema = props.itemIdSchema,
	        itemErrorSchema = props.itemErrorSchema,
	        autofocus = props.autofocus,
	        onBlur = props.onBlur,
	        onFocus = props.onFocus;
	    var _props7 = this.props,
	        disabled = _props7.disabled,
	        readonly = _props7.readonly,
	        uiSchema = _props7.uiSchema,
	        _props7$registry = _props7.registry,
	        registry = _props7$registry === undefined ? (0, _utils.getDefaultRegistry)() : _props7$registry;
	    var SchemaField = registry.fields.SchemaField;
	
	    var _orderable$removable$ = _extends({
	      orderable: true,
	      removable: true
	    }, uiSchema["ui:options"]),
	        orderable = _orderable$removable$.orderable,
	        removable = _orderable$removable$.removable;
	
	    var has = {
	      moveUp: orderable && canMoveUp,
	      moveDown: orderable && canMoveDown,
	      remove: removable && canRemove
	    };
	    has.toolbar = Object.keys(has).some(function (key) {
	      return has[key];
	    });
	
	    return {
	      children: _react2.default.createElement(SchemaField, {
	        schema: itemSchema,
	        uiSchema: itemUiSchema,
	        formData: itemData,
	        errorSchema: itemErrorSchema,
	        idSchema: itemIdSchema,
	        required: this.isItemRequired(itemSchema),
	        onChange: this.onChangeForIndex(index),
	        onBlur: onBlur,
	        onFocus: onFocus,
	        registry: this.props.registry,
	        disabled: this.props.disabled,
	        readonly: this.props.readonly,
	        autofocus: autofocus
	      }),
	      className: "array-item",
	      disabled: disabled,
	      hasToolbar: has.toolbar,
	      hasMoveUp: has.moveUp,
	      hasMoveDown: has.moveDown,
	      hasRemove: has.remove,
	      index: index,
	      onDropIndexClick: this.onDropIndexClick,
	      onReorderClick: this.onReorderClick,
	      readonly: readonly
	    };
	  };
	
	  _createClass(ArrayField, [{
	    key: "itemTitle",
	    get: function get() {
	      var schema = this.props.schema;
	
	      return schema.items.title || schema.items.description || "Item";
	    }
	  }]);
	
	  return ArrayField;
	}(_react.Component), _class.defaultProps = {
	  uiSchema: {},
	  formData: [],
	  idSchema: {},
	  required: false,
	  disabled: false,
	  readonly: false,
	  autofocus: false
	}, _temp2);
	
	
	function AddButton(_ref3) {
	  var onClick = _ref3.onClick,
	      disabled = _ref3.disabled;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "row" },
	    _react2.default.createElement(
	      "p",
	      { className: "col-xs-3 col-xs-offset-9 array-item-add text-right" },
	      _react2.default.createElement(IconBtn, {
	        type: "info",
	        icon: "plus",
	        className: "btn-add col-xs-12",
	        tabIndex: "0",
	        onClick: onClick,
	        disabled: disabled
	      })
	    )
	  );
	}
	
	if (false) {}
	
	exports.default = ArrayField;
	module.exports = exports["default"];

/***/ },

/***/ "Qnix":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UnsupportedField(_ref) {
	  var schema = _ref.schema,
	      idSchema = _ref.idSchema,
	      reason = _ref.reason;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "unsupported-field" },
	    _react2.default.createElement(
	      "p",
	      null,
	      "Unsupported field schema",
	      idSchema && idSchema.$id && _react2.default.createElement(
	        "span",
	        null,
	        " for",
	        " field ",
	        _react2.default.createElement(
	          "code",
	          null,
	          idSchema.$id
	        )
	      ),
	      reason && _react2.default.createElement(
	        "em",
	        null,
	        ": ",
	        reason
	      ),
	      "."
	    ),
	    schema && _react2.default.createElement(
	      "pre",
	      null,
	      JSON.stringify(schema, null, 2)
	    )
	  );
	}
	
	if (false) {}
	
	exports.default = UnsupportedField;
	module.exports = exports["default"];

/***/ },

/***/ "ofhc":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__("X7Bk");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function BooleanField(props) {
	  var schema = props.schema,
	      name = props.name,
	      uiSchema = props.uiSchema,
	      idSchema = props.idSchema,
	      formData = props.formData,
	      _props$registry = props.registry,
	      registry = _props$registry === undefined ? (0, _utils.getDefaultRegistry)() : _props$registry,
	      required = props.required,
	      disabled = props.disabled,
	      readonly = props.readonly,
	      autofocus = props.autofocus,
	      onChange = props.onChange;
	  var title = schema.title;
	  var widgets = registry.widgets,
	      formContext = registry.formContext;
	
	  var _getUiOptions = (0, _utils.getUiOptions)(uiSchema),
	      _getUiOptions$widget = _getUiOptions.widget,
	      widget = _getUiOptions$widget === undefined ? "checkbox" : _getUiOptions$widget,
	      options = _objectWithoutProperties(_getUiOptions, ["widget"]);
	
	  var Widget = (0, _utils.getWidget)(schema, widget, widgets);
	  var enumOptions = (0, _utils.optionsList)({
	    enum: [true, false],
	    enumNames: schema.enumNames || ["yes", "no"]
	  });
	  return _react2.default.createElement(Widget, {
	    options: _extends({}, options, { enumOptions: enumOptions }),
	    schema: schema,
	    id: idSchema && idSchema.$id,
	    onChange: onChange,
	    label: title === undefined ? name : title,
	    value: formData,
	    required: required,
	    disabled: disabled,
	    readonly: readonly,
	    registry: registry,
	    formContext: formContext,
	    autofocus: autofocus
	  });
	}
	
	if (false) {}
	
	BooleanField.defaultProps = {
	  uiSchema: {},
	  disabled: false,
	  readonly: false,
	  autofocus: false
	};
	
	exports.default = BooleanField;
	module.exports = exports["default"];

/***/ },

/***/ "nqH9":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DescriptionField(props) {
	  var id = props.id,
	      description = props.description;
	
	  if (!description) {
	    // See #312: Ensure compatibility with old versions of React.
	    return _react2.default.createElement("div", null);
	  }
	  if (typeof description === "string") {
	    return _react2.default.createElement(
	      "p",
	      { id: id, className: "field-description" },
	      description
	    );
	  } else {
	    return _react2.default.createElement(
	      "div",
	      { id: id, className: "field-description" },
	      description
	    );
	  }
	}
	
	if (false) {}
	
	exports.default = DescriptionField;
	module.exports = exports["default"];

/***/ },

/***/ "UT7Q":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__("X7Bk");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NumberField(props) {
	  var StringField = props.registry.fields.StringField;
	
	  return _react2.default.createElement(StringField, _extends({}, props, {
	    onChange: function onChange(value) {
	      return props.onChange((0, _utils.asNumber)(value));
	    }
	  }));
	}
	
	if (false) {}
	
	NumberField.defaultProps = {
	  uiSchema: {}
	};
	
	exports.default = NumberField;
	module.exports = exports["default"];

/***/ },

/***/ "xhAc":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp2;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__("X7Bk");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function DefaultObjectFieldTemplate(props) {
	  var TitleField = props.TitleField,
	      DescriptionField = props.DescriptionField;
	
	  return _react2.default.createElement(
	    "fieldset",
	    null,
	    (props.uiSchema["ui:title"] || props.title) && _react2.default.createElement(TitleField, {
	      id: props.idSchema.$id + "__title",
	      title: props.title || props.uiSchema["ui:title"],
	      required: props.required,
	      formContext: props.formContext
	    }),
	    props.description && _react2.default.createElement(DescriptionField, {
	      id: props.idSchema.$id + "__description",
	      description: props.description,
	      formContext: props.formContext
	    }),
	    props.properties.map(function (prop) {
	      return prop.content;
	    })
	  );
	}
	
	var ObjectField = (_temp2 = _class = function (_Component) {
	  _inherits(ObjectField, _Component);
	
	  function ObjectField() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ObjectField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onPropertyChange = function (name) {
	      return function (value, options) {
	        var _extends2;
	
	        var newFormData = _extends({}, _this.props.formData, (_extends2 = {}, _extends2[name] = value, _extends2));
	        _this.props.onChange(newFormData, options);
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ObjectField.prototype.isRequired = function isRequired(name) {
	    var schema = this.props.schema;
	    return Array.isArray(schema.required) && schema.required.indexOf(name) !== -1;
	  };
	
	  ObjectField.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        uiSchema = _props.uiSchema,
	        formData = _props.formData,
	        errorSchema = _props.errorSchema,
	        idSchema = _props.idSchema,
	        name = _props.name,
	        required = _props.required,
	        disabled = _props.disabled,
	        readonly = _props.readonly,
	        onBlur = _props.onBlur,
	        onFocus = _props.onFocus,
	        _props$registry = _props.registry,
	        registry = _props$registry === undefined ? (0, _utils.getDefaultRegistry)() : _props$registry;
	    var definitions = registry.definitions,
	        fields = registry.fields,
	        formContext = registry.formContext;
	    var SchemaField = fields.SchemaField,
	        TitleField = fields.TitleField,
	        DescriptionField = fields.DescriptionField;
	
	    var schema = (0, _utils.retrieveSchema)(this.props.schema, definitions, formData);
	    var title = schema.title === undefined ? name : schema.title;
	    var description = uiSchema["ui:description"] || schema.description;
	    var orderedProperties = void 0;
	
	    try {
	      var properties = Object.keys(schema.properties);
	      orderedProperties = (0, _utils.orderProperties)(properties, uiSchema["ui:order"]);
	    } catch (err) {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          { className: "config-error", style: { color: "red" } },
	          "Invalid ",
	          name || "root",
	          " object field configuration:",
	          _react2.default.createElement(
	            "em",
	            null,
	            err.message
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          "pre",
	          null,
	          JSON.stringify(schema)
	        )
	      );
	    }
	
	    var Template = registry.ObjectFieldTemplate || DefaultObjectFieldTemplate;
	
	    var templateProps = {
	      title: uiSchema["ui:title"] || title,
	      description: description,
	      TitleField: TitleField,
	      DescriptionField: DescriptionField,
	      properties: orderedProperties.map(function (name) {
	        return {
	          content: _react2.default.createElement(SchemaField, {
	            key: name,
	            name: name,
	            required: _this2.isRequired(name),
	            schema: schema.properties[name],
	            uiSchema: uiSchema[name],
	            errorSchema: errorSchema[name],
	            idSchema: idSchema[name],
	            formData: formData[name],
	            onChange: _this2.onPropertyChange(name),
	            onBlur: onBlur,
	            onFocus: onFocus,
	            registry: registry,
	            disabled: disabled,
	            readonly: readonly
	          }),
	          name: name,
	          readonly: readonly,
	          disabled: disabled,
	          required: required
	        };
	      }),
	      required: required,
	      idSchema: idSchema,
	      uiSchema: uiSchema,
	      schema: schema,
	      formData: formData,
	      formContext: formContext
	    };
	    return _react2.default.createElement(Template, templateProps);
	  };
	
	  return ObjectField;
	}(_react.Component), _class.defaultProps = {
	  uiSchema: {},
	  formData: {},
	  errorSchema: {},
	  idSchema: {},
	  required: false,
	  disabled: false,
	  readonly: false
	}, _temp2);
	
	
	if (false) {}
	
	exports.default = ObjectField;
	module.exports = exports["default"];

/***/ },

/***/ "rbn1":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__("X7Bk");
	
	var _UnsupportedField = __webpack_require__("Qnix");
	
	var _UnsupportedField2 = _interopRequireDefault(_UnsupportedField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var REQUIRED_FIELD_SYMBOL = "*";
	var COMPONENT_TYPES = {
	  array: "ArrayField",
	  boolean: "BooleanField",
	  integer: "NumberField",
	  number: "NumberField",
	  object: "ObjectField",
	  string: "StringField"
	};
	
	function getFieldComponent(schema, uiSchema, idSchema, fields) {
	  var field = uiSchema["ui:field"];
	  if (typeof field === "function") {
	    return field;
	  }
	  if (typeof field === "string" && field in fields) {
	    return fields[field];
	  }
	
	  var componentName = COMPONENT_TYPES[(0, _utils.getSchemaType)(schema)];
	  return componentName in fields ? fields[componentName] : function () {
	    return _react2.default.createElement(_UnsupportedField2.default, {
	      schema: schema,
	      idSchema: idSchema,
	      reason: "Unknown field type " + schema.type
	    });
	  };
	}
	
	function Label(props) {
	  var label = props.label,
	      required = props.required,
	      id = props.id;
	
	  if (!label) {
	    // See #312: Ensure compatibility with old versions of React.
	    return _react2.default.createElement("div", null);
	  }
	  return _react2.default.createElement(
	    "label",
	    { className: "control-label", htmlFor: id },
	    _react2.default.createElement(
	      "span",
	      null,
	      label
	    ),
	    required && _react2.default.createElement(
	      "span",
	      { className: "required-symbol" },
	      REQUIRED_FIELD_SYMBOL
	    )
	  );
	}
	
	function Help(props) {
	  var help = props.help;
	
	  if (!help) {
	    // See #312: Ensure compatibility with old versions of React.
	    return _react2.default.createElement("div", null);
	  }
	  if (typeof help === "string") {
	    return _react2.default.createElement(
	      "p",
	      { className: "help-block" },
	      help
	    );
	  }
	  return _react2.default.createElement(
	    "div",
	    { className: "help-block" },
	    help
	  );
	}
	
	function ErrorList(props) {
	  var _props$errors = props.errors,
	      errors = _props$errors === undefined ? [] : _props$errors;
	
	  if (errors.length === 0) {
	    return _react2.default.createElement("div", null);
	  }
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement("p", null),
	    _react2.default.createElement(
	      "ul",
	      { className: "error-detail bs-callout bs-callout-info" },
	      errors.map(function (error, index) {
	        return _react2.default.createElement(
	          "li",
	          { className: "text-danger", key: index },
	          error
	        );
	      })
	    )
	  );
	}
	
	function DefaultTemplate(props) {
	  var id = props.id,
	      classNames = props.classNames,
	      label = props.label,
	      children = props.children,
	      errors = props.errors,
	      help = props.help,
	      description = props.description,
	      hidden = props.hidden,
	      required = props.required,
	      displayLabel = props.displayLabel;
	
	  if (hidden) {
	    return children;
	  }
	
	  return _react2.default.createElement(
	    "div",
	    { className: classNames },
	    displayLabel && _react2.default.createElement(Label, { label: label, required: required, id: id }),
	    displayLabel && description ? description : null,
	    children,
	    errors,
	    help
	  );
	}
	
	if (false) {}
	
	DefaultTemplate.defaultProps = {
	  hidden: false,
	  readonly: false,
	  required: false,
	  displayLabel: true
	};
	
	function SchemaFieldRender(props) {
	  var uiSchema = props.uiSchema,
	      formData = props.formData,
	      errorSchema = props.errorSchema,
	      idSchema = props.idSchema,
	      name = props.name,
	      required = props.required,
	      _props$registry = props.registry,
	      registry = _props$registry === undefined ? (0, _utils.getDefaultRegistry)() : _props$registry;
	  var definitions = registry.definitions,
	      fields = registry.fields,
	      formContext = registry.formContext,
	      _registry$FieldTempla = registry.FieldTemplate,
	      FieldTemplate = _registry$FieldTempla === undefined ? DefaultTemplate : _registry$FieldTempla;
	
	  var schema = (0, _utils.retrieveSchema)(props.schema, definitions, formData);
	  var FieldComponent = getFieldComponent(schema, uiSchema, idSchema, fields);
	  var DescriptionField = fields.DescriptionField;
	
	  var disabled = Boolean(props.disabled || uiSchema["ui:disabled"]);
	  var readonly = Boolean(props.readonly || uiSchema["ui:readonly"]);
	  var autofocus = Boolean(props.autofocus || uiSchema["ui:autofocus"]);
	
	  if (Object.keys(schema).length === 0) {
	    // See #312: Ensure compatibility with old versions of React.
	    return _react2.default.createElement("div", null);
	  }
	
	  var uiOptions = (0, _utils.getUiOptions)(uiSchema);
	  var _uiOptions$label = uiOptions.label,
	      displayLabel = _uiOptions$label === undefined ? true : _uiOptions$label;
	
	  if (schema.type === "array") {
	    displayLabel = (0, _utils.isMultiSelect)(schema, definitions) || (0, _utils.isFilesArray)(schema, uiSchema, definitions);
	  }
	  if (schema.type === "object") {
	    displayLabel = false;
	  }
	  if (schema.type === "boolean" && !uiSchema["ui:widget"]) {
	    displayLabel = false;
	  }
	  if (uiSchema["ui:field"]) {
	    displayLabel = false;
	  }
	
	  var __errors = errorSchema.__errors,
	      fieldErrorSchema = _objectWithoutProperties(errorSchema, ["__errors"]);
	
	  // See #439: uiSchema: Don't pass consumed class names to child components
	
	
	  var field = _react2.default.createElement(FieldComponent, _extends({}, props, {
	    schema: schema,
	    uiSchema: _extends({}, uiSchema, { classNames: undefined }),
	    disabled: disabled,
	    readonly: readonly,
	    autofocus: autofocus,
	    errorSchema: fieldErrorSchema,
	    formContext: formContext
	  }));
	
	  var type = schema.type;
	
	  var id = idSchema.$id;
	  var label = uiSchema["ui:title"] || props.schema.title || schema.title || name;
	  var description = uiSchema["ui:description"] || props.schema.description || schema.description;
	  var errors = __errors;
	  var help = uiSchema["ui:help"];
	  var hidden = uiSchema["ui:widget"] === "hidden";
	  var classNames = ["form-group", "field", "field-" + type, errors && errors.length > 0 ? "field-error has-error has-danger" : "", uiSchema.classNames].join(" ").trim();
	
	  var fieldProps = {
	    description: _react2.default.createElement(DescriptionField, {
	      id: id + "__description",
	      description: description,
	      formContext: formContext
	    }),
	    rawDescription: description,
	    help: _react2.default.createElement(Help, { help: help }),
	    rawHelp: typeof help === "string" ? help : undefined,
	    errors: _react2.default.createElement(ErrorList, { errors: errors }),
	    rawErrors: errors,
	    id: id,
	    label: label,
	    hidden: hidden,
	    required: required,
	    disabled: disabled,
	    readonly: readonly,
	    displayLabel: displayLabel,
	    classNames: classNames,
	    formContext: formContext,
	    fields: fields,
	    schema: schema,
	    uiSchema: uiSchema
	  };
	
	  return _react2.default.createElement(
	    FieldTemplate,
	    fieldProps,
	    field
	  );
	}
	
	var SchemaField = function (_React$Component) {
	  _inherits(SchemaField, _React$Component);
	
	  function SchemaField() {
	    _classCallCheck(this, SchemaField);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SchemaField.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    // if schemas are equal idSchemas will be equal as well,
	    // so it is not necessary to compare
	    return !(0, _utils.deepEquals)(_extends({}, this.props, { idSchema: undefined }), _extends({}, nextProps, { idSchema: undefined }));
	  };
	
	  SchemaField.prototype.render = function render() {
	    return SchemaFieldRender(this.props);
	  };
	
	  return SchemaField;
	}(_react2.default.Component);
	
	SchemaField.defaultProps = {
	  uiSchema: {},
	  errorSchema: {},
	  idSchema: {},
	  disabled: false,
	  readonly: false,
	  autofocus: false
	};
	
	if (false) {}
	
	exports.default = SchemaField;
	module.exports = exports["default"];

/***/ },

/***/ "pjji":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__("X7Bk");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function StringField(props) {
	  var schema = props.schema,
	      name = props.name,
	      uiSchema = props.uiSchema,
	      idSchema = props.idSchema,
	      formData = props.formData,
	      required = props.required,
	      disabled = props.disabled,
	      readonly = props.readonly,
	      autofocus = props.autofocus,
	      onChange = props.onChange,
	      onBlur = props.onBlur,
	      onFocus = props.onFocus,
	      _props$registry = props.registry,
	      registry = _props$registry === undefined ? (0, _utils.getDefaultRegistry)() : _props$registry;
	  var title = schema.title,
	      format = schema.format;
	  var widgets = registry.widgets,
	      formContext = registry.formContext;
	
	  var enumOptions = (0, _utils.isSelect)(schema) && (0, _utils.optionsList)(schema);
	  var defaultWidget = format || (enumOptions ? "select" : "text");
	
	  var _getUiOptions = (0, _utils.getUiOptions)(uiSchema),
	      _getUiOptions$widget = _getUiOptions.widget,
	      widget = _getUiOptions$widget === undefined ? defaultWidget : _getUiOptions$widget,
	      _getUiOptions$placeho = _getUiOptions.placeholder,
	      placeholder = _getUiOptions$placeho === undefined ? "" : _getUiOptions$placeho,
	      options = _objectWithoutProperties(_getUiOptions, ["widget", "placeholder"]);
	
	  var Widget = (0, _utils.getWidget)(schema, widget, widgets);
	
	  return _react2.default.createElement(Widget, {
	    options: _extends({}, options, { enumOptions: enumOptions }),
	    schema: schema,
	    id: idSchema && idSchema.$id,
	    label: title === undefined ? name : title,
	    value: formData,
	    onChange: onChange,
	    onBlur: onBlur,
	    onFocus: onFocus,
	    required: required,
	    disabled: disabled,
	    readonly: readonly,
	    formContext: formContext,
	    autofocus: autofocus,
	    registry: registry,
	    placeholder: placeholder
	  });
	}
	
	if (false) {}
	
	StringField.defaultProps = {
	  uiSchema: {},
	  disabled: false,
	  readonly: false,
	  autofocus: false
	};
	
	exports.default = StringField;
	module.exports = exports["default"];

/***/ },

/***/ "17AZ":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REQUIRED_FIELD_SYMBOL = "*";
	
	function TitleField(props) {
	  var id = props.id,
	      title = props.title,
	      required = props.required;
	
	  var legend = required ? title + REQUIRED_FIELD_SYMBOL : title;
	  return _react2.default.createElement(
	    "legend",
	    { id: id },
	    legend
	  );
	}
	
	if (false) {}
	
	exports.default = TitleField;
	module.exports = exports["default"];

/***/ },

/***/ "k4i4":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _AltDateWidget = __webpack_require__("JjHN");
	
	var _AltDateWidget2 = _interopRequireDefault(_AltDateWidget);
	
	var _AltDateTimeWidget = __webpack_require__("FWO3");
	
	var _AltDateTimeWidget2 = _interopRequireDefault(_AltDateTimeWidget);
	
	var _BaseInput = __webpack_require__("SdZ3");
	
	var _BaseInput2 = _interopRequireDefault(_BaseInput);
	
	var _CheckboxWidget = __webpack_require__("kHgs");
	
	var _CheckboxWidget2 = _interopRequireDefault(_CheckboxWidget);
	
	var _CheckboxesWidget = __webpack_require__("tuKe");
	
	var _CheckboxesWidget2 = _interopRequireDefault(_CheckboxesWidget);
	
	var _ColorWidget = __webpack_require__("i+Ty");
	
	var _ColorWidget2 = _interopRequireDefault(_ColorWidget);
	
	var _DateWidget = __webpack_require__("0KHa");
	
	var _DateWidget2 = _interopRequireDefault(_DateWidget);
	
	var _DateTimeWidget = __webpack_require__("r4bn");
	
	var _DateTimeWidget2 = _interopRequireDefault(_DateTimeWidget);
	
	var _EmailWidget = __webpack_require__("nI+v");
	
	var _EmailWidget2 = _interopRequireDefault(_EmailWidget);
	
	var _FileWidget = __webpack_require__("dVmF");
	
	var _FileWidget2 = _interopRequireDefault(_FileWidget);
	
	var _HiddenWidget = __webpack_require__("vs1G");
	
	var _HiddenWidget2 = _interopRequireDefault(_HiddenWidget);
	
	var _PasswordWidget = __webpack_require__("1CWm");
	
	var _PasswordWidget2 = _interopRequireDefault(_PasswordWidget);
	
	var _RadioWidget = __webpack_require__("Nk6G");
	
	var _RadioWidget2 = _interopRequireDefault(_RadioWidget);
	
	var _RangeWidget = __webpack_require__("FUh+");
	
	var _RangeWidget2 = _interopRequireDefault(_RangeWidget);
	
	var _SelectWidget = __webpack_require__("2hmF");
	
	var _SelectWidget2 = _interopRequireDefault(_SelectWidget);
	
	var _TextareaWidget = __webpack_require__("fMDb");
	
	var _TextareaWidget2 = _interopRequireDefault(_TextareaWidget);
	
	var _TextWidget = __webpack_require__("pk+L");
	
	var _TextWidget2 = _interopRequireDefault(_TextWidget);
	
	var _URLWidget = __webpack_require__("jwrs");
	
	var _URLWidget2 = _interopRequireDefault(_URLWidget);
	
	var _UpDownWidget = __webpack_require__("C8K6");
	
	var _UpDownWidget2 = _interopRequireDefault(_UpDownWidget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  BaseInput: _BaseInput2.default,
	  PasswordWidget: _PasswordWidget2.default,
	  RadioWidget: _RadioWidget2.default,
	  UpDownWidget: _UpDownWidget2.default,
	  RangeWidget: _RangeWidget2.default,
	  SelectWidget: _SelectWidget2.default,
	  TextWidget: _TextWidget2.default,
	  DateWidget: _DateWidget2.default,
	  DateTimeWidget: _DateTimeWidget2.default,
	  AltDateWidget: _AltDateWidget2.default,
	  AltDateTimeWidget: _AltDateTimeWidget2.default,
	  EmailWidget: _EmailWidget2.default,
	  URLWidget: _URLWidget2.default,
	  TextareaWidget: _TextareaWidget2.default,
	  HiddenWidget: _HiddenWidget2.default,
	  ColorWidget: _ColorWidget2.default,
	  FileWidget: _FileWidget2.default,
	  CheckboxWidget: _CheckboxWidget2.default,
	  CheckboxesWidget: _CheckboxesWidget2.default
	};
	module.exports = exports["default"];

/***/ },

/***/ "JjHN":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__("X7Bk");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function rangeOptions(start, stop) {
	  var options = [];
	  for (var i = start; i <= stop; i++) {
	    options.push({ value: i, label: (0, _utils.pad)(i, 2) });
	  }
	  return options;
	}
	
	function readyForChange(state) {
	  return Object.keys(state).every(function (key) {
	    return state[key] !== -1;
	  });
	}
	
	function DateElement(props) {
	  var type = props.type,
	      range = props.range,
	      value = props.value,
	      select = props.select,
	      rootId = props.rootId,
	      disabled = props.disabled,
	      readonly = props.readonly,
	      autofocus = props.autofocus,
	      registry = props.registry,
	      onBlur = props.onBlur;
	
	  var id = rootId + "_" + type;
	  var SelectWidget = registry.widgets.SelectWidget;
	
	  return _react2.default.createElement(SelectWidget, {
	    schema: { type: "integer" },
	    id: id,
	    className: "form-control",
	    options: { enumOptions: rangeOptions(range[0], range[1]) },
	    placeholder: type,
	    value: value,
	    disabled: disabled,
	    readonly: readonly,
	    autofocus: autofocus,
	    onChange: function onChange(value) {
	      return select(type, value);
	    },
	    onBlur: onBlur
	  });
	}
	
	var AltDateWidget = (_temp = _class = function (_Component) {
	  _inherits(AltDateWidget, _Component);
	
	  function AltDateWidget(props) {
	    _classCallCheck(this, AltDateWidget);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.onChange = function (property, value) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _this$setState[property] = typeof value === "undefined" ? -1 : value, _this$setState), function () {
	        // Only propagate to parent state if we have a complete date{time}
	        if (readyForChange(_this.state)) {
	          _this.props.onChange((0, _utils.toDateString)(_this.state, _this.props.time));
	        }
	      });
	    };
	
	    _this.setNow = function (event) {
	      event.preventDefault();
	      var _this$props = _this.props,
	          time = _this$props.time,
	          disabled = _this$props.disabled,
	          readonly = _this$props.readonly,
	          onChange = _this$props.onChange;
	
	      if (disabled || readonly) {
	        return;
	      }
	      var nowDateObj = (0, _utils.parseDateString)(new Date().toJSON(), time);
	      _this.setState(nowDateObj, function () {
	        return onChange((0, _utils.toDateString)(_this.state, time));
	      });
	    };
	
	    _this.clear = function (event) {
	      event.preventDefault();
	      var _this$props2 = _this.props,
	          time = _this$props2.time,
	          disabled = _this$props2.disabled,
	          readonly = _this$props2.readonly,
	          onChange = _this$props2.onChange;
	
	      if (disabled || readonly) {
	        return;
	      }
	      _this.setState((0, _utils.parseDateString)("", time), function () {
	        return onChange(undefined);
	      });
	    };
	
	    _this.state = (0, _utils.parseDateString)(props.value, props.time);
	    return _this;
	  }
	
	  AltDateWidget.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.setState((0, _utils.parseDateString)(nextProps.value, nextProps.time));
	  };
	
	  AltDateWidget.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    return (0, _utils.shouldRender)(this, nextProps, nextState);
	  };
	
	  AltDateWidget.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        id = _props.id,
	        disabled = _props.disabled,
	        readonly = _props.readonly,
	        autofocus = _props.autofocus,
	        registry = _props.registry,
	        onBlur = _props.onBlur;
	
	    return _react2.default.createElement(
	      "ul",
	      { className: "list-inline" },
	      this.dateElementProps.map(function (elemProps, i) {
	        return _react2.default.createElement(
	          "li",
	          { key: i },
	          _react2.default.createElement(DateElement, _extends({
	            rootId: id,
	            select: _this2.onChange
	          }, elemProps, {
	            disabled: disabled,
	            readonly: readonly,
	            registry: registry,
	            onBlur: onBlur,
	            autofocus: autofocus && i === 0
	          }))
	        );
	      }),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: "#", className: "btn btn-info btn-now", onClick: this.setNow },
	          "Now"
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          {
	            href: "#",
	            className: "btn btn-warning btn-clear",
	            onClick: this.clear },
	          "Clear"
	        )
	      )
	    );
	  };
	
	  _createClass(AltDateWidget, [{
	    key: "dateElementProps",
	    get: function get() {
	      var time = this.props.time;
	      var _state = this.state,
	          year = _state.year,
	          month = _state.month,
	          day = _state.day,
	          hour = _state.hour,
	          minute = _state.minute,
	          second = _state.second;
	
	      var data = [{ type: "year", range: [1900, 2020], value: year }, { type: "month", range: [1, 12], value: month }, { type: "day", range: [1, 31], value: day }];
	      if (time) {
	        data.push({ type: "hour", range: [0, 23], value: hour }, { type: "minute", range: [0, 59], value: minute }, { type: "second", range: [0, 59], value: second });
	      }
	      return data;
	    }
	  }]);
	
	  return AltDateWidget;
	}(_react.Component), _class.defaultProps = {
	  time: false,
	  disabled: false,
	  readonly: false,
	  autofocus: false
	}, _temp);
	
	
	if (false) {}
	
	exports.default = AltDateWidget;
	module.exports = exports["default"];

/***/ },

/***/ "FWO3":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AltDateTimeWidget(props) {
	  var AltDateWidget = props.registry.widgets.AltDateWidget;
	
	  return _react2.default.createElement(AltDateWidget, _extends({ time: true }, props));
	}
	
	if (false) {}
	
	exports.default = AltDateTimeWidget;
	module.exports = exports["default"];

/***/ },

/***/ "SdZ3":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function BaseInput(props) {
	  // Note: since React 15.2.0 we can't forward unknown element attributes, so we
	  // exclude the "options" and "schema" ones here.
	  var value = props.value,
	      readonly = props.readonly,
	      disabled = props.disabled,
	      autofocus = props.autofocus,
	      onBlur = props.onBlur,
	      onFocus = props.onFocus,
	      options = props.options,
	      schema = props.schema,
	      formContext = props.formContext,
	      registry = props.registry,
	      inputProps = _objectWithoutProperties(props, ["value", "readonly", "disabled", "autofocus", "onBlur", "onFocus", "options", "schema", "formContext", "registry"]);
	
	  inputProps.type = options.inputType || inputProps.type || "text";
	  var _onChange = function _onChange(_ref) {
	    var value = _ref.target.value;
	
	    return props.onChange(value === "" ? options.emptyValue : value);
	  };
	  return _react2.default.createElement("input", _extends({
	    className: "form-control",
	    readOnly: readonly,
	    disabled: disabled,
	    autoFocus: autofocus,
	    value: value == null ? "" : value
	  }, inputProps, {
	    onChange: _onChange,
	    onBlur: onBlur && function (event) {
	      return onBlur(inputProps.id, event.target.value);
	    },
	    onFocus: onFocus && function (event) {
	      return onFocus(inputProps.id, event.target.value);
	    }
	  }));
	}
	
	BaseInput.defaultProps = {
	  type: "text",
	  required: false,
	  disabled: false,
	  readonly: false,
	  autofocus: false
	};
	
	if (false) {}
	
	exports.default = BaseInput;
	module.exports = exports["default"];

/***/ },

/***/ "kHgs":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DescriptionField = __webpack_require__("nqH9");
	
	var _DescriptionField2 = _interopRequireDefault(_DescriptionField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CheckboxWidget(props) {
	  var schema = props.schema,
	      id = props.id,
	      value = props.value,
	      required = props.required,
	      disabled = props.disabled,
	      readonly = props.readonly,
	      label = props.label,
	      autofocus = props.autofocus,
	      _onChange = props.onChange;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "checkbox " + (disabled || readonly ? "disabled" : "") },
	    schema.description && _react2.default.createElement(_DescriptionField2.default, { description: schema.description }),
	    _react2.default.createElement(
	      "label",
	      { className: "control" },
	      _react2.default.createElement("input", {
	        type: "checkbox",
	        id: id,
	        checked: typeof value === "undefined" ? false : value,
	        required: required,
	        disabled: disabled || readonly,
	        autoFocus: autofocus,
	        onChange: function onChange(event) {
	          return _onChange(event.target.checked);
	        }
	      }),
	      _react2.default.createElement("span", { className: "checkmark" }),
	      _react2.default.createElement(
	        "span",
	        null,
	        label
	      )
	    )
	  );
	}
	
	CheckboxWidget.defaultProps = {
	  autofocus: false
	};
	
	if (false) {}
	
	exports.default = CheckboxWidget;
	module.exports = exports["default"];

/***/ },

/***/ "tuKe":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function selectValue(value, selected, all) {
	  var at = all.indexOf(value);
	  var updated = selected.slice(0, at).concat(value, selected.slice(at));
	  // As inserting values at predefined index positions doesn't work with empty
	  // arrays, we need to reorder the updated selection to match the initial order
	  return updated.sort(function (a, b) {
	    return all.indexOf(a) > all.indexOf(b);
	  });
	}
	
	function deselectValue(value, selected) {
	  return selected.filter(function (v) {
	    return v !== value;
	  });
	}
	
	function CheckboxesWidget(props) {
	  var id = props.id,
	      disabled = props.disabled,
	      options = props.options,
	      value = props.value,
	      autofocus = props.autofocus,
	      readonly = props.readonly,
	      _onChange = props.onChange;
	  var enumOptions = options.enumOptions,
	      inline = options.inline;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "checkboxes", id: id },
	    enumOptions.map(function (option, index) {
	      var checked = value.indexOf(option.value) !== -1;
	      var disabledCls = disabled || readonly ? "disabled" : "";
	      var checkbox = _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement("input", {
	          type: "checkbox",
	          id: id + "_" + index,
	          checked: checked,
	          disabled: disabled || readonly,
	          autoFocus: autofocus && index === 0,
	          onChange: function onChange(event) {
	            var all = enumOptions.map(function (_ref) {
	              var value = _ref.value;
	              return value;
	            });
	            if (event.target.checked) {
	              _onChange(selectValue(option.value, value, all));
	            } else {
	              _onChange(deselectValue(option.value, value));
	            }
	          }
	        }),
	        _react2.default.createElement(
	          "span",
	          null,
	          option.label
	        )
	      );
	      return inline ? _react2.default.createElement(
	        "label",
	        { key: index, className: "checkbox-inline " + disabledCls },
	        checkbox
	      ) : _react2.default.createElement(
	        "div",
	        { key: index, className: "checkbox " + disabledCls },
	        _react2.default.createElement(
	          "label",
	          null,
	          checkbox
	        )
	      );
	    })
	  );
	}
	
	CheckboxesWidget.defaultProps = {
	  autofocus: false,
	  options: {
	    inline: false
	  }
	};
	
	if (false) {}
	
	exports.default = CheckboxesWidget;
	module.exports = exports["default"];

/***/ },

/***/ "i+Ty":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ColorWidget(props) {
	  var disabled = props.disabled,
	      readonly = props.readonly,
	      BaseInput = props.registry.widgets.BaseInput;
	
	  return _react2.default.createElement(BaseInput, _extends({ type: "color" }, props, { disabled: disabled || readonly }));
	}
	
	if (false) {}
	
	exports.default = ColorWidget;
	module.exports = exports["default"];

/***/ },

/***/ "0KHa":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DateWidget(props) {
	  var _onChange = props.onChange,
	      BaseInput = props.registry.widgets.BaseInput;
	
	  return _react2.default.createElement(BaseInput, _extends({
	    type: "date"
	  }, props, {
	    onChange: function onChange(value) {
	      return _onChange(value || undefined);
	    }
	  }));
	}
	
	if (false) {}
	
	exports.default = DateWidget;
	module.exports = exports["default"];

/***/ },

/***/ "r4bn":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.utcToLocal = utcToLocal;
	exports.localToUTC = localToUTC;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__("X7Bk");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function utcToLocal(jsonDate) {
	  if (!jsonDate) {
	    return "";
	  }
	
	  // required format of `"yyyy-MM-ddThh:mm" followed by optional ":ss" or ":ss.SSS"
	  // https://html.spec.whatwg.org/multipage/input.html#local-date-and-time-state-(type%3Ddatetime-local)
	  // > should be a _valid local date and time string_ (not GMT)
	
	  // Note - date constructor passed local ISO-8601 does not correctly
	  // change time to UTC in node pre-8
	  var date = new Date(jsonDate);
	
	  var yyyy = (0, _utils.pad)(date.getFullYear(), 4);
	  var MM = (0, _utils.pad)(date.getMonth() + 1, 2);
	  var dd = (0, _utils.pad)(date.getDate(), 2);
	  var hh = (0, _utils.pad)(date.getHours(), 2);
	  var mm = (0, _utils.pad)(date.getMinutes(), 2);
	  var ss = (0, _utils.pad)(date.getSeconds(), 2);
	  var SSS = (0, _utils.pad)(date.getMilliseconds(), 3);
	
	  return yyyy + "-" + MM + "-" + dd + "T" + hh + ":" + mm + ":" + ss + "." + SSS;
	}
	
	function localToUTC(dateString) {
	  if (dateString) {
	    return new Date(dateString).toJSON();
	  }
	}
	
	function DateTimeWidget(props) {
	  var value = props.value,
	      _onChange = props.onChange,
	      BaseInput = props.registry.widgets.BaseInput;
	
	  return _react2.default.createElement(BaseInput, _extends({
	    type: "datetime-local"
	  }, props, {
	    value: utcToLocal(value),
	    onChange: function onChange(value) {
	      return _onChange(localToUTC(value));
	    }
	  }));
	}
	
	if (false) {}
	
	exports.default = DateTimeWidget;

/***/ },

/***/ "nI+v":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmailWidget(props) {
	  var BaseInput = props.registry.widgets.BaseInput;
	
	  return _react2.default.createElement(BaseInput, _extends({ type: "email" }, props));
	}
	
	if (false) {}
	
	exports.default = EmailWidget;
	module.exports = exports["default"];

/***/ },

/***/ "dVmF":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__("X7Bk");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function addNameToDataURL(dataURL, name) {
	  return dataURL.replace(";base64", ";name=" + name + ";base64");
	}
	
	function processFile(file) {
	  var name = file.name,
	      size = file.size,
	      type = file.type;
	
	  return new Promise(function (resolve, reject) {
	    var reader = new window.FileReader();
	    reader.onload = function (event) {
	      resolve({
	        dataURL: addNameToDataURL(event.target.result, name),
	        name: name,
	        size: size,
	        type: type
	      });
	    };
	    reader.readAsDataURL(file);
	  });
	}
	
	function processFiles(files) {
	  return Promise.all([].map.call(files, processFile));
	}
	
	function FilesInfo(props) {
	  var filesInfo = props.filesInfo;
	
	  if (filesInfo.length === 0) {
	    return null;
	  }
	  return _react2.default.createElement(
	    "ul",
	    { className: "file-info" },
	    filesInfo.map(function (fileInfo, key) {
	      var name = fileInfo.name,
	          size = fileInfo.size,
	          type = fileInfo.type;
	
	      return _react2.default.createElement(
	        "li",
	        { key: key },
	        _react2.default.createElement(
	          "strong",
	          null,
	          name
	        ),
	        " (",
	        type,
	        ", ",
	        size,
	        " bytes)"
	      );
	    })
	  );
	}
	
	function extractFileInfo(dataURLs) {
	  return dataURLs.filter(function (dataURL) {
	    return typeof dataURL !== "undefined";
	  }).map(function (dataURL) {
	    var _dataURItoBlob = (0, _utils.dataURItoBlob)(dataURL),
	        blob = _dataURItoBlob.blob,
	        name = _dataURItoBlob.name;
	
	    return {
	      name: name,
	      size: blob.size,
	      type: blob.type
	    };
	  });
	}
	
	var FileWidget = function (_Component) {
	  _inherits(FileWidget, _Component);
	
	  function FileWidget(props) {
	    _classCallCheck(this, FileWidget);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.defaultProps = {
	      multiple: false
	    };
	
	    _this.onChange = function (event) {
	      var _this$props = _this.props,
	          multiple = _this$props.multiple,
	          onChange = _this$props.onChange;
	
	      processFiles(event.target.files).then(function (filesInfo) {
	        var state = {
	          values: filesInfo.map(function (fileInfo) {
	            return fileInfo.dataURL;
	          }),
	          filesInfo: filesInfo
	        };
	        (0, _utils.setState)(_this, state, function () {
	          if (multiple) {
	            onChange(state.values);
	          } else {
	            onChange(state.values[0]);
	          }
	        });
	      });
	    };
	
	    var value = props.value;
	
	    var values = Array.isArray(value) ? value : [value];
	    _this.state = { values: values, filesInfo: extractFileInfo(values) };
	    return _this;
	  }
	
	  FileWidget.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    return (0, _utils.shouldRender)(this, nextProps, nextState);
	  };
	
	  FileWidget.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        multiple = _props.multiple,
	        id = _props.id,
	        readonly = _props.readonly,
	        disabled = _props.disabled,
	        autofocus = _props.autofocus;
	    var filesInfo = this.state.filesInfo;
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement("input", {
	          ref: function ref(_ref) {
	            return _this2.inputRef = _ref;
	          },
	          id: id,
	          type: "file",
	          disabled: readonly || disabled,
	          onChange: this.onChange,
	          defaultValue: "",
	          autoFocus: autofocus,
	          multiple: multiple
	        })
	      ),
	      _react2.default.createElement(FilesInfo, { filesInfo: filesInfo })
	    );
	  };
	
	  return FileWidget;
	}(_react.Component);
	
	FileWidget.defaultProps = {
	  autofocus: false
	};
	
	if (false) {}
	
	exports.default = FileWidget;
	module.exports = exports["default"];

/***/ },

/***/ "vs1G":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HiddenWidget(_ref) {
	  var id = _ref.id,
	      value = _ref.value;
	
	  return _react2.default.createElement("input", {
	    type: "hidden",
	    id: id,
	    value: typeof value === "undefined" ? "" : value
	  });
	}
	
	if (false) {}
	
	exports.default = HiddenWidget;
	module.exports = exports["default"];

/***/ },

/***/ "1CWm":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PasswordWidget(props) {
	  var BaseInput = props.registry.widgets.BaseInput;
	
	  return _react2.default.createElement(BaseInput, _extends({ type: "password" }, props));
	}
	
	if (false) {}
	
	exports.default = PasswordWidget;
	module.exports = exports["default"];

/***/ },

/***/ "Nk6G":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RadioWidget(props) {
	  var options = props.options,
	      value = props.value,
	      required = props.required,
	      disabled = props.disabled,
	      readonly = props.readonly,
	      autofocus = props.autofocus,
	      _onChange = props.onChange;
	  // Generating a unique field name to identify this set of radio buttons
	
	  var name = Math.random().toString();
	  var enumOptions = options.enumOptions,
	      inline = options.inline;
	  // checked={checked} has been moved above name={name}, As mentioned in #349;
	  // this is a temporary fix for radio button rendering bug in React, facebook/react#7630.
	
	  return _react2.default.createElement(
	    "div",
	    { className: "field-radio-group" },
	    enumOptions.map(function (option, i) {
	      var checked = option.value === value;
	      var disabledCls = disabled || readonly ? "disabled" : "";
	      var radio = _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement("input", {
	          type: "radio",
	          checked: checked,
	          name: name,
	          required: required,
	          value: option.value,
	          disabled: disabled || readonly,
	          autoFocus: autofocus && i === 0,
	          onChange: function onChange(_) {
	            return _onChange(option.value);
	          }
	        }),
	        _react2.default.createElement(
	          "span",
	          null,
	          option.label
	        )
	      );
	
	      return inline ? _react2.default.createElement(
	        "label",
	        { key: i, className: "radio-inline " + disabledCls },
	        radio
	      ) : _react2.default.createElement(
	        "div",
	        { key: i, className: "radio " + disabledCls },
	        _react2.default.createElement(
	          "label",
	          null,
	          radio
	        )
	      );
	    })
	  );
	}
	
	RadioWidget.defaultProps = {
	  autofocus: false
	};
	
	if (false) {}
	exports.default = RadioWidget;
	module.exports = exports["default"];

/***/ },

/***/ "FUh+":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__("X7Bk");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RangeWidget(props) {
	  var schema = props.schema,
	      value = props.value,
	      BaseInput = props.registry.widgets.BaseInput;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "field-range-wrapper" },
	    _react2.default.createElement(BaseInput, _extends({ type: "range" }, props, (0, _utils.rangeSpec)(schema))),
	    _react2.default.createElement(
	      "span",
	      { className: "range-view" },
	      value
	    )
	  );
	}
	
	if (false) {}
	
	exports.default = RangeWidget;
	module.exports = exports["default"];

/***/ },

/***/ "2hmF":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__("X7Bk");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This is a silly limitation in the DOM where option change event values are
	 * always retrieved as strings.
	 */
	function processValue(_ref, value) {
	  var type = _ref.type,
	      items = _ref.items;
	
	  if (value === "") {
	    return undefined;
	  } else if (type === "array" && items && ["number", "integer"].includes(items.type)) {
	    return value.map(_utils.asNumber);
	  } else if (type === "boolean") {
	    return value === "true";
	  } else if (type === "number") {
	    return (0, _utils.asNumber)(value);
	  }
	  return value;
	}
	
	function getValue(event, multiple) {
	  if (multiple) {
	    return [].slice.call(event.target.options).filter(function (o) {
	      return o.selected;
	    }).map(function (o) {
	      return o.value;
	    });
	  } else {
	    return event.target.value;
	  }
	}
	
	function SelectWidget(props) {
	  var schema = props.schema,
	      id = props.id,
	      options = props.options,
	      value = props.value,
	      required = props.required,
	      disabled = props.disabled,
	      readonly = props.readonly,
	      multiple = props.multiple,
	      autofocus = props.autofocus,
	      _onChange = props.onChange,
	      onBlur = props.onBlur,
	      onFocus = props.onFocus,
	      placeholder = props.placeholder;
	  var enumOptions = options.enumOptions,
	      enumDisabled = options.enumDisabled;
	
	  var emptyValue = multiple ? [] : "";
	  return _react2.default.createElement(
	    "select",
	    {
	      id: id,
	      multiple: multiple,
	      className: "form-control",
	      value: typeof value === "undefined" ? emptyValue : value,
	      required: required,
	      disabled: disabled || readonly,
	      autoFocus: autofocus,
	      onBlur: onBlur && function (event) {
	        var newValue = getValue(event, multiple);
	        onBlur(id, processValue(schema, newValue));
	      },
	      onFocus: onFocus && function (event) {
	        var newValue = getValue(event, multiple);
	        onFocus(id, processValue(schema, newValue));
	      },
	      onChange: function onChange(event) {
	        var newValue = getValue(event, multiple);
	        _onChange(processValue(schema, newValue));
	      } },
	    !multiple && !schema.default && _react2.default.createElement(
	      "option",
	      { value: "" },
	      placeholder
	    ),
	    enumOptions.map(function (_ref2, i) {
	      var value = _ref2.value,
	          label = _ref2.label;
	
	      var disabled = enumDisabled && enumDisabled.indexOf(value) != -1;
	      return _react2.default.createElement(
	        "option",
	        { key: i, value: value, disabled: disabled },
	        label
	      );
	    })
	  );
	}
	
	SelectWidget.defaultProps = {
	  autofocus: false
	};
	
	if (false) {}
	
	exports.default = SelectWidget;
	module.exports = exports["default"];

/***/ },

/***/ "fMDb":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TextareaWidget(props) {
	  var id = props.id,
	      options = props.options,
	      placeholder = props.placeholder,
	      value = props.value,
	      required = props.required,
	      disabled = props.disabled,
	      readonly = props.readonly,
	      autofocus = props.autofocus,
	      onChange = props.onChange,
	      onBlur = props.onBlur,
	      onFocus = props.onFocus;
	
	  var _onChange = function _onChange(_ref) {
	    var value = _ref.target.value;
	
	    return onChange(value === "" ? options.emptyValue : value);
	  };
	  return _react2.default.createElement("textarea", {
	    id: id,
	    className: "form-control",
	    value: typeof value === "undefined" ? "" : value,
	    placeholder: placeholder,
	    required: required,
	    disabled: disabled,
	    readOnly: readonly,
	    autoFocus: autofocus,
	    rows: options.rows,
	    onBlur: onBlur && function (event) {
	      return onBlur(id, event.target.value);
	    },
	    onFocus: onFocus && function (event) {
	      return onFocus(id, event.target.value);
	    },
	    onChange: _onChange
	  });
	}
	
	TextareaWidget.defaultProps = {
	  autofocus: false,
	  options: {}
	};
	
	if (false) {}
	
	exports.default = TextareaWidget;
	module.exports = exports["default"];

/***/ },

/***/ "pk+L":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TextWidget(props) {
	  var BaseInput = props.registry.widgets.BaseInput;
	
	  return _react2.default.createElement(BaseInput, props);
	}
	
	if (false) {}
	
	exports.default = TextWidget;
	module.exports = exports["default"];

/***/ },

/***/ "jwrs":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function URLWidget(props) {
	  var BaseInput = props.registry.widgets.BaseInput;
	
	  return _react2.default.createElement(BaseInput, _extends({ type: "url" }, props));
	}
	
	if (false) {}
	
	exports.default = URLWidget;
	module.exports = exports["default"];

/***/ },

/***/ "C8K6":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__("X7Bk");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UpDownWidget(props) {
	  var BaseInput = props.registry.widgets.BaseInput;
	
	  return _react2.default.createElement(BaseInput, _extends({ type: "number" }, props, (0, _utils.rangeSpec)(props.schema)));
	}
	
	if (false) {}
	
	exports.default = UpDownWidget;
	module.exports = exports["default"];

/***/ },

/***/ "0D4V":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("OLUV");
	
	var _Transition = __webpack_require__("X/qO");
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _PanelWrapper = __webpack_require__("VPji");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Loading 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var DEFAULT_DELAY = 500;
	
	var DEFAULT_TYPE = 'ring';
	
	var Loading = function (_React$Component) {
	  _inherits(Loading, _React$Component);
	
	  function Loading(props) {
	    _classCallCheck(this, Loading);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    __addPrimary('Loading', 'FWEQ34', __webpack_require__("Hv6Q"));
	
	    _this.state = {};
	
	    return _this;
	  }
	
	  Loading.prototype.componentDidMount = function componentDidMount() {
	
	    var parentHeight = this.elem.parentNode.parentNode.clientHeight;
	
	    if (parentHeight) {
	      this.setState({
	        height: parentHeight
	      });
	    }
	  };
	
	  Loading.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        onPanel = _props.onPanel,
	        useCurtain = _props.useCurtain,
	        _props$curtainStyle = _props.curtainStyle,
	        curtainStyle = _props$curtainStyle === undefined ? {} : _props$curtainStyle,
	        _props$type = _props.type,
	        type = _props$type === undefined ? DEFAULT_TYPE : _props$type,
	        _props$zoom = _props.zoom,
	        zoom = _props$zoom === undefined ? 1 : _props$zoom,
	        title = _props.title;
	    var height = this.state.height;
	
	
	    curtainStyle.height = curtainStyle.height || height;
	
	    var LOGO = void 0;
	
	    if (type == 'logo') {
	      LOGO = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', { src: __webpack_require__("6atW") }),
	        _react2.default.createElement(
	          'h3',
	          null,
	          __('Loading...', 'Loading')
	        )
	      );
	    }
	
	    if (type == 'ring') {
	      LOGO = _react2.default.createElement(
	        'div',
	        { className: 'lds-ring', style: { transform: 'scale(' + zoom + ')' } },
	        _react2.default.createElement('div', null),
	        _react2.default.createElement('div', null),
	        _react2.default.createElement('div', null),
	        _react2.default.createElement('div', null)
	      );
	    }
	
	    if (type == 'facebook') {
	      LOGO = _react2.default.createElement(
	        'div',
	        { className: 'lds-facebook' },
	        _react2.default.createElement('div', null),
	        _react2.default.createElement('div', null),
	        _react2.default.createElement('div', null)
	      );
	    }
	
	    var Loading = _react2.default.createElement(
	      _Transition2.default,
	      { type: 'fade' },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('classtop-loading'), style: { height: height }, ref: function ref(s) {
	            _this2.elem = s;
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'loading-content' },
	          useCurtain && _react2.default.createElement('div', { className: 'loading-curtain', style: curtainStyle }),
	          _react2.default.createElement(
	            'div',
	            { className: 'loading-icon' },
	            LOGO,
	            title && _react2.default.createElement(
	              'h3',
	              null,
	              title
	            )
	          )
	        )
	      )
	    );
	
	    if (onPanel === true) {
	      return _react2.default.createElement(
	        _PanelWrapper.PanelCurtain,
	        null,
	        Loading
	      );
	    } else {
	      return Loading;
	    }
	  };
	
	  return Loading;
	}(_react2.default.Component);
	
	exports.default = Loading;
	module.exports = exports['default'];

/***/ },

/***/ "OLUV":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"classtop-loading":"classtop-loading","loading-curtain":"loading-curtain","loading-content":"loading-content","loading-icon":"loading-icon","lds-ring":"lds-ring","lds-facebook":"lds-facebook"};

/***/ },

/***/ "Hv6Q":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  'Loading...': '加载中...'
	};

/***/ },

/***/ "6atW":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "icon_blue.6e30965f.png";

/***/ },

/***/ "mHav":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"classtop-form":"classtop-form","fetching":"fetching","form-field":"form-field","control-label":"control-label","error-message":"error-message","form-group":"form-group","error-detail":"error-detail","has-error":"has-error","Select-control":"Select-control","Select-menu-outer":"Select-menu-outer","react-select-wrapper":"react-select-wrapper","direction-up":"direction-up","is-open":"is-open","required-symbol":"required-symbol","number-input":"number-input","money":"money","hour":"hour","unit-marker":"unit-marker","Select":"Select","select-extra-info":"select-extra-info","Select-value":"Select-value","react-datepicker-wrapper":"react-datepicker-wrapper","react-datepicker__input-container":"react-datepicker__input-container","react-datepicker":"react-datepicker","react-datepicker__header":"react-datepicker__header","react-datepicker__month":"react-datepicker__month","react-datepicker__day-name":"react-datepicker__day-name","react-datepicker__day":"react-datepicker__day","react-datepicker__current-month":"react-datepicker__current-month","react-datepicker__navigation":"react-datepicker__navigation","react-datepicker__navigation--previous":"react-datepicker__navigation--previous","react-datepicker__navigation--next":"react-datepicker__navigation--next"};

/***/ },

/***/ "NyIJ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ObjectField2 = __webpack_require__("JFvQ");
	
	var _ObjectField3 = _interopRequireDefault(_ObjectField2);
	
	var _utils = __webpack_require__("7Nbh");
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("ltKu");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SectionField = function (_ObjectField) {
	  _inherits(SectionField, _ObjectField);
	
	  function SectionField() {
	    _classCallCheck(this, SectionField);
	
	    return _possibleConstructorReturn(this, _ObjectField.apply(this, arguments));
	  }
	
	  SectionField.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        uiSchema = _props.uiSchema,
	        errorSchema = _props.errorSchema,
	        idSchema = _props.idSchema,
	        required = _props.required,
	        disabled = _props.disabled,
	        readonly = _props.readonly,
	        onBlur = _props.onBlur,
	        formData = _props.formData;
	    var _props$registry = this.props.registry,
	        definitions = _props$registry.definitions,
	        fields = _props$registry.fields,
	        formContext = _props$registry.formContext;
	    var SchemaField = fields.SchemaField,
	        TitleField = fields.TitleField,
	        DescriptionField = fields.DescriptionField;
	
	    var schema = (0, _utils.retrieveSchema)(this.props.schema, definitions);
	    var title = schema.title;
	    var sections = uiSchema['ui:section'];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'react-jsonschema-form-section' },
	      sections.map(function (_ref, idx) {
	        var classNames = _ref.classNames,
	            _ref$items = _ref.items,
	            items = _ref$items === undefined ? [] : _ref$items;
	
	        return _react2.default.createElement(
	          'section',
	          { className: (0, _classnames2.default)(classNames), key: idx },
	          Object.keys(items).map(function (name, fieldIdx) {
	            var item = items[name];
	            if (item.shown !== false) {
	              return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('form-field', item.className, { 'inline-form-field': item.inline == true }), key: fieldIdx },
	                item.beforeContent && _react2.default.createElement(
	                  'div',
	                  { className: 'before-content' },
	                  item.beforeContent
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-field-input' },
	                  _react2.default.createElement(SchemaField, {
	                    key: idx,
	                    name: name,
	                    required: _this2.isRequired(name),
	                    schema: schema.properties[name] || {},
	                    uiSchema: item,
	                    errorSchema: errorSchema[name],
	                    idSchema: idSchema[name],
	                    formData: formData[name],
	                    onChange: _this2.onPropertyChange(name),
	                    onBlur: onBlur,
	                    registry: _this2.props.registry,
	                    disabled: disabled,
	                    readonly: readonly }),
	                  item.afterContent && _react2.default.createElement(
	                    'div',
	                    { className: 'after-content' },
	                    item.afterContent
	                  )
	                )
	              );
	            }
	          })
	        );
	      })
	    );
	  };
	
	  return SectionField;
	}(_ObjectField3.default);
	
	exports.default = SectionField;
	module.exports = exports['default'];

/***/ },

/***/ "ltKu":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-jsonschema-form-section":"react-jsonschema-form-section","inline-form-field":"inline-form-field","form-input":"form-input","form-control":"form-control","error-detail":"error-detail","outline-form-field":"outline-form-field"};

/***/ },

/***/ "BgXg":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	// User can select a student.
	// a wraper of SelectItemModal
	//
	// eg.
	// SelectStudent({ schoolId })
	//  .then()
	//  .catch()
	//
	
	
	exports.default = function (opts) {
	  var schoolId = opts.schoolId,
	      selectMultiple = opts.selectMultiple,
	      _opts$onlyFetchCurren = opts.onlyFetchCurrent,
	      onlyFetchCurrent = _opts$onlyFetchCurren === undefined ? true : _opts$onlyFetchCurren,
	      _opts$itemPerPage = opts.itemPerPage,
	      itemPerPage = _opts$itemPerPage === undefined ? 25 : _opts$itemPerPage;
	
	  // this will return a promise
	
	  return (0, _SelectItem2.default)(_extends({
	    headerTitle: __('Select Student', 'schedule'),
	    headerIcon: 'fa icon-book-reader',
	    itemName: __('Student', 'schedule'),
	    searchPlaceholder: __('Search Student', 'schedule'),
	    selectMultiple: selectMultiple,
	    showName: true,
	
	    backendSearch: true,
	
	    getItemLabel: function getItemLabel(student) {
	      return student.name;
	    },
	    fetchItems: function fetchItems(cb, fetchOpts) {
	      var searchKeyword = fetchOpts.searchKeyword,
	          currentPageNumber = fetchOpts.currentPageNumber;
	
	
	      (0, _getStudentSummary2.default)({
	        schoolId: schoolId,
	        itemPerPage: itemPerPage,
	        searchKeyword: searchKeyword,
	        pageNumber: currentPageNumber,
	        studentState: onlyFetchCurrent ? 'all_not_archived' : 'all'
	      }).then(function (data) {
	        var list = data.list,
	            pageAmount = data.pageAmount;
	
	
	        var pageMeta = {
	          maxPageNumber: pageAmount
	        };
	
	        var studentObjs = list.map(function (studentRaw) {
	          return new _Student2.default(studentRaw);
	        });
	
	        cb(studentObjs, pageMeta);
	      }).catch(function (err) {
	        console.error(err);
	      });
	    },
	    selectFilter: function selectFilter(student, alreadySelected, selected) {
	      return alreadySelected.id == student.id;
	    }
	
	  }, opts));
	};
	
	var _SelectItem = __webpack_require__("k6Ef");
	
	var _SelectItem2 = _interopRequireDefault(_SelectItem);
	
	var _getStudentSummary = __webpack_require__("/y3Y");
	
	var _getStudentSummary2 = _interopRequireDefault(_getStudentSummary);
	
	var _Student = __webpack_require__("PT2B");
	
	var _Student2 = _interopRequireDefault(_Student);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ },

/***/ "k6Ef":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("vC8R");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "vC8R":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	__webpack_require__("xGaz");
	
	var _ModalContent = __webpack_require__("hsiw");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _lodash = __webpack_require__("M4fF");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ALLOW_DESELECT = true;
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._onSelect = _this._onSelect.bind(_this);
	
	    _this.state = {
	      selected: props.selected || []
	    };
	    return _this;
	  }
	
	  ModalBody.prototype._onSelect = function _onSelect(items) {
	    var _props = this.props,
	        selectMultiple = _props.selectMultiple,
	        proceed = _props.proceed,
	        onConfirm = _props.onConfirm;
	    var selected = this.state.selected;
	
	
	    if (!selectMultiple) {
	      // If we don't allow selecting multiple, we remove the items that's already in state.selected and only
	      // pick the one that is not in the state.selected. Here is a bit TRICKY.
	
	      // LOGIC 1. If this.state.selected is empty, we assume the first item if items is the one
	      // we selected.
	      var returnItem = void 0;
	      if (selected.length === 0) {
	        returnItem = items[0];
	      } else {
	        // LOGIC 2.
	        // Because selectList is adding a new select by push(), the newest item will always be the
	        // last one at index of items.length - 1.
	        if (items.length > 1) {
	          returnItem = items[items.length - 1];
	        }
	
	        // LOGIC 3.
	        // If the items has 0 length, it means we chose the "same" item. In this case
	        // it means we're deselecting the item. So if allowDeselect is 'true', we should return
	        // an empty array
	        if (items.length === 0) {
	          returnItem = null;
	        }
	      }
	
	      if (returnItem) {
	        this.setState({
	          selected: [returnItem]
	        }, this.onConfirm);
	      } else {
	        this.setState({
	          selected: []
	        }, this.onConfirm);
	      }
	    } else {
	      // If we allowed selecting multiple items, we just return items in array
	      this.setState({
	        selected: items
	      });
	    }
	  };
	
	  ModalBody.prototype.onConfirm = function onConfirm() {
	    var _props2 = this.props,
	        onConfirm = _props2.onConfirm,
	        proceed = _props2.proceed;
	
	
	    if (typeof onConfirm === 'function') {
	      onConfirm(_extends({}, this.props, { items: this.state.selected }), this);
	    } else {
	      proceed(this.state.selected);
	    }
	  };
	
	  ModalBody.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props3 = this.props,
	        show = _props3.show,
	        proceed = _props3.proceed,
	        dismiss = _props3.dismiss,
	        cancel = _props3.cancel,
	        headerTitle = _props3.headerTitle,
	        headerIcon = _props3.headerIcon,
	        selectMultiple = _props3.selectMultiple,
	        onConfirm = _props3.onConfirm;
	    var selected = this.state.selected;
	
	
	    var hasFooter = selectMultiple;
	    var isSelectedSortbale = selectMultiple;
	
	    var footerButtons = [];
	
	    footerButtons = [{
	      title: __('Confirm ({number})', 'SelectItemModal', { number: selected.length }),
	      className: 'btn btn-primary pull-right',
	      onClick: function onClick() {
	        if (typeof onConfirm == 'function') {
	          onConfirm(_extends({}, _this2.props, { selected: selected }), _this2);
	        } else {
	          proceed(selected);
	        }
	      }
	    }];
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        isShowingModal: show // if you want to show it when component mounts, set it true
	        , className: 'item-select-modal',
	        onCloseModalClick: dismiss,
	        fixedWidth: 500,
	        hasHeader: true,
	        headerType: 'bold' // default, bold
	        , headerTitle: headerTitle,
	        headerIcon: headerIcon // class for icon tag
	
	        , hasFooter: hasFooter,
	        footerButtons: footerButtons
	      },
	      _react2.default.createElement(_ModalContent2.default, _extends({}, this.props, {
	        onSelect: this._onSelect,
	        selected: selected,
	        allowDeselect: ALLOW_DESELECT,
	        isSelectedSortable: isSelectedSortbale }))
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "xGaz":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"item-select-modal":"item-select-modal","classtop-modal-content":"classtop-modal-content","Select-control":"Select-control","select-none":"select-none","searchbar-wrapper":"searchbar-wrapper","Select-placeholder":"Select-placeholder","Select-clear-zone":"Select-clear-zone","label-section":"label-section","sort-btn":"sort-btn","select-list":"select-list","select-item":"select-item","select-button":"select-button","btn-link":"btn-link","currently-selected":"currently-selected","display-name":"display-name"};

/***/ },

/***/ "hsiw":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SearchList = __webpack_require__("B5jL");
	
	var _SearchList2 = _interopRequireDefault(_SearchList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	//
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalContent.prototype.componentWillMount = function componentWillMount() {};
	
	  ModalContent.prototype.render = function render() {
	    var _props = this.props,
	        onSelect = _props.onSelect,
	        showName = _props.showName;
	
	
	    return _react2.default.createElement(_SearchList2.default, _extends({}, this.props, { onSelect: onSelect, showName: showName }));
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "B5jL":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SearchBar = __webpack_require__("EM0x");
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _lodash = __webpack_require__("M4fF");
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _NameCircle = __webpack_require__("Wsaj");
	
	var _NameCircle2 = _interopRequireDefault(_NameCircle);
	
	__webpack_require__("bH5w");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <SearchList />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * TODO: doc needed
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var SELECTED_FIRST = 'SELECTED_FIRST';
	
	var NOT_SELECTED_FIRST = 'NOT_SELECTED_FIRST';
	
	var DEFAULT_SORTABLE = false;
	
	var SEARCH_TIMEOUT = 250;
	
	var MIN_SEARCH_VALUE_LENGTH = 2;
	
	var DefaultSelectItem = function DefaultSelectItem(_ref) {
	  var item = _ref.item,
	      getItemLabel = _ref.getItemLabel,
	      selected = _ref.selected,
	      onClickSelect = _ref.onClickSelect;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'select-item' },
	    _react2.default.createElement(
	      'div',
	      null,
	      typeof getItemLabel == 'function' ? _react2.default.createElement(
	        'h5',
	        null,
	        getItemLabel(item)
	      ) : item.label
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'select-button' },
	      selected && _react2.default.createElement(
	        'span',
	        { className: 'btn-link currently-selected', onClick: onClickSelect },
	        __('Selected', 'SelectItemModal')
	      ),
	      !selected && _react2.default.createElement(
	        'span',
	        { className: 'btn-link', onClick: onClickSelect },
	        __('Select', 'SelectItemModal')
	      )
	    )
	  );
	};
	
	var SearchList = function (_React$Component) {
	  _inherits(SearchList, _React$Component);
	
	  function SearchList(props) {
	    _classCallCheck(this, SearchList);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._loadItemesOntoState = _this._loadItemesOntoState.bind(_this);
	    _this._onSearchSelected = _this._onSearchSelected.bind(_this);
	    _this._getSelectList = _this._getSelectList.bind(_this);
	    _this._onClickSelect = _this._onClickSelect.bind(_this);
	    _this._toggleOrderItem = _this._toggleOrderItem.bind(_this);
	    _this._toggleArray = _this._toggleArray.bind(_this);
	    _this._sortSelected = _this._sortSelected.bind(_this);
	    _this._onSearch = _this._onSearch.bind(_this);
	    _this.onListScroll = _this.onListScroll.bind(_this);
	    _this.state = {
	      selected: props.selected || [],
	      optionsForSearch: [],
	      selectedOption: undefined,
	      itemListOrder: SELECTED_FIRST,
	      itemList: props.itemList,
	      currentPageNumber: 0,
	      searchKeyword: undefined
	    };
	
	    _this.state.itemList = _this._sortSelected(props.itemList) || [];
	    return _this;
	  }
	
	  SearchList.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.selected) {
	      this.setState({
	        selected: nextProps.selected
	      });
	    }
	
	    if (!(0, _lodash.isEqual)(nextProps.itemList, this.props.itemList)) {
	      this.setState({
	        itemList: this._sortSelected(nextProps.itemList)
	      });
	    }
	  };
	
	  SearchList.prototype.componentWillMount = function componentWillMount() {
	    this._loadItemesOntoState();
	  };
	
	  SearchList.prototype._onClickSelect = function _onClickSelect(item) {
	    var _this2 = this;
	
	    var onSelect = this.props.onSelect;
	
	    return function (e) {
	      var selected = _this2.state.selected;
	
	
	      var newSelected = _this2._toggleArray(selected, item);
	
	      _this2.setState({
	        selected: newSelected
	      }, function () {
	        onSelect(newSelected);
	      });
	    };
	  };
	
	  SearchList.prototype._toggleArray = function _toggleArray(selected, item) {
	    var _props = this.props,
	        allowDeselect = _props.allowDeselect,
	        selectFilter = _props.selectFilter;
	
	
	    var filtered = [];
	
	    // STEP 1. filter it out the item
	    filtered = (0, _lodash.filter)(selected, function (alreadySelected, idx) {
	      if (typeof selectFilter == 'function') {
	        return selectFilter(item, alreadySelected, selected) === false;
	      } else {
	        return (0, _lodash.isEqual)(alreadySelected, item) === false;
	      }
	    });
	
	    // STEP 2. if the length is different, which means the item has been removed
	    // we return the removed array
	    if (filtered.length != selected.length) {
	      // if the modal allow deselecting, we return the deselected array
	      // otherwise we return the array as it was
	      if (allowDeselect) {
	        return filtered;
	      } else {
	        return selected;
	      }
	    } else {
	      // If the length of both arrays were the same, it means the item was already in
	      // the array, so we simply push the item into the array and return it.
	      filtered.push(item);
	      return filtered;
	    }
	  };
	
	  SearchList.prototype._loadItemesOntoState = function _loadItemesOntoState() {
	    var _this3 = this;
	
	    var fetchOpts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var refreshItemList = fetchOpts.refreshItemList;
	    var _props2 = this.props,
	        fetchItems = _props2.fetchItems,
	        getItemLabel = _props2.getItemLabel;
	    var _state = this.state,
	        _state$maxPageNumber = _state.maxPageNumber,
	        maxPageNumber = _state$maxPageNumber === undefined ? -1 : _state$maxPageNumber,
	        currentPageNumber = _state.currentPageNumber,
	        searchKeyword = _state.searchKeyword;
	
	
	    if (typeof fetchItems !== 'function') {
	      return;
	    }
	
	    // to prevent infinite loading 
	    if (currentPageNumber > 0 && maxPageNumber == -1) {
	      return;
	    }
	    // ---
	
	    if (maxPageNumber > 0 && currentPageNumber >= maxPageNumber) {
	      return;
	    }
	
	    var newPageNumber = currentPageNumber + 1;
	
	    //
	    // If fetchItem() exists, we start fetching it remotely,
	    // and will indicate that we're fetching.
	    //
	    this.setState({
	      fetching: true,
	      currentPageNumber: newPageNumber
	    });
	
	    fetchItems(function (itemList) {
	      var fetchResult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var maxPageNumber = fetchResult.maxPageNumber;
	
	
	      _this3.savedItemList = itemList;
	
	      var newItemList = void 0;
	
	      if (refreshItemList) {
	        newItemList = [].concat(itemList);
	
	        if (_this3.selectListRef) {
	          _this3.selectListRef.scrollTop = 0;
	        }
	      } else {
	        newItemList = [].concat(_this3.state.itemList, itemList);
	      }
	
	      var optionsForSearch = newItemList.map(function (item, idx) {
	        var label = void 0;
	        if (typeof getItemLabel == 'function') {
	          label = getItemLabel(item);
	        } else {
	          label = item.label;
	        }
	
	        return {
	          id: idx,
	          label: label,
	          value: item
	        };
	      });
	
	      _this3.setState({
	        maxPageNumber: maxPageNumber,
	        itemList: _this3._sortSelected(newItemList),
	        optionsForSearch: optionsForSearch,
	        fetching: false
	      });
	    }, {
	      // Search query: START
	      currentPageNumber: newPageNumber,
	      searchKeyword: searchKeyword
	      // Search query: END
	    });
	  };
	
	  SearchList.prototype._onSearchSelected = function _onSearchSelected(selected) {
	
	    // STEP 1. if selected is empty, which means the select field is clear out.
	    // Then, we update with the itemList saved in this.
	    if (selected === null) {
	      this.setState({
	        selectedOption: undefined,
	        itemList: this.savedItemList
	      });
	      return;
	    }
	
	    // STEP 2. If selected is indeed an list item object, then we recreate
	    // this.state.itemList by filtering out current list.
	    var item = selected.value;
	
	
	    var newItemList = this.savedItemList.filter(function (thisCls) {
	      return (0, _lodash.isEqual)(thisCls, item);
	    });
	
	    this.setState({
	      selectedOption: selected,
	      itemList: newItemList
	    });
	  };
	
	  SearchList.prototype._toggleOrderItem = function _toggleOrderItem() {
	    var _this4 = this;
	
	    var _state2 = this.state,
	        itemListOrder = _state2.itemListOrder,
	        itemList = _state2.itemList;
	
	
	    this.setState({
	      itemListOrder: itemListOrder === SELECTED_FIRST ? NOT_SELECTED_FIRST : SELECTED_FIRST
	    }, function () {
	      _this4.setState({
	        itemList: _this4._sortSelected(itemList)
	      });
	    });
	  };
	
	  SearchList.prototype._sortSelected = function _sortSelected(itemList) {
	    var _this5 = this;
	
	    if (!itemList) {
	      return;
	    }
	
	    var sortSelected = this.props.sortSelected;
	
	
	    if (sortSelected === false) {
	      return itemList;
	    }
	
	    var _state3 = this.state,
	        selected = _state3.selected,
	        itemListOrder = _state3.itemListOrder;
	
	
	    var inSelected = [];
	    var notInSelected = [];
	
	    itemList.map(function (item) {
	      if (_this5._arrayHas(selected, item)) {
	        inSelected.push(item);
	      } else {
	        notInSelected.push(item);
	      }
	    });
	
	    if (itemListOrder == SELECTED_FIRST) {
	      return inSelected.concat(notInSelected);
	    } else {
	      return notInSelected.concat(inSelected);
	    }
	  };
	
	  SearchList.prototype._onSearch = function _onSearch(e) {
	    var _this6 = this;
	
	    var backendSearch = this.props.backendSearch;
	    var _e$target$value = e.target.value,
	        value = _e$target$value === undefined ? '' : _e$target$value;
	
	
	    if (!backendSearch) {
	      return;
	    }
	
	    var searchKeyword = value;
	
	    if (value.length < MIN_SEARCH_VALUE_LENGTH) {
	      searchKeyword = '';
	    }
	
	    if (this.debouncedSearchTimeout) {
	      clearTimeout(this.debouncedSearchTimeout);
	    }
	
	    this.debouncedSearchTimeout = setTimeout(function () {
	      _this6.setState({
	        searchKeyword: searchKeyword,
	        currentPageNumber: 0
	      }, function () {
	        _this6._loadItemesOntoState({
	          refreshItemList: true
	        });
	      });
	    }, SEARCH_TIMEOUT);
	  };
	
	  SearchList.prototype.onListScroll = function onListScroll(e) {
	    var bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
	    if (bottom) {
	      this._loadItemesOntoState();
	    }
	  };
	
	  SearchList.prototype.render = function render() {
	    var _this7 = this;
	
	    var _state4 = this.state,
	        selectedOption = _state4.selectedOption,
	        optionsForSearch = _state4.optionsForSearch,
	        itemListOrder = _state4.itemListOrder,
	        fetching = _state4.fetching;
	    var _props3 = this.props,
	        itemName = _props3.itemName,
	        hideSearchbar = _props3.hideSearchbar,
	        _props3$backendSearch = _props3.backendSearch,
	        backendSearch = _props3$backendSearch === undefined ? false : _props3$backendSearch,
	        searchPlaceholder = _props3.searchPlaceholder,
	        allowDeselect = _props3.allowDeselect,
	        _props3$isSelectedSor = _props3.isSelectedSortable,
	        isSelectedSortable = _props3$isSelectedSor === undefined ? DEFAULT_SORTABLE : _props3$isSelectedSor,
	        selected = _props3.selected,
	        getItemLabel = _props3.getItemLabel,
	        _props3$showName = _props3.showName,
	        showName = _props3$showName === undefined ? false : _props3$showName;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('classtop-search-list', { 'allow-deselect': allowDeselect, 'select-none': typeof selectedOption == 'undefined' }) },
	      fetching && _react2.default.createElement(_Loading2.default, null),
	      hideSearchbar !== true && _react2.default.createElement(
	        'div',
	        { className: 'searchbar-wrapper' },
	        backendSearch !== true && _react2.default.createElement(_SearchBar2.default, { is: true, 'class': 'form-control',
	          selectedOption: selectedOption,
	          options: optionsForSearch,
	          onOptionSelected: this._onSearchSelected,
	          placeholder: searchPlaceholder }),
	        backendSearch == true && _react2.default.createElement('input', {
	          type: 'text',
	          classname: 'form-control',
	          onChange: this._onSearch,
	          placeholder: searchPlaceholder
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'label-section' },
	        itemName && _react2.default.createElement(
	          'label',
	          null,
	          itemName
	        ),
	        isSelectedSortable && _react2.default.createElement('div', { className: 'sort-btn btn-link pull-right', onClick: this._toggleOrderItem }),
	        showName === true && _react2.default.createElement(
	          'div',
	          { className: 'display-name' },
	          selected.map(function (item) {
	            return _react2.default.createElement(_NameCircle2.default, { fullName: typeof getItemLabel == 'function' ? getItemLabel(item) : item.label, showFullName: false });
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'select-list', onScroll: this.onListScroll, ref: function ref(r) {
	            _this7.selectListRef = r;
	          } },
	        this._getSelectList()
	      )
	    );
	  };
	
	  SearchList.prototype._getSelectList = function _getSelectList() {
	    var _this8 = this;
	
	    var _state5 = this.state,
	        itemList = _state5.itemList,
	        itemListOrder = _state5.itemListOrder,
	        selected = _state5.selected;
	    var _props4 = this.props,
	        _props4$components = _props4.components,
	        components = _props4$components === undefined ? {} : _props4$components,
	        SelectItem = _props4.SelectItem,
	        getItemLabel = _props4.getItemLabel,
	        mixin = _props4.mixin;
	
	
	    var ListItem = SelectItem || components.SelectItem || DefaultSelectItem;
	
	    return itemList.map(function (item, idx) {
	      var isSelected = _this8._arrayHas(selected, item);
	
	      return _react2.default.createElement(ListItem, {
	        selected: isSelected,
	        getItemLabel: getItemLabel,
	        item: item,
	        key: idx,
	        onClickSelect: _this8._onClickSelect(item),
	        mixin: mixin
	      });
	    });
	  };
	
	  SearchList.prototype._arrayHas = function _arrayHas(hash, needle) {
	    var selectFilter = this.props.selectFilter;
	
	
	    return typeof (0, _lodash.find)(hash, function (o) {
	      if (typeof selectFilter == 'function') {
	        return selectFilter(needle, o, hash);
	      } else {
	        return (0, _lodash.isEqual)(o, needle);
	      }
	    }) !== 'undefined';
	  };
	
	  return SearchList;
	}(_react2.default.Component);
	
	exports.default = SearchList;
	module.exports = exports['default'];

/***/ },

/***/ "EM0x":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__("tTw2");
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__("RmHk");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @prop selectedOption: (required) an Object of { value: $value, label: $label } for the current selected option. set to null if no option is selected
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @prop options: (required) an Array of { value: $value, label: $label } for rendering and searching
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @prop onOptionSelected(option): (required) a function callback to handle selected option(s)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @prop multi: (optional) a boolean to turn on/off multi selection
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @prop autofocus: (optional) a boolean to turn on/off autofocus on the component upon mounting
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @prop searchable: (optional) a boolean to enable/disable search
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @prop clearable: (optional) a boolean to enable/disable clearing
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @prop placeholder: (optional) a string to show when no option is selected
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var SearchBar = function (_React$Component) {
	  _inherits(SearchBar, _React$Component);
	
	  function SearchBar() {
	    _classCallCheck(this, SearchBar);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SearchBar.prototype.render = function render() {
	    var _props = this.props,
	        selectedOption = _props.selectedOption,
	        options = _props.options,
	        multi = _props.multi,
	        autofocus = _props.autofocus,
	        _props$searchable = _props.searchable,
	        searchable = _props$searchable === undefined ? true : _props$searchable,
	        clearable = _props.clearable,
	        placeholder = _props.placeholder,
	        disabled = _props.disabled;
	
	
	    return _react2.default.createElement(_reactSelect2.default, {
	      menuContainerStyle: { zIndex: 999 },
	      value: selectedOption,
	      options: options,
	      multi: multi ? multi : false,
	      autoFocus: autofocus ? autofocus : false,
	      searchable: searchable,
	      clearable: clearable ? clearable : true,
	      placeholder: placeholder ? placeholder : 'Select ...',
	      onChange: this.props.onOptionSelected,
	      onInputKeyDown: this.props.onInputKeyDown,
	      onInputChange: this.props.onInputChange,
	      disabled: disabled
	    });
	  };
	
	  return SearchBar;
	}(_react2.default.Component);
	
	exports.default = SearchBar;
	module.exports = exports['default'];

/***/ },

/***/ "Wsaj":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTooltip = __webpack_require__("Hh2+");
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _uniqid = __webpack_require__("2bpm");
	
	var _uniqid2 = _interopRequireDefault(_uniqid);
	
	__webpack_require__("K+jN");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * This component takes in 4 parameters (frist name, last name, showfullname, and fullname), only showfullname is required
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * When showfullname is true, full name is needed to display the full name.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Otherwise, it'll show either the first letter of first name, or first letter of last name, or the initial
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * i.e. if firstName='Kevin', it'll show K. lastname='Hart', it'll show H. Pass both first and last name, it'll show KH.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * if showfullname = true and full name = 'Kevin Hart', it'll show KH Kevin Hart.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	var NameCircle = function (_Component) {
	  _inherits(NameCircle, _Component);
	
	  function NameCircle() {
	    _classCallCheck(this, NameCircle);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  NameCircle.prototype.render = function render() {
	    var _props = this.props,
	        firstName = _props.firstName,
	        lastName = _props.lastName,
	        showFullName = _props.showFullName,
	        fullName = _props.fullName,
	        style = _props.style;
	
	
	    var initial = void 0;
	    if (firstName && lastName) {
	      initial = firstName[0].toUpperCase() + lastName[0].toUpperCase();
	    } else if (firstName && !lastName) {
	      initial = firstName[0].toUpperCase();
	    } else if (!firstName && lastName) {
	      initial = lastName[0].toUpperCase();
	    } else if (!firstName && !lastName && fullName) {
	      initial = fullName[0].toUpperCase();
	    }
	
	    var initialColor = 'name-bubble color' + initial[0];
	
	    var id = 'teacher-name-' + (0, _uniqid2.default)();
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'name-circle-container', style: style, 'data-tip': true, 'data-for': id },
	      _react2.default.createElement(
	        'span',
	        { className: initialColor },
	        initial
	      ),
	      showFullName && _react2.default.createElement(
	        'span',
	        { className: 'full-name-text' },
	        fullName
	      ),
	      _react2.default.createElement(_reactTooltip2.default, {
	        id: id,
	        effect: 'solid',
	        place: 'bottom',
	        type: 'info',
	        getContent: function getContent() {
	          return fullName ? fullName : firstName;
	        }
	      })
	    );
	  };
	
	  return NameCircle;
	}(_react.Component);
	
	exports.default = NameCircle;
	module.exports = exports['default'];

/***/ },

/***/ "K+jN":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"name-circle-container":"name-circle-container","name-bubble":"name-bubble","colorA":"colorA","colorB":"colorB","colorC":"colorC","colorD":"colorD","colorE":"colorE","colorF":"colorF","colorG":"colorG","colorH":"colorH","colorI":"colorI","colorJ":"colorJ","colorK":"colorK","colorL":"colorL","colorM":"colorM","colorN":"colorN","colorO":"colorO","colorP":"colorP","colorQ":"colorQ","colorR":"colorR","colorS":"colorS","colorT":"colorT","colorU":"colorU","colorV":"colorV","colorW":"colorW","colorX":"colorX","colorY":"colorY","colorZ":"colorZ"};

/***/ },

/***/ "bH5w":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"classtop-search-list":"classtop-search-list","classtop-modal-content":"classtop-modal-content","Select-control":"Select-control","select-none":"select-none","searchbar-wrapper":"searchbar-wrapper","Select-arrow":"Select-arrow","Select-placeholder":"Select-placeholder","Select-clear-zone":"Select-clear-zone","label-section":"label-section","sort-btn":"sort-btn","select-list":"select-list","select-item":"select-item","select-button":"select-button","btn-link":"btn-link","currently-selected":"currently-selected","Select-clear":"Select-clear"};

/***/ },

/***/ "/y3Y":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = getStudentSummary;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	var _studentStates = __webpack_require__("DWYU");
	
	var _studentStates2 = _interopRequireDefault(_studentStates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// PARAM SCHEMA
	// It is better to use 1 object param than multiple params, because it is hard to remember
	// which param goes where and how many params are needed. If we put all the params in
	// one object, we can solve the first problem and if we use object validation such as "Joi"
	// we can tell other programmers what params the function is looking for. If they didn't put
	// the right value, joy will throw errors and they can change it until it works.
	// This is called "error driven development." Errors will correct our developers until
	// it works!
	//
	// Here, we defined which params are used in this controller function.
	var schema = exports.schema = _joiBrowser2.default.object().keys({
		schoolId: _joiBrowser2.default.number().integer().required(),
		itemPerPage: _joiBrowser2.default.number().integer(),
		pageNumber: _joiBrowser2.default.number().integer(),
		studentState: _joiBrowser2.default.string().valid(_studentStates2.default).required(),
		searchKeyword: _joiBrowser2.default.string().allow('').optional(),
		export: _joiBrowser2.default.number().integer().optional(),
		order_by: _joiBrowser2.default.number().integer().optional()
	});
	
	// MORE VERBOUSE REPRESENTATION
	// The state number is hard to remember. We can make it more verbouse to help
	// our own understanding. Here, I put words in an array. Their array indexes represent
	// their stae number.
	// 0:全部  1:当期  2:未排班  3:在读  4:往期  5:续费
	//
	// STUDENT_STATES = ["all", "current", "not_enrolled", "enrolled", "archived", "pending_renewal"];
	/* eslint-disable indent */
	function getStudentSummary(opts) {
	
		// VALIDATE PARAMS
		// We throw an error if params are not fulfilled.
		var validateResult = _joiBrowser2.default.validate(opts, schema);
	
		if (validateResult.error) {
			return new Promise(function (resolve, reject) {
				reject(validateResult);
			});
		}
	
		// INPUT FACADE
		// We "translate" variable names to something developers can easily understand.
		// For examples, "sState." Is this student state or school state or subscription state?
		// We don't want our developers to guess or visit API documentation to figure this out.
		// We also don't want backend to change this name for us.
		// So instead, we use 'studentState' to accept values from the frontend and change its name to
		// "sState" when sending it back to the backend.
		//
		// Here, we used queryString to translate the object into query string.
		var query = _queryString2.default.stringify({
			pageSize: opts.itemPerPage,
			noPage: opts.pageNumber,
			kw: opts.searchKeyword,
			sState: _studentStates2.default.indexOf(opts.studentState),
			export: opts.export,
			order_by: opts.order_by
		});
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, {
				'uri': '/g_stdtsmr/' + opts.schoolId + '/?' + query,
				'method': 'GET',
				'token': localStorage.getItem('token')
			}).then(function (res) {
				// OUTPUT FACADE
				// When backend sends us data, the controller should filter out unnecessary data
				// and send the only data needed by the frontend. Sometimes we might want to
				// alter and translate the value. Variable names should be clear and make sense
				// in every context.
				//
				// Here, we only needed data in res object.
				resolve(res.data);
			}).catch(function (err) {
	
				reject(err);
			});
		});
	}

/***/ },

/***/ "hxne":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/**
	 *
	 *
	 */
	
	exports.default = {
		calendar: {
			defaultView: "month",
			timeslots: 4
		},
		supportedLanguages: [{
			code: "EN",
			title: "Switch To English"
		},
		//{
		//	code: "FR",
		//	title: "français"
		//},
		{
			code: "CN",
			title: "切换简体中文"
		}],
		APIAddress: "/proxy",
		WAPIAddress: '/proxy-wapi'
	
	};
	module.exports = exports["default"];

/***/ },

/***/ "DWYU":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	// the index of array represents the value of sState (student state)
	// 0:全部  1:未排班+已排版  2:未排班  3:在读  4:往期  5:续费
	exports.default = ["all", "all_not_archived", "not_enrolled", "enrolled", "archived", "pending_renewal"];
	module.exports = exports["default"];

/***/ },

/***/ "PT2B":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _Mediator2 = __webpack_require__("ek+r");
	
	var _Mediator3 = _interopRequireDefault(_Mediator2);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Student = function (_Mediator) {
	  _inherits(Student, _Mediator);
	
	  function Student(student) {
	    var _ret2;
	
	    _classCallCheck(this, Student);
	
	    var _this = _possibleConstructorReturn(this, _Mediator.call(this, student));
	
	    if (student instanceof _Mediator3.default) {
	      var _ret;
	
	      return _ret = _this, _possibleConstructorReturn(_this, _ret);
	    }
	
	    _this.setVersion('v1', ['sName', 'schoolStudentID', 'sEmail', 'sAge', 'list', 'class_count', 'sGender', 'sState']);
	
	    _this.setVersion('v2', ['age', 'arrangeLessonCount', 'classStudentFeeState', 'classStudentState', 'class_feeType', 'days_left', 'paidTotalQuantity', 'schoolStudentEmail', 'schoolStudentGender', 'paidInFee']);
	
	    _this.setVersion('v3', ['id', 'ssAge', 'ssGender', 'ssName']);
	
	    _this.setVersion('v4', ['student_id', 'student_name', 'student_nickname', 'student_age']);
	
	    _this.setVersion('v5', ["id", "ssFirstName", "ssLastName", "ssNickName", "ssGender", "ssBirthday", "ssPhone", "ssHomePhone", "ssEmail", "ssSource", "ssSocialType", "ssSocialID", "ssParentsName", "ssGuardianRelation", "ssParentsPhone", "ssParentsEmail", "ssParents2Name", "ssGuardian2Relation", "ssParents2Phone", "ssParents2Email", "ssCountry", "ssProvince", "ssCity", "ssSuitNumber", "ssPostcode", "ssAddress", "ssRemark", "ssState", "ssStudentCreateTime", "ssCode", "student_bound", "parents_bound", "custom_data", "ssSchool", "ssStudent", 'balance', 'currency', 'pofile_photo', 'profile_photo_thumbnail_1x', 'profile_photo_thumbnail_2x', 'profile_photo_thumbnail_8x', "ssPhone_parsed", 'ssParentsPhone_parsed', 'ssParents2Phone_parsed']);
	
	    _this.setVersion('v6', ['sFirstName', 'sLastName', 'sNickName', 'sGender', 'sBirthday', 'sPhone', 'sHomePhone', 'sEmail', 'sSource', 'sSocialID', 'sParentsName', 'sGuardianRelation', 'sCountry', 'sProvince', 'sCity', 'sSuitNumber', 'sPostcode', 'sAddress', 'sRemark', 'sCreateTime', "sParentsName", "sGuardianRelation", "sParentsPhone", "sParentsEmail", "sParents2Name", "sGuardian2Relation", "sParents2Phone", "sParents2Email", "custom_data", 'pofile_photo', 'profile_photo_thumbnail_1x', 'profile_photo_thumbnail_2x', 'profile_photo_thumbnail_8x']);
	
	    _this.__schema = {
	      id: {
	        alias: ['schoolStudentID', 'sID', 'id', 'student_id']
	        // transform: ()=> {}, // a function to transform the data
	      },
	      name: {
	        alias: ['schoolStudentName', 'sName', 'ssName', 'name', 'student_name'],
	        transform: function transform(_ref) {
	          var name = _ref.name,
	              firstName = _ref.firstName,
	              lastName = _ref.lastName;
	
	          if (typeof name == 'string' && name.length > 0) {
	            return name;
	          } else {
	            return (firstName || '') + ' ' + (lastName || '');
	          }
	        }
	      },
	      firstName: {
	        alias: ['ssFirstName', 'sFirstName'],
	        validate: ['required']
	      },
	      lastName: {
	        alias: ['ssLastName', 'sLastName'],
	        validate: ['required']
	      },
	      nickName: {
	        alias: ['sNickName', 'ssNickName', 'student_nickname']
	      },
	      age: {
	        alias: ['age', 'sAge', 'ssAge', 'student_age']
	      },
	      dob: {
	        alias: ['ssBirthday', 'sBirthday'],
	        transform: function transform(_ref2) {
	          var dob = _ref2.dob;
	
	          if (dob && (0, _moment2.default)(dob).isValid()) {
	            return (0, _moment2.default)(dob).format('YYYY-MM-DD');
	          } else {
	            return dob;
	          }
	        },
	        validate: [function (value) {
	          if (value && !(0, _moment2.default)(value).isValid()) {
	            return ['not in YYYY-MM-DD format'];
	          } else {
	            return [];
	          }
	        }]
	      },
	      email: {
	        alias: ['schoolStudentEmail', 'sEmail', 'ssEmail'],
	        validate: ['email']
	      },
	      gender: {
	        alias: ['schoolStudentGender', 'sGender', 'ssGender'],
	        transform: function transform(_ref3) {
	          var gender = _ref3.gender;
	
	          if (typeof gender === 'string') {
	            var genderA = gender.toUpperCase();
	
	            if (genderA == 'MALE' || genderA.indexOf('男') > -1 || genderA == 'BOY' || genderA == 'MAN') {
	              return 0;
	            }
	
	            if (genderA == 'FEMALE' || genderA.indexOf('女') > -1 || genderA == 'GIRL' || genderA == 'WOMAN') {
	              return 1;
	            }
	
	            return 3;
	          } else if (typeof gender === 'number') {
	            return gender;
	          }
	        }
	      },
	      countryCode: {
	        alias: ['countryCode']
	      },
	      phone: {
	        alias: ['ssPhone', 'sPhone'],
	        validate: ['required', 'phone']
	      },
	      phoneParsed: {
	        alias: ['ssPhone_parsed']
	      },
	      homePhone: {
	        alias: ['ssHomePhone', 'sHomePhone']
	      },
	      country: {
	        alias: ['ssCountry', 'sCountry']
	      },
	      province: {
	        alias: ['ssProvince', 'sProvince']
	      },
	      city: {
	        alias: ['ssCity', 'sCity']
	      },
	      suiteNumber: {
	        alias: ['ssSuitNumber', 'sSuitNumber']
	      },
	      postalCode: {
	        alias: ['ssPostcode', 'sPostcode']
	      },
	      address: {
	        alias: ['ssAddress', 'sAddress']
	      },
	
	      primaryGuardianName: {
	        alias: ['ssParentsName', 'sParentsName']
	      },
	      primaryGuardianEmail: {
	        alias: ['ssParentsEmail', 'sParentsEmail'],
	        validate: ['email']
	      },
	      primaryGuardianPhone: {
	        alias: ['ssParentsPhone', 'sParentsPhone'],
	        validate: ['phone']
	      },
	      primaryGuardianPhoneParsed: {
	        alias: ['ssParentsPhone_parsed', 'sParentsPhone_parsed'],
	        validate: ['phone']
	      },
	      primaryGuardianRelationship: {
	        alias: ['ssGuardianRelation', 'sGuardianRelation']
	      },
	
	      secondaryGuardianName: {
	        alias: ['ssParents2Name', 'sParents2Name']
	      },
	      secondaryGuardianEmail: {
	        alias: ['ssParents2Email', 'sParents2Email'],
	        validate: ['email']
	      },
	      secondaryGuardianPhone: {
	        alias: ['ssParents2Phone', 'sParents2Phone'],
	        validate: ['phone']
	      },
	      secondaryGuardianPhoneParsed: {
	        alias: ['ssParents2Phone_parsed', 'sParents2Phone_parsed'],
	        validate: ['phone']
	      },
	      secondaryGuardianRelationship: {
	        alias: ['ssGuardian2Relation', 'sGuardian2Relation']
	      },
	
	      customData: {
	        alias: ['custom_data'],
	        transform: function transform(_ref4) {
	          var customData = _ref4.customData;
	
	          // by some unknown errors custom_data is being saved as [object Object]
	          // to preven further corruption we adjust it back to {}
	          if ((typeof customData === 'undefined' ? 'undefined' : _typeof(customData)) !== 'object') {
	            return {};
	          } else {
	            return customData;
	          }
	        }
	      },
	      remark: {
	        alias: ['ssRemark', 'sRemark']
	      },
	      code: {
	        alias: ['ssCode']
	      },
	      studentBound: {
	        alias: ['student_bound']
	      },
	      parentsBound: {
	        alias: ['parents_bound']
	      },
	      createdOn: {
	        alias: ['ssStudentCreateTime', 'sCreateTime']
	      },
	
	      state: {
	        alias: ['sState', 'ssState']
	      },
	      arrangeLessonCount: {
	        alias: ['arrangeLessonCount']
	      },
	      classFeeType: {
	        alias: ['class_feeType']
	      },
	      classStudentState: {
	        alias: ['classStudentState']
	      },
	      usedLessonCount: {
	        alias: ['usedLessonCount']
	      },
	      paidTotalQuantity: {
	        alias: ['paidTotalQuantity']
	      },
	      usedTotalQuantity: {
	        alias: ['usedTotalQuantity']
	      },
	      daysLeft: {
	        alias: ['days_left']
	      },
	      paidInFee: {
	        alias: ['paidInFee']
	      },
	      classList: {
	        alias: ['list', 'classList'],
	        transform: function transform(_ref5) {
	          var classList = _ref5.classList;
	
	          if (!Array.isArray(classList)) {
	            return [];
	          }
	          return classList.map(function (cls) {
	            // sometimes classDetail in class list can have consumed_and_purchased
	            // we must to flat it out to make it work with PaymentModal
	            if (cls.consumed_and_purchased) {
	              return _extends({}, cls, cls.consumed_and_purchased);
	            } else {
	              return cls;
	            }
	          });
	        }
	      },
	      classCount: {
	        alias: ['class_count']
	      },
	      classInfo: {
	        alias: ['classInfo']
	      },
	      balance: {
	        alias: ['blanace']
	      },
	      currency: {
	        alias: ['currency']
	      },
	      profilePhoto: {
	        alias: ['profile_photo']
	      },
	      profilePhotoThumbnail1x: {
	        alias: ['profile_photo_thumbnail_1x']
	      },
	      profilePhotoThumbnail2x: {
	        alias: ['profile_photo_thumbnail_2x']
	      },
	      profilePhotoThumbnail8x: {
	        alias: ['profile_photo_thumbnail_8x']
	      }
	    };
	
	    return _ret2 = _this.create(), _possibleConstructorReturn(_this, _ret2);
	  }
	
	  Student.prototype.getAddress = function getAddress() {
	    var _privateData = this.__privateData,
	        suiteNumber = _privateData.suiteNumber,
	        address = _privateData.address,
	        city = _privateData.city,
	        province = _privateData.province,
	        country = _privateData.country,
	        postalCode = _privateData.postalCode;
	
	
	    var suiteNumberStr = typeof suiteNumber === 'string' && suiteNumber.length > 0 ? suiteNumber + ' - ' : '';
	    var addressStr = typeof address === 'string' && address.length > 0 ? address : '';
	    var cityStr = typeof city === 'string' && city.length > 0 ? city : '';
	    var provinceStr = typeof province === 'string' && province.length > 0 ? province : '';
	    var countryStr = typeof country === 'string' && country.length > 0 ? country : '';
	    var postalCodeStr = typeof postalCode === 'string' && postalCode.length > 0 ? postalCode.toUpperCase() : '';
	
	    return suiteNumberStr + ' ' + addressStr + ' ' + cityStr + ' ' + provinceStr + ' ' + countryStr + ' ' + postalCodeStr;
	  };
	
	  Student.prototype.onConvertFormData = function onConvertFormData(name, value) {};
	
	  return Student;
	}(_Mediator3.default);
	
	exports.default = Student;
	module.exports = exports['default'];

/***/ },

/***/ "ek+r":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _lodash = __webpack_require__("M4fF");
	
	var _validator = __webpack_require__("+b6B");
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//
	// Mediator
	//
	// The current API has no uniform data. We will use mediator to "mediate"
	// conflicts between different data models that are supposedly to be 
	// the same thing!
	//
	//
	var Mediator = function () {
	  function Mediator(rawData) {
	    _classCallCheck(this, Mediator);
	
	    if (rawData instanceof Mediator) {
	      rawData = rawData.getOriginal();
	    }
	    this.__keysPerVersion = {};
	    this.__originalData = rawData || {};
	    this.__versionData = 'unknown';
	    this.__privateData = {};
	  }
	
	  Mediator.prototype.create = function create() {
	    var _self = this;
	    var type = typeof _self === 'undefined' ? 'undefined' : _typeof(_self);
	
	    this.buildWithSchema();
	
	    var proxy = new Proxy(this, {
	      get: function get(target, name, receiver) {
	        if (typeof target[name] == 'function') {
	          if (name.startsWith('_')) {
	            throw new Error('Accessing to a private method ' + type + '.' + name + '() is not allowed');
	          }
	          return target[name].bind(_self);
	        }
	
	        return target.__privateData[name];
	      }
	    });
	
	    return proxy;
	  };
	
	  Mediator.prototype.buildWithSchema = function buildWithSchema() {
	    var _this = this;
	
	    if (typeof this.__schema === 'undefined') {
	      throw new Error('__schema is not defined.');
	    }
	
	    // originalKeys for eg: ['a', 'b', 'c']
	    this.__originalDataKeys = Object.keys(this.__originalData);
	
	    var runTransformsFor = [];
	
	    Object.keys(this.__schema).map(function (mediatorKey) {
	      var schemaItem = _this.__schema[mediatorKey];
	
	      // alias for eg: ['A', 'aa', 'a']
	      var alias = schemaItem.alias,
	          transform = schemaItem.transform;
	
	
	      if (typeof transform == 'function') {
	        runTransformsFor.push(mediatorKey);
	      }
	
	      if (!Array.isArray(alias)) {
	        throw new Error('Alias (array) is not defined.');
	      }
	
	      if (_this.__originalDataKeys.indexOf(mediatorKey) > -1) {
	        _this.__privateData[mediatorKey] = _this.__originalData[mediatorKey];
	      } else {
	        alias.forEach(function (aliasKey) {
	          if (typeof _this.__originalData[aliasKey] !== 'undefined' && _this.__originalDataKeys.indexOf(aliasKey) > -1) {
	            _this.__privateData[mediatorKey] = _this.__originalData[aliasKey];
	          }
	        });
	      }
	    });
	
	    runTransformsFor.map(function (key, idx) {
	      _this.__privateData[key] = _this.__schema[key].transform(_this.__privateData);
	    });
	  };
	
	  Mediator.prototype.setVersion = function setVersion(versionName, qualifyingKeys, meta) {
	    var numberOfQualifiedKeys = 0;
	
	    this.__keysPerVersion[versionName] = qualifyingKeys;
	
	    Object.keys(this.__originalData).map(function (key) {
	      if (qualifyingKeys.indexOf(key) > -1) {
	        numberOfQualifiedKeys++;
	      }
	    });
	
	    if (numberOfQualifiedKeys == qualifyingKeys.length) {
	      this.__version = versionName;
	      this.__versionMeta = meta || {};
	    }
	  };
	
	  Mediator.prototype.version = function version() {
	    return this.__version;
	  };
	
	  //
	  // Note that we're returning a new object. NOT A REFERENCE.
	  //
	
	
	  Mediator.prototype.toObject = function toObject() {
	    return (0, _lodash.cloneDeep)(this.__privateData);
	  };
	
	  Mediator.prototype.getOriginal = function getOriginal() {
	    return (0, _lodash.cloneDeep)(this.__originalData);
	  };
	
	  Mediator.prototype.isSameAs = function isSameAs(prox) {
	    return this.__privateData.id == prox.id;
	  };
	
	  Mediator.prototype.log = function log() {};
	
	  Mediator.prototype.toFormData = function toFormData(version) {
	    return this.execToFormData(this.__privateData, this.__keysPerVersion[version || this.__version]);
	  };
	
	  Mediator.prototype.toFormDataFrom = function toFormDataFrom(data, versionName) {
	    var keys = this.__keysPerVersion[versionName];
	
	    if (!keys) {
	      throw new Error('Version \'' + versionName + '\' does not exist.');
	    }
	
	    return this.execToFormData(data, keys);
	  };
	
	  Mediator.prototype.execToFormData = function execToFormData(data) {
	    var _this2 = this;
	
	    var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var formData = {};
	
	    Object.keys(data).map(function (key) {
	      if (key === 'id') {
	        return;
	      }
	
	      var value = data[key];
	
	      var alias = _this2.__schema[key].alias || [];
	
	      alias.map(function (name) {
	        if (keys.indexOf(name) > -1) {
	          var converted = void 0;
	          if (typeof _this2.onConvertFormData === 'function') {
	            converted = _this2.onConvertFormData(key, value);
	          }
	          formData[name] = converted || value;
	        }
	      });
	    });
	
	    return formData;
	  };
	
	  Mediator.prototype.validate = function validate() {
	    var _this3 = this;
	
	    var allErrors = {};
	    (0, _lodash.each)(this.__schema, function (_ref, key) {
	      var _ref$validate = _ref.validate,
	          validate = _ref$validate === undefined ? [] : _ref$validate;
	
	      var value = _this3.__privateData[key];
	      var errors = [];
	
	      validate.map(function (rule, idx) {
	        if (typeof rule === 'string') {
	          switch (rule) {
	            case 'required':
	              {
	                if (value === '' || typeof value === 'undefined') {
	                  errors.push('required');
	                }
	                break;
	              }
	            case 'email':
	              {
	                if (value && !_validator2.default.isEmail(value)) {
	                  errors.push('invalid email');
	                }
	                break;
	              }
	            case 'phone':
	              {
	
	                break;
	              }
	          }
	        } else if (typeof rule === 'function') {
	          var errorsFromFunction = rule(value) || [];
	          errors = [].concat(errors, errorsFromFunction);
	        }
	      });
	
	      if (errors.length > 0) {
	        allErrors[key] = errors;
	      }
	    });
	
	    return allErrors;
	  };
	
	  return Mediator;
	}();
	
	exports.default = Mediator;
	module.exports = exports['default'];

/***/ },

/***/ "wPVy":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	// User can select a classroom.
	// a wraper of SelectItemModal
	//
	// eg.
	// SelectClass({ schoolId })
	//  .then()
	//  .catch()
	//
	
	
	exports.default = function (opts) {
	  var schoolId = opts.schoolId,
	      _opts$conflictedIDs = opts.conflictedIDs,
	      conflictedIDs = _opts$conflictedIDs === undefined ? [] : _opts$conflictedIDs;
	
	  // this will return a promise
	
	  return (0, _SelectItem2.default)(_extends({
	    headerTitle: __('Select Classroom', 'schedule'),
	    headerIcon: 'fa icon-chalkboard',
	    itemName: __('Classroom', 'schedule'),
	    searchPlaceholder: __('Search Classroom', 'schedule'),
	    getItemLabel: function getItemLabel(item) {
	      return item.name;
	    },
	    fetchItems: function fetchItems(cb) {
	      (0, _getClassroom2.default)({ schoolId: schoolId }).then(function (_ref) {
	        var classroom_list = _ref.classroom_list;
	
	        cb(classroom_list.map(function (classroom) {
	          return new _Classroom2.default(classroom);
	        }));
	      }).catch(function (err) {
	        console.error(err);
	      });
	    },
	    components: {
	      SelectItem: function SelectItem(_ref2) {
	        var item = _ref2.item,
	            getItemLabel = _ref2.getItemLabel,
	            selected = _ref2.selected,
	            onClickSelect = _ref2.onClickSelect,
	            selectText = _ref2.selectText,
	            selectedText = _ref2.selectedText,
	            mixin = _ref2.mixin;
	
	
	        var conflicted = conflictedIDs.indexOf(item.id) > -1;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'select-item' },
	          _react2.default.createElement(
	            'div',
	            null,
	            item.name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'select-button' },
	            conflicted && _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              __('Conflict', 'classdetail')
	            ),
	            selected && _react2.default.createElement(
	              'span',
	              { className: 'btn-link currently-selected', onClick: onClickSelect },
	              selectText || __('Selected', 'SelectItemModal')
	            ),
	            !selected && _react2.default.createElement(
	              'span',
	              { className: 'btn-link', onClick: onClickSelect },
	              selectedText || __('Select', 'SelectItemModal')
	            )
	          )
	        );
	      }
	    },
	    selectFilter: function selectFilter(item, alreadySelected, selected) {
	      return alreadySelected.id == item.id;
	    }
	
	  }, opts));
	};
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectItem = __webpack_require__("k6Ef");
	
	var _SelectItem2 = _interopRequireDefault(_SelectItem);
	
	var _getClassroom = __webpack_require__("QWKB");
	
	var _getClassroom2 = _interopRequireDefault(_getClassroom);
	
	var _Classroom = __webpack_require__("WLpk");
	
	var _Classroom2 = _interopRequireDefault(_Classroom);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ },

/***/ "QWKB":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getClassroom;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getClassroom(opts) {
	
	  if (!opts.schoolId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school Id (number)')
	      });
	    });
	  }
	
	  var query = _queryString2.default.stringify({
	    amount_per_page: opts.amount_per_page,
	    current_page_number: opts.current_page_number,
	    keyword: opts.keyword,
	    order_by: opts.order_by
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/classroom_list/" + opts.schoolId + "/?" + query,
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "WLpk":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Mediator2 = __webpack_require__("ek+r");
	
	var _Mediator3 = _interopRequireDefault(_Mediator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Classroom = function (_Mediator) {
	  _inherits(Classroom, _Mediator);
	
	  function Classroom(data) {
	    var _ret2;
	
	    _classCallCheck(this, Classroom);
	
	    var _this = _possibleConstructorReturn(this, _Mediator.call(this, data));
	
	    if (data instanceof _Mediator3.default) {
	      var _ret;
	
	      return _ret = _this, _possibleConstructorReturn(_this, _ret);
	    }
	
	    _this.setVersion('v1', ['school_classroom_id', 'name', 'seating_capacity']);
	
	    _this.__schema = {
	      id: {
	        alias: ['id', 'school_classroom_id']
	      },
	      name: {
	        alias: ['name']
	      },
	      seatingCapacity: {
	        alias: ['seatingCapacity', 'seating_capacity']
	      }
	    };
	
	    return _ret2 = _this.create(), _possibleConstructorReturn(_this, _ret2);
	  }
	
	  return Classroom;
	}(_Mediator3.default);
	
	exports.default = Classroom;
	module.exports = exports['default'];

/***/ },

/***/ "EADx":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _selectDaysInWeek$sel;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactNumberFormat = __webpack_require__("RwBb");
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _DateRangePicker = __webpack_require__("g0Dv");
	
	var _TimeRange = __webpack_require__("eL63");
	
	var _SelectStudent = __webpack_require__("958X");
	
	var _SelectClassStudent = __webpack_require__("NpuD");
	
	var _SelectClassTeacher = __webpack_require__("Lx0Z");
	
	var _SelectTeacher = __webpack_require__("qPpx");
	
	var _SelectClass = __webpack_require__("2J0w");
	
	var _SelectClassroom = __webpack_require__("tYCd");
	
	var _DatePicker = __webpack_require__("vJje");
	
	var _SelectDaysInWeek = __webpack_require__("V3L3");
	
	var _SelectDaysInMonth = __webpack_require__("qLay");
	
	var _ReactSelect = __webpack_require__("Z40E");
	
	var _ColorPicker = __webpack_require__("ytvc");
	
	var _DropdownSelect = __webpack_require__("y7rH");
	
	var _ToggleSwitch = __webpack_require__("IPLN");
	
	var _Textarea = __webpack_require__("ylS4");
	
	var _TimeZone = __webpack_require__("dHZB");
	
	var _Currency = __webpack_require__("CKuu");
	
	var _Address = __webpack_require__("MwQ4");
	
	var _OpenHours = __webpack_require__("4sJU");
	
	var _AgeLimit = __webpack_require__("zajY");
	
	var _Quantity = __webpack_require__("9crX");
	
	var _Money = __webpack_require__("7bpD");
	
	var _Age = __webpack_require__("/1QF");
	
	var _SchoolHomepage = __webpack_require__("A6bG");
	
	var _ImageUploader = __webpack_require__("tbgL");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_selectDaysInWeek$sel = {
	  selectDaysInWeek: _SelectDaysInWeek.selectDaysInWeek,
	  selectDaysInMonth: _SelectDaysInMonth.selectDaysInMonth,
	  daterange: _DateRangePicker.daterange,
	  timerange: _TimeRange.timerange,
	  selectClassroom: _SelectClassroom.selectClassroom,
	  selectTeacher: _SelectTeacher.selectTeacher,
	  selectStudent: _SelectStudent.selectStudent,
	  selectClassStudent: _SelectClassStudent.selectClassStudent
	}, _selectDaysInWeek$sel['selectClassStudent'] = _SelectClassStudent.selectClassStudent, _selectDaysInWeek$sel.selectClassTeacher = _SelectClassTeacher.selectClassTeacher, _selectDaysInWeek$sel.datepicker = _DatePicker.datepicker, _selectDaysInWeek$sel.reactselect = _ReactSelect.reactselect, _selectDaysInWeek$sel.colorpicker = _ColorPicker.colorpicker, _selectDaysInWeek$sel.dropdownselect = _DropdownSelect.dropdownselect, _selectDaysInWeek$sel.toggleswitch = _ToggleSwitch.toggleswitch, _selectDaysInWeek$sel.imageuploader = _ImageUploader.imageuploader, _selectDaysInWeek$sel.textarea = _Textarea.textarea, _selectDaysInWeek$sel.timezone = _TimeZone.timezone, _selectDaysInWeek$sel.currency = _Currency.currency, _selectDaysInWeek$sel.address = _Address.address, _selectDaysInWeek$sel.openhours = _OpenHours.openhours, _selectDaysInWeek$sel.agelimit = _AgeLimit.agelimit, _selectDaysInWeek$sel.money = _Money.money, _selectDaysInWeek$sel.quantity = _Quantity.quantity, _selectDaysInWeek$sel.age = _Age.age, _selectDaysInWeek$sel.schoolhomepage = _SchoolHomepage.schoolhomepage, _selectDaysInWeek$sel.component = function component(props) {
	  var options = props.options;
	
	  if (options.component) {
	    return options.component;
	  } else {
	    return _react2.default.createElement('div', null);
	  }
	}, _selectDaysInWeek$sel);
	module.exports = exports['default'];

/***/ },

/***/ "g0Dv":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * <DateRangePickerField
	                                                                                                                                                                                                                                                                   *	/>
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * A custom wrapper for SingleDatePicker
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @parent anybody
	                                                                                                                                                                                                                                                                   * @stateful
	                                                                                                                                                                                                                                                                   */
	
	
	exports.daterange = daterange;
	
	__webpack_require__("lj70");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("DTuZ");
	
	var _reactDates = __webpack_require__("OjkW");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__("Uonx");
	
	var _constants = __webpack_require__("7rIE");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function daterange(props) {
	
	  return _react2.default.createElement(DateRangePickerField, _extends({}, props, {
	    onChange: function onChange(_ref) {
	      var startDate = _ref.startDate,
	          endDate = _ref.endDate;
	
	      if (startDate && endDate) {
	        props.onChange(startDate.format(_constants.DATE_FORMAT) + ':::' + endDate.format(_constants.DATE_FORMAT));
	      }
	    }
	  }));
	}
	
	var DateRangePickerField = function (_React$Component) {
	  _inherits(DateRangePickerField, _React$Component);
	
	  function DateRangePickerField(props) {
	    _classCallCheck(this, DateRangePickerField);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    var dates = void 0;
	    if (typeof props.value !== 'string') {
	      _this.state = {};
	    } else if (props.value != 'undefined:::undefined') {
	      dates = props.value.split(':::');
	      _this.state = {
	        startDate: (0, _moment2.default)(dates[0], 'YYYY-MM-DD') || (0, _moment2.default)()
	      };
	    } else {
	      _this.state = {};
	    }
	    _this.onDatesChange = _this.onDatesChange.bind(_this);
	    return _this;
	  }
	
	  DateRangePickerField.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    //
	    // When we receive props.value, it is in string form
	    // 'YYYY-MM-DD:::YYYY-MM-DD'
	    //
	    // So we're going to parse it into moment instances.
	    //
	    if (typeof nextProps.value === 'string') {
	      var dates = nextProps.value.split(':::');
	      this.setState({
	        startDate: (0, _moment2.default)(dates[0], 'YYYY-MM-DD'),
	        endDate: (0, _moment2.default)(dates[1], 'YYYY-MM-DD')
	      });
	    }
	
	    //
	    // when props receive startDate and endDate, we assume they are instance of moment
	    //
	    if (nextProps.startDate) {
	      this.setState({
	        startDate: nextProps.startDate
	      });
	    }
	
	    if (nextProps.endDate) {
	      this.setState({
	        endDate: nextProps.endDate
	      });
	    }
	  };
	
	  DateRangePickerField.prototype.onDatesChange = function onDatesChange(opts) {
	    var startDate = opts.startDate,
	        endDate = opts.endDate;
	    var onChange = this.props.onChange;
	
	
	    this.setState({ startDate: startDate, endDate: endDate }, function () {
	      onChange(opts);
	    });
	  };
	
	  DateRangePickerField.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        options = _props.options,
	        displayFormat = _props.displayFormat;
	
	
	    if (options) {
	      delete options.enumOptions;
	      delete options.isOutsideRange;
	    }
	
	    var _state = this.state,
	        startDate = _state.startDate,
	        endDate = _state.endDate,
	        focusedInput = _state.focusedInput;
	
	
	    var hasValue = startDate && endDate;
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('date-range-picker', 'form-input', { 'has-value': hasValue }) },
	      _react2.default.createElement(_reactDates.DateRangePicker, _extends({
	        small: true,
	        displayFormat: displayFormat || _constants.DATE_FORMAT,
	        startDate: startDate // momentPropTypes.momentObj or null,
	        , startDateId: 'start_date' // PropTypes.string.isRequired,
	
	        , startDatePlaceholderText: __('Start Date', 'DateRange'),
	        endDatePlaceholderText: __('End Date', 'DateRange'),
	
	        endDate: endDate // momentPropTypes.momentObj or null,
	        , endDateId: 'end_date' // PropTypes.string.isRequired,
	
	        , onDatesChange: this.onDatesChange // PropTypes.func.isRequired,
	        , focusedInput: focusedInput // PropTypes.oneOf([START_DATE, END_DATE]) or null,
	        , onFocusChange: function onFocusChange(focusedInput) {
	          return _this2.setState({ focusedInput: focusedInput });
	        } // PropTypes.func.isRequired,
	        , minimumNights: 0 // THIS allow selecting a same date
	        , showClearDates: true,
	        isOutsideRange: this.props.isOutsideRange ? this.props.isOutsideRange : function () {
	          return false;
	        }
	      }, options))
	    );
	  };
	
	  return DateRangePickerField;
	}(_react2.default.Component);
	
	exports.default = DateRangePickerField;

/***/ },

/***/ "Uonx":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"date-range-picker":"date-range-picker","has-value":"has-value","DateRangePickerInput_clearDates":"DateRangePickerInput_clearDates","DateRangePicker":"DateRangePicker","DateInput_input":"DateInput_input","DateRangePickerInput":"DateRangePickerInput","DateRangePickerInput_arrow":"DateRangePickerInput_arrow","DateRangePickerInput_arrow_svg":"DateRangePickerInput_arrow_svg","DateInput":"DateInput","DateInput_input__focused":"DateInput_input__focused","DateRangePicker_picker":"DateRangePicker_picker","DayPickerKeyboardShortcuts_buttonReset":"DayPickerKeyboardShortcuts_buttonReset"};

/***/ },

/***/ "7rIE":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var DATE_FORMAT = exports.DATE_FORMAT = 'YYYY-MM-DD';
	var TIME_FORMAT = exports.TIME_FORMAT = 'HH:mm';
	var START_END_MIN_DIFF = exports.START_END_MIN_DIFF = 30;
	var ITEM_NAME_LIST_LENGTH = exports.ITEM_NAME_LIST_LENGTH = 3;
	var DEFAULT_DATE_PLACEHOLDER = exports.DEFAULT_DATE_PLACEHOLDER = 'YYYY-MM-DD';
	var FULL_TIME_FORMAT = exports.FULL_TIME_FORMAT = 'HH:mm:ss';

/***/ },

/***/ "eL63":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * <TimeRange />
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Make a range of time
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @parent anybody
	                                                                                                                                                                                                                                                                   * @stateful
	                                                                                                                                                                                                                                                                   */
	
	// import TimePicker from 'rc-time-picker';
	//import 'rc-time-picker/assets/index.css';
	
	
	exports.timerange = timerange;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TimePicker = __webpack_require__("ryd0");
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _cloneDeep = __webpack_require__("kvU2");
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	__webpack_require__("QnAV");
	
	var _constants = __webpack_require__("7rIE");
	
	var _Svg = __webpack_require__("8M7V");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_START = (0, _moment2.default)('09:00', _constants.TIME_FORMAT);
	var DEFAULT_END = (0, _moment2.default)('09:30', _constants.TIME_FORMAT);
	var DEFAULT_USE_12HOURS = true;
	
	// this functions is a widget function used by a form
	function timerange(props) {
	  var value = props.value;
	
	  var startMoment = void 0,
	      endMoment = void 0;
	
	  if (typeof value === 'string') {
	    var parts = value.split(':::');
	    startMoment = (0, _moment2.default)(parts[0], 'HH:mm');
	    endMoment = (0, _moment2.default)(parts[1], 'HH:mm');
	  }
	
	  return _react2.default.createElement(TimeRange, _extends({}, props, props.options, {
	    startMoment: startMoment,
	    endMoment: endMoment,
	    onChange: function onChange(_ref) {
	      var startTime = _ref.startTime,
	          endTime = _ref.endTime;
	      props.onChange(startTime + ':::' + endTime);
	    } }));
	}
	
	var TimeRange = (_temp = _class = function (_React$Component) {
	  _inherits(TimeRange, _React$Component);
	
	  function TimeRange(props) {
	    _classCallCheck(this, TimeRange);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onStartTimeChange = _this.onStartTimeChange.bind(_this);
	    _this.onEndTimeChange = _this.onEndTimeChange.bind(_this);
	    _this.onReset = _this.onReset.bind(_this);
	
	    _this.state = {
	      startMoment: props.startMoment || DEFAULT_START,
	      endMoment: props.endMoment || DEFAULT_END
	    };
	    return _this;
	  }
	
	  TimeRange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var startTime = nextProps.startTime,
	        startMoment = nextProps.startMoment,
	        endTime = nextProps.endTime,
	        endMoment = nextProps.endMoment;
	
	
	    if (startTime) {
	      this.setState({
	        startTime: startTime
	      });
	    }
	
	    if (startMoment) {
	      this.setState({
	        startMoment: startMoment
	      });
	    }
	
	    if (endTime) {
	      this.setState({
	        endTime: endTime
	      });
	    }
	    if (endMoment) {
	      this.setState({
	        endMoment: endMoment
	      });
	    }
	  };
	
	  //
	  // This is how it works,
	  // We compare end time and start time, if start time is equal to end time OR it is later than end time,
	  // we automatically adjust the difference between these two to be START_END_MIN_DIFF apart which could be
	  // 5, 15, 30 mins. Users are ALLOWED to adjust the difference as small as to 1 minute.
	  //
	
	
	  TimeRange.prototype.onStartTimeChange = function onStartTimeChange(startMoment) {
	    var _this2 = this;
	
	    var endMoment = this.state.endMoment;
	
	    // let isStartTimeAfterEndTime;
	    // let isStartTimeSameAsEndTime;
	
	    // if (endMoment) {
	    //   isStartTimeAfterEndTime = startMoment.isAfter(endMoment, 'minute');
	    //   isStartTimeSameAsEndTime = startMoment.isSame(endMoment, 'minute');
	
	    //   this.setState({
	    //     diff: endMoment.diff(startMoment, 'minute'),
	    //     endMoment: moment(startMoment).add(5, 'minutes')
	    //   },()=>{
	    //     console.log('end', this.state.endMoment)
	    //     console.log('start', startMoment)
	    //     console.log('diff', this.state.diff)
	    //   });
	    // }
	
	    var dataFormat = this.props.dataFormat;
	
	    var adjustedEndMoment = startMoment.isSameOrAfter(endMoment, 'minute') ? (0, _cloneDeep2.default)(startMoment).add(5, 'm') : endMoment;
	    this.setState({
	      startMoment: startMoment,
	      endMoment: adjustedEndMoment,
	      startTime: startMoment.format(dataFormat || _constants.TIME_FORMAT),
	      endTime: adjustedEndMoment.format(dataFormat || _constants.TIME_FORMAT)
	    }, function () {
	      _this2.props.onChange(_this2.state);
	    });
	  };
	
	  TimeRange.prototype.onEndTimeChange = function onEndTimeChange(endMoment) {
	    var _this3 = this;
	
	    var startMoment = this.state.startMoment;
	
	    // let isStartTimeAfterEndTime;
	    // let isStartTimeSameAsEndTime;
	
	    // if (startMoment) {
	    //   isStartTimeAfterEndTime = startMoment.isAfter(endMoment, 'minute');
	    //   isStartTimeSameAsEndTime = startMoment.isSame(endMoment, 'minute');
	
	    //   this.setState({
	    //     diff: endMoment.diff(startMoment, 'minute'),
	    //   });
	    // }
	
	    var dataFormat = this.props.dataFormat;
	
	    var adjustedStartMoment = endMoment.isSameOrBefore(startMoment, 'minute') ? (0, _cloneDeep2.default)(endMoment).subtract(5, 'm') : startMoment;
	    this.setState({
	      startMoment: adjustedStartMoment,
	      endMoment: endMoment,
	      startTime: adjustedStartMoment.format(dataFormat || _constants.TIME_FORMAT),
	      endTime: endMoment.format(dataFormat || _constants.TIME_FORMAT)
	    }, function () {
	      _this3.props.onChange(_this3.state);
	    });
	  };
	
	  TimeRange.prototype.onReset = function onReset() {
	    var onReset = this.props.onReset;
	
	
	    this.setState({
	      startMoment: null,
	      endMoment: null
	    }, function () {
	      if (typeof onReset == 'function') {
	        onReset();
	      }
	    });
	  };
	
	  TimeRange.prototype.render = function render() {
	    var _props = this.props,
	        showSecond = _props.showSecond,
	        format = _props.format,
	        hasValue = _props.hasValue,
	        _props$use12Hours = _props.use12Hours,
	        use12Hours = _props$use12Hours === undefined ? DEFAULT_USE_12HOURS : _props$use12Hours,
	        minuteStep = _props.minuteStep;
	    var _state = this.state,
	        startMoment = _state.startMoment,
	        endMoment = _state.endMoment;
	
	
	    var itDoesHaveValue = this.props.hasValue || startMoment && endMoment;
	
	    //
	    // We must change language to English by startMoment.lang('en')
	    //
	    if (startMoment) {
	      startMoment = startMoment.lang('en');
	    }
	    if (endMoment) {
	      endMoment = endMoment.lang('en');
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('time-picker', 'form-input', { 'has-value': itDoesHaveValue }) },
	      _react2.default.createElement(
	        'div',
	        { className: 'time-picker-input' },
	        _react2.default.createElement(
	          'div',
	          { className: 'start-time' },
	          _react2.default.createElement(_TimePicker2.default, {
	            value: startMoment,
	            minuteStep: minuteStep,
	            onChange: this.onStartTimeChange,
	            format: format,
	            use12Hours: use12Hours,
	            showSecond: showSecond,
	            placeholder: __('Start Time', 'TimeRange') })
	        ),
	        _Svg.Arrow,
	        _react2.default.createElement(
	          'div',
	          { className: 'end-time' },
	          _react2.default.createElement(_TimePicker2.default, {
	            value: endMoment,
	            minuteStep: minuteStep,
	            onChange: this.onEndTimeChange,
	            format: format,
	            use12Hours: use12Hours,
	            showSecond: showSecond,
	            placeholder: __('End Time', 'TimeRange') })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reset-button', onClick: this.onReset },
	          'x'
	        )
	      )
	    );
	  };
	
	  return TimeRange;
	}(_react2.default.Component), _class.defaultProps = {
	  showSecond: false,
	  format: 'h:mm a',
	  startTime: '',
	  endTime: ''
	}, _temp);
	exports.default = TimeRange;

/***/ },

/***/ "ryd0":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp; /**
	                    * <TimePicker2
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _times = __webpack_require__("sHbl");
	
	var _times2 = _interopRequireDefault(_times);
	
	__webpack_require__("sfBL");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_STATE = {
	  hour: '',
	  minute: '',
	  ampm: ''
	};
	
	var TimePicker2 = (_temp = _class = function (_React$Component) {
	  _inherits(TimePicker2, _React$Component);
	
	  function TimePicker2(props) {
	    _classCallCheck(this, TimePicker2);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.renderHours = _this.renderHours.bind(_this);
	    _this.renderMinutes = _this.renderMinutes.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.setMomentToStrTime = _this.setMomentToStrTime.bind(_this);
	
	    if (props.value) {
	      _this.state = _extends({}, _this.setMomentToStrTime(props.value));
	    } else {
	      _this.state = _extends({}, DEFAULT_STATE);
	    }
	    return _this;
	  }
	
	  TimePicker2.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var value = _ref.value;
	
	    if (value) {
	      this.setState(this.setMomentToStrTime(value));
	    } else {
	      this.setState(_extends({}, DEFAULT_STATE));
	    }
	  };
	
	  TimePicker2.prototype.setMomentToStrTime = function setMomentToStrTime(value) {
	    return {
	      hour: value.format('h'),
	      minute: value.format('mm'),
	      ampm: value.format('a')
	    };
	  };
	
	  TimePicker2.prototype.onChange = function onChange(name) {
	    var _this2 = this;
	
	    return function (e) {
	      var value = e.target.value;
	      var newData = {};
	      switch (name) {
	        case 'hour':
	          newData = {
	            hour: value
	          };
	          break;
	        case 'minute':
	          newData = {
	            minute: value
	          };
	          break;
	        case 'ampm':
	          newData = {
	            ampm: value
	          };
	          break;
	      }
	
	      var onChange = _this2.props.onChange;
	
	
	      _this2.setState(_extends({}, newData), function () {
	        var _state = _this2.state,
	            hour = _state.hour,
	            minute = _state.minute,
	            ampm = _state.ampm;
	
	
	        var strValue = hour + ':' + minute + ' ' + ampm;
	
	        var momentValue = (0, _moment2.default)(strValue, 'h:mm a');
	
	        onChange(momentValue, strValue);
	      });
	    };
	  };
	
	  TimePicker2.prototype.renderHours = function renderHours() {
	    return _react2.default.createElement(
	      'select',
	      { value: this.state.hour, onChange: this.onChange('hour'), className: 'form-control' },
	      _react2.default.createElement('option', null),
	      (0, _times2.default)(12, function (num, key) {
	        var hour = num + 1;
	        return _react2.default.createElement(
	          'option',
	          { value: hour, key: num },
	          hour
	        );
	      })
	    );
	  };
	
	  TimePicker2.prototype.renderMinutes = function renderMinutes() {
	    var _props$minuteStep = this.props.minuteStep,
	        minuteStep = _props$minuteStep === undefined ? 5 : _props$minuteStep;
	
	
	    var numOfSteps = parseInt(60 / 5);
	
	    return _react2.default.createElement(
	      'select',
	      { value: this.state.minute, onChange: this.onChange('minute'), className: 'form-control' },
	      _react2.default.createElement('option', null),
	      (0, _times2.default)(numOfSteps, function (num, key) {
	        var value = num * minuteStep;
	        var minute = value < 10 ? '0' + value : value;
	        return _react2.default.createElement(
	          'option',
	          { value: minute, key: num },
	          minute
	        );
	      })
	    );
	  };
	
	  TimePicker2.prototype.render = function render() {
	    var ampm = this.state.ampm;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'timepicker-2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'timepicker-2-fields' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group hour' },
	          this.renderHours()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group minute' },
	          this.renderMinutes()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group am-pm' },
	          _react2.default.createElement(
	            'select',
	            { value: ampm, onChange: this.onChange('ampm'), className: 'form-control' },
	            _react2.default.createElement('option', null),
	            _react2.default.createElement(
	              'option',
	              { value: 'am', key: 1 },
	              'AM'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 'pm', key: 2 },
	              'PM'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return TimePicker2;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = TimePicker2;
	module.exports = exports['default'];

/***/ },

/***/ "sfBL":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"timepicker-2":"timepicker-2","form-group":"form-group","form-control":"form-control"};

/***/ },

/***/ "QnAV":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"time-picker":"time-picker","form-group":"form-group","end-time":"end-time","timepicker-2-fields":"timepicker-2-fields","time-picker-input":"time-picker-input","start-time":"start-time","rc-time-picker":"rc-time-picker","arrow":"arrow","reset-button":"reset-button","has-value":"has-value"};

/***/ },

/***/ "8M7V":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Arrow = undefined;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Arrow = exports.Arrow = _react2.default.createElement(
	  "svg",
	  { className: "arrow", viewBox: "0 0 1000 1000" },
	  _react2.default.createElement("path", { d: "M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" })
	);

/***/ },

/***/ "958X":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * <SelectStudent
	                                                                                                                                                                                                                                                                   *		// please describe props here
	                                                                                                                                                                                                                                                                   *	/>
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @parent anybody
	                                                                                                                                                                                                                                                                   * @stateful
	                                                                                                                                                                                                                                                                   */
	
	
	exports.selectStudent = selectStudent;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SelectStudent = __webpack_require__("BgXg");
	
	var _SelectStudent2 = _interopRequireDefault(_SelectStudent);
	
	__webpack_require__("zJYP");
	
	var _constants = __webpack_require__("7rIE");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function selectStudent(props) {
	  var value = parseJsonStrValue(props.value);
	  return _react2.default.createElement(SelectStudent, _extends({}, props, { value: value, onChange: function onChange(data) {
	      props.onChange(JSON.stringify(data));
	    } }));
	}
	
	var SelectStudent = (_temp = _class = function (_React$Component) {
	  _inherits(SelectStudent, _React$Component);
	
	  function SelectStudent(props) {
	    _classCallCheck(this, SelectStudent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	
	    _this.state = {
	      studentNames: [],
	      studentIds: [],
	      students: []
	    };
	    return _this;
	  }
	
	  SelectStudent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.value) {
	      this.setState({
	        students: nextProps.value
	      });
	    }
	  };
	
	  SelectStudent.prototype.onChange = function onChange() {
	    var _this2 = this;
	
	    var _props = this.props,
	        _props$options = _props.options,
	        options = _props$options === undefined ? {} : _props$options,
	        onChange = _props.onChange,
	        selectFilter = _props.selectFilter;
	    var selectMultiple = options.selectMultiple;
	    var students = this.state.students;
	
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    (0, _SelectStudent2.default)({
	      schoolId: schoolId,
	      selectMultiple: selectMultiple,
	      selected: students
	    }).then(function (studentsOut) {
	      var studentIds = [];
	      var students = [];
	
	      if (!Array.isArray(studentsOut)) {
	        students = [studentsOut];
	      } else {
	        students = studentsOut;
	      }
	
	      students.map(function (student) {
	        studentIds.push(student.schoolStudentId);
	      });
	
	      _this2.setState({
	        studentIds: studentIds,
	        students: students
	      });
	
	      onChange(students);
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  SelectStudent.prototype.render = function render() {
	    var students = this.state.students;
	    var disabled = this.props.disabled;
	
	
	    var studentNamesText = void 0;
	
	    if (students && students.length > 0) {
	      var comma = '';
	      var trailing = '';
	      var studentsInRange = students.slice(0, _constants.ITEM_NAME_LIST_LENGTH);
	
	      var totalText = __('Total {number}: ', 'SelectStudentField', { number: students.length });
	
	      studentNamesText = studentsInRange.map(function (student, idx) {
	        if (idx === _constants.ITEM_NAME_LIST_LENGTH - 1 && students.length > _constants.ITEM_NAME_LIST_LENGTH) {
	          trailing = __('...', 'SelectStudentField');
	        }
	
	        var StudentLink = _react2.default.createElement(
	          'span',
	          { key: idx },
	          totalText,
	          comma,
	          student.name,
	          trailing
	        );
	
	        totalText = ''; // We only need it once.
	
	        comma = ', ';
	
	        return StudentLink;
	      });
	    } else {
	      studentNamesText = _react2.default.createElement(
	        'span',
	        { className: 'no-items' },
	        __('Not Assigned', 'others')
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'select-items-button' },
	      _react2.default.createElement(
	        'div',
	        { className: 'item-names col-sm-10' },
	        studentNamesText
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'select-toolbar col-sm-2 ' + (disabled ? 'disabled' : '') },
	        _react2.default.createElement(
	          'button',
	          { className: 'btn-link pull-right', onClick: this.onChange, disabled: disabled },
	          __('Select', 'class')
	        )
	      )
	    );
	  };
	
	  return SelectStudent;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = SelectStudent;

/***/ },

/***/ "zJYP":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"select-items-button":"select-items-button","item-names":"item-names","no-items":"no-items","select-button":"select-button","disabled":"disabled"};

/***/ },

/***/ "NpuD":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * <SelectClassStudent
	                                                                                                                                                                                                                                                                   *	/>
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @parent anybody
	                                                                                                                                                                                                                                                                   * @stateful
	                                                                                                                                                                                                                                                                   */
	
	
	exports.selectClassStudent = selectClassStudent;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SelectClassStudent = __webpack_require__("MBl1");
	
	var _SelectClassStudent2 = _interopRequireDefault(_SelectClassStudent);
	
	__webpack_require__("zJYP");
	
	var _constants = __webpack_require__("7rIE");
	
	var _Student = __webpack_require__("PT2B");
	
	var _Student2 = _interopRequireDefault(_Student);
	
	var _parseJson = __webpack_require__("AKlS");
	
	var _parseJson2 = _interopRequireDefault(_parseJson);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function selectClassStudent(props) {
	  var value = (0, _parseJson2.default)(props.value);
	
	  var mixin = props.schema.mixin;
	
	
	  return _react2.default.createElement(SelectClassStudent, _extends({}, props, {
	    mixin: mixin,
	    value: value,
	    onChange: function onChange(data) {
	      props.onChange(JSON.stringify(data));
	    } }));
	}
	
	var SelectClassStudent = (_temp = _class = function (_React$Component) {
	  _inherits(SelectClassStudent, _React$Component);
	
	  function SelectClassStudent(props) {
	    _classCallCheck(this, SelectClassStudent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	
	    _this.state = {
	      studentNames: [],
	      studentIds: [],
	      selected: _this.convertToStudentMediator(props.value || [])
	    };
	
	    props.value.map(function (student) {
	      _this.setState({ studentNames: student.student_name });
	    });
	
	    return _this;
	  }
	
	  SelectClassStudent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.value) {
	      this.setState({
	        selected: this.convertToStudentMediator(nextProps.value)
	      });
	    }
	  };
	
	  SelectClassStudent.prototype.convertToStudentMediator = function convertToStudentMediator(value) {
	    return value.map(function (raw) {
	      return new _Student2.default(raw);
	    });
	  };
	
	  SelectClassStudent.prototype.convertToObject = function convertToObject(value) {
	    if ([value].length == 1 && !Array.isArray(value)) {
	      return value.toObject();
	    } else {
	      return value.map(function (prox) {
	        return prox.toObject();
	      });
	    }
	  };
	
	  SelectClassStudent.prototype.onChange = function onChange() {
	    var _this2 = this;
	
	    var _props = this.props,
	        options = _props.options,
	        onChange = _props.onChange,
	        selectFilter = _props.selectFilter;
	    var conflictedIDs = options.conflictedIDs,
	        selectMultiple = options.selectMultiple;
	    var selected = this.state.selected;
	
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    (0, _SelectClassStudent2.default)({
	      conflictedIDs: conflictedIDs,
	      schoolId: schoolId,
	      selectMultiple: selectMultiple,
	      selected: selected
	    }).then(function (studentsOut) {
	      var studentNames = [];
	      var studentIds = [];
	      var selected = [];
	
	      if (!Array.isArray(studentsOut)) {
	        selected = [_this2.convertToObject(studentsOut)];
	      } else {
	        selected = _this2.convertToObject(studentsOut);
	      }
	
	      selected.map(function (student) {
	        studentNames.push(student.name);
	        studentIds.push(student.id);
	      });
	
	      _this2.setState({
	        studentNames: studentNames,
	        studentIds: studentIds,
	        selected: selected
	      });
	
	      onChange(selected);
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  SelectClassStudent.prototype.render = function render() {
	    var selected = this.state.selected;
	    var disableSelect = this.props.options.disableSelect;
	
	
	    var studentNamesText = void 0;
	
	    if (selected.length > 0) {
	      var arr = [];
	
	      selected.map(function (s) {
	        arr.push(s.name);
	      });
	
	      studentNamesText = arr.join(', ');
	    } else {
	      studentNamesText = _react2.default.createElement(
	        'span',
	        { className: 'no-items' },
	        __('Not Assigned', 'classdetail')
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'select-items-button' },
	      _react2.default.createElement(
	        'div',
	        { className: 'item-names' },
	        studentNamesText
	      ),
	      disableSelect !== true && _react2.default.createElement(
	        'a',
	        { className: 'select-button', onClick: this.onChange },
	        __('Select', 'class')
	      )
	    );
	  };
	
	  return SelectClassStudent;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = SelectClassStudent;

/***/ },

/***/ "MBl1":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	// User can select a student within a class
	// a wraper of TwoColumnSelectItemModal
	//
	// eg.
	// SelectClassStudent({ classId })
	//  .then()
	//  .catch()
	//
	
	
	exports.default = function (opts) {
	  var schoolId = opts.schoolId,
	      conflictedIDs = opts.conflictedIDs,
	      _opts$itemPerPage = opts.itemPerPage,
	      itemPerPage = _opts$itemPerPage === undefined ? 25 : _opts$itemPerPage;
	
	  // this will return a promise
	
	  return (0, _SelectItem2.default)(_extends({
	    headerTitle: __('Select Student', 'schedule'),
	    headerIcon: 'fa icon-book-reader',
	    itemName: __('Student', 'schedule'),
	    searchPlaceholder: __('Search Student', 'schedule'),
	    showName: true,
	    backendSearch: true,
	
	    getItemLabel: function getItemLabel(student) {
	      return student.name;
	    },
	    fetchItems: function fetchItems(cb, fetchOpts) {
	      var searchKeyword = fetchOpts.searchKeyword,
	          currentPageNumber = fetchOpts.currentPageNumber;
	
	
	      (0, _getStudentSummary2.default)({
	        schoolId: schoolId,
	        itemPerPage: itemPerPage,
	        searchKeyword: searchKeyword,
	        pageNumber: currentPageNumber,
	        studentState: 'all_not_archived'
	      }).then(function (data) {
	        var list = data.list,
	            pageAmount = data.pageAmount;
	
	
	        var pageMeta = {
	          maxPageNumber: pageAmount
	        };
	
	        cb(list.map(function (studentRaw) {
	          return new _Student2.default(studentRaw);
	        }), pageMeta);
	      }).catch(function (err) {
	        console.error(err);
	      });
	    },
	    components: {
	      SelectItem: function SelectItem(_ref) {
	        var item = _ref.item,
	            getItemLabel = _ref.getItemLabel,
	            selected = _ref.selected,
	            onClickSelect = _ref.onClickSelect,
	            selectText = _ref.selectText,
	            selectedText = _ref.selectedText;
	
	
	        var conflicted = conflictedIDs.indexOf(item.id) > -1;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'select-item' },
	          _react2.default.createElement(
	            'div',
	            null,
	            item.name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'select-button' },
	            conflicted && _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              __('Conflict', 'classdetail')
	            ),
	            selected && _react2.default.createElement(
	              'span',
	              { className: 'btn-link currently-selected', onClick: onClickSelect },
	              selectText || __('Selected', 'SelectItemModal')
	            ),
	            !selected && _react2.default.createElement(
	              'span',
	              { className: 'btn-link', onClick: onClickSelect },
	              selectedText || __('Select', 'SelectItemModal')
	            )
	          )
	        );
	      }
	    },
	    selectFilter: function selectFilter(student, alreadySelected, selected) {
	      return alreadySelected.id == student.id;
	    },
	    selected: opts.selected
	
	  }, opts));
	};
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getStudentSummary = __webpack_require__("/y3Y");
	
	var _getStudentSummary2 = _interopRequireDefault(_getStudentSummary);
	
	var _SelectItem = __webpack_require__("k6Ef");
	
	var _SelectItem2 = _interopRequireDefault(_SelectItem);
	
	var _Student = __webpack_require__("PT2B");
	
	var _Student2 = _interopRequireDefault(_Student);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ },

/***/ "AKlS":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (str) {
	  if (typeof str === 'string' && str) {
	    return JSON.parse(str);
	  } else {
	    return str;;
	  }
	};
	
	module.exports = exports['default'];

/***/ },

/***/ "Lx0Z":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * <SelectClassTeacher 
	                                                                                                                                                                                                                                                                   *	/>
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @parent anybody
	                                                                                                                                                                                                                                                                   * @stateful
	                                                                                                                                                                                                                                                                   */
	
	
	exports.selectClassTeacher = selectClassTeacher;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SelectClassTeacher = __webpack_require__("PA/s");
	
	var _SelectClassTeacher2 = _interopRequireDefault(_SelectClassTeacher);
	
	__webpack_require__("zJYP");
	
	var _parseJson = __webpack_require__("AKlS");
	
	var _parseJson2 = _interopRequireDefault(_parseJson);
	
	var _Teacher = __webpack_require__("xSer");
	
	var _Teacher2 = _interopRequireDefault(_Teacher);
	
	var _constants = __webpack_require__("7rIE");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//
	// for ui:widget
	//
	function selectClassTeacher(props) {
	  var mixin = props.schema.mixin;
	
	
	  var value = (0, _parseJson2.default)(props.value);
	  return _react2.default.createElement(SelectClassTeacher, _extends({}, props, {
	    mixin: mixin,
	    value: value,
	    onChange: function onChange(data) {
	      props.onChange(JSON.stringify(data));
	    } }));
	}
	
	var SelectClassTeacher = (_temp = _class = function (_React$Component) {
	  _inherits(SelectClassTeacher, _React$Component);
	
	  function SelectClassTeacher(props) {
	    _classCallCheck(this, SelectClassTeacher);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	
	    _this.state = {
	      teacherNames: [],
	      teacherIds: [],
	      selected: _this.convertToMediator(props.value || [])
	    };
	
	    return _this;
	  }
	
	  SelectClassTeacher.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.value) {
	      this.setState({
	        selected: this.convertToMediator(nextProps.value)
	      });
	    }
	  };
	
	  SelectClassTeacher.prototype.convertToMediator = function convertToMediator(value) {
	
	    return value.map(function (raw) {
	      return new _Teacher2.default(raw);
	    });
	  };
	
	  SelectClassTeacher.prototype.convertToObject = function convertToObject(value) {
	    return value.map(function (prox) {
	      return prox.toObject();
	    });
	  };
	
	  SelectClassTeacher.prototype.onChange = function onChange() {
	    var _this2 = this;
	
	    var _props = this.props,
	        options = _props.options,
	        onChange = _props.onChange,
	        selectFilter = _props.selectFilter;
	    var conflictedIDs = options.conflictedIDs,
	        selectMultiple = options.selectMultiple;
	
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    var selected = this.state.selected;
	
	
	    (0, _SelectClassTeacher2.default)({
	      conflictedIDs: conflictedIDs,
	      schoolId: schoolId,
	      selectMultiple: selectMultiple,
	      selected: selected
	    }).then(function (selectedOut) {
	      var teacherNames = [];
	      var teacherIds = [];
	      var selected = [];
	
	      if (!Array.isArray(selectedOut)) {
	        selected = [_this2.convertToObject(selectedOut)];
	      } else {
	        selected = _this2.convertToObject(selectedOut);
	      }
	
	      selected.map(function (teacher) {
	        teacherNames.push(teacher.stName);
	        teacherIds.push(teacher.id);
	      });
	
	      _this2.setState({
	        teacherNames: teacherNames,
	        teacherIds: teacherIds,
	        selected: selected
	      });
	
	      onChange(selected);
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  SelectClassTeacher.prototype.render = function render() {
	    var selected = this.state.selected;
	    var disableSelect = this.props.options.disableSelect;
	
	
	    var teacherNames = selected.map(function (teacher) {
	      return teacher.name || teacher.tName;
	    });
	
	    var teacherNamesText = teacherNames.length > 0 ? teacherNames.join(', ') : _react2.default.createElement(
	      'span',
	      { className: 'no-items' },
	      __('Not Assigned', 'classdetail')
	    );
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'select-items-button' },
	      _react2.default.createElement(
	        'div',
	        { className: 'item-names' },
	        teacherNamesText
	      ),
	      disableSelect !== true && _react2.default.createElement(
	        'a',
	        { className: 'select-button', onClick: this.onChange },
	        __('Select', 'class')
	      )
	    );
	  };
	
	  return SelectClassTeacher;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = SelectClassTeacher;

/***/ },

/***/ "PA/s":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	// User can select a teacher within a class
	// a wraper of SelectItemModal
	//
	// eg.
	// SelectClassTeacher({ classId })
	//  .then()
	//  .catch()
	//
	
	
	exports.default = function (opts) {
	  var schoolId = opts.schoolId,
	      conflictedIDs = opts.conflictedIDs,
	      selectMultiple = opts.selectMultiple,
	      _opts$amount_per_page = opts.amount_per_page,
	      amount_per_page = _opts$amount_per_page === undefined ? 25 : _opts$amount_per_page;
	
	  // this will return a promise
	
	  return (0, _SelectItem2.default)(_extends({
	    headerTitle: __('Select Teacher', 'schedule'),
	    headerIcon: 'fa icon-chalkboard-teacher',
	    itemName: __('Teacher', 'schedule'),
	    searchPlaceholder: __('Search Teacher', 'schedule'),
	    selectMultiple: selectMultiple,
	    showName: true,
	    backendSearch: true,
	    getItemLabel: function getItemLabel(teacher) {
	      return teacher.name;
	    },
	    fetchItems: function fetchItems(cb, fetchOpts) {
	      var searchKeyword = fetchOpts.searchKeyword,
	          currentPageNumber = fetchOpts.currentPageNumber;
	
	
	      (0, _getCurrentTeacher2.default)({
	        schoolId: schoolId,
	        current_page_number: currentPageNumber,
	        keyword: searchKeyword,
	        amount_per_page: amount_per_page
	      }).then(function (data) {
	        var list = data.list,
	            page_amount = data.page_amount;
	
	
	        var pageMeta = {
	          maxPageNumber: page_amount
	        };
	
	        var teacherObjs = list.map(function (raw) {
	          return new _Teacher2.default(raw);
	        });
	
	        cb(teacherObjs, pageMeta);
	      }).catch(function (err) {
	        console.error(err);
	      });
	    },
	    components: {
	      SelectItem: function SelectItem(_ref) {
	        var item = _ref.item,
	            getItemLabel = _ref.getItemLabel,
	            selected = _ref.selected,
	            onClickSelect = _ref.onClickSelect,
	            selectText = _ref.selectText,
	            selectedText = _ref.selectedText,
	            mixin = _ref.mixin;
	
	
	        var conflicted = conflictedIDs.indexOf(item.id) > -1;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'select-item' },
	          _react2.default.createElement(
	            'div',
	            null,
	            item.name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'select-button' },
	            conflicted && _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              __('Conflict', 'classdetail')
	            ),
	            selected && _react2.default.createElement(
	              'span',
	              { className: 'btn-link currently-selected', onClick: onClickSelect },
	              selectText || __('Selected', 'SelectItemModal')
	            ),
	            !selected && _react2.default.createElement(
	              'span',
	              { className: 'btn-link', onClick: onClickSelect },
	              selectedText || __('Select', 'SelectItemModal')
	            )
	          )
	        );
	      }
	    },
	    selectFilter: function selectFilter(item, alreadySelected, selected) {
	      return alreadySelected.id == item.id;
	    },
	
	    selected: opts.selected
	
	  }, opts));
	};
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectItem = __webpack_require__("k6Ef");
	
	var _SelectItem2 = _interopRequireDefault(_SelectItem);
	
	var _getCurrentTeacher = __webpack_require__("PRcT");
	
	var _getCurrentTeacher2 = _interopRequireDefault(_getCurrentTeacher);
	
	var _Teacher = __webpack_require__("xSer");
	
	var _Teacher2 = _interopRequireDefault(_Teacher);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ },

/***/ "PRcT":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getCurrentTeacher;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getCurrentTeacher(opts) {
	
	  if (!opts.schoolId) {
	    throw 'Missing school ID';
	  }
	
	  var query = _queryString2.default.stringify({
	    amount_per_page: opts.amount_per_page,
	    current_page_number: opts.current_page_number,
	    keyword: opts.keyword,
	    order_by: opts.order_by
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/rgst_tch/" + opts.schoolId + "/?archived=false&" + query,
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "xSer":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Mediator2 = __webpack_require__("ek+r");
	
	var _Mediator3 = _interopRequireDefault(_Mediator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Teacher = function (_Mediator) {
	  _inherits(Teacher, _Mediator);
	
	  function Teacher(data) {
	    var _ret2;
	
	    _classCallCheck(this, Teacher);
	
	    var _this = _possibleConstructorReturn(this, _Mediator.call(this, data));
	
	    if (data instanceof _Mediator3.default) {
	      var _ret;
	
	      return _ret = _this, _possibleConstructorReturn(_this, _ret);
	    }
	
	    _this.setVersion('v1', ['id', 'tName', 'stArchived', 'stRemark', 'stState', 'tEmail', 'tGender', 'tGender', 'tPhone', 'taughthours', 'taughttimes', 'profile_photo', 'profile_photo_thumbnail_1x', 'profile_photo_thumbnail_2x', 'profile_photo_thumbnail_8x', 'stPhone_parsed']);
	
	    _this.setVersion('v2', ['id', 'stName', 'stGender', 'profile_photo', 'profile_photo_thumbnail_1x', 'profile_photo_thumbnail_2x', 'profile_photo_thumbnail_8x']);
	
	    _this.setVersion('v3', ['teacher_id', 'stName']);
	
	    _this.__schema = {
	      id: {
	        alias: ['id', 'teacher_id']
	      },
	      name: {
	        alias: ['name', 'stName', 'tName']
	      },
	      gender: {
	        alias: ['gender', 'stGender', 'tGender']
	      },
	      archived: {
	        alias: ['archived', 'stArchived']
	      },
	      remark: {
	        alias: ['remark', 'stRemark']
	      },
	      email: {
	        alias: ['email', 'tEmail', 'stEmail']
	      },
	      phone: {
	        alias: ['tPhone', 'phone', 'stPhone']
	      },
	      phoneParsed: {
	        alias: ['stPhone_parsed']
	      },
	      taughtHours: {
	        alias: ['taughthours']
	      },
	      taughtTimes: {
	        alias: ['taughttimes']
	      },
	      profilePhoto: {
	        alias: ['profile_photo']
	      },
	      profilePhotoThumbnail1x: {
	        alias: ['photo_thumbnail_1x']
	      },
	      profilePhotoThumbnail2x: {
	        alias: ['photo_thumbnail_2x']
	      },
	      profilePhotoThumbnail8x: {
	        alias: ['photo_thumbnail_8x']
	      }
	    };
	
	    return _ret2 = _this.create(), _possibleConstructorReturn(_this, _ret2);
	  }
	
	  return Teacher;
	}(_Mediator3.default);
	
	exports.default = Teacher;
	module.exports = exports['default'];

/***/ },

/***/ "qPpx":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * <SelectTeacher
	                                                                                                                                                                                                                                                                   *		// please describe props here
	                                                                                                                                                                                                                                                                   *	/>
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @parent anybody
	                                                                                                                                                                                                                                                                   * @stateful
	                                                                                                                                                                                                                                                                   */
	
	
	exports.selectTeacher = selectTeacher;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SelectTeacher = __webpack_require__("okp6");
	
	var _SelectTeacher2 = _interopRequireDefault(_SelectTeacher);
	
	__webpack_require__("zJYP");
	
	var _parseJson = __webpack_require__("AKlS");
	
	var _parseJson2 = _interopRequireDefault(_parseJson);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function selectTeacher(props) {
	  var value = (0, _parseJson2.default)(props.value);
	  return _react2.default.createElement(SelectTeacher, _extends({}, props, {
	    value: value,
	    onChange: function onChange(data) {
	      props.onChange(JSON.stringify(data));
	    } }));
	}
	
	var SelectTeacher = (_temp = _class = function (_React$Component) {
	  _inherits(SelectTeacher, _React$Component);
	
	  function SelectTeacher(props) {
	    _classCallCheck(this, SelectTeacher);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	
	    var teachers = props.value;
	
	    _this.state = {
	      teacherIds: [],
	      teachers: teachers || []
	    };
	    return _this;
	  }
	
	  SelectTeacher.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.value) {
	      this.setState({
	        teachers: nextProps.value
	      });
	    }
	  };
	
	  SelectTeacher.prototype.valueToTeachers = function valueToTeachers(value) {
	    return JSON.parse(value);
	  };
	
	  SelectTeacher.prototype.componentWillMount = function componentWillMount() {};
	
	  SelectTeacher.prototype.onChange = function onChange() {
	    var _this2 = this;
	
	    var _props = this.props,
	        _props$options = _props.options,
	        options = _props$options === undefined ? {} : _props$options,
	        onChange = _props.onChange;
	    var selectMultiple = options.selectMultiple;
	    var teachers = this.state.teachers;
	
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    (0, _SelectTeacher2.default)({
	      schoolId: schoolId,
	      selectMultiple: selectMultiple,
	      selected: teachers
	    }).then(function (teachersOut) {
	      var teacherIds = [];
	      var teachers = [];
	
	      if (!Array.isArray(teachersOut)) {
	        teachers = [teachersOut];
	      } else {
	        teachers = teachersOut;
	      }
	
	      teachers.map(function (teacher) {
	        teacherIds.push(teacher.id);
	      });
	
	      _this2.setState({
	        teacherIds: teacherIds,
	        teachers: teachers
	      });
	
	      onChange(teachers);
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  SelectTeacher.prototype.render = function render() {
	    var _state$teachers = this.state.teachers,
	        teachers = _state$teachers === undefined ? [] : _state$teachers;
	
	
	    var teacherNamesText = void 0;
	
	    if (teachers.length > 0) {
	      var comma = '';
	      teacherNamesText = teachers.map(function (teacher, idx) {
	        var TeacherLink = _react2.default.createElement(
	          'span',
	          { key: idx },
	          comma,
	          teacher.name || teacher.tName
	        );
	        comma = ', ';
	        return TeacherLink;
	      });
	    } else {
	      teacherNamesText = _react2.default.createElement(
	        'span',
	        { className: 'no-items' },
	        __('Not Assigned', 'others')
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'select-items-button' },
	      _react2.default.createElement(
	        'div',
	        { className: 'item-names col-sm-10' },
	        teacherNamesText
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'select-toolbar col-sm-2' },
	        _react2.default.createElement(
	          'a',
	          { className: 'btn-link pull-right', onClick: this.onChange },
	          __('Select', 'class')
	        )
	      )
	    );
	  };
	
	  return SelectTeacher;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = SelectTeacher;

/***/ },

/***/ "okp6":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	// User can select a teacher
	// a wraper of SelectItemModal
	//
	// eg.
	// SelectTeacher({ schoolId })
	//  .then()
	//  .catch()
	//
	
	
	exports.default = function (opts) {
	  var schoolId = opts.schoolId,
	      selectMultiple = opts.selectMultiple,
	      _opts$amount_per_page = opts.amount_per_page,
	      amount_per_page = _opts$amount_per_page === undefined ? 25 : _opts$amount_per_page;
	
	  // this will return a promise
	
	  return (0, _SelectItem2.default)(_extends({
	    headerTitle: __('Select Teacher', 'schedule'),
	    headerIcon: 'fa icon-chalkboard-teacher',
	    itemName: __('Teacher', 'schedule'),
	    searchPlaceholder: __('Search Teacher', 'schedule'),
	    selectMultiple: selectMultiple,
	    showName: true,
	
	    backendSearch: true,
	
	    getItemLabel: function getItemLabel(teacher) {
	      return teacher.name || teacher.tName;
	    },
	    fetchItems: function fetchItems(cb, fetchOpts) {
	      var searchKeyword = fetchOpts.searchKeyword,
	          currentPageNumber = fetchOpts.currentPageNumber;
	
	
	      (0, _getCurrentTeacher2.default)({
	        schoolId: schoolId,
	        current_page_number: currentPageNumber,
	        keyword: searchKeyword,
	        amount_per_page: amount_per_page
	      }).then(function (data) {
	        var list = data.list,
	            page_amount = data.page_amount;
	
	
	        var pageMeta = {
	          maxPageNumber: page_amount
	        };
	
	        var teacherObjs = list.map(function (raw) {
	          return new _Teacher2.default(raw);
	        });
	
	        cb(teacherObjs, pageMeta);
	      }).catch(function (err) {
	        console.error(err);
	      });
	    },
	    selectFilter: function selectFilter(item, alreadySelected, selected) {
	      return alreadySelected.id == item.id;
	    }
	
	  }, opts));
	};
	
	var _SelectItem = __webpack_require__("k6Ef");
	
	var _SelectItem2 = _interopRequireDefault(_SelectItem);
	
	var _getCurrentTeacher = __webpack_require__("PRcT");
	
	var _getCurrentTeacher2 = _interopRequireDefault(_getCurrentTeacher);
	
	var _Teacher = __webpack_require__("xSer");
	
	var _Teacher2 = _interopRequireDefault(_Teacher);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ },

/***/ "2J0w":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <SelectClass 
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children 
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SelectClass = __webpack_require__("/wCL");
	
	var _SelectClass2 = _interopRequireDefault(_SelectClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectClass = (_temp = _class = function (_React$Component) {
	  _inherits(SelectClass, _React$Component);
	
	  function SelectClass(props) {
	    _classCallCheck(this, SelectClass);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  SelectClass.prototype.componentWillMount = function componentWillMount() {};
	
	  SelectClass.prototype.render = function render() {
	    var props = this.props;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'select-class-button' },
	      'class',
	      _react2.default.createElement(
	        'a',
	        { className: 'btn-link', onClick: function onClick() {
	            var schoolId = localStorage.getItem('schoolId');
	            var selectMultiple = props.options.selectMultiple;
	
	
	            (0, _SelectClass2.default)({ schoolId: schoolId, selectMultiple: selectMultiple }).then(function (classs) {
	              props.onChange(classs);
	            }).catch(function (err) {
	              console.error(err);
	            });
	          } },
	        __('Select', 'class')
	      )
	    );
	  };
	
	  return SelectClass;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = SelectClass;
	module.exports = exports['default'];

/***/ },

/***/ "/wCL":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	// User can select a class.
	// a wraper of SelectItemModal
	//
	// eg.
	// SelectClass({ schoolId })
	//  .then()
	//  .catch()
	//
	
	
	exports.default = function (opts) {
	  var schoolId = opts.schoolId,
	      _opts$itemPerPage = opts.itemPerPage,
	      itemPerPage = _opts$itemPerPage === undefined ? 25 : _opts$itemPerPage;
	
	  // this will return a promise
	
	  return (0, _SelectItem2.default)(_extends({
	    headerTitle: __('Select Class', 'schedule'),
	    headerIcon: 'fa icon-users',
	    itemName: __('Class', 'schedule'),
	    searchPlaceholder: __('Search Class', 'schedule'),
	    backendSearch: true,
	    getItemLabel: function getItemLabel(item) {
	      return item.cName;
	    },
	    fetchItems: function fetchItems(cb, fetchOpts) {
	      var searchKeyword = fetchOpts.searchKeyword,
	          currentPageNumber = fetchOpts.currentPageNumber;
	
	
	      (0, _getClassBy2.default)({
	        schoolId: schoolId,
	        type: 'all',
	        state: 'all',
	        amount_per_page: itemPerPage,
	        current_page_number: currentPageNumber,
	        keyword: searchKeyword,
	        order_by: 0,
	        detail: 0
	      }).then(function (data) {
	        var classList = data.classList,
	            page_amount = data.page_amount;
	
	        var pageMeta = {
	          maxPageNumber: page_amount
	        };
	        var newClassList = [];
	        classList.map(function (cls) {
	          newClassList.push({ id: cls.classID, cName: cls.className });
	        });
	
	        cb(newClassList, pageMeta);
	      }).catch(function (err) {
	        console.error(err);
	      });
	    }
	
	  }, opts));
	};
	
	var _SelectItem = __webpack_require__("k6Ef");
	
	var _SelectItem2 = _interopRequireDefault(_SelectItem);
	
	var _getClassBy = __webpack_require__("OC/R");
	
	var _getClassBy2 = _interopRequireDefault(_getClassBy);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ },

/***/ "OC/R":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = getClassBy;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CLASS_TYPES = ['group', '1on1', 'all'];
	var CLASS_STATES = ['archived', 'current', 'all'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
		schoolId: _joiBrowser2.default.number().integer().required(),
		type: _joiBrowser2.default.string().valid(CLASS_TYPES).required(),
		state: _joiBrowser2.default.string().valid(CLASS_STATES).required(),
		amount_per_page: _joiBrowser2.default.number().allow(''),
		current_page_number: _joiBrowser2.default.number().allow(''),
		keyword: _joiBrowser2.default.string().allow(''),
		order_by: _joiBrowser2.default.number().allow(''),
		detail: _joiBrowser2.default.number().allow('')
	});
	
	function getClassBy(opts) {
	
		var validateResult = _joiBrowser2.default.validate(opts, schema);
	
		if (validateResult.error) {
			return new Promise(function (resolve, reject) {
				reject(validateResult);
			});
		}
	
		var type = CLASS_TYPES.indexOf(opts.type);
		var state = CLASS_STATES.indexOf(opts.state);
	
		var query = _queryString2.default.stringify({
			amount_per_page: opts.amount_per_page,
			current_page_number: opts.current_page_number,
			keyword: opts.keyword,
			order_by: opts.order_by,
			detail: opts.detail
		});
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put('/proxy', {
				'uri': '/g_clslstbytype/' + opts.schoolId + '/' + type + '/' + state + '/?' + query,
				'method': 'GET',
				'token': localStorage.getItem('token')
			}).then(function (res) {
				resolve(res.data);
			}).catch(function (err) {
				reject(err);
			});
		});
	}

/***/ },

/***/ "tYCd":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * <SelectClassroom 
	                                                                                                                                                                                                                                                                   *		// please describe props here
	                                                                                                                                                                                                                                                                   *	/>
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @parent anybody
	                                                                                                                                                                                                                                                                   * @stateful
	                                                                                                                                                                                                                                                                   */
	
	
	exports.selectClassroom = selectClassroom;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SelectClassroom = __webpack_require__("wPVy");
	
	var _SelectClassroom2 = _interopRequireDefault(_SelectClassroom);
	
	__webpack_require__("zJYP");
	
	var _Classroom = __webpack_require__("WLpk");
	
	var _Classroom2 = _interopRequireDefault(_Classroom);
	
	var _parseJson = __webpack_require__("AKlS");
	
	var _parseJson2 = _interopRequireDefault(_parseJson);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function selectClassroom(props) {
	  var value = (0, _parseJson2.default)(props.value);
	  return _react2.default.createElement(SelectClassroom, _extends({}, props, {
	    value: value,
	    onChange: function onChange(data) {
	      props.onChange(JSON.stringify(data));
	    } }));
	}
	
	var SelectClassroom = (_temp = _class = function (_React$Component) {
	  _inherits(SelectClassroom, _React$Component);
	
	  function SelectClassroom(props) {
	    _classCallCheck(this, SelectClassroom);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	
	    _this.state = {
	      classroomNames: [],
	      classroomIds: [],
	      classrooms: _this.convertToMediator(props.value || [])
	    };
	    return _this;
	  }
	
	  SelectClassroom.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.value) {
	      this.setState({
	        classrooms: this.convertToMediator(nextProps.value)
	      });
	    }
	  };
	
	  SelectClassroom.prototype.convertToMediator = function convertToMediator(value) {
	    return value.map(function (raw) {
	      return new _Classroom2.default(raw);
	    });
	  };
	
	  SelectClassroom.prototype.convertToObject = function convertToObject(value) {
	    return value.map(function (prox) {
	      return prox.toObject();
	    });
	  };
	
	  SelectClassroom.prototype.onChange = function onChange() {
	    var _this2 = this;
	
	    var _props = this.props,
	        options = _props.options,
	        onChange = _props.onChange;
	    var selectMultiple = options.selectMultiple,
	        conflictedIDs = options.conflictedIDs;
	    var classrooms = this.state.classrooms;
	
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    (0, _SelectClassroom2.default)({
	      conflictedIDs: conflictedIDs,
	      schoolId: schoolId,
	      selectMultiple: selectMultiple,
	      selected: classrooms
	    }).then(function (classroomsOut) {
	      var classroomNames = [];
	      var classroomIds = [];
	      var classrooms = [];
	
	      if (!Array.isArray(classroomsOut)) {
	        classrooms = [classroomsOut];
	      } else {
	        classrooms = classroomsOut;
	      }
	
	      classrooms.map(function (classroom) {
	        classroomNames.push(classroom.name);
	        classroomIds.push(classroom.id);
	      });
	
	      _this2.setState({
	        classroomNames: classroomNames,
	        classroomIds: classroomIds,
	        classrooms: classrooms
	      });
	
	      onChange(_this2.convertToObject(classrooms));
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  SelectClassroom.prototype.render = function render() {
	    var _state = this.state,
	        classroomNames = _state.classroomNames,
	        classrooms = _state.classrooms;
	
	
	    var classroomNamesText = void 0;
	
	    if (classrooms.length > 0) {
	      var comma = '';
	      classroomNamesText = classrooms.map(function (classroom, idx) {
	        var ClassroomLink = _react2.default.createElement(
	          'span',
	          { key: idx },
	          comma,
	          classroom.name
	        );
	        comma = ', ';
	        return ClassroomLink;
	      });
	    } else {
	      classroomNamesText = _react2.default.createElement(
	        'span',
	        { className: 'no-items' },
	        __('Not Assigned', 'classdetail')
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'select-items-button' },
	      _react2.default.createElement(
	        'div',
	        { className: 'item-names' },
	        classroomNamesText
	      ),
	      _react2.default.createElement(
	        'a',
	        { className: 'select-button', onClick: this.onChange },
	        __('Select', 'class')
	      )
	    );
	  };
	
	  return SelectClassroom;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = SelectClassroom;

/***/ },

/***/ "vJje":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * <DatePicker
	                                                                                                                                                                                                                                                                   *	/>
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * A custom wrapper for singleDatePicker
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @parent anybody
	                                                                                                                                                                                                                                                                   * @stateful
	                                                                                                                                                                                                                                                                   */
	
	exports.datepicker = datepicker;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("lj70");
	
	__webpack_require__("DTuZ");
	
	var _reactDates = __webpack_require__("OjkW");
	
	__webpack_require__("c5Zy");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__("7rIE");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function datepicker(props) {
	  return _react2.default.createElement(DatePicker, _extends({}, props, { onChange: function onChange(date) {
	      props.onChange(date.format(_constants.DATE_FORMAT));
	    } }));
	}
	
	var DatePicker = function (_React$Component) {
	  _inherits(DatePicker, _React$Component);
	
	  function DatePicker(props) {
	    _classCallCheck(this, DatePicker);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	
	    _this.state = {};
	
	    if (props.value) {
	      _this.state.date = (0, _moment2.default)(props.value, _constants.DATE_FORMAT);
	    }
	    return _this;
	  }
	
	  DatePicker.prototype.onChange = function onChange(date) {
	    var _this2 = this;
	
	    this.setState({ date: date }, function () {
	      _this2.props.onChange(date);
	    });
	  };
	
	  DatePicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	
	    if (typeof nextProps.value === 'string') {
	      this.setState({
	        date: (0, _moment2.default)(nextProps.value, _constants.DEFAULT_DATE_PLACEHOLDER)
	      });
	    }
	
	    if (nextProps.date) {
	      this.setState({
	        date: nextProps.date
	      });
	    }
	  };
	
	  DatePicker.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        options = _props.options,
	        placeholder = _props.placeholder,
	        displayFormat = _props.displayFormat,
	        disabled = _props.disabled;
	    var _state = this.state,
	        startDate = _state.startDate,
	        endDate = _state.endDate,
	        date = _state.date;
	
	
	    if (options) {
	      delete options.enumOptions;
	      delete options.emptyValue;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'date-range-picker form-input' },
	      _react2.default.createElement(_reactDates.SingleDatePicker, _extends({
	        placeholder: placeholder || _constants.DEFAULT_DATE_PLACEHOLDER,
	        displayFormat: displayFormat || _constants.DATE_FORMAT,
	        numberOfMonths: 1,
	        small: true,
	        date: date,
	        onDateChange: this.onChange // PropTypes.func.isRequired
	        , focused: this.state.focused // PropTypes.bool
	        , onFocusChange: function onFocusChange(_ref) {
	          var focused = _ref.focused;
	          return _this3.setState({ focused: focused });
	        } // PropTypes.func.isRequired
	        , isOutsideRange: function isOutsideRange() {
	          return false;
	        },
	        disabled: disabled || false
	      }, options))
	    );
	  };
	
	  return DatePicker;
	}(_react2.default.Component);
	
	exports.default = DatePicker;

/***/ },

/***/ "c5Zy":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"SingleDatePicker":"SingleDatePicker","SingleDatePickerInput":"SingleDatePickerInput","DateInput":"DateInput","DateInput_input__focused":"DateInput_input__focused"};

/***/ },

/***/ "V3L3":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * <SelectDaysInWeekField />
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @parent anybody
	                                                                                                                                                                                                                                                                   * @stateful
	                                                                                                                                                                                                                                                                   */
	
	
	exports.selectDaysInWeek = selectDaysInWeek;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("rrch");
	
	var _SearchList = __webpack_require__("B5jL");
	
	var _SearchList2 = _interopRequireDefault(_SearchList);
	
	var _parseJson = __webpack_require__("AKlS");
	
	var _parseJson2 = _interopRequireDefault(_parseJson);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectItem = function SelectItem(_ref) {
	  var item = _ref.item,
	      getItemLabel = _ref.getItemLabel,
	      selected = _ref.selected,
	      onClickSelect = _ref.onClickSelect,
	      selectText = _ref.selectText,
	      selectedText = _ref.selectedText;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('select-day', { 'selected': selected }) },
	    _react2.default.createElement(
	      'label',
	      null,
	      item.label,
	      _react2.default.createElement('input', { type: 'checkbox', onChange: onClickSelect })
	    )
	  );
	};
	
	function selectDaysInWeek(props) {
	  var value = (0, _parseJson2.default)(props.value);
	  return _react2.default.createElement(SelectDaysInWeekField, _extends({}, props, {
	    value: value,
	    onChange: function onChange(data) {
	      props.onChange(JSON.stringify(data));
	    } }));
	}
	
	var SelectDaysInWeekField = (_temp = _class = function (_React$Component) {
	  _inherits(SelectDaysInWeekField, _React$Component);
	
	  function SelectDaysInWeekField(props) {
	    _classCallCheck(this, SelectDaysInWeekField);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onSelect = _this.onSelect.bind(_this);
	
	    _this.itemList = [{ label: __('Mon', 'weekdays'), value: 1 }, { label: __('Tue', 'weekdays'), value: 2 }, { label: __('Wed', 'weekdays'), value: 3 }, { label: __('Thu', 'weekdays'), value: 4 }, { label: __('Fri', 'weekdays'), value: 5 }, { label: __('Sat', 'weekdays'), value: 6 }, { label: __('Sun', 'weekdays'), value: 7 }];
	
	    _this.state = {
	      selected: _this.props.value || []
	    };
	    return _this;
	  }
	
	  SelectDaysInWeekField.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref2) {
	    var value = _ref2.value;
	
	    if (Array.isArray(value)) {
	      this.setState({
	        selected: this.itemList.filter(function (item) {
	          return value.indexOf(item.value) > -1;
	        })
	      });
	    }
	  };
	
	  SelectDaysInWeekField.prototype.onSelect = function onSelect(selected) {
	    var arr = selected.map(function (item) {
	      return item.value;
	    });
	
	    this.props.onChange(arr);
	  };
	
	  SelectDaysInWeekField.prototype.render = function render() {
	    var value = this.props.value;
	    var selected = this.state.selected;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'select-days-in-week form-input' },
	      _react2.default.createElement(_SearchList2.default, {
	        itemList: this.itemList,
	        components: {
	          SelectItem: SelectItem
	        },
	        sortSelected: false,
	        allowDeselect: true,
	        mutipleSelect: true,
	        hideSearchbar: true,
	        onSelect: this.onSelect,
	        selected: selected
	      })
	    );
	  };
	
	  return SelectDaysInWeekField;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = SelectDaysInWeekField;

/***/ },

/***/ "rrch":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"select-days-in-week":"select-days-in-week","select-day":"select-day","selected":"selected","box-style":"box-style","select-list":"select-list"};

/***/ },

/***/ "qLay":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * <SelectDaysInMonthField />
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @parent anybody
	                                                                                                                                                                                                                                                                   * @stateful
	                                                                                                                                                                                                                                                                   */
	
	
	exports.selectDaysInMonth = selectDaysInMonth;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("JWQK");
	
	var _SearchList = __webpack_require__("B5jL");
	
	var _SearchList2 = _interopRequireDefault(_SearchList);
	
	var _times = __webpack_require__("sHbl");
	
	var _times2 = _interopRequireDefault(_times);
	
	var _parseJson = __webpack_require__("AKlS");
	
	var _parseJson2 = _interopRequireDefault(_parseJson);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DAYS_IN_MONTH = (0, _times2.default)(31, function (idx) {
	  return {
	    label: (idx + 1).toString(),
	    value: idx + 1
	  };
	});
	
	var SelectItem = function SelectItem(_ref) {
	  var item = _ref.item,
	      getItemLabel = _ref.getItemLabel,
	      selected = _ref.selected,
	      onClickSelect = _ref.onClickSelect,
	      selectText = _ref.selectText,
	      selectedText = _ref.selectedText;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('select-day', { 'selected': selected }), onClick: onClickSelect },
	    item.label
	  );
	};
	
	function selectDaysInMonth(props) {
	  var value = (0, _parseJson2.default)(props.value);
	  return _react2.default.createElement(SelectDaysInMonthField, _extends({}, props, {
	    value: value,
	    onChange: function onChange(data) {
	      props.onChange(JSON.stringify(data));
	    } }));
	}
	
	var SelectDaysInMonthField = (_temp = _class = function (_React$Component) {
	  _inherits(SelectDaysInMonthField, _React$Component);
	
	  function SelectDaysInMonthField(props) {
	    _classCallCheck(this, SelectDaysInMonthField);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onSelect = _this.onSelect.bind(_this);
	    _this.state = {
	      selected: _this.props.value || []
	    };
	    return _this;
	  }
	
	  SelectDaysInMonthField.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref2) {
	    var value = _ref2.value;
	
	    if (Array.isArray(value)) {
	      this.setState({
	        selected: DAYS_IN_MONTH.filter(function (item) {
	          return value.indexOf(item.value) > -1;
	        })
	      });
	    }
	  };
	
	  SelectDaysInMonthField.prototype.onSelect = function onSelect(selected) {
	    var arr = selected.map(function (item) {
	      return item.value;
	    });
	
	    this.props.onChange(arr);
	  };
	
	  SelectDaysInMonthField.prototype.render = function render() {
	    var value = this.props.value;
	    var selected = this.state.selected;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'select-days-in-month form-input' },
	      _react2.default.createElement(_SearchList2.default, {
	        itemList: DAYS_IN_MONTH,
	        components: {
	          SelectItem: SelectItem
	        },
	        sortSelected: false,
	        allowDeselect: true,
	        mutipleSelect: true,
	        hideSearchbar: true,
	        onSelect: this.onSelect,
	        selected: selected
	      })
	    );
	  };
	
	  return SelectDaysInMonthField;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = SelectDaysInMonthField;

/***/ },

/***/ "JWQK":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"select-days-in-month":"select-days-in-month","select-list":"select-list","select-day":"select-day","selected":"selected"};

/***/ },

/***/ "Z40E":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.reactselect = reactselect;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSelectPlus = __webpack_require__("6+tB");
	
	var _reactSelectPlus2 = _interopRequireDefault(_reactSelectPlus);
	
	__webpack_require__("18aU");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ReactSelect />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	function reactselect(props) {
	  var schema = props.schema,
	      _onChange = props.onChange,
	      options = props.options,
	      placeholder = props.placeholder,
	      disabled = props.disabled;
	  var noResultsText = options.noResultsText,
	      direction = options.direction,
	      clearable = options.clearable,
	      selectOptions = options.selectOptions,
	      joinValues = options.joinValues,
	      delimiter = options.delimiter,
	      multi = options.multi;
	  var name = schema.name;
	
	
	  var value = void 0;
	  if (multi == true) {
	    if (props.value) {
	      value = JSON.parse(props.value);
	    } else {
	      value = [];
	    }
	  } else {
	    value = props.value;
	  }
	
	  return _react2.default.createElement(ReactSelect, {
	    name: name,
	    value: value,
	    options: selectOptions,
	    direction: direction,
	    clearable: clearable,
	    placeholder: placeholder,
	    joinValues: joinValues,
	    delimiter: delimiter,
	    multi: multi,
	    disabled: disabled,
	    onChange: function onChange(value) {
	      if (Array.isArray(value)) {
	        _onChange(JSON.stringify(value));
	      } else {
	        _onChange(value);
	      }
	    }
	  });
	}
	
	var ReactSelect = function (_React$Component) {
	  _inherits(ReactSelect, _React$Component);
	
	  function ReactSelect(props) {
	    _classCallCheck(this, ReactSelect);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ReactSelect.prototype.render = function render() {
	    var _props = this.props,
	        name = _props.name,
	        value = _props.value,
	        options = _props.options,
	        placeholder = _props.placeholder,
	        noResultsText = _props.noResultsText,
	        _onChange2 = _props.onChange,
	        clearable = _props.clearable,
	        direction = _props.direction,
	        multi = _props.multi,
	        _props$delimiter = _props.delimiter,
	        delimiter = _props$delimiter === undefined ? ';' : _props$delimiter,
	        joinValues = _props.joinValues,
	        disabled = _props.disabled;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('react-select-wrapper form-input', 'direction-' + direction || 'down') },
	      _react2.default.createElement(_reactSelectPlus2.default, {
	        name: name,
	        value: value,
	        onChange: function onChange(item) {
	          if (Array.isArray(item)) {
	            _onChange2(item.map(function (_ref) {
	              var value = _ref.value;
	
	              return value;
	            }));
	          } else {
	            _onChange2(!item ? null : item.value);
	          }
	        },
	        delimiter: delimiter,
	        multi: multi,
	        clearable: clearable === true,
	        options: options,
	        placeholder: placeholder,
	        noResultsText: noResultsText,
	        joinValues: joinValues,
	        disabled: disabled
	
	      })
	    );
	  };
	
	  return ReactSelect;
	}(_react2.default.Component);
	
	exports.default = ReactSelect;

/***/ },

/***/ "18aU":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Select":"Select","Select-menu-outer":"Select-menu-outer","Select-option-group-label":"Select-option-group-label"};

/***/ },

/***/ "ytvc":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * <ColorPicker />
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @parent anybody
	                                                                                                                                                                                                                                                                   * @stateful
	                                                                                                                                                                                                                                                                   */
	
	
	exports.colorpicker = colorpicker;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSelect = __webpack_require__("tTw2");
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactColor = __webpack_require__("orX9");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function colorpicker(props) {
	  var value = props.value,
	      schema = props.schema,
	      onChange = props.onChange,
	      options = props.options,
	      placeholder = props.placeholder;
	  var name = schema.name;
	
	
	  return _react2.default.createElement(ColorPicker, _extends({
	    name: name,
	    value: value,
	    onChange: onChange
	  }, options));
	}
	
	var ColorPicker = function (_React$Component) {
	  _inherits(ColorPicker, _React$Component);
	
	  function ColorPicker(props) {
	    _classCallCheck(this, ColorPicker);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChangeComplete = _this.onChangeComplete.bind(_this);
	    return _this;
	  }
	
	  ColorPicker.prototype.onChangeComplete = function onChangeComplete(color, evt) {
	    this.props.onChange(color.hex);
	  };
	
	  ColorPicker.prototype.render = function render() {
	    var _props = this.props,
	        name = _props.name,
	        value = _props.value,
	        onChange = _props.onChange,
	        width = _props.width;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('color-picker-wrapper') },
	      _react2.default.createElement(_reactColor.CirclePicker, { color: value, onChangeComplete: this.onChangeComplete, width: width })
	    );
	  };
	
	  return ColorPicker;
	}(_react2.default.Component);
	
	exports.default = ColorPicker;

/***/ },

/***/ "y7rH":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.dropdownselect = dropdownselect;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownButton = __webpack_require__("Upq0");
	
	var _DropdownButton2 = _interopRequireDefault(_DropdownButton);
	
	var _reactBootstrap = __webpack_require__("3kvR");
	
	__webpack_require__("RdIe");
	
	var _find = __webpack_require__("kbi+");
	
	var _find2 = _interopRequireDefault(_find);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <DropdownSelect />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	function dropdownselect(props) {
	  var value = props.value,
	      onChange = props.onChange,
	      options = props.options,
	      schema = props.schema;
	  var noResultsText = options.noResultsText,
	      selectOptions = options.selectOptions;
	  var name = schema.name;
	
	
	  return _react2.default.createElement(DropdownSelect, {
	    noResultsText: noResultsText,
	    name: name,
	    value: value,
	    onChange: onChange,
	    options: selectOptions
	  });
	}
	
	var DropdownSelect = function (_React$Component) {
	  _inherits(DropdownSelect, _React$Component);
	
	  function DropdownSelect(props) {
	    _classCallCheck(this, DropdownSelect);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._getOptions = _this._getOptions.bind(_this);
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  DropdownSelect.prototype.onClick = function onClick(value) {
	    var _this2 = this;
	
	    return function () {
	      _this2.props.onChange(value);
	    };
	  };
	
	  DropdownSelect.prototype.render = function render() {
	    var _props = this.props,
	        name = _props.name,
	        value = _props.value,
	        noResultsText = _props.noResultsText,
	        options = _props.options,
	        onChange = _props.onChange,
	        _props$noCaret = _props.noCaret,
	        noCaret = _props$noCaret === undefined ? true : _props$noCaret;
	
	
	    var title = __('Select', 'classdetail');
	    if (typeof value !== 'undefined') {
	      var item = (0, _find2.default)(options, { value: value });
	      if (item && item.label) {
	        title = item.label;
	      }
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: "dropdown-select form-input" },
	      _react2.default.createElement(
	        _DropdownButton2.default,
	        { bsStyle: "link", title: title, className: "dropdown-select-button", noCaret: noCaret, id: "dropdown-select" },
	        this._getOptions()
	      )
	    );
	  };
	
	  DropdownSelect.prototype._getOptions = function _getOptions() {
	    var _this3 = this;
	
	    var options = this.props.options;
	
	
	    return options.map(function (item, idx) {
	      return _react2.default.createElement(
	        _reactBootstrap.MenuItem,
	        { key: idx, onClick: _this3.onClick(item.value), eventKey: idx },
	        item.label
	      );
	    });
	  };
	
	  return DropdownSelect;
	}(_react2.default.Component);
	
	exports.default = DropdownSelect;

/***/ },

/***/ "RdIe":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dropdown-select":"dropdown-select","dropdown":"dropdown","inline-form-field":"inline-form-field"};

/***/ },

/***/ "IPLN":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.toggleswitch = toggleswitch;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSelect = __webpack_require__("tTw2");
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactToggleSwitch = __webpack_require__("VkEr");
	
	var _reactToggleSwitch2 = _interopRequireDefault(_reactToggleSwitch);
	
	__webpack_require__("Oz+J");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ToggleSwitch />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	function toggleswitch(props) {
	  var value = props.value,
	      onChange = props.onChange,
	      schema = props.schema,
	      options = props.options;
	  var name = schema.name;
	
	  // ui:options: { disabled: true }
	
	  var disabled = options.disabled;
	
	
	  return _react2.default.createElement(ToggleSwitch, {
	    name: name,
	    value: value,
	    onChange: onChange,
	    disabled: disabled
	  });
	}
	
	var ToggleSwitch = function (_React$Component) {
	  _inherits(ToggleSwitch, _React$Component);
	
	  function ToggleSwitch(props) {
	    _classCallCheck(this, ToggleSwitch);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ToggleSwitch.prototype.render = function render() {
	    var _props = this.props,
	        name = _props.name,
	        value = _props.value,
	        onChange = _props.onChange,
	        disabled = _props.disabled;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'react-toggle-switch form-input' },
	      _react2.default.createElement(_reactToggleSwitch2.default, {
	        name: name,
	        on: value == true,
	        onClick: function onClick() {
	          onChange(value == false);
	        },
	        enabled: disabled !== true
	      })
	    );
	  };
	
	  return ToggleSwitch;
	}(_react2.default.Component);
	
	exports.default = ToggleSwitch;

/***/ },

/***/ "Oz+J":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-toggle-switch":"react-toggle-switch","inline-form-field":"inline-form-field"};

/***/ },

/***/ "ylS4":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * <Textarea />
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @parent anybody
	                                                                                                                                                                                                                                                                   * @stateful
	                                                                                                                                                                                                                                                                   */
	
	
	exports.textarea = textarea;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("/WXq");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_MAX_LENGTH = 500;
	var DEFAULT_ROWS = 5;
	
	function textarea(props) {
	  var value = props.value,
	      schema = props.schema,
	      onChange = props.onChange,
	      options = props.options,
	      placeholder = props.placeholder;
	  var name = schema.name;
	  var maxlength = options.maxlength;
	
	
	  return _react2.default.createElement(Textarea, _extends({
	    name: name,
	    value: value,
	    onChange: onChange,
	    maxlength: maxlength
	  }, options));
	}
	
	var Textarea = function (_React$Component) {
	  _inherits(Textarea, _React$Component);
	
	  function Textarea(props) {
	    _classCallCheck(this, Textarea);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  Textarea.prototype.onChange = function onChange(e) {
	    this.props.onChange(e.target.value);
	  };
	
	  Textarea.prototype.render = function render() {
	    var _props = this.props,
	        name = _props.name,
	        value = _props.value,
	        onChange = _props.onChange,
	        _props$rows = _props.rows,
	        rows = _props$rows === undefined ? DEFAULT_ROWS : _props$rows,
	        _props$maxlength = _props.maxlength,
	        maxlength = _props$maxlength === undefined ? DEFAULT_MAX_LENGTH : _props$maxlength;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'textarea-wrapper form-input' },
	      _react2.default.createElement('textarea', {
	        style: { width: '100%' },
	        value: value,
	        onChange: this.onChange,
	        className: 'form-control',
	        rows: rows,
	        maxLength: maxlength
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'text-count pull-right' },
	        (value || '').length,
	        ' / ',
	        maxlength
	      )
	    );
	  };
	
	  return Textarea;
	}(_react2.default.Component);
	
	exports.default = Textarea;

/***/ },

/***/ "/WXq":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"textarea-wrapper":"textarea-wrapper"};

/***/ },

/***/ "dHZB":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * <TimeZone />
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * NOTE: we're using timezone data inside data/timezone.js instead of having 
	                                                                                                                                                                                                                                                                   * a detached timezone file for this form. 
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @parent anybody
	                                                                                                                                                                                                                                                                   * @stateful
	                                                                                                                                                                                                                                                                   */
	
	
	exports.timezone = timezone;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _timezone = __webpack_require__("Vr+E");
	
	var _timezone2 = _interopRequireDefault(_timezone);
	
	var _reactSelect = __webpack_require__("tTw2");
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _parseJson = __webpack_require__("AKlS");
	
	var _parseJson2 = _interopRequireDefault(_parseJson);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_TIME_ZONE = 500;
	
	var timezoneOptions = _timezone2.default.map(function (zone, idx) {
	  return {
	    label: zone,
	    value: zone
	  };
	});
	
	function timezone(props) {
	  var schema = props.schema,
	      onChange = props.onChange,
	      options = props.options,
	      placeholder = props.placeholder,
	      value = props.value;
	  var name = schema.name;
	  var maxlength = options.maxlength;
	
	
	  return _react2.default.createElement(TimeZone, _extends({
	    name: name,
	    value: value,
	    onChange: onChange
	  }, options));
	}
	
	var TimeZone = function (_React$Component) {
	  _inherits(TimeZone, _React$Component);
	
	  function TimeZone(props) {
	    _classCallCheck(this, TimeZone);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  TimeZone.prototype.render = function render() {
	    var _props = this.props,
	        name = _props.name,
	        value = _props.value,
	        _onChange = _props.onChange,
	        disabled = _props.disabled;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'timezone-wrapper form-input' },
	      _react2.default.createElement(_reactSelect2.default, {
	        disabled: disabled,
	        clearable: false,
	        name: name,
	        value: value,
	        onChange: function onChange(item) {
	          _onChange(item.value);
	        },
	        options: timezoneOptions
	      })
	    );
	  };
	
	  return TimeZone;
	}(_react2.default.Component);
	
	exports.default = TimeZone;

/***/ },

/***/ "Vr+E":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = ['America/Vancouver', 'America/Toronto', 'Africa/Abidjan', 'Africa/Accra', 'Africa/Addis_Ababa', 'Africa/Algiers', 'Africa/Asmara', 'Africa/Bamako', 'Africa/Bangui', 'Africa/Banjul', 'Africa/Bissau', 'Africa/Blantyre', 'Africa/Brazzaville', 'Africa/Bujumbura', 'Africa/Cairo', 'Africa/Casablanca', 'Africa/Ceuta', 'Africa/Conakry', 'Africa/Dakar', 'Africa/Dar_es_Salaam', 'Africa/Djibouti', 'Africa/Douala', 'Africa/El_Aaiun', 'Africa/Freetown', 'Africa/Gaborone', 'Africa/Harare', 'Africa/Johannesburg', 'Africa/Juba', 'Africa/Kampala', 'Africa/Khartoum', 'Africa/Kigali', 'Africa/Kinshasa', 'Africa/Lagos', 'Africa/Libreville', 'Africa/Lome', 'Africa/Luanda', 'Africa/Lubumbashi', 'Africa/Lusaka', 'Africa/Malabo', 'Africa/Maputo', 'Africa/Maseru', 'Africa/Mbabane', 'Africa/Mogadishu', 'Africa/Monrovia', 'Africa/Nairobi', 'Africa/Ndjamena', 'Africa/Niamey', 'Africa/Nouakchott', 'Africa/Ouagadougou', 'Africa/Porto-Novo', 'Africa/Sao_Tome', 'Africa/Tripoli', 'Africa/Tunis', 'Africa/Windhoek', 'America/Adak', 'America/Anchorage', 'America/Anguilla', 'America/Antigua', 'America/Araguaina', 'America/Argentina/Buenos_Aires', 'America/Argentina/Catamarca', 'America/Argentina/Cordoba', 'America/Argentina/Jujuy', 'America/Argentina/La_Rioja', 'America/Argentina/Mendoza', 'America/Argentina/Rio_Gallegos', 'America/Argentina/Salta', 'America/Argentina/San_Juan', 'America/Argentina/San_Luis', 'America/Argentina/Tucuman', 'America/Argentina/Ushuaia', 'America/Aruba', 'America/Asuncion', 'America/Atikokan', 'America/Bahia', 'America/Bahia_Banderas', 'America/Barbados', 'America/Belem', 'America/Belize', 'America/Blanc-Sablon', 'America/Boa_Vista', 'America/Bogota', 'America/Boise', 'America/Cambridge_Bay', 'America/Campo_Grande', 'America/Cancun', 'America/Caracas', 'America/Cayenne', 'America/Cayman', 'America/Chicago', 'America/Chihuahua', 'America/Costa_Rica', 'America/Creston', 'America/Cuiaba', 'America/Curacao', 'America/Danmarkshavn', 'America/Dawson', 'America/Dawson_Creek', 'America/Denver', 'America/Detroit', 'America/Dominica', 'America/Edmonton', 'America/Eirunepe', 'America/El_Salvador', 'America/Fort_Nelson', 'America/Fortaleza', 'America/Glace_Bay', 'America/Godthab', 'America/Goose_Bay', 'America/Grand_Turk', 'America/Grenada', 'America/Guadeloupe', 'America/Guatemala', 'America/Guayaquil', 'America/Guyana', 'America/Halifax', 'America/Havana', 'America/Hermosillo', 'America/Indiana/Indianapolis', 'America/Indiana/Knox', 'America/Indiana/Marengo', 'America/Indiana/Petersburg', 'America/Indiana/Tell_City', 'America/Indiana/Vevay', 'America/Indiana/Vincennes', 'America/Indiana/Winamac', 'America/Inuvik', 'America/Iqaluit', 'America/Jamaica', 'America/Juneau', 'America/Kentucky/Louisville', 'America/Kentucky/Monticello', 'America/Kralendijk', 'America/La_Paz', 'America/Lima', 'America/Los_Angeles', 'America/Lower_Princes', 'America/Maceio', 'America/Managua', 'America/Manaus', 'America/Marigot', 'America/Martinique', 'America/Matamoros', 'America/Mazatlan', 'America/Menominee', 'America/Merida', 'America/Metlakatla', 'America/Mexico_City', 'America/Miquelon', 'America/Moncton', 'America/Monterrey', 'America/Montevideo', 'America/Montserrat', 'America/Nassau', 'America/New_York', 'America/Nipigon', 'America/Nome', 'America/Noronha', 'America/North_Dakota/Beulah', 'America/North_Dakota/Center', 'America/North_Dakota/New_Salem', 'America/Ojinaga', 'America/Panama', 'America/Pangnirtung', 'America/Paramaribo', 'America/Phoenix', 'America/Port-au-Prince', 'America/Port_of_Spain', 'America/Porto_Velho', 'America/Puerto_Rico', 'America/Punta_Arenas', 'America/Rainy_River', 'America/Rankin_Inlet', 'America/Recife', 'America/Regina', 'America/Resolute', 'America/Rio_Branco', 'America/Santarem', 'America/Santiago', 'America/Santo_Domingo', 'America/Sao_Paulo', 'America/Scoresbysund', 'America/Sitka', 'America/St_Barthelemy', 'America/St_Johns', 'America/St_Kitts', 'America/St_Lucia', 'America/St_Thomas', 'America/St_Vincent', 'America/Swift_Current', 'America/Tegucigalpa', 'America/Thule', 'America/Thunder_Bay', 'America/Tijuana', 'America/Tortola', 'America/Whitehorse', 'America/Winnipeg', 'America/Yakutat', 'America/Yellowknife', 'Antarctica/Casey', 'Antarctica/Davis', 'Antarctica/DumontDUrville', 'Antarctica/Macquarie', 'Antarctica/Mawson', 'Antarctica/McMurdo', 'Antarctica/Palmer', 'Antarctica/Rothera', 'Antarctica/Syowa', 'Antarctica/Troll', 'Antarctica/Vostok', 'Arctic/Longyearbyen', 'Asia/Aden', 'Asia/Almaty', 'Asia/Amman', 'Asia/Anadyr', 'Asia/Aqtau', 'Asia/Aqtobe', 'Asia/Ashgabat', 'Asia/Atyrau', 'Asia/Baghdad', 'Asia/Bahrain', 'Asia/Baku', 'Asia/Bangkok', 'Asia/Barnaul', 'Asia/Beirut', 'Asia/Bishkek', 'Asia/Brunei', 'Asia/Chita', 'Asia/Choibalsan', 'Asia/Colombo', 'Asia/Damascus', 'Asia/Dhaka', 'Asia/Dili', 'Asia/Dubai', 'Asia/Dushanbe', 'Asia/Famagusta', 'Asia/Gaza', 'Asia/Hebron', 'Asia/Ho_Chi_Minh', 'Asia/Hong_Kong', 'Asia/Hovd', 'Asia/Irkutsk', 'Asia/Jakarta', 'Asia/Jayapura', 'Asia/Jerusalem', 'Asia/Kabul', 'Asia/Kamchatka', 'Asia/Karachi', 'Asia/Kathmandu', 'Asia/Khandyga', 'Asia/Kolkata', 'Asia/Krasnoyarsk', 'Asia/Kuala_Lumpur', 'Asia/Kuching', 'Asia/Kuwait', 'Asia/Macau', 'Asia/Magadan', 'Asia/Makassar', 'Asia/Manila', 'Asia/Muscat', 'Asia/Nicosia', 'Asia/Novokuznetsk', 'Asia/Novosibirsk', 'Asia/Omsk', 'Asia/Oral', 'Asia/Phnom_Penh', 'Asia/Pontianak', 'Asia/Pyongyang', 'Asia/Qatar', 'Asia/Qyzylorda', 'Asia/Riyadh', 'Asia/Sakhalin', 'Asia/Samarkand', 'Asia/Seoul', 'Asia/Shanghai', 'Asia/Singapore', 'Asia/Srednekolymsk', 'Asia/Taipei', 'Asia/Tashkent', 'Asia/Tbilisi', 'Asia/Tehran', 'Asia/Thimphu', 'Asia/Tokyo', 'Asia/Tomsk', 'Asia/Ulaanbaatar', 'Asia/Urumqi', 'Asia/Ust-Nera', 'Asia/Vientiane', 'Asia/Vladivostok', 'Asia/Yakutsk', 'Asia/Yangon', 'Asia/Yekaterinburg', 'Asia/Yerevan', 'Atlantic/Azores', 'Atlantic/Bermuda', 'Atlantic/Canary', 'Atlantic/Cape_Verde', 'Atlantic/Faroe', 'Atlantic/Madeira', 'Atlantic/Reykjavik', 'Atlantic/South_Georgia', 'Atlantic/St_Helena', 'Atlantic/Stanley', 'Australia/Adelaide', 'Australia/Brisbane', 'Australia/Broken_Hill', 'Australia/Currie', 'Australia/Darwin', 'Australia/Eucla', 'Australia/Hobart', 'Australia/Lindeman', 'Australia/Lord_Howe', 'Australia/Melbourne', 'Australia/Perth', 'Australia/Sydney', 'Canada/Atlantic', 'Canada/Central', 'Canada/Eastern', 'Canada/Mountain', 'Canada/Newfoundland', 'Canada/Pacific', 'Europe/Amsterdam', 'Europe/Andorra', 'Europe/Astrakhan', 'Europe/Athens', 'Europe/Belgrade', 'Europe/Berlin', 'Europe/Bratislava', 'Europe/Brussels', 'Europe/Bucharest', 'Europe/Budapest', 'Europe/Busingen', 'Europe/Chisinau', 'Europe/Copenhagen', 'Europe/Dublin', 'Europe/Gibraltar', 'Europe/Guernsey', 'Europe/Helsinki', 'Europe/Isle_of_Man', 'Europe/Istanbul', 'Europe/Jersey', 'Europe/Kaliningrad', 'Europe/Kiev', 'Europe/Kirov', 'Europe/Lisbon', 'Europe/Ljubljana', 'Europe/London', 'Europe/Luxembourg', 'Europe/Madrid', 'Europe/Malta', 'Europe/Mariehamn', 'Europe/Minsk', 'Europe/Monaco', 'Europe/Moscow', 'Europe/Oslo', 'Europe/Paris', 'Europe/Podgorica', 'Europe/Prague', 'Europe/Riga', 'Europe/Rome', 'Europe/Samara', 'Europe/San_Marino', 'Europe/Sarajevo', 'Europe/Saratov', 'Europe/Simferopol', 'Europe/Skopje', 'Europe/Sofia', 'Europe/Stockholm', 'Europe/Tallinn', 'Europe/Tirane', 'Europe/Ulyanovsk', 'Europe/Uzhgorod', 'Europe/Vaduz', 'Europe/Vatican', 'Europe/Vienna', 'Europe/Vilnius', 'Europe/Volgograd', 'Europe/Warsaw', 'Europe/Zagreb', 'Europe/Zaporozhye', 'Europe/Zurich', 'GMT', 'Indian/Antananarivo', 'Indian/Chagos', 'Indian/Christmas', 'Indian/Cocos', 'Indian/Comoro', 'Indian/Kerguelen', 'Indian/Mahe', 'Indian/Maldives', 'Indian/Mauritius', 'Indian/Mayotte', 'Indian/Reunion', 'Pacific/Apia', 'Pacific/Auckland', 'Pacific/Bougainville', 'Pacific/Chatham', 'Pacific/Chuuk', 'Pacific/Easter', 'Pacific/Efate', 'Pacific/Enderbury', 'Pacific/Fakaofo', 'Pacific/Fiji', 'Pacific/Funafuti', 'Pacific/Galapagos', 'Pacific/Gambier', 'Pacific/Guadalcanal', 'Pacific/Guam', 'Pacific/Honolulu', 'Pacific/Kiritimati', 'Pacific/Kosrae', 'Pacific/Kwajalein', 'Pacific/Majuro', 'Pacific/Marquesas', 'Pacific/Midway', 'Pacific/Nauru', 'Pacific/Niue', 'Pacific/Norfolk', 'Pacific/Noumea', 'Pacific/Pago_Pago', 'Pacific/Palau', 'Pacific/Pitcairn', 'Pacific/Pohnpei', 'Pacific/Port_Moresby', 'Pacific/Rarotonga', 'Pacific/Saipan', 'Pacific/Tahiti', 'Pacific/Tarawa', 'Pacific/Tongatapu', 'Pacific/Wake', 'Pacific/Wallis', 'US/Alaska', 'US/Arizona', 'US/Central', 'US/Eastern', 'US/Hawaii', 'US/Mountain', 'US/Pacific', 'UTC'];
	module.exports = exports['default'];

/***/ },

/***/ "CKuu":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DEFAULT_CURRENCY = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * <Currency />
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * NOTE: we're using currency data inside data/currency.js instead of having 
	                                                                                                                                                                                                                                                                   * a detached currency file for this form. 
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @parent anybody
	                                                                                                                                                                                                                                                                   * @stateful
	                                                                                                                                                                                                                                                                   */
	
	
	exports.currency = currency;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _currency = __webpack_require__("hpCb");
	
	var _currency2 = _interopRequireDefault(_currency);
	
	var _reactSelect = __webpack_require__("tTw2");
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _parseJson = __webpack_require__("AKlS");
	
	var _parseJson2 = _interopRequireDefault(_parseJson);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_CURRENCY = exports.DEFAULT_CURRENCY = 'USD';
	
	var currencyOptions = _currency2.default.map(function (item, idx) {
	  return {
	    label: item.name + ' (' + item.symbol + ')',
	    value: item.code
	  };
	});
	
	function currency(props) {
	  var schema = props.schema,
	      onChange = props.onChange,
	      options = props.options,
	      placeholder = props.placeholder,
	      value = props.value;
	  var name = schema.name;
	  var maxlength = options.maxlength;
	
	
	  return _react2.default.createElement(Currency, _extends({
	    name: name,
	    value: value,
	    onChange: onChange
	  }, options));
	}
	
	var Currency = function (_React$Component) {
	  _inherits(Currency, _React$Component);
	
	  function Currency(props) {
	    _classCallCheck(this, Currency);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Currency.prototype.render = function render() {
	    var _props = this.props,
	        name = _props.name,
	        value = _props.value,
	        _onChange = _props.onChange;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'currency-wrapper form-input' },
	      _react2.default.createElement(_reactSelect2.default, {
	        clearable: false,
	        name: name,
	        value: value,
	        onChange: function onChange(item) {
	          _onChange(item.value);
	        },
	        options: currencyOptions
	      })
	    );
	  };
	
	  return Currency;
	}(_react2.default.Component);
	
	exports.default = Currency;

/***/ },

/***/ "hpCb":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = [{
	    "symbol": "$",
	    "name": "US Dollar",
	    "symbol_native": "$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "USD",
	    "name_plural": "US dollars"
	}, {
	    "symbol": "CA$",
	    "name": "Canadian Dollar",
	    "symbol_native": "$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "CAD",
	    "name_plural": "Canadian dollars"
	}, {
	    "symbol": "€",
	    "name": "Euro",
	    "symbol_native": "€",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "EUR",
	    "name_plural": "euros"
	}, {
	    "symbol": "AED",
	    "name": "United Arab Emirates Dirham",
	    "symbol_native": "?.?.?",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "AED",
	    "name_plural": "UAE dirhams"
	}, {
	    "symbol": "Af",
	    "name": "Afghan Afghani",
	    "symbol_native": "?",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "AFN",
	    "name_plural": "Afghan Afghanis"
	}, {
	    "symbol": "ALL",
	    "name": "Albanian Lek",
	    "symbol_native": "Lek",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "ALL",
	    "name_plural": "Albanian lekë"
	}, {
	    "symbol": "AMD",
	    "name": "Armenian Dram",
	    "symbol_native": "??.",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "AMD",
	    "name_plural": "Armenian drams"
	}, {
	    "symbol": "AR$",
	    "name": "Argentine Peso",
	    "symbol_native": "$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "ARS",
	    "name_plural": "Argentine pesos"
	}, {
	    "symbol": "AU$",
	    "name": "Australian Dollar",
	    "symbol_native": "$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "AUD",
	    "name_plural": "Australian dollars"
	}, {
	    "symbol": "man.",
	    "name": "Azerbaijani Manat",
	    "symbol_native": "???.",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "AZN",
	    "name_plural": "Azerbaijani manats"
	}, {
	    "symbol": "KM",
	    "name": "Bosnia-Herzegovina Convertible Mark",
	    "symbol_native": "KM",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "BAM",
	    "name_plural": "Bosnia-Herzegovina convertible marks"
	}, {
	    "symbol": "Tk",
	    "name": "Bangladeshi Taka",
	    "symbol_native": "?",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "BDT",
	    "name_plural": "Bangladeshi takas"
	}, {
	    "symbol": "BGN",
	    "name": "Bulgarian Lev",
	    "symbol_native": "??.",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "BGN",
	    "name_plural": "Bulgarian leva"
	}, {
	    "symbol": "BD",
	    "name": "Bahraini Dinar",
	    "symbol_native": "?.?.?",
	    "decimal_digits": 3,
	    "rounding": 0,
	    "code": "BHD",
	    "name_plural": "Bahraini dinars"
	}, {
	    "symbol": "FBu",
	    "name": "Burundian Franc",
	    "symbol_native": "FBu",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "BIF",
	    "name_plural": "Burundian francs"
	}, {
	    "symbol": "BN$",
	    "name": "Brunei Dollar",
	    "symbol_native": "$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "BND",
	    "name_plural": "Brunei dollars"
	}, {
	    "symbol": "Bs",
	    "name": "Bolivian Boliviano",
	    "symbol_native": "Bs",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "BOB",
	    "name_plural": "Bolivian bolivianos"
	}, {
	    "symbol": "R$",
	    "name": "Brazilian Real",
	    "symbol_native": "R$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "BRL",
	    "name_plural": "Brazilian reals"
	}, {
	    "symbol": "BWP",
	    "name": "Botswanan Pula",
	    "symbol_native": "P",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "BWP",
	    "name_plural": "Botswanan pulas"
	}, {
	    "symbol": "BYR",
	    "name": "Belarusian Ruble",
	    "symbol_native": "BYR",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "BYR",
	    "name_plural": "Belarusian rubles"
	}, {
	    "symbol": "BZ$",
	    "name": "Belize Dollar",
	    "symbol_native": "$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "BZD",
	    "name_plural": "Belize dollars"
	}, {
	    "symbol": "CDF",
	    "name": "Congolese Franc",
	    "symbol_native": "FrCD",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "CDF",
	    "name_plural": "Congolese francs"
	}, {
	    "symbol": "CHF",
	    "name": "Swiss Franc",
	    "symbol_native": "CHF",
	    "decimal_digits": 2,
	    "rounding": 0.05,
	    "code": "CHF",
	    "name_plural": "Swiss francs"
	}, {
	    "symbol": "CL$",
	    "name": "Chilean Peso",
	    "symbol_native": "$",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "CLP",
	    "name_plural": "Chilean pesos"
	}, {
	    "symbol": "CN¥",
	    "name": "Chinese Yuan",
	    "symbol_native": "CN¥",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "CNY",
	    "name_plural": "Chinese yuan"
	}, {
	    "symbol": "CO$",
	    "name": "Colombian Peso",
	    "symbol_native": "$",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "COP",
	    "name_plural": "Colombian pesos"
	}, {
	    "symbol": "?",
	    "name": "Costa Rican Colón",
	    "symbol_native": "?",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "CRC",
	    "name_plural": "Costa Rican colóns"
	}, {
	    "symbol": "CV$",
	    "name": "Cape Verdean Escudo",
	    "symbol_native": "CV$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "CVE",
	    "name_plural": "Cape Verdean escudos"
	}, {
	    "symbol": "K?",
	    "name": "Czech Republic Koruna",
	    "symbol_native": "K?",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "CZK",
	    "name_plural": "Czech Republic korunas"
	}, {
	    "symbol": "Fdj",
	    "name": "Djiboutian Franc",
	    "symbol_native": "Fdj",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "DJF",
	    "name_plural": "Djiboutian francs"
	}, {
	    "symbol": "Dkr",
	    "name": "Danish Krone",
	    "symbol_native": "kr",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "DKK",
	    "name_plural": "Danish kroner"
	}, {
	    "symbol": "RD$",
	    "name": "Dominican Peso",
	    "symbol_native": "RD$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "DOP",
	    "name_plural": "Dominican pesos"
	}, {
	    "symbol": "DA",
	    "name": "Algerian Dinar",
	    "symbol_native": "?.?.?",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "DZD",
	    "name_plural": "Algerian dinars"
	}, {
	    "symbol": "Ekr",
	    "name": "Estonian Kroon",
	    "symbol_native": "kr",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "EEK",
	    "name_plural": "Estonian kroons"
	}, {
	    "symbol": "EGP",
	    "name": "Egyptian Pound",
	    "symbol_native": "?.?.?",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "EGP",
	    "name_plural": "Egyptian pounds"
	}, {
	    "symbol": "Nfk",
	    "name": "Eritrean Nakfa",
	    "symbol_native": "Nfk",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "ERN",
	    "name_plural": "Eritrean nakfas"
	}, {
	    "symbol": "Br",
	    "name": "Ethiopian Birr",
	    "symbol_native": "Br",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "ETB",
	    "name_plural": "Ethiopian birrs"
	}, {
	    "symbol": "£",
	    "name": "British Pound Sterling",
	    "symbol_native": "£",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "GBP",
	    "name_plural": "British pounds sterling"
	}, {
	    "symbol": "GEL",
	    "name": "Georgian Lari",
	    "symbol_native": "GEL",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "GEL",
	    "name_plural": "Georgian laris"
	}, {
	    "symbol": "GH?",
	    "name": "Ghanaian Cedi",
	    "symbol_native": "GH?",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "GHS",
	    "name_plural": "Ghanaian cedis"
	}, {
	    "symbol": "FG",
	    "name": "Guinean Franc",
	    "symbol_native": "FG",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "GNF",
	    "name_plural": "Guinean francs"
	}, {
	    "symbol": "GTQ",
	    "name": "Guatemalan Quetzal",
	    "symbol_native": "Q",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "GTQ",
	    "name_plural": "Guatemalan quetzals"
	}, {
	    "symbol": "HK$",
	    "name": "Hong Kong Dollar",
	    "symbol_native": "$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "HKD",
	    "name_plural": "Hong Kong dollars"
	}, {
	    "symbol": "HNL",
	    "name": "Honduran Lempira",
	    "symbol_native": "L",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "HNL",
	    "name_plural": "Honduran lempiras"
	}, {
	    "symbol": "kn",
	    "name": "Croatian Kuna",
	    "symbol_native": "kn",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "HRK",
	    "name_plural": "Croatian kunas"
	}, {
	    "symbol": "Ft",
	    "name": "Hungarian Forint",
	    "symbol_native": "Ft",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "HUF",
	    "name_plural": "Hungarian forints"
	}, {
	    "symbol": "Rp",
	    "name": "Indonesian Rupiah",
	    "symbol_native": "Rp",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "IDR",
	    "name_plural": "Indonesian rupiahs"
	}, {
	    "symbol": "?",
	    "name": "Israeli New Sheqel",
	    "symbol_native": "?",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "ILS",
	    "name_plural": "Israeli new sheqels"
	}, {
	    "symbol": "Rs",
	    "name": "Indian Rupee",
	    "symbol_native": "???",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "INR",
	    "name_plural": "Indian rupees"
	}, {
	    "symbol": "IQD",
	    "name": "Iraqi Dinar",
	    "symbol_native": "?.?.?",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "IQD",
	    "name_plural": "Iraqi dinars"
	}, {
	    "symbol": "IRR",
	    "name": "Iranian Rial",
	    "symbol_native": "?",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "IRR",
	    "name_plural": "Iranian rials"
	}, {
	    "symbol": "Ikr",
	    "name": "Icelandic Króna",
	    "symbol_native": "kr",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "ISK",
	    "name_plural": "Icelandic krónur"
	}, {
	    "symbol": "J$",
	    "name": "Jamaican Dollar",
	    "symbol_native": "$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "JMD",
	    "name_plural": "Jamaican dollars"
	}, {
	    "symbol": "JD",
	    "name": "Jordanian Dinar",
	    "symbol_native": "?.?.?",
	    "decimal_digits": 3,
	    "rounding": 0,
	    "code": "JOD",
	    "name_plural": "Jordanian dinars"
	}, {
	    "symbol": "¥",
	    "name": "Japanese Yen",
	    "symbol_native": "?",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "JPY",
	    "name_plural": "Japanese yen"
	}, {
	    "symbol": "Ksh",
	    "name": "Kenyan Shilling",
	    "symbol_native": "Ksh",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "KES",
	    "name_plural": "Kenyan shillings"
	}, {
	    "symbol": "KHR",
	    "name": "Cambodian Riel",
	    "symbol_native": "?",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "KHR",
	    "name_plural": "Cambodian riels"
	}, {
	    "symbol": "CF",
	    "name": "Comorian Franc",
	    "symbol_native": "FC",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "KMF",
	    "name_plural": "Comorian francs"
	}, {
	    "symbol": "?",
	    "name": "South Korean Won",
	    "symbol_native": "?",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "KRW",
	    "name_plural": "South Korean won"
	}, {
	    "symbol": "KD",
	    "name": "Kuwaiti Dinar",
	    "symbol_native": "?.?.?",
	    "decimal_digits": 3,
	    "rounding": 0,
	    "code": "KWD",
	    "name_plural": "Kuwaiti dinars"
	}, {
	    "symbol": "KZT",
	    "name": "Kazakhstani Tenge",
	    "symbol_native": "???.",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "KZT",
	    "name_plural": "Kazakhstani tenges"
	}, {
	    "symbol": "LB£",
	    "name": "Lebanese Pound",
	    "symbol_native": "?.?.?",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "LBP",
	    "name_plural": "Lebanese pounds"
	}, {
	    "symbol": "SLRs",
	    "name": "Sri Lankan Rupee",
	    "symbol_native": "SL Re",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "LKR",
	    "name_plural": "Sri Lankan rupees"
	}, {
	    "symbol": "Lt",
	    "name": "Lithuanian Litas",
	    "symbol_native": "Lt",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "LTL",
	    "name_plural": "Lithuanian litai"
	}, {
	    "symbol": "Ls",
	    "name": "Latvian Lats",
	    "symbol_native": "Ls",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "LVL",
	    "name_plural": "Latvian lati"
	}, {
	    "symbol": "LD",
	    "name": "Libyan Dinar",
	    "symbol_native": "?.?.?",
	    "decimal_digits": 3,
	    "rounding": 0,
	    "code": "LYD",
	    "name_plural": "Libyan dinars"
	}, {
	    "symbol": "MAD",
	    "name": "Moroccan Dirham",
	    "symbol_native": "?.?.?",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "MAD",
	    "name_plural": "Moroccan dirhams"
	}, {
	    "symbol": "MDL",
	    "name": "Moldovan Leu",
	    "symbol_native": "MDL",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "MDL",
	    "name_plural": "Moldovan lei"
	}, {
	    "symbol": "MGA",
	    "name": "Malagasy Ariary",
	    "symbol_native": "MGA",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "MGA",
	    "name_plural": "Malagasy Ariaries"
	}, {
	    "symbol": "MKD",
	    "name": "Macedonian Denar",
	    "symbol_native": "MKD",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "MKD",
	    "name_plural": "Macedonian denari"
	}, {
	    "symbol": "MMK",
	    "name": "Myanma Kyat",
	    "symbol_native": "K",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "MMK",
	    "name_plural": "Myanma kyats"
	}, {
	    "symbol": "MOP$",
	    "name": "Macanese Pataca",
	    "symbol_native": "MOP$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "MOP",
	    "name_plural": "Macanese patacas"
	}, {
	    "symbol": "MURs",
	    "name": "Mauritian Rupee",
	    "symbol_native": "MURs",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "MUR",
	    "name_plural": "Mauritian rupees"
	}, {
	    "symbol": "MX$",
	    "name": "Mexican Peso",
	    "symbol_native": "$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "MXN",
	    "name_plural": "Mexican pesos"
	}, {
	    "symbol": "RM",
	    "name": "Malaysian Ringgit",
	    "symbol_native": "RM",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "MYR",
	    "name_plural": "Malaysian ringgits"
	}, {
	    "symbol": "MTn",
	    "name": "Mozambican Metical",
	    "symbol_native": "MTn",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "MZN",
	    "name_plural": "Mozambican meticals"
	}, {
	    "symbol": "N$",
	    "name": "Namibian Dollar",
	    "symbol_native": "N$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "NAD",
	    "name_plural": "Namibian dollars"
	}, {
	    "symbol": "?",
	    "name": "Nigerian Naira",
	    "symbol_native": "?",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "NGN",
	    "name_plural": "Nigerian nairas"
	}, {
	    "symbol": "C$",
	    "name": "Nicaraguan Córdoba",
	    "symbol_native": "C$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "NIO",
	    "name_plural": "Nicaraguan córdobas"
	}, {
	    "symbol": "Nkr",
	    "name": "Norwegian Krone",
	    "symbol_native": "kr",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "NOK",
	    "name_plural": "Norwegian kroner"
	}, {
	    "symbol": "NPRs",
	    "name": "Nepalese Rupee",
	    "symbol_native": "????",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "NPR",
	    "name_plural": "Nepalese rupees"
	}, {
	    "symbol": "NZ$",
	    "name": "New Zealand Dollar",
	    "symbol_native": "$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "NZD",
	    "name_plural": "New Zealand dollars"
	}, {
	    "symbol": "OMR",
	    "name": "Omani Rial",
	    "symbol_native": "?.?.?",
	    "decimal_digits": 3,
	    "rounding": 0,
	    "code": "OMR",
	    "name_plural": "Omani rials"
	}, {
	    "symbol": "B/.",
	    "name": "Panamanian Balboa",
	    "symbol_native": "B/.",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "PAB",
	    "name_plural": "Panamanian balboas"
	}, {
	    "symbol": "S/.",
	    "name": "Peruvian Nuevo Sol",
	    "symbol_native": "S/.",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "PEN",
	    "name_plural": "Peruvian nuevos soles"
	}, {
	    "symbol": "?",
	    "name": "Philippine Peso",
	    "symbol_native": "?",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "PHP",
	    "name_plural": "Philippine pesos"
	}, {
	    "symbol": "PKRs",
	    "name": "Pakistani Rupee",
	    "symbol_native": "?",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "PKR",
	    "name_plural": "Pakistani rupees"
	}, {
	    "symbol": "z?",
	    "name": "Polish Zloty",
	    "symbol_native": "z?",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "PLN",
	    "name_plural": "Polish zlotys"
	}, {
	    "symbol": "?",
	    "name": "Paraguayan Guarani",
	    "symbol_native": "?",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "PYG",
	    "name_plural": "Paraguayan guaranis"
	}, {
	    "symbol": "QR",
	    "name": "Qatari Rial",
	    "symbol_native": "?.?.?",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "QAR",
	    "name_plural": "Qatari rials"
	}, {
	    "symbol": "RON",
	    "name": "Romanian Leu",
	    "symbol_native": "RON",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "RON",
	    "name_plural": "Romanian lei"
	}, {
	    "symbol": "din.",
	    "name": "Serbian Dinar",
	    "symbol_native": "???.",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "RSD",
	    "name_plural": "Serbian dinars"
	}, {
	    "symbol": "RUB",
	    "name": "Russian Ruble",
	    "symbol_native": "???.",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "RUB",
	    "name_plural": "Russian rubles"
	}, {
	    "symbol": "RWF",
	    "name": "Rwandan Franc",
	    "symbol_native": "FR",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "RWF",
	    "name_plural": "Rwandan francs"
	}, {
	    "symbol": "SR",
	    "name": "Saudi Riyal",
	    "symbol_native": "?.?.?",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "SAR",
	    "name_plural": "Saudi riyals"
	}, {
	    "symbol": "SDG",
	    "name": "Sudanese Pound",
	    "symbol_native": "SDG",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "SDG",
	    "name_plural": "Sudanese pounds"
	}, {
	    "symbol": "Skr",
	    "name": "Swedish Krona",
	    "symbol_native": "kr",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "SEK",
	    "name_plural": "Swedish kronor"
	}, {
	    "symbol": "S$",
	    "name": "Singapore Dollar",
	    "symbol_native": "$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "SGD",
	    "name_plural": "Singapore dollars"
	}, {
	    "symbol": "Ssh",
	    "name": "Somali Shilling",
	    "symbol_native": "Ssh",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "SOS",
	    "name_plural": "Somali shillings"
	}, {
	    "symbol": "SY£",
	    "name": "Syrian Pound",
	    "symbol_native": "?.?.?",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "SYP",
	    "name_plural": "Syrian pounds"
	}, {
	    "symbol": "?",
	    "name": "Thai Baht",
	    "symbol_native": "?",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "THB",
	    "name_plural": "Thai baht"
	}, {
	    "symbol": "DT",
	    "name": "Tunisian Dinar",
	    "symbol_native": "?.?.?",
	    "decimal_digits": 3,
	    "rounding": 0,
	    "code": "TND",
	    "name_plural": "Tunisian dinars"
	}, {
	    "symbol": "T$",
	    "name": "Tongan Pa?anga",
	    "symbol_native": "T$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "TOP",
	    "name_plural": "Tongan pa?anga"
	}, {
	    "symbol": "TL",
	    "name": "Turkish Lira",
	    "symbol_native": "TL",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "TRY",
	    "name_plural": "Turkish Lira"
	}, {
	    "symbol": "TT$",
	    "name": "Trinidad and Tobago Dollar",
	    "symbol_native": "$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "TTD",
	    "name_plural": "Trinidad and Tobago dollars"
	}, {
	    "symbol": "NT$",
	    "name": "New Taiwan Dollar",
	    "symbol_native": "NT$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "TWD",
	    "name_plural": "New Taiwan dollars"
	}, {
	    "symbol": "TSh",
	    "name": "Tanzanian Shilling",
	    "symbol_native": "TSh",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "TZS",
	    "name_plural": "Tanzanian shillings"
	}, {
	    "symbol": "?",
	    "name": "Ukrainian Hryvnia",
	    "symbol_native": "?",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "UAH",
	    "name_plural": "Ukrainian hryvnias"
	}, {
	    "symbol": "USh",
	    "name": "Ugandan Shilling",
	    "symbol_native": "USh",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "UGX",
	    "name_plural": "Ugandan shillings"
	}, {
	    "symbol": "$U",
	    "name": "Uruguayan Peso",
	    "symbol_native": "$",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "UYU",
	    "name_plural": "Uruguayan pesos"
	}, {
	    "symbol": "UZS",
	    "name": "Uzbekistan Som",
	    "symbol_native": "UZS",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "UZS",
	    "name_plural": "Uzbekistan som"
	}, {
	    "symbol": "Bs.F.",
	    "name": "Venezuelan Bolívar",
	    "symbol_native": "Bs.F.",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "VEF",
	    "name_plural": "Venezuelan bolívars"
	}, {
	    "symbol": "?",
	    "name": "Vietnamese Dong",
	    "symbol_native": "?",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "VND",
	    "name_plural": "Vietnamese dong"
	}, {
	    "symbol": "FCFA",
	    "name": "CFA Franc BEAC",
	    "symbol_native": "FCFA",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "XAF",
	    "name_plural": "CFA francs BEAC"
	}, {
	    "symbol": "CFA",
	    "name": "CFA Franc BCEAO",
	    "symbol_native": "CFA",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "XOF",
	    "name_plural": "CFA francs BCEAO"
	}, {
	    "symbol": "YR",
	    "name": "Yemeni Rial",
	    "symbol_native": "?.?.?",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "YER",
	    "name_plural": "Yemeni rials"
	}, {
	    "symbol": "R",
	    "name": "South African Rand",
	    "symbol_native": "R",
	    "decimal_digits": 2,
	    "rounding": 0,
	    "code": "ZAR",
	    "name_plural": "South African rand"
	}, {
	    "symbol": "ZK",
	    "name": "Zambian Kwacha",
	    "symbol_native": "ZK",
	    "decimal_digits": 0,
	    "rounding": 0,
	    "code": "ZMK",
	    "name_plural": "Zambian kwachas"
	}];
	module.exports = exports["default"];

/***/ },

/***/ "MwQ4":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * <Address />
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * NOTE: we're using address data inside data/address.js instead of having 
	                                                                                                                                                                                                                                                                   * a detached address file for this form. 
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @parent anybody
	                                                                                                                                                                                                                                                                   * @stateful
	                                                                                                                                                                                                                                                                   */
	
	
	exports.address = address;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _parseJson = __webpack_require__("AKlS");
	
	var _parseJson2 = _interopRequireDefault(_parseJson);
	
	var _reactCountryRegionSelector = __webpack_require__("6Vl1");
	
	__webpack_require__("Dxjp");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function address(props) {
	  var schema = props.schema,
	      onChange = props.onChange,
	      options = props.options,
	      placeholder = props.placeholder;
	  var name = schema.name;
	  var maxlength = options.maxlength;
	
	
	  var value = (0, _parseJson2.default)(props.value || {});
	
	  return _react2.default.createElement(Address, _extends({
	    name: name,
	    value: value,
	    onChange: function onChange(data) {
	      props.onChange(JSON.stringify(data));
	    }
	  }, options));
	}
	
	var Address = function (_React$Component) {
	  _inherits(Address, _React$Component);
	
	  function Address(props) {
	    _classCallCheck(this, Address);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  Address.prototype.onChange = function onChange(itemName, itemValue) {
	    var _extends2;
	
	    var _props = this.props,
	        value = _props.value,
	        onChange = _props.onChange;
	
	
	    onChange(_extends({}, value, (_extends2 = {}, _extends2[itemName] = itemValue, _extends2)), itemName);
	  };
	
	  Address.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props2 = this.props,
	        name = _props2.name,
	        value = _props2.value,
	        placeholderAsLabel = _props2.placeholderAsLabel;
	
	
	    var placeholders = {};
	    if (placeholderAsLabel) {
	      placeholders = {
	        'country': __('Country', 'address'),
	        'unit': __('Unit No.', 'address'),
	        'street': __('Street', 'address'),
	        'postalCode': __('Postal Code', 'address'),
	        'province': __('Province/States', 'address'),
	        'city': __('City', 'address')
	      };
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'address-wrapper form-input' },
	      _react2.default.createElement(
	        'div',
	        { className: 'outline-form-field street-unit-number' },
	        _react2.default.createElement(
	          'div',
	          { className: 'street' },
	          placeholderAsLabel !== true && _react2.default.createElement(
	            'label',
	            null,
	            __('Street', 'address')
	          ),
	          _react2.default.createElement('input', {
	            type: 'text', className: 'form-control',
	            value: value.street,
	            placeholder: placeholders.street,
	            onChange: function onChange(e) {
	              _this2.onChange('street', e.target.value);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'unit-number' },
	          placeholderAsLabel !== true && _react2.default.createElement(
	            'label',
	            null,
	            __('Unit No.', 'address')
	          ),
	          _react2.default.createElement('input', {
	            placeholder: placeholders.unit,
	            type: 'text', className: 'form-control',
	            value: value.unit,
	            onChange: function onChange(e) {
	              _this2.onChange('unit', e.target.value);
	            }
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'outline-form-field' },
	        placeholderAsLabel !== true && _react2.default.createElement(
	          'label',
	          null,
	          __('City', 'address')
	        ),
	        _react2.default.createElement('input', {
	          placeholder: placeholders.city,
	          type: 'text', className: 'form-control',
	          value: value.city,
	          onChange: function onChange(e) {
	            _this2.onChange('city', e.target.value);
	          }
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'outline-form-field' },
	        placeholderAsLabel !== true && _react2.default.createElement(
	          'label',
	          null,
	          __('Country', 'address')
	        ),
	        _react2.default.createElement(_reactCountryRegionSelector.CountryDropdown, {
	          defaultOptionLabel: __('Country', 'address'),
	          value: value.country,
	          placeholder: placeholders.country,
	          classes: 'form-control',
	          onChange: function onChange(data) {
	            _this2.onChange('country', data);
	          }
	        })
	      ),
	      value.country && _react2.default.createElement(
	        'div',
	        { className: 'outline-form-field' },
	        placeholderAsLabel !== true && _react2.default.createElement(
	          'label',
	          null,
	          __('Province/States', 'address')
	        ),
	        _react2.default.createElement(_reactCountryRegionSelector.RegionDropdown, {
	          defaultOptionLabel: __('Province/States', 'address'),
	          country: value.country,
	          value: value.province,
	          classes: 'form-control',
	          onChange: function onChange(data) {
	            _this2.onChange('province', data);
	          }
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'outline-form-field' },
	        placeholderAsLabel !== true && _react2.default.createElement(
	          'label',
	          null,
	          __('Postal Code', 'address')
	        ),
	        _react2.default.createElement('input', {
	          type: 'text', className: 'form-control',
	          placeholder: placeholders.postalCode,
	          value: value.postalCode,
	          onChange: function onChange(e) {
	            _this2.onChange('postalCode', e.target.value);
	          }
	        })
	      )
	    );
	  };
	
	  return Address;
	}(_react2.default.Component);
	
	exports.default = Address;

/***/ },

/***/ "6Vl1":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CountryRegionData = exports.RegionDropdown = exports.CountryDropdown = undefined;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sourceData = __webpack_require__("Gs9Q");
	
	var _sourceData2 = _interopRequireDefault(_sourceData);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var C = {
	  DISPLAY_TYPE_FULL: 'full',
	  DISPLAY_TYPE_SHORT: 'short',
	  REGION_LIST_DELIMITER: '|',
	  SINGLE_REGION_DELIMITER: '~'
	};
	
	var CountryDropdown = function (_React$Component) {
	  _inherits(CountryDropdown, _React$Component);
	
	  function CountryDropdown(props) {
	    _classCallCheck(this, CountryDropdown);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      countries: _filterCountries(_sourceData2.default, props.whitelist, props.blacklist)
	    };
	    return _this;
	  }
	
	  CountryDropdown.prototype.getCountries = function getCountries() {
	    var _props = this.props,
	        valueType = _props.valueType,
	        labelType = _props.labelType;
	
	
	    return this.state.countries.map(function (_ref) {
	      var countryName = _ref[0],
	          countrySlug = _ref[1];
	
	      return _react2.default.createElement(
	        'option',
	        { value: valueType === C.DISPLAY_TYPE_SHORT ? countrySlug : countryName, key: countrySlug },
	        labelType === C.DISPLAY_TYPE_SHORT ? countrySlug : countryName
	      );
	    });
	  };
	
	  CountryDropdown.prototype.getDefaultOption = function getDefaultOption() {
	    var _props2 = this.props,
	        showDefaultOption = _props2.showDefaultOption,
	        defaultOptionLabel = _props2.defaultOptionLabel;
	
	    if (!showDefaultOption) {
	      return null;
	    }
	    return _react2.default.createElement(
	      'option',
	      { value: '', key: 'default' },
	      defaultOptionLabel
	    );
	  };
	
	  CountryDropdown.prototype.render = function render() {
	    var _props3 = this.props,
	        name = _props3.name,
	        id = _props3.id,
	        classes = _props3.classes,
	        value = _props3.value,
	        _onChange = _props3.onChange,
	        _onBlur = _props3.onBlur,
	        disabled = _props3.disabled;
	
	    var attrs = {
	      name: name,
	      value: value,
	      onChange: function onChange(e) {
	        return _onChange(e.target.value, e);
	      },
	      onBlur: function onBlur(e) {
	        return _onBlur(e);
	      },
	      disabled: disabled
	    };
	    if (id) {
	      attrs.id = id;
	    }
	    if (classes) {
	      attrs.className = classes;
	    }
	
	    return _react2.default.createElement(
	      'select',
	      attrs,
	      this.getDefaultOption(),
	      this.getCountries()
	    );
	  };
	
	  return CountryDropdown;
	}(_react2.default.Component);
	
	CountryDropdown.defaultProps = {
	  value: '',
	  name: 'rcrs-country',
	  id: '',
	  classes: '',
	  showDefaultOption: true,
	  defaultOptionLabel: 'Select Country',
	  onChange: function onChange() {},
	  onBlur: function onBlur() {},
	  labelType: C.DISPLAY_TYPE_FULL,
	  valueType: C.DISPLAY_TYPE_FULL,
	  whitelist: [],
	  blacklist: [],
	  disabled: false
	};
	
	var RegionDropdown = function (_React$Component2) {
	  _inherits(RegionDropdown, _React$Component2);
	
	  function RegionDropdown(props) {
	    _classCallCheck(this, RegionDropdown);
	
	    var _this2 = _possibleConstructorReturn(this, _React$Component2.call(this, props));
	
	    _this2.state = { regions: _this2.getRegions(props.country) };
	    _this2.getRegions = _this2.getRegions.bind(_this2);
	    return _this2;
	  }
	
	  RegionDropdown.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return nextProps.country !== this.props.country || nextProps.value !== this.props.value;
	  };
	
	  RegionDropdown.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.country === this.props.country) {
	      return;
	    }
	    this.setState({ regions: this.getRegions(nextProps.country) });
	  };
	
	  RegionDropdown.prototype.getRegions = function getRegions(country) {
	    if (!country) {
	      return [];
	    }
	
	    var countryValueType = this.props.countryValueType;
	
	    var searchIndex = countryValueType === C.DISPLAY_TYPE_FULL ? 0 : 1;
	    var regions = [];
	    _sourceData2.default.forEach(function (i) {
	      if (i[searchIndex] === country) {
	        regions = i;
	        return;
	      }
	    });
	
	    // this could happen if the user is managing the state of the region/country themselves and screws up passing
	    // in a valid country
	    if (!regions || regions.length === 0) {
	      console.error('Error. Unknown country passed: ' + country + '. If you\'re passing a country shortcode, be sure to include countryValueType="short" on the RegionDropdown');
	      return [];
	    }
	    return regions[2].split(C.REGION_LIST_DELIMITER).map(function (regionPair) {
	      var _regionPair$split = regionPair.split(C.SINGLE_REGION_DELIMITER),
	          regionName = _regionPair$split[0],
	          _regionPair$split$ = _regionPair$split[1],
	          regionShortCode = _regionPair$split$ === undefined ? null : _regionPair$split$;
	
	      return { regionName: regionName, regionShortCode: regionShortCode };
	    });
	  };
	
	  RegionDropdown.prototype.getRegionList = function getRegionList() {
	    var _props4 = this.props,
	        labelType = _props4.labelType,
	        valueType = _props4.valueType;
	
	    return this.state.regions.map(function (_ref2) {
	      var regionName = _ref2.regionName,
	          regionShortCode = _ref2.regionShortCode;
	
	      var label = labelType === C.DISPLAY_TYPE_FULL ? regionName : regionShortCode;
	      var value = valueType === C.DISPLAY_TYPE_FULL ? regionName : regionShortCode;
	      return _react2.default.createElement(
	        'option',
	        { value: value, key: regionName },
	        label
	      );
	    });
	  };
	
	  // there are two default options. The "blank" option which shows up when the user hasn't selected a country yet, and
	  // a "default" option which shows
	
	
	  RegionDropdown.prototype.getDefaultOption = function getDefaultOption() {
	    var _props5 = this.props,
	        blankOptionLabel = _props5.blankOptionLabel,
	        showDefaultOption = _props5.showDefaultOption,
	        defaultOptionLabel = _props5.defaultOptionLabel,
	        country = _props5.country;
	
	    if (!country) {
	      return _react2.default.createElement(
	        'option',
	        { value: '' },
	        blankOptionLabel
	      );
	    }
	    if (showDefaultOption) {
	      return _react2.default.createElement(
	        'option',
	        { value: '' },
	        defaultOptionLabel
	      );
	    }
	    return null;
	  };
	
	  RegionDropdown.prototype.render = function render() {
	    var _props6 = this.props,
	        value = _props6.value,
	        country = _props6.country,
	        _onChange2 = _props6.onChange,
	        _onBlur2 = _props6.onBlur,
	        id = _props6.id,
	        name = _props6.name,
	        classes = _props6.classes,
	        disabled = _props6.disabled,
	        disableWhenEmpty = _props6.disableWhenEmpty;
	
	    var isDisabled = disabled || disableWhenEmpty && country == '';
	    var attrs = {
	      name: name,
	      value: value,
	      onChange: function onChange(e) {
	        return _onChange2(e.target.value, e);
	      },
	      onBlur: function onBlur(e) {
	        return _onBlur2(e);
	      },
	      disabled: isDisabled
	    };
	    if (id) {
	      attrs.id = id;
	    }
	    if (classes) {
	      attrs.className = classes;
	    }
	
	    return _react2.default.createElement(
	      'select',
	      attrs,
	      this.getDefaultOption(),
	      this.getRegionList()
	    );
	  };
	
	  return RegionDropdown;
	}(_react2.default.Component);
	
	RegionDropdown.defaultProps = {
	  country: '',
	  value: '',
	  name: 'rcrs-region',
	  id: '',
	  classes: '',
	  blankOptionLabel: '-',
	  showDefaultOption: true,
	  defaultOptionLabel: 'Select Region',
	  onChange: function onChange() {},
	  onBlur: function onBlur() {},
	  countryValueType: C.DISPLAY_TYPE_FULL,
	  labelType: C.DISPLAY_TYPE_FULL,
	  valueType: C.DISPLAY_TYPE_FULL,
	  disabled: false,
	  disableWhenEmpty: false
	};
	
	// ------------------------- helpers --------------------------------
	
	
	// called on country field initialization. It reduces the subset of countries depending on whether the user
	// specified a white/blacklist
	function _filterCountries(countries, whitelist, blacklist) {
	  var filteredCountries = countries;
	
	  // N.B. I'd rather use ES6 array.includes() but it requires a polyfill on various browsers. Bit surprising that
	  // babel doesn't automatically convert it to ES5-friendly code, like the new syntax additions, but that requires
	  // a separate polyfill which is a total kludge
	  if (whitelist.length > 0) {
	    filteredCountries = countries.filter(function (_ref3) {
	      var countrySlug = _ref3[1];
	      return whitelist.indexOf(countrySlug) > -1;
	    });
	  } else if (blacklist.length > 0) {
	    filteredCountries = countries.filter(function (_ref4) {
	      var countrySlug = _ref4[1];
	      return blacklist.indexOf(countrySlug) === -1;
	    });
	  }
	
	  return filteredCountries;
	}
	
	exports.CountryDropdown = CountryDropdown;
	exports.RegionDropdown = RegionDropdown;
	exports.CountryRegionData = _sourceData2.default;

/***/ },

/***/ "Gs9Q":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var CountryRegionData = [["Afghanistan", "AF", "Badakhshan~BDS|Badghis~BDG|Baghlan~BGL|Balkh~BAL|Bamyan~BAM|Daykundi~DAY|Farah~FRA|Faryab~FYB|Ghazni~GHA|Ghor~GHO|Helmand~HEL|Herat~HER|Jowzjan~JOW|Kabul~KAB|Kandahar~KAN|Kapisa~KAP|Khost~KHO|Kunar~KNR|Kunduz~KDZ|Laghman~LAG|Logar~LOW|Maidan Wardak~WAR|Nangarhar~NAN|Nimruz~NIM|Nuristan~NUR|Paktia~PIA|Paktika~PKA|Panjshir~PAN|Parwan~PAR|Samangan~SAM|Sar-e Pol~SAR|Takhar~TAK|Urozgan~ORU|Zabul~ZAB"], ["Åland Islands", "AX", "Brändö~BR|Eckerö~EC|Finström~FN|Föglö~FG|Geta~GT|Hammarland~HM|Jomala~JM|Kumlinge~KM|Kökar~KK|Lemland~LE|Lumparland~LU|Mariehamn~MH|Saltvik~SV|Sottunga~ST|Sund~SD|Vårdö~VR"], ["Albania", "AL", "Berat~01|Dibër~09|Durrës~02|Elbasan~03|Fier~04|Gjirokastër~05|Korçë~06|Kukës~07|Lezhë~08|Shkodër~10|Tirana~11|Vlorë~12"], ["Algeria", "DZ", "Adrar~01|Aïn Defla~44|Aïn Témouchent~46|Algiers~16|Annaba~23|Batna~05|Béchar~08|Béjaïa~06|Biskra~07|Blida~09|Bordj Bou Arréridj~34|Bouïra~10|Boumerdès~35|Chlef~02|Constantine~25|Djelfa~17|El Bayadh~32|El Oued~39|El Tarf~36|Ghardaïa~47|Guelma~24|Illizi~33|Jijel~18|Khenchela~40|Laghouat~03|Mascara~29|Médéa~26|Mila~43|Mostaganem~27|Msila~28|Naâma~45|Oran~31|Ouargla~30|Oum el Bouaghi~04|Relizane~48|Saïda~20|Sétif~19|Sidi Bel Abbès~22|Skikda~21|Souk Ahras~41|Tamanghasset~11|Tébessa~12|Tiaret~14|Tindouf~37|Tipaza~42|Tissemsilt~38|Tizi Ouzou~15|Tlemcen~13"], ["American Samoa", "AS", "Tutuila~01|Aunu'u~02|Ta'ū~03|Ofu‑Olosega~04|Rose Atoll~21|Swains Island~22"], ["Andorra", "AD", "Andorra la Vella~07|Canillo~02|Encamp~03|Escaldes-Engordany~08|La Massana~04|Ordino~05|Sant Julià de Lòria~06"], ["Angola", "AO", "Bengo~BGO|Benguela~BGU|Bié~BIE|Cabinda~CAB|Cuando Cubango~CCU|Cuanza Norte~CNO|Cuanza Sul~CUS|Cunene~CNN|Huambo~HUA|Huíla~HUI|Luanda~LUA|Lunda Norte~LNO|Lunda Sul~LSU|Malanje~MAL|Moxico~MOX|Namibe~NAM|Uíge~UIG|Zaire~ZAI"], ["Anguilla", "AI", "Anguilla~01|Anguillita Island~02|Blowing Rock~03|Cove Cay~04|Crocus Cay~05|Deadman's Cay~06|Dog Island~07|East Cay~08|Little Island~09|Little Scrub Island~10|Mid Cay~11|North Cay~12|Prickly Pear Cays~13|Rabbit Island~14|Sandy Island/Sand Island~15|Scilly Cay~16|Scrub Island~17|Seal Island~18|Sombrero/Hat Island~19|South Cay~20|South Wager Island~21|West Cay~22"], ["Antarctica", "AQ", "Antarctica~AQ"], ["Antigua and Barbuda", "AG", "Antigua Island~01|Barbuda Island~02|Bird Island~04|Bishop Island~05|Blake Island~06|Crump Island~09|Dulcina Island~10|Exchange Island~11|Five Islands~12|Great Bird Island~13|Green Island~14|Guiana Island~15|Hawes Island~17|Hells Gate Island~16|Henry Island~18|Johnson Island~19|Kid Island~20|Lobster Island~22|Maiden Island~24|Moor Island~25|Nanny Island~26|Pelican Island~27|Prickly Pear Island~28|Rabbit Island~29|Red Head Island~31|Redonda Island~03|Sandy Island~32|Smith Island~33|The Sisters~34|Vernon Island~35|Wicked Will Island~36|York Island~37"], ["Argentina", "AR", "Buenos Aires~B|Capital Federal~C|Catamarca~K|Chaco~H|Chubut~U|Córdoba~X|Corrientes~W|Entre Ríos~E|Formosa~P|Jujuy~Y|La Pampa~L|La Rioja~F|Mendoza~M|Misiones~N|Neuquén~Q|Río Negro~R|Salta~A|San Juan~J|San Luis~D|Santa Cruz~Z|Santa Fe~S|Santiago del Estero~G|Tierra del Fuego~V|Tucumán~T"], ["Armenia", "AM", "Aragatsotn~AG|Ararat~AR|Armavir~AV|Gegharkunik~GR|Kotayk~KT|Lori~LO|Shirak~SH|Syunik~SU|Tavush~TV|Vayots Dzor~VD|Yerevan~ER"], ["Aruba", "AW", "Aruba~AW"], ["Australia", "AU", "Australian Capital Territory~ACT|New South Wales~NSW|Northern Territory~NT|Queensland~QLD|South Australia~SA|Tasmania~TAS|Victoria~VIC|Western Australia~WA"], ["Austria", "AT", "Burgenland~1|Kärnten~2|Niederösterreich~3|Oberösterreich~4|Salzburg~5|Steiermark~6|Tirol~7|Vorarlberg~8|Wien~9"], ["Azerbaijan", "AZ", "Abşeron~ABS|Ağcabədi~AGC|Ağdam~AGM|Ağdaş~AGS|Ağstafa~AGA|Ağsu~AGU|Astara~AST|Babək~BAB|Balakən~BAL|Bərdə~BAR|Beyləqan~BEY|Biləsuvar~BIL|Cəbrayıl~CAB|Cəlilabad~CAL|Culfa~CUL|Daşkəsən~DAS|Füzuli~FUZ|Gədəbəy~GAD|Goranboy~GOR|Göyçay~GOY|Göygöl~GYG|Hacıqabul~HAC|İmişli~IMI|İsmayıllı~ISM|Kəlbəcər~KAL|Kǝngǝrli~KAN|Kürdəmir~KUR|Laçın~LAC|Lənkəran~LAN|Lerik~LER|Masallı~MAS|Neftçala~NEF|Oğuz~OGU|Ordubad~ORD|Qəbələ~QAB|Qax~QAX|Qazax~QAZ|Qobustan~QOB|Quba~QBA|Qubadli~QBI|Qusar~QUS|Saatlı~SAT|Sabirabad~SAB|Şabran~SBN|Sədərək~SAD|Şahbuz~SAH|Şəki~SAK|Salyan~SAL|Şamaxı~SMI|Şəmkir~SKR|Samux~SMX|Şərur~SAR|Siyəzən~SIY|Şuşa~SUS|Tərtər~TAR|Tovuz~TOV|Ucar~UCA|Xaçmaz~XAC|Xızı~XIZ|Xocalı~XCI|Xocavənd~XVD|Yardımlı~YAR|Yevlax~YEV|Zəngilan~ZAN|Zaqatala~ZAQ|Zərdab~ZAR"], ["Bahamas", "BS", "Acklins Island~01|Berry Islands~22|Bimini~02|Black Point~23|Cat Island~03|Central Abaco~24|Crooked Island and Long Cay~28|East Grand Bahama~29|Exuma~04|Freeport~05|Fresh Creek~06|Governor's Harbour~07|Green Turtle Cay~08|Harbour Island~09|High Rock~10|Inagua~11|Kemps Bay~12|Long Island~13|Marsh Harbour~14|Mayaguana~15|Moore’s Island~40|New Providence~16|Nichollstown and Berry Islands~17|North Abaco~42|North Andros~41|North Eleuthera~33|Ragged Island~18|Rock Sound~19|San Salvador and Rum Cay~20|Sandy Point~21|South Abaco~35|South Andros~36|South Eleuthera~37|West Grand Bahama~39"], ["Bahrain", "BH", "Al Janūbīyah~14|Al Manāmah~13|Al Muḩarraq~15|Al Wusţá~16|Ash Shamālīyah~17"], ["Bangladesh", "BD", "Barisal~A|Chittagong~B|Dhaka~C|Khulna~D|Rajshahi~E|Rangpur~F|Sylhet~G"], ["Barbados", "BB", "Christ Church~01|Saint Andrew~02|Saint George~03|Saint James~04|Saint John~05|Saint Joseph~06|Saint Lucy~07|Saint Michael~08|Saint Peter~09|Saint Philip~10|Saint Thomas~11"], ["Belarus", "BY", "Brest voblast~BR|Gorod Minsk~HO|Homiel voblast~HO|Hrodna voblast~HR|Mahilyow voblast~MA|Minsk voblast~MI|Vitsebsk voblast~VI"], ["Belgium", "BE", "Bruxelles-Capitale~BRU|Région Flamande~VLG|Région Wallonië~WAL"], ["Belize", "BZ", "Belize District~BZ|Cayo District~CY|Corozal District~CZL|Orange Walk District~OW|Stann Creek District~SC|Toledo District~TOL"], ["Benin", "BJ", "Alibori~AL|Atakora~AK|Atlantique~AQ|Borgou~BO|Collines Department~CO|Donga~DO|Kouffo~KO|Littoral Department~LI|Mono Department~MO|Ouémé~OU|Plateau~PL|Zou~ZO"], ["Bermuda", "BM", "City of Hamilton~03|Devonshire Parish~01|Hamilton Parish~02|Paget Parish~04|Pembroke Parish~05|Sandys Parish~08|Smith's Parish~09|Southampton Parish~10|St. George's Parish~07|Town of St. George~06|Warwick Parish~11"], ["Bhutan", "BT", "Bumthang~33|Chhukha~12|Dagana~22|Gasa~GA|Haa~13|Lhuntse~44|Mongar~42|Paro~11|Pemagatshel~43|Punakha~23|Samdrup Jongkhar~45|Samtse~14|Sarpang~31|Thimphu~15|Trashigang~41|Trashiyangtse~TY|Trongsa~32|Tsirang~21|Wangdue Phodrang~24|Zhemgang~34"], ["Bolivia", "BO", "Beni~B|Chuquisaca~H|Cochabamba~C|La Paz~L|Oruro~O|Pando~N|Potosí~P|Santa Cruz~S|Tarija~T"], ["Bonaire, Sint Eustatius and Saba", "BQ", "Bonaire~BO|Saba Isand~SA|Sint Eustatius~SE"], ["Bosnia and Herzegovina", "BA", "Brčko Distrikt~BRC|Federacija Bosne i Hercegovine~BIH|Republika Srpska~SRP"], ["Botswana", "BW", "Central~CE|Ghanzi~GH|Kgalagadi~KG|Kgatleng~KL|Kweneng~KW|North West~NW|North-East~NE|South East~SE|Southern~SO"], ["Bouvet Island", "BV", "Bouvet Island~BV"], ["Brazil", "BR", "Acre~AC|Alagoas~AL|Amapá~AP|Amazonas~AM|Bahia~BA|Ceará~CE|Distrito Federal~DF|Espírito Santo~ES|Goiás~GO|Maranhão~MA|Mato Grosso~MT|Mato Grosso do Sul~MS|Minas Gerais~MG|Para~PA|Paraiba~PB|Paraná~PR|Pernambuco~PE|Piauí~PI|Rio de Janeiro~RJ|Rio Grande do Norte~RN|Rio Grande do Sul~RS|Rondônia~RO|Roraima~RR|Santa Catarina~SC|Sao Paulo~SP|Sergipe~SE|Tocantins~TO"], ["British Indian Ocean Territory", "IO", "British Indian Ocean Territory~IO"], ["Brunei Darussalam", "BN", "Belait~BE|Brunei Muara~BM|Temburong~TE|Tutong~TU"], ["Bulgaria", "BG", "Blagoevgrad~01|Burgas~02|Dobrich~08|Gabrovo~07|Jambol~28|Khaskovo~26|Kjustendil~10|Kurdzhali~09|Lovech~11|Montana~12|Pazardzhik~13|Pernik~14|Pleven~15|Plovdiv~16|Razgrad~17|Ruse~18|Shumen~27|Silistra~19|Sliven~20|Smoljan~21|Sofija~23|Sofija-Grad~22|Stara Zagora~24|Turgovishhe~25|Varna~03|Veliko Turnovo~04|Vidin~05|Vraca~06"], ["Burkina Faso", "BF", "Balé~BAL|Bam/Lake Bam~BAM|Banwa Province~BAN|Bazèga~BAZ|Bougouriba~BGR|Boulgou Province~BLG|Boulkiemdé~BLK|Comoé/Komoe~COM|Ganzourgou Province~GAN|Gnagna~GNA|Gourma Province~GOU|Houet~HOU|Ioba~IOB|Kadiogo~KAD|Kénédougou~KEN|Komondjari~KMD|Kompienga~KMP|Kossi Province~KOS|Koulpélogo~KOP|Kouritenga~KOT|Kourwéogo~KOW|Léraba~LER|Loroum~LOR|Mouhoun~MOU|Namentenga~NAM|Naouri/Nahouri~NAO|Nayala~NAY|Noumbiel~NOU|Oubritenga~OUB|Oudalan~OUD|Passoré~PAS|Poni~PON|Sanguié~SNG|Sanmatenga~SMT|Séno~SEN|Sissili~SIS|Soum~SOM|Sourou~SOR|Tapoa~TAP|Tui/Tuy~TUI|Yagha~YAG|Yatenga~YAT|Ziro~ZIR|Zondoma~ZON|Zoundwéogo~ZOU"], ["Burundi", "BI", "Bubanza~BB|Bujumbura Mairie~BM|Bujumbura Rural~BL|Bururi~BR|Cankuzo~CA|Cibitoke~CI|Gitega~GI|Karuzi~KR|Kayanza~KY|Kirundo~KI|Makamba~MA|Muramvya~MU|Muyinga~MY|Mwaro~MW|Ngozi~NG|Rutana~RT|Ruyigi~RY"], ["Cambodia", "KH", "Baat Dambang~2|Banteay Mean Chey~1|Kampong Chaam~3|Kampong Chhnang~4|Kampong Spueu~5|Kampong Thum~6|Kampot~7|Kandaal~8|Kaoh Kong~9|Kracheh~10|Krong Kaeb~23|Krong Pailin~24|Krong Preah Sihanouk~18|Mondol Kiri~11|Otdar Mean Chey~22|Phnom Penh~12|Pousaat~15|Preah Vihear~13|Prey Veaeng~14|Rotanah Kiri~16|Siem Reab~17|Stueng Treng~19|Svaay Rieng~20|Taakaev~21|Tbong Khmum~25"], ["Cameroon", "CM", "Adamaoua~AD|Centre~CE|Est~ES|Extrême-Nord~EN|Littoral~LT|Nord~NO|Nord-Ouest~NW|Ouest~OU|Sud~SU|Sud-Ouest~SW"], ["Canada", "CA", "Alberta~AB|British Columbia~BC|Manitoba~MB|New Brunswick~NB|Newfoundland and Labrador~NL|Northwest Territories~NT|Nova Scotia~NS|Nunavut~NU|Ontario~ON|Prince Edward Island~PE|Quebec~QC|Saskatchewan~SK|Yukon~YT"], ["Cape Verde", "CV", "Boa Vista~BV|Brava~BR|Calheta de São Miguel~CS|Maio~MA|Mosteiros~MO|Paúl~PA|Porto Novo~PN|Praia~PR|Ribeira Brava~RB|Ribeira Grande~RG|Sal~SL|Santa Catarina~CA|Santa Cruz~CR|São Domingos~SD|São Filipe~SF|São Nicolau~SN|São Vicente~SV|Tarrafal~TA|Tarrafal de São Nicolau~TS"], ["Cayman Islands", "KY", "Creek|Eastern|Midland|South Town|Spot Bay|Stake Bay|West End|Western"], ["Central African Republic", "CF", "Bamingui-Bangoran~BB|Bangui~BGF|Basse-Kotto~BK|Haute-Kotto~HK|Haut-Mbomou~HM|Kémo~KG|Lobaye~LB|Mambéré-Kadéï~HS|Mbomou~MB|Nana-Grebizi~10|Nana-Mambéré~NM|Ombella-M'Poko~MP|Ouaka~UK|Ouham~AC|Ouham Péndé~OP|Sangha-Mbaéré~SE|Vakaga~VK"], ["Chad", "TD", "Bahr el Ghazal~BG|Batha~BA|Borkou~BO|Chari-Baguirmi~CB|Ennedi-Est~EE|Ennedi-Ouest~EO|Guéra~GR|Hadjer Lamis~HL|Kanem~KA|Lac~LC|Logone Occidental~LO|Logone Oriental~LR|Mondoul~MA|Mayo-Kébbi-Est~ME|Moyen-Chari~MC|Ouaddai~OD|Salamat~SA|Sila~SI|Tandjilé~TA|Tibesti~TI|Ville de Ndjamena~ND|Wadi Fira~WF"], ["Chile", "CL", "Aisén del General Carlos Ibáñez del Campo~AI|Antofagasta~AN|Araucanía~AR|Arica y Parinacota~AP|Atacama~AT|Bío-Bío~BI|Coquimbo~CO|Libertador General Bernardo O'Higgins~LI|Los Lagos~LL|Los Ríos~LR|Magallanes y Antartica Chilena~MA|Marga-Marga~|Maule~ML|Región Metropolitana de Santiago~RM|Tarapacá~TA|Valparaíso~VS"], ["China", "CN", "Anhui~34|Beijing~11|Chongqing~50|Fujian~35|Gansu~62|Guangdong~44|Guangxi~45|Guizhou~52|Hainan~46|Hebei~13|Heilongjiang~23|Henan~41|Hong Kong~91|Hubei~42|Hunan~43|Inner Mongolia~15|Jiangsu~32|Jiangxi~36|Jilin~22|Liaoning~21|Macau~92|Ningxia~64|Qinghai~63|Shaanxi~61|Shandong~37|Shanghai~31|Shanxi~14|Sichuan~51|Tianjin~12|Tibet~54|Xinjiang~65|Yunnan~53|Zhejiang~33"], ["Christmas Island", "CX", "Christmas Island~CX"], ["Cocos (Keeling) Islands", "CC", "Direction Island~DI|Home Island~HM|Horsburgh Island~HR|North Keeling Island~NK|South Island~SI|West Island~WI"], ["Colombia", "CO", "Amazonas~AMA|Antioquia~ANT|Arauca~ARA|Archipiélago de San Andrés~SAP|Atlántico~ATL|Bogotá D.C.~DC|Bolívar~BOL|Boyacá~BOY|Caldas~CAL|Caquetá~CAQ|Casanare~CAS|Cauca~CAU|Cesar~CES|Chocó~CHO|Córdoba~COR|Cundinamarca~CUN|Guainía~GUA|Guaviare~GUV|Huila~HUI|La Guajira~LAG|Magdalena~MAG|Meta~MET|Nariño~NAR|Norte de Santander~NSA|Putumayo~PUT|Quindío~QUI|Risaralda~RIS|Santander~SAN|Sucre~SUC|Tolima~TOL|Valle del Cauca~VAC|Vaupés~VAU|Vichada~VID"], ["Comoros", "KM", "Andjazîdja~G|Andjouân~A|Moûhîlî~M"], ["Congo, Republic of the (Brazzaville)", "CG", "Bouenza~11|Brazzaville~BZV|Cuvette~8|Cuvette-Ouest~15|Kouilou~5|Lékoumou~2|Likouala~7|Niari~9|Plateaux~14|Pointe-Noire~16|Pool~12|Sangha~13"], ["Congo, the Democratic Republic of the (Kinshasa)", "CD", "Bandundu~BN|Bas-Congo~BC|Équateur~EQ|Kasaï-Occidental~KE|Kasaï-Oriental~KW|Katanga~KA|Kinshasa~KN|Maniema~MA|Nord-Kivu~NK|Orientale~OR|Sud-Kivu~SK"], ["Cook Islands", "CK", "Aitutaki|Atiu|Avarua|Mangaia|Manihiki|Ma'uke|Mitiaro|Nassau|Palmerston|Penrhyn|Pukapuka|Rakahanga"], ["Costa Rica", "CR", "Alajuela~2|Cartago~3|Guanacaste~5|Heredia~4|Limón~7|Puntarenas~6|San José~1"], ["Côte d'Ivoire, Republic of", "CI", "Agnéby~16|Bafing~17|Bas-Sassandra~09|Denguélé~10|Dix-Huit Montagnes~06|Fromager~18|Haut-Sassandra~02|Lacs~07|Lagunes~01|Marahoué~12|Moyen-Cavally~19|Moyen-Comoé~05|N'zi-Comoé~11|Savanes~03|Sud-Bandama~15|Sud-Comoé~13|Vallée du Bandama~04|Worodougou~14|Zanzan~08"], ["Croatia", "HR", "Bjelovarsko-Bilogorska Županija~07|Brodsko-Posavska Županija~12|Dubrovačko-Neretvanska Županija~19|Grad Zagreb~21|Istarska Županija~18|Karlovačka Županija~04|Koprivničko-Krizevačka Županija~06|Krapinsko-Zagorska Županija~02|Ličko-Senjska Županija~09|Međimurska Županija~20|Osječko-Baranjska Županija~14|Požeško-Slavonska Županija~11|Primorsko-Goranska Županija~08|Sisačko-Moslavačka Županija~03|Splitsko-Dalmatinska Županija~17|Sibensko-Kninska Županija~15|Varaždinska Županija~05|Virovitičko-Podravska Županija~10|Vukovarsko-Srijemska Županija~16|Zadarska Županija~13|Zagrebacka Zupanija~01"], ["Cuba", "CU", "Artemisa~15|Camagüey~09|Ciego de Ávila~08|Cienfuegos~06|Granma~12|Guantánamo~14|Holguín~11|Isla de la Juventud~99|La Habana~03|Las Tunas~10|Matanzas~04|Mayabeque~16|Pinar del Río~01|Sancti Spíritus~07|Santiago de Cuba~13|Villa Clara~05"], ["Curaçao", "CW", "Curaçao~CW"], ["Cyprus", "CY", "Ammochostos~04|Keryneia~05|Larnaka~03|Lefkosia~01|Lemesos~02|Pafos~05"], ["Czech Republic", "CZ", "Hlavní město Praha~PR|Jihočeský kraj~JC|Jihomoravský kraj~JM|Karlovarský kraj~KA|Královéhradecký kraj~KR|Liberecký kraj~LI|Moravskoslezský kraj~MO|Olomoucký kraj~OL|Pardubický kraj~PA|Plzeňský kraj~PL|Středočeský kraj~ST|Ústecký kraj~US|Vysočina~VY|Zlínský kraj~ZL"], ["Denmark", "DK", "Hovedstaden~84|Kujalleq~GL-KU|Midtjylland~82|Norderøerne~FO-01|Nordjylland~81|Østerø~FO-06|Qaasuitsup~GL-QA|Qeqqata~GL-QE|Sandø~FO-02|Sermersooq~GL-SM|Sjælland~85|Strømø~FO-03|Suderø~FO-04|Syddanmark~83|Vågø~FO-05"], ["Djibouti", "DJ", "Ali Sabieh~AS|Arta~AR|Dikhil~DI|Obock~OB|Tadjourah~TA"], ["Dominica", "DM", "Saint Andrew Parish~02|Saint David Parish~03|Saint George Parish~04|Saint John Parish~05|Saint Joseph Parish~06|Saint Luke Parish~07|Saint Mark Parish~08|Saint Patrick Parish~09|Saint Paul Parish~10|Saint Peter Parish~11"], ["Dominican Republic", "DO", "Cibao Central~02|Del Valle~37|Distrito Nacional~01|Enriquillo~38|Norcentral~04|Nordeste~34|Noroeste~34|Norte~35|Valdesia~42"], ["Ecuador", "EC", "Azuay~A|Bolívar~B|Cañar~F|Carchi~C|Chimborazo~H|Cotopaxi~X|El Oro~O|Esmeraldas~E|Galápagos~W|Guayas~G|Imbabura~I|Loja~L|Los Ríos~R|Manabí~M|Morona-Santiago~S|Napo~N|Orellana~D|Pastaza~Y|Pichincha~P|Santa Elena~SE|Santo Domingo de los Tsáchilas~SD|Sucumbíos~U|Tungurahua~T|Zamora-Chinchipe~Z"], ["Egypt", "EG", "Alexandria~ALX|Aswan~ASN|Asyout~AST|Bani Sueif~BNS|Beheira~BH|Cairo~C|Daqahlia~DK|Dumiat~DT|El Bahr El Ahmar~BA|El Ismailia~IS|El Suez~SUZ|El Wadi El Gedeed~WAD|Fayoum~FYM|Gharbia~GH|Giza~SUZ|Helwan~HU|Kafr El Sheikh~KFS|Luxor~LX|Matrouh~MT|Menia~MN|Menofia~MNF|North Sinai~SIN|Port Said~PTS|Qalubia~KB|Qena~KN|Sharqia~SHR|Sixth of October~SU|Sohag~SHG|South Sinai~JS"], ["El Salvador", "SV", "Ahuachapán~AH|Cabañas~CA|Cuscatlán~CU|Chalatenango~CH|La Libertad~LI|La Paz~PA|La Unión~UN|Morazán~MO|San Miguel~SM|San Salvador~SS|Santa Ana~SA|San Vicente~SV|Sonsonate~SO|Usulután~US"], ["Equatorial Guinea", "GQ", "Annobón~AN|Bioko Norte~BN|Bioko Sur~BS|Centro Sur~CS|Kié-Ntem~KN|Litoral~LI|Wele-Nzas~WN"], ["Eritrea", "ER", "Anseba~AN|Debub~DU|Debub-Keih-Bahri~DK|Gash-Barka~GB|Maekel~MA|Semien-Keih-Bahri~SK"], ["Estonia", "EE", "Harjumaa (Tallinn)~37|Hiiumaa (Kardla)~39|Ida-Virumaa (Johvi)~44|Järvamaa (Paide)~41|Jõgevamaa (Jogeva)~49|Läänemaa~57|Lääne-Virumaa (Rakvere)~59|Pärnumaa (Parnu)~67|Põlvamaa (Polva)~65|Raplamaa (Rapla)~70|Saaremaa (Kuessaare)~74|Tartumaa (Tartu)~78|Valgamaa (Valga)~82|Viljandimaa (Viljandi)~84|Võrumaa (Voru)~86"], ["Ethiopia", "ET", "Addis Ababa~AA|Afar~AF|Amhara~AM|Benshangul-Gumaz~BE|Dire Dawa~DD|Gambela~GA|Harari~HA|Oromia~OR|Somali~SO|Southern Nations Nationalities and People's Region~SN|Tigray~TI"], ["Falkland Islands (Islas Malvinas)", "FK", "Falkland Islands (Islas Malvinas)"], ["Faroe Islands", "FO", "Bordoy|Eysturoy|Mykines|Sandoy|Skuvoy|Streymoy|Suduroy|Tvoroyri|Vagar"], ["Fiji", "FJ", "Ba~01|Bua~01|Cakaudrove~03|Kadavu~04|Lau~05|Lomaiviti~06|Macuata~07|Nadroga and Navosa~08|Naitasiri~09|Namosi~10|Ra~011|Rewa~12|Rotuma~R|Serua~12|Tailevu~14"], ["Finland", "FI", "Ahvenanmaan lääni~AL|Etelä-Suomen lääni~ES|Itä-Suomen lääni~IS|Länsi-Suomen lääni~LS|Lapin lääni~LL|Oulun lääni~OL"], ["France", "FR", "Auvergne-Rhône-Alpes~ARA|Bourgogne-Franche-Comté~BFC|Bretagne~BRE|Centre-Val de Loire~CVL|Corse~COR|Grand Est~GES|Hauts-de-France~HDF|Île-de-France~IDF|Normandie~NOR|Nouvelle-Aquitaine~NAQ|Occitanie~OCC|Pays de la Loire~PDL|Provence-Alpes-Cote d'Azur~PAC|Clipperton~CP|Guadeloupe~GP|Guyane~GF|Martinique~MQ|Mayotte~YT|Novelle-Calédonie~NC|Polynésie~PF|Saint-Pierre-et-Miquelon~PM|Saint Barthélemy~BL|Saint Martin~MF|Réunion~RE|Terres Australes Françaises~TF|Wallis-et-Futuna~WF"], ["French Guiana", "GF", "French Guiana"], ["French Polynesia", "PF", "Archipel des Marquises|Archipel des Tuamotu|Archipel des Tubuai|Iles du Vent|Iles Sous-le-Vent"], ["French Southern and Antarctic Lands", "TF", "Adelie Land|Ile Crozet|Iles Kerguelen|Iles Saint-Paul et Amsterdam"], ["Gabon", "GA", "Estuaire~1|Haut-Ogooué~2|Moyen-Ogooué~3|Ngounié~4|Nyanga~5|Ogooué-Ivindo~6|Ogooué-Lolo~7|Ogooué-Maritime~8|Woleu-Ntem~9"], ["Gambia, The", "GM", "Banjul~B|Central River~M|Lower River~L|North Bank~N|Upper River~U|Western~W"], ["Georgia", "GE", "Abkhazia (Sokhumi)~AB|Ajaria (Bat'umi)~AJ|Guria~GU|Imereti~IM|K'akheti~KA|Kvemo Kartli~KK|Mtshkheta-Mtianeti~MM|Rach'a-Lexhkumi-KvemoSvaneti~RL|Samegrelo-Zemo Svaneti~SZ|Samtskhe-Javakheti~SJ|Shida Kartli~SK|Tbilisi~TB"], ["Germany", "DE", "Baden-Württemberg~BW|Bayern~BY|Berlin~BE|Brandenburg~BB|Bremen~HB|Hamburg~HH|Hessen~HE|Mecklenburg-Vorpommern~MV|Niedersachsen~NI|Nordrhein-Westfalen~NW|Rheinland-Pfalz~RP|Saarland~SL|Sachsen~SN|Sachsen-Anhalt~ST|Schleswig-Holstein~SH|Thüringen~TH"], ["Ghana", "GH", "Ashanti~AH|Brong-Ahafo~BA|Central~CP|Eastern~EP|Greater Accra~AA|Northern~NP|Upper East~UE|Upper West~UW|Volta~TV|Western~WP"], ["Gibraltar", "GI", "Gibraltar"], ["Greece", "GR", "Anatolikí Makedonía kai Thráki~A|Attikḯ~I|Dytikí Elláda~G|Dytikí Makedonía~C|Ionía Nísia~F|Kentrikí Makedonía~B|Krítí~M|Notío Aigaío~L|Peloponnísos~J|Stereá Elláda~H|Thessalía~E|Voreío Aigaío~K|Ípeiros~D|Ágion Óros~69"], ["Greenland", "GL", "Kommune Kujalleq~KU|Kommuneqarfik Sermersooq~SM|Qaasuitsup Kommunia~QA|Qeqqata Kommunia~QE"], ["Grenada", "GD", "Saint Andrew~01|Saint David~02|Saint George~03|Saint John~04|Saint Mark~05|Saint Patrick~06|Southern Grenadine Islands~10"], ["Guadeloupe", "GP", "Guadeloupe"], ["Guam", "GU", "Guam"], ["Guatemala", "GT", "Alta Verapaz~AV|Baja Verapaz~BV|Chimaltenango~CM|Chiquimula~CQ|El Progreso~PR|Escuintla~ES|Guatemala~GU|Huehuetenango~HU|Izabal~IZ|Jalapa~JA|Jutiapa~JU|Petén~PE|Quetzaltenango~QZ|Quiché~QC|Retalhuleu~Re|Sacatepéquez~SA|San Marcos~SM|Santa Rosa~SR|Sololá~SO|Suchitepéquez~SU|Totonicapán~TO|Zacapa~ZA"], ["Guernsey", "GG", "Castel|Forest|St. Andrew|St. Martin|St. Peter Port|St. Pierre du Bois|St. Sampson|St. Saviour|Torteval|Vale"], ["Guinea", "GN", "Boké~B|Conakry~C|Faranah~F|Kankan~K|Kindia~D|Labé~L|Mamou~M|Nzérékoré~N"], ["Guinea-Bissau", "GW", "Bafatá~BA|Biombo~BM|Bissau~BS|Bolama-Bijagos~BL|Cacheu~CA|Gabú~GA|Oio~OI|Quinara~QU|Tombali~TO"], ["Guyana", "GY", "Barima-Waini~BA|Cuyuni-Mazaruni~CU|Demerara-Mahaica~DE|East Berbice-Corentyne~EB|Essequibo Islands-West Demerara~ES|Mahaica-Berbice~MA|Pomeroon-Supenaam~PM|Potaro-Siparuni~PT|Upper Demerara-Berbice~UD|Upper Takutu-Upper Essequibo~UT"], ["Haiti", "HT", "Artibonite~AR|Centre~CE|Grand'Anse~GA|Nippes~NI|Nord~ND|Nord-Est~NE|Nord-Ouest~NO|Ouest~OU|Sud~SD|Sud-Est~SE"], ["Heard Island and McDonald Islands", "HM", "Heard Island and McDonald Islands"], ["Holy See (Vatican City)", "VA", "Holy See (Vatican City)~01"], ["Honduras", "HN", "Atlántida~AT|Choluteca~CH|Colón~CL|Comayagua~CM|Copán~CP|Cortés~CR|El Paraíso~EP|Francisco Morazan~FM|Gracias a Dios~GD|Intibucá~IN|Islas de la Bahía~IB|La Paz~LP|Lempira~LE|Ocotepeque~OC|Olancho~OL|Santa Bárbara~SB|Valle~VA|Yoro~YO"], ["Hong Kong", "HK", "Hong Kong"], ["Hungary", "HU", "Bács-Kiskun~BK|Baranya~BA|Békés~BE|Békéscsaba~BC|Borsod-Abauj-Zemplen~BZ|Budapest~BU|Csongrád~CS|Debrecen~DE|Dunaújváros~DU|Eger~EG|Érd~ER|Fejér~FE|Győr~GY|Győr-Moson-Sopron~GS|Hajdú-Bihar~HB|Heves~HE|Hódmezővásárhely~HV|Jász-Nagykun-Szolnok~N|Kaposvár~KV|Kecskemét~KM|Komárom-Esztergom~KE|Miskolc~MI|Nagykanizsa~NK|Nógrád~NO|Nyíregyháza~NY|Pécs~PS|Pest~PE|Salgótarján~ST|Somogy~SO|Sopron~SN|Szabolcs-á-Bereg~SZ|Szeged~SD|Székesfehérvár~SF|Szekszárd~SS|Szolnok~SK|Szombathely~SH|Tatabánya~TB|Tolna~TO|Vas~VA|Veszprém~VE|Veszprém (City)~VM|Zala~ZA|Zalaegerszeg~ZE"], ["Iceland", "IS", "Austurland~7|Höfuðborgarsvæði utan Reykjavíkur~1|Norðurland eystra~6|Norðurland vestra~5|Suðurland~8|Suðurnes~2|Vestfirðir~4|Vesturland~3"], ["India", "IN", "Andaman and Nicobar Islands~AN|Andhra Pradesh~AP|Arunachal Pradesh~AR|Assam~AS|Bihar~BR|Chandigarh~CH|Chhattisgarh~CT|Dadra and Nagar Haveli~DN|Daman and Diu~DD|Delhi~DL|Goa~GA|Gujarat~GJ|Haryana~HR|Himachal Pradesh~HP|Jammu and Kashmir~JK|Jharkhand~JH|Karnataka~KA|Kerala~KL|Lakshadweep~LD|Madhya Pradesh~MP|Maharashtra~MH|Manipur~MN|Meghalaya~ML|Mizoram~MZ|Nagaland~NL|Odisha~OR|Puducherry~PY|Punjab~PB|Rajasthan~RJ|Sikkim~WK|Tamil Nadu~TN|Telangana~TG|Tripura~TR|Uttarakhand~UT|Uttar Pradesh~UP|West Bengal~WB"], ["Indonesia", "ID", "Aceh~AC|Bali~BA|Bangka Belitung~BB|Banten~BT|Bengkulu~BE|Gorontalo~GO|Jakarta Raya~JK|Jambi~JA|Jawa Barat~JB|Jawa Tengah~JT|Jawa Timur~JI|Kalimantan Barat~KB|Kalimantan Selatan~KS|Kalimantan Tengah~KT|Kalimantan Timur~KI|Kalimantan Utara~KU|Kepulauan Riau~KR|Lampung~LA|Maluku~MA|Maluku Utara~MU|Nusa Tenggara Barat~NB|Nusa Tenggara Timur~NT|Papua~PA|Papua Barat~PB|Riau~RI|Sulawesi Selatan~SR|Sulawesi Tengah~ST|Sulawesi Tenggara~SG|Sulawesi Utara~SA|Sumatera Barat~SB|Sumatera Selatan~SS|Sumatera Utara~SU|Yogyakarta~YO"], ["Iran, Islamic Republic of", "IR", "Alborz~32|Ardabīl~03|Āz̄arbāyjān-e Gharbī~02|Āz̄arbāyjān-e Sharqī~01|Būshehr~06|Chahār Maḩāl va Bakhtīārī~08|Eşfahān~04|Fārs~14|Gīlān~19|Golestān~27|Hamadān~24|Hormozgān~23|Īlām~05|Kermān~15|Kermānshāh~17|Khorāsān-e Jonūbī~29|Khorāsān-e Raẕavī~30|Khorāsān-e Shomālī~61|Khūzestān~10|Kohgīlūyeh va Bowyer Aḩmad~18|Kordestān~16|Lorestān~20|Markazi~22|Māzandarān~21|Qazvīn~28|Qom~26|Semnān~12|Sīstān va Balūchestān~13|Tehrān~07|Yazd~25|Zanjān~11"], ["Iraq", "IQ", "Al Anbār~AN|Al Başrah~BA|Al Muthanná~MU|Al Qādisīyah~QA|An Najaf~NA|Arbīl~AR|As Sulaymānīyah~SU|Bābil~BB|Baghdād~BG|Dohuk~DA|Dhī Qār~DQ|Diyālá~DI|Karbalā'~KA|Kirkuk~KI|Maysān~MA|Nīnawá~NI|Şalāḩ ad Dīn~SD|Wāsiţ~WA"], ["Ireland", "IE", "Carlow~CW|Cavan~CN|Clare~CE|Cork~CO|Donegal~DL|Dublin~D|Galway~G|Kerry~KY|Kildare~KE|Kilkenny~KK|Laois~LS|Leitrim~LM|Limerick~LK|Longford~LD|Louth~LH|Mayo~MO|Meath~MH|Monaghan~MN|Offaly~OY|Roscommon~RN|Sligo~SO|Tipperary~TA|Waterford~WD|Westmeath~WH|Wexford~WX|Wicklow~WW"], ["Isle of Man", "IM", "Isle of Man"], ["Israel", "IL", "HaDarom~D|HaMerkaz~M|HaTsafon~Z|H̱efa~HA|Tel-Aviv~TA|Yerushalayim~JM"], ["Italy", "IT", "Abruzzo~65|Basilicata~77|Calabria~78|Campania~72|Emilia-Romagna~45|Friuli-Venezia Giulia~36|Lazio~62|Liguria~42|Lombardia~25|Marche~57|Molise~67|Piemonte~21|Puglia~75|Sardegna~88|Sicilia~82|Toscana~52|Trentino-Alto Adige~32|Umbria~55|Valle d'Aosta~23|Veneto~34"], ["Jamaica", "JM", "Clarendon~13|Hanover~09|Kingston~01|Manchester~12|Portland~04|Saint Andrew~02|Saint Ann~06|Saint Catherine~14|Saint Elizabeth~11|Saint James~08|Saint Mary~05|Saint Thomas~03|Trelawny~07|Westmoreland~10"], ["Japan", "JP", "Aichi~23|Akita~05|Aomori~02|Chiba~12|Ehime~38|Fukui~18|Fukuoka~40|Fukushima~07|Gifu~21|Gunma~10|Hiroshima~34|Hokkaido~01|Hyogo~28|Ibaraki~08|Ishikawa~17|Iwate~03|Kagawa~37|Kagoshima~46|Kanagawa~14|Kochi~39|Kumamoto~43|Kyoto~26|Mie~24|Miyagi~04|Miyazaki~45|Nagano~20|Nagasaki~42|Nara~29|Niigata~15|Oita~44|Okayama~33|Okinawa~47|Osaka~27|Saga~41|Saitama~11|Shiga~25|Shimane~32|Shizuoka~22|Tochigi~09|Tokushima~36|Tokyo~13|Tottori~31|Toyama~16|Wakayama~30|Yamagata~06|Yamaguchi~35|Yamanashi~19"], ["Jersey", "JE", "Jersey"], ["Jordan", "JO", "‘Ajlūn~AJ|Al 'Aqabah~AQ|Al Balqā’~BA|Al Karak~KA|Al Mafraq~MA|Al ‘A̅şimah~AM|Aţ Ţafīlah~AT|Az Zarqā’~AZ|Irbid~IR|Jarash~JA|Ma‘ān~MN|Mādabā~MD"], ["Kazakhstan", "KZ", "Almaty~ALA|Aqmola~AKM|Aqtobe~AKT|Astana~AST|Atyrau~ATY|Batys Qazaqstan~ZAP|Bayqongyr|Mangghystau~MAN|Ongtustik Qazaqstan~YUZ|Pavlodar~PAV|Qaraghandy~KAR|Qostanay~KUS|Qyzylorda~KZY|Shyghys Qazaqstan~VOS|Soltustik Qazaqstan~SEV|Zhambyl~ZHA"], ["Kenya", "KE", "Baringo~01|Bomet~02|Bungoma~03|Busia~04|Eleyo/Marakwet~05|Embu~06|Garissa~07|Homa Bay~08|Isiolo~09|Kajiado~10|Kakamega~11|Kericho~12|Kiambu~13|Kilifi~14|Kirinyaga~15|Kisii~16|Kisumu~17|Kitui~18|Kwale~19|Laikipia~20|Lamu~21|Machakos~22|Makueni~23|Mandera~24|Marsabit~25|Meru~26|Migori~27|Mombasa~28|Murang'a~29|Nairobi City~30|Nakuru~31|Nandi~32|Narok~33|Nyamira~34|Nyandarua~35|Nyeri~36|Samburu~37|Siaya~38|Taita/Taveta~39|Tana River~40|Tharaka-Nithi~41|Trans Nzoia~42|Turkana~43|Uasin Gishu~44|Vihiga~45|Wajir~46|West Pokot~47"], ["Kiribati", "KI", "Abaiang|Abemama|Aranuka|Arorae|Banaba|Beru|Butaritari|Central Gilberts|Gilbert Islands~G|Kanton|Kiritimati|Kuria|Line Islands~L|Maiana|Makin|Marakei|Nikunau|Nonouti|Northern Gilberts|Onotoa|Phoenix Islands~P|Southern Gilberts|Tabiteuea|Tabuaeran|Tamana|Tarawa|Teraina"], ["Korea, Democratic People's Republic of", "KP", "Chagang-do (Chagang Province)~04|Hamgyong-bukto (North Hamgyong Province)~09|Hamgyong-namdo (South Hamgyong Province)~08|Hwanghae-bukto (North Hwanghae Province)~06|Hwanghae-namdo (South Hwanghae Province)~05|Kangwon-do (Kangwon Province)~07|Nasŏn (Najin-Sŏnbong)~13|P'yongan-bukto (North P'yongan Province)~03|P'yongan-namdo (South P'yongan Province)~02|P'yongyang-si (P'yongyang City)~01|Yanggang-do (Yanggang Province)~10"], ["Korea, Republic of", "KR", "Ch'ungch'ongbuk-do~43|Ch'ungch'ongnam-do~44|Cheju-do~49|Chollabuk-do~45|Chollanam-do~46|Inch'on-Kwangyokhi~28|Kang-won-do~42|Kwangju-Kwangyokshi~28|Kyonggi-do~41|Kyongsangbuk-do~47|Kyongsangnam-do~48|Pusan-Kwangyokshi~26|Seoul-T'ukpyolshi~11|Sejong~50|Taegu-Kwangyokshi~27|Taejon-Kwangyokshi~30|Ulsan-Kwangyokshi~31"], ["Kuwait", "KW", "Al Aḩmadi~AH|Al Farwānīyah~FA|Al Jahrā’~JA|Al ‘Āşimah~KU|Ḩawallī~HA|Mubārak al Kabir~MU"], ["Kyrgyzstan", "KG", "Batken Oblasty~B|Bishkek Shaary~GB|Chuy Oblasty (Bishkek)~C|Jalal-Abad Oblasty~J|Naryn Oblasty~N|Osh Oblasty~O|Talas Oblasty~T|Ysyk-Kol Oblasty (Karakol)~Y"], ["Laos", "LA", "Attapu~AT|Bokèo~BK|Bolikhamxai~BL|Champasak~CH|Houaphan~HO|Khammouan~KH|Louang Namtha~LM|Louangphabang~LP|Oudômxai~OU|Phôngsali~PH|Salavan~SL|Savannakhét~SV|Vientiane~VI|Xaignabouli~XA|Xékong~XE|Xaisomboun~XS|Xiangkhouang~XI"], ["Latvia", "LV", "Aglona~001|Aizkraukle~002|Aizpute~003|Aknīste~004|Aloja~005|Alsunga~06|Alūksne~007|Amata~008|Ape~009|Auce~010|Ādaži~011|Babīte~012|Baldone~013|Baltinava~014|Balvi~015|Bauska~016|Beverīna~017|Brocēni~018|Burtnieki~019|Carnikava~020|Cesvaine~021|Cēsis~022|Cibla~023|Dagda~024|Daugavpils~025|Daugavpils (City)~DGV|Dobele~026|Dundaga~027|Durbe~028|Engure~029|Ērgļi~030|Garkalne~031|Grobiņa~032|Gulbene~033|Iecava~034|Ikšķile~035|Ilūkste~036|Inčukalns~037|Jaunjelgava~038|Jaunpiebalga~039|Jaunpils~040|Jelgava~041|Jelgava (City)~JEL|Jēkabpils~042|Jēkabpils (City)~JKB|Jūrmala (City)~JUR|Kandava~043|Kārsava~044|Kocēni~045|Koknese~046|Krāslava~047|Krimulda~048|Krustpils~049|Kuldīga~050|Ķegums~051|Ķekava~052|Lielvārde~053|Liepāja~LPX|Limbaži~054|Līgatne~055|Līvāni~056|Lubāna~057|Ludza~058|Madona~059|Mazsalaca~060|Mālpils~061|Mārupe~062|Mērsrags~063|Naukšēni~064|Nereta~065|Nīca~066|Ogre~067|Olaine~068|Ozolnieki~069|Pārgauja~070|Pāvilosta~071|Pļaviņas~072|Preiļi~073|Priekule~074|Priekuļi~075|Rauna~076|Rēzekne~077|Rēzekne (City)~REZ|Riebiņi~078|Rīga~RIX|Roja~079|Ropaži~080|Rucava~081|Rugāji~082|Rundāle~083|Rūjiena~084|Sala~085|Salacgrīva~086|Salaspils~087|Saldus~088|Saulkrasti~089|Sēja~090|Sigulda~091|Skrīveri~092|Skrunda~093|Smiltene~094|Stopiņi~095|Strenči~096|Talsi~097|Tērvete~098|Tukums~099|Vaiņode~100|Valka~101|Valmiera~VMR|Varakļāni~102|Vārkava~103|Vecpiebalga~104|Vecumnieki~105|Ventspils~106|Ventspils (City)~VEN|Viesīte~107|Viļaka~108|Viļāni~109|Zilupe~110"], ["Lebanon", "LB", "Aakkâr~AK|Baalbelk-Hermel~BH|Béqaa~BI|Beyrouth~BA|Liban-Nord~AS|Liban-Sud~JA|Mont-Liban~JL|Nabatîyé~NA"], ["Lesotho", "LS", "Berea~D|Butha-Buthe~B|Leribe~C|Mafeteng~E|Maseru~A|Mohales Hoek~F|Mokhotlong~J|Qacha's Nek~H|Quthing~G|Thaba-Tseka~K"], ["Liberia", "LR", "Bomi~BM|Bong~BG|Gbarpolu~GP|Grand Bassa~GB|Grand Cape Mount~CM|Grand Gedeh~GG|Grand Kru~GK|Lofa~LO|Margibi~MG|Maryland~MY|Montserrado~MO|Nimba~NI|River Cess~RI|River Geee~RG|Sinoe~SI"], ["Libya", "LY", "Al Buţnān~BU|Al Jabal al Akhḑar~JA|Al Jabal al Gharbī~JG|Al Jafārah~JA|Al Jufrah~JU|Al Kufrah~FK|Al Marj~MJ|Al Marquab~MB|Al Wāḩāt~WA|An Nuqaţ al Khams~NQ|Az Zāwiyah~ZA|Banghāzī~BA|Darnah~DR|Ghāt~GH|Mişrātah~MI|Murzuq~MQ|Nālūt~NL|Sabhā~SB|Surt~SR|Ţarābulus~TB|Yafran~WD|Wādī ash Shāţiʾ~WS"], ["Liechtenstein", "LI", "Balzers~01|Eschen~02|Gamprin~03|Mauren~04|Planken~05|Ruggell~06|Schaan~07|Schellenberg~08|Triesen~09|Triesenberg~10|Vaduz~11"], ["Lithuania", "LT", "Alytaus~AL|Kauno~KU|Klaipėdos~KL|Marijampolės~MR|Panevėžio~PN|Šiaulių~SA|Tauragės~TA|Telšių~TE|Utenos~UT|Vilniaus~VL"], ["Luxembourg", "LU", "Capellen~CA|Clevaux~CL|Diekirch~DI|Echternach~EC|Esch-sur-Alzette~ES|Grevenmacher~GR|Luxembourg~LU|Mersch~ME|Redange~RD|Remich~RM|Vianden~VD|Wiltz~WI"], ["Macao", "MO", "Macao"], ["Macedonia, Republic of", "MK", "Aračinovo~02|Berovo~03|Bitola~04|Bogdanci~05|Bogovinje~06|Bosilovo~07|Brvenica~08|Centar Župa~78|Čaška~08|Češinovo-Obleševo~81|Čučer Sandevo~82|Debar~21|Debarca~22|Delčevo~23|Demir Hisar~25|Demir Kapija~24|Doran~26|Dolneni~27|Gevgelija~18|Gostivar~19|Gradsko~20|Ilinden~34|Jegunovce~35|Karbinci~37|Kavadarci~36|Kičevo~40|Kočani~42|Konče~41|Kratovo~43|Kriva Palanka~44|Krivogaštani~45|Kruševo~46|Kumanovo~47|Lipkovo~48|Lozovo~49|Makedonska Kamenica~51|Makedonski Brod~52|Mavrovo i Rostuša~50|Mogila~53|Negotino~54|Novaci~55|Novo Selo~56|Ohrid~58|Pehčevo~60|Petrovec~59|Plasnica~61|Prilep~62|Probištip~63|Radoviš~|Rankovce~65|Resen~66|Rosoman~67|Skopje~85|Sopište~70|Staro Nagoričane~71|Struga~72|Strumica~73|Studeničani~74|Sveti Nikole~69|Štip~83|Tearce~75|Tetovo~76|Valandovo~10|Vasilevo~11|Veles~13|Vevčani~12|Vinica~14|Vrapčište~16|Zelenikovo~32|Zrnovci~33|Želino~30"], ["Madagascar", "MG", "Antananarivo~T|Antsiranana~D|Fianarantsoa~F|Mahajanga~M|Toamasina~A|Toliara~U"], ["Malawi", "MW", "Balaka~BA|Blantyre~BL|Chikwawa~CK|Chiradzulu~CR|Chitipa~CT|Dedza~DE|Dowa~DO|Karonga~KR|Kasungu~KS|Likoma~LK|Lilongwe~LI|Machinga~MH|Mangochi~MG|Mchinji~MC|Mulanje~MU|Mwanza~MW|Mzimba~MZ|Nkhata Bay~NE|Nkhotakota~NB|Nsanje~NS|Ntcheu~NU|Ntchisi~NI|Phalombe~PH|Rumphi~RU|Salima~SA|Thyolo~TH|Zomba~ZO"], ["Malaysia", "MY", "Johor~01|Kedah~02|Kelantan~03|Melaka~04|Negeri Sembilan~05|Pahang~06|Perak~08|Perlis~09|Pulau Pinang~07|Sabah~12|Sarawak~13|Selangor~10|Terengganu~11|Wilayah Persekutuan (Kuala Lumpur)~14|Wilayah Persekutuan (Labuan)~15|Wilayah Persekutuan (Putrajaya)~16"], ["Maldives", "MV", "Alifu Alifu~02|Alifu Dhaalu~00|Baa~20|Dhaalu~17|Faafu~14|Gaafu Alifu~27|Gaafu Dhaalu~28|Gnaviyani~29|Haa Alifu~07|Haa Dhaalu~23|Kaafu~29|Laamu~05|Lhaviyani~03|Malé~MLE|Meemu~12|Noonu~25|Raa~13|Seenu~01|Shaviyani~24|Thaa~08|Vaavu~04"], ["Mali", "ML", "Bamako~BKO|Gao~7|Kayes~1|Kidal~8|Koulikoro~2|Mopti~5|Segou~4|Sikasso~3|Tombouctou~6"], ["Malta", "MT", "Attard~01|Balzan~02|Birgu~03|Birkirkara~04|Birżebbuġa~05|Bormla~06|Dingli~07|Fgura~08|Floriana~09|Fontana~10|Guda~11|Gżira~12|Għajnsielem~13|Għarb~14|Għargħur~15|Għasri~16|Għaxaq~17|Ħamrun~18|Iklin~19|Isla~20|Kalkara~21|Kerċem~22|Kirkop~23|Lija~24|Luqa~25|Marsa~26|Marsaskala~27|Marsaxlokk~28|Mdina~29|Mellieħa~30|Mġarr~31|Mosta~32|Mqabba~33|Msida~34|Mtarfa~35|Munxar~36|Nadur~37|Naxxar~38|Paola~39|Pembroke~40|Pietà~41|Qala~42|Qormi~43|Qrendi~44|Rabat Għawdex~45|Rabat Malta~46|Safi~47|San Ġiljan~48|San Ġwann~49|San Lawrenz~50|San Pawl il-Baħar~51|Sannat~52|Santa Luċija~53|Santa Venera~54|Siġġiewi~55|Sliema~56|Swieqi~57|Tai Xbiex~58|Tarzien~59|Valletta~60|Xagħra~61|Xewkija~62|Xgħajra~63|Żabbar~64|Żebbuġ Għawde~65|Żebbuġ Malta~66|Żejtun~67|Żurrieq~68"], ["Marshall Islands", "MH", "Ailinglaplap~ALL|Ailuk~ALK|Arno~ARN|Aur~AUR|Bikini and Kili~KIL|Ebon~EBO|Jabat~JAB|Jaluit~JAL|Kwajalein~KWA|Lae~LAE|Lib~LIB|Likiep~LIK|Majuro~MAJ|Maloelap~MAL|Mejit~MEJ|Namdrik~NMK|Namu~NMU|Rongelap~RON|Ujae~UJA|Utrik~UTI|Wotho~WTH|Wotje~WTJ"], ["Martinique", "MQ", "Martinique"], ["Mauritania", "MR", "Adrar~07|Assaba~03|Brakna~05|Dakhlet Nouadhibou~08|Gorgol~04|Guidimaka~10|Hodh Ech Chargui~01|Hodh El Gharbi~02|Inchiri~12|Nouakchott Nord~14|Nouakchott Ouest~13|Nouakchott Sud~15|Tagant~09|Tiris Zemmour~11|Trarza~06"], ["Mauritius", "MU", "Agalega Islands~AG|Beau Bassin-Rose Hill~BR|Black River~BL|Cargados Carajos Shoals~CC|Curepipe~CU|Flacq~FL|Grand Port~GP|Moka~MO|Pamplemousses~PA|Plaines Wilhems~PW|Port Louis (City)~PU|Port Louis~PL|Riviere du Rempart~RR|Rodrigues Island~RO|Savanne~SA|Vacoas-Phoenix~CP"], ["Mayotte", "YT", "Dzaoudzi~01|Pamandzi~02|Mamoudzou~03|Dembeni~04|Bandrélé~05|Kani-Kéli~06|Bouéni~07|Chirongui~08|Sada~09|Ouangani~10|Chiconi~11|Tsingoni~12|M'Tsangamouji~13|Acoua~14|Mtsamboro~15|Bandraboua~16|Koungou~17"], ["Mexico", "MX", "Aguascalientes~AGU|Baja California~BCN|Baja California Sur~BCS|Campeche~CAM|Ciudad de México~DIF|Chiapas~CHP|Chihuahua~CHH|Coahuila de Zaragoza~COA|Colima~COL|Durango~DUR|Estado de México~MEX|Guanajuato~GUA|Guerrero~GRO|Hidalgo~HID|Jalisco~JAL|Michoacán de Ocampo~MIC|Morelos~MOR|Nayarit~NAY|Nuevo León~NLE|Oaxaca~OAX|Puebla~PUE|Querétaro de Arteaga~QUE|Quintana Roo~ROO|San Luis Potosí~SLP|Sinaloa~SIN|Sonora~SON|Tabasco~TAB|Tamaulipas~TAM|Tlaxcala~TLA|Veracruz~VER|Yucatán~YUC|Zacatecas~ZAC"], ["Micronesia, Federated States of", "FM", "Chuuk (Truk)~TRK|Kosrae~KSA|Pohnpei~PNI|Yap~YAP"], ["Moldova", "MD", "Aenii Noi~AN|Basarabeasca~BS|Bălți~BA|Bender~BD|Briceni~BR|Cahul~CA|Cantemir~CT|Călărași~CL|Căușeni~CS|Chișinău~CU|Cimișlia~CM|Criuleni~CR|Dondușeni~DO|Drochia~DR|Dubăsari~DU|Edineț~ED|Fălești~FA|Florești~FL|Găgăuzia~GA|Glodeni~GL|Hîncești~HI|Ialoveni~IA|Leova~LE|Nisporeni~NI|Ocnița~OC|Orhei~OR|Rezina~RE|Rîșcani~RI|Sîngerei~SI|Soroca~SO|Stînga Nistrului~SN|Strășeni~ST|Șoldănești~SD|Ștefan Vodă~SV|Taraclia~TA|Telenești~TE|Ungheni~UN"], ["Monaco", "MC", "Colle~CL|Condamine~CO|Fontvieille~FO|Gare~GA|Jardin Exotique~JE|Larvotto~LA|Malbousquet~MA|Monaco-Ville~MO|Moneghetti~MG|Monte-Carlo~MC|Moulins~MU|Port-Hercule~PH|Saint-Roman~SR|Sainte-Dévote~SD|Source~SO|Spélugues~SP|Vallon de la Rousse~VR"], ["Mongolia", "MN", "Arhangay~073|Bayan-Olgiy~071|Bayanhongor~069|Bulgan~067|Darhan~037|Dornod~061|Dornogovi~063|Dundgovi~059|Dzavhan~065|Govi-Altay~065|Govi-Sumber~064|Hovd~043|Hovsgol~041|Omnogovi~053|Ovorhangay~055|Selenge~049|Suhbaatar~051|Tov~047|Ulaanbaatar~1|Uvs~046"], ["Montenegro", "ME", "Andrijevica~01|Bar~02|Berane~03|Bijelo Polje~04|Budva~05|Cetinje~06|Danilovgrad~07|Gusinje~22|Herceg Novi~08|Kolašin~09|Kotor~10|Mojkovac~11|Nikšić~12|Petnica~23|Plav~13|Plužine~14|Pljevlja~15|Podgorica~16|Rožaje~17|Šavnik~18|Tivat~19|Ulcinj~20|Žabljak~21"], ["Montserrat", "MS", "Saint Anthony|Saint Georges|Saint Peter's"], ["Morocco", "MA", "Chaouia-Ouardigha~09|Doukhala-Abda~10|Fès-Boulemane~05|Gharb-Chrarda-Beni Hssen~02|Grand Casablanca~08|Guelmim-Es Semara~14|Laâyoune-Boujdour-Sakia el Hamra~15|Marrakech-Tensift-Al Haouz~11|Meknès-Tafilalet~06|Oriental~04|Oued ed Dahab-Lagouira~16|Souss-Massa-Drâa~13|Tadla-Azilal~12|Tanger-Tétouan~01|Taza-Al Hoceima-Taounate~03"], ["Mozambique", "MZ", "Cabo Delgado~P|Gaza~G|Inhambane~I|Manica~B|Maputo~L|Maputo (City)~MPM|Nampula~N|Niassa~A|Sofala~S|Tete~T|Zambezia~Q"], ["Myanmar", "MM", "Ayeyarwady~07|Bago~02|Chin~14|Kachin~11|Kayah~12|Kayin~13|Magway~03|Mandalay~04|Mon~15|Nay Pyi Taw~18|Rakhine~16|Sagaing~01|Shan~17|Tanintharyi~05|Yangon~06"], ["Namibia", "NA", "Erongo~ER|Hardap~HA|Kavango East~KE|Kavango West~KW|Karas~KA|Khomas~KH|Kunene~KU|Ohangwena~OW|Omaheke~OH|Omusati~OS|Oshana~ON|Oshikoto~OT|Otjozondjupa~OD|Zambezi~CA"], ["Nauru", "NR", "Aiwo~01|Anabar~02|Anetan~03|Anibare~04|Baiti~05|Boe~06|Buada~07|Denigomodu~08|Ewa~09|Ijuw~10|Meneng~11|Nibok~12|Uaboe~13|Yaren~14"], ["Nepal", "NP", "Bagmati~BA|Bheri~BH|Dhawalagiri~DH|Gandaki~GA|Janakpur~JA|Karnali~KA|Kosi~KO|Lumbini~LU|Mahakali~MA|Mechi~ME|Narayani~NA|Rapti~RA|Sagarmatha~SA|Seti~SE"], ["Netherlands", "NL", "Drenthe~DR|Flevoland~FL|Friesland~FR|Gelderland~GE|Groningen~GR|Limburg~LI|Noord-Brabant~NB|Noord-Holland~NH|Overijssel~OV|Utrecht~UT|Zeeland~ZE|Zuid-Holland~ZH"], ["New Caledonia", "NC", "Iles Loyaute|Nord|Sud"], ["New Zealand", "NZ", "Auckland~AUK|Bay of Plenty~BOP|Canterbury~CAN|Gisborne~GIS|Hawke's Bay~HKB|Marlborough~MBH|Manawatu-Wanganui~MWT|Northland~NTL|Nelson~NSN|Otago~OTA|Southland~STL|Taranaki~TKI|Tasman~TAS|Waikato~WKO|Wellington~WGN|West Coast~WTC|Chatham Islands Territory~CIT"], ["Nicaragua", "NI", "Boaco~BO|Carazo~CA|Chinandega~CI|Chontales~CO|Estelí~ES|Granada~GR|Jinotega~JI|León~LE|Madriz~MD|Managua~MN|Masaya~MS|Matagalpa~MT|Nueva Segovia~NS|Río San Juan~SJ|Rivas~RI|Atlántico Norte~AN|Atlántico Sur~AS"], ["Niger", "NE", "Agadez~1|Diffa~2|Dosso~3|Maradi~4|Niamey~8|Tahoua~5|Tillabéri~6|Zinder~7"], ["Nigeria", "NG", "Abia~AB|Abuja Federal Capital Territory~FC|Adamawa~AD|Akwa Ibom~AK|Anambra~AN|Bauchi~BA|Bayelsa~BY|Benue~BE|Borno~BO|Cross River~CR|Delta~DE|Ebonyi~EB|Edo~ED|Ekiti~EK|Enugu~EN|Gombe~GO|Imo~IM|Jigawa~JI|Kaduna~KD|Kano~KN|Katsina~KT|Kebbi~KE|Kogi~KO|Kwara~KW|Lagos~LA|Nassarawa~NA|Niger~NI|Ogun~OG|Ondo~ON|Osun~OS|Oyo~OY|Plateau~PL|Rivers~RI|Sokoto~SO|Taraba~TA|Yobe~YO|Zamfara~ZA"], ["Niue", "NU", "Niue"], ["Norfolk Island", "NF", "Norfolk Island"], ["Northern Mariana Islands", "MP", "Northern Islands|Rota|Saipan|Tinian"], ["Norway", "NO", "Akershus~02|Aust-Agder~09|Buskerud~06|Finnmark~20|Hedmark~04|Hordaland~12|Møre og Romsdal~15|Nordland~18|Nord-Trøndelag~17|Oppland~05|Oslo~03|Rogaland~11|Sogn og Fjordane~14|Sør-Trøndelag~16|Telemark~08|Troms~19|Vest-Agder~10|Vestfold~07|Østfold~01|Jan Mayen~22|Svalbard~21"], ["Oman", "OM", "Ad Dakhiliyah~DA|Al Buraymi~BU|Al Wusta~WU|Az Zahirah~ZA|Janub al Batinah~BS|Janub ash Sharqiyah~SS|Masqat~MA|Musandam~MU|Shamal al Batinah~BJ|Shamal ash Sharqiyah~SJ|Zufar~ZU"], ["Pakistan", "PK", "Āzād Kashmīr~JK|Balōchistān~BA|Gilgit-Baltistān~GB|Islāmābād~IS|Khaībar Pakhtūnkhwās~KP|Punjāb~PB|Sindh~SD|Federally Administered Tribal Areas~TA"], ["Palau", "PW", "Aimeliik~002|Airai~004|Angaur~010|Hatobohei~050|Kayangel~100|Koror~150|Melekeok~212|Ngaraard~214|Ngarchelong~218|Ngardmau~222|Ngatpang~224|Ngchesar~226|Ngeremlengui~227|Ngiwal~228|Peleliu~350|Sonsoral~350"], ["Palestine, State of", "PS", "Ak Khalīl~HBN|Al Quds~JEM|Arīḩā wal Aghwār~JRH|Bayt Laḩm~BTH|Dayr al Balaḩ~DEB|Ghazzah~GZA|Janīn~JEN|Khān Yūnis~KYS|Nāblus~NBS|Qalqīyah~QQA|Rafaḩ~RFH|Rām Allāh wal Bīrah~RBH|Salfīt~SLT|Shamāl Ghazzah~NGZ|Ţūbās~TBS|Ţūlkarm~TKM"], ["Panama", "PA", "Bocas del Toro~1|Chiriquí~4|Coclé~2|Colón~3|Darién~5|Emberá~EM|Herrera~6|Kuna Yala~KY|Los Santos~7|Ngäbe-Buglé~NB|Panamá~8|Panamá Oeste~10|Veraguas~9"], ["Papua New Guinea", "PG", "Bougainville~NSB|Central~CPM|Chimbu~CPK|East New Britain~EBR|East Sepik~ESW|Eastern Highlands~EHG|Enga~EPW|Gulf~GPK|Hela~HLA|Jiwaka~JWK|Madang~MOM|Manus~MRL|Milne Bay~MBA|Morobe~MPL|Port Moresby~NCD|New Ireland~NIK|Northern~NPP|Southern Highlands~SHM|West New Britain~WBK|West Sepik~SAN|Western~WPD|Western Highlands~WHM"], ["Paraguay", "PY", "Alto Paraguay~16|Alto Parana~10|Amambay~13|Asuncion~ASU|Caaguazu~5|Caazapa~6|Canindeyu~14|Central~11|Concepcion~1|Cordillera~3|Guaira~4|Itapua~7|Misiones~8|Neembucu~12|Paraguari~9|Presidente Hayes~15|San Pedro~2"], ["Peru", "PE", "Amazonas~AMA|Ancash~ANC|Apurimac~APU|Arequipa~ARE|Ayacucho~AYA|Cajamarca~CAJ|Callao~CAL|Cusco~CUS|Huancavelica~HUV|Huanuco~HUC|Ica~ICA|Junin~JUN|La Libertad~LAL|Lambayeque~LAM|Lima~LIM|Loreto~LOR|Madre de Dios~MDD|Moquegua~MOQ|Municipalidad Metropolitana de Lima~LMA|Pasco~PAS|Piura~PIU|Puno~PUN|San Martin~SAM|Tacna~TAC|Tumbes~TUM|Ucayali~UCA"], ["Philippines", "PH", "Abra~ABR|Agusan del Norte~AGN|Agusan del Sur~AGS|Aklan~AKL|Albay~ALB|Antique~ANT|Apayao~APA|Aurora~AUR|Basilan~BAS|Bataan~BAN|Batanes~BTN|Batangas~BTG|Benguet~BEN|Biliran~BIL|Bohol~BOH|Bukidnon~BUK|Bulacan~BUL|Cagayan~CAG|Camarines Norte~CAN|Camarines Sur~CAS|Camiguin~CAM|Capiz~CAP|Catanduanes~CAT|Cavite~CAV|Cebu~CEB|Compostela~COM|Cotabato~NCO|Davao del Norte~DAV|Davao del Sur~DAS|Davao Occidental~DVO|Davao Oriental~DAO|Dinagat Islands~DIN|Eastern Samar~EAS|Guimaras~GUI|Ifugao~IFU|Ilocos Norte~ILN|Ilocos Sur~ILS|Iloilo~ILI|Isabela~ISA|Kalinga~KAL|La Union~LUN|Laguna~LAG|Lanao del Norte~LAN|Lanao del Sur~LAS|Leyte~LEY|Maguindanao~MAG|Masbate~MAS|Mindoro Occidental~MDC|Mindoro Oriental~MDR|Misamis Occidental~MSC|Misamis Oriental~MSR|Mountain Province~MOU|Negros Occidental~NEC|Negros Oriental~NER|Northern Samar~NSA|Nueva Ecija~NUE|Nueva Vizcaya~NUV|Palawan~PLW|Pampanga~PAM|Pangasinan~PAN|Quezon~QUE|Quirino~QUI|Rizal~RIZ|Romblon~ROM|Samar~WSA|Sarangani~SAR|Siquijor~SIG|Sorsogon~SOR|Southern Leyte~SLE|Sultan Kudarat~AUK|Sulu~SLU|Surigao del Norte~SUN|Surigao del Sur~SUR|Tarlac~TAR|Tawi-Tawi~TAW|Zambales~ZMB|Zamboanga del Norte~ZAN|Zamboanga del Sur~ZAS|Zamboanga Sibugay~ZSI"], ["Pitcairn", "PN", "Pitcairn Islands"], ["Poland", "PL", "Dolnośląskie~DS|Kujawsko-pomorskie~KP|Łódzkie~LD|Lubelskie~LU|Lubuskie~LB|Malopolskie~MA|Mazowieckie~MZ|Opolskie~OP|Podkarpackie~PK|Podlaskie~PD|Pomorskie~PM|Śląskie~SL|Świętokrzyskie~SK|Warmińsko-mazurskie~WN|Wielkopolskie~WP|Zachodniopomorskie~ZP"], ["Portugal", "PT", "Acores~20|Aveiro~01|Beja~02|Braga~03|Braganca~04|Castelo Branco~05|Coimbra~06|Evora~07|Faro~08|Guarda~09|Leiria~10|Lisboa~11|Madeira~30|Portalegre~12|Porto~13|Santarem~14|Setubal~15|Viana do Castelo~16|Vila Real~17|Viseu~18"], ["Puerto Rico", "PR", "Adjuntas|Aguada|Aguadilla|Aguas Buenas|Aibonito|Anasco|Arecibo|Arroyo|Barceloneta|Barranquitas|Bayamon|Cabo Rojo|Caguas|Camuy|Canovanas|Carolina|Cat|Ceiba|Ciales|Cidra|Coamo|Comerio|Corozal|Culebra|Dorado|Fajardo|Florida|Guanica|Guayama|Guayanilla|Guaynabo|Gurabo|Hatillo|Hormigueros|Humacao|Isabe|Juana Diaz|Juncos|Lajas|Lares|Las Marias|Las oiza|Luquillo|Manati|Maricao|Maunabo|Mayaguez|Moca|Morovis|Naguabo|Naranjito|Orocovis|Patillas|Penuelas|Ponce|Quebradillas|Rincon|Rio Grande|Sabana linas|San German|San Juan|San Lorenzo|San Sebastian|Santa Isabel|Toa Alta|Toa Baja|Trujillo Alto|Utuado|Vega Alta|Vega ues|Villalba|Yabucoa|Yauco"], ["Qatar", "QA", "Ad Dawḩah~DA|Al Khawr wa adh Dhakhīrah~KH|Al Wakrah~WA|Ar Rayyān~RA|Ash Shamāl~MS|Az̧ Za̧`āyin~ZA|Umm Şalāl~US"], ["Réunion", "RE", "Réunion"], ["Romania", "RO", "Alba~AB|Arad~AR|Arges~AG|Bacau~BC|Bihor~BH|Bistrita-Nasaud~BN|Botosani~BT|Braila~BR|Brasov~BV|Bucuresti~B|Buzau~BZ|Calarasi~CL|Caras-Severin~CS|Cluj~CJ|Constanta~CT|Covasna~CV|Dambovita~DB|Dolj~DJ|Galati~GL|Giurgiu~GR|Gorj~GJ|Harghita~HR|Hunedoara~HD|Ialomita~IL|Iasi~IS|Maramures~MM|Mehedinti~MH|Mures~MS|Neamt~NT|Olt~OT|Prahova~PH|Salaj~SJ|Satu Mare~SM|Sibiu~SB|Suceava~SV|Teleorman~TR|Timis~TM|Tulcea~TL|Valcea~VL|Vaslui~VS|Vrancea~VN"], ["Russian Federation", "RU", "Republic of Adygea~AD|Republic of Altai (Gorno-Altaysk)~AL|Altai Krai~ALT|Amur Oblast~AMU|Arkhangelsk Oblast~ARK|Astrakhan Oblast~AST|Republic of Bashkortostan~BA|Belgorod Oblast~BEL|Bryansk Oblast~BRY|Republic of Buryatia~BU|Chechen Republic~CE|Chelyabinsk Oblast~CHE|Chukotka Autonomous Okrug~CHU|Chuvash Republic~CU|Republic of Dagestan~DA|Republic of Ingushetia~IN|Irkutsk Oblast~IRK|Ivanovo Oblast~IVA|Jewish Autonomous Oblast~JEW|Kabardino-Balkar Republic~KB|Kaliningrad Oblast~KLN|Republic of Kalmykia~KL|Kaluga Oblast~KLU|Kamchatka Krai~KAM|Karachay-Cherkess Republic~KC|Republic of Karelia~KR|Khabarovsk Krai~KHA|Republic of Khakassia~KK|Khanty-Mansi Autonomous Okrug - Yugra~KHM|Kemerovo Oblast~KEM|Kirov Oblast~KIR|Komi Republic~KO|Kostroma Oblast~KOS|Krasnodar Krai~KDA|Krasnoyarsk Krai~KYA|Kurgan Oblast~KGN|Kursk Oblast~KRS|Leningrad Oblast~LEN|Lipetsk Oblast~LIP|Magadan Oblast~MAG|Mari El Republic~ME|Republic of Mordovia~MO|Moscow Oblast~MOS|Moscow~MOW|Murmansk Oblast~MU|Nenets Autonomous Okrug~NEN|Nizhny Novgorod Oblast~NIZ|Novgorod Oblast~NGR|Novosibirsk Oblast~NVS|Omsk Oblast~OMS|Orenburg Oblast~ORE|Oryol Oblast~ORL|Penza Oblast~PNZ|Perm Krai~PER|Primorsky Krai~PRI|Pskov Oblast~PSK|Rostov Oblast~ROS|Ryazan Oblast~RYA|Saint Petersburg~SPE|Sakha (Yakutia) Republic~SA|Sakhalin Oblast~SAK|Samara Oblast~SAM|Saratov Oblast~SAR|Republic of North Ossetia-Alania~NOA|Smolensk Oblast~SMO|Stavropol Krai~STA|Sverdlovsk Oblast~SVE|Tambov Oblast~TAM|Republic of Tatarstan~TA|Tomsk Oblast~TOM|Tuva Republic~TU|Tula Oblast~TUL|Tver Oblast~TVE|Tyumen Oblast~TYU|Udmurt Republic~UD|Ulyanovsk Oblast~ULY|Vladimir Oblast~VLA|Volgograd Oblast~VGG|Vologda Oblast~VLG|Voronezh Oblast~VOR|Yamalo-Nenets Autonomous Okrug~YAN|Yaroslavl Oblast~YAR|Zabaykalsky Krai~ZAB"], ["Rwanda", "RW", "Kigali~01|Eastern~02|Northern~03|Western~04|Southern~05"], ["Saint Barthélemy", "BL", "Au Vent~02|Sous le Vent~01"], ["Saint Helena, Ascension and Tristan da Cunha", "SH", "Ascension~AC|Saint Helena~HL|Tristan da Cunha~TA"], ["Saint Kitts and Nevis", "KN", "Saint Kitts~K|Nevis~N"], ["Saint Lucia", "LC", "Anse-la-Raye~01|Canaries~12|Castries~02|Choiseul~03|Dennery~05|Gros Islet~06|Laborie~07|Micoud~08|Soufriere~10|Vieux Fort~11"], ["Saint Martin", "MF", "Saint Martin"], ["Saint Pierre and Miquelon", "PM", "Miquelon|Saint Pierre"], ["Saint Vincent and the Grenadines", "VC", "Charlotte~01|Grenadines~06|Saint Andrew~02|Saint David~03|Saint George~04|Saint Patrick~05"], ["Samoa", "WS", "A'ana~AA|Aiga-i-le-Tai~AL|Atua~AT|Fa'asaleleaga~FA|Gaga'emauga~GE|Gagaifomauga~GI|Palauli~PA|Satupa'itea~SA|Tuamasaga~TU|Va'a-o-Fonoti~VF|Vaisigano~VS"], ["San Marino", "SM", "Acquaviva~01|Borgo Maggiore~06|Chiesanuova~02|Domagnano~03|Faetano~04|Fiorentino~05|Montegiardino~08|San Marino~07|Serravalle~09"], ["Sao Tome and Principe", "ST", "Principe~P|Sao Tome~S"], ["Saudi Arabia", "SA", "'Asir~14|Al Bahah~11|Al Hudud ash Shamaliyah~08|Al Jawf~12|Al Madinah al Munawwarah~03|Al Qasim~05|Ar Riyad~01|Ash Sharqiyah~04|Ha'il~06|Jazan~09|Makkah al Mukarramah~02|Najran~10|Tabuk~07"], ["Senegal", "SN", "Dakar~DK|Diourbel~DB|Fatick~FK|Kaffrine~KA|Kaolack~KL|Kedougou~KE|Kolda~KD|Louga~LG|Matam~MT|Saint-Louis~SL|Sedhiou~SE|Tambacounda~TC|Thies~TH|Ziguinchor~ZG"], ["Serbia", "RS", "Beograd (Belgrade)~00|Borski~14|Braničevski~11|Jablanički~23|Južnobački~06|Južnobanatski~04|Kolubarski~09|Kosovski~25|Kosovsko-Mitrovački~28|Kosovsko-Pomoravski~29|Mačvanski~08|Moravički~17|Nišavski~20|Pčinjski~24|Pećki~26|Pirotski~22|Podunavski~10|Pomoravski~13|Prizrenski~27|Rasinski~19|Raški~18|Severnobački~01|Severnobanatski~03|Srednjebanatski~02|Sremski~07|Šumadijski~12|Toplički~21|Zaječarski~15|Zapadnobački~05|Zlatiborski~16"], ["Seychelles", "SC", "Anse aux Pins~01|Anse Boileau~02|Anse Etoile~03|Anse Royale~05|Anu Cap~04|Baie Lazare~06|Baie Sainte Anne~07|Beau Vallon~08|Bel Air~09|Bel Ombre~10|Cascade~11|Glacis~12|Grand'Anse Mahe~13|Grand'Anse Praslin~14|La Digue~15|La Riviere Anglaise~16|Les Mamelles~24|Mont Buxton~17|Mont Fleuri~18|Plaisance~19|Pointe La Rue~20|Port Glaud~21|Roche Caiman~25|Saint Louis~22|Takamaka~23"], ["Sierra Leone", "SL", "Eastern~E|Northern~N|Southern~S|Western~W"], ["Singapore", "SG", "Central Singapore~01|North East~02|North West~03|South East~04|South West~05"], ["Sint Maarten (Dutch part)", "SX", "Sint Maarten"], ["Slovakia", "SK", "Banskobystricky~BC|Bratislavsky~BL|Kosicky~KI|Nitriansky~NI|Presovsky~PV|Trenciansky~TC|Trnavsky~TA|Zilinsky~ZI"], ["Slovenia", "SI", "Ajdovscina~001|Apace~195|Beltinci~002|Benedikt~148|Bistrica ob Sotli~149|Bled~003|Bloke~150|Bohinj~004|Borovnica~005|Bovec~006|Braslovce~151|Brda~007|Brezice~009|Brezovica~008|Cankova~152|Celje~011|Cerklje na Gorenjskem~012|Cerknica~013|Cerkno~014|Cerkvenjak~153|Cirkulane~196|Crensovci~015|Crna na Koroskem~016|Crnomelj~017|Destrnik~018|Divaca~019|Dobje~154|Dobrepolje~020|Dobrna~155|Dobrova-Polhov Gradec~021|Dobrovnik~156|Dol pri Ljubljani~022|Dolenjske Toplice~157|Domzale~023|Dornava~024|Dravograd~025|Duplek~026|Gorenja Vas-Poljane~027|Gorisnica~028|Gorje~207|Gornja Radgona~029|Gornji Grad~030|Gornji Petrovci~031|Grad~158|Grosuplje~032|Hajdina~159|Hoce-Slivnica~160|Hodos~161|Horjul~162|Hrastnik~034|Hrpelje-Kozina~035|Idrija~036|Ig~037|Ilirska Bistrica~038|Ivancna Gorica~039|Izola~040s|Jesenice~041|Jursinci~042|Kamnik~043|Kanal~044|Kidricevo~045|Kobarid~046|Kobilje~047|Kocevje~048|Komen~049|Komenda~164|Koper~050|Kodanjevica na Krki~197|Kostel~165|Kozje~051|Kranj~052|Kranjska Gora~053|Krizevci~166|Krsko~054|Kungota~055|Kuzma~056|Lasko~057|Lenart~058|Lendava~059|Litija~068|Ljubljana~061|Ljubno~062|Ljutomer~063|Log-Dragomer~208|Logatec~064|Loska Dolina~065|Loski Potok~066|Lovrenc na Pohorju~167|Lukovica~068|Luce~067|Majsperk~069|Makole~198|Maribor~070|Markovci~168|Medvode~071|Menges~072|Metlika~073|Mezica~074|Miklavz na Dravskem Polju~169|Miren-Kostanjevica~075|Mirna~212|Mirna Pec~170|Mislinja~076|Mokronog-Trebelno~199|Moravce~077|Moravske Toplice~078|Mozirje~079|Murska Sobota~080|Naklo~082|Nazarje~083|Nova Gorica~084|Novo Mesto~085|Odranci~086|Ormoz~087|Osilnica~088|Pesnica~089|Piran~090|Pivka~091|Podcetrtek~092|Podlehnik~172|Podvelka~093|Poljcane~200|Postojna~094|Prebold~174|Preddvor~095|Prevalje~175|Ptuj~096|Race-Fram~098|Radece~099|Radenci~100|Radlje ob Dravi~101|Radovljica~102|Ravne na Koroskem~103|Razkrizje~176|Recica ob Savinji~209|Rence-Vogrsko~201|Ribnica~104|Ribnica na Poboriu~177|Rogaska Slatina~106|Rogasovci~105|Rogatec~107|Ruse~108|Salovci~033|Selnica ob Dravi~178|Semic~109|Sempeter-Vrtojba~183|Sencur~117|Sentilj~118|Sentjernej~119|Sentjur~120|Sentrupert~211|Sevnica~110|Sezana~111|Skocjan~121|Skofja Loka~122|Skofljica~123|Slovenj Gradec~112|Slovenska Bistrica~113|Slovenske Konjice~114|Smarje pri elsah~124|Smarjeske Toplice~206|Smartno ob Paki~125|Smartno pri Litiji~194|Sodrazica~179|Solcava~180|Sostanj~126|Sredisce ob Dravi~202|Starse~115|Store~127|Straza~203|Sveta Ana~181|Sveta Trojica v Slovenskih Goricah~204|Sveta Andraz v Slovenskih Goricah~182|Sveti Jurij~116|Sveti Jurij v Slovenskih Goricah~210|Sveti Tomaz~205|Tabor~184|Tisina~128|Tolmin~128|Trbovlje~129|Trebnje~130|Trnovska Vas~185|Trzin~186|Trzic~131|Turnisce~132|Velenje~133|Velika Polana~187|Velike Lasce~134|Verzej~188|Videm~135|Vipava~136|Vitanje~137|Vodice~138|Vojnik~139|Vransko~189|Vrhnika~140|Vuzenica~141|Zagorje ob Savi~142|Zavrc~143|Zrece~144|Zalec~190|Zelezniki~146|Zetale~191|Ziri~147|Zirovnica~192|Zuzemberk~193"], ["Solomon Islands", "SB", "Central~CE|Choiseul~CH|Guadalcanal~GU|Honiara~CT|Isabel~IS|Makira-Ulawa~MK|Malaita~ML|Rennell and Bellona~RB|Temotu~TE|Western~WE"], ["Somalia", "SO", "Awdal~AW|Bakool~BK|Banaadir~BN|Bari~BR|Bay~BY|Galguduud~GA|Gedo~GE|Hiiraan~HI|Jubbada Dhexe~JD|Jubbada Hoose~JH|Mudug~MU|Nugaal~NU|Sanaag~SA|Shabeellaha Dhexe~SD|Shabeellaha Hoose~SH|Sool~SO|Togdheer~TO|Woqooyi Galbeed~WO"], ["South Africa", "ZA", "Eastern Cape~EC|Free State~FS|Gauteng~GT|KwaZulu-Natal~NL|Limpopo~LP|Mpumalanga~MP|Northern Cape~NC|North West~NW|Western Cape~WC"], ["South Georgia and South Sandwich Islands", "GS", "Bird Island|Bristol Island|Clerke Rocks|Montagu Island|Saunders Island|South Georgia|Southern Thule|Traversay Islands"], ["South Sudan", "SS", "Central Equatoria~CE|Eastern Equatoria~EE|Jonglei~JG|Lakes~LK|Northern Bahr el Ghazal~BN|Unity~UY|Upper Nile~NU|Warrap~WR|Western Bahr el Ghazal~BW|Western Equatoria~EW"], ["Spain", "ES", "Albacete~CM|Alicante~VC|Almería~AN|Araba/Álava~VI|Asturias~O|Ávila~AV|Badajoz~BA|Barcelona~B|Bizkaia~BI|Burgos~BU|Cáceres~CC|Cádiz~CA|Cantabria~S|Castellón~CS|Cueta~CU|Ciudad Real~CR|Córdoba~CO|A Coruña~C|Cuenca~CU|Gipuzkoa~SS|Girona~GI|Granada~GR|Guadalajara~GU|Huelva~H|Huesca~HU|Illes Balears~PM|Jaén~J|León~LE|Lleida~L|Lugo~LU|Madrid~M|Málaga~MA|Melilla~ML|Murcia~MU|Navarre~NA|Ourense~OR|Palencia~P|Las Palmas~GC|Pontevedra~PO|La Rioja~LO|Salamanca~SA|Santa Cruz de Tenerife~TF|Segovia~SG|Sevilla~SE|Soria~SO|Tarragona~T|Teruel~TE|Toledo~TO|Valencia~V|Valladolid~VA|Zamora~ZA|Zaragoza~Z"], ["Sri Lanka", "LK", "Basnahira~1|Dakunu~3|Madhyama~2|Naegenahira~5|Sabaragamuwa~9|Uturu~4|Uturumaeda~7|Vayamba~6|Uva~8"], ["Sudan", "SD", "Al Bahr al Ahmar~RS|Al Jazirah~GZ|Al Khartum~KH|Al Qadarif~GD|An Nil al Abyad~NW|An Nil al Azraq~NB|Ash Shamaliyah~NO|Gharb Darfur~DW|Gharb Kurdufan~GK|Janub Darfur~DS|Janub Kurdufan~KS|Kassala~KA|Nahr an Nil~NR|Shamal Darfur~DN|Sharq Darfur~DE|Shiamal Kurdufan~KN|Sinnar~SI|Wasat Darfur Zalinjay~DC"], ["Suriname", "SR", "Brokopondo~BR|Commewijne~CM|Coronie~CR|Marowijne~MA|Nickerie~NI|Para~PR|Paramaribo~PM|Saramacca~SA|Sipaliwini~SI|Wanica~WA"], ["Swaziland", "SZ", "Hhohho~HH|Lubombo~LU|Manzini~MA|Shiselweni~SH"], ["Sweden", "SE", "Blekinge~K|Dalarnas~W|Gotlands~X|Gavleborgs~I|Hallands~N|Jamtlands~Z|Jonkopings~F|Kalmar~H|Kronobergs~G|Norrbottens~BD|Orebro~T|Ostergotlands~E|Skane~M|Sodermanlands~D|Stockholm~AB|Varmlands~S|Vasterbottens~AC|Vasternorrlands~Y|Vastmanlands~U|Vastra Gotalands~O"], ["Switzerland", "CH", "Aargau~AG|Appenzell Ausserrhoden~AR|Appenzell Innerhoden~AI|Basel-Landschaft~BL|Basel-Stadt~BS|Bern~BE|Fribourg~FR|Genève~GE|Glarus~GL|Graubünden~GR|Jura~JU|Luzern~LU|Neuchâtel~NE|Nidwalden~NW|Obwalden~OW|Sankt Gallen~SG|Schaffhausen~SH|Schwyz~SZ|Solothurn~SO|Thurgau~TG|Ticino~TI|Uri~UR|Valais~VS|Vaud~VD|Zug~ZG|Zürich~ZH"], ["Syrian Arab Republic", "SY", "Al Hasakah~HA|Al Ladhiqiyah~LA|Al Qunaytirah~QU|Ar Raqqah~RA|As Suwayda'~SU|Dar'a~DR|Dayr az Zawr~DY|Dimashq~DI|Halab~HL|Hamah~HM|Hims~HI|Idlib~ID|Rif Dimashq~RD|Tartus~TA"], ["Taiwan", "TW", "Chang-hua~CHA|Chia-i~CYQ|Hsin-chu~HSQ|Hua-lien~HUA|Kao-hsiung~KHH|Keelung~KEE|Kinmen~KIN|Lienchiang~LIE|Miao-li~MIA|Nan-t'ou~NAN|P'eng-hu~PEN|New Taipei~NWT|P'ing-chung~PIF|T'ai-chung~TXG|T'ai-nan~TNN|T'ai-pei~TPE|T'ai-tung~TTT|T'ao-yuan~TAO|Yi-lan~ILA|Yun-lin~YUN"], ["Tajikistan", "TJ", "Dushanbe~DU|Kŭhistoni Badakhshon~GB|Khatlon~KT|Sughd~SU"], ["Tanzania, United Republic of", "TZ", "Arusha~01|Coast~19|Dar es Salaam~02|Dodoma~03|Iringa~04|Kagera~05|Kigoma~08|Kilimanjaro~09|Lindi~12|Manyara~26|Mara~13|Mbeya~14|Morogoro~16|Mtwara~17|Mwanza~18|Pemba North~06|Pemba South~10|Rukwa~20|Ruvuma~21|Shinyanga~22|Singida~23|Tabora~24|Tanga~25|Zanzibar North~07|Zanzibar Central/South~11|Zanzibar Urban/West~15"], ["Thailand", "TH", "Amnat Charoen~37|Ang Thong~15|Bueng Kan~38|Buri Ram~31|Chachoengsao~24|Chai Nat~18|Chaiyaphum~36|Chanthaburi~22|Chiang Mai~50|Chiang Rai~57|Chon Buri~20|Chumphon~86|Kalasin~46|Kamphaeng Phet~62|Kanchanaburi~71|Khon Kaen~40|Krabi~81|Krung Thep Mahanakhon (Bangkok)~10|Lampang~52|Lamphun~51|Loei~42|Lop Buri~16|Mae Hong Son~58|Maha Sarakham~44|Mukdahan~49|Nakhon Nayok~26|Nakhon Phathom~73|Nakhon Phanom~48|Nakhon Ratchasima~30|Nakhon Sawan~60|Nakhon Si Thammarat~80|Nan~55|Narathiwat~96|Nong Bua Lam Phu~39|Nong Khai~43|Nonthaburi~12|Pathum Thani~13|Pattani~94|Phangnga~82|Phatthalung~93|Phayao~56|Phetchabun~76|Phetchaburi~76|Phichit~66|Phitsanulok~65|Phra Nakhon Si Ayutthaya~14|Phrae~54|Phuket~83|Prachin Buri~25|Prachuap Khiri Khan~77|Ranong~85|Ratchaburi~70|Rayong~21|Roi Et~45|Sa Kaeo~27|Sakon Nakhon~47|Samut Prakan~11|Samut Sakhon~74|Samut Songkhram~75|Saraburi~19|Satun~91|Sing Buri~17|Si Sa ket~33|Songkhla~90|Sukhothai~64|Suphan Buri~72|Surat Thani~84|Surin~32|Tak~63|Trang~92|Trat~23|Ubon Ratchathani~34|Udon Thani~41|Uthai Thani~61|Uttaradit~53|Yala~95|Yasothon~35"], ["Timor-Leste", "TL", "Aileu~AL|Ainaro~AN|Baucau~BA|Bobonaro~BO|Cova Lima~CO|Dili~DI|Ermera~ER|Lautem~LA|Liquica~LI|Manatuto~MT|Manufahi~MF|Oecussi~OE|Viqueque~VI"], ["Togo", "TG", "Centre~C|Kara~K|Maritime~M|Plateaux~P|Savannes~S"], ["Tokelau", "TK", "Atafu|Fakaofo|Nukunonu"], ["Tonga", "TO", "'Eua~01|Ha'apai~02|Niuas~03|Tongatapu~04|Vava'u~05"], ["Trinidad and Tobago", "TT", "Arima~ARI|Chaguanas~CHA|Couva-Tabaquite-Talparo~CTT|Diefo Martin~DMN|Mayaro-Rio Claro~MRC|Penal-Debe~PED|Point Fortin~PTF|Port-of-Spain~POS|Princes Town~PRT|San Fernando~SFO|San Juan-Laventille~SJL|Sangre Grande~SGE|Siparia~SIP|Tobago~TOB|Tunapuna-Piarco~TUP"], ["Tunisia", "TN", "Ariana~12|Beja~31|Ben Arous~13|Bizerte~23|Gabes~81|Gafsa~71|Jendouba~32|Kairouan~41|Kasserine~42|Kebili~73|Kef~33|Mahdia~53|Medenine~82|Monastir~52|Nabeul~21|Sfax~61|Sidi Bouzid~43|Siliana~34|Sousse~51|Tataouine~83|Tozeur~72|Tunis~11|Zaghouan~22"], ["Turkey", "TR", "Adana~01|Adiyaman~02|Afyonkarahisar~03|Agri~04|Aksaray~68|Amasya~05|Ankara~06|Antalya~07|Ardahan~75|Artvin~08|Aydin~09|Balikesir~10|Bartin~74|Batman~72|Bayburt~69|Bilecik~11|Bingol~12|Bitlis~13|Bolu~14|Burdur~15|Bursa~16|Canakkale~17|Cankiri~18|Corum~19|Denizli~20|Diyarbakir~21|Duzce~81|Edirne~22|Elazig~23|Erzincan~24|Erzurum~25|Eskisehir~26|Gaziantep~27|Giresun~28|Gumushane~29|Hakkari~30|Hatay~31|Igdir~76|Isparta~32|Istanbul~34|Izmir~35|Kahramanmaras~46|Karabuk~78|Karaman~70|Kars~36|Kastamonu~37|Kayseri~38|Kilis~79|Kirikkale~71|Kirklareli~39|Kirsehir~40|Kocaeli~41|Konya~42|Kutahya~43|Malatya~44|Manisa~45|Mardin~47|Mersin~33|Mugla~48|Mus~49|Nevsehir~50|Nigde~51|Ordu~52|Osmaniye~80|Rize~53|Sakarya~54|Samsun~55|Sanliurfa~63|Siirt~56|Sinop~57|Sirnak~73|Sivas~58|Tekirdag~59|Tokat~60|Trabzon~61|Tunceli~62|Usak~64|Van~65|Yalova~77|Yozgat~66|Zonguldak~67"], ["Turkmenistan", "TM", "Ahal~A|Asgabat~S|Balkan~B|Dashoguz~D|Lebap~L|Mary~M"], ["Turks and Caicos Islands", "TC", "Turks and Caicos Islands"], ["Tuvalu", "TV", "Funafuti~FUN|Nanumanga~NMG|Nanumea~NMA|Niutao~NIT|Nui~NUI|Nukufetau~NKF|Nukulaelae~NKL|Vaitupu~VAU"], ["Uganda", "UG", "Abim~317|Adjumani~301|Amolatar~314|Amuria~216|Amuru~319|Apac~302|Arua~303|Budaka~217|Bududa~223|Bugiri~201|Bukedea~224|Bukwa~218|Buliisa~419|Bundibugyo~401|Bushenyi~402|Busia~202|Butaleja~219|Dokolo~318|Gulu~304|Hoima~403|Ibanda~416|Iganga~203|Isingiro~417|Jinja~204|Kaabong~315|Kabale~404|Kabarole~405|Kaberamaido~213|Kalangala~101|Kaliro~220|Kampala~102|Kamuli~205|Kamwenge~413|Kanungu~414|Kapchorwa~206|Kasese~406|Katakwi~207|Kayunga~112|Kibaale~407|Kiboga~103|Kiruhura~418|Kisoro~408|Kitgum~305|Koboko~316|Kotido~306|Kumi~208|Kyenjojo~415|Lira~307|Luwero~104|Lyantonde~116|Manafwa~221|Maracha~320|Masaka~105|Masindi~409|Mayuge~214|Mbale~209|Mbarara~410|Mityana~114|Moroto~308|Moyo~309|Mpigi~106|Mubende~107|Mukono~108|Nakapiripirit~311|Nakaseke~115|Nakasongola~109|Namutumba~222|Nebbi~310|Ntungamo~411|Oyam~321|Pader~312|Pallisa~210|Rakai~110|Rukungiri~412|Sembabule~111|Sironko~215|Soroti~211|Tororo~212|Wakiso~113|Yumbe~313"], ["Ukraine", "UA", "Cherkasy~71|Chernihiv~74|Chernivtsi~77|Dnipropetrovsk~12|Donetsk~14|Ivano-Frankivsk~26|Kharkiv~63|Kherson~65|Khmelnytskyi~68|Kiev~32|Kirovohrad~35|Luhansk~09|Lviv~46|Mykolaiv~48|Odessa~51|Poltava~53|Rivne~56|Sumy~59|Ternopil~61|Vinnytsia~05|Volyn~07|Zakarpattia~21|Zaporizhia~23|Zhytomyr~18|Avtonomna Respublika Krym~43|Kyïv~30|Sevastopol~40"], ["United Arab Emirates", "AE", "Abu Dhabi~AZ|Ajman~AJ|Dubai~DU|Fujairah~FU|Ras al Khaimah~RK|Sharjah~SH|Umm Al Quwain~UQ"], ["United Kingdom", "GB", "Avon~AVN|Bedfordshire~BDF|Berkshire~BRK|Bristol, City of~COB|Buckinghamshire~BKM|Cambridgeshire~CAM|Cheshire~CHS|Cleveland~CLV|Cornwall~CON|Cumbria~CMA|Derbyshire~DBY|Devon~DEV|Dorset~DOR|Durham~DUR|East Sussex~SXE|Essex~ESS|Gloucestershire~GLS|Greater London~LND|Greater Manchester~GTM|Hampshire (County of Southampton)~HAM|Hereford and Worcester~HWR|Herefordshire~HEF|Hertfordshire~HRT|Isle of Wight~IOW|Kent~KEN|Lancashire~LAN|Leicestershire~LEI|Lincolnshire~LIN|London~LDN|Merseyside~MSY|Middlesex~MDX|Norfolk~NFK|Northamptonshire~NTH|Northumberland~NBL|North Humberside~NHM|North Yorkshire~NYK|Nottinghamshire~NTT|Oxfordshire~OXF|Rutland~RUT|Shropshire~SAL|Somerset~SOM|South Humberside~SHM|South Yorkshire~SYK|Staffordshire~STS|Suffolk~SFK|Surrey~SRY|Tyne and Wear~TWR|Warwickshire~WAR|West Midlands~WMD|West Sussex~SXW|West Yorkshire~WYK|Wiltshire~WIL|Worcestershire~WOR|Antrim~ANT|Armagh~ARM|Belfast, City of~BLF|Down~DOW|Fermanagh~FER|Londonderry~LDY|Derry, City of~DRY|Tyrone~TYR|Aberdeen, City of~AN|Aberdeenshire~ABD|Angus (Forfarshire)~ANS|Argyll~AGB|Ayrshire~ARG|Banffshire~BAN|Berwickshire~BEW|Bute~BUT|Caithness~CAI|Clackmannanshire~CLK|Cromartyshire~COC|Dumfriesshire~DFS|Dunbartonshire (Dumbarton)~DNB|Dundee, City of~DD|East Lothian (Haddingtonshire)~ELN|Edinburgh, City of~EB|Fife~FIF|Glasgow, City of~GLA|Inverness-shire~INV|Kincardineshire~KCD|Kinross-shire~KRS|Kirkcudbrightshire~KKD|Lanarkshire~LKS|Midlothian (County of Edinburgh)~MLN|Moray (Elginshire)~MOR|Nairnshire~NAI|Orkney~OKI|Peeblesshire~PEE|Perthshire~PER|Renfrewshire~RFW|Ross and Cromarty~ROC|Ross-shire~ROS|Roxburghshire~ROX|Selkirkshire~SEL|Shetland (Zetland)~SHI|Stirlingshire~STI|Sutherland~SUT|West Lothian (Linlithgowshire)~WLN|Wigtownshire~WIG|Clwyd~CWD|Dyfed~DFD|Gwent~GNT|Gwynedd~GWN|Mid Glamorgan~MGM|Powys~POW|South Glamorgan~SGM|West Glamorgan~WGM"], ["United States", "US", "Alabama~AL|Alaska~AK|American Samoa~AS|Arizona~AZ|Arkansas~AR|California~CA|Colorado~CO|Connecticut~CT|Delaware~DE|District of Columbia~DC|Micronesia~FM|Florida~FL|Georgia~GA|Guam~GU|Hawaii~HI|Idaho~ID|Illinois~IL|Indiana~IN|Iowa~IA|Kansas~KS|Kentucky~KY|Louisiana~LA|Maine~ME|Marshall Islands~MH|Maryland~MD|Massachusetts~MA|Michigan~MI|Minnesota~MN|Mississippi~MS|Missouri~MO|Montana~MT|Nebraska~NE|Nevada~NV|New Hampshire~NH|New Jersey~NJ|New Mexico~NM|New York~NY|North Carolina~NC|North Dakota~ND|Northern Mariana Islands~MP|Ohio~OH|Oklahoma~OK|Oregon~OR|Palau~PW|Pennsylvania~PA|Puerto Rico~PR|Rhode Island~RI|South Carolina~SC|South Dakota~SD|Tennessee~TN|Texas~TX|Utah~UT|Vermont~VT|Virgin Islands~VI|Virginia~VA|Washington~WA|West Virginia~WV|Wisconsin~WI|Wyoming~WY|Armed Forces Americas~AA|Armed Forces Europe, Canada, Africa and Middle East~AE|Armed Forces Pacific~AP"], ["United States Minor Outlying Islands", "UM", "Baker Island~81|Howland Island~84|Jarvis Island~86|Johnston Atoll~67|Kingman Reef~89|Midway Islands~71|Navassa Island~76|Palmyra Atoll~95|Wake Island~79|Bajo Nuevo Bank~BN|Serranilla Bank~SB"], ["Uruguay", "UY", "Artigas~AR|Canelones~CA|Cerro Largo~CL|Colonia~CO|Durazno~DU|Flores~FS|Florida~FD|Lavalleja~LA|Maldonado~MA|Montevideo~MO|Paysandú~PA|Río Negro~RN|Rivera~RV|Rocha~RO|Salto~SA|San José~SJ|Soriano~SO|Tacuarembó~TA|Treinta y Tres~TT"], ["Uzbekistan", "UZ", "Toshkent shahri~TK|Andijon~AN|Buxoro~BU|Farg‘ona~FA|Jizzax~JI|Namangan~NG|Navoiy~NW|Qashqadaryo (Qarshi)~QA|Samarqand~SA|Sirdaryo (Guliston)~SI|Surxondaryo (Termiz)~SU|Toshkent wiloyati~TO|Xorazm (Urganch)~XO|Qoraqalpog‘iston Respublikasi (Nukus)~QR"], ["Vanuatu", "VU", "Malampa~MAP|Pénama~PAM|Sanma~SAM|Shéfa~SEE|Taféa~TAE|Torba~TOB"], ["Venezuela, Bolivarian Republic of", "VE", "Dependencias Federales~W|Distrito Federal~A|Amazonas~Z|Anzoátegui~B|Apure~C|Aragua~D|Barinas~E|Bolívar~F|Carabobo~G|Cojedes~H|Delta Amacuro~Y|Falcón~I|Guárico~J|Lara~K|Mérida~L|Miranda~M|Monagas~N|Nueva Esparta~O|Portuguesa~P|Sucre~R|Táchira~S|Trujillo~T|Vargas~X|Yaracuy~U|Zulia~V"], ["Vietnam", "VN", "Đồng Nai~39|Đồng Tháp~45|Gia Lai~30|Hà Giang~03|Hà Nam~63|Hà Tây~15|Hà Tĩnh~23|Hải Dương~61|Hậu Giang~73|Hòa Bình~14|Hưng Yên~66|Khánh Hòa~34|Kiên Giang~47|Kon Tum~28|Lai Châu~01|Lâm Đồng~35|Lạng Sơn~09|Lào Cai~02|Long An~41|Nam Định~67|Nghệ An~22|Ninh Bình~18|Ninh Thuận~36|Phú Thọ~68|Phú Yên~32|Quảng Bình~24|Quảng Nam~27|Quảng Ngãi~29|Quảng Ninh~13|Quảng Trị~25|Sóc Trăng~52|Sơn La~05|Tây Ninh~37|Thái Bình~20|Thái Nguyên~69|Thanh Hóa~21|Thừa Thiên–Huế~26|Tiền Giang~46|Trà Vinh~51|Tuyên Quang~07|Vĩnh Long~49|Vĩnh Phúc~70|Yên Bái~06|Cần Thơ~CT|Đà Nẵng~DN|Hà Nội~HN|Hải Phòng~HP|Hồ Chí Minh (Sài Gòn)~SG"], ["Virgin Islands, British", "VG", "Anegada~ANG|Jost Van Dyke~JVD|Tortola~TTA|Virgin Gorda~VGD"], ["Virgin Islands, U.S.", "VI", "St. Thomas~STH|St. John~SJO|St. Croix~SCR"], ["Wallis and Futuna", "WF", "Alo~ALO|Sigave~SIG|Wallis~WAL"], ["Western Sahara", "EH", "Es Smara~ESM|Boujdour~BOD|Laâyoune~LAA|Aousserd~AOU|Oued ed Dahab~OUD"], ["Yemen", "YE", "Abyān~AB|'Adan~AD|Aḑ Ḑāli'~DA|Al Bayḑā'~BA|Al Ḩudaydah~HU|Al Jawf~JA|Al Mahrah~MR|Al Maḩwīt~MW|'Amrān~AM|Dhamār~DH|Ḩaḑramawt~HD|Ḩajjah~HJ|Ibb~IB|Laḩij~LA|Ma'rib~MA|Raymah~RA|Şā‘dah~SD|Şan‘ā'~SN|Shabwah~SH|Tā‘izz~TA"], ["Zambia", "ZM", "Central~02|Copperbelt~08|Eastern~03|Luapula~04|Lusaka~09|Northern~05|North-Western~06|Southern~07|Western~01"], ["Zimbabwe", "ZW", "Bulawayo~BU|Harare~HA|Manicaland~MA|Mashonaland Central~MC|Mashonaland East~ME|Mashonaland West~MW|Masvingo~MV|Matabeleland North~MN|Matabeleland South~MS|Midlands~MI"]];
	
	exports.default = CountryRegionData;
	module.exports = exports["default"];

/***/ },

/***/ "Dxjp":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"address-wrapper":"address-wrapper","street-unit-number":"street-unit-number","unit-number":"unit-number","street":"street","outline-form-field":"outline-form-field"};

/***/ },

/***/ "4sJU":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * <OpenHours />
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * The data i/o is in this format:
	                                                                                                                                                                                                                                                                   * Mon/09:00-17:00;Wed/09:00-17:00;Thu/11:00-16:00;Fri/09:00-17:00;Sat/10:00-17:00;Sun/09:00-17:00;
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * When it is closed, it is omitted (for eg. Tue is missing from the above)
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @parent anybody
	                                                                                                                                                                                                                                                                   * @stateful
	                                                                                                                                                                                                                                                                   */
	
	
	exports.openhours = openhours;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TimeRange = __webpack_require__("eL63");
	
	var _TimeRange2 = _interopRequireDefault(_TimeRange);
	
	__webpack_require__("PjrO");
	
	var _constants = __webpack_require__("7rIE");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
	
	var DEFAULT_VALUE = '';
	
	var DEFAULT_TIME = '09:00-17:00';
	
	function openhours(props) {
	  var schema = props.schema,
	      onChange = props.onChange,
	      options = props.options,
	      placeholder = props.placeholder,
	      value = props.value;
	  var name = schema.name;
	  var maxlength = options.maxlength;
	
	
	  return _react2.default.createElement(OpenHours, _extends({
	    name: name,
	    value: value,
	    onChange: onChange
	  }, options));
	}
	
	var OpenHours = function (_React$Component) {
	  _inherits(OpenHours, _React$Component);
	
	  function OpenHours(props) {
	    _classCallCheck(this, OpenHours);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.valueObj = {};
	    _this.onChangeTime = _this.onChangeTime.bind(_this);
	    _this.valueToStr = _this.valueToStr.bind(_this);
	    return _this;
	  }
	
	  OpenHours.prototype.onChangeTime = function onChangeTime(day) {
	    var _this2 = this;
	
	    return function (_ref) {
	      var endMoment = _ref.endMoment,
	          startMoment = _ref.startMoment;
	
	      _this2.valueObj[day] = {
	        startMoment: startMoment,
	        endMoment: endMoment
	      };
	      _this2.props.onChange(_this2.valueToStr());
	    };
	  };
	
	  OpenHours.prototype.onChangeClosed = function onChangeClosed(day) {
	    var _this3 = this;
	
	    return function (e) {
	      _this3.valueObj[day].closed = e.target.checked;
	      _this3.props.onChange(_this3.valueToStr());
	    };
	  };
	
	  OpenHours.prototype.strToValue = function strToValue(strValue) {
	    var _this4 = this;
	
	    var dayParts = strValue.split(';');
	
	    if (Array.isArray(dayParts) && dayParts.length > 0) {
	      dayParts.forEach(function (part) {
	        if (!part) {
	          return;
	        }
	        var data = part.split('/');
	        var day = data[0];
	        var timeRange = data[1].split('-');
	
	        _this4.valueObj[day] = {
	          startMoment: (0, _moment2.default)(timeRange[0], _constants.TIME_FORMAT),
	          endMoment: (0, _moment2.default)(timeRange[1], _constants.TIME_FORMAT)
	        };
	      });
	    }
	
	    WEEKDAYS.map(function (day) {
	      if (!_this4.valueObj[day]) {
	        _this4.valueObj[day] = {
	          closed: true
	        };
	      }
	    });
	  };
	
	  OpenHours.prototype.valueToStr = function valueToStr() {
	    var _this5 = this;
	
	    var str = '';
	    WEEKDAYS.map(function (day) {
	      var dayData = _this5.valueObj[day];
	      if (dayData.closed != true) {
	        if (dayData.startMoment && dayData.endMoment) {
	          var startTime = dayData.startMoment.format(_constants.TIME_FORMAT);
	          var endTime = dayData.endMoment.format(_constants.TIME_FORMAT);
	          str += day + '/' + startTime + '-' + endTime + ';';
	        } else {
	          str += day + '/' + DEFAULT_TIME + ';';
	        }
	      }
	    });
	    return str;
	  };
	
	  OpenHours.prototype.render = function render() {
	    var _this6 = this;
	
	    var _props = this.props,
	        name = _props.name,
	        _props$value = _props.value,
	        value = _props$value === undefined ? DEFAULT_VALUE : _props$value,
	        onChange = _props.onChange;
	
	
	    this.strToValue(value);
	
	    var Items = WEEKDAYS.map(function (day, key) {
	      var dayData = _this6.valueObj[day];
	      return _react2.default.createElement(
	        'div',
	        { className: 'openhours-day', key: key },
	        _react2.default.createElement(
	          'div',
	          { className: 'weekday' },
	          _react2.default.createElement(
	            'label',
	            null,
	            __(day, 'weekdays')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'time-range' },
	          dayData.closed != true && _react2.default.createElement(_TimeRange2.default, {
	            minuteStep: 5,
	            startMoment: dayData.startMoment,
	            endMoment: dayData.endMoment,
	            onChange: _this6.onChangeTime(day) })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'closed' },
	          _react2.default.createElement(
	            'label',
	            { className: 'control' },
	            _react2.default.createElement('input', {
	              type: 'checkbox',
	              onChange: _this6.onChangeClosed(day),
	              checked: dayData.closed
	            }),
	            __('closed', 'openHours'),
	            _react2.default.createElement('span', { className: 'checkmark' })
	          )
	        )
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'openhours-wrapper form-input outline-form-field' },
	      Items
	    );
	  };
	
	  return OpenHours;
	}(_react2.default.Component);
	
	exports.default = OpenHours;

/***/ },

/***/ "PjrO":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"openhours-wrapper":"openhours-wrapper","openhours-day":"openhours-day","weekday":"weekday","time-range":"time-range","closed":"closed"};

/***/ },

/***/ "zajY":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * <AgeLimit />
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @parent anybody
	                                                                                                                                                                                                                                                                   * @stateful
	                                                                                                                                                                                                                                                                   */
	
	
	exports.agelimit = agelimit;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSelect = __webpack_require__("tTw2");
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _parseJson = __webpack_require__("AKlS");
	
	var _parseJson2 = _interopRequireDefault(_parseJson);
	
	var _Age = __webpack_require__("/1QF");
	
	var _Age2 = _interopRequireDefault(_Age);
	
	__webpack_require__("E7Sy");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_VALUE = {
	  min: 23,
	  max: 23
	};
	
	function agelimit(props) {
	  var schema = props.schema,
	      onChange = props.onChange,
	      options = props.options,
	      placeholder = props.placeholder;
	  var name = schema.name;
	  var maxlength = options.maxlength;
	
	
	  var value = (0, _parseJson2.default)(props.value || DEFAULT_VALUE);
	
	  return _react2.default.createElement(AgeLimit, _extends({
	    name: name,
	    value: value,
	    onChange: function onChange(data) {
	      props.onChange(JSON.stringify(data));
	    }
	  }, options));
	}
	
	var AgeLimit = function (_React$Component) {
	  _inherits(AgeLimit, _React$Component);
	
	  function AgeLimit(props) {
	    _classCallCheck(this, AgeLimit);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChangeAge = _this.onChangeAge.bind(_this);
	    return _this;
	  }
	
	  AgeLimit.prototype.onChangeAge = function onChangeAge(name) {
	    var _this2 = this;
	
	    return function (newAge) {
	      var _props = _this2.props,
	          value = _props.value,
	          onChange = _props.onChange;
	      var min = value.min,
	          max = value.max;
	
	
	      if (name === 'max') {
	        if (min > newAge) {
	          min = newAge;
	        }
	        max = newAge;
	      }
	
	      if (name === 'min') {
	        if (newAge > max) {
	          max = newAge;
	        }
	        min = newAge;
	      }
	
	      onChange({
	        min: min,
	        max: max
	      });
	    };
	  };
	
	  AgeLimit.prototype.render = function render() {
	    var _props2 = this.props,
	        name = _props2.name,
	        value = _props2.value,
	        onChange = _props2.onChange;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'age-limit-wrapper form-input' },
	      _react2.default.createElement(
	        'div',
	        { className: 'age-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'age-limit-label' },
	          __('Minimum')
	        ),
	        _react2.default.createElement(_Age2.default, { value: value.min, onChange: this.onChangeAge('min') })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'age-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'age-limit-label' },
	          __('Maximum')
	        ),
	        _react2.default.createElement(_Age2.default, { value: value.max, onChange: this.onChangeAge('max') })
	      )
	    );
	  };
	
	  return AgeLimit;
	}(_react2.default.Component);
	
	exports.default = AgeLimit;

/***/ },

/***/ "/1QF":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.age = age;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactSelect = __webpack_require__("Z40E");
	
	var _ReactSelect2 = _interopRequireDefault(_ReactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function age(props) {
	  var options = props.options,
	      value = props.value,
	      onChange = props.onChange,
	      required = props.required;
	
	
	  return _react2.default.createElement(Age, _extends({
	    required: required,
	    value: value,
	    onChange: onChange
	  }, options));
	}
	
	var Age = function (_React$Component) {
	  _inherits(Age, _React$Component);
	
	  function Age(props) {
	    _classCallCheck(this, Age);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.ageOptions = Array.from(Array(120), function (_, age) {
	      var label = age <= 1 ? __('{age} year old', 'appwrapper', { age: age }) : __('{age} years old', 'appwrapper', { age: age });
	
	      return {
	        label: label,
	        value: age
	      };
	    });
	    return _this;
	  }
	
	  Age.prototype.render = function render() {
	    var _props = this.props,
	        value = _props.value,
	        onChange = _props.onChange;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'select-age-wrapper form-input' },
	      _react2.default.createElement(_ReactSelect2.default, {
	        value: value,
	        onChange: onChange,
	        options: this.ageOptions
	      })
	    );
	  };
	
	  return Age;
	}(_react2.default.Component);
	
	exports.default = Age;

/***/ },

/***/ "E7Sy":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"age-limit-wrapper":"age-limit-wrapper","age-container":"age-container","form-input":"form-input","select-age-wrapper":"select-age-wrapper","age-limit-label":"age-limit-label","Select-control":"Select-control","Select-menu-outer":"Select-menu-outer","locale-EN":"locale-EN"};

/***/ },

/***/ "9crX":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.quantity = quantity;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNumberFormat = __webpack_require__("RwBb");
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function quantity(props) {
	  var options = props.options,
	      value = props.value,
	      onChange = props.onChange,
	      required = props.required;
	
	
	  return _react2.default.createElement(Quantity, _extends({
	    required: required,
	    value: value,
	    onChange: onChange
	  }, options));
	}
	
	var Quantity = function (_React$Component) {
	  _inherits(Quantity, _React$Component);
	
	  function Quantity(props) {
	    _classCallCheck(this, Quantity);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Quantity.prototype.render = function render() {
	    var _props = this.props,
	        name = _props.name,
	        value = _props.value,
	        _onChange = _props.onChange,
	        _props$suffix = _props.suffix,
	        suffix = _props$suffix === undefined ? '' : _props$suffix,
	        _props$prefix = _props.prefix,
	        prefix = _props$prefix === undefined ? '' : _props$prefix,
	        _props$unit = _props.unit,
	        unit = _props$unit === undefined ? ['', ''] : _props$unit,
	        _props$paddingRight = _props.paddingRight,
	        paddingRight = _props$paddingRight === undefined ? [0, 0] : _props$paddingRight,
	        required = _props.required;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'number-input form-input' },
	      _react2.default.createElement(_reactNumberFormat2.default, {
	        style: { paddingRight: value > 1 ? paddingRight[1] : paddingRight[0] },
	        value: value || '',
	        allowNegative: false,
	        onChange: function onChange(event) {
	          var value = event.target.value || '0';
	          _onChange(parseFloat(value.replace(suffix, '').replace(prefix, '')));
	        },
	        placeholder: '0',
	        required: required,
	        className: 'form-control',
	        prefix: prefix,
	        suffix: suffix }),
	      _react2.default.createElement(
	        'div',
	        { className: 'unit-marker' },
	        value > 1 ? unit[1] : unit[0]
	      )
	    );
	  };
	
	  return Quantity;
	}(_react2.default.Component);
	
	exports.default = Quantity;

/***/ },

/***/ "7bpD":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.money = money;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNumberFormat = __webpack_require__("RwBb");
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_SYMBOL = '$';
	
	function money(props) {
	  var options = props.options,
	      value = props.value,
	      onChange = props.onChange,
	      required = props.required;
	
	
	  return _react2.default.createElement(Money, _extends({
	    required: required,
	    value: value,
	    onChange: onChange
	  }, options));
	}
	
	var Money = function (_React$Component) {
	  _inherits(Money, _React$Component);
	
	  function Money(props) {
	    _classCallCheck(this, Money);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Money.prototype.render = function render() {
	    var _props = this.props,
	        name = _props.name,
	        value = _props.value,
	        _onChange = _props.onChange,
	        currency = _props.currency,
	        outputType = _props.outputType,
	        _props$symbol = _props.symbol,
	        symbol = _props$symbol === undefined ? DEFAULT_SYMBOL : _props$symbol,
	        required = _props.required,
	        className = _props.className;
	
	
	    var newValue = void 0;
	    if (value == 0 || !value) {
	      newValue = '';
	    } else {
	      newValue = value;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'number-input money form-input ' + className },
	      _react2.default.createElement(_reactNumberFormat2.default, {
	        value: newValue,
	        allowNegative: false,
	        onChange: function onChange(event) {
	          var value = event.target.value || '';
	          _onChange(value.replace('$', ''));
	        },
	        placeholder: '$0',
	        required: required,
	        decimalScale: 2,
	        thousandSeparator: false,
	        className: 'form-control',
	        prefix: symbol }),
	      _react2.default.createElement(
	        'div',
	        { className: 'unit-marker' },
	        currency
	      )
	    );
	  };
	
	  return Money;
	}(_react2.default.Component);
	
	exports.default = Money;

/***/ },

/***/ "A6bG":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.schoolhomepage = schoolhomepage;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _parseJson = __webpack_require__("AKlS");
	
	var _parseJson2 = _interopRequireDefault(_parseJson);
	
	__webpack_require__("t2wX");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_VALUE = {
	  homepage: '',
	  enable: false
	};
	
	function schoolhomepage(props) {
	  var options = props.options,
	      onChange = props.onChange,
	      required = props.required;
	
	
	  var value = (0, _parseJson2.default)(props.value || DEFAULT_VALUE);
	
	  return _react2.default.createElement(SchoolHomepage, _extends({
	    required: required,
	    value: value,
	    onChange: function onChange(data) {
	      props.onChange(JSON.stringify(data));
	    }
	  }, options));
	}
	
	var SchoolHomepage = function (_React$Component) {
	  _inherits(SchoolHomepage, _React$Component);
	
	  function SchoolHomepage(props) {
	    _classCallCheck(this, SchoolHomepage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  SchoolHomepage.prototype.onChange = function onChange(name, value) {
	    var _extends2;
	
	    this.props.onChange(_extends({}, this.props.value, (_extends2 = {}, _extends2[name] = value, _extends2)));
	  };
	
	  SchoolHomepage.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        value = _props.value,
	        onChange = _props.onChange;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'schoolhomepage-wrapper form-input outline-form-field' },
	      _react2.default.createElement(
	        'div',
	        { className: 'homepage-url' },
	        _react2.default.createElement('input', { value: value.homepage, onChange: function onChange(e) {
	            return _this2.onChange('homepage', e.target.value);
	          }, className: 'form-control' })
	      )
	    );
	  };
	
	  return SchoolHomepage;
	}(_react2.default.Component);
	
	exports.default = SchoolHomepage;

/***/ },

/***/ "t2wX":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"schoolhomepage-wrapper":"schoolhomepage-wrapper","homepage-url":"homepage-url","enable-on-yellowpage":"enable-on-yellowpage","show-homepage":"show-homepage","hide-homepage":"hide-homepage"};

/***/ },

/***/ "tbgL":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.imageuploader = imageuploader;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDropzone = __webpack_require__("KTM0");
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	__webpack_require__("pddx");
	
	var _alert = __webpack_require__("BGi1");
	
	var _ImageCropper = __webpack_require__("jlVy");
	
	var _ImageCropper2 = _interopRequireDefault(_ImageCropper);
	
	var _logoUploader = __webpack_require__("ZmcG");
	
	var _logoUploader2 = _interopRequireDefault(_logoUploader);
	
	var _rcProgress = __webpack_require__("McaX");
	
	var _lodash = __webpack_require__("M4fF");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pica = __webpack_require__("N555")();
	
	var ACCEPT_MIME = 'image/png,image/jpeg';
	var MAX_SIZE = 5 * 1000 * 1000;
	var MIN_SIZE = 0;
	var DO_RESIZING = true;
	var RESIZE_WIDTH = 300;
	var RESIZE_HEIGHT = 300;
	
	function imageuploader(props) {
	  var options = props.options,
	      value = props.value,
	      onChange = props.onChange,
	      required = props.required;
	
	
	  return _react2.default.createElement(ImageUploader, _extends({
	    required: required,
	    value: value,
	    onChange: onChange
	  }, options));
	}
	
	var ImageUploader = function (_React$Component) {
	  _inherits(ImageUploader, _React$Component);
	
	  function ImageUploader(props) {
	    _classCallCheck(this, ImageUploader);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.uploadImage = _this.uploadImage.bind(_this);
	    _this.resizeImage = _this.resizeImage.bind(_this);
	
	    _this.state = {
	      existingImg: props.value,
	      lastUpdated: null,
	      uploading: false
	    };
	    return _this;
	  }
	
	  ImageUploader.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var value = _ref.value;
	
	    if (value) {
	      this.setState({
	        existingImg: value
	      });
	    }
	  };
	
	  ImageUploader.prototype.onDrop = function onDrop(accepted, rejected) {
	    var _this2 = this;
	
	    if (rejected.length > 0) {
	      _alert.alert.warning(__('Image file must be png/jpeg under 5 MB', 'image'), __('Image not qualified', 'image'));
	    } else if (accepted.length > 0) {
	      // STEP 1. Open up modal
	      (0, _ImageCropper2.default)({
	        file: accepted[0],
	        aspectRatioHeight: 1,
	        aspectRatioWidth: 1
	      }).then(function (_ref2) {
	        var file = _ref2.file,
	            imageUrl = _ref2.imageUrl,
	            dataUrl = _ref2.dataUrl;
	
	        // STEP 2. Modal returns a file and a temporary imageUrl which we apply
	        // to the image preview
	        if (file) {
	          _this2.setState({
	            existingImg: imageUrl
	          });
	          // Step 3. Resize (or not) image before uploading
	          var _props = _this2.props,
	              _props$doResizing = _props.doResizing,
	              doResizing = _props$doResizing === undefined ? DO_RESIZING : _props$doResizing,
	              options = _props.options,
	              onChange = _props.onChange;
	
	
	          if (doResizing == true) {
	            var _props2 = _this2.props,
	                _props2$resizeWidth = _props2.resizeWidth,
	                resizeWidth = _props2$resizeWidth === undefined ? RESIZE_WIDTH : _props2$resizeWidth,
	                _props2$resizeHeight = _props2.resizeHeight,
	                resizeHeight = _props2$resizeHeight === undefined ? RESIZE_HEIGHT : _props2$resizeHeight;
	
	
	            _this2.resizeImage(dataUrl, resizeWidth, resizeHeight, function (file) {
	              _this2.uploadImage(file);
	            });
	          } else {
	            _this2.uploadImage(file);
	          }
	        }
	      }).catch(function (err) {
	        console.error(err);
	      });
	    }
	  };
	
	  ImageUploader.prototype.resizeImage = function resizeImage(dataUrl, newWidth, newHeight, cb) {
	    var from = document.createElement('img');
	    from.src = dataUrl;
	
	    from.onload = function () {
	      var to = document.createElement('canvas');
	      to.width = newWidth;
	      to.height = newHeight;
	
	      pica.resize(from, to).then(function (result) {
	        return pica.toBlob(result, 'image/jpeg', 0.90);
	      }).then(function (resized) {
	        cb(resized);
	      }).catch(function (err) {
	        cb(null);
	        console.error(err);
	      });
	    };
	  };
	
	  ImageUploader.prototype.uploadImage = function uploadImage(file) {
	    var _this3 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    (0, _logoUploader2.default)(schoolId, file, function (_ref3) {
	      var ratio = _ref3.ratio;
	
	      _this3.setState({
	        uploading: true,
	        ratio: parseInt(ratio * 100)
	      });
	    }).then(function (data) {
	      // Step 4. UPload successful
	      _this3.setState({
	        uploading: false
	      }, function () {
	        // Step 5. Update the image url
	        _this3.props.onChange(data.save_to, file);
	      });
	    }).catch(function (err) {
	      // TODO: create a more comprehensive error messgae
	      console.error(err);
	    });
	  };
	
	  ImageUploader.prototype.render = function render() {
	    var _props3 = this.props,
	        name = _props3.name,
	        value = _props3.value,
	        onChange = _props3.onChange,
	        required = _props3.required,
	        _props3$accept = _props3.accept,
	        accept = _props3$accept === undefined ? ACCEPT_MIME : _props3$accept,
	        _props3$maxSize = _props3.maxSize,
	        maxSize = _props3$maxSize === undefined ? MAX_SIZE : _props3$maxSize,
	        _props3$minSize = _props3.minSize,
	        minSize = _props3$minSize === undefined ? MIN_SIZE : _props3$minSize;
	    var _state = this.state,
	        existingImg = _state.existingImg,
	        lastUpdated = _state.lastUpdated,
	        uploading = _state.uploading,
	        ratio = _state.ratio;
	
	
	    var variance = '';
	    if (lastUpdated) {
	      variance = '?lastupdated=' + lastUpdated;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'imageuploader-wrapper form-input' },
	      _react2.default.createElement(_reactDropzone2.default, {
	        accept: accept,
	        multiple: false,
	        className: 'zone',
	        maxSize: maxSize,
	        minSize: minSize,
	        onDrop: this.onDrop,
	        children: _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(existingImg ? 'has-image' : 'has-no-image') },
	          uploading != true && _react2.default.createElement(
	            'div',
	            { className: 'overlay' },
	            _react2.default.createElement(
	              'div',
	              { className: 'text' },
	              __('Click or drag and drop image here', 'schoolInformation.form')
	            )
	          ),
	          uploading == true && _react2.default.createElement(
	            'div',
	            { className: 'upload-overlay' },
	            _react2.default.createElement(_rcProgress.Line, { percent: ratio, strokeWidth: '5', trailWidth: '5' }),
	            _react2.default.createElement(
	              'div',
	              null,
	              ratio || 0,
	              '%'
	            )
	          ),
	          !_lodash2.default.isEmpty(existingImg) && _react2.default.createElement('img', { src: existingImg + variance })
	        )
	      })
	    );
	  };
	
	  return ImageUploader;
	}(_react2.default.Component);
	
	exports.default = ImageUploader;

/***/ },

/***/ "pddx":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"imageuploader-wrapper":"imageuploader-wrapper","zone":"zone","overlay":"overlay","upload-overlay":"upload-overlay","has-no-image":"has-no-image","has-image":"has-image"};

/***/ },

/***/ "jlVy":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (!opts.file) {
	    throw new Error('props.file is missing');
	  }
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("pT56");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports['default'];

/***/ },

/***/ "pT56":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	var _confirm = __webpack_require__("yMGN");
	
	__webpack_require__("39Pr");
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _reactCropper = __webpack_require__("WfM1");
	
	var _reactCropper2 = _interopRequireDefault(_reactCropper);
	
	__webpack_require__("5Qkr");
	
	var _locale = __webpack_require__("3G44");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onCrop = _this.onCrop.bind(_this);
	    _this.generateData = _this.generateData.bind(_this);
	    return _this;
	  }
	
	  ModalBody.prototype.onCrop = function onCrop() {
	    this.dataUrl = this.cropper.getCroppedCanvas().toDataURL();
	  };
	
	  ModalBody.prototype.dataUrlToBlob = function dataUrlToBlob(dataURL) {
	    var binary = atob(dataURL.split(',')[1]);
	    var array = [];
	    for (var i = 0; i < binary.length; i++) {
	      array.push(binary.charCodeAt(i));
	    }
	    return new Blob([new Uint8Array(array)], {
	      type: 'image/png',
	      name: 'cropped',
	      lastModifiedDate: new Date()
	    });
	  };
	
	  ModalBody.prototype.generateData = function generateData() {
	    var file = this.dataUrlToBlob(this.dataUrl);
	    var urlCreator = window.URL || window.webkitURL;
	    var imageUrl = urlCreator.createObjectURL(file);
	    this.props.proceed({
	      dataUrl: this.dataUrl,
	      imageUrl: imageUrl,
	      file: file
	    });
	  };
	
	  ModalBody.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel,
	        file = _props.file,
	        _props$minCropBoxHeig = _props.minCropBoxHeight,
	        minCropBoxHeight = _props$minCropBoxHeig === undefined ? 100 : _props$minCropBoxHeig,
	        _props$minCropBoxWidt = _props.minCropBoxWidth,
	        minCropBoxWidth = _props$minCropBoxWidt === undefined ? 100 : _props$minCropBoxWidt,
	        _props$minCanvasWidth = _props.minCanvasWidth,
	        minCanvasWidth = _props$minCanvasWidth === undefined ? 400 : _props$minCanvasWidth,
	        _props$minCanvasHeigh = _props.minCanvasHeight,
	        minCanvasHeight = _props$minCanvasHeigh === undefined ? 400 : _props$minCanvasHeigh,
	        aspectRatioHeight = _props.aspectRatioHeight,
	        aspectRatioWidth = _props.aspectRatioWidth,
	        removeItem = _props.removeItem,
	        index = _props.index;
	
	
	    var aspectRatio = void 0;
	
	    if (aspectRatioWidth && aspectRatioHeight) {
	      aspectRatio = aspectRatioWidth / aspectRatioHeight;
	    }
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        isShowingModal: show // if you want to show it when component mounts, set it true
	
	        // allowCloseByClickingShadow={false}
	        // useDefaultClosebutton={true}
	        , onCloseModalClick: dismiss
	        // fixedHeight={300}
	        , fixedWidth: 700
	        // overlayColor="#000"
	        // contentHeight={500}
	
	        , hasHeader: false,
	
	        hasFooter: true,
	        footerType: 'bold' // grey, transparent, bold
	        , footerButtons: [{
	          title: __('Cancel', _locale2.default),
	          className: "btn btn-default pull-right",
	          onClick: function onClick() {
	            (0, _confirm.confirm)(__('Proceed to cancel uploading image?', _locale2.default)).then(function () {
	              cancel();
	              removeItem(index);
	            }).catch(function () {});
	          }
	        }, {
	          title: __('Upload', _locale2.default),
	          className: "btn btn-primary pull-right",
	          onClick: this.generateData
	        }]
	        // footerClassName=""
	        // footerCustomContent={}
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'image-cropper' },
	        _react2.default.createElement(_reactCropper2.default, {
	          minCropBoxWidth: minCropBoxWidth,
	          minCropBoxHeight: minCropBoxHeight,
	          minCanvasWidth: minCanvasWidth,
	          minCanvasHeight: minCanvasHeight,
	          src: file.preview,
	          style: { height: 400, width: 400 }
	          // Cropper.js options
	          , aspectRatio: aspectRatio,
	          guides: true,
	          zoomable: false,
	          crop: this.onCrop,
	          preview: '#cropper-preview',
	          ref: function ref(c) {
	            _this2.cropper = c;
	          }
	        }),
	        _react2.default.createElement('div', { id: 'cropper-preview', style: { width: 150, height: 150 } })
	      )
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "yMGN":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.confirm = confirm;
	
	var _Confirm = __webpack_require__("p4PG");
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultConfirmation = (0, _reactConfirm.createConfirmation)(_Confirm2.default);
	
	function confirm(confirmation, title) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  return defaultConfirmation(_extends({ confirmation: confirmation, title: title }, options));
	}
	exports.default = confirm;

/***/ },

/***/ "p4PG":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("yjsJ");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Confirmation = function (_React$Component) {
		_inherits(Confirmation, _React$Component);
	
		function Confirmation() {
			_classCallCheck(this, Confirmation);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		Confirmation.prototype.render = function render() {
			var _props = this.props,
			    okButtonTitle = _props.okButtonTitle,
			    cancelButtonTitle = _props.cancelButtonTitle,
			    title = _props.title,
			    confirmation = _props.confirmation,
			    show = _props.show,
			    proceed = _props.proceed,
			    dismiss = _props.dismiss,
			    cancel = _props.cancel,
			    _props$enableEscape = _props.enableEscape,
			    enableEscape = _props$enableEscape === undefined ? true : _props$enableEscape;
	
	
			return _react2.default.createElement(
				_Modal2.default,
				{
					isShowingModal: show // if you want to show it when component mounts, set it true
					, className: (0, _classnames2.default)("confirm-modal"),
					fixedWidth: 400,
					allowCloseByClickingShadow: true,
					useDefaultCloseButton: false
	
					// contentHeight={300}
	
					, hasHeader: true,
					headerType: 'bold' // default, bold
					, headerTitle: title,
	
					hasFooter: true,
					footerType: 'bold' // grey, transparent, bold
					, footerButtons: [{
						title: okButtonTitle || __("Confirm", "UI.confirm"),
						className: "btn btn-primary pull-right",
						onClick: proceed
					}, {
						title: cancelButtonTitle || __("Cancel", "UI.confirm"),
						className: "btn btn-default pull-right",
						onClick: cancel
					}]
				},
				_react2.default.createElement(
					'div',
					{ className: 'alert-content' },
					_react2.default.createElement(
						'div',
						{ className: 'alert-text' },
						confirmation
					)
				)
			);
		};
	
		return Confirmation;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(Confirmation);
	module.exports = exports['default'];

/***/ },

/***/ "yjsJ":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"confirm-modal":"confirm-modal","header":"header"};

/***/ },

/***/ "39Pr":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"image-cropper":"image-cropper","cropper-preview":"cropper-preview"};

/***/ },

/***/ "3G44":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'ImageCropper',
	  code: 'CN',
	  text: {
	    'Proceed to cancel uploading image?': '确认取消上传图片？',
	    'Cancel': '取消',
	    'Upload': '上传'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "ZmcG":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _default(schoolId, file, _onUploadProgress) {
	  var API_URL = void 0;
	  if (false) {
	    API_URL = 'https://saas.classtop.com:3001/sapi';
	  } else {
	    API_URL = 'https://school.classtop.com:3001/sapi';
	  }
	
	  if (!schoolId) {
	    throw 'Missing school ID';
	  }
	
	  if (!file) {
	    throw 'Missing blob';
	  }
	
	  return new Promise(function (resolve, reject) {
	    var data = new FormData();
	    data.append('logo', file, 'cropped');
	    _axios2.default.put(API_URL + '/u_school_logo/' + schoolId + '/', data, {
	      'onUploadProgress': function onUploadProgress(progress) {
	        if (typeof _onUploadProgress == 'function') {
	          progress.ratio = progress.loaded / progress.total;
	          _onUploadProgress(progress);
	        }
	      },
	      headers: {
	        'Authorization': 'JWT ' + localStorage.getItem('token'),
	        'Content-Type': 'multipart/form-data'
	      }
	    }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {});
	  });
	} // We're using direct HTTP calls here, skipping Proxy
	exports.default = _default;
	module.exports = exports['default'];

/***/ },

/***/ "R/EM":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("VD1M");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <CountBadge />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var CountBadge = function (_React$Component) {
	  _inherits(CountBadge, _React$Component);
	
	  function CountBadge(props) {
	    _classCallCheck(this, CountBadge);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  CountBadge.prototype.render = function render() {
	    return _react2.default.createElement(
	      'span',
	      { className: 'badge count-badge' },
	      this.props.children
	    );
	  };
	
	  return CountBadge;
	}(_react2.default.Component);
	
	exports.default = CountBadge;
	module.exports = exports['default'];

/***/ },

/***/ "VD1M":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"count-badge":"count-badge"};

/***/ },

/***/ "FoBU":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "1drC":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Table = __webpack_require__("hD9Y");
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		Table: _Table2.default
	};
	module.exports = exports["default"];

/***/ },

/***/ "hD9Y":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	exports.paginationSchema = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _forOwn = __webpack_require__("AVgl");
	
	var _forOwn2 = _interopRequireDefault(_forOwn);
	
	var _TableSetting = __webpack_require__("NCde");
	
	var _TableSetting2 = _interopRequireDefault(_TableSetting);
	
	__webpack_require__("dCnJ");
	
	var _reactJsPagination = __webpack_require__("bgMy");
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is a table
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IMPORTANT:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * When there is a "nesting" tr, we use tbody as row, instead of tr
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * and data structure will be different when we use tbody as row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This might sound a little confusing, but here is the explanation.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * When tr is a row, we use "traditional" structure, where data looks like this:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * [ {}, {}, {}, {} ]
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * where {} reprensents an individual item, within an array.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * BUT when this.props.useTbodyAsRow == true, we expect data to be in format of:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 		[ [ {}, {} ], [ {}, {} ], [ {}, {} ] ]
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * where each [] represents tbodies and {} within it represents trs.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WHY WE ARE DOING THIS:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Sometimes we need nested rows (rows within rows) and this is
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the best way to represent that structure. The best example would be
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the table in Student page.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var USE_PAGINATION = true;
	var PAGE_RANGE_DISPLAYED = 5;
	var MULTI_SELECTION_WIDTH = 12;
	
	var paginationSchema = exports.paginationSchema = _joiBrowser2.default.object().keys({
	  activePage: _joiBrowser2.default.number().integer().required(),
	  totalItemsCount: _joiBrowser2.default.number().integer().required(),
	  itemsCountPerPage: _joiBrowser2.default.number().integer().required(),
	  showItemCount: _joiBrowser2.default.boolean().allow(null)
	});
	
	var TableEmptyMessage = function TableEmptyMessage(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'table-not-found' },
	    _react2.default.createElement(
	      'div',
	      { className: 'no-result-text' },
	      __('No Result', 'Table')
	    )
	  );
	};
	
	var Table = function (_React$Component) {
	  _inherits(Table, _React$Component);
	
	  function Table(props) {
	    _classCallCheck(this, Table);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.elemRefsForStickyThead = {};
	
	    _this.collectRefs = _this.collectRefs.bind(_this);
	    _this.renderUtilSection = _this.renderUtilSection.bind(_this);
	    _this._toggleCheckboxTd = _this._toggleCheckboxTd.bind(_this);
	    _this._toggleStickyTableHeader = _this._toggleStickyTableHeader.bind(_this);
	
	    _this.selectAll = _this.selectAll.bind(_this);
	    _this.getNonDisabledTrData = _this.getNonDisabledTrData.bind(_this);
	    _this.ifAllSelected = _this.ifAllSelected.bind(_this);
	
	    _this.state = {
	      stickyTableHeader: false,
	      selected: {},
	      tableData: []
	    };
	
	    return _this;
	  }
	
	  Table.prototype.componentDidMount = function componentDidMount() {
	    var mainSectionDomElem = global['--classtop-main-section'];
	
	    if (mainSectionDomElem) {
	      mainSectionDomElem.addEventListener('scroll', this._toggleStickyTableHeader);
	    }
	
	    this.setOffsetTdHeight();
	  };
	
	  Table.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.pagination) {
	      var validateResult = _joiBrowser2.default.validate(nextProps.pagination, paginationSchema);
	
	      if (validateResult.error) {
	        throw validateResult.error;
	      }
	    }
	
	    if (nextProps.selected) {
	      this.setState({
	        selected: nextProps.selected
	      });
	    }
	  };
	
	  //
	  // We're collecting refs to do "sticky thead effect." position: sticky is not very stable
	  // and is not receommended for production. These collected refs will be used in
	  // this._toggleStickyTableHeader()
	  //
	
	
	  Table.prototype.collectRefs = function collectRefs(refName) {
	    var _this2 = this;
	
	    return function (ref) {
	      if (ref) {
	        if (refName == 'th') {
	          _this2.thElems.push(ref);
	        } else {
	          _this2.elemRefsForStickyThead[refName] = ref;
	        }
	      }
	    };
	  };
	
	  Table.prototype.setOffsetTdHeight = function setOffsetTdHeight() {
	    var _elemRefsForStickyThe = this.elemRefsForStickyThead,
	        thead = _elemRefsForStickyThe.thead,
	        offsetTd = _elemRefsForStickyThe.offsetTd;
	
	
	    if (!thead || !offsetTd) {
	      return;
	    }
	
	    var _thead$getBoundingCli = thead.getBoundingClientRect(),
	        height = _thead$getBoundingCli.height;
	
	    offsetTd.style.height = height + 'px';
	    offsetTd.style.width = '1px';
	  };
	
	  Table.prototype._toggleStickyTableHeader = function _toggleStickyTableHeader() {
	
	    return; // disable the floating <thead> for now
	
	    var mainSectionDom = global['--classtop-main-section'];
	
	    var _elemRefsForStickyThe2 = this.elemRefsForStickyThead,
	        table = _elemRefsForStickyThe2.table,
	        thead = _elemRefsForStickyThe2.thead,
	        offsetTd = _elemRefsForStickyThe2.offsetTd;
	
	
	    var offsetTop = table.offsetTop;
	
	    if (!offsetTop) {
	      return;
	    }
	
	    if (!this.state.stickyTableHeader) {
	      if (mainSectionDom.scrollTop >= offsetTop) {
	        this.thElems.map(function (th) {
	          var _th$getBoundingClient = th.getBoundingClientRect(),
	              width = _th$getBoundingClient.width;
	
	          th.style.width = width + 'px';
	        });
	
	        var _mainSectionDom$getBo = mainSectionDom.getBoundingClientRect(),
	            y = _mainSectionDom$getBo.y;
	
	        thead.style.top = y + 'px';
	
	        this.setState({
	          stickyTableHeader: true
	        });
	      }
	    } else {
	      var _thead$getBoundingCli2 = thead.getBoundingClientRect(),
	          height = _thead$getBoundingCli2.height;
	
	      if (mainSectionDom.scrollTop < offsetTop - height) {
	
	        this.setState({
	          stickyTableHeader: false
	        });
	      }
	    }
	  };
	
	  Table.prototype.render = function render() {
	    var _props = this.props,
	        fetching = _props.fetching,
	        id = _props.id,
	        _props$data = _props.data,
	        data = _props$data === undefined ? [] : _props$data,
	        className = _props.className,
	        useTbodyAsRow = _props.useTbodyAsRow,
	        useMultiSelection = _props.useMultiSelection,
	        settings = _props.settings,
	        settingThTitle = _props.settingThTitle,
	        _props$usePagination = _props.usePagination,
	        usePagination = _props$usePagination === undefined ? USE_PAGINATION : _props$usePagination,
	        pagination = _props.pagination,
	        topUtilSection = _props.topUtilSection,
	        bottomUtilSection = _props.bottomUtilSection,
	        _props$selectAllInUti = _props.selectAllInUtilSection,
	        selectAllInUtilSection = _props$selectAllInUti === undefined ? true : _props$selectAllInUti,
	        _props$hasTopUtilSect = _props.hasTopUtilSection,
	        hasTopUtilSection = _props$hasTopUtilSect === undefined ? false : _props$hasTopUtilSect;
	    var stickyTableHeader = this.state.stickyTableHeader;
	
	
	    var tableClassNames = {
	      "tr-is-row": !useTbodyAsRow,
	      "tbody-is-row": useTbodyAsRow
	    };
	
	    if (usePagination && !pagination) {
	      throw new Error('usePagination is true. However props.pagination{} is null.');
	    }
	
	    // to collect refs for <th>
	    this.thElems = [];
	
	    var displayTableEmptyMessage = data.length === 0;
	
	    var classname = (0, _classnames2.default)('classtop-table-container', {
	      'sticky-table-header': stickyTableHeader,
	      'fetching': fetching,
	      'empty-table': displayTableEmptyMessage
	    });
	
	    // const hasTopUtilSection = typeof topUtilSection !== 'undefined';
	    var hasBottomUtilSection = typeof bottomUtilSection !== 'undefined';
	    var disableCheckbox = data.length === 0;
	
	    return _react2.default.createElement(
	      'div',
	      { className: classname, ref: this.collectRefs('table') },
	      _react2.default.createElement('div', { className: 'table-curtain' }),
	      fetching && _react2.default.createElement(_Loading2.default, { type: 'ring' }),
	      hasTopUtilSection && this.renderUtilSection('top', topUtilSection),
	      _react2.default.createElement(
	        'table',
	        {
	          id: id,
	          className: (0, _classnames2.default)("classtop-table", className, tableClassNames) },
	        _react2.default.createElement(
	          'thead',
	          { ref: this.collectRefs('thead'), className: (0, _classnames2.default)({ hasTopUtilSection: hasTopUtilSection }) },
	          _react2.default.createElement(
	            'tr',
	            null,
	            useMultiSelection && _react2.default.createElement(
	              'th',
	              { style: { width: MULTI_SELECTION_WIDTH }, ref: this.collectRefs('th') },
	              !selectAllInUtilSection && _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('toggle-all-checkbox', { disableCheckbox: disableCheckbox }), onClick: this.selectAll },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'control' },
	                  _react2.default.createElement('input', { type: 'checkbox', checked: this.ifAllSelected() }),
	                  _react2.default.createElement('span', { className: 'checkmark' })
	                )
	              )
	            ),
	            this._getTheads(),
	            settings && settings.length > 0 && _react2.default.createElement(
	              'th',
	              { ref: this.collectRefs('th') },
	              settingThTitle || "Settings"
	            )
	          )
	        ),
	        this._getTbodyRows()
	      ),
	      displayTableEmptyMessage && TableEmptyMessage(),
	      usePagination && this._renderPaginationToolbar()
	    );
	  };
	
	  Table.prototype.renderUtilSection = function renderUtilSection(type, sectionItem) {
	    var _props2 = this.props,
	        useMultiSelection = _props2.useMultiSelection,
	        _props2$data = _props2.data,
	        data = _props2$data === undefined ? [] : _props2$data,
	        _props2$selectAllInUt = _props2.selectAllInUtilSection,
	        selectAllInUtilSection = _props2$selectAllInUt === undefined ? true : _props2$selectAllInUt;
	
	
	    var disableCheckbox = data.length === 0;
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('util-section', type + '-util-section') },
	      useMultiSelection && selectAllInUtilSection && _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('toggle-all-checkbox', { disableCheckbox: disableCheckbox }), onClick: this.selectAll },
	        _react2.default.createElement(
	          'label',
	          { className: 'control' },
	          _react2.default.createElement('input', { type: 'checkbox', checked: this.ifAllSelected() }),
	          _react2.default.createElement('span', { className: 'checkmark' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('section-content', { useMultiSelection: useMultiSelection }) },
	        sectionItem
	      )
	    );
	  };
	
	  Table.prototype.getNonDisabledTrData = function getNonDisabledTrData() {
	    var _props3 = this.props,
	        getCheckboxDisabled = _props3.getCheckboxDisabled,
	        useTbodyAsRow = _props3.useTbodyAsRow,
	        _props3$data = _props3.data,
	        data = _props3$data === undefined ? [] : _props3$data;
	
	    var newSelected = {};
	    data.map(function (item, idx) {
	      var trData = void 0;
	      if (useTbodyAsRow) {
	        trData = item[0];
	      } else {
	        trData = item;
	      }
	
	      var checkboxDisabled = false;
	      if (typeof getCheckboxDisabled == 'function') {
	        checkboxDisabled = getCheckboxDisabled({
	          trData: trData,
	          trIndex: idx,
	          data: data
	        });
	      }
	
	      if (checkboxDisabled != true) {
	        newSelected[idx] = trData;
	      }
	    });
	
	    return newSelected;
	  };
	
	  Table.prototype.selectAll = function selectAll() {
	    var _this3 = this;
	
	    var _props4 = this.props,
	        getCheckboxDisabled = _props4.getCheckboxDisabled,
	        onTrSelectionToggled = _props4.onTrSelectionToggled,
	        useTbodyAsRow = _props4.useTbodyAsRow,
	        onTrSelect = _props4.onTrSelect;
	    var selected = this.state.selected;
	
	
	    var enabledTrData = this.getNonDisabledTrData();
	
	    if (Object.keys(selected).length === Object.keys(enabledTrData).length) {
	      this.setState({
	        selected: {}
	      }, function () {
	        if (typeof onTrSelectionToggled == "function") {
	          onTrSelectionToggled({ selected: [], toggleAll: true });
	        }
	
	        if (typeof onTrSelect === 'function') {
	          onTrSelect({ selected: [], toggleAll: true });
	        }
	      });
	
	      return;
	    }
	
	    this.setState({
	      selected: enabledTrData
	    }, function () {
	      var selectedArr = [];
	
	      (0, _forOwn2.default)(_this3.state.selected, function (tr) {
	        selectedArr.push(tr);
	      });
	
	      if (typeof onTrSelectionToggled == "function") {
	        onTrSelectionToggled({ selected: selectedArr, toggleAll: true });
	      }
	
	      if (typeof onTrSelect === 'function') {
	        onTrSelect({ selected: selectedArr, toggleAll: true });
	      }
	    });
	  };
	
	  Table.prototype.ifAllSelected = function ifAllSelected() {
	    var enabledTrData = this.getNonDisabledTrData();
	    var selected = this.state.selected;
	
	    var dataLength = Object.keys(enabledTrData).length;
	    return Object.keys(selected).length === dataLength && dataLength !== 0;
	  };
	
	  Table.prototype._renderPaginationToolbar = function _renderPaginationToolbar() {
	    var _props5 = this.props,
	        _props5$onPageChange = _props5.onPageChange,
	        onPageChange = _props5$onPageChange === undefined ? function () {
	      console.error('warning: props.onPageChange for <Table /> is not defined. A default behaviour is triggered which is this message.');
	    } : _props5$onPageChange,
	        _props5$onItemsCountP = _props5.onItemsCountPerPageChange,
	        onItemsCountPerPageChange = _props5$onItemsCountP === undefined ? function () {
	      console.error('warning: props.onItemsCountPerPageChange for <Table /> is not defined. A default behaviour is triggered which is this message.');
	    } : _props5$onItemsCountP;
	    var _props$pagination = this.props.pagination,
	        activePage = _props$pagination.activePage,
	        itemsCountPerPage = _props$pagination.itemsCountPerPage,
	        totalItemsCount = _props$pagination.totalItemsCount,
	        pageRangeDisplayed = _props$pagination.pageRangeDisplayed,
	        _props$pagination$sho = _props$pagination.showItemCount,
	        showItemCount = _props$pagination$sho === undefined ? true : _props$pagination$sho;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'table-toolbar' },
	      _react2.default.createElement(
	        'span',
	        null,
	        this._getPaginationInfoText(this.props.pagination)
	      ),
	      _react2.default.createElement(_reactJsPagination2.default, {
	        activePage: activePage,
	        itemsCountPerPage: itemsCountPerPage,
	        totalItemsCount: totalItemsCount,
	        pageRangeDisplayed: pageRangeDisplayed,
	        onChange: onPageChange
	      }),
	      showItemCount && _react2.default.createElement(
	        'select',
	        {
	          className: 'select-items-count-per-page form-control',
	          value: itemsCountPerPage,
	          onChange: function onChange(e) {
	            onItemsCountPerPageChange(parseInt(e.target.value));
	          } },
	        _react2.default.createElement(
	          'option',
	          { value: '5' },
	          '5'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '10' },
	          '10'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '25' },
	          '25'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '50' },
	          '50'
	        )
	      )
	    );
	  };
	
	  Table.prototype._getPaginationInfoText = function _getPaginationInfoText(pagination) {
	    var activePage = pagination.activePage,
	        totalItemsCount = pagination.totalItemsCount,
	        itemsCountPerPage = pagination.itemsCountPerPage;
	
	
	    var begin = (activePage - 1) * itemsCountPerPage + 1;
	    var end = activePage * itemsCountPerPage;
	
	    if (begin > totalItemsCount) {
	      begin = 1;
	    }
	
	    if (end > totalItemsCount) {
	      end = totalItemsCount;
	    }
	
	    if (totalItemsCount == 0) {
	      return '';
	    }
	
	    return __('Showing {begin} - {end} (total {total})', 'Table', {
	      begin: begin,
	      end: end,
	      total: totalItemsCount
	    });
	
	    //{activePage} / {Math.ceil(totalItemsCount / itemsCountPerPage)}
	  };
	
	  Table.prototype._getTheads = function _getTheads() {
	    var _this4 = this;
	
	    var fields = this.props.fields;
	
	
	    return fields.map(function (field, idx) {
	      return _react2.default.createElement(
	        'th',
	        { key: idx, ref: _this4.collectRefs('th') },
	        field.title
	      );
	    });
	  };
	
	  Table.prototype._getTbodyRows = function _getTbodyRows() {
	    var _this5 = this;
	
	    var _props6 = this.props,
	        data = _props6.data,
	        fields = _props6.fields,
	        getTbodyProps = _props6.getTbodyProps,
	        useTbodyAsRow = _props6.useTbodyAsRow,
	        tbodyFilter = _props6.tbodyFilter;
	
	    // Why are we doing this?
	    // Now when useTbodyAsRow != true, which is the most case,
	    // we expect data to come simply in a [ {},{}... ] form.
	    // Since by default, we iterate an array of tbodies
	    // and then trs within each tbody. We will treat that data as a
	    // single tbody. So we turn it into:
	    // 		[ [ {}, {}... ] ]
	
	    var tableData = useTbodyAsRow != true ? [data] : data;
	
	    return tableData.map(function (tbodyData, idx) {
	      var tbodyProps = {};
	      if (typeof getTbodyProps == "function") {
	        tbodyProps = getTbodyProps({
	          tbodyData: tbodyData,
	          index: idx,
	          data: data,
	          fields: fields
	        });
	      }
	
	      if (typeof tbodyFilter === 'function' && !tbodyFilter(_extends({}, _this5.props, { tbodyData: tbodyData, tbodyIndex: tbodyIndex }))) {
	        return;
	      }
	
	      return _react2.default.createElement(
	        'tbody',
	        _extends({ key: idx }, tbodyProps),
	        _this5._getTr(tbodyData, idx)
	      );
	    });
	  };
	
	  Table.prototype._getTr = function _getTr(tbodyData, tbodyIndex) {
	    var _this6 = this;
	
	    var _props7 = this.props,
	        oneSettingPerRow = _props7.oneSettingPerRow,
	        useMultiSelection = _props7.useMultiSelection,
	        settings = _props7.settings,
	        trFilter = _props7.trFilter,
	        getTrProps = _props7.getTrProps;
	
	
	    return (tbodyData || []).map(function (trData, idx) {
	      var settingTd = void 0;
	      if (Array.isArray(settings) && settings.length > 0) {
	        if (oneSettingPerRow && idx > 0) {
	          settingTd = _react2.default.createElement('td', null);
	        } else {
	          settingTd = _react2.default.createElement(_TableSetting2.default, _extends({}, _this6.props, { trData: trData, trIndex: idx, tbodyIndex: tbodyIndex }));
	        }
	      }
	
	      if (typeof trFilter === 'function' && !trFilter(_extends({}, _this6.props, { trData: trData, trIndex: idx, tbodyData: tbodyData, tbodyIndex: tbodyIndex }))) {
	        return;
	      }
	
	      var trProps = {};
	      if (typeof getTrProps === 'function') {
	        trProps = getTrProps({
	          trData: trData,
	          trIdx: idx,
	          tbodyIndex: tbodyIndex,
	          tbodyData: tbodyData
	        });
	      }
	
	      return _react2.default.createElement(
	        'tr',
	        _extends({ key: idx }, trProps),
	        useMultiSelection && _this6._getCheckboxTd(idx, trData, tbodyIndex),
	        _this6._getTd(trData, idx, tbodyData),
	        settingTd
	      );
	    });
	  };
	
	  Table.prototype._getCheckboxTd = function _getCheckboxTd(trIdx, trData, tbodyIndex) {
	    var _this7 = this;
	
	    var _props8 = this.props,
	        useTbodyAsRow = _props8.useTbodyAsRow,
	        _props8$data = _props8.data,
	        data = _props8$data === undefined ? [] : _props8$data,
	        getCheckboxProps = _props8.getCheckboxProps,
	        getCheckboxTdProps = _props8.getCheckboxTdProps,
	        getCheckboxDisabled = _props8.getCheckboxDisabled;
	
	
	    var params = {
	      trIdx: trIdx, trData: trData, tbodyIndex: tbodyIndex, data: data
	    };
	
	    var checkboxProps = {};
	    if (typeof getCheckboxProps === 'function') {
	      checkboxProps = getCheckboxProps(params);
	    }
	
	    var checkboxDisabled = false;
	    if (typeof getCheckboxDisabled === 'function') {
	      checkboxDisabled = getCheckboxDisabled(params);
	    }
	
	    var tdProps = {};
	    if (typeof getCheckboxTdProps === 'function') {
	      tdProps = getCheckboxTdProps(params);
	    }
	
	    if (tdProps.style) {
	      tdProps.style = _extends({ width: MULTI_SELECTION_WIDTH }, tdProps.style);
	    } else {
	      tdProps.style = { width: MULTI_SELECTION_WIDTH };
	    }
	
	    if (checkboxDisabled == true) {
	      tdProps = _extends({ disabled: true }, tdProps);
	    }
	
	    // if we use tbodyAsRow we just need the checkbox in the first tr
	    return _react2.default.createElement(
	      'td',
	      _extends({ className: 'checkbox-td' }, tdProps),
	      (trIdx == 0 && useTbodyAsRow == true || useTbodyAsRow != true) && _react2.default.createElement(
	        'div',
	        { className: 'checkbox-container', onClick: function onClick(e) {
	            if (checkboxDisabled != true) {
	              _this7._toggleCheckboxTd(trData, trIdx, tbodyIndex);
	            }
	          } },
	        _react2.default.createElement(
	          'label',
	          { className: 'control' },
	          _react2.default.createElement('input', _extends({ type: 'checkbox', checked: this.ifChecked(trIdx, tbodyIndex) }, checkboxProps)),
	          _react2.default.createElement('span', { className: 'checkmark' })
	        )
	      )
	    );
	  };
	
	  Table.prototype.ifChecked = function ifChecked(trIdx, tbodyIndex) {
	    var useTbodyAsRow = this.props.useTbodyAsRow;
	
	    var idx = useTbodyAsRow ? tbodyIndex : trIdx;
	    return typeof this.state.selected[idx] !== "undefined";
	  };
	
	  Table.prototype._toggleCheckboxTd = function _toggleCheckboxTd(trData, trIdx, tbodyIndex) {
	    var _this8 = this;
	
	    var _props9 = this.props,
	        onTrSelectionToggled = _props9.onTrSelectionToggled,
	        onTrSelect = _props9.onTrSelect,
	        useTbodyAsRow = _props9.useTbodyAsRow;
	    var selected = this.state.selected;
	
	    // if we use tbodyIndex as a index
	
	    var idx = useTbodyAsRow ? tbodyIndex : trIdx;
	
	    var checked = false;
	
	    if (typeof selected[idx] === 'undefined') {
	      checked = true;
	      selected[idx] = trData;
	    } else {
	      delete selected[idx];
	    }
	
	    this.setState({
	      selected: selected
	    }, function () {
	
	      var selectedArr = [];
	
	      (0, _forOwn2.default)(_this8.state.selected, function (tr) {
	        selectedArr.push(tr);
	      });
	
	      var params = {
	        checked: checked,
	        action: checked ? "checked" : "unchecked",
	        selected: selectedArr,
	        trIndex: idx,
	        trData: trData
	      };
	
	      if (typeof onTrSelectionToggled == "function") {
	        onTrSelectionToggled(params);
	      }
	
	      if (typeof onTrSelect == "function") {
	        onTrSelect(params);
	      }
	    });
	  };
	
	  Table.prototype._getTd = function _getTd(trData, trIndex, tbodyData) {
	    var _props10 = this.props,
	        fields = _props10.fields,
	        data = _props10.data;
	
	
	    return fields.map(function (field, tdIndex) {
	      var tdData = trData[field.name];
	
	      var params = {
	        tdData: tdData,
	        trData: trData,
	        tbodyData: tbodyData,
	        data: data,
	        field: field,
	        trIndex: trIndex,
	        tdIndex: tdIndex,
	        fields: fields
	      };
	
	      var tdProps = {};
	
	      if (typeof field.getTdProps == "function") {
	        tdProps = field.getTdProps(params);
	      };
	
	      params.tdProps = tdProps;
	
	      if (typeof field.toggleTd == "function" && field.toggleTd(params) == false) {
	        return;
	      }
	
	      if (typeof field.getTdContent == "function") {
	        return _react2.default.createElement(
	          'td',
	          _extends({ key: tdIndex }, tdProps),
	          field.getTdContent(params)
	        );
	      } else {
	        if (tdData === null || tdData === undefined) {
	          tdData = '';
	        }
	
	        if ((typeof tdData === 'undefined' ? 'undefined' : _typeof(tdData)) === 'object' || Array.isArray(tdData)) {
	          throw new Error('tdData cannot be an object or an array.');
	        }
	        return _react2.default.createElement(
	          'td',
	          _extends({ key: tdIndex }, tdProps),
	          tdData
	        );
	      }
	    });
	  };
	
	  return Table;
	}(_react2.default.Component);
	
	exports.default = Table;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "NCde":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__("3kvR");
	
	var _DropdownButton = __webpack_require__("Upq0");
	
	var _DropdownButton2 = _interopRequireDefault(_DropdownButton);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _cloneDeep = __webpack_require__("kvU2");
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <TableSetting
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is the setting cell where we nest controlling functions
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               		{ title: "加入班级", onClick: (opts)=>{ console.log(opts); }, isShow: ()=> {} },
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               		{ title: "签到", onClick: (opts)=>{ console.log(opts); } },
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               		{ title: "更多", id: "table1-modify", onClick: (opts)=>{ console.log(opts); }, dropdown: [
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               			{ title: "修改", onClick: (opts)=>{ console.log(opts); } },
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               			{ title: "归档", onClick: (opts)=>{ console.log(opts); } },
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               		] },
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Table
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var TableSetting = function (_React$Component) {
			_inherits(TableSetting, _React$Component);
	
			function TableSetting(props) {
					_classCallCheck(this, TableSetting);
	
					var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
					_this._handleCtrlOnClick = _this._handleCtrlOnClick.bind(_this);
					return _this;
			}
	
			TableSetting.prototype.render = function render() {
					var _this2 = this;
	
					var _props = this.props,
					    settings = _props.settings,
					    settingsModifier = _props.settingsModifier,
					    data = _props.data,
					    fields = _props.fields,
					    settingWidth = _props.settingWidth,
					    trData = _props.trData,
					    trIndex = _props.trIndex,
					    tbodyIndex = _props.tbodyIndex,
					    dropdownGuideWidth = _props.dropdownGuideWidth,
					    dropdownGuideHeight = _props.dropdownGuideHeight;
	
					// NOTE: make sure these settings are still
	
					var thisSettings = void 0;
					if (typeof settingsModifier == 'function') {
							thisSettings = (0, _cloneDeep2.default)(settings);
							thisSettings = settingsModifier(thisSettings, this.props);
					} else {
							thisSettings = settings;
					}
	
					return _react2.default.createElement(
							'td',
							{ className: 'table-setting', style: { width: settingWidth } },
							thisSettings.map(function (ctrl, idx) {
									var opts = {
											ctrl: ctrl,
											trData: trData,
											trIndex: trIndex,
											data: data,
											fields: fields,
											tbodyIndex: tbodyIndex
									};
	
									var disabled = false;
									if (typeof ctrl.isDisabled == "function" && ctrl.isDisabled(opts)) {
											disabled = true;
									}
	
									var hasAlert = void 0;
									if (typeof ctrl.hasAlert == 'function') {
											hasAlert = ctrl.hasAlert(opts);
									} else {
											hasAlert = ctrl.hasAlert;
									}
	
									if (Array.isArray(ctrl.dropdown)) {
											var _React$createElement;
	
											if (!ctrl.id) {
													throw new Error("Error: Missing id in dropdown button while creating settings for a table. Please add a dropdown id");
											}
											return _react2.default.createElement(
													'span',
													{ key: idx },
													_react2.default.createElement(
															_DropdownButton2.default,
															(_React$createElement = { dropdownGuideWidth: dropdownGuideWidth, dropdownGuideHeight: dropdownGuideHeight, disabled: disabled, id: ctrl.id, bsStyle: 'link', title: _this2._getDropdownTitle(ctrl, opts) }, _React$createElement['id'] = ctrl.id, _React$createElement.noCaret = true, _React$createElement),
															_this2._getDropdownMenuItems(opts)
													),
													hasAlert == true && _react2.default.createElement('div', { className: 'table-settings-btn-alert' })
											);
									} else {
	
											var ctrlTitle = void 0;
	
											if (typeof ctrl.title === 'function') {
													ctrlTitle = ctrl.title(opts);
											} else {
													ctrlTitle = ctrl.title;
											}
	
											return _react2.default.createElement(
													'span',
													null,
													_react2.default.createElement(
															'button',
															{ className: 'btn-link', disabled: disabled, onClick: function onClick(event) {
																			var params = { ctrl: ctrl, trData: trData, trIndex: trIndex, data: data, fields: fields, tbodyIndex: tbodyIndex };
																			_this2._handleCtrlOnClick(ctrl, params, event);
																	} },
															ctrlTitle
													),
													hasAlert == true && _react2.default.createElement('div', { className: 'table-settings-btn-alert' })
											);
									}
							})
					);
			};
	
			TableSetting.prototype._handleCtrlOnClick = function _handleCtrlOnClick(ctrl, params, event) {
	
					var fnName = ctrl.onClickFunctionName;
					var settingFunctions = this.props.settingFunctions;
	
					if (typeof ctrl.onClick == "function") {
							ctrl.onClick(params, event);
					}
	
					if (settingFunctions && typeof fnName == "string" && typeof settingFunctions[fnName] == "function") {
							settingFunctions[fnName](params, event);
					}
			};
	
			TableSetting.prototype._getDropdownTitle = function _getDropdownTitle(ctrl, opts) {
					var _props2 = this.props,
					    hideDropdownCaret = _props2.hideDropdownCaret,
					    _props2$dropdownCaret = _props2.dropdownCaretIcon,
					    dropdownCaretIcon = _props2$dropdownCaret === undefined ? "fa icon-angle-down" : _props2$dropdownCaret;
	
	
					var ctrlTitle = void 0;
	
					if (typeof ctrl.title === 'function') {
							ctrlTitle = ctrl.title(opts);
					} else {
							ctrlTitle = ctrl.title;
					}
	
					return _react2.default.createElement(
							'span',
							null,
							ctrlTitle,
							hideDropdownCaret !== true && _react2.default.createElement('i', { className: (0, _classnames2.default)(dropdownCaretIcon, "dropdown-caret") })
					);
			};
	
			TableSetting.prototype._getDropdownMenuItems = function _getDropdownMenuItems(opts) {
					var _this3 = this;
	
					var parentCtrl = opts.ctrl,
					    trData = opts.trData,
					    trIndex = opts.trIndex,
					    data = opts.data,
					    fields = opts.fields,
					    tbodyIndex = opts.tbodyIndex;
	
	
					return parentCtrl.dropdown.map(function (ctrl, childIdx) {
	
							var disabled = void 0;
							if (typeof ctrl.isDisabled == 'function') {
									disabled = ctrl.isDisabled(opts);
							}
	
							return _react2.default.createElement(
									_reactBootstrap.MenuItem,
									{
											eventKey: childIdx,
											key: childIdx,
											disabled: disabled,
											onClick: function onClick(event) {
													if (!disabled) {
															var params = { ctrl: ctrl, parentCtrl: parentCtrl, trData: trData, trIndex: trIndex, data: data, fields: fields, tbodyIndex: tbodyIndex };
															_this3._handleCtrlOnClick(ctrl, params, event);
													}
											} },
									ctrl.title
							);
					});
			};
	
			return TableSetting;
	}(_react2.default.Component);
	
	exports.default = TableSetting;
	module.exports = exports['default'];

/***/ },

/***/ "dCnJ":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"classtop-table-container":"classtop-table-container","checkbox-container":"checkbox-container","table-curtain":"table-curtain","fetching":"fetching","table-not-found":"table-not-found","table-toolbar":"table-toolbar","pagination":"pagination","select-items-count-per-page":"select-items-count-per-page","util-section":"util-section","toggle-all-checkbox":"toggle-all-checkbox","checkmark":"checkmark","disableCheckbox":"disableCheckbox","section-content":"section-content","useMultiSelection":"useMultiSelection","sticky-table-header":"sticky-table-header","sticky-thead-offset-tbody":"sticky-thead-offset-tbody","no-result-text":"no-result-text","empty-table":"empty-table","classtop-table":"classtop-table","scan-table":"scan-table","hasTopUtilSection":"hasTopUtilSection","control":"control","checkbox-td":"checkbox-td","tbody-is-row":"tbody-is-row","tr-is-row":"tr-is-row","table-setting":"table-setting","dropdown":"dropdown","dropdown-caret":"dropdown-caret","table-settings-btn-alert":"table-settings-btn-alert","teacher-table":"teacher-table","student-dropdown":"student-dropdown","registration-table-container":"registration-table-container"};

/***/ },

/***/ "vVJg":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"alert-modal":"alert-modal","footer":"footer","button-wrapper":"button-wrapper","header":"header","header-type-bold":"header-type-bold","header-icon":"header-icon","header-title":"header-title","close-button":"close-button","classtop-modal-content":"classtop-modal-content","alert-content":"alert-content","classtop-alert-warning":"classtop-alert-warning","classtop-alert-success":"classtop-alert-success","classtop-alert-fail":"classtop-alert-fail","classtop-alert-error":"classtop-alert-error","alert-icon":"alert-icon","alert-text":"alert-text","icon-ok":"icon-ok","fa":"fa"};

/***/ },

/***/ "g4RF":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Content":"Content","MainContainer":"MainContainer","app":"app","PrintControl":"PrintControl","printMe":"printMe","dontPrintMe":"dontPrintMe","landscape":"landscape","avoid-break":"avoid-break","rule":"rule","octicon":"octicon","Box":"Box","Box--condensed":"Box--condensed","Box-header":"Box-header","Box-body":"Box-body","Box-footer":"Box-footer","Box-btn-octicon":"Box-btn-octicon","btn-octicon":"btn-octicon","Box-row":"Box-row","Box--spacious":"Box--spacious","Box-title":"Box-title","Box-row--unread":"Box-row--unread","unread":"unread","navigation-focus":"navigation-focus","Box-row--drag-button":"Box-row--drag-button","is-dragging":"is-dragging","sortable-chosen":"sortable-chosen","sortable-ghost":"sortable-ghost","Box-row--drag-hide":"Box-row--drag-hide","Box-row--focus-gray":"Box-row--focus-gray","Box-row--focus-blue":"Box-row--focus-blue","Box-row--hover-gray":"Box-row--hover-gray","Box-row--hover-blue":"Box-row--hover-blue","Box-row-link":"Box-row-link","Box--scrollable":"Box--scrollable","Box--blue":"Box--blue","Box--danger":"Box--danger","Box-header--blue":"Box-header--blue","Box-row--yellow":"Box-row--yellow","Box-row--blue":"Box-row--blue","Box-row--gray":"Box-row--gray","breadcrumb-item":"breadcrumb-item","breadcrumb-item-selected":"breadcrumb-item-selected","btn":"btn","Counter":"Counter","disabled":"disabled","disbaled":"disbaled","selected":"selected","btn-primary":"btn-primary","btn-green":"btn-green","btn-danger":"btn-danger","btn-outline":"btn-outline","btn-sm":"btn-sm","btn-large":"btn-large","hidden-text-expander":"hidden-text-expander","inline":"inline","ellipsis-expander":"ellipsis-expander","btn-block":"btn-block","btn-link":"btn-link","danger":"danger","details-reset":"details-reset","btn-default":"btn-default","fa":"fa","disable":"disable","BtnGroup":"BtnGroup","BtnGroup-item":"BtnGroup-item","BtnGroup-form":"BtnGroup-form","form-control":"form-control","form-select":"form-select","focus":"focus","input-contrast":"input-contrast","input-sm":"input-sm","input-lg":"input-lg","input-block":"input-block","input-monospace":"input-monospace","input-hide-webkit-autofill":"input-hide-webkit-autofill","form-checkbox":"form-checkbox","highlight":"highlight","note":"note","form-checkbox-details":"form-checkbox-details","form-checkbox-details-trigger":"form-checkbox-details-trigger","hfields":"hfields","form-group":"form-group","form-actions":"form-actions","form-warning":"form-warning","Form":"Form","control":"control","classtop-table-container":"classtop-table-container","tags-field-content":"tags-field-content","gender-radio":"gender-radio","select-list":"select-list","RegisterSection":"RegisterSection","attendance-modal":"attendance-modal","payment-modal":"payment-modal","footer-section":"footer-section","classtop-custom-modal":"classtop-custom-modal","checkmark":"checkmark","radiomark":"radiomark","PermissionList":"PermissionList","select-sm":"select-sm","shorter":"shorter","short":"short","long":"long","flattened":"flattened","is-error":"is-error","is-success":"is-success","required":"required","success":"success","error":"error","indicator":"indicator","loading":"loading","spinner":"spinner","successful":"successful","warn":"warn","warning":"warning","errored":"errored","is-autocheck-loading":"is-autocheck-loading","is-autocheck-successful":"is-autocheck-successful","is-autocheck-errored":"is-autocheck-errored","status-indicator":"status-indicator","status-indicator-success":"status-indicator-success","octicon-check":"octicon-check","octicon-x":"octicon-x","status-indicator-failed":"status-indicator-failed","status-indicator-loading":"status-indicator-loading","inline-form":"inline-form","btn-plain":"btn-plain","drag-and-drop":"drag-and-drop","default":"default","is-default":"is-default","is-uploading":"is-uploading","is-bad-file":"is-bad-file","bad-file":"bad-file","is-duplicate-filename":"is-duplicate-filename","duplicate-filename":"duplicate-filename","is-too-big":"is-too-big","too-big":"too-big","is-hidden-file":"is-hidden-file","hidden-file":"hidden-file","is-empty":"is-empty","empty":"empty","is-bad-permissions":"is-bad-permissions","bad-permissions":"bad-permissions","is-repository-required":"is-repository-required","repository-required":"repository-required","drag-and-drop-error-info":"drag-and-drop-error-info","is-failed":"is-failed","failed-request":"failed-request","manual-file-chooser":"manual-file-chooser","manual-file-chooser-text":"manual-file-chooser-text","upload-enabled":"upload-enabled","focused":"focused","dragover":"dragover","write-content":"write-content","previewable-comment-form":"previewable-comment-form","tabnav":"tabnav","comment":"comment","comment-form-error":"comment-form-error","preview-content":"preview-content","write-selected":"write-selected","preview-selected":"preview-selected","form-action-spacious":"form-action-spacious","composer":"composer","comment-form-textarea":"comment-form-textarea","account":"account","explain":"explain","minibutton":"minibutton","input-group":"input-group","input-group-button":"input-group-button","menu":"menu","menu-item":"menu-item","menu-warning":"menu-warning","avatar":"avatar","alert":"alert","menu-heading":"menu-heading","SideMenu":"SideMenu","subMenus":"subMenus","UnderlineNav":"UnderlineNav","UnderlineNav-body":"UnderlineNav-body","UnderlineNav-item":"UnderlineNav-item","UnderlineNav-actions":"UnderlineNav-actions","UnderlineNav-container":"UnderlineNav-container","pagination":"pagination","active":"active","current":"current","gap":"gap","paginate-container":"paginate-container","tooltipped":"tooltipped","tooltip-appear":"tooltip-appear","tooltipped-no-delay":"tooltipped-no-delay","tooltipped-multiline":"tooltipped-multiline","tooltipped-s":"tooltipped-s","tooltipped-se":"tooltipped-se","tooltipped-sw":"tooltipped-sw","tooltipped-n":"tooltipped-n","tooltipped-ne":"tooltipped-ne","tooltipped-nw":"tooltipped-nw","tooltipped-w":"tooltipped-w","tooltipped-e":"tooltipped-e","tooltipped-align-right-1":"tooltipped-align-right-1","tooltipped-align-right-2":"tooltipped-align-right-2","tooltipped-align-left-1":"tooltipped-align-left-1","tooltipped-align-left-2":"tooltipped-align-left-2","tooltipped-sticky":"tooltipped-sticky","__react_component_tooltip":"__react_component_tooltip","type-info":"type-info","place-bottom":"place-bottom","place-top":"place-top","place-right":"place-right","place-left":"place-left","css-truncate":"css-truncate","css-truncate-target":"css-truncate-target","expandable":"expandable","zeroclipboard-is-hover":"zeroclipboard-is-hover","anim-fade-in":"anim-fade-in","fade-in":"fade-in","fast":"fast","anim-fade-out":"anim-fade-out","fade-out":"fade-out","anim-fade-up":"anim-fade-up","fade-up":"fade-up","anim-fade-down":"anim-fade-down","fade-down":"fade-down","anim-grow-x":"anim-grow-x","grow-x":"grow-x","anim-shrink-x":"anim-shrink-x","shrink-x":"shrink-x","anim-scale-in":"anim-scale-in","scale-in":"scale-in","anim-pulse":"anim-pulse","pulse":"pulse","anim-pulse-in":"anim-pulse-in","pulse-in":"pulse-in","hover-grow":"hover-grow","border":"border","border-top":"border-top","border-right":"border-right","border-bottom":"border-bottom","border-left":"border-left","border-y":"border-y","border-dashed":"border-dashed","border-blue":"border-blue","border-blue-light":"border-blue-light","border-green":"border-green","border-green-light":"border-green-light","border-red":"border-red","border-red-light":"border-red-light","border-purple":"border-purple","border-yellow":"border-yellow","border-gray-light":"border-gray-light","border-gray-dark":"border-gray-dark","border-black-fade":"border-black-fade","border-0":"border-0","border-top-0":"border-top-0","border-right-0":"border-right-0","border-bottom-0":"border-bottom-0","border-left-0":"border-left-0","rounded-0":"rounded-0","rounded-1":"rounded-1","rounded-2":"rounded-2","circle":"circle","box-shadow":"box-shadow","box-shadow-medium":"box-shadow-medium","box-shadow-large":"box-shadow-large","box-shadow-extra-large":"box-shadow-extra-large","box-shadow-none":"box-shadow-none","bg-white":"bg-white","bg-blue":"bg-blue","bg-blue-light":"bg-blue-light","bg-gray-dark":"bg-gray-dark","bg-gray":"bg-gray","bg-gray-light":"bg-gray-light","bg-green":"bg-green","bg-green-light":"bg-green-light","bg-red":"bg-red","bg-red-light":"bg-red-light","bg-shade-gradient":"bg-shade-gradient","text-blue":"text-blue","text-red":"text-red","text-gray-light":"text-gray-light","text-gray":"text-gray","text-gray-dark":"text-gray-dark","text-green":"text-green","text-orange":"text-orange","text-orange-light":"text-orange-light","text-white":"text-white","text-inherit":"text-inherit","text-pending":"text-pending","bg-pending":"bg-pending","link-gray":"link-gray","link-gray-dark":"link-gray-dark","link-hover-blue":"link-hover-blue","muted-link":"muted-link","icon-trash":"icon-trash","details-overlay":"details-overlay","details-overlay-dark":"details-overlay-dark","flex-row":"flex-row","flex-row-reverse":"flex-row-reverse","flex-column":"flex-column","flex-wrap":"flex-wrap","flex-nowrap":"flex-nowrap","flex-justify-start":"flex-justify-start","flex-justify-end":"flex-justify-end","flex-justify-center":"flex-justify-center","flex-justify-between":"flex-justify-between","flex-justify-around":"flex-justify-around","flex-items-start":"flex-items-start","flex-items-end":"flex-items-end","flex-items-center":"flex-items-center","flex-items-baseline":"flex-items-baseline","flex-items-stretch":"flex-items-stretch","flex-content-start":"flex-content-start","flex-content-end":"flex-content-end","flex-content-center":"flex-content-center","flex-content-between":"flex-content-between","flex-content-around":"flex-content-around","flex-content-stretch":"flex-content-stretch","flex-auto":"flex-auto","flex-shrink-0":"flex-shrink-0","flex-self-auto":"flex-self-auto","flex-self-start":"flex-self-start","flex-self-end":"flex-self-end","flex-self-center":"flex-self-center","flex-self-baseline":"flex-self-baseline","flex-self-stretch":"flex-self-stretch","flex-item-equal":"flex-item-equal","flex-sm-row":"flex-sm-row","flex-sm-row-reverse":"flex-sm-row-reverse","flex-sm-column":"flex-sm-column","flex-sm-wrap":"flex-sm-wrap","flex-sm-nowrap":"flex-sm-nowrap","flex-sm-justify-start":"flex-sm-justify-start","flex-sm-justify-end":"flex-sm-justify-end","flex-sm-justify-center":"flex-sm-justify-center","flex-sm-justify-between":"flex-sm-justify-between","flex-sm-justify-around":"flex-sm-justify-around","flex-sm-items-start":"flex-sm-items-start","flex-sm-items-end":"flex-sm-items-end","flex-sm-items-center":"flex-sm-items-center","flex-sm-items-baseline":"flex-sm-items-baseline","flex-sm-items-stretch":"flex-sm-items-stretch","flex-sm-content-start":"flex-sm-content-start","flex-sm-content-end":"flex-sm-content-end","flex-sm-content-center":"flex-sm-content-center","flex-sm-content-between":"flex-sm-content-between","flex-sm-content-around":"flex-sm-content-around","flex-sm-content-stretch":"flex-sm-content-stretch","flex-sm-auto":"flex-sm-auto","flex-sm-shrink-0":"flex-sm-shrink-0","flex-sm-self-auto":"flex-sm-self-auto","flex-sm-self-start":"flex-sm-self-start","flex-sm-self-end":"flex-sm-self-end","flex-sm-self-center":"flex-sm-self-center","flex-sm-self-baseline":"flex-sm-self-baseline","flex-sm-self-stretch":"flex-sm-self-stretch","flex-sm-item-equal":"flex-sm-item-equal","flex-md-row":"flex-md-row","flex-md-row-reverse":"flex-md-row-reverse","flex-md-column":"flex-md-column","flex-md-wrap":"flex-md-wrap","flex-md-nowrap":"flex-md-nowrap","flex-md-justify-start":"flex-md-justify-start","flex-md-justify-end":"flex-md-justify-end","flex-md-justify-center":"flex-md-justify-center","flex-md-justify-between":"flex-md-justify-between","flex-md-justify-around":"flex-md-justify-around","flex-md-items-start":"flex-md-items-start","flex-md-items-end":"flex-md-items-end","flex-md-items-center":"flex-md-items-center","flex-md-items-baseline":"flex-md-items-baseline","flex-md-items-stretch":"flex-md-items-stretch","flex-md-content-start":"flex-md-content-start","flex-md-content-end":"flex-md-content-end","flex-md-content-center":"flex-md-content-center","flex-md-content-between":"flex-md-content-between","flex-md-content-around":"flex-md-content-around","flex-md-content-stretch":"flex-md-content-stretch","flex-md-auto":"flex-md-auto","flex-md-shrink-0":"flex-md-shrink-0","flex-md-self-auto":"flex-md-self-auto","flex-md-self-start":"flex-md-self-start","flex-md-self-end":"flex-md-self-end","flex-md-self-center":"flex-md-self-center","flex-md-self-baseline":"flex-md-self-baseline","flex-md-self-stretch":"flex-md-self-stretch","flex-md-item-equal":"flex-md-item-equal","flex-lg-row":"flex-lg-row","flex-lg-row-reverse":"flex-lg-row-reverse","flex-lg-column":"flex-lg-column","flex-lg-wrap":"flex-lg-wrap","flex-lg-nowrap":"flex-lg-nowrap","flex-lg-justify-start":"flex-lg-justify-start","flex-lg-justify-end":"flex-lg-justify-end","flex-lg-justify-center":"flex-lg-justify-center","flex-lg-justify-between":"flex-lg-justify-between","flex-lg-justify-around":"flex-lg-justify-around","flex-lg-items-start":"flex-lg-items-start","flex-lg-items-end":"flex-lg-items-end","flex-lg-items-center":"flex-lg-items-center","flex-lg-items-baseline":"flex-lg-items-baseline","flex-lg-items-stretch":"flex-lg-items-stretch","flex-lg-content-start":"flex-lg-content-start","flex-lg-content-end":"flex-lg-content-end","flex-lg-content-center":"flex-lg-content-center","flex-lg-content-between":"flex-lg-content-between","flex-lg-content-around":"flex-lg-content-around","flex-lg-content-stretch":"flex-lg-content-stretch","flex-lg-auto":"flex-lg-auto","flex-lg-shrink-0":"flex-lg-shrink-0","flex-lg-self-auto":"flex-lg-self-auto","flex-lg-self-start":"flex-lg-self-start","flex-lg-self-end":"flex-lg-self-end","flex-lg-self-center":"flex-lg-self-center","flex-lg-self-baseline":"flex-lg-self-baseline","flex-lg-self-stretch":"flex-lg-self-stretch","flex-lg-item-equal":"flex-lg-item-equal","flex-xl-row":"flex-xl-row","flex-xl-row-reverse":"flex-xl-row-reverse","flex-xl-column":"flex-xl-column","flex-xl-wrap":"flex-xl-wrap","flex-xl-nowrap":"flex-xl-nowrap","flex-xl-justify-start":"flex-xl-justify-start","flex-xl-justify-end":"flex-xl-justify-end","flex-xl-justify-center":"flex-xl-justify-center","flex-xl-justify-between":"flex-xl-justify-between","flex-xl-justify-around":"flex-xl-justify-around","flex-xl-items-start":"flex-xl-items-start","flex-xl-items-end":"flex-xl-items-end","flex-xl-items-center":"flex-xl-items-center","flex-xl-items-baseline":"flex-xl-items-baseline","flex-xl-items-stretch":"flex-xl-items-stretch","flex-xl-content-start":"flex-xl-content-start","flex-xl-content-end":"flex-xl-content-end","flex-xl-content-center":"flex-xl-content-center","flex-xl-content-between":"flex-xl-content-between","flex-xl-content-around":"flex-xl-content-around","flex-xl-content-stretch":"flex-xl-content-stretch","flex-xl-auto":"flex-xl-auto","flex-xl-shrink-0":"flex-xl-shrink-0","flex-xl-self-auto":"flex-xl-self-auto","flex-xl-self-start":"flex-xl-self-start","flex-xl-self-end":"flex-xl-self-end","flex-xl-self-center":"flex-xl-self-center","flex-xl-self-baseline":"flex-xl-self-baseline","flex-xl-self-stretch":"flex-xl-self-stretch","flex-xl-item-equal":"flex-xl-item-equal","position-static":"position-static","position-relative":"position-relative","position-absolute":"position-absolute","position-fixed":"position-fixed","top-0":"top-0","right-0":"right-0","bottom-0":"bottom-0","left-0":"left-0","v-align-middle":"v-align-middle","v-align-top":"v-align-top","v-align-bottom":"v-align-bottom","v-align-text-top":"v-align-text-top","v-align-text-bottom":"v-align-text-bottom","v-align-baseline":"v-align-baseline","overflow-hidden":"overflow-hidden","overflow-scroll":"overflow-scroll","overflow-auto":"overflow-auto","clearfix":"clearfix","float-right":"float-right","float-left":"float-left","float-none":"float-none","float-sm-left":"float-sm-left","float-sm-right":"float-sm-right","float-sm-none":"float-sm-none","float-md-left":"float-md-left","float-md-right":"float-md-right","float-md-none":"float-md-none","float-lg-left":"float-lg-left","float-lg-right":"float-lg-right","float-lg-none":"float-lg-none","float-xl-left":"float-xl-left","float-xl-right":"float-xl-right","float-xl-none":"float-xl-none","width-fit":"width-fit","width-full":"width-full","height-fit":"height-fit","height-full":"height-full","min-width-0":"min-width-0","direction-rtl":"direction-rtl","direction-ltr":"direction-ltr","direction-sm-rtl":"direction-sm-rtl","direction-sm-ltr":"direction-sm-ltr","direction-md-rtl":"direction-md-rtl","direction-md-ltr":"direction-md-ltr","direction-lg-rtl":"direction-lg-rtl","direction-lg-ltr":"direction-lg-ltr","direction-xl-rtl":"direction-xl-rtl","direction-xl-ltr":"direction-xl-ltr","m-0":"m-0","mt-0":"mt-0","mr-0":"mr-0","mb-0":"mb-0","ml-0":"ml-0","mt-n0":"mt-n0","mr-n0":"mr-n0","mb-n0":"mb-n0","ml-n0":"ml-n0","mx-0":"mx-0","my-0":"my-0","m-1":"m-1","mt-1":"mt-1","mr-1":"mr-1","mb-1":"mb-1","ml-1":"ml-1","mt-n1":"mt-n1","mr-n1":"mr-n1","mb-n1":"mb-n1","ml-n1":"ml-n1","mx-1":"mx-1","my-1":"my-1","m-2":"m-2","mt-2":"mt-2","mr-2":"mr-2","mb-2":"mb-2","ml-2":"ml-2","mt-n2":"mt-n2","mr-n2":"mr-n2","mb-n2":"mb-n2","ml-n2":"ml-n2","mx-2":"mx-2","my-2":"my-2","m-3":"m-3","mt-3":"mt-3","mr-3":"mr-3","mb-3":"mb-3","ml-3":"ml-3","mt-n3":"mt-n3","mr-n3":"mr-n3","mb-n3":"mb-n3","ml-n3":"ml-n3","mx-3":"mx-3","my-3":"my-3","m-4":"m-4","mt-4":"mt-4","mr-4":"mr-4","mb-4":"mb-4","ml-4":"ml-4","mt-n4":"mt-n4","mr-n4":"mr-n4","mb-n4":"mb-n4","ml-n4":"ml-n4","mx-4":"mx-4","my-4":"my-4","m-5":"m-5","mt-5":"mt-5","mr-5":"mr-5","mb-5":"mb-5","ml-5":"ml-5","mt-n5":"mt-n5","mr-n5":"mr-n5","mb-n5":"mb-n5","ml-n5":"ml-n5","mx-5":"mx-5","my-5":"my-5","m-6":"m-6","mt-6":"mt-6","mr-6":"mr-6","mb-6":"mb-6","ml-6":"ml-6","mt-n6":"mt-n6","mr-n6":"mr-n6","mb-n6":"mb-n6","ml-n6":"ml-n6","mx-6":"mx-6","my-6":"my-6","mx-auto":"mx-auto","m-sm-0":"m-sm-0","mt-sm-0":"mt-sm-0","mr-sm-0":"mr-sm-0","mb-sm-0":"mb-sm-0","ml-sm-0":"ml-sm-0","mt-sm-n0":"mt-sm-n0","mr-sm-n0":"mr-sm-n0","mb-sm-n0":"mb-sm-n0","ml-sm-n0":"ml-sm-n0","mx-sm-0":"mx-sm-0","my-sm-0":"my-sm-0","m-sm-1":"m-sm-1","mt-sm-1":"mt-sm-1","mr-sm-1":"mr-sm-1","mb-sm-1":"mb-sm-1","ml-sm-1":"ml-sm-1","mt-sm-n1":"mt-sm-n1","mr-sm-n1":"mr-sm-n1","mb-sm-n1":"mb-sm-n1","ml-sm-n1":"ml-sm-n1","mx-sm-1":"mx-sm-1","my-sm-1":"my-sm-1","m-sm-2":"m-sm-2","mt-sm-2":"mt-sm-2","mr-sm-2":"mr-sm-2","mb-sm-2":"mb-sm-2","ml-sm-2":"ml-sm-2","mt-sm-n2":"mt-sm-n2","mr-sm-n2":"mr-sm-n2","mb-sm-n2":"mb-sm-n2","ml-sm-n2":"ml-sm-n2","mx-sm-2":"mx-sm-2","my-sm-2":"my-sm-2","m-sm-3":"m-sm-3","mt-sm-3":"mt-sm-3","mr-sm-3":"mr-sm-3","mb-sm-3":"mb-sm-3","ml-sm-3":"ml-sm-3","mt-sm-n3":"mt-sm-n3","mr-sm-n3":"mr-sm-n3","mb-sm-n3":"mb-sm-n3","ml-sm-n3":"ml-sm-n3","mx-sm-3":"mx-sm-3","my-sm-3":"my-sm-3","m-sm-4":"m-sm-4","mt-sm-4":"mt-sm-4","mr-sm-4":"mr-sm-4","mb-sm-4":"mb-sm-4","ml-sm-4":"ml-sm-4","mt-sm-n4":"mt-sm-n4","mr-sm-n4":"mr-sm-n4","mb-sm-n4":"mb-sm-n4","ml-sm-n4":"ml-sm-n4","mx-sm-4":"mx-sm-4","my-sm-4":"my-sm-4","m-sm-5":"m-sm-5","mt-sm-5":"mt-sm-5","mr-sm-5":"mr-sm-5","mb-sm-5":"mb-sm-5","ml-sm-5":"ml-sm-5","mt-sm-n5":"mt-sm-n5","mr-sm-n5":"mr-sm-n5","mb-sm-n5":"mb-sm-n5","ml-sm-n5":"ml-sm-n5","mx-sm-5":"mx-sm-5","my-sm-5":"my-sm-5","m-sm-6":"m-sm-6","mt-sm-6":"mt-sm-6","mr-sm-6":"mr-sm-6","mb-sm-6":"mb-sm-6","ml-sm-6":"ml-sm-6","mt-sm-n6":"mt-sm-n6","mr-sm-n6":"mr-sm-n6","mb-sm-n6":"mb-sm-n6","ml-sm-n6":"ml-sm-n6","mx-sm-6":"mx-sm-6","my-sm-6":"my-sm-6","m-md-0":"m-md-0","mt-md-0":"mt-md-0","mr-md-0":"mr-md-0","mb-md-0":"mb-md-0","ml-md-0":"ml-md-0","mt-md-n0":"mt-md-n0","mr-md-n0":"mr-md-n0","mb-md-n0":"mb-md-n0","ml-md-n0":"ml-md-n0","mx-md-0":"mx-md-0","my-md-0":"my-md-0","m-md-1":"m-md-1","mt-md-1":"mt-md-1","mr-md-1":"mr-md-1","mb-md-1":"mb-md-1","ml-md-1":"ml-md-1","mt-md-n1":"mt-md-n1","mr-md-n1":"mr-md-n1","mb-md-n1":"mb-md-n1","ml-md-n1":"ml-md-n1","mx-md-1":"mx-md-1","my-md-1":"my-md-1","m-md-2":"m-md-2","mt-md-2":"mt-md-2","mr-md-2":"mr-md-2","mb-md-2":"mb-md-2","ml-md-2":"ml-md-2","mt-md-n2":"mt-md-n2","mr-md-n2":"mr-md-n2","mb-md-n2":"mb-md-n2","ml-md-n2":"ml-md-n2","mx-md-2":"mx-md-2","my-md-2":"my-md-2","m-md-3":"m-md-3","mt-md-3":"mt-md-3","mr-md-3":"mr-md-3","mb-md-3":"mb-md-3","ml-md-3":"ml-md-3","mt-md-n3":"mt-md-n3","mr-md-n3":"mr-md-n3","mb-md-n3":"mb-md-n3","ml-md-n3":"ml-md-n3","mx-md-3":"mx-md-3","my-md-3":"my-md-3","m-md-4":"m-md-4","mt-md-4":"mt-md-4","mr-md-4":"mr-md-4","mb-md-4":"mb-md-4","ml-md-4":"ml-md-4","mt-md-n4":"mt-md-n4","mr-md-n4":"mr-md-n4","mb-md-n4":"mb-md-n4","ml-md-n4":"ml-md-n4","mx-md-4":"mx-md-4","my-md-4":"my-md-4","m-md-5":"m-md-5","mt-md-5":"mt-md-5","mr-md-5":"mr-md-5","mb-md-5":"mb-md-5","ml-md-5":"ml-md-5","mt-md-n5":"mt-md-n5","mr-md-n5":"mr-md-n5","mb-md-n5":"mb-md-n5","ml-md-n5":"ml-md-n5","mx-md-5":"mx-md-5","my-md-5":"my-md-5","m-md-6":"m-md-6","mt-md-6":"mt-md-6","mr-md-6":"mr-md-6","mb-md-6":"mb-md-6","ml-md-6":"ml-md-6","mt-md-n6":"mt-md-n6","mr-md-n6":"mr-md-n6","mb-md-n6":"mb-md-n6","ml-md-n6":"ml-md-n6","mx-md-6":"mx-md-6","my-md-6":"my-md-6","m-lg-0":"m-lg-0","mt-lg-0":"mt-lg-0","mr-lg-0":"mr-lg-0","mb-lg-0":"mb-lg-0","ml-lg-0":"ml-lg-0","mt-lg-n0":"mt-lg-n0","mr-lg-n0":"mr-lg-n0","mb-lg-n0":"mb-lg-n0","ml-lg-n0":"ml-lg-n0","mx-lg-0":"mx-lg-0","my-lg-0":"my-lg-0","m-lg-1":"m-lg-1","mt-lg-1":"mt-lg-1","mr-lg-1":"mr-lg-1","mb-lg-1":"mb-lg-1","ml-lg-1":"ml-lg-1","mt-lg-n1":"mt-lg-n1","mr-lg-n1":"mr-lg-n1","mb-lg-n1":"mb-lg-n1","ml-lg-n1":"ml-lg-n1","mx-lg-1":"mx-lg-1","my-lg-1":"my-lg-1","m-lg-2":"m-lg-2","mt-lg-2":"mt-lg-2","mr-lg-2":"mr-lg-2","mb-lg-2":"mb-lg-2","ml-lg-2":"ml-lg-2","mt-lg-n2":"mt-lg-n2","mr-lg-n2":"mr-lg-n2","mb-lg-n2":"mb-lg-n2","ml-lg-n2":"ml-lg-n2","mx-lg-2":"mx-lg-2","my-lg-2":"my-lg-2","m-lg-3":"m-lg-3","mt-lg-3":"mt-lg-3","mr-lg-3":"mr-lg-3","mb-lg-3":"mb-lg-3","ml-lg-3":"ml-lg-3","mt-lg-n3":"mt-lg-n3","mr-lg-n3":"mr-lg-n3","mb-lg-n3":"mb-lg-n3","ml-lg-n3":"ml-lg-n3","mx-lg-3":"mx-lg-3","my-lg-3":"my-lg-3","m-lg-4":"m-lg-4","mt-lg-4":"mt-lg-4","mr-lg-4":"mr-lg-4","mb-lg-4":"mb-lg-4","ml-lg-4":"ml-lg-4","mt-lg-n4":"mt-lg-n4","mr-lg-n4":"mr-lg-n4","mb-lg-n4":"mb-lg-n4","ml-lg-n4":"ml-lg-n4","mx-lg-4":"mx-lg-4","my-lg-4":"my-lg-4","m-lg-5":"m-lg-5","mt-lg-5":"mt-lg-5","mr-lg-5":"mr-lg-5","mb-lg-5":"mb-lg-5","ml-lg-5":"ml-lg-5","mt-lg-n5":"mt-lg-n5","mr-lg-n5":"mr-lg-n5","mb-lg-n5":"mb-lg-n5","ml-lg-n5":"ml-lg-n5","mx-lg-5":"mx-lg-5","my-lg-5":"my-lg-5","m-lg-6":"m-lg-6","mt-lg-6":"mt-lg-6","mr-lg-6":"mr-lg-6","mb-lg-6":"mb-lg-6","ml-lg-6":"ml-lg-6","mt-lg-n6":"mt-lg-n6","mr-lg-n6":"mr-lg-n6","mb-lg-n6":"mb-lg-n6","ml-lg-n6":"ml-lg-n6","mx-lg-6":"mx-lg-6","my-lg-6":"my-lg-6","m-xl-0":"m-xl-0","mt-xl-0":"mt-xl-0","mr-xl-0":"mr-xl-0","mb-xl-0":"mb-xl-0","ml-xl-0":"ml-xl-0","mt-xl-n0":"mt-xl-n0","mr-xl-n0":"mr-xl-n0","mb-xl-n0":"mb-xl-n0","ml-xl-n0":"ml-xl-n0","mx-xl-0":"mx-xl-0","my-xl-0":"my-xl-0","m-xl-1":"m-xl-1","mt-xl-1":"mt-xl-1","mr-xl-1":"mr-xl-1","mb-xl-1":"mb-xl-1","ml-xl-1":"ml-xl-1","mt-xl-n1":"mt-xl-n1","mr-xl-n1":"mr-xl-n1","mb-xl-n1":"mb-xl-n1","ml-xl-n1":"ml-xl-n1","mx-xl-1":"mx-xl-1","my-xl-1":"my-xl-1","m-xl-2":"m-xl-2","mt-xl-2":"mt-xl-2","mr-xl-2":"mr-xl-2","mb-xl-2":"mb-xl-2","ml-xl-2":"ml-xl-2","mt-xl-n2":"mt-xl-n2","mr-xl-n2":"mr-xl-n2","mb-xl-n2":"mb-xl-n2","ml-xl-n2":"ml-xl-n2","mx-xl-2":"mx-xl-2","my-xl-2":"my-xl-2","m-xl-3":"m-xl-3","mt-xl-3":"mt-xl-3","mr-xl-3":"mr-xl-3","mb-xl-3":"mb-xl-3","ml-xl-3":"ml-xl-3","mt-xl-n3":"mt-xl-n3","mr-xl-n3":"mr-xl-n3","mb-xl-n3":"mb-xl-n3","ml-xl-n3":"ml-xl-n3","mx-xl-3":"mx-xl-3","my-xl-3":"my-xl-3","m-xl-4":"m-xl-4","mt-xl-4":"mt-xl-4","mr-xl-4":"mr-xl-4","mb-xl-4":"mb-xl-4","ml-xl-4":"ml-xl-4","mt-xl-n4":"mt-xl-n4","mr-xl-n4":"mr-xl-n4","mb-xl-n4":"mb-xl-n4","ml-xl-n4":"ml-xl-n4","mx-xl-4":"mx-xl-4","my-xl-4":"my-xl-4","m-xl-5":"m-xl-5","mt-xl-5":"mt-xl-5","mr-xl-5":"mr-xl-5","mb-xl-5":"mb-xl-5","ml-xl-5":"ml-xl-5","mt-xl-n5":"mt-xl-n5","mr-xl-n5":"mr-xl-n5","mb-xl-n5":"mb-xl-n5","ml-xl-n5":"ml-xl-n5","mx-xl-5":"mx-xl-5","my-xl-5":"my-xl-5","m-xl-6":"m-xl-6","mt-xl-6":"mt-xl-6","mr-xl-6":"mr-xl-6","mb-xl-6":"mb-xl-6","ml-xl-6":"ml-xl-6","mt-xl-n6":"mt-xl-n6","mr-xl-n6":"mr-xl-n6","mb-xl-n6":"mb-xl-n6","ml-xl-n6":"ml-xl-n6","mx-xl-6":"mx-xl-6","my-xl-6":"my-xl-6","p-0":"p-0","pt-0":"pt-0","pr-0":"pr-0","pb-0":"pb-0","pl-0":"pl-0","px-0":"px-0","py-0":"py-0","p-1":"p-1","pt-1":"pt-1","pr-1":"pr-1","pb-1":"pb-1","pl-1":"pl-1","px-1":"px-1","py-1":"py-1","p-2":"p-2","pt-2":"pt-2","pr-2":"pr-2","pb-2":"pb-2","pl-2":"pl-2","px-2":"px-2","py-2":"py-2","p-3":"p-3","pt-3":"pt-3","pr-3":"pr-3","pb-3":"pb-3","pl-3":"pl-3","px-3":"px-3","py-3":"py-3","p-4":"p-4","pt-4":"pt-4","pr-4":"pr-4","pb-4":"pb-4","pl-4":"pl-4","px-4":"px-4","py-4":"py-4","p-5":"p-5","pt-5":"pt-5","pr-5":"pr-5","pb-5":"pb-5","pl-5":"pl-5","px-5":"px-5","py-5":"py-5","p-6":"p-6","pt-6":"pt-6","pr-6":"pr-6","pb-6":"pb-6","pl-6":"pl-6","px-6":"px-6","py-6":"py-6","p-sm-0":"p-sm-0","pt-sm-0":"pt-sm-0","pr-sm-0":"pr-sm-0","pb-sm-0":"pb-sm-0","pl-sm-0":"pl-sm-0","px-sm-0":"px-sm-0","py-sm-0":"py-sm-0","p-sm-1":"p-sm-1","pt-sm-1":"pt-sm-1","pr-sm-1":"pr-sm-1","pb-sm-1":"pb-sm-1","pl-sm-1":"pl-sm-1","px-sm-1":"px-sm-1","py-sm-1":"py-sm-1","p-sm-2":"p-sm-2","pt-sm-2":"pt-sm-2","pr-sm-2":"pr-sm-2","pb-sm-2":"pb-sm-2","pl-sm-2":"pl-sm-2","px-sm-2":"px-sm-2","py-sm-2":"py-sm-2","p-sm-3":"p-sm-3","pt-sm-3":"pt-sm-3","pr-sm-3":"pr-sm-3","pb-sm-3":"pb-sm-3","pl-sm-3":"pl-sm-3","px-sm-3":"px-sm-3","py-sm-3":"py-sm-3","p-sm-4":"p-sm-4","pt-sm-4":"pt-sm-4","pr-sm-4":"pr-sm-4","pb-sm-4":"pb-sm-4","pl-sm-4":"pl-sm-4","px-sm-4":"px-sm-4","py-sm-4":"py-sm-4","p-sm-5":"p-sm-5","pt-sm-5":"pt-sm-5","pr-sm-5":"pr-sm-5","pb-sm-5":"pb-sm-5","pl-sm-5":"pl-sm-5","px-sm-5":"px-sm-5","py-sm-5":"py-sm-5","p-sm-6":"p-sm-6","pt-sm-6":"pt-sm-6","pr-sm-6":"pr-sm-6","pb-sm-6":"pb-sm-6","pl-sm-6":"pl-sm-6","px-sm-6":"px-sm-6","py-sm-6":"py-sm-6","p-md-0":"p-md-0","pt-md-0":"pt-md-0","pr-md-0":"pr-md-0","pb-md-0":"pb-md-0","pl-md-0":"pl-md-0","px-md-0":"px-md-0","py-md-0":"py-md-0","p-md-1":"p-md-1","pt-md-1":"pt-md-1","pr-md-1":"pr-md-1","pb-md-1":"pb-md-1","pl-md-1":"pl-md-1","px-md-1":"px-md-1","py-md-1":"py-md-1","p-md-2":"p-md-2","pt-md-2":"pt-md-2","pr-md-2":"pr-md-2","pb-md-2":"pb-md-2","pl-md-2":"pl-md-2","px-md-2":"px-md-2","py-md-2":"py-md-2","p-md-3":"p-md-3","pt-md-3":"pt-md-3","pr-md-3":"pr-md-3","pb-md-3":"pb-md-3","pl-md-3":"pl-md-3","px-md-3":"px-md-3","py-md-3":"py-md-3","p-md-4":"p-md-4","pt-md-4":"pt-md-4","pr-md-4":"pr-md-4","pb-md-4":"pb-md-4","pl-md-4":"pl-md-4","px-md-4":"px-md-4","py-md-4":"py-md-4","p-md-5":"p-md-5","pt-md-5":"pt-md-5","pr-md-5":"pr-md-5","pb-md-5":"pb-md-5","pl-md-5":"pl-md-5","px-md-5":"px-md-5","py-md-5":"py-md-5","p-md-6":"p-md-6","pt-md-6":"pt-md-6","pr-md-6":"pr-md-6","pb-md-6":"pb-md-6","pl-md-6":"pl-md-6","px-md-6":"px-md-6","py-md-6":"py-md-6","p-lg-0":"p-lg-0","pt-lg-0":"pt-lg-0","pr-lg-0":"pr-lg-0","pb-lg-0":"pb-lg-0","pl-lg-0":"pl-lg-0","px-lg-0":"px-lg-0","py-lg-0":"py-lg-0","p-lg-1":"p-lg-1","pt-lg-1":"pt-lg-1","pr-lg-1":"pr-lg-1","pb-lg-1":"pb-lg-1","pl-lg-1":"pl-lg-1","px-lg-1":"px-lg-1","py-lg-1":"py-lg-1","p-lg-2":"p-lg-2","pt-lg-2":"pt-lg-2","pr-lg-2":"pr-lg-2","pb-lg-2":"pb-lg-2","pl-lg-2":"pl-lg-2","px-lg-2":"px-lg-2","py-lg-2":"py-lg-2","p-lg-3":"p-lg-3","pt-lg-3":"pt-lg-3","pr-lg-3":"pr-lg-3","pb-lg-3":"pb-lg-3","pl-lg-3":"pl-lg-3","px-lg-3":"px-lg-3","py-lg-3":"py-lg-3","p-lg-4":"p-lg-4","pt-lg-4":"pt-lg-4","pr-lg-4":"pr-lg-4","pb-lg-4":"pb-lg-4","pl-lg-4":"pl-lg-4","px-lg-4":"px-lg-4","py-lg-4":"py-lg-4","p-lg-5":"p-lg-5","pt-lg-5":"pt-lg-5","pr-lg-5":"pr-lg-5","pb-lg-5":"pb-lg-5","pl-lg-5":"pl-lg-5","px-lg-5":"px-lg-5","py-lg-5":"py-lg-5","p-lg-6":"p-lg-6","pt-lg-6":"pt-lg-6","pr-lg-6":"pr-lg-6","pb-lg-6":"pb-lg-6","pl-lg-6":"pl-lg-6","px-lg-6":"px-lg-6","py-lg-6":"py-lg-6","p-xl-0":"p-xl-0","pt-xl-0":"pt-xl-0","pr-xl-0":"pr-xl-0","pb-xl-0":"pb-xl-0","pl-xl-0":"pl-xl-0","px-xl-0":"px-xl-0","py-xl-0":"py-xl-0","p-xl-1":"p-xl-1","pt-xl-1":"pt-xl-1","pr-xl-1":"pr-xl-1","pb-xl-1":"pb-xl-1","pl-xl-1":"pl-xl-1","px-xl-1":"px-xl-1","py-xl-1":"py-xl-1","p-xl-2":"p-xl-2","pt-xl-2":"pt-xl-2","pr-xl-2":"pr-xl-2","pb-xl-2":"pb-xl-2","pl-xl-2":"pl-xl-2","px-xl-2":"px-xl-2","py-xl-2":"py-xl-2","p-xl-3":"p-xl-3","pt-xl-3":"pt-xl-3","pr-xl-3":"pr-xl-3","pb-xl-3":"pb-xl-3","pl-xl-3":"pl-xl-3","px-xl-3":"px-xl-3","py-xl-3":"py-xl-3","p-xl-4":"p-xl-4","pt-xl-4":"pt-xl-4","pr-xl-4":"pr-xl-4","pb-xl-4":"pb-xl-4","pl-xl-4":"pl-xl-4","px-xl-4":"px-xl-4","py-xl-4":"py-xl-4","p-xl-5":"p-xl-5","pt-xl-5":"pt-xl-5","pr-xl-5":"pr-xl-5","pb-xl-5":"pb-xl-5","pl-xl-5":"pl-xl-5","px-xl-5":"px-xl-5","py-xl-5":"py-xl-5","p-xl-6":"p-xl-6","pt-xl-6":"pt-xl-6","pr-xl-6":"pr-xl-6","pb-xl-6":"pb-xl-6","pl-xl-6":"pl-xl-6","px-xl-6":"px-xl-6","py-xl-6":"py-xl-6","p-responsive":"p-responsive","h1":"h1","h2":"h2","h3":"h3","h4":"h4","h5":"h5","h6":"h6","f1":"f1","f2":"f2","f3":"f3","f4":"f4","f5":"f5","f6":"f6","f00-light":"f00-light","f0-light":"f0-light","f1-light":"f1-light","f2-light":"f2-light","f3-light":"f3-light","text-small":"text-small","lead":"lead","lh-condensed-ultra":"lh-condensed-ultra","lh-condensed":"lh-condensed","lh-default":"lh-default","text-right":"text-right","text-left":"text-left","text-center":"text-center","text-sm-right":"text-sm-right","text-sm-left":"text-sm-left","text-sm-center":"text-sm-center","text-md-right":"text-md-right","text-md-left":"text-md-left","text-md-center":"text-md-center","text-lg-right":"text-lg-right","text-lg-left":"text-lg-left","text-lg-center":"text-lg-center","text-xl-right":"text-xl-right","text-xl-left":"text-xl-left","text-xl-center":"text-xl-center","text-normal":"text-normal","text-bold":"text-bold","text-italic":"text-italic","text-uppercase":"text-uppercase","no-underline":"no-underline","no-wrap":"no-wrap","ws-normal":"ws-normal","wb-break-all":"wb-break-all","text-emphasized":"text-emphasized","list-style-none":"list-style-none","text-shadow-dark":"text-shadow-dark","text-shadow-light":"text-shadow-light","text-mono":"text-mono","v-hidden":"v-hidden","v-visible":"v-visible","d-table":"d-table","d-table-cell":"d-table-cell","table-fixed":"table-fixed","d-block":"d-block","d-inline":"d-inline","d-inline-block":"d-inline-block","d-flex":"d-flex","d-inline-flex":"d-inline-flex","d-none":"d-none","d-sm-table":"d-sm-table","d-sm-table-cell":"d-sm-table-cell","d-sm-block":"d-sm-block","d-sm-inline":"d-sm-inline","d-sm-inline-block":"d-sm-inline-block","d-sm-flex":"d-sm-flex","d-sm-inline-flex":"d-sm-inline-flex","d-sm-none":"d-sm-none","d-md-table":"d-md-table","d-md-table-cell":"d-md-table-cell","d-md-block":"d-md-block","d-md-inline":"d-md-inline","d-md-inline-block":"d-md-inline-block","d-md-flex":"d-md-flex","d-md-inline-flex":"d-md-inline-flex","d-md-none":"d-md-none","d-lg-table":"d-lg-table","d-lg-table-cell":"d-lg-table-cell","d-lg-block":"d-lg-block","d-lg-inline":"d-lg-inline","d-lg-inline-block":"d-lg-inline-block","d-lg-flex":"d-lg-flex","d-lg-inline-flex":"d-lg-inline-flex","d-lg-none":"d-lg-none","d-xl-table":"d-xl-table","d-xl-table-cell":"d-xl-table-cell","d-xl-block":"d-xl-block","d-xl-inline":"d-xl-inline","d-xl-inline-block":"d-xl-inline-block","d-xl-flex":"d-xl-flex","d-xl-inline-flex":"d-xl-inline-flex","d-xl-none":"d-xl-none","hide-sm":"hide-sm","hide-md":"hide-md","hide-lg":"hide-lg","hide-xl":"hide-xl","sr-only":"sr-only","show-on-focus":"show-on-focus","flash":"flash","flash-messages":"flash-messages","flash-close":"flash-close","flash-action":"flash-action","flash-warn":"flash-warn","flash-error":"flash-error","flash-success":"flash-success","flash-full":"flash-full","avatar-small":"avatar-small","avatar-link":"avatar-link","avatar-group-item":"avatar-group-item","avatar-parent-child":"avatar-parent-child","avatar-child":"avatar-child","avatar-stack":"avatar-stack","AvatarStack":"AvatarStack","AvatarStack-body":"AvatarStack-body","AvatarStack--two":"AvatarStack--two","AvatarStack--three-plus":"AvatarStack--three-plus","avatar-more":"avatar-more","AvatarStack--right":"AvatarStack--right","CircleBadge":"CircleBadge","CircleBadge-icon":"CircleBadge-icon","CircleBadge--small":"CircleBadge--small","CircleBadge--medium":"CircleBadge--medium","CircleBadge--large":"CircleBadge--large","DashedConnection":"DashedConnection","labels":"labels","label":"label","Label":"Label","Popover":"Popover","Popover-message":"Popover-message","Popover-message--bottom":"Popover-message--bottom","Popover-message--bottom-right":"Popover-message--bottom-right","Popover-message--bottom-left":"Popover-message--bottom-left","Popover-message--top-right":"Popover-message--top-right","Popover-message--top-left":"Popover-message--top-left","Popover-message--right":"Popover-message--right","Popover-message--right-top":"Popover-message--right-top","Popover-message--right-bottom":"Popover-message--right-bottom","Popover-message--left":"Popover-message--left","Popover-message--left-top":"Popover-message--left-top","Popover-message--left-bottom":"Popover-message--left-bottom","Popover-message--large":"Popover-message--large","Subhead":"Subhead","Subhead--spacious":"Subhead--spacious","Subhead-heading":"Subhead-heading","Subhead-heading--danger":"Subhead-heading--danger","Subhead-description":"Subhead-description","Subhead-actions":"Subhead-actions","table-setting":"table-setting","class-info":"class-info","dropdown-menu":"dropdown-menu","setting-dropdown":"setting-dropdown","dropdown-toggle":"dropdown-toggle","pull-right":"pull-right","footer":"footer","show":"show","classtop-rbc-toolbar":"classtop-rbc-toolbar","radio":"radio","radio-inline":"radio-inline","checkbox":"checkbox","checkbox-inline":"checkbox-inline","class-calendar":"class-calendar","react-tabs__tab-list":"react-tabs__tab-list","form-input":"form-input","c-red":"c-red","CalendarDay__selected":"CalendarDay__selected","CalendarDay__hovered_span":"CalendarDay__hovered_span","DayPickerKeyboardShortcuts_show__bottomRight":"DayPickerKeyboardShortcuts_show__bottomRight","timepicker-2-fields":"timepicker-2-fields","panel-body":"panel-body","privacy-panel":"privacy-panel","react-tel-input":"react-tel-input","selected-flag":"selected-flag"};

/***/ },

/***/ "olkN":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	
	var _redux = __webpack_require__("c9Fv");
	
	var _reducers = __webpack_require__("ChGC");
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reduxThunk = __webpack_require__("4ufr");
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = void 0;
	if (global.__main__store) {
	  store = global.__main__store;
	} else {
	  var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
	  store = global.__main__store = (0, _redux.createStore)(_reducers2.default, composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk2.default)));
	}
	
	exports.default = store;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "ChGC":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// announcement
	
	
	//
	// REFECTOR REQUIRED
	// this should not reside in header
	//
	
	
	var _redux = __webpack_require__("c9Fv");
	
	var _reactRouterRedux = __webpack_require__("jZgO");
	
	var _user = __webpack_require__("2F2H");
	
	var _user2 = _interopRequireDefault(_user);
	
	var _subscription = __webpack_require__("ue3W");
	
	var _subscription2 = _interopRequireDefault(_subscription);
	
	var _clsAdd = __webpack_require__("hTtd");
	
	var _clsAdd2 = _interopRequireDefault(_clsAdd);
	
	var _clsInfo = __webpack_require__("sktl");
	
	var _clsInfo2 = _interopRequireDefault(_clsInfo);
	
	var _clsLst = __webpack_require__("7bm9");
	
	var _clsLst2 = _interopRequireDefault(_clsLst);
	
	var _clsStdt = __webpack_require__("1UrD");
	
	var _clsStdt2 = _interopRequireDefault(_clsStdt);
	
	var _clsStdtSttUpdate = __webpack_require__("YAtA");
	
	var _clsStdtSttUpdate2 = _interopRequireDefault(_clsStdtSttUpdate);
	
	var _clsSttUpdate = __webpack_require__("EhWx");
	
	var _clsSttUpdate2 = _interopRequireDefault(_clsSttUpdate);
	
	var _clsTch = __webpack_require__("6aop");
	
	var _clsTch2 = _interopRequireDefault(_clsTch);
	
	var _clsTchUpdate = __webpack_require__("ejIE");
	
	var _clsTchUpdate2 = _interopRequireDefault(_clsTchUpdate);
	
	var _clsStdtUpdate = __webpack_require__("hQRu");
	
	var _clsStdtUpdate2 = _interopRequireDefault(_clsStdtUpdate);
	
	var _clsJoin = __webpack_require__("Vqj8");
	
	var _clsJoin2 = _interopRequireDefault(_clsJoin);
	
	var _clsCt = __webpack_require__("3yA2");
	
	var _clsCt2 = _interopRequireDefault(_clsCt);
	
	var _clsUpdate = __webpack_require__("4dkR");
	
	var _clsUpdate2 = _interopRequireDefault(_clsUpdate);
	
	var _chcStt = __webpack_require__("pQv2");
	
	var _chcStt2 = _interopRequireDefault(_chcStt);
	
	var _clsLss = __webpack_require__("FIdM");
	
	var _clsLss2 = _interopRequireDefault(_clsLss);
	
	var _clsLssAdd = __webpack_require__("h8QV");
	
	var _clsLssAdd2 = _interopRequireDefault(_clsLssAdd);
	
	var _clsLssDelete = __webpack_require__("3OcF");
	
	var _clsLssDelete2 = _interopRequireDefault(_clsLssDelete);
	
	var _clsLssStdt = __webpack_require__("Kwcg");
	
	var _clsLssStdt2 = _interopRequireDefault(_clsLssStdt);
	
	var _clsLssStdtAdd = __webpack_require__("mw1U");
	
	var _clsLssStdtAdd2 = _interopRequireDefault(_clsLssStdtAdd);
	
	var _clsLssUpdate = __webpack_require__("jhQH");
	
	var _clsLssUpdate2 = _interopRequireDefault(_clsLssUpdate);
	
	var _stdtChcSttUpdate = __webpack_require__("BKSr");
	
	var _stdtChcSttUpdate2 = _interopRequireDefault(_stdtChcSttUpdate);
	
	var _lssTchUpdate = __webpack_require__("nguk");
	
	var _lssTchUpdate2 = _interopRequireDefault(_lssTchUpdate);
	
	var _sChcNote = __webpack_require__("p4Ur");
	
	var _sChcNote2 = _interopRequireDefault(_sChcNote);
	
	var _tChcNote = __webpack_require__("MNXn");
	
	var _tChcNote2 = _interopRequireDefault(_tChcNote);
	
	var _lsnWithTimeAdd = __webpack_require__("luLD");
	
	var _lsnWithTimeAdd2 = _interopRequireDefault(_lsnWithTimeAdd);
	
	var _lsnWithTimeUpdate = __webpack_require__("t0wH");
	
	var _lsnWithTimeUpdate2 = _interopRequireDefault(_lsnWithTimeUpdate);
	
	var _lsnMultiWithTimeAdd = __webpack_require__("wm/+");
	
	var _lsnMultiWithTimeAdd2 = _interopRequireDefault(_lsnMultiWithTimeAdd);
	
	var _schStdtLst = __webpack_require__("TLYC");
	
	var _schStdtLst2 = _interopRequireDefault(_schStdtLst);
	
	var _schTchLst = __webpack_require__("3Xuc");
	
	var _schTchLst2 = _interopRequireDefault(_schTchLst);
	
	var _sSignup = __webpack_require__("6nHS");
	
	var _sSignup2 = _interopRequireDefault(_sSignup);
	
	var _sRegister = __webpack_require__("N8yg");
	
	var _sRegister2 = _interopRequireDefault(_sRegister);
	
	var _token = __webpack_require__("IrP6");
	
	var _token2 = _interopRequireDefault(_token);
	
	var _chgPasswd = __webpack_require__("VvK/");
	
	var _chgPasswd2 = _interopRequireDefault(_chgPasswd);
	
	var _phVrfction = __webpack_require__("RoZr");
	
	var _phVrfction2 = _interopRequireDefault(_phVrfction);
	
	var _schTradeLst = __webpack_require__("JBzd");
	
	var _schTradeLst2 = _interopRequireDefault(_schTradeLst);
	
	var _trEmail = __webpack_require__("FwmL");
	
	var _trEmail2 = _interopRequireDefault(_trEmail);
	
	var _trNoteGet = __webpack_require__("6o6k");
	
	var _trNoteGet2 = _interopRequireDefault(_trNoteGet);
	
	var _trNoteUpdate = __webpack_require__("+FWb");
	
	var _trNoteUpdate2 = _interopRequireDefault(_trNoteUpdate);
	
	var _timetable = __webpack_require__("HWCZ");
	
	var _timetable2 = _interopRequireDefault(_timetable);
	
	var _sGroupList = __webpack_require__("mNT4");
	
	var _sGroupList2 = _interopRequireDefault(_sGroupList);
	
	var _sPermissionList = __webpack_require__("d2QZ");
	
	var _sPermissionList2 = _interopRequireDefault(_sPermissionList);
	
	var _groupListRegister = __webpack_require__("7hKR");
	
	var _groupListRegister2 = _interopRequireDefault(_groupListRegister);
	
	var _groupListTeacher = __webpack_require__("rzL2");
	
	var _groupListTeacher2 = _interopRequireDefault(_groupListTeacher);
	
	var _sGroupDetail = __webpack_require__("iYHi");
	
	var _sGroupDetail2 = _interopRequireDefault(_sGroupDetail);
	
	var _sDeleteGroup = __webpack_require__("/gPV");
	
	var _sDeleteGroup2 = _interopRequireDefault(_sDeleteGroup);
	
	var _sEditGroup = __webpack_require__("h1Jb");
	
	var _sEditGroup2 = _interopRequireDefault(_sEditGroup);
	
	var _sUpdateGroup = __webpack_require__("9Nf5");
	
	var _sUpdateGroup2 = _interopRequireDefault(_sUpdateGroup);
	
	var _rgstStdt = __webpack_require__("Ir40");
	
	var _rgstStdt2 = _interopRequireDefault(_rgstStdt);
	
	var _stdtChcRcd = __webpack_require__("2WtU");
	
	var _stdtChcRcd2 = _interopRequireDefault(_stdtChcRcd);
	
	var _stdtCrtCls = __webpack_require__("Hpt0");
	
	var _stdtCrtCls2 = _interopRequireDefault(_stdtCrtCls);
	
	var _stdtHstCls = __webpack_require__("asZ3");
	
	var _stdtHstCls2 = _interopRequireDefault(_stdtHstCls);
	
	var _stdtInfo = __webpack_require__("2Yj6");
	
	var _stdtInfo2 = _interopRequireDefault(_stdtInfo);
	
	var _stdtAttr = __webpack_require__("c9NW");
	
	var _stdtAttr2 = _interopRequireDefault(_stdtAttr);
	
	var _stdtCrdt = __webpack_require__("mn5V");
	
	var _stdtCrdt2 = _interopRequireDefault(_stdtCrdt);
	
	var _stdtInfoUpdate = __webpack_require__("BvbT");
	
	var _stdtInfoUpdate2 = _interopRequireDefault(_stdtInfoUpdate);
	
	var _stdtLog = __webpack_require__("V753");
	
	var _stdtLog2 = _interopRequireDefault(_stdtLog);
	
	var _stdtSmr = __webpack_require__("bV2V");
	
	var _stdtSmr2 = _interopRequireDefault(_stdtSmr);
	
	var _stdtSmrCt = __webpack_require__("bwN8");
	
	var _stdtSmrCt2 = _interopRequireDefault(_stdtSmrCt);
	
	var _stdtGetTrade = __webpack_require__("pFi5");
	
	var _stdtGetTrade2 = _interopRequireDefault(_stdtGetTrade);
	
	var _stdtTrade = __webpack_require__("E+ko");
	
	var _stdtTrade2 = _interopRequireDefault(_stdtTrade);
	
	var _stdtTrade3 = __webpack_require__("c1uH");
	
	var _stdtTrade4 = _interopRequireDefault(_stdtTrade3);
	
	var _stdtHstTrade = __webpack_require__("BKNI");
	
	var _stdtHstTrade2 = _interopRequireDefault(_stdtHstTrade);
	
	var _schStdtStt = __webpack_require__("Fby7");
	
	var _schStdtStt2 = _interopRequireDefault(_schStdtStt);
	
	var _multiStuArchive = __webpack_require__("K29h");
	
	var _multiStuArchive2 = _interopRequireDefault(_multiStuArchive);
	
	var _rgstTch = __webpack_require__("buwc");
	
	var _rgstTch2 = _interopRequireDefault(_rgstTch);
	
	var _tchInfo = __webpack_require__("plZL");
	
	var _tchInfo2 = _interopRequireDefault(_tchInfo);
	
	var _tchStt = __webpack_require__("MPtr");
	
	var _tchStt2 = _interopRequireDefault(_tchStt);
	
	var _tchUpdate = __webpack_require__("DGas");
	
	var _tchUpdate2 = _interopRequireDefault(_tchUpdate);
	
	var _tLogin = __webpack_require__("XqNl");
	
	var _tLogin2 = _interopRequireDefault(_tLogin);
	
	var _tchChcRcd = __webpack_require__("Yvru");
	
	var _tchChcRcd2 = _interopRequireDefault(_tchChcRcd);
	
	var _clsroomDetail = __webpack_require__("8YrF");
	
	var _clsroomDetail2 = _interopRequireDefault(_clsroomDetail);
	
	var _clsroomLst = __webpack_require__("W78K");
	
	var _clsroomLst2 = _interopRequireDefault(_clsroomLst);
	
	var _clsroomRgst = __webpack_require__("AvIb");
	
	var _clsroomRgst2 = _interopRequireDefault(_clsroomRgst);
	
	var _clsroomUpdate = __webpack_require__("7Ezr");
	
	var _clsroomUpdate2 = _interopRequireDefault(_clsroomUpdate);
	
	var _addAnn = __webpack_require__("X+eT");
	
	var _addAnn2 = _interopRequireDefault(_addAnn);
	
	var _annLst = __webpack_require__("+NAs");
	
	var _annLst2 = _interopRequireDefault(_annLst);
	
	var _annOperate = __webpack_require__("JfP5");
	
	var _annOperate2 = _interopRequireDefault(_annOperate);
	
	var _paymentMethod = __webpack_require__("28av");
	
	var _paymentMethod2 = _interopRequireDefault(_paymentMethod);
	
	var _subscription3 = __webpack_require__("jYsE");
	
	var _subscription4 = _interopRequireDefault(_subscription3);
	
	var _teacherConfirmation = __webpack_require__("4xrm");
	
	var _teacherConfirmation2 = _interopRequireDefault(_teacherConfirmation);
	
	var _sDeleteSchool = __webpack_require__("4yXo");
	
	var _sDeleteSchool2 = _interopRequireDefault(_sDeleteSchool);
	
	var _gSchoolCurrentTeacher = __webpack_require__("OJwi");
	
	var _gSchoolCurrentTeacher2 = _interopRequireDefault(_gSchoolCurrentTeacher);
	
	var _gSchoolArchivedTeacher = __webpack_require__("02e3");
	
	var _gSchoolArchivedTeacher2 = _interopRequireDefault(_gSchoolArchivedTeacher);
	
	var _inviteTeacher = __webpack_require__("/TtL");
	
	var _inviteTeacher2 = _interopRequireDefault(_inviteTeacher);
	
	var _gTeacherExit = __webpack_require__("hZPP");
	
	var _gTeacherExit2 = _interopRequireDefault(_gTeacherExit);
	
	var _ducks = __webpack_require__("vw3Y");
	
	var _ducks2 = _interopRequireDefault(_ducks);
	
	var _Locale = __webpack_require__("1iVG");
	
	var _Locale2 = _interopRequireDefault(_Locale);
	
	var _Dev = __webpack_require__("MusF");
	
	var _Dev2 = _interopRequireDefault(_Dev);
	
	var _schMonthlyFinance = __webpack_require__("l6bW");
	
	var _schMonthlyFinance2 = _interopRequireDefault(_schMonthlyFinance);
	
	var _ducks3 = __webpack_require__("yDaX");
	
	var _ducks4 = _interopRequireDefault(_ducks3);
	
	var _ducks5 = __webpack_require__("wTtZ");
	
	var _ducks6 = _interopRequireDefault(_ducks5);
	
	var _ducks7 = __webpack_require__("I0d0");
	
	var _ducks8 = _interopRequireDefault(_ducks7);
	
	var _ducks9 = __webpack_require__("yhkM");
	
	var _ducks10 = _interopRequireDefault(_ducks9);
	
	var _ducks11 = __webpack_require__("7wYd");
	
	var _ducks12 = _interopRequireDefault(_ducks11);
	
	var _ducks13 = __webpack_require__("lDbx");
	
	var _ducks14 = _interopRequireDefault(_ducks13);
	
	var _ducks15 = __webpack_require__("6mZg");
	
	var _ducks16 = _interopRequireDefault(_ducks15);
	
	var _ducks17 = __webpack_require__("DPWa");
	
	var _ducks18 = _interopRequireDefault(_ducks17);
	
	var _ducks19 = __webpack_require__("yuEY");
	
	var _ducks20 = _interopRequireDefault(_ducks19);
	
	var _ducks21 = __webpack_require__("W/Ox");
	
	var _ducks22 = _interopRequireDefault(_ducks21);
	
	var _ducks23 = __webpack_require__("srt+");
	
	var _ducks24 = _interopRequireDefault(_ducks23);
	
	var _ducks25 = __webpack_require__("2yUR");
	
	var _ducks26 = _interopRequireDefault(_ducks25);
	
	var _ducks27 = __webpack_require__("tCuI");
	
	var _ducks28 = _interopRequireDefault(_ducks27);
	
	var _reducer = __webpack_require__("pzkK");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	__webpack_require__("Ywk3");
	
	var _reactReduxHotline = __webpack_require__("IKa1");
	
	var _reducer3 = __webpack_require__("7bRE");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__("yChA");
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	var _reducer7 = __webpack_require__("+uPl");
	
	var _reducer8 = _interopRequireDefault(_reducer7);
	
	var _reducer9 = __webpack_require__("vA13");
	
	var _reducer10 = _interopRequireDefault(_reducer9);
	
	var _reducer11 = __webpack_require__("Av+e");
	
	var _reducer12 = _interopRequireDefault(_reducer11);
	
	var _ducks29 = __webpack_require__("Y5Sn");
	
	var _ducks30 = _interopRequireDefault(_ducks29);
	
	var _schoolDetail = __webpack_require__("8VNP");
	
	var _schoolDetail2 = _interopRequireDefault(_schoolDetail);
	
	var _ducks31 = __webpack_require__("vvL0");
	
	var _ducks32 = _interopRequireDefault(_ducks31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	// REFECTOR REQUIRED
	//
	
	var reducers = (0, _redux.combineReducers)(_extends({
	  routing: _reactRouterRedux.routerReducer,
	
	  user: _user2.default,
	
	  clsAdd: _clsAdd2.default,
	  clsInfo: _clsInfo2.default,
	  clsLst: _clsLst2.default,
	  clsStdt: _clsStdt2.default,
	  clsStdtSttUpdate: _clsStdtSttUpdate2.default,
	  clsSttUpdate: _clsSttUpdate2.default,
	  clsTch: _clsTch2.default,
	  clsTchUpdate: _clsTchUpdate2.default,
	  clsStdtUpdate: _clsStdtUpdate2.default,
	  chcStt: _chcStt2.default,
	  clsLss: _clsLss2.default,
	  clsLssAdd: _clsLssAdd2.default,
	  clsLssDelete: _clsLssDelete2.default,
	  clsLssStdt: _clsLssStdt2.default,
	  clsLssStdtAdd: _clsLssStdtAdd2.default,
	  clsLssUpdate: _clsLssUpdate2.default,
	  clsJoin: _clsJoin2.default,
	  clsCt: _clsCt2.default,
	  clsUpdate: _clsUpdate2.default,
	  stdtChcSttUpdate: _stdtChcSttUpdate2.default,
	  lssTchUpdate: _lssTchUpdate2.default,
	  sChcNote: _sChcNote2.default,
	  tChcNote: _tChcNote2.default,
	  lsnWithTimeAdd: _lsnWithTimeAdd2.default,
	  lsnWithTimeUpdate: _lsnWithTimeUpdate2.default,
	  lsnMultiWithTimeAdd: _lsnMultiWithTimeAdd2.default,
	  schStdtLst: _schStdtLst2.default,
	  schTchLst: _schTchLst2.default,
	  sSignup: _sSignup2.default,
	  sRegister: _sRegister2.default,
	  token: _token2.default,
	  chgPasswd: _chgPasswd2.default,
	  phVrfction: _phVrfction2.default,
	  schTradeLst: _schTradeLst2.default,
	  trEmail: _trEmail2.default,
	  trNoteGet: _trNoteGet2.default,
	  trNoteUpdate: _trNoteUpdate2.default,
	  timetable: _timetable2.default,
	  rgstStdt: _rgstStdt2.default,
	  stdtChcRcd: _stdtChcRcd2.default,
	  stdtCrtCls: _stdtCrtCls2.default,
	  stdtHstCls: _stdtHstCls2.default,
	  stdtInfo: _stdtInfo2.default,
	  stdtAttr: _stdtAttr2.default,
	  stdtCrdt: _stdtCrdt2.default,
	  stdtInfoUpdate: _stdtInfoUpdate2.default,
	  stdtLog: _stdtLog2.default,
	  stdtSmr: _stdtSmr2.default,
	  stdtSmrCt: _stdtSmrCt2.default,
	  stdtGetTrade: _stdtGetTrade2.default,
	  stdtTrade: _stdtTrade2.default,
	  stdtTrade2: _stdtTrade4.default,
	  stdtHstTrade: _stdtHstTrade2.default,
	  schStdtStt: _schStdtStt2.default,
	  rgstTch: _rgstTch2.default,
	  tchInfo: _tchInfo2.default,
	  tchStt: _tchStt2.default,
	  tchUpdate: _tchUpdate2.default,
	  tLogin: _tLogin2.default,
	  tchChcRcd: _tchChcRcd2.default,
	  clsroomLst: _clsroomLst2.default,
	  clsroomUpdate: _clsroomUpdate2.default,
	  clsroomRgst: _clsroomRgst2.default,
	  clsroomDetail: _clsroomDetail2.default,
	  addAnn: _addAnn2.default,
	  annLst: _annLst2.default,
	  annOperate: _annOperate2.default,
	  sGroupList: _sGroupList2.default,
	  sPermissionList: _sPermissionList2.default,
	  groupListRegister: _groupListRegister2.default,
	  groupListTeacher: _groupListTeacher2.default,
	  sGroupDetail: _sGroupDetail2.default,
	  sDeleteGroup: _sDeleteGroup2.default,
	  sEditGroup: _sEditGroup2.default,
	  sUpdateGroup: _sUpdateGroup2.default,
	  paymentMethod: _paymentMethod2.default,
	  subscription: _subscription4.default,
	  gSubscription: _subscription2.default,
	  teacherConfirmation: _teacherConfirmation2.default,
	  gSchoolCurrentTeacher: _gSchoolCurrentTeacher2.default,
	  gSchoolArchivedTeacher: _gSchoolArchivedTeacher2.default,
	  inviteTeacher: _inviteTeacher2.default,
	  sDeleteSchool: _sDeleteSchool2.default,
	  gTeacherExit: _gTeacherExit2.default,
	  multiStuArchive: _multiStuArchive2.default,
	  Locale: _Locale2.default,
	  Dev: _Dev2.default,
	  schMonthlyFinance: _schMonthlyFinance2.default,
	  teacherList: _ducks4.default,
	  classList: _ducks6.default,
	  classroomList: _ducks8.default,
	  schedule: _ducks10.default,
	  financeTable: _ducks12.default,
	  classLessonDetail: _ducks14.default,
	  classStudentDetail: _ducks16.default,
	  lessonAttendanceDetail: _ducks20.default,
	  posterList: _ducks22.default,
	  posterDetail: _ducks24.default,
	  attendeeList: _ducks26.default,
	  getAttendance: _ducks2.default,
	  classTeacherDetail: _ducks18.default,
	  clientList: _ducks28.default,
	  announcementList: _reducer2.default,
	  timelineReducer: _reducer4.default,
	  schoolDetail: _schoolDetail2.default,
	  teacherInfo: _reducer6.default,
	  contactInfo: _reducer8.default,
	  contactNotes: _reducer10.default,
	  mediaCenter: _reducer12.default,
	  schoolLog: _ducks32.default,
	  schoolStatistic: _ducks30.default
	}, (0, _reactReduxHotline.getReducers)()));
	
	exports.default = reducers;
	module.exports = exports['default'];

/***/ },

/***/ "2F2H":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.GET_USER_BY_TOKEN_OK = exports.GET_USER_BY_TOKEN_FAILED = exports.GET_USER_BY_TOKEN = exports.UPDATE_USER = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchUserByToken = fetchUserByToken;
	exports.default = user;
	
	var _getUserByToken = __webpack_require__("v34H");
	
	var _getUserByToken2 = _interopRequireDefault(_getUserByToken);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UPDATE_USER = exports.UPDATE_USER = 'UPDATE_USER';
	
	var GET_USER_BY_TOKEN = exports.GET_USER_BY_TOKEN = 'GET_USER_BY_TOKEN';
	var GET_USER_BY_TOKEN_FAILED = exports.GET_USER_BY_TOKEN_FAILED = 'GET_USER_BY_TOKEN_FAILED';
	var GET_USER_BY_TOKEN_OK = exports.GET_USER_BY_TOKEN_OK = 'GET_USER_BY_TOKEN_OK';
	
	// import { getSubscription } from './subscription';
	
	function fetchUserByToken() {
	  return function (dispatch) {
	
	    (0, _getUserByToken2.default)().then(function (result) {
	
	      var rolesPerSchool = {};
	      if (result.data.school_list) {
	        result.data.school_list.map(function (school) {
	          if (school.role_group[0]) {
	            rolesPerSchool[school.school_id] = {
	              role: school.role_group[0].name,
	              permissions: school.permissions
	            };
	          }
	        });
	      }
	
	      dispatch({
	        type: GET_USER_BY_TOKEN_OK,
	        result: result.data,
	        rolesPerSchool: rolesPerSchool
	      });
	
	      // dispatch(getSubscription());
	    }).catch(function (error) {
	      console.error(error);
	
	      dispatch({
	        type: GET_USER_BY_TOKEN_FAILED,
	        error: error
	      });
	    });
	  };
	}
	
	var initState = {
	  result: {
	    school_list: [],
	    teacher_to_be_confirmed: []
	  },
	  rolesPerSchool: {},
	  loading: true,
	  loginRequired: false,
	  loaded: false,
	  login: false
	};
	
	function user() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case UPDATE_USER:
	      {
	        var _user = action.user;
	
	        return _extends({}, state, {
	          user: _user
	        });
	      }
	
	    case GET_USER_BY_TOKEN:
	      {
	        return _extends({}, state, { loading: true });
	      }
	    case GET_USER_BY_TOKEN_OK:
	      {
	        var result = action.result,
	            rolesPerSchool = action.rolesPerSchool;
	
	        if (state.error) {
	          delete state.error;
	        }
	
	        return _extends({}, state, {
	          result: result,
	          rolesPerSchool: rolesPerSchool,
	          loading: false,
	          loaded: true,
	          login: true,
	          loginRequired: false
	        });
	      }
	    case GET_USER_BY_TOKEN_FAILED:
	      {
	        return _extends({}, state, {
	          error: action.error,
	          loading: false,
	          loaded: true,
	          login: false,
	          loginRequired: true
	        });
	      }
	
	    default:
	      return _extends({}, state);
	
	  }
	}

/***/ },

/***/ "v34H":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getUserByToken;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getUserByToken() {
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/from_token_to_user/',
				'method': 'GET',
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports['default'];

/***/ },

/***/ "ue3W":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.GET_SUBSCRIPTION_FAILED = exports.GET_SUBSCRIPTION_OK = exports.GET_SUBSCRIPTION = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getSubscription = getSubscription;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case GET_SUBSCRIPTION:
	      {
	        return _extends({}, state, { fetching: true });
	      }
	    case GET_SUBSCRIPTION_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result, fetching: false });
	      }
	    case GET_SUBSCRIPTION_FAILED:
	      {
	        return _extends({}, state, { error: action.error, fetching: false });
	      }
	    default:
	      return state;
	  }
	};
	
	var _getSubscription = __webpack_require__("h7zY");
	
	var _getSubscription2 = _interopRequireDefault(_getSubscription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GET_SUBSCRIPTION = exports.GET_SUBSCRIPTION = 'GET_SUBSCRIPTION';
	var GET_SUBSCRIPTION_OK = exports.GET_SUBSCRIPTION_OK = 'GET_SUBSCRIPTION_OK';
	var GET_SUBSCRIPTION_FAILED = exports.GET_SUBSCRIPTION_FAILED = 'GET_SUBSCRIPTION_FAILED';
	
	function getSubscription(schoolId) {
	  return function (dispatch) {
	    dispatch({
	      type: GET_SUBSCRIPTION
	    });
	
	    (0, _getSubscription2.default)(schoolId).then(function (results) {
	      dispatch({
	        type: GET_SUBSCRIPTION_OK,
	        result: results.data
	      });
	    }).catch(function (error) {
	
	      dispatch({
	        type: GET_SUBSCRIPTION_FAILED,
	        error: error
	      });
	    });
	  };
	}
	
	var initState = {
	  result: {},
	  fetching: false
	};

/***/ },

/***/ "h7zY":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getSubscription;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getSubscription(schoolId) {
	
		var url = void 0;
		if (schoolId) {
			url = "/subscription/?school=" + schoolId;
		} else {
			url = "/subscription/";
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': url,
				'method': 'GET',
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports["default"];

/***/ },

/***/ "hTtd":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.ADD_CLS:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.ADD_CLS_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.ADD_CLS_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "PZtk":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var UPDATE_USER = exports.UPDATE_USER = 'UPDATE_USER';
	
	// student
	var RGST_STDT = exports.RGST_STDT = 'RGST_STDT';
	var RGST_STDT_FAILED = exports.RGST_STDT_FAILED = 'RGST_STDT_FAILED';
	var RGST_STDT_OK = exports.RGST_STDT_OK = 'RGST_STDT_OK';
	
	var GET_STDT_INFO = exports.GET_STDT_INFO = 'GET_STDT_INFO';
	var GET_STDT_INFO_FAILED = exports.GET_STDT_INFO_FAILED = 'GET_STDT_INFO_FAILED';
	var GET_STDT_INFO_OK = exports.GET_STDT_INFO_OK = 'GET_STDT_INFO_OK';
	
	var GET_STDT_CREDIT = exports.GET_STDT_CREDIT = 'GET_STDT_CREDIT';
	var GET_STDT_CREDIT_FAILED = exports.GET_STDT_CREDIT_FAILED = 'GET_STDT_CREDIT_FAILED';
	var GET_STDT_CREDIT_OK = exports.GET_STDT_CREDIT_OK = 'GET_STDT_ACREDIT_OK';
	
	var GET_STDT_ATTRIBUTE = exports.GET_STDT_ATTRIBUTE = 'GET_STDT_ATTRIBUTE';
	var GET_STDT_ATTRIBUTE_FAILED = exports.GET_STDT_ATTRIBUTE_FAILED = 'GET_STDT_ATTRIBUTE_FAILED';
	var GET_STDT_ATTRIBUTE_OK = exports.GET_STDT_ATTRIBUTE_OK = 'GET_STDT_ATTRIBUTE_OK';
	
	var UPDATE_STDT_INFO = exports.UPDATE_STDT_INFO = 'UPDATE_STDT_INFO';
	var UPDATE_STDT_INFO_FAILED = exports.UPDATE_STDT_INFO_FAILED = 'UPDATE_STDT_INFO_FAILED';
	var UPDATE_STDT_INFO_OK = exports.UPDATE_STDT_INFO_OK = 'UPDATE_STDT_INFO_OK';
	
	var GET_STDT_SMR = exports.GET_STDT_SMR = 'GET_STDT_SMR';
	var GET_STDT_SMR_FAILED = exports.GET_STDT_SMR_FAILED = 'GET_STDT_SMR_FAILED';
	var GET_STDT_SMR_OK = exports.GET_STDT_SMR_OK = 'GET_STDT_SMR_OK';
	
	var GET_STDT_SMR_CT = exports.GET_STDT_SMR_CT = 'GET_STDT_SMR_CT';
	var GET_STDT_SMR_CT_FAILED = exports.GET_STDT_SMR_CT_FAILED = 'GET_STDT_SMR_CT_FAILED';
	var GET_STDT_SMR_CT_OK = exports.GET_STDT_SMR_CT_OK = 'GET_STDT_SMR_CT_OK';
	
	var GET_STDT_CRT_CLS = exports.GET_STDT_CRT_CLS = 'GET_STDT_CRT_CLS';
	var GET_STDT_CRT_CLS_FAILED = exports.GET_STDT_CRT_CLS_FAILED = 'GET_STDT_CRT_CLS_FAILED';
	var GET_STDT_CRT_CLS_OK = exports.GET_STDT_CRT_CLS_OK = 'GET_STDT_CRT_CLS_OK';
	
	var GET_STDT_HST_CLS = exports.GET_STDT_HST_CLS = 'GET_STDT_HST_CLS';
	var GET_STDT_HST_CLS_FAILED = exports.GET_STDT_HST_CLS_FAILED = 'GET_STDT_HST_CLS_FAILED';
	var GET_STDT_HST_CLS_OK = exports.GET_STDT_HST_CLS_OK = 'GET_STDT_HST_CLS_OK';
	
	var GET_STDT_CHC_RCD = exports.GET_STDT_CHC_RCD = 'GET_STDT_CHC_RCD';
	var GET_STDT_CHC_RCD_FAILED = exports.GET_STDT_CHC_RCD_FAILED = 'GET_STDT_CHC_RCD_FAILED';
	var GET_STDT_CHC_RCD_OK = exports.GET_STDT_CHC_RCD_OK = 'GET_STDT_CHC_RCD_OK';
	
	var GET_STDT_LOG = exports.GET_STDT_LOG = 'GET_STDT_LOG';
	var GET_STDT_LOG_FAILED = exports.GET_STDT_LOG_FAILED = 'GET_STDT_LOG_FAILED';
	var GET_STDT_LOG_OK = exports.GET_STDT_LOG_OK = 'GET_STDT_LOG_OK';
	
	var UPDATE_TRADE = exports.UPDATE_TRADE = 'UPDATE_TRADE';
	var UPDATE_TRADE_FAILED = exports.UPDATE_TRADE_FAILED = 'UPDATE_TRADE_FAILED';
	var UPDATE_TRADE_OK = exports.UPDATE_TRADE_OK = 'UPDATE_TRADE_OK';
	
	// victor add for updating and getting trade of the class student
	
	var UPDATE_TRADE2 = exports.UPDATE_TRADE2 = 'UPDATE_TRADE2';
	var UPDATE_TRADE2_FAILED = exports.UPDATE_TRADE2_FAILED = 'UPDATE_TRADE2_FAILED';
	var UPDATE_TRADE2_OK = exports.UPDATE_TRADE2_OK = 'UPDATE_TRADE2_OK';
	
	var GET_TRADE = exports.GET_TRADE = 'GET_TRADE';
	var GET_TRADE_FAILED = exports.GET_TRADE_FAILED = 'GET_TRADE_FAILED';
	var GET_TRADE_OK = exports.GET_TRADE_OK = 'GET_TRADE_OK';
	// victor add for get history trade of the student
	var GET_STDT_HST_TRADE = exports.GET_STDT_HST_TRADE = 'GET_STDT_HST_TRADE';
	var GET_STDT_HST_TRADE_FAILED = exports.GET_STDT_HST_TRADE_FAILED = 'GET_STDT_HST_TRADE_FAILED';
	var GET_STDT_HST_TRADE_OK = exports.GET_STDT_HST_TRADE_OK = 'GET_STDT_HST_TRADE_OK';
	
	var UPDATE_SCH_STDT_STT = exports.UPDATE_SCH_STDT_STT = 'UPDATE_SCH_STDT_STT';
	var UPDATE_SCH_STDT_STT_FAILED = exports.UPDATE_SCH_STDT_STT_FAILED = 'UPDATE_SCH_STDT_STT_FAILED';
	var UPDATE_SCH_STDT_STT_OK = exports.UPDATE_SCH_STDT_STT_OK = 'UPDATE_SCH_STDT_STT_OK';
	
	// Announcement
	var OPERATE_ANN = exports.OPERATE_ANN = 'OPERATE_ANN';
	var OPERATE_ANN_FAILED = exports.OPERATE_ANN_FAILED = 'OPERATE_ANN_FAILED';
	var OPERATE_ANN_OK = exports.OPERATE_ANN_OK = 'OPERATE_ANN_OK';
	
	var ADD_ANN = exports.ADD_ANN = 'ADD_ANN';
	var ADD_ANN_FAILED = exports.ADD_ANN_FAILED = 'ADD_ANN_FAILED';
	var ADD_ANN_OK = exports.ADD_ANN_OK = 'ADD_ANN_OK';
	
	var GET_ANN_LIST = exports.GET_ANN_LIST = 'GET_ANN_LIST';
	var GET_ANN_LIST_FAILED = exports.GET_ANN_LIST_FAILED = 'GET_ANN_LIST_FAILED';
	var GET_ANN_LIST_OK = exports.GET_ANN_LIST_OK = 'GET_ANN_LIST_OK';
	
	// class
	var ADD_CLS = exports.ADD_CLS = 'ADD_CLS';
	var ADD_CLS_FAILED = exports.ADD_CLS_FAILED = 'ADD_CLS_FAILED';
	var ADD_CLS_OK = exports.ADD_CLS_OK = 'ADD_CLS_OK';
	
	var GET_CLS_BY_TYPE = exports.GET_CLS_BY_TYPE = 'GET_CLS_BY_TYPE';
	var GET_CLS_BY_TYPE_FAILED = exports.GET_CLS_BY_TYPE_FAILED = 'GET_CLS_BY_TYPE_FAILED';
	var GET_CLS_BY_TYPE_OK = exports.GET_CLS_BY_TYPE_OK = 'GET_CLS_BY_TYPE_OK';
	
	var GET_CLS_CT_BY_TYPE = exports.GET_CLS_CT_BY_TYPE = 'GET_CLS_CT_BY_TYPE';
	var GET_CLS_CT_BY_TYPE_FAILED = exports.GET_CLS_CT_BY_TYPE_FAILED = 'GET_CLS_CT_BY_TYPE_FAILED';
	var GET_CLS_CT_BY_TYPE_OK = exports.GET_CLS_CT_BY_TYPE_OK = 'GET_CLS_CT_BY_TYPE_OK';
	
	var GET_CLS_BY_KEY = exports.GET_CLS_BY_KEY = 'GET_CLS_BY_KEY';
	var GET_CLS_BY_KEY_FAILED = exports.GET_CLS_BY_KEY_FAILED = 'GET_CLS_BY_KEY_FAILED';
	var GET_CLS_BY_KEY_OK = exports.GET_CLS_BY_KEY_OK = 'GET_CLS_BY_KEY_OK';
	
	var GET_CLS_BY_ID = exports.GET_CLS_BY_ID = 'GET_CLS_BY_ID';
	var GET_CLS_BY_ID_FAILED = exports.GET_CLS_BY_ID_FAILED = 'GET_CLS_BY_ID_FAILED';
	var GET_CLS_BY_ID_OK = exports.GET_CLS_BY_ID_OK = 'GET_CLS_BY_ID_OK';
	
	var GET_CLS_TCH = exports.GET_CLS_TCH = 'GET_CLS_TCH';
	var GET_CLS_TCH_FAILED = exports.GET_CLS_TCH_FAILED = 'GET_CLS_TCH_FAILED';
	var GET_CLS_TCH_OK = exports.GET_CLS_TCH_OK = 'GET_CLS_TCH_OK';
	
	var GET_CLS_STDT = exports.GET_CLS_STDT = 'GET_CLS_STDT';
	var GET_CLS_STDT_FAILED = exports.GET_CLS_STDT_FAILED = 'GET_CLS_STDT_FAILED';
	var GET_CLS_STDT_OK = exports.GET_CLS_STDT_OK = 'GET_CLS_STDT_OK';
	
	var UPDATE_CLS_STDT_STT = exports.UPDATE_CLS_STDT_STT = 'UPDATE_CLS_STDT_STT';
	var UPDATE_CLS_STDT_STT_FAILED = exports.UPDATE_CLS_STDT_STT_FAILED = 'UPDATE_CLS_STDT_STT_FAILED';
	var UPDATE_CLS_STDT_STT_OK = exports.UPDATE_CLS_STDT_STT_OK = 'UPDATE_CLS_STDT_STT_OK';
	
	var UPDATE_CLS_TCH = exports.UPDATE_CLS_TCH = 'UPDATE_CLS_TCH';
	var UPDATE_CLS_TCH_FAILED = exports.UPDATE_CLS_TCH_FAILED = 'UPDATE_CLS_TCH_FAILED';
	var UPDATE_CLS_TCH_OK = exports.UPDATE_CLS_TCH_OK = 'UPDATE_CLS_TCH_OK';
	
	var UPDATE_CLS_STDT = exports.UPDATE_CLS_STDT = 'UPDATE_CLS_STDT';
	var UPDATE_CLS_STDT_FAILED = exports.UPDATE_CLS_STDT_FAILED = 'UPDATE_CLS_STDT_FAILED';
	var UPDATE_CLS_STDT_OK = exports.UPDATE_CLS_STDT_OK = 'UPDATE_CLS_STDT_OK';
	
	var UPDATE_CLS_STT = exports.UPDATE_CLS_STT = 'UPDATE_CLS_STT';
	var UPDATE_CLS_STT_FAILED = exports.UPDATE_CLS_STT_FAILED = 'UPDATE_CLS_STT_FAILED';
	var UPDATE_CLS_STT_OK = exports.UPDATE_CLS_STT_OK = 'UPDATE_CLS_STT_OK';
	
	var CLS_JOIN_MULTI = exports.CLS_JOIN_MULTI = 'CLS_JOIN_MULTI';
	var CLS_JOIN_MULTI_FAILED = exports.CLS_JOIN_MULTI_FAILED = 'CLS_JOIN_MULTI_FAILED';
	var CLS_JOIN_MULTI_OK = exports.CLS_JOIN_MULTI_OK = 'CLS_JOIN_MULTI_OK';
	
	var UPDATE_CLS = exports.UPDATE_CLS = 'UPDATE_CLS';
	var UPDATE_CLS_FAILED = exports.UPDATE_CLS_FAILED = 'UPDATE_CLS_FAILED';
	var UPDATE_CLS_OK = exports.UPDATE_CLS_OK = 'UPDATE_CLS_OK';
	
	// lesson
	var ADD_CLS_LSS = exports.ADD_CLS_LSS = 'ADD_CLS_LSS';
	var ADD_CLS_LSS_FAILED = exports.ADD_CLS_LSS_FAILED = 'ADD_CLS_LSS_FAILED';
	var ADD_CLS_LSS_OK = exports.ADD_CLS_LSS_OK = 'ADD_CLS_LSS_OK';
	
	var UPDATE_CLS_LSS = exports.UPDATE_CLS_LSS = 'UPDATE_CLS_LSS';
	var UPDATE_CLS_LSS_FAILED = exports.UPDATE_CLS_LSS_FAILED = 'UPDATE_CLS_LSS_FAILED';
	var UPDATE_CLS_LSS_OK = exports.UPDATE_CLS_LSS_OK = 'UPDATE_CLS_LSS_OK';
	
	var DELETE_CLS_LSS = exports.DELETE_CLS_LSS = 'DELETE_CLS_LSS';
	var DELETE_CLS_LSS_FAILED = exports.DELETE_CLS_LSS_FAILED = 'DELETE_CLS_LSS_FAILED';
	var DELETE_CLS_LSS_OK = exports.DELETE_CLS_LSS_OK = 'DELETE_CLS_LSS_OK';
	
	var ADD_CLS_LSS_STDT = exports.ADD_CLS_LSS_STDT = 'ADD_CLS_LSS_STDT';
	var ADD_CLS_LSS_STDT_FAILED = exports.ADD_CLS_LSS_STDT_FAILED = 'ADD_CLS_LSS_STDT_FAILED';
	var ADD_CLS_LSS_STDT_OK = exports.ADD_CLS_LSS_STDT_OK = 'ADD_CLS_LSS_STDT_OK';
	
	var GET_CLS_LSS_STDT = exports.GET_CLS_LSS_STDT = 'GET_CLS_LSS_STDT';
	var GET_CLS_LSS_STDT_FAILED = exports.GET_CLS_LSS_STDT_FAILED = 'GET_CLS_LSS_STDT_FAILED';
	var GET_CLS_LSS_STDT_OK = exports.GET_CLS_LSS_STDT_OK = 'GET_CLS_LSS_STDT_OK';
	
	var GET_CHC_STT = exports.GET_CHC_STT = 'GET_CHC_STT';
	var GET_CHC_STT_FAILED = exports.GET_CHC_STT_FAILED = 'GET_CHC_STT_FAILED';
	var GET_CHC_STT_OK = exports.GET_CHC_STT_OK = 'GET_CHC_STT_OK';
	
	var UPDATE_STDT_CHC_STT = exports.UPDATE_STDT_CHC_STT = 'UPDATE_STDT_CHC_STT';
	var UPDATE_STDT_CHC_STT_FAILED = exports.UPDATE_STDT_CHC_STT_FAILED = 'UPDATE_STDT_CHC_STT_FAILED';
	var UPDATE_STDT_CHC_STT_OK = exports.UPDATE_STDT_CHC_STT_OK = 'UPDATE_STDT_CHC_STT_OK';
	
	var GET_CLS_LSS = exports.GET_CLS_LSS = 'GET_CLS_LSS';
	var GET_CLS_LSS_FAILED = exports.GET_CLS_LSS_FAILED = 'GET_CLS_LSS_FAILED';
	var GET_CLS_LSS_OK = exports.GET_CLS_LSS_OK = 'GET_CLS_LSS_OK';
	
	var UPDATE_LSS_TCH = exports.UPDATE_LSS_TCH = 'UPDATE_LSS_TCH';
	var UPDATE_LSS_TCH_FAILED = exports.UPDATE_LSS_TCH_FAILED = 'UPDATE_LSS_TCH_FAILED';
	var UPDATE_LSS_TCH_OK = exports.UPDATE_LSS_TCH_OK = 'UPDATE_LSS_TCH_OK';
	
	var S_CHECK_NOTE = exports.S_CHECK_NOTE = 'S_CHECK_NOTE';
	var S_CHECK_NOTE_FAILED = exports.S_CHECK_NOTE_FAILED = 'S_CHECK_NOTE_FAILED';
	var S_CHECK_NOTE_OK = exports.S_CHECK_NOTE_OK = 'S_CHECK_NOTE_OK';
	
	var T_CHECK_NOTE = exports.T_CHECK_NOTE = 'T_CHECK_NOTE';
	var T_CHECK_NOTE_FAILED = exports.T_CHECK_NOTE_FAILED = 'T_CHECK_NOTE_FAILED';
	var T_CHECK_NOTE_OK = exports.T_CHECK_NOTE_OK = 'T_CHECK_NOTE_OK';
	
	var ADD_LSN_WITH_TIME = exports.ADD_LSN_WITH_TIME = 'ADD_LSN_WITH_TIME';
	var ADD_LSN_WITH_TIME_FAILED = exports.ADD_LSN_WITH_TIME_FAILED = 'ADD_LSN_WITH_TIME_FAILED';
	var ADD_LSN_WITH_TIME_OK = exports.ADD_LSN_WITH_TIME_OK = 'ADD_LSN_WITH_TIME_OK';
	
	var UPDATE_LSN_WITH_TIME = exports.UPDATE_LSN_WITH_TIME = 'UPDATE_LSN_WITH_TIME';
	var UPDATE_LSN_WITH_TIME_FAILED = exports.UPDATE_LSN_WITH_TIME_FAILED = 'UPDATE_LSN_WITH_TIME_FAILED';
	var UPDATE_LSN_WITH_TIME_OK = exports.UPDATE_LSN_WITH_TIME_OK = 'UPDATE_LSN_WITH_TIME_OK';
	
	var ADD_MULTI_LSN_WITH_TIME = exports.ADD_MULTI_LSN_WITH_TIME = 'ADD_MULTI_LSN_WITH_TIME';
	var ADD_MULTI_LSN_WITH_TIME_FAILED = exports.ADD_MULTI_LSN_WITH_TIME_FAILED = 'ADD_MULTI_LSN_WITH_TIME_FAILED';
	var ADD_MULTI_LSN_WITH_TIME_OK = exports.ADD_MULTI_LSN_WITH_TIME_OK = 'ADD_MULTI_LSN_WITH_TIME_OK';
	
	// teacher
	var RGST_TCH = exports.RGST_TCH = 'RGST_TCH';
	var RGST_TCH_FAILED = exports.RGST_TCH_FAILED = 'RGST_TCH_FAILED';
	var RGST_TCH_OK = exports.RGST_TCH_OK = 'RGST_TCH_OK';
	
	var UPDATE_TCH = exports.UPDATE_TCH = 'UPDATE_TCH';
	var UPDATE_TCH_FAILED = exports.UPDATE_TCH_FAILED = 'UPDATE_TCH_FAILED';
	var UPDATE_TCH_OK = exports.UPDATE_TCH_OK = 'UPDATE_TCH_OK';
	var GET_TCH_INFO = exports.GET_TCH_INFO = 'GET_TCH_INFO';
	var GET_TCH_INFO_OK = exports.GET_TCH_INFO_OK = 'GET_TCH_INFO_OK';
	var GET_TCH_INFO_FAILED = exports.GET_TCH_INFO_FAILED = 'GET_TCH_INFO_FAILED';
	
	var GET_TCH_CHC_RCD = exports.GET_TCH_CHC_RCD = 'GET_TCH_CHC_RCD';
	var GET_TCH_CHC_RCD_FAILED = exports.GET_TCH_CHC_RCD_FAILED = 'GET_TCH_CHC_RCD_FAILED';
	var GET_TCH_CHC_RCD_OK = exports.GET_TCH_CHC_RCD_OK = 'GET_TCH_CHC_RCD_OK';
	
	var GET_TCH_STT = exports.GET_TCH_STT = 'GET_TCH_STT';
	var GET_TCH_STT_FAILED = exports.GET_TCH_STT_FAILED = 'GET_TCH_STT_FAILED';
	var GET_TCH_STT_OK = exports.GET_TCH_STT_OK = 'GET_TCH_STT_OK';
	
	var T_LOG_IN = exports.T_LOG_IN = 'T_LOG_IN';
	var T_LOG_IN_FAILED = exports.T_LOG_IN_FAILED = 'T_LOG_IN_FAILED';
	var T_LOG_IN_OK = exports.T_LOG_IN_OK = 'T_LOG_IN_OK';
	
	// classroom
	var RGST_CLSROOM = exports.RGST_CLSROOM = 'RGST_CLSROOM';
	var RGST_CLSROOM_FAILED = exports.RGST_CLSROOM_FAILED = 'RGST_CLSROOM_FAILED';
	var RGST_CLSROOM_OK = exports.RGST_CLSROOM_OK = 'RGST_CLSROOM_OK';
	
	var UPDATE_CLSROOM = exports.UPDATE_CLSROOM = 'UPDATE_CLSROOM';
	var UPDATE_CLSROOM_FAILED = exports.UPDATE_CLSROOM_FAILED = 'UPDATE_CLSROOM_FAILED';
	var UPDATE_CLSROOM_OK = exports.UPDATE_CLSROOM_OK = 'UPDATE_CLSROOM_OK';
	
	var GET_CLSROOM = exports.GET_CLSROOM = 'GET_CLSROOM';
	var GET_CLSROOM_FAILED = exports.GET_CLSROOM_FAILED = 'GET_CLSROOM_FAILED';
	var GET_CLSROOM_OK = exports.GET_CLSROOM_OK = 'GET_CLSROOM_OK';
	
	var GET_CLSROOM_LST = exports.GET_CLSROOM_LST = 'GET_CLSROOM_LST';
	var GET_CLSROOM_LST_FAILED = exports.GET_CLSROOM_LST_FAILED = 'GET_CLSROOM_LST_FAILED';
	var GET_CLSROOM_LST_OK = exports.GET_CLSROOM_LST_OK = 'GET_CLSROOM_LST_OK';
	
	// school
	var S_LOG_IN = exports.S_LOG_IN = 'S_LOG_IN';
	var S_LOG_IN_FAILED = exports.S_LOG_IN_FAILED = 'S_LOG_IN_FAILED';
	var S_LOG_IN_OK = exports.S_LOG_IN_OK = 'S_LOG_IN_OK';
	
	// Billy add school group list -- Nov.28.2017
	var S_GROUP_LIST = exports.S_GROUP_LIST = 'S_GROUP_LIST';
	var S_GROUP_LIST_OK = exports.S_GROUP_LIST_OK = 'S_GROUP_LIST_OK';
	var S_GROUP_LIST_FAILED = exports.S_GROUP_LIST_FAILED = 'S_GROUP_LIST_FAILED';
	
	// Billy add group list register --Nov.29.2017
	var RGST_GROUP_LIST = exports.RGST_GROUP_LIST = 'RGST_GROUP_LIST';
	var RGST_GROUP_LIST_OK = exports.RGST_GROUP_LIST_OK = 'RGST_GROUP_LIST_OK';
	var RGST_GROUP_LIST_FAILED = exports.RGST_GROUP_LIST_FAILED = 'RGST_GROUP_LIST_FAILED';
	
	// Billy add group list register --Nov.29.2017
	var GROUP_LIST_TEACHER = exports.GROUP_LIST_TEACHER = 'GROUP_LIST_TEACHER';
	var GROUP_LIST_TEACHER_OK = exports.GROUP_LIST_TEACHER_OK = 'GROUP_LIST_TEACHER_OK';
	var GROUP_LIST_TEACHER_FAILED = exports.GROUP_LIST_TEACHER_FAILED = 'GROUP_LIST_TEACHER_FAILED';
	
	// Billy add group detail -- Nov.29.2017
	var GET_GROUP_DETAIL = exports.GET_GROUP_DETAIL = 'GET_GROUP_DETAIL';
	var GET_GROUP_DETAIL_OK = exports.GET_GROUP_DETAIL_OK = 'GET_GROUP_DETAIL_OK';
	var GET_GROUP_DETAIL_FAILED = exports.GET_GROUP_DETAIL_FAILED = 'GET_GROUP_DETAIL_FAILED';
	
	// Billy add delete group -- Nov.30.2017
	var DELETE_GROUP = exports.DELETE_GROUP = 'DELETE_GROUP';
	var DELETE_GROUP_OK = exports.DELETE_GROUP_OK = 'DELETE_GROUP_OK';
	var DELETE_GROUP_FAILED = exports.DELETE_GROUP_FAILED = 'DELETE_GROUP_FAILED';
	
	// Billy add edit group detail -- Nov.30.2017
	var UPDATE_GROUP_LIST_TEACHER = exports.UPDATE_GROUP_LIST_TEACHER = 'UPDATE_GROUP_LIST_TEACHER';
	var UPDATE_GROUP_LIST_TEACHER_OK = exports.UPDATE_GROUP_LIST_TEACHER_OK = 'UPDATE_GROUP_LIST_TEACHER_OK';
	var UPDATE_GROUP_LIST_TEACHER_FAILED = exports.UPDATE_GROUP_LIST_TEACHER_FAILED = 'UPDATE_GROUP_LIST_TEACHER_FAILED';
	
	// Billy add update teacher group groupListTeacher
	var UPDATE_GROUP_LIST = exports.UPDATE_GROUP_LIST = 'UPDATE_GROUP_LIST';
	var UPDATE_GROUP_LIST_OK = exports.UPDATE_GROUP_LIST_OK = 'UPDATE_GROUP_LIST_OK';
	var UPDATE_GROUP_LIST_FAILED = exports.UPDATE_GROUP_LIST_FAILED = 'UPDATE_GROUP_LIST_FAILED';
	
	// Billy add school permission list -- Nov.29.2017
	var S_PERMISSION_LIST = exports.S_PERMISSION_LIST = 'S_PERMISSION_LIST';
	var S_PERMISSION_LIST_OK = exports.S_PERMISSION_LIST_OK = 'S_PERMISSION_LIST_OK';
	var S_PERMISSION_LIST_FAILED = exports.S_PERMISSION_LIST_FAILED = 'S_PERMISSION_LIST_FAILED';
	
	// Billy add register school -- Nov.08.2017
	var RGST_SCHOOL = exports.RGST_SCHOOL = 'RGST_SCHOOL';
	var RGST_SCHOOL_FAILED = exports.RGST_SCHOOL_FAILED = 'RGST_SCHOOL_FAILED';
	var RGST_SCHOOL_OK = exports.RGST_SCHOOL_OK = 'RGST_SCHOOL_OK';
	
	// Billy add school sign up -- Nov.07.2017
	var S_SIGN_UP = exports.S_SIGN_UP = 'S_SIGN_UP';
	var S_SIGN_UP_FAILED = exports.S_SIGN_UP_FAILED = 'S_SIGN_UP_FAILED';
	var S_SIGN_UP_OK = exports.S_SIGN_UP_OK = 'S_SIGN_UP_OK';
	
	var GET_SCH_TCH_LST = exports.GET_SCH_TCH_LST = 'GET_SCH_TCH_LST';
	var GET_SCH_TCH_LST_FAILED = exports.GET_SCH_TCH_LST_FAILED = 'GET_SCH_TCH_LST_FAILED';
	var GET_SCH_TCH_LST_OK = exports.GET_SCH_TCH_LST_OK = 'GET_SCH_TCH_LST_OK';
	
	var GET_SCH_STDT_LST = exports.GET_SCH_STDT_LST = 'GET_SCH_STDT_LST';
	var GET_SCH_STDT_LST_FAILED = exports.GET_SCH_STDT_LST_FAILED = 'GET_SCH_STDT_LST_FAILED';
	var GET_SCH_STDT_LST_OK = exports.GET_SCH_STDT_LST_OK = 'GET_SCH_STDT_LST_OK';
	
	var GET_USER_BY_TOKEN = exports.GET_USER_BY_TOKEN = 'GET_USER_BY_TOKEN';
	var GET_USER_BY_TOKEN_FAILED = exports.GET_USER_BY_TOKEN_FAILED = 'GET_USER_BY_TOKEN_FAILED';
	var GET_USER_BY_TOKEN_OK = exports.GET_USER_BY_TOKEN_OK = 'GET_USER_BY_TOKEN_OK';
	
	var REFRESH_TOKEN = exports.REFRESH_TOKEN = 'REFRESH_TOKEN';
	var REFRESH_TOKEN_FAILED = exports.REFRESH_TOKEN_FAILED = 'REFRESH_TOKEN_FAILED';
	var REFRESH_TOKEN_OK = exports.REFRESH_TOKEN_OK = 'REFRESH_TOKEN_OK';
	
	var CHANGE_PASSWD = exports.CHANGE_PASSWD = 'CHANGE_PASSWD';
	var CHANGE_PASSWD_FAILED = exports.CHANGE_PASSWD_FAILED = 'CHANGE_PASSWD_FAILED';
	var CHANGE_PASSWD_OK = exports.CHANGE_PASSWD_OK = 'CHANGE_PASSWD_OK';
	
	var SEND_PHONE_VRFCTION = exports.SEND_PHONE_VRFCTION = 'SEND_PHONE_VRFCTION';
	var SEND_PHONE_VRFCTION_FAILED = exports.SEND_PHONE_VRFCTION_FAILED = 'SEND_PHONE_VRFCTION_FAILED';
	var SEND_PHONE_VRFCTION_OK = exports.SEND_PHONE_VRFCTION_OK = 'SEND_PHONE_VRFCTION_OK';
	
	var GET_TRADE_LIST = exports.GET_TRADE_LIST = 'GET_TRADE_LIST';
	var GET_TRADE_LIST_FAILED = exports.GET_TRADE_LIST_FAILED = 'GET_TRADE_LIST_FAILED';
	var GET_TRADE_LIST_OK = exports.GET_TRADE_LIST_OK = 'GET_TRADE_LIST_OK';
	
	var GET_TRADE_NOTE = exports.GET_TRADE_NOTE = 'GET_TRADE_NOTE';
	var GET_TRADE_NOTE_FAILED = exports.GET_TRADE_NOTE_FAILED = 'GET_TRADE_NOTE_FAILED';
	var GET_TRADE_NOTE_OK = exports.GET_TRADE_NOTE_OK = 'GET_TRADE_NOTE_OK';
	
	var UPDATE_TRADE_NOTE = exports.UPDATE_TRADE_NOTE = 'UPDATE_TRADE_NOTE';
	var UPDATE_TRADE_NOTE_FAILED = exports.UPDATE_TRADE_NOTE_FAILED = 'UPDATE_TRADE_NOTE_FAILED';
	var UPDATE_TRADE_NOTE_OK = exports.UPDATE_TRADE_NOTE_OK = 'UPDATE_TRADE_NOTE_OK';
	
	var SEND_TRADE_EMAIL = exports.SEND_TRADE_EMAIL = 'SEND_TRADE_EMAIL';
	var SEND_TRADE_EMAIL_FAILED = exports.SEND_TRADE_EMAIL_FAILED = 'SEND_TRADE_EMAIL_FAILED';
	var SEND_TRADE_EMAIL_OK = exports.SEND_TRADE_EMAIL_OK = 'SEND_TRADE_EMAIL_OK';
	
	var GET_TIMETABLE = exports.GET_TIMETABLE = 'GET_TIMETABLE';
	var GET_TIMETABLE_FAILED = exports.GET_TIMETABLE_FAILED = 'GET_TIMETABLE_FAILED';
	var GET_TIMETABLE_OK = exports.GET_TIMETABLE_OK = 'GET_TIMETABLE_OK';
	
	// misc
	var SBMT_OPRT_LOG = exports.SBMT_OPRT_LOG = 'SBMT_OPRT_LOG';
	var SBMT_OPRT_LOG_FAILED = exports.SBMT_OPRT_LOG_FAILED = 'SBMT_OPRT_LOG_FAILED';
	var SBMT_OPRT_LOG_OK = exports.SBMT_OPRT_LOG_OK = 'SBMT_OPRT_LOG_OK';
	
	var GET_OPRT_LOG = exports.GET_OPRT_LOG = 'GET_OPRT_LOG';
	var GET_OPRT_LOG_FAILED = exports.GET_OPRT_LOG_FAILED = 'GET_OPRT_LOG_FAILED';
	var GET_OPRT_LOG_OK = exports.GET_OPRT_LOG_OK = 'GET_OPRT_LOG_OK';
	
	// Upgrade to Permium Version -- Billy Dec 06.2017
	var PAYMENT_METHOD = exports.PAYMENT_METHOD = 'PAYMENT_METHOD';
	var PAYMENT_METHOD_OK = exports.PAYMENT_METHOD_OK = 'PAYMENT_METHOD_OK';
	var PAYMENT_METHOD_FAILED = exports.PAYMENT_METHOD_FAILED = 'PAYMENT_METHOD_FAILED';
	
	var SUBSCRIPTION = exports.SUBSCRIPTION = 'SUBSCRIPTION';
	var SUBSCRIPTION_OK = exports.SUBSCRIPTION_OK = 'SUBSCRIPTION_OK';
	var SUBSCRIPTION_FAILED = exports.SUBSCRIPTION_FAILED = 'SUBSCRIPTION_FAILED';
	
	var GET_SUBSCRIPTION = exports.GET_SUBSCRIPTION = 'GET_SUBSCRIPTION';
	var GET_SUBSCRIPTION_OK = exports.GET_SUBSCRIPTION_OK = 'GET_SUBSCRIPTION_OK';
	var GET_SUBSCRIPTION_FAILED = exports.GET_SUBSCRIPTION_FAILED = 'GET_SUBSCRIPTION_FAILED';
	
	var TEACHER_CONFIRMATION = exports.TEACHER_CONFIRMATION = 'TEACHER_CONFIRMATION';
	var TEACHER_CONFIRMATION_OK = exports.TEACHER_CONFIRMATION_OK = 'TEACHER_CONFIRMATION_OK';
	var TEACHER_CONFIRMATION_FAILED = exports.TEACHER_CONFIRMATION_FAILED = 'TEACHER_CONFIRMATION_FAILED';
	
	var G_S_CURRENT_TEACHER = exports.G_S_CURRENT_TEACHER = 'G_S_CURRENT_TEACHER';
	var G_S_CURRENT_TEACHER_OK = exports.G_S_CURRENT_TEACHER_OK = 'G_S_CURRENT_TEACHER_OK';
	var G_S_CURRENT_TEACHER_FAILED = exports.G_S_CURRENT_TEACHER_FAILED = 'G_S_CURRENT_TEACHER';
	
	var G_S_ARCHIVED_TEACHER = exports.G_S_ARCHIVED_TEACHER = 'G_S_ARCHIVED_TEACHER';
	var G_S_ARCHIVED_TEACHER_OK = exports.G_S_ARCHIVED_TEACHER_OK = 'G_S_ARCHIVED_TEACHER_OK';
	var G_S_ARCHIVED_TEACHER_FAILED = exports.G_S_ARCHIVED_TEACHER_FAILED = 'G_S_ARCHIVED_TEACHER';
	
	var INVITE_TEACHER = exports.INVITE_TEACHER = 'INVITE_TEACHER';
	var INVITE_TEACHER_OK = exports.INVITE_TEACHER_OK = 'INVITE_TEACHER_OK';
	var INVITE_TEACHER_FAILED = exports.INVITE_TEACHER_FAILED = 'INVITE_TEACHER_FAILED';
	
	var DELETE_SCHOOL = exports.DELETE_SCHOOL = 'DELETE_SCHOOL';
	var DELETE_SCHOOL_OK = exports.DELETE_SCHOOL_OK = 'DELETE_SCHOOL_OK';
	var DELETE_SCHOOL_FAILED = exports.DELETE_SCHOOL_FAILED = 'DELETE_SCHOOL_FAILED';
	
	var G_TEACHER_EXIT = exports.G_TEACHER_EXIT = 'G_TEACHER_EXIT';
	var G_TEACHER_EXIT_OK = exports.G_TEACHER_EXIT_OK = 'G_TEACHER_EXIT_OK';
	var G_TEACHER_EXIT_FAILED = exports.G_TEACHER_EXIT_FAILED = 'G_TEACHER_EXIT_FAILED';
	
	var M_S_ARCHIVED = exports.M_S_ARCHIVED = 'M_S_ARCHIVED';
	var M_S_ARCHIVED_OK = exports.M_S_ARCHIVED_OK = 'M_S_ARCHIVED_OK';
	var M_S_ARCHIVED_FAILED = exports.M_S_ARCHIVED_FAILED = 'M_S_ARCHIVED_FAILED';
	
	// Ryan add UI actions
	var UPDATE_HEADER_HIGHLIGHT = exports.UPDATE_HEADER_HIGHLIGHT = 'UPDATE_HEADER_HIGHLIGHT';
	
	var GET_MONTHLY_FINANCE = exports.GET_MONTHLY_FINANCE = 'GET_MONTHLY_FINANCE';
	var GET_MONTHLY_FINANCE_OK = exports.GET_MONTHLY_FINANCE_OK = 'GET_MONTHLY_FINANCE_OK';
	var GET_MONTHLY_FINANCE_FAILED = exports.GET_MONTHLY_FINANCE_FAILED = 'GET_MONTHLY_FINANCE_FAILED';

/***/ },

/***/ "sktl":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_CLS_BY_ID:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_CLS_BY_ID_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_CLS_BY_ID_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "7bm9":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_CLS_BY_TYPE:
	    case _ActionTypes.GET_CLS_BY_KEY:
	      {
	        return _extends({}, state, { list: [] });
	      }
	    case _ActionTypes.GET_CLS_BY_TYPE_OK:
	    case _ActionTypes.GET_CLS_BY_KEY_OK:
	      {
	        var list = action.list;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { list: list });
	      }
	    case _ActionTypes.GET_CLS_BY_TYPE_FAILED:
	    case _ActionTypes.GET_CLS_BY_KEY_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "1UrD":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_CLS_STDT:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_CLS_STDT_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_CLS_STDT_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "YAtA":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_CLS_STDT_STT:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.UPDATE_CLS_STDT_STT_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.UPDATE_CLS_STDT_STT_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "EhWx":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_CLS_STT:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.UPDATE_CLS_STT_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.UPDATE_CLS_STT_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "6aop":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_CLS_TCH:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_CLS_TCH_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_CLS_TCH_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "ejIE":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_CLS_TCH:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.UPDATE_CLS_TCH_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.UPDATE_CLS_TCH_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "hQRu":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_CLS_STDT:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.UPDATE_CLS_STDT_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.UPDATE_CLS_STDT_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "Vqj8":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.CLS_JOIN_MULTI:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.CLS_JOIN_MULTI_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.CLS_JOIN_MULTI_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "3yA2":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_CLS_CT_BY_TYPE:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_CLS_CT_BY_TYPE_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_CLS_CT_BY_TYPE_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "4dkR":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_CLS:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.UPDATE_CLS_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.UPDATE_CLS_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "pQv2":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_CHC_STT:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_CHC_STT_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_CHC_STT_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "FIdM":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_CLS_LSS:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_CLS_LSS_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_CLS_LSS_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "h8QV":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.ADD_CLS_LSS:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.ADD_CLS_LSS_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.ADD_CLS_LSS_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "3OcF":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.DELETE_CLS_LSS:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.DELETE_CLS_LSS_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.DELETE_CLS_LSS_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "Kwcg":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_CLS_LSS_STDT:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_CLS_LSS_STDT_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_CLS_LSS_STDT_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "mw1U":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.ADD_CLS_LSS_STDT:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.ADD_CLS_LSS_STDT_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.ADD_CLS_LSS_STDT_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "jhQH":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_CLS_LSS:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.UPDATE_CLS_LSS_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.UPDATE_CLS_LSS_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "BKSr":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_STDT_CHC_STT:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.UPDATE_STDT_CHC_STT_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.UPDATE_STDT_CHC_STT_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "nguk":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_LSS_TCH:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.UPDATE_LSS_TCH_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.UPDATE_LSS_TCH_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "p4Ur":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.S_CHECK_NOTE:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.S_CHECK_NOTE_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.S_CHECK_NOTE_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "MNXn":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.T_CHECK_NOTE:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.T_CHECK_NOTE_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.T_CHECK_NOTE_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "luLD":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.ADD_LSN_WITH_TIME:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.ADD_LSN_WITH_TIME_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.ADD_LSN_WITH_TIME_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "t0wH":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_LSN_WITH_TIME:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.UPDATE_LSN_WITH_TIME_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.UPDATE_LSN_WITH_TIME_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "wm/+":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.ADD_MULTI_LSN_WITH_TIME:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.ADD_MULTI_LSN_WITH_TIME_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.ADD_MULTI_LSN_WITH_TIME_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "TLYC":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_SCH_STDT_LST:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_SCH_STDT_LST_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_SCH_STDT_LST_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "3Xuc":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_SCH_TCH_LST:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_SCH_TCH_LST_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_SCH_TCH_LST_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "6nHS":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.S_SIGN_UP:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.S_SIGN_UP_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.S_SIGN_UP_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "N8yg":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.RGST_SCHOOL:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.RGST_SCHOOL_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.RGST_SCHOOL_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "IrP6":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.REFRESH_TOKEN:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.REFRESH_TOKEN_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.REFRESH_TOKEN_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "VvK/":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.CHANGE_PASSWD:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.CHANGE_PASSWD_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.CHANGE_PASSWD_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "RoZr":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.SEND_PHONE_VRFCTION:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.SEND_PHONE_VRFCTION_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.SEND_PHONE_VRFCTION_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "JBzd":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_TRADE_LIST:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_TRADE_LIST_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_TRADE_LIST_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "FwmL":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.SEND_TRADE_EMAIL:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.SEND_TRADE_EMAIL_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.SEND_TRADE_EMAIL_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "6o6k":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_TRADE_NOTE:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_TRADE_NOTE_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_TRADE_NOTE_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "+FWb":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_TRADE_NOTE:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.UPDATE_TRADE_NOTE_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.UPDATE_TRADE_NOTE_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "HWCZ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_TIMETABLE:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_TIMETABLE_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_TIMETABLE_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "mNT4":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.S_GROUP_LIST:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.S_GROUP_LIST_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.S_GROUP_LIST_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "d2QZ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.S_PERMISSION_LIST:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.S_PERMISSION_LIST_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.S_PERMISSION_LIST_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "7hKR":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.RGST_GROUP_LIST:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.RGST_GROUP_LIST_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.RGST_GROUP_LIST_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "rzL2":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GROUP_LIST_TEACHER:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GROUP_LIST_TEACHER_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GROUP_LIST_TEACHER_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "iYHi":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_GROUP_DETAIL:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_GROUP_DETAIL_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_GROUP_DETAIL_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "/gPV":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.DELETE_GROUP:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.DELETE_GROUP_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, result);
	      }
	    case _ActionTypes.DELETE_GROUP_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "h1Jb":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_GROUP_LIST:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.UPDATE_GROUP_LIST_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.UPDATE_GROUP_LIST_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "9Nf5":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_GROUP_LIST_TEACHER:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.UPDATE_GROUP_LIST_TEACHER_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.UPDATE_GROUP_LIST_TEACHER_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "Ir40":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.RGST_STDT:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.RGST_STDT_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.RGST_STDT_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "2WtU":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_STDT_CHC_RCD:
	      {
	        return _extends({}, state, { list: [] });
	      }
	    case _ActionTypes.GET_STDT_CHC_RCD_OK:
	      {
	        var list = action.list;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { list: list });
	      }
	    case _ActionTypes.GET_STDT_CHC_RCD_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "Hpt0":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_STDT_CRT_CLS:
	      {
	        return _extends({}, state, { list: [] });
	      }
	    case _ActionTypes.GET_STDT_CRT_CLS_OK:
	      {
	        var list = action.list;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { list: list });
	      }
	    case _ActionTypes.GET_STDT_CRT_CLS_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "asZ3":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_STDT_HST_CLS:
	      {
	        return _extends({}, state, { list: [] });
	      }
	    case _ActionTypes.GET_STDT_HST_CLS_OK:
	      {
	        var list = action.list;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { list: list });
	      }
	    case _ActionTypes.GET_STDT_HST_CLS_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "2Yj6":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_STDT_INFO:
	      {
	        return _extends({}, state, { info: null });
	      }
	    case _ActionTypes.GET_STDT_INFO_OK:
	      {
	        var info = action.info;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { info: info });
	      }
	    case _ActionTypes.GET_STDT_INFO_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "c9NW":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_STDT_ATTRIBUTE:
	      {
	        return _extends({}, state, { attr: null });
	      }
	    case _ActionTypes.GET_STDT_ATTRIBUTE_OK:
	      {
	        var attr = action.attr;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { attr: attr });
	      }
	    case _ActionTypes.GET_STDT_ATTRIBUTE_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "mn5V":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_STDT_CREDIT:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_STDT_CREDIT_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_STDT_CREDIT_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "BvbT":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_STDT_INFO:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.UPDATE_STDT_INFO_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.UPDATE_STDT_INFO_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "V753":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_STDT_LOG:
	      {
	        return _extends({}, state, { list: [] });
	      }
	    case _ActionTypes.GET_STDT_LOG_OK:
	      {
	        var list = action.list;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { list: list });
	      }
	    case _ActionTypes.GET_STDT_LOG_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "bV2V":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_STDT_SMR:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_STDT_SMR_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_STDT_SMR_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "bwN8":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_STDT_SMR_CT:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_STDT_SMR_CT_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_STDT_SMR_CT_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "pFi5":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_TRADE:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_TRADE_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_TRADE_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "E+ko":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_TRADE:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.UPDATE_TRADE_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.UPDATE_TRADE_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "c1uH":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_TRADE2:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.UPDATE_TRADE2_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.UPDATE_TRADE2_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "BKNI":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_STDT_HST_TRADE:
	      {
	        return _extends({}, state, { list: [] });
	      }
	    case _ActionTypes.GET_STDT_HST_TRADE_OK:
	      {
	        var list = action.list;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { list: list });
	      }
	    case _ActionTypes.GET_STDT_HST_TRADE_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "Fby7":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_SCH_STDT_STT:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.UPDATE_SCH_STDT_STT_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.UPDATE_SCH_STDT_STT_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "K29h":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.M_S_ARCHIVED:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.M_S_ARCHIVED_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.M_S_ARCHIVED_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "buwc":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.RGST_TCH:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.RGST_TCH_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.RGST_TCH_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "plZL":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_TCH_INFO:
	      {
	        return _extends({}, state, { info: null });
	      }
	    case _ActionTypes.GET_TCH_INFO_OK:
	      {
	        var info = action.info;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { info: info });
	      }
	    case _ActionTypes.GET_TCH_INFO_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "MPtr":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_TCH_STT:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_TCH_STT_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_TCH_STT_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "DGas":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_TCH:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.UPDATE_TCH_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.UPDATE_TCH_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "XqNl":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.T_LOG_IN:
	      {
	        return _extends({}, state, { student: [] });
	      }
	    case _ActionTypes.T_LOG_IN_OK:
	      {
	        var student = action.student;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { student: student });
	      }
	    case _ActionTypes.T_LOG_IN_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "Yvru":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_TCH_CHC_RCD:
	      {
	        return _extends({}, state, { list: [] });
	      }
	    case _ActionTypes.GET_TCH_CHC_RCD_OK:
	      {
	        var list = action.list;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { list: list });
	      }
	    case _ActionTypes.GET_TCH_CHC_RCD_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "8YrF":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_CLSROOM:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_CLSROOM_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_CLSROOM_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "W78K":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_CLSROOM_LST:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_CLSROOM_LST_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_CLSROOM_LST_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "AvIb":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.RGST_CLSROOM:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.RGST_CLSROOM_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.RGST_CLSROOM_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "7Ezr":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_CLSROOM:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.UPDATE_CLSROOM_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.UPDATE_CLSROOM_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "X+eT":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.ADD_ANN:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.ADD_ANN_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.ADD_ANN_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "+NAs":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_ANN_LIST:
	      {
	        return _extends({}, state, { result: [] });
	      }
	    case _ActionTypes.GET_ANN_LIST_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.GET_ANN_LIST_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "JfP5":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.OPERATE_ANN:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.OPERATE_ANN_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.OPERATE_ANN_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "28av":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.PAYMENT_METHOD:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.PAYMENT_METHOD_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.PAYMENT_METHOD_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "jYsE":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.SUBSCRIPTION:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.SUBSCRIPTION_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.SUBSCRIPTION_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "4xrm":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.TEACHER_CONFIRMATION:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.TEACHER_CONFIRMATION_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.TEACHER_CONFIRMATION_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "4yXo":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.DELETE_SCHOOL:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.DELETE_SCHOOL_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, result);
	      }
	    case _ActionTypes.DELETE_SCHOOL_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "OJwi":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.G_S_CURRENT_TEACHER:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.G_S_CURRENT_TEACHER_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.G_S_CURRENT_TEACHER_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "02e3":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.G_S_ARCHIVED_TEACHER:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.G_S_ARCHIVED_TEACHER_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.G_S_ARCHIVED_TEACHER_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "/TtL":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.INVITE_TEACHER:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.INVITE_TEACHER_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.INVITE_TEACHER_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "hZPP":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.G_TEACHER_EXIT:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.G_TEACHER_EXIT_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, { result: result });
	      }
	    case _ActionTypes.G_TEACHER_EXIT_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	module.exports = exports['default'];

/***/ },

/***/ "vw3Y":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.resetTotalSalary = exports.setTotalSalary = exports.DEFAULT_PAGINATION = exports.SET_SALARY = exports.RESET_SALARY = exports.FAILED_FETCH_ATTENDANCE = exports.SUCCESS_FETCH_ATTENDANCE = exports.START_FETCH_ATTENDANCE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchAttendance = fetchAttendance;
	exports.default = getAttendance;
	
	var _teacherAttendanceRecord = __webpack_require__("2SmJ");
	
	var _teacherAttendanceRecord2 = _interopRequireDefault(_teacherAttendanceRecord);
	
	var _studentAttendanceRecord = __webpack_require__("ZTkw");
	
	var _studentAttendanceRecord2 = _interopRequireDefault(_studentAttendanceRecord);
	
	var _isEqual = __webpack_require__("hygk");
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var START_FETCH_ATTENDANCE = exports.START_FETCH_ATTENDANCE = 'START_FETCH_ATTENDANCE';
	var SUCCESS_FETCH_ATTENDANCE = exports.SUCCESS_FETCH_ATTENDANCE = 'SUCCESS_FETCH_ATTENDANCE';
	var FAILED_FETCH_ATTENDANCE = exports.FAILED_FETCH_ATTENDANCE = 'FAILED_FETCH_ATTENDANCE';
	
	var RESET_SALARY = exports.RESET_SALARY = 'RESET_SALARY';
	var SET_SALARY = exports.SET_SALARY = 'SET_SALARY';
	
	var DEFAULT_PAGINATION = exports.DEFAULT_PAGINATION = {
	  activePage: 0,
	  itemsCountPerPage: 10,
	  totalItemsCount: 0
	};
	
	function fetchAttendance(schoolId, state, attendanceInfo, callback) {
	
	  return function (dispatch) {
	    dispatch({
	      type: START_FETCH_ATTENDANCE,
	      payload: {
	        fetching: true
	      }
	    });
	
	    var controllerFunction = state == 'teacher' ? _teacherAttendanceRecord2.default : _studentAttendanceRecord2.default;
	
	    controllerFunction(schoolId, attendanceInfo).then(function (result) {
	
	      dispatch({
	        type: SUCCESS_FETCH_ATTENDANCE,
	        payload: _extends({}, result, { fetching: false })
	      });
	
	      if (typeof callback == 'function') {
	        callback();
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_ATTENDANCE,
	        payload: err
	      });
	    });
	  };
	}
	
	var setTotalSalary = exports.setTotalSalary = function setTotalSalary(salary) {
	  return {
	    type: SET_SALARY,
	    payload: salary
	  };
	};
	
	var resetTotalSalary = exports.resetTotalSalary = function resetTotalSalary() {
	  return {
	    type: RESET_SALARY
	  };
	};
	
	var initState = {
	  list: [],
	  pagination: DEFAULT_PAGINATION,
	  totalSalary: 0
	};
	
	function getAttendance() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case START_FETCH_ATTENDANCE:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case SUCCESS_FETCH_ATTENDANCE:
	      {
	        var resetSalary = {};
	
	        if ((0, _isEqual2.default)(state.list, action.payload.result_list) !== true || action.payload.result_list.length == 0) {
	          resetSalary = {
	            totalSalary: 0
	          };
	        }
	
	        return _extends({}, state, {
	          list: action.payload.result_list,
	          teacher_name: action.payload.teacher_name,
	          unchecked_count: action.payload.total_unchecked_amount,
	          unchecked_hour: action.payload.total_unchecked_duration,
	          attended_count: action.payload.total_counted_amount,
	          attended_hour: action.payload.total_counted_duration,
	          unattended_count: action.payload.total_absent_amount,
	          unattended_hour: action.payload.total_absent_duration,
	          absent_count: action.payload.total_leave_amount,
	          absent_hour: action.payload.total_leave_duration,
	          truancy_count: action.payload.total_truancy_amount,
	          truancy_hour: action.payload.total_truancy_duration,
	          late_count: action.payload.total_late_amount,
	          late_hour: action.payload.total_late_duration,
	          normal_count: action.payload.total_normal_amount,
	          normal_hour: action.payload.total_normal_duration,
	          retroactive_count: action.payload.total_retroactive_amount,
	          fetching: action.payload.fetching,
	          result: action.payload.result,
	          reason: action.payload.reason
	        }, resetSalary, {
	
	          pagination: {
	            itemsCountPerPage: action.payload.amount_per_page || 10,
	            activePage: action.payload.current_page_number || 1,
	            totalItemsCount: action.payload.total_record_amount || 0
	          }
	
	        });
	      }
	    case FAILED_FETCH_ATTENDANCE:
	      {
	        return state;
	      }
	
	    case RESET_SALARY:
	      {
	        return _extends({}, state, { totalSalary: 0 });
	      }
	
	    case SET_SALARY:
	      {
	        return _extends({}, state, { totalSalary: action.payload });
	      }
	
	    default:
	      return _extends({}, state);
	  }
	}
	
	//

/***/ },

/***/ "2SmJ":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = teacherAttendanceRecord;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATE = ['absent (without notice)', 'attended', 'absent (with excuse)'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  start_date: _joiBrowser2.default.string().required(),
	  end_date: _joiBrowser2.default.string().required(),
	  class_id_list: _joiBrowser2.default.array().allow(''),
	  state: _joiBrowser2.default.string().valid(STATE).allow(''),
	  amount_per_page: _joiBrowser2.default.number().integer().allow(''),
	  current_page_number: _joiBrowser2.default.number().integer().allow('')
	});
	
	function teacherAttendanceRecord(teacherId, attendanceInfo) {
	
	  if (!teacherId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing teacher Id (number)')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(attendanceInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, attendanceInfo, {
	    state: !attendanceInfo.state ? '' : STATE.indexOf(attendanceInfo.state)
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/t_check_rcd/" + teacherId + "/",
	      'method': 'POST',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "ZTkw":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = studentAttendanceRecord;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATE = ['unchecked', 'attended', 'absent (with excuse)', 'late', 'absent (without notice)'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  start_date: _joiBrowser2.default.string().required(),
	  end_date: _joiBrowser2.default.string().required(),
	  class_id_list: _joiBrowser2.default.array().allow(''),
	  state: _joiBrowser2.default.string().valid(STATE).allow(''),
	  amount_per_page: _joiBrowser2.default.number().integer().allow(''),
	  current_page_number: _joiBrowser2.default.number().integer().allow('')
	});
	
	function studentAttendanceRecord(studentId, attendanceInfo) {
	
	  if (!studentId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing student Id (number)')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(attendanceInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, attendanceInfo, {
	    state: !attendanceInfo.state ? '' : STATE.indexOf(attendanceInfo.state)
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/s_check_rcd/" + studentId + "/",
	      'method': 'POST',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "1iVG":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CHANGE_LOCALE = undefined;
	
	exports.default = function () {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		switch (action.type) {
			case CHANGE_LOCALE:
				return action.newLocale;
				break;
			default:
				return state;
		}
	};
	
	exports.changeLocale = changeLocale;
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Constructor = __webpack_require__("CqEj");
	
	var _Constructor2 = _interopRequireDefault(_Constructor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CHANGE_LOCALE = exports.CHANGE_LOCALE = "CHANGE_LOCALE";
	
	function changeLocale(newLocale) {
	
		// We create a new locale object and assign it's show() method
		// as global function __
		var locale = new _Constructor2.default(newLocale);
		window.__ = locale.init();
	
		_store2.default.dispatch({
			type: CHANGE_LOCALE,
			newLocale: newLocale
		});
	}

/***/ },

/***/ "MusF":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.DEV_TOGGLE_LOCALE_LABEL = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * Dev related Redux states
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   */
	
	
	exports.default = function () {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		if (true) {
			return {};
		}
		switch (action.type) {
			case DEV_TOGGLE_LOCALE_LABEL:
				return _extends({}, state, {
					showLocaleLabel: state.showLocaleLabel ? false : true
				});
				break;
			default:
				return state;
		}
	};
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEV_TOGGLE_LOCALE_LABEL = exports.DEV_TOGGLE_LOCALE_LABEL = "DEV_TOGGLE_LOCALE_LABEL";

/***/ },

/***/ "l6bW":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.GET_MONTHLY_FINANCE:
	      {
	        return _extends({}, state, { result: null });
	      }
	    case _ActionTypes.GET_MONTHLY_FINANCE_OK:
	      {
	        var result = action.result;
	
	        if (state.error) {
	          delete state.error;
	        }
	        return _extends({}, state, result);
	      }
	    case _ActionTypes.GET_MONTHLY_FINANCE_FAILED:
	      {
	        return _extends({}, state, { error: action.error });
	      }
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	var initialState = {};
	
	module.exports = exports['default'];

/***/ },

/***/ "yDaX":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DEFAULT_PAGINATION = exports.SUCCESS_FETCH_TEACHER = exports.FAILED_FETCH_TEACHER = exports.START_FETCH_TEACHER = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchTeacher = fetchTeacher;
	exports.default = teacherList;
	
	var _getCurrentTeacher = __webpack_require__("PRcT");
	
	var _getCurrentTeacher2 = _interopRequireDefault(_getCurrentTeacher);
	
	var _getArchivedTeacher = __webpack_require__("TZzc");
	
	var _getArchivedTeacher2 = _interopRequireDefault(_getArchivedTeacher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// calling both current and archived teacher
	var START_FETCH_TEACHER = exports.START_FETCH_TEACHER = 'START_FETCH_TEACHER';
	var FAILED_FETCH_TEACHER = exports.FAILED_FETCH_TEACHER = 'FAILED_FETCH_TEACHER';
	var SUCCESS_FETCH_TEACHER = exports.SUCCESS_FETCH_TEACHER = 'SUCCESS_FETCH_TEACHER';
	
	var DEFAULT_PAGINATION = exports.DEFAULT_PAGINATION = {
	  activePage: 1,
	  itemsCountPerPage: 25,
	  totalItemsCount: 0
	};
	
	function fetchTeacher(opts, state) {
	
	  return function (dispatch) {
	
	    dispatch({
	      type: START_FETCH_TEACHER,
	      payload: {
	        fetching: true,
	        teacherState: state
	      }
	    });
	
	    var controllerFunction = state == 'current' ? _getCurrentTeacher2.default : _getArchivedTeacher2.default;
	
	    controllerFunction(opts).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_TEACHER,
	        payload: _extends({}, result, { fetching: false, hasPermission: true })
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_TEACHER,
	        payload: { err: err, hasPermission: false, fetching: false }
	      });
	    });
	  };
	}
	
	var initState = {
	  list: [],
	  pagination: DEFAULT_PAGINATION
	};
	
	function teacherList() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case START_FETCH_TEACHER:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case SUCCESS_FETCH_TEACHER:
	      {
	        var _action$payload = action.payload,
	            list = _action$payload.list,
	            count = _action$payload.count,
	            fetching = _action$payload.fetching,
	            hasPermission = _action$payload.hasPermission,
	            school_has_teacher = _action$payload.school_has_teacher;
	
	        return _extends({}, state, {
	          list: list,
	          count: count,
	          fetching: fetching,
	          hasPermission: hasPermission,
	          school_has_teacher: school_has_teacher,
	          pagination: {
	            itemsCountPerPage: action.payload.amount_per_page,
	            activePage: action.payload.current_page_number,
	            totalItemsCount: action.payload.total_amount
	          }
	        });
	      }
	    case FAILED_FETCH_TEACHER:
	      {
	        var _action$payload2 = action.payload,
	            err = _action$payload2.err,
	            _hasPermission = _action$payload2.hasPermission,
	            _fetching = _action$payload2.fetching;
	
	        return _extends({}, state, { err: err, hasPermission: _hasPermission, fetching: _fetching });
	      }
	
	    default:
	      return _extends({}, state);
	  }
	}
	
	//

/***/ },

/***/ "TZzc":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getArchivedTeacher;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getArchivedTeacher(opts) {
	
	  if (!opts.schoolId) {
	    throw 'Missing school ID';
	  }
	
	  var query = _queryString2.default.stringify({
	    amount_per_page: opts.amount_per_page,
	    current_page_number: opts.current_page_number,
	    keyword: opts.keyword,
	    order_by: opts.order_by
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/rgst_tch/' + opts.schoolId + '/?archived=true&' + query,
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "wTtZ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DEFAULT_PAGINATION = exports.SUCCESS_FETCH_CLASS = exports.FAILED_FETCH_CLASS = exports.START_FETCH_CLASS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchClass = fetchClass;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	
	    case START_FETCH_CLASS:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case SUCCESS_FETCH_CLASS:
	      {
	        return _extends({}, state, {
	          list: action.payload.classList,
	          count: action.payload.classCount,
	          fetching: action.payload.fetching,
	          hasPermission: action.payload.hasPermission,
	          school_has_class: action.payload.school_has_class,
	          pagination: {
	            itemsCountPerPage: action.payload.amount_per_page,
	            activePage: action.payload.current_page_number,
	            totalItemsCount: action.payload.total_amount
	          }
	        });
	      }
	    case FAILED_FETCH_CLASS:
	      {
	        return _extends({}, state, {
	          err: action.payload.error,
	          hasPermission: action.payload.hasPermission,
	          fetching: action.payload.fetching
	        });
	      }
	
	    default:
	      return _extends({}, state);
	  }
	};
	
	var _getClassBy = __webpack_require__("OC/R");
	
	var _getClassBy2 = _interopRequireDefault(_getClassBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var START_FETCH_CLASS = exports.START_FETCH_CLASS = 'START_FETCH_CURRENT_CLASS';
	var FAILED_FETCH_CLASS = exports.FAILED_FETCH_CLASS = 'FAILED_FETCH_CURRENT_CLASS';
	var SUCCESS_FETCH_CLASS = exports.SUCCESS_FETCH_CLASS = 'SUCCESS_FETCH_CURRENT_CLASS';
	
	var DEFAULT_PAGINATION = exports.DEFAULT_PAGINATION = {
	  activePage: 1,
	  itemsCountPerPage: 25,
	  totalItemsCount: 0
	};
	
	function fetchClass(opts) {
	
	  return function (dispatch) {
	
	    dispatch({
	      type: START_FETCH_CLASS,
	      payload: { fetching: true }
	    });
	
	    (0, _getClassBy2.default)(opts).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_CLASS,
	        payload: _extends({}, result, { fetching: false, hasPermission: true })
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_CLASS,
	        payload: {
	          error: err,
	          hasPermission: false,
	          fetching: false
	        }
	      });
	    });
	  };
	}
	
	var initState = {
	  list: [],
	  pagination: DEFAULT_PAGINATION
	};

/***/ },

/***/ "I0d0":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DEFAULT_PAGINATION = exports.SUCCESS_FETCH_CLASSROOM = exports.FAILED_FETCH_CLASSROOM = exports.START_FETCH_CLASSROOM = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchClassroom = fetchClassroom;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	
	    case START_FETCH_CLASSROOM:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case SUCCESS_FETCH_CLASSROOM:
	      {
	        return _extends({}, state, {
	          list: action.payload.classroom_list,
	          count: action.payload.amount,
	          fetching: action.payload.fetching,
	          hasPermission: action.payload.hasPermission,
	          school_has_classroom: action.payload.school_has_classroom,
	          pagination: {
	            itemsCountPerPage: action.payload.amount_per_page,
	            activePage: action.payload.current_page_number,
	            totalItemsCount: action.payload.total_amount
	          }
	        });
	      }
	    case FAILED_FETCH_CLASSROOM:
	      {
	        return _extends({}, state, {
	          error: action.payload.err,
	          hasPermission: action.payload.hasPermission,
	          fetching: false
	        });
	      }
	
	    default:
	      return _extends({}, state);
	  }
	};
	
	var _getClassroom = __webpack_require__("QWKB");
	
	var _getClassroom2 = _interopRequireDefault(_getClassroom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var START_FETCH_CLASSROOM = exports.START_FETCH_CLASSROOM = 'START_FETCH_CLASSROOM';
	var FAILED_FETCH_CLASSROOM = exports.FAILED_FETCH_CLASSROOM = 'FAILED_FETCH_CLASSROOM';
	var SUCCESS_FETCH_CLASSROOM = exports.SUCCESS_FETCH_CLASSROOM = 'SUCCESS_FETCH_CLASSROOM';
	
	var DEFAULT_PAGINATION = exports.DEFAULT_PAGINATION = {
	  activePage: 1,
	  itemsCountPerPage: 25,
	  totalItemsCount: 0
	};
	
	function fetchClassroom(opts) {
	
	  return function (dispatch) {
	
	    dispatch({
	      type: START_FETCH_CLASSROOM,
	      payload: { fetching: true }
	    });
	
	    (0, _getClassroom2.default)(opts).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_CLASSROOM,
	        payload: _extends({}, result, { fetching: false, hasPermission: true })
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_CLASSROOM,
	        payload: { error: err, hasPermission: false, fetching: false }
	      });
	    });
	  };
	}
	
	var initState = {
	  list: [],
	  pagination: DEFAULT_PAGINATION
	};

/***/ },

/***/ "yhkM":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SET_FILTER_DATA = exports.SET_LOGGEDIN_TEACHER_ID = exports.SUCCESS_FETCH_SCHEDULE = exports.FAILED_FETCH_SCHEDULE = exports.START_FETCH_SCHEDULE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchSchedule = fetchSchedule;
	exports.setFilterData = setFilterData;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	
	    case START_FETCH_SCHEDULE:
	      {
	        return _extends({}, state, {
	          fetching: true
	        });
	      }
	    case SUCCESS_FETCH_SCHEDULE:
	      {
	        return _extends({}, state, {
	          events: action.events,
	          fetching: false
	        });
	      }
	    case FAILED_FETCH_SCHEDULE:
	      {
	        return _extends({}, state, {
	          error: action.error,
	          fetching: false
	        });
	      }
	
	    case SET_FILTER_DATA:
	      {
	        return _extends({}, state, {
	          filterData: action.filterData
	        });
	      }
	
	    case SET_LOGGEDIN_TEACHER_ID:
	      {
	        return _extends({}, state, {
	          loggedinTeacherId: action.loggedinTeacherId
	        });
	      }
	
	    default:
	      return _extends({}, state);
	  }
	};
	
	var _getTimetable = __webpack_require__("sxrQ");
	
	var _getTimetable2 = _interopRequireDefault(_getTimetable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var START_FETCH_SCHEDULE = exports.START_FETCH_SCHEDULE = 'START_FETCH_SCHEDULE';
	var FAILED_FETCH_SCHEDULE = exports.FAILED_FETCH_SCHEDULE = 'FAILED_FETCH_SCHEDULE';
	var SUCCESS_FETCH_SCHEDULE = exports.SUCCESS_FETCH_SCHEDULE = 'SUCCESS_FETCH_SCHEDULE';
	var SET_LOGGEDIN_TEACHER_ID = exports.SET_LOGGEDIN_TEACHER_ID = 'SET_LOGGEDIN_TEACHER_ID';
	
	var SET_FILTER_DATA = exports.SET_FILTER_DATA = 'SET_FILTER_DATA';
	
	function fetchSchedule(schoolId, fetchOption) {
	
	  return function (dispatch) {
	
	    dispatch({
	      type: START_FETCH_SCHEDULE
	    });
	
	    (0, _getTimetable2.default)(schoolId, fetchOption).then(function (_ref) {
	      var data = _ref.data;
	
	
	      dispatch({
	        type: SUCCESS_FETCH_SCHEDULE,
	        events: data.result_list
	      });
	    }).catch(function (error) {
	      dispatch({
	        type: FAILED_FETCH_SCHEDULE,
	        error: error
	      });
	    });
	  };
	}
	
	function setFilterData(filterData) {
	  return {
	    type: SET_FILTER_DATA,
	    filterData: filterData
	  };
	}
	
	var initState = {
	  events: [],
	  filterData: {}
	};

/***/ },

/***/ "sxrQ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = getTimetable;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  teacher_id: _joiBrowser2.default.array().allow(null),
	  class_id: _joiBrowser2.default.array().allow(null),
	  classroom_id: _joiBrowser2.default.array().allow(null),
	  student_id: _joiBrowser2.default.array().allow(null),
	  start_date: _joiBrowser2.default.string().allow(''),
	  end_date: _joiBrowser2.default.string().allow(''),
	  page_or_not: _joiBrowser2.default.number().integer(),
	  amount_per_page: _joiBrowser2.default.number().integer(),
	  page_number: _joiBrowser2.default.number().integer(),
	  detail: _joiBrowser2.default.number().allow(null)
	});
	
	function getTimetable(schoolId, params) {
	
	  if (!schoolId) {
	    throw 'Missing school ID';
	  }
	
	  var validateResult = _joiBrowser2.default.validate(params, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/timetable/' + schoolId + '/',
	      'method': 'POST',
	      'data': JSON.stringify(params),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "7wYd":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DEFAULT_PAGINATION = exports.FAILED_FETCH_TRADE_RECORD = exports.SUCCESS_FETCH_TRADE_RECORD = exports.START_FETCH_TRADE_RECORD = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchTradeRecord = fetchTradeRecord;
	exports.default = financeTable;
	
	var _getTradeRecord = __webpack_require__("KAiH");
	
	var _getTradeRecord2 = _interopRequireDefault(_getTradeRecord);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var START_FETCH_TRADE_RECORD = exports.START_FETCH_TRADE_RECORD = 'START_FETCH_TRADE_RECORD';
	var SUCCESS_FETCH_TRADE_RECORD = exports.SUCCESS_FETCH_TRADE_RECORD = 'SUCCESS_FETCH_TRADE_RECORD';
	var FAILED_FETCH_TRADE_RECORD = exports.FAILED_FETCH_TRADE_RECORD = 'FAILED_FETCH_TRADE_RECORD';
	
	var DEFAULT_PAGINATION = exports.DEFAULT_PAGINATION = {
	  activePage: 1,
	  itemsCountPerPage: 10,
	  totalItemsCount: 0
	};
	
	function fetchTradeRecord(schoolId, tradeInfo, pagination) {
	
	  return function (dispatch) {
	
	    dispatch({
	      type: START_FETCH_TRADE_RECORD,
	      payload: {
	        fetching: true
	      }
	    });
	
	    var activePage = pagination.activePage,
	        itemsCountPerPage = pagination.itemsCountPerPage;
	
	
	    var paramToServer = _extends({}, tradeInfo, {
	      paging_or_not: 1,
	      page_number: activePage,
	      amount_per_page: itemsCountPerPage
	    });
	
	    (0, _getTradeRecord2.default)(schoolId, paramToServer).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_TRADE_RECORD,
	        payload: _extends({}, result, { amount_per_page: itemsCountPerPage, fetching: false, hasPermission: true })
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_TRADE_RECORD,
	        payload: {
	          fetching: false,
	          hasPermission: false,
	          err: err
	        }
	      });
	    });
	  };
	}
	
	var initState = {
	  list: [],
	  pagination: DEFAULT_PAGINATION
	};
	
	function financeTable() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case START_FETCH_TRADE_RECORD:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case SUCCESS_FETCH_TRADE_RECORD:
	      {
	        var _action$payload = action.payload,
	            result_list = _action$payload.result_list,
	            current_page_number = _action$payload.current_page_number,
	            amount_per_page = _action$payload.amount_per_page,
	            total_record_amount = _action$payload.total_record_amount,
	            fetching = _action$payload.fetching,
	            hasPermission = _action$payload.hasPermission,
	            school_has_traderecord = _action$payload.school_has_traderecord;
	
	
	        return _extends({}, state, {
	          list: result_list,
	          fetching: fetching,
	          hasPermission: hasPermission,
	          school_has_traderecord: school_has_traderecord,
	          pagination: {
	            itemsCountPerPage: amount_per_page,
	            activePage: current_page_number,
	            totalItemsCount: total_record_amount
	          }
	        });
	      }
	    case FAILED_FETCH_TRADE_RECORD:
	      {
	        return _extends({}, state, { err: action.payload.err, hasPermission: action.payload.hasPermission, fetching: action.payload.fetching });
	      }
	
	    default:
	      return _extends({}, state);
	  }
	}

/***/ },

/***/ "KAiH":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = getTradeRecord;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  student_id_list: _joiBrowser2.default.array().allow(null),
	  class_id_list: _joiBrowser2.default.array().allow(null),
	  start_date: _joiBrowser2.default.string().allow('').allow(null),
	  end_date: _joiBrowser2.default.string().allow('').allow(null),
	  transaction_number: _joiBrowser2.default.string().allow('').allow(null),
	  paging_or_not: _joiBrowser2.default.number().integer(),
	  amount_per_page: _joiBrowser2.default.number().integer(),
	  page_number: _joiBrowser2.default.number().integer()
	});
	
	function getTradeRecord(schoolId, tradeInfo) {
	  if (!schoolId) {
	    throw "mssing a school ID";
	  }
	
	  var validateResult = _joiBrowser2.default.validate(tradeInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/search_trade_list/' + schoolId + '/',
	      'method': 'POST',
	      'data': JSON.stringify(tradeInfo),
	      'token': localStorage.getItem('token') }).then(function (res) {
	
	      //
	      // the backend returns { result: '' } when transaction_number is not found
	      // to keep the data integrity, we have added dummy result that includes
	      // an empty array for result_list and some number such as total_record_amount etc...
	      //
	      if (typeof res.data.result == 'string' && res.data.result.indexOf('no such transaction_number in database') > -1) {
	        resolve({
	          amount_per_page: tradeInfo.amount_per_page,
	          current_page_number: tradeInfo.page_number,
	          total_record_amount: 0,
	          result_list: []
	        });
	      } else {
	        resolve(res.data);
	      }
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "lDbx":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_FETCH_CLASS_LESSON = exports.SUCCESS_FETCH_CLASS_LESSON = exports.START_FETCH_CLASS_LESSON = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchClassLesson = fetchClassLesson;
	exports.default = classLessonDetail;
	
	var _getClassLesson = __webpack_require__("XDwt");
	
	var _getClassLesson2 = _interopRequireDefault(_getClassLesson);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// fetch class lesson
	var START_FETCH_CLASS_LESSON = exports.START_FETCH_CLASS_LESSON = 'START_FETCH_CLASS_LESSON';
	var SUCCESS_FETCH_CLASS_LESSON = exports.SUCCESS_FETCH_CLASS_LESSON = 'SUCCESS_FETCH_CLASS_LESSON';
	var FAILED_FETCH_CLASS_LESSON = exports.FAILED_FETCH_CLASS_LESSON = 'FAILED_FETCH_CLASS_LESSON';
	
	function fetchClassLesson(classId, params) {
	  return function (dispatch) {
	    dispatch({
	      type: START_FETCH_CLASS_LESSON,
	      payload: {
	        fetching: true
	      }
	    });
	
	    (0, _getClassLesson2.default)(classId, params).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_CLASS_LESSON,
	        payload: _extends({}, result, { fetching: false })
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_CLASS_LESSON,
	        payload: err
	      });
	    });
	  };
	}
	
	var initState = {
	  detail: {}
	};
	
	function classLessonDetail() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case START_FETCH_CLASS_LESSON:
	      {
	        // IMPORTANT NOTE: 
	        // When start fetching class lesson it's requred to empty out detail 
	        return _extends({}, state, action.payload, { detail: null });
	      }
	    case SUCCESS_FETCH_CLASS_LESSON:
	      {
	        return _extends({}, state, { detail: action.payload, fetching: action.payload.fetching });
	      }
	    case FAILED_FETCH_CLASS_LESSON:
	      {
	        return state;
	      }
	    default:
	      return _extends({}, state);
	  }
	}

/***/ },

/***/ "XDwt":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getClassLesson;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getClassLesson(classId, params) {
	
		var query = _queryString2.default.stringify({
			per_page: params.amount_per_page,
			page: params.current_page_number,
			after_today: params.after_today,
			detail: params.detail
		});
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, {
				'uri': "/g_cls_lss/" + classId + "/?" + query,
				'method': 'GET',
				'token': localStorage.getItem('token')
			}).then(function (res) {
				resolve(res.data);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports["default"];

/***/ },

/***/ "6mZg":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_FETCH_CLASS_STUDENT = exports.SUCCESS_FETCH_CLASS_STUDENT = exports.START_FETCH_CLASS_STUDENT = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchClassStudent = fetchClassStudent;
	exports.default = classStudentDetail;
	
	var _getClassStudent = __webpack_require__("Epyc");
	
	var _getClassStudent2 = _interopRequireDefault(_getClassStudent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var START_FETCH_CLASS_STUDENT = exports.START_FETCH_CLASS_STUDENT = 'START_FETCH_CLASS_STUDENT';
	var SUCCESS_FETCH_CLASS_STUDENT = exports.SUCCESS_FETCH_CLASS_STUDENT = 'SUCCESS_FETCH_CLASS_STUDENT';
	var FAILED_FETCH_CLASS_STUDENT = exports.FAILED_FETCH_CLASS_STUDENT = 'FAILED_FETCH_CLASS_STUDENT';
	
	function fetchClassStudent(classId) {
	  return function (dispatch) {
	    dispatch({
	      type: START_FETCH_CLASS_STUDENT,
	      payload: {
	        fetching: true
	      }
	    });
	
	    (0, _getClassStudent2.default)(classId).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_CLASS_STUDENT,
	        payload: _extends({}, result, { fetching: false })
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_CLASS_STUDENT,
	        payload: err
	      });
	    });
	  };
	}
	
	var initState = {
	  detail: {}
	};
	
	function classStudentDetail() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case START_FETCH_CLASS_STUDENT:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case SUCCESS_FETCH_CLASS_STUDENT:
	      {
	        return _extends({}, state, { detail: action.payload, fetching: action.payload.fetching });
	      }
	    case FAILED_FETCH_CLASS_STUDENT:
	      {
	        return state;
	      }
	    default:
	      return _extends({}, state);
	  }
	}

/***/ },

/***/ "Epyc":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getClassStudent;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getClassStudent(id) {
	
	  if (typeof id === 'undefined') {
	    throw new Error('class ID (number) is missing. getClassStudent(classId)');
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put('/proxy', {
	      'uri': '/g_cls_stdt/' + id + '/',
	      'method': 'GET',
	      'token': localStorage.getItem('token')
	    }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "DPWa":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_FETCH_CLASS_TEACHER = exports.SUCCESS_FETCH_CLASS_TEACHER = exports.START_FETCH_CLASS_TEACHER = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchClassTeacher = fetchClassTeacher;
	exports.default = classTeacherDetail;
	
	var _getClassTeacher = __webpack_require__("Vo3g");
	
	var _getClassTeacher2 = _interopRequireDefault(_getClassTeacher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var START_FETCH_CLASS_TEACHER = exports.START_FETCH_CLASS_TEACHER = 'START_FETCH_CLASS_TEACHER';
	var SUCCESS_FETCH_CLASS_TEACHER = exports.SUCCESS_FETCH_CLASS_TEACHER = 'SUCCESS_FETCH_CLASS_TEACHER';
	var FAILED_FETCH_CLASS_TEACHER = exports.FAILED_FETCH_CLASS_TEACHER = 'FAILED_FETCH_CLASS_TEACHER';
	
	function fetchClassTeacher(classId) {
	  return function (dispatch) {
	    dispatch({
	      type: START_FETCH_CLASS_TEACHER,
	      payload: {
	        fetching: true
	      }
	    });
	
	    (0, _getClassTeacher2.default)(classId).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_CLASS_TEACHER,
	        payload: _extends({}, result, { fetching: false })
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_CLASS_TEACHER,
	        payload: err
	      });
	    });
	  };
	}
	
	var initState = {
	  detail: {}
	};
	
	function classTeacherDetail() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case START_FETCH_CLASS_TEACHER:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case SUCCESS_FETCH_CLASS_TEACHER:
	      {
	        return _extends({}, state, { detail: action.payload, fetching: action.payload.fetching });
	      }
	    case FAILED_FETCH_CLASS_TEACHER:
	      {
	        return state;
	      }
	    default:
	      return _extends({}, state);
	  }
	}

/***/ },

/***/ "Vo3g":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getClassTeacher;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getClassTeacher(classId) {
	
	  if (typeof classId === 'undefined') {
	    throw new Error('class ID (number) is missing');
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put('/proxy', {
	      'uri': '/g_clstch/' + classId + '/',
	      'method': 'GET',
	      'token': localStorage.getItem('token')
	    }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "yuEY":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_FETCH_LESSON_ATTENDANCE = exports.SUCCESS_FETCH_LESSON_ATTENDANCE = exports.START_FETCH_LESSON_ATTENDANCE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchLessonAttendance = fetchLessonAttendance;
	exports.default = lessonAttendanceDetail;
	
	var _getLessonAttendance = __webpack_require__("NQer");
	
	var _getLessonAttendance2 = _interopRequireDefault(_getLessonAttendance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// fetch class lesson
	var START_FETCH_LESSON_ATTENDANCE = exports.START_FETCH_LESSON_ATTENDANCE = 'START_FETCH_LESSON_ATTENDANCE';
	var SUCCESS_FETCH_LESSON_ATTENDANCE = exports.SUCCESS_FETCH_LESSON_ATTENDANCE = 'SUCCESS_FETCH_LESSON_ATTENDANCE';
	var FAILED_FETCH_LESSON_ATTENDANCE = exports.FAILED_FETCH_LESSON_ATTENDANCE = 'FAILED_FETCH_LESSON_ATTENDANCE';
	
	function fetchLessonAttendance(classId) {
	  return function (dispatch) {
	    dispatch({
	      type: START_FETCH_LESSON_ATTENDANCE,
	      payload: {
	        fetching: true
	      }
	    });
	
	    (0, _getLessonAttendance2.default)(classId).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_LESSON_ATTENDANCE,
	        payload: _extends({}, result, {
	          fetching: false
	        })
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_LESSON_ATTENDANCE,
	        payload: err
	      });
	    });
	  };
	}
	
	var initState = {};
	
	function lessonAttendanceDetail() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case START_FETCH_LESSON_ATTENDANCE:
	      {
	        // NOTE: it is important to empty out the previous state.
	        // So we only return fetching
	        return {
	          fetching: true
	        };
	      }
	    case SUCCESS_FETCH_LESSON_ATTENDANCE:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case FAILED_FETCH_LESSON_ATTENDANCE:
	      {
	        return state;
	      }
	    default:
	      return _extends({}, state);
	  }
	}

/***/ },

/***/ "NQer":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getLessonAttendance;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getLessonAttendance(lessonId) {
	
	  if (!lessonId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing lesson Id (number)')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/g_chc/" + lessonId,
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "W/Ox":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_UPDATE_POSTER = exports.SUCCESS_UPDATE_POSTER = exports.START_UPDATE_POSTER = exports.FAILED_FETCH_POSTER = exports.SUCCESS_FETCH_POSTER = exports.START_FETCH_POSTER = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchPosterList = fetchPosterList;
	exports.updatePoster = updatePoster;
	exports.default = posterList;
	
	var _getPosterList = __webpack_require__("19P0");
	
	var _getPosterList2 = _interopRequireDefault(_getPosterList);
	
	var _updatePoster = __webpack_require__("xsdH");
	
	var _updatePoster2 = _interopRequireDefault(_updatePoster);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// calling both current and archived teacher
	var START_FETCH_POSTER = exports.START_FETCH_POSTER = 'START_FETCH_POSTER';
	var SUCCESS_FETCH_POSTER = exports.SUCCESS_FETCH_POSTER = 'SUCCESS_FETCH_POSTER';
	var FAILED_FETCH_POSTER = exports.FAILED_FETCH_POSTER = 'FAILED_FETCH_POSTER';
	
	var START_UPDATE_POSTER = exports.START_UPDATE_POSTER = 'START_UPDATE_POSTER';
	var SUCCESS_UPDATE_POSTER = exports.SUCCESS_UPDATE_POSTER = 'SUCCESS_UPDATE_POSTER';
	var FAILED_UPDATE_POSTER = exports.FAILED_UPDATE_POSTER = 'FAILED_UPDATE_POSTER';
	
	function fetchPosterList(schoolId, poster_state, amount_per_page, page_number) {
	
	  return function (dispatch) {
	
	    dispatch({
	      type: START_FETCH_POSTER
	    });
	
	    (0, _getPosterList2.default)(schoolId, poster_state, amount_per_page, page_number).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_POSTER,
	        payload: _extends({}, result, { fetching: false, hasPermission: true })
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_POSTER,
	        payload: { err: err, fetching: false, hasPermission: false }
	      });
	    });
	  };
	}
	
	function updatePoster(index, posterId, posterInfo, callback) {
	  return function (dispatch) {
	
	    dispatch({
	      type: START_UPDATE_POSTER,
	      payload: { index: index, posterInfo: posterInfo }
	
	    });
	
	    (0, _updatePoster2.default)(posterId, posterInfo).then(function (result) {
	      dispatch({
	        type: SUCCESS_UPDATE_POSTER,
	        payload: _extends({}, result)
	      });
	
	      if (typeof callback == 'function') {
	        callback();
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_UPDATE_POSTER,
	        payload: err
	      });
	    });
	  };
	}
	
	var initState = {
	  list: []
	};
	
	function posterList() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case START_FETCH_POSTER:
	      {
	        return _extends({}, state, { fetching: true, list: [], count: 0 });
	      }
	    case SUCCESS_FETCH_POSTER:
	      {
	        return _extends({}, state, {
	          list: action.payload.result_list,
	          count: action.payload.total_amount,
	          fetching: action.payload.fetching,
	          hasPermission: action.payload.hasPermission,
	          school_has_poster: action.payload.school_has_poster
	        });
	      }
	    case FAILED_FETCH_POSTER:
	      {
	        return _extends({}, state, {
	          error: action.payload.err,
	          fetching: action.payload.fetching,
	          hasPermission: action.payload.hasPermission
	        });
	      }
	
	    // updating
	    case START_UPDATE_POSTER:
	      {
	        var _action$payload = action.payload,
	            index = _action$payload.index,
	            posterInfo = _action$payload.posterInfo;
	
	
	        var list = state.list.map(function (existing, i) {
	          return index === i ? _extends({}, existing, posterInfo) : existing;
	        });
	
	        return _extends({}, state, {
	          list: list
	        });
	      }
	
	    default:
	      return _extends({}, state);
	  }
	}
	
	//

/***/ },

/***/ "19P0":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getPosterList;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _updatePoster = __webpack_require__("xsdH");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getPosterList(schoolId, poster_state, amount_per_page, page_number, keyword) {
	  if (typeof schoolId === 'undefined') {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school ID')
	      });
	    });
	  }
	
	  if (typeof poster_state === 'undefined') {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing poster state')
	      });
	    });
	  }
	
	  if (!amount_per_page) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing amount per page')
	      });
	    });
	  }
	
	  if (!page_number) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing page number')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/poster_lst/" + schoolId + "/" + poster_state + "/" + amount_per_page + "/" + page_number + "?keyword=" + (keyword ? keyword : ''),
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "xsdH":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = exports.SHOW_PAGE_VIEW = exports.SHOW_SPOTS_LEFT = exports.STATE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = updatePoster;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATE = exports.STATE = ["draft", "published", "closed", "all"];
	var SHOW_SPOTS_LEFT = exports.SHOW_SPOTS_LEFT = ['no', 'yes'];
	var SHOW_PAGE_VIEW = exports.SHOW_PAGE_VIEW = ['no', 'yes'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  title: _joiBrowser2.default.string().allow(''),
	  state: _joiBrowser2.default.string().valid(STATE).allow(''),
	  show_spots_left: _joiBrowser2.default.string().valid(SHOW_SPOTS_LEFT).allow(''),
	  show_page_view: _joiBrowser2.default.string().valid(SHOW_PAGE_VIEW).allow(''),
	  page_setting: _joiBrowser2.default.object().allow('').allow(null),
	  theme_setting: _joiBrowser2.default.object().allow('').allow(null)
	});
	
	function updatePoster(posterId, posterInfo) {
	
	  if (!posterId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing poster ID')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(posterInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, posterInfo);
	
	  if (typeof posterInfo.state != 'undefined') {
	    toServer.state = STATE.indexOf(posterInfo.state);
	  }
	  if (typeof posterInfo.show_spots_left != 'undefined') {
	    toServer.show_spots_left = SHOW_SPOTS_LEFT.indexOf(posterInfo.show_spots_left);
	  }
	  if (typeof posterInfo.show_page_view != 'undefined') {
	    toServer.show_page_view = SHOW_PAGE_VIEW.indexOf(posterInfo.show_page_view);
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/u_poster/" + posterId + "/",
	      'method': 'PUT',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "srt+":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.UPDATE_CONTENT_ITEM_ID = exports.UPDATE_CONTENT_ITEM_ORDER = exports.UPDATE_CONTENT_ITEM = exports.ADD_CONTENT_ITEM = exports.REMOVE_CONTENT_ITEM = exports.FAILED_UPDATE_TICKET = exports.SUCCESS_UPDATE_TICKET = exports.START_UPDATE_TICKET = exports.FAILED_DELETE_TICKET = exports.SUCCESS_DELETE_TICKET = exports.START_DELETE_TICKET = exports.FAILED_CREATE_TICKET = exports.SUCCESS_CREATE_TICKET = exports.START_CREATE_TICKET = exports.UPDATE_TICKET_CONTENT = exports.REMOVE_TICKET_FROM_TICKET_LIST = exports.ADD_TICKET_TO_TICKET_LIST = exports.DELETE_TICKET = exports.UPDATE_TICKET = exports.CREATE_TICKET = exports.UPDATE_TITLE = exports.FAILED_FETCH_POSTER_DETAIL = exports.SUCCESS_FETCH_POSTER_DETAIL = exports.START_FETCH_POSTER_DETAIL = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchPosterDetail = fetchPosterDetail;
	exports.updateTitle = updateTitle;
	exports.updateOrder = updateOrder;
	exports.updateContentItem = updateContentItem;
	exports.removeContentItem = removeContentItem;
	exports.addContentItem = addContentItem;
	exports.createTicket = createTicket;
	exports.deleteTicket = deleteTicket;
	exports.updateTicket = updateTicket;
	exports.default = posterDetail;
	
	var _getPosterDetail = __webpack_require__("+5oY");
	
	var _getPosterDetail2 = _interopRequireDefault(_getPosterDetail);
	
	var _createTicket = __webpack_require__("8x3i");
	
	var _createTicket2 = _interopRequireDefault(_createTicket);
	
	var _deleteTicket = __webpack_require__("V2aK");
	
	var _deleteTicket2 = _interopRequireDefault(_deleteTicket);
	
	var _updateTicket = __webpack_require__("bYN+");
	
	var _updateTicket2 = _interopRequireDefault(_updateTicket);
	
	var _updateContent = __webpack_require__("fQnq");
	
	var _updateContent2 = _interopRequireDefault(_updateContent);
	
	var _deleteContent = __webpack_require__("+ilL");
	
	var _deleteContent2 = _interopRequireDefault(_deleteContent);
	
	var _createContent = __webpack_require__("SquY");
	
	var _createContent2 = _interopRequireDefault(_createContent);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// calling both current and archived teacher
	var START_FETCH_POSTER_DETAIL = exports.START_FETCH_POSTER_DETAIL = 'START_FETCH_POSTER_DETAIL';
	var SUCCESS_FETCH_POSTER_DETAIL = exports.SUCCESS_FETCH_POSTER_DETAIL = 'SUCCESS_FETCH_POSTER_DETAIL';
	var FAILED_FETCH_POSTER_DETAIL = exports.FAILED_FETCH_POSTER_DETAIL = 'FAILED_FETCH_POSTER_DETAIL';
	
	var UPDATE_TITLE = exports.UPDATE_TITLE = "UPDATE_TITLE";
	
	var CREATE_TICKET = exports.CREATE_TICKET = "CREATE_TICKET";
	var UPDATE_TICKET = exports.UPDATE_TICKET = "UPDATE_TICKET";
	var DELETE_TICKET = exports.DELETE_TICKET = "DELETE_TICKET";
	
	var ADD_TICKET_TO_TICKET_LIST = exports.ADD_TICKET_TO_TICKET_LIST = 'ADD_TICKET_TO_TICKET_LIST';
	var REMOVE_TICKET_FROM_TICKET_LIST = exports.REMOVE_TICKET_FROM_TICKET_LIST = 'REMOVE_TICKET_FROM_TICKET_LIST';
	var UPDATE_TICKET_CONTENT = exports.UPDATE_TICKET_CONTENT = 'UPDATE_TICKET_CONTENT';
	
	var START_CREATE_TICKET = exports.START_CREATE_TICKET = 'START_CREATE_TICKET';
	var SUCCESS_CREATE_TICKET = exports.SUCCESS_CREATE_TICKET = 'SUCCESS_CREATE_TICKET';
	var FAILED_CREATE_TICKET = exports.FAILED_CREATE_TICKET = 'FAILED_CREATE_TICKET';
	
	var START_DELETE_TICKET = exports.START_DELETE_TICKET = 'START_DELETE_TICKET';
	var SUCCESS_DELETE_TICKET = exports.SUCCESS_DELETE_TICKET = 'SUCCESS_DELETE_TICKET';
	var FAILED_DELETE_TICKET = exports.FAILED_DELETE_TICKET = 'FAILED_DELETE_TICKET';
	
	var START_UPDATE_TICKET = exports.START_UPDATE_TICKET = 'START_UPDATE_TICKET';
	var SUCCESS_UPDATE_TICKET = exports.SUCCESS_UPDATE_TICKET = 'SUCCESS_UPDATE_TICKET';
	var FAILED_UPDATE_TICKET = exports.FAILED_UPDATE_TICKET = 'FAILED_UPDATE_TICKET';
	
	var REMOVE_CONTENT_ITEM = exports.REMOVE_CONTENT_ITEM = 'REMOVE_CONTENT_ITEM';
	var ADD_CONTENT_ITEM = exports.ADD_CONTENT_ITEM = 'ADD_CONTENT_ITEM';
	var UPDATE_CONTENT_ITEM = exports.UPDATE_CONTENT_ITEM = 'UPDATE_CONTENT_ITEM';
	
	var UPDATE_CONTENT_ITEM_ORDER = exports.UPDATE_CONTENT_ITEM_ORDER = 'UPDATE_CONTENT_ITEM_ORDER';
	
	var UPDATE_CONTENT_ITEM_ID = exports.UPDATE_CONTENT_ITEM_ID = 'UPDATE_CONTENT_ITEM_ID'; // when create a new content item, a new object(A) is inserted into an array before calling an API. When API is called and returns an ID for newly created item, we update that ID in object(A)
	function fetchPosterDetail(posterId, callback) {
	
	  return function (dispatch) {
	
	    dispatch({
	      type: START_FETCH_POSTER_DETAIL,
	      fetching: true
	    });
	
	    (0, _getPosterDetail2.default)(posterId).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_POSTER_DETAIL,
	        payload: _extends({}, result)
	      });
	
	      if (typeof callback == 'function') {
	        callback();
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_POSTER_DETAIL,
	        payload: err
	      });
	    });
	  };
	}
	
	function updateTitle(title) {
	  return function (dispatch) {
	    dispatch({
	      type: UPDATE_TITLE,
	      title: title
	    });
	  };
	}
	
	function updateOrder(contentList, itemToMove) {
	  return function (dispatch) {
	    var toServer = _extends({}, itemToMove);
	
	    contentList.forEach(function (item, index) {
	      var newIndex = index + 1;
	      item.index = newIndex;
	      if (toServer.id === item.id) {
	        toServer.index = newIndex;
	      }
	    });
	
	    dispatch({
	      type: UPDATE_CONTENT_ITEM_ORDER,
	      contentList: contentList
	    });
	
	    delete toServer.id;
	    delete toServer.poster;
	
	    (0, _updateContent2.default)(itemToMove.id, toServer).then(function (res) {});
	  };
	}
	
	function updateContentItem() {
	  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var contentId = arguments[1];
	  var contentItemChanges = arguments[2];
	
	  return function (dispatch) {
	    dispatch({
	      type: UPDATE_CONTENT_ITEM,
	      index: index,
	      contentItemChanges: contentItemChanges
	    });
	
	    delete contentItemChanges.id; // ID is not allowed
	
	    (0, _updateContent2.default)(contentId, contentItemChanges).then(function (res) {});
	  };
	}
	
	function removeContentItem(index, contentId, posterId) {
	  return function (dispatch) {
	    dispatch({
	      type: REMOVE_CONTENT_ITEM,
	      index: index
	    });
	
	    // this.countEmptyItem()
	    if (contentId) {
	      (0, _deleteContent2.default)(contentId).then(function () {});
	    }
	  };
	}
	
	function addContentItem(index, posterId, newContentItem, dontCallAPI) {
	  return function (dispatch) {
	    dispatch({
	      type: ADD_CONTENT_ITEM,
	      index: index + 1,
	      newContentItem: newContentItem
	    });
	
	    var contentIndex = index + 1;
	
	    newContentItem.index = contentIndex + 1;
	
	    if (dontCallAPI !== true) {
	      (0, _createContent2.default)(posterId, newContentItem).then(function (res) {
	        dispatch({
	          type: UPDATE_CONTENT_ITEM_ID,
	          index: index + 1,
	          id: res.content_block_id
	        });
	      });
	    }
	  };
	}
	
	function createTicket(posterId, ticket) {
	
	  return function (dispatch) {
	    dispatch({
	      type: START_CREATE_TICKET
	    });
	
	    dispatch({
	      type: CREATE_TICKET,
	      ticket: ticket
	    });
	
	    (0, _createTicket2.default)(posterId, ticket).then(function (result) {
	      dispatch({
	        type: SUCCESS_CREATE_TICKET,
	        payload: _extends({}, result)
	      });
	
	      dispatch({
	        type: UPDATE_TICKET,
	        ticket: _extends({}, ticket, {
	          id: result.ticket_id
	        })
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_CREATE_TICKET,
	        payload: err
	      });
	    });
	  };
	}
	
	function deleteTicket(ticketId, ticketIndexInArray) {
	
	  return function (dispatch) {
	
	    dispatch({
	      type: START_DELETE_TICKET,
	      ticketIndexInArray: ticketIndexInArray
	    });
	
	    dispatch({
	      type: DELETE_TICKET,
	      ticketIndexInArray: ticketIndexInArray
	    });
	
	    (0, _deleteTicket2.default)(ticketId).then(function (result) {
	      dispatch({
	        type: SUCCESS_DELETE_TICKET,
	        payload: _extends({}, result)
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_DELETE_TICKET,
	        payload: err
	      });
	    });
	  };
	}
	
	function updateTicket(ticketId, ticket) {
	
	  return function (dispatch) {
	
	    dispatch({
	      type: START_UPDATE_TICKET
	    });
	
	    dispatch({
	      type: UPDATE_TICKET,
	      ticket: ticket
	    });
	
	    (0, _updateTicket2.default)(ticketId, convertTicketToServer(ticket)).then(function (result) {
	      dispatch({
	        type: SUCCESS_UPDATE_TICKET,
	        payload: _extends({}, result)
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_UPDATE_TICKET,
	        payload: err
	      });
	    });
	  };
	}
	
	var initState = {
	  contentList: [],
	  detail: {}
	
	};
	
	var POSTER_TYPE = ["registration", "ticket", 'survey', 'basic'];
	
	function posterDetail() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    // ===================================
	    //  actions for fetching poster detail
	    // ===================================
	    case START_FETCH_POSTER_DETAIL:
	      {
	        return _extends({}, state, {
	          fetching: true,
	          contentList: [],
	          ticketList: [],
	          detail: {},
	          poster_type: undefined,
	          title: undefined
	        });
	      }
	    case SUCCESS_FETCH_POSTER_DETAIL:
	      {
	        var _action$payload = action.payload,
	            poster_info = _action$payload.poster_info,
	            content = _action$payload.content,
	            ticket = _action$payload.ticket;
	
	
	        return _extends({}, state, {
	          title: poster_info.title,
	          hasTitle: typeof poster_info.title === 'string' && poster_info.title.length > 0,
	          detail: poster_info,
	          contentList: content,
	          ticketList: ticket.map(function (ticketFromServer) {
	            return convertTicketFromServer(ticketFromServer);
	          }),
	          poster_type: POSTER_TYPE[poster_info.poster_type],
	          fetching: false
	        });
	      }
	    case FAILED_FETCH_POSTER_DETAIL:
	      {
	        return state;
	      }
	
	    // ===================================
	    //  updating content editor part
	    //  of posterdetail
	    // ===================================
	    case UPDATE_TITLE:
	      {
	        var title = action.title;
	
	
	        return _extends({}, state, {
	          title: title,
	          hasTitle: typeof title === 'string' && title.length > 0
	        });
	        break;
	      }
	
	    case UPDATE_CONTENT_ITEM_ORDER:
	      {
	        var contentList = action.contentList;
	
	        return _extends({}, state, {
	          contentList: contentList
	        });
	        break;
	      }
	
	    case UPDATE_CONTENT_ITEM:
	      {
	        var index = action.index,
	            contentItemChanges = action.contentItemChanges;
	
	
	        return _extends({}, state, {
	          contentList: state.contentList.map(function (item, i) {
	            return i === index ? _extends({}, item, contentItemChanges) : item;
	          })
	        });
	
	        break;
	      }
	
	    case UPDATE_CONTENT_ITEM_ID:
	      {
	        var _index = action.index,
	            id = action.id;
	
	
	        return _extends({}, state, {
	          contentList: state.contentList.map(function (item, i) {
	            return i === _index ? _extends({}, item, { id: id }) : item;
	          })
	        });
	      }
	
	    case ADD_CONTENT_ITEM:
	      {
	        var _index2 = action.index,
	            newContentItem = action.newContentItem;
	
	
	        return _extends({}, state, {
	          contentList: [].concat(state.contentList.slice(0, _index2), [newContentItem], state.contentList.slice(_index2))
	        });
	
	        break;
	      }
	
	    case REMOVE_CONTENT_ITEM:
	      {
	        var _index3 = action.index;
	
	
	        return _extends({}, state, {
	          contentList: [].concat(state.contentList.slice(0, _index3), state.contentList.slice(_index3 + 1))
	        });
	
	        break;
	      }
	
	    // ===================================
	    //  actions for local states for ticket
	    // ===================================
	    case CREATE_TICKET:
	      {
	        return _extends({}, state, {
	          ticketList: [].concat(state.ticketList, [action.ticket])
	        });
	      }
	
	    case UPDATE_TICKET:
	      {
	        var _index4 = action.ticket.index;
	
	
	        return _extends({}, state, {
	          ticketList: state.ticketList.map(function (existingTicket, i) {
	            return _index4 === i + 1 ? _extends({}, existingTicket, action.ticket) : existingTicket;
	          })
	        });
	      }
	
	    case DELETE_TICKET:
	      {
	        var ticketIndexInArray = action.ticketIndexInArray;
	
	
	        return _extends({}, state, {
	          ticketList: [].concat(state.ticketList.slice(0, ticketIndexInArray), state.ticketList.slice(ticketIndexInArray + 1))
	        });
	      }
	    // ===================================
	    //  actions for API calls creating ticket
	    // ===================================
	    case START_CREATE_TICKET:
	      {
	        return _extends({}, state, {
	          loading: true
	        });
	      }
	    case SUCCESS_CREATE_TICKET:
	      {
	        var _action$payload2 = action.payload,
	            ticket_id = _action$payload2.ticket_id,
	            _index5 = _action$payload2.index;
	
	        return _extends({}, state, {
	          loading: false
	        });
	      }
	    case FAILED_CREATE_TICKET:
	      {
	        return _extends({}, state, {
	          loading: false
	        });
	      }
	
	    // ===================================
	    //  actions for API calls deleting ticket
	    // ===================================
	    case START_DELETE_TICKET:
	      {
	        return _extends({}, state, {
	          loading: true,
	          ticketList: [].concat(state.ticketList.slice(0, action.ticketIndexInArray), state.ticketList.slice(action.ticketIndexInArray + 1))
	        });
	      }
	    case SUCCESS_DELETE_TICKET:
	      {
	        return _extends({}, state, {
	          loading: false
	        });
	      }
	    case FAILED_DELETE_TICKET:
	      {
	        return _extends({}, state, {
	          loading: false
	        });
	      }
	
	    // ===================================
	    //  actions for API calls updating ticket
	    // ===================================
	    case START_UPDATE_TICKET:
	      {
	        return _extends({}, state, {
	          loading: true
	        });
	      }
	    case SUCCESS_UPDATE_TICKET:
	      {
	        return _extends({}, state, {
	          loading: false
	        });
	      }
	    case FAILED_UPDATE_TICKET:
	      {
	        return _extends({}, state, {
	          loading: false
	        });
	      }
	
	    default:
	      return _extends({}, state);
	  }
	}
	
	function convertTicketFromServer(opts) {
	  var id = opts.id,
	      index = opts.index,
	      title = opts.title,
	      amount = opts.amount,
	      price = opts.price,
	      auto_wait_list = opts.auto_wait_list,
	      start_at = opts.start_at,
	      end_at = opts.end_at,
	      price_type = opts.price_type;
	
	
	  var endDate = void 0,
	      endTime = void 0;
	
	  if (end_at) {
	    var endMoment = (0, _moment2.default)(end_at);
	    endDate = endMoment.format('YYYY-MM-DD');
	    endTime = endMoment.format('HH:mm:ss');
	  }
	
	  var startDate = void 0,
	      startTime = void 0;
	
	  if (start_at) {
	    var startMoment = (0, _moment2.default)(start_at);
	    startDate = startMoment.format('YYYY-MM-DD');
	    startTime = startMoment.format('HH:mm:ss');
	  }
	
	  var PRICE_TYPE = ['freeOrPayOffline', 'fixedAmount', 'noFixAmount'];
	
	  return {
	    id: id,
	    index: index,
	    title: title,
	    amount: amount,
	    price: price,
	    auto_wait_list: auto_wait_list,
	    noEndTime: !end_at ? true : false,
	    startDate: startDate,
	    startTime: startTime,
	    endDate: endDate,
	    endTime: endTime,
	    price_type: PRICE_TYPE[price_type]
	  };
	}
	
	function convertTicketToServer(_ref) {
	  var index = _ref.index,
	      title = _ref.title,
	      amount = _ref.amount,
	      price = _ref.price,
	      startDate = _ref.startDate,
	      startTime = _ref.startTime,
	      endDate = _ref.endDate,
	      endTime = _ref.endTime,
	      auto_wait_list = _ref.auto_wait_list,
	      noEndTime = _ref.noEndTime;
	
	  var noStartTime = !startDate || !startTime;
	
	  var obj = {
	    index: index,
	    title: title,
	    amount: Number(amount),
	    price: price,
	    auto_wait_list: auto_wait_list,
	    start_at: noStartTime ? null : startDate + ' ' + startTime,
	    end_at: noEndTime ? null : endDate + ' ' + endTime
	  };
	
	  if (obj.noEndTime == false) {
	    obj.end_at = endDate + ' ' + endTime;
	  }
	
	  return obj;
	}

/***/ },

/***/ "+5oY":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = getPosterDetail;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _updateContent = __webpack_require__("fQnq");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getPosterDetail(posterId) {
	
	  if (!posterId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing poster ID')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/u_poster/" + posterId + "/",
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(_extends({}, res.data, {
	        content: res.data.content.map(function (c) {
	          c.content_type = _updateContent.CONTENT_TYPE[c.content_type];
	          return c;
	        })
	      }));
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "fQnq":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = exports.CONTENT_TYPE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = updateContent;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONTENT_TYPE = exports.CONTENT_TYPE = ['text', 'picture', 'video', 'pictureAndText', 'videoAndText'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  index: _joiBrowser2.default.number().integer().allow(''),
	  content_type: _joiBrowser2.default.string().valid(CONTENT_TYPE).allow(''),
	  text: _joiBrowser2.default.string().allow(''),
	  image_url: _joiBrowser2.default.string().allow(''),
	  video_url: _joiBrowser2.default.string().allow(''),
	  custom_data: _joiBrowser2.default.object().allow('').allow(null)
	});
	
	function updateContent(contentId, contentInfo) {
	
	  if (!contentId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing content ID')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(contentInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = {};
	  if (contentInfo.content_type) {
	    toServer = _extends({}, contentInfo, {
	      content_type: CONTENT_TYPE.indexOf(contentInfo.content_type)
	    });
	  } else {
	    toServer = _extends({}, contentInfo);
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/u_content/" + contentId + "/",
	      'method': 'PUT',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "8x3i":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTicket;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TICKET_TYPE = ['noBarCode', 'eTicket', 'ticket'];
	var WAIT_LIST = ['noWaitList', 'enterWaitList'];
	var PRICE_TYPE = ['freeOrPayOffline', 'fixedAmount', 'noFixAmount'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  title: _joiBrowser2.default.string().allow(''),
	  index: _joiBrowser2.default.number().integer().allow(''),
	  ticket_type: _joiBrowser2.default.string().valid(TICKET_TYPE).allow(''),
	  amount: _joiBrowser2.default.number().integer().allow(''),
	  auto_wait_list: _joiBrowser2.default.string().valid(WAIT_LIST).allow(''),
	  start_at: _joiBrowser2.default.string().allow(null).allow(''),
	  end_at: _joiBrowser2.default.string().allow(null).allow(''),
	  max_per_order: _joiBrowser2.default.number().integer().allow(''),
	  price_type: _joiBrowser2.default.string().valid(PRICE_TYPE).allow(''),
	  price: _joiBrowser2.default.number().integer().allow(''),
	  tax_percent: _joiBrowser2.default.number().integer().allow('')
	});
	
	function createTicket(posterId, ticketInfo) {
	
	  if (!posterId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing poster ID')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(ticketInfo, schema);
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, ticketInfo, {
	    ticket_type: ticketInfo.ticket_type ? TICKET_TYPE.indexOf(ticketInfo.ticket_type) : 0,
	    auto_wait_list: ticketInfo.auto_wait_list ? WAIT_LIST.indexOf(ticketInfo.auto_wait_list) : 1,
	    price_type: ticketInfo.price_type ? PRICE_TYPE.indexOf(ticketInfo.price_type) : 0
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/poster_ticket_list/" + posterId + "/",
	      'method': 'POST',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "V2aK":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = deleteTicket;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deleteTicket(ticketId) {
	
	  if (!ticketId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing ticket ID')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/u_ticket/" + ticketId + "/",
	      'method': 'DELETE',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "bYN+":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = updateTicket;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TICKET_TYPE = ['noBarCode', 'eTicket', 'ticket'];
	var WAIT_LIST = ['noWaitList', 'enterWaitList'];
	var PRICE_TYPE = ['free', 'fixedAmount', 'noFixAmount'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  title: _joiBrowser2.default.string().allow(''),
	  index: _joiBrowser2.default.number().integer().required(),
	  ticket_type: _joiBrowser2.default.string().valid(TICKET_TYPE).allow(''),
	  amount: _joiBrowser2.default.number().integer().allow(''),
	  auto_wait_list: _joiBrowser2.default.string().valid(WAIT_LIST).allow(''),
	  start_at: _joiBrowser2.default.string().allow(null).allow(''),
	  end_at: _joiBrowser2.default.string().allow(null).allow(''),
	  max_per_order: _joiBrowser2.default.number().integer().allow(''),
	  price_type: _joiBrowser2.default.string().valid(PRICE_TYPE).allow(''),
	  price: _joiBrowser2.default.number().allow(''),
	  tax_percent: _joiBrowser2.default.number().integer().allow('')
	});
	
	function updateTicket(ticketId, ticketInfo) {
	
	  if (!ticketId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing ticket ID')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(ticketInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, ticketInfo);
	
	  if (typeof ticketInfo.ticket_type != 'undefined') {
	    toServer.ticket_type = TICKET_TYPE.indexOf(ticketInfo.ticket_type);
	  }
	  if (typeof ticketInfo.auto_wait_list != 'undefined') {
	    toServer.auto_wait_list = WAIT_LIST.indexOf(ticketInfo.auto_wait_list);
	  }
	  if (typeof ticketInfo.price_type != 'undefined') {
	    toServer.price_type = PRICE_TYPE.indexOf(ticketInfo.price_type);
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/u_ticket/" + ticketId + "/",
	      'method': 'PUT',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "+ilL":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = deleteContent;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deleteContent(contentId) {
	
	  if (!contentId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing content ID')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/u_content/" + contentId + "/",
	      'method': 'DELETE',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "SquY":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createContent;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONTENT_TYPE = ['text', 'picture', 'video', 'pictureAndText', 'videoAndText', 'hero', 'tab', 'carousel', 'features', 'html', 'form'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  index: _joiBrowser2.default.number().integer().required(),
	  content_type: _joiBrowser2.default.string().valid(CONTENT_TYPE).required(),
	  text: _joiBrowser2.default.string().allow(''),
	  image_url: _joiBrowser2.default.string().allow(''),
	  video_url: _joiBrowser2.default.string().allow(''),
	  custom_data: _joiBrowser2.default.object().allow('').allow(null)
	});
	
	function createContent(posterId, contentInfo) {
	
	  if (!posterId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing poster ID')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(contentInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, contentInfo, {
	    content_type: CONTENT_TYPE.indexOf(contentInfo.content_type)
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/create_content/" + posterId + "/",
	      'method': 'POST',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "2yUR":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_FETCH_ATTENDEE_LIST = exports.SUCCESS_FETCH_ATTENDEE_LIST = exports.START_FETCH_ATTENDEE_LIST = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchAttendeeList = fetchAttendeeList;
	exports.default = attendeeList;
	
	var _getAttendeeList = __webpack_require__("/4wT");
	
	var _getAttendeeList2 = _interopRequireDefault(_getAttendeeList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var START_FETCH_ATTENDEE_LIST = exports.START_FETCH_ATTENDEE_LIST = 'START_FETCH_ATTENDEE_LIST';
	var SUCCESS_FETCH_ATTENDEE_LIST = exports.SUCCESS_FETCH_ATTENDEE_LIST = 'SUCCESS_FETCH_ATTENDEE_LIST';
	var FAILED_FETCH_ATTENDEE_LIST = exports.FAILED_FETCH_ATTENDEE_LIST = 'FAILED_FETCH_ATTENDEE_LIST';
	
	function fetchAttendeeList(schoolId, params) {
	
	  return function (dispatch) {
	
	    dispatch({
	      type: START_FETCH_ATTENDEE_LIST
	    });
	
	    (0, _getAttendeeList2.default)(schoolId, params).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_ATTENDEE_LIST,
	        payload: _extends({}, result)
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_ATTENDEE_LIST,
	        payload: err
	      });
	    });
	  };
	}
	
	var initState = {
	  list: []
	};
	
	function attendeeList() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case START_FETCH_ATTENDEE_LIST:
	      {
	        return _extends({}, state, { fetching: true });
	      }
	    case SUCCESS_FETCH_ATTENDEE_LIST:
	      {
	        return _extends({}, state, {
	          list: action.payload.result_list,
	          count: action.payload.total_amount,
	          posterTitle: action.payload.poster_title,
	          fetching: false
	        });
	      }
	    case FAILED_FETCH_ATTENDEE_LIST:
	      {
	        return _extends({}, state, {
	          error: action.payload
	        });
	      }
	
	    default:
	      return _extends({}, state);
	  }
	}
	
	//

/***/ },

/***/ "/4wT":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getAttendeeList;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATE = ['waitList', 'registeredNotConfirmed', 'registered', 'cancelled', 'transferedStudents', 'registeredNotSuccess', 'all'];
	
	function getAttendeeList(schoolId, params) {
	
	  if (!schoolId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school ID')
	      });
	    });
	  }
	
	  var query = _queryString2.default.stringify({
	    poster: params.posterId,
	    state: params.state,
	    amount_per_page: params.amount_per_page,
	    page_number: params.page_number,
	    order_by: params.order_by,
	    kw: params.kw
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/attendee_lst/" + schoolId + "/?" + query,
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "tCuI":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DEFAULT_PAGINATION = exports.SUCCESS_EDIT_CLIENT_TAG = exports.START_EDIT_CLIENT_TAG = exports.SUCCESS_DELETE_CLIENT_TAG = exports.START_DELETE_CLIENT_TAG = exports.FAILED_FETCH_CLIENT_LIST = exports.SUCCESS_FETCH_CLIENT_LIST = exports.START_FETCH_CLIENT_LIST = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchClientList = fetchClientList;
	exports.deleteClientTag = deleteClientTag;
	exports.editClientTag = editClientTag;
	exports.default = clientList;
	
	var _getClientList = __webpack_require__("pwCt");
	
	var _getClientList2 = _interopRequireDefault(_getClientList);
	
	var _deleteClientTag = __webpack_require__("zUZJ");
	
	var _deleteClientTag2 = _interopRequireDefault(_deleteClientTag);
	
	var _editClientTag = __webpack_require__("FeFj");
	
	var _editClientTag2 = _interopRequireDefault(_editClientTag);
	
	var _alert = __webpack_require__("BGi1");
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _without = __webpack_require__("yI9a");
	
	var _without2 = _interopRequireDefault(_without);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// calling both current and archived teacher
	var START_FETCH_CLIENT_LIST = exports.START_FETCH_CLIENT_LIST = 'START_FETCH_CLIENT_LIST';
	var SUCCESS_FETCH_CLIENT_LIST = exports.SUCCESS_FETCH_CLIENT_LIST = 'SUCCESS_FETCH_CLIENT_LIST';
	var FAILED_FETCH_CLIENT_LIST = exports.FAILED_FETCH_CLIENT_LIST = 'FAILED_FETCH_CLIENT_LIST';
	
	var START_DELETE_CLIENT_TAG = exports.START_DELETE_CLIENT_TAG = 'START_DELETE_CLIENT_TAG';
	var SUCCESS_DELETE_CLIENT_TAG = exports.SUCCESS_DELETE_CLIENT_TAG = 'SUCCESS_DELETE_CLIENT_TAG';
	
	var START_EDIT_CLIENT_TAG = exports.START_EDIT_CLIENT_TAG = 'START_EDIT_CLIENT_TAG';
	var SUCCESS_EDIT_CLIENT_TAG = exports.SUCCESS_EDIT_CLIENT_TAG = 'SUCCESS_EDIT_CLIENT_TAG';
	
	var DEFAULT_PAGINATION = exports.DEFAULT_PAGINATION = {
	  activePage: 0,
	  itemsCountPerPage: 10,
	  totalItemsCount: 0
	};
	
	function fetchClientList(obj) {
	
	  return function (dispatch) {
	    dispatch({
	      type: START_FETCH_CLIENT_LIST,
	      payload: {
	        fetching: true
	      }
	    });
	
	    (0, _getClientList2.default)(obj).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_CLIENT_LIST,
	        payload: _extends({}, result, { fetching: false, amount_per_page: obj.amount_per_page, hasPermission: true })
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_CLIENT_LIST,
	        payload: { err: err, fetching: false, hasPermission: false }
	      });
	    });
	  };
	}
	
	function deleteClientTag(index, tagId, tagName) {
	  return function (dispatch) {
	    dispatch({
	      type: START_DELETE_CLIENT_TAG,
	      payload: {
	        index: index,
	        tagName: tagName,
	        tagId: tagId
	      }
	    });
	
	    (0, _deleteClientTag2.default)(tagId).then(function (result) {
	      dispatch({
	        type: SUCCESS_DELETE_CLIENT_TAG,
	        payload: _extends({}, result)
	      });
	    }).catch(function (err) {
	      _alert2.default.error('API CALL FAILED: Net error').then(function () {
	        window.location.reload();
	      });
	    });
	  };
	}
	
	function editClientTag(index, tagId, oldTagName, tagName, callback) {
	  return function (dispatch) {
	    dispatch({
	      type: START_EDIT_CLIENT_TAG
	    });
	
	    (0, _editClientTag2.default)(tagId, tagName).then(function (result) {
	      dispatch({
	        type: SUCCESS_EDIT_CLIENT_TAG,
	        payload: _extends({}, result, { index: index, tagId: tagId, oldTagName: oldTagName, tagName: tagName })
	      });
	
	      if (typeof callback == 'function') {
	        callback();
	      }
	    }).catch(function (err) {
	      _alert2.default.error('API CALL FAILED: Net error').then(function () {
	        window.location.reload();
	      });
	    });
	  };
	}
	
	var initState = {
	  list: [],
	  tag_list: [],
	  pagination: DEFAULT_PAGINATION,
	  fetching: false
	};
	
	function clientList() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case START_FETCH_CLIENT_LIST:
	      {
	        return _extends({}, state, { fetching: true });
	      }
	    case SUCCESS_FETCH_CLIENT_LIST:
	      {
	        var _action$payload = action.payload,
	            result_list = _action$payload.result_list,
	            fetching = _action$payload.fetching,
	            tag_filter_list = _action$payload.tag_filter_list,
	            amount_per_page = _action$payload.amount_per_page,
	            current_page_number = _action$payload.current_page_number,
	            total_amount = _action$payload.total_amount,
	            hasPermission = _action$payload.hasPermission,
	            school_has_contact = _action$payload.school_has_contact;
	
	
	        return _extends({}, state, {
	          list: result_list,
	          tag_list: tag_filter_list,
	          fetching: false,
	          hasPermission: hasPermission,
	          school_has_contact: school_has_contact,
	          pagination: {
	            itemsCountPerPage: amount_per_page,
	            activePage: current_page_number,
	            totalItemsCount: total_amount
	          }
	        });
	      }
	    case FAILED_FETCH_CLIENT_LIST:
	      {
	        return _extends({}, state, { err: action.payload.err, fetching: false, hasPermission: action.payload.hasPermission });
	      }
	
	    // delete tag
	    case START_DELETE_CLIENT_TAG:
	      {
	
	        var newList = state.list;
	        newList.map(function (item) {
	          item.tag_name_list.map(function (name) {
	            if (name == action.payload.tagName) {
	              item.tag_name_list = (0, _without2.default)(item.tag_name_list, name);
	            }
	          });
	        });
	
	        return _extends({}, state, {
	          list: newList,
	          tag_list: [].concat(state.tag_list.slice(0, action.payload.index), state.tag_list.slice(action.payload.index + 1))
	        });
	      }
	
	    // edit tag
	    case SUCCESS_EDIT_CLIENT_TAG:
	      {
	        var _action$payload2 = action.payload,
	            index = _action$payload2.index,
	            oldTagName = _action$payload2.oldTagName,
	            tagName = _action$payload2.tagName,
	            tagId = _action$payload2.tagId;
	
	
	        var _newList = state.list;
	        var i = void 0;
	        _newList.map(function (item) {
	          item.tag_name_list.map(function (n) {
	            if (n == oldTagName) {
	              i = item.tag_name_list.indexOf(n);
	              item.tag_name_list[i] = tagName.tag_name;
	            }
	          });
	        });
	
	        var name = { name: tagName.tag_name };
	        return _extends({}, state, {
	          list: _newList,
	          tag_list: state.tag_list.map(function (existing, i) {
	            return index === i ? _extends({}, existing, name) : existing;
	          })
	        });
	      }
	
	    default:
	      return _extends({}, state);
	  }
	}
	
	//

/***/ },

/***/ "pwCt":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = getClientList;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATES = ['notTransfer', 'transferred'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  schoolId: _joiBrowser2.default.number().integer().required(),
	  student_state: _joiBrowser2.default.string().valid(STATES).allow(''),
	  amount_per_page: _joiBrowser2.default.number().integer().required(),
	  page_number: _joiBrowser2.default.number().integer().required(),
	  keyword: _joiBrowser2.default.string().allow('')
	});
	
	function getClientList(obj) {
	
	  var validateResult = _joiBrowser2.default.validate(obj, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var query = _queryString2.default.stringify({
	    student_state: STATES.indexOf(obj.student_state),
	    amount_per_page: obj.amount_per_page,
	    page_number: obj.page_number,
	    keyword: obj.keyword
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/contact_lst/' + obj.schoolId + '/?' + query,
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "zUZJ":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = deleteClientTag;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deleteClientTag(tagId) {
	
	  if (!tagId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing tag Id')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/contact_tag_detail/" + tagId + "/",
	      'method': 'DELETE',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "FeFj":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = editClientTag;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  "tag_name": _joiBrowser2.default.string().required()
	});
	
	function editClientTag(tagId, tagInfo) {
	
	  if (!tagId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing tag Id')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(tagInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/contact_tag_detail/" + tagId + "/",
	      'method': 'PUT',
	      'data': JSON.stringify(tagInfo),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "pzkK":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // importing actions
	
	
	exports.default = announcementList;
	
	var _addAnnouncement = __webpack_require__("/Cga");
	
	var _getAnnouncementList = __webpack_require__("sYDS");
	
	var _updateAnnouncement = __webpack_require__("eVF0");
	
	var _searchAnnouncement = __webpack_require__("EV0/");
	
	var _setCurrentTabState = __webpack_require__("d4iu");
	
	var initState = {
	  list: [],
	  count: 0,
	  fetching: false,
	  adding: false,
	  currentTabState: {
	    tabName: 'all',
	    tabIndex: 0
	  }
	};
	
	function announcementList() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	
	    // Fetching
	    case _getAnnouncementList.START_FETCH_ANNOUNCEMENT_LIST:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case _getAnnouncementList.SUCCESS_FETCH_ANNOUNCEMENT_LIST:
	      {
	        var _action$payload = action.payload,
	            result_list = _action$payload.result_list,
	            total_amount = _action$payload.total_amount,
	            fetching = _action$payload.fetching,
	            hasPermission = _action$payload.hasPermission,
	            school_has_announcement = _action$payload.school_has_announcement;
	
	        return _extends({}, state, { list: result_list, count: total_amount, fetching: fetching, hasPermission: hasPermission, school_has_announcement: school_has_announcement });
	      }
	    case _getAnnouncementList.FAILED_FETCH_ANNOUNCEMENT_LIST:
	      {
	        var _action$payload2 = action.payload,
	            error = _action$payload2.error,
	            _fetching = _action$payload2.fetching,
	            _hasPermission = _action$payload2.hasPermission;
	
	
	        return _extends({}, state, { error: error, hasPermission: _hasPermission, fetching: _fetching });
	      }
	
	    // Adding
	    case _addAnnouncement.START_ADD_ANNOUNCEMENT:
	      {
	        var announcementInfo = action.payload.announcementInfo;
	
	        var newList = state.list;
	
	        newList.push(announcementInfo);
	        return _extends({}, state, { newList: newList });
	      }
	    case _addAnnouncement.SUCCESS_ADD_ANNOUNCEMENT:
	      {
	        return _extends({}, state, { adding: action.payload.adding });
	      }
	    case _addAnnouncement.FAILED_ADD_ANNOUNCEMENT:
	      {
	        return _extends({}, state, { err: action.payload });
	      }
	
	    // Deleting
	    case _getAnnouncementList.START_DELETE_ANNOUNCEMENT:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case _getAnnouncementList.SUCCESS_DELETE_ANNOUNCEMENT:
	      {
	        return _extends({}, state, { fetching: action.payload.deleting });
	      }
	    case _getAnnouncementList.FAILED_DELETE_ANNOUNCEMENT:
	      {
	        return _extends({}, state, { err: action.payload });
	      }
	
	    // Updating
	    case _updateAnnouncement.START_UPDATE_ANNOUNCEMENT:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case _updateAnnouncement.SUCCESS_UPDATE_ANNOUNCEMENT:
	      {
	        return _extends({}, state, { fetching: action.payload.deleting });
	      }
	    case _updateAnnouncement.FAILED_UPDATE_ANNOUNCEMENT:
	      {
	        return _extends({}, state, { err: action.payload });
	      }
	
	    // Searching
	    case _searchAnnouncement.START_SEARCH_ANNOUNCEMENT_LIST:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case _searchAnnouncement.SUCCESS_SEARCH_ANNOUNCEMENT_LIST:
	      {
	        return _extends({}, state, { list: action.payload.result_list, count: action.payload.total_amount, fetching: action.payload.fetching });
	      }
	    case _searchAnnouncement.FAILED_SEARCH_ANNOUNCEMENT_LIST:
	      {
	        return _extends({}, state, { err: action.payload });
	      }
	    case _setCurrentTabState.SET_CURRENT_TAB_STATE:
	      {
	        return _extends({}, state, { currentTabState: action.payload });
	      }
	    default:
	      return _extends({}, state);
	  }
	}
	module.exports = exports['default'];

/***/ },

/***/ "/Cga":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_ADD_ANNOUNCEMENT = exports.SUCCESS_ADD_ANNOUNCEMENT = exports.START_ADD_ANNOUNCEMENT = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Import controller
	
	
	exports.addAnnouncement = addAnnouncement;
	
	var _addAnnouncement = __webpack_require__("p1IZ");
	
	var _addAnnouncement2 = _interopRequireDefault(_addAnnouncement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	var START_ADD_ANNOUNCEMENT = exports.START_ADD_ANNOUNCEMENT = 'START_ADD_ANNOUNCEMENT';
	var SUCCESS_ADD_ANNOUNCEMENT = exports.SUCCESS_ADD_ANNOUNCEMENT = 'SUCCESS_ADD_ANNOUNCEMENT';
	var FAILED_ADD_ANNOUNCEMENT = exports.FAILED_ADD_ANNOUNCEMENT = 'FAILED_ADD_ANNOUNCEMENT';
	
	// Action Creator
	function addAnnouncement(schoolId, announcementInfo, callback) {
	  return function (dispatch) {
	
	    dispatch({
	      type: START_ADD_ANNOUNCEMENT,
	      payload: { adding: true, announcementInfo: announcementInfo }
	    });
	
	    (0, _addAnnouncement2.default)(schoolId, announcementInfo).then(function (result) {
	      dispatch({
	        type: SUCCESS_ADD_ANNOUNCEMENT,
	        payload: _extends({}, result, { adding: false })
	      });
	      callback();
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_ADD_ANNOUNCEMENT,
	        payload: err
	      });
	    });
	  };
	}

/***/ },

/***/ "p1IZ":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = addAnnouncement;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SEND_TO = ['all', 'teacherOnly'];
	var STATE = ['draft', 'published'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  "send_to": _joiBrowser2.default.string().valid(SEND_TO).required(),
	  "class_id_list": _joiBrowser2.default.allow(''),
	  "title": _joiBrowser2.default.string().required(),
	  "content": _joiBrowser2.default.string().required(),
	  "state": _joiBrowser2.default.string().valid(STATE).required()
	});
	
	function addAnnouncement(schoolId, announcementInfo) {
	
	  if (!schoolId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school Id')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(announcementInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, announcementInfo, {
	    send_to: SEND_TO.indexOf(announcementInfo.send_to),
	    state: STATE.indexOf(announcementInfo.state)
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/create_announcement/" + schoolId + "/",
	      'method': 'POST',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "sYDS":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_FETCH_ANNOUNCEMENT_LIST = exports.SUCCESS_FETCH_ANNOUNCEMENT_LIST = exports.START_FETCH_ANNOUNCEMENT_LIST = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Import controller
	
	
	exports.fetchAnnouncementList = fetchAnnouncementList;
	
	var _getAnnouncementList = __webpack_require__("YxwS");
	
	var _getAnnouncementList2 = _interopRequireDefault(_getAnnouncementList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Fetch Announcement Actions
	var START_FETCH_ANNOUNCEMENT_LIST = exports.START_FETCH_ANNOUNCEMENT_LIST = 'START_FETCH_ANNOUNCEMENT_LIST';
	var SUCCESS_FETCH_ANNOUNCEMENT_LIST = exports.SUCCESS_FETCH_ANNOUNCEMENT_LIST = 'SUCCESS_FETCH_ANNOUNCEMENT_LIST';
	var FAILED_FETCH_ANNOUNCEMENT_LIST = exports.FAILED_FETCH_ANNOUNCEMENT_LIST = 'FAILED_FETCH_ANNOUNCEMENT_LIST';
	
	// Fetch Action Creator
	function fetchAnnouncementList(obj) {
	  return function (dispatch) {
	
	    dispatch({
	      type: START_FETCH_ANNOUNCEMENT_LIST,
	      payload: { fetching: true }
	    });
	
	    (0, _getAnnouncementList2.default)(obj).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_ANNOUNCEMENT_LIST,
	        payload: _extends({}, result, { fetching: false, hasPermission: true })
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_ANNOUNCEMENT_LIST,
	        payload: { error: err, fetching: false, hasPermission: false }
	      });
	    });
	  };
	}

/***/ },

/***/ "YxwS":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = getAnnouncementList;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PARAM = ['all', 'teacherOnly'];
	var STATES = ['draft', 'published', 'all'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  schoolId: _joiBrowser2.default.number().integer().required(),
	  param: _joiBrowser2.default.string().valid(PARAM).required(),
	  amount_per_page: _joiBrowser2.default.number().integer().required(),
	  page_number: _joiBrowser2.default.number().integer().required(),
	  state: _joiBrowser2.default.string().valid(STATES).allow(''),
	  order_by: _joiBrowser2.default.number().allow(''),
	  title_keyword: _joiBrowser2.default.string().allow('')
	});
	
	function getAnnouncementList(obj) {
	
	  if (!obj.schoolId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school Id')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(obj, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var query = _queryString2.default.stringify({
	    state: STATES.indexOf(obj.state) >= 0 && STATES.indexOf(obj.state) <= 1 ? STATES.indexOf(obj.state) : undefined,
	    order_by: obj.order_by,
	    title_keyword: obj.title_keyword
	  });
	
	  var param = PARAM.indexOf(obj.param);
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/g_announce_lst/' + obj.schoolId + '/' + param + '/' + obj.amount_per_page + '/' + obj.page_number + '?' + query,
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "eVF0":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_UPDATE_ANNOUNCEMENT = exports.SUCCESS_UPDATE_ANNOUNCEMENT = exports.START_UPDATE_ANNOUNCEMENT = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Import controller
	
	
	exports.updateAnnouncement = updateAnnouncement;
	
	var _updateAnnouncement = __webpack_require__("93pi");
	
	var _updateAnnouncement2 = _interopRequireDefault(_updateAnnouncement);
	
	var _getAnnouncementList = __webpack_require__("sYDS");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	var START_UPDATE_ANNOUNCEMENT = exports.START_UPDATE_ANNOUNCEMENT = 'START_UPDATE_ANNOUNCEMENT';
	var SUCCESS_UPDATE_ANNOUNCEMENT = exports.SUCCESS_UPDATE_ANNOUNCEMENT = 'SUCCESS_UPDATE_ANNOUNCEMENT';
	var FAILED_UPDATE_ANNOUNCEMENT = exports.FAILED_UPDATE_ANNOUNCEMENT = 'FAILED_UPDATE_ANNOUNCEMENT';
	
	var schoolId = localStorage.getItem('schoolId');
	
	// Action Creator
	function updateAnnouncement(announcementId, announcementInfo, currentTabState, callback) {
	  return function (dispatch) {
	
	    dispatch({
	      type: START_UPDATE_ANNOUNCEMENT,
	      payload: { updating: true, announcementInfo: announcementInfo }
	    });
	
	    (0, _updateAnnouncement2.default)(announcementId, announcementInfo).then(function (result) {
	      dispatch({
	        type: SUCCESS_UPDATE_ANNOUNCEMENT,
	        payload: _extends({}, result, { updating: false })
	      });
	      if (currentTabState.tabName == 'all') {
	        dispatch((0, _getAnnouncementList.fetchAnnouncementList)({ schoolId: Number(schoolId), param: 'all', amount_per_page: 12, page_number: 1 }));
	      } else if (currentTabState.tabName == 'draft') {
	        dispatch((0, _getAnnouncementList.fetchAnnouncementList)({ schoolId: Number(schoolId), param: 'all', amount_per_page: 12, page_number: 1, state: 'draft' }));
	      } else {
	        dispatch((0, _getAnnouncementList.fetchAnnouncementList)({ schoolId: Number(schoolId), param: 'all', amount_per_page: 12, page_number: 1, state: 'published' }));
	      }
	
	      callback();
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_UPDATE_ANNOUNCEMENT,
	        payload: err
	      });
	    });
	  };
	}

/***/ },

/***/ "93pi":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = updateAnnouncement;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SEND_TO = ['all', 'teacherOnly'];
	var STATE = ['draft', 'published'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  "send_to": _joiBrowser2.default.string().valid(SEND_TO).allow(''),
	  "class_id_list": _joiBrowser2.default.allow(''),
	  "title": _joiBrowser2.default.string().allow(''),
	  "content": _joiBrowser2.default.string().allow(''),
	  "state": _joiBrowser2.default.string().valid(STATE).allow('')
	});
	
	function updateAnnouncement(announcementId, announcementInfo) {
	
	  if (!announcementId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing announcement Id')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(announcementInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, announcementInfo, {
	    send_to: SEND_TO.indexOf(announcementInfo.send_to),
	    state: announcementInfo.state ? STATE.indexOf(announcementInfo.state) : 0
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/announcement_detail/" + announcementId + "/",
	      'method': 'PUT',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "EV0/":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_SEARCH_ANNOUNCEMENT_LIST = exports.SUCCESS_SEARCH_ANNOUNCEMENT_LIST = exports.START_SEARCH_ANNOUNCEMENT_LIST = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Import controller
	
	
	exports.searchAnnouncement = searchAnnouncement;
	
	var _searchAnnouncement = __webpack_require__("ujpM");
	
	var _searchAnnouncement2 = _interopRequireDefault(_searchAnnouncement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Fetch Announcement Actions
	var START_SEARCH_ANNOUNCEMENT_LIST = exports.START_SEARCH_ANNOUNCEMENT_LIST = 'START_SEARCH_ANNOUNCEMENT_LIST';
	var SUCCESS_SEARCH_ANNOUNCEMENT_LIST = exports.SUCCESS_SEARCH_ANNOUNCEMENT_LIST = 'SUCCESS_SEARCH_ANNOUNCEMENT_LIST';
	var FAILED_SEARCH_ANNOUNCEMENT_LIST = exports.FAILED_SEARCH_ANNOUNCEMENT_LIST = 'FAILED_SEARCH_ANNOUNCEMENT_LIST';
	
	// Fetch Action Creator
	function searchAnnouncement(obj) {
	  return function (dispatch) {
	
	    dispatch({
	      type: START_SEARCH_ANNOUNCEMENT_LIST,
	      payload: { fetching: true }
	    });
	
	    (0, _searchAnnouncement2.default)(obj).then(function (result) {
	      dispatch({
	        type: SUCCESS_SEARCH_ANNOUNCEMENT_LIST,
	        payload: _extends({}, result, { fetching: false })
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_SEARCH_ANNOUNCEMENT_LIST,
	        payload: err
	      });
	    });
	  };
	}

/***/ },

/***/ "ujpM":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = searchAnnouncement;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PARAM = ['all', 'teacherOnly'];
	var STATES = ['draft', 'published'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  schoolId: _joiBrowser2.default.number().integer().required(),
	  param: _joiBrowser2.default.string().valid(PARAM).required(),
	  amount_per_page: _joiBrowser2.default.number().integer().required(),
	  page_number: _joiBrowser2.default.number().integer().required(),
	  state: _joiBrowser2.default.string().valid(STATES).allow(''),
	  title_keyword: _joiBrowser2.default.string().required()
	});
	
	function searchAnnouncement(obj) {
	  if (!obj.schoolId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school Id')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(obj, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var param = PARAM.indexOf(obj.param);
	
	  var state = void 0;
	  var uri = void 0;
	  if (obj.state) {
	    state = STATES.indexOf(obj.state);
	    uri = "/g_announce_lst/" + obj.schoolId + "/" + param + "/" + obj.amount_per_page + "/" + obj.page_number + "?state=" + state + "&title_keyword=" + encodeURIComponent(obj.title_keyword);
	  } else {
	    uri = "/g_announce_lst/" + obj.schoolId + "/" + param + "/" + obj.amount_per_page + "/" + obj.page_number + "?title_keyword=" + encodeURIComponent(obj.title_keyword);
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': uri,
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "d4iu":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.setCurrentTabState = setCurrentTabState;
	var SET_CURRENT_TAB_STATE = exports.SET_CURRENT_TAB_STATE = 'SET_CURRENT_TAB_STATE';
	
	function setCurrentTabState(currentState) {
	  return {
	    type: SET_CURRENT_TAB_STATE,
	    payload: currentState
	  };
	}

/***/ },

/***/ "Ywk3":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactReduxHotline = __webpack_require__("IKa1");
	
	var _unarchiveStudent = __webpack_require__("LcO5");
	
	var _unarchiveStudent2 = _interopRequireDefault(_unarchiveStudent);
	
	var _getStudentSummary = __webpack_require__("/y3Y");
	
	var _getStudentSummary2 = _interopRequireDefault(_getStudentSummary);
	
	var _archiveStudent = __webpack_require__("GDgk");
	
	var _archiveStudent2 = _interopRequireDefault(_archiveStudent);
	
	var _constants = __webpack_require__("AvVx");
	
	var _alert = __webpack_require__("BGi1");
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *
	 * WARNING: We're only using react-redux-hotline in Student page only.
	 *
	 */
	
	var initState = {
	  studentList: [],
	  studentSelectedByCheckbox: [],
	  touchedServer: false,
	  count: 0,
	  pagination: _constants.DEFAULT_PAGINATION
	};
	
	var methods = {
	  setStudentState: function setStudentState(_ref, newState) {
	    var setState = _ref.setState,
	        state = _ref.state,
	        methods = _ref.methods;
	
	    setState({
	      studentState: newState
	    });
	  },
	
	  fetchStudent: function fetchStudent(_ref2, studentState) {
	    var setState = _ref2.setState,
	        state = _ref2.state,
	        methods = _ref2.methods;
	    var pagination = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var searchKeyword = arguments[3];
	    var order_by = arguments[4];
	
	    if (typeof studentState !== 'string') throw new Error('studentState must be a string.');
	
	    var schoolId = localStorage.getItem("schoolId");
	
	    setState({
	      fetching: true,
	      counted: false,
	      studentState: studentState,
	      searchStudentKeyword: searchKeyword
	    });
	
	    var itemsCountPerPage = pagination.itemsCountPerPage || state.pagination.itemsCountPerPage;
	
	    var activePage = pagination.activePage || state.pagination.activePage;
	
	    (0, _getStudentSummary2.default)({
	      schoolId: schoolId,
	      itemPerPage: itemsCountPerPage,
	      pageNumber: activePage,
	      studentState: studentState || state.studentState,
	      searchKeyword: searchKeyword,
	      order_by: order_by
	    }).then(function (res) {
	
	      var params = {
	        fetching: false,
	        studentList: res.list,
	        pagination: {
	          activePage: activePage,
	          itemsCountPerPage: itemsCountPerPage,
	          totalItemsCount: res.student_count
	        },
	        currentCount: res.student_count,
	        school_has_student: res.school_has_student
	
	      };
	
	      setState(params);
	    }).catch(function (err) {
	
	      var params = {
	        fetching: false
	      };
	
	      setState(params);
	    });
	  },
	
	  unarchiveStudent: function unarchiveStudent(_ref3, studentID) {
	    var setState = _ref3.setState,
	        state = _ref3.state,
	        methods = _ref3.methods;
	
	
	    (0, _unarchiveStudent2.default)(studentID).then(function (res) {
	      if (res.data.result === 'failure') {
	        _alert2.default.message(__('You are about go over the student limit, please upgrade to higher subscription plan to add more students', 'header'), __('Upgrade Subscription Plan', 'header'));
	      } else {
	
	        methods.student.fetchStudent('after student is unarchived @unarchiveStudent', 'archived');
	      }
	      // ... for now it's empty
	    }).catch(function (err) {
	      // ... for now it's empty
	    });
	  },
	
	  updateSelectedStudents: function updateSelectedStudents(_ref4, studentSelectedByCheckbox) {
	    var setState = _ref4.setState,
	        state = _ref4.state,
	        methods = _ref4.methods;
	
	    setState({
	      studentSelectedByCheckbox: studentSelectedByCheckbox
	    });
	  },
	
	  archiveSingleStudent: function archiveSingleStudent(_ref5, student) {
	    var setState = _ref5.setState,
	        state = _ref5.state,
	        methods = _ref5.methods;
	
	    (0, _archiveStudent2.default)([student], function () {
	      methods.student.fetchStudent('after archived a single student', state.studentState);
	    });
	  },
	
	  archiveMultipleSelectedStudents: function archiveMultipleSelectedStudents(_ref6) {
	    var setState = _ref6.setState,
	        state = _ref6.state,
	        methods = _ref6.methods;
	
	
	    var students = state.studentSelectedByCheckbox;
	
	    (0, _archiveStudent2.default)(students, function (res) {
	
	      methods.student.fetchStudent('after archived multiple students', state.studentState);
	    });
	  }
	};
	
	(0, _reactReduxHotline.install)('student', initState, methods);

/***/ },

/***/ "IKa1":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.hotline = exports.install = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getReducers = getReducers;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var lines = {};
	
	var lineIDs = {};
	
	var reducers = {};
	
	function reducerFactory(id, name, initState) {
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	    var action = arguments[1];
	
	    if (action.type.indexOf(id) > -1) {
	      return _extends({}, state, action.payload);
	    }
	
	    return state;
	  };
	}
	
	function getReducers(store) {
	  return reducers;
	}
	
	var install = exports.install = function install(name) {
	  var initState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var methods = arguments[2];
	
	  lines[name] = methods;
	
	  var id = name + '_' + Math.random().toString(36).substring(7);
	
	  lineIDs[name] = id;
	
	  reducers[name] = reducerFactory(id, name, initState);
	};
	
	// Simple wrapper again wrapped by connect
	// DO NOT rewrap it with connect. This can be used as an alternative
	// to Redux connect.
	var hotline = exports.hotline = function hotline(Target) {
	  for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    names[_key - 1] = arguments[_key];
	  }
	
	  var Hotline = function (_React$Component) {
	    _inherits(Hotline, _React$Component);
	
	    function Hotline(props) {
	      _classCallCheck(this, Hotline);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	      _this._setStateByDispatch = _this._setStateByDispatch.bind(_this);
	
	      _this._updateMethodParams = _this._updateMethodParams.bind(_this);
	
	      _this.processed = {};
	
	      _this.methodParams = {};
	
	      _this.state = {};
	
	      names.map(function (storeName) {
	        var name = storeName;
	
	        _this.processed[name] = {};
	
	        var methods = lines[name] || {};
	        var state = _this.props.__hotlines[name];
	
	        _this.methodParams[name] = {};
	
	        Object.keys(methods).map(function (methodName) {
	          _this.methodParams[name][methodName] = {
	            state: state,
	            methods: _this.processed
	          };
	
	          var processedMethod = function processedMethod(context) {
	            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	              args[_key2 - 1] = arguments[_key2];
	            }
	
	            _this.methodParams[name][methodName].setState = _this._setStateByDispatch(name, methodName, context), methods[methodName].apply(methods, [_this.methodParams[name][methodName]].concat(args));
	          };
	
	          _this.processed[name][methodName] = processedMethod;
	        });
	      });
	
	      return _this;
	    }
	
	    Hotline.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      this._updateMethodParams(nextProps);
	    };
	
	    //
	    // update this.methodParams through reference
	    //
	
	
	    Hotline.prototype._updateMethodParams = function _updateMethodParams(nextProps) {
	      var _this2 = this;
	
	      names.map(function (name) {
	        var methods = lines[name] || {};
	
	        Object.keys(methods).map(function (methodName) {
	
	          _this2.methodParams[name][methodName].state = nextProps.__hotlines[name];
	
	          var processedMethod = function processedMethod(context) {
	            for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	              args[_key3 - 1] = arguments[_key3];
	            }
	
	            _this2.methodParams[name][methodName].setState = _this2._setStateByDispatch(name, methodName, context), methods[methodName].apply(methods, [_this2.methodParams[name][methodName]].concat(args));
	          };
	
	          _this2.processed[name][methodName] = processedMethod;
	        });
	      });
	    };
	
	    Hotline.prototype._setStateByDispatch = function _setStateByDispatch(name, key, context) {
	      var _this3 = this;
	
	      var fn = name + '.' + key;
	
	      return function (payload, cb) {
	
	        if (typeof context !== 'string') {
	          throw new Error(fn + '() is missing a context (string). Pass a string as a context as its first param. Eg. ' + fn + '(\'when login button is clicked\')');
	        }
	
	        var type = (fn + '() ' + context).toUpperCase() + (' [' + lineIDs[name] + ']');
	
	        //
	        // wrapped by redux connect. We will use their dispatch
	        //
	        _this3.props.dispatch({
	          type: type,
	          payload: payload
	        });
	
	        _this3._updateMethodParams(_this3.props);
	
	        if (typeof cb === 'function') {
	          cb();
	        }
	
	        // this.forceUpdate()
	      };
	    };
	
	    Hotline.prototype.render = function render() {
	      var _this4 = this;
	
	      var processed = {};
	      if (this.processed) {
	        //
	        // messy but no choice
	        //
	        names.map(function (name) {
	
	          if (_this4.props[name]) {
	            console.warn('' + name);
	          }
	
	          processed[name] = _extends({}, _this4.processed[name], _this4.props.__hotlines[name]);
	        });
	      }
	
	      //
	      // The order of passing props is not very explcit
	      // but DO NOT change the order
	      //
	      return _react2.default.createElement(Target, _extends({}, this.props, processed));
	    };
	
	    return Hotline;
	  }(_react2.default.Component);
	
	  return (0, _reactRedux.connect)(function (reduxStates) {
	    var __hotlines = {};
	    names.forEach(function (name) {
	      __hotlines[name] = reduxStates[name];
	    });
	
	    return {
	      __hotlines: __hotlines
	    };
	  })(Hotline);
	};

/***/ },

/***/ "LcO5":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = unarchiveStudent;
	
	var _config = __webpack_require__("hxne");
	
	var _updateStudentState = __webpack_require__("Y/r6");
	
	var _updateStudentState2 = _interopRequireDefault(_updateStudentState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	// Archive student by student id
	//
	// example:
	// unarchiveStudent(studentId)
	// 			.then(()=>{
	// 				// when success
	// 			})
	// 			.catch((err)=>{
	// 				// when failed
	// 			});
	function unarchiveStudent(studentId) {
	
	  if (!studentId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school ID (number)')
	      });
	    });
	  }
	
	  return (0, _updateStudentState2.default)(studentId, "not_scheduled");
	}
	module.exports = exports["default"];

/***/ },

/***/ "Y/r6":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = updateStudentState;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATES = ["not_scheduled", "enrolled", "archived"];
	
	// eg. updateStudentState(123, "archived") <-- archive student
	function updateStudentState(studentId, newState) {
	
	  if (!studentId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school ID')
	      });
	    });
	  }
	
	  if (STATES.indexOf(newState) == -1) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Invalid states: please enter one of the following states: ' + STATES.toString())
	      });
	    });
	  }
	
	  // this is the data structure the API wants
	  var data = {
	    state: STATES.indexOf(newState)
	  };
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/u_schstdtstt/' + studentId + '/',
	      'method': 'PUT',
	      'data': JSON.stringify(data),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "GDgk":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (studentsToArchive, cb) {
	  var studentWithClass = [];
	  var confirmText = void 0;
	  var confirmTitle = void 0;
	
	  studentsToArchive.map(function (student) {
	    if (student.class_count > 0) {
	      studentWithClass.push(student.sName);
	    }
	  });
	
	  if (studentsToArchive.length < 2) {
	    confirmTitle = __('Archive Student', 'student');
	  } else {
	    confirmTitle = __('Archive Multiple Students', 'student');
	  }
	
	  if (studentWithClass.length > 0) {
	    if (studentsToArchive.length < 2) {
	      confirmText = _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          null,
	          __("Student {student} is currently in class, proceed to archive student?", 'student', { student: studentWithClass.join(', ') })
	        )
	      );
	    } else {
	      confirmText = _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          null,
	          __("Students {student} are currently in classes, proceed to archive students?", 'student', { student: studentWithClass.join(', ') })
	        )
	      );
	    }
	  } else {
	    confirmText = __('Proceed to archive student {student}?', 'student');
	  }
	
	  (0, _confirm.confirm)(confirmText, confirmTitle).then(function () {
	    var studentIDs = studentsToArchive.map(function (student) {
	      return student.schoolStudentID;
	    });
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    (0, _archiveMultipleStudents2.default)(schoolId, studentIDs).then(function (res) {
	      cb(null, res);
	    }).catch(function (err) {
	      cb(err, null);
	    });
	  }).catch(function (err) {
	    cb(err);
	  });
	};
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _archiveMultipleStudents = __webpack_require__("0ZyH");
	
	var _archiveMultipleStudents2 = _interopRequireDefault(_archiveMultipleStudents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	// Handles archive Student when user clicks "archive" from "options" dropdown
	//
	module.exports = exports["default"];

/***/ },

/***/ "0ZyH":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = archiveMultipleStudent;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function archiveMultipleStudent(schoolId, studentIdList) {
	
	  if (!schoolId) {
	    throw new Error('missing school ID');
	  }
	
	  if (!Array.isArray(studentIdList) || studentIdList.length == 0) {
	    throw new Error('studentIdList must be a non-empty array.');
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/multi_stu_archive/' + schoolId + '/',
	      'method': 'PUT',
	      'data': JSON.stringify({
	        student_id_list: studentIdList
	      }),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "AvVx":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var SHOW_CLASSES_UPTO_NUMBER_OF = exports.SHOW_CLASSES_UPTO_NUMBER_OF = 3;
	
	var FIRST_PAGE = exports.FIRST_PAGE = 1;
	
	var ITEMS_COUNT_PER_PAGE = exports.ITEMS_COUNT_PER_PAGE = 50;
	
	var DEFAULT_PAGINATION = exports.DEFAULT_PAGINATION = {
	  activePage: FIRST_PAGE,
	  itemsCountPerPage: ITEMS_COUNT_PER_PAGE,
	  totalItemsCount: 0
	};
	
	var locale = {
	  id: 'StudentConstant',
	  code: 'CN',
	  text: {
	    "./images/student_en@2x.png": "./images/student@2x.png",
	    'Student Record Documentation and Management': '学员档案记录与管理',
	    'Student Management includes entry, search, edit multiple students, and register students through iPad. Student Management divides all students into different categories: current, not enrolled, enrolled, and past students. It allows you to enroll students, as well as payments and attendance. It also allows you to check student status.': '学员管理包括录入，查询，及批量学员同时操作，并可以设置前台iPad登记与报名。学员被划分为当期，未排班，在读，以及历史的多种状态类型。通过简单的操作给学生排班，充值，缴费，办理签到等各种事项。随时可以查询学生的上课状态，缴费，学费，退费，充值等记录。'
	  }
	};
	
	var onBoardingContents = exports.onBoardingContents = {
	  // we show this when student state is 'all_not_archived'
	  all_not_archived: {
	    title: __('Student Record Documentation and Management', locale),
	    text: __('Student Management includes entry, search, edit multiple students, and register students through iPad. Student Management divides all students into different categories: current, not enrolled, enrolled, and past students. It allows you to enroll students, as well as payments and attendance. It also allows you to check student status.', locale),
	    image: __webpack_require__(3)(__('./images/student_en@2x.png', locale)),
	    showArrow: true
	  }
	
	};

/***/ },

/***/ 3:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./DefaultTab": "+mk/",
		"./DefaultTab.js": "+mk/",
		"./Student.scss": "S5pW",
		"./StudentTable/ClassInfoTd": "n5V7",
		"./StudentTable/ClassInfoTd.js": "n5V7",
		"./StudentTable/ClassStatusTd": "e/Ic",
		"./StudentTable/ClassStatusTd.js": "e/Ic",
		"./StudentTable/PaymentTd": "u5QA",
		"./StudentTable/PaymentTd.js": "u5QA",
		"./StudentTable/StudentInfoTd": "0vxt",
		"./StudentTable/StudentInfoTd.js": "0vxt",
		"./StudentTable/index": "8JRb",
		"./StudentTable/index.js": "8JRb",
		"./StudentTable/student-table.scss": "A9k/",
		"./archive-student": "GDgk",
		"./archive-student.js": "GDgk",
		"./constants": "AvVx",
		"./constants.js": "AvVx",
		"./ducks": "Qttv",
		"./ducks.js": "Qttv",
		"./enroll-student-to-class": "PhAh",
		"./enroll-student-to-class.js": "PhAh",
		"./exit-class": "YFf2",
		"./exit-class.js": "YFf2",
		"./hotline": "Ywk3",
		"./hotline.js": "Ywk3",
		"./images/student@2x.png": "etGk",
		"./images/student_en@2x.png": "tfRU",
		"./index": "7No8",
		"./index.js": "7No8",
		"./locale": "aMEQ",
		"./locale.js": "aMEQ",
		"./payment": "PWBe",
		"./payment.js": "PWBe",
		"./refund": "qP8b",
		"./refund.js": "qP8b",
		"./student-table-field": "27cS",
		"./student-table-field.js": "27cS",
		"./table-settings": "nQH9",
		"./table-settings.js": "nQH9",
		"./unarchive-student": "JMLs",
		"./unarchive-student.js": "JMLs"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 3;


/***/ },

/***/ "+mk/":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactReduxHotline = __webpack_require__("IKa1");
	
	var _StudentTable = __webpack_require__("8JRb");
	
	var _StudentTable2 = _interopRequireDefault(_StudentTable);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _PanelWrapper = __webpack_require__("VPji");
	
	var _searchStudentSummary = __webpack_require__("R3SI");
	
	var _searchStudentSummary2 = _interopRequireDefault(_searchStudentSummary);
	
	var _tableSettings = __webpack_require__("nQH9");
	
	var _tableSettings2 = _interopRequireDefault(_tableSettings);
	
	var _studentTableField = __webpack_require__("27cS");
	
	var _studentTableField2 = _interopRequireDefault(_studentTableField);
	
	var _enrollStudentToClass = __webpack_require__("PhAh");
	
	var _enrollStudentToClass2 = _interopRequireDefault(_enrollStudentToClass);
	
	var _exitClass = __webpack_require__("YFf2");
	
	var _exitClass2 = _interopRequireDefault(_exitClass);
	
	var _refund = __webpack_require__("qP8b");
	
	var _refund2 = _interopRequireDefault(_refund);
	
	var _archiveStudent = __webpack_require__("GDgk");
	
	var _archiveStudent2 = _interopRequireDefault(_archiveStudent);
	
	var _unarchiveStudent = __webpack_require__("JMLs");
	
	var _unarchiveStudent2 = _interopRequireDefault(_unarchiveStudent);
	
	var _payment = __webpack_require__("PWBe");
	
	var _payment2 = _interopRequireDefault(_payment);
	
	var _OnBoardingNatural = __webpack_require__("PwUp");
	
	var _OnBoardingNatural2 = _interopRequireDefault(_OnBoardingNatural);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _constants = __webpack_require__("AvVx");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <DefaultTab
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is ...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @redux
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	//
	
	
	// controllers
	
	
	var DefaultTab = function (_React$Component) {
	  _inherits(DefaultTab, _React$Component);
	
	  function DefaultTab(props) {
	    _classCallCheck(this, DefaultTab);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.unarchiveStudent = _unarchiveStudent2.default.bind(_this);
	    _this.refund = _refund2.default.bind(_this);
	    _this.exitClass = _exitClass2.default.bind(_this);
	    _this.archiveStudent = _archiveStudent2.default.bind(_this);
	    _this.enrollStudentToClass = _enrollStudentToClass2.default.bind(_this);
	    _this.payment = _payment2.default.bind(_this);
	
	    _this._settingsModifier = _this._settingsModifier.bind(_this);
	    _this._onTrSelectionToggled = _this._onTrSelectionToggled.bind(_this);
	    _this._onPageChange = _this._onPageChange.bind(_this);
	    _this._onItemsCountPerPageChange = _this._onItemsCountPerPageChange.bind(_this);
	
	    _this.state = {
	      expandedClassInfos: {
	        // [student.schoolStudentID]: true <-- if true which means 'the collapsed school classes'
	        // are expanded and all shown
	      }
	    };
	
	    return _this;
	  }
	
	  DefaultTab.prototype.componentWillMount = function componentWillMount() {
	    var _props = this.props,
	        studentState = _props.studentState,
	        orderBy = _props.orderBy;
	
	
	    this.props.student.setStudentState('@constructor @DefaultTab', studentState);
	
	    this.collapseRows = this.collapseRows.bind(this);
	    this.tableSettings = _tableSettings2.default.call(this, studentState);
	    this.studentFields = _studentTableField2.default.call(this, studentState);
	
	    this.props.student.fetchStudent('@componentWillMount() @DefualtTab', studentState, {
	      activePage: _constants.FIRST_PAGE,
	      itemsCountPerPage: _constants.ITEMS_COUNT_PER_PAGE
	    }, this.props.filterData.searchKeyword, orderBy);
	  };
	
	  DefaultTab.prototype._onPageChange = function _onPageChange(activePage) {
	    var _props2 = this.props,
	        studentState = _props2.studentState,
	        orderBy = _props2.orderBy,
	        filterData = _props2.filterData;
	
	
	    this.props.student.fetchStudent('after changing page @DefualtTab', studentState, { activePage: activePage }, filterData.searchKeyword, orderBy);
	  };
	
	  DefaultTab.prototype._onItemsCountPerPageChange = function _onItemsCountPerPageChange(itemsCountPerPage) {
	    var _props3 = this.props,
	        studentState = _props3.studentState,
	        orderBy = _props3.orderBy,
	        filterData = _props3.filterData;
	
	
	    this.props.student.fetchStudent('after changing items per page @DefualtTab', studentState, { itemsCountPerPage: itemsCountPerPage }, filterData.searchKeyword, orderBy);
	  };
	
	  DefaultTab.prototype.isClassInfosExpanded = function isClassInfosExpanded(student) {
	    return this.state.expandedClassInfos[student.schoolStudentID] == true;
	  };
	
	  DefaultTab.prototype.expandClassInfos = function expandClassInfos(student) {
	    var _extends2;
	
	    var expandedClassInfos = this.state.expandedClassInfos;
	
	    //
	    // expand the collapsed class info
	    // TODO: should we refactor it as more explicit method inside the TabComponent?
	    //
	
	    this.setState({
	      expandedClassInfos: _extends({}, expandedClassInfos, (_extends2 = {}, _extends2[student.schoolStudentID] = true, _extends2))
	    });
	  };
	
	  DefaultTab.prototype.collapseRows = function collapseRows(_ref) {
	    var trIndex = _ref.trIndex,
	        tbodyData = _ref.tbodyData;
	
	    if (!tbodyData) {
	      return;
	    }
	    var student = tbodyData[0];
	    return this.isClassInfosExpanded(student) || trIndex < _constants.SHOW_CLASSES_UPTO_NUMBER_OF;
	  };
	
	  //
	  // Insert a "refund" button when there is refundable class
	  //
	
	
	  DefaultTab.prototype._settingsModifier = function _settingsModifier(settings, _ref2) {
	    var student = _ref2.trData;
	
	    //
	    // we can assume that we want to refund anytime for now
	    //
	    var showRefund = true;
	
	    //
	    // Later we might want to add 'refund' button conditionally,
	    //
	    // if (Array.isArray(student.list)) {
	    //  student.list.map((cls)=>{
	    //   ...do some conditional stuff
	    //  });
	    // }
	    //
	    if (!showRefund || !settings[2]) {
	      return settings;
	    }
	
	    settings[2].dropdown.splice(2, 0, {
	      title: __('Refund', 'student'),
	      onClick: this.refund
	    });
	
	    return settings;
	  };
	
	  DefaultTab.prototype._onTrSelectionToggled = function _onTrSelectionToggled(_ref3) {
	    var selected = _ref3.selected;
	
	    this.props.student.updateSelectedStudents('selected students updated @ DefaultTab', selected);
	  };
	
	  DefaultTab.prototype.render = function render() {
	    var _props$student = this.props.student,
	        studentList = _props$student.studentList,
	        studentState = _props$student.studentState,
	        fetching = _props$student.fetching,
	        currentCount = _props$student.currentCount,
	        pagination = _props$student.pagination,
	        studentSelectedByCheckbox = _props$student.studentSelectedByCheckbox,
	        school_has_student = _props$student.school_has_student;
	
	    // we show onBoarding content in the following scenario
	    // 1. The server is not fetching. We want to use fetched info not, default currentCount value 0.
	    // 2. OnBoarding content is actually not empty
	    // 3. currentCount is 0
	
	    var content = _constants.onBoardingContents[studentState] || {};
	
	    if (studentList.length == 0 && fetching == true && !content) {
	      return _react2.default.createElement('div', null);
	    }
	
	    if (school_has_student == false && content && fetching !== true) {
	      return _react2.default.createElement(_OnBoardingNatural2.default, {
	        isShown: true,
	        showArrow: content.showArrow,
	        title: content.title,
	        text: content.text,
	        image: content.image
	      });
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'default-tab' },
	      _react2.default.createElement(_StudentTable2.default, _extends({
	        data: studentList,
	        fetching: fetching,
	        settings: this.tableSettings,
	        fields: this.studentFields,
	        trFilter: this.collapseRows,
	        settingsModifier: this._settingsModifier,
	        onTrSelectionToggled: this._onTrSelectionToggled,
	        useMultiSelection: studentState !== 'archived',
	        studentSelectedByCheckbox: studentSelectedByCheckbox,
	
	        pagination: pagination,
	        usePagination: true,
	        onPageChange: this._onPageChange,
	        onItemsCountPerPageChange: this._onItemsCountPerPageChange
	
	      }, this.props))
	    );
	  };
	
	  return DefaultTab;
	}(_react2.default.Component);
	
	exports.default = (0, _reactReduxHotline.hotline)(DefaultTab, 'user', 'student', 'schoolDetail');
	module.exports = exports['default'];

/***/ },

/***/ "8JRb":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Table = __webpack_require__("1drC");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _EnrollClass = __webpack_require__("0dt0");
	
	var _EnrollClass2 = _interopRequireDefault(_EnrollClass);
	
	var _Export = __webpack_require__("M4e5");
	
	var _Export2 = _interopRequireDefault(_Export);
	
	var _CreateClass = __webpack_require__("dFGx");
	
	var _CreateClass2 = _interopRequireDefault(_CreateClass);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _locale = __webpack_require__("aMEQ");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <StudentTable
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 		data={[student list in array]}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		settings={{setting object for the table}}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	//
	
	
	var CONTROLLER_WIDTH = "14%";
	
	var StudentTable = function (_React$Component) {
	  _inherits(StudentTable, _React$Component);
	
	  function StudentTable(props) {
	    _classCallCheck(this, StudentTable);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.convertToStudentTableData = _this.convertToStudentTableData.bind(_this);
	    _this.deleteMultipleStudents = _this.deleteMultipleStudents.bind(_this);
	    _this.enrollMultipleStudentsToClass = _this.enrollMultipleStudentsToClass.bind(_this);
	    return _this;
	  }
	
	  StudentTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProp) {};
	
	  // Ryan:
	  // When props.data comes in to StudentTable, we convert it into
	  // a format that StudentTable wants. This is a terrible way
	  // because it is very complicated. It could be much simplified,
	  // if we used <div> instead of nesting <tr>. However, we wanted
	  // to write a flawless(?) table because we loved table.
	
	
	  StudentTable.prototype.convertToStudentTableData = function convertToStudentTableData(data) {
	    var students = data.map(function (student, idx) {
	      var row = [];
	
	      // pushing classes into the row
	      if (Array.isArray(student.list) && student.list.length > 0) {
	        student.list.map(function (cls, idx) {
	          if (idx == 0) {
	            // we only need student data for the first row
	            row[0] = _extends({}, student, { classInfo: cls });
	            return;
	          }
	          // the next rows we omit student data
	          row.push({
	            classInfo: cls
	          });
	        });
	      } else {
	        // there is no class list!
	        row[0] = _extends({}, student);
	      }
	
	      return row;
	    });
	
	    return students;
	  };
	
	  StudentTable.prototype.deleteMultipleStudents = function deleteMultipleStudents() {
	    var student = this.props.student;
	
	
	    student.archiveMultipleSelectedStudents('deleting multiple studnets');
	  };
	
	  StudentTable.prototype.enrollMultipleStudentsToClass = function enrollMultipleStudentsToClass() {
	    var _this2 = this;
	
	    var student = this.props.student;
	    var studentSelectedByCheckbox = student.studentSelectedByCheckbox,
	        studentState = student.studentState;
	
	
	    (0, _EnrollClass2.default)({ students: studentSelectedByCheckbox }).then(function (_ref) {
	      var updateStudentTableRequired = _ref.updateRequired;
	
	      if (updateStudentTableRequired) {
	        student.fetchStudent('After editing classes @enroll-student-to-class', studentState);
	        _this2.forceUpdate();
	      }
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  StudentTable.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        settings = _props.settings,
	        fields = _props.fields,
	        fetching = _props.fetching,
	        trFilter = _props.trFilter,
	        settingsModifier = _props.settingsModifier,
	        onTrSelectionToggled = _props.onTrSelectionToggled,
	        useMultiSelection = _props.useMultiSelection,
	        pagination = _props.pagination,
	        usePagination = _props.usePagination,
	        onPageChange = _props.onPageChange,
	        onItemsCountPerPageChange = _props.onItemsCountPerPageChange,
	        studentSelectedByCheckbox = _props.studentSelectedByCheckbox;
	    var _props$student = this.props.student,
	        deleting = _props$student.deleting,
	        studentState = _props$student.studentState;
	
	    return _react2.default.createElement(_Table.Table, {
	      data: this.convertToStudentTableData(data),
	      fields: fields,
	      className: 'student-table',
	      settingThTitle: __('Settings', 'class'),
	      settingWidth: CONTROLLER_WIDTH,
	      settings: settings,
	      useTbodyAsRow: true,
	      oneSettingPerRow: true,
	      onTrSelectionToggled: onTrSelectionToggled,
	      fetching: fetching || deleting,
	
	      dropdownGuideWidth: 160,
	      dropdownGuideHeight: 228,
	
	      trFilter: trFilter,
	      settingsModifier: settingsModifier,
	      usePagination: usePagination,
	      pagination: pagination,
	      onPageChange: onPageChange,
	      onItemsCountPerPageChange: onItemsCountPerPageChange,
	      useMultiSelection: true,
	
	      hasTopUtilSection: studentState == 'archived' ? false : true,
	      topUtilSection: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _R2.default,
	          { can: 'assign_student_to_class', by: 'disable' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn', disabled: studentSelectedByCheckbox.length < 1 ? 'disabled' : '', onClick: this.enrollMultipleStudentsToClass },
	            __('Join Class', 'studentTable')
	          )
	        ),
	        _react2.default.createElement(
	          _R2.default,
	          { can: 'create_class_and_assign_student', by: 'disable' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn', disabled: studentSelectedByCheckbox.length < 1 ? 'disabled' : '', onClick: function onClick() {
	                var studentIdList = [];
	                studentSelectedByCheckbox.map(function (student) {
	                  studentIdList.push(student.schoolStudentID);
	                });
	                (0, _CreateClass2.default)({ mode: 'create', studentIdList: studentIdList });
	              } },
	            __('Create Class', 'studentTable')
	          )
	        ),
	        _react2.default.createElement(
	          _R2.default,
	          { can: 'archive_student_from_school', by: 'disable' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn', disabled: studentSelectedByCheckbox.length < 1 ? 'disabled' : '', onClick: this.deleteMultipleStudents },
	            __('Archive Students', _locale2.default)
	          )
	        )
	      )
	    });
	  };
	
	  return StudentTable;
	}(_react2.default.Component);
	
	exports.default = StudentTable;
	module.exports = exports['default'];

/***/ },

/***/ "0dt0":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  // if(opts.type == 'potentialStudent'){
	  //   return modal(opts)
	  // }
	  if (!Array.isArray(opts.students) || opts.students.length == 0) {
	    throw new Error("This modal requires an array of student objects { students: [student] }");
	  }
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("WJ0n");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "WJ0n":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	var _confirm = __webpack_require__("yMGN");
	
	__webpack_require__("UPBM");
	
	var _ModalContent = __webpack_require__("zSUl");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _locale = __webpack_require__("MZ0r");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _addMassLessonAndClass = __webpack_require__("wAgf");
	
	var _addMassLessonAndClass2 = _interopRequireDefault(_addMassLessonAndClass);
	
	var _addStudentToMultiClass = __webpack_require__("CANW");
	
	var _addStudentToMultiClass2 = _interopRequireDefault(_addStudentToMultiClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.updateRequired = false;
	
	    _this.enrollClass = _this.enrollClass.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.resultAlert = _this.resultAlert.bind(_this);
	    _this.nextStage = _this.nextStage.bind(_this);
	    _this.previousStage = _this.previousStage.bind(_this);
	
	    _this.state = {
	      form: {},
	      stage: 'enrollClass'
	    };
	    return _this;
	  }
	
	  ModalBody.prototype.onChange = function onChange(value) {
	    this.setState({
	      form: _extends({}, this.state.form, value)
	    });
	  };
	
	  ModalBody.prototype.enrollClass = function enrollClass() {
	    var _this2 = this;
	
	    var _state$form = this.state.form,
	        selectedClass = _state$form.selectedClass,
	        _state$form$lessonIDS = _state$form.lessonIDSelected,
	        lessonIDSelected = _state$form$lessonIDS === undefined ? [] : _state$form$lessonIDS;
	    var _props = this.props,
	        students = _props.students,
	        proceed = _props.proceed;
	
	
	    (0, _confirm.confirm)(__("Proceed to join '{className}'?", 'student', { className: selectedClass.className }), __('Join Class', 'student')).then(function () {
	      var classID = selectedClass.classID;
	
	
	      var studentIDs = students.map(function (student) {
	        return student.schoolStudentID;
	      });
	
	      _this2.setState({
	        loading: true
	      });
	
	      // 2 ways to to add onto a class. One through addMassLEssonAndClass
	      // another through
	      if (lessonIDSelected.length > 0) {
	        (0, _addMassLessonAndClass2.default)(classID, {
	          student_id_list: studentIDs,
	          lesson_id_list: lessonIDSelected,
	          conflict_tag: 1
	        }).then(function (_ref) {
	          var data = _ref.data;
	          var added_detail = data.added_detail,
	              conflicted_detail = data.conflicted_detail;
	
	
	          _this2.setState({
	            loading: false
	          });
	
	          _this2.resultAlert(students, conflicted_detail, added_detail);
	        }).catch(function (err) {
	          // TODO: create reverse function
	          console.error(err);
	        });
	      } else {
	        (0, _addStudentToMultiClass2.default)(classID, studentIDs).then(function (res) {
	          proceed({ updateRequired: true });
	        }).catch(function (err) {
	          // TODO: create reverse function
	          console.error(err);
	        });
	      }
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  ModalBody.prototype.resultAlert = function resultAlert(students) {
	    var conflicted_detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var added_detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	    var _props2 = this.props,
	        dismiss = _props2.dismiss,
	        proceed = _props2.proceed;
	
	
	    var namePerID = {};
	    var conflictedStudentNames = [];
	    students.map(function (student) {
	      namePerID[student.schoolStudentID] = student.sName;
	    });
	
	    if (conflicted_detail.length > 0) {
	      // FAILED
	      var conflictedNames = '';
	      conflicted_detail.map(function (_ref2) {
	        var conflicted_detail = _ref2.conflicted_detail;
	        var conflicted_student_list = conflicted_detail.student.conflicted_student_list;
	
	        conflicted_student_list.map(function (_ref3) {
	          var student_id = _ref3.student_id;
	
	          var studentName = namePerID[student_id];
	          if (conflictedStudentNames.indexOf(studentName) === -1) {
	            conflictedStudentNames.push(studentName);
	          }
	        });
	      });
	      conflictedNames = conflictedStudentNames.join(', ');
	
	      _alert.alert.fail(_react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          __('Failed to complete the request because following students have conflicted schedules:', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            conflictedNames
	          )
	        )
	      ), __('Failed To Complete Request', _locale2.default)).then(function () {
	        dismiss();
	      });
	    } else if (added_detail.length > 0) {
	      // SUCCESS
	      proceed({ updateRequired: true });
	    }
	  };
	
	  ModalBody.prototype.nextStage = function nextStage() {
	    this.setState({
	      stage: 'enrollLessons'
	    });
	  };
	
	  ModalBody.prototype.previousStage = function previousStage() {
	    this.setState({
	      stage: 'enrollClass'
	    });
	  };
	
	  ModalBody.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props3 = this.props,
	        show = _props3.show,
	        proceed = _props3.proceed,
	        dismiss = _props3.dismiss,
	        cancel = _props3.cancel,
	        students = _props3.students;
	    var _state = this.state,
	        loading = _state.loading,
	        stage = _state.stage;
	    var selectedClass = this.state.form.selectedClass;
	
	    var footerButtons = void 0;
	    if (stage === 'enrollClass') {
	      footerButtons = [];
	    } else {
	      footerButtons = [{
	        title: __('Confirm', 'UI.confirm'),
	        className: 'btn btn-primary pull-right',
	        isDisabled: typeof selectedClass == 'undefined',
	        onClick: function onClick() {
	          _this3.enrollClass();
	        }
	      }];
	    }
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        isShowingModal: show // if you want to show it when component mounts, set it true
	        , className: 'class-select-modal'
	        // allowCloseByClickingShadow={false}
	        // useDefaultClosebutton={true}
	        , onCloseModalClick: function onCloseModalClick() {
	          proceed({ updateRequired: _this3.updateRequired });
	        }
	        // fixedHeight={300}
	        , fixedWidth: 500
	        // overlayColor="#000"
	        // contentHeight={300}
	
	        , loading: loading,
	
	        hasHeader: true,
	        headerType: 'bold' // default, bold
	        , headerTitle: __("Join Current Classes", "student"),
	        headerIcon: 'fa icon-users' // class for icon tag
	        // headerClassName=""
	        // headerCustomContent={}
	        , hasFooter: true,
	        footerButtons: footerButtons
	      },
	      _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: _store2.default },
	        _react2.default.createElement(_ModalContent2.default, {
	          onChange: this.onChange,
	          nextStage: this.nextStage,
	          students: students,
	          stage: stage,
	          onPreviousStageSelect: this.previousStage })
	      )
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "UPBM":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"class-select-modal":"class-select-modal","control":"control","checkmark":"checkmark","selection-wrapper":"selection-wrapper","classtop-modal-content":"classtop-modal-content","Select-control":"Select-control","select-none":"select-none","searchbar-wrapper":"searchbar-wrapper","Select-placeholder":"Select-placeholder","Select-clear-zone":"Select-clear-zone","label-section":"label-section","sort-btn":"sort-btn","select-list":"select-list","select-class-item":"select-class-item","select-class":"select-class","selected":"selected","select-button":"select-button","enrolled":"enrolled","btn-link":"btn-link","currently-enrolled":"currently-enrolled","loading":"loading","content":"content","loadingMask":"loadingMask","select-lesson-wrapper":"select-lesson-wrapper","lessonItem":"lessonItem","lessonNumber":"lessonNumber","lessonDate":"lessonDate","lessonTime":"lessonTime","lessonCheckbox":"lessonCheckbox","lessonSelected":"lessonSelected","lessonDisabled":"lessonDisabled","lessonLoaded":"lessonLoaded","lessonList":"lessonList","right-arrow":"right-arrow","selected-class-info":"selected-class-info","previous-button":"previous-button","selected-class-wrapper":"selected-class-wrapper","class-title":"class-title","class-detail":"class-detail","text-wrapper":"text-wrapper","class-teacher":"class-teacher","selection-label":"selection-label","label-text":"label-text","select-all-btn":"select-all-btn","noLessonText":"noLessonText","pagination-wrapper":"pagination-wrapper","pagination":"pagination","loading-wrapper":"loading-wrapper"};

/***/ },

/***/ "zSUl":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getClassBy = __webpack_require__("OC/R");
	
	var _getClassBy2 = _interopRequireDefault(_getClassBy);
	
	var _find = __webpack_require__("kbi+");
	
	var _find2 = _interopRequireDefault(_find);
	
	var _reactReduxHotline = __webpack_require__("IKa1");
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _ClassItem = __webpack_require__("Bd4K");
	
	var _ClassItem2 = _interopRequireDefault(_ClassItem);
	
	var _getClassLesson = __webpack_require__("XDwt");
	
	var _getClassLesson2 = _interopRequireDefault(_getClassLesson);
	
	var _getAllClassLessons = __webpack_require__("DoBN");
	
	var _getAllClassLessons2 = _interopRequireDefault(_getAllClassLessons);
	
	var _LessonList = __webpack_require__("nnLh");
	
	var _LessonList2 = _interopRequireDefault(_LessonList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ENROLLED_FIRST = 'ENROLLED_FIRST';
	
	var LESSON_PER_PAGE = 25;
	var CLASS_PER_PAGE = 25;
	var SEARCH_TIMEOUT = 250;
	var MIN_SEARCH_VALUE_LENGTH = 2;
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._loadClassesOntoState = _this._loadClassesOntoState.bind(_this);
	    _this._onSearchSelected = _this._onSearchSelected.bind(_this);
	    _this._getSelectList = _this._getSelectList.bind(_this);
	
	    _this.onToggleLessonSelect = _this.onToggleLessonSelect.bind(_this);
	    _this.loadSelectedClassLesson = _this.loadSelectedClassLesson.bind(_this);
	    _this.onSelectClass = _this.onSelectClass.bind(_this);
	    _this._handleClassScrolling = _this._handleClassScrolling.bind(_this);
	    _this._onSearch = _this._onSearch.bind(_this);
	    _this.onToggleCurrentPageLessons = _this.onToggleCurrentPageLessons.bind(_this);
	    _this.onPageChanged = _this.onPageChanged.bind(_this);
	    _this.selectAllLessonsInClass = _this.selectAllLessonsInClass.bind(_this);
	    var students = _this.props.students;
	
	
	    _this.state = {
	      classList: [],
	      students: students,
	      optionsForSearch: [],
	      selectedOption: undefined,
	      classListOrder: ENROLLED_FIRST,
	      selectedClass: {},
	      lessonIDSelected: [],
	      activePage: 1,
	      isloadingMoreLesson: false,
	      totalPageAmount: 0,
	      isLoadingMoreClass: false,
	      activeClassPage: 1,
	      totalClassPageAmount: 0,
	      classSearchKey: '',
	      lessonList: [],
	      totalItemsCount: 0,
	      pageSelectAllTracker: [],
	      isAllLessonsSelected: false
	    };
	    return _this;
	  }
	
	  ModalContent.prototype.componentWillMount = function componentWillMount() {
	    this._loadClassesOntoState();
	  };
	
	  ModalContent.prototype.loadSelectedClassLesson = function loadSelectedClassLesson(classID) {
	    var _this2 = this;
	
	    var activePage = this.state.activePage;
	
	    this.setState({
	      loadingLessons: true
	    });
	    (0, _getClassLesson2.default)(classID, {
	      amount_per_page: LESSON_PER_PAGE,
	      current_page_number: activePage
	    }).then(function (_ref) {
	      var result = _ref.result,
	          lessonList = _ref.lessonList,
	          total_page_amount = _ref.total_page_amount,
	          total_lesson_amount = _ref.total_lesson_amount;
	
	      if (result === 'success') {
	        _this2.setState({
	          loadingLessons: false,
	          lessonList: lessonList,
	          totalPageAmount: total_page_amount,
	          totalItemsCount: total_lesson_amount,
	          activePage: activePage
	        }, function () {
	          var pageSelectAllTracker = [];
	          for (var i = 0; i < total_page_amount; i++) {
	            pageSelectAllTracker.push(false);
	          }
	          _this2.setState({
	            pageSelectAllTracker: pageSelectAllTracker
	          });
	          _this2.props.nextStage();
	        });
	      }
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  ModalContent.prototype.onSelectClass = function onSelectClass(selectedClass) {
	    var _this3 = this;
	
	    return function (e) {
	      e.stopPropagation();
	
	      var has_lesson = selectedClass.has_lesson;
	
	
	      _this3.setState({
	        selectedClass: selectedClass,
	        lessonIDSelected: [],
	        loadingLessons: has_lesson,
	        isAllLessonsSelected: false
	      }, function () {
	        _this3.props.onChange({
	          selectedClass: selectedClass
	        });
	        _this3.loadSelectedClassLesson(selectedClass.classID);
	      });
	    };
	  };
	
	  ModalContent.prototype.onPageChanged = function onPageChanged(e) {
	    var _this4 = this;
	
	    var selectedClass = this.state.selectedClass;
	
	
	    this.setState({
	      loadingLessons: true
	    });
	    (0, _getClassLesson2.default)(selectedClass.classID, {
	      amount_per_page: LESSON_PER_PAGE,
	      current_page_number: e
	    }).then(function (_ref2) {
	      var result = _ref2.result,
	          lessonList = _ref2.lessonList,
	          total_page_amount = _ref2.total_page_amount,
	          total_lesson_amount = _ref2.total_lesson_amount;
	
	      if (result === 'success') {
	        _this4.setState({
	          loadingLessons: false,
	          lessonList: lessonList,
	          totalPageAmount: total_page_amount,
	          totalItemsCount: total_lesson_amount,
	          activePage: e
	        });
	      }
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  ModalContent.prototype.loadMoreClasses = function loadMoreClasses() {
	    var _this5 = this;
	
	    var _state = this.state,
	        activeClassPage = _state.activeClassPage,
	        totalClassPageAmount = _state.totalClassPageAmount,
	        classSearchKey = _state.classSearchKey;
	
	    var schoolId = parseInt(localStorage.getItem('schoolId'));
	
	    if (activeClassPage < totalClassPageAmount) {
	      this.setState(function (prevState) {
	        return _extends({}, prevState, { activeClassPage: prevState.activeClassPage + 1, isLoadingMoreClass: true });
	      }, function () {
	
	        (0, _getClassBy2.default)({
	          schoolId: schoolId,
	          type: 'group',
	          state: 'current',
	          amount_per_page: CLASS_PER_PAGE,
	          current_page_number: activeClassPage,
	          keyword: classSearchKey,
	          order_by: 0
	        }).then(function (_ref3) {
	          var classList = _ref3.classList,
	              page_amount = _ref3.page_amount;
	
	          _this5.setState(function (prevState) {
	            return _extends({}, prevState, {
	              isLoadingMoreClass: false,
	              classList: [].concat(prevState.classList, classList),
	              totalClassPageAmount: page_amount
	            });
	          });
	        }).catch(function (err) {
	          console.error(err);
	        });
	      });
	    }
	  };
	
	  ModalContent.prototype.onToggleLessonSelect = function onToggleLessonSelect(lessonID) {
	    var _this6 = this;
	
	    return function (e) {
	      var lessonIDSelected = _this6.state.lessonIDSelected;
	
	      var idx = lessonIDSelected.indexOf(lessonID);
	      if (idx > -1) {
	        lessonIDSelected.splice(idx, 1);
	      } else {
	        lessonIDSelected.push(lessonID);
	      }
	
	      _this6.setState({
	        lessonIDSelected: lessonIDSelected
	      }, function () {
	        _this6.props.onChange({
	          lessonIDSelected: lessonIDSelected
	        });
	      });
	    };
	  };
	
	  ModalContent.prototype.onToggleCurrentPageLessons = function onToggleCurrentPageLessons(e) {
	    var _this7 = this;
	
	    e.stopPropagation();
	    var _state2 = this.state,
	        lessonList = _state2.lessonList,
	        lessonIDSelected = _state2.lessonIDSelected,
	        activePage = _state2.activePage,
	        pageSelectAllTracker = _state2.pageSelectAllTracker;
	
	    var currentPageSelectAll = pageSelectAllTracker[activePage - 1];
	    var selectedLessons = lessonIDSelected.slice();
	    lessonList.forEach(function (lesson) {
	      if (lesson.lesson_status !== 1) {
	        var lessonId = lesson.lesson_id;
	        var idx = selectedLessons.indexOf(lessonId);
	        if (idx > -1) {
	          if (currentPageSelectAll) {
	            selectedLessons.splice(idx, 1);
	          }
	        } else {
	          if (!currentPageSelectAll) {
	            selectedLessons.push(lessonId);
	          }
	        }
	      }
	    });
	    var selectAllTracker = pageSelectAllTracker.slice();
	    selectAllTracker[activePage - 1] = !selectAllTracker[activePage - 1];
	    this.setState({
	      lessonIDSelected: selectedLessons,
	      pageSelectAllTracker: selectAllTracker
	    }, function () {
	      _this7.props.onChange({
	        lessonIDSelected: selectedLessons
	      });
	    });
	  };
	
	  ModalContent.prototype._loadClassesOntoState = function _loadClassesOntoState() {
	    var _this8 = this;
	
	    var _state3 = this.state,
	        classSearchKey = _state3.classSearchKey,
	        activeClassPage = _state3.activeClassPage;
	
	    var schoolId = parseInt(localStorage.getItem('schoolId'));
	    (0, _getClassBy2.default)({
	      schoolId: schoolId,
	      type: 'group',
	      state: 'current',
	      amount_per_page: CLASS_PER_PAGE,
	      current_page_number: activeClassPage,
	      keyword: classSearchKey,
	      order_by: 0
	    }).then(function (res) {
	      _this8.setState({
	        classList: res.classList,
	        totalClassPageAmount: res.page_amount
	      });
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  ModalContent.prototype._onSearchSelected = function _onSearchSelected(selected) {
	    // STEP 1. if selected is empty, which means the select field is clear out.
	    // Then, we update with the classList saved in this.
	    if (selected === null) {
	      this.setState({
	        selectedOption: undefined,
	        classList: this.savedClassList
	      });
	      return;
	    }
	
	    // STEP 2. If selected is indeed an list item object, then we recreate
	    // this.state.classList by filtering out current list.
	    var cls = selected.value;
	
	
	    var newClassList = this.savedClassList.filter(function (thisCls) {
	      return thisCls.classID == cls.classID;
	    });
	
	    this.setState({
	      selectedOption: selected,
	      classList: newClassList
	    });
	  };
	
	  ModalContent.prototype._onSearch = function _onSearch(e) {
	    var _this9 = this;
	
	    var _e$target$value = e.target.value,
	        value = _e$target$value === undefined ? '' : _e$target$value;
	
	
	    var classSearchKey = value;
	
	    if (value.length < MIN_SEARCH_VALUE_LENGTH) {
	      classSearchKey = '';
	    }
	
	    if (this.debouncedSearchTimeout) {
	      clearTimeout(this.debouncedSearchTimeout);
	    }
	
	    this.debouncedSearchTimeout = setTimeout(function () {
	      _this9.setState({
	        classSearchKey: classSearchKey,
	        activeClassPage: 1
	      }, function () {
	        _this9._loadClassesOntoState();
	      });
	    }, SEARCH_TIMEOUT);
	  };
	
	  ModalContent.prototype._handleClassScrolling = function _handleClassScrolling() {
	    var isLoadingMoreClass = this.state.isLoadingMoreClass;
	
	    var BOTTOM_OFFSET = 500;
	    if (this.classLoadingScroller && !isLoadingMoreClass && this.classLoadingScroller.scrollTop >= this.classLoadingScroller.scrollHeight - BOTTOM_OFFSET) {
	      this.loadMoreClasses();
	    }
	  };
	
	  ModalContent.prototype.selectAllLessonsInClass = function selectAllLessonsInClass() {
	    var _this10 = this;
	
	    var _state4 = this.state,
	        selectedClass = _state4.selectedClass,
	        isAllLessonsSelected = _state4.isAllLessonsSelected;
	
	    if (!isAllLessonsSelected) {
	      (0, _getAllClassLessons2.default)(selectedClass.classID, {
	        detail: 0
	      }).then(function (res) {
	        var lessonIDSelected = [];
	        if (res.lesson_list.length > 0) {
	          res.lesson_list.forEach(function (lesson) {
	            if (lesson.lesson_status !== 1) {
	              lessonIDSelected.push(lesson.lesson_id);
	            }
	          });
	        }
	        var pageSelectAllTracker = _this10.state.pageSelectAllTracker;
	        for (var i = 0; i < pageSelectAllTracker.length; i++) {
	          pageSelectAllTracker[i] = true;
	        }
	        _this10.setState({ pageSelectAllTracker: pageSelectAllTracker, lessonIDSelected: lessonIDSelected, isAllLessonsSelected: !isAllLessonsSelected }, function () {
	          _this10.props.onChange({ lessonIDSelected: lessonIDSelected });
	        });
	      }).catch(function (err) {
	        console.error(err);
	      });
	    } else {
	      var pageSelectAllTracker = this.state.pageSelectAllTracker;
	      for (var i = 0; i < pageSelectAllTracker.length; i++) {
	        pageSelectAllTracker[i] = false;
	      }
	      this.setState({ pageSelectAllTracker: pageSelectAllTracker, lessonIDSelected: [], isAllLessonsSelected: !isAllLessonsSelected }, function () {
	        _this10.props.onChange({ lessonIDSelected: [] });
	      });
	    }
	  };
	
	  ModalContent.prototype.render = function render() {
	    var _this11 = this;
	
	    var _state5 = this.state,
	        selectedOption = _state5.selectedOption,
	        isLoadingMoreClass = _state5.isLoadingMoreClass,
	        isloadingMoreLesson = _state5.isloadingMoreLesson,
	        loadingLessons = _state5.loadingLessons,
	        lessonList = _state5.lessonList,
	        lessonIDSelected = _state5.lessonIDSelected,
	        selectedClass = _state5.selectedClass,
	        pageSelectAllTracker = _state5.pageSelectAllTracker,
	        activePage = _state5.activePage,
	        totalItemsCount = _state5.totalItemsCount,
	        isAllLessonsSelected = _state5.isAllLessonsSelected;
	    var stage = this.props.stage;
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)({ 'select-none': typeof selectedOption == 'undefined' }) },
	      (isLoadingMoreClass || isloadingMoreLesson) && _react2.default.createElement(_Loading2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        stage === 'enrollClass' && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'searchbar-wrapper' },
	            _react2.default.createElement('input', {
	              type: 'text',
	              classname: 'form-control',
	              onChange: this._onSearch,
	              placeholder: __('Search Class Name', 'student')
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'label-section' },
	            _react2.default.createElement(
	              'label',
	              null,
	              __('Class', 'student')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'select-list', ref: function ref(scroller) {
	                return _this11.classLoadingScroller = scroller;
	              }, onScroll: this._handleClassScrolling },
	            this._getSelectList()
	          )
	        ),
	        stage === 'enrollLessons' && _react2.default.createElement(_LessonList2.default, {
	          cls: selectedClass,
	          lessonList: lessonList,
	          loadingLessons: loadingLessons,
	          isloadingMoreLesson: isloadingMoreLesson,
	          onToggleLessonSelect: this.onToggleLessonSelect,
	          lessonIDSelected: lessonIDSelected,
	          loadMoreLessons: this.loadMoreLessons,
	          onPreviousStageSelect: this.props.onPreviousStageSelect,
	          onToggleCurrentPageLessons: function onToggleCurrentPageLessons(e) {
	            return _this11.onToggleCurrentPageLessons(e);
	          },
	          pageSelectAllTracker: pageSelectAllTracker,
	          onPageChanged: this.onPageChanged,
	          pagination: { activePage: activePage, totalItemsCount: totalItemsCount, itemsPerPage: LESSON_PER_PAGE },
	          selectAllLessonsInClass: this.selectAllLessonsInClass,
	          isAllLessonsSelected: isAllLessonsSelected
	        })
	      )
	    );
	  };
	
	  ModalContent.prototype._getSelectList = function _getSelectList() {
	    var _this12 = this;
	
	    var _state6 = this.state,
	        classList = _state6.classList,
	        selectedClass = _state6.selectedClass,
	        students = _state6.students;
	
	
	    var list = Array.from(classList);
	
	    list.map(function (cls, idx) {
	      cls.enrolled = _this12._classAlreadyEnrolled(students, cls);
	    });
	    return list.map(function (cls, idx) {
	      return _react2.default.createElement(_ClassItem2.default, {
	        enrolled: cls.enrolled,
	        selected: cls.classID == selectedClass.classID,
	        cls: cls,
	        key: idx,
	        onSelectClass: _this12.onSelectClass(cls) });
	    });
	  };
	
	  // NOTE: at this moment, 'not enrolled' will replace 'enrolled.'
	  // which means
	  // 1. if there is at least one student who is not enrolled,
	  // the status will be displayed as 'not enrolled'.
	  // 2. if every students are enrolled, it is displayed as enrolled
	
	
	  ModalContent.prototype._classAlreadyEnrolled = function _classAlreadyEnrolled(students, cls) {
	    var enrolledStudents = students.filter(function (student, idx) {
	      var foundCls = (0, _find2.default)(student.list, function (clsItem) {
	        return clsItem.classID == cls.classID;
	      });
	
	      return typeof foundCls != 'undefined';
	    });
	
	    return students.length === 1 && enrolledStudents.length === 1 || enrolledStudents.length === students.length;
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = (0, _reactReduxHotline.hotline)(ModalContent, 'student');
	module.exports = exports['default'];

/***/ },

/***/ "Bd4K":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ProfileBadge = __webpack_require__("6YyL");
	
	var _ProfileBadge2 = _interopRequireDefault(_ProfileBadge);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ClassItem 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ClassItem = function (_React$Component) {
	  _inherits(ClassItem, _React$Component);
	
	  function ClassItem(props) {
	    _classCallCheck(this, ClassItem);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleLessonScrolling = _this.handleLessonScrolling.bind(_this);
	    return _this;
	  }
	
	  ClassItem.prototype.handleLessonScrolling = function handleLessonScrolling() {
	    var _props = this.props,
	        loadMoreLessons = _props.loadMoreLessons,
	        isloadingMoreLesson = _props.isloadingMoreLesson;
	
	    var bottomOffset = 400;
	    if (this.lessonLoadingScroller && !isloadingMoreLesson && this.lessonLoadingScroller.scrollTop >= this.lessonLoadingScroller.scrollHeight - bottomOffset) {
	      loadMoreLessons();
	    }
	  };
	
	  ClassItem.prototype.render = function render() {
	    var _props2 = this.props,
	        cls = _props2.cls,
	        enrolled = _props2.enrolled,
	        selected = _props2.selected,
	        onSelectClass = _props2.onSelectClass,
	        loadingLessons = _props2.loadingLessons;
	    var teacherList = cls.teacherList;
	
	
	    var profiles = teacherList.map(function (teacher) {
	      return {
	        name: teacher.stName
	      };
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'select-class-item' },
	      loadingLessons == true && selected && _react2.default.createElement(_Loading2.default, { zoom: 0.7 }),
	      loadingLessons == true && selected && _react2.default.createElement('div', { className: 'loadingMask' }),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('select-class', { selected: selected }), onClick: onSelectClass },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h5',
	            null,
	            cls.className
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { float: 'left' } },
	          _react2.default.createElement(
	            'small',
	            null,
	            __('Date', 'class'),
	            ': ',
	            cls.earliest_date,
	            ' - ',
	            cls.latest_date
	          ),
	          _react2.default.createElement(
	            'small',
	            null,
	            __('Student: {number}', 'schedule', { number: cls.studentCount })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { float: 'left' } },
	          _react2.default.createElement(
	            'small',
	            null,
	            __('Teacher', 'teacher'),
	            ': '
	          ),
	          teacherList.length === 0 && _react2.default.createElement(
	            'small',
	            null,
	            __('N/A', 'data')
	          ),
	          profiles.length > 0 && _react2.default.createElement(
	            'div',
	            { style: { float: 'left' } },
	            _react2.default.createElement(_ProfileBadge2.default, { profiles: profiles })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('select-button', { enrolled: enrolled }) },
	          _react2.default.createElement('i', { className: 'fa icon-right-open right-arrow' })
	        )
	      )
	    );
	  };
	
	  return ClassItem;
	}(_react2.default.Component);
	
	exports.default = ClassItem;
	module.exports = exports['default'];

/***/ },

/***/ "6YyL":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <ProfileBadge />
	                    *
	                    * When profile has .img, we display the image, if not, we display 
	                    * it's initial. It's colour is determined by the initial as well.
	                    *
	                    * @parent anybody
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactTooltip = __webpack_require__("Hh2+");
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	__webpack_require__("fuzy");
	
	var _uniqid = __webpack_require__("2bpm");
	
	var _uniqid2 = _interopRequireDefault(_uniqid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_TYPE = 'small';
	
	var ProfileBadge = (_temp = _class = function (_React$Component) {
	  _inherits(ProfileBadge, _React$Component);
	
	  function ProfileBadge(props) {
	    _classCallCheck(this, ProfileBadge);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ProfileBadge.prototype.componentWillMount = function componentWillMount() {};
	
	  ProfileBadge.prototype.render = function render() {
	    var _props = this.props,
	        profiles = _props.profiles,
	        _props$type = _props.type,
	        type = _props$type === undefined ? DEFAULT_TYPE : _props$type;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('profile-badge', type) },
	      profiles.map(function (profile, key) {
	        var id = 'profile-name-' + (0, _uniqid2.default)();
	        if (profile.img) {
	          return _react2.default.createElement(
	            'div',
	            { key: key, 'data-tip': true, 'data-for': id, className: 'badge badge-image', style: { backgroundImage: profile.img } },
	            _react2.default.createElement(_reactTooltip2.default, {
	              id: id,
	              effect: 'solid',
	              place: 'top',
	              type: 'info',
	              getContent: function getContent() {
	                return profile.name;
	              }
	            })
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { key: key, 'data-tip': true, 'data-for': id, className: 'badge badge-initial' },
	            profile.name[0],
	            _react2.default.createElement(_reactTooltip2.default, {
	              id: id,
	              effect: 'solid',
	              place: 'top',
	              type: 'info',
	              getContent: function getContent() {
	                return profile.name;
	              }
	            })
	          );
	        }
	      })
	    );
	  };
	
	  return ProfileBadge;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = ProfileBadge;
	module.exports = exports['default'];

/***/ },

/***/ "fuzy":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"profile-badge":"profile-badge","small":"small","badge":"badge","__react_component_tooltip":"__react_component_tooltip","place-top":"place-top"};

/***/ },

/***/ "DoBN":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getAllClassLessons;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getAllClassLessons(classId, params) {
		var query = _queryString2.default.stringify({
			detail: params.detail
		});
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, {
				'uri': "/g_clslss/" + classId + "/?" + query,
				'method': 'GET',
				'token': localStorage.getItem('token')
			}).then(function (res) {
				resolve(res.data);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports["default"];

/***/ },

/***/ "nnLh":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ProfileBadge = __webpack_require__("6YyL");
	
	var _ProfileBadge2 = _interopRequireDefault(_ProfileBadge);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _locale = __webpack_require__("MZ0r");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactJsPagination = __webpack_require__("bgMy");
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ClassItem 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var LESSON_TIME_FORMAT = 'YYYY-MM-DD hh:mm:ss';
	var DISPLAY_TIME_FORMAT = 'HH:mm';
	var DISPLAY_DATE_FORMAT = 'YYYY-MM-DD';
	
	var LessonList = function (_React$Component) {
	  _inherits(LessonList, _React$Component);
	
	  function LessonList(props) {
	    _classCallCheck(this, LessonList);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleLessonScrolling = _this.handleLessonScrolling.bind(_this);
	    return _this;
	  }
	
	  LessonList.prototype.handleLessonScrolling = function handleLessonScrolling() {
	    var _props = this.props,
	        loadMoreLessons = _props.loadMoreLessons,
	        isloadingMoreLesson = _props.isloadingMoreLesson;
	
	    var bottomOffset = 400;
	    if (this.lessonLoadingScroller && !isloadingMoreLesson && this.lessonLoadingScroller.scrollTop >= this.lessonLoadingScroller.scrollHeight - bottomOffset) {
	      loadMoreLessons();
	    }
	  };
	
	  LessonList.prototype.render = function render() {
	    var _props2 = this.props,
	        loadingLessons = _props2.loadingLessons,
	        _props2$lessonList = _props2.lessonList,
	        lessonList = _props2$lessonList === undefined ? [] : _props2$lessonList,
	        onToggleLessonSelect = _props2.onToggleLessonSelect,
	        _props2$lessonIDSelec = _props2.lessonIDSelected,
	        lessonIDSelected = _props2$lessonIDSelec === undefined ? [] : _props2$lessonIDSelec,
	        cls = _props2.cls,
	        onPreviousStageSelect = _props2.onPreviousStageSelect,
	        onToggleCurrentPageLessons = _props2.onToggleCurrentPageLessons,
	        pageSelectAllTracker = _props2.pageSelectAllTracker,
	        onPageChanged = _props2.onPageChanged,
	        pagination = _props2.pagination,
	        selectAllLessonsInClass = _props2.selectAllLessonsInClass,
	        isAllLessonsSelected = _props2.isAllLessonsSelected;
	    var teacherList = cls.teacherList,
	        has_lesson = cls.has_lesson;
	
	
	    var profiles = teacherList.map(function (teacher) {
	      return {
	        name: teacher.stName
	      };
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'select-class-item' },
	      _react2.default.createElement(
	        'div',
	        { className: 'selected-class-info' },
	        _react2.default.createElement(
	          'div',
	          { className: 'previous-button', onClick: onPreviousStageSelect },
	          _react2.default.createElement('i', { className: 'fa icon-left-open right-arrow' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'selected-class-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'class-title' },
	            cls.className
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'class-detail' },
	            _react2.default.createElement(
	              'div',
	              { className: 'text-wrapper class-date' },
	              __('Date', 'class'),
	              ': ',
	              cls.earliest_date,
	              ' - ',
	              cls.latest_date
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'text-wrapper class-student' },
	              __('Student: {number}', 'schedule', { number: cls.studentCount })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'text-wrapper class-teacher' },
	              _react2.default.createElement(
	                'div',
	                null,
	                __('Teacher', 'teacher'),
	                ':'
	              ),
	              teacherList.length === 0 && _react2.default.createElement(
	                'span',
	                null,
	                ' ',
	                __('N/A', 'data')
	              ),
	              profiles.length > 0 && _react2.default.createElement(
	                'span',
	                null,
	                ' ',
	                _react2.default.createElement(_ProfileBadge2.default, { profiles: profiles })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'selection-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'selection-label' },
	          _react2.default.createElement(
	            'label',
	            { className: 'control', onClick: function onClick(e) {
	                return onToggleCurrentPageLessons(e);
	              } },
	            _react2.default.createElement('input', { type: 'checkbox', disabled: !has_lesson, checked: pageSelectAllTracker[pagination.activePage - 1] }),
	            _react2.default.createElement('span', { className: 'checkmark' })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'label-text' },
	            __('Selected {selectedLessons}/{totalLessons} Lessons', _locale2.default, { selectedLessons: lessonIDSelected.length, totalLessons: pagination.totalItemsCount })
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'select-all-btn', disabled: !has_lesson, onClick: function onClick() {
	              return selectAllLessonsInClass();
	            } },
	          isAllLessonsSelected ? __('Unselect All Lessons', _locale2.default) : __('Select All Lessons', _locale2.default)
	        )
	      ),
	      loadingLessons == true && _react2.default.createElement(
	        'div',
	        { className: 'loading-wrapper' },
	        _react2.default.createElement(_Loading2.default, { zoom: 0.7 })
	      ),
	      loadingLessons == true && _react2.default.createElement('div', { className: 'loadingMask' }),
	      !loadingLessons && lessonList.length > 0 && _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('select-lesson-wrapper', { lessonLoaded: loadingLessons !== true }) },
	        lessonList.map(function (lesson, key) {
	          var lesson_status = lesson.lesson_status,
	              lesson_number = lesson.lesson_number,
	              lesson_id = lesson.lesson_id,
	              lesson_start_time = lesson.lesson_start_time,
	              lesson_end_time = lesson.lesson_end_time;
	
	          var lessonSelected = lessonIDSelected.indexOf(lesson_id) > -1;
	          var lessonDisabled = lesson_status == 1;
	
	          return _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('lessonItem', { lessonDisabled: lessonDisabled, lessonSelected: lessonSelected }), key: key, onClick: function onClick() {
	                if (lessonDisabled != true) {
	                  onToggleLessonSelect(lesson_id)();
	                }
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'lessonCheckbox' },
	              _react2.default.createElement(
	                'label',
	                { className: 'control' },
	                _react2.default.createElement('input', { type: 'checkbox', disabled: lessonDisabled, checked: lessonSelected == true }),
	                _react2.default.createElement('span', { className: 'checkmark' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'lessonNumber' },
	              __('Lesson {lesson_number}', _locale2.default, { lesson_number: lesson_number })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'lessonDate' },
	              (0, _moment2.default)(lesson_start_time, LESSON_TIME_FORMAT).format(DISPLAY_DATE_FORMAT)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'lessonTime' },
	              (0, _moment2.default)(lesson_start_time, LESSON_TIME_FORMAT).format(DISPLAY_TIME_FORMAT),
	              ' - ',
	              (0, _moment2.default)(lesson_end_time, LESSON_TIME_FORMAT).format(DISPLAY_TIME_FORMAT)
	            )
	          );
	        })
	      ),
	      lessonList.length === 0 && _react2.default.createElement(
	        'div',
	        { className: 'noLessonText' },
	        __('No Lessons', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'pagination-wrapper' },
	        _react2.default.createElement(_reactJsPagination2.default, {
	          activePage: pagination.activePage,
	          itemsCountPerPage: pagination.itemsPerPage,
	          totalItemsCount: pagination.totalItemsCount,
	          onChange: onPageChanged
	        })
	      )
	    );
	  };
	
	  return LessonList;
	}(_react2.default.Component);
	
	exports.default = LessonList;
	module.exports = exports['default'];

/***/ },

/***/ "MZ0r":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'EnrollClassModal',
	  code: 'CN',
	  text: {
	    'Lesson {lesson_number}': '课节 {lesson_number}',
	    'Failed to complete the request because following students have conflicted schedules:': '未能成功加入班级，下列学员的时间与已有课程有冲突',
	    'Failed To Complete Request': '加入班级失败',
	    'Selected {selectedLessons}/{totalLessons} Lessons': '已选择 {selectedLessons}/{totalLessons} 课节',
	    'Unselect All Lessons': '取消勾选所有未上课节',
	    'Select All Lessons': '勾选所有未上课节',
	    'No Lessons': '暂无课节'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "wAgf":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                  POST方法：将多个学生、多个老师加入多个lesson
	                                                                                                                                                                                                                                                                  
	                                                                                                                                                                                                                                                                  :param request:
	                                                                                                                                                                                                                                                                    {
	                                                                                                                                                                                                                                                                      "student_id_list": [4, 10, 11],  # 想要加入lessons的 school_student_id list
	                                                                                                                                                                                                                                                                      "teacher_id_list": [3, 6, 9],  # 想要加入lessons的 school_teacher_id list
	                                                                                                                                                                                                                                                                      "lesson_id_list": [1, 2],  # 想要加入的lesson id列表
	                                                                                                                                                                                                                                                                      "conflict_tag": 1  # 0: 不考虑是否有时间冲突，即使冲突也加入lesson；1：如果冲突则全部lesson都不加入，返回冲突的lesson id；2：如果冲突则仅加入不冲突的lesson，返回冲突的lesson id
	                                                                                                                                                                                                                                                                    }
	                                                                                                                                                                                                                                                                  */
	
	
	exports.default = addMassLessonAndClass;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_CONFLICT_TAG = 1;
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  'student_id_list': _joiBrowser2.default.array().items(_joiBrowser2.default.number().integer()),
	  'teacher_id_list': _joiBrowser2.default.array().items(_joiBrowser2.default.number().integer()),
	  'lesson_id_list': _joiBrowser2.default.array().items(_joiBrowser2.default.number().integer()),
	  'conflict_tag': _joiBrowser2.default.number().integer()
	});
	
	function addMassLessonAndClass(classId, params) {
	
	  if (!classId) {
	    throw 'missing a class ID';
	  }
	
	  var validateResult = _joiBrowser2.default.validate(params, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({
	    conflict_tag: DEFAULT_CONFLICT_TAG
	  }, params);
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/a_s_t_to_lsns/' + classId + '/',
	      'method': 'POST',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "CANW":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = addStudentToMultiClass;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addStudentToMultiClass(classID, studentIDs) {
	
	  if (typeof classID != "number" || !Array.isArray(studentIDs)) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing or wrong type of params: classID:number, studentIDs:[...studentID]')
	      });
	    });
	  }
	
	  var toServer = {
	    students_list: studentIDs
	  };
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/multi_joinclass/" + classID + "/",
	      'data': JSON.stringify(toServer),
	      'method': 'POST',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      console.error(err);
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "M4e5":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	
	  if (typeof opts.type === "undefined") {
	    throw new Error("type is required");
	  }
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalProvider = __webpack_require__("UB0b");
	
	var _ModalProvider2 = _interopRequireDefault(_ModalProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalProvider2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "UB0b":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalBody = __webpack_require__("7H70");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalProvider = function (_React$Component) {
	  _inherits(ModalProvider, _React$Component);
	
	  function ModalProvider(props) {
	    _classCallCheck(this, ModalProvider);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalProvider.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        otherProps = _objectWithoutProperties(_props, ['children']);
	
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(_ModalBody2.default, this.props)
	    );
	  };
	
	  return ModalProvider;
	}(_react2.default.Component);
	
	exports.default = ModalProvider;
	module.exports = exports['default'];

/***/ },

/***/ "7H70":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("70Bv");
	
	var _ModalContent = __webpack_require__("jBhe");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _locale = __webpack_require__("0SmY");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel,
	        title = _props.title;
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        isShowingModal: show // if you want to show it when component mounts, set it true
	        , onCloseModalClick: dismiss,
	        fixedWidth: 350,
	        hasHeader: true,
	        headerType: 'bold' // default, bold 
	        , headerTitle: __(title, _locale2.default),
	        headerIcon: 'fa icon-list-bullet' // class for icon tag
	      },
	      _react2.default.createElement(_ModalContent2.default, this.props)
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "70Bv":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"AttendanceTable":"AttendanceTable","StudentTable":"StudentTable","FinanceTable":"FinanceTable","download-btn":"download-btn","download-success-text":"download-success-text","redownload-btn":"redownload-btn"};

/***/ },

/***/ "jBhe":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Student = __webpack_require__("Mat4");
	
	var _Student2 = _interopRequireDefault(_Student);
	
	var _Attendance = __webpack_require__("ghZc");
	
	var _Attendance2 = _interopRequireDefault(_Attendance);
	
	var _Finance = __webpack_require__("LMA4");
	
	var _Finance2 = _interopRequireDefault(_Finance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	//
	// 
	//
	//
	//
	//
	//
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  ModalContent.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'export-modal-content' },
	      this.props.type === 'attendance' && _react2.default.createElement(_Attendance2.default, this.props),
	      this.props.type === 'student' && _react2.default.createElement(_Student2.default, this.props),
	      this.props.type === 'finance' && _react2.default.createElement(_Finance2.default, this.props)
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "Mat4":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHtmlTableToExcel = __webpack_require__("zJ5Q");
	
	var _reactHtmlTableToExcel2 = _interopRequireDefault(_reactHtmlTableToExcel);
	
	var _rcProgress = __webpack_require__("McaX");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getStudentSummary = __webpack_require__("/y3Y");
	
	var _getStudentSummary2 = _interopRequireDefault(_getStudentSummary);
	
	var _getStudentCustomFields = __webpack_require__("61c/");
	
	var _getStudentCustomFields2 = _interopRequireDefault(_getStudentCustomFields);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _reactCsv = __webpack_require__("xdcN");
	
	var _UI = __webpack_require__("OM1Z");
	
	var _locale = __webpack_require__("0SmY");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <AttendanceTable
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var StudentTable = function (_React$Component) {
	  _inherits(StudentTable, _React$Component);
	
	  function StudentTable(props) {
	    _classCallCheck(this, StudentTable);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      currentStudentList: [],
	      currentStudentListDetail: {},
	      pastStudentList: [],
	      pastStudentListDetail: {},
	      doneFetchingCurrentStudents: false,
	      doneFetchingPastStudents: false,
	      customizedFields: [],
	      downloaded: false
	    };
	    _this.csvHeader = [];
	    _this.csvCurrentStudentList = [];
	    _this.csvPastStudentList = [];
	    _this.currentPageForCurrentList = 1;
	    _this.currentPageForPastList = 1;
	    _this.fetchCurrentStudents = _this.fetchCurrentStudents.bind(_this);
	    return _this;
	  }
	
	  StudentTable.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    (0, _getStudentCustomFields2.default)(schoolId).then(function (result) {
	      _this2.setState({ customizedFields: result.student_fields_setting.fields }, function () {
	        _this2.fetchCurrentStudents();
	        _this2.fetchPastStudents();
	      });
	    });
	  };
	
	  StudentTable.prototype.fetchCurrentStudents = function fetchCurrentStudents() {
	    var _this3 = this;
	
	    this.fetchCurrentStudentList(function () {
	      _this3.setState({ doneFetchingCurrentStudents: true });
	    });
	  };
	
	  StudentTable.prototype.fetchPastStudents = function fetchPastStudents() {
	    var _this4 = this;
	
	    this.fetchPastStudentList(function () {
	      _this4.setState({ doneFetchingPastStudents: true });
	    });
	  };
	
	  StudentTable.prototype.fetchPastStudentList = function fetchPastStudentList(done) {
	    var _this5 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    (0, _getStudentSummary2.default)({
	      schoolId: schoolId,
	      itemPerPage: 50,
	      pageNumber: this.currentPageForPastList,
	      studentState: 'archived',
	      export: 1
	    }).then(function (result) {
	      _this5.setState({ pastStudentList: _this5.state.pastStudentList.concat(result.list), pastStudentListDetail: result }, function () {
	        _this5.csvPastStudentList = _this5.state.pastStudentList.map(function (student) {
	          var pastStudent = {};
	          var separator = '';
	          if (student.ssSuitNumber) {
	            separator = '-';
	          }
	          pastStudent[__('Student Status', _locale2.default)] = __('Past', _locale2.default);
	          pastStudent[__('Name', _locale2.default)] = student.ssFirstName + ' ' + student.ssLastName;
	          pastStudent[__('Student Number', _locale2.default)] = student.ssCode;
	          pastStudent[__('Gender', _locale2.default)] = _this5.renderGender(student);
	          pastStudent[__('DOB', _locale2.default)] = student.ssBirthday;
	          pastStudent[__('Phone', _locale2.default)] = student.ssPhone;
	          pastStudent[__('Email', _locale2.default)] = student.ssEmail;
	          pastStudent[__('Nickname', _locale2.default)] = student.ssNickName;
	          pastStudent[__('Address', _locale2.default)] = student.ssSuitNumber + separator + student.ssAddress + ' ' + student.ssCity + ' ' + student.ssProvince + ' ' + student.ssCountry + ' ' + student.ssPostcode;
	          pastStudent[__('Created On', _locale2.default)] = (0, _moment2.default)(student.ssStudentCreateTime).format('YYYY-MM-DD');
	          pastStudent[__('Remark', _locale2.default)] = student.ssRemark;
	          pastStudent[__('Primary Guardian Name', _locale2.default)] = student.ssParentsName;
	          pastStudent[__('Primary Guardian Email', _locale2.default)] = student.ssParentsEmail;
	          pastStudent[__('Primary Guardian Phone', _locale2.default)] = student.ssParentsPhone;
	          pastStudent[__('Primary Guardian Relationship', _locale2.default)] = student.ssGuardianRelation;
	          pastStudent[__('Secondary Guardian Name', _locale2.default)] = student.ssParents2Name;
	          pastStudent[__('Secondary Guardian Email', _locale2.default)] = student.ssParents2Email;
	          pastStudent[__('Secondary Guardian Phone', _locale2.default)] = student.ssParents2Phone;
	          pastStudent[__('Secondary Guardian Relationship', _locale2.default)] = student.ssGuardian2Relation;
	          if (_this5.state.customizedFields && _this5.state.customizedFields.length > 0) {
	            _this5.state.customizedFields.forEach(function (item) {
	              if (student.custom_data[item.id]) {
	                if (item.type === 'checkbox') {
	                  pastStudent[item.label] = student.custom_data[item.id].toString().replace(/"/g, '\'');
	                } else {
	                  pastStudent[item.label] = student.custom_data[item.id];
	                }
	              } else {
	                pastStudent[item.label] = '';
	              }
	            });
	          }
	          return pastStudent;
	        });
	      });
	      if (_this5.currentPageForPastList >= result.pageAmount) {
	        done();
	        return;
	      }
	      _this5.currentPageForPastList++;
	      _this5.fetchPastStudentList(done);
	    });
	  };
	
	  StudentTable.prototype.fetchCurrentStudentList = function fetchCurrentStudentList(done) {
	    var _this6 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    (0, _getStudentSummary2.default)({
	      schoolId: schoolId,
	      itemPerPage: 50,
	      pageNumber: this.currentPageForCurrentList,
	      studentState: 'all_not_archived',
	      export: 1
	    }).then(function (result) {
	      _this6.setState({ currentStudentList: _this6.state.currentStudentList.concat(result.list), currentStudentListDetail: result }, function () {
	        _this6.csvCurrentStudentList = _this6.state.currentStudentList.map(function (student) {
	          var currentStudent = {};
	          var separator = '';
	          if (student.ssSuitNumber) {
	            separator = '-';
	          }
	          currentStudent[__('Student Status', _locale2.default)] = __('Current', _locale2.default);
	          currentStudent[__('Name', _locale2.default)] = student.ssFirstName + ' ' + student.ssLastName;
	          currentStudent[__('Student Number', _locale2.default)] = student.ssCode;
	          currentStudent[__('Gender', _locale2.default)] = _this6.renderGender(student);
	          currentStudent[__('DOB', _locale2.default)] = student.ssBirthday;
	          currentStudent[__('Phone', _locale2.default)] = student.ssPhone;
	          currentStudent[__('Email', _locale2.default)] = student.ssEmail;
	          currentStudent[__('Nickname', _locale2.default)] = student.ssNickName;
	          currentStudent[__('Address', _locale2.default)] = student.ssSuitNumber + separator + student.ssAddress + ' ' + student.ssCity + ' ' + student.ssProvince + ' ' + student.ssCountry + ' ' + student.ssPostcode;
	          currentStudent[__('Created On', _locale2.default)] = (0, _moment2.default)(student.ssStudentCreateTime).format('YYYY-MM-DD');
	          currentStudent[__('Remark', _locale2.default)] = student.ssRemark;
	          currentStudent[__('Primary Guardian Name', _locale2.default)] = student.ssParentsName;
	          currentStudent[__('Primary Guardian Email', _locale2.default)] = student.ssParentsEmail;
	          currentStudent[__('Primary Guardian Phone', _locale2.default)] = student.ssParentsPhone;
	          currentStudent[__('Primary Guardian Relationship', _locale2.default)] = student.ssGuardianRelation;
	          currentStudent[__('Secondary Guardian Name', _locale2.default)] = student.ssParents2Name;
	          currentStudent[__('Secondary Guardian Email', _locale2.default)] = student.ssParents2Email;
	          currentStudent[__('Secondary Guardian Phone', _locale2.default)] = student.ssParents2Phone;
	          currentStudent[__('Secondary Guardian Relationship', _locale2.default)] = student.ssGuardian2Relation;
	          if (_this6.state.customizedFields && _this6.state.customizedFields.length > 0) {
	            _this6.state.customizedFields.forEach(function (item) {
	              if (student.custom_data[item.id]) {
	                if (item.type == 'checkbox') {
	                  currentStudent[item.label] = student.custom_data[item.id].toString().replace(/"/g, '\'');
	                } else {
	                  currentStudent[item.label] = student.custom_data[item.id];
	                }
	              } else {
	                currentStudent[item.label] = '';
	              }
	            });
	          }
	          return currentStudent;
	        });
	      });
	      if (_this6.currentPageForCurrentList >= result.pageAmount) {
	        done();
	        return;
	      }
	      _this6.currentPageForCurrentList++;
	      _this6.fetchCurrentStudentList(done);
	    });
	  };
	
	  StudentTable.prototype.renderDownloadBtn = function renderDownloadBtn() {
	    var _this7 = this;
	
	    var format = this.props.format;
	
	
	    if ((!this.state.doneFetchingCurrentStudents || !this.state.doneFetchingPastStudents) && this.state.currentStudentListDetail.pageAmount && this.state.pastStudentListDetail.pageAmount) {
	      return _react2.default.createElement(
	        'div',
	        { style: { height: 40, textAlign: 'center' } },
	        _react2.default.createElement(_rcProgress.Line, { percent: (this.currentPageForCurrentList + this.currentPageForPastList) / (this.state.currentStudentListDetail.pageAmount + this.state.pastStudentListDetail.pageAmount) * 100, strokeWidth: '4', strokeColor: '#346aff' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          __('Loading...', _locale2.default) + ' ' + Math.round((this.currentPageForCurrentList + this.currentPageForPastList) / (this.state.currentStudentListDetail.pageAmount + this.state.pastStudentListDetail.pageAmount) * 100),
	          '%'
	        )
	      );
	    } else if (this.state.doneFetchingCurrentStudents && this.state.doneFetchingPastStudents && !this.state.downloaded) {
	      return _react2.default.createElement(
	        'span',
	        { className: 'downloadBtnWrapper', onClick: function onClick() {
	            _this7.setState({ downloaded: true });
	          } },
	        format === 'excel' && _react2.default.createElement(_reactHtmlTableToExcel2.default, {
	          className: 'btn btn-primary download-btn',
	          table: 'student-table',
	          filename: 'School Student List',
	          sheet: 'student_table',
	          buttonText: __('Download', _locale2.default)
	        }),
	        format === 'csv' && _react2.default.createElement(
	          _reactCsv.CSVLink,
	          {
	            data: this.csvCurrentStudentList.concat(this.csvPastStudentList),
	            filename: 'School Student List.csv',
	            className: 'btn btn-primary download-btn',
	            target: '_self'
	          },
	          __('Download', _locale2.default)
	        )
	      );
	    } else if (this.state.doneFetchingCurrentStudents && this.state.doneFetchingPastStudents && this.state.downloaded) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          { className: 'download-success-text' },
	          __('Download Successfully!', _locale2.default)
	        ),
	        format === 'excel' && _react2.default.createElement(_reactHtmlTableToExcel2.default, {
	          className: 'btn-link redownload-btn',
	          table: 'student-table',
	          filename: 'School Student List',
	          sheet: 'student_table',
	          buttonText: __('Redownload', _locale2.default)
	        }),
	        format === 'csv' && _react2.default.createElement(
	          _reactCsv.CSVLink,
	          {
	            data: this.csvCurrentStudentList.concat(this.csvPastStudentList),
	            filename: 'School Student List.csv',
	            className: 'btn-link redownload-btn',
	            target: '_self'
	          },
	          __('Redownload', _locale2.default)
	        )
	      );
	    } else {
	      return null;
	    }
	  };
	
	  StudentTable.prototype.renderCustomizedFieldLabel = function renderCustomizedFieldLabel() {
	    var fieldsTitle = [];
	    if (this.state.customizedFields && this.state.customizedFields.length > 0) {
	      this.state.customizedFields.forEach(function (item, index) {
	        fieldsTitle.push(_react2.default.createElement(
	          'th',
	          { key: index },
	          item.label
	        ));
	      });
	    }
	    return fieldsTitle;
	  };
	
	  StudentTable.prototype.renderTableFields = function renderTableFields() {
	    this.csvHeader = [{ label: 'Name', key: 'ssFirstName' }, { label: 'Student Number', key: 'ssCode' }, { label: 'Gender', key: 'ssGender' }, { label: 'DOB', key: 'ssBirthday' }, { label: 'Phone', key: 'ssPhone' }, { label: 'Email', key: 'ssEmail' }, { label: 'Nickname', key: 'ssNickname' }];
	    return _react2.default.createElement(
	      'tr',
	      null,
	      _react2.default.createElement(
	        'th',
	        null,
	        __('Name', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'th',
	        null,
	        __('Student Number', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'th',
	        null,
	        __('Gender', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'th',
	        null,
	        __('DOB', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'th',
	        null,
	        __('Phone', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'th',
	        null,
	        __('Email', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'th',
	        null,
	        __('Nickname', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'th',
	        null,
	        __('Address', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'th',
	        null,
	        __('Created On', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'th',
	        null,
	        __('Remark', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'th',
	        null,
	        __('Primary Guardian Name', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'th',
	        null,
	        __('Primary Guardian Email', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'th',
	        null,
	        __('Primary Guardian Phone', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'th',
	        null,
	        __('Primary Guardian Relationship', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'th',
	        null,
	        __('Secondary Guardian Name', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'th',
	        null,
	        __('Secondary Guardian Email', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'th',
	        null,
	        __('Secondary Guardian Phone', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'th',
	        null,
	        __('Secondary Guardian Relationship', _locale2.default)
	      ),
	      this.renderCustomizedFieldLabel()
	    );
	  };
	
	  StudentTable.prototype.renderGender = function renderGender(student) {
	    if (student.ssGender == 0) {
	      return __('Male', _locale2.default);
	    } else if (student.ssGender == 1) {
	      return __('Female', _locale2.default);
	    } else {
	      return __('N/A', _locale2.default);
	    }
	  };
	
	  StudentTable.prototype.renderCustomizedData = function renderCustomizedData(student) {
	    var customizedDatalist = [];
	    if (this.state.customizedFields && this.state.customizedFields.length > 0) {
	      this.state.customizedFields.forEach(function (item) {
	        if (student.custom_data[item.id]) {
	          customizedDatalist.push(_react2.default.createElement(
	            'td',
	            { key: item.id },
	            student.custom_data[item.id]
	          ));
	        } else {
	          customizedDatalist.push(_react2.default.createElement('td', { key: item.id }));
	        }
	      });
	      return customizedDatalist;
	    } else {
	      return _react2.default.createElement(
	        'div',
	        { style: { height: 40, textAlign: 'center' } },
	        _react2.default.createElement(_Loading2.default, null)
	      );
	    }
	  };
	
	  StudentTable.prototype.renderStudents = function renderStudents(list) {
	    var _this8 = this;
	
	    var studentList = [];
	    if (list.length > 0) {
	      list.forEach(function (student) {
	        var separator = '';
	        if (student.ssSuitNumber) {
	          separator = '-';
	        }
	        studentList.push(_react2.default.createElement(
	          'tr',
	          { style: { textAlign: 'center' } },
	          _react2.default.createElement(
	            'td',
	            null,
	            student.ssFirstName + ' ' + student.ssLastName
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            student.ssCode
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _this8.renderGender(student)
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            student.ssBirthday
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            student.ssPhone
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            student.ssEmail
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            student.ssNickName
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            student.ssSuitNumber + separator + student.ssAddress + ' ' + student.ssCity + ' ' + student.ssProvince + ' ' + student.ssCountry + ' ' + student.ssPostcode
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            (0, _moment2.default)(student.ssStudentCreateTime).format('YYYY-MM-DD')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            student.ssRemark
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            student.ssParentsName
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            student.ssParentsEmail
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            student.ssParentsPhone
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            student.ssGuardianRelation
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            student.ssParents2Name
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            student.ssParents2Email
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            student.ssParents2Phone
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            student.ssGuardian2Relation
	          ),
	          _this8.renderCustomizedData(student)
	        ));
	      });
	    }
	    return studentList;
	  };
	
	  StudentTable.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'StudentTable' },
	      this.renderDownloadBtn(),
	      _react2.default.createElement(
	        'table',
	        { id: 'student-table', style: { width: '100%', display: 'none' } },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              { colSpan: 18 + (this.state.customizedFields ? this.state.customizedFields.length : 0), style: { textAlign: 'center', fontSize: 18, color: '#fff', backgroundColor: '#3b67bc' } },
	              __('Current Student List', _locale2.default)
	            )
	          ),
	          this.renderTableFields(),
	          this.renderStudents(this.state.currentStudentList),
	          _react2.default.createElement('tr', null),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              { colSpan: 18 + (this.state.customizedFields ? this.state.customizedFields.length : 0), style: { textAlign: 'center', fontSize: 18, color: '#fff', backgroundColor: '#3b67bc' } },
	              __('Past Student List', _locale2.default)
	            )
	          ),
	          this.renderTableFields(),
	          this.renderStudents(this.state.pastStudentList)
	        )
	      )
	    );
	  };
	
	  return StudentTable;
	}(_react2.default.Component);
	
	exports.default = StudentTable;
	module.exports = exports['default'];

/***/ },

/***/ "zJ5Q":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window, document, Blob */
	
	
	var propTypes = {
	  table: _propTypes2.default.string.isRequired,
	  filename: _propTypes2.default.string.isRequired,
	  sheet: _propTypes2.default.string.isRequired,
	  id: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  buttonText: _propTypes2.default.string
	};
	
	var defaultProps = {
	  id: 'button-download-as-xls',
	  className: 'button-download',
	  buttonText: 'Download'
	};
	
	var ReactHTMLTableToExcel = function (_Component) {
	  _inherits(ReactHTMLTableToExcel, _Component);
	
	  function ReactHTMLTableToExcel(props) {
	    _classCallCheck(this, ReactHTMLTableToExcel);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleDownload = _this.handleDownload.bind(_this);
	    return _this;
	  }
	
	  ReactHTMLTableToExcel.base64 = function base64(s) {
	    return window.btoa(unescape(encodeURIComponent(s)));
	  };
	
	  ReactHTMLTableToExcel.format = function format(s, c) {
	    return s.replace(/{(\w+)}/g, function (m, p) {
	      return c[p];
	    });
	  };
	
	  ReactHTMLTableToExcel.prototype.handleDownload = function handleDownload() {
	    if (!document) {
	      if (false) {
	        console.error('Failed to access document object');
	      }
	
	      return null;
	    }
	
	    if (document.getElementById(this.props.table).nodeType !== 1 || document.getElementById(this.props.table).nodeName !== 'TABLE') {
	      if (false) {
	        console.error('Provided table property is not html table element');
	      }
	
	      return null;
	    }
	
	    var table = document.getElementById(this.props.table).outerHTML;
	    var sheet = String(this.props.sheet);
	    var filename = String(this.props.filename) + '.xls';
	
	    // const uri = 'data:application/vnd.ms-excel;base64,';
	    // const template =
	    //   '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-mic' +
	    //   'rosoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta cha' +
	    //   'rset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:Exce' +
	    //   'lWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/>' +
	    //   '</x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></' +
	    //   'xml><![endif]--></head><body>{table}</body></html>';
	
	    // const context = {
	    //   worksheet: sheet || 'Worksheet',
	    //   table,
	    // };
	
	    // If IE11
	    if (window.navigator.msSaveOrOpenBlob) {
	      var _fileData = ['' + ('<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-mic' + 'rosoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta cha' + 'rset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:Exce' + 'lWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/>' + '</x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></' + 'xml><![endif]--></head><body>') + table + '</body></html>'];
	      var _blobObject = new Blob(_fileData);
	      document.getElementById('react-html-table-to-excel').click()(function () {
	        window.navigator.msSaveOrOpenBlob(_blobObject, filename);
	      });
	
	      return true;
	    }
	    var fileData = ['' + ('<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-mic' + 'rosoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta cha' + 'rset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:Exce' + 'lWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/>' + '</x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></' + 'xml><![endif]--></head><body>') + table + '</body></html>'];
	    var blobObject = new Blob(fileData);
	    var element = window.document.createElement('a');
	    // element.href =
	    //   uri +
	    //   ReactHTMLTableToExcel.base64(
	    //     ReactHTMLTableToExcel.format(template, context),
	    //   );
	    element.href = window.URL.createObjectURL(blobObject);
	    element.download = filename;
	    document.body.appendChild(element);
	    element.click();
	    document.body.removeChild(element);
	
	    return true;
	  };
	
	  ReactHTMLTableToExcel.prototype.render = function render() {
	    return _react2.default.createElement(
	      'button',
	      {
	        id: this.props.id,
	        className: this.props.className,
	        type: 'button',
	        onClick: this.handleDownload
	      },
	      this.props.buttonText
	    );
	  };
	
	  return ReactHTMLTableToExcel;
	}(_react.Component);
	
	ReactHTMLTableToExcel.defaultProps = defaultProps;
	
	exports.default = ReactHTMLTableToExcel;
	module.exports = exports['default'];

/***/ },

/***/ "61c/":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getStudentCustomFields;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStudentCustomFields(schoolId) {
	
	  if (!schoolId) {
	    throw 'missing student ID';
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/stu_custom_fields/' + schoolId + '/',
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "0SmY":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'ExportTableInfo',
	  code: 'CN',
	  text: {
	    'Age': '年龄',
	    'Gender': '性别',
	    'DOB': '生日',
	    'Phone': '联系电话',
	    'Email': '联系邮箱',
	    'Address': '现居地址',
	    'Created On': '注册时间',
	    'Nickname': '学员昵称',
	    'Name': '姓名',
	    'Remark': '备注',
	    'Primary Guardian Name': '家长1姓名',
	    'Primary Guardian Phone': '家长1电话',
	    'Primary Guardian Email': '家长1邮箱',
	    'Primary Guardian Relationship': '家长1关系',
	    'Secondary Guardian Name': '家长2姓名',
	    'Secondary Guardian Phone': '家长2电话',
	    'Secondary Guardian Email': '家长2邮箱',
	    'Secondary Guardian Relationship': '家长2关系',
	    'Male': '男生',
	    'Female': '女生',
	    'Other': '其他',
	    'N/A': '未提供',
	    'Download': '导出',
	    'Redownload': '重新导出',
	    'Download Excel': '导出 Excel',
	    'Export Student List': '导出学员列表',
	    'Export Teacher Attendance': '导出老师签到记录',
	    'Export Student Attendance': '导出学生签到记录',
	    'Export Transaction Records': '导出交易记录',
	    'Loading...': '正在载入...',
	    'Student Number': '学号',
	    'Download Successfully!': '成功导出!',
	    'Student Status': '学员状态',
	    'Current': '当期学员',
	    'Past': '历史学员',
	    'Absent (without notice)': '旷课',
	    'Late': '迟到',
	    'Attended': '出勤',
	    'Absent (with excuse)': '请假',
	    'Unattended': '未出勤',
	    'Make Up': '补签',
	    'Unchecked': '无记录',
	    'Current Student List': '在读学生列表',
	    'Past Student List': '历史学生列表'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "ghZc":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHtmlTableToExcel = __webpack_require__("zJ5Q");
	
	var _reactHtmlTableToExcel2 = _interopRequireDefault(_reactHtmlTableToExcel);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _teacherAttendanceRecord = __webpack_require__("2SmJ");
	
	var _teacherAttendanceRecord2 = _interopRequireDefault(_teacherAttendanceRecord);
	
	var _studentAttendanceRecord = __webpack_require__("ZTkw");
	
	var _studentAttendanceRecord2 = _interopRequireDefault(_studentAttendanceRecord);
	
	var _AttendanceLessonTime = __webpack_require__("4Kje");
	
	var _AttendanceLessonTime2 = _interopRequireDefault(_AttendanceLessonTime);
	
	var _AttendanceStatus = __webpack_require__("zeU0");
	
	var _AttendanceStatus2 = _interopRequireDefault(_AttendanceStatus);
	
	var _AttendTime = __webpack_require__("dg0h");
	
	var _AttendTime2 = _interopRequireDefault(_AttendTime);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _reactCsv = __webpack_require__("xdcN");
	
	var _UI = __webpack_require__("OM1Z");
	
	var _locale = __webpack_require__("0SmY");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _momentDurationFormat = __webpack_require__("SdwT");
	
	var _momentDurationFormat2 = _interopRequireDefault(_momentDurationFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <AttendanceTable 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	(0, _momentDurationFormat2.default)(_moment2.default);
	
	var AttendanceTable = function (_React$Component) {
	  _inherits(AttendanceTable, _React$Component);
	
	  function AttendanceTable(props) {
	    _classCallCheck(this, AttendanceTable);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      attendanceList: [],
	      attendanceDetail: {},
	      doneFetching: false,
	      downloaded: false
	    };
	    _this.csvAttendanceList = [];
	    _this.fetchAttendance = _this.fetchAttendance.bind(_this);
	    return _this;
	  }
	
	  AttendanceTable.prototype.componentWillMount = function componentWillMount() {
	    this.fetchAttendance();
	  };
	
	  AttendanceTable.prototype.fetchAttendanceSummary = function fetchAttendanceSummary() {
	    var _props = this.props,
	        state = _props.state,
	        attendance = _props.attendance;
	    var _state$attendanceDeta = this.state.attendanceDetail,
	        total_counted_amount = _state$attendanceDeta.total_counted_amount,
	        total_counted_duration = _state$attendanceDeta.total_counted_duration,
	        total_normal_amount = _state$attendanceDeta.total_normal_amount,
	        total_normal_duration = _state$attendanceDeta.total_normal_duration,
	        total_late_amount = _state$attendanceDeta.total_late_amount,
	        total_late_duration = _state$attendanceDeta.total_late_duration,
	        total_retroactive_amount = _state$attendanceDeta.total_retroactive_amount,
	        total_absent_amount = _state$attendanceDeta.total_absent_amount,
	        total_absent_duration = _state$attendanceDeta.total_absent_duration,
	        total_leave_amount = _state$attendanceDeta.total_leave_amount,
	        total_leave_duration = _state$attendanceDeta.total_leave_duration,
	        total_truancy_amount = _state$attendanceDeta.total_truancy_amount,
	        total_truancy_duration = _state$attendanceDeta.total_truancy_duration,
	        total_unchecked_amount = _state$attendanceDeta.total_unchecked_amount,
	        total_unchecked_duration = _state$attendanceDeta.total_unchecked_duration;
	
	
	    this.csvAttendanceList[0][''] = '                                 ';
	    this.csvAttendanceList[0][__('Total Attended Count', 'teacherAttendance')] = total_counted_amount;
	    this.csvAttendanceList[0][__('Total Attended Duration', 'teacherAttendance')] = _moment2.default.duration(Number(total_counted_duration), 'minutes').format('h [h] m [m]', { trim: 'all' }) || '0h';
	    this.csvAttendanceList[0][__('On-Time Count', 'teacherAttendance')] = total_normal_amount;
	    this.csvAttendanceList[0][__('On-Time Duration', 'teacherAttendance')] = _moment2.default.duration(Number(total_normal_duration), 'minutes').format('h [h] m [m]', { trim: 'all' }) || '0h';
	    this.csvAttendanceList[0][__('Late Count', 'teacherAttendance')] = total_late_amount;
	    this.csvAttendanceList[0][__('Late Duration', 'teacherAttendance')] = _moment2.default.duration(Number(total_late_duration), 'minutes').format('h [h] m [m]', { trim: 'all' }) || '0h';
	    this.csvAttendanceList[0][__('Makeup Count', 'teacherAttendance')] = total_retroactive_amount;
	    this.csvAttendanceList[0][__('Total Unattended Count', 'teacherAttendance')] = total_absent_amount;
	    this.csvAttendanceList[0][__('Total Unattended Duration', 'teacherAttendance')] = _moment2.default.duration(Number(total_absent_duration), 'minutes').format('h [h] m [m]', { trim: 'all' }) || '0h';
	    this.csvAttendanceList[0][__('Absent (with excuse) Count', 'teacherAttendance')] = total_leave_amount;
	    this.csvAttendanceList[0][__('Absent (with excuse) Duration', 'teacherAttendance')] = _moment2.default.duration(Number(total_leave_duration), 'minutes').format('h[h] m[m]', { trim: 'all' }) || '0h';
	    this.csvAttendanceList[0][__('Absent (without notice) Count', 'teacherAttendance')] = total_truancy_amount;
	    this.csvAttendanceList[0][__('Absent (without notice) Duration', 'teacherAttendance')] = _moment2.default.duration(Number(total_truancy_duration), 'minutes').format('h [h] m [m]', { trim: 'all' }) || '0h';
	    if (state === 'student') {
	      this.csvAttendanceList[0][__('Unchecked Count', 'teacherAttendance')] = _moment2.default.duration(Number(total_unchecked_amount), 'minutes').format('h [h] m [m]', { trim: 'all' }) || '0h';
	      this.csvAttendanceList[0][__('Unchecked Duration', 'teacherAttendance')] = _moment2.default.duration(Number(total_unchecked_duration), 'minutes').format('h [h] m [m]', { trim: 'all' }) || '0h';
	    }
	    if (state === 'teacher') {
	      this.csvAttendanceList[0][__('Total Salary:', 'teacherAttendance')] = '$' + attendance.totalSalary;
	    }
	  };
	
	  AttendanceTable.prototype.fetchAttendance = function fetchAttendance() {
	    var _this2 = this;
	
	    var state = this.props.state;
	
	    this.currentPage = 1;
	    if (state === 'teacher') {
	      this.fetchTeacherAttendance(function () {
	        _this2.fetchAttendanceSummary();
	        _this2.setState({ doneFetching: true });
	      });
	    } else {
	      this.fetchStudentAttendance(function () {
	        _this2.fetchAttendanceSummary();
	        _this2.setState({ doneFetching: true });
	      });
	    }
	  };
	
	  AttendanceTable.prototype.formatLessonTime = function formatLessonTime(attendance) {
	    var lesson_start_datetime = attendance.lesson_start_datetime,
	        lesson_end_datetime = attendance.lesson_end_datetime,
	        check_in_state = attendance.check_in_state;
	
	    var lessonTime = void 0;
	    lessonTime = (0, _moment2.default)(lesson_start_datetime).format(__('MMM DD, YYYY', 'dateFormat')) + ' ' + (0, _moment2.default)(lesson_start_datetime).format('HH:mm') + ' - ' + (0, _moment2.default)(lesson_end_datetime).format('HH:mm');
	    if (check_in_state === 1) {
	      lessonTime = lessonTime + ' ' + _moment2.default.duration((0, _moment2.default)(lesson_end_datetime) - (0, _moment2.default)(lesson_start_datetime)).format('h [h] m [m]', { trim: 'all' });
	    }
	    return lessonTime;
	  };
	
	  AttendanceTable.prototype.formatAttendTime = function formatAttendTime(attendance) {
	    var lesson_start_datetime = attendance.lesson_start_datetime,
	        check_in_datetime = attendance.check_in_datetime;
	
	    var attendTime = void 0;
	    if (!check_in_datetime) {
	      attendTime = '––';
	    } else if ((0, _moment2.default)(lesson_start_datetime).format('YYYY-MM-DD') == (0, _moment2.default)(check_in_datetime).format('YYYY-MM-DD')) {
	      attendTime = (0, _moment2.default)(check_in_datetime).format('HH:mm');
	    } else {
	      attendTime = (0, _moment2.default)(check_in_datetime).format(__('MMM DD, YYYY', 'dateFormat')) + ' ' + (0, _moment2.default)(check_in_datetime).format('HH:mm');
	    }
	    return attendTime;
	  };
	
	  AttendanceTable.prototype.getAttendanceStatus = function getAttendanceStatus(attendance) {
	    var state = this.props.state;
	    var check_in_state = attendance.check_in_state,
	        lesson_start_datetime = attendance.lesson_start_datetime,
	        lesson_end_datetime = attendance.lesson_end_datetime,
	        check_in_datetime = attendance.check_in_datetime;
	
	
	    if (check_in_state == 0) {
	      if (state === 'student') {
	        return __('Unchecked', _locale2.default);
	      } else {
	        return __('Absent (without notice)', _locale2.default);
	      }
	    } else if (check_in_state == 1) {
	      if ((0, _moment2.default)(check_in_datetime).isBefore(lesson_start_datetime)) {
	        return __('Attended', _locale2.default);
	      } else if ((0, _moment2.default)(check_in_datetime).isBetween((0, _moment2.default)(lesson_start_datetime), (0, _moment2.default)(lesson_end_datetime), null, '[]')) {
	        return __('Late', _locale2.default);
	      } else {
	        return __('Make Up', _locale2.default);
	      }
	    } else if (check_in_state == 2) {
	      return __('Absent (with excuse)', _locale2.default);
	    } else if (check_in_state == 3) {
	      return __('Late', _locale2.default);
	    } else if (check_in_state == 4) {
	      return __('Absent (without notice)', _locale2.default);
	    } else if (check_in_state == 5) {
	      return __('Make Up', _locale2.default);
	    }
	  };
	
	  AttendanceTable.prototype.fetchTeacherAttendance = function fetchTeacherAttendance(done) {
	    var _this3 = this;
	
	    var _props2 = this.props,
	        id = _props2.id,
	        attendanceInfo = _props2.attendanceInfo;
	
	    (0, _teacherAttendanceRecord2.default)(id, _extends({}, attendanceInfo, {
	      amount_per_page: 50,
	      current_page_number: this.currentPage
	    })).then(function (result) {
	      _this3.setState({ attendanceList: _this3.state.attendanceList.concat(result.result_list), attendanceDetail: result }, function () {
	        if (_this3.state.attendanceList.length > 0) {
	          _this3.csvAttendanceList = _this3.state.attendanceList.map(function (attendance) {
	            var csvAttendance = {};
	            csvAttendance[__('Class Name', 'teacherAttendance')] = attendance.class_name;
	            csvAttendance[__('Lesson', 'teacherAttendance')] = __('Lesson', 'teacherAttendance') + ' ' + attendance.lesson_index;
	            csvAttendance[__('Lesson Time', 'teacherAttendance')] = _this3.formatLessonTime(attendance);
	            csvAttendance[__('Attend Time', 'teacherAttendance')] = _this3.formatAttendTime(attendance);
	            csvAttendance[__('Status', 'teacherAttendance')] = _this3.getAttendanceStatus(attendance);
	            return csvAttendance;
	          });
	        }
	      });
	      if (_this3.currentPage >= result.page_amount) {
	        done();
	        return;
	      }
	      _this3.currentPage++;
	      _this3.fetchTeacherAttendance(done);
	    });
	  };
	
	  AttendanceTable.prototype.fetchStudentAttendance = function fetchStudentAttendance(done) {
	    var _this4 = this;
	
	    var _props3 = this.props,
	        id = _props3.id,
	        attendanceInfo = _props3.attendanceInfo;
	
	    (0, _studentAttendanceRecord2.default)(id, _extends({}, attendanceInfo, {
	      amount_per_page: 50,
	      current_page_number: this.currentPage
	    })).then(function (result) {
	      _this4.setState({ attendanceList: _this4.state.attendanceList.concat(result.result_list), attendanceDetail: result }, function () {
	        if (_this4.state.attendanceList.length > 0) {
	          _this4.csvAttendanceList = _this4.state.attendanceList.map(function (attendance) {
	            var csvAttendance = {};
	            csvAttendance[__('Class Name', 'teacherAttendance')] = attendance.class_name;
	            csvAttendance[__('Lesson', 'teacherAttendance')] = __('Lesson', 'teacherAttendance') + ' ' + attendance.lesson_index;
	            csvAttendance[__('Lesson Time', 'teacherAttendance')] = _this4.formatLessonTime(attendance);
	            csvAttendance[__('Attend Time', 'teacherAttendance')] = _this4.formatAttendTime(attendance);
	            csvAttendance[__('Status', 'teacherAttendance')] = _this4.getAttendanceStatus(attendance);
	            return csvAttendance;
	          });
	        }
	      });
	      if (_this4.currentPage >= result.page_amount) {
	        done();
	        return;
	      }
	      _this4.currentPage++;
	      _this4.fetchStudentAttendance(done);
	    });
	  };
	
	  AttendanceTable.prototype.renderDownloadBtn = function renderDownloadBtn() {
	    var _this5 = this;
	
	    var format = this.props.format;
	
	
	    if (!this.state.doneFetching) {
	      return _react2.default.createElement(
	        'div',
	        { style: { height: 40, textAlign: 'center' } },
	        _react2.default.createElement(_Loading2.default, null)
	      );
	    } else if (!this.state.downloaded) {
	      return _react2.default.createElement(
	        'span',
	        { className: 'downloadBtnWrapper', onClick: function onClick() {
	            _this5.setState({ downloaded: true });
	          } },
	        format === 'excel' && _react2.default.createElement(_reactHtmlTableToExcel2.default, {
	          className: 'btn btn-primary download-btn',
	          table: 'attendance-table',
	          filename: this.props.state === 'teacher' ? 'Attendance Record for ' + this.state.attendanceDetail.teacher_name : 'Attendance Record for ' + this.state.attendanceDetail.student_name,
	          sheet: 'attendance_table',
	          buttonText: __('Download', _locale2.default)
	        }),
	        format === 'csv' && _react2.default.createElement(
	          _reactCsv.CSVLink,
	          {
	            data: this.csvAttendanceList,
	            filename: this.props.state === 'teacher' ? 'Attendance Record for ' + this.state.attendanceDetail.teacher_name + '.csv' : 'Attendance Record for ' + this.state.attendanceDetail.student_name + '.csv',
	            className: 'btn btn-primary download-btn',
	            target: '_self' },
	          __('Download', _locale2.default)
	        )
	      );
	    } else if (this.state.downloaded) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          { className: 'download-success-text' },
	          __('Download Successfully!', _locale2.default)
	        ),
	        format === 'excel' && _react2.default.createElement(_reactHtmlTableToExcel2.default, {
	          className: 'btn-link redownload-btn',
	          table: 'attendance-table',
	          filename: this.props.state === 'teacher' ? 'Attendance Record for ' + this.state.attendanceDetail.teacher_name : 'Attendance Record for ' + this.state.attendanceDetail.student_name,
	          sheet: 'attendance_table',
	          buttonText: __('Redownload', _locale2.default)
	        }),
	        format === 'csv' && _react2.default.createElement(
	          _reactCsv.CSVLink,
	          {
	            data: this.csvAttendanceList,
	            filename: this.props.state === 'teacher' ? 'Attendance Record for ' + this.state.attendanceDetail.teacher_name + '.csv' : 'Attendance Record for ' + this.state.attendanceDetail.student_name + '.csv',
	            className: 'btn-link redownload-btn',
	            target: '_self' },
	          __('Redownload', _locale2.default)
	        )
	      );
	    } else {
	      return null;
	    }
	  };
	
	  AttendanceTable.prototype.render = function render() {
	    var _this6 = this;
	
	    var _props4 = this.props,
	        state = _props4.state,
	        attendanceInfo = _props4.attendanceInfo;
	    var _state$attendanceDeta2 = this.state.attendanceDetail,
	        total_counted_amount = _state$attendanceDeta2.total_counted_amount,
	        total_counted_duration = _state$attendanceDeta2.total_counted_duration,
	        total_normal_amount = _state$attendanceDeta2.total_normal_amount,
	        total_normal_duration = _state$attendanceDeta2.total_normal_duration,
	        total_late_amount = _state$attendanceDeta2.total_late_amount,
	        total_late_duration = _state$attendanceDeta2.total_late_duration,
	        total_retroactive_amount = _state$attendanceDeta2.total_retroactive_amount,
	        total_absent_amount = _state$attendanceDeta2.total_absent_amount,
	        total_absent_duration = _state$attendanceDeta2.total_absent_duration,
	        total_leave_amount = _state$attendanceDeta2.total_leave_amount,
	        total_leave_duration = _state$attendanceDeta2.total_leave_duration,
	        total_truancy_amount = _state$attendanceDeta2.total_truancy_amount,
	        total_truancy_duration = _state$attendanceDeta2.total_truancy_duration,
	        total_unchecked_amount = _state$attendanceDeta2.total_unchecked_amount,
	        total_unchecked_duration = _state$attendanceDeta2.total_unchecked_duration,
	        teacher_name = _state$attendanceDeta2.teacher_name,
	        student_name = _state$attendanceDeta2.student_name;
	
	    var fields = [{
	      name: 'class_name',
	      title: __('Class Name', 'teacherAttendance'),
	      getTdProps: function getTdProps(_ref) {
	        var tbodyData = _ref.tbodyData;
	
	        return {
	          style: {
	            width: "15%"
	          }
	        };
	      }
	    }, {
	      name: 'lesson_index',
	      title: __('Lesson', 'teacherAttendance'),
	      getTdProps: function getTdProps(_ref2) {
	        var tbodyData = _ref2.tbodyData;
	
	        return {
	          style: {
	            width: "8%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref3) {
	        var trData = _ref3.trData;
	
	        return __('Lesson', 'teacherAttendance') + ' ' + trData.lesson_index;
	      }
	    }, {
	      name: 'lesson_time',
	      title: __('Lesson Time', 'teacherAttendance'),
	      getTdProps: function getTdProps(_ref4) {
	        var tbodyData = _ref4.tbodyData;
	
	        return {
	          style: {
	            width: "20%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref5) {
	        var attendenceInfo = _ref5.trData;
	
	        return _react2.default.createElement(_AttendanceLessonTime2.default, { attendenceInfo: attendenceInfo });
	      }
	    }, {
	      name: 'check_in_datetime',
	      title: __('Attend Time', 'teacherAttendance'),
	      getTdProps: function getTdProps(_ref6) {
	        var tbodyData = _ref6.tbodyData;
	
	        return {
	          style: {
	            width: "15%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref7) {
	        var attendenceInfo = _ref7.trData;
	
	        return _react2.default.createElement(_AttendTime2.default, { attendenceInfo: attendenceInfo });
	      }
	    }, {
	      name: 'state',
	      title: __('Status', 'teacherAttendance'),
	      getTdProps: function getTdProps(_ref8) {
	        var tbodyData = _ref8.tbodyData;
	
	        return {
	          style: {
	            width: "7%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref9) {
	        var attendenceInfo = _ref9.trData;
	
	        return _react2.default.createElement(_AttendanceStatus2.default, { attendenceInfo: attendenceInfo, currentRole: _this6.props.state });
	      }
	    }];
	    return _react2.default.createElement(
	      'div',
	      { className: 'AttendanceTable' },
	      this.renderDownloadBtn(),
	      _react2.default.createElement(
	        'table',
	        { id: 'attendance-table', style: { width: '100%', display: 'none' } },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'tr',
	              { style: { fontSize: 15 } },
	              state == 'teacher' && _react2.default.createElement(
	                'th',
	                null,
	                teacher_name
	              ),
	              state == 'student' && _react2.default.createElement(
	                'th',
	                null,
	                student_name
	              ),
	              _react2.default.createElement(
	                'th',
	                { colSpan: '2' },
	                attendanceInfo.start_date,
	                ' - ',
	                attendanceInfo.end_date
	              )
	            ),
	            _react2.default.createElement('tr', null),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                { colSpan: '7', style: { color: '#fff', backgroundColor: '#3b67bc', fontSize: 14 } },
	                __('Attendance Overview', 'teacherAttendance')
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                __('Total Attended Count & Duration', 'teacherAttendance')
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                __('On Time Count & Duration', 'teacherAttendance')
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                __('Late Count & Duration', 'teacherAttendance')
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                __('Makeup Count', 'teacherAttendance')
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                __('Total Unattended Count & Duration', 'teacherAttendance')
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                __('Absent (with excuse) Count & Duration', 'teacherAttendance')
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                __('Absent (without notice) Count & Duration', 'teacherAttendance')
	              ),
	              state == 'student' && _react2.default.createElement(
	                'th',
	                null,
	                __('Unchecked Count & Duration', 'teacherAttendance')
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              { style: { textAlign: 'center' } },
	              _react2.default.createElement(
	                'td',
	                null,
	                total_counted_amount
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                total_normal_amount
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                total_late_amount
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                total_retroactive_amount
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                total_absent_amount
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                total_leave_amount
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                total_truancy_amount
	              ),
	              state == 'student' && _react2.default.createElement(
	                'td',
	                null,
	                total_unchecked_amount
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              { style: { textAlign: 'center' } },
	              _react2.default.createElement(
	                'td',
	                null,
	                _moment2.default.duration(Number(total_counted_duration), 'minutes').format('h [h] m [m]', { trim: 'all' }) || '0h'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                _moment2.default.duration(Number(total_normal_duration), 'minutes').format('h [h] m [m]', { trim: 'all' }) || '0h'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                _moment2.default.duration(Number(total_late_duration), 'minutes').format('h [h] m [m]', { trim: 'all' }) || '0h'
	              ),
	              _react2.default.createElement('td', null),
	              _react2.default.createElement(
	                'td',
	                null,
	                _moment2.default.duration(Number(total_absent_duration), 'minutes').format('h [h] m [m]', { trim: 'all' }) || '0h'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                _moment2.default.duration(Number(total_leave_duration), 'minutes').format('h[h] m[m]', { trim: 'all' }) || '0h'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                _moment2.default.duration(Number(total_truancy_duration), 'minutes').format('h [h] m [m]', { trim: 'all' }) || '0h'
	              ),
	              state == 'student' && _react2.default.createElement(
	                'td',
	                null,
	                _moment2.default.duration(Number(total_unchecked_duration), 'minutes').format('h [h] m [m]', { trim: 'all' }) || '0h'
	              )
	            ),
	            _react2.default.createElement('tr', null),
	            state == 'teacher' && _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                { style: { fontSize: 15 } },
	                __('Total Salary:', 'teacherAttendance')
	              ),
	              _react2.default.createElement(
	                'td',
	                { style: { color: '#FCAF3D', fontSize: 18 } },
	                '$',
	                this.props.attendance.totalSalary
	              )
	            ),
	            _react2.default.createElement('tr', null),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                { colSpan: '7', style: { color: '#fff', backgroundColor: '#3b67bc', fontSize: 14 } },
	                __('Attendance Detail', 'teacherAttendance')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_UI.Table, {
	              data: this.state.attendanceList,
	              fields: fields,
	              crqassName: 'registration-table',
	              settingThTitle: __('Settings', 'class'),
	              settingWidth: '15%',
	              useMultiSelection: false,
	              oneSettingPerRow: false,
	              dropdownGuideWidth: 160,
	              dropdownGuideHeight: 228,
	              usePagination: false
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return AttendanceTable;
	}(_react2.default.Component);
	
	exports.default = AttendanceTable;
	module.exports = exports['default'];

/***/ },

/***/ "4Kje":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentDurationFormat = __webpack_require__("SdwT");
	
	var _momentDurationFormat2 = _interopRequireDefault(_momentDurationFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _momentDurationFormat2.default)(_moment2.default);
	
	var AttendanceLessonTime = function (_Component) {
	  _inherits(AttendanceLessonTime, _Component);
	
	  function AttendanceLessonTime(props) {
	    _classCallCheck(this, AttendanceLessonTime);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  AttendanceLessonTime.prototype.render = function render() {
	    var attendenceInfo = this.props.attendenceInfo;
	    var lesson_start_datetime = attendenceInfo.lesson_start_datetime,
	        lesson_end_datetime = attendenceInfo.lesson_end_datetime,
	        check_in_state = attendenceInfo.check_in_state;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'class-status' },
	      _react2.default.createElement(
	        'span',
	        null,
	        (0, _moment2.default)(lesson_start_datetime).format(__('MMM DD, YYYY', 'dateFormat')) + ' ' + (0, _moment2.default)(lesson_start_datetime).format('HH:mm') + ' - ' + (0, _moment2.default)(lesson_end_datetime).format('HH:mm')
	      ),
	      _react2.default.createElement(
	        'span',
	        { style: { paddingLeft: '10px' } },
	        check_in_state == 1 && _moment2.default.duration((0, _moment2.default)(lesson_end_datetime) - (0, _moment2.default)(lesson_start_datetime)).format('h [h] m [m]', { trim: 'all' })
	      )
	    );
	  };
	
	  return AttendanceLessonTime;
	}(_react.Component);
	
	exports.default = AttendanceLessonTime;
	module.exports = exports['default'];

/***/ },

/***/ "zeU0":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _locale = __webpack_require__("wqLs");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AttendanceStatus = function (_Component) {
	  _inherits(AttendanceStatus, _Component);
	
	  function AttendanceStatus(props) {
	    _classCallCheck(this, AttendanceStatus);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  AttendanceStatus.prototype.renderStatus = function renderStatus() {
	    var _props = this.props,
	        attendenceInfo = _props.attendenceInfo,
	        currentRole = _props.currentRole;
	    var check_in_state = attendenceInfo.check_in_state,
	        lesson_start_datetime = attendenceInfo.lesson_start_datetime,
	        lesson_end_datetime = attendenceInfo.lesson_end_datetime,
	        check_in_datetime = attendenceInfo.check_in_datetime;
	
	    if (check_in_state == 0) {
	      if (currentRole === 'student') {
	        return __('Unchecked', _locale2.default);
	      } else {
	        return __('Absent (without notice)', _locale2.default);
	      }
	    } else if (check_in_state == 1) {
	      if ((0, _moment2.default)(check_in_datetime).isBefore(lesson_start_datetime)) {
	        return __('Attended', _locale2.default);
	      } else if ((0, _moment2.default)(check_in_datetime).isBetween((0, _moment2.default)(lesson_start_datetime), (0, _moment2.default)(lesson_end_datetime), null, '[]')) {
	        return __('Late', _locale2.default);
	      } else {
	        return __('Make Up', _locale2.default);
	      }
	    } else if (check_in_state == 2) {
	      return __('Absent (with excuse)', _locale2.default);
	    } else if (check_in_state == 3) {
	      return __('Late', _locale2.default);
	    } else if (check_in_state == 4) {
	      return __('Absent (without notice)', _locale2.default);
	    } else if (check_in_state == 5) {
	      return __('Make Up', _locale2.default);
	    }
	  };
	
	  AttendanceStatus.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'class-status' },
	      this.renderStatus()
	    );
	  };
	
	  return AttendanceStatus;
	}(_react.Component);
	
	exports.default = AttendanceStatus;
	module.exports = exports['default'];

/***/ },

/***/ "wqLs":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'attendanceRecord',
	  code: 'CN',
	  text: {
	    'Absent (without notice)': '旷课',
	    'Late': '迟到',
	    'Attended': '出勤',
	    'Absent (with excuse)': '请假',
	    'Unchecked': '无记录',
	    'Make Up': '补签',
	    'Teacher': '老师'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "dg0h":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AttendTime = function (_Component) {
	  _inherits(AttendTime, _Component);
	
	  function AttendTime(props) {
	    _classCallCheck(this, AttendTime);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  AttendTime.prototype.renderCheckInTime = function renderCheckInTime() {
	    var attendenceInfo = this.props.attendenceInfo;
	    var lesson_start_datetime = attendenceInfo.lesson_start_datetime,
	        lesson_end_datetime = attendenceInfo.lesson_end_datetime,
	        check_in_datetime = attendenceInfo.check_in_datetime;
	
	
	    if (!check_in_datetime) {
	      return '––';
	    } else if ((0, _moment2.default)(lesson_start_datetime).format('YYYY-MM-DD') == (0, _moment2.default)(check_in_datetime).format('YYYY-MM-DD')) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        (0, _moment2.default)(check_in_datetime).format('HH:mm')
	      );
	    } else {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          (0, _moment2.default)(check_in_datetime).format(__('MMM DD, YYYY', 'dateFormat'))
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: { paddingLeft: '5px' } },
	          (0, _moment2.default)(check_in_datetime).format('HH:mm'),
	          '  '
	        )
	      );
	    }
	  };
	
	  AttendTime.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'class-status' },
	      this.renderCheckInTime()
	    );
	  };
	
	  return AttendTime;
	}(_react.Component);
	
	exports.default = AttendTime;
	module.exports = exports['default'];

/***/ },

/***/ "LMA4":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHtmlTableToExcel = __webpack_require__("zJ5Q");
	
	var _reactHtmlTableToExcel2 = _interopRequireDefault(_reactHtmlTableToExcel);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _rcProgress = __webpack_require__("McaX");
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getTradeRecord = __webpack_require__("KAiH");
	
	var _getTradeRecord2 = _interopRequireDefault(_getTradeRecord);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _reactCsv = __webpack_require__("xdcN");
	
	var _UI = __webpack_require__("OM1Z");
	
	var _constants = __webpack_require__("K30H");
	
	var _locale = __webpack_require__("0SmY");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <AttendanceTable 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var FinanceTable = function (_React$Component) {
	  _inherits(FinanceTable, _React$Component);
	
	  function FinanceTable(props) {
	    _classCallCheck(this, FinanceTable);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      recordList: [],
	      recordDetail: {},
	      doneFetching: false,
	      downloaded: false
	    };
	    _this.currentPage = 1;
	    _this.csvRecordList = [];
	    _this.fetchTradeRecord = _this.fetchTradeRecord.bind(_this);
	    return _this;
	  }
	
	  FinanceTable.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    this.fetchTradeRecord(function () {
	      _this2.setState({ doneFetching: true });
	    });
	  };
	
	  FinanceTable.prototype.fetchTradeRecord = function fetchTradeRecord(done) {
	    var _this3 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var params = this.props.params;
	
	    (0, _getTradeRecord2.default)(schoolId, {
	      student_id_list: params.student_id_list ? params.student_id_list : null,
	      class_id_list: params.class_id_list ? params.class_id_list : null,
	      start_date: params.start_date ? params.start_date : null,
	      end_date: params.end_date ? params.end_date : null,
	      transaction_number: params.transaction_number ? params.transaction_number : null,
	      paging_or_not: 1,
	      amount_per_page: 50,
	      page_number: this.currentPage
	    }).then(function (result) {
	      _this3.setState({ recordList: _this3.state.recordList.concat(result.result_list), recordDetail: result }, function () {
	        _this3.csvRecordList = _this3.state.recordList.map(function (record) {
	          var recordList = {};
	
	          recordList[__('Date', 'class')] = record.transaction_date;
	          recordList[__('E-Receipt No.', 'finance')] = record.transaction_number;
	          recordList[__('Student', 'finance')] = record.student_name;
	          recordList[__('Class', 'student')] = record.class_name ? record.class_name : __('School Credit', 'PaymentModal');
	          recordList[__('Charge/Refund', 'finance')] = record.trType == 1 ? __('Charge', 'finance') : __('Refund', 'finance');
	          recordList[__('Amount', 'finance')] = record.trTransactionAmount;
	          recordList[__('Payment Methods', 'finance')] = _constants.PAYMENT_METHOD[record.source_or_direction];
	          recordList[__('Purchased Lessons', 'finance')] = _this3.renderPurchasedLesson(record);
	          recordList[__('Operator', 'finance')] = record.operator_name;
	          return recordList;
	        });
	      });
	      if (_this3.currentPage >= result.page_amount) {
	        done();
	        return;
	      }
	      _this3.currentPage++;
	      _this3.fetchTradeRecord(done);
	    });
	  };
	
	  FinanceTable.prototype.renderPurchasedLesson = function renderPurchasedLesson(record) {
	    if (record.class_name.length == 0) {
	      return 'N/A';
	    } else if (record.trEndDate) {
	      return __('To', 'finance') + ' ' + record.trEndDate;
	    } else {
	      return Math.round(record.trQuantity) + __('', 'classdetail');
	    }
	  };
	
	  FinanceTable.prototype.renderTransactionRecords = function renderTransactionRecords() {
	    var _this4 = this;
	
	    var recordList = [];
	    if (this.state.recordList.length > 0) {
	      this.state.recordList.forEach(function (record) {
	        recordList.push(_react2.default.createElement(
	          'tr',
	          { style: { textAlign: 'center' }, key: record.id },
	          _react2.default.createElement(
	            'td',
	            null,
	            record.transaction_date
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            record.transaction_number
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            record.student_name
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            record.class_name ? record.class_name : __('School Credit', 'PaymentModal')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            record.trType == 1 ? __('Charge', 'finance') : __('Refund', 'finance')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            record.trTransactionAmount
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _constants.PAYMENT_METHOD[record.source_or_direction]
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _this4.renderPurchasedLesson(record)
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            record.operator_name
	          )
	        ));
	      });
	    }
	    return recordList;
	  };
	
	  FinanceTable.prototype.renderDownloadBtn = function renderDownloadBtn() {
	    var _this5 = this;
	
	    var format = this.props.format;
	
	    if (!this.state.doneFetching && this.state.recordDetail.page_amount) {
	      return _react2.default.createElement(
	        'div',
	        { style: { height: 40, textAlign: 'center' } },
	        _react2.default.createElement(_rcProgress.Line, { percent: this.currentPage / this.state.recordDetail.page_amount * 100, strokeWidth: '4', strokeColor: '#346aff' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          __('Loading...', _locale2.default) + ' ' + Math.round(this.currentPage / this.state.recordDetail.page_amount * 100),
	          '%'
	        )
	      );
	    } else if (this.state.doneFetching && !this.state.downloaded) {
	      return _react2.default.createElement(
	        'span',
	        { className: 'downloadBtnWrapper', onClick: function onClick() {
	            _this5.setState({ downloaded: true });
	          } },
	        format === 'excel' && _react2.default.createElement(_reactHtmlTableToExcel2.default, {
	          className: 'btn btn-primary download-btn',
	          table: 'finance-table',
	          filename: 'School Transaction Records',
	          sheet: 'finance-table',
	          buttonText: __('Download', _locale2.default)
	        }),
	        format === 'csv' && _react2.default.createElement(
	          _reactCsv.CSVLink,
	          {
	            data: this.csvRecordList,
	            filename: 'School Transaction Records.csv',
	            className: 'btn btn-primary download-btn',
	            target: '_self' },
	          __('Download', _locale2.default)
	        )
	      );
	    } else if (this.state.doneFetching && this.state.downloaded) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          { className: 'download-success-text' },
	          __('Download Successfully!', _locale2.default)
	        ),
	        format === 'excel' && _react2.default.createElement(_reactHtmlTableToExcel2.default, {
	          className: 'btn-link redownload-btn',
	          table: 'finance-table',
	          filename: 'School Transaction Records',
	          sheet: 'finance-table',
	          buttonText: __('Redownload', _locale2.default)
	        }),
	        format === 'csv' && _react2.default.createElement(
	          _reactCsv.CSVLink,
	          {
	            data: this.csvRecordList,
	            filename: 'School Transaction Records.csv',
	            className: 'btn-link redownload-btn',
	            target: '_self' },
	          __('Redownload', _locale2.default)
	        )
	      );
	    } else {
	      return null;
	    }
	  };
	
	  FinanceTable.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'FinanceTable' },
	      this.renderDownloadBtn(),
	      _react2.default.createElement(
	        'table',
	        { id: 'finance-table', style: { width: '100%', display: 'none' } },
	        _react2.default.createElement(
	          'tr',
	          { style: { fontSize: 15, color: '#fff', backgroundColor: '#3b67bc' } },
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Date', 'class')
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            __('E-Receipt No.', 'finance')
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Student', 'finance')
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Class', 'student')
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Charge/Refund', 'finance')
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Amount', 'finance')
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Payment Methods', 'finance')
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Purchased Lessons', 'finance')
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Operator', 'finance')
	          )
	        ),
	        this.renderTransactionRecords()
	      )
	    );
	  };
	
	  return FinanceTable;
	}(_react2.default.Component);
	
	exports.default = FinanceTable;
	module.exports = exports['default'];

/***/ },

/***/ "K30H":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var CHECK_IN_TYPE = exports.CHECK_IN_TYPE = ['未签到', '到课', '请假', '迟到', '旷课'];
	
	var QUANTITY_NAME_S = exports.QUANTITY_NAME_S = localStorage.getItem('language') == 'CN' ? ['天', '次', '小时'] : ['Day', 'Lesson', 'Hour'];
	
	var QUANTITY_NAME_C = exports.QUANTITY_NAME_C = localStorage.getItem('language') == 'CN' ? ['天', '次', '次'] : ['', '', ''];
	
	var UNIT_NAME_C = exports.UNIT_NAME_C = ['期', '次', '次'];
	
	var COST_RULE = exports.COST_RULE = localStorage.getItem('language') == 'CN' ? ['课程时间结束后自动算课消', '课程签到后算课消'] : ['Lesson counts as completion after end date', 'Lesson counts as completion after attending'];
	
	var ABSENT_RULE = exports.ABSENT_RULE = localStorage.getItem('language') == 'CN' ? ['旷课不算课消', '旷课算消课'] : ['Absence (without notice) counts as incompletion', 'Absence (without notice) counts as completion'];
	
	var CANCEL_RULE = exports.CANCEL_RULE = localStorage.getItem('language') == 'CN' ? ['请假不算消课', '请假算消课'] : ['Absence (with excuse) counts as incompletion', 'Absence (with excuse) counts as completion'];
	
	var CLASS_TYPE_STATE = exports.CLASS_TYPE_STATE = [['已归档', '当期班级'], ['已归档', '当期私课']];
	
	var STUDENT_STATE = exports.STUDENT_STATE = ['', '当期学员', '未排班学员', '在读学员', '往期学员', '待续费学员'];
	
	var CHARGE_TYPE = exports.CHARGE_TYPE = ['按期收费', '按次收费', '按课时收费'];
	
	var CHARGE_REMINDER_TYPE = exports.CHARGE_REMINDER_TYPE = localStorage.getItem('language') == 'CN' ? ['按日期消耗完', '按课次数消耗完', '按课时数消耗完'] : ['End Date', 'End Lesson', 'End Lesson Hour'];
	
	var PAYMENT_METHOD = exports.PAYMENT_METHOD = localStorage.getItem('language') == 'CN' ? ['现金', '信用卡', '支票', '转账', '校内钱包', 'ClassTopBase 钱包', '微信扫码器支付', '支付宝扫码器支付', '微信网页支付', '支付宝网页支付', '微信转账', '支付宝转账'] : ['Cash', 'Credit Card', 'Chqeque', 'Bank Transfer', 'School Credit', 'ClassTopBase Credit', 'WeChat Pay (Barcode)', 'AliPay (Barcode)', 'WeChat Pay (Web)', 'AliPay (Web)', 'WeChat Pay Transfer', 'AliPay Transfer'];
	
	var SAAS_VERSIONS = exports.SAAS_VERSIONS = [{ name: 'Free Trial' }, { name: 'Discount Plan', price: 79, billCycle: 'monthly', planCodename: 'regular_usd_monthly' }, { name: 'Customized Plan' }, { name: 'Basic Plan', price: 30, billCycle: 'monthly', planCodename: 'basic_30usd_monthly' }, { name: 'Basic Plan', price: 27, billCycle: 'yearly', planCodename: 'basic_324usd_yearly' }, { name: 'Professional Plan', price: 180, billCycle: 'monthly', planCodename: 'professional_180usd_monthly' }, { name: 'Professional Plan', price: 162, billCycle: 'yearly', planCodename: 'professional_1944usd_yearly' }, { name: 'Premium Plan', price: 360, billCycle: 'monthly', planCodename: 'premium_360usd_monthly' }, { name: 'Premium Plan', price: 324, billCycle: 'yearly', planCodename: 'premium_3888usd_yearly' }, { name: 'Customized Plan', price: 600, billCycle: 'monthly', planCodename: 'customized_600usd_monthly' }, { name: 'Customized Plan', price: 540, billCycle: 'yearly', planCodename: 'customized_6480usd_yearly' }, { name: 'Customized Plan', price: 800, billCycle: 'monthly', planCodename: 'customized_800usd_monthly' }, { name: 'Customized Plan', price: 720, billCycle: 'yearly', planCodename: 'customized_8640usd_yearly' }];

/***/ },

/***/ "dFGx":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalProvider = __webpack_require__("Om+H");
	
	var _ModalProvider2 = _interopRequireDefault(_ModalProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalProvider2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "Om+H":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalBody = __webpack_require__("MuzG");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalProvider = function (_React$Component) {
	  _inherits(ModalProvider, _React$Component);
	
	  function ModalProvider(props) {
	    _classCallCheck(this, ModalProvider);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalProvider.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(_ModalBody2.default, this.props)
	    );
	  };
	
	  return ModalProvider;
	}(_react2.default.Component);
	
	exports.default = ModalProvider;
	module.exports = exports['default'];

/***/ },

/***/ "MuzG":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("qL05");
	
	var _ModalContent = __webpack_require__("mz+f");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _locale = __webpack_require__("5AUk");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _addClass = __webpack_require__("yjcn");
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _editClass = __webpack_require__("OHvH");
	
	var _editClass2 = _interopRequireDefault(_editClass);
	
	var _getClassDetailByID = __webpack_require__("DY3E");
	
	var _getClassDetailByID2 = _interopRequireDefault(_getClassDetailByID);
	
	var _ducks = __webpack_require__("wTtZ");
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _ducks2 = __webpack_require__("lDbx");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
		return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
		return {
			fetchClass: function fetchClass(opts) {
				return dispatch((0, _ducks.fetchClass)(opts));
			},
			fetchClassLesson: function fetchClassLesson(classId, params) {
				return dispatch((0, _ducks2.fetchClassLesson)(classId, params));
			}
		};
	};
	
	var ModalBody = function (_React$Component) {
		_inherits(ModalBody, _React$Component);
	
		function ModalBody(props) {
			_classCallCheck(this, ModalBody);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			var INIT_FORM_DATA = {
				costAlertRange: 1,
				costRule: true,
				absentFlag: true,
				cancelFlag: false,
				billingMethod: {
					feeType: 0
				}
			};
	
			_this.state = {
				classData: INIT_FORM_DATA,
				disabledBtn: false
			};
			return _this;
		}
	
		ModalBody.prototype.componentDidMount = function componentDidMount() {
			var _this2 = this;
	
			if (this.props.id) {
				(0, _getClassDetailByID2.default)(this.props.id).then(function (res) {
					var classData = {
						cName: res.cName,
						cType: res.cType,
						costAlertRange: res.costAlertRange,
						costRule: true,
						cancelFlag: res.cancelFlag == 1 ? true : false,
						absentFlag: res.absentFlag == 1 ? true : false,
						billingMethod: {
							feeType: res.feeType,
							totalPrice: res.totalPrice,
							unitPrice: res.unitPrice,
							consumption_type: res.consumption_type
						}
					};
					_this2.setState({ classData: classData });
				});
			}
		};
	
		ModalBody.prototype.render = function render() {
			var _this3 = this;
	
			var _props = this.props,
			    show = _props.show,
			    proceed = _props.proceed,
			    dismiss = _props.dismiss,
			    cancel = _props.cancel,
			    mode = _props.mode,
			    pageState = _props.pageState,
			    pagination = _props.pagination;
	
	
			var schoolId = localStorage.getItem('schoolId');
	
			return _react2.default.createElement(
				_Modal2.default,
				{
					className: 'create-class-modal',
					isShowingModal: show,
	
					onCloseModalClick: dismiss,
					fixedWidth: 600,
					overlayColor: '#000',
	
					hasHeader: true,
					headerTitle: this.props.mode == 'create' ? __('Create Class', _locale2.default) : __('Edit Class', _locale2.default),
					headerType: 'bold',
					footerType: 'grey',
					hasFooter: true,
					footerButtons: [{
						title: __('Complete', 'appwrapper'),
						className: 'btn btn-primary pull-right',
						onClick: function onClick() {
							_this3.setState({ disabledBtn: true });
							var validateResult = _this3.validate();
							if (!validateResult.ok) {
								_this3.setState({ disabledBtn: false });
								return;
							}
	
							var consumption_type = void 0;
							var feeType = _this3.state.classData.billingMethod.feeType ? _this3.state.classData.billingMethod.feeType : 1;
	
							feeType == 1 ? consumption_type = 1 : consumption_type = 2;
	
							var newFormData = _extends({}, _this3.state.classData, {
								absentFlag: _this3.state.classData.absentFlag ? 1 : 0,
								cancelFlag: _this3.state.classData.cancelFlag ? 1 : 0,
								costRule: 1,
								cType: 0,
								student_id_list: _this3.props.studentIdList ? _this3.props.studentIdList : [],
								feeType: typeof _this3.state.classData.billingMethod.feeType !== 'undefined' ? _this3.state.classData.billingMethod.feeType : 1,
								consumption_type: _this3.state.classData.billingMethod.consumption_type ? _this3.state.classData.billingMethod.consumption_type : consumption_type,
								totalPrice: _this3.state.classData.billingMethod.totalPrice,
								unitPrice: _this3.state.classData.billingMethod.unitPrice ? _this3.state.classData.billingMethod.unitPrice : undefined
							});
	
							delete newFormData.billingMethod;
	
							if (newFormData.feeType !== 0) {
								delete newFormData.totalPrice;
							}
	
							if (mode == 'create') {
								(0, _addClass2.default)(schoolId, newFormData).then(function (res) {
									if (res.result == 'success') {
										_this3.props.fetchClass({ schoolId: schoolId, type: 'group', state: 'current', amount_per_page: 25, current_page_number: 1 });
										if (_this3.props.studentIdList) {
											_reactRouter.browserHistory.push('/class');
										}
										_this3.props.proceed();
									}
								});
							} else if (mode == 'update') {
								(0, _editClass2.default)(_this3.props.id, newFormData).then(function (res) {
									if (res.result == 'success') {
										_this3.props.fetchClassLesson(_this3.props.id, {
											amount_per_page: pagination.itemsCountPerPage,
											current_page_number: pagination.activePage,
											after_today: pageState === 'current' ? 1 : 0
										});
										_this3.props.proceed();
									}
								});
							}
						},
						isDisabled: function isDisabled() {
							return _this3.state.disabledBtn;
						}
					}]
				},
				_react2.default.createElement(_ModalContent2.default, _extends({}, this.props, {
					classData: this.state.classData,
					onFormChange: function onFormChange(classData) {
						_this3.setState({ classData: classData });
					},
					getValidationRef: function getValidationRef(fn) {
						_this3.validate = fn;
					}
				}))
			);
		};
	
		return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactConfirm.confirmable)(ModalBody));
	module.exports = exports['default'];

/***/ },

/***/ "qL05":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "mz+f":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("5AUk");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      formData: props.classData
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  ModalContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var classData = _ref.classData;
	
	    this.setState({ formData: classData });
	  };
	
	  ModalContent.prototype.onChange = function onChange(formData) {
	    var _this2 = this;
	
	    this.setState({
	      formData: _extends({}, this.state.formData, formData)
	    }, function () {
	      _this2.props.onFormChange(formData);
	    });
	  };
	
	  ModalContent.prototype.render = function render() {
	    var formData = this.state.formData;
	
	    var notifyOption = [];
	
	    for (var i = 1; i < 31; i++) {
	      if (formData.billingMethod.feeType == 0) {
	        if (i > 1) {
	          notifyOption.push({ label: __('{i} days in advance', _locale2.default, { i: i }), value: i });
	        } else {
	          notifyOption.push({ label: __('{i} day in advance', _locale2.default, { i: i }), value: i });
	        }
	      } else if (formData.billingMethod.feeType == 1) {
	        if (i > 1) {
	          notifyOption.push({ label: __('{i} lessons in advance', _locale2.default, { i: i }), value: i });
	        } else {
	          notifyOption.push({ label: __('{i} lesson in advance', _locale2.default, { i: i }), value: i });
	        }
	      } else if (formData.billingMethod.feeType == 2) {
	        if (i > 1) {
	          notifyOption.push({ label: __('{i} hours in advance', _locale2.default, { i: i }), value: i });
	        } else {
	          notifyOption.push({ label: __('{i} hour in advance', _locale2.default, { i: i }), value: i });
	        }
	      }
	    }
	
	    var schema = [{
	      name: 'cName',
	      label: __('Class Name', _locale2.default),
	      type: 'text',
	      required: true
	    }, {
	      name: 'billingMethod',
	      label: __('Billing Types', _locale2.default),
	      type: 'classBillingMethod',
	      required: true,
	      mode: this.props.mode
	    }, {
	      name: 'costAlertRange',
	      label: __('Notify me overdue fee...', _locale2.default),
	      type: 'select',
	      required: false,
	      options: notifyOption,
	      tip: __('Lesson Completion Rules', _locale2.default)
	    }, {
	      name: 'costRule',
	      placeholder: __('Attending counts as completion', _locale2.default),
	      type: 'checkbox',
	      required: false,
	      disabled: true
	    }, {
	      name: 'absentFlag',
	      placeholder: __('Absence (without reason) counts as completion', _locale2.default),
	      type: 'checkbox',
	      required: false
	    }, {
	      name: 'cancelFlag',
	      placeholder: __('Absence (with reason) counts as completion', _locale2.default),
	      type: 'checkbox',
	      required: false
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'create-class-modal-content' },
	      _react2.default.createElement(_Form2.default, {
	        onChange: this.onChange,
	        schema: schema,
	        formData: formData,
	        formStyle: 'outline',
	        getValidationRef: this.props.getValidationRef
	      })
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "5AUk":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'CreateClassModal',
	  code: 'CN',
	  text: {
	    'Create Class': '新增班级',
	    'Edit Class': '编辑班级',
	    'Class Name': '班级名称',
	    'Billing Types': '学费标准',
	    'Notify me overdue fee...': '欠费提醒时间',
	    'Lesson Completion Rules': '课消规则',
	    'Attending counts as completion': '签到算课消',
	    'Absence (with reason) counts as completion': '请假算课消',
	    'Absence (without reason) counts as completion': '缺课算课消',
	    '{i} day in advance': '课时剩余 {i} 天前提醒',
	    '{i} lesson in advance': '课时剩余 {i} 节课前提醒',
	    '{i} hour in advance': '课时剩余 {i} 小时前提醒',
	    '{i} days in advance': '课时剩余 {i} 天前提醒',
	    '{i} lessons in advance': '课时剩余 {i} 节课前提醒',
	    '{i} hours in advance': '课时剩余 {i} 小时前提醒',
	    'Bill by term total price': '按每期总价收费',
	    'Bill by lessons unit price': '按课次单价收费',
	    'Bill by hours unit price': '按小时单价收费',
	    'Total Price': '总价',
	    'Unit Price': '单价',
	    'Display finished lessons consumption': '按已上课次显示消耗',
	    'Display finished hours consumption': '按已上小时数显示消耗',
	    'Total consumption when make payment': '缴费时计为全部消耗消耗',
	    'Tuition Consumption Display': '学费消耗显示'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "RYFX":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp; /**
	                    * <Form />
	                    *
	                    *
	                    * <Form onChange={onChange} />
	                    *
	                    *
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	// fields
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("O27J");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Field = __webpack_require__("89wR");
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getPresets = __webpack_require__("hfh4");
	
	var _getPresets2 = _interopRequireDefault(_getPresets);
	
	var _objectPath = __webpack_require__("SeUI");
	
	var _objectPath2 = _interopRequireDefault(_objectPath);
	
	var _DatePicker = __webpack_require__("uvnf");
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _Gender = __webpack_require__("yUzp");
	
	var _Gender2 = _interopRequireDefault(_Gender);
	
	var _ReactSelect = __webpack_require__("Z40E");
	
	var _ReactSelect2 = _interopRequireDefault(_ReactSelect);
	
	var _Address = __webpack_require__("MwQ4");
	
	var _Address2 = _interopRequireDefault(_Address);
	
	var _ClassBillingMethod = __webpack_require__("fVu1");
	
	var _ClassBillingMethod2 = _interopRequireDefault(_ClassBillingMethod);
	
	var _DateTime = __webpack_require__("f+Wu");
	
	var _DateTime2 = _interopRequireDefault(_DateTime);
	
	var _SelectTeacher = __webpack_require__("qPpx");
	
	var _SelectTeacher2 = _interopRequireDefault(_SelectTeacher);
	
	var _SelectStudent = __webpack_require__("958X");
	
	var _SelectStudent2 = _interopRequireDefault(_SelectStudent);
	
	var _PhoneNumber = __webpack_require__("GM/A");
	
	var _PhoneNumber2 = _interopRequireDefault(_PhoneNumber);
	
	var _ImageUploader = __webpack_require__("skwP");
	
	var _ImageUploader2 = _interopRequireDefault(_ImageUploader);
	
	var _Money = __webpack_require__("Eh0C");
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _Email = __webpack_require__("j6CV");
	
	var _Email2 = _interopRequireDefault(_Email);
	
	var _Radio = __webpack_require__("ioGM");
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	var _Name = __webpack_require__("Ivgm");
	
	var _Name2 = _interopRequireDefault(_Name);
	
	var _Textarea = __webpack_require__("ylS4");
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _Guardian = __webpack_require__("yKsk");
	
	var _Guardian2 = _interopRequireDefault(_Guardian);
	
	var _ObjectArray = __webpack_require__("+gOk");
	
	var _ObjectArray2 = _interopRequireDefault(_ObjectArray);
	
	var _MediaCenter = __webpack_require__("jIpW");
	
	var _MediaCenter2 = _interopRequireDefault(_MediaCenter);
	
	var _OpenHours = __webpack_require__("4sJU");
	
	var _OpenHours2 = _interopRequireDefault(_OpenHours);
	
	var _AgeLimit = __webpack_require__("zajY");
	
	var _AgeLimit2 = _interopRequireDefault(_AgeLimit);
	
	var _TimePicker = __webpack_require__("A+Vk");
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	var _WeekdateSelect = __webpack_require__("UsQE");
	
	var _WeekdateSelect2 = _interopRequireDefault(_WeekdateSelect);
	
	__webpack_require__("4U9G");
	
	__webpack_require__("7o1w");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fieldValidations = {
	  name: _Name.validateName,
	  guardian: _Guardian.validateGuardian,
	  email: _Email.validateEmail,
	  radio: _Radio.validateRadio,
	  phone: _PhoneNumber.validatePhone,
	  classBillingMethod: _ClassBillingMethod.validateClassBillingMethod,
	  weekdateSelect: _WeekdateSelect.validateWeekdateSelect
	};
	
	var fields = {
	  Name: _Name2.default,
	  Email: _Email2.default,
	  Guardian: _Guardian2.default,
	  DatePicker: _DatePicker2.default,
	  Gender: _Gender2.default,
	  Address: _Address2.default,
	  ImageUploader: _ImageUploader2.default,
	  DateTime: _DateTime2.default,
	  SelectTeacher: _SelectTeacher2.default,
	  SelectStudent: _SelectStudent2.default,
	  ReactPhoneInput: _PhoneNumber2.default,
	  ObjectArray: _ObjectArray2.default,
	  MediaCenter: _MediaCenter2.default,
	  Money: _Money2.default,
	  ClassBillingMethod: _ClassBillingMethod2.default,
	  Textarea: _Textarea2.default,
	  ReactSelect: _ReactSelect2.default,
	  Openhours: _OpenHours2.default,
	  Agelimit: _AgeLimit2.default,
	  Radio: _Radio2.default,
	  TimePicker2: _TimePicker2.default,
	  WeekdateSelect: _WeekdateSelect2.default
	};
	
	var Form = (_temp = _class = function (_React$Component) {
	  _inherits(Form, _React$Component);
	
	  function Form(props) {
	    _classCallCheck(this, Form);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.validate = _this.validate.bind(_this);
	
	    _this.formData = props.formData || {};
	    _this.formFieldRefs = {};
	
	    _this.state = {
	      schema: [],
	      failed: {}
	    };
	    return _this;
	  }
	
	  Form.prototype.componentWillMount = function componentWillMount() {
	    var _props = this.props,
	        getValidationRef = _props.getValidationRef,
	        schema = _props.schema,
	        formData = _props.formData;
	
	
	    this.setState({
	      schema: this.getSchemaFromPreset(schema)
	    });
	
	    if (typeof getValidationRef === 'function') {
	      getValidationRef(this.validate);
	    }
	    if (formData) {
	      this.formData = formData;
	
	      this.forceUpdate();
	    }
	  };
	
	  Form.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (props.failed) {
	      this.setState({
	        failed: props.failed
	      });
	    }
	
	    if (props.schema) {
	      this.setState({
	        schema: this.getSchemaFromPreset(props.schema)
	      });
	    }
	
	    if (props.formData) {
	      this.formData = props.formData;
	      this.forceUpdate();
	    }
	  };
	
	  Form.prototype.getSchemaFromPreset = function getSchemaFromPreset(schemaIn) {
	    var presets = (0, _getPresets2.default)();
	
	    return schemaIn.map(function (item) {
	      var field = void 0;
	      if (typeof item === "string" && presets[item]) {
	        field = presets[item];
	      } else if (item && typeof item.presetType === "string" && presets[item.presetType]) {
	        var existingField = presets[item.presetType] || {};
	
	        field = _extends({}, existingField, item);
	      } else {
	        field = _extends({}, item);
	      }
	
	      if (field) {
	        return field;
	      }
	    });
	  };
	
	  Form.prototype.onChange = function onChange(path, value) {
	    var parts = path.split('.');
	    var o = this.formData;
	    if (parts.length > 1) {
	      for (var i = 0; i < parts.length - 1; i++) {
	        if (!o[parts[i]]) o[parts[i]] = {};
	        o = o[parts[i]];
	      }
	    }
	
	    o[parts[parts.length - 1]] = value;
	    this.props.onChange(this.formData);
	  };
	
	  Form.prototype.validate = function validate() {
	    var _this2 = this;
	
	    var schema = this.state.schema;
	
	
	    var result = {
	      ok: true,
	      failed: {}
	
	      // Step 1. Validate
	    };schema.map(function (item, key) {
	      var name = item.name,
	          _item$validate = item.validate,
	          validate = _item$validate === undefined ? [] : _item$validate,
	          type = item.type;
	
	      var value = _objectPath2.default.get(_this2.formData, name);
	      if (item.required === true && (typeof value == 'undefined' || value === '')) {
	        result.ok = false;
	
	        if (!result.failed[name]) {
	          result.failed[name] = {
	            because: []
	          };
	        }
	
	        result.failed[name].value = value;
	        result.failed[name].because.push("required");
	      }
	
	      validate.map(function (rule) {
	        var ok = true;
	        var because = void 0;
	        var message = void 0;
	
	        if (typeof rule === "function") {
	          var ruleResult = rule();
	          ok = ruleResult.ok;
	          because = ruleResult.because;
	          message = ruleResult.message;
	        } else if (typeof rule === 'string') {
	          // ...need to do it
	        }
	
	        if (!ok) {
	          if (!result.failed[name]) {
	            result.failed[name] = {
	              because: []
	            };
	          }
	
	          result.failed[name].value = value;
	          result.failed[name].because.push(because);
	          result.failed[name].message = message;
	        }
	      });
	
	      if (typeof fieldValidations[type] == 'function') {
	        var validationResult = fieldValidations[type](value);
	        if (validationResult && validationResult.failed) {
	          result.ok = false;
	          result.failed[name] = validationResult.failed;
	        }
	      }
	    });
	
	    //
	    // Step 2. scroll to the first validation failure
	    //
	    this.scrollToFailed(result.failed);
	
	    this.setState({
	      failed: result.failed
	    });
	
	    return result;
	  };
	
	  Form.prototype.scrollToFailed = function scrollToFailed(failed) {
	    var scrollingContainerRef = this.props.scrollingContainerRef;
	
	
	    if (!scrollingContainerRef) {
	      return;
	    }
	
	    var failedKeys = Object.keys(failed);
	
	    if (failedKeys == 0) {
	      return; // everything's good no need to scroll
	    }
	
	    var firstKey = failedKeys[0];
	
	    var targetInput = _reactDom2.default.findDOMNode(this.formFieldRefs[firstKey]); // find the first input's DOM node with its ref
	
	    var offsetTop = targetInput.getBoundingClientRect().top; // get the offset top of the input
	
	    var containerRef = _reactDom2.default.findDOMNode(scrollingContainerRef);
	
	    containerRef.scrollTop = offsetTop;
	  };
	
	  Form.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props2 = this.props,
	        title = _props2.title,
	        _props2$formStyle = _props2.formStyle,
	        formStyle = _props2$formStyle === undefined ? 'inline' : _props2$formStyle;
	    var _state = this.state,
	        schema = _state.schema,
	        failed = _state.failed;
	
	
	    var formData = this.formData;
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('Form', formStyle) },
	      title && _react2.default.createElement(
	        'h3',
	        null,
	        title
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'fields' },
	        schema.map(function (item, key) {
	          var fieldData = void 0;
	          var name = item.name;
	
	          fieldData = _objectPath2.default.get(formData, name);
	
	          if (typeof item.inputTransform === 'function') {
	            fieldData = item.inputTransform(fieldData, formData);
	          }
	
	          return _react2.default.createElement(_Field2.default, {
	            fields: fields,
	            item: item,
	            failed: failed[name],
	            fieldData: fieldData,
	            formData: formData,
	            onChange: _this3.onChange,
	            formStyle: formStyle,
	            key: key,
	            ref: function ref(r) {
	              if (r) {
	                _this3.formFieldRefs[name] = r;
	              }
	            }
	          });
	        })
	      )
	    );
	  };
	
	  return Form;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = Form;
	module.exports = exports['default'];

/***/ },

/***/ "89wR":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <Field
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getDefaultErrorMessages = __webpack_require__("ns2g");
	
	var _getDefaultErrorMessages2 = _interopRequireDefault(_getDefaultErrorMessages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Field = (_temp = _class = function (_React$Component) {
	  _inherits(Field, _React$Component);
	
	  function Field(props) {
	    _classCallCheck(this, Field);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.renderField = _this.renderField.bind(_this);
	    return _this;
	  }
	
	  Field.prototype.componentWillMount = function componentWillMount() {};
	
	  Field.prototype.onChange = function onChange(data) {
	    var _props = this.props,
	        item = _props.item,
	        onChange = _props.onChange,
	        formData = _props.formData;
	
	
	    if (typeof item.outputTransform === 'function') {
	      data = item.outputTransform(data, formData);
	    }
	
	    onChange(item.name, data);
	  };
	
	  Field.prototype.renderField = function renderField() {
	    var _this2 = this;
	
	    var fields = this.props.fields;
	    var _props$item = this.props.item,
	        type = _props$item.type,
	        placeholder = _props$item.placeholder,
	        options = _props$item.options,
	        defaultValue = _props$item.defaultValue,
	        disabled = _props$item.disabled,
	        hidden = _props$item.hidden,
	        currency = _props$item.currency,
	        mode = _props$item.mode,
	        maxLength = _props$item.maxLength,
	        rows = _props$item.rows,
	        direction = _props$item.direction,
	        content = _props$item.content,
	        fixValue = _props$item.fixValue,
	        hasEndDate = _props$item.hasEndDate,
	        allowNegative = _props$item.allowNegative;
	
	
	    var value = void 0;
	    if (typeof this.props.fieldData === 'undefined') {
	      value = defaultValue;
	    } else {
	      value = this.props.fieldData;
	    }
	
	    switch (type) {
	      case "text":
	        {
	          return _react2.default.createElement('input', { type: hidden ? 'hidden' : 'text', disabled: disabled, value: value, className: 'form-control', placeholder: placeholder, onChange: function onChange(e) {
	              _this2.onChange(e.target.value);
	            } });
	          break;
	        }
	
	      case "number":
	        {
	          return _react2.default.createElement('input', { type: hidden ? 'hidden' : 'number', value: value, className: 'form-control', placeholder: placeholder, onChange: function onChange(e) {
	              _this2.onChange(e.target.value);
	            } });
	          break;
	        }
	
	      case "email":
	        {
	          return _react2.default.createElement(fields.Email, { type: 'email', value: value || "", className: 'form-control', placeholder: placeholder, onChange: this.onChange });
	          break;
	        }
	
	      case "password":
	        {
	          return _react2.default.createElement('input', { type: 'password', value: value || "", className: 'form-control', placeholder: placeholder, onChange: function onChange(e) {
	              _this2.onChange(e.target.value);
	            } });
	          break;
	        }
	
	      case "money":
	        {
	          return _react2.default.createElement(fields.Money, { hidden: hidden, disabled: disabled, currency: currency, value: value || fixValue, allowNegative: allowNegative, className: 'form-control', placeholder: placeholder, onChange: function onChange(value) {
	              _this2.onChange(value);
	            } });
	          break;
	        }
	
	      case "textarea":
	        {
	          return _react2.default.createElement(fields.Textarea, { value: value, className: 'form-control', placeholder: placeholder, onChange: function onChange(value) {
	              _this2.onChange(value);
	            }, maxlength: maxLength, rows: rows });
	          break;
	        }
	
	      case "checkbox":
	        {
	          return _react2.default.createElement(
	            'label',
	            { className: (0, _classnames2.default)('control') },
	            _react2.default.createElement('input', { type: 'checkbox', checked: value, value: value, disabled: disabled, onChange: function onChange(e) {
	                _this2.onChange(value !== true);
	              } }),
	            _react2.default.createElement('span', { className: 'checkmark' }),
	            placeholder
	          );
	          break;
	        }
	
	      case "radio":
	        {
	          return _react2.default.createElement(fields.Radio, { onChange: this.onChange, value: value, options: options });
	          break;
	        }
	
	      case 'custom':
	        {
	          var component = this.props.item.component;
	
	
	          return component(value, this.onChange, this.props.item, this.props);
	
	          break;
	        }
	
	      case "gender":
	        {
	          return _react2.default.createElement(fields.Gender, { onChange: this.onChange, value: value });
	          break;
	        }
	
	      case "datePicker":
	        {
	          return _react2.default.createElement(fields.DatePicker, { onChange: this.onChange, value: value, hasEndDate: hasEndDate });
	          break;
	        }
	
	      case "dateTime":
	        {
	          return _react2.default.createElement(fields.DateTime, { onChange: this.onChange, value: value });
	          break;
	        }
	
	      case 'timepicker':
	        {
	          return _react2.default.createElement(fields.TimePicker2, { onChange: this.onChange, value: value });
	        }
	      case "address":
	        {
	          return _react2.default.createElement(fields.Address, { onChange: this.onChange, value: value || {} });
	          break;
	        }
	
	      case "classBillingMethod":
	        {
	          return _react2.default.createElement(fields.ClassBillingMethod, { onChange: this.onChange, value: value || {}, mode: mode });
	          break;
	        }
	
	      case "selectTeacher":
	        {
	          return _react2.default.createElement(fields.SelectTeacher, { onChange: this.onChange, value: value, options: options });
	          break;
	        }
	
	      case "selectStudent":
	        {
	          return _react2.default.createElement(fields.SelectStudent, { onChange: this.onChange, value: value, options: options, disabled: disabled });
	          break;
	        }
	
	      case 'select':
	        {
	          return _react2.default.createElement(
	            'select',
	            { className: 'form-control', value: value, disabled: disabled, onChange: function onChange(e) {
	                _this2.onChange(e.target.value);
	              } },
	            options && options.map(function (_ref, key) {
	              var label = _ref.label,
	                  value = _ref.value,
	                  disable = _ref.disable;
	
	              return _react2.default.createElement(
	                'option',
	                { key: key, value: value, disabled: disable, defaultValue: !disable },
	                label
	              );
	            })
	          );
	          break;
	        }
	
	      case 'name':
	        {
	          return _react2.default.createElement(fields.Name, { value: value, onChange: this.onChange });
	          break;
	        }
	
	      case 'openhours':
	        {
	          return _react2.default.createElement(fields.Openhours, { value: value, onChange: this.onChange });
	          break;
	        }
	
	      case 'agelimit':
	        {
	          return _react2.default.createElement(fields.Agelimit, { value: value, onChange: this.onChange });
	          break;
	        }
	
	      case 'guardian':
	        {
	          return _react2.default.createElement(fields.Guardian, { value: value || {}, onChange: this.onChange });
	          break;
	        }
	
	      case 'imageUploader':
	        {
	          return _react2.default.createElement(fields.ImageUploader, { value: value || {}, onChange: this.onChange, options: options });
	          break;
	        }
	
	      case 'mediaCenter':
	        {
	          var selectMultiple = this.props.item.selectMultiple;
	
	
	          if (typeof selectMultiple == 'undefined') {
	            throw new Error('selectMultiple is required.');
	          }
	
	          return _react2.default.createElement(fields.MediaCenter, { value: value || {}, onChange: this.onChange, selectMultiple: selectMultiple });
	          break;
	        }
	
	      case "phone":
	        {
	          return _react2.default.createElement(fields.ReactPhoneInput, {
	            defaultCountry: 'ca'
	            // onlyCountries={['ca', 'us']}
	            , value: value,
	            className: 'form-control',
	            onChange: function onChange(number) {
	              _this2.onChange(number);
	            }
	          });
	          break;
	        }
	
	      case "objectArray":
	        {
	          var objectSchema = this.props.item.objectSchema;
	
	
	          return _react2.default.createElement(fields.ObjectArray, {
	            onChange: this.onChange,
	            objectSchema: objectSchema,
	            value: value
	          });
	          break;
	        }
	
	      case "reactSearch":
	        {
	          return _react2.default.createElement(fields.ReactSelect, {
	            value: value || {},
	            onChange: this.onChange,
	            options: options,
	            disabled: disabled,
	            direction: direction
	          });
	          break;
	        }
	      case 'weekdateSelect':
	        {
	          return _react2.default.createElement(fields.WeekdateSelect, { onChange: this.onChange, value: value || [] });
	        }
	      case "customContent":
	        {
	          return content;
	          break;
	        }
	
	    }
	  };
	
	  Field.prototype.render = function render() {
	    var _props$item2 = this.props.item,
	        label = _props$item2.label,
	        type = _props$item2.type,
	        required = _props$item2.required,
	        className = _props$item2.className,
	        _props$item2$fieldSty = _props$item2.fieldStyle,
	        fieldStyle = _props$item2$fieldSty === undefined ? 'outline' : _props$item2$fieldSty,
	        tip = _props$item2.tip,
	        hidden = _props$item2.hidden;
	    var _props2 = this.props,
	        failed = _props2.failed,
	        formStyle = _props2.formStyle;
	
	
	    var errorMessage = void 0;
	    var hasError = void 0;
	
	    if (failed && Array.isArray(failed.because) && failed.because.length > 0) {
	      hasError = true;
	      errorMessage = (0, _getDefaultErrorMessages2.default)(failed.because[0]);
	    }
	
	    var hasNoLabel = typeof label === "undefined";
	
	    var fieldClassName = (0, _classnames2.default)('Field form-group', className, 'form-type-' + type, 'field-style-' + fieldStyle, { hasError: hasError, hasNoLabel: hasNoLabel });
	
	    if (formStyle === 'inline') {
	      return _react2.default.createElement(
	        'div',
	        null,
	        !hidden && _react2.default.createElement(
	          'div',
	          { className: fieldClassName },
	          !hasNoLabel && !hidden && _react2.default.createElement(
	            'label',
	            { className: 'col-sm-3 control-label' },
	            label,
	            required && _react2.default.createElement(
	              'span',
	              { className: 'ast' },
	              '*'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-9' },
	            _react2.default.createElement(
	              'div',
	              { className: 'control-input' },
	              this.renderField(),
	              hasError && !hidden && _react2.default.createElement(
	                'div',
	                { className: 'errorMsg' },
	                errorMessage
	              )
	            ),
	            typeof tip !== 'undefined' && _react2.default.createElement(
	              'div',
	              { className: 'tip' },
	              tip
	            )
	          )
	        )
	      );
	    } else if (formStyle === 'outline') {
	      return _react2.default.createElement(
	        'div',
	        null,
	        !hidden && _react2.default.createElement(
	          'div',
	          { className: fieldClassName },
	          !hasNoLabel && !hidden && _react2.default.createElement(
	            'label',
	            { className: 'control-label' },
	            label,
	            required && _react2.default.createElement(
	              'span',
	              { className: 'ast' },
	              '*'
	            )
	          ),
	          !hidden && _react2.default.createElement(
	            'div',
	            { className: 'control-input' },
	            this.renderField(),
	            hasError && !hidden && _react2.default.createElement(
	              'div',
	              { className: 'errorMsg' },
	              errorMessage
	            )
	          ),
	          typeof tip !== 'undefined' && _react2.default.createElement(
	            'div',
	            { className: 'tip' },
	            tip
	          )
	        )
	      );
	    }
	  };
	
	  return Field;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = Field;
	module.exports = exports['default'];

/***/ },

/***/ "ns2g":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _locale = __webpack_require__("kjsl");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (name) {
	  var msgs = {
	    "required": __('This field is required', _locale2.default),
	    "invalid_email": __('Please enter a valid email', _locale2.default),
	    "invalid_phone": __('Please enter a valid phone number', _locale2.default)
	  };
	
	  return msgs[name];
	};
	
	module.exports = exports['default'];

/***/ },

/***/ "kjsl":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'Form',
	  code: 'CN',
	  text: {
	    "This field is required": "此项为必填项",
	    "Please enter a valid email": "请输入正确的邮件地址",
	    "Please enter a valid phone number": "请输入正确的电话号码"
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "hfh4":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _locale = __webpack_require__("kjsl");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return {
	    firstName: {
	      presetType: 'firstName',
	      type: "text",
	      label: __('First Name', _locale2.default),
	      name: "first_name"
	    },
	
	    lastName: {
	      presetType: 'lastName',
	      type: "text",
	      label: __('Last Name', _locale2.default),
	      name: "last_name"
	    },
	
	    DOB: {
	      presetType: 'DOB',
	      label: __('DOB', _locale2.default),
	      type: "datePicker",
	      name: "dob"
	      // beforeOnChange: ()=>{ }
	    },
	
	    gender: {
	      presetType: 'gender',
	      label: __('Gender', _locale2.default),
	      type: "gender",
	      name: "gender"
	    },
	
	    address: {
	      presetType: 'address',
	      label: __('Address', _locale2.default),
	      type: "address",
	      name: "address"
	    }
	
	  };
	};
	
	module.exports = exports['default'];

/***/ },

/***/ "uvnf":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <DatePicker />
	                    *
	                    * @parent anybody
	                    * @stateful
	                    */
	
	
	exports.validateDatePicker = validateDatePicker;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDatepicker = __webpack_require__("rAVN");
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__("V/K8");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__("Hzm1");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_DATE = 'YYYY-MM-DD';
	
	function validateDatePicker(selected) {
	
	  if (selected) {
	    return {
	      ok: false,
	      failed: {
	        because: ['required']
	      }
	    };
	  }
	}
	
	var ThisDatePicker = (_temp = _class = function (_React$Component) {
	  _inherits(ThisDatePicker, _React$Component);
	
	  function ThisDatePicker(props) {
	    _classCallCheck(this, ThisDatePicker);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ThisDatePicker.prototype.render = function render() {
	    var _props = this.props,
	        value = _props.value,
	        onChange = _props.onChange,
	        _props$dateFormat = _props.dateFormat,
	        dateFormat = _props$dateFormat === undefined ? DEFAULT_DATE : _props$dateFormat,
	        _props$placeholderTex = _props.placeholderText,
	        placeholderText = _props$placeholderTex === undefined ? DEFAULT_DATE : _props$placeholderTex,
	        className = _props.className,
	        _props$hasEndDate = _props.hasEndDate,
	        hasEndDate = _props$hasEndDate === undefined ? true : _props$hasEndDate;
	
	
	    var selected = void 0;
	
	    if (value instanceof _moment2.default) {
	      selected = value;
	    } else if (typeof value === 'string' && value.length > 0) {
	      selected = (0, _moment2.default)(value, dateFormat);
	    } else {
	      selected = value;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'date-picker' },
	      _react2.default.createElement(_reactDatepicker2.default, {
	        className: (0, _classnames2.default)('form-control ' + className),
	        selected: selected,
	        onChange: onChange,
	        dateFormat: dateFormat,
	        showMonthDropdown: true,
	        placeholderText: placeholderText,
	        showYearDropdown: true,
	        maxDate: hasEndDate ? (0, _moment2.default)() : '',
	        yearDropdownItemNumber: 50,
	        scrollableYearDropdown: true })
	    );
	  };
	
	  return ThisDatePicker;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = ThisDatePicker;

/***/ },

/***/ "Hzm1":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"date-picker":"date-picker","react-datepicker-wrapper":"react-datepicker-wrapper","react-datepicker__input-container":"react-datepicker__input-container","react-datepicker":"react-datepicker","react-datepicker__header":"react-datepicker__header","react-datepicker__month":"react-datepicker__month","react-datepicker__day-name":"react-datepicker__day-name","react-datepicker__day":"react-datepicker__day","react-datepicker__current-month":"react-datepicker__current-month","react-datepicker__navigation":"react-datepicker__navigation","react-datepicker__navigation--previous":"react-datepicker__navigation--previous","react-datepicker__navigation--next":"react-datepicker__navigation--next","react-datepicker__navigation--years-upcoming":"react-datepicker__navigation--years-upcoming","react-datepicker__navigation--years-previous":"react-datepicker__navigation--years-previous","react-datepicker__year-option":"react-datepicker__year-option"};

/***/ },

/***/ "yUzp":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("l1S7");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GENDERS = ['male', 'female', 'other', 'n/a'];
	
	var Gender = function (_React$Component) {
	  _inherits(Gender, _React$Component);
	
	  function Gender(props) {
	    _classCallCheck(this, Gender);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  Gender.prototype.onChange = function onChange(e) {
	    this.props.onChange(e.target.value, GENDERS.indexOf(e.target.value));
	  };
	
	  Gender.prototype.render = function render() {
	    var _props = this.props,
	        value = _props.value,
	        label = _props.label,
	        className = _props.className;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'row gender-radio ' + className },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-xs-4' },
	        _react2.default.createElement(
	          'div',
	          { className: 'radio' },
	          _react2.default.createElement(
	            'label',
	            { className: 'control' },
	            _react2.default.createElement('input', { type: 'radio', value: 'male', onChange: this.onChange, checked: value === 'male' || value === 0 }),
	            _react2.default.createElement('span', { className: 'radiomark' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'radio-gender' },
	              __('Male', 'teacher')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-xs-4' },
	        _react2.default.createElement(
	          'div',
	          { className: 'radio' },
	          _react2.default.createElement(
	            'label',
	            { className: 'control' },
	            _react2.default.createElement('input', {
	              type: 'radio',
	              value: 'female',
	              onChange: this.onChange,
	              checked: value === 'female' || value === 1
	            }),
	            _react2.default.createElement('span', { className: 'radiomark' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'radio-gender' },
	              __('Female', 'teacher')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-xs-4' },
	        _react2.default.createElement(
	          'div',
	          { className: 'radio' },
	          _react2.default.createElement(
	            'label',
	            { className: 'control' },
	            _react2.default.createElement('input', {
	              type: 'radio',
	              value: 'n/a',
	              onChange: this.onChange,
	              checked: value === 'n/a' || value === 3
	            }),
	            _react2.default.createElement('span', { className: 'radiomark' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'radio-gender' },
	              __('N/A', 'teacher')
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Gender;
	}(_react2.default.Component);
	
	exports.default = Gender;
	module.exports = exports['default'];

/***/ },

/***/ "l1S7":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"gender-radio":"gender-radio","radio":"radio","radio-gender":"radio-gender"};

/***/ },

/***/ "fVu1":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.validateClassBillingMethod = validateClassBillingMethod;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Money = __webpack_require__("7bpD");
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _locale = __webpack_require__("3srw");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("044t");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function validateClassBillingMethod(_ref) {
	  var feeType = _ref.feeType,
	      consumption_type = _ref.consumption_type,
	      totalPrice = _ref.totalPrice,
	      unitPrice = _ref.unitPrice;
	
	  // mind fucked validation, sometimes feeType is a number, sometimes it's string......kill me now
	
	  // if feetype is "term"
	  if (feeType == 0) {
	    // and if there's no consumption_type or !totalPrice, it should failed validation
	    if (!consumption_type || !totalPrice) {
	      return {
	        ok: false,
	        failed: {
	          because: ['required']
	        }
	        // if consumption_type is not "term/ one fixed rate" and there's no unitPrice, it should also failed
	      };
	    } else if (consumption_type != 3 && !unitPrice) {
	      return {
	        ok: false,
	        failed: {
	          because: ['required']
	        }
	      };
	    }
	    // if feeType is not "term"
	  } else if (feeType != 0) {
	    // and if there is no unitPrice, it should failed
	    if (!unitPrice) {
	      return {
	        ok: false,
	        failed: {
	          because: ['required']
	        }
	      };
	    }
	  }
	}
	
	var ClassBillingMethod = function (_Component) {
	  _inherits(ClassBillingMethod, _Component);
	
	  function ClassBillingMethod(props) {
	    _classCallCheck(this, ClassBillingMethod);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  ClassBillingMethod.prototype.onChange = function onChange(itemName, itemValue) {
	    var _extends2;
	
	    var _props = this.props,
	        value = _props.value,
	        onChange = _props.onChange;
	
	
	    onChange(_extends({}, value, (_extends2 = {}, _extends2[itemName] = itemValue, _extends2)), itemName);
	  };
	
	  ClassBillingMethod.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props2 = this.props,
	        value = _props2.value,
	        mode = _props2.mode;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'billing-method-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row', style: { marginBottom: '10px' } },
	        _react2.default.createElement(_Money2.default, {
	          onChange: function onChange(e) {
	            value.feeType == 0 ? _this2.onChange('totalPrice', e) : _this2.onChange('unitPrice', e);
	          },
	          className: 'col-xs-8',
	          value: value.feeType == 0 ? value.totalPrice : value.unitPrice
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-4' },
	          _react2.default.createElement(
	            'select',
	            {
	              className: 'form-control',
	              onChange: function onChange(e) {
	                _this2.onChange('feeType', e.target.value);
	              },
	              value: value.feeType,
	              disabled: mode == 'update' ? true : false
	            },
	            _react2.default.createElement(
	              'option',
	              { value: '1' },
	              __('By lessons', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: '2' },
	              __('By hours', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: '0' },
	              __('By terms', _locale2.default)
	            )
	          )
	        )
	      ),
	      value.feeType == 0 && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-6' },
	            _react2.default.createElement(
	              'label',
	              { className: 'control' },
	              _react2.default.createElement('input', {
	                id: 'none',
	                type: 'radio',
	                className: 'radio',
	                value: '3',
	                onChange: function onChange(e) {
	                  _this2.onChange('consumption_type', e.target.value);
	                },
	                checked: value.consumption_type == 3 ? 'checked' : ''
	              }),
	              _react2.default.createElement('span', { className: 'radiomark' }),
	              __('None', _locale2.default)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-4' },
	            _react2.default.createElement(
	              'label',
	              { className: 'control' },
	              _react2.default.createElement('input', {
	                id: 'lessonRate',
	                type: 'radio',
	                className: 'radio',
	                value: '1',
	                onChange: function onChange(e) {
	                  _this2.onChange('consumption_type', e.target.value);
	                },
	                checked: value.consumption_type == 1 ? 'checked' : ''
	              }),
	              _react2.default.createElement('span', { className: 'radiomark' }),
	              __('Lesson rate', _locale2.default)
	            )
	          ),
	          value.consumption_type == 1 && _react2.default.createElement(_Money2.default, {
	            onChange: function onChange(e) {
	              _this2.onChange('unitPrice', e);
	            },
	            className: 'col-xs-8',
	            value: value.unitPrice
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-4' },
	            _react2.default.createElement(
	              'label',
	              { className: 'control' },
	              _react2.default.createElement('input', {
	                id: 'hourRate',
	                type: 'radio',
	                className: 'radio',
	                value: '2',
	                onChange: function onChange(e) {
	                  _this2.onChange('consumption_type', e.target.value);
	                },
	                checked: value.consumption_type == 2 ? 'checked' : ''
	              }),
	              _react2.default.createElement('span', { className: 'radiomark' }),
	              __('Hour rate', _locale2.default)
	            )
	          ),
	          value.consumption_type == 2 && _react2.default.createElement(_Money2.default, {
	            onChange: function onChange(e) {
	              _this2.onChange('unitPrice', e);
	            },
	            className: 'col-xs-8',
	            value: value.unitPrice
	          })
	        )
	      ),
	      value.feeType == 1 && _react2.default.createElement(
	        'p',
	        null,
	        __('Classes are charged at the price of each lessons and are calculated for consumption according to lessons used.', _locale2.default)
	      ),
	      value.feeType == 2 && _react2.default.createElement(
	        'p',
	        null,
	        __('Classes are charged at the price of each class hours and are calculated for consumption according to class hours used.', _locale2.default)
	      ),
	      value.feeType == 0 && value.consumption_type == 1 && _react2.default.createElement(
	        'p',
	        null,
	        __('Classes are charged at the price of each term and are calculated for consumption according to lessons used.', _locale2.default)
	      ),
	      value.feeType == 0 && value.consumption_type == 2 && _react2.default.createElement(
	        'p',
	        null,
	        __('Classes are charged at the price of each term and are calculated for consumption according to class hours used.', _locale2.default)
	      ),
	      value.feeType == 0 && value.consumption_type == 3 && _react2.default.createElement(
	        'p',
	        null,
	        __('Classes are charged at the price of each term and are calculated for consumption after the fee is paid.', _locale2.default)
	      )
	    );
	  };
	
	  return ClassBillingMethod;
	}(_react.Component);
	
	exports.default = ClassBillingMethod;

/***/ },

/***/ "3srw":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _text;
	
	exports.default = {
	  id: 'ClassBillingMethod',
	  code: 'CN',
	  text: (_text = {
	    'By hours': '每课时',
	    'By lessons': '每课节',
	    'By terms': '每课期',
	    '': '课程按课期总价收费 并且按课时计算消耗',
	    'None': '无单价',
	    'Lesson rate': '课程单价',
	    'Hour rate': '课时单价',
	    'Classes are charged at the price of each term and are calculated for consumption according to class hours used.': '班级将按课期总价收费，并且按上课时计算消耗。',
	    'Classes are charged at the price of each term and are calculated for consumption according to lessons used.': '班级将按课期总价收费，并且按已上课节计算消耗。',
	    'Classes are charged at the price of each term and are calculated for consumption after the fee is paid.': '班级将按课期总价收费，并且在缴费时计算消耗。',
	    'Classes are charged at the price of each class hours and are calculated for consumption according to class hours used.': '班级将按课时单价收费，并且按已上课时计算消耗。',
	    'Classes are charged at the price of each lessons and are calculated for consumption according to lessons used.': '班级将按课节单价收费，并且按已上课节计算消耗。'
	  }, _text[''] = '', _text)
	};
	module.exports = exports['default'];

/***/ },

/***/ "044t":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"form-type-classBillingMethod":"form-type-classBillingMethod","hasError":"hasError","row":"row","billing-method-container":"billing-method-container","radio":"radio"};

/***/ },

/***/ "f+Wu":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("lj70");
	
	__webpack_require__("DTuZ");
	
	var _reactDates = __webpack_require__("OjkW");
	
	__webpack_require__("DeHz");
	
	var _TimePicker = __webpack_require__("ryd0");
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__("7rIE");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <DateTime
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * A custom wrapper for singleDatePicker and time picker
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var DateTime = function (_React$Component) {
	  _inherits(DateTime, _React$Component);
	
	  function DateTime(props) {
	    _classCallCheck(this, DateTime);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onDateChange = _this.onDateChange.bind(_this);
	    _this.onTimeChange = _this.onTimeChange.bind(_this);
	
	    _this.state = {};
	
	    if (props.value) {
	      _this.state.date = (0, _moment2.default)(props.value).format(_constants.DATE_FORMAT);
	      _this.state.time = (0, _moment2.default)(props.value).format(_constants.TIME_FORMAT);
	    }
	    return _this;
	  }
	
	  DateTime.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	
	    if (typeof nextProps.value === 'string') {
	      this.setState({
	        date: (0, _moment2.default)(nextProps.value).format(_constants.DATE_FORMAT),
	        time: (0, _moment2.default)(nextProps.value).format(_constants.TIME_FORMAT)
	      });
	    }
	  };
	
	  DateTime.prototype.onDateChange = function onDateChange(momentDate) {
	    var _this2 = this;
	
	    var date = momentDate.format(_constants.DATE_FORMAT);
	
	    var time = this.state.time;
	
	
	    if (!time) {
	      time = "12:00";
	    }
	
	    this.setState({
	      date: date,
	      time: time
	    }, function () {
	
	      if (date && time) {
	        _this2.props.onChange(date + ' ' + time);
	      }
	    });
	  };
	
	  DateTime.prototype.onTimeChange = function onTimeChange(momentTime) {
	    var _this3 = this;
	
	    var time = momentTime.format(_constants.TIME_FORMAT);
	
	    var date = this.state.date;
	
	
	    if (!date) {
	      date = (0, _moment2.default)().format(_constants.DATE_FORMAT);
	    }
	
	    this.setState({
	      date: date,
	      time: time
	    }, function () {
	
	      if (date && time) {
	        _this3.props.onChange(date + ' ' + time);
	      }
	    });
	  };
	
	  DateTime.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props = this.props,
	        options = _props.options,
	        placeholder = _props.placeholder,
	        displayFormat = _props.displayFormat,
	        disabled = _props.disabled;
	    var _state = this.state,
	        date = _state.date,
	        time = _state.time;
	
	
	    if (options) {
	      delete options.enumOptions;
	      delete options.emptyValue;
	    }
	
	    var dateToDisplay = date ? (0, _moment2.default)(date, _constants.DATE_FORMAT) : undefined;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'DateTime' },
	      _react2.default.createElement(
	        'div',
	        { className: 'DatePicker form-input' },
	        _react2.default.createElement(_reactDates.SingleDatePicker, _extends({
	          placeholder: placeholder || _constants.DEFAULT_DATE_PLACEHOLDER,
	          displayFormat: displayFormat || _constants.DATE_FORMAT,
	          numberOfMonths: 1,
	          small: true,
	          date: dateToDisplay,
	          onDateChange: this.onDateChange // PropTypes.func.isRequired
	          , focused: this.state.focused // PropTypes.bool
	          , onFocusChange: function onFocusChange(_ref) {
	            var focused = _ref.focused;
	            return _this4.setState({ focused: focused });
	          } // PropTypes.func.isRequired
	          , isOutsideRange: function isOutsideRange() {
	            return false;
	          },
	          disabled: disabled || false
	        }, options))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'TimePicker form-input' },
	        _react2.default.createElement(_TimePicker2.default, { value: (0, _moment2.default)(time, _constants.TIME_FORMAT), onChange: this.onTimeChange })
	      )
	    );
	  };
	
	  return DateTime;
	}(_react2.default.Component);
	
	exports.default = DateTime;
	module.exports = exports['default'];

/***/ },

/***/ "DeHz":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"DateTime":"DateTime","DatePicker":"DatePicker","TimePicker":"TimePicker"};

/***/ },

/***/ "GM/A":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.validatePhone = validatePhone;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("eUcS");
	
	var _countryCode = __webpack_require__("E07D");
	
	__webpack_require__("WFbx");
	
	var _isEmpty = __webpack_require__("lHK6");
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <PhoneNumber
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var DEFAULT_COUNTRY = 'ca'; // CA for Canada for now
	
	function validatePhone(value) {
	  if (value.length > 1 && value.length < 6) {
	    return {
	      ok: false,
	      failed: {
	        because: ['invalid_phone'],
	        value: value
	      }
	    };
	  }
	}
	
	var PhoneNumberInput = function (_React$Component) {
	  _inherits(PhoneNumberInput, _React$Component);
	
	  function PhoneNumberInput(props) {
	    _classCallCheck(this, PhoneNumberInput);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.countryCodes = (0, _countryCode.getCountryCodes)();
	
	    _this.onChangeCountry = _this.onChangeCountry.bind(_this);
	    _this.onChangeNumber = _this.onChangeNumber.bind(_this);
	    _this.toggleCountrySelect = _this.toggleCountrySelect.bind(_this);
	
	    _this.state = {
	      country: (0, _countryCode.getCountryCodeByISO)(props.defaultCountry || DEFAULT_COUNTRY)
	    };
	    return _this;
	  }
	
	  PhoneNumberInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!(0, _isEmpty2.default)(nextProps.value) && _typeof(nextProps.value) == 'object') {
	      if (nextProps.value.region_code && this.state.country.iso == nextProps.value.region_code.toLowerCase()) {
	        return;
	      }
	      var country = !nextProps.value.region_code ? (0, _countryCode.getCountryISO)(nextProps.value.country_code) : (0, _countryCode.getCountryCodeByISO)(nextProps.value.region_code.toLowerCase());
	      this.setState({ country: country });
	    }
	  };
	
	  PhoneNumberInput.prototype.convertNumber = function convertNumber() {
	    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var _value$country_code = value.country_code,
	        country_code = _value$country_code === undefined ? '' : _value$country_code,
	        _value$national_numbe = value.national_number,
	        national_number = _value$national_numbe === undefined ? '' : _value$national_numbe;
	
	
	    return '+' + country_code + ' ' + national_number;
	  };
	
	  PhoneNumberInput.prototype.toggleCountrySelect = function toggleCountrySelect(isOn) {
	    this.setState({
	      selectCountry: typeof isOn !== 'undefined' ? isOn : this.selectCountry !== true
	    });
	  };
	
	  PhoneNumberInput.prototype.onChangeCountry = function onChangeCountry(country) {
	    var _this2 = this;
	
	    return function () {
	      _this2.setState({ country: country });
	      _this2.toggleCountrySelect(false);
	      _this2.props.onChange({
	        national_number: '',
	        country_code: country.code,
	        region_code: country.iso
	      });
	
	      _this2.inputRef.focus();
	    };
	  };
	
	  PhoneNumberInput.prototype.onChangeNumber = function onChangeNumber(e) {
	    var value = e.target.value || "";
	
	    return this.formatChangeNumber(value);
	  };
	
	  PhoneNumberInput.prototype.formatChangeNumber = function formatChangeNumber(value) {
	    var _state$country = this.state.country,
	        code = _state$country.code,
	        iso = _state$country.iso;
	
	
	    this.props.onChange({
	      national_number: value.replace("+" + code, '').replace(/[^0-9]/g, '').trim(),
	      country_code: code.trim(),
	      region_code: iso
	    });
	  };
	
	  PhoneNumberInput.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        onChange = _props.onChange,
	        _props$value = _props.value,
	        value = _props$value === undefined ? {} : _props$value,
	        placeholder = _props.placeholder;
	    var _state = this.state,
	        country = _state.country,
	        selectCountry = _state.selectCountry;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'PhoneNumberInput' },
	      _react2.default.createElement('input', {
	        placeholder: placeholder,
	        className: 'form-control phone-number',
	        onChange: this.onChangeNumber,
	        value: this.convertNumber(value),
	        onFocus: function onFocus() {
	          _this3.toggleCountrySelect(false);
	        },
	        onBlur: function onBlur() {
	          _this3.toggleCountrySelect(false);
	        },
	        ref: function ref(r) {
	          _this3.inputRef = r;
	        }
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'PhoneNumberInput--holder f16', onClick: this.toggleCountrySelect },
	        _react2.default.createElement('div', { className: (0, _classnames2.default)('PhoneNumberInput--flag flag 0', country.iso) }),
	        _react2.default.createElement('i', { className: 'fa icon-down-dir' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('PhoneNumberInput--country-list', { selectCountry: selectCountry }) },
	        _react2.default.createElement(
	          'ul',
	          null,
	          this.countryCodes.map(function (c, index) {
	            return _react2.default.createElement(
	              'li',
	              { key: index, className: 'f16', onClick: _this3.onChangeCountry(c) },
	              _react2.default.createElement('div', { className: (0, _classnames2.default)('PhoneNumberInput--flag flag 1', c.iso) }),
	              _react2.default.createElement(
	                'div',
	                { className: 'name' },
	                c.name
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'code' },
	                '+',
	                c.code
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return PhoneNumberInput;
	}(_react2.default.Component);
	
	exports.default = PhoneNumberInput;

/***/ },

/***/ "eUcS":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PhoneNumberInput":"PhoneNumberInput","PhoneNumberInput--country-list":"PhoneNumberInput--country-list","selectCountry":"selectCountry","school-name-input":"school-name-input","PhoneNumberInput--holder":"PhoneNumberInput--holder","PhoneNumberInput--flag":"PhoneNumberInput--flag","name":"name","code":"code","register-phone":"register-phone"};

/***/ },

/***/ "E07D":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getCountryCodes = getCountryCodes;
	exports.getCountryISO = getCountryISO;
	exports.getCountryCodeByISO = getCountryCodeByISO;
	
	var _codes = __webpack_require__("k1Ru");
	
	var _codes2 = _interopRequireDefault(_codes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var newCodes = [];
	Object.keys(_codes2.default).map(function (code) {
	  _codes2.default[code].iso = code;
	  newCodes.push(_codes2.default[code]);
	});
	
	function getCountryCodes(only) {
	  if (!Array.isArray(only)) {
	    return newCodes;
	  }
	
	  var toReturn = [];
	
	  only.map(function (iso) {
	    if (_codes2.default[iso]) {
	      _codes2.default[iso].iso = iso;
	      toReturn.push(_codes2.default[iso]);
	    }
	  });
	
	  return toReturn;
	}
	
	function getCountryISO(num) {
	  var countryISO = void 0;
	  newCodes.map(function (code) {
	    if (code.code == num) {
	      countryISO = code;
	    }
	  });
	
	  return countryISO;
	}
	
	//
	// Return single country code object by iso code
	// 
	// @param {string} iso           - iso code such as UK, CA, US ...
	// @return {object} country      -
	// @return {string} country.name - full name of a country
	// @return {string} country.code - calling code of the country
	// @return {string} country.iso  - iso of the country.
	//
	function getCountryCodeByISO(iso) {
	
	  if (!_codes2.default[iso]) {
	    throw new Error('No country found by iso ' + iso);
	    return;
	  }
	
	  _codes2.default[iso].iso = iso;
	
	  return _codes2.default[iso];
	}

/***/ },

/***/ "k1Ru":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
	  // "Afghanistan": {
	  //   "name": "Afghanistan",
	  //   "code": "93"
	  // },
	  // "Albania": {
	  //   "name": "Albania",
	  //   "code": "355"
	  // },
	  // "Algeria": {
	  //   "name": "Algeria",
	  //   "code": "213"
	  // },
	  // "American Samoa": {
	  //   "name": "American Samoa",
	  //   "code": "1684"
	  // },
	  // "Andorra": {
	  //   "name": "Andorra",
	  //   "code": "376"
	  // },
	  // "Angola": {
	  //   "name": "Angola",
	  //   "code": "244"
	  // },
	  // "Anguilla": {
	  //   "name": "Anguilla",
	  //   "code": "1264"
	  // },
	  // "Antigua and Barbuda": {
	  //   "name": "Antigua and Barbuda",
	  //   "code": "1268"
	  // },
	  // "Argentina": {
	  //   "name": "Argentina",
	  //   "code": "54"
	  // },
	  // "Armenia": {
	  //   "name": "Armenia",
	  //   "code": "374"
	  // },
	  // "Aruba": {
	  //   "name": "Aruba",
	  //   "code": "297"
	  // },
	  // "Australia": {
	  //   "name": "Australia",
	  //   "code": "61"
	  // },
	  // "Austria": {
	  //   "name": "Austria",
	  //   "code": "43"
	  // },
	  // "Azerbaijan": {
	  //   "name": "Azerbaijan",
	  //   "code": "994"
	  // },
	  // "Bahamas": {
	  //   "name": "Bahamas",
	  //   "code": "1242"
	  // },
	  // "Bahrain": {
	  //   "name": "Bahrain",
	  //   "code": "973"
	  // },
	  // "Bangladesh": {
	  //   "name": "Bangladesh",
	  //   "code": "880"
	  // },
	  // "Barbados": {
	  //   "name": "Barbados",
	  //   "code": "1246"
	  // },
	  // "Belarus": {
	  //   "name": "Belarus",
	  //   "code": "375"
	  // },
	  // "Belgium": {
	  //   "name": "Belgium",
	  //   "code": "32"
	  // },
	  // "Belize": {
	  //   "name": "Belize",
	  //   "code": "501"
	  // },
	  // "Benin": {
	  //   "name": "Benin",
	  //   "code": "229"
	  // },
	  // "Bermuda": {
	  //   "name": "Bermuda",
	  //   "code": "1441"
	  // },
	  // "Bhutan": {
	  //   "name": "Bhutan",
	  //   "code": "975"
	  // },
	  // "Bolivia": {
	  //   "name": "Bolivia",
	  //   "code": "591"
	  // },
	  // "Bosnia and Herzegovina": {
	  //   "name": "Bosnia and Herzegovina",
	  //   "code": "387"
	  // },
	  // "Botswana": {
	  //   "name": "Botswana",
	  //   "code": "267"
	  // },
	  // "Brazil": {
	  //   "name": "Brazil",
	  //   "code": "55"
	  // },
	  // "British Indian Ocean Territory": {
	  //   "name": "British Indian Ocean Territory",
	  //   "code": "246"
	  // },
	  // "British Virgin Islands": {
	  //   "name": "British Virgin Islands",
	  //   "code": "1284"
	  // },
	  // "Brunei": {
	  //   "name": "Brunei",
	  //   "code": "673"
	  // },
	  // "Bulgaria": {
	  //   "name": "Bulgaria",
	  //   "code": "359"
	  // },
	  // "Burkina Faso": {
	  //   "name": "Burkina Faso",
	  //   "code": "226"
	  // },
	  // "Burundi": {
	  //   "name": "Burundi",
	  //   "code": "257"
	  // },
	  // "Cambodia": {
	  //   "name": "Cambodia",
	  //   "code": "855"
	  // },
	  // "Cameroon": {
	  //   "name": "Cameroon",
	  //   "code": "237"
	  // },
	  // "Canada": {
	  //   "name": "Canada",
	  //   "code": "1"
	  // },
	  // "Cape Verde": {
	  //   "name": "Cape Verde",
	  //   "code": "238"
	  // },
	  // "Caribbean Netherlands": {
	  //   "name": "Caribbean Netherlands",
	  //   "code": "599"
	  // },
	  // "Cayman Islands": {
	  //   "name": "Cayman Islands",
	  //   "code": "1345"
	  // },
	  // "Central African Republic": {
	  //   "name": "Central African Republic",
	  //   "code": "236"
	  // },
	  // "Chad": {
	  //   "name": "Chad",
	  //   "code": "235"
	  // },
	  // "Chile": {
	  //   "name": "Chile",
	  //   "code": "56"
	  // },
	  // "China": {
	  //   "name": "China",
	  //   "code": "86"
	  // },
	  // "Colombia": {
	  //   "name": "Colombia",
	  //   "code": "57"
	  // },
	  // "Comoros": {
	  //   "name": "Comoros",
	  //   "code": "269"
	  // },
	  // "Congo (DRC)": {
	  //   "name": "Congo (DRC)",
	  //   "code": "243"
	  // },
	  // "Congo (Republic)": {
	  //   "name": "Congo (Republic)",
	  //   "code": "242"
	  // },
	  // "Cook Islands": {
	  //   "name": "Cook Islands",
	  //   "code": "682"
	  // },
	  // "Costa Rica": {
	  //   "name": "Costa Rica",
	  //   "code": "506"
	  // },
	  // "CÃ´te dâ€™Ivoire": {
	  //   "name": "CÃ´te dâ€™Ivoire",
	  //   "code": "225"
	  // },
	  // "Croatia": {
	  //   "name": "Croatia",
	  //   "code": "385"
	  // },
	  // "Cuba": {
	  //   "name": "Cuba",
	  //   "code": "53"
	  // },
	  // "CuraÃ§ao": {
	  //   "name": "CuraÃ§ao",
	  //   "code": "599"
	  // },
	  // "Cyprus": {
	  //   "name": "Cyprus",
	  //   "code": "357"
	  // },
	  // "Czech Republic": {
	  //   "name": "Czech Republic",
	  //   "code": "420"
	  // },
	  // "Denmark": {
	  //   "name": "Denmark",
	  //   "code": "45"
	  // },
	  // "Djibouti": {
	  //   "name": "Djibouti",
	  //   "code": "253"
	  // },
	  // "Dominica": {
	  //   "name": "Dominica",
	  //   "code": "1767"
	  // },
	  // "Dominican Republic": {
	  //   "name": "Dominican Republic",
	  //   "code": "1"
	  // },
	  // "Ecuador": {
	  //   "name": "Ecuador",
	  //   "code": "593"
	  // },
	  // "Egypt": {
	  //   "name": "Egypt",
	  //   "code": "20"
	  // },
	  // "El Salvador": {
	  //   "name": "El Salvador",
	  //   "code": "503"
	  // },
	  // "Equatorial Guinea": {
	  //   "name": "Equatorial Guinea",
	  //   "code": "240"
	  // },
	  // "Eritrea": {
	  //   "name": "Eritrea",
	  //   "code": "291"
	  // },
	  // "Estonia": {
	  //   "name": "Estonia",
	  //   "code": "372"
	  // },
	  // "Ethiopia": {
	  //   "name": "Ethiopia",
	  //   "code": "251"
	  // },
	  // "Falkland Islands": {
	  //   "name": "Falkland Islands",
	  //   "code": "500"
	  // },
	  // "Faroe Islands": {
	  //   "name": "Faroe Islands",
	  //   "code": "298"
	  // },
	  // "Fiji": {
	  //   "name": "Fiji",
	  //   "code": "679"
	  // },
	  // "Finland": {
	  //   "name": "Finland",
	  //   "code": "358"
	  // },
	  // "France": {
	  //   "name": "France",
	  //   "code": "33"
	  // },
	  // "French Guiana": {
	  //   "name": "French Guiana",
	  //   "code": "594"
	  // },
	  // "French Polynesia": {
	  //   "name": "French Polynesia",
	  //   "code": "689"
	  // },
	  // "Gabon": {
	  //   "name": "Gabon",
	  //   "code": "241"
	  // },
	  // "Gambia": {
	  //   "name": "Gambia",
	  //   "code": "220"
	  // },
	  // "Georgia": {
	  //   "name": "Georgia",
	  //   "code": "995"
	  // },
	  // "Germany": {
	  //   "name": "Germany",
	  //   "code": "49"
	  // },
	  // "Ghana": {
	  //   "name": "Ghana",
	  //   "code": "233"
	  // },
	  // "Gibraltar": {
	  //   "name": "Gibraltar",
	  //   "code": "350"
	  // },
	  // "Greece": {
	  //   "name": "Greece",
	  //   "code": "30"
	  // },
	  // "Greenland": {
	  //   "name": "Greenland",
	  //   "code": "299"
	  // },
	  // "Grenada": {
	  //   "name": "Grenada",
	  //   "code": "1473"
	  // },
	  // "Guadeloupe": {
	  //   "name": "Guadeloupe",
	  //   "code": "590"
	  // },
	  // "Guam": {
	  //   "name": "Guam",
	  //   "code": "1671"
	  // },
	  // "Guatemala": {
	  //   "name": "Guatemala",
	  //   "code": "502"
	  // },
	  // "Guinea": {
	  //   "name": "Guinea",
	  //   "code": "224"
	  // },
	  // "Guinea-Bissau": {
	  //   "name": "Guinea-Bissau",
	  //   "code": "245"
	  // },
	  // "Guyana": {
	  //   "name": "Guyana",
	  //   "code": "592"
	  // },
	  // "Haiti": {
	  //   "name": "Haiti",
	  //   "code": "509"
	  // },
	  // "Honduras": {
	  //   "name": "Honduras",
	  //   "code": "504"
	  // },
	  // "Hong Kong": {
	  //   "name": "Hong Kong",
	  //   "code": "852"
	  // },
	  // "Hungary": {
	  //   "name": "Hungary",
	  //   "code": "36"
	  // },
	  // "Iceland": {
	  //   "name": "Iceland",
	  //   "code": "354"
	  // },
	  // "India": {
	  //   "name": "India",
	  //   "code": "91"
	  // },
	  // "Indonesia": {
	  //   "name": "Indonesia",
	  //   "code": "62"
	  // },
	  // "Iran": {
	  //   "name": "Iran",
	  //   "code": "98"
	  // },
	  // "Iraq": {
	  //   "name": "Iraq",
	  //   "code": "964"
	  // },
	  // "Ireland": {
	  //   "name": "Ireland",
	  //   "code": "353"
	  // },
	  // "Israel": {
	  //   "name": "Israel",
	  //   "code": "972"
	  // },
	  // "Italy": {
	  //   "name": "Italy",
	  //   "code": "39"
	  // },
	  // "Jamaica": {
	  //   "name": "Jamaica",
	  //   "code": "1876"
	  // },
	  // "Japan": {
	  //   "name": "Japan",
	  //   "code": "81"
	  // },
	  // "Jordan": {
	  //   "name": "Jordan",
	  //   "code": "962"
	  // },
	  // "Kazakhstan": {
	  //   "name": "Kazakhstan",
	  //   "code": "7"
	  // },
	  // "Kenya": {
	  //   "name": "Kenya",
	  //   "code": "254"
	  // },
	  // "Kiribati": {
	  //   "name": "Kiribati",
	  //   "code": "686"
	  // },
	  // "Kuwait": {
	  //   "name": "Kuwait",
	  //   "code": "965"
	  // },
	  // "Kyrgyzstan": {
	  //   "name": "Kyrgyzstan",
	  //   "code": "996"
	  // },
	  // "Laos": {
	  //   "name": "Laos",
	  //   "code": "856"
	  // },
	  // "Latvia": {
	  //   "name": "Latvia",
	  //   "code": "371"
	  // },
	  // "Lebanon": {
	  //   "name": "Lebanon",
	  //   "code": "961"
	  // },
	  // "Lesotho": {
	  //   "name": "Lesotho",
	  //   "code": "266"
	  // },
	  // "Liberia": {
	  //   "name": "Liberia",
	  //   "code": "231"
	  // },
	  // "Libya": {
	  //   "name": "Libya",
	  //   "code": "218"
	  // },
	  // "Liechtenstein": {
	  //   "name": "Liechtenstein",
	  //   "code": "423"
	  // },
	  // "Lithuania": {
	  //   "name": "Lithuania",
	  //   "code": "370"
	  // },
	  // "Luxembourg": {
	  //   "name": "Luxembourg",
	  //   "code": "352"
	  // },
	  // "Macau": {
	  //   "name": "Macau",
	  //   "code": "853"
	  // },
	  // "Macedonia": {
	  //   "name": "Macedonia",
	  //   "code": "389"
	  // },
	  // "Madagascar": {
	  //   "name": "Madagascar",
	  //   "code": "261"
	  // },
	  // "Malawi": {
	  //   "name": "Malawi",
	  //   "code": "265"
	  // },
	  // "Malaysia": {
	  //   "name": "Malaysia",
	  //   "code": "60"
	  // },
	  // "Maldives": {
	  //   "name": "Maldives",
	  //   "code": "960"
	  // },
	  // "Mali": {
	  //   "name": "Mali",
	  //   "code": "223"
	  // },
	  // "Malta": {
	  //   "name": "Malta",
	  //   "code": "356"
	  // },
	  // "Marshall Islands": {
	  //   "name": "Marshall Islands",
	  //   "code": "692"
	  // },
	  // "Martinique": {
	  //   "name": "Martinique",
	  //   "code": "596"
	  // },
	  // "Mauritania": {
	  //   "name": "Mauritania",
	  //   "code": "222"
	  // },
	  // "Mauritius": {
	  //   "name": "Mauritius",
	  //   "code": "230"
	  // },
	  // "Mexico": {
	  //   "name": "Mexico",
	  //   "code": "52"
	  // },
	  // "Micronesia": {
	  //   "name": "Micronesia",
	  //   "code": "691"
	  // },
	  // "Moldova": {
	  //   "name": "Moldova",
	  //   "code": "373"
	  // },
	  // "Monaco": {
	  //   "name": "Monaco",
	  //   "code": "377"
	  // },
	  // "Mongolia": {
	  //   "name": "Mongolia",
	  //   "code": "976"
	  // },
	  // "Montenegro": {
	  //   "name": "Montenegro",
	  //   "code": "382"
	  // },
	  // "Montserrat": {
	  //   "name": "Montserrat",
	  //   "code": "1664"
	  // },
	  // "Morocco": {
	  //   "name": "Morocco",
	  //   "code": "212"
	  // },
	  // "Mozambique": {
	  //   "name": "Mozambique",
	  //   "code": "258"
	  // },
	  // "Myanmar": {
	  //   "name": "Myanmar",
	  //   "code": "95"
	  // },
	  // "Namibia": {
	  //   "name": "Namibia",
	  //   "code": "264"
	  // },
	  // "Nauru": {
	  //   "name": "Nauru",
	  //   "code": "674"
	  // },
	  // "Nepal": {
	  //   "name": "Nepal",
	  //   "code": "977"
	  // },
	  // "Netherlands": {
	  //   "name": "Netherlands",
	  //   "code": "31"
	  // },
	  // "New Caledonia": {
	  //   "name": "New Caledonia",
	  //   "code": "687"
	  // },
	  // "New Zealand": {
	  //   "name": "New Zealand",
	  //   "code": "64"
	  // },
	  // "Nicaragua": {
	  //   "name": "Nicaragua",
	  //   "code": "505"
	  // },
	  // "Niger": {
	  //   "name": "Niger",
	  //   "code": "227"
	  // },
	  // "Nigeria": {
	  //   "name": "Nigeria",
	  //   "code": "234"
	  // },
	  // "Niue": {
	  //   "name": "Niue",
	  //   "code": "683"
	  // },
	  // "Norfolk Island": {
	  //   "name": "Norfolk Island",
	  //   "code": "672"
	  // },
	  // "North Korea": {
	  //   "name": "North Korea",
	  //   "code": "850"
	  // },
	  // "Northern Mariana Islands": {
	  //   "name": "Northern Mariana Islands",
	  //   "code": "1670"
	  // },
	  // "Norway": {
	  //   "name": "Norway",
	  //   "code": "47"
	  // },
	  // "Oman": {
	  //   "name": "Oman",
	  //   "code": "968"
	  // },
	  // "Pakistan": {
	  //   "name": "Pakistan",
	  //   "code": "92"
	  // },
	  // "Palau": {
	  //   "name": "Palau",
	  //   "code": "680"
	  // },
	  // "Palestine": {
	  //   "name": "Palestine",
	  //   "code": "970"
	  // },
	  // "Panama": {
	  //   "name": "Panama",
	  //   "code": "507"
	  // },
	  // "Papua New Guinea": {
	  //   "name": "Papua New Guinea",
	  //   "code": "675"
	  // },
	  // "Paraguay": {
	  //   "name": "Paraguay",
	  //   "code": "595"
	  // },
	  // "Peru": {
	  //   "name": "Peru",
	  //   "code": "51"
	  // },
	  // "Philippines": {
	  //   "name": "Philippines",
	  //   "code": "63"
	  // },
	  // "Poland": {
	  //   "name": "Poland",
	  //   "code": "48"
	  // },
	  // "Portugal": {
	  //   "name": "Portugal",
	  //   "code": "351"
	  // },
	  // "Puerto Rico": {
	  //   "name": "Puerto Rico",
	  //   "code": "1"
	  // },
	  // "Qatar": {
	  //   "name": "Qatar",
	  //   "code": "974"
	  // },
	  // "RÃ©union": {
	  //   "name": "RÃ©union",
	  //   "code": "262"
	  // },
	  // "Romania": {
	  //   "name": "Romania",
	  //   "code": "40"
	  // },
	  // "Russia": {
	  //   "name": "Russia",
	  //   "code": "7"
	  // },
	  // "Rwanda": {
	  //   "name": "Rwanda",
	  //   "code": "250"
	  // },
	  // "Saint BarthÃ©lemy": {
	  //   "name": "Saint BarthÃ©lemy",
	  //   "code": "590"
	  // },
	  // "Saint Helena": {
	  //   "name": "Saint Helena",
	  //   "code": "290"
	  // },
	  // "Saint Kitts and Nevis": {
	  //   "name": "Saint Kitts and Nevis",
	  //   "code": "1869"
	  // },
	  // "Saint Lucia": {
	  //   "name": "Saint Lucia",
	  //   "code": "1758"
	  // },
	  // "Saint Martin": {
	  //   "name": "Saint Martin",
	  //   "code": "590"
	  // },
	  // "Saint Pierre and Miquelon": {
	  //   "name": "Saint Pierre and Miquelon",
	  //   "code": "508"
	  // },
	  // "Saint Vincent and the Grenadines": {
	  //   "name": "Saint Vincent and the Grenadines",
	  //   "code": "1784"
	  // },
	  // "Samoa": {
	  //   "name": "Samoa",
	  //   "code": "685"
	  // },
	  // "San Marino": {
	  //   "name": "San Marino",
	  //   "code": "378"
	  // },
	  // "SÃ£o TomÃ© and PrÃ­ncipe": {
	  //   "name": "SÃ£o TomÃ© and PrÃ­ncipe",
	  //   "code": "239"
	  // },
	  // "Saudi Arabia": {
	  //   "name": "Saudi Arabia",
	  //   "code": "966"
	  // },
	  // "Senegal": {
	  //   "name": "Senegal",
	  //   "code": "221"
	  // },
	  // "Serbia": {
	  //   "name": "Serbia",
	  //   "code": "381"
	  // },
	  // "Seychelles": {
	  //   "name": "Seychelles",
	  //   "code": "248"
	  // },
	  // "Sierra Leone": {
	  //   "name": "Sierra Leone",
	  //   "code": "232"
	  // },
	  // "Singapore": {
	  //   "name": "Singapore",
	  //   "code": "65"
	  // },
	  // "Sint Maarten": {
	  //   "name": "Sint Maarten",
	  //   "code": "1721"
	  // },
	  // "Slovakia": {
	  //   "name": "Slovakia",
	  //   "code": "421"
	  // },
	  // "Slovenia": {
	  //   "name": "Slovenia",
	  //   "code": "386"
	  // },
	  // "Solomon Islands": {
	  //   "name": "Solomon Islands",
	  //   "code": "677"
	  // },
	  // "Somalia": {
	  //   "name": "Somalia",
	  //   "code": "252"
	  // },
	  // "South Africa": {
	  //   "name": "South Africa",
	  //   "code": "27"
	  // },
	  // "South Korea": {
	  //   "name": "South Korea",
	  //   "code": "82"
	  // },
	  // "South Sudan": {
	  //   "name": "South Sudan",
	  //   "code": "211"
	  // },
	  // "Spain": {
	  //   "name": "Spain",
	  //   "code": "34"
	  // },
	  // "Sri Lanka": {
	  //   "name": "Sri Lanka",
	  //   "code": "94"
	  // },
	  // "Sudan": {
	  //   "name": "Sudan",
	  //   "code": "249"
	  // },
	  // "Suriname": {
	  //   "name": "Suriname",
	  //   "code": "597"
	  // },
	  // "Swaziland": {
	  //   "name": "Swaziland",
	  //   "code": "268"
	  // },
	  // "Sweden": {
	  //   "name": "Sweden",
	  //   "code": "46"
	  // },
	  // "Switzerland": {
	  //   "name": "Switzerland",
	  //   "code": "41"
	  // },
	  // "Syria": {
	  //   "name": "Syria",
	  //   "code": "963"
	  // },
	  // "Taiwan": {
	  //   "name": "Taiwan",
	  //   "code": "886"
	  // },
	  // "Tajikistan": {
	  //   "name": "Tajikistan",
	  //   "code": "992"
	  // },
	  // "Tanzania": {
	  //   "name": "Tanzania",
	  //   "code": "255"
	  // },
	  // "Thailand": {
	  //   "name": "Thailand",
	  //   "code": "66"
	  // },
	  // "Timor-Leste": {
	  //   "name": "Timor-Leste",
	  //   "code": "670"
	  // },
	  // "Togo": {
	  //   "name": "Togo",
	  //   "code": "228"
	  // },
	  // "Tokelau": {
	  //   "name": "Tokelau",
	  //   "code": "690"
	  // },
	  // "Tonga": {
	  //   "name": "Tonga",
	  //   "code": "676"
	  // },
	  // "Trinidad and Tobago": {
	  //   "name": "Trinidad and Tobago",
	  //   "code": "1868"
	  // },
	  // "Tunisia": {
	  //   "name": "Tunisia",
	  //   "code": "216"
	  // },
	  // "Turkey": {
	  //   "name": "Turkey",
	  //   "code": "90"
	  // },
	  // "Turkmenistan": {
	  //   "name": "Turkmenistan",
	  //   "code": "993"
	  // },
	  // "Turks and Caicos Islands": {
	  //   "name": "Turks and Caicos Islands",
	  //   "code": "1649"
	  // },
	  // "Tuvalu": {
	  //   "name": "Tuvalu",
	  //   "code": "688"
	  // },
	  // "U.S. Virgin Islands": {
	  //   "name": "U.S. Virgin Islands",
	  //   "code": "1340"
	  // },
	  // "Uganda": {
	  //   "name": "Uganda",
	  //   "code": "256"
	  // },
	  // "Ukraine": {
	  //   "name": "Ukraine",
	  //   "code": "380"
	  // },
	  // "United Arab Emirates": {
	  //   "name": "United Arab Emirates",
	  //   "code": "971"
	  // },
	  // "United Kingdom": {
	  //   "name": "United Kingdom",
	  //   "code": "44"
	  // },
	  // "United States": {
	  //   "name": "United States",
	  //   "code": "1"
	  // },
	  // "Uruguay": {
	  //   "name": "Uruguay",
	  //   "code": "598"
	  // },
	  // "Uzbekistan": {
	  //   "name": "Uzbekistan",
	  //   "code": "998"
	  // },
	  // "Vanuatu": {
	  //   "name": "Vanuatu",
	  //   "code": "678"
	  // },
	  // "Vatican City": {
	  //   "name": "Vatican City",
	  //   "code": "39"
	  // },
	  // "Venezuela": {
	  //   "name": "Venezuela",
	  //   "code": "58"
	  // },
	  // "Vietnam": {
	  //   "name": "Vietnam",
	  //   "code": "84"
	  // },
	  // "Wallis and Futuna": {
	  //   "name": "Wallis and Futuna",
	  //   "code": "681"
	  // },
	  // "Yemen": {
	  //   "name": "Yemen",
	  //   "code": "967"
	  // },
	  // "Zambia": {
	  //   "name": "Zambia",
	  //   "code": "260"
	  // },
	  // "Zimbabwe": {
	  //   "name": "Zimbabwe",
	  //   "code": "263"
	  // },
	  "ca": {
	    "name": "Canada",
	    "code": "1"
	  },
	  "us": {
	    "name": "United States",
	    "code": "1"
	  },
	  "af": {
	    "name": "Afghanistan",
	    "code": "93"
	  },
	  "al": {
	    "name": "Albania",
	    "code": "355"
	  },
	  "dz": {
	    "name": "Algeria",
	    "code": "213"
	  },
	  "as": {
	    "name": "American Samoa",
	    "code": "1684"
	  },
	  "ad": {
	    "name": "Andorra",
	    "code": "376"
	  },
	  "ao": {
	    "name": "Angola",
	    "code": "244"
	  },
	  "ai": {
	    "name": "Anguilla",
	    "code": "1264"
	  },
	  "ag": {
	    "name": "Antigua and Barbuda",
	    "code": "1268"
	  },
	  "ar": {
	    "name": "Argentina",
	    "code": "54"
	  },
	  "am": {
	    "name": "Armenia",
	    "code": "374"
	  },
	  "aw": {
	    "name": "Aruba",
	    "code": "297"
	  },
	  "au": {
	    "name": "Australia",
	    "code": "61"
	  },
	  "at": {
	    "name": "Austria",
	    "code": "43"
	  },
	  "az": {
	    "name": "Azerbaijan",
	    "code": "994"
	  },
	  "bs": {
	    "name": "Bahamas",
	    "code": "1242"
	  },
	  "bh": {
	    "name": "Bahrain",
	    "code": "973"
	  },
	  "bd": {
	    "name": "Bangladesh",
	    "code": "880"
	  },
	  "bb": {
	    "name": "Barbados",
	    "code": "1246"
	  },
	  "by": {
	    "name": "Belarus",
	    "code": "375"
	  },
	  "be": {
	    "name": "Belgium",
	    "code": "32"
	  },
	  "bz": {
	    "name": "Belize",
	    "code": "501"
	  },
	  "bj": {
	    "name": "Benin",
	    "code": "229"
	  },
	  "bm": {
	    "name": "Bermuda",
	    "code": "1441"
	  },
	  "bt": {
	    "name": "Bhutan",
	    "code": "975"
	  },
	  "bo": {
	    "name": "Bolivia",
	    "code": "591"
	  },
	  "ba": {
	    "name": "Bosnia and Herzegovina",
	    "code": "387"
	  },
	  "bw": {
	    "name": "Botswana",
	    "code": "267"
	  },
	  "br": {
	    "name": "Brazil",
	    "code": "55"
	  },
	  "io": {
	    "name": "British Indian Ocean Territory",
	    "code": "246"
	  },
	  "vg": {
	    "name": "British Virgin Islands",
	    "code": "1284"
	  },
	  "bn": {
	    "name": "Brunei",
	    "code": "673"
	  },
	  "bg": {
	    "name": "Bulgaria",
	    "code": "359"
	  },
	  "bf": {
	    "name": "Burkina Faso",
	    "code": "226"
	  },
	  "bi": {
	    "name": "Burundi",
	    "code": "257"
	  },
	  "kh": {
	    "name": "Cambodia",
	    "code": "855"
	  },
	  "cm": {
	    "name": "Cameroon",
	    "code": "237"
	  },
	  "cv": {
	    "name": "Cape Verde",
	    "code": "238"
	  },
	  "bq": {
	    "name": "Caribbean Netherlands",
	    "code": "599"
	  },
	  "ky": {
	    "name": "Cayman Islands",
	    "code": "1345"
	  },
	  "cf": {
	    "name": "Central African Republic",
	    "code": "236"
	  },
	  "td": {
	    "name": "Chad",
	    "code": "235"
	  },
	  "cl": {
	    "name": "Chile",
	    "code": "56"
	  },
	  // "cn": {
	  //   "name": "China",
	  //   "code": "86"
	  // },
	  "co": {
	    "name": "Colombia",
	    "code": "57"
	  },
	  "km": {
	    "name": "Comoros",
	    "code": "269"
	  },
	  "cd": {
	    "name": "Congo (DRC)",
	    "code": "243"
	  },
	  "cg": {
	    "name": "Congo (Republic)",
	    "code": "242"
	  },
	  "ck": {
	    "name": "Cook Islands",
	    "code": "682"
	  },
	  "cr": {
	    "name": "Costa Rica",
	    "code": "506"
	  },
	  "ci": {
	    "name": "CÃ´te dâ€™Ivoire",
	    "code": "225"
	  },
	  "hr": {
	    "name": "Croatia",
	    "code": "385"
	  },
	  "cu": {
	    "name": "Cuba",
	    "code": "53"
	  },
	  "cw": {
	    "name": "CuraÃ§ao",
	    "code": "599"
	  },
	  "cy": {
	    "name": "Cyprus",
	    "code": "357"
	  },
	  "cz": {
	    "name": "Czech Republic",
	    "code": "420"
	  },
	  "dk": {
	    "name": "Denmark",
	    "code": "45"
	  },
	  "dj": {
	    "name": "Djibouti",
	    "code": "253"
	  },
	  "dm": {
	    "name": "Dominica",
	    "code": "1767"
	  },
	  "do": {
	    "name": "Dominican Republic",
	    "code": "1"
	  },
	  "ec": {
	    "name": "Ecuador",
	    "code": "593"
	  },
	  "eg": {
	    "name": "Egypt",
	    "code": "20"
	  },
	  "sv": {
	    "name": "El Salvador",
	    "code": "503"
	  },
	  "gq": {
	    "name": "Equatorial Guinea",
	    "code": "240"
	  },
	  "er": {
	    "name": "Eritrea",
	    "code": "291"
	  },
	  "ee": {
	    "name": "Estonia",
	    "code": "372"
	  },
	  "et": {
	    "name": "Ethiopia",
	    "code": "251"
	  },
	  "fk": {
	    "name": "Falkland Islands",
	    "code": "500"
	  },
	  "fo": {
	    "name": "Faroe Islands",
	    "code": "298"
	  },
	  "fj": {
	    "name": "Fiji",
	    "code": "679"
	  },
	  "fi": {
	    "name": "Finland",
	    "code": "358"
	  },
	  "fr": {
	    "name": "France",
	    "code": "33"
	  },
	  "gf": {
	    "name": "French Guiana",
	    "code": "594"
	  },
	  "pf": {
	    "name": "French Polynesia",
	    "code": "689"
	  },
	  "ga": {
	    "name": "Gabon",
	    "code": "241"
	  },
	  "gm": {
	    "name": "Gambia",
	    "code": "220"
	  },
	  "ge": {
	    "name": "Georgia",
	    "code": "995"
	  },
	  "de": {
	    "name": "Germany",
	    "code": "49"
	  },
	  "gh": {
	    "name": "Ghana",
	    "code": "233"
	  },
	  "gi": {
	    "name": "Gibraltar",
	    "code": "350"
	  },
	  "gr": {
	    "name": "Greece",
	    "code": "30"
	  },
	  "gl": {
	    "name": "Greenland",
	    "code": "299"
	  },
	  "gd": {
	    "name": "Grenada",
	    "code": "1473"
	  },
	  "gp": {
	    "name": "Guadeloupe",
	    "code": "590"
	  },
	  "gu": {
	    "name": "Guam",
	    "code": "1671"
	  },
	  "gt": {
	    "name": "Guatemala",
	    "code": "502"
	  },
	  "gn": {
	    "name": "Guinea",
	    "code": "224"
	  },
	  "gw": {
	    "name": "Guinea-Bissau",
	    "code": "245"
	  },
	  "gy": {
	    "name": "Guyana",
	    "code": "592"
	  },
	  "ht": {
	    "name": "Haiti",
	    "code": "509"
	  },
	  "hn": {
	    "name": "Honduras",
	    "code": "504"
	  },
	  "hk": {
	    "name": "Hong Kong",
	    "code": "852"
	  },
	  "hu": {
	    "name": "Hungary",
	    "code": "36"
	  },
	  "is": {
	    "name": "Iceland",
	    "code": "354"
	  },
	  "in": {
	    "name": "India",
	    "code": "91"
	  },
	  "id": {
	    "name": "Indonesia",
	    "code": "62"
	  },
	  "ir": {
	    "name": "Iran",
	    "code": "98"
	  },
	  "iq": {
	    "name": "Iraq",
	    "code": "964"
	  },
	  "ie": {
	    "name": "Ireland",
	    "code": "353"
	  },
	  "il": {
	    "name": "Israel",
	    "code": "972"
	  },
	  "it": {
	    "name": "Italy",
	    "code": "39"
	  },
	  "jm": {
	    "name": "Jamaica",
	    "code": "1876"
	  },
	  "jp": {
	    "name": "Japan",
	    "code": "81"
	  },
	  "jo": {
	    "name": "Jordan",
	    "code": "962"
	  },
	  "kz": {
	    "name": "Kazakhstan",
	    "code": "7"
	  },
	  "ke": {
	    "name": "Kenya",
	    "code": "254"
	  },
	  "ki": {
	    "name": "Kiribati",
	    "code": "686"
	  },
	  "kw": {
	    "name": "Kuwait",
	    "code": "965"
	  },
	  "kg": {
	    "name": "Kyrgyzstan",
	    "code": "996"
	  },
	  "la": {
	    "name": "Laos",
	    "code": "856"
	  },
	  "lv": {
	    "name": "Latvia",
	    "code": "371"
	  },
	  "lb": {
	    "name": "Lebanon",
	    "code": "961"
	  },
	  "ls": {
	    "name": "Lesotho",
	    "code": "266"
	  },
	  "lr": {
	    "name": "Liberia",
	    "code": "231"
	  },
	  "ly": {
	    "name": "Libya",
	    "code": "218"
	  },
	  "li": {
	    "name": "Liechtenstein",
	    "code": "423"
	  },
	  "lt": {
	    "name": "Lithuania",
	    "code": "370"
	  },
	  "lu": {
	    "name": "Luxembourg",
	    "code": "352"
	  },
	  "mo": {
	    "name": "Macau",
	    "code": "853"
	  },
	  "mk": {
	    "name": "Macedonia",
	    "code": "389"
	  },
	  "mg": {
	    "name": "Madagascar",
	    "code": "261"
	  },
	  "mw": {
	    "name": "Malawi",
	    "code": "265"
	  },
	  "my": {
	    "name": "Malaysia",
	    "code": "60"
	  },
	  "mv": {
	    "name": "Maldives",
	    "code": "960"
	  },
	  "ml": {
	    "name": "Mali",
	    "code": "223"
	  },
	  "mt": {
	    "name": "Malta",
	    "code": "356"
	  },
	  "mh": {
	    "name": "Marshall Islands",
	    "code": "692"
	  },
	  "mq": {
	    "name": "Martinique",
	    "code": "596"
	  },
	  "mr": {
	    "name": "Mauritania",
	    "code": "222"
	  },
	  "mu": {
	    "name": "Mauritius",
	    "code": "230"
	  },
	  "mx": {
	    "name": "Mexico",
	    "code": "52"
	  },
	  "fm": {
	    "name": "Micronesia",
	    "code": "691"
	  },
	  "md": {
	    "name": "Moldova",
	    "code": "373"
	  },
	  "mc": {
	    "name": "Monaco",
	    "code": "377"
	  },
	  "mn": {
	    "name": "Mongolia",
	    "code": "976"
	  },
	  "me": {
	    "name": "Montenegro",
	    "code": "382"
	  },
	  "ms": {
	    "name": "Montserrat",
	    "code": "1664"
	  },
	  "ma": {
	    "name": "Morocco",
	    "code": "212"
	  },
	  "mz": {
	    "name": "Mozambique",
	    "code": "258"
	  },
	  "mm": {
	    "name": "Myanmar",
	    "code": "95"
	  },
	  "na": {
	    "name": "Namibia",
	    "code": "264"
	  },
	  "nr": {
	    "name": "Nauru",
	    "code": "674"
	  },
	  "np": {
	    "name": "Nepal",
	    "code": "977"
	  },
	  "nl": {
	    "name": "Netherlands",
	    "code": "31"
	  },
	  "nc": {
	    "name": "New Caledonia",
	    "code": "687"
	  },
	  "nz": {
	    "name": "New Zealand",
	    "code": "64"
	  },
	  "ni": {
	    "name": "Nicaragua",
	    "code": "505"
	  },
	  "ne": {
	    "name": "Niger",
	    "code": "227"
	  },
	  "ng": {
	    "name": "Nigeria",
	    "code": "234"
	  },
	  "nu": {
	    "name": "Niue",
	    "code": "683"
	  },
	  "nf": {
	    "name": "Norfolk Island",
	    "code": "672"
	  },
	  "kp": {
	    "name": "North Korea",
	    "code": "850"
	  },
	  "mp": {
	    "name": "Northern Mariana Islands",
	    "code": "1670"
	  },
	  "no": {
	    "name": "Norway",
	    "code": "47"
	  },
	  "om": {
	    "name": "Oman",
	    "code": "968"
	  },
	  "pk": {
	    "name": "Pakistan",
	    "code": "92"
	  },
	  "pw": {
	    "name": "Palau",
	    "code": "680"
	  },
	  "ps": {
	    "name": "Palestine",
	    "code": "970"
	  },
	  "pa": {
	    "name": "Panama",
	    "code": "507"
	  },
	  "pg": {
	    "name": "Papua New Guinea",
	    "code": "675"
	  },
	  "py": {
	    "name": "Paraguay",
	    "code": "595"
	  },
	  "pe": {
	    "name": "Peru",
	    "code": "51"
	  },
	  "ph": {
	    "name": "Philippines",
	    "code": "63"
	  },
	  "pl": {
	    "name": "Poland",
	    "code": "48"
	  },
	  "pt": {
	    "name": "Portugal",
	    "code": "351"
	  },
	  "pr": {
	    "name": "Puerto Rico",
	    "code": "1"
	  },
	  "qa": {
	    "name": "Qatar",
	    "code": "974"
	  },
	  "re": {
	    "name": "RÃ©union",
	    "code": "262"
	  },
	  "ro": {
	    "name": "Romania",
	    "code": "40"
	  },
	  "ru": {
	    "name": "Russia",
	    "code": "7"
	  },
	  "rw": {
	    "name": "Rwanda",
	    "code": "250"
	  },
	  "bl": {
	    "name": "Saint BarthÃ©lemy",
	    "code": "590"
	  },
	  "sh": {
	    "name": "Saint Helena",
	    "code": "290"
	  },
	  "kn": {
	    "name": "Saint Kitts and Nevis",
	    "code": "1869"
	  },
	  "lc": {
	    "name": "Saint Lucia",
	    "code": "1758"
	  },
	  "mf": {
	    "name": "Saint Martin",
	    "code": "590"
	  },
	  "pm": {
	    "name": "Saint Pierre and Miquelon",
	    "code": "508"
	  },
	  "vc": {
	    "name": "Saint Vincent and the Grenadines",
	    "code": "1784"
	  },
	  "ws": {
	    "name": "Samoa",
	    "code": "685"
	  },
	  "sm": {
	    "name": "San Marino",
	    "code": "378"
	  },
	  "st": {
	    "name": "SÃ£o TomÃ© and PrÃ­ncipe",
	    "code": "239"
	  },
	  "sa": {
	    "name": "Saudi Arabia",
	    "code": "966"
	  },
	  "sn": {
	    "name": "Senegal",
	    "code": "221"
	  },
	  "rs": {
	    "name": "Serbia",
	    "code": "381"
	  },
	  "sc": {
	    "name": "Seychelles",
	    "code": "248"
	  },
	  "sl": {
	    "name": "Sierra Leone",
	    "code": "232"
	  },
	  "sg": {
	    "name": "Singapore",
	    "code": "65"
	  },
	  "sx": {
	    "name": "Sint Maarten",
	    "code": "1721"
	  },
	  "sk": {
	    "name": "Slovakia",
	    "code": "421"
	  },
	  "si": {
	    "name": "Slovenia",
	    "code": "386"
	  },
	  "sb": {
	    "name": "Solomon Islands",
	    "code": "677"
	  },
	  "so": {
	    "name": "Somalia",
	    "code": "252"
	  },
	  "za": {
	    "name": "South Africa",
	    "code": "27"
	  },
	  "kr": {
	    "name": "South Korea",
	    "code": "82"
	  },
	  "ss": {
	    "name": "South Sudan",
	    "code": "211"
	  },
	  "es": {
	    "name": "Spain",
	    "code": "34"
	  },
	  "lk": {
	    "name": "Sri Lanka",
	    "code": "94"
	  },
	  "sd": {
	    "name": "Sudan",
	    "code": "249"
	  },
	  "sr": {
	    "name": "Suriname",
	    "code": "597"
	  },
	  "sz": {
	    "name": "Swaziland",
	    "code": "268"
	  },
	  "se": {
	    "name": "Sweden",
	    "code": "46"
	  },
	  "ch": {
	    "name": "Switzerland",
	    "code": "41"
	  },
	  "sy": {
	    "name": "Syria",
	    "code": "963"
	  },
	  "tw": {
	    "name": "Taiwan",
	    "code": "886"
	  },
	  "tj": {
	    "name": "Tajikistan",
	    "code": "992"
	  },
	  "tz": {
	    "name": "Tanzania",
	    "code": "255"
	  },
	  "th": {
	    "name": "Thailand",
	    "code": "66"
	  },
	  "tl": {
	    "name": "Timor-Leste",
	    "code": "670"
	  },
	  "tg": {
	    "name": "Togo",
	    "code": "228"
	  },
	  "tk": {
	    "name": "Tokelau",
	    "code": "690"
	  },
	  "to": {
	    "name": "Tonga",
	    "code": "676"
	  },
	  "tt": {
	    "name": "Trinidad and Tobago",
	    "code": "1868"
	  },
	  "tn": {
	    "name": "Tunisia",
	    "code": "216"
	  },
	  "tr": {
	    "name": "Turkey",
	    "code": "90"
	  },
	  "tm": {
	    "name": "Turkmenistan",
	    "code": "993"
	  },
	  "tc": {
	    "name": "Turks and Caicos Islands",
	    "code": "1649"
	  },
	  "tv": {
	    "name": "Tuvalu",
	    "code": "688"
	  },
	  "vi": {
	    "name": "U.S. Virgin Islands",
	    "code": "1340"
	  },
	  "ug": {
	    "name": "Uganda",
	    "code": "256"
	  },
	  "ua": {
	    "name": "Ukraine",
	    "code": "380"
	  },
	  "ae": {
	    "name": "United Arab Emirates",
	    "code": "971"
	  },
	  "gb": {
	    "name": "United Kingdom",
	    "code": "44"
	  },
	  "uy": {
	    "name": "Uruguay",
	    "code": "598"
	  },
	  "uz": {
	    "name": "Uzbekistan",
	    "code": "998"
	  },
	  "vu": {
	    "name": "Vanuatu",
	    "code": "678"
	  },
	  "va": {
	    "name": "Vatican City",
	    "code": "39"
	  },
	  "ve": {
	    "name": "Venezuela",
	    "code": "58"
	  },
	  "vn": {
	    "name": "Vietnam",
	    "code": "84"
	  },
	  "wf": {
	    "name": "Wallis and Futuna",
	    "code": "681"
	  },
	  "ye": {
	    "name": "Yemen",
	    "code": "967"
	  },
	  "zm": {
	    "name": "Zambia",
	    "code": "260"
	  },
	  "zw": {
	    "name": "Zimbabwe",
	    "code": "263"
	  }
	};
	module.exports = exports["default"];

/***/ },

/***/ "WFbx":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"f16":"f16","flag":"flag","_African_Union":"_African_Union","_Arab_League":"_Arab_League","_ASEAN":"_ASEAN","_CARICOM":"_CARICOM","_CIS":"_CIS","_Commonwealth":"_Commonwealth","_England":"_England","_European_Union":"_European_Union","_Islamic_Conference":"_Islamic_Conference","_Kosovo":"_Kosovo","_NATO":"_NATO","_Northern_Cyprus":"_Northern_Cyprus","_Northern_Ireland":"_Northern_Ireland","_Olimpic_Movement":"_Olimpic_Movement","_OPEC":"_OPEC","_Red_Cross":"_Red_Cross","_Scotland":"_Scotland","_Somaliland":"_Somaliland","_Tibet":"_Tibet","_United_Nations":"_United_Nations","_Wales":"_Wales","eu":"eu","ad":"ad","ae":"ae","af":"af","ag":"ag","ai":"ai","al":"al","am":"am","ao":"ao","aq":"aq","ar":"ar","as":"as","at":"at","au":"au","aw":"aw","ax":"ax","az":"az","ba":"ba","bb":"bb","bd":"bd","be":"be","bf":"bf","bg":"bg","bh":"bh","bi":"bi","bj":"bj","bm":"bm","bn":"bn","bo":"bo","br":"br","bs":"bs","bt":"bt","bw":"bw","by":"by","bz":"bz","ca":"ca","cg":"cg","cf":"cf","cd":"cd","ch":"ch","ci":"ci","ck":"ck","cl":"cl","cm":"cm","cn":"cn","co":"co","cr":"cr","cu":"cu","cv":"cv","cy":"cy","cz":"cz","de":"de","dj":"dj","dk":"dk","dm":"dm","do":"do","dz":"dz","ec":"ec","ee":"ee","eg":"eg","eh":"eh","er":"er","es":"es","et":"et","fi":"fi","fj":"fj","fm":"fm","fo":"fo","fr":"fr","bl":"bl","cp":"cp","mf":"mf","yt":"yt","ga":"ga","gb":"gb","sh":"sh","gd":"gd","ge":"ge","gg":"gg","gh":"gh","gi":"gi","gl":"gl","gm":"gm","gn":"gn","gp":"gp","gq":"gq","gr":"gr","gt":"gt","gu":"gu","gw":"gw","gy":"gy","hk":"hk","hn":"hn","hr":"hr","ht":"ht","hu":"hu","id":"id","mc":"mc","ie":"ie","il":"il","im":"im","in":"in","iq":"iq","ir":"ir","is":"is","it":"it","je":"je","jm":"jm","jo":"jo","jp":"jp","ke":"ke","kg":"kg","kh":"kh","ki":"ki","km":"km","kn":"kn","kp":"kp","kr":"kr","kw":"kw","ky":"ky","kz":"kz","la":"la","lb":"lb","lc":"lc","li":"li","lk":"lk","lr":"lr","ls":"ls","lt":"lt","lu":"lu","lv":"lv","ly":"ly","ma":"ma","md":"md","me":"me","mg":"mg","mh":"mh","mk":"mk","ml":"ml","mm":"mm","mn":"mn","mo":"mo","mq":"mq","mr":"mr","ms":"ms","mt":"mt","mu":"mu","mv":"mv","mw":"mw","mx":"mx","my":"my","mz":"mz","na":"na","nc":"nc","ne":"ne","ng":"ng","ni":"ni","nl":"nl","bq":"bq","no":"no","bv":"bv","nq":"nq","sj":"sj","np":"np","nr":"nr","nz":"nz","om":"om","pa":"pa","pe":"pe","pf":"pf","pg":"pg","ph":"ph","pk":"pk","pl":"pl","pr":"pr","ps":"ps","pt":"pt","pw":"pw","py":"py","qa":"qa","re":"re","ro":"ro","rs":"rs","ru":"ru","rw":"rw","sa":"sa","sb":"sb","sc":"sc","sd":"sd","se":"se","sg":"sg","si":"si","sk":"sk","sl":"sl","sm":"sm","sn":"sn","so":"so","sr":"sr","st":"st","sv":"sv","sy":"sy","sz":"sz","tc":"tc","td":"td","tg":"tg","th":"th","tj":"tj","tl":"tl","tm":"tm","tn":"tn","to":"to","tr":"tr","tt":"tt","tv":"tv","tw":"tw","tz":"tz","ua":"ua","ug":"ug","us":"us","uy":"uy","uz":"uz","va":"va","vc":"vc","ve":"ve","vg":"vg","vi":"vi","vn":"vn","vu":"vu","ws":"ws","ye":"ye","za":"za","zm":"zm","zw":"zw","sx":"sx","cw":"cw","ss":"ss","nu":"nu"};

/***/ },

/***/ "skwP":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDropzone = __webpack_require__("KTM0");
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	__webpack_require__("yV0A");
	
	var _alert = __webpack_require__("BGi1");
	
	var _ImageCropper = __webpack_require__("jlVy");
	
	var _ImageCropper2 = _interopRequireDefault(_ImageCropper);
	
	var _rcProgress = __webpack_require__("McaX");
	
	var _isEmpty = __webpack_require__("lHK6");
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pica = __webpack_require__("N555")();
	
	var ACCEPT_MIME = 'image/png,image/jpeg';
	var MAX_SIZE = 5 * 1000 * 1000;
	var MIN_SIZE = 0;
	var DO_RESIZING = true;
	var RESIZE_WIDTH = 300;
	var RESIZE_HEIGHT = 300;
	
	var ImageUploader = function (_React$Component) {
	  _inherits(ImageUploader, _React$Component);
	
	  function ImageUploader(props) {
	    _classCallCheck(this, ImageUploader);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.uploadImage = _this.uploadImage.bind(_this);
	    _this.resizeImage = _this.resizeImage.bind(_this);
	
	    _this.state = {
	      existingImg: props.value,
	      lastUpdated: null,
	      uploading: false
	    };
	    return _this;
	  }
	
	  ImageUploader.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var value = _ref.value;
	
	    if (value.image) {
	      this.setState({
	        existingImg: value.image
	      });
	    }
	    if (value.file) {
	      this.file = value.file;
	    }
	  };
	
	  ImageUploader.prototype.onDrop = function onDrop(accepted, rejected) {
	    var _this2 = this;
	
	    var _props$options = this.props.options,
	        aspectRatioHeight = _props$options.aspectRatioHeight,
	        aspectRatioWidth = _props$options.aspectRatioWidth;
	
	
	    if (rejected.length > 0) {
	      _alert.alert.warning(__('Image file must be png/jpeg under 5 MB', 'image'), __('Image not qualified', 'image'));
	    } else if (accepted.length > 0) {
	      // STEP 1. Open up modal
	      (0, _ImageCropper2.default)({
	        file: accepted[0],
	        aspectRatioHeight: aspectRatioHeight,
	        aspectRatioWidth: aspectRatioWidth
	      }).then(function (_ref2) {
	        var file = _ref2.file,
	            imageUrl = _ref2.imageUrl,
	            dataUrl = _ref2.dataUrl;
	
	        // STEP 2. Modal returns a file and a temporary imageUrl which we apply
	        // to the image preview
	        if (file) {
	          _this2.setState({
	            existingImg: imageUrl
	          });
	          // Step 3. Resize (or not) image before uploading
	          var _props = _this2.props,
	              _props$doResizing = _props.doResizing,
	              doResizing = _props$doResizing === undefined ? DO_RESIZING : _props$doResizing,
	              options = _props.options,
	              onChange = _props.onChange;
	
	
	          if (doResizing == true) {
	            var _props2 = _this2.props,
	                _props2$resizeWidth = _props2.resizeWidth,
	                resizeWidth = _props2$resizeWidth === undefined ? RESIZE_WIDTH : _props2$resizeWidth,
	                _props2$resizeHeight = _props2.resizeHeight,
	                resizeHeight = _props2$resizeHeight === undefined ? RESIZE_HEIGHT : _props2$resizeHeight;
	
	
	            _this2.resizeImage(dataUrl, resizeWidth, resizeHeight, function (file) {
	              onChange({
	                image: dataUrl,
	                file: file
	              });
	            });
	          } else {
	            onChange({
	              image: dataUrl,
	              file: file
	            });
	          }
	        }
	      }).catch(function (err) {
	        console.error(err);
	      });
	    }
	  };
	
	  ImageUploader.prototype.resizeImage = function resizeImage(dataUrl, newWidth, newHeight, cb) {
	    var from = document.createElement('img');
	    from.src = dataUrl;
	
	    from.onload = function () {
	      var to = document.createElement('canvas');
	      to.width = newWidth;
	      to.height = newHeight;
	
	      pica.resize(from, to).then(function (result) {
	        return pica.toBlob(result, 'image/jpeg', 0.90);
	      }).then(function (resized) {
	        cb(resized);
	      }).catch(function (err) {
	        cb(null);
	        console.error(err);
	      });
	    };
	  };
	
	  ImageUploader.prototype.uploadImage = function uploadImage(file) {
	    var _this3 = this;
	
	    var uploader = this.props.options.uploader;
	
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    if (typeof uploader === 'function') {
	      this.setState({
	        uploading: true
	      });
	
	      uploader(file, function (ratio) {
	        _this3.setState({
	          uploading: true,
	          ratio: parseInt(ratio * 100)
	        });
	      }, function (data) {
	        // Step 4. UPload successful
	        _this3.setState({
	          uploading: false
	        }, function () {
	          // Step 5. Update the image url
	          _this3.props.onChange(data.save_to, file);
	        });
	      });
	    } else {}
	  };
	
	  ImageUploader.prototype.render = function render() {
	    var _props3 = this.props,
	        name = _props3.name,
	        value = _props3.value,
	        onChange = _props3.onChange,
	        required = _props3.required,
	        _props3$accept = _props3.accept,
	        accept = _props3$accept === undefined ? ACCEPT_MIME : _props3$accept,
	        _props3$maxSize = _props3.maxSize,
	        maxSize = _props3$maxSize === undefined ? MAX_SIZE : _props3$maxSize,
	        _props3$minSize = _props3.minSize,
	        minSize = _props3$minSize === undefined ? MIN_SIZE : _props3$minSize;
	    var _state = this.state,
	        existingImg = _state.existingImg,
	        lastUpdated = _state.lastUpdated,
	        uploading = _state.uploading,
	        ratio = _state.ratio;
	
	
	    var variance = '';
	    if (lastUpdated) {
	      variance = '?lastupdated=' + lastUpdated;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'imageuploader-wrapper form-input' },
	      _react2.default.createElement(_reactDropzone2.default, {
	        accept: accept,
	        multiple: false,
	        className: 'zone',
	        maxSize: maxSize,
	        minSize: minSize,
	        onDrop: this.onDrop,
	        children: _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(existingImg ? 'has-image' : 'has-no-image') },
	          uploading != true && _react2.default.createElement(
	            'div',
	            { className: 'overlay' },
	            _react2.default.createElement(
	              'div',
	              { className: 'text' },
	              __('Click or drag and drop image here', 'schoolInformation.form')
	            )
	          ),
	          uploading == true && _react2.default.createElement(
	            'div',
	            { className: 'upload-overlay' },
	            _react2.default.createElement(_rcProgress.Line, { percent: ratio, strokeWidth: '5', trailWidth: '5' }),
	            _react2.default.createElement(
	              'div',
	              null,
	              ratio || 0,
	              '%'
	            )
	          ),
	          !(0, _isEmpty2.default)(existingImg) && _react2.default.createElement('img', { src: existingImg + variance })
	        )
	      })
	    );
	  };
	
	  return ImageUploader;
	}(_react2.default.Component);
	
	exports.default = ImageUploader;
	module.exports = exports['default'];

/***/ },

/***/ "yV0A":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"imageuploader-wrapper":"imageuploader-wrapper","zone":"zone","overlay":"overlay","upload-overlay":"upload-overlay","text":"text","has-no-image":"has-no-image","has-image":"has-image","locale-EN":"locale-EN","create-student-modal-content":"create-student-modal-content"};

/***/ },

/***/ "Eh0C":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.money = money;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNumberFormat = __webpack_require__("RwBb");
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_SYMBOL = '$';
	
	function money(props) {
	  var options = props.options,
	      value = props.value,
	      onChange = props.onChange,
	      required = props.required;
	
	
	  return _react2.default.createElement(Money, _extends({
	    required: required,
	    value: value,
	    onChange: onChange
	  }, options));
	}
	
	var Money = function (_React$Component) {
	  _inherits(Money, _React$Component);
	
	  function Money(props) {
	    _classCallCheck(this, Money);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Money.prototype.render = function render() {
	    var _props = this.props,
	        value = _props.value,
	        _onChange = _props.onChange,
	        currency = _props.currency,
	        _props$symbol = _props.symbol,
	        symbol = _props$symbol === undefined ? DEFAULT_SYMBOL : _props$symbol,
	        required = _props.required,
	        hidden = _props.hidden,
	        disabled = _props.disabled,
	        allowNegative = _props.allowNegative;
	
	
	    var newValue = void 0;
	    if (!value) {
	      newValue = '';
	    } else {
	      newValue = value;
	    }
	
	    var displayHidden = hidden ? 'none' : '';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'number-input money form-input', style: { display: displayHidden } },
	      _react2.default.createElement(_reactNumberFormat2.default, {
	        disabled: disabled,
	        value: newValue,
	        allowNegative: allowNegative ? allowNegative : false,
	        onChange: function onChange(event) {
	          var value = event.target.value || '';
	          _onChange(value.replace('$', ''));
	        },
	        placeholder: '$0',
	        required: required,
	        decimalScale: 2,
	        thousandSeparator: false,
	        className: 'form-control',
	        prefix: symbol }),
	      _react2.default.createElement(
	        'div',
	        { className: 'unit-marker' },
	        currency
	      )
	    );
	  };
	
	  return Money;
	}(_react2.default.Component);
	
	exports.default = Money;

/***/ },

/***/ "j6CV":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.validateEmail = validateEmail;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _validator = __webpack_require__("+b6B");
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Email
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	function validateEmail(value) {
	
	  if (value && !_validator2.default.isEmail(value.trim())) {
	    return {
	      ok: false,
	      failed: {
	        because: ['invalid_email'],
	        value: value
	      }
	    };
	  }
	}
	
	var Email = function (_React$Component) {
	  _inherits(Email, _React$Component);
	
	  function Email(props) {
	    _classCallCheck(this, Email);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Email.prototype.componentWillMount = function componentWillMount() {};
	
	  Email.prototype.render = function render() {
	    var _props = this.props,
	        value = _props.value,
	        placeholder = _props.placeholder,
	        _onChange = _props.onChange;
	
	
	    return _react2.default.createElement('input', { type: 'email', value: value, className: 'form-control', placeholder: placeholder, onChange: function onChange(e) {
	        _onChange(e.target.value);
	      } });
	  };
	
	  return Email;
	}(_react2.default.Component);
	
	exports.default = Email;

/***/ },

/***/ "ioGM":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.validateRadio = validateRadio;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _validator = __webpack_require__("+b6B");
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Email
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	function validateRadio(value) {
	  if (!value) {
	    return {
	      ok: false,
	      failed: {
	        because: ['required'],
	        value: value
	      }
	    };
	  }
	}
	
	var Radio = function (_Component) {
	  _inherits(Radio, _Component);
	
	  function Radio(props) {
	    _classCallCheck(this, Radio);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  Radio.prototype.componentWillMount = function componentWillMount() {};
	
	  Radio.prototype.render = function render() {
	    var _props = this.props,
	        value = _props.value,
	        _onChange = _props.onChange,
	        options = _props.options;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('Radio') },
	      options.map(function (option, key) {
	        if (typeof option.value === 'undefined') {
	          throw new Error('{ value, label } are required.');
	        }
	        return _react2.default.createElement(
	          'label',
	          { className: 'control' },
	          _react2.default.createElement('input', { type: 'radio', key: key, checked: value == option.value, value: option.value, onChange: function onChange(e) {
	              _onChange(option.value);
	            } }),
	          _react2.default.createElement('span', { className: 'radiomark' }),
	          ' ',
	          option.label
	        );
	      })
	    );
	  };
	
	  return Radio;
	}(_react.Component);
	
	exports.default = Radio;

/***/ },

/***/ "Ivgm":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.validateName = validateName;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function validateName(value) {
	  if (!value.firstName || !value.lastName) {
	    return {
	      ok: false,
	      failed: {
	        because: ['required'],
	        value: value
	      }
	    };
	  }
	}
	
	var Name = function (_React$Component) {
	  _inherits(Name, _React$Component);
	
	  function Name(props) {
	    _classCallCheck(this, Name);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  Name.prototype.onChange = function onChange(name) {
	    var _this2 = this;
	
	    var onChange = this.props.onChange;
	
	    return function (e) {
	      var _extends2;
	
	      onChange(_extends({}, _this2.props.value, (_extends2 = {}, _extends2[name] = e.target.value, _extends2)));
	    };
	  };
	
	  Name.prototype.render = function render() {
	    var _props = this.props,
	        _props$value = _props.value,
	        value = _props$value === undefined ? {} : _props$value,
	        onChange = _props.onChange,
	        label = _props.label,
	        required = _props.required,
	        className = _props.className;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'row ' + className },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-xs-6' },
	        _react2.default.createElement('input', { className: 'form-control', value: value.firstName, onChange: this.onChange('firstName'), placeholder: __('First Name', 'createstudent') })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-xs-6' },
	        _react2.default.createElement('input', { className: 'form-control', value: value.lastName, onChange: this.onChange('lastName'), placeholder: __('Last Name', 'createstudent') })
	      )
	    );
	  };
	
	  return Name;
	}(_react2.default.Component);
	
	exports.default = Name;

/***/ },

/***/ "yKsk":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.validateGuardian = validateGuardian;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("RtBd");
	
	var _Input = __webpack_require__("n/J4");
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _PhoneNumber = __webpack_require__("GM/A");
	
	var _PhoneNumber2 = _interopRequireDefault(_PhoneNumber);
	
	var _locale = __webpack_require__("BVVL");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _validator = __webpack_require__("+b6B");
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Address />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * NOTE: we're using address data inside data/address.js instead of having
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * a detached address file for this form.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	function validateGuardian(value) {
	  if (value.email && !_validator2.default.isEmail(value.email.trim())) {
	    return {
	      ok: false,
	      failed: {
	        because: ['invalid_email'],
	        value: value
	      }
	    };
	  }
	}
	
	var Guardian = function (_React$Component) {
	  _inherits(Guardian, _React$Component);
	
	  function Guardian(props) {
	    _classCallCheck(this, Guardian);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  Guardian.prototype.onChange = function onChange(itemName, itemValue) {
	    var _extends2;
	
	    var _props = this.props,
	        value = _props.value,
	        onChange = _props.onChange;
	
	
	    onChange(_extends({}, value, (_extends2 = {}, _extends2[itemName] = itemValue, _extends2)), itemName);
	  };
	
	  Guardian.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props2 = this.props,
	        name = _props2.name,
	        value = _props2.value;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'guardianInfo-wrapper form-input' },
	      _react2.default.createElement(
	        'div',
	        { className: 'form-group guardianInfo' },
	        _react2.default.createElement(_Input2.default, { className: 'outline-form-field', placeholder: __('Guardian Name', _locale2.default), onChange: function onChange(name) {
	            _this2.onChange('name', name);
	          }, value: value.name }),
	        _react2.default.createElement(_Input2.default, { className: 'parent-email outline-form-field', placeholder: __('Guardian Email', _locale2.default), onChange: function onChange(email) {
	            _this2.onChange('email', email);
	          }, value: value.email }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_PhoneNumber2.default, {
	            className: 'form-control',
	            defaultCountry: 'ca',
	            value: value.phoneParsed,
	            onChange: function onChange(phoneParsed) {
	              _this2.onChange('phoneParsed', phoneParsed);
	            },
	            onlyCountries: ['ca', 'us'],
	            disableAreaCodes: true
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'tip' },
	            __('Guardian can use phone number to sign up and log in mobile app', _locale2.default)
	          )
	        ),
	        _react2.default.createElement(_Input2.default, { className: 'outline-form-field', placeholder: __('Relationship', _locale2.default), onChange: function onChange(relationship) {
	            _this2.onChange('relationship', relationship);
	          }, value: value.relationship })
	      )
	    );
	  };
	
	  return Guardian;
	}(_react2.default.Component);
	
	exports.default = Guardian;

/***/ },

/***/ "RtBd":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"guardianInfo":"guardianInfo","phone-number":"phone-number","tip":"tip"};

/***/ },

/***/ "n/J4":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Input = function (_React$Component) {
	  _inherits(Input, _React$Component);
	
	  function Input(props) {
	    _classCallCheck(this, Input);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  Input.prototype.onChange = function onChange(e) {
	    this.props.onChange(e.target.value);
	  };
	
	  Input.prototype.render = function render() {
	    var _props = this.props,
	        value = _props.value,
	        label = _props.label,
	        type = _props.type,
	        className = _props.className,
	        placeholder = _props.placeholder;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('row', className) },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-xs-12' },
	        _react2.default.createElement('input', { className: 'form-control', type: type, value: value, onChange: this.onChange, placeholder: placeholder })
	      )
	    );
	  };
	
	  return Input;
	}(_react2.default.Component);
	
	exports.default = Input;
	module.exports = exports['default'];

/***/ },

/***/ "BVVL":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'GuardianComponent',
	  code: 'CN',
	  text: {
	    'Guardian Name': '家长姓名',
	    'Guardian Email': '家长邮箱',
	    'Guardian can use phone number to sign up and log in mobile app': '家长将可以使用手机号注册登录手机 app',
	    'Relationship': '亲属关系',
	    '': ''
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "+gOk":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _cloneDeep = __webpack_require__("kvU2");
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	__webpack_require__("qBFl");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ObjectArray 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ObjectArray = function (_React$Component) {
	  _inherits(ObjectArray, _React$Component);
	
	  function ObjectArray(props) {
	    _classCallCheck(this, ObjectArray);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.addItem = _this.addItem.bind(_this);
	    _this.removeItem = _this.removeItem.bind(_this);
	    return _this;
	  }
	
	  ObjectArray.prototype.componentWillMount = function componentWillMount() {};
	
	  ObjectArray.prototype.addItem = function addItem(index) {
	    var _this2 = this;
	
	    return function () {
	      var returnValue = (0, _cloneDeep2.default)(_this2.props.value || []);
	      returnValue.splice(index + 1, 0, {});
	      _this2.props.onChange(returnValue);
	    };
	  };
	
	  ObjectArray.prototype.removeItem = function removeItem(index) {
	    var _this3 = this;
	
	    return function () {
	      var returnValue = (0, _cloneDeep2.default)(_this3.props.value || []);
	      returnValue.splice(index, 1);
	      _this3.props.onChange(returnValue);
	    };
	  };
	
	  ObjectArray.prototype.onChange = function onChange(index) {
	    var _this4 = this;
	
	    return function (itemValue) {
	      var returnValue = (0, _cloneDeep2.default)(_this4.props.value);
	      returnValue[index] = itemValue;
	      _this4.props.onChange(returnValue);
	    };
	  };
	
	  ObjectArray.prototype.render = function render() {
	    var _this5 = this;
	
	    var _props = this.props,
	        _props$objectSchema = _props.objectSchema,
	        objectSchema = _props$objectSchema === undefined ? [] : _props$objectSchema,
	        _props$value = _props.value,
	        value = _props$value === undefined ? [] : _props$value;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'ObjectArray' },
	      _react2.default.createElement(
	        'ul',
	        { className: (0, _classnames2.default)('ObjectArray--basket', { 'has-padding-bottom': value.length == 0 }) },
	        value.length > 0 && value.map(function (itemValue, index) {
	          return _react2.default.createElement(
	            'li',
	            { key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'ObjectArray--item' },
	              _react2.default.createElement(
	                'a',
	                { className: 'delete-btn', onClick: _this5.removeItem(index) },
	                _react2.default.createElement('i', { className: 'fa icon-cancel' })
	              ),
	              _react2.default.createElement(_Form2.default, {
	                formStyle: 'outline',
	                onChange: _this5.onChange(index),
	                formData: itemValue,
	                schema: objectSchema
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'ObjectArray--addArrayItem' },
	              _react2.default.createElement('i', {
	                className: 'addButton fa icon-plus',
	                onClick: _this5.addItem(index) })
	            )
	          );
	        }),
	        value.length == 0 && _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'ObjectArray--addArrayItem' },
	            _react2.default.createElement('i', {
	              className: 'addButton fa icon-plus',
	              onClick: this.addItem(0) })
	          )
	        )
	      )
	    );
	  };
	
	  return ObjectArray;
	}(_react2.default.Component);
	
	exports.default = ObjectArray;
	module.exports = exports['default'];

/***/ },

/***/ "qBFl":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ObjectArray":"ObjectArray","ObjectArray--basket":"ObjectArray--basket","has-padding-bottom":"has-padding-bottom","ObjectArray--item":"ObjectArray--item","control-input":"control-input","delete-btn":"delete-btn","ObjectArray--addArrayItem":"ObjectArray--addArrayItem","addButton":"addButton"};

/***/ },

/***/ "jIpW":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("pFGo");
	
	var _MediaCenter = __webpack_require__("LEzc");
	
	var _MediaCenter2 = _interopRequireDefault(_MediaCenter);
	
	var _locale = __webpack_require__("K6rp");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <MediaCenterInput 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var MediaCenterInput = function (_React$Component) {
	  _inherits(MediaCenterInput, _React$Component);
	
	  function MediaCenterInput(props) {
	    _classCallCheck(this, MediaCenterInput);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.openMediaCenterInput = _this.openMediaCenterInput.bind(_this);
	    return _this;
	  }
	
	  MediaCenterInput.prototype.componentWillMount = function componentWillMount() {};
	
	  MediaCenterInput.prototype.openMediaCenterInput = function openMediaCenterInput() {
	    var _props = this.props,
	        selectMultiple = _props.selectMultiple,
	        onChange = _props.onChange;
	
	
	    (0, _MediaCenter2.default)({
	      selectMultiple: selectMultiple
	    }).then(function () {
	      var images = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      if (images.length > 0) {
	        if (selectMultiple) {
	          onChange(images);
	        } else {
	          onChange(images[0]);
	        }
	      }
	    });
	  };
	
	  MediaCenterInput.prototype.render = function render() {
	    var _props2 = this.props,
	        value = _props2.value,
	        onChange = _props2.onChange;
	
	
	    var images = [];
	    if (value) {
	      if (Array.isArray(value)) {
	        images = value;
	      } else {
	        images = [value];
	      }
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'MediaCenterInput' },
	      _react2.default.createElement(
	        'ul',
	        { 'class': 'MediaCenterInput--thumbnail--list' },
	        images.map(function () {
	          var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          return _react2.default.createElement(
	            'li',
	            { className: 'MediaCenterInput--thumbnail' },
	            _react2.default.createElement('img', { src: src.thumbnail_url || src.original_url })
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary', onClick: this.openMediaCenterInput },
	        __('Add Image', _locale2.default)
	      )
	    );
	  };
	
	  return MediaCenterInput;
	}(_react2.default.Component);
	
	exports.default = MediaCenterInput;
	module.exports = exports['default'];

/***/ },

/***/ "pFGo":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"MediaCenterInput--thumbnail":"MediaCenterInput--thumbnail"};

/***/ },

/***/ "LEzc":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	
	  if (!opts.hasOwnProperty('selectMultiple')) {
	    throw new Error('Missing selectMultiple props, please pass in props: selectMultiple (boolean)');
	  }
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalProvider = __webpack_require__("vKLx");
	
	var _ModalProvider2 = _interopRequireDefault(_ModalProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalProvider2.default);
	
	module.exports = exports['default'];

/***/ },

/***/ "vKLx":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalBody = __webpack_require__("8sZl");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalProvider = function (_React$Component) {
	  _inherits(ModalProvider, _React$Component);
	
	  function ModalProvider(props) {
	    _classCallCheck(this, ModalProvider);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalProvider.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(_ModalBody2.default, this.props)
	    );
	  };
	
	  return ModalProvider;
	}(_react2.default.Component);
	
	exports.default = ModalProvider;
	module.exports = exports['default'];

/***/ },

/***/ "8sZl":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _ModalContent = __webpack_require__("XcCu");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _getUserByToken = __webpack_require__("v34H");
	
	var _getUserByToken2 = _interopRequireDefault(_getUserByToken);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _locale = __webpack_require__("0i1Q");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("ul+r");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {};
	
	    return _this;
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel,
	        user = _props.user;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'media-center-modal',
	        hasHeader: true,
	        hasFooter: true,
	        headerTitle: __("Media Center", _locale2.default),
	        fixedWidth: '90%',
	        contentHeight: 500,
	
	        onCloseModalClick: dismiss,
	
	        footerType: 'grey',
	        footerButtons: [{
	          title: __('Complete', 'appwrapper'),
	          className: 'btn btn-primary pull-right',
	          isDisabled: function isDisabled() {},
	          onClick: function onClick() {
	            proceed(_this2.formData);
	          }
	        }]
	        // footerCustomContent={this.footerContent()}
	        , isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, _extends({}, this.props, {
	        onFormChange: function onFormChange(stateFromModalContent) {
	          _this2.formData = stateFromModalContent;
	        }
	      }))
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactConfirm.confirmable)(ModalBody));
	module.exports = exports['default'];

/***/ },

/***/ "XcCu":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _DefaultTab = __webpack_require__("EmVc");
	
	var _DefaultTab2 = _interopRequireDefault(_DefaultTab);
	
	var _locale = __webpack_require__("0i1Q");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("ul+r");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      selectedIndex: 0
	    };
	
	    _this.onTabSelected = _this.onTabSelected.bind(_this);
	    return _this;
	  }
	
	  ModalContent.prototype.onTabSelected = function onTabSelected(selectedIndex) {
	    this.setState({ selectedIndex: selectedIndex });
	  };
	
	  ModalContent.prototype.render = function render() {
	    var selectedIndex = this.state.selectedIndex;
	
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      { className: 'media-center-content' },
	      _react2.default.createElement(
	        _UI.Tabs,
	        { selectedIndex: selectedIndex, onSelect: this.onTabSelected },
	        _react2.default.createElement(
	          _UI.TabList,
	          null,
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('Upload Files', _locale2.default)
	          ),
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('Media Library', _locale2.default)
	          ),
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('Public Media Library', _locale2.default)
	          )
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, {
	            mediaState: 'upload',
	            selectMultiple: this.props.selectMultiple,
	            selectedIndexChange: this.onTabSelected,
	            onFormChange: this.props.onFormChange
	          })
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, {
	            mediaState: 'list',
	            selectMultiple: this.props.selectMultiple,
	            selectedIndexChange: this.onTabSelected,
	            onFormChange: this.props.onFormChange
	          })
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, {
	            mediaState: 'public',
	            selectMultiple: this.props.selectMultiple,
	            selectedIndexChange: this.onTabSelected,
	            onFormChange: this.props.onFormChange
	          })
	        )
	      )
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "EmVc":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDropzone = __webpack_require__("KTM0");
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _ImageCropper = __webpack_require__("jlVy");
	
	var _ImageCropper2 = _interopRequireDefault(_ImageCropper);
	
	var _imageUploader = __webpack_require__("X2ik");
	
	var _imageUploader2 = _interopRequireDefault(_imageUploader);
	
	var _alert = __webpack_require__("BGi1");
	
	var _rcProgress = __webpack_require__("McaX");
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _locale = __webpack_require__("0i1Q");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _MediaList = __webpack_require__("L+or");
	
	var _MediaList2 = _interopRequireDefault(_MediaList);
	
	__webpack_require__("ul+r");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ACCEPT_MIME = 'image/png,image/jpeg';
	var MAX_SIZE = 5 * 1024 * 1024;
	var MIN_SIZE = 0;
	
	var DefaultTab = function (_Component) {
	  _inherits(DefaultTab, _Component);
	
	  function DefaultTab(props) {
	    _classCallCheck(this, DefaultTab);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      uploading: false,
	      progress: '0'
	    };
	
	    _this.selectImage = _this.selectImage.bind(_this);
	    _this.increaseProgressBar = _this.increaseProgressBar.bind(_this);
	    return _this;
	  }
	
	  DefaultTab.prototype.selectImage = function selectImage(accepted, rejected) {
	    var _this2 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    if (rejected.length > 0) {
	      _alert.alert.warning(__('Image file must be png/jpeg under 5 MB', 'image'), __('Image not qualified', 'image'));
	      return;
	    } else if (accepted.length === 0) {
	      _alert.alert.warning('', __('No Image Selected'));
	      return;
	    }
	
	    this.setState({ uploading: true });
	    // Option 1
	    // this.startProgressBar()
	
	    (0, _imageUploader2.default)(schoolId, accepted[0]).then(function (res) {
	      // Option 1 below commented
	      // clearTimeout(this.tm);
	      _this2.props.selectedIndexChange(1);
	      _this2.setState({ uploading: false });
	    });
	  };
	
	  // Option 1 function
	
	
	  DefaultTab.prototype.increaseProgressBar = function increaseProgressBar() {
	    var progress = this.state.progress + 3;
	    if (progress > 100) {
	      clearTimeout(this.tm);
	      return;
	    }
	
	    this.setState({ progress: progress });
	    this.tm = setTimeout(this.increaseProgressBar, 5);
	  };
	
	  // Option 1 function
	
	
	  DefaultTab.prototype.startProgressBar = function startProgressBar() {
	    var _this3 = this;
	
	    clearTimeout(this.tm);
	    this.setState({ progress: 0 }, function () {
	      _this3.increaseProgressBar();
	    });
	  };
	
	  DefaultTab.prototype.render = function render() {
	    var mediaState = this.props.mediaState;
	    var _state = this.state,
	        uploading = _state.uploading,
	        progress = _state.progress;
	
	
	    if (mediaState == 'upload') {
	      return _react2.default.createElement(
	        'div',
	        null,
	        !uploading && _react2.default.createElement(
	          'a',
	          null,
	          _react2.default.createElement(_reactDropzone2.default, {
	            accept: ACCEPT_MIME,
	            multiple: false,
	            className: 'MediaCenter--dropzone',
	            maxSize: MAX_SIZE,
	            minSize: MIN_SIZE,
	            onDrop: this.selectImage,
	            children: _react2.default.createElement(
	              'div',
	              { className: 'container-overlay' },
	              _react2.default.createElement(
	                'div',
	                { className: 'text' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  __('Click or drag and drop image here', 'schoolInformation.form')
	                ),
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  __('Max file size: 5 MB', 'schoolInformation.form')
	                )
	              )
	            )
	          })
	        ),
	        uploading && _react2.default.createElement(
	          'div',
	          { className: 'loading-container' },
	          _react2.default.createElement(_Loading2.default, null),
	          _react2.default.createElement(
	            'p',
	            null,
	            __('Uploading...', _locale2.default)
	          )
	        )
	      );
	    } else if (mediaState == 'list') {
	      return _react2.default.createElement(_MediaList2.default, { mediaState: 'list', selectMultiple: this.props.selectMultiple, onFormChange: this.props.onFormChange });
	    } else if (mediaState == 'public') {
	      return _react2.default.createElement(_MediaList2.default, { mediaState: 'public', selectMultiple: this.props.selectMultiple, onFormChange: this.props.onFormChange });
	    }
	  };
	
	  return DefaultTab;
	}(_react.Component);
	
	exports.default = DefaultTab;
	module.exports = exports['default'];

/***/ },

/***/ "X2ik":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _default(schoolId, file, _onUploadProgress) {
	  var API_URL = void 0;
	  if (false) {
	    API_URL = 'https://saas.classtop.com:3001/sapi';
	  } else {
	    API_URL = 'https://school.classtop.com:3001/sapi';
	  }
	
	  if (!schoolId) {
	    throw 'Missing school ID';
	  }
	
	  if (!file) {
	    throw 'Missing blob';
	  }
	
	  return new Promise(function (resolve, reject) {
	    var data = new FormData();
	    data.append('pic', file);
	
	    _axios2.default.post(API_URL + '/media_library/' + schoolId + '/', data, {
	      'onUploadProgress': function onUploadProgress(progress) {
	        if (typeof _onUploadProgress == 'function') {
	          progress.ratio = progress.loaded / progress.total;
	          _onUploadProgress(progress);
	        }
	      },
	      headers: {
	        'Authorization': 'JWT ' + localStorage.getItem('token'),
	        'Content-Type': 'multipart/form-data'
	      }
	    }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {});
	  });
	} // We're using direct HTTP calls here, skipping Proxy
	exports.default = _default;
	module.exports = exports['default'];

/***/ },

/***/ "0i1Q":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'MediaCenter',
	  code: 'CN',
	  text: {
	    'Media Center': '媒体中心',
	    'Upload Files': '上传文件',
	    'Media Library': '媒体库',
	    'Public Media Library': '公用媒体库',
	    'Upload Successfully': '上传成功',
	    'Proceed to delete image?': '确认删除图片吗？',
	    'All Record': '所有纪录',
	    'Uploading...': '上传中...'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "L+or":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getMediaList = __webpack_require__("xDRm");
	
	var _deleteMedia2 = __webpack_require__("3AlC");
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _reactJsPagination = __webpack_require__("bgMy");
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _reactMonthPicker = __webpack_require__("M2KA");
	
	var _reactMonthPicker2 = _interopRequireDefault(_reactMonthPicker);
	
	__webpack_require__("Rwn/");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _locale = __webpack_require__("0i1Q");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("ul+r");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MONTHS = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    mediaCenter: state.mediaCenter
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchMediaList: function fetchMediaList(schoolId, opts) {
	      return dispatch((0, _getMediaList.fetchMediaList)(schoolId, opts));
	    },
	    deleteMedia: function deleteMedia(index, schoolId, prefix, callback) {
	      return dispatch((0, _deleteMedia2.deleteMedia)(index, schoolId, prefix, callback));
	    }
	  };
	};
	
	var MediaList = function (_Component) {
	  _inherits(MediaList, _Component);
	
	  function MediaList(props) {
	    _classCallCheck(this, MediaList);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      photo: [],
	      toggleImage: {},
	      selectedYear: (0, _moment2.default)().subtract(1, 'months').get('year'),
	      selectedMonth: (0, _moment2.default)().get('month') + 1
	
	    };
	
	    _this.selectImage = _this.selectImage.bind(_this);
	    _this.fetchMedia = _this.fetchMedia.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.onDateClicked = _this.onDateClicked.bind(_this);
	    _this.onDateSearch = _this.onDateSearch.bind(_this);
	
	    return _this;
	  }
	
	  MediaList.prototype.componentDidMount = function componentDidMount() {
	    this.fetchMedia(1);
	  };
	
	  MediaList.prototype.fetchMedia = function fetchMedia(newPageNumber, newAmountPerPage) {
	    var _props$mediaCenter$pa = this.props.mediaCenter.pagination,
	        activePage = _props$mediaCenter$pa.activePage,
	        itemsCountPerPage = _props$mediaCenter$pa.itemsCountPerPage;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    if (this.props.mediaState == 'list') {
	      this.props.fetchMediaList(schoolId, { amount_per_page: newAmountPerPage || itemsCountPerPage, current_page_number: newPageNumber });
	    } else if (this.props.mediaState == 'public') {
	      this.props.fetchMediaList(schoolId, { amount_per_page: newAmountPerPage || itemsCountPerPage, current_page_number: newPageNumber, public: 1 });
	    }
	  };
	
	  MediaList.prototype.selectImage = function selectImage(key, photo) {
	    var _this2 = this;
	
	    return function () {
	      if (_this2.props.selectMultiple) {
	        var _extends2;
	
	        var photoArr = _this2.state.photo;
	        photoArr.push(photo);
	
	        // this is to remove any duplicates inside the array
	        var newArr = Array.from(new Set(photoArr));
	
	        _this2.setState({
	          toggleImage: _extends({}, _this2.state.toggleImage, (_extends2 = {}, _extends2[key] = _this2.state.toggleImage[key] !== true, _extends2)),
	          photo: newArr
	        }, function () {
	          _this2.props.onFormChange(_this2.state.photo);
	        });
	      } else {
	        var _toggleImage;
	
	        _this2.setState({
	          toggleImage: (_toggleImage = {}, _toggleImage[key] = _this2.state.toggleImage[key] !== true, _toggleImage),
	          photo: [photo]
	        }, function () {
	          _this2.props.onFormChange(_this2.state.photo);
	        });
	      }
	    };
	  };
	
	  MediaList.prototype.onPageChange = function onPageChange(activePage) {
	    if (activePage == this.props.mediaCenter.pagination.activePage) {
	      return;
	    }
	
	    this.fetchMedia(activePage);
	  };
	
	  MediaList.prototype.onDateClicked = function onDateClicked() {
	    this.refs.pickAMonth.show();
	  };
	
	  MediaList.prototype.onDateSearch = function onDateSearch(year, month) {
	    var _props$mediaCenter$pa2 = this.props.mediaCenter.pagination,
	        activePage = _props$mediaCenter$pa2.activePage,
	        itemsCountPerPage = _props$mediaCenter$pa2.itemsCountPerPage;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    // format month from 3 to 03
	    var newMonth = month < 10 ? '0' + month.toString() : month.toString();
	    this.setState({ selectedYear: year, selectedMonth: month });
	    this.props.fetchMediaList(schoolId, {
	      amount_per_page: itemsCountPerPage,
	      current_page_number: activePage,
	      year_month: year + newMonth
	    });
	  };
	
	  MediaList.prototype.render = function render() {
	    var _this3 = this;
	
	    var mediaCenter = this.props.mediaCenter;
	    var _mediaCenter$paginati = mediaCenter.pagination,
	        activePage = _mediaCenter$paginati.activePage,
	        itemsCountPerPage = _mediaCenter$paginati.itemsCountPerPage,
	        totalItemsCount = _mediaCenter$paginati.totalItemsCount;
	    var _state = this.state,
	        toggleImage = _state.toggleImage,
	        photo = _state.photo,
	        selectedYear = _state.selectedYear,
	        selectedMonth = _state.selectedMonth;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    if (!mediaCenter.list || mediaCenter.fetching) {
	      return _react2.default.createElement(_Loading2.default, null);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: 'pull-left tuitionReceipt', style: { cursor: 'pointer', marginRight: '10px' }, onClick: function onClick() {
	            _this3.fetchMedia(1);
	          } },
	        _react2.default.createElement('i', { className: 'fa icon-folder' }),
	        _react2.default.createElement(
	          'span',
	          { style: { marginLeft: '10px' } },
	          __('All Record', _locale2.default)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { onClick: this.onDateClicked, style: { cursor: 'pointer', marginBottom: '20px' } },
	        _react2.default.createElement('i', { className: 'fa icon-calendar', 'aria-hidden': 'true' }),
	        _react2.default.createElement(
	          'span',
	          { style: { marginLeft: '10px' } },
	          __('Search by Date', 'monthlyFinance')
	        )
	      ),
	      _react2.default.createElement(_reactMonthPicker2.default, {
	        ref: 'pickAMonth',
	        years: { min: { year: 2014, month: 1 }, max: { year: (0, _moment2.default)().subtract(1, 'months').get('year'), month: (0, _moment2.default)().get('month') + 1 } },
	        value: { year: selectedYear, month: selectedMonth },
	        lang: MONTHS,
	        theme: 'dark',
	        onChange: this.onDateSearch
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'media-list' },
	        mediaCenter.list.map(function (photo, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'photo-container', key: index },
	            _react2.default.createElement('img', { className: (0, _classnames2.default)('image', { 'active': toggleImage[index] == true }), src: photo.thumbnail_url, onClick: _this3.selectImage(index, photo) }),
	            _this3.props.mediaState == 'list' && _react2.default.createElement('i', { className: 'fa icon-cancel', onClick: function onClick() {
	                var regex = /(schools\/.*)/;
	                var prefix = regex.exec(photo.original_url);
	                (0, _confirm.confirm)(__('Proceed to delete image?', _locale2.default)).then(function () {
	                  _this3.props.deleteMedia(index, schoolId, { prefix: prefix[0] }, function () {
	                    _this3.fetchMedia(activePage);
	                  });
	                }).catch(function () {});
	              } })
	          );
	        })
	      ),
	      _react2.default.createElement(_reactJsPagination2.default, {
	        innerClass: 'pagination pull-right',
	        activePage: activePage,
	        itemsCountPerPage: itemsCountPerPage,
	        totalItemsCount: totalItemsCount,
	        pageRangeDisplayed: 5,
	        onChange: this.onPageChange
	      })
	    );
	  };
	
	  return MediaList;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MediaList);
	module.exports = exports['default'];

/***/ },

/***/ "xDRm":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_FETCH_MEDIA_LIST = exports.SUCCESS_FETCH_MEDIA_LIST = exports.START_FETCH_MEDIA_LIST = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Import controller
	
	
	exports.fetchMediaList = fetchMediaList;
	
	var _getMediaCenter = __webpack_require__("mjCm");
	
	var _getMediaCenter2 = _interopRequireDefault(_getMediaCenter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Fetch Announcement Actions
	var START_FETCH_MEDIA_LIST = exports.START_FETCH_MEDIA_LIST = 'START_FETCH_MEDIA_LIST';
	var SUCCESS_FETCH_MEDIA_LIST = exports.SUCCESS_FETCH_MEDIA_LIST = 'SUCCESS_FETCH_MEDIA_LIST';
	var FAILED_FETCH_MEDIA_LIST = exports.FAILED_FETCH_MEDIA_LIST = 'FAILED_FETCH_MEDIA_LIST';
	
	// Fetch Action Creator
	function fetchMediaList(schoolId, obj) {
	  return function (dispatch) {
	
	    dispatch({
	      type: START_FETCH_MEDIA_LIST,
	      payload: { fetching: true }
	    });
	
	    (0, _getMediaCenter2.default)(schoolId, obj).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_MEDIA_LIST,
	        payload: _extends({}, result, { fetching: false, hasPermission: true })
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_MEDIA_LIST,
	        payload: { error: err, fetching: false, hasPermission: false }
	      });
	    });
	  };
	}

/***/ },

/***/ "mjCm":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getMediaCenter;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getMediaCenter(schoolId, opts) {
	
	  if (!schoolId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school Id')
	      });
	    });
	  }
	
	  var query = _queryString2.default.stringify({
	    amount_per_page: opts.amount_per_page,
	    current_page_number: opts.current_page_number,
	    year_month: opts.year_month,
	    public: opts.public
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/media_library/" + schoolId + "/?" + query,
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "3AlC":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_DELETE_MEDIA = exports.SUCCESS_DELETE_MEDIA = exports.START_DELETE_MEDIA = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Import controller
	
	
	exports.deleteMedia = deleteMedia;
	
	var _deleteMedia = __webpack_require__("EKXO");
	
	var _deleteMedia2 = _interopRequireDefault(_deleteMedia);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	var START_DELETE_MEDIA = exports.START_DELETE_MEDIA = 'START_DELETE_MEDIA';
	var SUCCESS_DELETE_MEDIA = exports.SUCCESS_DELETE_MEDIA = 'SUCCESS_DELETE_MEDIA';
	var FAILED_DELETE_MEDIA = exports.FAILED_DELETE_MEDIA = 'FAILED_DELETE_MEDIA';
	
	// Action Creator
	function deleteMedia(index, schoolId, prefix, callback) {
	  return function (dispatch) {
	
	    dispatch({
	      type: START_DELETE_MEDIA,
	      payload: { deleting: true, index: index }
	    });
	
	    (0, _deleteMedia2.default)(schoolId, prefix).then(function (result) {
	      dispatch({
	        type: SUCCESS_DELETE_MEDIA,
	        payload: _extends({}, result, { deleting: false })
	      });
	
	      if (typeof callback == 'function') {
	        callback();
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_DELETE_MEDIA,
	        payload: err
	      });
	    });
	  };
	}

/***/ },

/***/ "EKXO":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = deleteMedia;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  "prefix": _joiBrowser2.default.string().required()
	});
	
	function deleteMedia(schoolId, prefix) {
	
	  if (!schoolId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school Id')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(prefix, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/media_library/" + schoolId + "/",
	      'method': 'PUT',
	      'data': JSON.stringify(prefix),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "ul+r":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"media-center-modal":"media-center-modal","modal-float-body":"modal-float-body","classtop-modal-content":"classtop-modal-content","rc-progress-circle":"rc-progress-circle","loading-container":"loading-container","classtop-loading":"classtop-loading","panel-wrapper-content":"panel-wrapper-content","MediaCenter--dropzone":"MediaCenter--dropzone","container-overlay":"container-overlay","text":"text","media-list":"media-list","photo-container":"photo-container","icon-cancel":"icon-cancel","image":"image","active":"active"};

/***/ },

/***/ "K6rp":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'MediaCenterInputField',
	  code: 'CN',
	  text: {
	    'Add Image': '选择图片'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "A+Vk":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp; /**
	                    * <TimePicker2
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _times = __webpack_require__("sHbl");
	
	var _times2 = _interopRequireDefault(_times);
	
	__webpack_require__("tBjh");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_STATE = {
	  hour: '',
	  minute: '',
	  ampm: ''
	};
	
	var TimePicker2 = (_temp = _class = function (_React$Component) {
	  _inherits(TimePicker2, _React$Component);
	
	  function TimePicker2(props) {
	    _classCallCheck(this, TimePicker2);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.renderHours = _this.renderHours.bind(_this);
	    _this.renderMinutes = _this.renderMinutes.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.setMomentToStrTime = _this.setMomentToStrTime.bind(_this);
	    if (props.value) {
	      _this.state = _extends({}, _this.setMomentToStrTime(props.value));
	    } else {
	      _this.state = _extends({}, DEFAULT_STATE);
	    }
	    return _this;
	  }
	
	  TimePicker2.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var value = _ref.value;
	
	    if (value) {
	      this.setState(this.setMomentToStrTime(value));
	    } else {
	      this.setState(_extends({}, DEFAULT_STATE));
	    }
	  };
	
	  TimePicker2.prototype.setMomentToStrTime = function setMomentToStrTime(value) {
	    return {
	      hour: value.format('h'),
	      minute: value.format('mm'),
	      ampm: value.format('a')
	    };
	  };
	
	  TimePicker2.prototype.onChange = function onChange(name) {
	    var _this2 = this;
	
	    return function (e) {
	      var value = e.target.value;
	      var newData = {};
	      switch (name) {
	        case 'hour':
	          newData = {
	            hour: value
	          };
	          break;
	        case 'minute':
	          newData = {
	            minute: value
	          };
	          break;
	        case 'ampm':
	          newData = {
	            ampm: value
	          };
	          break;
	      }
	
	      var onChange = _this2.props.onChange;
	
	
	      _this2.setState(_extends({}, newData), function () {
	        var _state = _this2.state,
	            hour = _state.hour,
	            minute = _state.minute,
	            ampm = _state.ampm;
	
	
	        var strValue = hour + ':' + minute + ' ' + ampm;
	
	        var momentValue = (0, _moment2.default)(strValue, 'h:mm a');
	
	        onChange(momentValue, strValue);
	      });
	    };
	  };
	
	  TimePicker2.prototype.renderHours = function renderHours() {
	    return _react2.default.createElement(
	      'select',
	      { value: this.state.hour, onChange: this.onChange('hour'), className: 'form-control' },
	      _react2.default.createElement('option', null),
	      (0, _times2.default)(12, function (num, key) {
	        var hour = num + 1;
	        return _react2.default.createElement(
	          'option',
	          { value: hour, key: num },
	          hour
	        );
	      })
	    );
	  };
	
	  TimePicker2.prototype.renderMinutes = function renderMinutes() {
	    var _props$minuteStep = this.props.minuteStep,
	        minuteStep = _props$minuteStep === undefined ? 5 : _props$minuteStep;
	
	
	    var numOfSteps = parseInt(60 / 5);
	
	    return _react2.default.createElement(
	      'select',
	      { value: this.state.minute, onChange: this.onChange('minute'), className: 'form-control' },
	      _react2.default.createElement('option', null),
	      (0, _times2.default)(numOfSteps, function (num, key) {
	        var value = num * minuteStep;
	        var minute = value < 10 ? '0' + value : value;
	        return _react2.default.createElement(
	          'option',
	          { value: minute, key: num },
	          minute
	        );
	      })
	    );
	  };
	
	  TimePicker2.prototype.render = function render() {
	    var ampm = this.state.ampm;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'timepicker-2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'timepicker-2-fields' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group hour' },
	          this.renderHours()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group minute' },
	          this.renderMinutes()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group am-pm' },
	          _react2.default.createElement(
	            'select',
	            { value: ampm, onChange: this.onChange('ampm'), className: 'form-control' },
	            _react2.default.createElement('option', null),
	            _react2.default.createElement(
	              'option',
	              { value: 'am', key: 1 },
	              'AM'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 'pm', key: 2 },
	              'PM'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return TimePicker2;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = TimePicker2;
	module.exports = exports['default'];

/***/ },

/***/ "tBjh":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"timepicker-2":"timepicker-2","form-group":"form-group","form-control":"form-control"};

/***/ },

/***/ "UsQE":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.validateWeekdateSelect = validateWeekdateSelect;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _validator = __webpack_require__("+b6B");
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _reactSelect = __webpack_require__("tTw2");
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _locale = __webpack_require__("6voC");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Email
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var options = [{ value: '1', label: __('Monday', _locale2.default) }, { value: '2', label: __('Tuesday', _locale2.default) }, { value: '3', label: __('Wednesday', _locale2.default) }, { value: '4', label: __('Thursday', _locale2.default) }, { value: '5', label: __('Friday', _locale2.default) }, { value: '6', label: __('Saturaday', _locale2.default) }, { value: '7', label: __('Sunday', _locale2.default) }];
	function validateWeekdateSelect(value) {
	  if (!value || value.length < 1) {
	    return {
	      ok: false,
	      failed: {
	        because: ['required'],
	        value: value
	      }
	    };
	  }
	}
	
	var WeekdateSelect = function (_Component) {
	  _inherits(WeekdateSelect, _Component);
	
	  function WeekdateSelect(props) {
	    _classCallCheck(this, WeekdateSelect);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      selectedOptions: props.value
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  WeekdateSelect.prototype.componentWillMount = function componentWillMount() {
	    // const { onChange } = this.props;
	    // const { selectedOptions } = this.state;
	    // onChange(selectedOptions)
	  };
	
	  WeekdateSelect.prototype.onChange = function onChange(selectedOptions) {
	    this.setState({ selectedOptions: selectedOptions });
	    this.props.onChange(selectedOptions);
	  };
	
	  WeekdateSelect.prototype.render = function render() {
	    var _props = this.props,
	        value = _props.value,
	        onChange = _props.onChange;
	    var selectedOptions = this.state.selectedOptions;
	
	    return _react2.default.createElement(_reactSelect2.default, {
	      value: selectedOptions,
	      onChange: this.onChange,
	      options: options,
	      multi: true,
	      closeOnSelect: false
	    });
	  };
	
	  return WeekdateSelect;
	}(_react.Component);
	
	exports.default = WeekdateSelect;

/***/ },

/***/ "6voC":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'WeekdateSelect',
	  code: 'CN',
	  text: {
	    'Monday': '星期一',
	    'Tuesday': '星期二',
	    'Wednesday': '星期三',
	    'Thursday': '星期四',
	    'Friday': '星期五',
	    'Saturaday': '星期六',
	    'Sunday': '星期日'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "4U9G":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Form":"Form","ast":"ast","control-label":"control-label","tip":"tip","form-group":"form-group","Field":"Field","hasError":"hasError","control-input":"control-input","form-type-textarea":"form-type-textarea","errorMsg":"errorMsg","form-type-checkbox":"form-type-checkbox","outline":"outline","hasNoLabel":"hasNoLabel"};

/***/ },

/***/ "7o1w":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"form-type-checkbox":"form-type-checkbox","field-style-inline":"field-style-inline","form-type-radio":"form-type-radio","field-style-outline":"field-style-outline"};

/***/ },

/***/ "yjcn":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = addClass;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  cName: _joiBrowser2.default.string().required(),
	  cType: _joiBrowser2.default.number().integer().allow(''),
	  feeType: _joiBrowser2.default.number().integer().allow(''),
	  consumption_type: _joiBrowser2.default.number().integer().required(''),
	  totalPrice: _joiBrowser2.default.number().allow(''),
	  unitPrice: _joiBrowser2.default.number().allow(''),
	  totalQuantity: _joiBrowser2.default.number().integer().allow(''),
	  maxStudentsNumber: _joiBrowser2.default.number().integer().allow(''),
	  cAddress: _joiBrowser2.default.string().allow(''),
	  costRule: _joiBrowser2.default.number().integer().allow(''),
	  costAlertRange: _joiBrowser2.default.number().integer().allow(''),
	  absentFlag: _joiBrowser2.default.number().integer().allow(''),
	  cancelFlag: _joiBrowser2.default.number().integer().allow(''),
	  student_id_list: _joiBrowser2.default.array().allow(''),
	  teacher_id_list: _joiBrowser2.default.array().allow('')
	});
	
	function addClass(schoolId, classInfo) {
	
	  if (!schoolId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school ID')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(classInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/add_cls/" + schoolId + "/",
	      'data': JSON.stringify(classInfo),
	      'method': 'POST',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "OHvH":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = editClass;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  cName: _joiBrowser2.default.string().required(),
	  cType: _joiBrowser2.default.number().integer().allow(''),
	  feeType: _joiBrowser2.default.number().integer().allow(''),
	  consumption_type: _joiBrowser2.default.number().integer().required(''),
	  totalPrice: _joiBrowser2.default.number().allow(''),
	  unitPrice: _joiBrowser2.default.number().allow(''),
	  totalQuantity: _joiBrowser2.default.number().integer().allow(''),
	  maxStudentsNumber: _joiBrowser2.default.number().integer().allow(''),
	  cAddress: _joiBrowser2.default.string().allow(''),
	  costRule: _joiBrowser2.default.number().integer().allow(''),
	  costAlertRange: _joiBrowser2.default.number().integer().allow(''),
	  absentFlag: _joiBrowser2.default.number().integer().allow(''),
	  cancelFlag: _joiBrowser2.default.number().integer().allow(''),
	  student_id_list: _joiBrowser2.default.array().allow(''),
	  teacher_id_list: _joiBrowser2.default.array().allow('')
	});
	
	function editClass(classId, classInfo) {
	  if (!classId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing class ID')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(classInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/u_cls/" + classId + "/",
	      'data': JSON.stringify(classInfo),
	      'method': 'PUT',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "DY3E":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getClassDetailByID;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getClassDetailByID(id) {
	
			if (typeof id === 'undefined') {
					throw new Error('class ID is missing. getClassDetailByID(classId)');
			}
	
			return new Promise(function (resolve, reject) {
					_axios2.default.put('/proxy', {
							'uri': '/g_clsbyid/' + id + '/',
							'method': 'GET',
							'token': localStorage.getItem('token')
					}).then(function (res) {
							resolve(res.data);
					}).catch(function (err) {
							reject(err);
					});
			});
	}
	module.exports = exports['default'];

/***/ },

/***/ "nRUD":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.userCan = userCan;
	exports.isBasicUser = isBasicUser;
	exports.isValidUser = isValidUser;
	exports.isOnlyTeacher = isOnlyTeacher;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _locale = __webpack_require__("CNf9");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _alert = __webpack_require__("BGi1");
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	__webpack_require__("H5+v");
	
	__webpack_require__("eX60");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 *
	 */
	function userCan(can) {
	  var schoolId = localStorage.getItem('schoolId');
	
	  var _store$getState = _store2.default.getState(),
	      user = _store$getState.user;
	
	  if (user && user.rolesPerSchool && schoolId && user.rolesPerSchool[schoolId]) {
	    var _user$rolesPerSchool$ = user.rolesPerSchool[schoolId],
	        permissions = _user$rolesPerSchool$.permissions,
	        role = _user$rolesPerSchool$.role;
	
	    if (role === 'school_owner') {
	      return true;
	    }
	
	    if (!permissions) {
	      return false;
	    } else if (permissions && permissions.indexOf(can) > -1) {
	      return true;
	    } else {
	      return false;
	    }
	  }
	}
	
	function isBasicUser() {
	  var _store$getState2 = _store2.default.getState(),
	      gSubscription = _store$getState2.gSubscription;
	
	  var saas_version = gSubscription.result.saas_version;
	
	
	  return saas_version === 0 || saas_version === 3 || saas_version === 4;
	}
	
	function isValidUser() {
	  var _store$getState3 = _store2.default.getState(),
	      gSubscription = _store$getState3.gSubscription;
	
	  var _gSubscription$result = gSubscription.result,
	      is_valid = _gSubscription$result.is_valid,
	      maximum_amount = _gSubscription$result.maximum_amount;
	
	
	  return is_valid && maximum_amount.maximum_school > 0;
	}
	
	function isOnlyTeacher() {
	  var _store$getState4 = _store2.default.getState(),
	      user = _store$getState4.user,
	      gSubscription = _store$getState4.gSubscription;
	
	  var _gSubscription$result2 = gSubscription.result,
	      is_valid = _gSubscription$result2.is_valid,
	      maximum_amount = _gSubscription$result2.maximum_amount,
	      saas_version = _gSubscription$result2.saas_version;
	  var _user$result = user.result,
	      teacher_to_be_confirmed = _user$result.teacher_to_be_confirmed,
	      school_amount = _user$result.school_amount,
	      school_owned_amount = _user$result.school_owned_amount;
	
	
	  return (teacher_to_be_confirmed.length > 0 || school_amount - school_owned_amount > 0) && saas_version === 0 && !is_valid && maximum_amount.maximum_school === 0;
	}
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	var R = function (_Component) {
	  _inherits(R, _Component);
	
	  function R(props) {
	    _classCallCheck(this, R);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.modifyChild = _this.modifyChild.bind(_this);
	    return _this;
	  }
	
	  R.prototype.modifyChild = function modifyChild(child) {
	    var _props = this.props,
	        by = _props.by,
	        can = _props.can,
	        _props$tooltipPositio = _props.tooltipPosition,
	        tooltipPosition = _props$tooltipPositio === undefined ? 'down' : _props$tooltipPositio,
	        _props$title = _props.title,
	        title = _props$title === undefined ? __('You do not have permission', _locale2.default) : _props$title;
	
	
	    var existingClassName = (child.props || {}).className || '';
	
	    var newClassName = (0, _classnames2.default)(existingClassName, { 'noPermission--target': by == 'disable' });
	
	    var onClick = {};
	    if (by == 'alert') {
	      onClick = {
	        onClick: function onClick(e) {
	          e.stopPropagation();
	          e.preventDefault();
	          _alert.alert.warning(__('You do not have permission', _locale2.default)).then(function () {});
	        }
	      };
	    }
	
	    return _react2.default.cloneElement(child, _extends({}, child.props, {
	      disabled: by == 'disable',
	      className: newClassName,
	      "data-balloon": title,
	      "data-balloon-pos": tooltipPosition
	
	    }, onClick));
	  };
	
	  R.prototype.render = function render() {
	    var _this2 = this;
	
	    var rolesPerSchool = this.props.user.rolesPerSchool;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    // if there is no role for the teacher in the school we hide it
	    if (!rolesPerSchool || !schoolId || !rolesPerSchool[schoolId]) {
	      return _react2.default.createElement('span', { 'data-restricted': 'hidden by ' + can + '. User has no role in school.' });
	    }
	
	    var _rolesPerSchool$schoo = rolesPerSchool[schoolId],
	        role = _rolesPerSchool$schoo.role,
	        permissions = _rolesPerSchool$schoo.permissions;
	    var _props2 = this.props,
	        _props2$by = _props2.by,
	        by = _props2$by === undefined ? 'hide' : _props2$by,
	        className = _props2.className,
	        can = _props2.can;
	
	
	    if (role === 'school_owner') {
	      return _react2.default.createElement(
	        'span',
	        null,
	        this.props.children
	      );
	    }
	
	    // if undefined, we assume the user is the owner
	    if (typeof permissions === 'undefined') {
	      return _react2.default.createElement(
	        'span',
	        null,
	        this.props.children
	      );
	    }
	    // hiding it by default
	    if (by == 'hide' && permissions.indexOf(can) == -1) {
	      return _react2.default.createElement('span', { 'data-restricted': 'hidden by ' + can });
	    }
	
	    if (permissions.indexOf(can) == -1) {
	      var newChildren = void 0;
	      // add disabled class and also disabled attr
	      if (Array.isArray(this.props.children)) {
	        newChildren = this.props.children.map(function (child) {
	          return _this2.modifyChild(child);
	        });
	      } else {
	        newChildren = this.modifyChild(this.props.children);
	      }
	
	      return _react2.default.createElement(
	        'span',
	        {
	          dataRestricted: 'disabled by ' + can,
	          className: (0, _classnames2.default)('noPermission', className)
	        },
	        newChildren
	      );
	    }
	
	    return _react2.default.createElement(
	      'span',
	      null,
	      this.props.children
	    );
	  };
	
	  return R;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(R);

/***/ },

/***/ "CNf9":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: '__R',
	  code: 'CN',
	  text: {
	    'You do not have permission': '您无此操作权限'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "H5+v":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "aMEQ":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
	  id: "StudentTable",
	  code: "CN",
	  text: {
	    "Credit": "钱包余额",
	    'Used/Purchased': '已消耗/已购买',
	    'Used/Paid': '已消耗/已缴学费',
	    'Setup': '未设置',
	
	    'Archive Student': '转为历史学员',
	    'This student has paid tuition or credit, do you wish to refund?': '此学员已缴费或有钱包余额，是否要退费？',
	    'Discounted': '折扣',
	
	    'Archive Students': '批量转为历史学员',
	    'Archived': '历史学员',
	
	    'Sort by': '排序',
	    'Creation Time: Newest to Oldest': '按创建时间：由新到旧',
	    'Creation Time: Oldest to Newest': '按创建时间：由旧到新',
	    'First Name: A-Z': '按名：由A到Z',
	    'First Name: Z-A': '按名：由Z到A',
	    'Last Name: A-Z': '按姓：由A到Z',
	    'Last Name: Z-A': '按姓：由Z到A',
	    'Upgrade': '升级'
	  }
	};
	module.exports = exports["default"];

/***/ },

/***/ "R3SI":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // MAKING CONTROLLER FUNCTION MORE EXPLICIT
	// We used to pass "kw" to the controller as an optional parameter when we want to
	// search by the keyword. But how do other developers know if the "kw" is an optional
	// or not and what does "kw" actually mean? They have to read the documentation
	// everytime when they use the controller which takes time and time is precious.
	//
	// Instead, explicitly declare another controller called searchStudentSummary.
	// The name tells everything.
	
	
	exports.default = searchStudentSummary;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _getStudentSummary = __webpack_require__("/y3Y");
	
	var _getStudentSummary2 = _interopRequireDefault(_getStudentSummary);
	
	var _studentStates = __webpack_require__("DWYU");
	
	var _studentStates2 = _interopRequireDefault(_studentStates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TOKEN = localStorage.getItem('token');
	
	// we add a key called searchKeyword in schema
	var schema = exports.schema = _getStudentSummary.schema.keys({
		searchKeyword: _joiBrowser2.default.string().required().label("searchKeyword: kw-搜索字符，注：当kw为空时，按照参数2的条件进行搜索，如果有kw时，联合参数和参数3 kw 进行搜索")
	});
	
	function searchStudentSummary(opts) {
		var _Joi$validate = _joiBrowser2.default.validate(opts, schema),
		    error = _Joi$validate.error;
	
		if (error) {
			throw error;
		}
	
		return (0, _getStudentSummary2.default)(_extends({}, opts));
	}

/***/ },

/***/ "nQH9":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (studentState) {
	
	  if (studentState == "archived") {
	    return getArchivedStudentTableSettings.call(this);
	  }
	
	  return getDefaultTableSettings.call(this);
	};
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _Remarks = __webpack_require__("EAm8");
	
	var _Remarks2 = _interopRequireDefault(_Remarks);
	
	var _NewPayment = __webpack_require__("BztD");
	
	var _NewPayment2 = _interopRequireDefault(_NewPayment);
	
	var _CreateClassOne = __webpack_require__("sbFW");
	
	var _CreateClassOne2 = _interopRequireDefault(_CreateClassOne);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _locale = __webpack_require__("aMEQ");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _confirm = __webpack_require__("yMGN");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDefaultTableSettings(opts) {
	  var _this = this;
	
	  var TabComponent = this;
	
	  var dropdown = [{
	    title: __("New Private Class", "student"),
	    onClick: function onClick(_ref) {
	      var student = _ref.trData;
	
	      (0, _CreateClassOne2.default)({ mode: 'create', studentInfo: [{ name: student.sName, id: student.schoolStudentID }] });
	    },
	    isDisabled: function isDisabled(opts) {
	      return !(0, _R.userCan)('create_private_class');
	    }
	  }, {
	    title: __("Join Class", "student"),
	    onClick: function onClick(_ref2) {
	      var student = _ref2.trData;
	
	      _this.enrollStudentToClass([student], function () {
	        var _props$student = _this.props.student,
	            fetchStudent = _props$student.fetchStudent,
	            studentState = _props$student.studentState;
	
	
	        fetchStudent('after student enrolled @table-setting', studentState);
	      });
	    },
	    isDisabled: function isDisabled(opts) {
	      return !(0, _R.userCan)('assign_student_to_class');
	    }
	  }, {
	    title: __("Remarks", "classdetail"),
	    onClick: function onClick(_ref3) {
	      var student = _ref3.trData;
	
	      (0, _Remarks2.default)({ id: student.schoolStudentID, type: 'student' });
	    },
	    isDisabled: function isDisabled(opts) {
	      return !(0, _R.userCan)('edit_student_notes');
	    }
	  }, {
	    title: __("Refund", "student"),
	    onClick: function onClick(_ref4) {
	      var student = _ref4.trData;
	
	      var user_id = _this.props.user.result.user_id;
	      var _props$student2 = _this.props.student,
	          fetchStudent = _props$student2.fetchStudent,
	          studentState = _props$student2.studentState;
	
	
	      (0, _NewPayment2.default)({ student: student, user_id: user_id, paymentType: student.classInfo ? _NewPayment.REFUND : _NewPayment.REFUND_CREDIT }).then(function () {
	        var _props$student3 = _this.props.student,
	            fetchStudent = _props$student3.fetchStudent,
	            studentState = _props$student3.studentState;
	
	        fetchStudent('after refund', studentState);
	      });
	    },
	    isDisabled: function isDisabled(opts) {
	      return !(0, _R.userCan)('student_refund');
	    }
	  }, {
	    title: __("Archive Student", _locale2.default),
	    onClick: function onClick(_ref5) {
	      var student = _ref5.trData;
	
	      var user_id = _this.props.user.result.user_id;
	      var hasPaid = void 0;
	
	      if (student.list && student.list.length >= 1) {
	        student.list.map(function (cls) {
	          if (cls.paidTotalFee && cls.paidTotalFee > 0) {
	            hasPaid = true;
	          }
	        });
	      }
	
	      if (hasPaid === true || student.balance > 0) {
	        (0, _confirm.confirm)(__('This student has paid tuition or credit, do you wish to refund?', _locale2.default)).then(function () {
	          (0, _NewPayment2.default)({ student: student, user_id: user_id, paymentType: _NewPayment.REFUND }).then(function () {
	            _this.props.student.archiveSingleStudent('clicking delete @tabble-settings @defaultTab', student);
	          });
	        }).catch(function () {
	          _this.props.student.archiveSingleStudent('clicking delete @tabble-settings @defaultTab', student);
	        });
	      } else {
	        _this.props.student.archiveSingleStudent('clicking delete @tabble-settings @defaultTab', student);
	      }
	    },
	    isDisabled: function isDisabled(opts) {
	      return !(0, _R.userCan)('archive_student_from_school');
	    }
	  }];
	
	  return [{
	    title: __('Payment', 'finance'),
	    onClick: function onClick(opts) {
	      _this.payment(opts);
	    },
	    isDisabled: function isDisabled(opts) {
	      return !(0, _R.userCan)('student_charge');
	    }
	  }, {
	    title: __('Options', 'teacher'),
	    id: "student-dropdown",
	    dropdown: dropdown
	  }];
	}
	
	// Specifically used for archived student table
	
	
	// Table setting factory creates table setting object according to 'studentState'
	
	// IMPORTANT NOTE:
	// 'this' here is a Tab component such as DefaultTab.
	function getArchivedStudentTableSettings() {
	  var TabComponent = this;
	
	  return [{
	    title: __('Restore', 'teacher'),
	    onClick: this.unarchiveStudent,
	    isDisabled: function isDisabled(opts) {
	      return !(0, _R.userCan)('recover_student_in_school');
	    }
	  }];
	}
	module.exports = exports["default"];

/***/ },

/***/ "EAm8":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("xYV5");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This modal takes in and id and a type
	// Right now, the types are either 'finance' or 'student'
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "xYV5":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("ot1/");
	
	var _ModalContent = __webpack_require__("+brr");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _updateTradeNote = __webpack_require__("os9A");
	
	var _updateTradeNote2 = _interopRequireDefault(_updateTradeNote);
	
	var _updateStudentInfo = __webpack_require__("kxXT");
	
	var _updateStudentInfo2 = _interopRequireDefault(_updateStudentInfo);
	
	var _editClient = __webpack_require__("+NDk");
	
	var _editClient2 = _interopRequireDefault(_editClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalBody.prototype.onSubmitAction = function onSubmitAction() {
	    var _props = this.props,
	        dismiss = _props.dismiss,
	        id = _props.id,
	        type = _props.type,
	        proceed = _props.proceed;
	
	
	    if (type == 'finance') {
	      if (this.formData) {
	        (0, _updateTradeNote2.default)(id, this.formData).then(function (res) {
	          proceed();
	        });
	      } else {
	        dismiss();
	      }
	    } else if (type == 'student') {
	      if (this.formData) {
	        (0, _updateStudentInfo2.default)(id, this.formData).then(function (res) {
	          dismiss();
	        });
	      } else {
	        dismiss();
	      }
	    } else if (type == 'client') {
	      if (this.formData) {
	        (0, _editClient2.default)(id, this.formData).then(function (res) {
	          dismiss();
	        });
	      } else {
	        dismiss();
	      }
	    }
	  };
	
	  ModalBody.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props2 = this.props,
	        show = _props2.show,
	        proceed = _props2.proceed,
	        dismiss = _props2.dismiss,
	        cancel = _props2.cancel,
	        id = _props2.id,
	        type = _props2.type;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'remarks-modal',
	        hasHeader: true,
	        hasFooter: true,
	        headerTitle: __("Remarks", "finance"),
	        headerIcon: 'fa icon-clipboard-check',
	        fixedWidth: 500,
	        contentHeight: 300,
	        onCloseModalClick: dismiss,
	        footerType: 'grey',
	        footerButtons: [{
	          title: __('Complete', 'appwrapper'),
	          className: 'btn btn-primary pull-right',
	          onClick: function onClick() {
	            _this2.onSubmitAction();
	          }
	        }, {
	          title: __('Cancel', 'changeschool'),
	          className: 'btn btn-default pull-right',
	          onClick: function onClick() {
	            dismiss();
	          }
	        }],
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, _extends({}, this.props, {
	        onFormChange: function onFormChange(stateFromModalContent) {
	          _this2.formData = stateFromModalContent;
	        }
	      }))
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "ot1/":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"remarks-modal-content":"remarks-modal-content"};

/***/ },

/***/ "+brr":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getTradeNote = __webpack_require__("o+LH");
	
	var _getTradeNote2 = _interopRequireDefault(_getTradeNote);
	
	var _getStudentInfo = __webpack_require__("EUd3");
	
	var _getStudentInfo2 = _interopRequireDefault(_getStudentInfo);
	
	var _getClientDetail = __webpack_require__("3heM");
	
	var _getClientDetail2 = _interopRequireDefault(_getClientDetail);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__("ot1/");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      finance: {
	        notes: ''
	      },
	      studentInfo: {
	        ssRemark: '',
	        ssFirstName: '',
	        ssLastName: '',
	        ssPhone: '',
	        ssBirthday: '',
	        ssGender: '',
	        ssStudentCreateTime: '',
	        ssEmail: ''
	      },
	      clientInfo: {
	        first_name: '',
	        last_name: '',
	        gender: 'male',
	        date_of_birth: '',
	        mobile: '',
	        email: '',
	        guardian_name: '',
	        guardian_mobile: '',
	        guardian_email: '',
	        tag_name_list: [],
	        remark: ''
	      }
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  ModalContent.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        id = _props.id,
	        type = _props.type;
	
	    if (type == 'finance') {
	      (0, _getTradeNote2.default)(id).then(function (res) {
	        _this2.state.finance.notes = res.notes;
	
	        _this2.setState({ finance: _this2.state.finance });
	      });
	    } else if (type == 'student') {
	      (0, _getStudentInfo2.default)(id).then(function (res) {
	        _this2.state.studentInfo.ssFirstName = res.ssFirstName;
	        _this2.state.studentInfo.ssLastName = res.ssLastName;
	        _this2.state.studentInfo.ssPhone = res.ssPhone;
	        _this2.state.studentInfo.ssBirthday = res.ssBirthday;
	        _this2.state.studentInfo.ssGender = res.ssGender == 0 ? 'male' : 'female';
	        _this2.state.studentInfo.ssStudentCreateTime = res.ssStudentCreateTime;
	        _this2.state.studentInfo.ssRemark = res.ssRemark;
	        _this2.state.studentInfo.ssEmail = res.ssEmail;
	
	        _this2.setState({
	          studentInfo: _this2.state.studentInfo
	        });
	      });
	    } else if (type == 'client') {
	      (0, _getClientDetail2.default)(id).then(function (res) {
	        var convertedGender = '';
	        if (res.gender == 0) {
	          convertedGender = 'male';
	        } else if (res.gender == 1) {
	          convertedGender = 'female';
	        }
	
	        _this2.setState({
	          clientInfo: _extends({}, _this2.state.clientInfo, {
	            first_name: res.first_name,
	            last_name: res.last_name,
	            gender: convertedGender,
	            date_of_birth: res.birthday ? (0, _moment2.default)(res.birthday).format('YYYY-MM-DD') : '',
	            mobile: res.mobile,
	            email: res.email,
	            guardian_name: res.guardian_name,
	            guardian_mobile: res.guardian_mobile,
	            guardian_email: res.guardian_email,
	            tag_name_list: res.tag_name_list,
	            remark: res.remark
	          })
	        });
	      });
	    }
	  };
	
	  ModalContent.prototype.onChange = function onChange(event) {
	    var _this3 = this;
	
	    var _props2 = this.props,
	        onFormChange = _props2.onFormChange,
	        type = _props2.type;
	
	
	    if (type == 'finance') {
	      this.state.finance.notes = event.target.value;
	      this.setState({ finance: this.state.finance }, function () {
	        onFormChange(_this3.state.finance);
	      });
	    } else if (type == 'student') {
	      this.state.studentInfo.ssRemark = event.target.value;
	      this.setState({ ssRemark: this.state.studentInfo }, function () {
	        onFormChange(_this3.state.studentInfo);
	      });
	    } else if (type == 'client') {
	      this.state.clientInfo.remark = event.target.value;
	      this.setState({ remark: this.state.clientInfo }, function () {
	        onFormChange(_this3.state.clientInfo);
	      });
	    }
	  };
	
	  ModalContent.prototype.renderValue = function renderValue() {
	    var type = this.props.type;
	
	    if (type == 'finance') {
	      return this.state.finance.notes;
	    } else if (type == 'student') {
	      return this.state.studentInfo.ssRemark;
	    } else if (type == 'client') {
	      return this.state.clientInfo.remark;
	    }
	  };
	
	  ModalContent.prototype.render = function render() {
	    var type = this.props.type;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'remarks-modal-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container-fluid' },
	        _react2.default.createElement('textarea', {
	          rows: '12', cols: '59',
	          className: 'form-control',
	          onChange: this.onChange,
	          value: this.renderValue(),
	          placeholder: __('Please enter remarks content', 'finance')
	        })
	      )
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "o+LH":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTradeNote;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTradeNote(tradeRecordId) {
		if (!tradeRecordId) {
			throw 'Missing trade record ID';
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/u_trade_notes/' + tradeRecordId + '/',
				'method': 'GET',
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res.data);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports['default'];

/***/ },

/***/ "EUd3":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getStudentInfo;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStudentInfo(studentId) {
	
	  if (!studentId) {
	    throw 'missing student ID';
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/g_stdtinfo/' + studentId + '/',
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "3heM":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getClientDetail;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getClientDetail(clientId) {
	
	  if (!clientId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing client Id')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/contact_detail/" + clientId + "/",
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "os9A":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = updateTradeNote;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
		notes: _joiBrowser2.default.string().allow('').allow(null)
	});
	
	function updateTradeNote(tradeRecordId, notes) {
		if (!tradeRecordId) {
			throw 'Missing trade record ID';
		}
	
		var validateResult = _joiBrowser2.default.validate(notes, schema);
	
		if (validateResult.error) {
			return new Promise(function (resolve, reject) {
				reject(validateResult);
			});
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/u_trade_notes/' + tradeRecordId + '/',
				'method': 'PUT',
				'data': JSON.stringify(notes),
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res);
			}).catch(function (err) {
				reject(err);
			});
		});
	}

/***/ },

/***/ "kxXT":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = updateStudentInfo;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GENDER = ['male', 'female', 'other', 'n/a'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  ssFirstName: _joiBrowser2.default.string().required(),
	  ssLastName: _joiBrowser2.default.string().required(),
	  ssNickName: _joiBrowser2.default.string().allow(''),
	  ssGender: _joiBrowser2.default.any().required(),
	  ssBirthday: _joiBrowser2.default.string().allow('').allow(null),
	  ssPhone: _joiBrowser2.default.string().allow(''),
	  ssHomePhone: _joiBrowser2.default.string().allow(''),
	  ssEmail: _joiBrowser2.default.string().allow(''),
	  ssSource: _joiBrowser2.default.string().allow(''),
	  ssSocialType: _joiBrowser2.default.number().allow(null),
	  ssSocialID: _joiBrowser2.default.string().allow(''),
	  ssCountry: _joiBrowser2.default.string().allow(''),
	  ssProvince: _joiBrowser2.default.string().allow(''),
	  ssCity: _joiBrowser2.default.string().allow(''),
	  ssPostcode: _joiBrowser2.default.string().allow(''),
	  ssAddress: _joiBrowser2.default.string().allow(''),
	  ssRemark: _joiBrowser2.default.string().allow(''),
	  ssStudentCreateTime: _joiBrowser2.default.string().allow('').allow(null),
	  ssSuitNumber: _joiBrowser2.default.string().allow(''),
	  ssCode: _joiBrowser2.default.string().allow(''),
	  student_bound: _joiBrowser2.default.number().allow(null),
	  teacher_bound: _joiBrowser2.default.number().allow(null),
	  parents_bound: _joiBrowser2.default.number().allow(null),
	  ssSchool: _joiBrowser2.default.string().allow(''),
	  ssStudent: _joiBrowser2.default.string().allow(''),
	
	  custom_data: _joiBrowser2.default.object(),
	  photo: _joiBrowser2.default.object(),
	
	  ssParentsName: _joiBrowser2.default.string().allow(''),
	  ssGuardianRelation: _joiBrowser2.default.string().allow(''),
	  ssParentsEmail: _joiBrowser2.default.string().allow(''),
	  ssParentsPhone: _joiBrowser2.default.string().allow(''),
	
	  ssParents2Name: _joiBrowser2.default.string().allow(''),
	  ssGuardian2Relation: _joiBrowser2.default.string().allow(''),
	  ssParents2Email: _joiBrowser2.default.string().allow(''),
	  ssParents2Phone: _joiBrowser2.default.string().allow('')
	});
	
	function updateStudentInfo(studentId, studentInfo) {
	
	  if (!studentId) {
	    throw 'missing student ID';
	  }
	
	  var validateResult = _joiBrowser2.default.validate(studentInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  //
	  // when the data is a plain json with no file we use proxy server.
	  // when it contains multi-part/form-data we upload it directly
	  //
	  var toServer = _extends({}, studentInfo, {
	    ssGender: typeof studentInfo.ssGender === 'string' ? GENDER.indexOf(studentInfo.ssGender) : studentInfo.ssGender
	
	    // only use this for now
	  });if (toServer.photo) {
	    return updateWithUpload(studentId, toServer);
	  } else {
	    return update(studentId, toServer);
	  }
	}
	
	function updateWithUpload(studentId, toServer) {
	
	  var API_URL = void 0;
	  if (false) {
	    API_URL = 'https://saas.classtop.com:3001/sapi';
	  } else {
	    API_URL = 'https://school.classtop.com:3001/sapi';
	  }
	
	  return new Promise(function (resolve, reject) {
	    var data = new FormData();
	
	    _.each(toServer, function (value, name) {
	      if (name === 'photo') {
	        data.append('photo', toServer.photo, 'photo');
	      } else if (name === 'custom_data') {
	        data.append('custom_data', JSON.stringify(value));
	      } else if (typeof value !== 'undefined') {
	        data.append(name, value);
	      }
	    });
	
	    _axios2.default.put(API_URL + '/u_stdtinfo/' + studentId + '/', data, {
	      'onUploadProgress': function (_onUploadProgress) {
	        function onUploadProgress(_x) {
	          return _onUploadProgress.apply(this, arguments);
	        }
	
	        onUploadProgress.toString = function () {
	          return _onUploadProgress.toString();
	        };
	
	        return onUploadProgress;
	      }(function (progress) {
	        if (typeof onUploadProgress == 'function') {
	          progress.ratio = progress.loaded / progress.total;
	          onUploadProgress(progress);
	        }
	      }),
	      headers: {
	        'Authorization': 'JWT ' + localStorage.getItem('token'),
	        'Content-Type': 'multipart/form-data'
	      }
	    }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	      console.error(err);
	    });
	  });
	}
	
	function update(studentId, toServer) {
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/u_stdtinfo/' + studentId + '/',
	      'method': 'PUT',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      console.error(err);
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "+NDk":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = editClient;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GENDER = ['male', 'female', 'other', 'n/a'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  "first_name": _joiBrowser2.default.string().required(),
	  "last_name": _joiBrowser2.default.string().required(),
	  "gender": _joiBrowser2.default.string().valid(GENDER),
	  "date_of_birth": _joiBrowser2.default.string().allow(''),
	  "mobile": _joiBrowser2.default.string().allow(''),
	  "email": _joiBrowser2.default.string().allow(''),
	  "guardian_name": _joiBrowser2.default.string().allow(''),
	  "guardian_mobile": _joiBrowser2.default.string().allow(''),
	  "guardian_email": _joiBrowser2.default.string().allow(''),
	  "remark": _joiBrowser2.default.string().allow(''),
	  "tag_name_list": _joiBrowser2.default.array().allow(''),
	  "custom_data": _joiBrowser2.default.object().allow(null)
	});
	
	function editClient(clientId, clientInfo) {
	
	  if (!clientId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing client Id')
	      });
	    });
	  }
	
	  /*
	  let validateResult = Joi.validate(clientInfo, schema);
	   if (validateResult.error) {
	    return new Promise((resolve, reject)=> {
	      reject(validateResult);
	    });
	  }
	  */
	
	  if (Array.isArray(clientInfo.custom_data)) {
	    clientInfo.custom_data = {};
	  }
	
	  var toServer = _extends({}, clientInfo, {
	    gender: !clientInfo.gender ? '' : GENDER.indexOf(clientInfo.gender)
	  });
	
	  if (toServer.gender === '') {
	    delete toServer.gender;
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/contact_detail/" + clientId + "/",
	      'method': 'PUT',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "BztD":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CHARGE = exports.ADD_CREDIT = exports.REFUND = exports.REFUND_CREDIT = undefined;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (!opts.student) {
	    throw new Error('This modal requires a student object { student: a student object }');
	  }
	  if (!opts.user_id) {
	    throw new Error('This modal requires an user_id');
	  }
	
	  if (opts.classDetail) {
	
	    // If classDetail.paidTotalFee is undefined, and paidInFee is present in student. It is
	    // a situation where operation was under a student per class, for eg. ClassDetail page,
	    // where students list are part of a classDetail.
	
	    if (typeof opts.classDetail.paidTotalFee === 'undefined') {
	      opts.classDetail.paidTotalFee = opts.student.paidInFee;
	      opts.classDetail.classTotalFee = opts.classDetail.total_price;
	    }
	
	    opts.student.list = [opts.classDetail];
	  }
	
	  if (opts.student instanceof _Student2.default !== true) {
	    opts.student = new _Student2.default(opts.student);
	  }
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("elvt");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _Student = __webpack_require__("PT2B");
	
	var _Student2 = _interopRequireDefault(_Student);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REFUND_CREDIT = exports.REFUND_CREDIT = 'refund_credit';
	var REFUND = exports.REFUND = 'refund';
	var ADD_CREDIT = exports.ADD_CREDIT = 'add_credit';
	var CHARGE = exports.CHARGE = 'charge';
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);

/***/ },

/***/ "elvt":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CHECK_PAYMENT_RESULT_INTERVAL = exports.MIN_INTERVAL_FOR_LEGIT_INPUT = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("UmdA");
	
	var _ModalContent = __webpack_require__("3hQu");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _index = __webpack_require__("BztD");
	
	var _constants = __webpack_require__("7rIE");
	
	var _StudentModalHeader = __webpack_require__("CwGh");
	
	var _StudentModalHeader2 = _interopRequireDefault(_StudentModalHeader);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _locale = __webpack_require__("iqR3");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _isEmpty = __webpack_require__("lHK6");
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _scan = __webpack_require__("ByhE");
	
	var _scan2 = _interopRequireDefault(_scan);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _snapScan = __webpack_require__("tMIw");
	
	var _snapScan2 = _interopRequireDefault(_snapScan);
	
	var _checkSnapScan = __webpack_require__("5rP/");
	
	var _checkSnapScan2 = _interopRequireDefault(_checkSnapScan);
	
	var _getStudentCreditInfo = __webpack_require__("Qjqn");
	
	var _getStudentCreditInfo2 = _interopRequireDefault(_getStudentCreditInfo);
	
	var _updateStudentTrade = __webpack_require__("GxWe");
	
	var _updateStudentTrade2 = _interopRequireDefault(_updateStudentTrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MIN_INTERVAL_FOR_LEGIT_INPUT = exports.MIN_INTERVAL_FOR_LEGIT_INPUT = 200;
	var CHECK_PAYMENT_RESULT_INTERVAL = exports.CHECK_PAYMENT_RESULT_INTERVAL = 5; // seconds
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    var _formData;
	
	    _classCallCheck(this, ModalBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    var _this$props = _this.props,
	        student = _this$props.student,
	        paymentType = _this$props.paymentType;
	
	    var DEFAULT_EMPTY_FORM = {
	      amount_of_money: 0,
	      email_recipient: _this.props.student.email,
	      send_email_or_not: false,
	      trade_date: (0, _moment2.default)().format(_constants.DATE_FORMAT)
	    };
	
	    _this.state = {
	      step: 'payment_info',
	      studentCreditInfo: {},
	      currentClass: {},
	      disabledBtn: false,
	      formData: (_formData = {}, _formData[_index.CHARGE] = DEFAULT_EMPTY_FORM, _formData[_index.ADD_CREDIT] = DEFAULT_EMPTY_FORM, _formData[_index.REFUND] = DEFAULT_EMPTY_FORM, _formData[_index.REFUND_CREDIT] = DEFAULT_EMPTY_FORM, _formData)
	    };
	
	    if (paymentType == _index.REFUND) {
	      _this.state.paymentType = _index.REFUND;
	    } else if (paymentType == _index.REFUND_CREDIT) {
	      _this.state.paymentType = _index.REFUND_CREDIT;
	    } else {
	      if (student.classList && student.classList.length > 0) {
	        _this.state.paymentType = _index.CHARGE;
	      } else {
	        _this.state.paymentType = _index.ADD_CREDIT;
	      }
	    }
	
	    _this.isPaymentWithBarcodeScan = _this.isPaymentWithBarcodeScan.bind(_this);
	    _this.changePaymentType = _this.changePaymentType.bind(_this);
	    _this.onFormChange = _this.onFormChange.bind(_this);
	    _this.checkClassType = _this.checkClassType.bind(_this);
	    _this.renderFooterButtons = _this.renderFooterButtons.bind(_this);
	    _this.recordScanner = _this.recordScanner.bind(_this);
	    _this.submitBarcode = _this.submitBarcode.bind(_this);
	    _this.startCheckingPaymentResult = _this.startCheckingPaymentResult.bind(_this);
	
	    _this.legitInput = '';
	    _this.legitInput = '';
	    _this.tradeID;
	    return _this;
	  }
	
	  ModalBody.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var student = this.props.student;
	
	
	    (0, _getStudentCreditInfo2.default)(student.id).then(function (_ref) {
	      var data = _ref.data;
	
	      _this2.setState({
	        studentCreditInfo: data
	      });
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  ModalBody.prototype.renderFooterButtons = function renderFooterButtons() {
	    var _this3 = this;
	
	    var _state = this.state,
	        paymentType = _state.paymentType,
	        step = _state.step,
	        disabledBtn = _state.disabledBtn,
	        currentClass = _state.currentClass,
	        formData = _state.formData;
	    var _props = this.props,
	        student = _props.student,
	        user_id = _props.user_id,
	        proceed = _props.proceed;
	
	    var discountPrice = formData.charge.discount_amount * 100 || 0;
	    var lessonQuantity = formData.charge.lesson_quantity || 1;
	    var price = currentClass.feeType == 0 ? currentClass.classTotalFee : currentClass.unitPrice;
	
	    var newData = void 0;
	    if (paymentType == _index.CHARGE) {
	
	      var amountPayable = void 0;
	      if (formData.charge.amount_payable) {
	        amountPayable = formData.charge.amount_payable * 100;
	      }
	
	      newData = _extends({}, this.state.formData.charge, {
	        operator_id: user_id,
	        trade_date: (0, _moment2.default)(formData.charge.trade_data).format('YYYY-MM-DD'),
	        trade_type: 'charge',
	        discount_amount: discountPrice / 100,
	        amount_payable: amountPayable ? amountPayable / 100 : price * 100 * lessonQuantity / 100,
	        amount_of_money: amountPayable ? (amountPayable - discountPrice) / 100 : (price * 100 * lessonQuantity - discountPrice) / 100,
	        end_date: formData.charge.end_date ? (0, _moment2.default)(formData.charge.end_date).format('YYYY-MM-DD') : undefined
	      });
	    }
	
	    if (paymentType == _index.ADD_CREDIT) {
	      newData = _extends({}, this.state.formData.add_credit, {
	        operator_id: user_id,
	        trade_date: (0, _moment2.default)(formData.add_credit.trade_data).format('YYYY-MM-DD'),
	        trade_type: 'charge'
	      });
	    }
	
	    if (paymentType == _index.REFUND) {
	      newData = _extends({}, this.state.formData.refund, {
	        operator_id: user_id,
	        trade_date: (0, _moment2.default)(formData.refund.trade_data).format('YYYY-MM-DD'),
	        trade_type: 'refund',
	        end_date: formData.refund.end_date ? (0, _moment2.default)(formData.refund.end_date).format('YYYY-MM-DD') : undefined
	      });
	    }
	
	    if (paymentType == _index.REFUND_CREDIT) {
	      newData = _extends({}, this.state.formData.refund_credit, {
	        operator_id: user_id,
	        trade_date: (0, _moment2.default)(formData.refund_credit.trade_data).format('YYYY-MM-DD'),
	        trade_type: 'refund'
	      });
	    }
	
	    this.newData = newData;
	
	    if (step === 'payment_info') {
	      if ((paymentType !== _index.REFUND || paymentType !== _index.REFUND_CREDIT) && this.isPaymentWithBarcodeScan()) {
	        return [{
	          title: __('Proceed to payment', _locale2.default),
	          className: 'btn btn-primary pull-right',
	          onClick: function onClick() {
	
	            _this3.setState({ disabledBtn: true });
	            (0, _updateStudentTrade2.default)(student.id, newData).then(function (res) {
	              _this3.tradeId = res.data.trade_id;
	              window.addEventListener('keypress', _this3.recordScanner);
	              _this3.setState({ step: 'scan_barcode' });
	              // proceed({ success: true });
	            });
	          },
	          isDisabled: function isDisabled() {
	            return disabledBtn;
	          }
	        }];
	      } else {
	        return [{
	          title: __('Confirm', 'UI.confirm'),
	          className: 'btn btn-primary pull-right',
	          onClick: function onClick() {
	            var validateResultRight = _this3.validateRight();
	            var validateResultLeft = _this3.validateLeft();
	            if (!validateResultRight.ok || !validateResultLeft.ok) {
	              return;
	            }
	            _this3.setState({ disabledBtn: true });
	            (0, _updateStudentTrade2.default)(student.id, newData).then(function (res) {
	              proceed({ success: true });
	            });
	          },
	          isDisabled: function isDisabled() {
	            return disabledBtn;
	          }
	        }];
	      }
	    }
	  };
	
	  ModalBody.prototype.isPaymentWithBarcodeScan = function isPaymentWithBarcodeScan() {
	    var _state2 = this.state,
	        paymentType = _state2.paymentType,
	        formData = _state2.formData;
	
	    var form = formData[paymentType];
	
	    return ['wechat_barcode_pay', 'ali_barcode_pay'].indexOf(form.payment_method) > -1;
	  };
	
	  ModalBody.prototype.changePaymentType = function changePaymentType(paymentType) {
	    this.setState({ paymentType: paymentType });
	  };
	
	  ModalBody.prototype.onFormChange = function onFormChange(formData) {
	    var _extends2;
	
	    var paymentType = this.state.paymentType;
	
	
	    if (formData.class_id) {
	      this.checkClassType(formData.class_id);
	    }
	
	    this.setState({
	      formData: _extends({}, this.state.formData, (_extends2 = {}, _extends2[paymentType] = formData, _extends2))
	    });
	  };
	
	  ModalBody.prototype.checkClassType = function checkClassType(class_id) {
	    var _this4 = this;
	
	    var student = this.props.student;
	
	    if (student.classList) {
	      student.classList.map(function (cls) {
	        if (cls.classID == class_id) {
	          if (!cls.hasOwnProperty('paidTotalQuantity')) {
	            var newData = _extends({}, cls, {
	              paidTotalQuantity: student.paidTotalQuantity,
	              usedTotalQuantity: student.usedTotalQuantity,
	              classTotalFee: cls.total_price,
	              unitPrice: cls.unit_price
	            });
	            _this4.setState({ currentClass: newData });
	          } else {
	            _this4.setState({ currentClass: cls });
	          }
	        }
	      });
	    }
	  };
	
	  ModalBody.prototype.recordScanner = function recordScanner(e) {
	    var _this5 = this;
	
	    e.preventDefault();
	
	    clearTimeout(this.recordScannerTimeout);
	
	    if (e.charCode === 13) {
	      this.submitBarcode(this.legitInput);
	      return;
	    }
	    this.legitInput += e.key;
	
	    this.recordScannerTimeout = setTimeout(function () {
	      _this5.submitBarcode(_this5.legitInput);
	    }, MIN_INTERVAL_FOR_LEGIT_INPUT);
	  };
	
	  ModalBody.prototype.submitBarcode = function submitBarcode(code) {
	    var _this6 = this;
	
	    this.legitInput = '';
	    window.removeEventListener('keypress', this.recordScanner);
	
	    var sendEmail = this.newData.send_email_or_not ? true : false;
	    var emailRecipient = this.newData.send_email_or_not ? this.newData.email_recipient : undefined;
	
	    (0, _snapScan2.default)(this.tradeId, { auth_code: code, send_email_or_not: sendEmail, email_recipient: emailRecipient }).then(function (res) {
	      if (res.result === 'failure') {
	        if (res.reason === 'the school has not set Wechat pay or Alipay') {
	          _alert.alert.fail(__("WeChat Pay and Alipay are not set up for this school. Please contact us to create an account.", _locale2.default));
	          _this6.setState({ step: "payment_info", disabledBtn: false });
	          return;
	        } else {
	          _alert.alert.fail(__("", _locale2.default));
	          _this6.setState({ step: "payment_info", disabledBtn: false });
	          return;
	        }
	      }
	
	      if (res.creation_result === 'success' && res.payment_result === 'success') {
	        _this6.setState({ step: "payment_successful" });
	      } else if (res.creation_result === 'success' && res.payment_result === 'to be queried') {
	        _this6.startCheckingPaymentResult(_this6.tradeId);
	      } else {
	        _alert.alert.fail(__("", _locale2.default));
	        _this6.setState({ step: "payment_info", disabledBtn: false });
	      }
	    });
	  };
	
	  ModalBody.prototype.startCheckingPaymentResult = function startCheckingPaymentResult(tradeID) {
	    var _this7 = this;
	
	    var totalTry = 0;
	
	    this.setState({ step: 'processing' });
	
	    setTimeout(function () {
	      _this7.callCheckSnapScan(tradeID, function () {
	
	        var interval = setInterval(function () {
	          _this7.callCheckSnapScan(tradeID, function () {
	            totalTry++;
	
	            if (totalTry >= 5) {
	              clearInterval(interval);
	              _alert.alert.fail(__("Payment Request Timeout", _locale2.default));
	              _this7.setState({ step: "payment_info", disabledBtn: false });
	            }
	          });
	        }, CHECK_PAYMENT_RESULT_INTERVAL * 1000);
	      }, CHECK_PAYMENT_RESULT_INTERVAL * 1000);
	    });
	  };
	
	  ModalBody.prototype.callCheckSnapScan = function callCheckSnapScan(tradeID, callAgain) {
	    var _this8 = this;
	
	    (0, _checkSnapScan2.default)(tradeID).then(function (res) {
	      var payment_result = res.payment_result,
	          result = res.result;
	
	
	      if (payment_result === 'success') {
	        _this8.setState({ step: "payment_successful" });
	      } else if (payment_result === 'to be queried') {
	        callAgain();
	      }
	    });
	  };
	
	  ModalBody.prototype.render = function render() {
	    var _this9 = this;
	
	    var _props2 = this.props,
	        show = _props2.show,
	        proceed = _props2.proceed,
	        dismiss = _props2.dismiss,
	        student = _props2.student;
	    var _state3 = this.state,
	        currentClass = _state3.currentClass,
	        paymentType = _state3.paymentType,
	        step = _state3.step;
	    var _state$studentCreditI = this.state.studentCreditInfo,
	        currency = _state$studentCreditI.currency,
	        balance = _state$studentCreditI.balance;
	
	
	    if ((0, _isEmpty2.default)(this.state.studentCreditInfo)) {
	      return _react2.default.createElement('div', null);
	    }
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        isShowingModal: show,
	        onCloseModalClick: dismiss,
	        className: 'new-payment-modal',
	
	        fixedWidth: 620,
	        contentHeight: 528,
	
	        hasHeader: true,
	        headerType: 'bold',
	        headerTitle: '',
	
	        headerCustomContent: _react2.default.createElement(_StudentModalHeader2.default, { name: student.name, gender: student.gender, profileThumbnail: student.profilePhotoThumbnail2x }),
	
	        hasFooter: step === 'payment_info',
	        footerType: 'grey' // grey, transparent, bold
	        , footerButtons: this.renderFooterButtons(this.state.formData),
	        footerCustomContent: _react2.default.createElement(
	          'div',
	          { className: 'price-on-modal' },
	          __('Account Balance: ', 'classdetail'),
	          ' ',
	          balance,
	          ' ',
	          currency.toUpperCase()
	        )
	      },
	      _react2.default.createElement(
	        'div',
	        null,
	        step == 'payment_info' && _react2.default.createElement(_ModalContent2.default, {
	          student: student,
	          studentCreditInfo: this.state.studentCreditInfo,
	          paymentType: paymentType,
	          changePaymentType: this.changePaymentType,
	          onFormChange: this.onFormChange,
	          currentClass: currentClass,
	          getValidationRefRight: function getValidationRefRight(fn) {
	            _this9.validateRight = fn;
	          },
	          getValidationRefLeft: function getValidationRefLeft(fn) {
	            _this9.validateLeft = fn;
	          }
	        }),
	        step == 'scan_barcode' && _react2.default.createElement(
	          'div',
	          { className: 'scan-msg' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            __("Scan Payment QR Code", _locale2.default)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            __("Please do not close this window during scanning", _locale2.default)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'scan-image-wrapper' },
	            _react2.default.createElement('img', { src: _scan2.default }),
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center circle-container' },
	              _react2.default.createElement('div', { className: 'circle1' }),
	              _react2.default.createElement('div', { className: 'circle2' }),
	              _react2.default.createElement('div', { className: 'circle3' }),
	              _react2.default.createElement('div', { className: 'circle4' }),
	              _react2.default.createElement('div', { className: 'circle5' })
	            )
	          )
	        ),
	        step === 'processing' && _react2.default.createElement(
	          'div',
	          { className: 'processing-container' },
	          _react2.default.createElement(_Loading2.default, null),
	          _react2.default.createElement(
	            'p',
	            null,
	            __('Processing...', _locale2.default)
	          )
	        ),
	        step === 'payment_successful' && _react2.default.createElement(
	          'div',
	          { className: 'scan-msg' },
	          _react2.default.createElement('i', { className: 'fa icon-ok' }),
	          _react2.default.createElement(
	            'h2',
	            null,
	            __('Payment Successful', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'a',
	            { className: 'btn btn-primary', onClick: function onClick() {
	                proceed({ success: true });
	              } },
	            __('Confirm', _locale2.default)
	          )
	        )
	      )
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);

/***/ },

/***/ "UmdA":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"new-payment-modal":"new-payment-modal","classtop-modal-content":"classtop-modal-content","processing-container":"processing-container","sleeve":"sleeve","new-payment-modal-content":"new-payment-modal-content","schemaLeft":"schemaLeft","schemaRight":"schemaRight","row":"row","price-on-modal":"price-on-modal","scan-msg":"scan-msg","scan-image-wrapper":"scan-image-wrapper","icon-ok":"icon-ok","circle-container":"circle-container","circle1":"circle1","blink-animation":"blink-animation","circle2":"circle2","circle3":"circle3","circle4":"circle4","circle5":"circle5"};

/***/ },

/***/ "3hQu":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _index = __webpack_require__("BztD");
	
	var _schemaLeft = __webpack_require__("Sb/z");
	
	var _schemaLeft2 = _interopRequireDefault(_schemaLeft);
	
	var _schemaRight = __webpack_require__("bMxF");
	
	var _schemaRight2 = _interopRequireDefault(_schemaRight);
	
	var _locale = __webpack_require__("iqR3");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("UmdA");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_Component) {
	  _inherits(ModalContent, _Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      formData: {},
	      paymentType: _this.props.paymentType || _index.ADD_CREDIT
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.changePaymentType = _this.changePaymentType.bind(_this);
	    return _this;
	  }
	
	  ModalContent.prototype.onChange = function onChange(formData) {
	    var _this2 = this;
	
	    this.setState({
	      formData: _extends({}, this.state.formData, formData)
	    }, function () {
	      _this2.props.onFormChange(formData);
	    });
	  };
	
	  ModalContent.prototype.changePaymentType = function changePaymentType(e) {
	    var _this3 = this;
	
	    this.setState({
	      paymentType: e.target.value,
	      formData: {}
	    }, function () {
	      _this3.props.onFormChange(_this3.state.formData);
	      _this3.props.changePaymentType(_this3.state.paymentType);
	    });
	  };
	
	  ModalContent.prototype.render = function render() {
	    var _state = this.state,
	        formData = _state.formData,
	        paymentType = _state.paymentType;
	    var student = this.props.student;
	
	    var schemaLeft = _schemaLeft2.default.call(this, paymentType);
	    var schemaRight = _schemaRight2.default.call(this, paymentType);
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'new-payment-modal-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'sleeve' },
	          (paymentType === _index.REFUND || paymentType == _index.REFUND_CREDIT) && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-6' },
	              _react2.default.createElement(
	                'label',
	                { className: 'control' },
	                _react2.default.createElement('input', { type: 'radio', name: 'charge_type', value: _index.REFUND, checked: paymentType === _index.REFUND, onChange: this.changePaymentType }),
	                __('Refund Class Fee', _locale2.default),
	                _react2.default.createElement('span', { className: 'radiomark' })
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                __('Refund the paid fee for this student', 'PaymentModal.refund')
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-6' },
	              _react2.default.createElement(
	                'label',
	                { className: 'control' },
	                _react2.default.createElement('input', { type: 'radio', name: 'charge_type', value: _index.REFUND_CREDIT, disabled: student.balance <= 0 ? true : false, checked: paymentType === _index.REFUND_CREDIT, onChange: this.changePaymentType }),
	                __('Refund Credits', _locale2.default),
	                _react2.default.createElement('span', { className: 'radiomark' })
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                __('Refund the collected credit for this student', 'PaymentModal.refund')
	              )
	            )
	          ),
	          paymentType !== _index.REFUND && paymentType !== _index.REFUND_CREDIT && _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              'label',
	              { className: 'control' },
	              _react2.default.createElement('input', { type: 'radio', name: 'charge_type', value: _index.ADD_CREDIT, checked: paymentType === _index.ADD_CREDIT, onChange: this.changePaymentType }),
	              __('Add Credit', 'student'),
	              _react2.default.createElement('span', { className: 'radiomark' })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              __("Add the credit to the student's account and can be used towards other expenses", 'student')
	            )
	          ),
	          student.classList && student.classList.length > 0 && paymentType !== _index.REFUND && paymentType !== _index.REFUND_CREDIT && _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              'label',
	              { className: 'control' },
	              _react2.default.createElement('input', { type: 'radio', name: 'charge_type', value: _index.CHARGE, checked: paymentType === _index.CHARGE, onChange: this.changePaymentType }),
	              __('Charge', 'student'),
	              _react2.default.createElement('span', { className: 'radiomark' })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              __('Collecting tuition fee and renewal', 'student')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-6 schemaLeft' },
	            _react2.default.createElement(_Form2.default, {
	              onChange: this.onChange,
	              schema: schemaLeft,
	              formData: formData,
	              formStyle: 'outline',
	              getValidationRef: this.props.getValidationRefLeft
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-6 schemaRight' },
	            _react2.default.createElement(_Form2.default, {
	              onChange: this.onChange,
	              schema: schemaRight,
	              formData: formData,
	              formStyle: 'outline',
	              getValidationRef: this.props.getValidationRefRight
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return ModalContent;
	}(_react.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "Sb/z":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ClassOptionItem = undefined;
	
	exports.default = function (paymentType) {
	  var _this = this;
	
	  var paymentOptions = [];
	
	  if (paymentType !== _index.REFUND && paymentType !== _index.REFUND_CREDIT) {
	    paymentOptions.push({
	      label: __('Online Payment', _locale2.default), options: [{ value: 'wechat_barcode_pay', label: __('WeChat Pay', _locale2.default) }, { value: 'ali_barcode_pay', label: __('Alipay', _locale2.default) }]
	    });
	  }
	
	  paymentOptions.push({
	    label: __('Transaction Record', _locale2.default),
	    options: [{ value: 'cash', label: __('Cash', 'PaymentModal') }, { value: 'credit_card', label: __('Credit Card', 'PaymentModal') }, { value: 'cheque', label: __('Cheque', 'PaymentModal') }, { value: 'bank_transfer', label: __('Bank Transfer', 'PaymentModal') }, { value: 'wechat_record_only', label: __('WeChat Pay Transfer', 'PaymentModal') }, { value: 'ali_record_only', label: __('Alipay Transfer', 'PaymentModal') }]
	  });
	
	  if (paymentType !== _index.ADD_CREDIT && paymentType !== _index.REFUND_CREDIT) {
	    paymentOptions.push({ value: 'school_credit', label: __('School Credit', 'PaymentModal') });
	  }
	
	  var classOptions = void 0;
	  if (this.props.classDetail) {
	    classOptions = [ClassOptionItem(this.props.classDetail, currency)];
	  } else {
	    var classes = this.props.student.classList || [];
	    classOptions = classes.map(function (cls) {
	      return ClassOptionItem(cls, _this.props.student.currency);
	    });
	  }
	
	  switch (paymentType) {
	    case _index.ADD_CREDIT:
	      return topupSchema.call(this, paymentOptions);
	      break;
	    case _index.CHARGE:
	      return chargeSchema.call(this, paymentOptions, classOptions);
	      break;
	    case _index.REFUND:
	      return refundSchema.call(this, paymentOptions, classOptions);
	      break;
	    case _index.REFUND_CREDIT:
	      return refundCreditSchema.call(this, paymentOptions, classOptions);
	      break;
	  }
	};
	
	var _index = __webpack_require__("BztD");
	
	var _locale = __webpack_require__("iqR3");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClassOptionItem = exports.ClassOptionItem = function ClassOptionItem(cls) {
	  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  return {
	    value: cls.classID,
	    label: _react2.default.createElement(
	      'div',
	      { className: 'select-class' },
	      _react2.default.createElement(
	        'span',
	        null,
	        cls.className
	      )
	    )
	  };
	};
	
	function refundSchema(paymentOptions, classOptions) {
	  var _props = this.props,
	      currentClass = _props.currentClass,
	      student = _props.student,
	      studentCreditInfo = _props.studentCreditInfo;
	
	
	  var usedPurchasedLabel = void 0;
	  var lessonLabel = void 0;
	  var lessonQuantityLabel = void 0;
	  var fee = void 0;
	  var currency = student.currency ? student.currency : studentCreditInfo.currency;
	
	  if (currentClass.feeType == 0) {
	    usedPurchasedLabel = __('Term Rate', _locale2.default);
	    lessonLabel = __('Term Rate', _locale2.default);
	    fee = currentClass.classTotalFee;
	  } else if (currentClass.feeType == 1) {
	    usedPurchasedLabel = __('Used Lessons/Purchased Lessons', _locale2.default);
	    lessonLabel = __('Lesson Rate', _locale2.default);
	    fee = currentClass.unitPrice;
	    lessonQuantityLabel = __('Refund Lessons', _locale2.default);
	  } else if (currentClass.feeType == 2) {
	    usedPurchasedLabel = __('Used Hours/Purchased Hours', _locale2.default);
	    lessonLabel = __('Hour Rate', _locale2.default);
	    fee = currentClass.unitPrice;
	    lessonQuantityLabel = __('Refund Hours', _locale2.default);
	  }
	
	  return [{
	    name: 'class_id',
	    label: __('Class', _locale2.default),
	    type: 'reactSearch',
	    required: true,
	    options: classOptions,
	    direction: 'down'
	  }, {
	    type: 'customContent',
	    content: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'label',
	        { className: 'control-label' },
	        usedPurchasedLabel
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        currentClass.usedTotalQuantity + '/' + currentClass.paidTotalQuantity
	      )
	    ),
	    hidden: !this.state.formData.class_id || currentClass.feeType === 0 ? true : false
	  }, {
	    type: 'customContent',
	    content: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'label',
	        { className: 'control-label' },
	        lessonLabel
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        fee + ' ' + currency
	      )
	    ),
	    hidden: !this.state.formData.class_id ? true : false
	  }, {
	    name: 'end_date',
	    label: __('Refund Lesson Until...', _locale2.default),
	    type: 'datePicker',
	    hasEndDate: false,
	    required: this.props.currentClass.feeType === 0 ? true : false,
	    hidden: !this.state.formData.class_id || currentClass.feeType !== 0 ? true : false
	  }, {
	    name: 'lesson_quantity',
	    label: lessonQuantityLabel,
	    type: 'number',
	    required: currentClass.feeType === 0 ? false : true,
	    hidden: !this.state.formData.class_id || currentClass.feeType === 0 ? true : false
	  }, {
	    name: 'amount_of_money',
	    label: __('Refund Amount', _locale2.default),
	    type: 'money',
	    required: true
	  }, {
	    name: 'trade_date',
	    label: __('Refund Date', _locale2.default),
	    type: 'datePicker',
	    required: true
	  }, {
	    name: 'payment_method',
	    label: __('Refund Methods', _locale2.default),
	    type: 'reactSearch',
	    required: true,
	    options: paymentOptions,
	    direction: 'up'
	  }];
	}
	
	function refundCreditSchema(paymentOptions, classOptions) {
	  return [{
	    name: 'amount_of_money',
	    label: __('Refund Amount', _locale2.default),
	    type: 'money',
	    required: true
	  }, {
	    name: 'trade_date',
	    label: __('Refund Date', _locale2.default),
	    type: 'datePicker',
	    required: true
	  }, {
	    name: 'payment_method',
	    label: __('Refund Methods', _locale2.default),
	    type: 'reactSearch',
	    required: true,
	    options: paymentOptions,
	    direction: 'up'
	  }];
	}
	
	function chargeSchema(paymentOptions, classOptions) {
	  var amountLabel = void 0;
	  var lessonLabel = void 0;
	  var tempPrice = void 0;
	  var fixValue = void 0;
	
	  if (this.props.currentClass.feeType == 0) {
	    amountLabel = __('Term Rate', _locale2.default);
	    tempPrice = this.props.currentClass.classTotalFee;
	  } else if (this.props.currentClass.feeType == 1) {
	    amountLabel = __('Lesson Rate', _locale2.default);
	    tempPrice = this.props.currentClass.unitPrice;
	    lessonLabel = __('Number of lessons', _locale2.default);
	  } else if (this.props.currentClass.feeType == 2) {
	    amountLabel = __('Hour Rate', _locale2.default);
	    tempPrice = this.props.currentClass.unitPrice;
	    lessonLabel = __('Number of hours', _locale2.default);
	  }
	
	  if (this.state.formData.amount_payable && this.props.currentClass.tuition_consumption === null) {
	    tempPrice = this.state.formData.amount_payable;
	  }
	
	  var discountPrice = this.state.formData.discount_amount || 0;
	  var lessonQuantity = this.state.formData.lesson_quantity || 1;
	
	  return [{
	    name: 'class_id',
	    label: __('Class', _locale2.default),
	    type: 'reactSearch',
	    required: true,
	    options: classOptions,
	    direction: 'down'
	  }, {
	    type: 'customContent',
	    content: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'label',
	        { className: 'control-label' },
	        amountLabel
	      ),
	      tempPrice >= 0 && this.props.currentClass.tuition_consumption !== null && _react2.default.createElement(
	        'div',
	        null,
	        this.state.formData.class_id ? tempPrice + ' ' + this.props.student.currency : ''
	      ),
	      (!tempPrice || this.props.currentClass.tuition_consumption === null) && _react2.default.createElement(
	        'div',
	        { style: { color: 'red' } },
	        __('Setup', _locale2.default)
	      )
	    ),
	    hidden: this.state.formData.class_id ? false : true
	  }, {
	    name: 'lesson_quantity',
	    label: lessonLabel,
	    type: 'number',
	    required: this.props.currentClass.feeType === 0 ? false : true,
	    hidden: !this.state.formData.class_id || this.props.currentClass.feeType === 0 ? true : false
	  }, {
	    type: 'customContent',
	    content: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'label',
	        { className: 'control-label' },
	        __('Total Price', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        this.state.formData.class_id ? tempPrice * lessonQuantity + ' ' + this.props.student.currency : ''
	      )
	    ),
	    hidden: this.state.formData.class_id && this.props.currentClass.tuition_consumption !== null ? false : true
	  }, {
	    name: 'end_date',
	    label: __('Purchase Lesson Until...', _locale2.default),
	    type: 'datePicker',
	    hasEndDate: false,
	    required: this.props.currentClass.feeType === 0 ? true : false,
	    hidden: !this.state.formData.class_id || this.props.currentClass.feeType !== 0 ? true : false
	  }, {
	    name: 'amount_payable',
	    label: __('Total Price', _locale2.default),
	    type: 'money',
	    required: false,
	    hidden: !this.state.formData.class_id || this.props.currentClass.tuition_consumption !== null ? true : false
	  }, {
	    name: 'discount_amount',
	    label: __('Discount Price', _locale2.default),
	    type: 'money',
	    required: false
	  }, {
	    name: 'amount_of_money',
	    label: __('Net Price', _locale2.default),
	    type: 'money',
	    fixValue: this.props.currentClass.tuition_consumption === null ? tempPrice - discountPrice : tempPrice * lessonQuantity - discountPrice,
	    required: false,
	    disabled: true,
	    allowNegative: true
	  }];
	}
	
	function topupSchema(paymentOptions) {
	  return [{
	    name: 'amount_of_money',
	    label: __('Top-up Amount', _locale2.default),
	    type: 'money',
	    required: true
	  }, {
	    name: 'trade_date',
	    label: __('Top-up Date', _locale2.default),
	    type: 'datePicker',
	    required: true
	  }, {
	    name: 'payment_method',
	    label: __('Payment Methods', _locale2.default),
	    type: 'reactSearch',
	    required: true,
	    options: paymentOptions,
	    direction: 'up'
	  }];
	}

/***/ },

/***/ "iqR3":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _text;
	
	exports.default = {
	  id: 'NewPaymentModal',
	  code: 'CN',
	  text: (_text = {
	    'Hours To Be Refunded': '退掉多少小时',
	    'Refund Lesson Until...': '退款后课期为',
	    'Number Of Lesson To Refund': '退掉多少课次',
	    'Refund Method': '退款方式',
	
	    'Online Payment': '在线支付',
	    'Transaction Record': '记账',
	    'WeChat Pay': '微信支付',
	    'Alipay': '支付宝',
	    'Proceed to payment': '下一步',
	
	    'Remarks': '备注',
	    'Email': '邮箱',
	    'Paper Receipt Number': '纸质收据号',
	    'Send Receipt To Parents': '电子收据会通过邮件发给家长',
	
	    'Top-up Amount': '充值金额',
	    'Top-up Date': '充值日期',
	    'Payment Methods': '付款方式',
	
	    'Charge Amount': '收款金额',
	    'Class': '班级',
	    'Charge Date': '收款日期',
	
	    'Purchase Lesson Until...': '购买课期至'
	  }, _text['Refund Lesson Until...'] = '退款课期至', _text['Used Lessons/Purchased Lessons'] = '消耗课次/购买课次', _text['Used Hours/Purchased Hours'] = '消耗课时/购买课时', _text['Number of lessons'] = '购买课次', _text['Number of hours'] = '购买课时', _text['Refund Amount'] = '退款金额', _text['Refund Date'] = '退款日期', _text['Refund Lessons'] = '退款课次', _text['Refund Hours'] = '退款课时', _text['Term Rate'] = '课期总价', _text['Hour Rate'] = '课次单价', _text['Lesson Rate'] = '课时单价', _text['Discount Price'] = '折扣金额', _text['Total Price'] = '应付金额', _text['Net Price'] = '实付金额', _text['Refund Class Fee'] = '班级退款', _text['Refund Credits'] = '钱包退款', _text['Refund Methods'] = '退款方式', _text['Scan Payment QR Code'] = '扫描付款QR码', _text['Please do not close this window during scanning'] = '扫描时请不要关闭当前窗口', _text['Payment Successful'] = '付款成功！', _text['Confirm'] = '确定', _text['Setup'] = '未设置', _text['This school has not integrate weChat Pay and AliPay, please contact our product specialist'] = '此学校未开通微信支付和支付宝支付，请联系我们的产品专家', _text['Payment Request Timeout'] = '付款请求超时', _text['Processing...'] = '处理中...', _text)
	};
	module.exports = exports['default'];

/***/ },

/***/ "bMxF":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (paymentType) {
	
	  var paymentOptions = [];
	
	  if (paymentType !== _index.REFUND) {
	    paymentOptions.push({
	      label: __('Online Payment', _locale2.default), options: [{ value: 'wechat_barcode_pay', label: __('WeChat Pay', _locale2.default) }, { value: 'ali_barcode_pay', label: __('Alipay', _locale2.default) }]
	    });
	  }
	
	  paymentOptions.push({
	    label: __('Transaction Record', _locale2.default),
	    options: [{ value: 'cash', label: __('Cash', 'PaymentModal') }, { value: 'credit_card', label: __('Credit Card', 'PaymentModal') }, { value: 'cheque', label: __('Cheque', 'PaymentModal') }, { value: 'bank_transfer', label: __('Bank Transfer', 'PaymentModal') }, { value: 'wechat_record_only', label: __('WeChat Pay Transfer', 'PaymentModal') }, { value: 'ali_record_only', label: __('Alipay Transfer', 'PaymentModal') }]
	  });
	
	  if (paymentType !== _index.ADD_CREDIT) {
	    paymentOptions.push({ value: 'school_credit', label: __('School Credit', 'PaymentModal') });
	  }
	
	  switch (paymentType) {
	    case _index.ADD_CREDIT:
	      return defaultSchema.call(this, paymentOptions);
	      break;
	    case _index.CHARGE:
	      return chargeSchema.call(this, paymentOptions);
	      break;
	    case _index.REFUND:
	      return defaultSchema.call(this, paymentOptions);
	      break;
	    case _index.REFUND_CREDIT:
	      return defaultSchema.call(this, paymentOptions);
	      break;
	  }
	};
	
	var _index = __webpack_require__("BztD");
	
	var _locale = __webpack_require__("iqR3");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultSchema() {
	  return [{
	    name: 'send_email_or_not',
	    placeholder: __('Send Receipt To Parents', _locale2.default),
	    type: 'checkbox',
	    required: false
	  }, {
	    name: 'email_recipient',
	    label: __('Email', _locale2.default),
	    type: 'email',
	    required: this.state.formData.send_email_or_not ? true : false,
	    hidden: this.state.formData.send_email_or_not ? false : true
	  }, {
	    name: 'paper_receipt_num',
	    label: __('Paper Receipt Number', _locale2.default),
	    type: 'text',
	    required: false
	  }, {
	    name: 'remark',
	    label: __('Remarks', _locale2.default),
	    type: 'textarea',
	    required: false
	  }];
	}
	
	function chargeSchema(paymentOptions) {
	
	  return [{
	    name: 'trade_date',
	    label: __('Charge Date', _locale2.default),
	    type: 'datePicker',
	    required: true
	  }, {
	    name: 'payment_method',
	    label: __('Payment Methods', _locale2.default),
	    type: 'reactSearch',
	    required: true,
	    options: paymentOptions,
	    direction: 'up'
	  }, {
	    name: 'send_email_or_not',
	    placeholder: __('Send Receipt To Parents', _locale2.default),
	    type: 'checkbox',
	    required: false
	  }, {
	    name: 'email_recipient',
	    label: __('Email', _locale2.default),
	    type: 'email',
	    required: this.state.formData.send_email_or_not ? true : false,
	    hidden: this.state.formData.send_email_or_not ? false : true
	  }, {
	    name: 'paper_receipt_num',
	    label: __('Paper Receipt Number', _locale2.default),
	    type: 'text',
	    required: false
	  }, {
	    name: 'remark',
	    label: __('Remarks', _locale2.default),
	    type: 'textarea',
	    required: false
	  }];
	}
	module.exports = exports['default'];

/***/ },

/***/ "CwGh":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("AWmt");
	
	var _Male_student = __webpack_require__("X56S");
	
	var _Male_student2 = _interopRequireDefault(_Male_student);
	
	var _Female_student = __webpack_require__("Irbd");
	
	var _Female_student2 = _interopRequireDefault(_Female_student);
	
	var _defaultLogo = __webpack_require__("bReY");
	
	var _defaultLogo2 = _interopRequireDefault(_defaultLogo);
	
	var _maleUserIcon = __webpack_require__("njhv");
	
	var _maleUserIcon2 = _interopRequireDefault(_maleUserIcon);
	
	var _femaleUserIcon = __webpack_require__("iEF/");
	
	var _femaleUserIcon2 = _interopRequireDefault(_femaleUserIcon);
	
	var _Photo = __webpack_require__("7PAg");
	
	var _Photo2 = _interopRequireDefault(_Photo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <StudentModalHeader />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * this is a custom modal header
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent mostly Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var StudentModalHeader = function (_Component) {
	  _inherits(StudentModalHeader, _Component);
	
	  function StudentModalHeader(props) {
	    _classCallCheck(this, StudentModalHeader);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  StudentModalHeader.prototype.onClick = function onClick() {
	    var profilePhoto = this.props.profilePhoto;
	
	
	    (0, _Photo2.default)({ photo: profilePhoto });
	  };
	
	  StudentModalHeader.prototype.render = function render() {
	    var _props = this.props,
	        name = _props.name,
	        gender = _props.gender,
	        profilePhoto = _props.profilePhoto,
	        profileThumbnail = _props.profileThumbnail,
	        type = _props.type;
	
	    var portrait = void 0;
	    var hasProfilePhoto = false;
	
	    if (profileThumbnail) {
	      portrait = profileThumbnail;
	      hasProfilePhoto = true;
	    } else if (type == 'teacher') {
	      switch (gender) {
	        case 0:
	        case 'male':
	          portrait = _maleUserIcon2.default;
	          break;
	        case 1:
	        case 'female':
	          portrait = _femaleUserIcon2.default;
	          break;
	        case 2:
	          portrait = _defaultLogo2.default;
	          break;
	        case 3:
	          portrait = _defaultLogo2.default;
	          break;
	      }
	    } else {
	      switch (gender) {
	        case 0:
	        case 'male':
	          portrait = _Male_student2.default;
	          break;
	        case 1:
	        case 'female':
	          portrait = _Female_student2.default;
	          break;
	        case 2:
	          portrait = _defaultLogo2.default;
	          break;
	        case 3:
	          portrait = _defaultLogo2.default;
	          break;
	      }
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'student-modal-header' },
	      _react2.default.createElement('div', { className: (0, _classnames2.default)('portrait', { hasProfilePhoto: hasProfilePhoto }),
	        onClick: this.onClick,
	        style: {
	          backgroundImage: 'url(' + portrait + ')'
	        } }),
	      _react2.default.createElement(
	        'div',
	        { className: 'student-name' },
	        name
	      )
	    );
	  };
	
	  return StudentModalHeader;
	}(_react.Component);
	
	exports.default = StudentModalHeader;
	module.exports = exports['default'];

/***/ },

/***/ "AWmt":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"student-modal-header":"student-modal-header","student-name":"student-name","portrait":"portrait","hasProfilePhoto":"hasProfilePhoto"};

/***/ },

/***/ "X56S":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Male_student.a06bbd5c.png";

/***/ },

/***/ "Irbd":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Female_student.e0d086e2.png";

/***/ },

/***/ "bReY":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "default-logo.8d181f79.png";

/***/ },

/***/ "njhv":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "male-user-icon.c4ba6b8b.png";

/***/ },

/***/ "iEF/":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "female-user-icon.7982dfc3.png";

/***/ },

/***/ "7PAg":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (!opts.photo) {
	    throw new Error('opts.photo is missing!');
	  }
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("Lq2H");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports['default'];

/***/ },

/***/ "Lq2H":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("+uYp");
	
	var _ModalContent = __webpack_require__("9NQH");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel,
	        title = _props.title;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        isShowingModal: show // if you want to show it when component mounts, set it true
	
	        // allowCloseByClickingShadow={false}
	        // useDefaultClosebutton={true} 
	        , onCloseModalClick: dismiss,
	        fixedHeight: 300,
	        fixedWidth: 300
	        // overlayColor="#000"
	        // contentHeight={300} 
	        , className: 'photo-view-modal',
	        hasHeader: false,
	        headerType: 'default' // default, bold 
	        , headerTitle: title,
	        headerIcon: 'fa icon-play' // class for icon tag
	        , hasFooter: false
	      },
	      _react2.default.createElement(_ModalContent2.default, this.props)
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "+uYp":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"photo-view-modal":"photo-view-modal","content-wrapper":"content-wrapper","classtop-modal-content":"classtop-modal-content","custom-modal-content":"custom-modal-content","classtop-loading":"classtop-loading"};

/***/ },

/***/ "9NQH":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent() {
	    _classCallCheck(this, ModalContent);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalContent.prototype.render = function render() {
	    var photo = this.props.photo;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'custom-modal-content' },
	      _react2.default.createElement('img', { src: photo })
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "ByhE":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "scan.2efba815.png";

/***/ },

/***/ "tMIw":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = snapScan;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	http://localhost:8000/sapi/snap_scan/{ trade_record_id }/
	Snap Pay 扫码枪支付接口，仅当选择snap pay的微信扫码支付或支付宝扫码支付时，才能调用这个接口。
	:param request:
	    {
	        "auth_code": "32142131231", # 扫码枪所扫描的家长支付宝或微信支付的付款二维码
	        "send_email_or_not": 0, # 是否在成功后发邮件，0:不发，1:发。仅在成功后才发
	        "email_recipient": “yanan.song@richwaytech.ca” # 收件人email
	    }
	
	:param pk: trade_record_id
	:return:
	    支付成功时：
	    {
	        'creation_result’: 'success’,
	        'payment_result’: 'success’,
	        'school_student_id’: trade_record.trStudent_id,
	        'school_student_name’: trade_record.trStudent.ssName,
	        'trade_id’: pk,
	        'trade_type’: trade_record.trType,
	        'amount_of_money’: trade_record.trTransactionAmount,
	        'payment_state’: trade_record.payment_state,
	        'class_id’: trade_record.trClass_id,
	    }
	
	    创建成功，但支付是否成功还需要调接口确认时：
	    response_data = {
	        'creation_result': 'success',
	        'payment_result': 'to be queried',
	        'school_student_id': trade_record.trStudent_id,
	        'school_student_name': trade_record.trStudent.ssName,
	        'trade_id': pk,
	        'trade_type': trade_record.trType,
	        'amount_of_money': trade_record.trTransactionAmount,
	        'payment_state': trade_record.payment_state,
	        'class_id': trade_record.trClass_id,
	    }
	
	    如果支付方式不是微信扫码支付或者支付宝扫码支付，则不应调这个接口，返回错误：
	    {'result': 'failure', 'reason': 'wrong source_or_direction.'}
	
	    如果该trade_record已经被支付完成了，或者其他无法支付的状态，则返回错误：
	    {'result': 'failure', 'reason': 'this trade_record can not be paid'}
	
	*/
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	    auth_code: _joiBrowser2.default.string().required(),
	    email_recipient: _joiBrowser2.default.string().allow(''),
	    send_email_or_not: _joiBrowser2.default.boolean()
	});
	
	function snapScan(tradeID, params) {
	    var validateResult = _joiBrowser2.default.validate(params, schema);
	
	    if (validateResult.error) {
	        return new Promise(function (resolve, reject) {
	            reject(validateResult);
	        });
	    }
	
	    params.send_email_or_not = params.send_email_or_not ? 1 : 0;
	
	    return new Promise(function (resolve, reject) {
	        _axios2.default.put(_config.APIAddress, { 'uri': '/snap_scan/' + tradeID + '/',
	            'method': 'POST',
	            'data': JSON.stringify(params),
	            'token': localStorage.getItem('token') }).then(function (res) {
	            resolve(res.data);
	        }).catch(function (err) {
	            reject(err);
	        });
	    });
	}

/***/ },

/***/ "5rP/":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = checkSnapScan;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	:param pk: trade_record_id
	:return:
	    {
	        'payment_result': 'success' / 'to be queried',  # 支付成功 / 支付还未成功
	        'school_student_id': trade_record.trStudent_id,
	        'school_student_name': trade_record.trStudent.ssName,
	        'trade_id': pk,
	        'trade_type': trade_record.trType,
	        'amount_of_money': trade_record.trTransactionAmount,
	        'payment_state': trade_record.payment_state,
	        'class_id': trade_record.trClass_id,
	    }
	
	    如果该交易记录不是用的支付宝或微信，返回错误：
	    {'result': 'failure', 'reason': 'this record was not paid by Wechat pay or Alipay'}
	
	    如果这个学校还没通过ClassTop inc.开通微信支付或支付宝支付，返回错误，这里需要弹框提示学校联络ClassTop进行开通：
	    {'result': 'failure', 'reason': 'the school has not set Wechat pay or Alipay'}
	*/
	
	function checkSnapScan(tradeID) {
	
	  if (typeof tradeID == 'undefined') {
	    throw new Error('Missing tradeID');
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/snap_scan/' + tradeID + '/',
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "Qjqn":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getStudentCreditInfo;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStudentCreditInfo(studentId) {
	
	  if (!studentId) {
	    throw 'missing student ID';
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/g_credit/' + studentId + '/',
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "GxWe":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                  http://localhost:8000/sapi/u_trade2/{ school_student_id }/
	                                                                                                                                                                                                                                                                  
	                                                                                                                                                                                                                                                                  注：当学员没有加入一个班级时，无法向一个班级付费。如果想实现这步操作，需要先调加入班级接口，然后再调收费接口。
	                                                                                                                                                                                                                                                                  
	                                                                                                                                                                                                                                                                      :param request:
	                                                                                                                                                                                                                                                                          {
	                                                                                                                                                                                                                                                                              "operator_id": 4,  # 经办人的user_id，可选范围为校长、老师、行政人员，原接口的'oprID'
	                                                                                                                                                                                                                                                                              "class_id": 16,  # 缴费至哪个班级，或从哪个班级退费，为空则表示充值给学校（存到该学员在该学校的credit里）或从学校credit里退钱给家长，原接口的'clsID'
	                                                                                                                                                                                                                                                                              "trade_type": 1,  # 1:缴费，2:退费，原接口的'optType'，对应models中的 trType 字段
	                                                                                                                                                                                                                                                                              "amount_payable": 100,  # 应付金额，单位是元，可为空
	                                                                                                                                                                                                                                                                              "discount_amount": 0,  # 优惠所扣减的金额，单位是元，可为空
	                                                                                                                                                                                                                                                                              "amount_of_money": 200,  # 缴费或退费的金额，原接口的'cost'
	                                                                                                                                                                                                                                                                              "lesson_quantity": 12,  # 购买或退的课次|课小时，可为空，原接口的'quantity'
	                                                                                                                                                                                                                                                                              "end_date": 2017-12-01,  # 当class为按日期时此字段有用，原接口的'endDate'
	                                                                                                                                                                                                                                                                              "remark": "这个学生需要注意提醒续费",  # 备注信息，仅给校长看的
	                                                                                                                                                                                                                                                                              "payment_method": 0,  # 付款或退款的方法：0:现金；1:信用卡; 2:支票; 3:转账 4:学校授与的Credit 5:存在ClassTop的deposit（校长暂时无法选择5）
	                                                                                                                                                                                                                                                                                                    # 6:wxBarCodePay:微信条码 7:aliBarCodePay:支付宝扫码枪, 8: wxNativePay:微信网页支付；9: aliWebPay:支付宝网页支付；
	                                                                                                                                                                                                                                                                                                    # 10: 微信转账（未通过classtop转账）, 11: 支付宝转账（未通过classtop转账）
	                                                                                                                                                                                                                                                                              "email_recipient": "adam@classtop.com",  # 接收电子transaction summary的email
	                                                                                                                                                                                                                                                                              "send_email_or_not": 1,  # 是否发电子收据的标识，0:不发，1:发
	                                                                                                                                                                                                                                                                              "paper_receipt_num": "AB1232",  # 如果线下给了纸质单据，这里填纸质单据的号码，没有则为空
	                                                                                                                                                                                                                                                                              "trade_date": "2017-10-11",  # 付款日期，默认载入当前日期，可手动更改
	                                                                                                                                                                                                                                                                          }
	                                                                                                                                                                                                                                                                  
	                                                                                                                                                                                                                                                                      :param pk: school_student_id
	                                                                                                                                                                                                                                                                      :return: 成功时：
	                                                                                                                                                                                                                                                                          {
	                                                                                                                                                                                                                                                                  
	                                                                                                                                                                                                                                                                              'result': 'success',
	                                                                                                                                                                                                                                                                              'school_student_id': 1,
	                                                                                                                                                                                                                                                                              'school_student_name': 'Adam Song',
	                                                                                                                                                                                                                                                                              'trade_id': 9
	                                                                                                                                                                                                                                                                              'trade_type': 1,  #1=缴费 2=退费
	                                                                                                                                                                                                                                                                              'amount_of_money': 100,  # 单位：元
	                                                                                                                                                                                                                                                                              'payment_state': 1,  # 0:付款未成功 1:付款已成功 2:线下付款记录（未在系统内付款，仅记录）
	                                                                                                                                                                                                                                                                              'class_id': 15,
	                                                                                                                                                                                                                                                                          }
	                                                                                                                                                                                                                                                                          失败时：
	                                                                                                                                                                                                                                                                          {'result': 'failure', 'reason': 'wrong payment_method'}
	                                                                                                                                                                                                                                                                  */
	
	exports.validateForm = validateForm;
	exports.default = updateStudentTrade;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TRADE_TYPE = ['', 'charge', 'refund'];
	var PAYMENT_METHOD = ['cash', // 0
	'credit_card', // 1
	'cheque', // 2
	'bank_transfer', // 3
	'school_credit', // 4
	'_', // 5
	'wechat_barcode_pay', // 6
	'ali_barcode_pay', // 7
	'wechat_native_pay', // 8
	'ali_web_pay', // 9
	'wechat_record_only', // 10
	'ali_record_only'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  // NOTE: operator_id is not a school ID. It is the id of the owner of the school
	  operator_id: _joiBrowser2.default.number().integer().required(), // 经办人的user_id，可选范围为校长、老师、行政人员，原接口的'oprID'
	  class_id: _joiBrowser2.default.number().integer().allow(null),
	  trade_type: _joiBrowser2.default.string().valid(TRADE_TYPE).required(),
	  amount_payable: _joiBrowser2.default.number(),
	  discount_amount: _joiBrowser2.default.number(),
	  amount_of_money: _joiBrowser2.default.number().required(),
	  lesson_quantity: _joiBrowser2.default.number(),
	  end_date: _joiBrowser2.default.string().allow(null),
	  remark: _joiBrowser2.default.string().allow(''),
	  payment_method: _joiBrowser2.default.string().valid(PAYMENT_METHOD).required(),
	  email_recipient: _joiBrowser2.default.string().email().allow(''),
	  send_email_or_not: _joiBrowser2.default.boolean(), // this is actually required. But if you pass 'null' we will treat it as 'false'
	  paper_receipt_num: _joiBrowser2.default.string().allow(''),
	  trade_date: _joiBrowser2.default.string().required()
	});
	
	function validateForm(data) {
	  return _joiBrowser2.default.validate(data, schema, {
	    abortEarly: false
	  });
	}
	
	function updateStudentTrade(studentId, tradeInfo) {
	
	  if (!studentId) {
	    throw new Error('Missing student ID');
	  }
	
	  var validateResult = validateForm(tradeInfo);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, tradeInfo, {
	    trade_type: TRADE_TYPE.indexOf(tradeInfo.trade_type),
	    payment_method: PAYMENT_METHOD.indexOf(tradeInfo.payment_method),
	    send_email_or_not: tradeInfo.send_email_or_not === true ? 1 : 0,
	    amount_of_money: Number(tradeInfo.amount_of_money)
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/u_trade2/' + studentId + '/',
	      'method': 'POST',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res);
	    }).catch(function (err) {
	      reject();
	    });
	  });
	}

/***/ },

/***/ "sbFW":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalProvider = __webpack_require__("A4HT");
	
	var _ModalProvider2 = _interopRequireDefault(_ModalProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalProvider2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "A4HT":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalBody = __webpack_require__("vFv0");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalProvider = function (_React$Component) {
	  _inherits(ModalProvider, _React$Component);
	
	  function ModalProvider(props) {
	    _classCallCheck(this, ModalProvider);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalProvider.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(_ModalBody2.default, this.props)
	    );
	  };
	
	  return ModalProvider;
	}(_react2.default.Component);
	
	exports.default = ModalProvider;
	module.exports = exports['default'];

/***/ },

/***/ "vFv0":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("Tna2");
	
	var _ModalContent = __webpack_require__("sWQO");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _locale = __webpack_require__("+sMC");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _addClass = __webpack_require__("yjcn");
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _editClass = __webpack_require__("OHvH");
	
	var _editClass2 = _interopRequireDefault(_editClass);
	
	var _getClassTeacherStudent = __webpack_require__("TnP3");
	
	var _getClassTeacherStudent2 = _interopRequireDefault(_getClassTeacherStudent);
	
	var _ducks = __webpack_require__("wTtZ");
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _ducks2 = __webpack_require__("lDbx");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
		return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
		return {
			fetchClass: function fetchClass(opts) {
				return dispatch((0, _ducks.fetchClass)(opts));
			},
			fetchClassLesson: function fetchClassLesson(classId, params) {
				return dispatch((0, _ducks2.fetchClassLesson)(classId, params));
			}
		};
	};
	
	var ModalBody = function (_React$Component) {
		_inherits(ModalBody, _React$Component);
	
		function ModalBody(props) {
			_classCallCheck(this, ModalBody);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			var INIT_FORM_DATA = {
				costAlertRange: 1,
				costRule: true,
				absentFlag: true,
				cancelFlag: false,
				billingMethod: {
					feeType: 0
				}
			};
	
			_this.state = {
				classData: INIT_FORM_DATA,
				disabledBtn: false
			};
			return _this;
		}
	
		ModalBody.prototype.componentDidMount = function componentDidMount() {
			var _this2 = this;
	
			if (this.props.id) {
				(0, _getClassTeacherStudent2.default)(this.props.id, true).then(function (res) {
					var studentArr = [];
					if (res.classStudentList.length >= 1) {
						// studentArr = [{name: res.classStudentList[0].ssName, id: res.classStudentList[0].id}]
						studentArr = res.classStudentList.map(function (student) {
							return {
								name: student.ssName,
								id: student.id
							};
						});
					}
					var teacherArr = [];
					res.classTeacherList.map(function (item) {
						teacherArr.push({ name: item.stName, id: item.id });
					});
	
					var classData = {
						cName: res.classDetail.cName,
						feeType: res.classDetail.feeType,
						costAlertRange: res.classDetail.costAlertRange,
						costRule: true,
						cancelFlag: res.classDetail.cancelFlag == 1 ? true : false,
						absentFlag: res.classDetail.absentFlag == 1 ? true : false,
						student_id_list: studentArr,
						teacher_id_list: teacherArr,
						billingMethod: {
							feeType: res.classDetail.feeType,
							totalPrice: res.classDetail.totalPrice,
							unitPrice: res.classDetail.unitPrice,
							consumption_type: res.classDetail.consumption_type
						}
					};
					_this2.setState({ classData: classData });
				});
			}
	
			if (this.props.studentInfo) {
				var studentArr = [{ name: this.props.studentInfo[0].name, id: this.props.studentInfo[0].id }];
				var classData = {
					student_id_list: studentArr,
					costAlertRange: 1,
					costRule: true,
					absentFlag: false,
					cancelFlag: true,
					billingMethod: {
						feeType: 0
					}
				};
				this.setState({ classData: classData });
			}
		};
	
		ModalBody.prototype.render = function render() {
			var _this3 = this;
	
			var _props = this.props,
			    show = _props.show,
			    proceed = _props.proceed,
			    dismiss = _props.dismiss,
			    cancel = _props.cancel,
			    mode = _props.mode,
			    pagination = _props.pagination,
			    pageState = _props.pageState;
	
	
			var schoolId = localStorage.getItem('schoolId');
	
			return _react2.default.createElement(
				_Modal2.default,
				{
					className: 'create-classone-modal',
					isShowingModal: show,
	
					onCloseModalClick: dismiss,
					fixedWidth: 600,
					overlayColor: '#000',
	
					hasHeader: true,
					headerTitle: this.props.mode == 'create' ? __('Create Private Class', _locale2.default) : __('Edit Private Class', _locale2.default),
					headerType: 'bold',
					footerType: 'grey',
					hasFooter: true,
					footerButtons: [{
						title: __('Complete', 'appwrapper'),
						className: 'btn btn-primary pull-right',
						onClick: function onClick() {
							_this3.setState({ disabledBtn: true });
	
							var validateResult = _this3.validate();
	
							if (!validateResult.ok) {
								_this3.setState({ disabledBtn: false });
								return;
							}
	
							var arr = [];
							if (_this3.state.classData.teacher_id_list) {
								_this3.state.classData.teacher_id_list.map(function (teacher) {
									arr.push(teacher.id);
								});
							}
	
							var consumption_type = void 0;
							var feeType = _this3.state.classData.billingMethod.feeType ? _this3.state.classData.billingMethod.feeType : 1;
	
							feeType == 1 ? consumption_type = 1 : consumption_type = 2;
	
							var newFormData = _extends({}, _this3.state.classData, {
								absentFlag: _this3.state.classData.absentFlag ? 1 : 0,
								cancelFlag: _this3.state.classData.cancelFlag ? 1 : 0,
								costRule: 1,
								cType: 1,
								// student_id_list: this.state.classData.student_id_list.length >= 1 ? [this.state.classData.student_id_list[0].id] : [],
								student_id_list: (_this3.state.classData.student_id_list || []).map(function (student) {
									return student.id;
								}),
								teacher_id_list: arr,
								feeType: typeof _this3.state.classData.billingMethod.feeType !== 'undefined' ? _this3.state.classData.billingMethod.feeType : 1,
								consumption_type: _this3.state.classData.billingMethod.consumption_type ? _this3.state.classData.billingMethod.consumption_type : consumption_type,
								totalPrice: _this3.state.classData.billingMethod.totalPrice ? _this3.state.classData.billingMethod.totalPrice : undefined,
								unitPrice: _this3.state.classData.billingMethod.unitPrice ? _this3.state.classData.billingMethod.unitPrice : undefined
							});
	
							delete newFormData.billingMethod;
	
							if (mode == 'create') {
								(0, _addClass2.default)(schoolId, newFormData).then(function (res) {
									localStorage.setItem('showClassOneOnboarding', 'false');
	
									if (res.result == 'success') {
										_this3.props.fetchClass({ schoolId: schoolId, type: '1on1', state: 'current', amount_per_page: 25, current_page_number: 1 });
										if (_this3.props.studentInfo) {
											_reactRouter.browserHistory.push('/one_one');
										}
										_this3.props.proceed();
									}
								});
							} else if (mode == 'update') {
								(0, _editClass2.default)(_this3.props.id, newFormData).then(function (res) {
									if (res.result == 'success') {
										_this3.props.fetchClassLesson(_this3.props.id, {
											amount_per_page: pagination.itemsCountPerPage,
											current_page_number: pagination.activePage,
											after_today: pageState === 'current' ? 1 : 0
										});
										_this3.props.proceed();
									}
								});
							}
						},
						isDisabled: function isDisabled() {
							return _this3.state.disabledBtn;
						}
					}]
				},
				_react2.default.createElement(_ModalContent2.default, _extends({}, this.props, {
					classData: this.state.classData,
					onFormChange: function onFormChange(classData) {
						_this3.setState({ classData: classData });
					},
					getValidationRef: function getValidationRef(fn) {
						_this3.validate = fn;
					}
				}))
			);
		};
	
		return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactConfirm.confirmable)(ModalBody));
	module.exports = exports['default'];

/***/ },

/***/ "Tna2":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "sWQO":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("+sMC");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      formData: props.classData
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  ModalContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var classData = _ref.classData;
	
	    this.setState({ formData: classData });
	  };
	
	  ModalContent.prototype.onChange = function onChange(formData) {
	    var _this2 = this;
	
	    this.setState({
	      formData: _extends({}, this.state.formData, formData)
	    }, function () {
	      _this2.props.onFormChange(formData);
	    });
	  };
	
	  ModalContent.prototype.render = function render() {
	    var formData = this.state.formData;
	
	
	    var notifyOption = [];
	    for (var i = 1; i < 31; i++) {
	      if (formData.billingMethod.feeType == 0) {
	        if (i > 1) {
	          notifyOption.push({ label: __('{i} days in advance', _locale2.default, { i: i }), value: i });
	        } else {
	          notifyOption.push({ label: __('{i} day in advance', _locale2.default, { i: i }), value: i });
	        }
	      } else if (formData.billingMethod.feeType == 1) {
	        if (i > 1) {
	          notifyOption.push({ label: __('{i} lessons in advance', _locale2.default, { i: i }), value: i });
	        } else {
	          notifyOption.push({ label: __('{i} lesson in advance', _locale2.default, { i: i }), value: i });
	        }
	      } else if (formData.billingMethod.feeType == 2) {
	        if (i > 1) {
	          notifyOption.push({ label: __('{i} hours in advance', _locale2.default, { i: i }), value: i });
	        } else {
	          notifyOption.push({ label: __('{i} hour in advance', _locale2.default, { i: i }), value: i });
	        }
	      }
	    }
	
	    var schema = [{
	      name: 'cName',
	      label: __('Class Name', _locale2.default),
	      type: 'text',
	      required: true
	    }, {
	      name: 'student_id_list',
	      label: __('Student', _locale2.default),
	      type: 'selectStudent',
	      required: true,
	      options: {
	        selectMultiple: true
	      }
	      // disabled: this.props.mode == 'update' ? true : false
	    }, {
	      name: 'billingMethod',
	      label: __('Billing Types', _locale2.default),
	      type: 'classBillingMethod',
	      required: true,
	      mode: this.props.mode
	    }, {
	      name: 'costAlertRange',
	      label: __('Notify me overdue fee...', _locale2.default),
	      type: 'select',
	      required: false,
	      options: notifyOption
	    }, {
	      name: 'teacher_id_list',
	      label: __('Teacher', _locale2.default),
	      type: 'selectTeacher',
	      required: false,
	      options: {
	        selectMultiple: true
	      },
	      tip: __('Lesson Completion Rules', _locale2.default)
	    }, {
	      name: 'costRule',
	      placeholder: __('Attending counts as completion', _locale2.default),
	      type: 'checkbox',
	      required: false,
	      disabled: true
	    }, {
	      name: 'absentFlag',
	      placeholder: __('Absence (without reason) counts as completion', _locale2.default),
	      type: 'checkbox',
	      required: false
	    }, {
	      name: 'cancelFlag',
	      placeholder: __('Absence (with reason) counts as completion', _locale2.default),
	      type: 'checkbox',
	      required: false
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'create-classone-modal-content' },
	      _react2.default.createElement(_Form2.default, {
	        onChange: this.onChange,
	        schema: schema,
	        formData: formData,
	        formStyle: 'outline',
	        getValidationRef: this.props.getValidationRef
	      })
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "+sMC":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'CreateClassOneModal',
	  code: 'CN',
	  text: {
	    'Create Private Class': '新增私课',
	    'Edit Private Class': '编辑私课',
	    'Class Name': '私课名称',
	    'Student': '学员',
	    'Teacher': '老师',
	    'Billing Types': '学费标准',
	    'Notify me overdue fee...': '欠费提醒时间',
	    'Lesson Completion Rules': '课消规则',
	    'Attending counts as completion': '签到算课消',
	    'Absence (with reason) counts as completion': '请假算课消',
	    'Absence (without reason) counts as completion': '缺课算课消',
	    '{i} day in advance': '课时剩余 {i} 天前提醒',
	    '{i} lesson in advance': '课时剩余 {i} 节课前提醒',
	    '{i} hour in advance': '课时剩余 {i} 小时前提醒',
	    '{i} days in advance': '课时剩余 {i} 天前提醒',
	    '{i} lessons in advance': '课时剩余 {i} 节课前提醒',
	    '{i} hours in advance': '课时剩余 {i} 小时前提醒',
	    'Bill by date': '按日期计费',
	    'Bill by lessons': '按课次计费',
	    'Bill by hours': '按小时计费',
	    'Total Price': '总价',
	    'Unit Price': '单价',
	    'Display finished lessons consumption': '按已上课次显示消耗',
	    'Display finished hours consumption': '按已上小时数显示消耗',
	    'Total consumption when make payment': '缴费时计为全部消耗消耗',
	    'Tuition Consumption Display': '学费消耗显示'
	
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "TnP3":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getClassTeacherStudent;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _ClassDetail = __webpack_require__("715+");
	
	var _ClassDetail2 = _interopRequireDefault(_ClassDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getClassTeacherStudent(id) {
	  var originalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	
	  if (typeof id !== 'number') {
	    throw new Error('class ID (number) is missing. getClassTeacherStudent(classId)');
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put('/proxy', {
	      'uri': '/g_clss_tch_stdt/' + id + '/',
	      'method': 'GET',
	      'token': localStorage.getItem('token')
	    }).then(function (_ref) {
	      var data = _ref.data;
	
	      if (data) {
	        var clsRaw = data.classDetail;
	        clsRaw.classStudentList = data.classStudentList;
	        clsRaw.classTeacherList = data.classTeacherList;
	
	        originalData ? resolve(data) : resolve(new _ClassDetail2.default(clsRaw));
	      }
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "715+":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Mediator2 = __webpack_require__("ek+r");
	
	var _Mediator3 = _interopRequireDefault(_Mediator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CLASS_TYPE = ['multi', '1on1'];
	
	var ClassDetail = function (_Mediator) {
	  _inherits(ClassDetail, _Mediator);
	
	  function ClassDetail(rawData) {
	    var _this$__schema;
	
	    var _ret2;
	
	    _classCallCheck(this, ClassDetail);
	
	    var _this = _possibleConstructorReturn(this, _Mediator.call(this, rawData));
	
	    if (rawData instanceof _Mediator3.default) {
	      var _ret;
	
	      return _ret = _this, _possibleConstructorReturn(_this, _ret);
	    }
	
	    _this.setVersion('v1', ['absentFlag', 'cState', 'cancelFlag', 'classID', 'className', 'classStudentCount', 'classStudentList', 'classTeacherList', 'costRule', 'endDateTime', 'feeType', 'lessonCheckinedCount', 'lessonCount', 'lessonList', 'maxStudentNumber', 'startDateTime', 'total_price', 'unit_price'], {});
	
	    _this.setVersion('v2', ["id", "cName", "cType", "feeType", "totalPrice", "unitPrice", "startDate", "endDate", "currencyUnit", "totalQuantity", "maxStudentsNumber", "cAddress", "costRule", "costAlertRange", "absentFlag", "cancelFlag", "cState", "classCode", "cReateTime", "cRemark", "cSchool", "usedLessonTimes", "usedLessonHours", "totalHours"], {
	      relatedAPIs: ['g_clss_tch_stdt']
	    });
	
	    _this.setVersion('v3', ['id', 'cName', 'cType']);
	
	    _this.setVersion('v4', ['absentFlag', 'cancelFlag', 'classID', 'className', 'costRule', 'feeType', 'has_lesson', 'maxStudentsNumber', 'studentCount', 'teacherCount', 'teacherList', 'totalHours', 'totalPrice', 'totalQuantity', 'unitPrice', 'usedLessonHours', 'usedLessonTimes'], {});
	
	    _this.__schema = (_this$__schema = {
	      id: { alias: ['classID', 'id', 'cId'] },
	      address: { alias: ['cAddress'] },
	      name: { alias: ['className', 'cName'] },
	      state: { alias: ['cState'] },
	      type: { alias: ['classType', 'cType'] },
	      feeType: { alias: ['feeType'] },
	      studentCount: { alias: ['classStudentCount', 'studentCount'] },
	      studentList: { alias: ['classStudentList', 'studentList'] },
	      teacherCount: { alias: ['teacherCount'] },
	      teacherList: { alias: ['classTeacherList', 'teacherList'] },
	      absentFlag: { alias: ['absentFlag'] },
	      cancelFlag: { alias: ['cancelFlag'] },
	      costRule: { alias: ['costRule'] },
	      endDateTime: { alias: ['endDateTime'] },
	      startDateTime: { alias: ['startDateTime'] }
	
	    }, _this$__schema['endDateTime'] = { alias: ['endDateTime'] }, _this$__schema['startDateTime'] = { alias: ['startDateTime'] }, _this$__schema.endTime = { alias: ['endTime'] }, _this$__schema.startTime = { alias: ['startTime'] }, _this$__schema.totalHours = { alias: ['totalHours'] }, _this$__schema.totalQuantity = { alias: ['totalQuantity'] }, _this$__schema.totalPrice = { alias: ['totalPrice'] }, _this$__schema.usedLessonHours = { alias: ['usedLessonHours'] }, _this$__schema.usedLessonTimes = { alias: ['usedLessonTimes'] }, _this$__schema.hasLesson = { alias: ['hasLesson'] }, _this$__schema.lessonCheckinedCount = { alias: ['lessonCheckinCount'] }, _this$__schema.lessonCount = { alias: ['lessonCount'] }, _this$__schema.lessonList = { alias: ['lessonList'] }, _this$__schema.maxStudentNumber = { alias: ['maxStudentNumber', 'maxStudentsNumber'] }, _this$__schema['totalPrice'] = { alias: ['totalPrice', 'total_price'] }, _this$__schema.unitPrice = { alias: ['unitPrice', 'unit_price'] }, _this$__schema.createTime = { alias: ['cReateTime'] }, _this$__schema.remark = { alias: ['cRemark'] }, _this$__schema.schoolID = { alias: ['cSchool'] }, _this$__schema.classCode = { alias: ['classCode'] }, _this$__schema.costAlertRange = { alias: ['costAlertRange'] }, _this$__schema.currencyUnit = { alias: ['currencyUnit'] }, _this$__schema.eachLessonDuration = { alias: ['eachLessonDuration'] }, _this$__schema);
	
	    return _ret2 = _this.create(), _possibleConstructorReturn(_this, _ret2);
	  }
	
	  ClassDetail.prototype.getClassTypeStr = function getClassTypeStr() {
	    var type = this.__privateData.type;
	
	
	    if (typeof type !== 'undefined') {
	      return CLASS_TYPE[type];
	    } else {
	      return;
	    }
	  };
	
	  ClassDetail.prototype.getStudentIdList = function getStudentIdList() {
	    var _privateData = this.__privateData,
	        studentIdList = _privateData.studentIdList,
	        _privateData$studentL = _privateData.studentList,
	        studentList = _privateData$studentL === undefined ? [] : _privateData$studentL;
	
	
	    if (Array.isArray(studentIdList)) {
	      return studentIdList;
	    }
	
	    return studentList.map(function (student) {
	      return student.id;
	    });
	  };
	
	  ClassDetail.prototype.getTeacherIdList = function getTeacherIdList() {
	    var _privateData2 = this.__privateData,
	        teacherIdList = _privateData2.teacherIdList,
	        _privateData2$teacher = _privateData2.teacherList,
	        teacherList = _privateData2$teacher === undefined ? [] : _privateData2$teacher;
	
	
	    if (Array.isArray(teacherIdList)) {
	      return teacherIdList;
	    }
	
	    return teacherList.map(function (teacher) {
	      return teacher.id;
	    });
	  };
	
	  return ClassDetail;
	}(_Mediator3.default);
	
	exports.default = ClassDetail;
	module.exports = exports['default'];

/***/ },

/***/ "27cS":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (studentState) {
	
	  if (studentState == "archived") {
	    return getArchivedStudentFields.call(this);
	  }
	
	  return getDefaultFields.call(this);
	};
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StudentInfoTd = __webpack_require__("0vxt");
	
	var _StudentInfoTd2 = _interopRequireDefault(_StudentInfoTd);
	
	var _ClassInfoTd = __webpack_require__("n5V7");
	
	var _ClassInfoTd2 = _interopRequireDefault(_ClassInfoTd);
	
	var _ClassStatusTd = __webpack_require__("e/Ic");
	
	var _ClassStatusTd2 = _interopRequireDefault(_ClassStatusTd);
	
	var _locale = __webpack_require__("aMEQ");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _constants = __webpack_require__("AvVx");
	
	var _CreateClass = __webpack_require__("dFGx");
	
	var _CreateClass2 = _interopRequireDefault(_CreateClass);
	
	var _CreateClassOne = __webpack_require__("sbFW");
	
	var _CreateClassOne2 = _interopRequireDefault(_CreateClassOne);
	
	var _isEmpty = __webpack_require__("lHK6");
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _reactTooltip = __webpack_require__("Hh2+");
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDefaultFields() {
	  var _this = this;
	
	  var TabComponent = this;
	
	  // default settings
	  return [{
	    name: "sName",
	    title: __('Student', 'student', null, true),
	    getTdProps: function getTdProps(_ref) {
	      var tbodyData = _ref.tbodyData;
	
	      return {
	        className: "student-info",
	        style: {}
	      };
	    },
	    getTdContent: function getTdContent(_ref2) {
	      var student = _ref2.trData;
	
	      return _react2.default.createElement(_StudentInfoTd2.default, { studentInfo: student });
	    }
	  }, {
	    name: "balance",
	    title: __('Credit', _locale2.default),
	    getTdContent: function getTdContent(_ref3) {
	      var student = _ref3.trData,
	          trIndex = _ref3.trIndex;
	
	      if (trIndex === 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'balance' },
	          student.balance + ' ' + student.currency
	        );
	      } else {
	        return '';
	      }
	    }
	  }, {
	    name: "className",
	    title: __('Class', 'student', null, true),
	    getTdProps: function getTdProps(_ref4) {
	      var tbodyData = _ref4.tbodyData;
	
	      return {
	        className: "class-info",
	        style: {
	          width: "28%"
	        }
	      };
	    },
	    getTdContent: function getTdContent(opts) {
	      var trData = opts.trData,
	          tbodyData = opts.tbodyData,
	          classIndex = opts.trIndex;
	      var studentState = _this.props.studentState;
	
	      // student is the first item of tbodyData array
	
	      var student = tbodyData[0];
	
	      /**
	       *
	       * When there are 3 <tr> within this <tbody>
	       * Which means there already 3 classes displayed,
	       * We will collapse the rest of <tr> (classes)
	       * right below the last row we leave a button to
	       * expand these collapsed classes.
	       *
	       * Inside DefaultTab.js the method collapseRows() is then passed to the <Table />
	       * through a prop called trFilter. This method filters out the classes.
	       *
	       */
	      var numberOfClasses = tbodyData.length;
	
	      var showExpandedButton = classIndex + 1 == _constants.SHOW_CLASSES_UPTO_NUMBER_OF;
	
	      var shouldExpand = numberOfClasses > _constants.SHOW_CLASSES_UPTO_NUMBER_OF;
	
	      var expanded = _this.isClassInfosExpanded(student);
	
	      var TD = _react2.default.createElement(_ClassInfoTd2.default, {
	        userId: _this.props.user.result.user_id,
	        classInfo: trData.classInfo,
	        student: student,
	        exitClass: _this.exitClass,
	        enrollStudentToClass: function enrollStudentToClass() {
	          _this.enrollStudentToClass([student], function () {
	            _this.props.student.fetchStudent('after enrolled at a class @classInfoTD', studentState);
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        TD,
	        shouldExpand && showExpandedButton && !expanded && _react2.default.createElement(
	          'div',
	          { className: 'expand-folded-classes-button', onClick: function onClick() {
	              _this.expandClassInfos(student);
	            } },
	          _react2.default.createElement('i', { className: 'fa icon-ellipsis' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'button-text' },
	            __('show all ({classNumber})', 'student', { classNumber: numberOfClasses })
	          )
	        )
	      );
	
	      return TD;
	    }
	  }, {
	    name: "classStatus",
	    title: __('Used/Purchased', _locale2.default),
	    getTdContent: function getTdContent(_ref5) {
	      var data = _ref5.trData;
	
	      return _react2.default.createElement(_ClassStatusTd2.default, { classInfo: data.classInfo });
	    }
	  }, {
	    name: 'tuitionConsumption',
	    title: __('Used/Paid', _locale2.default),
	    getTdContent: function getTdContent(_ref6) {
	      var data = _ref6.trData;
	      var currency = _this.props.schoolDetail.detail.currency;
	      var studentState = _this.props.studentState;
	
	      var id = 'student-id-' + data.schoolStudentID;
	
	      if (data.classInfo && data.classInfo.tuition_consumption !== null) {
	        if (data.classInfo.total_discount_amount > 0) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: data.classInfo.tuition_consumption > data.classInfo.paidTotalFee ? 'notice-alert' : '' },
	              data.classInfo.tuition_consumption + ' / ' + data.classInfo.paidTotalFee + ' ' + currency
	            ),
	            _react2.default.createElement('i', { className: 'fa icon-tag', 'data-tip': true, 'data-for': id }),
	            _react2.default.createElement(_reactTooltip2.default, {
	              id: id,
	              effect: 'solid',
	              place: 'bottom',
	              type: 'info',
	              getContent: function getContent() {
	                return __('Discounted', _locale2.default) + ' ' + data.classInfo.total_discount_amount + ' ' + currency;
	              }
	            })
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { className: data.classInfo.tuition_consumption > data.classInfo.paidTotalFee ? 'notice-alert' : '' },
	            data.classInfo.tuition_consumption + ' / ' + data.classInfo.paidTotalFee + ' ' + currency
	          );
	        }
	      } else if ((0, _isEmpty2.default)(data.list)) {
	        return _react2.default.createElement('div', null);
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { style: { cursor: 'pointer' }, onClick: function onClick() {
	              if (data.classInfo.type == 0) {
	                (0, _CreateClass2.default)({ mode: 'update', id: data.classInfo.classID }).then(function () {
	                  _this.props.student.fetchStudent('after enrolled at a class @classInfoTD', studentState);
	                });
	              } else {
	                (0, _CreateClassOne2.default)({ mode: 'update', id: data.classInfo.classID }).then(function () {
	                  _this.props.student.fetchStudent('after enrolled at a class @classInfoTD', studentState);
	                });
	              }
	            } },
	          __('Setup', _locale2.default) + ' / ' + data.classInfo.paidTotalFee + ' ' + currency
	        );
	      }
	    }
	  }];
	}
	
	// Table fields specifically for 'archived students'
	
	
	// IMPORTANT NOTE:
	// This function is bind to a Tab component.
	// 'this' here refers to Tab Component
	
	// import PaymentTD from './StudentTable/PaymentTd';
	function getArchivedStudentFields() {
	  var TabComponent = this;
	
	  return [{
	    name: "sName",
	    title: __('Student', 'student', null, true),
	    getTdProps: function getTdProps(_ref7) {
	      var tbodyData = _ref7.tbodyData;
	
	      return {
	        className: "student-info"
	      };
	    },
	    getTdContent: function getTdContent(_ref8) {
	      var student = _ref8.trData;
	
	      return _react2.default.createElement(_StudentInfoTd2.default, { studentInfo: student });
	    }
	  }];
	}
	module.exports = exports['default'];

/***/ },

/***/ "0vxt":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _StudentName = __webpack_require__("hBDJ");
	
	var _StudentName2 = _interopRequireDefault(_StudentName);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _Photo = __webpack_require__("7PAg");
	
	var _Photo2 = _interopRequireDefault(_Photo);
	
	var _reactReduxHotline = __webpack_require__("IKa1");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <StudentInfoTD
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		student={studentObject}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - This goes into <td> of "student" column and display
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *   an avatar, student's name and age
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Table (but passed by student-table-field)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var MALE_IMG = __webpack_require__("X56S");
	var FEMALE_IMG = __webpack_require__("Irbd");
	var NEUTRAL_IMG = __webpack_require__("bReY");
	
	var StudentInfoTD = function (_React$Component) {
		_inherits(StudentInfoTD, _React$Component);
	
		function StudentInfoTD(props) {
			_classCallCheck(this, StudentInfoTD);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			_this.viewPhoto = _this.viewPhoto.bind(_this);
			return _this;
		}
	
		StudentInfoTD.prototype.viewPhoto = function viewPhoto() {
			var profile_photo_thumbnail_8x = this.props.studentInfo.profile_photo_thumbnail_8x;
	
	
			if (!profile_photo_thumbnail_8x) {
				return;
			}
	
			(0, _Photo2.default)({ photo: profile_photo_thumbnail_8x });
		};
	
		StudentInfoTD.prototype.checkStudentUpdate = function checkStudentUpdate(isUpdated) {
			if (isUpdated) {
				this.props.student.fetchStudent('after enrolled at a class @classInfoTD', this.props.student.studentState);
			}
		};
	
		StudentInfoTD.prototype.render = function render() {
			var _this2 = this;
	
			var studentInfo = this.props.studentInfo;
			var schoolStudentID = studentInfo.schoolStudentID,
			    sName = studentInfo.sName,
			    sAge = studentInfo.sAge;
	
	
			var hasPhoto = studentInfo.profile_photo_thumbnail_8x != '';
	
			var image = void 0;
			if (studentInfo.profile_photo_thumbnail_2x) {
				image = 'url(' + studentInfo.profile_photo_thumbnail_2x + ')';
			} else {
				if (studentInfo.sGender == 0) {
					image = 'url(' + MALE_IMG + ')';
				} else if (studentInfo.sGender == 1) {
					image = 'url(' + FEMALE_IMG + ')';
				} else if (studentInfo.sGender == 3) {
					image = 'url(' + NEUTRAL_IMG + ')';
				}
			}
	
			if (!sName) {
				return _react2.default.createElement('div', null);
			}
	
			return _react2.default.createElement(
				'div',
				{ className: 'student-info-container' },
				_react2.default.createElement('div', { className: (0, _classnames2.default)("portrait", { hasPhoto: hasPhoto }), style: {
						backgroundImage: image
					}, onClick: this.viewPhoto }),
				_react2.default.createElement(
					'div',
					{ className: 'text-container' },
					_react2.default.createElement(
						'div',
						{ className: 'name' },
						_react2.default.createElement(_StudentName2.default, { name: sName, id: schoolStudentID, checkStudentUpdate: function checkStudentUpdate(isUpdated) {
								return _this2.checkStudentUpdate(isUpdated);
							} }),
						typeof sAge !== 'undefined' && sAge !== null && _react2.default.createElement(
							'small',
							null,
							__("{sAge} yrs old", "student.table", { sAge: sAge }, true)
						)
					)
				)
			);
		};
	
		return StudentInfoTD;
	}(_react2.default.Component);
	
	// export default StudentInfoTD;
	
	
	exports.default = (0, _reactReduxHotline.hotline)(StudentInfoTD, 'student');
	module.exports = exports['default'];

/***/ },

/***/ "hBDJ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <StudentName
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _StudentInfo = __webpack_require__("R3ni");
	
	var _StudentInfo2 = _interopRequireDefault(_StudentInfo);
	
	var _Student = __webpack_require__("PT2B");
	
	var _Student2 = _interopRequireDefault(_Student);
	
	__webpack_require__("m8OE");
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StudentName = (_temp = _class = function (_React$Component) {
	  _inherits(StudentName, _React$Component);
	
	  function StudentName(props) {
	    _classCallCheck(this, StudentName);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onClick = _this.onClick.bind(_this);
	
	    return _this;
	  }
	
	  StudentName.prototype.componentWillMount = function componentWillMount() {};
	
	  StudentName.prototype.onClick = function onClick() {
	    var _props = this.props,
	        id = _props.id,
	        name = _props.name,
	        checkStudentUpdate = _props.checkStudentUpdate;
	
	
	    (0, _StudentInfo2.default)({ id: id, name: name }).then(function (res) {
	      checkStudentUpdate(res.isUpdated);
	    });
	  };
	
	  StudentName.prototype.render = function render() {
	    var name = this.props.name;
	
	
	    return _react2.default.createElement(
	      _R2.default,
	      { can: 'read_student_detail', by: 'disable' },
	      _react2.default.createElement(
	        'button',
	        { className: 'btn-link studentName', onClick: this.onClick },
	        name
	      )
	    );
	  };
	
	  return StudentName;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = StudentName;
	module.exports = exports['default'];

/***/ },

/***/ "R3ni":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	
	  if (opts.student && opts.student instanceof _Student2.default !== true) {
	    // we used {...opts.classDetail } because it has to be a new object
	    return modal(_extends({}, opts, {
	      studentData: new _Student2.default(opts.student)
	    }));
	  }
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _Student = __webpack_require__("PT2B");
	
	var _Student2 = _interopRequireDefault(_Student);
	
	var _DockProvider = __webpack_require__("nMEB");
	
	var _DockProvider2 = _interopRequireDefault(_DockProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_DockProvider2.default);
	
	// if only is given, the dock will load studentData from backend
	module.exports = exports['default'];

/***/ },

/***/ "nMEB":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DockBody = __webpack_require__("iS0G");
	
	var _DockBody2 = _interopRequireDefault(_DockBody);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DockProvider = function (_React$Component) {
	  _inherits(DockProvider, _React$Component);
	
	  function DockProvider(props) {
	    _classCallCheck(this, DockProvider);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  DockProvider.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(_DockBody2.default, this.props)
	    );
	  };
	
	  return DockProvider;
	}(_react2.default.Component);
	
	exports.default = DockProvider;
	module.exports = exports['default'];

/***/ },

/***/ "iS0G":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _Transition = __webpack_require__("X/qO");
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _lodash = __webpack_require__("M4fF");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _locale = __webpack_require__("8nDk");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _HorizontalInfoGrid = __webpack_require__("mlMS");
	
	var _HorizontalInfoGrid2 = _interopRequireDefault(_HorizontalInfoGrid);
	
	var _VerticalInfoGrid = __webpack_require__("VUlR");
	
	var _VerticalInfoGrid2 = _interopRequireDefault(_VerticalInfoGrid);
	
	var _Student = __webpack_require__("PT2B");
	
	var _Student2 = _interopRequireDefault(_Student);
	
	var _StudentHeader = __webpack_require__("be9/");
	
	var _StudentHeader2 = _interopRequireDefault(_StudentHeader);
	
	var _getStudentCustomFields = __webpack_require__("61c/");
	
	var _getStudentCustomFields2 = _interopRequireDefault(_getStudentCustomFields);
	
	var _getSchoolSettings = __webpack_require__("yY2/");
	
	var _getSchoolSettings2 = _interopRequireDefault(_getSchoolSettings);
	
	var _NewPayment = __webpack_require__("BztD");
	
	var _NewPayment2 = _interopRequireDefault(_NewPayment);
	
	var _getStudentInfo = __webpack_require__("EUd3");
	
	var _getStudentInfo2 = _interopRequireDefault(_getStudentInfo);
	
	var _getStudentCurrentClass = __webpack_require__("KFjI");
	
	var _getStudentCurrentClass2 = _interopRequireDefault(_getStudentCurrentClass);
	
	var _CourseRecord = __webpack_require__("5LdL");
	
	var _CourseRecord2 = _interopRequireDefault(_CourseRecord);
	
	var _tuitionRecordTable = __webpack_require__("J7sC");
	
	var _tuitionRecordTable2 = _interopRequireDefault(_tuitionRecordTable);
	
	var _Attendance = __webpack_require__("gjj1");
	
	var _Attendance2 = _interopRequireDefault(_Attendance);
	
	var _reactReduxHotline = __webpack_require__("IKa1");
	
	var _Timeline = __webpack_require__("GXBW");
	
	var _Timeline2 = _interopRequireDefault(_Timeline);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _CreateStudent = __webpack_require__("yvp6");
	
	var _CreateStudent2 = _interopRequireDefault(_CreateStudent);
	
	__webpack_require__("ygM2");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <DockBody />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var DEFAULT_TAB_INDEX = 0;
	
	var GENDERS = [__('Male', _locale2.default), __('Female', _locale2.default), __('Others', _locale2.default), __('N/A', _locale2.default)];
	
	var DockBody = function (_React$Component) {
	  _inherits(DockBody, _React$Component);
	
	  function DockBody(props) {
	    _classCallCheck(this, DockBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onClickPayment = _this.onClickPayment.bind(_this);
	    _this.onClickEdit = _this.onClickEdit.bind(_this);
	    _this.fetchStudentInfo = _this.fetchStudentInfo.bind(_this);
	    _this.getCustomFields = _this.getCustomFields.bind(_this);
	
	    var version = void 0;
	    if (props.studentData) {
	      version = props.studentData.version();
	    }
	
	    _this.state = {
	      version: version,
	      student: props.studentData,
	      fields: [],
	      contactFields: [],
	      fetching: true,
	      isStudentUpdated: false // to check if the student info or payment is changed in the dock
	    };
	    return _this;
	  }
	
	  DockBody.prototype.getCustomFields = function getCustomFields(done) {
	    var _this2 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    (0, _getSchoolSettings2.default)(schoolId).then(function (_ref) {
	      var student_fields_setting = _ref.student_fields_setting,
	          contact_custom_fields = _ref.contact_custom_fields;
	
	
	      var fields = [].concat(student_fields_setting.fields || []);
	
	      var contactFields = [].concat(contact_custom_fields.fields || []);
	
	      _this2.setState({
	        fields: fields,
	        contactFields: contactFields
	      }, function () {
	        done();
	      });
	    }).catch(function (err) {
	      console.error(err);
	      done();
	    });
	  };
	
	  DockBody.prototype.componentWillMount = function componentWillMount() {
	    var _this3 = this;
	
	    var version = this.state.version;
	    var id = this.props.id;
	
	    this.getCustomFields(function () {
	      if (version === 'v5') {
	        _this3.setState({
	          student: _this3.props.studentData
	        });
	      } else {
	        if (!id) {
	          throw new Error('The given student version is not v5. So need to load up studentInfo with an id but the id is missing from opts.');
	        }
	
	        _this3.fetchStudentInfo();
	      }
	    });
	  };
	
	  DockBody.prototype.fetchStudentInfo = function fetchStudentInfo() {
	    var _this4 = this;
	
	    var id = this.props.id;
	
	
	    this.setState({
	      fetching: true
	    });
	
	    (0, _getStudentInfo2.default)(id).then(function (student) {
	      (0, _getStudentCurrentClass2.default)(id).then(function (res) {
	        var classList = res.data.classList;
	        var newStudent = new _Student2.default(_extends({}, student, { classList: classList }));
	
	        _this4.setState({
	          fetching: false,
	          student: newStudent
	        });
	      });
	    }).catch(function (e) {});
	  };
	
	  DockBody.prototype.onClickEdit = function onClickEdit() {
	    var _this5 = this;
	
	    var student = this.state.student;
	
	    (0, _CreateStudent2.default)({ mode: 'update', studentData: student }).then(function (_ref2) {
	      var result = _ref2.result,
	          student = _ref2.student;
	
	
	      if (result === 'success') {
	        _this5.setState({ isStudentUpdated: true });
	        _this5.fetchStudentInfo(); // we're refetching it, because we don't have updated path for photos
	      }
	    }).catch(function () {});
	  };
	
	  DockBody.prototype.onClickPayment = function onClickPayment(user_id) {
	    var _this6 = this;
	
	    var student = this.state.student;
	    var studentState = this.props.student.studentState;
	
	
	    (0, _NewPayment2.default)({ student: student, user_id: user_id }).then(function (_ref3) {
	      var success = _ref3.success;
	
	      if (success == true) {
	        _this6.setState({ isStudentUpdated: true });
	        _this6.fetchStudentInfo();
	      }
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  DockBody.prototype.render = function render() {
	    var _this7 = this;
	
	    var _props = this.props,
	        isVisible = _props.isVisible,
	        show = _props.show,
	        proceed = _props.proceed,
	        mode = _props.mode,
	        id = _props.id,
	        name = _props.name;
	    var _state = this.state,
	        fetching = _state.fetching,
	        student = _state.student,
	        fields = _state.fields,
	        contactFields = _state.contactFields;
	
	
	    var numOfCustomData = [];
	    var horizontalData = [];
	    var basicInfo = [];
	    var otherInfo = [];
	    var otherContactInfo = [];
	
	    if (student) {
	      numOfCustomData = Object.keys(student.customData || {}).length;
	
	      horizontalData = [{ label: __('Age', _locale2.default), value: student.age ? __('{age} yrs old', _locale2.default, { age: student.age }) : '-' }, { label: __('Gender', _locale2.default), value: __(GENDERS[student.gender], _locale2.default) }, { label: __('DOB', _locale2.default), value: student.dob ? student.dob : '-' }, { label: __('Phone', _locale2.default), value: student.phone ? student.phone : '-' }, { label: __('Student ID', _locale2.default), value: student.code }, { label: __('Email', _locale2.default), value: student.email ? student.email : '-' }, { label: __('Available Credit', _locale2.default), value: student.balance + ' ' + student.currency }];
	
	      basicInfo = [{ label: __('Name', _locale2.default), value: student.name }, { label: __('Gender', _locale2.default), value: __(GENDERS[student.gender], _locale2.default) }, { label: __('DOB', _locale2.default), value: student.dob }, { label: __('Phone', _locale2.default), value: student.phone }, { label: __('Email', _locale2.default), value: student.email }, { label: __('Nickname', _locale2.default), value: student.nickName }, { label: __('Address', _locale2.default), value: student.getAddress() }, { label: __('Created On', _locale2.default), value: student.createdOn }, { label: __('Remark', _locale2.default), value: student.remark }, { label: __('Primary Guardian Name', _locale2.default), value: student.primaryGuardianName }, { label: __('Primary Guardian Email', _locale2.default), value: student.primaryGuardianEmail }, { label: __('Primary Guardian Phone', _locale2.default), value: student.primaryGuardianPhone }, { label: __('Relationship', _locale2.default), value: student.primaryGuardianRelationship }, { label: __('Secondary Guardian Name', _locale2.default), value: student.secondaryGuardianName }, { label: __('Secondary Guardian Email', _locale2.default), value: student.secondaryGuardianEmail }, { label: __('Secondary Guardian Phone', _locale2.default), value: student.secondaryGuardianPhone }, { label: __('Relationship', _locale2.default), value: student.secondaryGuardianRelationship }];
	
	      fields.map(function (field) {
	        var label = field.label,
	            id = field.id,
	            type = field.type;
	
	
	        if (student.customData) {
	          var value = student.customData[id];
	
	          if (type === 'checkbox') {
	            try {
	              var arrayValue = JSON.parse(value);
	              value = arrayValue.toString();
	            } catch (e) {}
	          }
	
	          if (label) {
	            otherInfo.push({ label: label, value: value });
	          }
	        }
	      });
	
	      contactFields.map(function (field) {
	        var label = field.label,
	            id = field.id,
	            type = field.type;
	
	
	        if (student.customData) {
	          var value = student.customData[id];
	
	          if (type === 'checkbox') {
	            try {
	              var arrayValue = JSON.parse(value);
	              value = arrayValue.toString();
	            } catch (e) {}
	          }
	
	          if (label && value) {
	            otherContactInfo.push({ label: label, value: value });
	          }
	        }
	      });
	    }
	
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(
	        _UI.Dock,
	        {
	          dockStyle: { minWidth: 760, maxWidth: 880 },
	          className: 'studentInfoDock',
	          position: 'right',
	          isVisible: show,
	          size: 0.62,
	          overlayOpacity: 0.2,
	          onCloseDockClick: function onCloseDockClick() {
	            proceed({ isUpdated: _this7.state.isStudentUpdated });
	          },
	          useClosingTag: true,
	          dockTitle: _react2.default.createElement(_StudentHeader2.default, { student: student, onClickEdit: this.onClickEdit, onClickPayment: this.onClickPayment }),
	          useDefaultCloseButton: false
	        },
	        fetching && _react2.default.createElement(_Loading2.default, null),
	        !fetching && _react2.default.createElement(
	          _Transition2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'basicInfo' },
	            _react2.default.createElement(_HorizontalInfoGrid2.default, { data: horizontalData })
	          ),
	          _react2.default.createElement(
	            _UI.Tabs,
	            { defaultIndex: DEFAULT_TAB_INDEX, onSelect: this.onSelectTab },
	            _react2.default.createElement(
	              _UI.TabList,
	              null,
	              _react2.default.createElement(
	                _UI.Tab,
	                null,
	                __("Info", _locale2.default)
	              ),
	              _react2.default.createElement(
	                _UI.Tab,
	                { title: 'You do not have permission.', disabled: !(0, _R.userCan)('read_student_class') },
	                __("Course", _locale2.default)
	              ),
	              _react2.default.createElement(
	                _UI.Tab,
	                { title: 'You do not have permission.', disabled: !(0, _R.userCan)('read_student_trade_record') },
	                __("Tuition", _locale2.default)
	              ),
	              _react2.default.createElement(
	                _UI.Tab,
	                { title: 'You do not have permission.', disabled: !(0, _R.userCan)('read_student_check_in_record') },
	                __('Attendance', _locale2.default)
	              ),
	              _react2.default.createElement(
	                _UI.Tab,
	                { title: 'You do not have permission.', disabled: !(0, _R.userCan)('read_student_task') },
	                __('Planning', _locale2.default)
	              )
	            ),
	            _react2.default.createElement(
	              _UI.TabPanel,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'studentDetail' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  __('Basic Info', _locale2.default)
	                ),
	                _react2.default.createElement(_VerticalInfoGrid2.default, { data: basicInfo }),
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  __('Other Info', _locale2.default)
	                ),
	                _react2.default.createElement(_VerticalInfoGrid2.default, { data: otherInfo }),
	                Object.keys(otherContactInfo).length > 0 && _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    __('Previous Contact Info', _locale2.default)
	                  ),
	                  _react2.default.createElement(_VerticalInfoGrid2.default, { data: otherContactInfo })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _UI.TabPanel,
	              null,
	              _react2.default.createElement(_CourseRecord2.default, {
	                studentId: id,
	                studentInfo: student,
	                schoolDetail: this.props.schoolDetail.detail,
	                checkStudentUpdate: function checkStudentUpdate(isStudentUpdated) {
	                  if (isStudentUpdated) {
	                    _this7.fetchStudentInfo();
	                  }
	                  _this7.setState({ isStudentUpdated: isStudentUpdated });
	                } })
	            ),
	            _react2.default.createElement(
	              _UI.TabPanel,
	              null,
	              _react2.default.createElement(_tuitionRecordTable2.default, { studentId: id })
	            ),
	            _react2.default.createElement(
	              _UI.TabPanel,
	              null,
	              _react2.default.createElement(_Attendance2.default, { state: 'student', studentId: id, studentName: name })
	            ),
	            _react2.default.createElement(
	              _UI.TabPanel,
	              null,
	              _react2.default.createElement(_Timeline2.default, { studentInfo: student, studentId: id })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return DockBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactReduxHotline.hotline)((0, _reactConfirm.confirmable)(DockBody), 'student', 'schoolDetail');
	module.exports = exports['default'];

/***/ },

/***/ "8nDk":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'StudentDockInfo',
	  code: 'CN',
	  text: {
	    'Age': '年龄',
	    'Gender': '性别',
	    'DOB': '生日',
	    'Phone': '联系电话',
	    'Email': '联系邮箱',
	    'Address': '现居地址',
	    'Created On': '注册时间',
	    'Nickname': '学员昵称',
	    'Name': '姓名',
	    'Remark': '备注',
	    'Primary Guardian Name': '家长姓名1',
	    'Relationship': '亲属关系',
	    'Primary Guardian Phone': '家长电话',
	    'Primary Guardian Email': '家长邮箱',
	    'Secondary Guardian Name': '家长姓名2',
	    'Secondary Guardian Phone': '家长电话',
	    'Secondary Guardian Email': '家长邮箱',
	
	    'Available Credit': '校内钱包余额',
	
	    'Info': '学生档案',
	    'Course': '课程记录',
	    'Tuition': '学费记录',
	    'Attendance': '签到记录',
	
	    'Male': '男生',
	    'Female': '女生',
	    'Other': '其他',
	    'N/A': '未提供',
	    '{age} yrs old': '{age} 岁',
	
	    'Basic Info': '基本信息',
	    'Other Info': '其他信息',
	    'Edit': '编辑',
	
	    'Payment': '收款',
	    'Wallet': '钱包',
	
	    'Current Class': '当期班级',
	    'Past Class': '结业班级',
	    'Class': '班级',
	    'Attended': '出勤',
	    'Unattended': '缺勤',
	    'Class Status': '已消耗/已购买',
	    'Export record': '导出考勤记录',
	    'Exit Class': '退出班级',
	    'lessons': '节课',
	    'Hour': '小时',
	
	    'MMM DD, YYYY': 'YYYY年MM月DD日',
	    'ddd, MMM DD YYYY': 'YYYY年MM月DD日ddd',
	    'MMMM YYYY': 'YYYY年MM月',
	
	    'Cash': '现金',
	    'Credit Card': '信用卡',
	    'Cheque': '支票',
	    'Transfer': '转账',
	    'School Credit': '学校授与的Credit',
	    'ClassTopBase Credit': '存在ClassTopBase的deposit',
	    'WeChat Barcode': '微信条码',
	    'Alipay Barcode': '支付宝扫码枪',
	    'WeChat Web Pay': '微信网页支付',
	    'Alipay Web Pay': '支付宝网页支付',
	    'WeChat Transfer': '微信转账',
	    'Alipay Transfer': '支付宝转账',
	    'Poster Online Payment': '海报在线支付',
	    'Previous Contact Info': '联系人转换前信息',
	
	    'Charged': '收费',
	    'Refunded': '退费',
	    'Receipt': '发送账单',
	    'Top Up': '钱包充值',
	
	    'Class Filter': '班级筛选',
	    'Month Filter': '月份筛选',
	    'Search Receipt': '收据查询',
	
	    'Jan': '01',
	    'Feb': '02',
	    'Mar': '03',
	    'Apr': '04',
	    'May': '05',
	    'Jun': '06',
	    'Jul': '07',
	    'Aug': '08',
	    'Sep': '09',
	    'Oct': '10',
	    'Nov': '11',
	    'Dec': '12',
	
	    'Proceed to exit class?': '确认退出班级？',
	
	    'Planning': '时间规划',
	    'Student ID': '学号',
	    'All Record': '所有纪录',
	
	    'Used/Paid': '已消耗/已缴学费',
	    'Setup': '未设置',
	    'Discounted': '折扣'
	
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "mlMS":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <HorizontalInfoGrid
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("XB2u");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HorizontalInfoGrid = (_temp = _class = function (_React$Component) {
	  _inherits(HorizontalInfoGrid, _React$Component);
	
	  function HorizontalInfoGrid(props) {
	    _classCallCheck(this, HorizontalInfoGrid);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  HorizontalInfoGrid.prototype.componentWillMount = function componentWillMount() {};
	
	  HorizontalInfoGrid.prototype.render = function render() {
	    var data = this.props.data;
	
	
	    var ths = [];
	    var tds = [];
	
	    data.map(function (_ref) {
	      var label = _ref.label,
	          value = _ref.value;
	
	      ths.push(label);
	      tds.push(value);
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'horizontalInfoGrid' },
	      _react2.default.createElement(
	        'table',
	        null,
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            ths.map(function (th, key) {
	              return _react2.default.createElement(
	                'th',
	                { key: key },
	                th
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            tds.map(function (th, key) {
	              return _react2.default.createElement(
	                'td',
	                { key: key },
	                th
	              );
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return HorizontalInfoGrid;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = HorizontalInfoGrid;
	module.exports = exports['default'];

/***/ },

/***/ "XB2u":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"horizontalInfoGrid":"horizontalInfoGrid"};

/***/ },

/***/ "VUlR":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <VerticalInfoGrid
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("ab8Z");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VerticalInfoGrid = (_temp = _class = function (_React$Component) {
	  _inherits(VerticalInfoGrid, _React$Component);
	
	  function VerticalInfoGrid(props) {
	    _classCallCheck(this, VerticalInfoGrid);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  VerticalInfoGrid.prototype.componentWillMount = function componentWillMount() {};
	
	  VerticalInfoGrid.prototype.render = function render() {
	    var data = this.props.data;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'verticalInfoGrid' },
	      _react2.default.createElement(
	        'table',
	        null,
	        _react2.default.createElement(
	          'tbody',
	          null,
	          data.map(function (_ref, key) {
	            var label = _ref.label,
	                value = _ref.value;
	
	            return _react2.default.createElement(
	              'tr',
	              { key: key },
	              _react2.default.createElement(
	                'th',
	                null,
	                label
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                value
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return VerticalInfoGrid;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = VerticalInfoGrid;
	module.exports = exports['default'];

/***/ },

/***/ "ab8Z":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"verticalInfoGrid":"verticalInfoGrid","locale-CN":"locale-CN"};

/***/ },

/***/ "be9/":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <StudentHeader
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _locale = __webpack_require__("8nDk");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _StudentModalHeader = __webpack_require__("CwGh");
	
	var _StudentModalHeader2 = _interopRequireDefault(_StudentModalHeader);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _wallet = __webpack_require__("7EYa");
	
	var _wallet2 = _interopRequireDefault(_wallet);
	
	var _pencil = __webpack_require__("QIHI");
	
	var _pencil2 = _interopRequireDefault(_pencil);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	var StudentHeader = (_temp = _class = function (_React$Component) {
	  _inherits(StudentHeader, _React$Component);
	
	  function StudentHeader(props) {
	    _classCallCheck(this, StudentHeader);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  StudentHeader.prototype.componentWillMount = function componentWillMount() {};
	
	  StudentHeader.prototype.render = function render() {
	    var _props = this.props,
	        _props$student = _props.student,
	        student = _props$student === undefined ? {} : _props$student,
	        onClickPayment = _props.onClickPayment,
	        onClickEdit = _props.onClickEdit,
	        user = _props.user;
	
	    // console.log(student.state === 2)
	
	    var studentLoaded = typeof student.id !== 'undefined';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'studentInfoDockHeader' },
	      _react2.default.createElement(_StudentModalHeader2.default, { name: student.name, gender: student.gender, profilePhoto: student.profilePhotoThumbnail8x, profileThumbnail: student.profilePhotoThumbnail2x }),
	      _react2.default.createElement(
	        'div',
	        { className: 'studentInfoHeaderBtn' },
	        studentLoaded && _react2.default.createElement(
	          _R2.default,
	          { can: 'edit_student', by: 'disable' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn', disabled: student.state === 2, onClick: onClickEdit },
	            __('Edit', _locale2.default)
	          )
	        ),
	        studentLoaded && _react2.default.createElement(
	          _R2.default,
	          { can: 'student_charge', by: 'disable' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn', disabled: student.state === 2, onClick: function onClick() {
	                onClickPayment(user.result.user_id);
	              } },
	            __('Payment', _locale2.default)
	          )
	        )
	      )
	    );
	  };
	
	  return StudentHeader;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(StudentHeader);
	module.exports = exports['default'];

/***/ },

/***/ "7EYa":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "wallet.0bb6512b.png";

/***/ },

/***/ "QIHI":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "pencil.97cc40c0.png";

/***/ },

/***/ "yY2/":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getSchoolSettings;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	* GET
	* School Settings
	**/
	function getSchoolSettings(schoolId) {
	
		if (!schoolId) {
			throw new Error('missing school id');
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': "/school_settings/" + schoolId + "/",
				'method': 'GET',
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res.data);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports["default"];

/***/ },

/***/ "KFjI":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getStudentCurrentClass;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStudentCurrentClass(studentId) {
	
	  if (!studentId) {
	    throw 'missing student ID';
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/g_stdtcrtcls/' + studentId + '/',
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "5LdL":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("8nDk");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _currentClassTable = __webpack_require__("mCFA");
	
	var _currentClassTable2 = _interopRequireDefault(_currentClassTable);
	
	var _pastClassTable = __webpack_require__("/6PK");
	
	var _pastClassTable2 = _interopRequireDefault(_pastClassTable);
	
	var _getStudentClass = __webpack_require__("dWt5");
	
	var _getStudentClass2 = _interopRequireDefault(_getStudentClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CourseRecord = function (_Component) {
	  _inherits(CourseRecord, _Component);
	
	  function CourseRecord(props) {
	    _classCallCheck(this, CourseRecord);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      showCurrentTable: true,
	      showPastTable: false,
	      currentClassList: [],
	      pastClassList: []
	    };
	    _this.getClassList = _this.getClassList.bind(_this);
	    return _this;
	  }
	
	  CourseRecord.prototype.componentWillMount = function componentWillMount() {
	    var studentId = this.props.studentId;
	
	
	    this.getClassList(studentId);
	  };
	
	  CourseRecord.prototype.getClassList = function getClassList() {
	    var _this2 = this;
	
	    var studentId = this.props.studentId;
	
	
	    (0, _getStudentClass2.default)(studentId, 'current_class').then(function (res) {
	      _this2.setState({ currentClassList: res.classList });
	    });
	
	    (0, _getStudentClass2.default)(studentId, 'past_class').then(function (res) {
	      _this2.setState({ pastClassList: res.classList });
	    });
	  };
	
	  CourseRecord.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        studentId = _props.studentId,
	        studentInfo = _props.studentInfo,
	        checkStudentUpdate = _props.checkStudentUpdate;
	    var _state = this.state,
	        showCurrentTable = _state.showCurrentTable,
	        showPastTable = _state.showPastTable,
	        currentClassList = _state.currentClassList,
	        pastClassList = _state.pastClassList;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'studentCourseRecord' },
	      _react2.default.createElement(
	        'div',
	        { className: 'currrentClass' },
	        _react2.default.createElement(
	          'div',
	          { className: 'currentClassHeader' },
	          showCurrentTable && _react2.default.createElement('i', { className: 'fa icon-angle-down', onClick: function onClick() {
	              _this3.setState({ showCurrentTable: false });
	            } }),
	          showCurrentTable === false && _react2.default.createElement('i', { className: 'fa icon-angle-right', onClick: function onClick() {
	              _this3.setState({ showCurrentTable: true });
	            } }),
	          _react2.default.createElement(
	            'span',
	            null,
	            __('Current Class', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'badge' },
	            currentClassList.length
	          )
	        ),
	        _react2.default.createElement(_currentClassTable2.default, { schoolDetail: this.props.schoolDetail, showTable: showCurrentTable, studentId: studentId, classList: currentClassList, student: studentInfo, getClassList: this.getClassList, checkStudentUpdate: checkStudentUpdate })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'pastClass' },
	        _react2.default.createElement(
	          'div',
	          { className: 'pastClassHeader' },
	          showPastTable && _react2.default.createElement('i', { className: 'fa icon-angle-down', onClick: function onClick() {
	              _this3.setState({ showPastTable: false });
	            } }),
	          showPastTable === false && _react2.default.createElement('i', { className: 'fa icon-angle-right', onClick: function onClick() {
	              _this3.setState({ showPastTable: true });
	            } }),
	          _react2.default.createElement(
	            'span',
	            null,
	            __('Past Class', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'badge' },
	            pastClassList.length
	          )
	        ),
	        _react2.default.createElement(_pastClassTable2.default, { schoolDetail: this.props.schoolDetail, showTable: showPastTable, studentId: studentId, classList: pastClassList })
	      )
	    );
	  };
	
	  return CourseRecord;
	}(_react.Component);
	
	exports.default = CourseRecord;
	module.exports = exports['default'];

/***/ },

/***/ "mCFA":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("8nDk");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _updateClassStudentState = __webpack_require__("97kv");
	
	var _updateClassStudentState2 = _interopRequireDefault(_updateClassStudentState);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _NewPayment = __webpack_require__("BztD");
	
	var _NewPayment2 = _interopRequireDefault(_NewPayment);
	
	var _CreateClass = __webpack_require__("dFGx");
	
	var _CreateClass2 = _interopRequireDefault(_CreateClass);
	
	var _CreateClassOne = __webpack_require__("sbFW");
	
	var _CreateClassOne2 = _interopRequireDefault(_CreateClassOne);
	
	var _reactTooltip = __webpack_require__("Hh2+");
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	var currentClassTable = function (_Component) {
	  _inherits(currentClassTable, _Component);
	
	  function currentClassTable(props) {
	    _classCallCheck(this, currentClassTable);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      classList: [],
	      fetching: true
	    };
	    return _this;
	  }
	
	  currentClassTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var classList = _ref.classList;
	
	    if (classList) {
	      this.setState({ classList: classList, fetching: false });
	    }
	  };
	
	  currentClassTable.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        showTable = _props.showTable,
	        student = _props.student,
	        getClassList = _props.getClassList,
	        checkStudentUpdate = _props.checkStudentUpdate;
	    var _state = this.state,
	        classList = _state.classList,
	        fetching = _state.fetching;
	
	
	    var fields = [{
	      name: 'className',
	      title: __('Class', _locale2.default),
	      getTdProps: function getTdProps(_ref2) {
	        var tbodyData = _ref2.tbodyData;
	
	        return {
	          style: {
	            width: "35%"
	          }
	        };
	      }
	    }, {
	      name: 'total_counted_amount',
	      title: __('Attended', _locale2.default),
	      getTdProps: function getTdProps(_ref3) {
	        var tbodyData = _ref3.tbodyData;
	
	        return {
	          style: {
	            width: "10%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref4) {
	        var classInfo = _ref4.trData;
	
	        return classInfo.check_in_statistics.total_counted_amount;
	      }
	    }, {
	      name: 'total_absent_amount',
	      title: __('Unattended', _locale2.default),
	      getTdProps: function getTdProps(_ref5) {
	        var tbodyData = _ref5.tbodyData;
	
	        return {
	          style: {
	            width: "10%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref6) {
	        var classInfo = _ref6.trData;
	
	        return classInfo.check_in_statistics.total_absent_amount;
	      }
	    }, {
	      name: 'class status',
	      title: __('Class Status', _locale2.default),
	      getTdProps: function getTdProps(_ref7) {
	        var tbodyData = _ref7.tbodyData;
	
	        return {
	          style: {
	            width: "20%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref8) {
	        var classInfo = _ref8.trData;
	
	        if (classInfo.feeType == 0) {
	          return classInfo.consumed_and_purchased.paidEndDate ? (0, _moment2.default)(classInfo.consumed_and_purchased.paidEndDate).format(__('MMM DD, YYYY', _locale2.default)) : '';
	        } else if (classInfo.feeType == 1) {
	          return classInfo.consumed_and_purchased.usedTotalQuantity + '/' + classInfo.consumed_and_purchased.paidTotalQuantity + ' ' + __('', _locale2.default);
	        } else if (classInfo.feeType == 2) {
	          return classInfo.consumed_and_purchased.usedTotalQuantity + '/' + classInfo.consumed_and_purchased.paidTotalQuantity + ' ' + __('Hour', _locale2.default);
	        }
	      }
	    }, {
	      name: 'tuition_consumption',
	      title: __('Used/Paid', _locale2.default),
	      getTdProps: function getTdProps(_ref9) {
	        var tbodyData = _ref9.tbodyData;
	
	        return {
	          style: {
	            width: "20%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref10) {
	        var classInfo = _ref10.trData;
	
	        var currency = _this2.props.schoolDetail.currency;
	        var tuition_consumption = classInfo.consumed_and_purchased.tuition_consumption;
	        var paidTotalFee = classInfo.consumed_and_purchased.paidTotalFee;
	        var discountAmount = classInfo.consumed_and_purchased.total_discount_amount;
	
	        if (classInfo && tuition_consumption !== null) {
	          if (discountAmount > 0) {
	            return _react2.default.createElement(
	              'div',
	              null,
	              tuition_consumption + ' / ' + paidTotalFee + ' ' + currency,
	              _react2.default.createElement('i', { className: 'fa icon-tag', 'data-tip': true, 'data-for': toString(classInfo.classID) }),
	              _react2.default.createElement(_reactTooltip2.default, {
	                id: toString(classInfo.classID),
	                effect: 'solid',
	                place: 'bottom',
	                type: 'info',
	                getContent: function getContent() {
	                  return __('Discounted', _locale2.default) + ' ' + discountAmount + ' ' + currency;
	                }
	              })
	            );
	          } else {
	            return _react2.default.createElement(
	              'div',
	              null,
	              tuition_consumption + ' / ' + paidTotalFee + ' ' + currency
	            );
	          }
	        } else if (_.isEmpty(classInfo)) {
	          return _react2.default.createElement('div', null);
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { style: { cursor: 'pointer' }, onClick: function onClick() {
	                if (classInfo.class_type == 0) {
	                  (0, _CreateClass2.default)({ mode: 'update', id: classInfo.classID }).then(function () {
	                    getClassList();
	                  });
	                } else {
	                  (0, _CreateClassOne2.default)({ mode: 'update', id: data.classInfo.classID }).then(function () {
	                    getClassList();
	                  });
	                }
	              } },
	            __('Setup', _locale2.default)
	          );
	        }
	      }
	    }];
	
	    var dropdown = [{
	      title: __('Payment', _locale2.default),
	      onClick: function onClick(_ref11) {
	        var classInfo = _ref11.trData;
	
	        var user_id = _this2.props.user.result.user_id;
	        (0, _NewPayment2.default)({ student: student, user_id: user_id }).then(function () {
	          checkStudentUpdate(true);
	        });
	      },
	      isDisabled: function isDisabled(opts) {
	        return !(0, _R.userCan)('student_charge');
	      }
	    }, {
	      title: __('Exit Class', _locale2.default),
	      onClick: function onClick(_ref12) {
	        var classInfo = _ref12.trData;
	        var studentId = _this2.props.studentId;
	
	
	        if (classInfo.consumed_and_purchased.paidTotalFee > 0) {
	          (0, _confirm.confirm)(__('This student has paid tuition, do you wish to refund?', 'studentTable')).then(function () {
	            (0, _NewPayment2.default)({
	              student: student,
	              classInfo: classInfo,
	              user_id: _this2.props.user.result.user_id,
	              paymentType: _NewPayment.REFUND,
	              confirmTitle: __('Refund & Exit Class', 'classdetail'),
	              confirmText: __('Proceed to refund and remove the student, {student_name}, from class?', 'classdetail', { student_name: student.sName })
	            }).then(function () {
	              (0, _confirm.confirm)(__('Proceed to exit class?', _locale2.default)).then(function () {
	                _this2.setState({ fetching: true });
	                (0, _updateClassStudentState2.default)(classInfo.classID, Number(studentId), 'not_enrolled').then(function (res) {
	                  _this2.setState({ fetching: false });
	                  checkStudentUpdate(true);
	                  getClassList();
	                });
	              });
	            }).catch(function () {});
	          }).catch(function () {
	            (0, _confirm.confirm)(__('Proceed to exit class?', _locale2.default)).then(function () {
	              _this2.setState({ fetching: true });
	              (0, _updateClassStudentState2.default)(classInfo.classID, Number(studentId), 'not_enrolled').then(function (res) {
	                _this2.setState({ fetching: false });
	                checkStudentUpdate(true);
	                getClassList();
	              });
	            }).catch(function () {});
	          });
	        } else {
	          (0, _confirm.confirm)(__('Proceed to exit class?', _locale2.default)).then(function () {
	            _this2.setState({ fetching: true });
	            (0, _updateClassStudentState2.default)(classInfo.classID, Number(studentId), 'not_enrolled').then(function (res) {
	              _this2.setState({ fetching: false });
	              checkStudentUpdate(true);
	              getClassList();
	            });
	          }).catch(function () {});
	        }
	      },
	      isDisabled: function isDisabled(opts) {
	        return !(0, _R.userCan)('archive_student_from_class');
	      }
	    }];
	
	    var settings = [{
	      title: _react2.default.createElement('i', { className: 'fa icon-ellipsis-vert' }),
	      id: "client-dropdown",
	      dropdown: dropdown
	    }];
	
	    if (showTable) {
	      return _react2.default.createElement(_UI.Table, {
	        data: classList,
	        fields: fields,
	        className: 'currentClassTable',
	        settingThTitle: ' ',
	        settingWidth: '15%',
	        settings: settings,
	        useMultiSelection: false,
	        oneSettingPerRow: false,
	        usePagination: false,
	        hideDropdownCaret: true,
	        fetching: fetching,
	        dropdownGuideWidth: 160,
	        dropdownGuideHeight: 228
	      });
	    } else {
	      return _react2.default.createElement('div', null);
	    }
	  };
	
	  return currentClassTable;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(currentClassTable);
	module.exports = exports['default'];

/***/ },

/***/ "97kv":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateClassStudentState;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATES = ["not_enrolled", "enrolled"];
	
	//
	// update student's newState (enrolled or not-enrolled) in a class
	//
	function updateClassStudentState(classId, studentId, newState) {
	
	  if (!classId || !studentId || !newState) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing or wrong type of params: classId:number, studentId:number, newState:string')
	      });
	    });
	  }
	
	  if (STATES.indexOf(newState) == -1) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('newState (string) must be one of [' + STATES.toString() + ']')
	      });
	    });
	  }
	
	  // this is the data structure the API wants
	  var toServer = {
	    state: STATES.indexOf(newState)
	  };
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/u_clsstdtstt/" + classId + "/" + studentId + "/",
	      'data': JSON.stringify(toServer),
	      'method': 'PUT',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      console.error(err);
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "/6PK":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("8nDk");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _getStudentClass = __webpack_require__("dWt5");
	
	var _getStudentClass2 = _interopRequireDefault(_getStudentClass);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactTooltip = __webpack_require__("Hh2+");
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pastClassTable = function (_Component) {
	  _inherits(pastClassTable, _Component);
	
	  function pastClassTable(props) {
	    _classCallCheck(this, pastClassTable);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      classList: [],
	      fetching: true
	    };
	    return _this;
	  }
	
	  pastClassTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var classList = _ref.classList;
	
	    if (classList) {
	      this.setState({ classList: classList, fetching: false });
	    }
	  };
	
	  pastClassTable.prototype.render = function render() {
	    var _this2 = this;
	
	    var showTable = this.props.showTable;
	    var _state = this.state,
	        classList = _state.classList,
	        fetching = _state.fetching;
	
	
	    var fields = [{
	      name: 'className',
	      title: __('Class', _locale2.default),
	      getTdProps: function getTdProps(_ref2) {
	        var tbodyData = _ref2.tbodyData;
	
	        return {
	          style: {
	            width: "35%"
	          }
	        };
	      }
	    }, {
	      name: 'total_counted_amount',
	      title: __('Attended', _locale2.default),
	      getTdProps: function getTdProps(_ref3) {
	        var tbodyData = _ref3.tbodyData;
	
	        return {
	          style: {
	            width: "10%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref4) {
	        var classInfo = _ref4.trData;
	
	        return classInfo.check_in_statistics.total_counted_amount;
	      }
	    }, {
	      name: 'total_absent_amount',
	      title: __('Unattended', _locale2.default),
	      getTdProps: function getTdProps(_ref5) {
	        var tbodyData = _ref5.tbodyData;
	
	        return {
	          style: {
	            width: "10%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref6) {
	        var classInfo = _ref6.trData;
	
	        return classInfo.check_in_statistics.total_absent_amount;
	      }
	    }, {
	      name: 'class status',
	      title: __('Class Status', _locale2.default),
	      getTdProps: function getTdProps(_ref7) {
	        var tbodyData = _ref7.tbodyData;
	
	        return {
	          style: {
	            width: "20%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref8) {
	        var classInfo = _ref8.trData;
	
	        if (classInfo.feeType == 0) {
	          return classInfo.consumed_and_purchased.paidEndDate ? (0, _moment2.default)(classInfo.consumed_and_purchased.paidEndDate).format(__('MMM DD, YYYY', _locale2.default)) : '';
	        } else if (classInfo.feeType == 1) {
	          return classInfo.consumed_and_purchased.usedTotalQuantity + '/' + classInfo.consumed_and_purchased.paidTotalQuantity + ' ' + __('', _locale2.default);
	        } else if (classInfo.feeType == 2) {
	          return classInfo.consumed_and_purchased.usedTotalQuantity + '/' + classInfo.consumed_and_purchased.paidTotalQuantity + ' ' + __('Hour', _locale2.default);
	        }
	      }
	    }, {
	      name: 'tuition_consumption',
	      title: __('Used/Paid', _locale2.default),
	      getTdProps: function getTdProps(_ref9) {
	        var tbodyData = _ref9.tbodyData;
	
	        return {
	          style: {
	            width: "20%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref10) {
	        var classInfo = _ref10.trData;
	
	        var currency = _this2.props.schoolDetail.currency;
	        var tuition_consumption = classInfo.consumed_and_purchased.tuition_consumption;
	        var paidTotalFee = classInfo.consumed_and_purchased.paidTotalFee;
	        var discountAmount = classInfo.consumed_and_purchased.total_discount_amount;
	
	        if (classInfo && tuition_consumption !== null) {
	          if (discountAmount > 0) {
	            return _react2.default.createElement(
	              'div',
	              null,
	              tuition_consumption + ' / ' + paidTotalFee + ' ' + currency,
	              _react2.default.createElement('i', { className: 'fa icon-tag', 'data-tip': true, 'data-for': toString(classInfo.classID) }),
	              _react2.default.createElement(_reactTooltip2.default, {
	                id: toString(classInfo.classID),
	                effect: 'solid',
	                place: 'bottom',
	                type: 'info',
	                getContent: function getContent() {
	                  return __('Discounted', _locale2.default) + ' ' + discountAmount + ' ' + currency;
	                }
	              })
	            );
	          } else {
	            return _react2.default.createElement(
	              'div',
	              null,
	              tuition_consumption + ' / ' + paidTotalFee + ' ' + currency
	            );
	          }
	        } else {
	          return _react2.default.createElement('div', null);
	        }
	      }
	    }];
	
	    if (classList.length == 0) {
	      return _react2.default.createElement('div', null);
	    }
	
	    if (showTable) {
	      return _react2.default.createElement(_UI.Table, {
	        data: classList,
	        fields: fields,
	        className: 'pastClassTable',
	        settingThTitle: ' ',
	        settingWidth: '15%',
	        settings: '',
	        useMultiSelection: false,
	        oneSettingPerRow: false,
	        fetching: fetching,
	        hideDropdownCaret: true,
	        usePagination: false,
	
	        dropdownGuideWidth: 160,
	        dropdownGuideHeight: 228
	      });
	    } else {
	      return _react2.default.createElement('div', null);
	    }
	  };
	
	  return pastClassTable;
	}(_react.Component);
	
	exports.default = pastClassTable;
	module.exports = exports['default'];

/***/ },

/***/ "dWt5":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getStudentClass;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATE = ['past_class', 'current_class', 'all'];
	
	function getStudentClass(studentId, state) {
	
	  if (!studentId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing student Id (number)')
	      });
	    });
	  }
	
	  if (!state) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing state')
	      });
	    });
	  }
	
	  var newState = STATE.indexOf(state);
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/g_stdtcrtcls/' + studentId + '/' + newState,
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "J7sC":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("8nDk");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _getTradeRecord = __webpack_require__("KAiH");
	
	var _getTradeRecord2 = _interopRequireDefault(_getTradeRecord);
	
	var _TransactionSummary = __webpack_require__("nWN0");
	
	var _TransactionSummary2 = _interopRequireDefault(_TransactionSummary);
	
	var _Remarks = __webpack_require__("EAm8");
	
	var _Remarks2 = _interopRequireDefault(_Remarks);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactMonthPicker = __webpack_require__("M2KA");
	
	var _reactMonthPicker2 = _interopRequireDefault(_reactMonthPicker);
	
	var _TransactionSearchFloat = __webpack_require__("pcAD");
	
	var _TransactionSearchFloat2 = _interopRequireDefault(_TransactionSearchFloat);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MONTHS = [__('Jan', _locale2.default), __('Feb', _locale2.default), __('Mar', _locale2.default), __('Apr', _locale2.default), __('May', _locale2.default), __('Jun', _locale2.default), __('Jul', _locale2.default), __('Aug', _locale2.default), __('Sep', _locale2.default), __('Oct', _locale2.default), __('Nov', _locale2.default), __('Dec', _locale2.default)];
	
	var tuitionRecordTable = function (_Component) {
	  _inherits(tuitionRecordTable, _Component);
	
	  function tuitionRecordTable(props) {
	    _classCallCheck(this, tuitionRecordTable);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      tuitionList: [],
	      fetching: false,
	      selectedYear: '',
	      selectedMonth: '',
	      openFloatModal: false,
	      floatTarget: ''
	    };
	
	    _this.onDateClicked = _this.onDateClicked.bind(_this);
	    _this.onDateChanged = _this.onDateChanged.bind(_this);
	    _this.openFloat = _this.openFloat.bind(_this);
	    _this.closeFloat = _this.closeFloat.bind(_this);
	    _this.onSubmitSearch = _this.onSubmitSearch.bind(_this);
	    _this.fetchTradeRecord = _this.fetchTradeRecord.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.onItemsCountPerPageChange = _this.onItemsCountPerPageChange.bind(_this);
	    return _this;
	  }
	
	  tuitionRecordTable.prototype.componentWillMount = function componentWillMount() {
	    this.fetchTradeRecord(1, 10);
	  };
	
	  tuitionRecordTable.prototype.fetchTradeRecord = function fetchTradeRecord(newPageNumber, newAmountPerPage) {
	    var _this2 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var studentId = this.props.studentId;
	    var _state = this.state,
	        selectedYear = _state.selectedYear,
	        selectedMonth = _state.selectedMonth;
	
	
	    this.setState({ fetching: true });
	
	    (0, _getTradeRecord2.default)(schoolId, { student_id_list: [studentId], paging_or_not: 1, amount_per_page: newAmountPerPage, page_number: newPageNumber }).then(function (res) {
	      _this2.setState({
	        tuitionList: res.result_list,
	        fetching: false,
	        pagination: {
	          itemsCountPerPage: res.amount_per_page,
	          activePage: res.current_page_number,
	          totalItemsCount: res.total_record_amount
	        }
	      });
	    });
	  };
	
	  tuitionRecordTable.prototype.onDateClicked = function onDateClicked() {
	    this.refs.pickAMonth.show();
	  };
	
	  tuitionRecordTable.prototype.onDateChanged = function onDateChanged(year, month) {
	    var _this3 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var studentId = this.props.studentId;
	
	    var newMonth = void 0;
	    var searchDate = void 0;
	    if (month < 10) {
	      newMonth = '0' + month;
	    } else {
	      newMonth = month;
	    }
	
	    searchDate = year + '-' + newMonth + '-01';
	
	    this.setState({ selectedYear: year, selectedMonth: newMonth, fetching: true });
	
	    (0, _getTradeRecord2.default)(schoolId, {
	      student_id_list: [studentId],
	      start_date: (0, _moment2.default)(searchDate).format('YYYY-MM-DD'),
	      end_date: (0, _moment2.default)(searchDate).endOf('month').format("YYYY-MM-DD")
	    }).then(function (res) {
	      _this3.setState({
	        tuitionList: res.result_list,
	        fetching: false,
	        pagination: {
	          itemsCountPerPage: res.amount_per_page,
	          activePage: res.current_page_number,
	          totalItemsCount: res.total_record_amount
	        }
	      });
	    });
	    this.refs.pickAMonth.dismiss();
	  };
	
	  tuitionRecordTable.prototype.openFloat = function openFloat(e) {
	    var _this4 = this;
	
	    this.setState({ floatTarget: e.currentTarget, openFloatModal: true }, function () {
	      _this4.forceUpdate();
	    });
	  };
	
	  tuitionRecordTable.prototype.closeFloat = function closeFloat() {
	    this.setState({ openFloatModal: false });
	  };
	
	  tuitionRecordTable.prototype.onSubmitSearch = function onSubmitSearch(data) {
	    var _this5 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var studentId = this.props.studentId;
	    var _state2 = this.state,
	        selectedYear = _state2.selectedYear,
	        selectedMonth = _state2.selectedMonth;
	
	
	    var startDate = selectedYear + '-' + selectedMonth + '-1';
	
	    this.setState({ fetching: true });
	
	    if (!data) {
	      return (0, _getTradeRecord2.default)(schoolId, { student_id_list: [studentId], start_date: startDate, end_date: (0, _moment2.default)().format('YYYY-MM-DD') }).then(function (res) {
	        _this5.setState({
	          tuitionList: res.result_list,
	          fetching: false,
	          pagination: {
	            itemsCountPerPage: res.amount_per_page,
	            activePage: res.current_page_number,
	            totalItemsCount: res.total_record_amount
	          }
	        });
	      });
	    }
	
	    (0, _getTradeRecord2.default)(schoolId, { student_id_list: [studentId], transaction_number: data }).then(function (res) {
	      _this5.setState({
	        tuitionList: res.result_list,
	        fetching: false,
	        pagination: {
	          itemsCountPerPage: res.amount_per_page,
	          activePage: res.current_page_number,
	          totalItemsCount: res.total_record_amount
	        }
	      });
	    });
	  };
	
	  tuitionRecordTable.prototype.onPageChange = function onPageChange(activePage) {
	    if (activePage == this.state.pagination.activePage) {
	      return;
	    }
	
	    this.fetchTradeRecord(activePage, this.state.pagination.itemsCountPerPage);
	  };
	
	  tuitionRecordTable.prototype.onItemsCountPerPageChange = function onItemsCountPerPageChange(itemsCountPerPage) {
	
	    this.fetchTradeRecord(1, itemsCountPerPage);
	  };
	
	  tuitionRecordTable.prototype.render = function render() {
	    var _this6 = this;
	
	    var _state3 = this.state,
	        _state3$tuitionList = _state3.tuitionList,
	        tuitionList = _state3$tuitionList === undefined ? [] : _state3$tuitionList,
	        fetching = _state3.fetching,
	        selectedYear = _state3.selectedYear,
	        selectedMonth = _state3.selectedMonth,
	        openFloatModal = _state3.openFloatModal,
	        floatTarget = _state3.floatTarget,
	        pagination = _state3.pagination;
	
	    if (!pagination) {
	      return _react2.default.createElement('div', null);
	    }
	    var source = [__('Cash', _locale2.default), __('Credit Card', _locale2.default), __('Cheque', _locale2.default), __('Transfer', _locale2.default), __('School Credit', _locale2.default), __('ClassTopBase Credit', _locale2.default), __('WeChat Barcode', _locale2.default), __('Alipay Barcode', _locale2.default), __('WeChat Web Pay', _locale2.default), __('Alipay Web Pay', _locale2.default), __('WeChat Transfer', _locale2.default), __('Alipay Transfer', _locale2.default), __('Poster Online Payment', _locale2.default)];
	    var type = ['', __('Charged', _locale2.default), __('Refunded', _locale2.default)];
	    var feeType = ['', __('lessons', _locale2.default), __('Hour', _locale2.default)];
	
	    var fields = [{
	      name: 'name',
	      title: '',
	      getTdProps: function getTdProps(_ref) {
	        var trData = _ref.trData;
	
	        return {
	          style: { width: "50%", padding: '15px' }
	        };
	      },
	      getTdContent: function getTdContent(_ref2) {
	        var studentInfo = _ref2.trData;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'transactionDate' },
	            (0, _moment2.default)(studentInfo.transaction_date).format(__('MMM DD, YYYY', _locale2.default))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tuitionClass' },
	            studentInfo.class_name ? studentInfo.class_name : __('Top Up', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'transactionNumber' },
	            studentInfo.transaction_number
	          )
	        );
	      }
	    }, {
	      name: 'age',
	      title: '',
	      getTdProps: function getTdProps(_ref3) {
	        var trData = _ref3.trData;
	
	        return {
	          style: { width: "25%", padding: '15px' }
	        };
	      },
	      getTdContent: function getTdContent(_ref4) {
	        var studentInfo = _ref4.trData;
	
	        var amount = void 0;
	        var discountAmount = '';
	        if (studentInfo.class_fee_type === 0) {
	          amount = (0, _moment2.default)(studentInfo.trEndDate).format(__('MMM DD, YYYY', _locale2.default));
	        } else if (studentInfo.class_fee_type === 1) {
	          amount = parseInt(studentInfo.trQuantity);
	        } else if (studentInfo.class_fee_type === 2) {
	          amount = studentInfo.trQuantity;
	        } else {
	          amount = '-';
	        }
	
	        var feeUnit = void 0;
	        if (typeof studentInfo.class_fee_type != 'undefined') {
	          feeUnit = feeType[studentInfo.class_fee_type];
	        }
	
	        if (studentInfo.discount_amount > 0) {
	          discountAmount = __('Discounted', _locale2.default) + ' ' + studentInfo.discount_amount;
	        } else {
	          discountAmount = '';
	        }
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'transactionDate' },
	            source[studentInfo.source_or_direction]
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tuitionClass' },
	            discountAmount + ' ' + type[studentInfo.trType] + ' ' + studentInfo.trTransactionAmount
	          ),
	          studentInfo.class_fee_type !== null && _react2.default.createElement(
	            'div',
	            { className: 'transactionNumber' },
	            amount + ' ' + feeUnit
	          )
	        );
	      }
	    }];
	
	    var settings = [{
	      title: __('Receipt', _locale2.default),
	      onClick: function onClick(_ref5) {
	        var studentInfo = _ref5.trData;
	
	        (0, _TransactionSummary2.default)({
	          id: studentInfo.id,
	          student: studentInfo.student_name,
	          transaction_number: studentInfo.transaction_number,
	          operator_name: studentInfo.operator_name,
	          student_email: studentInfo.student_email
	        });
	      },
	      isDisabled: function isDisabled(opts) {
	        return !(0, _R.userCan)('send_trade_record_email');
	      }
	    }, {
	      title: __('Remark', _locale2.default),
	      onClick: function onClick(_ref6) {
	        var studentInfo = _ref6.trData;
	
	        (0, _Remarks2.default)({ id: studentInfo.id, type: 'finance' });
	      },
	      hasAlert: function hasAlert(_ref7) {
	        var studentInfo = _ref7.trData;
	
	        return studentInfo.trRemark && studentInfo.trRemark.length > 0;
	      },
	      isDisabled: function isDisabled(opts) {
	        return !(0, _R.userCan)('edit_trade_record_note');
	      }
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'studentTuitionRecord', ref: function ref(r) {
	          _this6.studentTuitionRecordRef = r;
	        } },
	      _react2.default.createElement(_UI.Table, {
	        data: tuitionList,
	        fields: fields,
	        className: 'tuitionRecordTable',
	        settingThTitle: ' ',
	        settingWidth: '25%',
	        settings: settings,
	        useMultiSelection: false,
	        oneSettingPerRow: false,
	        fetching: fetching,
	        hideDropdownCaret: true,
	        dropdownGuideWidth: 160,
	        dropdownGuideHeight: 228,
	        pagination: pagination,
	        usePagination: true,
	        onPageChange: this.onPageChange,
	        onItemsCountPerPageChange: this.onItemsCountPerPageChange,
	        hasTopUtilSection: true,
	        topUtilSection: _react2.default.createElement(
	          'div',
	          { className: 'tutionFilter' },
	          _react2.default.createElement(
	            'span',
	            { className: 'tuitionYear' },
	            selectedYear == '' && selectedMonth == '' ? __('All Record', _locale2.default) : (0, _moment2.default)(selectedYear + '-' + selectedMonth, 'YYYY-MM').format(__('MMMM YYYY', _locale2.default))
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'pull-right tuitionReceipt', onClick: this.openFloat },
	            _react2.default.createElement('i', { className: 'fa icon-barcode' }),
	            __('Search Receipt', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'pull-right tuitionCalendar', onClick: this.onDateClicked },
	            _react2.default.createElement('i', { className: 'fa icon-calendar' }),
	            __('Month Filter', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'pull-right tuitionReceipt', onClick: function onClick() {
	                _this6.setState({ selectedYear: '', selectedMonth: '' });
	                _this6.fetchTradeRecord(1, 10);
	              } },
	            _react2.default.createElement('i', { className: 'fa icon-folder' }),
	            __('All Record', _locale2.default)
	          ),
	          _react2.default.createElement(_reactMonthPicker2.default, {
	            ref: 'pickAMonth',
	            years: { min: { year: 2014, month: 1 }, max: { year: (0, _moment2.default)().year(), month: (0, _moment2.default)().month() + 1 } },
	            value: { year: selectedYear, month: selectedMonth },
	            lang: MONTHS,
	            theme: 'dark',
	            onChange: this.onDateChanged })
	        )
	      }),
	      _react2.default.createElement(_TransactionSearchFloat2.default, {
	        onSubmitSearch: this.onSubmitSearch,
	        show: openFloatModal,
	        target: floatTarget,
	        onCloseFloat: this.closeFloat,
	        container: this.studentTuitionRecordRef
	      })
	    );
	  };
	
	  return tuitionRecordTable;
	}(_react.Component);
	
	exports.default = tuitionRecordTable;
	module.exports = exports['default'];

/***/ },

/***/ "nWN0":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("noHg");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "noHg":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	var _ModalContent = __webpack_require__("b+Pc");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _sendTradeEmail = __webpack_require__("UhR/");
	
	var _sendTradeEmail2 = _interopRequireDefault(_sendTradeEmail);
	
	__webpack_require__("BneF");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel,
	        student_email = _props.student_email,
	        id = _props.id;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'transaction-summary-modal',
	        hasHeader: true,
	        hasFooter: true,
	        headerTitle: __("Transaction Summary", "finance"),
	        headerIcon: 'fa icon-indent-right',
	        fixedWidth: 500,
	        contentHeight: 300,
	        onCloseModalClick: dismiss,
	        footerType: 'grey',
	        footerButtons: [{
	          title: __('Send', 'finance'),
	          className: 'btn btn-primary pull-right',
	          onClick: function onClick() {
	            if (!_this2.formData) {
	              (0, _sendTradeEmail2.default)(id, { email_recipient: student_email }).then(function (res) {
	                dismiss();
	              });
	            } else {
	              (0, _sendTradeEmail2.default)(id, _this2.formData).then(function (res) {
	                dismiss();
	              });
	            }
	          }
	        }],
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, _extends({}, this.props, {
	        onFormChange: function onFormChange(stateFromModalContent) {
	          _this2.formData = stateFromModalContent;
	        }
	      }))
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "b+Pc":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("BneF");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      email_recipient: _this.props.student_email
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  ModalContent.prototype.onChange = function onChange(name) {
	    var _this2 = this;
	
	    return function (event) {
	      var _this2$setState;
	
	      var onFormChange = _this2.props.onFormChange;
	
	
	      _this2.setState((_this2$setState = {}, _this2$setState[name] = event.target.value, _this2$setState), function () {
	        onFormChange(_this2.state);
	      });
	    };
	  };
	
	  ModalContent.prototype.render = function render() {
	    var _props = this.props,
	        student = _props.student,
	        operator_name = _props.operator_name,
	        transaction_number = _props.transaction_number,
	        student_email = _props.student_email;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'transaction-summary-modal-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container-fluid' },
	        _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _react2.default.createElement(
	            'label',
	            null,
	            __('Student: ', 'finance')
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            student
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _react2.default.createElement(
	            'label',
	            null,
	            __('Operator: ', 'finance')
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            operator_name
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'text-center transaction-receipt' },
	          _react2.default.createElement(
	            'label',
	            null,
	            __('E-Receipt Number: ', 'finance')
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            transaction_number
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _react2.default.createElement(
	            'h5',
	            null,
	            __('Send To', 'finance')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'input-group' },
	            _react2.default.createElement(
	              'span',
	              { className: 'input-group-addon' },
	              _react2.default.createElement('i', { className: 'fa icon-envelope' })
	            ),
	            _react2.default.createElement('input', { type: 'text', className: 'form-control', value: this.state.email_recipient, onChange: this.onChange('email_recipient') })
	          )
	        )
	      )
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "BneF":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"transaction-summary-modal-content":"transaction-summary-modal-content","transaction-receipt":"transaction-receipt","input-group":"input-group"};

/***/ },

/***/ "UhR/":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = sendTradeEmail;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
		email_recipient: _joiBrowser2.default.string().required()
	});
	
	function sendTradeEmail(tradeRecordId, email) {
		if (!tradeRecordId) {
			throw 'Missing trade record ID';
		}
	
		var validateResult = _joiBrowser2.default.validate(email, schema);
	
		if (validateResult.error) {
			return new Promise(function (resolve, reject) {
				reject(validateResult);
			});
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/tr_email/' + tradeRecordId + '/',
				'method': 'POST',
				'data': JSON.stringify(email),
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res.data);
			}).catch(function (err) {
				reject(err);
			});
		});
	}

/***/ },

/***/ "pcAD":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Float = __webpack_require__("oGSK");
	
	var _Float2 = _interopRequireDefault(_Float);
	
	__webpack_require__("QPQA");
	
	var _locale = __webpack_require__("E2Ig");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var TransactionSearchFloat = function (_Component) {
	  _inherits(TransactionSearchFloat, _Component);
	
	  function TransactionSearchFloat(props) {
	    _classCallCheck(this, TransactionSearchFloat);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      number: ''
	    };
	
	    _this.renderFloatContent = _this.renderFloatContent.bind(_this);
	    return _this;
	  }
	
	  TransactionSearchFloat.prototype.renderFloatContent = function renderFloatContent() {
	    var _this2 = this;
	
	    var onSubmitSearch = this.props.onSubmitSearch;
	    var number = this.state.number;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'TransctionSearch-float container-fluid text-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'TransctionSearchHeader' },
	        __('Electronic Receipt No.', _locale2.default)
	      ),
	      _react2.default.createElement('input', { className: 'form-control TransctionSearchInput', value: number, onChange: function onChange(e) {
	          _this2.setState({ number: e.target.value });
	        } }),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary TransctionSearchBtn', onClick: function onClick() {
	            onSubmitSearch(number);
	          }, disabled: number.length < 1 },
	        __('Search', _locale2.default)
	      )
	    );
	  };
	
	  TransactionSearchFloat.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        show = _props.show,
	        target = _props.target,
	        _onCloseFloat = _props.onCloseFloat,
	        container = _props.container;
	
	
	    return _react2.default.createElement(
	      _Float2.default,
	      {
	        container: container,
	        show: show,
	        target: target,
	        floatWidth: 250,
	        onCloseFloat: function onCloseFloat() {
	          _this3.setState({ number: '' });
	          _onCloseFloat();
	        }
	      },
	      this.renderFloatContent()
	    );
	  };
	
	  return TransactionSearchFloat;
	}(_react.Component);
	
	exports.default = TransactionSearchFloat;
	module.exports = exports['default'];

/***/ },

/***/ "oGSK":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("O27J");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Transition = __webpack_require__("X/qO");
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	__webpack_require__("V9ZR");
	
	var _reactKeydown = __webpack_require__("BZBu");
	
	var _reactKeydown2 = _interopRequireDefault(_reactKeydown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Float />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Float = function (_React$Component) {
	  _inherits(Float, _React$Component);
	
	  function Float(props) {
	    _classCallCheck(this, Float);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.computeFloatXY = _this.computeFloatXY.bind(_this);
	    _this.closeFloat = _this.closeFloat.bind(_this);
	    _this.listenToKeys = _this.listenToKeys.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	
	    _this.state = {
	      show: props.show,
	      target: props.target
	    };
	    return _this;
	  }
	
	  Float.prototype.listenToKeys = function listenToKeys(e) {
	    if (e.keyCode === 27) {
	      this.closeFloat();
	    }
	  };
	
	  Float.prototype.componentWillReceiveProps = function componentWillReceiveProps(opts) {
	    var _this2 = this;
	
	    var show = opts.show,
	        target = opts.target,
	        container = opts.container,
	        floatWidth = opts.floatWidth,
	        floatHeight = opts.floatHeight;
	
	
	    if (this.state.show !== true && show == true) {
	      this.setState({
	        show: show
	      }, function () {
	        setTimeout(function () {
	          _reactDom2.default.findDOMNode(_this2.floatRef).focus();
	        }, 10);
	      });
	    }
	    if (this.state.show === true && show == false) {
	      this.closeFloat();
	    }
	  };
	
	  Float.prototype.computeFloatXY = function computeFloatXY(container, target, floatWidth, floatHeight) {
	    var containerDim = container.getBoundingClientRect();
	    var targetDim = target.getBoundingClientRect();
	
	    var rightCorner = targetDim.x - containerDim.left + container.scrollLeft + targetDim.width;
	    var topCorner = targetDim.y - containerDim.top + container.scrollTop;
	
	    var leftOffset = 0;
	    var bottomOffset = 0;
	    var directionX = 'right';
	    var directionY = 'down';
	    var floatX = 0;
	    var floatY = 0;
	    if (rightCorner + floatWidth > containerDim.width) {
	      leftOffset = (targetDim.width + floatWidth) * -1;
	      directionX = 'left';
	    }
	
	    if (topCorner + floatHeight > containerDim.height) {
	      bottomOffset = (floatHeight - targetDim.height) * -1;
	      directionY = 'up';
	    }
	    floatX = rightCorner + leftOffset;
	    floatY = topCorner + bottomOffset;
	    if (targetDim.width + floatWidth > containerDim.width) {
	      floatX = targetDim.x - containerDim.left + container.scrollLeft;
	      floatY = targetDim.y - containerDim.top + container.scrollTop;
	    }
	    return {
	      floatX: floatX,
	      floatY: floatY,
	      directionX: directionX,
	      directionY: directionY
	    };
	  };
	
	  Float.prototype.closeFloat = function closeFloat() {
	    var onCloseFloat = this.props.onCloseFloat;
	
	
	    this.setState({
	      container: null,
	      show: false,
	      target: null,
	      floatX: null,
	      floatY: null,
	      floatWidth: 'auto',
	      floatHeight: 'auto',
	      directionX: null,
	      directionY: null
	    }, function () {
	      if (typeof onCloseFloat == 'function') {
	        onCloseFloat();
	      }
	    });
	  };
	
	  Float.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _props = this.props,
	        _props$container = _props.container,
	        container = _props$container === undefined ? document.body : _props$container,
	        target = _props.target,
	        floatWidth = _props.floatWidth,
	        floatHeight = _props.floatHeight,
	        show = _props.show;
	
	    if (this.floatRef && target && this.state.target != target) {
	      var _floatRef$getBounding = this.floatRef.getBoundingClientRect(),
	          height = _floatRef$getBounding.height,
	          width = _floatRef$getBounding.width;
	
	      var usedHeight = floatHeight || height;
	      var usedWidth = floatWidth || width;
	
	      var _computeFloatXY = this.computeFloatXY(container, target, usedWidth, usedHeight),
	          floatX = _computeFloatXY.floatX,
	          floatY = _computeFloatXY.floatY,
	          directionX = _computeFloatXY.directionX,
	          directionY = _computeFloatXY.directionY;
	
	      this.setState({
	        container: container,
	        showComplete: show,
	        target: target,
	        floatX: floatX,
	        floatY: floatY,
	        floatWidth: usedWidth,
	        floatHeight: usedHeight,
	        directionX: directionX,
	        directionY: directionY
	      });
	    }
	  };
	
	  Float.prototype.onBlur = function onBlur(e) {
	    var _this3 = this;
	
	    if (this.props.closeOnBlur === true) {
	      return;
	    }
	
	    var currentTarget = e.currentTarget;
	
	    //
	    // We don't want to close it when the blur is called by
	    // an element within the target.
	    //
	    setTimeout(function () {
	      if (!currentTarget.contains(document.activeElement)) {
	        _this3.closeFloat();
	      }
	    }, 1);
	  };
	
	  Float.prototype.render = function render() {
	    var _this4 = this;
	
	    var _state = this.state,
	        showComplete = _state.showComplete,
	        floatX = _state.floatX,
	        floatY = _state.floatY,
	        directionX = _state.directionX,
	        show = _state.show;
	    var _props2 = this.props,
	        floatHeight = _props2.floatHeight,
	        floatWidth = _props2.floatWidth;
	
	    // if (!show) {
	    //  this.floatRef = null;
	    //  return (<span />);
	    // }
	
	
	    var style = {
	      top: floatY,
	      left: floatX,
	      width: floatWidth,
	      height: floatHeight,
	      display: show ? 'block' : 'none',
	      opacity: showComplete ? 1 : 0
	    };
	
	    return _react2.default.createElement(
	      _Transition2.default,
	      { type: 'slide-' + directionX },
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'float-modal',
	          style: style,
	          ref: function ref(f) {
	            _this4.floatRef = f;
	          },
	          onBlur: this.onBlur,
	          tabIndex: '0',
	          onKeyDown: this.listenToKeys
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'float-content' },
	          this.props.children
	        )
	      )
	    );
	  };
	
	  return Float;
	}(_react2.default.Component);
	
	exports.default = Float;
	module.exports = exports['default'];

/***/ },

/***/ "V9ZR":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"float-modal":"float-modal","float-content":"float-content"};

/***/ },

/***/ "QPQA":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"TransctionSearch-float":"TransctionSearch-float","TransctionSearchHeader":"TransctionSearchHeader","TransctionSearchInput":"TransctionSearchInput","TransctionSearchBtn":"TransctionSearchBtn"};

/***/ },

/***/ "E2Ig":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'TransactionSearchFloat',
	  code: 'CN',
	  text: {
	    'Electronic Receipt No.': '电子收据号',
	    'Search': '查询',
	    '': ''
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "gjj1":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentDurationFormat = __webpack_require__("SdwT");
	
	var _momentDurationFormat2 = _interopRequireDefault(_momentDurationFormat);
	
	var _AttendanceLessonTime = __webpack_require__("4Kje");
	
	var _AttendanceLessonTime2 = _interopRequireDefault(_AttendanceLessonTime);
	
	var _AttendanceStatus = __webpack_require__("zeU0");
	
	var _AttendanceStatus2 = _interopRequireDefault(_AttendanceStatus);
	
	var _AttendTime = __webpack_require__("dg0h");
	
	var _AttendTime2 = _interopRequireDefault(_AttendTime);
	
	var _ducks = __webpack_require__("vw3Y");
	
	var _FilterBy = __webpack_require__("SdD8");
	
	var _FilterBy2 = _interopRequireDefault(_FilterBy);
	
	var _alert = __webpack_require__("BGi1");
	
	var _Salary = __webpack_require__("lkGD");
	
	var _Salary2 = _interopRequireDefault(_Salary);
	
	var _Export = __webpack_require__("M4e5");
	
	var _Export2 = _interopRequireDefault(_Export);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _SalaryCalculator = __webpack_require__("HJsy");
	
	var _SalaryCalculator2 = _interopRequireDefault(_SalaryCalculator);
	
	var _reactBootstrap = __webpack_require__("3kvR");
	
	__webpack_require__("sfhh");
	
	var _UI = __webpack_require__("OM1Z");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FILTER_OPTIONS = {
	  attendanceClass: {
	    selectMultiple: true
	  },
	  attendanceStatus: {
	    selectMultiple: false
	  }
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    attendance: state.getAttendance
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchAttendance: function fetchAttendance(schoolId, state, attendanceInfo, callback) {
	      return dispatch((0, _ducks.fetchAttendance)(schoolId, state, attendanceInfo, callback));
	    },
	    setTotalSalary: function setTotalSalary(salary) {
	      return dispatch((0, _ducks.setTotalSalary)(salary));
	    },
	    resetTotalSalary: function resetTotalSalary() {
	      return dispatch((0, _ducks.resetTotalSalary)());
	    }
	  };
	};
	
	(0, _momentDurationFormat2.default)(_moment2.default);
	
	var Attendance = function (_React$Component) {
	  _inherits(Attendance, _React$Component);
	
	  function Attendance(props) {
	    _classCallCheck(this, Attendance);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      attendanceInfo: {
	        start_date: (0, _moment2.default)().subtract(1, 'month').format('YYYY-MM-DD'),
	        end_date: (0, _moment2.default)().format('YYYY-MM-DD'),
	        class_id_list: '',
	        state: ''
	      },
	      filterData: {
	        daterange: {}
	      },
	      filterTypes: ['daterange', 'attendanceClass', 'attendanceStatus'],
	      totalSalary: 0
	    };
	
	    _this.onFilterChange = _this.onFilterChange.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.onItemsCountPerPageChange = _this.onItemsCountPerPageChange.bind(_this);
	    _this.fetchAttendanceList = _this.fetchAttendanceList.bind(_this);
	    return _this;
	  }
	
	  Attendance.prototype.componentWillMount = function componentWillMount() {
	    this.fetchAttendanceList(1);
	  };
	
	  Attendance.prototype.downloadCheckinRecord = function downloadCheckinRecord(format) {
	    (0, _Export2.default)({
	      type: 'attendance',
	      format: format,
	      totalSalary: this.state.totalSalary,
	      attendance: this.props.attendance,
	      attendanceInfo: this.state.attendanceInfo,
	      id: this.props.state === 'teacher' ? this.props.teacherId : this.props.studentId,
	      state: this.props.state,
	      title: this.props.state === 'teacher' ? 'Export Teacher Attendance' : 'Export Student Attendance'
	    });
	  };
	
	  Attendance.prototype.fetchAttendanceList = function fetchAttendanceList(newPageNumber, newAmountPerPage) {
	    var _props = this.props,
	        dispatch = _props.dispatch,
	        params = _props.params,
	        state = _props.state,
	        studentId = _props.studentId,
	        attendance = _props.attendance,
	        teacherId = _props.teacherId;
	    var _attendance$paginatio = attendance.pagination,
	        activePage = _attendance$paginatio.activePage,
	        itemsCountPerPage = _attendance$paginatio.itemsCountPerPage;
	
	
	    if (state == 'student') {
	      this.props.fetchAttendance(studentId, state, _extends({}, this.state.attendanceInfo, {
	        amount_per_page: newAmountPerPage || itemsCountPerPage,
	        current_page_number: newPageNumber
	      }));
	    } else if (state == 'teacher') {
	      this.props.fetchAttendance(teacherId, state, _extends({}, this.state.attendanceInfo, {
	        amount_per_page: newAmountPerPage || itemsCountPerPage,
	        current_page_number: newPageNumber
	      }));
	    }
	  };
	
	  Attendance.prototype.onFilterChange = function onFilterChange(change) {
	    var _this2 = this;
	
	    var filterData = change.filterData,
	        lastFilterReset = change.lastFilterReset,
	        justReset = change.justReset,
	        lastFilterChanged = change.lastFilterChanged;
	    var _props2 = this.props,
	        dispatch = _props2.dispatch,
	        params = _props2.params,
	        state = _props2.state,
	        studentId = _props2.studentId,
	        teacherId = _props2.teacherId;
	
	
	    var attendanceInfo = _extends({}, this.state.attendanceInfo);
	
	    var newArr = [];
	    if (filterData.attendanceClass) {
	      filterData.attendanceClass.items.map(function (c) {
	        newArr.push(c.ctClass || c.classID);
	      });
	    }
	
	    attendanceInfo.class_id_list = newArr;
	    attendanceInfo.amount_per_page = 10;
	    attendanceInfo.current_page_number = 1;
	
	    if (filterData.daterange.startDate && !filterData.daterange.endDate || !filterData.daterange.startDate && filterData.daterange.endDate) {
	      return;
	    }
	
	    if (filterData.daterange) {
	      if (filterData.daterange.endDate && filterData.daterange.startDate) {
	        attendanceInfo.start_date = (0, _moment2.default)(filterData.daterange.startDate).format('YYYY-MM-DD');
	        attendanceInfo.end_date = (0, _moment2.default)(filterData.daterange.endDate).format('YYYY-MM-DD');
	      }
	    }
	
	    if (filterData.attendanceStatus) {
	      attendanceInfo.state = filterData.attendanceStatus.items[0].value;
	    }
	
	    var Id = '';
	    if (state == 'student') {
	      Id = studentId;
	    } else if (state == 'teacher') {
	      Id = teacherId;
	    }
	
	    if (lastFilterReset == 'attendanceStatus' && justReset == true) {
	      delete attendanceInfo.state;
	    }
	
	    if (lastFilterChanged == 'daterange' && filterData.daterange.endDate == null && filterData.daterange.startDate == null) {
	      this.setState({
	        attendanceInfo: _extends({}, this.state.attendanceInfo, {
	          start_date: (0, _moment2.default)().subtract(1, 'month').format('YYYY-MM-DD'),
	          end_date: (0, _moment2.default)().format('YYYY-MM-DD')
	        })
	      }, function () {
	        _this2.fetchAttendanceList(1);
	      });
	    } else if ((0, _moment2.default)(attendanceInfo.end_date).diff((0, _moment2.default)(attendanceInfo.start_date), 'months') >= 3) {
	      return _alert.alert.warning(__('Only search within three months period', 'teacherAttendance'));
	    } else {
	      this.setState({ attendanceInfo: attendanceInfo }, function () {
	        _this2.props.fetchAttendance(Id, state, _extends({}, _this2.state.attendanceInfo, {
	          amount_per_page: 10,
	          current_page_number: 1
	        }), function () {
	          if (_this2.props.attendance.result == 'failure' && _this2.props.attendance.reason == 'can not filter records more than 3 months') {
	            _alert.alert.warning(__('Only search within three months period', 'teacherAttendance')).then(function () {});
	          }
	        });
	      });
	    }
	
	    this.setState({ filterData: filterData });
	  };
	
	  Attendance.prototype.onPageChange = function onPageChange(activePage) {
	    if (activePage == this.props.attendance.pagination.activePage) {
	      return;
	    }
	
	    this.fetchAttendanceList(activePage);
	  };
	
	  Attendance.prototype.onItemsCountPerPageChange = function onItemsCountPerPageChange(itemsCountPerPage) {
	    this.fetchAttendanceList(1, itemsCountPerPage);
	  };
	
	  Attendance.prototype.render = function render() {
	    var _this3 = this;
	
	    var fields = [{
	      name: 'class_name',
	      title: __('Class Name', 'teacherAttendance'),
	      getTdProps: function getTdProps(_ref) {
	        var tbodyData = _ref.tbodyData;
	
	        return {
	          style: {
	            width: "15%"
	          }
	        };
	      }
	    }, {
	      name: 'lesson_index',
	      title: __('Lesson', 'teacherAttendance'),
	      getTdProps: function getTdProps(_ref2) {
	        var tbodyData = _ref2.tbodyData;
	
	        return {
	          style: {
	            width: "8%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref3) {
	        var trData = _ref3.trData;
	
	        return __('Lesson', 'teacherAttendance') + ' ' + trData.lesson_index;
	      }
	    }, {
	      name: 'lesson_time',
	      title: __('Lesson Time', 'teacherAttendance'),
	      getTdProps: function getTdProps(_ref4) {
	        var tbodyData = _ref4.tbodyData;
	
	        return {
	          style: {
	            width: "20%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref5) {
	        var attendenceInfo = _ref5.trData;
	
	        return _react2.default.createElement(_AttendanceLessonTime2.default, { attendenceInfo: attendenceInfo });
	      }
	    }, {
	      name: 'check_in_datetime',
	      title: __('Attend Time', 'teacherAttendance'),
	      getTdProps: function getTdProps(_ref6) {
	        var tbodyData = _ref6.tbodyData;
	
	        return {
	          style: {
	            width: "15%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref7) {
	        var attendenceInfo = _ref7.trData;
	
	        return _react2.default.createElement(_AttendTime2.default, { attendenceInfo: attendenceInfo });
	      }
	    }, {
	      name: 'state',
	      title: __('Status', 'teacherAttendance'),
	      getTdProps: function getTdProps(_ref8) {
	        var tbodyData = _ref8.tbodyData;
	
	        return {
	          style: {
	            width: "7%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref9) {
	        var attendenceInfo = _ref9.trData;
	
	        return _react2.default.createElement(_AttendanceStatus2.default, { attendenceInfo: attendenceInfo, currentRole: _this3.props.state });
	      }
	    }];
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    var returningPath = '';
	    if (!this.props.location) {
	      returningPath = '/student';
	    } else if (this.props.location.state != undefined) {
	      returningPath = this.props.location.state.returningPath;
	    }
	
	    var _state = this.state,
	        attendanceInfo = _state.attendanceInfo,
	        filterData = _state.filterData;
	    var start_date = attendanceInfo.start_date,
	        end_date = attendanceInfo.end_date;
	
	    var daterangeOptions = {
	      startDate: filterData.daterange.startDate || (0, _moment2.default)(start_date),
	      endDate: filterData.daterange.endDate || (0, _moment2.default)(end_date),
	      endDatePlaceholderText: __('Today', 'teacherAttendance')
	    };
	
	    var _props3 = this.props,
	        attendance = _props3.attendance,
	        state = _props3.state,
	        params = _props3.params,
	        studentId = _props3.studentId,
	        studentName = _props3.studentName,
	        teacherId = _props3.teacherId,
	        resetTotalSalary = _props3.resetTotalSalary,
	        setTotalSalary = _props3.setTotalSalary,
	        teacherInfo = _props3.teacherInfo;
	    var _attendance$list = attendance.list,
	        list = _attendance$list === undefined ? [] : _attendance$list,
	        teacher_name = attendance.teacher_name,
	        attended_count = attendance.attended_count,
	        attended_hour = attendance.attended_hour,
	        absent_count = attendance.absent_count,
	        absent_hour = attendance.absent_hour,
	        late_count = attendance.late_count,
	        late_hour = attendance.late_hour,
	        unattended_count = attendance.unattended_count,
	        unattended_hour = attendance.unattended_hour,
	        truancy_count = attendance.truancy_count,
	        truancy_hour = attendance.truancy_hour,
	        normal_count = attendance.normal_count,
	        normal_hour = attendance.normal_hour,
	        retroactive_count = attendance.retroactive_count,
	        unchecked_count = attendance.unchecked_count,
	        unchecked_hour = attendance.unchecked_hour,
	        pagination = attendance.pagination;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: state == 'teacher' ? 'teacher-attendance-table-container' : 'student-attendance-table-container' },
	      returningPath != '/student' &&
	      // temporary solution to redirect to deleted teacher tab
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { className: 'teacher_attendance-close pull-right', to: '/teacher' },
	        _react2.default.createElement('i', { className: 'fa icon-cancel' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'attendance-title' },
	        _react2.default.createElement(
	          'div',
	          null,
	          __('Attendance Record', 'teacherAttendance')
	        )
	      ),
	      _react2.default.createElement(
	        _R2.default,
	        { can: state == 'teacher' ? 'view_teacher_check_in_record' : "view_student_check_in_record", by: 'disable' },
	        _react2.default.createElement(
	          _reactBootstrap.Dropdown,
	          { id: 'setting-dropdown' },
	          _react2.default.createElement(
	            _reactBootstrap.Dropdown.Toggle,
	            { className: 'expand-to-right expand-to-down' },
	            __('Export Record', 'teacherAttendance')
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Dropdown.Menu,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.MenuItem,
	              { eventKey: 'export-student', onSelect: function onSelect() {
	                  return _this3.downloadCheckinRecord('excel');
	                }, disabled: list.length === 0 },
	              __('Export Record to Excel', 'teacherAttendance')
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.MenuItem,
	              { eventKey: 'export-student', onSelect: function onSelect() {
	                  return _this3.downloadCheckinRecord('csv');
	                }, disabled: list && list.length === 0 },
	              __('Export Record to CSV', 'teacherAttendance')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_FilterBy2.default, {
	        filterData: this.state.filterData,
	        selectMultiple: true,
	        filters: this.state.filterTypes,
	        options: _extends({}, FILTER_OPTIONS, { daterange: daterangeOptions, Id: teacherId ? teacherId : studentId, state: state }),
	        schoolId: schoolId,
	        onChange: this.onFilterChange
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'container-fluid' },
	        _react2.default.createElement(
	          'div',
	          { className: 'sections section-1' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'section-label' },
	                __('Total Attended Count/Duration: {count}', 'teacherAttendance', { count: attended_count })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'section-content' },
	                _moment2.default.duration(Number(attended_hour), 'minutes').format('h[h] m[m]', { trim: 'all' }) || '0h'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'section-info-1' },
	                __('On Time Count/Duration: {count} / {hour}', 'teacherAttendance', { count: normal_count, hour: _moment2.default.duration(Number(normal_hour), 'minutes').format('h[h] m[m]', { trim: 'all' }) || '0h' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'section-info-1' },
	                __('Late Count/Duration: {count} / {hour}', 'teacherAttendance', { count: late_count, hour: _moment2.default.duration(Number(late_hour), 'minutes').format('h[h] m[m]', { trim: 'all' }) || '0h' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'section-info-1' },
	                __('Makeup Count: {count}', 'teacherAttendance', { count: retroactive_count })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'sections section-2' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'section-label' },
	                __('Total Unattended Count/Duration: {count}', 'teacherAttendance', { count: unattended_count })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'section-content' },
	                _moment2.default.duration(Number(unattended_hour), 'minutes').format('h[h] m[m]', { trim: 'all' }) || '0h'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'section-info-2' },
	                __('Absent (with excuse) Count/Duration: {count} / {hour}', 'teacherAttendance', { count: absent_count, hour: _moment2.default.duration(Number(absent_hour), 'minutes').format('h[h] m[m]', { trim: 'all' }) || '0h' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'section-info-2' },
	                __('Absent (without notice) Count/Duration: {count} / {hour}', 'teacherAttendance', { count: truancy_count, hour: _moment2.default.duration(Number(truancy_hour), 'minutes').format('h[h] m[m]', { trim: 'all' }) || '0h' })
	              )
	            )
	          )
	        ),
	        state === 'student' && _react2.default.createElement(
	          'div',
	          { className: 'sections section-3' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section-info-2' },
	            _react2.default.createElement(
	              'div',
	              null,
	              __('Unchecked Count: {count}', 'teacherAttendance', { count: unchecked_count })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section-info-2' },
	            _react2.default.createElement(
	              'div',
	              null,
	              __('Unchecked Duration: {hour}', 'teacherAttendance', { hour: _moment2.default.duration(Number(unchecked_hour), 'minutes').format('h[h] m[m]', { trim: 'all' }) || '0h' })
	            )
	          )
	        )
	      ),
	      state === 'teacher' && _react2.default.createElement(_SalaryCalculator2.default, { teacherInfo: teacherInfo, attendance: attendance, setTotalSalary: setTotalSalary, resetTotalSalary: resetTotalSalary, salaryCalculatorType: 'checkin' }),
	      _react2.default.createElement(
	        'table',
	        { style: { width: '100%' } },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_UI.Table, {
	              data: list,
	              fields: fields,
	              crqassName: 'registration-table',
	              settingThTitle: __('Settings', 'class'),
	              settingWidth: '150px',
	              useMultiSelection: false,
	              oneSettingPerRow: false,
	              dropdownGuideWidth: 160,
	              dropdownGuideHeight: 228,
	              pagination: pagination,
	              usePagination: true,
	              onPageChange: this.onPageChange,
	              onItemsCountPerPageChange: this.onItemsCountPerPageChange
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return Attendance;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Attendance);
	module.exports = exports['default'];

/***/ },

/***/ "SdD8":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextFilter = __webpack_require__("Lzp7");
	
	var _TextFilter2 = _interopRequireDefault(_TextFilter);
	
	var _StudentFilter = __webpack_require__("8C5a");
	
	var _StudentFilter2 = _interopRequireDefault(_StudentFilter);
	
	var _TeacherFilter = __webpack_require__("m9hZ");
	
	var _TeacherFilter2 = _interopRequireDefault(_TeacherFilter);
	
	var _ClassFilter = __webpack_require__("Bvnj");
	
	var _ClassFilter2 = _interopRequireDefault(_ClassFilter);
	
	var _ClassroomFilter = __webpack_require__("tZAm");
	
	var _ClassroomFilter2 = _interopRequireDefault(_ClassroomFilter);
	
	var _DateRangeFilter = __webpack_require__("wEap");
	
	var _DateRangeFilter2 = _interopRequireDefault(_DateRangeFilter);
	
	var _AttendanceClassFilter = __webpack_require__("1Lmc");
	
	var _AttendanceClassFilter2 = _interopRequireDefault(_AttendanceClassFilter);
	
	var _AttendanceStatusFilter = __webpack_require__("rzoH");
	
	var _AttendanceStatusFilter2 = _interopRequireDefault(_AttendanceStatusFilter);
	
	var _PosterRegistrationStatusFilter = __webpack_require__("rUBk");
	
	var _PosterRegistrationStatusFilter2 = _interopRequireDefault(_PosterRegistrationStatusFilter);
	
	var _posterFilter = __webpack_require__("+HIp");
	
	var _posterFilter2 = _interopRequireDefault(_posterFilter);
	
	__webpack_require__("j+en");
	
	var _omit = __webpack_require__("Dc7M");
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <FilterBy
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    schooldId={schoolId} // required
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    filters=['classroom', 'class', 'teacher', 'student'] // required
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    onChange={(opts)=>{ console.log(opts); }} // required
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody who wants to get some filtering done. (eg. Schedule calendar etc)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var FILTERS = {
	  student: function student(props) {
	    return _react2.default.createElement(_StudentFilter2.default, props);
	  },
	  class: function _class(props) {
	    return _react2.default.createElement(_ClassFilter2.default, props);
	  },
	  teacher: function teacher(props) {
	    return _react2.default.createElement(_TeacherFilter2.default, props);
	  },
	  classroom: function classroom(props) {
	    return _react2.default.createElement(_ClassroomFilter2.default, props);
	  },
	  daterange: function daterange(props) {
	    return _react2.default.createElement(_DateRangeFilter2.default, props);
	  },
	  attendanceClass: function attendanceClass(props) {
	    return _react2.default.createElement(_AttendanceClassFilter2.default, props);
	  },
	  attendanceStatus: function attendanceStatus(props) {
	    return _react2.default.createElement(_AttendanceStatusFilter2.default, props);
	  },
	  registrationStatus: function registrationStatus(props) {
	    return _react2.default.createElement(_PosterRegistrationStatusFilter2.default, props);
	  },
	  poster: function poster(props) {
	    return _react2.default.createElement(_posterFilter2.default, props);
	  }
	};
	
	var FilterBy = function (_React$Component) {
	  _inherits(FilterBy, _React$Component);
	
	  function FilterBy(props) {
	    _classCallCheck(this, FilterBy);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._onReset = _this._onReset.bind(_this);
	    _this._onChange = _this._onChange.bind(_this);
	
	    _this.state = {
	      filterData: props.filterData || {}
	    };
	    return _this;
	  }
	
	  FilterBy.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.filterData !== this.props.filterData) {
	      this.setState({
	        filterData: _extends({}, this.state.filterData, nextProps.filterData)
	      });
	    }
	  };
	
	  FilterBy.prototype._onChange = function _onChange(filterName) {
	    var _this2 = this;
	
	    return function (value) {
	      var _extends2;
	
	      var onChange = _this2.props.onChange;
	
	
	      _this2.setState({
	        filterData: _extends({}, _this2.state.filterData, (_extends2 = {}, _extends2[filterName] = value, _extends2)),
	        lastFilterChanged: filterName,
	        justReset: false
	      }, function () {
	        onChange(_this2.state);
	      });
	    };
	  };
	
	  FilterBy.prototype._onReset = function _onReset(filterName) {
	    var _this3 = this;
	
	    //
	    // remove filter data
	    //
	    return function () {
	      var onChange = _this3.props.onChange;
	
	
	      _this3.setState({
	        filterData: _extends({}, (0, _omit2.default)(_this3.state.filterData, filterName)),
	        lastFilterReset: filterName,
	        justReset: true
	      }, function () {
	        onChange(_this3.state);
	      });
	    };
	  };
	
	  FilterBy.prototype.render = function render() {
	    var _this4 = this;
	
	    var filterData = this.state.filterData;
	    var _props = this.props,
	        schoolId = _props.schoolId,
	        filters = _props.filters,
	        selectMultiple = _props.selectMultiple,
	        _props$options = _props.options,
	        options = _props$options === undefined ? {} : _props$options;
	    var Id = options.Id,
	        state = options.state;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'filter-by' },
	      filters.map(function (name, key) {
	        if (name.indexOf('text:') > -1) {
	          var nameParts = name.split(':');
	          var dataName = nameParts[1];
	          return _react2.default.createElement(_TextFilter2.default, {
	            key: key,
	            Id: Id,
	            state: state,
	            schoolId: schoolId,
	            value: filterData[dataName],
	            name: dataName,
	            options: options[name] || {},
	            onChange: _this4._onChange(dataName),
	            onReset: _this4._onReset(dataName) });
	        }
	
	        if (typeof FILTERS[name] !== 'function') {
	          throw new Error(name + ' is not a filter in FILTERS.');
	        }
	
	        return FILTERS[name]({
	          key: key,
	          schoolId: schoolId,
	          Id: Id,
	          state: state,
	          options: options[name] || {},
	          selected: (filterData[name] || {}).items || [],
	          onReset: _this4._onReset(name),
	          onChange: _this4._onChange(name),
	          value: filterData[name]
	        });
	      })
	    );
	  };
	
	  return FilterBy;
	}(_react2.default.Component);
	
	exports.default = FilterBy;
	module.exports = exports['default'];

/***/ },

/***/ "Lzp7":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <TextFilter />
	                    *
	                    * @parent anybody
	                    * @stateful
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ResettableInput = __webpack_require__("M8Vd");
	
	var _ResettableInput2 = _interopRequireDefault(_ResettableInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_PLACEHOLDER = __('Search', 'TextFilter');
	
	var VALUE_MIN_LENGTH = 3;
	
	var TextFilter = (_temp = _class = function (_React$Component) {
	  _inherits(TextFilter, _React$Component);
	
	  function TextFilter(props) {
	    _classCallCheck(this, TextFilter);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      value: '',
	      hasMeaningfulValue: false
	    };
	
	    _this.onReset = _this.onReset.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  TextFilter.prototype.onReset = function onReset() {
	    var onReset = this.props.onReset;
	
	
	    this.setState({
	      value: '',
	      hasMeaningfulValue: false
	    }, function () {
	      onReset();
	    });
	  };
	
	  //
	  // Ryan: It works but I didn't write logic explicitly. Please refer to the comments.
	  //
	
	
	  TextFilter.prototype.onChange = function onChange(e) {
	    var _this2 = this;
	
	    var value = e.target.value || '';
	
	    var onChange = this.props.onChange;
	    var _props$options$valueM = this.props.options.valueMinLength,
	        valueMinLength = _props$options$valueM === undefined ? VALUE_MIN_LENGTH : _props$options$valueM;
	
	
	    this.setState({
	      value: value
	    }, function () {
	      clearTimeout(_this2.filterTimeout);
	      _this2.filterTimeout = setTimeout(function () {
	        // console.log(value, value.length < valueMinLength);
	        if (value.length >= valueMinLength) {
	          _this2.setState({
	            hasMeaningfulValue: true
	          }, function () {
	            onChange(value);
	          });
	        } else if (_this2.state.hasMeaningfulValue && value.length < valueMinLength) {
	          _this2.setState({
	            hasMeaningfulValue: false
	          }, function () {
	            _this2.props.onReset();
	          });
	        }
	      }, 500);
	    });
	  };
	
	  TextFilter.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var value = _ref.value;
	
	    this.setState({
	      value: value
	    });
	    if (value === '') {
	      this.setState({ hasMeaningfulValue: false });
	    } else if (value) {
	      this.setState({ hasMeaningfulValue: true });
	    }
	  };
	
	  TextFilter.prototype.render = function render() {
	    var _props = this.props,
	        onReset = _props.onReset,
	        onChange = _props.onChange,
	        disabled = _props.disabled;
	    var _state = this.state,
	        value = _state.value,
	        hasMeaningfulValue = _state.hasMeaningfulValue;
	    var placeholder = this.props.options.placeholder;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'filter-by-field' },
	      _react2.default.createElement(_ResettableInput2.default, {
	        placeholder: placeholder || DEFAULT_PLACEHOLDER,
	        hasMeaningfulValue: hasMeaningfulValue,
	        value: value,
	        onReset: this.onReset,
	        onChange: this.onChange,
	        disabled: disabled
	      })
	    );
	  };
	
	  return TextFilter;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = TextFilter;
	module.exports = exports['default'];

/***/ },

/***/ "M8Vd":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("zsuf");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ResettableInput />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * A text input that has an 'X' that empties the field
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ResettableInput = function (_React$Component) {
	  _inherits(ResettableInput, _React$Component);
	
	  function ResettableInput(props) {
	    _classCallCheck(this, ResettableInput);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._onChange = _this._onChange.bind(_this);
	    _this._onReset = _this._onReset.bind(_this);
	
	    _this.state = {
	      value: props.value || ''
	    };
	    return _this;
	  }
	
	  ResettableInput.prototype._onReset = function _onReset() {
	    var onReset = this.props.onReset;
	
	
	    if (typeof onReset == 'function') {
	      onReset();
	    } else {
	      this.setState({
	        value: ''
	      });
	    }
	  };
	
	  ResettableInput.prototype._onChange = function _onChange(e) {
	    var onChange = this.props.onChange;
	
	
	    if (typeof onChange == 'function') {
	      onChange(e);
	    } else {
	      this.setState({
	        value: e.target.value
	      });
	    }
	  };
	
	  ResettableInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.value !== undefined) {
	      this.setState({
	        value: nextProps.value
	      });
	    }
	  };
	
	  ResettableInput.prototype.render = function render() {
	    var value = this.state.value;
	    var _props = this.props,
	        className = _props.className,
	        placeholder = _props.placeholder,
	        hasMeaningfulValue = _props.hasMeaningfulValue,
	        onFocus = _props.onFocus,
	        isButton = _props.isButton,
	        isDropdown = _props.isDropdown,
	        onClick = _props.onClick,
	        disabled = _props.disabled;
	
	
	    var hasValue = void 0;
	    if (hasMeaningfulValue !== undefined) {
	      hasValue = hasMeaningfulValue;
	    } else {
	      hasValue = value != '';
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('resettable-input', className, {
	          'has-value': hasValue,
	          'is-button': isButton,
	          'is-dropdown': isDropdown
	        }) },
	      _react2.default.createElement('input', {
	        placeholder: placeholder,
	        value: value,
	        className: (0, _classnames2.default)('form-control'),
	        type: 'text',
	        onFocus: onFocus,
	        onClick: onClick,
	        onChange: this._onChange,
	        disabled: disabled
	      }),
	      isDropdown && _react2.default.createElement('i', { onClick: onClick }),
	      value !== "" && value !== undefined && _react2.default.createElement(
	        'div',
	        { className: 'reset-button', onClick: this._onReset },
	        'x'
	      )
	    );
	  };
	
	  return ResettableInput;
	}(_react2.default.Component);
	
	exports.default = ResettableInput;
	module.exports = exports['default'];

/***/ },

/***/ "zsuf":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"resettable-input":"resettable-input","is-button":"is-button","is-dropdown":"is-dropdown","dropdown-icon":"dropdown-icon","reset-button":"reset-button"};

/***/ },

/***/ "8C5a":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <StudentFilter />
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent <FilterBy />
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SelectStudent = __webpack_require__("BgXg");
	
	var _SelectStudent2 = _interopRequireDefault(_SelectStudent);
	
	var _ResettableInput = __webpack_require__("M8Vd");
	
	var _ResettableInput2 = _interopRequireDefault(_ResettableInput);
	
	var _reactTooltip = __webpack_require__("Hh2+");
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _uniqid = __webpack_require__("2bpm");
	
	var _uniqid2 = _interopRequireDefault(_uniqid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StudentFilter = (_temp = _class = function (_React$Component) {
	  _inherits(StudentFilter, _React$Component);
	
	  function StudentFilter(props) {
	    _classCallCheck(this, StudentFilter);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.id = 'student-filter_' + (0, _uniqid2.default)();
	
	    _this._chooseItem = _this._chooseItem.bind(_this);
	    return _this;
	  }
	
	  StudentFilter.prototype._chooseItem = function _chooseItem() {
	    var _props = this.props,
	        onChange = _props.onChange,
	        schoolId = _props.schoolId,
	        selected = _props.selected;
	    var _props$options = this.props.options,
	        selectMultiple = _props$options.selectMultiple,
	        onlyFetchCurrent = _props$options.onlyFetchCurrent;
	
	
	    (0, _SelectStudent2.default)({
	      schoolId: schoolId,
	      selectMultiple: selectMultiple,
	      selected: selected,
	      onlyFetchCurrent: onlyFetchCurrent
	    }).then(function (items) {
	      if (Array.isArray(items)) {
	        var IDs = items.map(function (c) {
	          return c.id;
	        });
	        onChange({ items: items, IDs: IDs });
	      } else {
	        onChange({ items: [items], IDs: [items.id] });
	      }
	    });
	  };
	
	  StudentFilter.prototype.render = function render() {
	    var _props2 = this.props,
	        onReset = _props2.onReset,
	        value = _props2.value;
	    var items = this.props.value.items;
	    var disabled = this.props.options.disabled;
	
	    var valueText = '';
	    var tooltipText = void 0;
	    if (items && items.length > 1) {
	      valueText = items[0].name + '...';
	      tooltipText = items.map(function (item, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          item.name
	        );
	      });
	    } else if (items && items.length == 1) {
	      valueText = items[0].name;
	    }
	
	    var disableTooltip = items === undefined || items.length == 1 || disabled;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'filter-by-field' },
	      _react2.default.createElement(
	        'div',
	        { 'data-tip': true, 'data-for': this.id },
	        _react2.default.createElement(_ResettableInput2.default, {
	          placeholder: __('All Students', 'schedule'),
	          value: valueText,
	          onReset: onReset,
	          onClick: this._chooseItem,
	          isDropdown: true // this will enable caret on the righthand side
	          , disabled: disabled
	        })
	      ),
	      _react2.default.createElement(_reactTooltip2.default, {
	        id: this.id,
	        disable: disableTooltip,
	        effect: 'solid',
	        place: 'bottom',
	        getContent: function getContent() {
	          return tooltipText;
	        } })
	    );
	  };
	
	  return StudentFilter;
	}(_react2.default.Component), _class.defaultProps = {
	  value: {}
	}, _temp);
	exports.default = StudentFilter;
	module.exports = exports['default'];

/***/ },

/***/ "m9hZ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <TeacherFilter />
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent <FilterBy />
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SelectTeacher = __webpack_require__("okp6");
	
	var _SelectTeacher2 = _interopRequireDefault(_SelectTeacher);
	
	var _ResettableInput = __webpack_require__("M8Vd");
	
	var _ResettableInput2 = _interopRequireDefault(_ResettableInput);
	
	var _reactTooltip = __webpack_require__("Hh2+");
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _uniqid = __webpack_require__("2bpm");
	
	var _uniqid2 = _interopRequireDefault(_uniqid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeacherFilter = (_temp = _class = function (_React$Component) {
	  _inherits(TeacherFilter, _React$Component);
	
	  function TeacherFilter(props) {
	    _classCallCheck(this, TeacherFilter);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.id = 'teacher-filter_' + (0, _uniqid2.default)();
	
	    _this._chooseItem = _this._chooseItem.bind(_this);
	    return _this;
	  }
	
	  TeacherFilter.prototype._chooseItem = function _chooseItem() {
	    var _props = this.props,
	        onChange = _props.onChange,
	        schoolId = _props.schoolId,
	        selected = _props.selected;
	    var selectMultiple = this.props.options.selectMultiple;
	
	
	    (0, _SelectTeacher2.default)({
	      schoolId: schoolId,
	      selectMultiple: selectMultiple,
	      selected: selected
	    }).then(function (items) {
	      if (Array.isArray(items)) {
	        var IDs = items.map(function (c) {
	          return c.id;
	        });
	        onChange({ items: items, IDs: IDs });
	      } else {
	        onChange({ items: [items], IDs: [items.id] });
	      }
	    });
	  };
	
	  TeacherFilter.prototype.componentWillMount = function componentWillMount() {};
	
	  TeacherFilter.prototype.render = function render() {
	    var _props2 = this.props,
	        onReset = _props2.onReset,
	        value = _props2.value;
	    var items = this.props.value.items;
	    var disabled = this.props.options.disabled;
	
	    var valueText = '';
	    var tooltipText = void 0;
	    if (items && items.length > 1) {
	      valueText = items[0].name + '...';
	      tooltipText = items.map(function (item, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          item.name
	        );
	      });
	    } else if (items && items.length == 1) {
	      valueText = items[0].name;
	    }
	
	    var disableTooltip = items === undefined || items.length == 1 || disabled;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'filter-by-field' },
	      _react2.default.createElement(
	        'div',
	        { 'data-tip': true, 'data-for': this.id },
	        _react2.default.createElement(_ResettableInput2.default, {
	          placeholder: __('All Teachers', 'schedule'),
	          value: valueText,
	          onReset: onReset,
	          onClick: this._chooseItem,
	          isDropdown: true // this will enable caret on the righthand side
	          , disabled: disabled
	        })
	      ),
	      _react2.default.createElement(_reactTooltip2.default, {
	        id: this.id,
	        disable: disableTooltip,
	        effect: 'solid',
	        place: 'bottom',
	        getContent: function getContent() {
	          return tooltipText;
	        } })
	    );
	  };
	
	  return TeacherFilter;
	}(_react2.default.Component), _class.defaultProps = {
	  value: {}
	}, _temp);
	exports.default = TeacherFilter;
	module.exports = exports['default'];

/***/ },

/***/ "Bvnj":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <ClassFilter />
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent <FilterBy />
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectClass = __webpack_require__("/wCL");
	
	var _SelectClass2 = _interopRequireDefault(_SelectClass);
	
	var _ResettableInput = __webpack_require__("M8Vd");
	
	var _ResettableInput2 = _interopRequireDefault(_ResettableInput);
	
	var _reactTooltip = __webpack_require__("Hh2+");
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _uniqid = __webpack_require__("2bpm");
	
	var _uniqid2 = _interopRequireDefault(_uniqid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassFilter = (_temp = _class = function (_React$Component) {
	  _inherits(ClassFilter, _React$Component);
	
	  function ClassFilter(props) {
	    _classCallCheck(this, ClassFilter);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.id = 'class-filter_' + (0, _uniqid2.default)();
	
	    _this._chooseItemByModal = _this._chooseItemByModal.bind(_this);
	    return _this;
	  }
	
	  ClassFilter.prototype._chooseItemByModal = function _chooseItemByModal() {
	    var _props = this.props,
	        onChange = _props.onChange,
	        schoolId = _props.schoolId,
	        selected = _props.selected;
	    var selectMultiple = this.props.options.selectMultiple;
	
	
	    (0, _SelectClass2.default)({
	      schoolId: schoolId,
	      selectMultiple: selectMultiple,
	      selected: selected
	    }).then(function (items) {
	      if (Array.isArray(items)) {
	
	        var IDs = items.map(function (c) {
	          return c.id;
	        });
	        // a class is selected for filtering
	        onChange({ items: items, IDs: IDs });
	      } else {
	        onChange({ items: [items], IDs: [items.id] });
	      }
	    });
	  };
	
	  ClassFilter.prototype.render = function render() {
	    var onReset = this.props.onReset;
	    var items = this.props.value.items;
	    var disabled = this.props.options.disabled;
	
	    var valueText = '';
	    var tooltipText = void 0;
	    if (items && items.length > 1) {
	      valueText = items[0].cName + '...';
	
	      tooltipText = items.map(function (item, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          item.cName
	        );
	      });
	    } else if (items && items.length == 1) {
	      valueText = items[0].cName;
	    }
	
	    var disableTooltip = items === undefined || items.length == 1 || disabled;
	
	    var SelectorComponent = void 0;
	    SelectorComponent = _react2.default.createElement(_ResettableInput2.default, {
	      placeholder: __('All Classes', 'schedule'),
	      value: valueText,
	      onReset: onReset,
	      onClick: this._chooseItemByModal,
	      isDropdown: true // this will enable caret on the righthand side
	      , disabled: disabled
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'filter-by-field' },
	      _react2.default.createElement(
	        'div',
	        { 'data-tip': true, 'data-for': this.id },
	        SelectorComponent
	      ),
	      _react2.default.createElement(_reactTooltip2.default, {
	        id: this.id,
	        disable: disableTooltip,
	        effect: 'solid',
	        place: 'bottom',
	        getContent: function getContent() {
	          return tooltipText;
	        } })
	    );
	  };
	
	  return ClassFilter;
	}(_react2.default.Component), _class.defaultProps = {
	  value: {}
	}, _temp);
	exports.default = ClassFilter;
	module.exports = exports['default'];

/***/ },

/***/ "tZAm":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <ClassroomFilter />
	                    *
	                    * @parent <FilterBy />
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SelectClassroom = __webpack_require__("wPVy");
	
	var _SelectClassroom2 = _interopRequireDefault(_SelectClassroom);
	
	var _ResettableInput = __webpack_require__("M8Vd");
	
	var _ResettableInput2 = _interopRequireDefault(_ResettableInput);
	
	var _reactTooltip = __webpack_require__("Hh2+");
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _uniqid = __webpack_require__("2bpm");
	
	var _uniqid2 = _interopRequireDefault(_uniqid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassroomFilter = (_temp = _class = function (_React$Component) {
	  _inherits(ClassroomFilter, _React$Component);
	
	  function ClassroomFilter(props) {
	    _classCallCheck(this, ClassroomFilter);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.id = 'class-filter_' + (0, _uniqid2.default)();
	
	    _this._chooseItem = _this._chooseItem.bind(_this);
	    return _this;
	  }
	
	  ClassroomFilter.prototype._chooseItem = function _chooseItem() {
	    var _props = this.props,
	        onChange = _props.onChange,
	        schoolId = _props.schoolId,
	        selected = _props.selected;
	    var selectMultiple = this.props.options.selectMultiple;
	
	
	    (0, _SelectClassroom2.default)({
	      schoolId: schoolId,
	      selectMultiple: selectMultiple,
	      selected: selected
	    }).then(function (items) {
	      if (Array.isArray(items)) {
	        var IDs = items.map(function (c) {
	          return c.id;
	        });
	        onChange({ items: items, IDs: IDs });
	      } else {
	        onChange({ items: [items], IDs: [items.id] });
	      }
	    });
	  };
	
	  ClassroomFilter.prototype.componentWillMount = function componentWillMount() {};
	
	  ClassroomFilter.prototype.render = function render() {
	    var onReset = this.props.onReset;
	    var items = this.props.value.items;
	    var disabled = this.props.options.disabled;
	
	    var valueText = '';
	    var tooltipText = void 0;
	
	    if (items && items.length > 1) {
	      valueText = items[0].name + '...';
	
	      tooltipText = items.map(function (item, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          item.name
	        );
	      });
	    } else if (items && items.length == 1) {
	      valueText = items[0].name;
	    }
	
	    var disableTooltip = items === undefined || items.length == 1 || disabled;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'filter-by-field' },
	      _react2.default.createElement(
	        'div',
	        { 'data-tip': true, 'data-for': this.id },
	        _react2.default.createElement(_ResettableInput2.default, {
	          placeholder: __('All Classrooms', 'schedule'),
	          value: valueText,
	          onReset: onReset,
	          onClick: this._chooseItem,
	          isDropdown: true // this will enable caret on the righthand side
	          , disabled: disabled
	        })
	      ),
	      _react2.default.createElement(_reactTooltip2.default, {
	        id: this.id,
	        disable: disableTooltip,
	        effect: 'solid',
	        place: 'bottom',
	        getContent: function getContent() {
	          return tooltipText;
	        } })
	    );
	  };
	
	  return ClassroomFilter;
	}(_react2.default.Component), _class.defaultProps = {
	  value: {}
	}, _temp);
	exports.default = ClassroomFilter;
	module.exports = exports['default'];

/***/ },

/***/ "wEap":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Fields = __webpack_require__("8/2o");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <DateRangeField />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var DateRangeField = function (_React$Component) {
	  _inherits(DateRangeField, _React$Component);
	
	  function DateRangeField(props) {
	    _classCallCheck(this, DateRangeField);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  DateRangeField.prototype.onChange = function onChange(_ref) {
	    var startDate = _ref.startDate,
	        endDate = _ref.endDate;
	    var onChange = this.props.onChange;
	
	
	    if (startDate && endDate) {
	      onChange({ startDate: startDate, endDate: endDate });
	    } else if (!startDate && !endDate) {
	      onChange({ startDate: startDate, endDate: endDate });
	    }
	  };
	
	  DateRangeField.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'filter-by-field' },
	      _react2.default.createElement(_Fields.DateRangePicker, _extends({}, this.props, this.props.options, { onChange: this.onChange }))
	    );
	  };
	
	  return DateRangeField;
	}(_react2.default.Component);
	
	exports.default = DateRangeField;
	module.exports = exports['default'];

/***/ },

/***/ "8/2o":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DateRangePicker = __webpack_require__("g0Dv");
	
	var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);
	
	var _TimeRange = __webpack_require__("eL63");
	
	var _TimeRange2 = _interopRequireDefault(_TimeRange);
	
	var _SelectStudent = __webpack_require__("958X");
	
	var _SelectStudent2 = _interopRequireDefault(_SelectStudent);
	
	var _SelectTeacher = __webpack_require__("qPpx");
	
	var _SelectTeacher2 = _interopRequireDefault(_SelectTeacher);
	
	var _SelectClass = __webpack_require__("2J0w");
	
	var _SelectClass2 = _interopRequireDefault(_SelectClass);
	
	var _SelectClassroom = __webpack_require__("tYCd");
	
	var _SelectClassroom2 = _interopRequireDefault(_SelectClassroom);
	
	var _DatePicker = __webpack_require__("vJje");
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _SimpleInput = __webpack_require__("7qYq");
	
	var _SimpleInput2 = _interopRequireDefault(_SimpleInput);
	
	var _Quantity = __webpack_require__("9crX");
	
	var _Quantity2 = _interopRequireDefault(_Quantity);
	
	var _Money = __webpack_require__("7bpD");
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _TimePicker = __webpack_require__("+m14");
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	var _DropdownSelect = __webpack_require__("y7rH");
	
	var _DropdownSelect2 = _interopRequireDefault(_DropdownSelect);
	
	var _Name = __webpack_require__("Ivgm");
	
	var _Name2 = _interopRequireDefault(_Name);
	
	var _Input = __webpack_require__("n/J4");
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Gender = __webpack_require__("yUzp");
	
	var _Gender2 = _interopRequireDefault(_Gender);
	
	var _index = __webpack_require__("xp4B");
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Remarks = __webpack_require__("ZTVs");
	
	var _Remarks2 = _interopRequireDefault(_Remarks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  DateRangePicker: _DateRangePicker2.default,
	  TimeRange: _TimeRange2.default,
	  SelectStudent: _SelectStudent2.default,
	  SelectTeacher: _SelectTeacher2.default,
	  SelectClass: _SelectClass2.default,
	  SelectClassroom: _SelectClassroom2.default,
	  DatePicker: _DatePicker2.default,
	  SimpleInput: _SimpleInput2.default,
	  Quantity: _Quantity2.default,
	  Money: _Money2.default,
	  TimePicker: _TimePicker2.default,
	  DropdownSelect: _DropdownSelect2.default,
	  Name: _Name2.default,
	  Input: _Input2.default,
	  Gender: _Gender2.default,
	  Tags: _index2.default,
	  Remarks: _Remarks2.default
	};
	module.exports = exports['default'];

/***/ },

/***/ "7qYq":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimpleInput = function (_Component) {
	  _inherits(SimpleInput, _Component);
	
	  function SimpleInput() {
	    _classCallCheck(this, SimpleInput);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SimpleInput.prototype.render = function render() {
	    var _props = this.props,
	        value = _props.value,
	        _onChange = _props.onChange,
	        placeholder = _props.placeholder;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'select-age-wrapper form-input' },
	      _react2.default.createElement('input', {
	        className: 'form-control',
	        value: value,
	        onChange: function onChange(event) {
	          _onChange(event.target.value);
	        },
	        placeholder: placeholder
	      })
	    );
	  };
	
	  return SimpleInput;
	}(_react.Component);
	
	exports.default = SimpleInput;
	module.exports = exports['default'];

/***/ },

/***/ "+m14":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <SingleTimePicker />
	                    *
	                    * Make a range of time
	                    *
	                    * @parent anybody
	                    * @stateful
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _rcTimePicker = __webpack_require__("/wVV");
	
	var _rcTimePicker2 = _interopRequireDefault(_rcTimePicker);
	
	__webpack_require__("/w6H");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__("bi0s");
	
	var _constants = __webpack_require__("7rIE");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_TIME = (0, _moment2.default)('10:00', _constants.TIME_FORMAT);
	var DEFAULT_USE_12HOURS = true;
	
	var SingleTimePicker = (_temp = _class = function (_Component) {
	  _inherits(SingleTimePicker, _Component);
	
	  function SingleTimePicker(props) {
	    _classCallCheck(this, SingleTimePicker);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.onTimeChange = _this.onTimeChange.bind(_this);
	
	    _this.state = {
	      time: DEFAULT_TIME
	    };
	    return _this;
	  }
	
	  SingleTimePicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var time = nextProps.time;
	
	
	    if (time) {
	      this.setState({
	        time: time
	      });
	    }
	  };
	
	  SingleTimePicker.prototype.onTimeChange = function onTimeChange(time) {
	    var _this2 = this;
	
	    var dataFormat = this.props.dataFormat;
	
	
	    this.setState({
	      time: time
	    }, function () {
	      _this2.props.onChange(_this2.state.time);
	    });
	  };
	
	  SingleTimePicker.prototype.render = function render() {
	    var _props = this.props,
	        showSecond = _props.showSecond,
	        format = _props.format,
	        hasValue = _props.hasValue,
	        _props$use12Hours = _props.use12Hours,
	        use12Hours = _props$use12Hours === undefined ? DEFAULT_USE_12HOURS : _props$use12Hours,
	        minuteStep = _props.minuteStep,
	        disabled = _props.disabled;
	    var time = this.state.time;
	
	
	    var itDoesHaveValue = this.props.hasValue || time;
	
	    if (time) {
	      time = time.lang('en');
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('time-picker', 'form-input', { 'has-value': itDoesHaveValue }) },
	      _react2.default.createElement(
	        'div',
	        { className: 'time-picker-input' },
	        _react2.default.createElement(
	          'div',
	          { className: 'start-time' },
	          _react2.default.createElement(_rcTimePicker2.default, {
	            value: time,
	            minuteStep: minuteStep,
	            onChange: this.onTimeChange,
	            format: format,
	            use12Hours: use12Hours,
	            showSecond: showSecond,
	            disabled: disabled || false })
	        )
	      )
	    );
	  };
	
	  return SingleTimePicker;
	}(_react.Component), _class.defaultProps = {
	  showSecond: false,
	  format: 'h:mm a',
	  time: ''
	}, _temp);
	exports.default = SingleTimePicker;
	module.exports = exports['default'];

/***/ },

/***/ "bi0s":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"time-picker":"time-picker","time-picker-input":"time-picker-input","start-time":"start-time","end-time":"end-time","rc-time-picker":"rc-time-picker","arrow":"arrow","reset-button":"reset-button","has-value":"has-value"};

/***/ },

/***/ "xp4B":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTagInput = __webpack_require__("L2Hf");
	
	__webpack_require__("0oPG");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tags = function (_React$Component) {
	  _inherits(Tags, _React$Component);
	
	  function Tags(props) {
	    _classCallCheck(this, Tags);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Tags.prototype.render = function render() {
	    var _props = this.props,
	        value = _props.value,
	        onChange = _props.onChange,
	        label = _props.label,
	        tagContainerClass = _props.tagContainerClass,
	        className = _props.className,
	        handleInputFocus = _props.handleInputFocus,
	        placeholder = _props.placeholder,
	        suggestions = _props.suggestions,
	        tags = _props.tags,
	        handleAddition = _props.handleAddition,
	        handleDelete = _props.handleDelete,
	        handleInputBlur = _props.handleInputBlur;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'row ' + className },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-xs-3' },
	        _react2.default.createElement(
	          'span',
	          { className: 'tags-label' },
	          label
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-xs-9' },
	        _react2.default.createElement(_reactTagInput.WithContext, {
	          classNames: {
	            tags: tagContainerClass + ' tagsClass',
	            tagInput: tags.length > 0 ? 'tagInputClass adjusted-width' : 'tagInputClass',
	            tagInputField: 'tagInputFieldClass',
	            selected: 'selectedClass',
	            tag: 'tagClass',
	            remove: 'removeClass',
	            suggestions: 'suggestionsClass',
	            activeSuggestion: 'activeSuggestionClass'
	          },
	          inline: true,
	          suggestions: suggestions,
	          placeholder: tags.length > 0 ? '' : placeholder,
	          tags: tags,
	          handleDelete: handleDelete,
	          handleAddition: handleAddition,
	          handleInputFocus: handleInputFocus,
	          handleInputBlur: handleInputBlur,
	          autofocus: false
	        })
	      )
	    );
	  };
	
	  return Tags;
	}(_react2.default.Component);
	
	exports.default = Tags;
	module.exports = exports['default'];

/***/ },

/***/ "L2Hf":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDnd = __webpack_require__("EyLK");
	
	var _reactDndHtml5Backend = __webpack_require__("5NWm");
	
	var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);
	
	var _noop = __webpack_require__("qrdl");
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _uniq = __webpack_require__("WIDu");
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _Suggestions = __webpack_require__("myub");
	
	var _Suggestions2 = _interopRequireDefault(_Suggestions);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Tag = __webpack_require__("IWFC");
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _utils = __webpack_require__("ImIL");
	
	var _constants = __webpack_require__("H7kL");
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	//Constants
	
	
	var ReactTags = function (_Component) {
	  _inherits(ReactTags, _Component);
	
	  function ReactTags(props) {
	    _classCallCheck(this, ReactTags);
	
	    var _this = _possibleConstructorReturn(this, (ReactTags.__proto__ || Object.getPrototypeOf(ReactTags)).call(this, props));
	
	    _this.addTag = function (tag) {
	      var _this$props = _this.props,
	          tags = _this$props.tags,
	          labelField = _this$props.labelField;
	
	      if (!tag.id || !tag[labelField]) {
	        return;
	      }
	      var existingKeys = tags.map(function (tag) {
	        return tag.id.toLowerCase();
	      });
	      // Return if tag has been already added
	      if (existingKeys.indexOf(tag.id.toLowerCase()) >= 0) {
	        return;
	      }
	      if (_this.props.autocomplete) {
	        var possibleMatches = _this.filteredSuggestions(tag[labelField], _this.props.suggestions);
	
	        if (_this.props.autocomplete === 1 && possibleMatches.length === 1 || _this.props.autocomplete === true && possibleMatches.length) {
	          tag = possibleMatches[0];
	        }
	      }
	
	      // call method to add
	      _this.props.handleAddition(tag);
	
	      // reset the state
	      _this.setState({
	        query: '',
	        selectionMode: false,
	        selectedIndex: -1
	      });
	
	      _this.resetAndFocusInput();
	    };
	
	    _this.getTagItems = function () {
	      var _this$props2 = _this.props,
	          tags = _this$props2.tags,
	          labelField = _this$props2.labelField,
	          removeComponent = _this$props2.removeComponent,
	          readOnly = _this$props2.readOnly,
	          handleDrag = _this$props2.handleDrag;
	      var classNames = _this.props.classNames;
	      var moveTag = handleDrag ? _this.moveTag : null;
	      return tags.map(function (tag, index) {
	        return _react2.default.createElement(_Tag2.default, {
	          key: tag.id,
	          index: index,
	          tag: tag,
	          labelField: labelField,
	          onDelete: _this.handleDelete.bind(_this, index),
	          moveTag: moveTag,
	          removeComponent: removeComponent,
	          onTagClicked: _this.handleTagClick.bind(_this, index),
	          readOnly: readOnly,
	          classNames: classNames
	        });
	      });
	    };
	
	    _this.state = {
	      suggestions: _this.props.suggestions,
	      query: '',
	      isFocused: false,
	      selectedIndex: -1,
	      selectionMode: false
	    };
	
	    _this.handleFocus = _this.handleFocus.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.moveTag = _this.moveTag.bind(_this);
	    _this.handlePaste = _this.handlePaste.bind(_this);
	    _this.resetAndFocusInput = _this.resetAndFocusInput.bind(_this);
	    _this.handleSuggestionHover = _this.handleSuggestionHover.bind(_this);
	    _this.handleSuggestionClick = _this.handleSuggestionClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(ReactTags, [{
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {
	      this.setState({
	        classNames: _extends({}, _constants.DEFAULT_CLASSNAMES, this.props.classNames)
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          autofocus = _props.autofocus,
	          readOnly = _props.readOnly;
	
	      if (autofocus && !readOnly) {
	        this.resetAndFocusInput();
	      }
	    }
	  }, {
	    key: 'UNSAFE_componentWillReceiveProps',
	    value: function UNSAFE_componentWillReceiveProps(props) {
	      var suggestions = this.filteredSuggestions(this.state.query, props.suggestions);
	      this.setState({
	        suggestions: suggestions,
	        classNames: _extends({}, _constants.DEFAULT_CLASSNAMES, props.classNames)
	      });
	    }
	  }, {
	    key: 'filteredSuggestions',
	    value: function filteredSuggestions(query, suggestions) {
	      var _this2 = this;
	
	      if (this.props.handleFilterSuggestions) {
	        return this.props.handleFilterSuggestions(query, suggestions);
	      }
	
	      return suggestions.filter(function (item) {
	        return item[_this2.props.labelField].toLowerCase().indexOf(query.toLowerCase()) === 0;
	      });
	    }
	  }, {
	    key: 'resetAndFocusInput',
	    value: function resetAndFocusInput() {
	      this.setState({ query: '' });
	      if (this.textInput) {
	        this.textInput.value = '';
	        this.textInput.focus();
	      }
	    }
	  }, {
	    key: 'handleDelete',
	    value: function handleDelete(i, e) {
	      this.props.handleDelete(i, e);
	      if (!this.props.resetInputOnDelete) {
	        this.textInput && this.textInput.focus();
	      } else {
	        this.resetAndFocusInput();
	      }
	      e.stopPropagation();
	    }
	  }, {
	    key: 'handleTagClick',
	    value: function handleTagClick(i, e) {
	      if (this.props.handleTagClick) {
	        this.props.handleTagClick(i, e);
	      }
	      if (!this.props.resetInputOnDelete) {
	        this.textInput && this.textInput.focus();
	      } else {
	        this.resetAndFocusInput();
	      }
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(e) {
	      if (this.props.handleInputChange) {
	        this.props.handleInputChange(e.target.value);
	      }
	
	      var query = e.target.value.trim();
	      var suggestions = this.filteredSuggestions(query, this.props.suggestions);
	
	      var selectedIndex = this.state.selectedIndex;
	
	      this.setState({
	        query: query,
	        suggestions: suggestions,
	        selectedIndex: selectedIndex >= suggestions.length ? suggestions.length - 1 : selectedIndex
	      });
	    }
	  }, {
	    key: 'handleFocus',
	    value: function handleFocus(e) {
	      var value = e.target.value;
	      if (this.props.handleInputFocus) {
	        this.props.handleInputFocus(value);
	      }
	      this.setState({ isFocused: true });
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur(e) {
	      var value = e.target.value;
	      if (this.props.handleInputBlur) {
	        this.props.handleInputBlur(value);
	        if (this.textInput) {
	          this.textInput.value = '';
	        }
	      }
	      this.setState({ isFocused: false });
	    }
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(e) {
	      var _state = this.state,
	          query = _state.query,
	          selectedIndex = _state.selectedIndex,
	          suggestions = _state.suggestions,
	          selectionMode = _state.selectionMode;
	
	      // hide suggestions menu on escape
	
	      if (e.keyCode === _constants.KEYS.ESCAPE) {
	        e.preventDefault();
	        e.stopPropagation();
	        this.setState({
	          selectedIndex: -1,
	          selectionMode: false,
	          suggestions: []
	        });
	      }
	
	      // When one of the terminating keys is pressed, add current query to the tags.
	      // If no text is typed in so far, ignore the action - so we don't end up with a terminating
	      // character typed in.
	      if (this.props.delimiters.indexOf(e.keyCode) !== -1 && !e.shiftKey) {
	        if (e.keyCode !== _constants.KEYS.TAB || query !== '') {
	          e.preventDefault();
	        }
	
	        var selectedQuery = selectionMode && selectedIndex !== -1 ? suggestions[selectedIndex] : _defineProperty({ id: query }, this.props.labelField, query);
	
	        if (selectedQuery !== '') {
	          this.addTag(selectedQuery);
	        }
	      }
	
	      // when backspace key is pressed and query is blank, delete tag
	      if (e.keyCode === _constants.KEYS.BACKSPACE && query === '' && this.props.allowDeleteFromEmptyInput) {
	        this.handleDelete(this.props.tags.length - 1, e);
	      }
	
	      // up arrow
	      if (e.keyCode === _constants.KEYS.UP_ARROW) {
	        e.preventDefault();
	        this.setState({
	          selectedIndex: selectedIndex <= 0 ? suggestions.length - 1 : selectedIndex - 1,
	          selectionMode: true
	        });
	      }
	
	      // down arrow
	      if (e.keyCode === _constants.KEYS.DOWN_ARROW) {
	        e.preventDefault();
	        this.setState({
	          selectedIndex: suggestions.length === 0 ? -1 : (selectedIndex + 1) % suggestions.length,
	          selectionMode: true
	        });
	      }
	    }
	  }, {
	    key: 'handlePaste',
	    value: function handlePaste(e) {
	      var _this3 = this;
	
	      if (!this.props.allowAdditionFromPaste) {
	        return;
	      }
	
	      e.preventDefault();
	
	      var clipboardData = e.clipboardData || window.clipboardData;
	      var pastedText = clipboardData.getData('text');
	
	      // Used to determine how the pasted content is split.
	      var delimiterRegExp = (0, _utils.buildRegExpFromDelimiters)(this.props.delimiters);
	      var tags = pastedText.split(delimiterRegExp);
	
	      // Only add unique tags
	      (0, _uniq2.default)(tags).forEach(function (tag) {
	        return _this3.addTag(_defineProperty({ id: tag }, _this3.props.labelField, tag));
	      });
	    }
	  }, {
	    key: 'handleSuggestionClick',
	    value: function handleSuggestionClick(i) {
	      this.addTag(this.state.suggestions[i]);
	    }
	  }, {
	    key: 'handleSuggestionHover',
	    value: function handleSuggestionHover(i) {
	      this.setState({
	        selectedIndex: i,
	        selectionMode: true
	      });
	    }
	  }, {
	    key: 'moveTag',
	    value: function moveTag(dragIndex, hoverIndex) {
	      var tags = this.props.tags;
	
	      // locate tags
	      var dragTag = tags[dragIndex];
	
	      // call handler with the index of the dragged tag
	      // and the tag that is hovered
	      this.props.handleDrag(dragTag, dragIndex, hoverIndex);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var tagItems = this.getTagItems();
	
	      // get the suggestions for the given query
	      var query = this.state.query.trim(),
	          selectedIndex = this.state.selectedIndex,
	          suggestions = this.state.suggestions,
	          placeholder = this.props.placeholder,
	          inputName = this.props.name,
	          inputId = this.props.id,
	          maxLength = this.props.maxLength;
	      var tagInput = !this.props.readOnly ? _react2.default.createElement('div', { className: this.props.classNames.tagInput }, _react2.default.createElement('input', {
	        ref: function ref(input) {
	          _this4.textInput = input;
	        },
	        className: this.props.classNames.tagInputField,
	        type: 'text',
	        placeholder: placeholder,
	        'aria-label': placeholder,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        onChange: this.handleChange,
	        onKeyDown: this.handleKeyDown,
	        onPaste: this.handlePaste,
	        name: inputName,
	        id: inputId,
	        maxLength: maxLength,
	        value: this.props.inputValue
	      }), _react2.default.createElement(_Suggestions2.default, {
	        query: query,
	        suggestions: suggestions,
	        labelField: this.props.labelField,
	        selectedIndex: selectedIndex,
	        handleClick: this.handleSuggestionClick,
	        handleHover: this.handleSuggestionHover,
	        minQueryLength: this.props.minQueryLength,
	        shouldRenderSuggestions: this.props.shouldRenderSuggestions,
	        isFocused: this.state.isFocused,
	        classNames: this.props.classNames
	      })) : null;
	
	      return _react2.default.createElement('div', { className: this.props.classNames.tags }, _react2.default.createElement('div', { className: this.props.classNames.selected }, tagItems, this.props.inline && tagInput), !this.props.inline && tagInput);
	    }
	  }]);
	
	  return ReactTags;
	}(_react.Component);
	
	ReactTags.propTypes = {
	  placeholder: _propTypes2.default.string,
	  labelField: _propTypes2.default.string,
	  suggestions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    id: _propTypes2.default.string.isRequired
	  })),
	  delimiters: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  autofocus: _propTypes2.default.bool,
	  inline: _propTypes2.default.bool,
	  handleDelete: _propTypes2.default.func,
	  handleAddition: _propTypes2.default.func,
	  handleDrag: _propTypes2.default.func,
	  handleFilterSuggestions: _propTypes2.default.func,
	  handleTagClick: _propTypes2.default.func,
	  allowDeleteFromEmptyInput: _propTypes2.default.bool,
	  allowAdditionFromPaste: _propTypes2.default.bool,
	  resetInputOnDelete: _propTypes2.default.bool,
	  handleInputChange: _propTypes2.default.func,
	  handleInputFocus: _propTypes2.default.func,
	  handleInputBlur: _propTypes2.default.func,
	  minQueryLength: _propTypes2.default.number,
	  shouldRenderSuggestions: _propTypes2.default.func,
	  removeComponent: _propTypes2.default.func,
	  autocomplete: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number]),
	  readOnly: _propTypes2.default.bool,
	  classNames: _propTypes2.default.object,
	  name: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  maxLength: _propTypes2.default.number,
	  inputValue: _propTypes2.default.string,
	  tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    id: _propTypes2.default.string.isRequired
	  }))
	};
	ReactTags.defaultProps = {
	  placeholder: _constants.DEFAULT_PLACEHOLDER,
	  labelField: _constants.DEFAULT_LABEL_FIELD,
	  suggestions: [],
	  delimiters: [_constants.KEYS.ENTER, _constants.KEYS.TAB],
	  autofocus: true,
	  inline: true,
	  handleDelete: _noop2.default,
	  handleAddition: _noop2.default,
	  allowDeleteFromEmptyInput: true,
	  allowAdditionFromPaste: true,
	  resetInputOnDelete: true,
	  autocomplete: false,
	  readOnly: false
	};
	
	module.exports = {
	  WithContext: (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2.default)(ReactTags),
	  WithOutContext: ReactTags,
	  KEYS: _constants.KEYS
	};

/***/ },

/***/ "myub":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isEqual = __webpack_require__("hygk");
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _number = __webpack_require__("fh28");
	
	var _number2 = _interopRequireDefault(_number);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	// Polyfills
	
	
	var maybeScrollSuggestionIntoView = function maybeScrollSuggestionIntoView(suggestionEl, suggestionsContainer) {
	  var containerHeight = suggestionsContainer.offsetHeight;
	  var suggestionHeight = suggestionEl.offsetHeight;
	  var relativeSuggestionTop = suggestionEl.offsetTop - suggestionsContainer.scrollTop;
	
	  if (relativeSuggestionTop + suggestionHeight >= containerHeight) {
	    suggestionsContainer.scrollTop += relativeSuggestionTop - containerHeight + suggestionHeight;
	  } else if (relativeSuggestionTop < 0) {
	    suggestionsContainer.scrollTop += relativeSuggestionTop;
	  }
	};
	
	var Suggestions = function (_Component) {
	  _inherits(Suggestions, _Component);
	
	  function Suggestions() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Suggestions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Suggestions.__proto__ || Object.getPrototypeOf(Suggestions)).call.apply(_ref, [this].concat(args))), _this), _this.markIt = function (input, query) {
	      var escapedRegex = query.trim().replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');
	      var labelValue = input[_this.props.labelField];
	
	      return {
	        __html: labelValue.replace(RegExp(escapedRegex, 'gi'), '<mark>$&</mark>')
	      };
	    }, _this.shouldRenderSuggestions = function (query) {
	      var _this$props = _this.props,
	          minQueryLength = _this$props.minQueryLength,
	          isFocused = _this$props.isFocused;
	
	      return query.length >= minQueryLength && isFocused;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Suggestions, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var props = this.props;
	
	      var shouldRenderSuggestions = props.shouldRenderSuggestions || this.shouldRenderSuggestions;
	      return props.isFocused !== nextProps.isFocused || !(0, _isEqual2.default)(props.suggestions, nextProps.suggestions) || shouldRenderSuggestions(nextProps.query) || shouldRenderSuggestions(nextProps.query) !== shouldRenderSuggestions(props.query);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props = this.props,
	          selectedIndex = _props.selectedIndex,
	          classNames = _props.classNames;
	
	      if (this.suggestionsContainer && prevProps.selectedIndex !== selectedIndex) {
	        var activeSuggestion = this.suggestionsContainer.querySelector(classNames.activeSuggestion);
	
	        if (activeSuggestion) {
	          maybeScrollSuggestionIntoView(activeSuggestion, this.suggestionsContainer);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var props = this.props;
	
	      var suggestions = props.suggestions.map(function (item, i) {
	        return _react2.default.createElement('li', {
	          key: i,
	          onMouseDown: props.handleClick.bind(null, i),
	          onMouseOver: props.handleHover.bind(null, i),
	          className: i === props.selectedIndex ? props.classNames.activeSuggestion : '' }, _react2.default.createElement('span', { dangerouslySetInnerHTML: this.markIt(item, props.query) }));
	      }.bind(this));
	
	      // use the override, if provided
	      var shouldRenderSuggestions = props.shouldRenderSuggestions || this.shouldRenderSuggestions;
	      if (suggestions.length === 0 || !shouldRenderSuggestions(props.query)) {
	        return null;
	      }
	
	      return _react2.default.createElement('div', {
	        ref: function ref(elem) {
	          _this2.suggestionsContainer = elem;
	        },
	        className: this.props.classNames.suggestions }, _react2.default.createElement('ul', null, ' ', suggestions, ' '));
	    }
	  }]);
	
	  return Suggestions;
	}(_react.Component);
	
	Suggestions.propTypes = {
	  query: _propTypes2.default.string.isRequired,
	  selectedIndex: _propTypes2.default.number.isRequired,
	  suggestions: _propTypes2.default.array.isRequired,
	  handleClick: _propTypes2.default.func.isRequired,
	  handleHover: _propTypes2.default.func.isRequired,
	  minQueryLength: _propTypes2.default.number,
	  shouldRenderSuggestions: _propTypes2.default.func,
	  isFocused: _propTypes2.default.bool.isRequired,
	  classNames: _propTypes2.default.object,
	  labelField: _propTypes2.default.string.isRequired
	};
	Suggestions.defaultProps = {
	  minQueryLength: 2
	};
	exports.default = Suggestions;

/***/ },

/***/ "IWFC":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDnd = __webpack_require__("EyLK");
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _flow = __webpack_require__("Kp45");
	
	var _flow2 = _interopRequireDefault(_flow);
	
	var _DragAndDropHelper = __webpack_require__("ARr0");
	
	var _RemoveComponent = __webpack_require__("v6nm");
	
	var _RemoveComponent2 = _interopRequireDefault(_RemoveComponent);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var ItemTypes = { TAG: 'tag' };
	
	var Tag = function (_Component) {
	  _inherits(Tag, _Component);
	
	  function Tag() {
	    _classCallCheck(this, Tag);
	
	    return _possibleConstructorReturn(this, (Tag.__proto__ || Object.getPrototypeOf(Tag)).apply(this, arguments));
	  }
	
	  _createClass(Tag, [{
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	
	      var label = props.tag[props.labelField];
	      var connectDragSource = props.connectDragSource,
	          isDragging = props.isDragging,
	          connectDropTarget = props.connectDropTarget,
	          readOnly = props.readOnly;
	
	      var tagComponent = _react2.default.createElement('span', {
	        style: { opacity: isDragging ? 0 : 1 },
	        className: props.classNames.tag,
	        onClick: props.onTagClicked,
	        onKeyDown: props.onTagClicked }, label, _react2.default.createElement(_RemoveComponent2.default, {
	        tag: props.tag,
	        className: props.classNames.remove,
	        removeComponent: props.removeComponent,
	        onClick: props.onDelete,
	        readOnly: readOnly
	      }));
	      return connectDragSource(connectDropTarget(tagComponent));
	    }
	  }]);
	
	  return Tag;
	}(_react.Component);
	
	Tag.propTypes = {
	  labelField: _propTypes2.default.string,
	  onDelete: _propTypes2.default.func.isRequired,
	  tag: _propTypes2.default.object.isRequired,
	  moveTag: _propTypes2.default.func,
	  removeComponent: _propTypes2.default.func,
	  onTagClicked: _propTypes2.default.func,
	  classNames: _propTypes2.default.object,
	  readOnly: _propTypes2.default.bool,
	  connectDragSource: _propTypes2.default.func.isRequired,
	  isDragging: _propTypes2.default.bool.isRequired,
	  connectDropTarget: _propTypes2.default.func.isRequired
	};
	
	Tag.defaultProps = {
	  labelField: 'text',
	  readOnly: false
	};
	
	exports.default = (0, _flow2.default)((0, _reactDnd.DragSource)(ItemTypes.TAG, _DragAndDropHelper.tagSource, _DragAndDropHelper.dragSource), (0, _reactDnd.DropTarget)(ItemTypes.TAG, _DragAndDropHelper.tagTarget, _DragAndDropHelper.dropCollect))(Tag);

/***/ },

/***/ "ARr0":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dropCollect = exports.dragSource = exports.tagTarget = exports.tagSource = undefined;
	
	var _reactDom = __webpack_require__("O27J");
	
	var tagSource = {
	  beginDrag: function beginDrag(props) {
	    return { id: props.tag.index, index: props.index };
	  },
	  canDrag: function canDrag(props) {
	    return props.moveTag && !props.readOnly;
	  }
	};
	
	var tagTarget = {
	  hover: function hover(props, monitor, component) {
	    var dragIndex = monitor.getItem().index;
	    var hoverIndex = props.index;
	
	    if (dragIndex === hoverIndex) {
	      return;
	    }
	
	    var hoverBoundingRect = (0, _reactDom.findDOMNode)(component).getBoundingClientRect();
	    var hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2;
	    var clientOffset = monitor.getClientOffset();
	    var hoverClientX = clientOffset.x - hoverBoundingRect.left;
	
	    // Only perform the move when the mouse has crossed half of the items width
	    if (dragIndex < hoverIndex && hoverClientX < hoverMiddleX) {
	      return;
	    }
	
	    if (dragIndex > hoverIndex && hoverClientX > hoverMiddleX) {
	      return;
	    }
	
	    props.moveTag(dragIndex, hoverIndex);
	
	    monitor.getItem().index = hoverIndex;
	  },
	  canDrop: function canDrop(props) {
	    return !props.readOnly;
	  }
	};
	
	var dragSource = function dragSource(connect, monitor) {
	  return {
	    connectDragSource: connect.dragSource(),
	    isDragging: monitor.isDragging()
	  };
	};
	
	var dropCollect = function dropCollect(connect) {
	  return {
	    connectDropTarget: connect.dropTarget()
	  };
	};
	
	exports.tagSource = tagSource;
	exports.tagTarget = tagTarget;
	exports.dragSource = dragSource;
	exports.dropCollect = dropCollect;

/***/ },

/***/ "v6nm":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var crossStr = String.fromCharCode(215);
	var RemoveComponent = function RemoveComponent(props) {
	  var readOnly = props.readOnly,
	      removeComponent = props.removeComponent,
	      onClick = props.onClick,
	      className = props.className;
	
	  if (readOnly) {
	    return _react2.default.createElement('span', null);
	  }
	
	  if (removeComponent) {
	    var Component = removeComponent;
	    return _react2.default.createElement(Component, props);
	  }
	
	  return _react2.default.createElement('a', { onClick: onClick, className: className, onKeyDown: onClick }, crossStr);
	};
	
	RemoveComponent.propTypes = {
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func.isRequired,
	  readOnly: _propTypes2.default.bool,
	  removeComponent: _propTypes2.default.func
	};
	
	exports.default = RemoveComponent;

/***/ },

/***/ "ImIL":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buildRegExpFromDelimiters = buildRegExpFromDelimiters;
	
	var _escapeRegExp = __webpack_require__("1kli");
	
	var _escapeRegExp2 = _interopRequireDefault(_escapeRegExp);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Convert an array of delimiter characters into a regular expression
	 * that can be used to split content by those delimiters.
	 * @param {Array<char>} delimiters Array of characters to turn into a regex
	 * @returns {RegExp} Regular expression
	 */
	function buildRegExpFromDelimiters(delimiters) {
	  var delimiterChars = delimiters.map(function (delimiter) {
	    // See: http://stackoverflow.com/a/34711175/1463681
	    var chrCode = delimiter - 48 * Math.floor(delimiter / 48);
	    return String.fromCharCode(96 <= delimiter ? chrCode : delimiter);
	  }).join('');
	  var escapedDelimiterChars = (0, _escapeRegExp2.default)(delimiterChars);
	  return new RegExp('[' + escapedDelimiterChars + ']+');
	}

/***/ },

/***/ "H7kL":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var KEYS = exports.KEYS = {
	  ENTER: 13,
	  TAB: 9,
	  BACKSPACE: 8,
	  UP_ARROW: 38,
	  DOWN_ARROW: 40,
	  ESCAPE: 27
	};
	
	var DEFAULT_PLACEHOLDER = exports.DEFAULT_PLACEHOLDER = 'Add new tag';
	
	var DEFAULT_LABEL_FIELD = exports.DEFAULT_LABEL_FIELD = 'text';
	
	var DEFAULT_CLASSNAMES = exports.DEFAULT_CLASSNAMES = {
	  tags: 'ReactTags__tags',
	  tagInput: 'ReactTags__tagInput',
	  tagInputField: 'ReactTags__tagInputField',
	  selected: 'ReactTags__selected',
	  tag: 'ReactTags__tag',
	  remove: 'ReactTags__remove',
	  suggestions: 'ReactTags__suggestions',
	  activeSuggestion: 'ReactTags__activeSuggestion'
	};

/***/ },

/***/ "0oPG":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"potential-client-tags":"potential-client-tags","tagsClass":"tagsClass","tagInputClass":"tagInputClass","adjusted-width":"adjusted-width","tagInputFieldClass":"tagInputFieldClass","selectedClass":"selectedClass","tagClass":"tagClass","removeClass":"removeClass","suggestionsClass":"suggestionsClass","activeSuggestionClass":"activeSuggestionClass"};

/***/ },

/***/ "ZTVs":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Remarks = function (_React$Component) {
	  _inherits(Remarks, _React$Component);
	
	  function Remarks(props) {
	    _classCallCheck(this, Remarks);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Remarks.prototype.render = function render() {
	    var _props = this.props,
	        value = _props.value,
	        onChange = _props.onChange,
	        label = _props.label,
	        inputClassName = _props.inputClassName,
	        cols = _props.cols,
	        rows = _props.rows,
	        className = _props.className;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'row ' + className },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-xs-3' },
	        _react2.default.createElement(
	          'span',
	          { className: 'remarks-label' },
	          label
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-xs-9' },
	        _react2.default.createElement('textarea', {
	          className: inputClassName,
	          cols: cols,
	          rows: rows,
	          value: value,
	          onChange: onChange
	        })
	      )
	    );
	  };
	
	  return Remarks;
	}(_react2.default.Component);
	
	exports.default = Remarks;
	module.exports = exports['default'];

/***/ },

/***/ "1Lmc":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <AttendanceClassFilter />
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent <FilterBy />
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SelectAttendanceClass = __webpack_require__("m/dx");
	
	var _SelectAttendanceClass2 = _interopRequireDefault(_SelectAttendanceClass);
	
	var _ResettableInput = __webpack_require__("M8Vd");
	
	var _ResettableInput2 = _interopRequireDefault(_ResettableInput);
	
	var _reactTooltip = __webpack_require__("Hh2+");
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _uniqid = __webpack_require__("2bpm");
	
	var _uniqid2 = _interopRequireDefault(_uniqid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AttendanceClassFilter = (_temp = _class = function (_React$Component) {
	  _inherits(AttendanceClassFilter, _React$Component);
	
	  function AttendanceClassFilter(props) {
	    _classCallCheck(this, AttendanceClassFilter);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.id = 'class-filter_' + (0, _uniqid2.default)();
	
	    _this._chooseItemByModal = _this._chooseItemByModal.bind(_this);
	    return _this;
	  }
	
	  AttendanceClassFilter.prototype._chooseItemByModal = function _chooseItemByModal() {
	    var _props = this.props,
	        onChange = _props.onChange,
	        schoolId = _props.schoolId,
	        selected = _props.selected,
	        Id = _props.Id,
	        state = _props.state;
	    var selectMultiple = this.props.options.selectMultiple;
	
	
	    (0, _SelectAttendanceClass2.default)({
	      schoolId: schoolId,
	      selectMultiple: selectMultiple,
	      selected: selected,
	      Id: Id,
	      state: state
	    }).then(function (items) {
	      if (Array.isArray(items)) {
	
	        var IDs = items.map(function (c) {
	          return c.id;
	        });
	        // a class is selected for filtering
	        onChange({ items: items, IDs: IDs });
	      } else {
	        onChange({ items: [items], IDs: [items.id] });
	      }
	    });
	  };
	
	  AttendanceClassFilter.prototype.render = function render() {
	    var onReset = this.props.onReset;
	    var items = this.props.value.items;
	
	
	    var valueText = '';
	    var tooltipText = void 0;
	    if (items && items.length > 1) {
	      if (items[0].ctClass__cName) {
	        valueText = items[0].ctClass__cName + '...';
	
	        tooltipText = items.map(function (item, key) {
	          return _react2.default.createElement(
	            'div',
	            { key: key },
	            item.ctClass__cName
	          );
	        });
	      } else {
	        valueText = items[0].className + '...';
	
	        tooltipText = items.map(function (item, key) {
	          return _react2.default.createElement(
	            'div',
	            { key: key },
	            item.className
	          );
	        });
	      }
	    } else if (items && items.length == 1) {
	      if (items[0].ctClass__cName) {
	        valueText = items[0].ctClass__cName;
	      } else {
	        valueText = items[0].className;
	      }
	    }
	
	    var disableTooltip = items === undefined || items.length == 1;
	
	    var SelectorComponent = void 0;
	
	    SelectorComponent = _react2.default.createElement(_ResettableInput2.default, {
	      placeholder: __('All Classes', 'schedule'),
	      value: valueText,
	      onReset: onReset,
	      onClick: this._chooseItemByModal,
	      isDropdown: true // this will enable caret on the righthand side
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'filter-by-field' },
	      _react2.default.createElement(
	        'div',
	        { 'data-tip': true, 'data-for': this.id },
	        SelectorComponent
	      ),
	      _react2.default.createElement(_reactTooltip2.default, {
	        id: this.id,
	        disable: disableTooltip,
	        effect: 'solid',
	        place: 'bottom',
	        getContent: function getContent() {
	          return tooltipText;
	        } })
	    );
	  };
	
	  return AttendanceClassFilter;
	}(_react2.default.Component), _class.defaultProps = {
	  value: {}
	}, _temp);
	exports.default = AttendanceClassFilter;
	module.exports = exports['default'];

/***/ },

/***/ "m/dx":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	// User can select a class.
	// a wraper of SelectItemModal
	//
	// eg.
	// SelectClass({ schoolId })
	//  .then()
	//  .catch()
	//
	
	
	exports.default = function (opts) {
	  var schoolId = opts.schoolId,
	      Id = opts.Id,
	      state = opts.state;
	
	  // this will return a promise
	
	  if (state == 'teacher') {
	    return (0, _SelectItem2.default)(_extends({
	      headerTitle: __('Select Class', 'schedule'),
	      headerIcon: 'fa icon-users',
	      itemName: __('Class', 'schedule'),
	      searchPlaceholder: __('Search Class', 'schedule'),
	
	      getItemLabel: function getItemLabel(item) {
	        return item.ctClass__cName;
	      },
	      fetchItems: function fetchItems(cb) {
	        (0, _getTeacherStatus2.default)(Id, 'all').then(function (data) {
	          cb(data.class_list);
	        }).catch(function (err) {
	          console.error(err);
	        });
	      }
	
	    }, opts));
	  } else if (state == 'student') {
	    return (0, _SelectItem2.default)(_extends({
	      headerTitle: __('Select Class', 'schedule'),
	      headerIcon: 'fa icon-users',
	      itemName: __('Class', 'schedule'),
	      searchPlaceholder: __('Search Class', 'schedule'),
	
	      getItemLabel: function getItemLabel(item) {
	        return item.className;
	      },
	      fetchItems: function fetchItems(cb) {
	        (0, _getStudentClass2.default)(Id, 'all').then(function (data) {
	          cb(data.classList);
	        }).catch(function (err) {
	          console.error(err);
	        });
	      }
	
	    }, opts));
	  }
	};
	
	var _SelectItem = __webpack_require__("k6Ef");
	
	var _SelectItem2 = _interopRequireDefault(_SelectItem);
	
	var _getTeacherStatus = __webpack_require__("Eu4U");
	
	var _getTeacherStatus2 = _interopRequireDefault(_getTeacherStatus);
	
	var _getStudentClass = __webpack_require__("dWt5");
	
	var _getStudentClass2 = _interopRequireDefault(_getStudentClass);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ },

/***/ "Eu4U":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getTeacherStatus;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATE = ['past_class', 'current_class', 'all'];
	
	function getTeacherStatus(teacherId, state) {
	
	  if (!teacherId) {
	    throw 'Missing teacher ID';
	  }
	
	  var query = _queryString2.default.stringify({
	    state: state
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/u_tch/" + teacherId + "/?" + query,
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "rzoH":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <AttendanceStatusFilter />
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent <FilterBy />
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SelectAttendanceStatus = __webpack_require__("U4ZT");
	
	var _SelectAttendanceStatus2 = _interopRequireDefault(_SelectAttendanceStatus);
	
	var _ResettableInput = __webpack_require__("M8Vd");
	
	var _ResettableInput2 = _interopRequireDefault(_ResettableInput);
	
	var _reactTooltip = __webpack_require__("Hh2+");
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _uniqid = __webpack_require__("2bpm");
	
	var _uniqid2 = _interopRequireDefault(_uniqid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AttendanceStatusFilter = (_temp = _class = function (_React$Component) {
	  _inherits(AttendanceStatusFilter, _React$Component);
	
	  function AttendanceStatusFilter(props) {
	    _classCallCheck(this, AttendanceStatusFilter);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.id = 'teacher-filter_' + (0, _uniqid2.default)();
	
	    _this._chooseItem = _this._chooseItem.bind(_this);
	    return _this;
	  }
	
	  AttendanceStatusFilter.prototype._chooseItem = function _chooseItem() {
	    var _props = this.props,
	        onChange = _props.onChange,
	        schoolId = _props.schoolId,
	        selected = _props.selected,
	        state = _props.state;
	    var selectMultiple = this.props.options.selectMultiple;
	
	
	    (0, _SelectAttendanceStatus2.default)({
	      schoolId: schoolId,
	      selectMultiple: selectMultiple,
	      selected: selected,
	      state: state
	    }).then(function (items) {
	      if (Array.isArray(items)) {
	        var IDs = items.map(function (c) {
	          return c.id;
	        });
	        onChange({ items: items, IDs: IDs });
	      } else {
	        onChange({ items: [items], IDs: [items.id] });
	      }
	    });
	  };
	
	  AttendanceStatusFilter.prototype.componentWillMount = function componentWillMount() {};
	
	  AttendanceStatusFilter.prototype.render = function render() {
	    var _props2 = this.props,
	        onReset = _props2.onReset,
	        value = _props2.value;
	    var items = this.props.value.items;
	
	
	    var valueText = '';
	    var tooltipText = void 0;
	    if (items && items.length > 1) {
	      valueText = items[0].name + '...';
	      tooltipText = items.map(function (item, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          item.name
	        );
	      });
	    } else if (items && items.length == 1) {
	      valueText = items[0].name;
	    }
	
	    var disableTooltip = items === undefined || items.length == 1;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'filter-by-field' },
	      _react2.default.createElement(
	        'div',
	        { 'data-tip': true, 'data-for': this.id },
	        _react2.default.createElement(_ResettableInput2.default, {
	          placeholder: __('Attendance Status', 'teacherAttendance'),
	          value: valueText,
	          onReset: onReset,
	          onClick: this._chooseItem,
	          isDropdown: true // this will enable caret on the righthand side
	        })
	      ),
	      _react2.default.createElement(_reactTooltip2.default, {
	        id: this.id,
	        disable: disableTooltip,
	        effect: 'solid',
	        place: 'bottom',
	        getContent: function getContent() {
	          return tooltipText;
	        } })
	    );
	  };
	
	  return AttendanceStatusFilter;
	}(_react2.default.Component), _class.defaultProps = {
	  value: {}
	}, _temp);
	exports.default = AttendanceStatusFilter;
	module.exports = exports['default'];

/***/ },

/***/ "U4ZT":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	// User can select a teacher within a class
	// a wraper of SelectItemModal
	//
	// eg.
	// SelectClassTeacher({ classId })
	//  .then()
	//  .catch()
	//
	
	
	exports.default = function (opts) {
	  var schoolId = opts.schoolId,
	      conflictedIDs = opts.conflictedIDs,
	      state = opts.state;
	
	  var filterOptions = [];
	  if (state == 'student') {
	    filterOptions = [{ 'name': __('Unchecked', 'teacherAttendance'), 'value': 'unchecked' }, { 'name': __('Attended', 'teacherAttendance'), 'value': 'attended' }, { 'name': __('Absent (with excuse)', 'teacherAttendance'), 'value': 'absent (with excuse)' }, { 'name': __('Absent (without notice)', 'teacherAttendance'), 'value': 'absent (without notice)' }];
	  } else {
	    filterOptions = [{ 'name': __('Attended', 'teacherAttendance'), 'value': 'attended' }, { 'name': __('Absent (with excuse)', 'teacherAttendance'), 'value': 'absent (with excuse)' }, { 'name': __('Absent (without notice)', 'teacherAttendance'), 'value': 'absent (without notice)' }];
	  }
	  // this will return a promise
	  return (0, _SelectItem2.default)(_extends({
	    headerTitle: __('Select Status', 'teacherAttendance'),
	    headerIcon: 'fa icon-ok',
	    itemName: __('Status', 'teacherAttendance'),
	    searchPlaceholder: __('Attendance Status', 'teacherAttendance'),
	    hideSearchbar: true,
	    fetchItems: function fetchItems(cb) {
	      cb(filterOptions);
	    },
	
	    components: {
	      SelectItem: function SelectItem(_ref) {
	        var item = _ref.item,
	            getItemLabel = _ref.getItemLabel,
	            selected = _ref.selected,
	            onClickSelect = _ref.onClickSelect,
	            selectText = _ref.selectText,
	            selectedText = _ref.selectedText,
	            mixin = _ref.mixin;
	
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'select-item' },
	          _react2.default.createElement(
	            'div',
	            null,
	            item.name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'select-button' },
	            selected && _react2.default.createElement(
	              'span',
	              { className: 'btn-link currently-selected', onClick: onClickSelect },
	              selectText || __('Selected', 'SelectItemModal')
	            ),
	            !selected && _react2.default.createElement(
	              'span',
	              { className: 'btn-link', onClick: onClickSelect },
	              selectedText || __('Select', 'SelectItemModal')
	            )
	          )
	        );
	      }
	    },
	    selectFilter: function selectFilter(item, alreadySelected, selected) {
	      return alreadySelected.value == item.value;
	    },
	
	    selected: opts.selected
	
	  }, opts));
	};
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectItem = __webpack_require__("k6Ef");
	
	var _SelectItem2 = _interopRequireDefault(_SelectItem);
	
	var _Teacher = __webpack_require__("xSer");
	
	var _Teacher2 = _interopRequireDefault(_Teacher);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ },

/***/ "rUBk":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <AttendanceStatusFilter />
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent <FilterBy />
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PosterRegistrationStatus = __webpack_require__("0yP3");
	
	var _PosterRegistrationStatus2 = _interopRequireDefault(_PosterRegistrationStatus);
	
	var _ResettableInput = __webpack_require__("M8Vd");
	
	var _ResettableInput2 = _interopRequireDefault(_ResettableInput);
	
	var _reactTooltip = __webpack_require__("Hh2+");
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _uniqid = __webpack_require__("2bpm");
	
	var _uniqid2 = _interopRequireDefault(_uniqid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PosterRegistrationStatusFilter = (_temp = _class = function (_React$Component) {
	  _inherits(PosterRegistrationStatusFilter, _React$Component);
	
	  function PosterRegistrationStatusFilter(props) {
	    _classCallCheck(this, PosterRegistrationStatusFilter);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.id = 'registration-status-filter_' + (0, _uniqid2.default)();
	
	    _this._chooseItem = _this._chooseItem.bind(_this);
	    return _this;
	  }
	
	  PosterRegistrationStatusFilter.prototype._chooseItem = function _chooseItem() {
	    var _props = this.props,
	        onChange = _props.onChange,
	        schoolId = _props.schoolId,
	        selected = _props.selected;
	    var selectMultiple = this.props.options.selectMultiple;
	
	
	    (0, _PosterRegistrationStatus2.default)({
	      schoolId: schoolId,
	      selectMultiple: selectMultiple,
	      selected: selected
	    }).then(function (items) {
	      if (Array.isArray(items)) {
	        var IDs = items.map(function (c) {
	          return c.id;
	        });
	        onChange({ items: items, IDs: IDs });
	      } else {
	        onChange({ items: [items], IDs: [items.id] });
	      }
	    });
	  };
	
	  PosterRegistrationStatusFilter.prototype.componentWillMount = function componentWillMount() {};
	
	  PosterRegistrationStatusFilter.prototype.render = function render() {
	    var _props2 = this.props,
	        onReset = _props2.onReset,
	        value = _props2.value;
	    var items = this.props.value.items;
	
	
	    var valueText = '';
	    var tooltipText = void 0;
	    if (items && items.length > 1) {
	      valueText = items[0].name + '...';
	      tooltipText = items.map(function (item, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          item.name
	        );
	      });
	    } else if (items && items.length == 1) {
	      valueText = items[0].name;
	    }
	
	    var disableTooltip = items === undefined || items.length == 1;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'filter-by-field' },
	      _react2.default.createElement(
	        'div',
	        { 'data-tip': true, 'data-for': this.id },
	        _react2.default.createElement(_ResettableInput2.default, {
	          placeholder: __('Registration Status', 'registrationTable'),
	          value: valueText,
	          onReset: onReset,
	          onClick: this._chooseItem,
	          isDropdown: true // this will enable caret on the righthand side
	        })
	      ),
	      _react2.default.createElement(_reactTooltip2.default, {
	        id: this.id,
	        disable: disableTooltip,
	        effect: 'solid',
	        place: 'bottom',
	        getContent: function getContent() {
	          return tooltipText;
	        } })
	    );
	  };
	
	  return PosterRegistrationStatusFilter;
	}(_react2.default.Component), _class.defaultProps = {
	  value: {}
	}, _temp);
	exports.default = PosterRegistrationStatusFilter;
	module.exports = exports['default'];

/***/ },

/***/ "0yP3":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (opts) {
	  var filterOptions = [{ 'name': __('Waiting List', 'registrationTable'), 'value': '0' }, { 'name': __('Success', 'registrationTable'), 'value': '2' }, { 'name': __('Transferred', 'registrationTable'), 'value': '4' }];
	  // this will return a promise
	  return (0, _SelectItem2.default)(_extends({
	    headerTitle: __('Select Status', 'teacherAttendance'),
	    headerIcon: 'fa icon-ok',
	    itemName: __('Status', 'teacherAttendance'),
	    searchPlaceholder: __('Registration Status', 'registrationTable'),
	    hideSearchbar: true,
	    fetchItems: function fetchItems(cb) {
	      cb(filterOptions);
	    },
	
	    components: {
	      SelectItem: function SelectItem(_ref) {
	        var item = _ref.item,
	            getItemLabel = _ref.getItemLabel,
	            selected = _ref.selected,
	            onClickSelect = _ref.onClickSelect,
	            selectText = _ref.selectText,
	            selectedText = _ref.selectedText,
	            mixin = _ref.mixin;
	
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'select-item' },
	          _react2.default.createElement(
	            'div',
	            null,
	            item.name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'select-button' },
	            selected && _react2.default.createElement(
	              'span',
	              { className: 'btn-link currently-selected', onClick: onClickSelect },
	              selectText || __('Selected', 'SelectItemModal')
	            ),
	            !selected && _react2.default.createElement(
	              'span',
	              { className: 'btn-link', onClick: onClickSelect },
	              selectedText || __('Select', 'SelectItemModal')
	            )
	          )
	        );
	      }
	    },
	    selectFilter: function selectFilter(item, alreadySelected, selected) {
	      return alreadySelected.value == item.value;
	    },
	
	    selected: opts.selected
	
	  }, opts));
	};
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectItem = __webpack_require__("k6Ef");
	
	var _SelectItem2 = _interopRequireDefault(_SelectItem);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ },

/***/ "+HIp":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <ClassFilter />
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent <FilterBy />
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectPoster = __webpack_require__("A/H1");
	
	var _SelectPoster2 = _interopRequireDefault(_SelectPoster);
	
	var _ResettableInput = __webpack_require__("M8Vd");
	
	var _ResettableInput2 = _interopRequireDefault(_ResettableInput);
	
	var _reactTooltip = __webpack_require__("Hh2+");
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _uniqid = __webpack_require__("2bpm");
	
	var _uniqid2 = _interopRequireDefault(_uniqid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PosterFilter = (_temp = _class = function (_React$Component) {
	  _inherits(PosterFilter, _React$Component);
	
	  function PosterFilter(props) {
	    _classCallCheck(this, PosterFilter);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.id = 'poster-filter_' + (0, _uniqid2.default)();
	
	    _this._chooseItemByModal = _this._chooseItemByModal.bind(_this);
	    return _this;
	  }
	
	  PosterFilter.prototype._chooseItemByModal = function _chooseItemByModal() {
	    var _props = this.props,
	        onChange = _props.onChange,
	        schoolId = _props.schoolId,
	        selected = _props.selected;
	    var selectMultiple = this.props.options.selectMultiple;
	
	
	    (0, _SelectPoster2.default)({
	      schoolId: schoolId,
	      selectMultiple: selectMultiple,
	      selected: selected
	    }).then(function (items) {
	      if (Array.isArray(items)) {
	
	        var IDs = items.map(function (c) {
	          return c.id;
	        });
	        // a poster is selected for filtering
	        onChange({ items: items, IDs: IDs });
	      } else {
	        onChange({ items: [items], IDs: [items.id] });
	      }
	    });
	  };
	
	  PosterFilter.prototype.render = function render() {
	    var onReset = this.props.onReset;
	    var items = this.props.value.items;
	
	
	    var valueText = '';
	    var tooltipText = void 0;
	    if (items && items.length > 1) {
	      valueText = items[0].cName + '...';
	
	      tooltipText = items.map(function (item, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          item.cName
	        );
	      });
	    } else if (items && items.length == 1) {
	      valueText = items[0].cName;
	    }
	
	    var disableTooltip = items === undefined || items.length == 1;
	
	    var SelectorComponent = void 0;
	    SelectorComponent = _react2.default.createElement(_ResettableInput2.default, {
	      placeholder: __('All Posters', 'registrationTable'),
	      value: valueText,
	      onReset: onReset,
	      onClick: this._chooseItemByModal,
	      isDropdown: true // this will enable caret on the righthand side
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'filter-by-field' },
	      _react2.default.createElement(
	        'div',
	        { 'data-tip': true, 'data-for': this.id },
	        SelectorComponent
	      ),
	      _react2.default.createElement(_reactTooltip2.default, {
	        id: this.id,
	        disable: disableTooltip,
	        effect: 'solid',
	        place: 'bottom',
	        getContent: function getContent() {
	          return tooltipText;
	        } })
	    );
	  };
	
	  return PosterFilter;
	}(_react2.default.Component), _class.defaultProps = {
	  value: {}
	}, _temp);
	exports.default = PosterFilter;
	module.exports = exports['default'];

/***/ },

/***/ "A/H1":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (opts) {
	  var schoolId = opts.schoolId,
	      _opts$itemPerPage = opts.itemPerPage,
	      itemPerPage = _opts$itemPerPage === undefined ? 25 : _opts$itemPerPage;
	
	  // this will return a promise
	
	  return (0, _SelectItem2.default)(_extends({
	    headerTitle: __('Select Poster', 'registrationTable'),
	    headerIcon: 'fa icon-userss',
	    itemName: __('Poster Title', 'registrationTable'),
	    searchPlaceholder: __('Select Poster', 'registrationTable'),
	    backendSearch: true,
	    getItemLabel: function getItemLabel(item) {
	      return item.cName;
	    },
	    fetchItems: function fetchItems(cb, fetchOpts) {
	      var searchKeyword = fetchOpts.searchKeyword,
	          currentPageNumber = fetchOpts.currentPageNumber;
	
	
	      (0, _getPosterList2.default)(schoolId, 3, itemPerPage, currentPageNumber, searchKeyword).then(function (data) {
	        var result_list = data.result_list,
	            page_amount = data.page_amount;
	
	        var pageMeta = {
	          maxPageNumber: page_amount
	        };
	        var newPosterList = [];
	        result_list.map(function (poster) {
	          newPosterList.push({ id: poster.id, cName: poster.title });
	        });
	
	        cb(newPosterList, pageMeta);
	      }).catch(function (err) {
	        console.error(err);
	      });
	    }
	
	  }, opts));
	};
	
	var _SelectItem = __webpack_require__("k6Ef");
	
	var _SelectItem2 = _interopRequireDefault(_SelectItem);
	
	var _getPosterList = __webpack_require__("19P0");
	
	var _getPosterList2 = _interopRequireDefault(_getPosterList);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ },

/***/ "j+en":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"filter-by":"filter-by","filter-by-field":"filter-by-field","__react_component_tooltip":"__react_component_tooltip","place-bottom":"place-bottom","place-top":"place-top","DateRangePickerInput":"DateRangePickerInput","DateInput":"DateInput","DateRangePickerInput_arrow_svg":"DateRangePickerInput_arrow_svg","DateRangePickerInput_clearDates":"DateRangePickerInput_clearDates","date-range-picker":"date-range-picker","has-value":"has-value","resettable-input":"resettable-input","reset-button":"reset-button","dropdown-icon":"dropdown-icon","red-filter":"red-filter","green-filter":"green-filter","yellow-filter":"yellow-filter"};

/***/ },

/***/ "lkGD":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalProvider = __webpack_require__("hW4a");
	
	var _ModalProvider2 = _interopRequireDefault(_ModalProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// requires lesson ID to use this modal
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalProvider2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "hW4a":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalBody = __webpack_require__("stsu");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalProvider = function (_React$Component) {
	  _inherits(ModalProvider, _React$Component);
	
	  function ModalProvider(props) {
	    _classCallCheck(this, ModalProvider);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalProvider.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        otherProps = _objectWithoutProperties(_props, ['children']);
	
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(_ModalBody2.default, _extends({}, this.props, { attendanceDetail: this.props.attendanceDetail }))
	    );
	  };
	
	  return ModalProvider;
	}(_react2.default.Component);
	
	exports.default = ModalProvider;
	module.exports = exports['default'];

/***/ },

/***/ "stsu":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("Rvje");
	
	var _ModalContent = __webpack_require__("8Lv/");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// const mapStateToProps = (state) => ({
	//   attendanceDetail: state.lessonAttendanceDetail,
	//   classDetail: state.classLessonDetail
	// })
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'salary-modal',
	        hasHeader: true,
	        hasFooter: true,
	        headerTitle: __("Salary Calculation", "teacherAttendance"),
	        headerIcon: 'fa icon-calc',
	        fixedWidth: 550,
	        contentHeight: 570,
	        onCloseModalClick: function onCloseModalClick() {
	          return proceed();
	        },
	        footerType: 'grey',
	        footerButtons: [{
	          title: __('Complete', 'appwrapper'),
	          className: 'btn btn-primary pull-right',
	          onClick: function onClick() {
	            proceed({ data: _this2.formData });
	          }
	        }],
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, _extends({
	        fetching: false
	      }, this.props, {
	        onFormChange: function onFormChange(stateFromModalContent) {
	          _this2.formData = stateFromModalContent;
	        } }))
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)()((0, _reactConfirm.confirmable)(ModalBody));
	module.exports = exports['default'];

/***/ },

/***/ "Rvje":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"salary-modal-content":"salary-modal-content","number-input":"number-input"};

/***/ },

/***/ "8Lv/":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _checkinCalculationTable = __webpack_require__("xbJY");
	
	var _checkinCalculationTable2 = _interopRequireDefault(_checkinCalculationTable);
	
	var _clockCardCalculationTable = __webpack_require__("tPf7");
	
	var _clockCardCalculationTable2 = _interopRequireDefault(_clockCardCalculationTable);
	
	__webpack_require__("Rvje");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalContent.prototype.render = function render() {
	    var salaryCalculatorType = this.props.salaryCalculatorType;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'salary-modal-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container-fluid' },
	        _react2.default.createElement(
	          'p',
	          null,
	          __('Please fill the fields you need for the calculation.', 'teacherAttendance')
	        ),
	        salaryCalculatorType === 'checkin' && _react2.default.createElement(_checkinCalculationTable2.default, this.props),
	        salaryCalculatorType === 'clockCard' && _react2.default.createElement(_clockCardCalculationTable2.default, this.props)
	      )
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "xbJY":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNumberFormat = __webpack_require__("RwBb");
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckinCalculationTable = function (_Component) {
	  _inherits(CheckinCalculationTable, _Component);
	
	  function CheckinCalculationTable(props) {
	    _classCallCheck(this, CheckinCalculationTable);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      baseSalary: 0,
	      hourlyRate: 0,
	      salaryByHour: 0,
	      timeRate: 0,
	      salaryByTime: 0,
	      lateHourlyRate: 0,
	      lateHourlyTotal: 0,
	      lateTimeRate: 0,
	      lateTimeTotal: 0,
	      absentWithReasonHourlyRate: 0,
	      absentWithReasonHourTotal: 0,
	      absentWithoutReasonHourlyRate: 0,
	      absentWithoutReasonHourTotal: 0,
	      absentWithReasonTimeRate: 0,
	      absentWithReasonTimeTotal: 0,
	      absentWithoutReasonTimeRate: 0,
	      absentWithoutReasonTimeTotal: 0,
	      benefit: 0,
	      tax: 0,
	      otherAddition: 0,
	      otherDeduction: 0,
	      totalSalary: 0
	    };
	    return _this;
	  }
	
	  CheckinCalculationTable.prototype.renderTotalSalary = function renderTotalSalary() {
	    var total = (parseFloat(this.state.baseSalary) + parseFloat(this.state.salaryByHour) + parseFloat(this.state.salaryByTime) - parseFloat(this.state.lateHourlyTotal) - parseFloat(this.state.lateTimeTotal) - parseFloat(this.state.absentWithReasonHourTotal) - parseFloat(this.state.absentWithReasonTimeTotal) - parseFloat(this.state.absentWithoutReasonHourTotal) - parseFloat(this.state.absentWithoutReasonTimeTotal) + parseFloat(this.state.benefit) - parseFloat(this.state.tax) + parseFloat(this.state.otherAddition) - parseFloat(this.state.otherDeduction)).toFixed(2);
	    this.props.onFormChange(total);
	    return total;
	  };
	
	  CheckinCalculationTable.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'table',
	        { style: { width: '100%', textAlign: 'center' } },
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('th', null),
	          _react2.default.createElement(
	            'th',
	            { style: { textAlign: 'center' } },
	            __('Hour/Count', 'teacherAttendance')
	          ),
	          _react2.default.createElement('th', null),
	          _react2.default.createElement(
	            'th',
	            { style: { textAlign: 'center' } },
	            __('Rate', 'teacherAttendance')
	          ),
	          _react2.default.createElement('th', null),
	          _react2.default.createElement(
	            'th',
	            { style: { textAlign: 'center' } },
	            __('Total', 'teacherAttendance')
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Base Salary', 'teacherAttendance')
	          ),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.baseSalary,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ baseSalary: value });
	                } else {
	                  _this2.setState({ baseSalary: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.baseSalary === 0) {
	                  _this2.setState({ baseSalary: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.baseSalary === '') {
	                  _this2.setState({ baseSalary: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '+'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Salary (By Hours)', 'teacherAttendance')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            (this.props.attendanceDetail.attended_hour / 60).toFixed(2),
	            ' h'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'x'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.hourlyRate,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ hourlyRate: value, salaryByHour: (value * parseFloat((_this2.props.attendanceDetail.attended_hour / 60).toFixed(2))).toFixed(2) });
	                } else {
	                  _this2.setState({ hourlyRate: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.hourlyRate === 0) {
	                  _this2.setState({ hourlyRate: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.hourlyRate === '') {
	                  _this2.setState({ hourlyRate: 0, salaryByHour: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '='
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.state.salaryByHour
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '+'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Salary (By Counts)', 'teacherAttendance')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.props.attendanceDetail.attended_count
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'x'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.timeRate,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ timeRate: value, salaryByTime: (value * _this2.props.attendanceDetail.attended_count).toFixed(2) });
	                } else {
	                  _this2.setState({ timeRate: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.timeRate === 0) {
	                  _this2.setState({ timeRate: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.timeRate === '') {
	                  _this2.setState({ timeRate: 0, salaryByTime: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '='
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.state.salaryByTime
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '-'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Late Penalty (By Hours)', 'teacherAttendance')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            (this.props.attendanceDetail.late_hour / 60).toFixed(2),
	            ' h'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'x'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.lateHourlyRate,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ lateHourlyRate: value, lateHourlyTotal: (value * parseFloat((_this2.props.attendanceDetail.late_hour / 60).toFixed(2))).toFixed(2) });
	                } else {
	                  _this2.setState({ lateHourlyRate: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.lateHourlyRate === 0) {
	                  _this2.setState({ lateHourlyRate: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.lateHourlyRate === '') {
	                  _this2.setState({ lateHourlyRate: 0, lateHourlyTotal: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '='
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.state.lateHourlyTotal
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '-'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Late Penalty (By Counts)', 'teacherAttendance')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.props.attendanceDetail.late_count
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'x'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.lateTimeRate,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ lateTimeRate: value, lateTimeTotal: (value * _this2.props.attendanceDetail.late_count).toFixed(2) });
	                } else {
	                  _this2.setState({ lateTimeRate: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.lateTimeRate === 0) {
	                  _this2.setState({ lateTimeRate: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.lateTimeRate === '') {
	                  _this2.setState({ lateTimeRate: 0, lateTimeTotal: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '='
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.state.lateTimeTotal
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '-'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Absent (with excuse) Penalty (By Hours)', 'teacherAttendance')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            (this.props.attendanceDetail.absent_hour / 60).toFixed(2),
	            ' h'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'x'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.absentWithReasonHourlyRate,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ absentWithReasonHourlyRate: value, absentWithReasonHourTotal: (value * parseFloat((_this2.props.attendanceDetail.absent_hour / 60).toFixed(2))).toFixed(2) });
	                } else {
	                  _this2.setState({ absentWithReasonHourlyRate: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.absentWithReasonHourlyRate === 0) {
	                  _this2.setState({ absentWithReasonHourlyRate: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.absentWithReasonHourlyRate === '') {
	                  _this2.setState({ absentWithReasonHourlyRate: 0, absentWithReasonHourTotal: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '='
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.state.absentWithReasonHourTotal
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '-'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Absent (with excuse) Penalty (By Counts)', 'teacherAttendance')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.props.attendanceDetail.absent_count
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'x'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.absentWithReasonTimeRate,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ absentWithReasonTimeRate: value, absentWithReasonTimeTotal: (value * _this2.props.attendanceDetail.absent_count).toFixed(2) });
	                } else {
	                  _this2.setState({ absentWithReasonTimeRate: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.absentWithReasonTimeRate === 0) {
	                  _this2.setState({ absentWithReasonTimeRate: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.absentWithReasonTimeRate === '') {
	                  _this2.setState({ absentWithReasonTimeRate: 0, absentWithReasonTimeTotal: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '='
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.state.absentWithReasonTimeTotal
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '-'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Absent (without notice) Penalty (By Hours)', 'teacherAttendance')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            (this.props.attendanceDetail.truancy_hour / 60).toFixed(2),
	            ' h'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'x'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.absentWithoutReasonHourlyRate,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ absentWithoutReasonHourlyRate: value, absentWithoutReasonHourTotal: (value * parseFloat((_this2.props.attendanceDetail.truancy_hour / 60).toFixed(2))).toFixed(2) });
	                } else {
	                  _this2.setState({ absentWithoutReasonHourlyRate: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.absentWithoutReasonHourlyRate === 0) {
	                  _this2.setState({ absentWithoutReasonHourlyRate: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.absentWithoutReasonHourlyRate === '') {
	                  _this2.setState({ absentWithoutReasonHourlyRate: 0, absentWithoutReasonHourTotal: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '='
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.state.absentWithoutReasonHourTotal
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '-'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Absent (without notice) Penalty (By Counts)', 'teacherAttendance')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.props.attendanceDetail.truancy_count
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'x'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.absentWithoutReasonTimeRate,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ absentWithoutReasonTimeRate: value, absentWithoutReasonTimeTotal: (value * _this2.props.attendanceDetail.truancy_count).toFixed(2) });
	                } else {
	                  _this2.setState({ absentWithoutReasonTimeRate: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.absentWithoutReasonTimeRate === 0) {
	                  _this2.setState({ absentWithoutReasonTimeRate: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.absentWithoutReasonTimeRate === '') {
	                  _this2.setState({ absentWithoutReasonTimeRate: 0, absentWithoutReasonTimeTotal: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '='
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.state.absentWithoutReasonTimeTotal
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '+'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Benefit', 'teacherAttendance')
	          ),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.benefit,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ benefit: value });
	                } else {
	                  _this2.setState({ benefit: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.benefit === 0) {
	                  _this2.setState({ benefit: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.benefit === '') {
	                  _this2.setState({ benefit: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '-'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Tax', 'teacherAttendance')
	          ),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.tax,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '');
	                if (value) {
	                  _this2.setState({ tax: value });
	                } else {
	                  _this2.setState({ tax: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.tax === 0) {
	                  _this2.setState({ tax: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.tax === '') {
	                  _this2.setState({ tax: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '+'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Other Additions', 'teacherAttendance')
	          ),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.otherAddition,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ otherAddition: value });
	                } else {
	                  _this2.setState({ otherAddition: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.otherAddition === 0) {
	                  _this2.setState({ otherAddition: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.otherAddition === '') {
	                  _this2.setState({ otherAddition: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '-'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Other Deductions', 'teacherAttendance')
	          ),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.otherDeduction,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '');
	                if (value) {
	                  _this2.setState({ otherDeduction: value });
	                } else {
	                  _this2.setState({ otherDeduction: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.otherDeduction === 0) {
	                  _this2.setState({ otherDeduction: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.otherDeduction === '') {
	                  _this2.setState({ otherDeduction: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('th', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '='
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'right', width: '100%', paddingRight: 20 } },
	        __('Total Salary:', 'teacherAttendance'),
	        ' ',
	        _react2.default.createElement(
	          'span',
	          { style: { color: '#FCAF3D', fontSize: 18 } },
	          '$',
	          this.renderTotalSalary()
	        )
	      )
	    );
	  };
	
	  return CheckinCalculationTable;
	}(_react.Component);
	
	exports.default = CheckinCalculationTable;
	module.exports = exports['default'];

/***/ },

/***/ "tPf7":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNumberFormat = __webpack_require__("RwBb");
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClockCardCalculationTable = function (_Component) {
	  _inherits(ClockCardCalculationTable, _Component);
	
	  function ClockCardCalculationTable(props) {
	    _classCallCheck(this, ClockCardCalculationTable);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      baseSalary: 0,
	      hourlyRate: 0,
	      salaryByHour: 0,
	      lateHourlyRate: 0,
	      lateHourlyTotal: 0,
	      lateTimeRate: 0,
	      lateTimeTotal: 0,
	      absentHourlyRate: 0,
	      absentHourTotal: 0,
	      absentTimeRate: 0,
	      absentTimeTotal: 0,
	      earlyLeaveHourlyRate: 0,
	      earlyLeaveHourTotal: 0,
	      earlyLeaveTimeRate: 0,
	      earlyLeaveTimeTotal: 0,
	      benefit: 0,
	      tax: 0,
	      otherAddition: 0,
	      otherDeduction: 0,
	      totalSalary: 0
	    };
	    return _this;
	  }
	
	  ClockCardCalculationTable.prototype.renderTotalSalary = function renderTotalSalary() {
	    var total = (parseFloat(this.state.baseSalary) + parseFloat(this.state.salaryByHour) - parseFloat(this.state.lateHourlyTotal) - parseFloat(this.state.lateTimeTotal) - parseFloat(this.state.absentHourTotal) - parseFloat(this.state.absentTimeTotal) - parseFloat(this.state.earlyLeaveHourTotal) - parseFloat(this.state.earlyLeaveTimeTotal) + parseFloat(this.state.benefit) - parseFloat(this.state.tax) + parseFloat(this.state.otherAddition) - parseFloat(this.state.otherDeduction)).toFixed(2);
	    this.props.onFormChange(total);
	    return total;
	  };
	
	  ClockCardCalculationTable.prototype.render = function render() {
	    var _this2 = this;
	
	    var statistics = this.props.statistics;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'table',
	        { style: { width: '100%', textAlign: 'center' } },
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('th', null),
	          _react2.default.createElement(
	            'th',
	            { style: { textAlign: 'center' } },
	            __('Hour/Count', 'teacherAttendance')
	          ),
	          _react2.default.createElement('th', null),
	          _react2.default.createElement(
	            'th',
	            { style: { textAlign: 'center' } },
	            __('Rate', 'teacherAttendance')
	          ),
	          _react2.default.createElement('th', null),
	          _react2.default.createElement(
	            'th',
	            { style: { textAlign: 'center' } },
	            __('Total', 'teacherAttendance')
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Base Salary', 'teacherAttendance')
	          ),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.baseSalary,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ baseSalary: value });
	                } else {
	                  _this2.setState({ baseSalary: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.baseSalary === 0) {
	                  _this2.setState({ baseSalary: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.baseSalary === '') {
	                  _this2.setState({ baseSalary: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '+'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Salary (By Hours)', 'teacherAttendance')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            statistics.work_duration.toFixed(2),
	            ' h'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'x'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.hourlyRate,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ hourlyRate: value, salaryByHour: (value * parseFloat(statistics.work_duration.toFixed(2))).toFixed(2) });
	                } else {
	                  _this2.setState({ hourlyRate: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.hourlyRate === 0) {
	                  _this2.setState({ hourlyRate: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.hourlyRate === '') {
	                  _this2.setState({ hourlyRate: 0, salaryByHour: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '='
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.state.salaryByHour
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '-'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Late Penalty (By Hours)', 'teacherAttendance')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            statistics.late_duration.toFixed(2),
	            ' h'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'x'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.lateHourlyRate,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ lateHourlyRate: value, lateHourlyTotal: (value * parseFloat(statistics.late_duration.toFixed(2))).toFixed(2) });
	                } else {
	                  _this2.setState({ lateHourlyRate: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.lateHourlyRate === 0) {
	                  _this2.setState({ lateHourlyRate: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.lateHourlyRate === '') {
	                  _this2.setState({ lateHourlyRate: 0, lateHourlyTotal: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '='
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.state.lateHourlyTotal
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '-'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Late Penalty (By Counts)', 'teacherAttendance')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            statistics.late_amount
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'x'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.lateTimeRate,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ lateTimeRate: value, lateTimeTotal: (value * statistics.late_amount).toFixed(2) });
	                } else {
	                  _this2.setState({ lateTimeRate: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.lateTimeRate === 0) {
	                  _this2.setState({ lateTimeRate: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.lateTimeRate === '') {
	                  _this2.setState({ lateTimeRate: 0, lateTimeTotal: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '='
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.state.lateTimeTotal
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '-'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Absent Penalty (By Hours)', 'teacherAttendance')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            statistics.absent_duration.toFixed(2),
	            ' h'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'x'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.absentHourlyRate,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ absentHourlyRate: value, absentHourTotal: (value * parseFloat(statistics.absent_duration.toFixed(2))).toFixed(2) });
	                } else {
	                  _this2.setState({ absentHourlyRate: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.absentHourlyRate === 0) {
	                  _this2.setState({ absentHourlyRate: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.absentHourlyRate === '') {
	                  _this2.setState({ absentHourlyRate: 0, absentHourTotal: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '='
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.state.absentHourTotal
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '-'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Absent Penalty (By Counts)', 'teacherAttendance')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            statistics.absent_amount
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'x'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.absentTimeRate,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ absentTimeRate: value, absentTimeTotal: (value * statistics.absent_amount).toFixed(2) });
	                } else {
	                  _this2.setState({ absentTimeRate: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.absentTimeRate === 0) {
	                  _this2.setState({ absentTimeRate: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.absentTimeRate === '') {
	                  _this2.setState({ absentTimeRate: 0, absentTimeTotal: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '='
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.state.absentTimeTotal
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '-'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Leave Early Penalty (By Hours)', 'teacherAttendance')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            statistics.leave_early_duration.toFixed(2),
	            ' h'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'x'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.earlyLeaveHourlyRate,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ earlyLeaveHourlyRate: value, earlyLeaveHourTotal: (value * parseFloat(statistics.leave_early_duration.toFixed(2))).toFixed(2) });
	                } else {
	                  _this2.setState({ earlyLeaveHourlyRate: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.earlyLeaveHourlyRate === 0) {
	                  _this2.setState({ earlyLeaveHourlyRate: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.earlyLeaveHourlyRate === '') {
	                  _this2.setState({ earlyLeaveHourlyRate: 0, earlyLeaveHourTotal: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '='
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.state.earlyLeaveHourTotal
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '-'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Leave Early Penalty (By Counts)', 'teacherAttendance')
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            statistics.leave_early_amount
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'x'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.earlyLeaveTimeRate,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ earlyLeaveTimeRate: value, earlyLeaveTimeTotal: (value * statistics.leave_early_amount).toFixed(2) });
	                } else {
	                  _this2.setState({ earlyLeaveTimeRate: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.earlyLeaveTimeRate === 0) {
	                  _this2.setState({ earlyLeaveTimeRate: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.earlyLeaveTimeRate === '') {
	                  _this2.setState({ earlyLeaveTimeRate: 0, earlyLeaveTimeTotal: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '='
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.state.earlyLeaveTimeTotal
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '+'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Benefit', 'teacherAttendance')
	          ),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.benefit,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ benefit: value });
	                } else {
	                  _this2.setState({ benefit: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.benefit === 0) {
	                  _this2.setState({ benefit: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.benefit === '') {
	                  _this2.setState({ benefit: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '-'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Tax', 'teacherAttendance')
	          ),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.tax,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '');
	                if (value) {
	                  _this2.setState({ tax: value });
	                } else {
	                  _this2.setState({ tax: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.tax === 0) {
	                  _this2.setState({ tax: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.tax === '') {
	                  _this2.setState({ tax: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '+'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Other Additions', 'teacherAttendance')
	          ),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.otherAddition,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '0');
	                if (value) {
	                  _this2.setState({ otherAddition: value });
	                } else {
	                  _this2.setState({ otherAddition: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.otherAddition === 0) {
	                  _this2.setState({ otherAddition: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.otherAddition === '') {
	                  _this2.setState({ otherAddition: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '-'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            __('Other Deductions', 'teacherAttendance')
	          ),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: this.state.otherDeduction,
	              allowNegative: false,
	              onChange: function onChange(event) {
	                var value = event.target.value.replace(/^0+/, '');
	                if (value) {
	                  _this2.setState({ otherDeduction: value });
	                } else {
	                  _this2.setState({ otherDeduction: '' });
	                }
	              },
	              onFocus: function onFocus() {
	                if (_this2.state.otherDeduction === 0) {
	                  _this2.setState({ otherDeduction: '' });
	                }
	              },
	              onBlur: function onBlur() {
	                if (_this2.state.otherDeduction === '') {
	                  _this2.setState({ otherDeduction: 0 });
	                }
	              },
	              required: false,
	              decimalScale: 2,
	              thousandSeparator: false,
	              className: 'number-input'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('th', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            '='
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'right', width: '100%', paddingRight: 20 } },
	        __('Total Salary:', 'teacherAttendance'),
	        ' ',
	        _react2.default.createElement(
	          'span',
	          { style: { color: '#FCAF3D', fontSize: 18 } },
	          '$',
	          this.renderTotalSalary()
	        )
	      )
	    );
	  };
	
	  return ClockCardCalculationTable;
	}(_react.Component);
	
	exports.default = ClockCardCalculationTable;
	module.exports = exports['default'];

/***/ },

/***/ "HJsy":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Salary = __webpack_require__("lkGD");
	
	var _Salary2 = _interopRequireDefault(_Salary);
	
	var _locale = __webpack_require__("oG4h");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("K4l3");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Email
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var SalaryCalculator = function (_Component) {
	  _inherits(SalaryCalculator, _Component);
	
	  function SalaryCalculator() {
	    _classCallCheck(this, SalaryCalculator);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SalaryCalculator.prototype.openSalaryModal = function openSalaryModal() {
	    var _this2 = this;
	
	    (0, _Salary2.default)({ attendanceDetail: this.props.attendance, salaryCalculatorType: this.props.salaryCalculatorType }).then(function (_ref) {
	      var data = _ref.data;
	
	      if (data) {
	        _this2.props.setTotalSalary(data);
	      } else {
	        _this2.props.resetTotalSalary();
	      }
	    }).catch(function (e) {});
	  };
	
	  SalaryCalculator.prototype.render = function render() {
	    var _this3 = this;
	
	    var teacherInfo = this.props.teacherInfo;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'container-fluid' },
	      _react2.default.createElement(
	        'div',
	        { className: 'salary-section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'salary-section-label col-xs-1' },
	            __('Total Salary', _locale2.default),
	            ':'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'salary-section-content col-xs-2' },
	            '$',
	            this.props.attendance.totalSalary === 0 ? '0.00' : this.props.attendance.totalSalary
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'salary-section-tip col-xs-6' },
	            __('The calculated salary will not be saved to our system, please export it after the calculation', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary pull-right salary-btn', disabled: teacherInfo.archived, onClick: function onClick() {
	                return _this3.openSalaryModal();
	              } },
	            __('Calculate Salary', _locale2.default)
	          )
	        )
	      )
	    );
	  };
	
	  return SalaryCalculator;
	}(_react.Component);
	
	exports.default = SalaryCalculator;
	module.exports = exports['default'];

/***/ },

/***/ "oG4h":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'SalaryCalculator',
	  code: 'CN',
	  text: {
	    'Total Salary:': '总工资:',
	    'Total Salary': '当前工资',
	    'The calculated salary will not be saved to our system, please export it after the calculation': '工资计算完成后请及时导出, 系统不会保存计算结果',
	    'Calculate Salary': '计算工资'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "K4l3":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "sfhh":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"teacher-attendance-table-container":"teacher-attendance-table-container","attendance-red":"attendance-red","icon-cancel":"icon-cancel","teacher_attendance-close":"teacher_attendance-close","container-fluid":"container-fluid","attendance-title":"attendance-title","sections":"sections","section-1":"section-1","section-2":"section-2","salary-section":"salary-section","section-label":"section-label","salary-section-label":"salary-section-label","section-content":"section-content","salary-section-content":"salary-section-content","salary-section-tip":"salary-section-tip","section-info-1":"section-info-1","section-info-2":"section-info-2","salary-btn":"salary-btn","vl":"vl","class-time":"class-time","xls-tch-btn":"xls-tch-btn","xls-stu-btn":"xls-stu-btn","dropdown":"dropdown","student-attendance-table-container":"student-attendance-table-container","classtop-table":"classtop-table","classtop-table-container":"classtop-table-container","util-section":"util-section","section-3":"section-3"};

/***/ },

/***/ "GXBW":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("ZsvE");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _ReactTimeline = __webpack_require__("nRKq");
	
	var _ReactTimeline2 = _interopRequireDefault(_ReactTimeline);
	
	var _TimelineForm = __webpack_require__("vRnp");
	
	var _TimelineForm2 = _interopRequireDefault(_TimelineForm);
	
	var _OnBoardingNatural = __webpack_require__("PwUp");
	
	var _OnBoardingNatural2 = _interopRequireDefault(_OnBoardingNatural);
	
	var _constant = __webpack_require__("nvon");
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _SchoolAction = __webpack_require__("4ydO");
	
	var _getStudentTimeline = __webpack_require__("qSKE");
	
	var _getStudentTimelineYear = __webpack_require__("9Dzj");
	
	var _updateTimelineTask2 = __webpack_require__("FMQi");
	
	var _createTimelineTask2 = __webpack_require__("AzMl");
	
	var _deleteTimelineTask2 = __webpack_require__("A7oE");
	
	__webpack_require__("qjB7");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AMOUNT_PER_PAGE_PERLOAD = 10;
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    gSubscription: state.gSubscription,
	    timeline: state.timelineReducer
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchStudentTimeline: function fetchStudentTimeline(studentId, opts, callback) {
	      return dispatch((0, _getStudentTimeline.fetchStudentTimeline)(studentId, opts, callback));
	    },
	    fetchStudentTimelineYear: function fetchStudentTimelineYear(studentId, callback) {
	      return dispatch((0, _getStudentTimelineYear.fetchStudentTimelineYear)(studentId, callback));
	    },
	    createTimelineTask: function createTimelineTask(studentId, taskInfo, callback) {
	      return dispatch((0, _createTimelineTask2.createTimelineTask)(studentId, taskInfo, callback));
	    },
	    updateTimelineTask: function updateTimelineTask(index, taskId, taskInfo, type, callback) {
	      return dispatch((0, _updateTimelineTask2.updateTimelineTask)(index, taskId, taskInfo, type, callback));
	    },
	    deleteTimelineTask: function deleteTimelineTask(index, taskId, callback) {
	      return dispatch((0, _deleteTimelineTask2.deleteTimelineTask)(index, taskId, callback));
	    },
	    resetTimelineCache: function resetTimelineCache() {
	      return dispatch((0, _getStudentTimeline.resetTimelineCache)());
	    },
	    getSubscription: function getSubscription() {
	      return dispatch((0, _SchoolAction.getSubscriptionAction)());
	    }
	  };
	};
	
	var Timeline = function (_Component) {
	  _inherits(Timeline, _Component);
	
	  function Timeline(props) {
	    _classCallCheck(this, Timeline);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      toggledYearMenu: { 1: true },
	
	      showTypeToggles: {
	        recent: true,
	        completed: false,
	        pending: false
	      },
	
	      viewMode: 'timeline',
	      years: [],
	      amount_per_page: {
	        completed: AMOUNT_PER_PAGE_PERLOAD,
	        pending: AMOUNT_PER_PAGE_PERLOAD,
	        recent: AMOUNT_PER_PAGE_PERLOAD,
	        year: AMOUNT_PER_PAGE_PERLOAD
	      }
	    };
	
	    _this.toggleYearmenu = _this.toggleYearmenu.bind(_this);
	    _this.onSubmitAdd = _this.onSubmitAdd.bind(_this);
	    _this.editTask = _this.editTask.bind(_this);
	    _this.cancel = _this.cancel.bind(_this);
	    _this.onSubmitUpdate = _this.onSubmitUpdate.bind(_this);
	    return _this;
	  }
	
	  Timeline.prototype.componentDidMount = function componentDidMount() {
	    var _props = this.props,
	        studentId = _props.studentId,
	        timeline = _props.timeline;
	    var recent = this.state.amount_per_page.recent;
	
	
	    this.props.fetchStudentTimeline(studentId, { amount_per_page: recent, current_page_number: 1, recent: 1 });
	    this.props.fetchStudentTimelineYear(studentId);
	  };
	
	  Timeline.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.props.resetTimelineCache();
	  };
	
	  Timeline.prototype.toggleYearmenu = function toggleYearmenu(toggleYear) {
	    var _this2 = this;
	
	    var studentId = this.props.studentId;
	    var _state$amount_per_pag = this.state.amount_per_page,
	        recent = _state$amount_per_pag.recent,
	        year = _state$amount_per_pag.year;
	
	
	    return function () {
	      if (Object.keys(_this2.state.toggledYearMenu) != toggleYear) {
	        var _toggledYearMenu;
	
	        if (toggleYear == 1) {
	          _this2.props.fetchStudentTimeline(studentId, { amount_per_page: recent, current_page_number: 1, recent: 1 });
	        } else {
	          _this2.props.fetchStudentTimeline(studentId, { amount_per_page: year, current_page_number: 1, year: toggleYear });
	        }
	
	        _this2.setState({
	          toggledYearMenu: (_toggledYearMenu = {}, _toggledYearMenu[toggleYear] = _this2.state.toggledYearMenu[toggleYear] !== true, _toggledYearMenu),
	          showCompleted: false,
	          showUpcoming: false,
	          showRecent: true
	        });
	      }
	    };
	  };
	
	  Timeline.prototype.onSubmitAdd = function onSubmitAdd(toSubmit) {
	    var _this3 = this;
	
	    var _props2 = this.props,
	        createTimelineTask = _props2.createTimelineTask,
	        studentId = _props2.studentId;
	    var recent = this.state.amount_per_page.recent;
	
	
	    createTimelineTask(studentId, toSubmit, function () {
	      _this3.setState({
	        viewMode: "timeline"
	      });
	
	      _this3.props.fetchStudentTimeline(studentId, { amount_per_page: recent, current_page_number: 1, recent: 1 });
	      _this3.props.fetchStudentTimelineYear(studentId);
	    });
	  };
	
	  Timeline.prototype.onSubmitUpdate = function onSubmitUpdate(toSubmit) {
	    var _this4 = this;
	
	    var _props3 = this.props,
	        updateTimelineTask = _props3.updateTimelineTask,
	        studentId = _props3.studentId;
	    var _state = this.state,
	        taskToEditIndex = _state.taskToEditIndex,
	        amount_per_page = _state.amount_per_page;
	    var recent = amount_per_page.recent;
	
	    var id = toSubmit.id;
	
	    delete toSubmit.id;
	
	    updateTimelineTask(taskToEditIndex, id, toSubmit, '', function () {
	      _this4.setState({
	        viewMode: "timeline"
	      });
	
	      _this4.props.fetchStudentTimeline(studentId, { amount_per_page: recent, current_page_number: 1, recent: 1 });
	      _this4.props.fetchStudentTimelineYear(studentId);
	    });
	  };
	
	  Timeline.prototype.editTask = function editTask(task, taskToEditIndex) {
	    var taskToEdit = _extends({}, task);
	
	    if (task.teacher_id_assigned_to && task.teacher_name_assigned_to) {
	      // convert data for the Form to understand
	      taskToEdit.assigned_to = [{
	        id: task.teacher_id_assigned_to,
	        tName: task.teacher_name_assigned_to
	      }];
	    }
	
	    // convert date format for the Form to understand
	    taskToEdit.due_datetime = taskToEdit.due_datetime ? (0, _moment2.default)(taskToEdit.due_datetime).format('YYYY-MM-DD HH:mm') : undefined;
	    taskToEdit.remind_at = taskToEdit.remind_at ? (0, _moment2.default)(taskToEdit.remind_at).format('YYYY-MM-DD HH:mm') : undefined;
	
	    delete taskToEdit.teacher_id_assigned_to;
	    delete taskToEdit.teacher_name_assigned_to;
	
	    this.setState({
	      viewMode: 'edit',
	      taskToEdit: taskToEdit,
	      taskToEditIndex: taskToEditIndex
	    });
	  };
	
	  Timeline.prototype.cancel = function cancel() {
	    this.setState({ viewMode: 'timeline' });
	  };
	
	  Timeline.prototype.render = function render() {
	    var _this5 = this;
	
	    var _state2 = this.state,
	        toggledYearMenu = _state2.toggledYearMenu,
	        showCompleted = _state2.showCompleted,
	        showUpcoming = _state2.showUpcoming,
	        showRecent = _state2.showRecent,
	        viewMode = _state2.viewMode,
	        taskToEdit = _state2.taskToEdit,
	        amount_per_page = _state2.amount_per_page;
	    var _props4 = this.props,
	        studentId = _props4.studentId,
	        timeline = _props4.timeline,
	        gSubscription = _props4.gSubscription,
	        studentInfo = _props4.studentInfo;
	    var list = timeline.list,
	        fetching = timeline.fetching,
	        year_list = timeline.year_list,
	        formWorking = timeline.formWorking,
	        pagination = timeline.pagination;
	    var completed = amount_per_page.completed,
	        pending = amount_per_page.pending,
	        recent = amount_per_page.recent,
	        year = amount_per_page.year;
	
	    var content = _constant.onBoardingContents;
	    var role = localStorage.getItem('role');
	
	    if (!year_list || !pagination) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'timeline-container' },
	        _react2.default.createElement(_Loading2.default, null)
	      );
	    }
	
	    var renderSection = function renderSection(type, title, fetchOpts) {
	      var showThisType = _this5.state.showTypeToggles[type];
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'eventType' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'eventTypeToggle',
	            onClick: function onClick() {
	              var _showTypeToggles;
	
	              var toggle = showThisType !== true;
	
	              _this5.setState({
	                showTypeToggles: (_showTypeToggles = {}, _showTypeToggles[type] = toggle, _showTypeToggles)
	              });
	
	              if (toggle) {
	                _this5.props.fetchStudentTimeline(studentId, _extends({ amount_per_page: amount_per_page[type], current_page_number: 1 }, fetchOpts));
	              }
	            }
	          },
	          title,
	          showThisType === true && _react2.default.createElement('i', { className: 'fa icon-angle-up' }),
	          showThisType !== true && _react2.default.createElement('i', { className: 'fa icon-angle-down' })
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(_ReactTimeline2.default, {
	          type: type,
	          tasks: list,
	          showTimeline: showThisType === true,
	          editTask: _this5.editTask,
	          updateTask: _this5.props.updateTimelineTask,
	          deleteTask: _this5.props.deleteTimelineTask,
	          fetching: fetching
	        }),
	        pagination.totalItemsCount > pagination.itemsCountPerPage && showThisType && _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                _this5.setState({
	                  amount_per_page: _extends({}, _this5.state.amount_per_page, {
	                    recent: recent + 10
	                  })
	                }, function () {
	                  _this5.props.fetchStudentTimeline(studentId, { amount_per_page: amount_per_page[type], current_page_number: 1, recent: 1 });
	                });
	              } },
	            __('Load More', _locale2.default)
	          )
	        )
	      );
	    };
	
	    var showOnBoarding = pagination.totalItemsCount <= 0 && year_list.length <= 1;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'timeline-container' },
	      viewMode === 'add' && _react2.default.createElement(_TimelineForm2.default, {
	        title: __('Create Task', _locale2.default),
	        formData: {},
	        loading: formWorking,
	        onSubmit: this.onSubmitAdd,
	        triggerCancel: this.cancel
	      }),
	      viewMode === 'edit' && _react2.default.createElement(_TimelineForm2.default, {
	        title: __('Edit Task', _locale2.default),
	        formData: taskToEdit,
	        loading: formWorking,
	        onSubmit: this.onSubmitUpdate,
	        triggerCancel: this.cancel
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('timeline', { 'active': viewMode == 'timeline' }) },
	        _react2.default.createElement(
	          _R2.default,
	          { can: 'create_student_task', by: 'disable' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary add-event pull-right', disabled: studentInfo.state === 2, onClick: function onClick() {
	                _this5.setState({
	                  viewMode: 'add'
	                });
	              } },
	            __('Add Task', _locale2.default)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'timeline-title' },
	          __('Planning', _locale2.default)
	        ),
	        showOnBoarding && _react2.default.createElement(_OnBoardingNatural2.default, {
	          isShown: true,
	          title: content.title,
	          text: content.text,
	          image: content.image,
	          showArrow: content.showArrow
	        }),
	        showOnBoarding !== true && _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-1', style: { marginTop: '32px', paddingRight: '0px' } },
	            _react2.default.createElement(
	              'ul',
	              null,
	              year_list.map(function (year, key) {
	                return _react2.default.createElement(
	                  'li',
	                  {
	                    key: key,
	                    className: (0, _classnames2.default)('event-year', { "active": toggledYearMenu[year] == true }),
	                    onClick: _this5.toggleYearmenu(year) },
	                  year == 1 ? __('Recent', _locale2.default) : year
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-10', style: { paddingLeft: '0px' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'eventColumn' },
	              renderSection('completed', __('Completed', _locale2.default), { state: 1 }),
	              renderSection('pending', __('Pending', _locale2.default), { state: 0 }),
	              renderSection('recent', Object.keys(toggledYearMenu) == 1 ? __('Recent', _locale2.default) : Object.keys(toggledYearMenu), { recent: 1 })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Timeline;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Timeline);
	module.exports = exports['default'];

/***/ },

/***/ "ZsvE":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'Timeline',
	  code: 'CN',
	  text: {
	    "Title": "标题",
	    "Due": "完成日期",
	    "Remind At": "提醒日期",
	    "Assign To": "分配给",
	    "Note": "描述",
	    "Also remind parents and students (If don't check, will only remind teacher)": "是否需要提醒家长以及学生（如果不勾选则只提醒分配老师）",
	    "Save": "保存",
	    "Cancel": "取消",
	
	    "Create Task": "创建事项",
	    "Edit Task": "编辑事项",
	    'Add Task': '新增事项',
	    'Completed': '已完成',
	    'Pending': '未完成',
	    'Recent': '近期事项',
	    'Load More': '载入更多',
	
	    'Planning': '时间规划'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "nRKq":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactEventTimeline = __webpack_require__("kCet");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _locale = __webpack_require__("gL8n");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("XscE");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTimeline = function (_Component) {
	  _inherits(ReactTimeline, _Component);
	
	  function ReactTimeline(props) {
	    _classCallCheck(this, ReactTimeline);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      showDetail: {}
	    };
	
	    _this.updateTask = _this.updateTask.bind(_this);
	    return _this;
	  }
	
	  ReactTimeline.prototype.updateTask = function updateTask(key, task, type) {
	    var _this2 = this;
	
	    return function (e) {
	      e.stopPropagation();
	
	      if (task.state == 0) {
	
	        var newTask = _extends({}, task, {
	          state: 1,
	          due_datetime: task.due_datetime ? (0, _moment2.default)(task.due_datetime).format('YYYY-MM-DD HH:mm') : undefined,
	          remind_at: task.remind_at ? (0, _moment2.default)(task.remind_at).format('YYYY-MM-DD HH:mm') : undefined
	        });
	
	        delete newTask.teacher_id_assigned_to;
	        delete newTask.teacher_name_assigned_to;
	        delete newTask.id;
	
	        _this2.props.updateTask(key, task.id, newTask, type);
	      } else if (task.state == 1) {
	
	        var _newTask = _extends({}, task, {
	          state: 0,
	          due_datetime: task.due_datetime ? (0, _moment2.default)(task.due_datetime).format('YYYY-MM-DD HH:mm') : undefined,
	          remind_at: task.remind_at ? (0, _moment2.default)(task.remind_at).format('YYYY-MM-DD HH:mm') : undefined
	        });
	
	        delete _newTask.teacher_id_assigned_to;
	        delete _newTask.teacher_name_assigned_to;
	        delete _newTask.id;
	
	        _this2.props.updateTask(key, task.id, _newTask, type);
	      }
	    };
	  };
	
	  ReactTimeline.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        tasks = _props.tasks,
	        showTimeline = _props.showTimeline,
	        type = _props.type,
	        editTask = _props.editTask,
	        deleteTask = _props.deleteTask,
	        fetching = _props.fetching;
	    var showDetail = this.state.showDetail;
	
	
	    if (showTimeline == false) {
	      return _react2.default.createElement('div', null);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('react-timeline-container', { fetching: fetching }) },
	      fetching && _react2.default.createElement(_Loading2.default, null),
	      _react2.default.createElement(
	        _reactEventTimeline.Timeline,
	        { className: 'Timeline', lineColor: '#EBEBED', lineStyle: { width: 1 } },
	        tasks.map(function (task, key) {
	          return _react2.default.createElement(
	            'div',
	            { key: key },
	            _react2.default.createElement(
	              _reactEventTimeline.TimelineEvent,
	              {
	                className: 'timeline-event-container',
	                title: '',
	                contentStyle: { boxShadow: 'none', padding: '0px' },
	                bubbleStyle: { background: 'none', color: 'white', fontSize: '15px', border: 'none' },
	                titleStyle: { color: '#11151E', fontSize: '20px', fontWeight: '600' },
	                createdAt: _react2.default.createElement(
	                  'div',
	                  { className: 'createdAt' },
	                  (0, _moment2.default)(task.due_datetime).format('YYYY-MM-DD')
	                ),
	                icon: _react2.default.createElement('img', { className: 'school-success-icon', src: task.state == 1 ? __webpack_require__("dVIu") : __webpack_require__("rjhU") })
	              },
	              showDetail[task.id] !== true && _react2.default.createElement(
	                'div',
	                { className: 'task-container' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 short-task', onClick: function onClick() {
	                      var _extends2;
	
	                      _this3.setState({ showDetail: _extends({}, _this3.state.showDetail, (_extends2 = {}, _extends2[task.id] = true, _extends2)) });
	                    } },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'timeline-title' },
	                    task.title
	                  ),
	                  _react2.default.createElement('i', { className: 'fa icon-angle-down pull-right' })
	                )
	              ),
	              showDetail[task.id] && _react2.default.createElement(
	                'div',
	                { className: 'task-container detail-task', onClick: function onClick() {
	                    var _extends3;
	
	                    _this3.setState({ showDetail: _extends({}, _this3.state.showDetail, (_extends3 = {}, _extends3[task.id] = false, _extends3)) });
	                  } },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'timeline-title' },
	                  task.title
	                ),
	                _react2.default.createElement('i', { className: 'fa icon-angle-up pull-right' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'event-date-info' },
	                  task.teacher_name_assigned_to && _react2.default.createElement(
	                    'span',
	                    { style: { marginRight: '50px' } },
	                    __('Person In Charge: {name}', _locale2.default, { name: task.teacher_name_assigned_to })
	                  ),
	                  task.remind_at && _react2.default.createElement(
	                    'span',
	                    null,
	                    __('Reminder Time: {time}', _locale2.default, { time: (0, _moment2.default)(task.remind_at).format('YYYY-MM-DD HH:mm') })
	                  )
	                ),
	                task.note && _react2.default.createElement(
	                  'div',
	                  { className: 'timeline-content' },
	                  task.note
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'btn-container' },
	                    task.state == 1 && _react2.default.createElement(
	                      _R2.default,
	                      { can: 'complete_student_task', by: 'disable' },
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-default btn-sm', onClick: _this3.updateTask(key, task, type) },
	                        __('Completed', _locale2.default)
	                      )
	                    ),
	                    task.state == 0 && _react2.default.createElement(
	                      _R2.default,
	                      { can: 'complete_student_task', by: 'disable' },
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-primary btn-sm', onClick: _this3.updateTask(key, task, type) },
	                        __('Complete', _locale2.default)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _R2.default,
	                      { can: 'edit_student_task', by: 'disable' },
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'btn-link edit-event', onClick: function onClick(e) {
	                            e.stopPropagation();
	                            editTask(task, key);
	                          } },
	                        __('Edit', _locale2.default)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _R2.default,
	                      { can: 'delete_student_task', by: 'disable' },
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'btn-link delete-event', onClick: function onClick(e) {
	                            e.stopPropagation();
	                            (0, _confirm.confirm)(__('Proceed to delete task?', _locale2.default)).then(function () {
	                              deleteTask(key, task.id);
	                            }).catch(function () {});
	                          } },
	                        __('Delete', _locale2.default)
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return ReactTimeline;
	}(_react.Component);
	
	exports.default = ReactTimeline;
	module.exports = exports['default'];

/***/ },

/***/ "gL8n":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'ReactTimeLine',
	  code: 'CN',
	  text: {
	    'Complete': '确认完成',
	    'Completed': '已完成',
	    'Edit': '编辑',
	    'Delete': '删除',
	    'Person In Charge: {name}': '负责老师：{name}',
	    'Reminder Time: {time}': '提醒时间：{time}',
	    'Proceed to delete task?': '确认删除事项',
	    '': ''
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "XscE":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-timeline-container":"react-timeline-container","fetching":"fetching","Timeline":"Timeline","timeline-event-container":"timeline-event-container","task-container":"task-container","detail-task":"detail-task","timeline-title":"timeline-title","createdAt":"createdAt","timeline-content":"timeline-content","btn-container":"btn-container","btn":"btn","edit-event":"edit-event","delete-event":"delete-event","event-date-info":"event-date-info","person-charge":"person-charge","short-task":"short-task","icon-angle-down":"icon-angle-down","icon-angle-right":"icon-angle-right","icon-angle-up":"icon-angle-up"};

/***/ },

/***/ "dVIu":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Group@2x.896cf366.png";

/***/ },

/***/ "rjhU":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "grey@2x.0308cec7.png";

/***/ },

/***/ "vRnp":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _locale = __webpack_require__("ZsvE");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("Va3t");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <TimelineForm />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var TimelineForm = function (_React$Component) {
	  _inherits(TimelineForm, _React$Component);
	
	  function TimelineForm(props) {
	    _classCallCheck(this, TimelineForm);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.save = _this.save.bind(_this);
	
	    _this.state = {
	      formData: props.formData || {}
	    };
	    return _this;
	  }
	
	  TimelineForm.prototype.componentWillMount = function componentWillMount() {};
	
	  TimelineForm.prototype.onChange = function onChange(formData) {
	    this.setState({
	      formData: _extends({}, this.state.formData, formData)
	    });
	  };
	
	  TimelineForm.prototype.save = function save() {
	    var result = this.validate();
	
	    if (result.ok) {
	      this.submit();
	    }
	  };
	
	  TimelineForm.prototype.submit = function submit() {
	    var toSubmit = _extends({}, this.state.formData);
	
	    if (Array.isArray(toSubmit.assigned_to) && toSubmit.assigned_to.length > 0) {
	      toSubmit.assigned_to = toSubmit.assigned_to[0].id;
	    }
	
	    this.props.onSubmit(toSubmit);
	  };
	
	  TimelineForm.prototype.render = function render() {
	    var _this2 = this;
	
	    var formData = this.state.formData;
	    var _props = this.props,
	        loading = _props.loading,
	        title = _props.title;
	
	
	    var schema = [{
	      name: 'title',
	      label: __('Title', _locale2.default),
	      type: 'text',
	      required: true
	    }, {
	      label: __('Due', _locale2.default),
	      name: 'due_datetime',
	      type: 'dateTime',
	      required: true
	    }, {
	      label: __('Remind At', _locale2.default),
	      name: 'remind_at',
	      type: 'dateTime'
	    }, {
	      label: __('Assign To', _locale2.default),
	      name: 'assigned_to',
	      type: 'selectTeacher'
	    }, {
	      label: __('Note', _locale2.default),
	      name: 'note',
	      type: 'textarea'
	    }, {
	      name: 'remind_both',
	      type: 'checkbox',
	      placeholder: __('Also remind parents and students (If don\'t check, will only remind teacher)', _locale2.default),
	      inputTransform: function inputTransform(data) {
	        return data === 1;
	      },
	      outputTransform: function outputTransform(data) {
	        return data ? 1 : 0;
	      }
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'TimelineForm' },
	      _react2.default.createElement(_Form2.default, {
	        title: title,
	        loading: loading,
	        onChange: this.onChange,
	        schema: schema,
	        formData: formData,
	        formStyle: 'inline',
	        getValidationRef: function getValidationRef(fn) {
	          _this2.validate = fn;
	        }
	      }),
	      loading !== true && _react2.default.createElement(
	        'section',
	        { className: 'btnSection' },
	        _react2.default.createElement(
	          'a',
	          { className: 'btn btn-primary', onClick: this.save },
	          __('Save', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'btn btn-default', onClick: this.props.triggerCancel },
	          __('Cancel', _locale2.default)
	        )
	      )
	    );
	  };
	
	  return TimelineForm;
	}(_react2.default.Component);
	
	exports.default = TimelineForm;
	module.exports = exports['default'];

/***/ },

/***/ "Va3t":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"TimelineForm":"TimelineForm","form-type-checkbox":"form-type-checkbox","col-sm-10":"col-sm-10","btnSection":"btnSection"};

/***/ },

/***/ "PwUp":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("9U4k");
	
	var _arrow2x = __webpack_require__("6bID");
	
	var _arrow2x2 = _interopRequireDefault(_arrow2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <StudentOnBoarding />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	//
	
	
	var StudentOnBoarding = function (_React$Component) {
	  _inherits(StudentOnBoarding, _React$Component);
	
	  function StudentOnBoarding(props) {
	    _classCallCheck(this, StudentOnBoarding);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  StudentOnBoarding.prototype.componentWillMount = function componentWillMount() {};
	
	  StudentOnBoarding.prototype.render = function render() {
	    var _props = this.props,
	        title = _props.title,
	        text = _props.text,
	        image = _props.image,
	        showArrow = _props.showArrow;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'on-boarding' },
	      this.props.children,
	      _react2.default.createElement(
	        'div',
	        { className: 'on-boarding-text' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          text
	        )
	      ),
	      _react2.default.createElement('img', { src: image }),
	      showArrow && _react2.default.createElement('img', { className: 'arrow-img', src: _arrow2x2.default })
	    );
	  };
	
	  return StudentOnBoarding;
	}(_react2.default.Component);
	
	exports.default = StudentOnBoarding;
	module.exports = exports['default'];

/***/ },

/***/ "9U4k":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"on-boarding":"on-boarding","on-boarding-text":"on-boarding-text","arrow-img":"arrow-img"};

/***/ },

/***/ "6bID":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "arrow@2x.6a40e6b2.png";

/***/ },

/***/ "nvon":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var locale = {
	  id: 'TimelineConstant',
	  code: 'CN',
	  text: {
	    "./images/timeline-onboarding-eng@2x.png": "./images/timeline-onboarding-cn@2x.png",
	    'Planning': '时间规划',
	    'Here you can set up a plan detailing any future plan for your students. ClassTopBase will remind the student, appointed teachers, and their parents to complete the task as planned.': '您可以在这为学生建立未来学业的规划安排，ClassTopBase 会提醒您以及学生、家长按照计划完成教学。'
	  }
	};
	
	var onBoardingContents = exports.onBoardingContents = {
	  title: __('Planning', locale),
	  text: __('Here you can set up a plan detailing any future plan for your students. ClassTopBase will remind the student, appointed teachers, and their parents to complete the task as planned.', locale),
	  image: __webpack_require__(4)(__('./images/timeline-onboarding-eng@2x.png', locale)),
	  showArrow: true
	};

/***/ },

/***/ 4:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./Timeline.scss": "qjB7",
		"./TimelineForm": "vRnp",
		"./TimelineForm.js": "vRnp",
		"./TimelineForm.scss": "Va3t",
		"./constant": "nvon",
		"./constant.js": "nvon",
		"./images/timeline-onboarding-cn@2x.png": "7GlU",
		"./images/timeline-onboarding-eng@2x.png": "4c4i",
		"./index": "GXBW",
		"./index.js": "GXBW",
		"./locale": "ZsvE",
		"./locale.js": "ZsvE",
		"./redux/actions/createTimelineTask": "AzMl",
		"./redux/actions/createTimelineTask.js": "AzMl",
		"./redux/actions/deleteTimelineTask": "A7oE",
		"./redux/actions/deleteTimelineTask.js": "A7oE",
		"./redux/actions/getStudentTimeline": "qSKE",
		"./redux/actions/getStudentTimeline.js": "qSKE",
		"./redux/actions/getStudentTimelineYear": "9Dzj",
		"./redux/actions/getStudentTimelineYear.js": "9Dzj",
		"./redux/actions/updateTimelineTask": "FMQi",
		"./redux/actions/updateTimelineTask.js": "FMQi",
		"./redux/reducer": "7bRE",
		"./redux/reducer.js": "7bRE"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 4;


/***/ },

/***/ "qjB7":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"timeline-container":"timeline-container","col-xs-2":"col-xs-2","col-xs-10":"col-xs-10","timeline":"timeline","active":"active","add-event":"add-event","event-year":"event-year","eventTypeToggle":"eventTypeToggle","icon-angle-right":"icon-angle-right","icon-angle-down":"icon-angle-down","eventColumn":"eventColumn","timeline-title":"timeline-title","on-boarding":"on-boarding","col-sm-2":"col-sm-2","col-sm-10":"col-sm-10","col-xs-1":"col-xs-1"};

/***/ },

/***/ "7GlU":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "timeline-onboarding-cn@2x.cd9d2f12.png";

/***/ },

/***/ "4c4i":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "timeline-onboarding-eng@2x.12d05c19.png";

/***/ },

/***/ "AzMl":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_CREATE_TIMELINE_TASK = exports.SUCCESS_CREATE_TIMELINE_TASK = exports.START_CREATE_TIMELINE_TASK = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Import controller
	
	
	exports.createTimelineTask = createTimelineTask;
	
	var _addTimelineTask = __webpack_require__("nVM+");
	
	var _addTimelineTask2 = _interopRequireDefault(_addTimelineTask);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	var START_CREATE_TIMELINE_TASK = exports.START_CREATE_TIMELINE_TASK = 'START_CREATE_TIMELINE_TASK';
	var SUCCESS_CREATE_TIMELINE_TASK = exports.SUCCESS_CREATE_TIMELINE_TASK = 'SUCCESS_CREATE_TIMELINE_TASK';
	var FAILED_CREATE_TIMELINE_TASK = exports.FAILED_CREATE_TIMELINE_TASK = 'FAILED_CREATE_TIMELINE_TASK';
	
	// Action Creator
	function createTimelineTask(studentId, taskInfo, callback) {
	  return function (dispatch) {
	
	    dispatch({
	      type: START_CREATE_TIMELINE_TASK,
	      payload: {
	        formWorking: true,
	        studentId: studentId,
	        taskInfo: taskInfo
	      }
	    });
	
	    (0, _addTimelineTask2.default)(studentId, taskInfo).then(function (result) {
	      dispatch({
	        type: SUCCESS_CREATE_TIMELINE_TASK,
	        payload: _extends({}, result, {
	          formWorking: false
	        })
	      });
	
	      if (typeof callback == 'function') {
	        callback();
	      }
	    }).catch(function (err) {
	
	      dispatch({
	        type: FAILED_CREATE_TIMELINE_TASK,
	        payload: err
	      });
	    });
	  };
	}

/***/ },

/***/ "nVM+":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = addTimelineTask;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  title: _joiBrowser2.default.string().required(),
	  note: _joiBrowser2.default.string(),
	  due_datetime: _joiBrowser2.default.string().required(),
	  assigned_to: _joiBrowser2.default.number().integer().allow(''),
	  remind_at: _joiBrowser2.default.string().allow(''),
	  remind_both: _joiBrowser2.default.number().integer().allow('')
	});
	
	function addTimelineTask(studentId, taskInfo) {
	
	  if (!studentId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing student ID')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(taskInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/student_task_list/" + studentId + "/",
	      'method': 'POST',
	      'data': JSON.stringify(taskInfo),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "A7oE":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SUCCESS_DELETE_TIMELINE_TASK = exports.START_DELETE_TIMELINE_TASK = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Import controller
	
	
	exports.deleteTimelineTask = deleteTimelineTask;
	
	var _deleteTimelineTask = __webpack_require__("kHkL");
	
	var _deleteTimelineTask2 = _interopRequireDefault(_deleteTimelineTask);
	
	var _alert = __webpack_require__("BGi1");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import {fetchAnnouncementList} from './getAnnouncementList'
	// Actions
	var START_DELETE_TIMELINE_TASK = exports.START_DELETE_TIMELINE_TASK = 'START_DELETE_TIMELINE_TASK';
	var SUCCESS_DELETE_TIMELINE_TASK = exports.SUCCESS_DELETE_TIMELINE_TASK = 'SUCCESS_DELETE_TIMELINE_TASK';
	
	// Action Creator
	function deleteTimelineTask(index, taskId, callback) {
	  return function (dispatch) {
	
	    dispatch({
	      type: START_DELETE_TIMELINE_TASK,
	      payload: {
	        deleting: true,
	        index: index
	      }
	    });
	
	    (0, _deleteTimelineTask2.default)(taskId).then(function (result) {
	      dispatch({
	        type: SUCCESS_DELETE_TIMELINE_TASK,
	        payload: _extends({}, result, { deleting: false })
	      });
	
	      if (typeof callback == 'function') {
	        callback();
	      }
	    }).catch(function (err) {
	      _alert.alert.warning("API CALL FAILED: Net error").then(function () {
	        window.location.reload();
	      });
	    });
	  };
	}

/***/ },

/***/ "kHkL":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = deleteTimelineTask;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deleteTimelineTask(taskId) {
	
	  if (!taskId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing task ID')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/student_task_detail/" + taskId + "/",
	      'method': 'DELETE',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "qSKE":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.RESET_TIMELINE_CACHE = exports.FAILED_FETCH_STUDENT_TIMELINE = exports.SUCCESS_FETCH_STUDENT_TIMELINE = exports.START_FETCH_STUDENT_TIMELINE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Import controller
	
	
	exports.fetchStudentTimeline = fetchStudentTimeline;
	exports.resetTimelineCache = resetTimelineCache;
	
	var _getStudentTimeline = __webpack_require__("8CKx");
	
	var _getStudentTimeline2 = _interopRequireDefault(_getStudentTimeline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	var START_FETCH_STUDENT_TIMELINE = exports.START_FETCH_STUDENT_TIMELINE = 'START_FETCH_STUDENT_TIMELINE';
	var SUCCESS_FETCH_STUDENT_TIMELINE = exports.SUCCESS_FETCH_STUDENT_TIMELINE = 'SUCCESS_FETCH_STUDENT_TIMELINE';
	var FAILED_FETCH_STUDENT_TIMELINE = exports.FAILED_FETCH_STUDENT_TIMELINE = 'FAILED_FETCH_STUDENT_TIMELINE';
	
	var RESET_TIMELINE_CACHE = exports.RESET_TIMELINE_CACHE = 'RESET_TIMELINE_CACHE';
	
	// Action Creator
	
	function fetchStudentTimeline(studentId, opts, callback) {
	  return function (dispatch) {
	
	    dispatch({
	      type: START_FETCH_STUDENT_TIMELINE,
	      payload: { fetching: true }
	    });
	
	    (0, _getStudentTimeline2.default)(studentId, opts).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_STUDENT_TIMELINE,
	        payload: _extends({}, result, { fetching: false })
	      });
	
	      if (typeof callback == 'function') {
	        callback();
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_STUDENT_TIMELINE,
	        payload: err
	      });
	    });
	  };
	}
	
	function resetTimelineCache() {
	  return function (dispatch) {
	    dispatch({
	      type: RESET_TIMELINE_CACHE
	    });
	  };
	}

/***/ },

/***/ "8CKx":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getStudentTimeline;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStudentTimeline(studentId, opts) {
	
	  if (!studentId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing student ID')
	      });
	    });
	  }
	
	  var query = _queryString2.default.stringify({
	    amount_per_page: opts.amount_per_page,
	    current_page_number: opts.current_page_number,
	    state: opts.state,
	    year: opts.year,
	    recent: opts.recent
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, {
	      'uri': "/student_task_list/" + studentId + "/?" + query,
	      'method': 'GET',
	      'token': localStorage.getItem('token')
	    }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "9Dzj":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_FETCH_STUDENT_TIMELINE_YEAR = exports.SUCCESS_FETCH_STUDENT_TIMELINE_YEAR = exports.START_FETCH_STUDENT_TIMELINE_YEAR = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Import controller
	
	
	exports.fetchStudentTimelineYear = fetchStudentTimelineYear;
	
	var _getStudentTimelineYear = __webpack_require__("REAb");
	
	var _getStudentTimelineYear2 = _interopRequireDefault(_getStudentTimelineYear);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	var START_FETCH_STUDENT_TIMELINE_YEAR = exports.START_FETCH_STUDENT_TIMELINE_YEAR = 'START_FETCH_STUDENT_TIMELINE_YEAR';
	var SUCCESS_FETCH_STUDENT_TIMELINE_YEAR = exports.SUCCESS_FETCH_STUDENT_TIMELINE_YEAR = 'SUCCESS_FETCH_STUDENT_TIMELINE_YEAR';
	var FAILED_FETCH_STUDENT_TIMELINE_YEAR = exports.FAILED_FETCH_STUDENT_TIMELINE_YEAR = 'FAILED_FETCH_STUDENT_TIMELINE_YEAR';
	
	// Action Creator
	
	function fetchStudentTimelineYear(studentId, callback) {
	  return function (dispatch) {
	
	    dispatch({
	      type: START_FETCH_STUDENT_TIMELINE_YEAR,
	      payload: { fetching: true }
	    });
	
	    (0, _getStudentTimelineYear2.default)(studentId).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_STUDENT_TIMELINE_YEAR,
	        payload: _extends({}, result, { fetching: false })
	      });
	
	      if (typeof callback == 'function') {
	        callback();
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_STUDENT_TIMELINE_YEAR,
	        payload: err
	      });
	    });
	  };
	}

/***/ },

/***/ "REAb":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getStudentTimelineYear;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStudentTimelineYear(studentId) {
	
	  if (!studentId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing student ID')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, {
	      'uri': "/student_task_years/" + studentId,
	      'method': 'GET',
	      'token': localStorage.getItem('token')
	    }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "FMQi":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_UPDATE_TIMELINE_TASK = exports.SUCCESS_UPDATE_TIMELINE_TASK = exports.START_UPDATE_TIMELINE_TASK = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Import controller
	
	
	exports.updateTimelineTask = updateTimelineTask;
	
	var _updateTimelineTask = __webpack_require__("yrw7");
	
	var _updateTimelineTask2 = _interopRequireDefault(_updateTimelineTask);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	var START_UPDATE_TIMELINE_TASK = exports.START_UPDATE_TIMELINE_TASK = 'START_UPDATE_TIMELINE_TASK';
	var SUCCESS_UPDATE_TIMELINE_TASK = exports.SUCCESS_UPDATE_TIMELINE_TASK = 'SUCCESS_UPDATE_TIMELINE_TASK';
	var FAILED_UPDATE_TIMELINE_TASK = exports.FAILED_UPDATE_TIMELINE_TASK = 'FAILED_UPDATE_TIMELINE_TASK';
	
	// Action Creator
	function updateTimelineTask(index, taskId, taskInfo, type, callback) {
	  return function (dispatch) {
	
	    dispatch({
	      type: START_UPDATE_TIMELINE_TASK,
	      payload: { formWorking: true, index: index, taskInfo: taskInfo, type: type }
	    });
	
	    (0, _updateTimelineTask2.default)(taskId, taskInfo).then(function (result) {
	      dispatch({
	        type: SUCCESS_UPDATE_TIMELINE_TASK,
	        payload: _extends({}, result, { formWorking: false })
	      });
	
	      if (typeof callback == 'function') {
	        callback();
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_UPDATE_TIMELINE_TASK,
	        payload: {
	          formWorking: formWorking,
	          err: err
	        }
	      });
	    });
	  };
	}

/***/ },

/***/ "yrw7":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = updateTimelineTask;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  title: _joiBrowser2.default.string().allow(''),
	  note: _joiBrowser2.default.string().allow(''),
	  due_datetime: _joiBrowser2.default.string().allow(''),
	  assigned_to: _joiBrowser2.default.number().integer().allow(''),
	  remind_at: _joiBrowser2.default.string().allow(''),
	  remind_both: _joiBrowser2.default.number().integer().allow(''),
	  state: _joiBrowser2.default.number().integer().allow('')
	});
	
	function updateTimelineTask(taskId, taskInfo) {
	
	  if (!taskId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing task ID')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(taskInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/student_task_detail/" + taskId + "/",
	      'method': 'PUT',
	      'data': JSON.stringify(taskInfo),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "7bRE":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // importing actions
	
	
	exports.default = timelineReducer;
	
	var _getStudentTimeline = __webpack_require__("qSKE");
	
	var _createTimelineTask = __webpack_require__("AzMl");
	
	var _updateTimelineTask = __webpack_require__("FMQi");
	
	var _deleteTimelineTask = __webpack_require__("A7oE");
	
	var _getStudentTimelineYear = __webpack_require__("9Dzj");
	
	var _locale = __webpack_require__("ZsvE");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initState = {
	  list: [],
	  fetching: false
	
	};
	
	function timelineReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	
	    // fetching timeline
	    case _getStudentTimeline.START_FETCH_STUDENT_TIMELINE:
	      {
	        return _extends({}, state, { fetching: true });
	      }
	    case _getStudentTimeline.SUCCESS_FETCH_STUDENT_TIMELINE:
	      {
	        return _extends({}, state, {
	          fetching: action.payload.fetching,
	          list: action.payload.result_list,
	          pagination: {
	            itemsCountPerPage: action.payload.amount_per_page,
	            activePage: action.payload.current_page_number,
	            totalItemsCount: action.payload.total_task_amount
	          }
	        });
	      }
	
	    case _getStudentTimeline.FAILED_FETCH_STUDENT_TIMELINE:
	      {
	        return _extends({}, state, { err: action.payload });
	      }
	
	    // fetching timeline year
	    case _getStudentTimeline.RESET_TIMELINE_CACHE:
	      {
	        return _extends({}, initState);
	      }
	    case _getStudentTimelineYear.START_FETCH_STUDENT_TIMELINE_YEAR:
	      {
	        return _extends({}, state, { fetching: true });
	      }
	    case _getStudentTimelineYear.SUCCESS_FETCH_STUDENT_TIMELINE_YEAR:
	      {
	        var years = action.payload.years.unshift(1);
	        return _extends({}, state, {
	          year_list: action.payload.years
	        });
	      }
	
	    case _getStudentTimelineYear.FAILED_FETCH_STUDENT_TIMELINE_YEAR:
	      {
	        return _extends({}, state, { err: action.payload });
	      }
	
	    // formWorking
	    case _createTimelineTask.START_CREATE_TIMELINE_TASK:
	      {
	        var formWorking = action.payload.formWorking;
	
	
	        return _extends({}, state, {
	          formWorking: formWorking
	        });
	      }
	
	    case _createTimelineTask.SUCCESS_CREATE_TIMELINE_TASK:
	      {
	        var _formWorking = action.payload.formWorking;
	
	
	        return _extends({}, state, {
	          formWorking: _formWorking
	        });
	      }
	
	    case _createTimelineTask.FAILED_CREATE_TIMELINE_TASK:
	      {
	        var err = action.payload.err;
	
	
	        return _extends({}, state);
	      }
	
	    // updating
	    case _updateTimelineTask.START_UPDATE_TIMELINE_TASK:
	      {
	        var _action$payload = action.payload,
	            index = _action$payload.index,
	            _formWorking2 = _action$payload.formWorking,
	            taskInfo = _action$payload.taskInfo,
	            type = _action$payload.type;
	
	
	        var list = state.list.map(function (existing, i) {
	          return index === i ? _extends({}, existing, taskInfo) : existing;
	        });
	
	        if (type == 'pending' || type == 'completed') {
	          return _extends({}, state, {
	            list: [].concat(state.list.slice(0, index), state.list.slice(index + 1))
	          });
	        } else {
	          return _extends({}, state, {
	            formWorking: _formWorking2,
	            list: list
	          });
	        }
	      }
	
	    case _updateTimelineTask.SUCCESS_UPDATE_TIMELINE_TASK:
	      {
	        var _formWorking3 = action.payload.formWorking;
	
	
	        return _extends({}, state, {
	          formWorking: _formWorking3
	        });
	      }
	
	    case _updateTimelineTask.FAILED_UPDATE_TIMELINE_TASK:
	      {
	        var _formWorking4 = action.payload.formWorking;
	
	
	        return _extends({}, state, {
	          formWorking: _formWorking4
	        });
	      }
	
	    // deleting
	    case _deleteTimelineTask.START_DELETE_TIMELINE_TASK:
	      {
	        var _index = action.payload.index;
	
	
	        return _extends({}, state, {
	          list: [].concat(state.list.slice(0, _index), state.list.slice(_index + 1))
	        });
	      }
	
	    default:
	      return _extends({}, state);
	  }
	}
	module.exports = exports['default'];

/***/ },

/***/ "4ydO":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schoolLoginRequestOut = schoolLoginRequestOut;
	exports.schoolLoginOk = schoolLoginOk;
	exports.schoolLoginFailed = schoolLoginFailed;
	exports.schoolLoginAction = schoolLoginAction;
	exports.schoolSignupRequestOut = schoolSignupRequestOut;
	exports.schoolSignupOk = schoolSignupOk;
	exports.schoolSignupFailed = schoolSignupFailed;
	exports.schoolSignupAction = schoolSignupAction;
	exports.schoolRegisterRequestOut = schoolRegisterRequestOut;
	exports.schoolRegisterRequestOk = schoolRegisterRequestOk;
	exports.schoolRegisterRequestFailed = schoolRegisterRequestFailed;
	exports.schoolRegisterAction = schoolRegisterAction;
	exports.getSchoolClassListRequestOut = getSchoolClassListRequestOut;
	exports.getSchoolClassListOk = getSchoolClassListOk;
	exports.getSchoolClassListFailed = getSchoolClassListFailed;
	exports.getSchoolClassListAction = getSchoolClassListAction;
	exports.getSchoolTeacherListRequestOut = getSchoolTeacherListRequestOut;
	exports.getSchoolTeacherListOk = getSchoolTeacherListOk;
	exports.getSchoolTeacherListFailed = getSchoolTeacherListFailed;
	exports.getSchoolTeacherListAction = getSchoolTeacherListAction;
	exports.getSchoolStudentListRequestOut = getSchoolStudentListRequestOut;
	exports.getSchoolStudentListOk = getSchoolStudentListOk;
	exports.getSchoolStudentListFailed = getSchoolStudentListFailed;
	exports.getSchoolStudentListAction = getSchoolStudentListAction;
	exports.getUserByTokenRequestOut = getUserByTokenRequestOut;
	exports.getUserByTokenOk = getUserByTokenOk;
	exports.getUserByTokenFailed = getUserByTokenFailed;
	exports.getUserByTokenAction = getUserByTokenAction;
	exports.refreshTokenRequestOut = refreshTokenRequestOut;
	exports.refreshTokenOk = refreshTokenOk;
	exports.refreshTokenFailed = refreshTokenFailed;
	exports.refreshTokenAction = refreshTokenAction;
	exports.changePasswordRequestOut = changePasswordRequestOut;
	exports.changePasswordOk = changePasswordOk;
	exports.changePasswordFailed = changePasswordFailed;
	exports.changePasswordAction = changePasswordAction;
	exports.sendPhoneVerificationRequestOut = sendPhoneVerificationRequestOut;
	exports.sendPhoneVerificationOk = sendPhoneVerificationOk;
	exports.sendPhoneVerificationFailed = sendPhoneVerificationFailed;
	exports.sendPhoneVerificationAction = sendPhoneVerificationAction;
	exports.getSchoolTradeListRequestOut = getSchoolTradeListRequestOut;
	exports.getSchoolTradeListOk = getSchoolTradeListOk;
	exports.getSchoolTradeListFailed = getSchoolTradeListFailed;
	exports.getSchoolTradeListAction = getSchoolTradeListAction;
	exports.getTradeNoteRequestOut = getTradeNoteRequestOut;
	exports.getTradeNoteOk = getTradeNoteOk;
	exports.getTradeNoteFailed = getTradeNoteFailed;
	exports.getTradeNoteAction = getTradeNoteAction;
	exports.updateTradeNoteRequestOut = updateTradeNoteRequestOut;
	exports.updateTradeNoteOk = updateTradeNoteOk;
	exports.updateTradeNoteFailed = updateTradeNoteFailed;
	exports.updateTradeNoteAction = updateTradeNoteAction;
	exports.sendTradeEmailRequestOut = sendTradeEmailRequestOut;
	exports.sendTradeEmailOk = sendTradeEmailOk;
	exports.sendTradeEmailFailed = sendTradeEmailFailed;
	exports.sendTradeEmailAction = sendTradeEmailAction;
	exports.getTimetableRequestOut = getTimetableRequestOut;
	exports.getTimetableOk = getTimetableOk;
	exports.getTimetableFailed = getTimetableFailed;
	exports.getTimetableAction = getTimetableAction;
	exports.schoolGroupListRequestOut = schoolGroupListRequestOut;
	exports.schoolGroupListOk = schoolGroupListOk;
	exports.schoolGroupListFailed = schoolGroupListFailed;
	exports.getSchoolGroupListAction = getSchoolGroupListAction;
	exports.groupListRegisterRequestOut = groupListRegisterRequestOut;
	exports.groupListRegisterOk = groupListRegisterOk;
	exports.groupListRegisterFailed = groupListRegisterFailed;
	exports.groupListRegisterAction = groupListRegisterAction;
	exports.groupListTeacherRequestOut = groupListTeacherRequestOut;
	exports.groupListTeacherOk = groupListTeacherOk;
	exports.groupListTeacherFailed = groupListTeacherFailed;
	exports.groupListTeacherAction = groupListTeacherAction;
	exports.updateGroupListTeacherRequestOut = updateGroupListTeacherRequestOut;
	exports.updateGroupListTeacherOk = updateGroupListTeacherOk;
	exports.updateGroupListTeacherFailed = updateGroupListTeacherFailed;
	exports.updateGroupListTeacherAction = updateGroupListTeacherAction;
	exports.getGroupDetailRequestOut = getGroupDetailRequestOut;
	exports.getGroupDetailOk = getGroupDetailOk;
	exports.getGroupDetailFailed = getGroupDetailFailed;
	exports.getGroupDetailAction = getGroupDetailAction;
	exports.deleteGroupRequestOut = deleteGroupRequestOut;
	exports.deleteGroupOk = deleteGroupOk;
	exports.deleteGroupFailed = deleteGroupFailed;
	exports.deleteGroupAction = deleteGroupAction;
	exports.updateGroupListRequestOut = updateGroupListRequestOut;
	exports.updateGroupListOk = updateGroupListOk;
	exports.updateGroupListFailed = updateGroupListFailed;
	exports.updateGroupListAction = updateGroupListAction;
	exports.paymentMethodRequestOut = paymentMethodRequestOut;
	exports.paymentMethodOk = paymentMethodOk;
	exports.paymentMethodFailed = paymentMethodFailed;
	exports.paymentMethodAction = paymentMethodAction;
	exports.subscriptionRequestOut = subscriptionRequestOut;
	exports.subscriptionOk = subscriptionOk;
	exports.subscriptionFailed = subscriptionFailed;
	exports.subscriptionAction = subscriptionAction;
	exports.getSubscriptionRequestOut = getSubscriptionRequestOut;
	exports.getSubscriptionOk = getSubscriptionOk;
	exports.getSubscriptionFailed = getSubscriptionFailed;
	exports.getSubscriptionAction = getSubscriptionAction;
	exports.schoolPermissionListRequestOut = schoolPermissionListRequestOut;
	exports.schoolPermissionListOk = schoolPermissionListOk;
	exports.schoolPermissionListFailed = schoolPermissionListFailed;
	exports.getSchoolPermissionListAction = getSchoolPermissionListAction;
	exports.teacherConfirmationRequestOut = teacherConfirmationRequestOut;
	exports.teacherConfirmationOk = teacherConfirmationOk;
	exports.teacherConfirmationFailed = teacherConfirmationFailed;
	exports.teacherConfirmationAction = teacherConfirmationAction;
	exports.deleteSchoolRequestOut = deleteSchoolRequestOut;
	exports.deleteSchoolOk = deleteSchoolOk;
	exports.deleteSchoolFailed = deleteSchoolFailed;
	exports.deleteSchoolAction = deleteSchoolAction;
	exports.getSchoolMonthlyFinanceRequestOut = getSchoolMonthlyFinanceRequestOut;
	exports.getSchoolMonthlyFinanceOk = getSchoolMonthlyFinanceOk;
	exports.getSchoolMonthlyFinanceFailed = getSchoolMonthlyFinanceFailed;
	exports.getSchoolMonthlyFinanceAction = getSchoolMonthlyFinanceAction;
	
	var _ActionTypes = __webpack_require__("PZtk");
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _registerSchool = __webpack_require__("xNAE");
	
	var _registerSchool2 = _interopRequireDefault(_registerSchool);
	
	var _loginAsUser = __webpack_require__("zyKh");
	
	var _loginAsUser2 = _interopRequireDefault(_loginAsUser);
	
	var _registerUser = __webpack_require__("gmOA");
	
	var _registerUser2 = _interopRequireDefault(_registerUser);
	
	var _getAllClass = __webpack_require__("oS9b");
	
	var _getAllClass2 = _interopRequireDefault(_getAllClass);
	
	var _getAllTeacher = __webpack_require__("eOJR");
	
	var _getAllTeacher2 = _interopRequireDefault(_getAllTeacher);
	
	var _getAllStudent = __webpack_require__("xuVx");
	
	var _getAllStudent2 = _interopRequireDefault(_getAllStudent);
	
	var _getUserByToken = __webpack_require__("v34H");
	
	var _getUserByToken2 = _interopRequireDefault(_getUserByToken);
	
	var _refreshToken = __webpack_require__("z0/O");
	
	var _refreshToken2 = _interopRequireDefault(_refreshToken);
	
	var _resetPassword = __webpack_require__("5+v8");
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _sendPhoneVerification = __webpack_require__("qfzY");
	
	var _sendPhoneVerification2 = _interopRequireDefault(_sendPhoneVerification);
	
	var _getTradeRecord = __webpack_require__("KAiH");
	
	var _getTradeRecord2 = _interopRequireDefault(_getTradeRecord);
	
	var _getTradeNote = __webpack_require__("o+LH");
	
	var _getTradeNote2 = _interopRequireDefault(_getTradeNote);
	
	var _updateTradeNote = __webpack_require__("os9A");
	
	var _updateTradeNote2 = _interopRequireDefault(_updateTradeNote);
	
	var _sendTradeEmail = __webpack_require__("UhR/");
	
	var _sendTradeEmail2 = _interopRequireDefault(_sendTradeEmail);
	
	var _getTimetable = __webpack_require__("sxrQ");
	
	var _getTimetable2 = _interopRequireDefault(_getTimetable);
	
	var _getPermissionGroupList = __webpack_require__("3tPD");
	
	var _getPermissionGroupList2 = _interopRequireDefault(_getPermissionGroupList);
	
	var _registerPermissionGroup = __webpack_require__("/Jya");
	
	var _registerPermissionGroup2 = _interopRequireDefault(_registerPermissionGroup);
	
	var _addPermissionGroupTeacher = __webpack_require__("blDn");
	
	var _addPermissionGroupTeacher2 = _interopRequireDefault(_addPermissionGroupTeacher);
	
	var _updatePermissionGroupTeacher = __webpack_require__("LFjV");
	
	var _updatePermissionGroupTeacher2 = _interopRequireDefault(_updatePermissionGroupTeacher);
	
	var _getPermissionGroupDetail = __webpack_require__("aktW");
	
	var _getPermissionGroupDetail2 = _interopRequireDefault(_getPermissionGroupDetail);
	
	var _deletePermissionGroup = __webpack_require__("NCSu");
	
	var _deletePermissionGroup2 = _interopRequireDefault(_deletePermissionGroup);
	
	var _updatePermissionGroup = __webpack_require__("lJJu");
	
	var _updatePermissionGroup2 = _interopRequireDefault(_updatePermissionGroup);
	
	var _addPaymentMethod = __webpack_require__("ZNb7");
	
	var _addPaymentMethod2 = _interopRequireDefault(_addPaymentMethod);
	
	var _addSubscription = __webpack_require__("g9St");
	
	var _addSubscription2 = _interopRequireDefault(_addSubscription);
	
	var _getSubscription = __webpack_require__("h7zY");
	
	var _getSubscription2 = _interopRequireDefault(_getSubscription);
	
	var _getPermissionList = __webpack_require__("Gnol");
	
	var _getPermissionList2 = _interopRequireDefault(_getPermissionList);
	
	var _confirmTeacher = __webpack_require__("7MKa");
	
	var _confirmTeacher2 = _interopRequireDefault(_confirmTeacher);
	
	var _deleteSchool = __webpack_require__("+3nq");
	
	var _deleteSchool2 = _interopRequireDefault(_deleteSchool);
	
	var _getMonthlyFinance = __webpack_require__("RkBl");
	
	var _getMonthlyFinance2 = _interopRequireDefault(_getMonthlyFinance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function schoolLoginRequestOut() {
	  return {
	    type: types.S_LOG_IN
	  };
	}
	
	function schoolLoginOk(result) {
	  return {
	    type: types.S_LOG_IN_OK,
	    result: result
	  };
	}
	
	function schoolLoginFailed(error) {
	  return {
	    type: types.S_LOG_IN_FAILED,
	    error: error
	  };
	}
	
	function schoolLoginAction(params) {
	  return function (dispatch) {
	    dispatch(schoolLoginRequestOut);
	    return (0, _loginAsUser2.default)(params).then(function (results) {
	      dispatch(schoolLoginOk(results.data));
	    }).catch(function (error) {
	      dispatch(schoolLoginFailed(error));
	    });
	  };
	}
	
	// Billy add school sign up action Nov.07.2017
	function schoolSignupRequestOut() {
	  return {
	    type: types.S_SIGN_UP
	  };
	}
	
	function schoolSignupOk(result) {
	  return {
	    type: types.S_SIGN_UP_OK,
	    result: result
	  };
	}
	
	function schoolSignupFailed(error) {
	  return {
	    type: types.S_SIGN_UP_FAILED,
	    error: error
	  };
	}
	
	function schoolSignupAction(params) {
	  return function (dispatch) {
	    dispatch(schoolSignupRequestOut);
	    return (0, _registerUser2.default)(params).then(function (results) {
	      dispatch(schoolSignupOk(results.data));
	    }).catch(function (error) {
	      dispatch(schoolSignupFailed(error));
	    });
	  };
	}
	
	// Billy add create school action Nov.08.2017
	function schoolRegisterRequestOut() {
	  return {
	    type: types.RGST_SCHOOL
	  };
	}
	
	function schoolRegisterRequestOk(result) {
	  return {
	    type: types.RGST_SCHOOL_OK,
	    result: result
	  };
	}
	
	function schoolRegisterRequestFailed(error) {
	  return {
	    type: types.RGST_SCHOOL_FAILED,
	    error: error
	  };
	}
	
	function schoolRegisterAction(params) {
	  return function (dispatch) {
	    dispatch(schoolRegisterRequestOut);
	    return (0, _registerSchool2.default)(params).then(function (results) {
	      dispatch(schoolRegisterRequestOk(results.data));
	    }).catch(function (error) {
	      dispatch(schoolRegisterRequestFailed(error));
	    });
	  };
	}
	
	function getSchoolClassListRequestOut() {
	  return {
	    type: types.GET_SCH_CLS_LST
	  };
	}
	
	function getSchoolClassListOk(result) {
	  return {
	    type: types.GET_SCH_CLS_LST_OK,
	    result: result
	  };
	}
	
	function getSchoolClassListFailed(error) {
	  return {
	    type: types.GET_SCH_CLS_LST_FAILED,
	    error: error
	  };
	}
	
	function getSchoolClassListAction(schoolId) {
	  return function (dispatch) {
	    dispatch(getSchoolClassListRequestOut);
	    return (0, _getAllClass2.default)(schoolId).then(function (results) {
	      dispatch(getSchoolClassListOk(results.data));
	    }).catch(function (error) {
	      dispatch(getSchoolClassListFailed(error));
	    });
	  };
	}
	
	function getSchoolTeacherListRequestOut() {
	  return {
	    type: types.GET_SCH_TCH_LST
	  };
	}
	
	function getSchoolTeacherListOk(result) {
	  var list = _.orderBy(result.list, ['id'], ['desc']);
	  result.list = list;
	  return {
	    type: types.GET_SCH_TCH_LST_OK,
	    result: result
	  };
	}
	
	function getSchoolTeacherListFailed(error) {
	  return {
	    type: types.GET_SCH_TCH_LST_FAILED,
	    error: error
	  };
	}
	
	function getSchoolTeacherListAction(schoolId) {
	  return function (dispatch) {
	    dispatch(getSchoolTeacherListRequestOut);
	    return (0, _getAllTeacher2.default)(schoolId).then(function (results) {
	      dispatch(getSchoolTeacherListOk(results.data));
	    }).catch(function (error) {
	      dispatch(getSchoolTeacherListFailed(error));
	    });
	  };
	}
	
	function getSchoolStudentListRequestOut() {
	  return {
	    type: types.GET_SCH_STDT_LST
	  };
	}
	
	function getSchoolStudentListOk(data) {
	  data.list = _.sortBy(data.list, ['sName']);
	  return {
	    type: types.GET_SCH_STDT_LST_OK,
	    result: data
	  };
	}
	
	function getSchoolStudentListFailed(error) {
	  return {
	    type: types.GET_SCH_STDT_LST_FAILED,
	    error: error
	  };
	}
	
	function getSchoolStudentListAction(schoolId, state) {
	  return function (dispatch) {
	    dispatch(getSchoolStudentListRequestOut);
	    return (0, _getAllStudent2.default)(schoolId, state).then(function (results) {
	      dispatch(getSchoolStudentListOk(results.data));
	    }).catch(function (error) {
	      dispatch(getSchoolStudentListFailed(error));
	    });
	  };
	}
	
	function getUserByTokenRequestOut() {
	  return {
	    type: types.GET_USER_BY_TOKEN
	  };
	}
	
	function getUserByTokenOk(result) {
	  return {
	    type: types.GET_USER_BY_TOKEN_OK,
	    result: result
	  };
	}
	
	function getUserByTokenFailed(error) {
	  return {
	    type: types.GET_USER_BY_TOKEN_FAILED,
	    error: error
	  };
	}
	
	function getUserByTokenAction() {
	  return function (dispatch) {
	    dispatch(getUserByTokenRequestOut);
	    return (0, _getUserByToken2.default)().then(function (results) {
	      dispatch(getUserByTokenOk(results.data));
	    }).catch(function (error) {
	      dispatch(getUserByTokenFailed(error));
	    });
	  };
	}
	
	function refreshTokenRequestOut() {
	  return {
	    type: types.REFRESH_TOKEN
	  };
	}
	
	function refreshTokenOk(result) {
	  localStorage.setItem('token', result.token);
	  return {
	    type: types.REFRESH_TOKEN_OK,
	    result: result
	  };
	}
	
	function refreshTokenFailed(error) {
	  return {
	    type: types.REFRESH_TOKEN_FAILED,
	    error: error
	  };
	}
	
	function refreshTokenAction(params) {
	  return function (dispatch) {
	    dispatch(refreshTokenRequestOut);
	    return (0, _refreshToken2.default)(params).then(function (results) {
	      dispatch(refreshTokenOk(results.data));
	    }).catch(function (error) {
	      dispatch(refreshTokenFailed(error));
	    });
	  };
	}
	
	function changePasswordRequestOut() {
	  return {
	    type: types.CHANGE_PASSWD
	  };
	}
	
	function changePasswordOk(result) {
	  return {
	    type: types.CHANGE_PASSWD_OK,
	    result: result
	  };
	}
	
	function changePasswordFailed(error) {
	  return {
	    type: types.CHANGE_PASSWD_FAILED,
	    error: error
	  };
	}
	
	function changePasswordAction(params) {
	  return function (dispatch) {
	    dispatch(changePasswordRequestOut);
	    return (0, _resetPassword2.default)(params).then(function (results) {
	      dispatch(changePasswordOk(results.data));
	    }).catch(function (error) {
	      dispatch(changePasswordFailed(error));
	    });
	  };
	}
	
	function sendPhoneVerificationRequestOut() {
	  return {
	    type: types.SEND_PHONE_VRFCTION
	  };
	}
	
	function sendPhoneVerificationOk(result) {
	  return {
	    type: types.SEND_PHONE_VRFCTION_OK,
	    result: result
	  };
	}
	
	function sendPhoneVerificationFailed(error) {
	  return {
	    type: types.SEND_PHONE_VRFCTION_FAILED,
	    error: error
	  };
	}
	
	function sendPhoneVerificationAction(params) {
	  return function (dispatch) {
	    dispatch(sendPhoneVerificationRequestOut);
	    return (0, _sendPhoneVerification2.default)(params).then(function (results) {
	      dispatch(sendPhoneVerificationOk(results.data));
	    }).catch(function (error) {
	      dispatch(sendPhoneVerificationFailed(error));
	    });
	  };
	}
	
	function getSchoolTradeListRequestOut() {
	  return {
	    type: types.GET_TRADE_LIST
	  };
	}
	
	function getSchoolTradeListOk(result) {
	  return {
	    type: types.GET_TRADE_LIST_OK,
	    result: result
	  };
	}
	
	function getSchoolTradeListFailed(error) {
	  return {
	    type: types.GET_TRADE_LIST_FAILED,
	    error: error
	  };
	}
	
	function getSchoolTradeListAction(schoolId, params) {
	  return function (dispatch) {
	    dispatch(getSchoolTradeListRequestOut);
	    return (0, _getTradeRecord2.default)(schoolId, params).then(function (results) {
	      dispatch(getSchoolTradeListOk(results));
	    }).catch(function (error) {
	      dispatch(getSchoolTradeListFailed(error));
	    });
	  };
	}
	
	function getTradeNoteRequestOut() {
	  return {
	    type: types.GET_TRADE_NOTE
	  };
	}
	
	function getTradeNoteOk(result) {
	  return {
	    type: types.GET_TRADE_NOTE_OK,
	    result: result
	  };
	}
	
	function getTradeNoteFailed(error) {
	  return {
	    type: types.GET_TRADE_NOTE_FAILED,
	    error: error
	  };
	}
	
	function getTradeNoteAction(tradeRecordId) {
	  return function (dispatch) {
	    dispatch(getTradeNoteRequestOut);
	    return (0, _getTradeNote2.default)(tradeRecordId).then(function (results) {
	      dispatch(getTradeNoteOk(results.data));
	    }).catch(function (error) {
	      dispatch(getTradeNoteFailed(error));
	    });
	  };
	}
	
	function updateTradeNoteRequestOut() {
	  return {
	    type: types.UPDATE_TRADE_NOTE
	  };
	}
	
	function updateTradeNoteOk(result) {
	  return {
	    type: types.UPDATE_TRADE_NOTE_OK,
	    result: result
	  };
	}
	
	function updateTradeNoteFailed(error) {
	  return {
	    type: types.UPDATE_TRADE_NOTE_FAILED,
	    error: error
	  };
	}
	
	function updateTradeNoteAction(tradeRecordId, params) {
	  return function (dispatch) {
	    dispatch(updateTradeNoteRequestOut);
	    return (0, _updateTradeNote2.default)(tradeRecordId, params).then(function (results) {
	      dispatch(updateTradeNoteOk(results.data));
	    }).catch(function (error) {
	      dispatch(updateTradeNoteFailed(error));
	    });
	  };
	}
	
	function sendTradeEmailRequestOut() {
	  return {
	    type: types.SEND_TRADE_EMAIL
	  };
	}
	
	function sendTradeEmailOk(result) {
	  return {
	    type: types.SEND_TRADE_EMAIL_OK,
	    result: result
	  };
	}
	
	function sendTradeEmailFailed(error) {
	  return {
	    type: types.SEND_TRADE_EMAIL_FAILED,
	    error: error
	  };
	}
	
	function sendTradeEmailAction(tradeRecordId, params) {
	  return function (dispatch) {
	    dispatch(sendTradeEmailRequestOut);
	    return (0, _sendTradeEmail2.default)(tradeRecordId, params).then(function (results) {
	      dispatch(sendTradeEmailOk(results.data));
	    }).catch(function (error) {
	      dispatch(sendTradeEmailFailed(error));
	    });
	  };
	}
	
	function getTimetableRequestOut() {
	  return {
	    type: types.GET_TIMETABLE
	  };
	}
	
	function getTimetableOk(result) {
	  return {
	    type: types.GET_TIMETABLE_OK,
	    result: result
	  };
	}
	
	function getTimetableFailed(error) {
	  return {
	    type: types.GET_TIMETABLE_FAILED,
	    error: error
	  };
	}
	
	function getTimetableAction(schoolId, params) {
	  return function (dispatch) {
	    dispatch(getTimetableRequestOut);
	    return (0, _getTimetable2.default)(schoolId, params).then(function (results) {
	      dispatch(getTimetableOk(results.data));
	    }).catch(function (error) {
	      dispatch(getTimetableFailed(error));
	    });
	  };
	}
	
	// Billy add get school group list action -- Nov.28.2017
	function schoolGroupListRequestOut() {
	  return {
	    type: types.S_GROUP_LIST
	  };
	}
	
	function schoolGroupListOk(result) {
	  return {
	    type: types.S_GROUP_LIST_OK,
	    result: result
	  };
	}
	
	function schoolGroupListFailed(error) {
	  return {
	    type: types.S_GROUP_LIST_FAILED,
	    error: error
	  };
	}
	
	function getSchoolGroupListAction(schoolId) {
	  return function (dispatch) {
	    dispatch(schoolGroupListRequestOut);
	    return (0, _getPermissionGroupList2.default)(schoolId).then(function (results) {
	      dispatch(schoolGroupListOk(results.data));
	    }).catch(function (error) {
	      dispatch(schoolGroupListFailed(error));
	    });
	  };
	}
	
	// Billy add post school group list action -- NOv.29.2017
	function groupListRegisterRequestOut() {
	  return {
	    type: types.RGST_GROUP_LIST
	  };
	}
	
	function groupListRegisterOk(result) {
	  return {
	    type: types.RGST_GROUP_LIST_OK,
	    result: result
	  };
	}
	
	function groupListRegisterFailed(error) {
	  return {
	    type: types.RGST_GROUP_LIST_FAILED,
	    error: error
	  };
	}
	
	function groupListRegisterAction(schoolId, params) {
	  return function (dispatch) {
	    dispatch(groupListRegisterRequestOut);
	    return (0, _registerPermissionGroup2.default)(schoolId, params).then(function (results) {
	      dispatch(groupListRegisterOk(results.data));
	    }).catch(function (error) {
	      dispatch(groupListRegisterFailed(error));
	    });
	  };
	}
	
	// Billy add teacher group edit action -- Nov.29.2017
	function groupListTeacherRequestOut() {
	  return {
	    type: types.GROUP_LIST_TEACHER
	  };
	}
	
	function groupListTeacherOk(result) {
	  return {
	    type: types.GROUP_LIST_TEACHER_OK,
	    result: result
	  };
	}
	
	function groupListTeacherFailed(error) {
	  return {
	    type: types.GROUP_LIST_TEACHER_FAILED,
	    error: error
	  };
	}
	
	function groupListTeacherAction(schoolId, params) {
	  return function (dispatch) {
	    dispatch(groupListTeacherRequestOut);
	    return (0, _addPermissionGroupTeacher2.default)(schoolId, params).then(function (results) {
	      dispatch(groupListTeacherOk(results.data));
	    }).catch(function (error) {
	      dispatch(groupListTeacherFailed(error));
	    });
	  };
	}
	
	// Billy add update teacher group list action -- Nov.30.2017
	function updateGroupListTeacherRequestOut() {
	  return {
	    type: types.UPDATE_GROUP_LIST_TEACHER
	  };
	}
	
	function updateGroupListTeacherOk(result) {
	  return {
	    type: types.UPDATE_GROUP_LIST_TEACHER_OK,
	    result: result
	  };
	}
	
	function updateGroupListTeacherFailed(error) {
	  return {
	    type: types.UPDATE_GROUP_LIST_TEACHER_FAILED,
	    error: error
	  };
	}
	
	function updateGroupListTeacherAction(schoolId, params) {
	  return function (dispatch) {
	    dispatch(updateGroupListTeacherRequestOut);
	    return (0, _updatePermissionGroupTeacher2.default)(schoolId, params).then(function (results) {
	      dispatch(updateGroupListTeacherOk(results.data));
	    }).catch(function (error) {
	      dispatch(updateGroupListTeacherFailed(error));
	    });
	  };
	}
	
	// Billy add get school group detail action -- Nov.29.2017
	function getGroupDetailRequestOut() {
	  return {
	    type: types.GET_GROUP_DETAIL
	  };
	}
	
	function getGroupDetailOk(result) {
	  return {
	    type: types.GET_GROUP_DETAIL_OK,
	    result: result
	  };
	}
	
	function getGroupDetailFailed(error) {
	  return {
	    type: types.GET_GROUP_DETAIL_FAILED,
	    error: error
	  };
	}
	
	function getGroupDetailAction(school_group_id) {
	  return function (dispatch) {
	    dispatch(getGroupDetailRequestOut);
	    return (0, _getPermissionGroupDetail2.default)(school_group_id).then(function (results) {
	      dispatch(getGroupDetailOk(results.data));
	    }).catch(function (error) {
	      dispatch(getGroupDetailFailed(error));
	    });
	  };
	}
	
	// Billy add delete group action -- Nov.30.2017
	function deleteGroupRequestOut() {
	  return {
	    type: types.DELETE_GROUP
	  };
	}
	
	function deleteGroupOk(result) {
	  return {
	    type: types.DELETE_GROUP_OK,
	    result: result
	  };
	}
	
	function deleteGroupFailed(error) {
	  return {
	    type: types.DELETE_GROUP_FAILED,
	    error: error
	  };
	}
	
	function deleteGroupAction(groupId) {
	  return function (dispatch) {
	    dispatch(deleteGroupRequestOut);
	    return (0, _deletePermissionGroup2.default)(groupId).then(function (results) {
	      dispatch(deleteGroupOk(results.data));
	    }).catch(function (error) {
	      dispatch(deleteGroupFailed(error));
	    });
	  };
	}
	
	// Billy add update group list -- Nov.30.2017
	function updateGroupListRequestOut() {
	  return {
	    type: types.UPDATE_GROUP_LIST
	  };
	}
	
	function updateGroupListOk(result) {
	  return {
	    type: types.UPDATE_GROUP_LIST_OK,
	    result: result
	  };
	}
	
	function updateGroupListFailed(error) {
	  return {
	    type: types.UPDATE_GROUP_LIST_FAILED,
	    error: error
	  };
	}
	
	function updateGroupListAction(groupId, params) {
	  return function (dispatch) {
	    dispatch(updateGroupListRequestOut);
	    return (0, _updatePermissionGroup2.default)(groupId, params).then(function (results) {
	      dispatch(updateGroupListOk(results.data));
	    }).catch(function (error) {
	      dispatch(updateGroupListFailed(error));
	    });
	  };
	}
	
	// Billy add upgrade to premium version action -- Dec.06.2017
	function paymentMethodRequestOut() {
	  return {
	    type: types.PAYMENT_METHOD
	  };
	}
	
	function paymentMethodOk(result) {
	  return {
	    type: types.PAYMENT_METHOD_OK,
	    result: result
	  };
	}
	
	function paymentMethodFailed(error) {
	  return {
	    type: types.PAYMENT_METHOD_FAILED,
	    error: error
	  };
	}
	
	function paymentMethodAction(params) {
	  return function (dispatch) {
	    dispatch(paymentMethodRequestOut);
	    return (0, _addPaymentMethod2.default)(params).then(function (results) {
	      dispatch(paymentMethodOk(results.data));
	    }).catch(function (error) {
	      dispatch(paymentMethodFailed(error));
	    });
	  };
	}
	
	// Billy add subscription action -- Dec.06.2017
	function subscriptionRequestOut() {
	  return {
	    type: types.SUBSCRIPTION
	  };
	}
	
	function subscriptionOk(result) {
	  return {
	    type: types.SUBSCRIPTION_OK,
	    result: result
	  };
	}
	
	function subscriptionFailed(error) {
	  return {
	    type: types.SUBSCRIPTION_FAILED,
	    error: error
	  };
	}
	
	function subscriptionAction(params) {
	  return function (dispatch) {
	    dispatch(subscriptionRequestOut);
	    return (0, _addSubscription2.default)(params).then(function (results) {
	      dispatch(subscriptionOk(results.data));
	    }).catch(function (error) {
	      dispatch(subscriptionFailed(error));
	    });
	  };
	}
	
	// Billy add get subscription action -- Dec.06.2017
	function getSubscriptionRequestOut() {
	  return {
	    type: types.GET_SUBSCRIPTION
	  };
	}
	
	function getSubscriptionOk(result) {
	  return {
	    type: types.GET_SUBSCRIPTION_OK,
	    result: result
	  };
	}
	
	function getSubscriptionFailed(error) {
	  return {
	    type: types.GET_SUBSCRIPTION_FAILED,
	    error: error
	  };
	}
	
	function getSubscriptionAction() {
	  return function (dispatch) {
	    dispatch(getSubscriptionRequestOut);
	    return (0, _getSubscription2.default)().then(function (results) {
	      dispatch(getSubscriptionOk(results.data));
	    }).catch(function (error) {
	      dispatch(getSubscriptionFailed(error));
	    });
	  };
	}
	
	// Billy add get school permission list action -- Nov.29.2017
	function schoolPermissionListRequestOut() {
	  return {
	    type: types.S_PERMISSION_LIST
	  };
	}
	
	function schoolPermissionListOk(result) {
	  return {
	    type: types.S_PERMISSION_LIST_OK,
	    result: result
	  };
	}
	
	function schoolPermissionListFailed(error) {
	  return {
	    type: types.S_PERMISSION_LIST_FAILED,
	    error: error
	  };
	}
	
	function getSchoolPermissionListAction() {
	  return function (dispatch) {
	    dispatch(schoolPermissionListRequestOut);
	    return (0, _getPermissionList2.default)().then(function (results) {
	      dispatch(schoolPermissionListOk(results.data));
	    }).catch(function (error) {
	      dispatch(schoolPermissionListFailed(error));
	    });
	  };
	}
	
	// Billy add teacher confirmation action -- Dec.08.2017
	function teacherConfirmationRequestOut() {
	  return {
	    type: types.TEACHER_CONFIRMATION
	  };
	}
	
	function teacherConfirmationOk(result) {
	  return {
	    type: types.TEACHER_CONFIRMATION_OK,
	    result: result
	  };
	}
	
	function teacherConfirmationFailed(error) {
	  return {
	    type: types.TEACHER_CONFIRMATION_FAILED,
	    error: error
	  };
	}
	
	function teacherConfirmationAction(teacherId, params) {
	  return function (dispatch) {
	    dispatch(teacherConfirmationRequestOut);
	    return (0, _confirmTeacher2.default)(teacherId, params).then(function (results) {
	      dispatch(teacherConfirmationOk(results.data));
	    }).catch(function (error) {
	      dispatch(teacherConfirmationFailed(error));
	    });
	  };
	}
	
	// Billy add delete school action -- Dec.13.2017
	function deleteSchoolRequestOut() {
	  return {
	    type: types.DELETE_SCHOOL
	  };
	}
	
	function deleteSchoolOk(result) {
	  return {
	    type: types.DELETE_SCHOOL_OK,
	    result: result
	  };
	}
	
	function deleteSchoolFailed(error) {
	  return {
	    type: types.DELETE_SCHOOL_FAILED,
	    error: error
	  };
	}
	
	function deleteSchoolAction(schoolId) {
	  return function (dispatch) {
	    dispatch(deleteSchoolRequestOut);
	    return (0, _deleteSchool2.default)(schoolId).then(function (results) {
	      dispatch(deleteSchoolOk(results.data));
	    }).catch(function (error) {
	      dispatch(deleteSchoolFailed(error));
	    });
	  };
	}
	
	function getSchoolMonthlyFinanceRequestOut() {
	  return {
	    type: types.GET_MONTHLY_FINANCE
	  };
	}
	
	function getSchoolMonthlyFinanceOk(result) {
	  return {
	    type: types.GET_MONTHLY_FINANCE_OK,
	    result: result
	  };
	}
	
	function getSchoolMonthlyFinanceFailed(error) {
	  return {
	    type: types.GET_MONTHLY_FINANCE_FAILED,
	    error: error
	  };
	}
	
	function getSchoolMonthlyFinanceAction(schoolId, params) {
	  return function (dispatch) {
	    dispatch(getSchoolMonthlyFinanceRequestOut);
	    return (0, _getMonthlyFinance2.default)(schoolId, params).then(function (results) {
	      dispatch(getSchoolMonthlyFinanceOk(results.data));
	    }).catch(function (error) {
	      dispatch(getSchoolMonthlyFinanceFailed(error));
	    });
	  };
	}

/***/ },

/***/ "xNAE":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = registerSchool;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  title: _joiBrowser2.default.string().required(),
	  description: _joiBrowser2.default.string().allow(''),
	  chineseTitle: _joiBrowser2.default.string().allow(''),
	  chineseDescription: _joiBrowser2.default.string().allow(''),
	  schoolType: _joiBrowser2.default.number().integer(),
	  suitAgeLower: _joiBrowser2.default.number().integer(),
	  suitAgeUpper: _joiBrowser2.default.number().integer(),
	  openHour: _joiBrowser2.default.string().allow(''),
	  address: _joiBrowser2.default.string().allow(''),
	  suit_number: _joiBrowser2.default.string().allow(''),
	  postcode: _joiBrowser2.default.string().allow(''),
	  city: _joiBrowser2.default.string().allow(''),
	  province: _joiBrowser2.default.string().allow(''),
	  country: _joiBrowser2.default.string().allow(''),
	  timezone: _joiBrowser2.default.string().required(),
	  currency: _joiBrowser2.default.string().required(),
	  homepage: _joiBrowser2.default.string().allow(''),
	  phone: _joiBrowser2.default.string().allow(''),
	  email: _joiBrowser2.default.string().allow(''),
	  image: _joiBrowser2.default.string().allow(''),
	  tags: _joiBrowser2.default.array().allow(''),
	  enable: _joiBrowser2.default.boolean().allow(''),
	  categories: _joiBrowser2.default.array().allow(''),
	  remark: _joiBrowser2.default.string().max(500, 'utf8').allow('')
	});
	
	function registerSchool(schoolInfo) {
	  // VALIDATE PARAMS
	  // We throw an error if params are not fulfilled.
	  var validateResult = _joiBrowser2.default.validate(schoolInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/createschool/',
	      'method': 'POST',
	      'data': JSON.stringify(schoolInfo),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "zyKh":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = loginAsUser;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
		username: _joiBrowser2.default.string().required(),
		password: _joiBrowser2.default.string().required()
	});
	
	function loginAsUser(loginInfo) {
		if (!loginInfo) {
			throw 'Missing loginInfo';
		}
	
		var validateResult = _joiBrowser2.default.validate(loginInfo, schema);
	
		if (validateResult.error) {
			return new Promise(function (resolve, reject) {
				reject(validateResult);
			});
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/slogin/',
				'method': 'POST',
				'data': JSON.stringify(loginInfo),
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res);
			}).catch(function (err) {
				reject(err);
			});
		});
	}

/***/ },

/***/ "gmOA":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = registerUser;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  phone: _joiBrowser2.default.string().required(),
	  new_password: _joiBrowser2.default.string().required(),
	  pin: _joiBrowser2.default.string().required(),
	  agent_id: _joiBrowser2.default.number().integer().allow(''),
	  email: _joiBrowser2.default.string().required()
	});
	
	function registerUser(userInfo) {
	
	  var validateResult = _joiBrowser2.default.validate(userInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  if (!userInfo) {
	    throw 'Missing userInfo';
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/register_user/',
	      'method': 'POST',
	      'data': JSON.stringify(userInfo),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "oS9b":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getAllClass;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getAllClass(schoolId) {
	
		if (!schoolId) {
			throw 'Missing school ID';
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': "/g_schclslist/" + schoolId + "/",
				'method': 'GET',
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res.data);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports["default"];

/***/ },

/***/ "eOJR":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getAllTeacher;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getAllTeacher(schoolId) {
	
		if (!schoolId) {
			throw 'Missing school ID';
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/rgst_tch/' + schoolId + '/',
				'method': 'GET',
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports['default'];

/***/ },

/***/ "xuVx":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getAllStudent;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATES = ['not_scheduled', "all_not_archived", "archived", "enrolled", "all"];
	
	function getAllStudent(schoolId, state) {
	
	  if (!schoolId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school ID')
	      });
	    });
	  }
	
	  if (STATES.indexOf(state) == -1) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Invalid states: please enter one of the following states: ' + STATES.toString())
	      });
	    });
	  }
	
	  var sState = state == 'all' ? '' : '?sState=' + STATES.indexOf(state);
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/g_schstdtlist/' + schoolId + sState,
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "z0/O":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = refreshToken;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function refreshToken(params) {
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/api-token-refresh/',
				'method': 'POST',
				'data': JSON.stringify(params)
			}).then(function (res) {
				resolve(res);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports["default"];

/***/ },

/***/ "5+v8":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = resetPassword;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
		phone: _joiBrowser2.default.string().required(),
		pin: _joiBrowser2.default.string().required(),
		new_password: _joiBrowser2.default.string().required()
	});
	
	function resetPassword(userInfo) {
		if (!userInfo) {
			throw 'Missing loginInfo';
		}
	
		var validateResult = _joiBrowser2.default.validate(userInfo, schema);
	
		if (validateResult.error) {
			return new Promise(function (resolve, reject) {
				reject(validateResult);
			});
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/changepasswd_sms/',
				'method': 'POST',
				'data': JSON.stringify(userInfo),
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res.data);
			}).catch(function (err) {
				reject(err);
			});
		});
	}

/***/ },

/***/ "qfzY":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = sendPhoneVerification;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATUS = ['sendWithoutCheck', 'sendIfUserExist', 'sendIfUserNotExist'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
		phone: _joiBrowser2.default.string().required(),
		check_phone: _joiBrowser2.default.string().valid(STATUS).required()
	});
	
	function sendPhoneVerification(info) {
		var validateResult = _joiBrowser2.default.validate(info, schema);
	
		if (validateResult.error) {
			return new Promise(function (resolve, reject) {
				reject(validateResult);
			});
		}
	
		var toServer = _extends({}, info, {
			check_phone: STATUS.indexOf(info.check_phone)
	
		});
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/send_phone_vrfction/',
				'method': 'POST',
				'data': JSON.stringify(toServer),
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res.data);
			}).catch(function (err) {
				reject(err);
			});
		});
	}

/***/ },

/***/ "3tPD":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getPermissionGroupList;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getPermissionGroupList(schoolId) {
		if (!schoolId) {
			throw 'Missing school ID';
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': "/group_list/" + schoolId + "/",
				'method': 'GET',
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports["default"];

/***/ },

/***/ "/Jya":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = registerPermissionGroup;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
		name: _joiBrowser2.default.string().required(),
		description: _joiBrowser2.default.string().allow(''),
		permissions: _joiBrowser2.default.array().required()
	});
	
	function registerPermissionGroup(schoolId, groupInfo) {
		if (!schoolId) {
			throw 'Missing school ID';
		}
	
		var validateResult = _joiBrowser2.default.validate(groupInfo, schema);
	
		if (validateResult.error) {
			return new Promise(function (resolve, reject) {
				reject(validateResult);
			});
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/group_list/' + schoolId + '/',
				'method': 'POST',
				'data': JSON.stringify(groupInfo),
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res);
			}).catch(function (err) {
				reject(err);
			});
		});
	}

/***/ },

/***/ "blDn":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = addGroupListTeacher;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
		teacher_id_list: _joiBrowser2.default.array().required(),
		group_id_list: _joiBrowser2.default.array().required()
	});
	
	function addGroupListTeacher(schoolId, groupInfo) {
		if (!schoolId) {
			throw 'Missing school ID';
		}
	
		var validateResult = _joiBrowser2.default.validate(groupInfo, schema);
	
		if (validateResult.error) {
			return new Promise(function (resolve, reject) {
				reject(validateResult);
			});
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/group_tch_edit/' + schoolId + '/',
				'method': 'POST',
				'data': JSON.stringify(groupInfo),
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res);
			}).catch(function (err) {
				reject(err);
			});
		});
	}

/***/ },

/***/ "LFjV":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = updatePermissionGroupTeacher;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  teacher_id_list: _joiBrowser2.default.array().required(),
	  group_id_list: _joiBrowser2.default.array().required()
	});
	
	function updatePermissionGroupTeacher(schoolId, groupInfo) {
	  if (!schoolId) {
	    throw 'Missing school ID';
	  }
	
	  var validateResult = _joiBrowser2.default.validate(groupInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, groupInfo, {
	    obj_being_edited: 2
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/group_tch_edit/' + schoolId + '/',
	      'method': 'PUT',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "aktW":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getPermissionGroupDetail;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getPermissionGroupDetail(school_group_id) {
		if (!school_group_id) {
			throw 'Missing permission group ID';
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/group_detail/' + school_group_id + '/',
				'method': 'GET',
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports['default'];

/***/ },

/***/ "NCSu":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = deletePermissionGroup;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deletePermissionGroup(groupId) {
		if (!groupId) {
			throw 'Missing permission group ID';
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/group_detail/' + groupId + '/',
				'method': 'DELETE',
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports['default'];

/***/ },

/***/ "lJJu":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = updatePermissionGroup;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
		name: _joiBrowser2.default.string().required(),
		description: _joiBrowser2.default.string().allow(''),
		permissions: _joiBrowser2.default.array().required()
	});
	
	function updatePermissionGroup(groupId, groupInfo) {
	
		if (!groupId) {
			throw 'Missing permission group ID';
		}
	
		var validateResult = _joiBrowser2.default.validate(groupInfo, schema);
	
		if (validateResult.error) {
			return new Promise(function (resolve, reject) {
				reject(validateResult);
			});
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/group_detail/' + groupId + '/',
				'method': 'PUT',
				'data': JSON.stringify(groupInfo),
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res);
			}).catch(function (err) {
				reject(err);
			});
		});
	}

/***/ },

/***/ "ZNb7":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = addPaymentMethod;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SET_DEFAULT = ['no_default', 'set_default'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
		source: _joiBrowser2.default.string().required(),
		email: _joiBrowser2.default.string().required(),
		set_default: _joiBrowser2.default.string().valid(SET_DEFAULT)
	});
	
	function addPaymentMethod(paymentInfo) {
	
		var validateResult = _joiBrowser2.default.validate(paymentInfo, schema);
	
		if (validateResult.error) {
			return new Promise(function (resolve, reject) {
				reject(validateResult);
			});
		}
		var toServer = {};
		if (paymentInfo.set_default) {
			toServer = _extends({}, paymentInfo, {
				set_default: SET_DEFAULT.indexOf(paymentInfo.set_default)
			});
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/payment_method/',
				'method': 'POST',
				'data': JSON.stringify(toServer),
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res.data);
			}).catch(function (err) {
				reject(err);
			});
		});
	}

/***/ },

/***/ "g9St":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = addSubscription;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  plan_codename: _joiBrowser2.default.string().required(),
	  quantity: _joiBrowser2.default.number().integer().allow('')
	});
	
	function addSubscription(paymentInfo) {
	
	  var validateResult = _joiBrowser2.default.validate(paymentInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/subscription/',
	      'method': 'POST',
	      'data': JSON.stringify(paymentInfo),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "Gnol":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getPermissionList;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getPermissionList(byChannel) {
		var byChannelParam = byChannel === true ? "?by_channel=1" : "";
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/permission_list/' + byChannelParam,
				'method': 'GET',
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports['default'];

/***/ },

/***/ "7MKa":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = confirmTeacher;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONFIRMATION = ['not_confirmed', 'confirmed', 'declined'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
		confirm_or_not: _joiBrowser2.default.string().required()
	});
	
	function confirmTeacher(teacherId, confirm) {
	
		var validateResult = _joiBrowser2.default.validate(confirm, schema);
	
		if (validateResult.error) {
			return new Promise(function (resolve, reject) {
				reject(validateResult);
			});
		}
	
		var toServer = _extends({}, confirm, {
			confirm_or_not: CONFIRMATION.indexOf(confirm.confirm_or_not)
		});
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/tch_confirm/' + teacherId + '/',
				'method': 'POST',
				'data': JSON.stringify(toServer),
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res);
			}).catch(function (err) {
				reject(err);
			});
		});
	}

/***/ },

/***/ "+3nq":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = deleteSchool;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deleteSchool(schoolId) {
	
		if (!schoolId) {
			throw 'Missing school ID';
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/u_school/' + schoolId + '/',
				'method': 'DELETE',
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports['default'];

/***/ },

/***/ "RkBl":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = getMonthlyFinance;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
		student_id_list: _joiBrowser2.default.array().allow(null),
		class_id_list: _joiBrowser2.default.array().allow(null),
		start_date: _joiBrowser2.default.string().allow(''),
		end_date: _joiBrowser2.default.string().allow(''),
		transaction_number: _joiBrowser2.default.string().allow(''),
		paging_or_not: _joiBrowser2.default.number().integer(),
		amount_per_page: _joiBrowser2.default.number().integer(),
		page_number: _joiBrowser2.default.number().integer(),
		summary: _joiBrowser2.default.number().integer()
	});
	
	function getMonthlyFinance(schoolId, tradeInfo) {
		if (!schoolId) {
			throw "mssing a school ID";
		}
	
		var validateResult = _joiBrowser2.default.validate(tradeInfo, schema);
	
		if (validateResult.error) {
			return new Promise(function (resolve, reject) {
				reject(validateResult);
			});
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/search_trade_list/' + schoolId + '/',
				'method': 'POST',
				'data': JSON.stringify(tradeInfo),
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res);
			}).catch(function (err) {
				reject(err);
			});
		});
	}

/***/ },

/***/ "yvp6":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalProvider = __webpack_require__("IL9h");
	
	var _ModalProvider2 = _interopRequireDefault(_ModalProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalProvider2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "IL9h":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalBody = __webpack_require__("+Br2");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalProvider = function (_React$Component) {
	  _inherits(ModalProvider, _React$Component);
	
	  function ModalProvider(props) {
	    _classCallCheck(this, ModalProvider);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalProvider.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(_ModalBody2.default, this.props)
	    );
	  };
	
	  return ModalProvider;
	}(_react2.default.Component);
	
	exports.default = ModalProvider;
	module.exports = exports['default'];

/***/ },

/***/ "+Br2":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("tu5P");
	
	var _ModalContent = __webpack_require__("oJW9");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _locale = __webpack_require__("YyvE");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _registerStudent = __webpack_require__("aRxi");
	
	var _registerStudent2 = _interopRequireDefault(_registerStudent);
	
	var _updateStudentInfo = __webpack_require__("kxXT");
	
	var _updateStudentInfo2 = _interopRequireDefault(_updateStudentInfo);
	
	var _updateStudentPhoto = __webpack_require__("amEp");
	
	var _updateStudentPhoto2 = _interopRequireDefault(_updateStudentPhoto);
	
	var _Student = __webpack_require__("PT2B");
	
	var _Student2 = _interopRequireDefault(_Student);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_REGION_CODE = 'ca';
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    student: state.student
	  };
	};
	
	var DEFAULT_COUNTRY = "Canada";
	
	var DEFAULT_PROVINCE = "British Columbia";
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      formData: {
	        name: {}
	      },
	      customFormData: {},
	      disabledBtn: false
	    };
	
	    _this.submitForm = _this.submitForm.bind(_this);
	    _this.formDataToStudent = _this.formDataToStudent.bind(_this);
	    _this.onFormChange = _this.onFormChange.bind(_this);
	    _this.onCustomDataChange = _this.onCustomDataChange.bind(_this);
	    _this.studentPhotoUploader = _this.studentPhotoUploader.bind(_this);
	    return _this;
	  }
	
	  ModalBody.prototype.componentDidMount = function componentDidMount() {
	    this.studentDataToFormData();
	  };
	
	  // studentData -> formData
	
	
	  ModalBody.prototype.studentDataToFormData = function studentDataToFormData() {
	    var _props = this.props,
	        studentData = _props.studentData,
	        mode = _props.mode;
	
	
	    var formData = {};
	
	    var customFormData = {};
	
	    if (studentData && mode !== 'create') {
	      formData = {
	        name: {
	          firstName: studentData.firstName,
	          lastName: studentData.lastName
	        },
	        gender: studentData.gender,
	        phoneParsed: studentData.phoneParsed.national_number ? studentData.phoneParsed : { country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE },
	        phone: studentData.phone,
	        dob: studentData.dob,
	        profilePhoto: studentData.profilePhoto,
	        email: studentData.email,
	        nickName: studentData.nickName,
	        createdOn: studentData.createdOn,
	        address: {
	          street: studentData.address,
	          unit: studentData.suiteNumber,
	          city: studentData.city,
	          country: studentData.country,
	          province: studentData.province,
	          postalCode: studentData.postalCode
	        },
	        remark: studentData.remark,
	        primaryGuardian: {
	          name: studentData.primaryGuardianName,
	          email: studentData.primaryGuardianEmail,
	          phone: studentData.primaryGuardianPhone,
	          phoneParsed: studentData.primaryGuardianPhoneParsed.national_number ? studentData.primaryGuardianPhoneParsed : { country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE },
	          relationship: studentData.primaryGuardianRelationship
	        },
	        secondaryGuardian: {
	          name: studentData.secondaryGuardianName,
	          email: studentData.secondaryGuardianEmail,
	          phone: studentData.secondaryGuardianPhone,
	          phoneParsed: studentData.secondaryGuardianPhoneParsed.national_number ? studentData.secondaryGuardianPhoneParsed : { country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE },
	          relationship: studentData.secondaryGuardianRelationship
	        },
	        photo: {
	          image: studentData.profilePhoto
	        }
	      };
	
	      customFormData = studentData.customData;
	    } else {
	      formData = {
	        name: { firstName: '', lastName: '' },
	        phone: '1',
	        phoneParsed: { country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE },
	        address: { street: '', unit: '', city: '', province: DEFAULT_PROVINCE, country: DEFAULT_COUNTRY, postalCode: '' },
	        createdOn: (0, _moment2.default)().format('YYYY-MM-DD'),
	        primaryGuardian: { name: '', phone: '1', email: '', relationship: '', phoneParsed: { country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE } },
	        secondaryGuardian: { name: '', phone: '1', email: '', relationship: '', phoneParsed: { country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE } },
	        customData: {}
	      };
	      customFormData = {};
	    }
	
	    this.setState({
	      formData: formData,
	      customFormData: customFormData
	    });
	  };
	
	  // formData -> studentData
	
	
	  ModalBody.prototype.formDataToStudent = function formDataToStudent() {
	    var _state = this.state,
	        formData = _state.formData,
	        customFormData = _state.customFormData;
	
	
	    var newStudentData = _extends({}, formData, {
	
	      firstName: formData.name.firstName,
	      lastName: formData.name.lastName,
	      gender: formData.gender,
	      dob: formData.dob ? (0, _moment2.default)(formData.dob).format('YYYY-MM-DD') : '',
	      phone: formData.phoneParsed.country_code.toString() + formData.phoneParsed.national_number.toString(),
	      profilePhoto: formData.profilePhoto,
	      nickName: formData.nickName,
	      suiteNumber: formData.address.unit,
	      city: formData.address.city,
	      address: formData.address.street,
	      country: formData.address.country,
	      province: formData.address.province,
	      postalCode: formData.address.postalCode,
	      primaryGuardianName: formData.primaryGuardian.name,
	      primaryGuardianEmail: formData.primaryGuardian.email,
	      primaryGuardianPhone: formData.primaryGuardian.phoneParsed.national_number.length > 2 ? formData.primaryGuardian.phoneParsed.country_code + formData.primaryGuardian.phoneParsed.national_number : '',
	      primaryGuardianRelationship: formData.primaryGuardian.relationship,
	      secondaryGuardianName: formData.secondaryGuardian.name,
	      secondaryGuardianEmail: formData.secondaryGuardian.email,
	      secondaryGuardianPhone: formData.secondaryGuardian.phoneParsed.national_number.length > 2 ? formData.secondaryGuardian.phoneParsed.country_code + formData.secondaryGuardian.phoneParsed.national_number : '',
	      secondaryGuardianRelationship: formData.secondaryGuardian.relationship,
	      createdOn: formData.createdOn ? (0, _moment2.default)(formData.createdOn).format('YYYY-MM-DD') : '',
	
	      customData: customFormData
	
	      // delete newStudentData.address
	    });delete newStudentData.name;
	    delete newStudentData.phoneParsed;
	    delete newStudentData.primaryGuardian;
	    delete newStudentData.secondaryGuardian;
	
	    return new _Student2.default(newStudentData);
	  };
	
	  ModalBody.prototype.proceed = function proceed(res, student) {
	    this.props.proceed({
	      result: res.result,
	      student: student
	    });
	  };
	
	  ModalBody.prototype.studentPhotoUploader = function studentPhotoUploader(file, progress, done) {
	    var _this2 = this;
	
	    if (file) {
	      (0, _updateStudentPhoto2.default)(this.props.studentData.id, file).then(function (res) {
	        student.profilePhoto = res.save_to;
	
	        (0, _updateStudentInfo2.default)(_this2.props.studentData.id, student).then(function (res) {
	          _this2.proceed(res, student);
	        }).catch(function () {});
	      });
	      return;
	    }
	  };
	
	  ModalBody.prototype.onFormChange = function onFormChange(formData) {
	    this.setState({
	      formData: _extends({}, this.state.formData, formData)
	    });
	  };
	
	  ModalBody.prototype.onCustomDataChange = function onCustomDataChange(customFormData) {
	    this.setState({
	      customFormData: _extends({}, this.state.customFormData, customFormData)
	    });
	  };
	
	  ModalBody.prototype.submitForm = function submitForm() {
	    var _this3 = this;
	
	    var mode = this.props.mode;
	    var formData = this.state.formData;
	
	
	    this.setState({ disabledBtn: true });
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    var validateResult = this.validate();
	    var customDataValidateResult = this.customDataValidate();
	
	    if (!validateResult.ok || !customDataValidateResult.ok) {
	      this.setState({ disabledBtn: false });
	      return;
	    }
	
	    var convertedStudent = this.formDataToStudent();
	
	    if (mode == 'create') {
	      var studentToCreate = convertedStudent.toFormData('v6');
	
	      if (formData.photo && formData.photo.file) {
	        studentToCreate.photo = formData.photo.file;
	      }
	
	      (0, _registerStudent2.default)(schoolId, studentToCreate).then(function (res) {
	        var studentWithID = new _Student2.default(_extends({
	          id: res.schoolStudentID
	        }, convertedStudent));
	
	        _this3.proceed(res, studentWithID);
	      });
	    } else if (mode == 'update') {
	      var studentUpdated = convertedStudent.toFormData('v5');
	      if (formData.photo.file) {
	        studentUpdated.photo = formData.photo.file;
	      }
	      (0, _updateStudentInfo2.default)(this.props.studentData.id, studentUpdated).then(function (res) {
	        _this3.proceed(res, convertedStudent);
	      });
	    }
	  };
	
	  ModalBody.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props2 = this.props,
	        show = _props2.show,
	        proceed = _props2.proceed,
	        dismiss = _props2.dismiss,
	        cancel = _props2.cancel,
	        mode = _props2.mode;
	    var _state2 = this.state,
	        formData = _state2.formData,
	        customFormData = _state2.customFormData;
	
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    var headerTitle = mode == 'create' ? __('New Student', _locale2.default) : formData.name.firstName + ' ' + formData.name.lastName;
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'create-class-modal',
	        isShowingModal: show,
	
	        onCloseModalClick: dismiss,
	        fixedWidth: 600,
	        overlayColor: '#000',
	
	        hasHeader: true,
	        headerTitle: headerTitle,
	        headerType: 'bold',
	        footerType: 'grey',
	        hasFooter: true,
	
	        getContentRef: function getContentRef(ref) {
	          _this4.modalContentRef = ref;
	        },
	
	        footerButtons: [{
	          title: __('Complete', 'appwrapper'),
	          className: 'btn btn-primary pull-right',
	          onClick: this.submitForm,
	          isDisabled: function isDisabled() {
	            return _this4.state.disabledBtn;
	          }
	        }]
	      },
	      _react2.default.createElement(_ModalContent2.default, _extends({}, this.props, {
	
	        onFormChange: this.onFormChange,
	        onCustomDataChange: this.onCustomDataChange,
	        formData: formData,
	        scrollingContainerRef: this.modalContentRef,
	        customFormData: customFormData,
	        getCustomDataValidationRef: function getCustomDataValidationRef(fn) {
	          _this4.customDataValidate = fn;
	        },
	        getValidationRef: function getValidationRef(fn) {
	          _this4.validate = fn;
	        },
	        studentPhotoUploader: this.studentPhotoUploader
	      }))
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactConfirm.confirmable)(ModalBody));
	module.exports = exports['default'];

/***/ },

/***/ "tu5P":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"create-student-modal-content":"create-student-modal-content","react-tel-input":"react-tel-input"};

/***/ },

/***/ "oJW9":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("YyvE");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _getStudentCustomFields = __webpack_require__("61c/");
	
	var _getStudentCustomFields2 = _interopRequireDefault(_getStudentCustomFields);
	
	var _CheckboxForCustomField = __webpack_require__("yZ7h");
	
	var _CheckboxForCustomField2 = _interopRequireDefault(_CheckboxForCustomField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      customFieldSchema: []
	    };
	    return _this;
	  }
	
	  ModalContent.prototype.componentWillMount = function componentWillMount() {
	    this.loadCustomFieldSchema();
	  };
	
	  ModalContent.prototype.loadCustomFieldSchema = function loadCustomFieldSchema() {
	    var _this2 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    (0, _getStudentCustomFields2.default)(schoolId).then(function (res) {
	      if (res && res.student_fields_setting) {
	        var fields = res.student_fields_setting.fields;
	
	        var customFieldSchema = [];
	
	        fields.map(function (field, index) {
	          var id = field.id,
	              label = field.label,
	              type = field.type,
	              options = field.options,
	              required = field.required;
	
	
	          if (typeof label === 'string' && label.length > 0) {
	            switch (type) {
	              case "text":
	                customFieldSchema.push({ name: id, label: label, type: 'text', required: required });
	                break;
	              case "select":
	                var optionArr = options.map(function (option, i) {
	                  return {
	                    value: option,
	                    label: option
	                  };
	                });
	
	                // add an empty value in the beginning
	                optionArr = [{}].concat(optionArr);
	
	                customFieldSchema.push({
	                  name: id,
	                  required: required,
	                  label: label,
	                  type: 'select',
	                  options: optionArr
	                });
	
	                break;
	              case "checkbox":
	                customFieldSchema.push({
	                  name: id,
	                  label: label,
	                  type: 'custom',
	                  required: required,
	                  component: function component(value, onChange, item, props) {
	                    return _react2.default.createElement(_CheckboxForCustomField2.default, { value: value, onChange: onChange, item: field });
	                  }
	                });
	                break;
	            }
	          }
	        });
	
	        _this2.setState({
	          customFieldSchema: customFieldSchema
	        });
	      }
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  ModalContent.prototype.render = function render() {
	
	    var formSchema = [{
	      name: 'name',
	      label: __('Student Name', _locale2.default),
	      type: 'name',
	      required: true
	    }, {
	      name: 'gender',
	      label: __('Gender', _locale2.default),
	      type: 'gender',
	      required: true
	    }, {
	      name: 'phoneParsed',
	      label: __('Phone', _locale2.default),
	      type: 'phone',
	      required: false,
	      tip: __('Student can use phone number to sign up and log in mobile app', _locale2.default)
	    }, {
	      name: 'photo',
	      label: __('Student Photo', _locale2.default),
	      type: 'imageUploader',
	      options: {
	        aspectRatioHeight: 1,
	        aspectRatioWidth: 1
	      }
	    }, {
	      name: 'dob',
	      label: __('DOB', _locale2.default),
	      type: 'datePicker'
	    }, {
	      name: 'email',
	      label: __('Email', _locale2.default),
	      type: 'email'
	    }, {
	      name: 'nickName',
	      label: __('Preferred Name', _locale2.default),
	      type: 'text'
	    }, {
	      name: 'createdOn',
	      label: __('Created On', _locale2.default),
	      type: 'datePicker'
	    }, {
	      name: 'address',
	      label: __('Address', _locale2.default),
	      type: 'address'
	    }, {
	      name: 'remark',
	      label: __('Remarks', _locale2.default),
	      type: 'textarea'
	    }, {
	      name: 'primaryGuardian',
	      label: __('Primary Guardian', _locale2.default),
	      type: 'guardian'
	    }, {
	      name: 'secondaryGuardian',
	      label: __('Secondary Guardian', _locale2.default),
	      type: 'guardian'
	    }];
	
	    var _props = this.props,
	        formData = _props.formData,
	        onFormChange = _props.onFormChange,
	        customFormData = _props.customFormData,
	        onCustomDataChange = _props.onCustomDataChange,
	        scrollingContainerRef = _props.scrollingContainerRef;
	    var _state = this.state,
	        customFieldSchema = _state.customFieldSchema,
	        fields = _state.fields;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'create-student-modal-content' },
	      _react2.default.createElement(
	        'h3',
	        null,
	        __('Basic Info', _locale2.default)
	      ),
	      _react2.default.createElement(_Form2.default, {
	        onChange: onFormChange,
	        schema: formSchema,
	        formData: formData,
	        formStyle: 'inline',
	        getValidationRef: this.props.getValidationRef,
	        scrollingContainerRef: scrollingContainerRef
	      }),
	      _react2.default.createElement(
	        'h3',
	        null,
	        __('Other Info', _locale2.default)
	      ),
	      _react2.default.createElement(_Form2.default, {
	        onChange: onCustomDataChange,
	        schema: customFieldSchema,
	        formData: customFormData,
	        formStyle: 'inline',
	        getValidationRef: this.props.getCustomDataValidationRef,
	        scrollingContainerRef: scrollingContainerRef
	      })
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "YyvE":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'CreateStudentModal',
	  code: 'CN',
	  text: {
	    'Student Name': '学员姓名',
	    'Gender': '学员性别',
	    'DOB': '学员生日',
	    'Phone': '学员电话',
	    'Email': '学员邮箱',
	    'Preferred Name': '学员昵称',
	    'Created On': '注册时间',
	    'Address': '现居地址',
	    'Remarks': '备注',
	    'Primary Guardian': '家长1',
	    'Secondary Guardian': '家长2',
	    'New Student': '新增学员',
	    'Student Photo': '学员头像',
	
	    'Basic Info': '基本信息',
	    'Other Info': '其他信息',
	    '': '',
	    'Student can use phone number to sign up and log in mobile app': '学生将可以使用手机号注册登录手机 app'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "yZ7h":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <CheckboxForCustomField 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var CheckboxForCustomField = function (_React$Component) {
	  _inherits(CheckboxForCustomField, _React$Component);
	
	  function CheckboxForCustomField(props) {
	    _classCallCheck(this, CheckboxForCustomField);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  CheckboxForCustomField.prototype.componentWillMount = function componentWillMount() {
	    this.strValueToArray(this.props.value);
	  };
	
	  CheckboxForCustomField.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var value = _ref.value;
	
	    if (value) {
	      this.strValueToArray(value);
	    }
	  };
	
	  CheckboxForCustomField.prototype.strValueToArray = function strValueToArray() {
	    var strValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[]';
	
	    if (strValue === '') {
	      strValue = '[]';
	    }
	
	    var value = void 0;
	    if (typeof strValue == "string") {
	      value = JSON.parse(strValue);
	    } else if (Array.isArray(strValue)) {
	      value = strValue;
	    }
	    if (!Array.isArray(value)) {
	      value = value.split(',');
	      //value = [];
	    }
	
	    this.setState({
	      value: value
	    });
	  };
	
	  CheckboxForCustomField.prototype.onChange = function onChange(option) {
	    var _this2 = this;
	
	    return function () {
	      var _state$value = _this2.state.value,
	          value = _state$value === undefined ? [] : _state$value;
	
	
	      var index = value.indexOf(option);
	
	      if (index === -1) {
	        value.push(option);
	      } else {
	        value.splice(index, 1);
	      }
	
	      _this2.props.onChange(JSON.stringify(value));
	    };
	  };
	
	  CheckboxForCustomField.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props$item$options = this.props.item.options,
	        options = _props$item$options === undefined ? [] : _props$item$options;
	    var value = this.state.value;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'CheckboxForCustomField' },
	      options.map(function (option, key) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'form-group', key: key },
	          _react2.default.createElement(
	            'label',
	            { className: 'control' },
	            _react2.default.createElement('input', { type: 'checkbox', value: option, checked: value.indexOf(option) > -1, onClick: _this3.onChange(option) }),
	            _react2.default.createElement('span', { className: 'checkmark' }),
	            option
	          )
	        );
	      })
	    );
	  };
	
	  return CheckboxForCustomField;
	}(_react2.default.Component);
	
	exports.default = CheckboxForCustomField;
	module.exports = exports['default'];

/***/ },

/***/ "aRxi":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Joi$object$keys;
	
	exports.default = registerStudent;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TOKEN = localStorage.getItem('token');
	
	var schema = exports.schema = _joiBrowser2.default.object().keys((_Joi$object$keys = {
	  sFirstName: _joiBrowser2.default.string().required(),
	  sLastName: _joiBrowser2.default.string().required(),
	  sNickName: _joiBrowser2.default.string().allow(''),
	  sGender: _joiBrowser2.default.number().required(),
	  sBirthday: _joiBrowser2.default.string().allow(''),
	  sPhone: _joiBrowser2.default.string().required(),
	  sHomePhone: _joiBrowser2.default.string().allow('', NaN),
	  sEmail: _joiBrowser2.default.string().allow(''),
	  sSource: _joiBrowser2.default.string().allow(''),
	  sSocialID: _joiBrowser2.default.string().allow(''),
	  sParentsName: _joiBrowser2.default.string().allow(''),
	  sGuardianRelation: _joiBrowser2.default.string().allow(''),
	  sCountry: _joiBrowser2.default.string().allow(''),
	  sProvince: _joiBrowser2.default.string().allow(''),
	  sCity: _joiBrowser2.default.string().allow(''),
	  sPostcode: _joiBrowser2.default.string().allow(''),
	  sAddress: _joiBrowser2.default.string().allow(''),
	  sSuitNumber: _joiBrowser2.default.string().allow(''),
	  sRemark: _joiBrowser2.default.string().allow(''),
	  sCreateTime: _joiBrowser2.default.string().allow(''),
	
	  custom_data: _joiBrowser2.default.object(),
	  photo: _joiBrowser2.default.object()
	
	}, _Joi$object$keys['sParentsName'] = _joiBrowser2.default.string().allow(''), _Joi$object$keys['sGuardianRelation'] = _joiBrowser2.default.string().allow(''), _Joi$object$keys.sParentsEmail = _joiBrowser2.default.string().allow(''), _Joi$object$keys.sParentsPhone = _joiBrowser2.default.string().allow(''), _Joi$object$keys.sParents2Name = _joiBrowser2.default.string().allow(''), _Joi$object$keys.sGuardian2Relation = _joiBrowser2.default.string().allow(''), _Joi$object$keys.sParents2Email = _joiBrowser2.default.string().allow(''), _Joi$object$keys.sParents2Phone = _joiBrowser2.default.string().allow(''), _Joi$object$keys));
	
	function registerStudent(schoolId, studentInfo) {
	
	  if (!schoolId) {
	    throw 'missing school ID';
	  }
	
	  var validateResult = _joiBrowser2.default.validate(studentInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, studentInfo);
	
	  // this is to ensure that the error "Column ssAddress cannot be null, I'm not sure where the ssAddress is coming from..."
	  delete toServer.ssAddress;
	
	  if (toServer.photo) {
	    return updateWithUpload(schoolId, toServer);
	  } else {
	    return update(schoolId, toServer);
	  }
	}
	
	function updateWithUpload(schoolId, toServer) {
	
	  var API_URL = void 0;
	  if (false) {
	    API_URL = 'https://saas.classtop.com:3001/sapi';
	  } else {
	    API_URL = 'https://school.classtop.com:3001/sapi';
	  }
	
	  return new Promise(function (resolve, reject) {
	    var data = new FormData();
	
	    _.each(toServer, function (value, name) {
	      if (name === 'photo') {
	        data.append('photo', toServer.photo, 'photo');
	      } else if (name === 'custom_data') {
	        data.append('custom_data', JSON.stringify(value));
	      } else if (typeof value !== 'undefined') {
	        data.append(name, value);
	      }
	    });
	
	    _axios2.default.post(API_URL + '/rgst/' + schoolId + '/', data, {
	      'onUploadProgress': function (_onUploadProgress) {
	        function onUploadProgress(_x) {
	          return _onUploadProgress.apply(this, arguments);
	        }
	
	        onUploadProgress.toString = function () {
	          return _onUploadProgress.toString();
	        };
	
	        return onUploadProgress;
	      }(function (progress) {
	        if (typeof onUploadProgress == 'function') {
	          progress.ratio = progress.loaded / progress.total;
	          onUploadProgress(progress);
	        }
	      }),
	      headers: {
	        'Authorization': 'JWT ' + localStorage.getItem('token'),
	        'Content-Type': 'multipart/form-data'
	      }
	    }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	      console.error(err);
	    });
	  });
	}
	
	function update(schoolId, toServer) {
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/rgst/' + schoolId + '/', 'method': 'POST', 'data': JSON.stringify(toServer), 'token': TOKEN }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "amEp":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _default(studentId, file, _onUploadProgress) {
	  var API_URL = void 0;
	  if (false) {
	    API_URL = 'https://saas.classtop.com:3001/sapi';
	  } else {
	    API_URL = 'https://school.classtop.com:3001/sapi';
	  }
	
	  if (!studentId) {
	    throw 'Missing student ID';
	  }
	
	  if (!file) {
	    throw 'Missing blob';
	  }
	
	  return new Promise(function (resolve, reject) {
	    var data = new FormData();
	    data.append('photo', file, 'cropped');
	    _axios2.default.put(API_URL + '/u_student_photo/' + studentId + '/', data, {
	      'onUploadProgress': function onUploadProgress(progress) {
	        if (typeof _onUploadProgress == 'function') {
	          progress.ratio = progress.loaded / progress.total;
	          _onUploadProgress(progress);
	        }
	      },
	      headers: {
	        'Authorization': 'JWT ' + localStorage.getItem('token'),
	        'Content-Type': 'multipart/form-data'
	      }
	    }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {});
	  });
	} // We're using direct HTTP calls here, skipping Proxy
	exports.default = _default;
	module.exports = exports['default'];

/***/ },

/***/ "ygM2":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"studentInfoDock":"studentInfoDock","dock-header":"dock-header","dock-body":"dock-body","basicInfo":"basicInfo","react-tabs":"react-tabs","react-tabs__tab-list":"react-tabs__tab-list","react-tabs__tab":"react-tabs__tab","react-tabs__tab--selected":"react-tabs__tab--selected","tab-panel-content":"tab-panel-content","studentInfoDockHeader":"studentInfoDockHeader","studentInfoHeaderBtn":"studentInfoHeaderBtn","studentCourseRecord":"studentCourseRecord","classtop-table":"classtop-table","classtop-table-container":"classtop-table-container","util-section":"util-section","icon-angle-down":"icon-angle-down","icon-angle-right":"icon-angle-right","badge":"badge","currentClassHeader":"currentClassHeader","pastClassHeader":"pastClassHeader","icon-tag":"icon-tag","studentTuitionRecord":"studentTuitionRecord","transactionDate":"transactionDate","tuitionClass":"tuitionClass","transactionNumber":"transactionNumber","sendReceipt":"sendReceipt","tuitionYear":"tuitionYear","tutionFilter":"tutionFilter","tuitionSort":"tuitionSort","tuitionCalendar":"tuitionCalendar","tuitionReceipt":"tuitionReceipt","icon-barcode":"icon-barcode","icon-calendar":"icon-calendar","icon-sort-alt-up":"icon-sort-alt-up","icon-folder":"icon-folder","rmp-popup":"rmp-popup","month-picker":"month-picker","rmp-container":"rmp-container"};

/***/ },

/***/ "m8OE":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"btn-link":"btn-link","studentName":"studentName"};

/***/ },

/***/ "n5V7":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NewPayment = __webpack_require__("BztD");
	
	var _NewPayment2 = _interopRequireDefault(_NewPayment);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _reactBootstrap = __webpack_require__("3kvR");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ClassInfoTD
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 		classInfo={classInfo Object}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent table in Student
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ClassInfoTD = function (_React$Component) {
	  _inherits(ClassInfoTD, _React$Component);
	
	  function ClassInfoTD(props) {
	    _classCallCheck(this, ClassInfoTD);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ClassInfoTD.prototype.goToClassDetail = function goToClassDetail() {
	    var classInfo = this.props.classInfo;
	    var classID = classInfo.classID,
	        type = classInfo.type;
	
	    if (type === 0) {
	      _reactRouter.browserHistory.push('/class-detail/' + classID);
	    } else {
	      _reactRouter.browserHistory.push('/class-one-detail/' + classID);
	    }
	  };
	
	  ClassInfoTD.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        student = _props.student,
	        classInfo = _props.classInfo,
	        exitClass = _props.exitClass,
	        enrollStudentToClass = _props.enrollStudentToClass,
	        userId = _props.userId;
	
	
	    if (!classInfo) {
	      return _react2.default.createElement(
	        _R2.default,
	        { can: 'assign_student_to_class', by: 'disable' },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { className: 'btn-link', onClick: function onClick() {
	              enrollStudentToClass();
	            } },
	          __("Join Class", "student")
	        )
	      );
	    }
	
	    var classID = classInfo.classID,
	        type = classInfo.type,
	        className = classInfo.className,
	        classTotalFee = classInfo.classTotalFee,
	        paidTotalFee = classInfo.paidTotalFee;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'class-info-container' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _R2.default,
	          { can: 'read_student_class', by: 'disable' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn-link class-info-name', onClick: function onClick() {
	                return _this2.goToClassDetail();
	              } },
	            className
	          )
	        ),
	        _react2.default.createElement(
	          _R2.default,
	          { can: 'archive_student_from_class', by: 'disable' },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { className: 'btn-link exit-class', onClick: function onClick() {
	                if (paidTotalFee > 0) {
	                  (0, _confirm.confirm)(__('This student has paid tuition, do you wish to refund?', 'studentTable')).then(function () {
	                    (0, _NewPayment2.default)({
	                      student: student,
	                      classInfo: classInfo,
	                      user_id: userId,
	                      paymentType: _NewPayment.REFUND,
	                      confirmTitle: __('Refund & Exit Class', 'classdetail'),
	                      confirmText: __('Proceed to refund and remove the student, {student_name}, from class?', 'classdetail', { student_name: student.sName })
	                    }).then(function () {
	                      exitClass(classInfo, student);
	                    }).catch(function () {});
	                  }).catch(function () {
	                    exitClass(classInfo, student);
	                  });
	                } else {
	                  exitClass(classInfo, student);
	                }
	              } },
	            __("Exit Class", "student")
	          )
	        )
	      )
	    );
	  };
	
	  return ClassInfoTD;
	}(_react2.default.Component);
	
	exports.default = ClassInfoTD;
	module.exports = exports['default'];

/***/ },

/***/ "e/Ic":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ClassStatusTd
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 		classInfo={classInfo Object}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent table in Student
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ClassStatusTd = function (_React$Component) {
	  _inherits(ClassStatusTd, _React$Component);
	
	  function ClassStatusTd(props) {
	    _classCallCheck(this, ClassStatusTd);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ClassStatusTd.prototype._getFeeType = function _getFeeType(classInfo) {
	    return ['per_day', 'per_time', 'per_hour'][classInfo.feeType];
	  };
	
	  ClassStatusTd.prototype.render = function render() {
	    var classInfo = this.props.classInfo;
	
	
	    if (!classInfo) {
	      return _react2.default.createElement('span', null);
	    }
	
	    var feeType = this._getFeeType(classInfo);
	
	    var infoContent = '';
	
	    var needToAlert = false;
	
	    var qty = classInfo.usedTotalQuantity,
	        total = classInfo.paidTotalQuantity;
	
	
	    switch (feeType) {
	      case 'per_day':
	        var days_left = classInfo.days_left,
	            alertRange = classInfo.alertRange;
	
	
	        if (days_left < 0) {
	          days_left = 0;
	        }
	
	        if (days_left > 1) {
	          infoContent = __('{days_left} days remaining', 'student.table', { days_left: days_left });
	        } else if (days_left == 0) {
	          infoContent = __('{days_left} day remaining', 'student.table', { days_left: days_left });
	        } else if (days_left == 1) {
	          infoContent = __('{days_left} day remaining', 'student.table', { days_left: days_left });
	        }
	
	        if (days_left <= alertRange) {
	          needToAlert = true;
	        }
	        break;
	      case 'per_time':
	
	        // if (total == 0 && qty == 0) {
	        //   break;
	        // }
	
	        if (qty > 1) {
	          infoContent = __('{qty} / {total} lessons', 'student.table', { qty: qty, total: total });
	        } else {
	          infoContent = __('{qty} / {total} lesson', 'student.table', { qty: qty, total: total });
	        }
	
	        if (total - qty <= classInfo.alertRange) {
	          needToAlert = true;
	        }
	        break;
	      case 'per_hour':
	        // if (total == 0) {
	        //   break;
	        // }
	
	        if (qty > 1) {
	          infoContent = __('{qty} / {total} hours', 'student.table', { qty: qty, total: total });
	        } else {
	          infoContent = __('{qty} / {total} hour', 'student.table', { qty: qty, total: total });
	        }
	
	        if (total - qty <= classInfo.alertRange) {
	          needToAlert = true;
	        }
	        break;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'td-inner-content' },
	      _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)('class-status', { 'alert-text': needToAlert }) },
	        infoContent
	      )
	    );
	  };
	
	  return ClassStatusTd;
	}(_react2.default.Component);
	
	exports.default = ClassStatusTd;
	module.exports = exports['default'];

/***/ },

/***/ "PhAh":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = enrollStudentToClass;
	
	var _EnrollClass = __webpack_require__("0dt0");
	
	var _EnrollClass2 = _interopRequireDefault(_EnrollClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function enrollStudentToClass(students, cb) {
	  var _this = this;
	
	  (0, _EnrollClass2.default)({ students: students }).then(function (_ref) {
	    var updateStudentTableRequired = _ref.updateRequired;
	
	    if (updateStudentTableRequired) {
	      var _props = _this.props,
	          studentState = _props.studentState,
	          student = _props.student;
	
	
	      student.fetchStudent('After editing classes @enroll-student-to-class', studentState);
	    }
	  }).catch(function (err) {
	    console.error(err);
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "YFf2":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exitClass;
	
	var _removeStudentFromClass = __webpack_require__("3og2");
	
	var _removeStudentFromClass2 = _interopRequireDefault(_removeStudentFromClass);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	// handle exitclass function in student table
	//
	// NOTE: 'this' here is bind to a TabComponent (eg. DefaultTab) where unmodified students state is stored.
	// 
	function exitClass(_ref, _ref2) {
	  var _this = this;
	
	  var classIDToRemove = _ref.classID,
	      className = _ref.className;
	  var schoolStudentID = _ref2.schoolStudentID,
	      sName = _ref2.sName;
	
	  (0, _confirm.confirm)(__('Remove "{sName}" From "{className}"?', 'student', { className: className, sName: sName }), __('Exit Class', 'student')).then(function () {
	    _this.setState({
	      fetching: true
	    });
	
	    // STEP 2. use controller to call backend
	    (0, _removeStudentFromClass2.default)(classIDToRemove, schoolStudentID).then(function (res) {
	      var studentState = _this.props.studentState;
	
	      _alert.alert.success(__('The student {student_name} has been removed from the class.', 'student', { student_name: sName }), __('Exit Class Successful', 'student')).then(function () {
	        _this.props.student.fetchStudent('after student removed by ctrl @exitClass', studentState);
	      });;
	    }).catch(function (err) {
	      console.error(err);
	    });
	  }).catch(function (err) {
	    console.error(err);
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "3og2":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStudentFromClass;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	var _updateClassStudentState = __webpack_require__("97kv");
	
	var _updateClassStudentState2 = _interopRequireDefault(_updateClassStudentState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// remove student from class
	//
	function removeStudentFromClass(classId, studentId) {
	
	  if (typeof classId != "number" || typeof studentId != "number") {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing or wrong type of params: classId:number, studentId:number')
	      });
	    });
	  }
	
	  return (0, _updateClassStudentState2.default)(classId, studentId, "not_enrolled");
	}
	module.exports = exports["default"];

/***/ },

/***/ "qP8b":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = refundClass;
	
	var _NewPayment = __webpack_require__("BztD");
	
	var _NewPayment2 = _interopRequireDefault(_NewPayment);
	
	var _alert = __webpack_require__("BGi1");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	// refund class
	//
	// NOTE: 'this' here is bind to a TabComponent (eg. DefaultTab) where unmodified students state is stored.
	//
	function refundClass(_ref) {
	  var _this = this;
	
	  var student = _ref.trData;
	  var _props = this.props,
	      user = _props.user,
	      studentState = _props.studentState;
	
	
	  var user_id = user.result.user_id;
	
	  (0, _NewPayment2.default)({ student: student, user_id: user_id, paymentType: _NewPayment.REFUND }).then(function (_ref2) {
	    var success = _ref2.success;
	
	    if (success) {
	      _this.props.student.fetchStudent('after refund was made', studentState);
	    }
	  }).catch(function (err) {
	    console.error(err);
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "JMLs":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (_ref) {
	  var _this = this;
	
	  var studentToUnarchive = _ref.trData;
	  var sName = studentToUnarchive.sName;
	
	
	  (0, _confirm.confirm)(__('Proceed to restore student: {name}？', 'student', { name: sName }), __('Restore', 'teacher')).then(function () {
	    var schoolStudentID = studentToUnarchive.schoolStudentID;
	    var _props$student = _this.props.student,
	        fetchStudent = _props$student.fetchStudent,
	        unarchiveStudent = _props$student.unarchiveStudent;
	
	
	    unarchiveStudent('@unarchive-student', schoolStudentID);
	  }).catch(function (err) {});
	};
	
	var _confirm = __webpack_require__("yMGN");
	
	//
	// Handles unarchive Student when user clicks "unarchive" from "options" dropdown
	//
	// TO THINK: this is almost a duplicate as archive-student. It's against the DRY.
	// Should we do somehting about it? Or just keep it this way for simplicity?
	//
	module.exports = exports['default'];

/***/ },

/***/ "PWBe":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = payment;
	
	var _NewPayment = __webpack_require__("BztD");
	
	var _NewPayment2 = _interopRequireDefault(_NewPayment);
	
	var _alert = __webpack_require__("BGi1");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Open payment Modal
	// NOTE: 'this' here is a TabComponent (eg. DefaultTab)
	function payment(_ref) {
	  var student = _ref.trData;
	  var _props = this.props,
	      user = _props.user,
	      studentState = _props.studentState;
	  var fetchStudent = this.props.student.fetchStudent;
	
	
	  (0, _NewPayment2.default)({ student: student, user_id: user.result.user_id, paymentType: _NewPayment.ADD_CREDIT }).then(function (_ref2) {
	    var success = _ref2.success;
	
	    if (success == true) {
	      fetchStudent('After payment is successful', studentState);
	    }
	  }).catch(function (err) {
	    console.error(err);
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "S5pW":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"student-panel":"student-panel","setting-section":"setting-section","filter-by":"filter-by","setting-dropdown":"setting-dropdown","student-dropdown":"student-dropdown","dropdown-menu":"dropdown-menu","tab-list":"tab-list","icon-tag":"icon-tag","notice-alert":"notice-alert","sort-by":"sort-by","sort-by-label":"sort-by-label"};

/***/ },

/***/ "u5QA":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <PaymentTd
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		data={entire Row data including student info}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Table in Student
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	//
	
	var PaymentTd = function (_React$Component) {
		_inherits(PaymentTd, _React$Component);
	
		function PaymentTd(props) {
			_classCallCheck(this, PaymentTd);
	
			return _possibleConstructorReturn(this, _React$Component.call(this, props));
		}
	
		PaymentTd.prototype.render = function render() {
			if (!this.props.classInfo) {
				return _react2.default.createElement('div', null);
			}
	
			var paidTotalFee = this.props.classInfo.paidTotalFee;
	
	
			return _react2.default.createElement(
				'div',
				{ className: 'td-inner-content' },
				_react2.default.createElement(
					'span',
					{ className: (0, _classnames2.default)({ 'alert-text': paidTotalFee === 0 }) },
					'$' + paidTotalFee
				)
			);
		};
	
		return PaymentTd;
	}(_react2.default.Component);
	
	exports.default = PaymentTd;
	module.exports = exports['default'];

/***/ },

/***/ "A9k/":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"student-table":"student-table","student-info":"student-info","student-info-container":"student-info-container","portrait":"portrait","hasPhoto":"hasPhoto","text-container":"text-container","name":"name","class-info":"class-info","class-info-container":"class-info-container","class-info-name":"class-info-name","exit-class":"exit-class","alert-text":"alert-text","expand-folded-classes-button":"expand-folded-classes-button","button-text":"button-text"};

/***/ },

/***/ "Qttv":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.selectStudent = selectStudent;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SELECT_MULTIPLE_STUDENT:
	      {
	        return _extends({}, state, {
	          multiSelectedStudents: action.students
	        });
	      }
	    default:
	      return state;
	  }
	};
	
	// calling both current and archived teacher
	var SELECT_MULTIPLE_STUDENT = exports.SELECT_MULTIPLE_STUDENT = 'SELECT_MULTIPLE_STUDENT';
	
	function selectStudent(students) {
	  return {
	    type: SELECT_MULTIPLE_STUDENT,
	    students: students
	  };
	}
	
	//
	var initState = {
	  multiSelectedStudents: []
	};

/***/ },

/***/ "etGk":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "student@2x.f420bcbf.png";

/***/ },

/***/ "tfRU":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "student_en@2x.7afdc82a.png";

/***/ },

/***/ "7No8":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__("3kvR");
	
	var _reactReduxHotline = __webpack_require__("IKa1");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _EnrollClass = __webpack_require__("0dt0");
	
	var _EnrollClass2 = _interopRequireDefault(_EnrollClass);
	
	var _Export = __webpack_require__("M4e5");
	
	var _Export2 = _interopRequireDefault(_Export);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _UI = __webpack_require__("OM1Z");
	
	__webpack_require__("S5pW");
	
	var _iPadGuide = __webpack_require__("hUsB");
	
	var _iPadGuide2 = _interopRequireDefault(_iPadGuide);
	
	var _alert = __webpack_require__("BGi1");
	
	var _DefaultTab = __webpack_require__("+mk/");
	
	var _DefaultTab2 = _interopRequireDefault(_DefaultTab);
	
	var _FilterBy = __webpack_require__("SdD8");
	
	var _FilterBy2 = _interopRequireDefault(_FilterBy);
	
	var _CreateStudent = __webpack_require__("yvp6");
	
	var _CreateStudent2 = _interopRequireDefault(_CreateStudent);
	
	var _locale = __webpack_require__("aMEQ");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _subscription = __webpack_require__("ue3W");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Student />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is student page. Mostly it only comprises of Tabs. It handles
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * UI redux to record the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since caspian
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent routes
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @redux
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var DEFAULT_TAB_INDEX = 0;
	
	var Student = function (_React$Component) {
	  _inherits(Student, _React$Component);
	
	  function Student(props) {
	    _classCallCheck(this, Student);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      tabIndex: DEFAULT_TAB_INDEX,
	      filterData: {
	        searchKeyword: _this.props.student.searchStudentKeyword || ''
	      },
	      orderBy: 0
	    };
	
	    _this.onSearch = _this.onSearch.bind(_this);
	
	    _this._onSelectTab = _this._onSelectTab.bind(_this);
	    _this._enrollMultipleStudentsToClass = _this._enrollMultipleStudentsToClass.bind(_this);
	    _this._archiveMultipleStudents = _this._archiveMultipleStudents.bind(_this);
	    _this.exportStudentList = _this.exportStudentList.bind(_this);
	    return _this;
	  }
	
	  Student.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var dispatch = this.props.dispatch;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    if (this.props.student.currentCount && this.props.student.currentCount !== nextProps.student.currentCount) {
	      dispatch((0, _subscription.getSubscription)(schoolId));
	    }
	  };
	
	  Student.prototype.onSearch = function onSearch(_ref) {
	    var _this2 = this;
	
	    var filterData = _ref.filterData;
	    var studentState = this.props.student.studentState;
	    var orderBy = this.state.orderBy;
	
	
	    this.setState({
	      filterData: filterData
	    }, function () {
	      _this2.props.student.fetchStudent('@onSearch()', studentState, {}, filterData.searchKeyword, orderBy);
	    });
	  };
	
	  Student.prototype._enrollMultipleStudentsToClass = function _enrollMultipleStudentsToClass() {
	    var _this3 = this;
	
	    var student = this.props.student;
	    var orderBy = this.state.orderBy;
	    var studentSelectedByCheckbox = student.studentSelectedByCheckbox,
	        studentState = student.studentState;
	
	
	    (0, _EnrollClass2.default)({ students: studentSelectedByCheckbox }).then(function (_ref2) {
	      var updateStudentTableRequired = _ref2.updateRequired;
	
	      if (updateStudentTableRequired) {
	        student.fetchStudent('After editing classes @enroll-student-to-class', studentState, {}, '', orderBy);
	        _this3.forceUpdate();
	      }
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  Student.prototype._archiveMultipleStudents = function _archiveMultipleStudents() {
	    var student = this.props.student;
	
	
	    student.archiveMultipleSelectedStudents();
	  };
	
	  Student.prototype._onSelectTab = function _onSelectTab(tabIndex) {
	    this.setState({
	      filterData: _extends({}, this.state.filterData, {
	        searchKeyword: this.props.student.searchStudentKeyword || ''
	      }),
	      tabIndex: tabIndex
	    });
	  };
	
	  Student.prototype.exportStudentList = function exportStudentList(format) {
	    (0, _Export2.default)({
	      type: 'student',
	      title: 'Export Student List',
	      format: format
	    });
	  };
	
	  Student.prototype.renderAddStudentButton = function renderAddStudentButton() {
	    var _this4 = this;
	
	    var gSubscription = this.props.gSubscription;
	    var _gSubscription$result = gSubscription.result,
	        maximum_amount = _gSubscription$result.maximum_amount,
	        existing_amount = _gSubscription$result.existing_amount,
	        saas_version = _gSubscription$result.saas_version,
	        is_valid = _gSubscription$result.is_valid;
	    var maximum_student = maximum_amount.maximum_student;
	    var student_amount = existing_amount.student_amount;
	    var orderBy = this.state.orderBy;
	
	
	    return _react2.default.createElement(
	      _R2.default,
	      { can: 'create_student', by: 'disable' },
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary', onClick: function onClick() {
	            if (is_valid && (saas_version === 1 || maximum_student === null || student_amount < maximum_student)) {
	              (0, _CreateStudent2.default)({ mode: 'create' }).then(function (_ref3) {
	                var result = _ref3.result,
	                    student = _ref3.student;
	
	                if (result === 'success') {
	                  var studentState = _this4.props.student.studentState;
	
	                  _this4.props.student.fetchStudent('after edit student', studentState, {}, '', orderBy);
	                }
	              }).catch(function () {});
	            } else {
	              _alert.alert.message(__('You are about go over the student limit, please upgrade to higher subscription plan to add more students', 'header'), __('Upgrade Subscription Plan', 'header'));
	            }
	          } },
	        __("New Student", "student")
	      )
	    );
	  };
	
	  Student.prototype.render = function render() {
	    var _this5 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _props = this.props,
	        student = _props.student,
	        gSubscription = _props.gSubscription;
	    var currentCount = student.currentCount,
	        studentList = student.studentList,
	        fetching = student.fetching,
	        studentState = student.studentState;
	    var _state = this.state,
	        tabIndex = _state.tabIndex,
	        filterData = _state.filterData,
	        orderBy = _state.orderBy;
	
	    var Filter = _react2.default.createElement(_FilterBy2.default, {
	      filterData: filterData,
	      filters: ['text:searchKeyword'],
	      options: {
	        'text:searchKeyword': {
	          placeholder: __('Search name...', 'student'),
	          valueMinLength: 2
	        }
	      },
	      disabled: fetching,
	      schoolId: schoolId,
	      onChange: this.onSearch });
	
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      { className: 'student-panel' },
	      _react2.default.createElement(
	        'div',
	        null,
	        __("Student List", "student")
	      ),
	      _react2.default.createElement(
	        _UI.Tabs,
	        { defaultIndex: DEFAULT_TAB_INDEX, onSelect: this._onSelectTab },
	        _react2.default.createElement(
	          _UI.TabList,
	          { id: 'tab-list' },
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __("Registered", "student"),
	            studentState == 'all_not_archived' && fetching !== true && _react2.default.createElement(
	              _UI.CountBadge,
	              null,
	              currentCount
	            )
	          ),
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __("Not Enrolled", "student"),
	            studentState == 'not_enrolled' && fetching !== true && _react2.default.createElement(
	              _UI.CountBadge,
	              null,
	              currentCount
	            )
	          ),
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __("Enrolled", "student"),
	            studentState == 'enrolled' && fetching !== true && _react2.default.createElement(
	              _UI.CountBadge,
	              null,
	              currentCount
	            )
	          ),
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __("Pending Renewal", "student"),
	            studentState == 'pending_renewal' && fetching !== true && _react2.default.createElement(
	              _UI.CountBadge,
	              null,
	              currentCount
	            )
	          ),
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __("Archived", _locale2.default),
	            studentState == 'archived' && fetching !== true && _react2.default.createElement(
	              _UI.CountBadge,
	              null,
	              currentCount
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'setting-section pull-right' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sort-by-label' },
	              __('Sort by', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'select',
	              { className: 'form-control sort-by',
	                onChange: function onChange(e) {
	                  _this5.props.student.fetchStudent('@onSearch()', studentState, {}, filterData.searchKeyword, e.target.value);
	                } },
	              _react2.default.createElement(
	                'option',
	                { key: '0', value: '0' },
	                __('Creation Time: Newest to Oldest', _locale2.default)
	              ),
	              _react2.default.createElement(
	                'option',
	                { key: '5', value: '5' },
	                __('Creation Time: Oldest to Newest', _locale2.default)
	              ),
	              _react2.default.createElement(
	                'option',
	                { key: '1', value: '1' },
	                __('Last Name: A-Z', _locale2.default)
	              ),
	              _react2.default.createElement(
	                'option',
	                { key: '2', value: '2' },
	                __('Last Name: Z-A', _locale2.default)
	              ),
	              _react2.default.createElement(
	                'option',
	                { key: '3', value: '3' },
	                __('First Name: A-Z', _locale2.default)
	              ),
	              _react2.default.createElement(
	                'option',
	                { key: '4', value: '4' },
	                __('First Name: Z-A', _locale2.default)
	              )
	            ),
	            Filter,
	            !gSubscription.fetching && this.renderAddStudentButton(),
	            _react2.default.createElement(
	              _reactBootstrap.Dropdown,
	              { id: 'setting-dropdown' },
	              _react2.default.createElement(
	                _reactBootstrap.Dropdown.Toggle,
	                { className: 'expand-to-right expand-to-down' },
	                _react2.default.createElement('i', { className: 'fa icon-cog', style: { marginRight: 5 } })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Dropdown.Menu,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.MenuItem,
	                  { eventKey: 'student-settings', onSelect: function onSelect() {
	                      _reactRouter.browserHistory.push('/student-settings');
	                    }, disabled: !(0, _R.userCan)('edit_school_setting') },
	                  __('Student Custom Fields', 'studentTable')
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.MenuItem,
	                  { eventKey: 'export-student', onSelect: function onSelect() {
	                      return _reactRouter.browserHistory.push('/import-student');
	                    }, disabled: !(0, _R.userCan)('create_student') || !(0, _R.userCan)('edit_school_setting') },
	                  __('Import Students', 'studentTable')
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.MenuItem,
	                  { eventKey: 'export-student', onSelect: function onSelect() {
	                      return _this5.exportStudentList('excel');
	                    }, disabled: !(0, _R.userCan)('export_student') },
	                  __('Export Student List to Excel', 'teacherAttendance')
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.MenuItem,
	                  { eventKey: 'export-student', onSelect: function onSelect() {
	                      return _this5.exportStudentList('csv');
	                    }, disabled: !(0, _R.userCan)('export_student') },
	                  __('Export Student List to CSV', 'teacherAttendance')
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.MenuItem,
	                  { eventKey: 'export-student', onSelect: function onSelect() {
	                      (0, _iPadGuide2.default)();
	                    } },
	                  __("Registration Guide", "student")
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { studentState: 'all_not_archived', orderBy: orderBy, filterData: filterData })
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { studentState: 'not_enrolled', orderBy: orderBy, filterData: filterData })
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { studentState: 'enrolled', orderBy: orderBy, filterData: filterData })
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { studentState: 'pending_renewal', orderBy: orderBy, filterData: filterData })
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { studentState: 'archived', orderBy: orderBy, filterData: filterData })
	        )
	      )
	    );
	  };
	
	  return Student;
	}(_react2.default.Component);
	
	exports.default = (0, _reactReduxHotline.hotline)(Student, 'student', 'gSubscription');
	module.exports = exports['default'];

/***/ },

/***/ "hUsB":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("rLEJ");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "rLEJ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("/U5E");
	
	var _ModalContent = __webpack_require__("7dMR");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'ipadguide-modal',
	        hasHeader: true
	        // hasFooter={true}
	
	        , headerTitle: __("Self-registration Setup", "student"),
	        headerIcon: 'fa icon-tablet',
	        fixedWidth: 743,
	        contentHeight: 490,
	        onCloseModalClick: dismiss,
	
	        footerType: 'grey',
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, null)
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "/U5E":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ipadguide-modal":"ipadguide-modal","classtop-modal-content":"classtop-modal-content","guide-container":"guide-container","part-one":"part-one","part-two":"part-two","step-one":"step-one","step-two":"step-two","step-three":"step-three","step-four":"step-four","part-two-step-one":"part-two-step-one","part-one-steps":"part-one-steps","part-one-header":"part-one-header","part-two-first-header":"part-two-first-header","part-one-body":"part-one-body","part-two-body":"part-two-body","part-one-image":"part-one-image","part-two-steps":"part-two-steps","part-two-header":"part-two-header","guided-ul":"guided-ul","guided-ol":"guided-ol"};

/***/ },

/***/ "7dMR":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("/U5E");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	//;
	
	
	var locale = {
	  id: 'RegistrationGuideContent',
	  code: 'CN',
	  text: {
	    'Enter your phone number and password, and then select the school to enter the student registration page': '填写手机号与密码，登陆后请选择相应学校进入学生注册页面',
	    'After your student has been registered successfully, student information will be saved and displayed on the student page': '学生注册成功后，信息会存入您学校的学生列表里同时为您建立新学员。'
	  }
	};
	var language = localStorage.getItem('language');
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent() {
	    _classCallCheck(this, ModalContent);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalContent.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'custom-modal-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container-fluid guide-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'part-one' },
	          _react2.default.createElement(
	            'div',
	            { className: 'step-one' },
	            _react2.default.createElement(
	              'div',
	              { className: 'part-one-steps' },
	              __('Step One', 'student')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-one-header' },
	              __('Enter Self-registration Address on Your Tablet Device', 'student')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-one-body' },
	              __('Open any browser (Safari, Chrome, Firefox) on your tablet device and enter the following URL ', 'student'),
	              _react2.default.createElement(
	                'a',
	                { className: 'register-link', href: 'http://register.classtop.com', target: '_blank' },
	                'register.classtop.com'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-one-image' },
	              _react2.default.createElement('img', { src: __webpack_require__("bjIW") })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'step-two' },
	            _react2.default.createElement(
	              'div',
	              { className: 'part-one-steps' },
	              __('Step Two', 'student')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-one-header' },
	              __('Log In to Your School', 'student')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-one-body' },
	              __('Enter your phone number and password, and then select the school to enter the student registration page', locale)
	            ),
	            _react2.default.createElement('div', { className: 'part-one-image' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'step-three' },
	            _react2.default.createElement(
	              'div',
	              { className: 'part-one-steps' },
	              __('Step Three', 'student')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-one-header' },
	              __('Enter Student Information', 'student')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-one-body' },
	              __('After your student has been registered successfully, student information will be saved and displayed on the student page', locale)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-one-image' },
	              _react2.default.createElement('img', { src: __webpack_require__(language === 'EN' ? "WoqI" : "WoqI") })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'part-two' },
	          _react2.default.createElement(
	            'div',
	            { className: 'part-two-first-header' },
	            __('Privacy Setting (only on iPad)', 'student')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'part-two-body' },
	            __('If you do not wish others to change your account information, you could setup privacy setting on your iPad by following the steps below: ', 'student')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'part-two-step-one' },
	            _react2.default.createElement(
	              'div',
	              { className: 'part-two-steps' },
	              __('Step One', 'student')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-two-header' },
	              __("On your iPad, press 'Settings' > 'General' > 'Accessibility' > 'Guided Access' to set up Guided Access, you could do the following: ", 'student')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-two-body' },
	              _react2.default.createElement(
	                'ul',
	                { className: 'guided-ul' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  __('• Turn on/off Guided Access', 'student')
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  __('• Setup passcode for Guided Access, such as preventing others from exiting the application', 'student')
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  __('• Setup time limits so the application will be disabled once the time expires', 'student')
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'step-two' },
	            _react2.default.createElement(
	              'div',
	              { className: 'part-two-steps' },
	              __('Step Two', 'student')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-two-header' },
	              __("To enable Guided Access, please follow the steps below: ", 'student')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-two-body' },
	              _react2.default.createElement(
	                'ol',
	                { className: 'guided-ol' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  __('1. Open the application', 'student')
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  __('2. Press Home Button three times', 'student')
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  __("3. Enter the passcode, set up Guided Access, and then press 'Start'", 'student')
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'step-three' },
	            _react2.default.createElement(
	              'div',
	              { className: 'part-two-steps' },
	              __('Step Three', 'student')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-two-header' },
	              __("You could use Guided Access to control the application, such as disabling areas of the screen that aren’t relevant to a task, or areas where an accidental gesture might cause a distraction. Please follow the steps below: ", 'student')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-two-header' },
	              __("You could use Guided Access to control the application, such as disabling areas of the screen that aren’t relevant to a task, or areas where an accidental gesture might cause a distraction. Please follow the steps below: ", 'student')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-two-body' },
	              _react2.default.createElement(
	                'ol',
	                { className: 'guided-ol' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  __('1. Circle areas of the screen', 'student')
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  __('2. Adjust the areas by dragging the circle', 'student')
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-two-header' },
	              __("To disable any screen interaction, please turn off the Touch button", 'student'),
	              _react2.default.createElement('br', null),
	              __("To disable screen lock in the application or any motion, press the 'Hardware Buttons' and turn off 'Motion' button", 'student')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'step-four' },
	            _react2.default.createElement(
	              'div',
	              { className: 'part-two-steps' },
	              __('Step Four', 'student')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-two-header' },
	              __("If Touch ID is enabled on your iPad, then it could be used to end Guided Access. Go to 'Settings' > 'General' > 'Accessibility' > 'Guided Access' > 'Passcode Settings'and turn on the Touch ID button. Now you could do the following steps to end Guided Access", 'student')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-two-body' },
	              _react2.default.createElement(
	                'ol',
	                { className: 'guided-ol' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  __('1. Press the Home Button', 'student')
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  __('2. Use Touch ID', 'student')
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-two-header' },
	              __("If Touch ID is disabled on your iPad, you can end the Guided Access by the following steps", 'student')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'part-two-body' },
	              _react2.default.createElement(
	                'ol',
	                { className: 'guided-ol' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  __('1. Press the Home Button three times', 'student')
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  __("2. Enter the passcode and press 'End'", 'student')
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "bjIW":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "iPadGuide1@2x.e9be4be7.png";

/***/ },

/***/ "WoqI":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "iPadGuide2@2x.ee924883.png";

/***/ },

/***/ "yChA":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // importing actions
	
	
	exports.default = teacherInfo;
	
	var _fetchTeacherInfo = __webpack_require__("2xNr");
	
	function teacherInfo(state, action) {
	  switch (action.type) {
	
	    // Fetching
	    case _fetchTeacherInfo.START_FETCH_TEACHER_INFO:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case _fetchTeacherInfo.SUCCESS_FETCH_TEACHER_INFO:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case _fetchTeacherInfo.FAILED_FETCH_TEACHER_INFO:
	      {
	        var _action$payload = action.payload,
	            error = _action$payload.error,
	            fetching = _action$payload.fetching,
	            hasPermission = _action$payload.hasPermission;
	
	
	        return _extends({}, state, { error: error, hasPermission: hasPermission, fetching: fetching });
	      }
	
	    default:
	      return _extends({}, state);
	  }
	}
	module.exports = exports['default'];

/***/ },

/***/ "2xNr":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_FETCH_TEACHER_INFO = exports.SUCCESS_FETCH_TEACHER_INFO = exports.START_FETCH_TEACHER_INFO = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchTeacherInfo = fetchTeacherInfo;
	
	var _getTeacherStatus = __webpack_require__("Eu4U");
	
	var _getTeacherStatus2 = _interopRequireDefault(_getTeacherStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var START_FETCH_TEACHER_INFO = exports.START_FETCH_TEACHER_INFO = 'START_FETCH_TEACHER_INFO';
	var SUCCESS_FETCH_TEACHER_INFO = exports.SUCCESS_FETCH_TEACHER_INFO = 'SUCCESS_FETCH_TEACHER_INFO';
	var FAILED_FETCH_TEACHER_INFO = exports.FAILED_FETCH_TEACHER_INFO = 'FAILED_FETCH_TEACHER_INFO';
	
	function fetchTeacherInfo(teacherId, state, callback) {
	
	  return function (dispatch) {
	
	    dispatch({
	      type: START_FETCH_TEACHER_INFO,
	      payload: {
	        fetching: true,
	        teacherState: state
	      }
	    });
	
	    (0, _getTeacherStatus2.default)(teacherId, state).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_TEACHER_INFO,
	        payload: _extends({}, result, { fetching: false, hasPermission: true })
	      });
	
	      if (typeof callback == 'function') {
	        callback();
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_TEACHER_INFO,
	        payload: { err: err, hasPermission: false, fetching: false }
	      });
	    });
	  };
	}

/***/ },

/***/ "+uPl":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // importing actions
	
	
	exports.default = contactInfo;
	
	var _fetchContactInfo = __webpack_require__("LP1D");
	
	function contactInfo(state, action) {
	  switch (action.type) {
	
	    // Fetching
	    case _fetchContactInfo.START_FETCH_CONTACT_INFO:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case _fetchContactInfo.SUCCESS_FETCH_CONTACT_INFO:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case _fetchContactInfo.FAILED_FETCH_CONTACT_INFO:
	      {
	        var _action$payload = action.payload,
	            error = _action$payload.error,
	            fetching = _action$payload.fetching,
	            hasPermission = _action$payload.hasPermission;
	
	
	        return _extends({}, state, { error: error, hasPermission: hasPermission, fetching: fetching });
	      }
	
	    default:
	      return _extends({}, state);
	  }
	}
	module.exports = exports['default'];

/***/ },

/***/ "LP1D":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_FETCH_CONTACT_INFO = exports.SUCCESS_FETCH_CONTACT_INFO = exports.START_FETCH_CONTACT_INFO = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchContactInfo = fetchContactInfo;
	
	var _getClientDetail = __webpack_require__("3heM");
	
	var _getClientDetail2 = _interopRequireDefault(_getClientDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var START_FETCH_CONTACT_INFO = exports.START_FETCH_CONTACT_INFO = 'START_FETCH_CONTACT_INFO';
	var SUCCESS_FETCH_CONTACT_INFO = exports.SUCCESS_FETCH_CONTACT_INFO = 'SUCCESS_FETCH_CONTACT_INFO';
	var FAILED_FETCH_CONTACT_INFO = exports.FAILED_FETCH_CONTACT_INFO = 'FAILED_FETCH_CONTACT_INFO';
	
	function fetchContactInfo(contactId, callback) {
	
	  return function (dispatch) {
	
	    dispatch({
	      type: START_FETCH_CONTACT_INFO,
	      payload: {
	        fetching: true
	      }
	    });
	
	    (0, _getClientDetail2.default)(contactId).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_CONTACT_INFO,
	        payload: _extends({}, result, { fetching: false, hasPermission: true })
	      });
	
	      if (typeof callback == 'function') {
	        callback();
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_CONTACT_INFO,
	        payload: { err: err, hasPermission: false, fetching: false }
	      });
	    });
	  };
	}

/***/ },

/***/ "vA13":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // importing actions
	
	
	exports.default = contactNotes;
	
	var _fetchContactNotes = __webpack_require__("YC01");
	
	var _addContactNotes = __webpack_require__("ayZH");
	
	var _deleteContactNotes = __webpack_require__("dCVY");
	
	function contactNotes(state, action) {
	  switch (action.type) {
	
	    // Fetching
	    case _fetchContactNotes.START_FETCH_CONTACT_NOTES:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case _fetchContactNotes.SUCCESS_FETCH_CONTACT_NOTES:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case _fetchContactNotes.FAILED_FETCH_CONTACT_NOTES:
	      {
	        var _action$payload = action.payload,
	            error = _action$payload.error,
	            fetching = _action$payload.fetching,
	            hasPermission = _action$payload.hasPermission;
	
	
	        return _extends({}, state, { error: error, hasPermission: hasPermission, fetching: fetching });
	      }
	
	    // Adding
	    case _addContactNotes.START_ADD_CONTACT_NOTES:
	      {
	        var params = action.payload.params;
	
	        return _extends({}, state);
	      }
	    case _addContactNotes.SUCCESS_ADD_CONTACT_NOTES:
	      {
	        return _extends({}, state);
	      }
	    case _addContactNotes.FAILED_ADD_CONTACT_NOTES:
	      {
	        return _extends({}, state, { err: action.payload });
	      }
	
	    // deleting
	    case _deleteContactNotes.START_DELETE_CONTACT_NOTES:
	      {
	        var index = action.payload.index;
	
	
	        return _extends({}, state, {
	          result_list: [].concat(state.result_list.slice(0, index), state.result_list.slice(index + 1))
	        });
	      }
	
	    // Updating
	    case _addContactNotes.START_UPDATE_CONTACT_NOTES:
	      {
	        var _params = action.payload.params;
	
	        return _extends({}, state);
	      }
	    case _addContactNotes.SUCCESS_UPDATE_CONTACT_NOTES:
	      {
	        return _extends({}, state);
	      }
	    case _addContactNotes.FAILED_UPDATE_CONTACT_NOTES:
	      {
	        return _extends({}, state, { err: action.payload });
	      }
	
	    default:
	      return _extends({}, state);
	  }
	}
	module.exports = exports['default'];

/***/ },

/***/ "YC01":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_FETCH_CONTACT_NOTES = exports.SUCCESS_FETCH_CONTACT_NOTES = exports.START_FETCH_CONTACT_NOTES = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchContactNotes = fetchContactNotes;
	
	var _fetchContactNotesList = __webpack_require__("KF19");
	
	var _fetchContactNotesList2 = _interopRequireDefault(_fetchContactNotesList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var START_FETCH_CONTACT_NOTES = exports.START_FETCH_CONTACT_NOTES = 'START_FETCH_CONTACT_NOTES';
	var SUCCESS_FETCH_CONTACT_NOTES = exports.SUCCESS_FETCH_CONTACT_NOTES = 'SUCCESS_FETCH_CONTACT_NOTES';
	var FAILED_FETCH_CONTACT_NOTES = exports.FAILED_FETCH_CONTACT_NOTES = 'FAILED_FETCH_CONTACT_NOTES';
	
	function fetchContactNotes(contactId, callback) {
	
	  return function (dispatch) {
	
	    dispatch({
	      type: START_FETCH_CONTACT_NOTES,
	      payload: {
	        fetching: true
	      }
	    });
	
	    (0, _fetchContactNotesList2.default)(contactId).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_CONTACT_NOTES,
	        payload: _extends({}, result, { fetching: false, hasPermission: true })
	      });
	
	      if (typeof callback == 'function') {
	        callback();
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_CONTACT_NOTES,
	        payload: { err: err, hasPermission: false, fetching: false }
	      });
	    });
	  };
	}

/***/ },

/***/ "KF19":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getContactNotesList;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContactNotesList(contactId) {
	
	  if (!contactId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing contact Id')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/contact_notes_list/" + contactId,
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "ayZH":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_ADD_CONTACT_NOTES = exports.SUCCESS_ADD_CONTACT_NOTES = exports.START_ADD_CONTACT_NOTES = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.addContactNotes = addContactNotes;
	
	var _addContactNotes = __webpack_require__("mC9g");
	
	var _addContactNotes2 = _interopRequireDefault(_addContactNotes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var START_ADD_CONTACT_NOTES = exports.START_ADD_CONTACT_NOTES = 'START_ADD_CONTACT_NOTES';
	var SUCCESS_ADD_CONTACT_NOTES = exports.SUCCESS_ADD_CONTACT_NOTES = 'SUCCESS_ADD_CONTACT_NOTES';
	var FAILED_ADD_CONTACT_NOTES = exports.FAILED_ADD_CONTACT_NOTES = 'FAILED_ADD_CONTACT_NOTES';
	
	// Action Creator
	function addContactNotes(contactId, params, callback) {
	  return function (dispatch) {
	
	    dispatch({
	      type: START_ADD_CONTACT_NOTES,
	      payload: { adding: true, params: params }
	    });
	
	    (0, _addContactNotes2.default)(contactId, params).then(function (result) {
	      dispatch({
	        type: SUCCESS_ADD_CONTACT_NOTES,
	        payload: _extends({}, result, { adding: false })
	      });
	
	      if (typeof callback == 'function') {
	        callback();
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_ADD_CONTACT_NOTES,
	        payload: err
	      });
	    });
	  };
	}

/***/ },

/***/ "mC9g":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = addContactNotes;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  "content": _joiBrowser2.default.string().required()
	});
	
	function addContactNotes(contactId, params) {
	
	  if (!contactId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing contactId Id')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(params, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/contact_notes_list/" + contactId + "/",
	      'method': 'POST',
	      'data': JSON.stringify(params),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "dCVY":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_DELETE_CONTACT_NOTES = exports.SUCCESS_DELETE_CONTACT_NOTES = exports.START_DELETE_CONTACT_NOTES = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.deleteContactNotes = deleteContactNotes;
	
	var _deleteContactNotes = __webpack_require__("zbQX");
	
	var _deleteContactNotes2 = _interopRequireDefault(_deleteContactNotes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var START_DELETE_CONTACT_NOTES = exports.START_DELETE_CONTACT_NOTES = 'START_DELETE_CONTACT_NOTES';
	var SUCCESS_DELETE_CONTACT_NOTES = exports.SUCCESS_DELETE_CONTACT_NOTES = 'SUCCESS_DELETE_CONTACT_NOTES';
	var FAILED_DELETE_CONTACT_NOTES = exports.FAILED_DELETE_CONTACT_NOTES = 'FAILED_DELETE_CONTACT_NOTES';
	
	// Action Creator
	function deleteContactNotes(index, contactId, callback) {
	  return function (dispatch) {
	
	    dispatch({
	      type: START_DELETE_CONTACT_NOTES,
	      payload: { index: index }
	    });
	
	    (0, _deleteContactNotes2.default)(contactId).then(function (result) {
	      dispatch({
	        type: SUCCESS_DELETE_CONTACT_NOTES,
	        payload: _extends({}, result)
	      });
	
	      if (typeof callback == 'function') {
	        callback();
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_DELETE_CONTACT_NOTES,
	        payload: err
	      });
	    });
	  };
	}

/***/ },

/***/ "zbQX":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = deleteContactNotes;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deleteContactNotes(contactId) {
	
	  if (!contactId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing contact Id')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/contact_notes_detail/" + contactId + "/",
	      'method': 'DELETE',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "Av+e":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DEFAULT_PAGINATION = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // importing actions
	
	
	exports.default = MediaCenter;
	
	var _getMediaList = __webpack_require__("xDRm");
	
	var _deleteMedia = __webpack_require__("3AlC");
	
	var DEFAULT_PAGINATION = exports.DEFAULT_PAGINATION = {
	  activePage: 1,
	  itemsCountPerPage: 12,
	  totalItemsCount: 0
	};
	
	var initState = {
	  list: [],
	  pagination: DEFAULT_PAGINATION
	};
	
	function MediaCenter() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	
	    // Fetching
	    case _getMediaList.START_FETCH_MEDIA_LIST:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case _getMediaList.SUCCESS_FETCH_MEDIA_LIST:
	      {
	        var _action$payload = action.payload,
	            data_list = _action$payload.data_list,
	            total_count = _action$payload.total_count,
	            fetching = _action$payload.fetching,
	            hasPermission = _action$payload.hasPermission,
	            amount_per_page = _action$payload.amount_per_page,
	            current_page_number = _action$payload.current_page_number,
	            page_amount = _action$payload.page_amount;
	
	
	        return _extends({}, state, {
	          list: data_list,
	          count: total_count,
	          fetching: fetching,
	          hasPermission: hasPermission,
	          pagination: {
	            itemsCountPerPage: amount_per_page,
	            activePage: current_page_number,
	            totalItemsCount: total_count
	          }
	        });
	      }
	    case _getMediaList.FAILED_FETCH_MEDIA_LIST:
	      {
	        var _action$payload2 = action.payload,
	            error = _action$payload2.error,
	            _fetching = _action$payload2.fetching,
	            _hasPermission = _action$payload2.hasPermission;
	
	        return _extends({}, state, { error: error, hasPermission: _hasPermission, fetching: _fetching });
	      }
	
	    // Deleting
	    case _deleteMedia.START_DELETE_MEDIA:
	      {
	        var index = action.payload.index;
	
	
	        return _extends({}, state);
	      }
	
	    default:
	      return _extends({}, state);
	  }
	}

/***/ },

/***/ "Y5Sn":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.GET_STATISTIC_FAIL = exports.GET_STATISTIC_OK = exports.GET_STATISTIC = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchSchoolStatistic = fetchSchoolStatistic;
	exports.default = schoolStatistic;
	
	var _getSchoolStatistic = __webpack_require__("AsQf");
	
	var _getSchoolStatistic2 = _interopRequireDefault(_getSchoolStatistic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GET_STATISTIC = exports.GET_STATISTIC = 'GET_STATISTIC';
	var GET_STATISTIC_OK = exports.GET_STATISTIC_OK = 'GET_STATISTIC_OK';
	var GET_STATISTIC_FAIL = exports.GET_STATISTIC_FAIL = 'GET_STATISTIC_FAIL';
	
	function fetchSchoolStatistic(schoolId) {
	  return function (dispatch) {
	    dispatch({
	      type: GET_STATISTIC
	    });
	    (0, _getSchoolStatistic2.default)(schoolId).then(function (result) {
	      dispatch({
	        type: GET_STATISTIC_OK,
	        payload: result
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: GET_STATISTIC_FAIL,
	        payload: err
	      });
	    });
	  };
	}
	var initialState = {
	  fetching: false,
	  statistic: {}
	};
	function schoolStatistic() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case GET_STATISTIC:
	      return _extends({}, state, { fetching: true });
	    case GET_STATISTIC_OK:
	      return _extends({}, state, { statistic: action.payload, fetching: false });
	    case GET_STATISTIC_FAIL:
	      return _extends({}, state, { err: action.payload, fetching: false });
	    default:
	      return state;
	  }
	}

/***/ },

/***/ "AsQf":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getSchoolStatistic;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	* GET
	* get statistic for all schools
	**/
	function getSchoolStatistic(schoolId) {
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': "/dashboard/" + schoolId + "/",
				'method': 'GET',
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res.data);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports["default"];

/***/ },

/***/ "8VNP":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.UPDATE_SCHOOL_INFO = exports.FAILED_FETCH_SCHOOL_DETAIL = exports.SUCCESS_FETCH_SCHOOL_DETAIL = exports.START_FETCH_SCHOOL_DETAIL = exports.CLEAR_SCHOOL_DETAIL = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.clearSchoolDetail = clearSchoolDetail;
	exports.updateSchoolInfo = updateSchoolInfo;
	exports.fetchSchoolDetail = fetchSchoolDetail;
	exports.default = schoolDetail;
	
	var _getSchoolDetail = __webpack_require__("eF4U");
	
	var _getSchoolDetail2 = _interopRequireDefault(_getSchoolDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CLEAR_SCHOOL_DETAIL = exports.CLEAR_SCHOOL_DETAIL = 'CLEAR_SCHOOL_DETAIL';
	var START_FETCH_SCHOOL_DETAIL = exports.START_FETCH_SCHOOL_DETAIL = 'START_FETCH_SCHOOL_DETAIL';
	var SUCCESS_FETCH_SCHOOL_DETAIL = exports.SUCCESS_FETCH_SCHOOL_DETAIL = 'SUCCESS_FETCH_SCHOOL_DETAIL';
	var FAILED_FETCH_SCHOOL_DETAIL = exports.FAILED_FETCH_SCHOOL_DETAIL = 'FAILED_FETCH_SCHOOL_DETAIL';
	var UPDATE_SCHOOL_INFO = exports.UPDATE_SCHOOL_INFO = 'UPDATE_SCHOOL_INFO';
	
	function clearSchoolDetail() {
	  return function (dispatch) {
	    dispatch({
	      type: CLEAR_SCHOOL_DETAIL
	    });
	  };
	}
	function updateSchoolInfo(updatedInfo) {
	  return function (dispatch) {
	    dispatch({
	      type: UPDATE_SCHOOL_INFO,
	      payload: updatedInfo
	    });
	  };
	}
	function fetchSchoolDetail(schoolId, callback) {
	
	  return function (dispatch) {
	
	    dispatch({
	      type: START_FETCH_SCHOOL_DETAIL,
	      payload: { fetching: true }
	    });
	
	    (0, _getSchoolDetail2.default)(schoolId).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_SCHOOL_DETAIL,
	        payload: _extends({}, result, { fetching: false })
	      });
	
	      if (typeof callback == 'function') {
	        callback();
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_SCHOOL_DETAIL,
	        payload: err
	      });
	    });
	  };
	}
	
	var initState = {
	  detail: {}
	};
	
	function schoolDetail() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	
	  switch (action.type) {
	    case START_FETCH_SCHOOL_DETAIL:
	      {
	        return _extends({}, state, action.payload);
	      }
	    case SUCCESS_FETCH_SCHOOL_DETAIL:
	      {
	        return _extends({}, state, { detail: action.payload });
	      }
	    case FAILED_FETCH_SCHOOL_DETAIL:
	      {
	        return _extends({}, state, { err: action.payload });
	      }
	    case UPDATE_SCHOOL_INFO:
	      {
	        return _extends({}, state, { detail: action.payload });
	      }
	    case CLEAR_SCHOOL_DETAIL:
	      {
	        localStorage.removeItem('schoolId');
	        return _extends({}, state, { detail: {} });
	      }
	
	    default:
	      return _extends({}, state);
	  }
	}

/***/ },

/***/ "eF4U":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getSchoolDetail;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	* GET
	* Return the information of school.
	**/
	function getSchoolDetail(schoolID) {
		if (!schoolID) {
			throw "ERROR getSchoolDetail(): schoolID is missing";
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, {
				'uri': "/u_school/" + schoolID + "/",
				'method': 'GET',
				'token': localStorage.getItem('token')
			}).then(function (res) {
				var toReturn = res.data;
				resolve(toReturn);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports["default"];

/***/ },

/***/ "vvL0":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.GET_SCHOOL_LOG_FAIL = exports.GET_SCHOOL_LOG_OK = exports.GET_SCHOOL_LOG = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getSchoolLog = getSchoolLog;
	exports.default = schoolLog;
	
	var _getSchoolLog = __webpack_require__("SZM+");
	
	var _getSchoolLog2 = _interopRequireDefault(_getSchoolLog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GET_SCHOOL_LOG = exports.GET_SCHOOL_LOG = 'GET_SCHOOL_LOG';
	var GET_SCHOOL_LOG_OK = exports.GET_SCHOOL_LOG_OK = 'GET_SCHOOL_LOG_OK';
	var GET_SCHOOL_LOG_FAIL = exports.GET_SCHOOL_LOG_FAIL = 'GET_SCHOOL_LOG_FAIL';
	
	function getSchoolLog(schoolId, params) {
	  return function (dispatch) {
	    dispatch({
	      type: GET_SCHOOL_LOG
	    });
	    (0, _getSchoolLog2.default)(schoolId, params).then(function (result) {
	      dispatch({
	        type: GET_SCHOOL_LOG_OK,
	        payload: result
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: GET_SCHOOL_LOG_FAIL,
	        payload: err
	      });
	    });
	  };
	}
	
	var initState = {
	  fetching: false,
	  logs: {}
	};
	
	function schoolLog() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case GET_SCHOOL_LOG:
	      {
	        return _extends({}, state, { fetching: true });
	      }
	    case GET_SCHOOL_LOG_OK:
	      {
	        if (state.err) {
	          delete state.err;
	        }
	        return _extends({}, state, { logs: action.payload, fetching: false });
	      }
	    case GET_SCHOOL_LOG_FAIL:
	      {
	        return _extends({}, state, { err: action.payload, fetching: false });
	      }
	    default:
	      return state;
	  }
	}

/***/ },

/***/ "SZM+":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = getSchoolLog;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _parseLog = __webpack_require__("07FU");
	
	var _parseLog2 = _interopRequireDefault(_parseLog);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	* GET
	* Return school operation logs.
	**/
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  school_teacher: _joiBrowser2.default.number().integer().allow(null),
	  start_date: _joiBrowser2.default.string().allow(''),
	  end_date: _joiBrowser2.default.string().allow(''),
	  amount_per_page: _joiBrowser2.default.number().integer().allow(null),
	  current_page_number: _joiBrowser2.default.number().integer().allow(null)
	});
	
	function getSchoolLog(schoolID, params) {
	
	  var validateResult = _joiBrowser2.default.validate(params, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	  var query = _queryString2.default.stringify(params);
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, {
	      'uri': '/log/' + schoolID + '/?' + query,
	      'method': 'GET',
	      'token': localStorage.getItem('token')
	    }).then(function (res) {
	      var logs = (0, _parseLog2.default)(res.data);
	      resolve(logs);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "07FU":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var logs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var parsedLogList = [];
	  var logList = logs.result_list;
	
	  parsedLogList = logList.map(function (log) {
	    return reformatLogDetail(log);
	  });
	
	  var newLog = (0, _lodash.mapValues)((0, _lodash.groupBy)(parsedLogList, 'operated_at_date'), function (list) {
	    return list.map(function (parsedLogList) {
	      return (0, _lodash.omit)(parsedLogList, 'operated_at_date');
	    });
	  });
	
	  Object.keys(newLog).map(function (key) {
	    var newList = newLog[key];
	    var convertedLog = (0, _lodash.mapValues)((0, _lodash.groupBy)(newList, 'operated_at_time'), function (list) {
	      return list.map(function (newList) {
	        return (0, _lodash.omit)(newList, 'operated_at_time');
	      });
	    });
	
	    newLog[key] = convertedLog;
	  });
	
	  return _extends({}, logs, {
	    result_list: newLog
	  });
	};
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__("M4fF");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function reformatLogDetail(log) {
	  var objectType = log.log_context.object_type;
	  var context = log.log_context;
	  var operator_type = log.operator_type;
	  var newLog = {};
	
	  if (objectType === 'student' || objectType === 'lesson' || objectType === 'lesson_list') {
	    if (context.operation === 'add') {
	      context.operation = 'edit';
	    }
	  }
	
	  if (objectType === 'lesson' || objectType === 'lesson_list') {
	    if (typeof context.object_name === 'string') {
	      context.object_name_list = [context.object_name];
	    }
	  }
	
	  if (operator_type === 'other') {
	    log.operator_name = 'Principal';
	  }
	
	  log.operated_at_date = (0, _moment2.default)(log.operated_at).format('YYYY-MM-DD');
	  log.operated_at_time = (0, _moment2.default)(log.operated_at).format('hh:mm a');
	
	  return log;
	}
	
	module.exports = exports['default'];

/***/ },

/***/ "DP/h":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	exports.routesObj = undefined;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _Main = __webpack_require__("4u/q");
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _routes = __webpack_require__("T1vP");
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var routesObj = exports.routesObj = {};
	
	function generateRoutes(routes) {
	  return routes.items.map(function (r) {
	    var component = __webpack_require__(5)("./" + r.component);
	    routesObj[r.path] = r;
	    return _react2.default.createElement(_reactRouter.Route, { key: r.path, path: r.path, component: component });
	  });
	}
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    subscription: state.gSubscription.result || {}
	  };
	};
	
	var Routes = function (_React$Component) {
	  _inherits(Routes, _React$Component);
	
	  function Routes(opts) {
	    _classCallCheck(this, Routes);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, opts));
	
	    _this.onRouteChange = _this.onRouteChange.bind(_this);
	
	    // const currentLocation = window.location; 
	
	    // this.checkIfRedirectNeeded(currentLocation);
	    return _this;
	  }
	
	  Routes.prototype.onRouteChange = function onRouteChange(e) {
	    //this.checkIfRedirectNeeded(e.location);
	    if (global['--classtop-main-section']) {
	      global['--classtop-main-section'].scrollTo(0, 0);
	    }
	  };
	
	  // Not sure why we need this, this is causing some errors on change school page --Billy
	
	
	  Routes.prototype.checkIfRedirectNeeded = function checkIfRedirectNeeded(_ref) {
	    // const {is_valid, maximum_amount} = this.props.subscription;
	    // if (pathname !== '/') {
	    //   if (!localStorage.getItem('schoolId')) {
	    //     browserHistory.push('/');
	    //   }
	    // }
	    // if(is_valid && maximum_amount.maximum_school!==0){
	    //   if(pathname !== '/' || pathname !== '/account-settings'){
	    //     //browserHistory.push('/');
	    //   }
	    // }
	
	    var pathname = _ref.pathname;
	  };
	
	  Routes.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactRouter.Router,
	      { history: this.props.history },
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { component: _Main2.default, onEnter: this.onRouteChange, onChange: this.onRouteChange },
	        generateRoutes(_routes2.default)
	      )
	    );
	  };
	
	  return Routes;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Routes);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "4u/q":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _user = __webpack_require__("2F2H");
	
	var _subscription = __webpack_require__("ue3W");
	
	var _Login = __webpack_require__("ixZ5");
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _MobileScreen = __webpack_require__("eYV8");
	
	var _MobileScreen2 = _interopRequireDefault(_MobileScreen);
	
	var _MainContainer = __webpack_require__("ZDcJ");
	
	var _MainContainer2 = _interopRequireDefault(_MainContainer);
	
	var _refreshToken = __webpack_require__("z0/O");
	
	var _refreshToken2 = _interopRequireDefault(_refreshToken);
	
	var _isEmpty = __webpack_require__("lHK6");
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	__webpack_require__("ZxDm");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Main />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @redux
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    subscription: state.gSubscription
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchUserByToken: function fetchUserByToken() {
	      return dispatch((0, _user.fetchUserByToken)());
	    },
	    getSubscription: function getSubscription() {
	      return dispatch((0, _subscription.getSubscription)());
	    }
	  };
	};
	
	var Main = function (_React$Component) {
	  _inherits(Main, _React$Component);
	
	  function Main(props) {
	    _classCallCheck(this, Main);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  Main.prototype.componentWillMount = function componentWillMount() {
	    this.props.fetchUserByToken();
	    this.props.getSubscription();
	  };
	
	  Main.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!this.props.user.login && nextProps.user.login) {
	      setInterval(function () {
	        (0, _refreshToken2.default)({ token: localStorage.getItem('token') }).then(function (result) {
	          localStorage.setItem('token', result.data.token);
	        });
	      }, 3600000);
	    }
	  };
	
	  Main.prototype.render = function render() {
	    var _props = this.props,
	        user = _props.user,
	        subscription = _props.subscription,
	        routes = _props.routes;
	    var result = subscription.result;
	    var login = user.login,
	        loginRequired = user.loginRequired;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('Main') },
	      login && !(0, _isEmpty2.default)(result) && (result.maximum_amount.maximum_school !== 0 || user.result.school_amount - user.result.school_owned_amount > 0 || user.result.teacher_to_be_confirmed.length > 0) && _react2.default.createElement(
	        _MainContainer2.default,
	        { routes: routes },
	        this.props.children
	      ),
	      (loginRequired || !(0, _isEmpty2.default)(result) && result.maximum_amount.maximum_school === 0 && user.result.school_amount - user.result.school_owned_amount === 0 && user.result.teacher_to_be_confirmed.length === 0) && _react2.default.createElement(
	        'div',
	        { className: 'LoginPageWrapper' },
	        _react2.default.createElement(_Login2.default, null)
	      ),
	      _react2.default.createElement(_MobileScreen2.default, null)
	    );
	  };
	
	  return Main;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Main);
	module.exports = exports['default'];

/***/ },

/***/ "ixZ5":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _login = __webpack_require__("kQpO");
	
	var _login2 = _interopRequireDefault(_login);
	
	var _logo_white2x = __webpack_require__("yWBF");
	
	var _logo_white2x2 = _interopRequireDefault(_logo_white2x);
	
	var _PhoneNumber = __webpack_require__("GM/A");
	
	var _PhoneNumber2 = _interopRequireDefault(_PhoneNumber);
	
	var _loginAsUser = __webpack_require__("zyKh");
	
	var _loginAsUser2 = _interopRequireDefault(_loginAsUser);
	
	var _sendPhoneVerification = __webpack_require__("qfzY");
	
	var _sendPhoneVerification2 = _interopRequireDefault(_sendPhoneVerification);
	
	var _registerUser2 = __webpack_require__("gmOA");
	
	var _registerUser3 = _interopRequireDefault(_registerUser2);
	
	var _startTrial = __webpack_require__("s4Vs");
	
	var _startTrial2 = _interopRequireDefault(_startTrial);
	
	var _getSubscription = __webpack_require__("h7zY");
	
	var _getSubscription2 = _interopRequireDefault(_getSubscription);
	
	var _ForgotPassword = __webpack_require__("He4N");
	
	var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);
	
	var _validator = __webpack_require__("+b6B");
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _getUserByToken = __webpack_require__("v34H");
	
	var _getUserByToken2 = _interopRequireDefault(_getUserByToken);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _locale = __webpack_require__("xDtR");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("9pbx");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Login
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is ...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @redux
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var DEFAULT_NUMBER = '1';
	var DEFAULT_REGION_CODE = 'ca';
	var COUNT_DOWN_SECONDS = 59;
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var Login = function (_React$Component) {
	  _inherits(Login, _React$Component);
	
	  function Login(props) {
	    _classCallCheck(this, Login);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.login = _this.login.bind(_this);
	    _this.forgotPassword = _this.forgotPassword.bind(_this);
	    _this.registerUser = _this.registerUser.bind(_this);
	    _this.sendVerificationCode = _this.sendVerificationCode.bind(_this);
	    _this.startTrial = _this.startTrial.bind(_this);
	    _this.state = {
	      username: { country_code: DEFAULT_NUMBER, national_number: '', region_code: DEFAULT_REGION_CODE },
	      password: '',
	      signingIn: false,
	      pageState: 'login',
	      showPassword: false,
	      verificationCode: '',
	      showMsg: false,
	      showVerificationFailure: false,
	      counterTime: COUNT_DOWN_SECONDS,
	      resendCode: false,
	      newPassword: '',
	      email: '',
	      agentId: '',
	      errorMessage: ''
	    };
	    return _this;
	  }
	
	  Login.prototype.componentWillMount = function componentWillMount() {
	    localStorage.removeItem('token');
	  };
	
	  Login.prototype.forgotPassword = function forgotPassword() {
	    (0, _ForgotPassword2.default)().then(function (a) {}).catch(function () {});
	  };
	
	  Login.prototype.login = function login() {
	    var _this2 = this;
	
	    var _state = this.state,
	        username = _state.username,
	        password = _state.password;
	
	
	    this.setState({
	      signingIn: true
	    });
	
	    (0, _loginAsUser2.default)({ username: username.country_code + username.national_number, password: password }).then(function (res) {
	      if (!res.data) {
	        return;
	      }
	
	      var _res$data = res.data,
	          result = _res$data.result,
	          user_token = _res$data.user_token,
	          reason = _res$data.reason;
	
	
	      if (result === 'failure') {
	        _this2.setState({
	          errorMessage: reason,
	          signingIn: false
	        });
	      } else if (result === 'success') {
	        localStorage.setItem('token', user_token);
	        (0, _getUserByToken2.default)().then(function (_ref) {
	          var data = _ref.data;
	
	          if (data && data.school_list.length === 0 && data.school_owned_amount === 0 && data.teacher_to_be_confirmed.length === 0) {
	            _this2.setState({ pageState: 'startTrial' });
	          } else if (data && (data.school_list.length > 0 || data.teacher_to_be_confirmed.length > 0) && data.school_owned_amount === 0) {
	            window.location.href = '/';
	          } else {
	            _this2.setState({
	              errorMessage: '',
	              signingIn: false,
	              signedIn: true
	            });
	
	            window.location.href = '/';
	          }
	        });
	        // getSubscriptionCtrl()
	        //   .then((res)=>{
	        //     if(res.data.maximum_amount.maximum_school === 0){
	        //       this.setState({pageState: 'startTrial'})
	        //     }else {
	        //       this.setState({
	        //         errorMessage: '',
	        //         signingIn: false,
	        //         signedIn: true,
	        //       });
	
	        //       window.location.href = '/';
	        //     }
	        //   })
	      }
	    }).catch(function (error) {
	      console.error(error);
	    });;
	  };
	
	  Login.prototype.registerUser = function registerUser() {
	    var _this3 = this;
	
	    var _state2 = this.state,
	        newPassword = _state2.newPassword,
	        verificationCode = _state2.verificationCode,
	        username = _state2.username,
	        agentId = _state2.agentId,
	        email = _state2.email;
	
	    var phone = username.country_code + username.national_number;
	
	    (0, _registerUser3.default)({ phone: phone, pin: verificationCode, new_password: newPassword, agent_id: agentId, email: email }).then(function (res) {
	      if (res.result == 'success') {
	        (0, _loginAsUser2.default)({ username: phone, password: newPassword }).then(function (res) {
	          var _res$data2 = res.data,
	              result = _res$data2.result,
	              user_token = _res$data2.user_token;
	
	
	          if (result === 'success') {
	            localStorage.setItem('token', user_token);
	            (0, _getUserByToken2.default)().then(function (_ref2) {
	              var data = _ref2.data;
	
	              if (data && data.school_list.length === 0 && data.school_owned_amount === 0 && data.teacher_to_be_confirmed.length === 0) {
	                _this3.setState({ pageState: 'startTrial' });
	              } else if (data && (data.school_list.length > 0 || data.teacher_to_be_confirmed.length > 0) && data.school_owned_amount === 0) {
	                window.location.href = '/';
	              } else {
	                _this3.setState({
	                  errorMessage: '',
	                  signingIn: false,
	                  signedIn: true
	                });
	
	                window.location.href = '/';
	              }
	            });
	          }
	        }).catch(function (error) {
	          console.error(error);
	        });
	      } else if (res.result == 'failure') {
	        _this3.setState({ errorMessage: res.reason });
	      }
	    });
	  };
	
	  Login.prototype.sum = function sum(x, y) {
	    return x + y;
	  };
	
	  Login.prototype.setVerificationCounter = function setVerificationCounter() {
	    var _this4 = this;
	
	    this.setState({ resendCode: true });
	    this.timmer = setInterval(function () {
	      if (_this4.state.counterTime > 0) {
	        _this4.setState({ counterTime: _this4.state.counterTime - 1 });
	      } else {
	        _this4.setState({ resendCode: false, counterTime: COUNT_DOWN_SECONDS });
	        _this4.clearCounter();
	      }
	    }, 1000);
	  };
	
	  Login.prototype.clearCounter = function clearCounter() {
	    clearInterval(this.timmer);
	  };
	
	  Login.prototype.sendVerificationCode = function sendVerificationCode() {
	    var _this5 = this;
	
	    var username = this.state.username;
	
	    var phone = username.country_code + username.national_number;
	
	    (0, _sendPhoneVerification2.default)({ phone: phone, check_phone: 'sendIfUserNotExist' }).then(function (res) {
	      if (res.result == 'success') {
	        _this5.setVerificationCounter();
	      } else {
	        _this5.setState({ errorMessage: res.result });
	      }
	    }).catch(function (err) {
	      _this5.setState({ showVerificationFailure: true });
	    });
	  };
	
	  Login.prototype.matchErrorMessages = function matchErrorMessages() {
	    var errorMessage = this.state.errorMessage;
	
	    switch (errorMessage) {
	      case 'The Phone No./Password combination is not valid':
	      case 'username does not exist':
	      case 'wrong password':
	        return __('The Phone No./Password combination is not valid', _locale2.default);
	      case 'new password is less than 6 characters':
	        return __('Password has to be at least 6 characters long', _locale2.default);
	      case 'User already exists':
	      case 'user with this phone has registered':
	        return __('User already exists', _locale2.default);
	      case 'pin is wrong':
	      case 'please request the verification code first':
	        return __('Invalid verification code', _locale2.default);
	      case 'The verification code has expired':
	        return __('Verification code is expired', _locale2.default);
	      default:
	        return __('Unexpected errors', _locale2.default);
	    }
	  };
	
	  Login.prototype.startTrial = function startTrial() {
	    (0, _startTrial2.default)().then(function (res) {
	      if (res.result === 'success') {
	        window.location.href = '/';
	      } else {
	        _alert.alert.warning(__('You have used the free trial', _locale2.default));
	      }
	    });
	  };
	
	  Login.prototype.renderLoginForm = function renderLoginForm() {
	    var _this6 = this;
	
	    var _state3 = this.state,
	        username = _state3.username,
	        password = _state3.password,
	        errorMessage = _state3.errorMessage,
	        signingIn = _state3.signingIn;
	
	
	    var newUserName = username.country_code + username.national_number;
	
	    var ready = newUserName.length > 6 && password.length > 3 || signingIn == true;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'LoginColumn' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        __('Log In to ClassTopBase', _locale2.default)
	      ),
	      errorMessage.length > 0 && _react2.default.createElement(
	        'div',
	        { className: 'errorMessage' },
	        this.matchErrorMessages()
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'login' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(_PhoneNumber2.default, { defaultCountry: 'ca', value: username, onChange: function onChange(username) {
	              _this6.setState({ username: username });
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group password' },
	          _react2.default.createElement(
	            'span',
	            { className: 'password-icon' },
	            _react2.default.createElement('i', { className: 'icon-lock' })
	          ),
	          _react2.default.createElement('input', { type: 'password', className: 'form-control', onChange: function onChange(e) {
	              _this6.setState({
	                password: e.target.value
	              });
	            },
	            onKeyPress: function onKeyPress(e) {
	              if (e.charCode === 13) {
	                _this6.login();
	              }
	            }
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'control' },
	        _react2.default.createElement(
	          'a',
	          { className: 'btn btn-primary', disabled: !ready, onClick: this.login },
	          __('Sign In', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'btn-link', onClick: this.forgotPassword },
	          __('Forgot Your Password?', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'line' },
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            'div',
	            { className: 'or' },
	            'or'
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'btn', onClick: function onClick() {
	              return _this6.setState({ pageState: 'signup', errorMessage: '' });
	            } },
	          __('Register New Account', _locale2.default)
	        )
	      )
	    );
	  };
	
	  Login.prototype.renderSignupForm = function renderSignupForm() {
	    var _this7 = this;
	
	    var _state4 = this.state,
	        username = _state4.username,
	        password = _state4.password,
	        newPassword = _state4.newPassword,
	        errorMessage = _state4.errorMessage,
	        showPassword = _state4.showPassword,
	        resendCode = _state4.resendCode,
	        counterTime = _state4.counterTime,
	        verificationCode = _state4.verificationCode,
	        email = _state4.email;
	
	
	    var newPhone = username.country_code + username.national_number;
	
	    var validPhone = newPhone.length > 6;
	    var validEmail = _validator2.default.isEmail(email.trim());
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'LoginColumn' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        __('Sign up to ClassTopBase', _locale2.default)
	      ),
	      errorMessage.length > 0 && _react2.default.createElement(
	        'div',
	        { className: 'errorMessage' },
	        this.matchErrorMessages()
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'login' },
	        _react2.default.createElement(
	          'div',
	          { className: 'field-label' },
	          __('Phone Number', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(_PhoneNumber2.default, { defaultCountry: 'ca', value: username, onChange: function onChange(username) {
	              _this7.setState({ username: username });
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'field-label' },
	          __('Verification Code', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group verification-wrapper' },
	          _react2.default.createElement('input', { type: 'number', placeholder: __('4 digits', _locale2.default), value: verificationCode, className: 'form-control', onChange: function onChange(e) {
	              return _this7.setState({ verificationCode: e.target.value });
	            } }),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary', onClick: this.sendVerificationCode, disabled: !validPhone || resendCode },
	            resendCode ? __('Resend in {counterTime}s', _locale2.default, { counterTime: counterTime }) : __('Send Code', _locale2.default)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'field-label' },
	          __('Password', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group password' },
	          _react2.default.createElement(
	            'span',
	            { className: 'password-icon' },
	            _react2.default.createElement('i', { className: 'icon-lock' })
	          ),
	          _react2.default.createElement('input', { type: showPassword ? 'text' : 'password', placeholder: __('At least 6 characters', _locale2.default), className: 'form-control', onChange: function onChange(e) {
	              _this7.setState({
	                newPassword: e.target.value
	              });
	            }
	          }),
	          _react2.default.createElement(
	            'span',
	            { className: 'toggle-text', onClick: function onClick() {
	                return _this7.setState({ showPassword: !showPassword });
	              } },
	            showPassword ? __('hide', _locale2.default) : __('show', _locale2.default)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'field-label' },
	          __('Email', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group email' },
	          _react2.default.createElement('input', { type: 'email', className: 'form-control', placeholder: 'eg. name@mail.com', onChange: function onChange(e) {
	              return _this7.setState({ email: e.target.value });
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'agreement-text' },
	          __('By clicking Register, you agree to our ', 'appwrapper'),
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: __('https://base.classtop.com/terms-of-service-en.html', 'appwrapper') },
	            __('Terms of Service', 'appwrapper')
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'control' },
	        _react2.default.createElement(
	          'a',
	          { className: 'btn btn-primary', disabled: !validPhone || newPassword.length < 6 || verificationCode.length < 4 || !validEmail, onClick: this.registerUser },
	          __('Register', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'line' },
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            'div',
	            { className: 'or' },
	            __('Or', _locale2.default)
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'btn', onClick: function onClick() {
	              return _this7.setState({ pageState: 'login', errorMessage: '' });
	            } },
	          __('Sign In', _locale2.default)
	        )
	      )
	    );
	  };
	
	  Login.prototype.renderTrailSection = function renderTrailSection() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'trail-section' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'section-title' },
	        __('Start your 14 days free trail now!', 'planDetails')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section-description' },
	        _react2.default.createElement(
	          'div',
	          { className: 'included-features' },
	          _react2.default.createElement(
	            'div',
	            { className: 'feature-title' },
	            __('Features that are included in free trial', 'planDetails'),
	            ':'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('i', { className: 'fa icon-ok check-icon' }),
	              __('All basic plan features', 'planDetails')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('i', { className: 'fa icon-ok check-icon' }),
	              __('{amount} Registered Students', 'planDetails', { amount: 80 })
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('i', { className: 'fa icon-ok check-icon' }),
	              __('{amount} Registered Teachers', 'planDetails', { amount: 40 })
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('i', { className: 'fa icon-ok check-icon' }),
	              __('{amount} Campus', 'planDetails', { amount: 1 })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'excluded-features' },
	          _react2.default.createElement(
	            'div',
	            { className: 'feature-title' },
	            __('Features that are NOT included', 'planDetails'),
	            ':'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('i', { className: 'fa icon-cancel close-icon' }),
	              __('No Posters', 'planDetails')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('i', { className: 'fa icon-cancel close-icon' }),
	              __('No Contacts', 'planDetails')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('i', { className: 'fa icon-cancel close-icon' }),
	              __('No Smart Check-in', 'planDetails')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('i', { className: 'fa icon-cancel close-icon' }),
	              __('No Recent Activity Logs', 'planDetails')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary btn-start-trial', onClick: this.startTrial },
	        __('Start My Trial', 'planDetails')
	      )
	    );
	  };
	
	  Login.prototype.render = function render() {
	    var _state5 = this.state,
	        signedIn = _state5.signedIn,
	        pageState = _state5.pageState;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('Login', { signedIn: signedIn }) },
	      _react2.default.createElement(
	        'div',
	        { className: 'Loading' },
	        _react2.default.createElement(_Loading2.default, { type: 'logo' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'Content' },
	        pageState === 'login' && this.renderLoginForm(),
	        pageState === 'signup' && this.renderSignupForm(),
	        pageState === 'startTrial' && this.renderTrailSection(),
	        _react2.default.createElement(
	          'div',
	          { className: 'bg-1 overlay', style: { backgroundImage: 'url(' + _login2.default + ')' } },
	          _react2.default.createElement('img', { src: _logo_white2x2.default, width: 182, className: 'logo' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              __('EASY SOLUTION', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'h4',
	              null,
	              __('FOR YOUR SCHOOL MANAGEMENT', _locale2.default)
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Login;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Login);
	module.exports = exports['default'];

/***/ },

/***/ "kQpO":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "login.9629c460.jpg";

/***/ },

/***/ "yWBF":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "logo_white@2x.90ad4a69.png";

/***/ },

/***/ "zRW5":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _WebsiteSideMenu = __webpack_require__("fU3o");
	
	var _WebsiteSideMenu2 = _interopRequireDefault(_WebsiteSideMenu);
	
	var _Preview = __webpack_require__("/OJU");
	
	var _Preview2 = _interopRequireDefault(_Preview);
	
	var _ComponentEditor = __webpack_require__("pxxT");
	
	var _ComponentEditor2 = _interopRequireDefault(_ComponentEditor);
	
	__webpack_require__("D/tK");
	
	var _locale = __webpack_require__("aEdv");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _AddComponent = __webpack_require__("WHlH");
	
	var _AddComponent2 = _interopRequireDefault(_AddComponent);
	
	var _ThemeSetting = __webpack_require__("ZtKT");
	
	var _ThemeSetting2 = _interopRequireDefault(_ThemeSetting);
	
	var _NavSetting = __webpack_require__("CUBd");
	
	var _NavSetting2 = _interopRequireDefault(_NavSetting);
	
	var _WebsiteSetting = __webpack_require__("DEdD");
	
	var _WebsiteSetting2 = _interopRequireDefault(_WebsiteSetting);
	
	var _SelectTheme = __webpack_require__("u3wL");
	
	var _SelectTheme2 = _interopRequireDefault(_SelectTheme);
	
	var _EditPageOnSideMenu = __webpack_require__("y9jc");
	
	var _EditPageOnSideMenu2 = _interopRequireDefault(_EditPageOnSideMenu);
	
	var _PageEditor = __webpack_require__("qZd9");
	
	var _PageEditor2 = _interopRequireDefault(_PageEditor);
	
	var _createPoster = __webpack_require__("NYMm");
	
	var _createPoster2 = _interopRequireDefault(_createPoster);
	
	var _updatePoster = __webpack_require__("xsdH");
	
	var _updatePoster2 = _interopRequireDefault(_updatePoster);
	
	var _createContent = __webpack_require__("SquY");
	
	var _createContent2 = _interopRequireDefault(_createContent);
	
	var _updateContent = __webpack_require__("fQnq");
	
	var _updateContent2 = _interopRequireDefault(_updateContent);
	
	var _deleteContent = __webpack_require__("+ilL");
	
	var _deleteContent2 = _interopRequireDefault(_deleteContent);
	
	var _getPosterDetail = __webpack_require__("+5oY");
	
	var _getPosterDetail2 = _interopRequireDefault(_getPosterDetail);
	
	var _updateSchoolSettings = __webpack_require__("gl/q");
	
	var _updateSchoolSettings2 = _interopRequireDefault(_updateSchoolSettings);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Website 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Website = function (_React$Component) {
	  _inherits(Website, _React$Component);
	
	  function Website(props) {
	    _classCallCheck(this, Website);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      openPreview: false,
	      editFormSchema: {},
	      themeInfo: {},
	      currentPagePath: '/'
	    };
	
	    _this.onEndEdit = _this.onEndEdit.bind(_this);
	    _this.onStartEdit = _this.onStartEdit.bind(_this);
	    _this.onIframeLoaded = _this.onIframeLoaded.bind(_this);
	    _this.onComponentChange = _this.onComponentChange.bind(_this);
	    _this.onComponentSubmit = _this.onComponentSubmit.bind(_this);
	
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.onClosePageEditor = _this.onClosePageEditor.bind(_this);
	    _this.onPageSubmit = _this.onPageSubmit.bind(_this);
	    _this.onPageDelete = _this.onPageDelete.bind(_this);
	    _this.onSettingSubmit = _this.onSettingSubmit.bind(_this);
	
	    _this.onAddComponent = _this.onAddComponent.bind(_this);
	    _this.onDeleteComponent = _this.onDeleteComponent.bind(_this);
	    _this.onSubmitAddComponent = _this.onSubmitAddComponent.bind(_this);
	    _this.onMoveComponent = _this.onMoveComponent.bind(_this);
	
	    _this.onCurrentPageChange = _this.onCurrentPageChange.bind(_this);
	    return _this;
	  }
	
	  Website.prototype.componentWillMount = function componentWillMount() {};
	
	  Website.prototype.onComponentChange = function onComponentChange(componentUnderEdit) {
	    this.setState({
	      componentUnderEdit: componentUnderEdit
	    });
	  };
	
	  Website.prototype.onPageChange = function onPageChange() {};
	
	  Website.prototype.onClosePageEditor = function onClosePageEditor() {
	    this.setState({
	      isPageEdit: false
	    });
	  };
	
	  Website.prototype.onPageSubmit = function onPageSubmit(page) {
	
	    var nextAction = void 0;
	    if (typeof page.id == 'undefined') {
	      nextAction = 'create_new_page';
	    } else {
	      nextAction = 'update_page';
	    }
	
	    switch (nextAction) {
	      case 'create_new_page':
	        {
	          this.createNewPage(page);
	          break;
	        }
	      case 'update_page':
	        {
	          this.updatePage(page);
	          break;
	        }
	    }
	  };
	
	  Website.prototype.createNewPage = function createNewPage(page) {
	    var _this2 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    (0, _createPoster2.default)(schoolId, {
	      poster_type: 'web_page',
	      title: page.title,
	      state: 'published',
	      page_setting: page.page_setting
	    }).then(function (res) {
	      if (res && res.result == 'success') {
	        _this2.onClosePageEditor();
	        _this2.refreshPage();
	      }
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  Website.prototype.onPageDelete = function onPageDelete() {
	    var page = this.state.page;
	  };
	
	  Website.prototype.updatePage = function updatePage(page) {
	    var _this3 = this;
	
	    (0, _updatePoster2.default)(page.id, {
	      state: 'draft'
	    }).then(function (res) {
	      return (0, _updatePoster2.default)(page.id, {
	        title: page.title,
	        state: 'published',
	        page_setting: page.page_setting
	      });
	    }).then(function (res) {
	      _this3.onClosePageEditor();
	      _this3.refreshPage();
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  // both ThemeSettings and WebsiteSettings are usting the same controller
	
	
	  Website.prototype.onSettingSubmit = function onSettingSubmit(site) {
	    var _this4 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    var theme = site.theme,
	        siteUrl = site.siteUrl,
	        themeUrl = site.themeUrl,
	        themeSetting = site.themeSetting,
	        locale = site.locale,
	        nav = site.nav;
	
	
	    var toSubmit = {
	      website_locale: locale,
	      website_url: siteUrl,
	      website_theme_name: theme,
	      website_theme_settings: themeSetting,
	      website_nav_settings: nav
	    };
	
	    (0, _updateSchoolSettings2.default)(schoolId, toSubmit).then(function (res) {
	      _this4.refreshPage();
	      _this4.sideMenuMethods.backToPrevious();
	    });
	  };
	
	  Website.prototype.onStartEdit = function onStartEdit(eventData) {
	    var _eventData$__edit = eventData.__edit,
	        componentFormSchemas = _eventData$__edit.componentFormSchemas,
	        componentFormData = _eventData$__edit.componentFormData;
	    var componentType = eventData.componentType,
	        contentId = eventData.contentId;
	
	
	    var editFormSchema = componentFormSchemas[componentType];
	
	    var componentUnderEdit = componentFormData[contentId];
	
	    // controller to get componentUnderEdit
	    this.setState({
	      editFormSchema: editFormSchema,
	      isComponentEdit: true,
	      componentUnderEdit: componentUnderEdit,
	      componentIdUnderEdit: contentId
	    });
	  };
	
	  Website.prototype.onCurrentPageChange = function onCurrentPageChange(currentPagePath) {
	    this.setState({
	      currentPagePath: currentPagePath
	    });
	  };
	
	  Website.prototype.onEndEdit = function onEndEdit() {
	    this.setState({
	      isComponentEdit: false,
	      isPageEdit: false,
	      isAddComponent: false,
	      editFormSchema: {},
	      componentUnderEdit: {},
	      componentIdUnderEdit: null
	    });
	  };
	
	  Website.prototype.onDeleteComponent = function onDeleteComponent(eventData) {
	    var _this5 = this;
	
	    var id = this.state.page.id;
	    var deleteComponentId = eventData.deleteComponentId;
	
	
	    if (typeof deleteComponentId == 'number') {
	      var deleteSuccess = '';
	      (0, _confirm.confirm)(__('Are you sure you want to delete this component?', _locale2.default), __('Delete Component', _locale2.default)).then(function () {
	        return (0, _updatePoster2.default)(id, {
	          state: "draft"
	        });
	      }).then(function (res) {
	        return (0, _deleteContent2.default)(deleteComponentId);
	      }).then(function (res) {
	        deleteSuccess = res.result;
	        return (0, _updatePoster2.default)(id, {
	          state: "published"
	        });
	      }).then(function (res) {
	        if (deleteSuccess == 'success') {
	          _this5.refreshPage();
	        } else {
	          throw new Error('failed to delete');
	        }
	      }).catch(function (err) {
	        _alert.alert.fail(__('We encountered an error during the process.', _locale2.default), __('Failed to Delete Component', _locale2.default));
	        console.error(err);
	      });
	    }
	  };
	
	  Website.prototype.onMoveComponent = function onMoveComponent(eventData) {
	    var _this6 = this;
	
	    var moveComponentIndex = eventData.moveComponentIndex,
	        contentId = eventData.contentId;
	    var id = this.state.page.id;
	
	
	    (0, _updatePoster2.default)(id, {
	      state: "draft"
	    }).then(function () {
	      return (0, _updateContent2.default)(contentId, {
	        index: moveComponentIndex
	      });
	    }).then(function () {
	      return (0, _updatePoster2.default)(id, {
	        state: "published"
	      });
	    }).then(function (result) {
	      _this6.refreshPage();
	      _this6.onEndEdit();
	    });
	  };
	
	  Website.prototype.onAddComponent = function onAddComponent(eventData) {
	    this.setState({
	      isAddComponent: true,
	      addComponentIndex: eventData.addComponentIndex
	    });
	  };
	
	  Website.prototype.onComponentSubmit = function onComponentSubmit() {
	    var _this7 = this;
	
	    var _state$page = this.state.page,
	        id = _state$page.id,
	        page_setting = _state$page.page_setting;
	    var _state = this.state,
	        componentUnderEdit = _state.componentUnderEdit,
	        componentIdUnderEdit = _state.componentIdUnderEdit;
	
	
	    (0, _updatePoster2.default)(id, {
	      state: "draft",
	      page_setting: page_setting
	    }).then(function () {
	      return (0, _updateContent2.default)(componentIdUnderEdit, {
	        custom_data: componentUnderEdit
	      });
	    }).then(function () {
	      return (0, _updatePoster2.default)(id, {
	        state: "published",
	        page_setting: page_setting
	      });
	    }).then(function (result) {
	      _this7.refreshPage();
	      _this7.onEndEdit();
	    });
	  };
	
	  Website.prototype.onSubmitAddComponent = function onSubmitAddComponent(component) {
	    var _this8 = this;
	
	    var _state2 = this.state,
	        addComponentIndex = _state2.addComponentIndex,
	        componentInitValues = _state2.componentInitValues;
	    var _state$page2 = this.state.page,
	        id = _state$page2.id,
	        _state$page2$content = _state$page2.content,
	        content = _state$page2$content === undefined ? [] : _state$page2$content,
	        page_setting = _state$page2.page_setting;
	    var type = component.type;
	
	
	    var index = void 0;
	    if (content.length == 0) {
	      index = 1;
	    } else {
	      index = parseInt(addComponentIndex);
	    }
	
	    var initValue = componentInitValues[type] || {};
	
	    (0, _updatePoster2.default)(id, {
	      state: "draft",
	      page_setting: page_setting
	    }).then(function () {
	      return (0, _createContent2.default)(id, {
	        index: index,
	        content_type: type,
	        custom_data: _extends({
	          type: type
	        }, initValue)
	      });
	    }).then(function (err) {
	      return (0, _updatePoster2.default)(id, {
	        state: "published",
	        page_setting: page_setting
	      });
	    }).then(function () {
	      _this8.refreshPage();
	      _this8.onEndEdit();
	    });
	  };
	
	  Website.prototype.refreshPage = function refreshPage() {
	    if (this.iframeRef) {
	      this.iframeRef.contentWindow.postMessage({
	        type: "REFRESH"
	      }, '*');
	    }
	  };
	
	  Website.prototype.onSelectMenu = function onSelectMenu(menuItem) {};
	
	  //
	  // when iFrame is loaded, the website (in edit mode) will send an the site data through postMessage()
	  // this is the handler for that event
	  //
	
	
	  Website.prototype.onIframeLoaded = function onIframeLoaded(eventData) {
	    this.setStatePageOptions(eventData.__edit);
	
	    // controller to get componentUnderEdit
	    this.setState(_extends({}, eventData.__edit));
	  };
	
	  Website.prototype.setStatePageOptions = function setStatePageOptions(_ref) {
	    var pages = _ref.pages,
	        corePages = _ref.corePages;
	
	    var selectOptionForPages = [{}];
	
	    delete corePages['::404']; // we don't need 404 to be one of options
	    delete corePages['::500']; // we don't need 404 to be one of options
	
	    _.each(_extends({}, pages, corePages), function (page) {
	      var id = page.id,
	          title = page.title;
	
	
	      selectOptionForPages.push({
	        label: title,
	        value: id
	      });
	    });
	
	    this.setState({
	      selectOptionForPages: selectOptionForPages
	    });
	  };
	
	  Website.prototype.render = function render() {
	    var _this9 = this;
	
	    var _state3 = this.state,
	        page = _state3.page,
	        pages = _state3.pages,
	        openPreview = _state3.openPreview,
	        editFormSchema = _state3.editFormSchema,
	        currentPagePath = _state3.currentPagePath,
	        _state3$componentUnde = _state3.componentUnderEdit,
	        componentUnderEdit = _state3$componentUnde === undefined ? {} : _state3$componentUnde,
	        isComponentEdit = _state3.isComponentEdit,
	        isAddComponent = _state3.isAddComponent,
	        isPageEdit = _state3.isPageEdit,
	        leftSettingColumnMode = _state3.leftSettingColumnMode,
	        selectOptionForPages = _state3.selectOptionForPages,
	        componentFormSchemas = _state3.componentFormSchemas;
	
	
	    this.defaultSettingSchema = [{
	      sectionName: "general",
	      sectionLabel: "General",
	      fields: [{
	        name: "siteTitle",
	        type: "text",
	        label: "Site Title"
	      }, {
	        name: "siteLogo",
	        type: "mediaCenter",
	        label: "Logo",
	        selectMultiple: false
	      }, {
	        name: "homePage",
	        type: "select",
	        label: __('Home Page', _locale2.default),
	        options: selectOptionForPages
	      }] // fields
	    }];
	
	    var sideMenu = {
	      title: __('Website Settings', _locale2.default),
	      items: [{
	        title: __('Website Settings', _locale2.default),
	        name: 'website_settings',
	        component: function component() {
	          var site = _this9.state.site;
	
	
	          return _react2.default.createElement(_WebsiteSetting2.default, {
	            site: _this9.state.site,
	            onClose: function onClose() {
	              _this9.sideMenuMethods.backToPrevious();
	            },
	            onSubmit: _this9.onSettingSubmit
	          });
	        }
	      }, {
	        title: __('Select Theme', _locale2.default),
	        name: 'select_theme',
	        width: 700,
	        component: function component() {
	          return _react2.default.createElement(_SelectTheme2.default, null);
	        }
	      }, {
	        title: __('Theme Settings', _locale2.default),
	        name: 'theme_settings',
	        width: 450,
	        component: function component() {
	          var _state$themeInfo$sett = _this9.state.themeInfo.settingSchema,
	              settingSchema = _state$themeInfo$sett === undefined ? [] : _state$themeInfo$sett;
	          var site = _this9.state.site;
	
	
	          return _react2.default.createElement(_ThemeSetting2.default, {
	            site: site,
	            settingSchema: [].concat(_this9.defaultSettingSchema, settingSchema),
	            onSubmitThemeSetting: _this9.onSettingSubmit,
	            onCloseThemeSetting: function onCloseThemeSetting() {
	              _this9.sideMenuMethods.backToPrevious();
	            }
	          });
	        }
	      }, {
	        title: __('Nav Settings', _locale2.default),
	        name: 'nav_settings',
	        width: 450,
	        component: function component() {
	          var _state4 = _this9.state,
	              site = _state4.site,
	              selectOptionForPages = _state4.selectOptionForPages;
	
	
	          return _react2.default.createElement(_NavSetting2.default, {
	            site: site,
	            onSubmit: _this9.onSettingSubmit,
	            selectOptionForPages: selectOptionForPages,
	            onClose: function onClose() {
	              _this9.sideMenuMethods.backToPrevious();
	            }
	          });
	        }
	      }, {
	        title: __('Edit Page', _locale2.default),
	        name: 'edit_page',
	        component: function component() {
	          var _state5 = _this9.state,
	              page = _state5.page,
	              pages = _state5.pages,
	              site = _state5.site;
	
	          return _react2.default.createElement(_EditPageOnSideMenu2.default, {
	            site: site,
	            page: page,
	            pages: pages,
	            onChange: _this9.onCurrentPageChange,
	            onStartEdit: function onStartEdit(page) {
	              _this9.setState({
	                isPageEdit: true,
	                page: page
	              });
	            }
	          });
	        }
	      }]
	    };
	
	    var isEdit = false;
	
	    if (isComponentEdit || isPageEdit || isAddComponent) {
	      isEdit = true;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'Website' },
	      _react2.default.createElement(_WebsiteSideMenu2.default, {
	        menu: sideMenu,
	        onSelectMenu: this.onSelectMenu,
	        getMethodsOnLoad: function getMethodsOnLoad(methods) {
	          _this9.sideMenuMethods = methods;
	        }
	      }),
	      _react2.default.createElement(_Preview2.default, {
	        isEdit: isEdit,
	        currentPagePath: currentPagePath,
	        page: page,
	        onEndEdit: this.onEndEdit,
	        onStartEdit: this.onStartEdit,
	        onAddComponent: this.onAddComponent,
	        onMoveComponent: this.onMoveComponent,
	        onDeleteComponent: this.onDeleteComponent,
	        openPreview: openPreview,
	        editFormSchema: editFormSchema,
	        onIframeLoaded: this.onIframeLoaded,
	        registerIframeRef: function registerIframeRef(r) {
	          _this9.iframeRef = r;
	        }
	      }),
	      _react2.default.createElement('div', { className: (0, _classnames2.default)('editMask', { isEdit: isEdit }), onClick: this.onEndEdit }),
	      _react2.default.createElement(_AddComponent2.default, {
	        isEdit: isAddComponent,
	        onSubmit: this.onSubmitAddComponent,
	        onCloseEditor: this.onEndEdit,
	        componentFormSchemas: componentFormSchemas
	      }),
	      _react2.default.createElement(_ComponentEditor2.default, {
	        isEdit: isComponentEdit,
	        editFormSchema: editFormSchema,
	        editFormData: componentUnderEdit,
	        onComponentChange: this.onComponentChange,
	        onSubmit: this.onComponentSubmit,
	        onCloseEditor: this.onEndEdit
	      }),
	      _react2.default.createElement(_PageEditor2.default, {
	        isEdit: isPageEdit,
	        page: page,
	        onDelete: this.onPageDelete,
	        onSubmit: this.onPageSubmit,
	        onClose: this.onClosePageEditor
	      })
	    );
	  };
	
	  return Website;
	}(_react2.default.Component);
	
	exports.default = Website;
	module.exports = exports['default'];

/***/ },

/***/ "He4N":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("VFn9");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "VFn9":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	var _ModalContent = __webpack_require__("jJax");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _resetPassword2 = __webpack_require__("5+v8");
	
	var _resetPassword3 = _interopRequireDefault(_resetPassword2);
	
	var _loginAsUser = __webpack_require__("zyKh");
	
	var _loginAsUser2 = _interopRequireDefault(_loginAsUser);
	
	__webpack_require__("iDC5");
	
	var _isEmpty = __webpack_require__("lHK6");
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_Component) {
	  _inherits(ModalBody, _Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.validateInputs = _this.validateInputs.bind(_this);
	    _this.state = {
	      formData: {},
	      errorMessage: ''
	    };
	    return _this;
	  }
	
	  ModalBody.prototype.resetPassword = function resetPassword() {
	    var _this2 = this;
	
	    var _state$formData = this.state.formData,
	        phone = _state$formData.phone,
	        pin = _state$formData.pin,
	        new_password = _state$formData.new_password;
	    var dismiss = this.props.dismiss;
	
	    var newPhone = phone.country_code.trim() + phone.national_number.trim();
	    (0, _resetPassword3.default)({ phone: newPhone, pin: pin, new_password: new_password }).then(function (res) {
	      if (res.result === 'success') {
	        _this2.setState({ errorMessage: '' });
	        (0, _loginAsUser2.default)({ username: newPhone, password: new_password }).then(function (res) {
	          localStorage.setItem('token', res.data.user_token);
	          dismiss();
	          _alert.alert.success(__('Password Updated', 'settings')).then(function () {
	            _reactRouter.browserHistory.push('/');
	            window.location.reload();
	          });
	        });
	      } else {
	        _this2.setState({ errorMessage: res.reason });
	      }
	    });
	  };
	
	  ModalBody.prototype.validateInputs = function validateInputs() {
	    var formData = this.state.formData;
	
	    if ((0, _isEmpty2.default)(formData) || formData.new_password.length < 6 || (formData.phone.national_number + formData.phone.country_code).length < 6 || formData.pin.length !== 4) {
	      return true;
	    }
	    return false;
	  };
	
	  ModalBody.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'forgot-password-modal',
	        hasHeader: true,
	        hasFooter: true,
	        headerTitle: __('Forgot Password', 'appwrapper'),
	        headerIcon: 'fa icon-tablet',
	        fixedWidth: 500,
	        contentHeight: 300,
	        onCloseModalClick: dismiss,
	        footerType: 'grey',
	        footerButtons: [{
	          title: __('Complete', 'appwrapper'),
	          className: 'btn btn-primary pull-right',
	          onClick: function onClick() {
	            _this3.resetPassword();
	          },
	          isDisabled: this.validateInputs
	        }],
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, {
	        onFormChange: function onFormChange(stateFromModalContent) {
	          _this3.setState({ formData: stateFromModalContent.params });
	        },
	        errorMessage: this.state.errorMessage
	      })
	    );
	  };
	
	  return ModalBody;
	}(_react.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "jJax":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PhoneNumber = __webpack_require__("GM/A");
	
	var _PhoneNumber2 = _interopRequireDefault(_PhoneNumber);
	
	var _alert = __webpack_require__("BGi1");
	
	var _sendPhoneVerification = __webpack_require__("qfzY");
	
	var _sendPhoneVerification2 = _interopRequireDefault(_sendPhoneVerification);
	
	__webpack_require__("iDC5");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_Component) {
	  _inherits(ModalContent, _Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      params: {
	        phone: '',
	        pin: '',
	        new_password: ''
	      },
	      message: 'sent-message',
	      errorMsg: 'noShow',
	      showNewPassword: false,
	      resendCode: false,
	      counterTime: 59,
	      showPassword: false
	    };
	
	    _this.onPhoneChange = _this.onPhoneChange.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	
	    return _this;
	  }
	
	  ModalContent.prototype.onPhoneChange = function onPhoneChange(name) {
	    var _this2 = this;
	
	    return function (value) {
	      var _extends2;
	
	      var onFormChange = _this2.props.onFormChange;
	
	
	      _this2.setState({
	        params: _extends({}, _this2.state.params, (_extends2 = {}, _extends2[name] = value, _extends2))
	      }, function () {
	        onFormChange(_this2.state);
	      });
	    };
	  };
	
	  ModalContent.prototype.onChange = function onChange(name) {
	    var _this3 = this;
	
	    return function (event) {
	      var _extends3;
	
	      var onFormChange = _this3.props.onFormChange;
	
	
	      _this3.setState({
	        params: _extends({}, _this3.state.params, (_extends3 = {}, _extends3[name] = event.target.value, _extends3))
	      }, function () {
	        onFormChange(_this3.state);
	      });
	    };
	  };
	
	  ModalContent.prototype.setVerificationCounter = function setVerificationCounter() {
	    var _this4 = this;
	
	    this.setState({ resendCode: true });
	    this.timmer = setInterval(function () {
	      if (_this4.state.counterTime > 0) {
	        _this4.setState({ counterTime: _this4.state.counterTime - 1 });
	      } else {
	        _this4.setState({ resendCode: false, counterTime: 59 });
	        _this4.clearCounter();
	      }
	    }, 1000);
	  };
	
	  ModalContent.prototype.clearCounter = function clearCounter() {
	    clearInterval(this.timmer);
	  };
	
	  ModalContent.prototype.matchErrorMessages = function matchErrorMessages(errorMessage) {
	    switch (errorMessage) {
	      case 'username does not exist':
	        return __('User does not exist', 'settings');
	      case 'new password is less than 6 characters':
	        return __('Password has to be at least 6 characters long', 'settings');
	      case 'pin is wrong':
	      case 'please request the verification code first':
	        return __('Invalid verification code', 'settings');
	      case 'The verification code has expired':
	        return __('Verification code is expired', 'settings');
	      default:
	        return __('Unexpected errors', 'settings');
	    }
	  };
	
	  ModalContent.prototype.render = function render() {
	    var _this5 = this;
	
	    var _state = this.state,
	        resendCode = _state.resendCode,
	        counterTime = _state.counterTime,
	        showPassword = _state.showPassword;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'forgotpassword-modal-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container-fluid forgot-password-phone-input' },
	        _react2.default.createElement(
	          'div',
	          { className: 'phone-input form-group' },
	          this.props.errorMessage && _react2.default.createElement(
	            'div',
	            { className: 'showErrMsg' },
	            this.matchErrorMessages(this.props.errorMessage)
	          ),
	          _react2.default.createElement(
	            'label',
	            null,
	            __('Please enter your phone number', 'appwrapper')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'phone-input2' },
	            _react2.default.createElement(_PhoneNumber2.default, { className: 'abc', defaultCountry: 'ca', value: this.state.params.phone, onChange: this.onPhoneChange('phone'), onlyCountries: ['ca', 'us'], disableAreaCodes: true }),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary verify-btn', onClick: function onClick() {
	                  var phone = _this5.state.params.phone.country_code.trim() + _this5.state.params.phone.national_number.trim();
	                  (0, _sendPhoneVerification2.default)({ phone: phone, check_phone: 'sendIfUserExist' }).then(function (res) {
	                    if (res.result == 'success') {
	                      _this5.setState({ message: 'show-message', errorMsg: 'noShow' });
	                      _this5.setVerificationCounter();
	                    } else {
	                      _this5.setState({ errorMsg: 'showErrMsg', message: 'sent-message' });
	                    }
	                  }).catch(function (err) {
	                    return _alert.alert.warning(__('Please enter a valid phone number', 'teacher'));
	                  });
	                }, disabled: resendCode },
	              !resendCode ? __("Send Verification Code", 'appwrapper') : __('Resent in {counterTime} s', 'appwrapper', { counterTime: counterTime })
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: this.state.message },
	            __("Verification Code Sent", 'settings')
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: this.state.errorMsg },
	            __("User does not exist, please check the phone number", 'settings')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pin-input form-group' },
	          _react2.default.createElement(
	            'label',
	            null,
	            __('Verification Code', 'appwrapper')
	          ),
	          _react2.default.createElement('input', { type: 'number', placeholder: __('4 digits', 'settings'), className: 'form-control', onChange: this.onChange('pin') })
	        ),
	        _react2.default.createElement(
	          'label',
	          null,
	          __('Enter New Password', 'settings')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'password-input form-group' },
	          _react2.default.createElement(
	            'span',
	            { className: 'password-icon' },
	            _react2.default.createElement('i', { className: 'icon-lock' })
	          ),
	          _react2.default.createElement('input', { className: 'form-control', type: showPassword ? 'text' : 'password', placeholder: __('At least 6 characters', 'settings'), onChange: this.onChange('new_password') }),
	          _react2.default.createElement(
	            'span',
	            { className: 'toggle-text', onClick: function onClick() {
	                return _this5.setState({ showPassword: !showPassword });
	              } },
	            showPassword ? __('hide', 'settings') : __('show', 'settings')
	          )
	        )
	      )
	    );
	  };
	
	  return ModalContent;
	}(_react.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "iDC5":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"forgotpassword-modal-content":"forgotpassword-modal-content","react-tel-input":"react-tel-input","phone-input2":"phone-input2","verify-btn":"verify-btn","sent-message":"sent-message","show-message":"show-message","noShow":"noShow","showErrMsg":"showErrMsg","password-input":"password-input","password-icon":"password-icon","toggle-text":"toggle-text"};

/***/ },

/***/ "xDtR":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'LoginPage',
	  code: 'CN',
	  text: {
	    'Log In to ClassTopBase': '登录 ClassTopBase',
	    'Forgot Your Password?': '忘记你的密码？',
	    'Register New Account': '注册新账户',
	    'Sign In': '登录',
	    'EASY SOLUTION': '轻松管理',
	    'FOR YOUR SCHOOL MANAGEMENT': '您所有的学校事务',
	    'show': '显示',
	    'hide': '隐藏',
	    'Resend in {counterTime}s': '重新发送 ({counterTime})s',
	    'Send Code': '发送验证码',
	    'Unexpected errors': '操作失败',
	    'The Phone No./Password combination is not valid': '用户名或密码错误',
	    'Password has to be at least 6 characters long': '密码长度至少为六位',
	    'User already exists': '用户已存在',
	    'Invalid verification code': '验证码错误',
	    'Verification code is expired': '验证码已过期',
	    'You have used the free trial': '您已经使用过体验版',
	    'Phone Number': '手机号',
	    'Verification Code': '验证码',
	    'Password': '密码',
	    'At least 6 characters': '至少6个字符',
	    'Email': '邮箱',
	    'Or': '或',
	    '4 digits': '4位数字',
	    'Sign up to ClassTopBase': '注册ClassTopBase账号',
	    'Register': '注册'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "9pbx":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Login":"Login","Content":"Content","Loading":"Loading","signedIn":"signedIn","trail-section":"trail-section","section-title":"section-title","feature-title":"feature-title","check-icon":"check-icon","close-icon":"close-icon","section-description":"section-description","included-features":"included-features","btn-start-trial":"btn-start-trial","LoginColumn":"LoginColumn","verification-wrapper":"verification-wrapper","bg-1":"bg-1","overlay":"overlay","logo":"logo","title":"title","react-tel-input":"react-tel-input","flag-dropdown":"flag-dropdown","errorMessage":"errorMessage","password":"password","password-icon":"password-icon","toggle-text":"toggle-text","login":"login","control":"control","btn":"btn","line":"line","or":"or","field-label":"field-label","agreement-text":"agreement-text","bg":"bg","locale-CN":"locale-CN"};

/***/ },

/***/ "eYV8":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("ifxQ");
	
	var _RegisterUser = __webpack_require__("JgpJ");
	
	var _RegisterUser2 = _interopRequireDefault(_RegisterUser);
	
	var _mobileDetect = __webpack_require__("UMwo");
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <MobileScreen 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var MobileScreen = function (_React$Component) {
	  _inherits(MobileScreen, _React$Component);
	
	  function MobileScreen(props) {
	    _classCallCheck(this, MobileScreen);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  MobileScreen.prototype.componentWillMount = function componentWillMount() {};
	
	  MobileScreen.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'mobile-screen' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container-fluid mobile-wrapper text-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'mobile-content' },
	          _react2.default.createElement('img', { className: 'img-responsive mobile-logo', src: __webpack_require__("JadV") }),
	          _react2.default.createElement(
	            'p',
	            { className: 'mobile-text-title' },
	            __("For better user experience, please use 'ClassTopBase' on computer or tablet.", 'appwrapper')
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'mobile-text-title' },
	            __('Or try our mobile app!', 'appwrapper')
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary btn-block mobile-btn', onClick: function onClick() {
	                window.location.href = 'https://smarturl.it/classtopteacher';
	              } },
	            __('Download teacher app', 'appwrapper')
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary btn-block mobile-btn', onClick: function onClick() {
	                window.location.href = 'https://smarturl.it/classtopstudent';
	              } },
	            __('Download student app', 'appwrapper')
	          )
	        )
	      )
	    );
	  };
	
	  return MobileScreen;
	}(_react2.default.Component);
	
	exports.default = MobileScreen;
	module.exports = exports['default'];

/***/ },

/***/ "ifxQ":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"mobile-screen":"mobile-screen","mobile-wrapper":"mobile-wrapper","mobile-logo":"mobile-logo","mobile-content":"mobile-content","mobile-text-title":"mobile-text-title","mobile-btn":"mobile-btn","btn-primary":"btn-primary"};

/***/ },

/***/ "JgpJ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (typeof opts.type === 'undefined') {
	    throw new Error('opts.type is required.');
	  }
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("bsFK");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This modal takes in and id and a type
	// Right now, the types are either 'finance' or 'student'
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports['default'];

/***/ },

/***/ "bsFK":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("7VtY");
	
	var _ModalContent = __webpack_require__("n3Ng");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      height: 400
	    };
	
	    _this.handleHeight = _this.handleHeight.bind(_this);
	    return _this;
	  }
	
	  ModalBody.prototype.handleHeight = function handleHeight(height, modelContentRef) {
	    this.setState({ height: height });
	    if (modelContentRef) {
	      modelContentRef.scrollTop = 0;
	    }
	  };
	
	  ModalBody.prototype.render = function render() {
	    var height = this.state.height;
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'RegisterUserModal',
	        hasHeader: false,
	        hasFooter: false,
	        fixedWidth: 500,
	        contentHeight: height,
	        allowCloseByClickingShadow: false,
	        onCloseModalClick: dismiss,
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, _extends({}, this.props, { onHeightChange: this.handleHeight }))
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "7VtY":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"RegisterUserModal":"RegisterUserModal","classtop-modal-wrapper":"classtop-modal-wrapper","icon-cancel":"icon-cancel","icon-left-big":"icon-left-big","register-msg":"register-msg","register-phone":"register-phone","PhoneNumberInput":"PhoneNumberInput","react-tel-input":"react-tel-input","register-phone-btn":"register-phone-btn","register-msg3-success":"register-msg3-success","errorMsg":"errorMsg","modal-float-body":"modal-float-body","content-wrapper":"content-wrapper","classtop-modal-content":"classtop-modal-content","registerUser-modal-content":"registerUser-modal-content","pin-number":"pin-number","password":"password","agent_id":"agent_id","mobile-success":"mobile-success","mobile-success-text":"mobile-success-text","showMsg":"showMsg","noMsg":"noMsg","registerBtn":"registerBtn","resendBtn":"resendBtn","locale-EN":"locale-EN","desktopRegisterSuccess":"desktopRegisterSuccess","footer":"footer","register-circle":"register-circle","bg":"bg","btn":"btn"};

/***/ },

/***/ "n3Ng":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PhoneNumber = __webpack_require__("GM/A");
	
	var _PhoneNumber2 = _interopRequireDefault(_PhoneNumber);
	
	var _sendPhoneVerification = __webpack_require__("qfzY");
	
	var _sendPhoneVerification2 = _interopRequireDefault(_sendPhoneVerification);
	
	var _registerUser = __webpack_require__("gmOA");
	
	var _registerUser2 = _interopRequireDefault(_registerUser);
	
	var _mobileDetect = __webpack_require__("UMwo");
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	var _loginAsUser = __webpack_require__("zyKh");
	
	var _loginAsUser2 = _interopRequireDefault(_loginAsUser);
	
	var _alert = __webpack_require__("BGi1");
	
	var _locale = __webpack_require__("4fEO");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("7VtY");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var COUNT_DOWN_SECONDS = 59;
	var DEFAULT_REGION_CODE = 'ca';
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      steps: 1,
	      phone: { country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE },
	      newPhone: '',
	      verificationCode: '',
	      agentId: '',
	      password: '',
	      email: '',
	      errorMsg: '',
	      showMsg: false,
	      showVerificationFailure: false,
	      counterTime: COUNT_DOWN_SECONDS,
	      resendCode: false
	    };
	
	    _this.createSchool = _this.createSchool.bind(_this);
	    _this.startUsing = _this.startUsing.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onKeyDownRegisterPhone = _this.onKeyDownRegisterPhone.bind(_this);
	    return _this;
	  }
	
	  ModalContent.prototype.createSchool = function createSchool() {
	    var proceed = this.props.proceed;
	    var _state = this.state,
	        _state$phone = _state.phone,
	        phone = _state$phone === undefined ? '' : _state$phone,
	        password = _state.password,
	        newPhone = _state.newPhone;
	
	
	    this.setState({
	      creatingSchool: true
	    });
	
	    (0, _loginAsUser2.default)({
	      username: newPhone,
	      password: password
	    }).then(function (res) {
	      if (res.data && res.data.result === 'success') {
	        localStorage.setItem('token', res.data.user_token);
	        proceed({
	          createSchool: true
	        });
	      }
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  ModalContent.prototype.startUsing = function startUsing() {
	    var _this2 = this;
	
	    var _state2 = this.state,
	        _state2$phone = _state2.phone,
	        phone = _state2$phone === undefined ? '' : _state2$phone,
	        password = _state2.password;
	
	
	    var newPhone = phone.country_code + phone.national_number;
	
	    (0, _loginAsUser2.default)({ username: newPhone, password: password }).then(function (res) {
	      if (res.data && res.data.result === 'success') {
	        localStorage.setItem('token', res.data.user_token);
	        _this2.props.proceed({
	          createSchool: false
	        });
	      }
	    }).catch(function (err) {});
	  };
	
	  ModalContent.prototype.onChange = function onChange(name) {
	    var _this3 = this;
	
	    if (name == 'phone') {
	      return function (e) {
	        var _this3$setState;
	
	        _this3.setState((_this3$setState = {}, _this3$setState[name] = e, _this3$setState));
	      };
	    } else {
	      return function (e) {
	        var _this3$setState2;
	
	        _this3.setState((_this3$setState2 = {}, _this3$setState2[name] = e.target.value, _this3$setState2));
	      };
	    }
	  };
	
	  ModalContent.prototype.onKeyDownRegisterPhone = function onKeyDownRegisterPhone(event) {
	    var _this4 = this;
	
	    var phone = this.state.phone;
	
	    if (event.keyCode == 13) {
	      (0, _sendPhoneVerification2.default)({ phone: phone, check_phone: 'sendIfUserNotExist' }).then(function (res) {
	        if (res.result == 'success') {
	          _this4.setState({ steps: 2, showMsg: false, showVerificationFailure: true }, onHeightChange(600, _this4.modelContentRef));
	        } else {
	          _this4.setState({ showMsg: true, showVerificationFailure: false });
	        }
	      }).catch(function (err) {
	        _this4.setState({ showVerificationFailure: true });
	      });
	    }
	  };
	
	  ModalContent.prototype.setVerificationCounter = function setVerificationCounter() {
	    var _this5 = this;
	
	    this.setState({ resendCode: true });
	    this.timmer = setInterval(function () {
	      if (_this5.state.counterTime > 0) {
	        _this5.setState({ counterTime: _this5.state.counterTime - 1 });
	      } else {
	        _this5.setState({ resendCode: false, counterTime: COUNT_DOWN_SECONDS });
	        _this5.clearCounter();
	      }
	    }, 1000);
	  };
	
	  ModalContent.prototype.clearCounter = function clearCounter() {
	    clearInterval(this.timmer);
	  };
	
	  ModalContent.prototype.renderSignUpProcess = function renderSignUpProcess() {
	    var _this6 = this;
	
	    var _state3 = this.state,
	        steps = _state3.steps,
	        phone = _state3.phone,
	        verificationCode = _state3.verificationCode,
	        agentId = _state3.agentId,
	        password = _state3.password,
	        errorMsg = _state3.errorMsg,
	        showMsg = _state3.showMsg,
	        creatingSchool = _state3.creatingSchool,
	        email = _state3.email,
	        showVerificationFailure = _state3.showVerificationFailure,
	        counterTime = _state3.counterTime,
	        resendCode = _state3.resendCode,
	        newPhone = _state3.newPhone;
	    var _props = this.props,
	        dismiss = _props.dismiss,
	        onHeightChange = _props.onHeightChange,
	        type = _props.type;
	
	
	    if (steps == 1) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'row text-center RegisterUserModal--step-1' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'nav-btn' },
	            _react2.default.createElement(
	              'span',
	              { className: 'pull-right register-cancel' },
	              _react2.default.createElement('i', { className: 'fa icon-cancel pull-left register-cancel', onClick: function onClick() {
	                  dismiss();
	                } })
	            )
	          ),
	          _react2.default.createElement('img', {
	            className: 'register-circle',
	            src: __webpack_require__("15mg")
	          }),
	          _react2.default.createElement(
	            'p',
	            { className: 'register-msg' },
	            __('Please enter your phone number', 'appwrapper', null, true)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: showMsg ? 'showMsg register-msg3-failed' : 'noMsg' },
	            __('User already registered, please sign in or sign up with different phone number', 'appwrapper')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: showVerificationFailure ? 'showMsg register-msg3-failed' : 'noMsg' },
	            __('Invalid phone number!', 'appwrapper')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'register-phone' },
	            _react2.default.createElement(_PhoneNumber2.default, { defaultCountry: 'ca',
	              value: phone,
	              onChange: this.onChange('phone'),
	              onKeyDown: this.onKeyDownRegisterPhone,
	              onlyCountries: ['ca', 'us'],
	              dropdownStyle: { 'text-align': 'left', 'width': '300px' },
	              autoComplete: 'off',
	              disableAreaCodes: true
	            }),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary register-phone-btn', onClick: function onClick() {
	                  var newPhone = phone.country_code + phone.national_number;
	                  _this6.setState({ newPhone: newPhone });
	
	                  (0, _sendPhoneVerification2.default)({ phone: newPhone, check_phone: 'sendIfUserNotExist' }).then(function (res) {
	                    if (res.result == 'success') {
	                      _this6.setState({ steps: 2, showMsg: false, showVerificationFailure: false }, onHeightChange(540, _this6.modelContentRef));
	                      _this6.setVerificationCounter();
	                    } else if (res.result === 'failure' && res.reason === 'wrong phone number') {
	                      _this6.setState({ showMsg: false, showVerificationFailure: true });
	                    } else {
	                      _this6.setState({ showMsg: true, showVerificationFailure: false });
	                    }
	                  }).catch(function (err) {
	                    _this6.setState({ showVerificationFailure: true });
	                  });
	                } },
	              __('Next ', 'appwrapper', null, true)
	            )
	          )
	        )
	      );
	    } else if (steps == 2) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'row text-center RegisterUserModal--step-2' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'nav-btn' },
	            _react2.default.createElement(
	              'span',
	              { className: 'pull-right register-cancel' },
	              _react2.default.createElement('i', { className: 'fa icon-cancel pull-left register-cancel', onClick: function onClick() {
	                  dismiss();
	                } })
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'pull-left register-cancel' },
	              _react2.default.createElement('i', { className: 'fa icon-left-big pull-left register-cancel', onClick: function onClick() {
	                  _this6.clearCounter();
	                  _this6.setState({ steps: 1, counterTime: COUNT_DOWN_SECONDS }, onHeightChange(400));
	                } })
	            )
	          ),
	          _react2.default.createElement('img', { className: 'register-circle', src: __webpack_require__("15mg") }),
	          _react2.default.createElement(
	            'p',
	            { className: 'register-msg' },
	            __('Verify your phone number', 'appwrapper')
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'register-msg2' },
	            __('The verification code is sent to: {phone}', 'appwrapper', { phone: newPhone })
	          ),
	          !resendCode && _react2.default.createElement(
	            'p',
	            { className: 'register-msg2' },
	            _react2.default.createElement(
	              'a',
	              { className: 'resendBtn', onClick: function onClick() {
	                  var newPhone = phone.country_code + phone.national_number;
	
	                  (0, _sendPhoneVerification2.default)({ phone: newPhone, check_phone: 'sendIfUserNotExist' }).then(function (res) {
	                    _this6.setVerificationCounter();
	                  });
	                } },
	              __('Resend verification code', 'appwrapper')
	            )
	          ),
	          resendCode && _react2.default.createElement(
	            'p',
	            { className: 'register-msg2' },
	            __('Verification code can be resent in {counterTime} seconds ', 'appwrapper', { counterTime: counterTime })
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: errorMsg == 'User already exists' ? 'register-msg3-failed' : 'register-msg3-success' },
	            __('User already registered, please sign in or sign up with different phone number', 'appwrapper')
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: errorMsg == 'new password is less than 6 characters' ? 'register-msg3-failed' : 'register-msg3-success' },
	            __('Password must be at least 6 characters', 'appwrapper')
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: errorMsg == 'pin is wrong' ? 'register-msg3-failed' : 'register-msg3-success' },
	            __('Incorrect PIN', 'appwrapper')
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: errorMsg == 'The verification code has expired' ? 'register-msg3-failed' : 'register-msg3-success' },
	            __('PIN expired', 'appwrapper')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid', style: { width: '60%' } },
	            _react2.default.createElement('input', { type: 'number', className: 'form-control pin-number', placeholder: __('Verification Code', 'appwrapper'), value: verificationCode, onChange: this.onChange('verificationCode') }),
	            _react2.default.createElement('input', { type: 'password', className: 'form-control password', placeholder: __('New Password', 'appwrapper'),
	              value: password, onChange: this.onChange('password'), onKeyPress: this.onUserSignup1 }),
	            _react2.default.createElement('input', { type: 'email', className: 'form-control password', placeholder: __('Email', _locale2.default), value: email, onChange: this.onChange('email') }),
	            _react2.default.createElement('input', { type: 'number', className: 'form-control agent_id', placeholder: __('Agent ID (Optional)', 'appwrapper'),
	              value: agentId, onChange: this.onChange('agentId'), onKeyPress: this.onUserSignup1 }),
	            _react2.default.createElement(
	              'p',
	              { style: { fontSize: '12px' } },
	              __('By clicking Register, you agree to our ', 'appwrapper'),
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', href: __('https://base.classtop.com/terms-of-service-en.html', 'appwrapper') },
	                __('Terms of Service', 'appwrapper')
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary register2-phone-btn btn-block registerBtn', onClick: function onClick() {
	                  if (!verificationCode || !password || !email) {
	                    return _alert.alert.warning(__('Verification Code, New Password, and Email are required', _locale2.default)).then(function () {});
	                  }
	                  var newPhone = phone.country_code + phone.national_number;
	
	                  (0, _registerUser2.default)({ phone: newPhone, pin: verificationCode, new_password: password, agent_id: agentId, email: email }).then(function (res) {
	                    if (res.result == 'success') {
	                      _this6.setState({ steps: 3 }, onHeightChange(600, _this6.modelContentRef));
	                    } else if (res.result == 'failure') {
	                      _this6.setState({ errorMsg: res.reason });
	                    }
	                  });
	                } },
	              __('Register', 'appwrapper')
	            )
	          )
	        )
	      );
	    } else if (steps == 3) {
	      if (type === 'mobile') {
	        return _react2.default.createElement(
	          'div',
	          { className: 'row text-center RegisterUserModal--step-3-mobile' },
	          _react2.default.createElement(
	            'div',
	            { className: 'mobile-success' },
	            _react2.default.createElement('img', { className: 'register-circle', src: __webpack_require__("68Kf") }),
	            _react2.default.createElement(
	              'div',
	              { className: 'mobile-success-text' },
	              __('Sign up successful, please download our app!', 'appwrapper')
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-block register-phone', onClick: function onClick() {
	                  var md = new _mobileDetect2.default(window.navigator.userAgent);
	
	                  if (md.os() == 'iOS') {
	                    window.location.href = 'https://itunes.apple.com/ca/app/classtop-for-school-staff/id1315842973?mt=8';
	                  } else if (md.os() == 'AndroidOS') {
	                    window.location.href = 'https://play.google.com/store/apps/details?id=com.company.classtop.ionic&hl=en';
	                  } else {}
	                } },
	              __('Download', 'appwrapper')
	            )
	          )
	        );
	      } else if (type == 'desktop') {
	        return _react2.default.createElement(
	          'div',
	          { className: 'desktopRegisterSuccess RegisterUserModal--step-3-desktop' },
	          _react2.default.createElement('div', { className: 'bg', style: { backgroundImage: 'url(' + successBg + ')' } }),
	          _react2.default.createElement(
	            'section',
	            { className: 'footer' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              __('Register Successful', 'appwrapper')
	            ),
	            _react2.default.createElement(
	              'h5',
	              null,
	              __('Login account: {phone}', 'appwrapper', { phone: newPhone })
	            ),
	            creatingSchool !== true && _react2.default.createElement(
	              'a',
	              { className: 'btn btn-primary', onClick: this.createSchool },
	              __('Create School', 'appwrapper')
	            ),
	            creatingSchool !== true && _react2.default.createElement(
	              'a',
	              { className: 'btn', onClick: this.startUsing },
	              __('Start Using', 'appwrapper')
	            )
	          )
	        );
	      }
	    } else {
	      return _react2.default.createElement('div', null);
	    }
	  };
	
	  ModalContent.prototype.render = function render() {
	    var _this7 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'registerUser-modal-content', ref: function ref(_ref) {
	          _this7.modelContentRef = _ref;
	        } },
	      _react2.default.createElement(
	        'div',
	        { className: 'container-fluid' },
	        this.renderSignUpProcess()
	      )
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "4fEO":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'RegisterUserModal',
	  code: 'CN',
	  text: {
	    'Email': '邮箱',
	    'Verification Code, New Password, and Email are required': '验证码，新密码，邮箱必填'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "15mg":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Ellipse_1.ade99b41.png";

/***/ },

/***/ "68Kf":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Group@2x.896cf366.png";

/***/ },

/***/ "JadV":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "logo_blue@3x.4c69a222.png";

/***/ },

/***/ "ZDcJ":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _schoolDetail = __webpack_require__("8VNP");
	
	var _getMenuItems = __webpack_require__("xYRA");
	
	var _getMenuItems2 = _interopRequireDefault(_getMenuItems);
	
	var _SideMenu = __webpack_require__("Byxb");
	
	var _SideMenu2 = _interopRequireDefault(_SideMenu);
	
	var _Header = __webpack_require__("H27k");
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _subscription = __webpack_require__("ue3W");
	
	var _NoPermission = __webpack_require__("zrmO");
	
	var _NoPermission2 = _interopRequireDefault(_NoPermission);
	
	var _ChangeSchool = __webpack_require__("12fy");
	
	var _ChangeSchool2 = _interopRequireDefault(_ChangeSchool);
	
	var _AccountSettings = __webpack_require__("lOrV");
	
	var _AccountSettings2 = _interopRequireDefault(_AccountSettings);
	
	var _cn = __webpack_require__("nhSS");
	
	var _cn2 = _interopRequireDefault(_cn);
	
	var _en = __webpack_require__("WPCA");
	
	var _en2 = _interopRequireDefault(_en);
	
	var _getSubscription2 = __webpack_require__("h7zY");
	
	var _getSubscription3 = _interopRequireDefault(_getSubscription2);
	
	var _routes = __webpack_require__("DP/h");
	
	var _R = __webpack_require__("nRUD");
	
	var _locale = __webpack_require__("cOih");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <MainContainer
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is ...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @redux
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var NO_SUCH_ROUTE = 'NO_SUCH_ROUTE';
	var USER_NOT_LOADED = 'USER_NOT_LOADED';
	var HAS_PERMISSION = 'HAS_PERMISSION';
	var NO_PERMISSION = 'NO_PERMISSION';
	var PAGE_HAS_NO_RESTRICTION = 'PAGE_HAS_NO_RESTRICTION';
	var NOT_FOR_BASIC_USER = 'NOT_FOR_BASIC_USER';
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    schoolDetail: state.schoolDetail.detail || {},
	    subscription: state.gSubscription.result || {},
	    user: state.user
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchSchoolDetail: function fetchSchoolDetail(schoolId) {
	      return dispatch((0, _schoolDetail.fetchSchoolDetail)(schoolId));
	    },
	    getSubscription: function getSubscription(schoolId) {
	      return dispatch((0, _subscription.getSubscription)(schoolId));
	    },
	    clearSchoolDetail: function clearSchoolDetail() {
	      return dispatch((0, _schoolDetail.clearSchoolDetail)());
	    }
	  };
	};
	
	var SEARCH_TIMEOUT = 500;
	
	var MainContainer = function (_React$Component) {
	  _inherits(MainContainer, _React$Component);
	
	  function MainContainer(props) {
	    _classCallCheck(this, MainContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    var sideMenuHidden = localStorage.getItem('_ct_menu_hidden') == "true";
	
	    _this.state = {
	      noSideMenu: true,
	      searchText: '',
	      searchActive: false,
	      sideMenuHidden: sideMenuHidden
	    };
	
	    _this.onMenuLoad = _this.onMenuLoad.bind(_this);
	    _this.onSearchClear = _this.onSearchClear.bind(_this);
	    _this.onSearchChange = _this.onSearchChange.bind(_this);
	    _this.onSearchFocus = _this.onSearchFocus.bind(_this);
	    _this.unfocusSearch = _this.unfocusSearch.bind(_this);
	    _this.registerMainContent = _this.registerMainContent.bind(_this);
	
	    _this.toggleSideMenu = _this.toggleSideMenu.bind(_this);
	    return _this;
	  }
	
	  MainContainer.prototype.componentWillMount = function componentWillMount() {
	    this.menus = (0, _getMenuItems2.default)();
	    var schoolId = localStorage.getItem('schoolId');
	    if (schoolId) {
	      this.props.getSubscription(schoolId);
	      this.setRefreshingSubscription();
	    }
	  };
	
	  MainContainer.prototype.componentDidMount = function componentDidMount() {
	    var schoolId = localStorage.getItem('schoolId');
	
	    if (schoolId) {
	      this.props.fetchSchoolDetail(schoolId);
	    }
	  };
	
	  MainContainer.prototype.setRefreshingSubscription = function setRefreshingSubscription() {
	    var _this2 = this;
	
	    if (!global['--subscription-refresher']) {
	      global['--subscription-refresher'] = setInterval(function () {
	        var schoolId = localStorage.getItem('schoolId');
	        (0, _getSubscription3.default)(schoolId).then(function (res) {
	          if (!res.data.is_valid) {
	            window.location.href = '/';
	          } else {
	            _this2.props.getSubscription(schoolId);
	          }
	        });
	      }, 3600000);
	    }
	  };
	
	  MainContainer.prototype.registerMainContent = function registerMainContent(ref) {
	    if (ref) {
	      global['--classtop-main-section'] = ref;
	    }
	  };
	
	  MainContainer.prototype.onMenuLoad = function onMenuLoad() {};
	
	  MainContainer.prototype.unfocusSearch = function unfocusSearch() {
	    this.setState({
	      searchActive: false
	    });
	  };
	
	  MainContainer.prototype.onSearchFocus = function onSearchFocus() {
	    var searchText = this.state.searchText;
	
	
	    this.setState({
	      searchActive: searchText.length >= 3
	    });
	  };
	
	  MainContainer.prototype.onSearchChange = function onSearchChange(e) {
	    var _this3 = this;
	
	    var searchText = e.target.value;
	
	    this.setState({
	      searchText: searchText,
	      searchActive: false
	    });
	
	    if (this.searchTimeout) {
	      clearTimeout(this.searchTimeout);
	    }
	
	    this.searchTimeout = setTimeout(function () {
	      _this3.setState({
	        searchText: searchText,
	        searchActive: searchText.length >= 3
	      });
	    }, SEARCH_TIMEOUT);
	  };
	
	  MainContainer.prototype.onSearchClear = function onSearchClear() {
	    this.setState({
	      searchText: '',
	      searchActive: false
	    });
	  };
	
	  MainContainer.prototype.toggleSideMenu = function toggleSideMenu() {
	    var sideMenuHidden = this.state.sideMenuHidden !== true;
	
	    localStorage.setItem('_ct_menu_hidden', sideMenuHidden);
	
	    this.setState({
	      sideMenuHidden: sideMenuHidden
	    });
	  };
	
	  MainContainer.prototype.getContent = function getContent(activePath) {
	    if (!(0, _R.isValidUser)() && !(0, _R.isOnlyTeacher)()) {
	      if (activePath === '/') {
	        return _react2.default.createElement(_ChangeSchool2.default, null);
	      } else if (activePath === '/account-settings') {
	        return _react2.default.createElement(_AccountSettings2.default, null);
	      } else if (activePath === '/privacy-en') {
	        return _react2.default.createElement(_en2.default, null);
	      } else if (activePath === '/privacy-cn') {
	        return _react2.default.createElement(_cn2.default, null);
	      }
	    }
	    var result = this.getPagePermission();
	    switch (result) {
	      case NO_SUCH_ROUTE:
	        {
	          return _react2.default.createElement('span', null);
	        }
	      case USER_NOT_LOADED:
	        {
	          return _react2.default.createElement('span', null);
	        }
	      case NOT_FOR_BASIC_USER:
	        {
	          return _react2.default.createElement(
	            'div',
	            { className: 'upgrade-plan' },
	            __('Please upgrade to higher subscription plan to unlock this feature', _locale2.default)
	          );
	        }
	      case PAGE_HAS_NO_RESTRICTION:
	        {
	          return this.props.children;
	        }
	      case HAS_PERMISSION:
	        {
	          return this.props.children;
	        }
	      case NO_PERMISSION:
	        {
	          return _react2.default.createElement(_NoPermission2.default, null);
	        }
	    }
	  };
	
	  MainContainer.prototype.getPagePermission = function getPagePermission() {
	    var _props = this.props,
	        user = _props.user,
	        routes = _props.routes;
	    var path = routes[1].path;
	
	
	    var route = _routes.routesObj[path];
	
	    if (!route) {
	      return NO_SUCH_ROUTE;
	    }
	
	    //
	    // Check if user has permission to view the page
	    //
	    var permissionRequired = route.permissionRequired,
	        notForBasicUser = route.notForBasicUser;
	
	
	    if (user.loaded !== true) {
	      return USER_NOT_LOADED; // user not loaded don't show anything
	    }
	    var schoolId = localStorage.getItem('schoolId');
	
	    if ((0, _R.isBasicUser)() && notForBasicUser) {
	      return NOT_FOR_BASIC_USER;
	    }
	    var hasPermission = false;
	
	    if (typeof permissionRequired == 'undefined') {
	      return PAGE_HAS_NO_RESTRICTION;
	    }
	
	    if (user.loaded && Object.keys(user.rolesPerSchool).length > 0 && schoolId && typeof user.rolesPerSchool[schoolId] !== 'undefined') {
	
	      var schoolRole = user.rolesPerSchool[schoolId];
	
	      if (schoolRole.role == 'school_owner') {
	        hasPermission = true;
	      } else {
	        var hasAllPermission = true;
	
	        // if missing permission all fails
	        permissionRequired.map(function (perm) {
	          if (schoolRole.permissions.indexOf(perm) == -1) {
	            hasAllPermission = false;
	          }
	        });
	
	        hasPermission = hasAllPermission;
	      }
	    }
	
	    return hasPermission == true ? HAS_PERMISSION : NO_PERMISSION;
	  };
	
	  MainContainer.prototype.render = function render() {
	    var _props2 = this.props,
	        user = _props2.user,
	        subscription = _props2.subscription,
	        schoolDetail = _props2.schoolDetail,
	        routes = _props2.routes;
	    var _state = this.state,
	        noSideMenu = _state.noSideMenu,
	        searchText = _state.searchText,
	        searchActive = _state.searchActive,
	        sideMenuHidden = _state.sideMenuHidden;
	
	
	    var Collapsed = false; // implement it later
	
	    var activePath = '';
	    if (!(0, _R.isValidUser)() && user.result.school_amount - user.result.school_owned_amount < 1) {
	      if (_getMenuItems.invalidUserAllowedPath.indexOf(routes[1].path) !== -1) {
	        activePath = routes[1].path;
	      } else {
	        activePath = '/';
	      }
	    } else {
	      activePath = routes[1].path;
	    }
	    var Content = this.getContent(activePath);
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('MainContainer', { noSideMenu: _getMenuItems.fullScreenPath.indexOf(activePath) > -1, sideMenuHidden: sideMenuHidden }) },
	      _getMenuItems.fullScreenPath.indexOf(activePath) === -1 && _react2.default.createElement(_SideMenu2.default, {
	        menus: this.menus,
	        activePath: activePath,
	        onMenuLoad: this.onMenuLoad,
	        subscription: this.props.subscription,
	
	        toggleSideMenu: this.toggleSideMenu,
	        sideMenuHidden: sideMenuHidden
	      }),
	      _react2.default.createElement(_Header2.default, {
	        user: user.result,
	        schoolDetail: schoolDetail,
	        onSearchChange: this.onSearchChange,
	        onSearchClear: this.onSearchClear,
	        onSearchFocus: this.onSearchFocus,
	        searchText: searchText,
	        searchActive: searchActive
	      }),
	      searchActive && _react2.default.createElement('div', { className: 'searchOverlay', onClick: this.unfocusSearch }),
	      _react2.default.createElement(
	        'div',
	        { className: 'Content', ref: this.registerMainContent },
	        Content
	      )
	    );
	  };
	
	  return MainContainer;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MainContainer);
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "xYRA":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.invalidUserAllowedPath = exports.fullScreenPath = undefined;
	
	exports.default = function () {
	  // this here is Main.js component
	
	  return [{
	    name: 'dashboard',
	    label: __("Home", _locale2.default),
	    icon: "icon-dashboard",
	    active: true,
	    subMenus: [{
	      label: __("Dashboard", _locale2.default),
	      path: '/dashboard',
	      default: true,
	      active: true
	      // disabled: ()=>{
	      //   return !userCan('announcement_channel')
	      // }
	    }, {
	      label: __("Activity Log", _locale2.default),
	      path: "/logs",
	      onClick: function onClick() {
	        if ((0, _R.isBasicUser)()) {
	          _alert.alert.warning(__('Please upgrade to higher subscription plan to unlock this feature', _locale2.default));
	        }
	      },
	      disabled: function disabled() {
	        return !(0, _R.userCan)('operation_log_channel') || (0, _R.isBasicUser)();
	      }
	    }]
	  }, {
	    name: 'teaching',
	    label: __("Administration", _locale2.default),
	    icon: "icon-assignment",
	    subMenus: [{
	      label: __("Schedules", _locale2.default),
	      path: "/schedule",
	      onClick: function onClick() {
	        // default
	      },
	      disabled: function disabled() {
	        return !(0, _R.userCan)('timetable_channel');
	      }
	    }, {
	      label: __("Students", _locale2.default),
	      path: "/student",
	      activePaths: ['/student-settings'],
	      disabled: function disabled() {
	        return !(0, _R.userCan)('student_channel');
	      }
	    }, {
	      label: __("Classes", _locale2.default),
	      path: "/class",
	      activePaths: ['/class-detail/:classId'],
	      disabled: function disabled() {
	        return !(0, _R.userCan)('class_channel');
	      }
	    }, {
	      label: __("Private Classes", _locale2.default),
	      path: "/one_one",
	      activePaths: ['/class-one-detail/:classId'],
	      disabled: function disabled() {
	        return !(0, _R.userCan)('private_class_channel');
	      }
	    }, {
	      label: __("Teachers", _locale2.default),
	      path: "/teacher",
	      disabled: function disabled() {
	        return !(0, _R.userCan)('teacher_channel');
	      }
	    }, {
	      label: __("Classrooms", _locale2.default),
	      path: "/classroom",
	      disabled: function disabled() {
	        return !(0, _R.userCan)('classroom_channel');
	      }
	    }, {
	      label: __("Announcements", _locale2.default),
	      path: "/announcement",
	      disabled: function disabled() {
	        return !(0, _R.userCan)('announcement_channel');
	      }
	    }]
	  }, {
	    name: 'finance',
	    label: __("Finance", _locale2.default),
	    icon: "icon-assessment",
	    subMenus: [{
	      label: __("Statement Detail", _locale2.default),
	      default: true,
	      path: "/finance",
	      disabled: function disabled() {
	        return !(0, _R.userCan)('finance_channel');
	      }
	    }, {
	      label: __("Monthly Summary", _locale2.default),
	      path: "/monthly-finance",
	      disabled: function disabled() {
	        return !(0, _R.userCan)('finance_channel');
	      }
	    }]
	  }, {
	    name: 'marketing',
	    label: __("Marketing", _locale2.default),
	    icon: "icon-perm_contact_calendar",
	    subMenus: [{
	      label: __("Posters", _locale2.default),
	      default: true,
	      path: "/poster",
	      activePaths: ['/edit-poster/:posterId', '/registration-table/:posterId'],
	      onClick: function onClick() {
	        if ((0, _R.isBasicUser)()) {
	          _alert.alert.warning(__('Please upgrade to higher subscription plan to unlock this feature', _locale2.default));
	        }
	      },
	      disabled: function disabled() {
	        return !(0, _R.userCan)('poster_channel') || (0, _R.isBasicUser)();
	      }
	    }, {
	      label: __("Contacts", _locale2.default),
	      path: "/contacts",
	      activePaths: ['/contact-settings'],
	      onClick: function onClick() {
	        if ((0, _R.isBasicUser)()) {
	          _alert.alert.warning(__('Please upgrade to higher subscription plan to unlock this feature', _locale2.default));
	        }
	      },
	      disabled: function disabled() {
	        return !(0, _R.userCan)('contact_channel') || (0, _R.isBasicUser)();
	      }
	    }]
	  }, {
	    name: 'school',
	    label: __("School Settings", _locale2.default),
	    icon: "icon-account_balance",
	    subMenus: [{
	      label: __("Information", _locale2.default),
	      default: true,
	      path: "/school-information",
	      disabled: function disabled() {
	        return !(0, _R.userCan)('school_setting_channel');
	      }
	    }, {
	      label: __("Permissions", _locale2.default),
	      path: "/school-settings",
	      disabled: function disabled() {
	        return !(0, _R.userCan)('group_perm_channel');
	      }
	    }, {
	      label: __("Website", _locale2.default),
	      path: "/website",
	      hide: function hide() {
	        return ("production") !== 'development';
	      },
	      disabled: function disabled() {
	        return !(0, _R.userCan)('website');
	      }
	    }, {
	      label: __("Terms and Conditions", _locale2.default),
	      path: "/registration-agreement",
	      disabled: function disabled() {
	        return !(0, _R.userCan)('edit_school_setting');
	      }
	    }]
	  }];
	};
	
	var _locale = __webpack_require__("cOih");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _alert = __webpack_require__("BGi1");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fullScreenPath = exports.fullScreenPath = ['/', '/upgrade', '/privacy-en', '/privacy-cn', '/print-schedule', '/account-settings', '/website']; /*
	                                                                                                                                                     icon-assignment
	                                                                                                                                                     icon-dashboard
	                                                                                                                                                     icon-devices
	                                                                                                                                                     icon-perm_contact_calendar
	                                                                                                                                                     icon-assessment
	                                                                                                                                                   */
	var invalidUserAllowedPath = exports.invalidUserAllowedPath = ['/', '/privacy-en', '/privacy-cn', '/account-settings'];

/***/ },

/***/ "cOih":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'SideMenu',
	  code: 'CN',
	  text: {
	    '{ticket_amount}': '{ticket_amount}人',
	    'Administration': '教务管理',
	    'Schedules': '课表',
	    'Students': '学员',
	    'Classes': '班级',
	    'Private Classes': '私课',
	    'Teachers': '老师',
	    'Classrooms': '教室',
	    'Announcements': '公告',
	    'Finance': '财务管理',
	    'Statement Detail': '收支明细',
	    'Monthly Summary': '月度汇总',
	    'Marketing': '营销管理',
	    'Posters': '海报',
	    'Contacts': '联系人',
	    'School Settings': '学校设置',
	    'Information': '学校信息',
	    'Permissions': '权限设置',
	    'Website': '官网设置',
	    'Terms and Conditions': '注册条款',
	    'Please upgrade to higher subscription plan to unlock this feature': '请升级您的计划以解锁此功能',
	    'Activity Log': '操作记录',
	    'Dashboard': '仪表盘',
	    'Home': '控制台'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "Byxb":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("se6L");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <SideMenu
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var SideMenu = function (_React$Component) {
	  _inherits(SideMenu, _React$Component);
	
	  function SideMenu(props) {
	    _classCallCheck(this, SideMenu);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {};
	
	    _this.onSelectMenu = _this.onSelectMenu.bind(_this);
	    _this.onSelectSubMenu = _this.onSelectSubMenu.bind(_this);
	    return _this;
	  }
	
	  SideMenu.prototype.componentWillMount = function componentWillMount() {
	    this.getActiveMenuFromPath();
	  };
	
	  SideMenu.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var activePath = _ref.activePath;
	
	    if (this.activePath != activePath) {
	
	      this.activePath = activePath;
	
	      this.getActiveMenuFromPath();
	    }
	  };
	
	  SideMenu.prototype.getActiveMenuFromPath = function getActiveMenuFromPath() {
	    var _props = this.props,
	        menus = _props.menus,
	        onMenuLoad = _props.onMenuLoad,
	        activePath = _props.activePath;
	
	
	    var pathToCompare = this.activePath || activePath;
	
	    var activeMenu = void 0;
	
	    menus.map(function (_ref2) {
	      var _ref2$subMenus = _ref2.subMenus,
	          subMenus = _ref2$subMenus === undefined ? [] : _ref2$subMenus,
	          name = _ref2.name;
	
	      subMenus.map(function (_ref3) {
	        var path = _ref3.path,
	            _ref3$activePaths = _ref3.activePaths,
	            activePaths = _ref3$activePaths === undefined ? [] : _ref3$activePaths;
	
	        if (pathToCompare === path) {
	          activeMenu = name;
	        } else if (activePaths.indexOf(pathToCompare) > -1) {
	          activeMenu = name;
	        }
	      });
	    });
	
	    this.setState({
	      activeMenu: activeMenu
	    });
	
	    onMenuLoad(activeMenu);
	  };
	
	  SideMenu.prototype.onSelectMenu = function onSelectMenu(menu) {
	    var _this2 = this;
	
	    return function () {
	      var name = menu.name;
	
	
	      _this2.setState({
	        openedMenu: name
	      });
	
	      //menu.subMenus.map((subMenu)=>{
	      //  if (subMenu.default) {
	      //    browserHistory.push(subMenu.path);
	      //  }
	      //});
	    };
	  };
	
	  SideMenu.prototype.onSelectSubMenu = function onSelectSubMenu(subMenu) {
	    return function () {
	      if (typeof subMenu.onClick == 'function' && typeof subMenu.disabled == 'function') {
	        if (subMenu.disabled()) {
	          return subMenu.onClick();
	        }
	      } else if (typeof subMenu.disabled == 'function') {
	        if (subMenu.disabled()) {
	          return;
	        }
	      } else if (subMenu.disabled) {
	        return;
	      }
	      _reactRouter.browserHistory.push(subMenu.path);
	    };
	  };
	
	  SideMenu.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props2 = this.props,
	        menus = _props2.menus,
	        activePath = _props2.activePath,
	        toggleSideMenu = _props2.toggleSideMenu,
	        sideMenuHidden = _props2.sideMenuHidden;
	    var _state = this.state,
	        activeMenu = _state.activeMenu,
	        openedMenu = _state.openedMenu;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('SideMenu', { 'SideMenu__hidden': sideMenuHidden }) },
	      _react2.default.createElement(
	        'div',
	        { className: 'SideMenu--content' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'menus' },
	          menus.map(function (menu, key) {
	            var label = menu.label,
	                path = menu.path,
	                icon = menu.icon,
	                subMenus = menu.subMenus,
	                name = menu.name;
	
	            return _react2.default.createElement(
	              'li',
	              { key: key, className: (0, _classnames2.default)('menus--item', name, { active: activeMenu === name, opened: openedMenu == name }) },
	              _react2.default.createElement(
	                'div',
	                { className: 'menus--item--content', onClick: _this3.onSelectMenu(menu) },
	                _react2.default.createElement('i', { className: (0, _classnames2.default)('menus--item--icon', icon) }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'menus--item--name' },
	                  label
	                )
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'subMenus' },
	                subMenus.map(function (menu, key) {
	                  var label = menu.label,
	                      path = menu.path,
	                      _menu$activePaths = menu.activePaths,
	                      activePaths = _menu$activePaths === undefined ? [] : _menu$activePaths;
	
	                  var active = false;
	
	                  if (activePath === path || activePaths.indexOf(activePath) > -1) {
	                    active = true;
	                  }
	
	                  if (typeof menu.hide == 'function' && menu.hide()) {
	                    return;
	                  }
	
	                  return _react2.default.createElement(
	                    'li',
	                    { key: key, className: (0, _classnames2.default)({ active: active, disabled: typeof menu.disabled == 'function' ? menu.disabled() : false }), onClick: _this3.onSelectSubMenu(menu) },
	                    label
	                  );
	                })
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'SideMenu--hideToggle' },
	          sideMenuHidden !== true && _react2.default.createElement('i', { className: 'fa icon-left-big', onClick: toggleSideMenu }),
	          sideMenuHidden === true && _react2.default.createElement('i', { className: 'fa icon-right-big', onClick: toggleSideMenu })
	        )
	      )
	    );
	  };
	
	  return SideMenu;
	}(_react2.default.Component);
	
	exports.default = SideMenu;
	module.exports = exports['default'];

/***/ },

/***/ "se6L":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"locale-CN":"locale-CN","SideMenu":"SideMenu","menus--item":"menus--item","subMenus":"subMenus","SideMenu__hidden":"SideMenu__hidden","menus":"menus","active":"active","teaching":"teaching","finance":"finance","marketing":"marketing","school":"school","menus--item--icon":"menus--item--icon","menus--item--name":"menus--item--name","SideMenu--content":"SideMenu--content","menus--item--content":"menus--item--content","opened":"opened","SideMenu--hideToggle":"SideMenu--hideToggle"};

/***/ },

/***/ "H27k":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _reactBootstrap = __webpack_require__("3kvR");
	
	var _version = __webpack_require__("kB8h");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _SearchResult = __webpack_require__("Xv7M");
	
	var _SearchResult2 = _interopRequireDefault(_SearchResult);
	
	var _subscription = __webpack_require__("ue3W");
	
	var _alert = __webpack_require__("BGi1");
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _locale = __webpack_require__("bIlh");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("6eRx");
	
	var _CreateStudent = __webpack_require__("yvp6");
	
	var _CreateStudent2 = _interopRequireDefault(_CreateStudent);
	
	var _CreateTeacher = __webpack_require__("dZ0O");
	
	var _CreateTeacher2 = _interopRequireDefault(_CreateTeacher);
	
	var _CreateClass = __webpack_require__("dFGx");
	
	var _CreateClass2 = _interopRequireDefault(_CreateClass);
	
	var _CreateClassOne = __webpack_require__("sbFW");
	
	var _CreateClassOne2 = _interopRequireDefault(_CreateClassOne);
	
	var _CreateClassroom = __webpack_require__("q1HF");
	
	var _CreateClassroom2 = _interopRequireDefault(_CreateClassroom);
	
	var _Announcement = __webpack_require__("j/11");
	
	var _Announcement2 = _interopRequireDefault(_Announcement);
	
	var _PosterType = __webpack_require__("qmPG");
	
	var _PosterType2 = _interopRequireDefault(_PosterType);
	
	var _PotentialClient = __webpack_require__("r8r1");
	
	var _PotentialClient2 = _interopRequireDefault(_PotentialClient);
	
	var _AttendanceScanMessage = __webpack_require__("EnYG");
	
	var _AttendanceScanMessage2 = _interopRequireDefault(_AttendanceScanMessage);
	
	var _CreateSchool = __webpack_require__("biI2");
	
	var _CreateSchool2 = _interopRequireDefault(_CreateSchool);
	
	var _MediaCenter = __webpack_require__("LEzc");
	
	var _MediaCenter2 = _interopRequireDefault(_MediaCenter);
	
	var _logo_blue2x = __webpack_require__("FG4y");
	
	var _logo_blue2x2 = _interopRequireDefault(_logo_blue2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Header
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    subscription: state.gSubscription,
	    user: state.user
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getSubscription: function getSubscription(schoolId) {
	      return dispatch((0, _subscription.getSubscription)(schoolId));
	    }
	  };
	};
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    var currentLocale = localStorage.getItem('language');
	
	    _this.getVersionName = _this.getVersionName.bind(_this);
	    _this.changeLocale = _this.changeLocale.bind(_this);
	    _this.signOut = _this.signOut.bind(_this);
	
	    _this.state = {
	      version: (0, _version.getVersion)(currentLocale),
	      searchText: '',
	      currentLocale: currentLocale,
	      showUpgradeMessage: true
	    };
	    return _this;
	  }
	
	  Header.prototype.componentWillMount = function componentWillMount() {};
	
	  Header.prototype.signOut = function signOut() {
	    localStorage.removeItem('token');
	    localStorage.removeItem('schoolId');
	    if (global['--subscription-refresher']) {
	      clearInterval(global['--subscription-refresher']);
	    }
	    window.location.href = '/';
	  };
	
	  Header.prototype.getVersionName = function getVersionName() {
	    var _props$subscription$r = this.props.subscription.result,
	        saas_version = _props$subscription$r.saas_version,
	        days_left = _props$subscription$r.days_left;
	
	
	    switch (saas_version) {
	      case 0:
	        return __('Free Trial ({daysLeft} days left)', _locale2.default, { daysLeft: days_left });
	      case 1:
	        return __('Discount Plan', 'settings');
	      case 2:
	      case 9:
	      case 10:
	      case 11:
	      case 12:
	        return __('Customized Plan', 'settings');
	      case 3:
	      case 4:
	        return __('Basic Plan', 'settings');
	      case 5:
	      case 6:
	        return __('Professional Plan', 'settings');
	      case 7:
	      case 8:
	        return __('Premium Plan', 'settings');
	      default:
	        return '';
	
	    }
	  };
	
	  Header.prototype.changeLocale = function changeLocale(newCode) {
	    return function () {
	      localStorage.setItem('language', newCode);
	      window.location.reload();
	    };
	  };
	
	  Header.prototype.createAnnouncementModal = function createAnnouncementModal() {
	    (0, _Announcement2.default)({ allowEdit: 'true' });
	  };
	
	  Header.prototype.renderLogDetail = function renderLogDetail(log) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      log.operator_type === 'teacher' ? log.operator_name : 'principal',
	      ' ',
	      log.log_context.operation,
	      ' ',
	      log.log_context.object_type,
	      ' '
	    );
	  };
	
	  Header.prototype.overLimitAlert = function overLimitAlert(type) {
	    _alert.alert.message(__('You are about go over the ' + type + ' limit, please upgrade to higher subscription plan to add more ' + type + 's', 'header'), __('Upgrade Subscription Plan', 'header'));
	  };
	
	  Header.prototype.render = function render() {
	    var _this2 = this;
	
	    var currentLocale = this.state.currentLocale;
	    var _props = this.props,
	        schoolDetail = _props.schoolDetail,
	        subscription = _props.subscription,
	        user = _props.user,
	        onSearchClear = _props.onSearchClear,
	        onSearchChange = _props.onSearchChange,
	        onSearchFocus = _props.onSearchFocus,
	        searchText = _props.searchText,
	        searchActive = _props.searchActive,
	        getSubscription = _props.getSubscription;
	    var _user$result = user.result,
	        user_id = _user$result.user_id,
	        school_owned_amount = _user$result.school_owned_amount;
	
	    var showSchoolInfo = typeof schoolDetail.id !== 'undefined';
	    var showUerInfo = typeof user_id !== 'undefined';
	    var role = localStorage.getItem('role');
	    var schoolId = localStorage.getItem('schoolId');
	
	    if (subscription.fetching) {
	      return _react2.default.createElement('div', null);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('Header', { 'Header__searchActive': searchActive }) },
	      _react2.default.createElement(
	        'div',
	        { className: 'Header--left' },
	        showSchoolInfo && _react2.default.createElement(
	          'div',
	          { className: 'Header--left--brand', onClick: function onClick() {
	              onSearchClear();_reactRouter.browserHistory.push('/student');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'Header--left--logoWrapper' },
	            _react2.default.createElement('img', { src: schoolDetail.logo })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'Header--left--schoolName' },
	            schoolDetail.title
	          )
	        ),
	        showSchoolInfo && _react2.default.createElement(
	          _reactBootstrap.Dropdown,
	          { className: 'Header--left--toggle' },
	          _react2.default.createElement(
	            _reactBootstrap.Dropdown.Toggle,
	            { className: 'btn-link expand-to-left expand-to-down' },
	            _react2.default.createElement('i', { className: 'fa icon-down-open' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Dropdown.Menu,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.MenuItem,
	              { eventKey: 'change-school', onSelect: function onSelect() {
	                  _reactRouter.browserHistory.push('/');
	                } },
	              __('Change School', _locale2.default)
	            ),
	            !(role == 'Teacher' || role == '老师' || role == 'undefined') && _react2.default.createElement(
	              _reactBootstrap.MenuItem,
	              { eventKey: 'create-school', onSelect: function onSelect() {
	                  if (subscription.result.is_valid && (school_owned_amount < subscription.result.maximum_amount.maximum_school || subscription.result.saas_version === 1)) {
	                    (0, _CreateSchool2.default)();
	                  } else {
	                    _this2.overLimitAlert('school');
	                  }
	                } },
	              __('Create New School', _locale2.default),
	              subscription.result.saas_version === 1 && _react2.default.createElement(
	                'small',
	                null,
	                __('$79 USD / month per school', _locale2.default)
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Header--left--version' },
	          !showSchoolInfo && _react2.default.createElement('img', { src: _logo_blue2x2.default, onClick: function onClick() {
	              _reactRouter.browserHistory.push('/');
	            }, style: { height: 18, marginRight: 16, marginTop: -5, cursor: 'pointer' } }),
	          (0, _R.isValidUser)() && !(role == 'Teacher' || role == '老师' || role == 'undefined') && this.getVersionName(),
	          !(0, _R.isValidUser)() && !(0, _R.isOnlyTeacher)() && !(role == 'Teacher' || role == '老师' || role == 'undefined') && _react2.default.createElement(
	            'span',
	            null,
	            __('Need Subscription', _locale2.default)
	          )
	        ),
	        !(0, _R.isOnlyTeacher)() && (subscription.result.saas_version === 0 || !(0, _R.isValidUser)()) && !(role == 'Teacher' || role == '老师' || role == 'undefined') && _react2.default.createElement(
	          'a',
	          { className: 'Header--left--upgradeButton', onClick: function onClick() {
	              return _reactRouter.browserHistory.push('/account-settings');
	            } },
	          __('Subscribe', _locale2.default)
	        )
	      ),
	      showSchoolInfo && false && _react2.default.createElement(
	        'div',
	        { className: 'Header--search' },
	        _react2.default.createElement('input', {
	          type: 'text',
	          value: searchText,
	          onChange: onSearchChange,
	          onFocus: onSearchFocus,
	          placeholder: 'Search...' }),
	        _react2.default.createElement('i', { className: 'fa icon-search' }),
	        searchText.length > 0 && _react2.default.createElement('i', { className: 'fa icon-cancel', onClick: onSearchClear })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'Header--right' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Header--right--tools' },
	          ("production") === 'development' && _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary', onClick: function onClick() {
	                (0, _MediaCenter2.default)({ selectMultiple: true });
	              } },
	            'MEDIA CENTER'
	          ),
	          showSchoolInfo && _react2.default.createElement(
	            _reactBootstrap.Dropdown,
	            { className: 'Header--right--create' },
	            _react2.default.createElement(
	              _reactBootstrap.Dropdown.Toggle,
	              { className: 'btn-defult expand-to-right expand-to-down' },
	              _react2.default.createElement('i', { className: 'fa icon-plus' }),
	              ' ',
	              __('New', _locale2.default)
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Dropdown.Menu,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.MenuItem,
	                {
	                  eventKey: 'create-student',
	                  onSelect: function onSelect() {
	                    if (subscription.result.saas_version === 1 || subscription.result.maximum_amount.maximum_student === null || subscription.result.existing_amount.student_amount < subscription.result.maximum_amount.maximum_student) {
	                      (0, _CreateStudent2.default)({ mode: 'create' }).then(function (res) {
	                        getSubscription(schoolId);
	                      });
	                    } else {
	                      _this2.overLimitAlert('student');
	                    }
	                  },
	                  disabled: !(0, _R.userCan)('create_student')
	                },
	                __('Students', _locale2.default)
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.MenuItem,
	                { eventKey: 'create-teacher',
	                  onSelect: function onSelect() {
	                    if (subscription.result.saas_version === 1 || subscription.result.maximum_amount.maximum_teacher === null || subscription.result.existing_amount.teacher_amount < subscription.result.maximum_amount.maximum_teacher) {
	                      (0, _CreateTeacher2.default)({ mode: 'create' }).then(function (res) {
	                        getSubscription(schoolId);
	                      });
	                    } else {
	                      _this2.overLimitAlert('teacher');
	                    }
	                  },
	                  disabled: !(0, _R.userCan)('create_teacher') },
	                __('Teachers', _locale2.default)
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.MenuItem,
	                { eventKey: 'create-class', onSelect: function onSelect() {
	                    (0, _CreateClass2.default)({ mode: 'create' });
	                  }, disabled: !(0, _R.userCan)('create_class') },
	                __('Classes', _locale2.default)
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.MenuItem,
	                { eventKey: 'create-class', onSelect: function onSelect() {
	                    (0, _CreateClassOne2.default)({ mode: 'create' });
	                  }, disabled: !(0, _R.userCan)('create_private_class') },
	                __('Private Classes', _locale2.default)
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.MenuItem,
	                { eventKey: 'create-classroom', onSelect: function onSelect() {
	                    (0, _CreateClassroom2.default)({ mode: 'create' });
	                  }, disabled: !(0, _R.userCan)('create_classroom') },
	                __('Classrooms', _locale2.default)
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.MenuItem,
	                { eventKey: 'create-announcement', onSelect: function onSelect() {
	                    _this2.createAnnouncementModal();
	                  }, disabled: !(0, _R.userCan)('create_announcement') },
	                __('Announcements', _locale2.default)
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.MenuItem,
	                { eventKey: 'create-poster', onSelect: function onSelect() {
	                    (0, _PosterType2.default)();
	                  }, disabled: !(0, _R.userCan)('create_poster') || (0, _R.isBasicUser)() },
	                __('Posters', _locale2.default)
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.MenuItem,
	                { eventKey: 'create-potentialStudent', onSelect: function onSelect() {
	                    (0, _PotentialClient2.default)();
	                  }, disabled: !(0, _R.userCan)('create_contact') || (0, _R.isBasicUser)() },
	                __('Contacts', _locale2.default)
	              )
	            )
	          ),
	          showSchoolInfo && _react2.default.createElement(
	            _R2.default,
	            { can: 'start_smart_check_in', by: 'disable', className: 'smart-check-in__R' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-default', disabled: (0, _R.isBasicUser)(), onClick: function onClick() {
	                  (0, _AttendanceScanMessage2.default)();
	                } },
	              __('Smart Check-in', _locale2.default)
	            )
	          ),
	          showUerInfo && _react2.default.createElement(
	            _reactBootstrap.Dropdown,
	            { className: 'Header--right--account' },
	            _react2.default.createElement(
	              _reactBootstrap.Dropdown.Toggle,
	              { className: 'btn-link expand-to-right expand-to-down' },
	              _react2.default.createElement('i', { className: 'fa icon-down-open' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Dropdown.Menu,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'switchLanguages' },
	                currentLocale !== 'EN' && _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn-primary', onClick: this.changeLocale('EN') },
	                  'EN'
	                ),
	                currentLocale !== 'CN' && _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn-primary', onClick: this.changeLocale('CN') },
	                  '\u4E2D\u6587'
	                )
	              ),
	              _react2.default.createElement('hr', null),
	              _react2.default.createElement(
	                _reactBootstrap.MenuItem,
	                { eventKey: 'privacy-policy', onSelect: function onSelect() {
	                    _reactRouter.browserHistory.push('/privacy-' + currentLocale.toLowerCase());
	                  } },
	                __('Privacy Policy', _locale2.default)
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.MenuItem,
	                { eventKey: 'account-settings', onSelect: function onSelect() {
	                    _reactRouter.browserHistory.replace('/account-settings');
	                  } },
	                __('Account Settings', _locale2.default)
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.MenuItem,
	                { eventKey: 'logout', onSelect: this.signOut },
	                __('Sign Out', _locale2.default)
	              )
	            )
	          )
	        )
	      ),
	      searchActive === true && _react2.default.createElement(_SearchResult2.default, { searchText: searchText })
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Header);
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "kB8h":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.getVersion = getVersion;
	function getVersion(language) {
	  var version = void 0;
	  currentVersion.map(function (ver) {
	    if (!version && ver.locale === language) {
	      version = ver;
	    }
	  });
	
	  return version;
	}
	
	var currentVersion = exports.currentVersion = [{
	  locale: 'EN',
	  version: '1.0.0',
	  date: '2018-08-20',
	  description: '',
	  updates: [{
	    title: 'Navigation Style Update',
	    description: ''
	  }, {
	    title: '',
	    description: ''
	  }]
	}, {
	  locale: 'CN',
	  version: '1.0.0',
	  date: '2018-08-20',
	  description: '',
	  updates: [{
	    title: 'Navigation Style Update',
	    description: ''
	  }, {
	    title: '',
	    description: ''
	  }]
	}];

/***/ },

/***/ "Xv7M":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _locale = __webpack_require__("cabS");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	__webpack_require__("eKxl");
	
	var _StudentResult = __webpack_require__("JWDz");
	
	var _StudentResult2 = _interopRequireDefault(_StudentResult);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <SearchResult
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is ...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Header
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @redux
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var SearchResult = function (_React$Component) {
	  _inherits(SearchResult, _React$Component);
	
	  function SearchResult(props) {
	    _classCallCheck(this, SearchResult);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onSearch = _this.onSearch.bind(_this);
	    _this.onSearching = _this.onSearching.bind(_this);
	
	    _this.state = {
	      totalSearchedNumber: 0,
	      categories: [],
	      finishedCategories: 0
	    };
	    return _this;
	  }
	
	  SearchResult.prototype.componentWillMount = function componentWillMount() {};
	
	  SearchResult.prototype.onSearch = function onSearch(err, _ref) {
	    var searchedNumber = _ref.searchedNumber;
	
	    if (err) {
	      console.error(err);
	    }
	
	    this.setState({
	      totalSearchedNumber: this.state.totalSearchedNumber + searchedNumber,
	      finishedCategories: this.state.finishedCategories + 1
	    });
	  };
	
	  SearchResult.prototype.onSearching = function onSearching(categoryName) {
	    this.setState({
	      categories: [].concat(this.state.categories, [categoryName])
	    });
	  };
	
	  SearchResult.prototype.render = function render() {
	    var searchText = this.props.searchText;
	    var _state = this.state,
	        totalSearchedNumber = _state.totalSearchedNumber,
	        _state$categories = _state.categories,
	        categories = _state$categories === undefined ? [] : _state$categories,
	        finishedCategories = _state.finishedCategories;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'SearchResult' },
	      _react2.default.createElement(
	        'div',
	        { className: 'SearchResult--content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'SearchResult--title' },
	          __('Searching for "{searchText}"', _locale2.default, { searchText: searchText }),
	          ' (',
	          totalSearchedNumber,
	          ' result(s) found) '
	        ),
	        _react2.default.createElement(_StudentResult2.default, { searchText: searchText, onSearching: this.onSearching, onSearch: this.onSearch })
	      ),
	      finishedCategories < categories.length && _react2.default.createElement(
	        'div',
	        { className: 'SearchResult--loading' },
	        _react2.default.createElement(_Loading2.default, { type: 'facebook' })
	      )
	    );
	  };
	
	  return SearchResult;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchResult);
	module.exports = exports['default'];

/***/ },

/***/ "cabS":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'SearchResult',
	  code: 'CN',
	  text: {
	    '{ticket_amount}': '{ticket_amount}人'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "eKxl":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"SearchResult":"SearchResult","SearchResult--content":"SearchResult--content","SearchResult--loading":"SearchResult--loading","SearchResult--category":"SearchResult--category","SearchResult--category--title":"SearchResult--category--title"};

/***/ },

/***/ "JWDz":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _searchStudentSummary = __webpack_require__("R3SI");
	
	var _searchStudentSummary2 = _interopRequireDefault(_searchStudentSummary);
	
	var _StudentName = __webpack_require__("hBDJ");
	
	var _StudentName2 = _interopRequireDefault(_StudentName);
	
	var _Student = __webpack_require__("PT2B");
	
	var _Student2 = _interopRequireDefault(_Student);
	
	__webpack_require__("3N7T");
	
	var _locale = __webpack_require__("jv3a");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <StudentResult 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is ...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @redux
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var StudentResult = function (_React$Component) {
	  _inherits(StudentResult, _React$Component);
	
	  function StudentResult(props) {
	    _classCallCheck(this, StudentResult);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      students: []
	    };
	    return _this;
	  }
	
	  StudentResult.prototype.componentWillMount = function componentWillMount() {
	    this.props.onSearching('student'); // you must tell the parent who you are 
	    this.searchStudent();
	  };
	
	  StudentResult.prototype.searchStudent = function searchStudent() {
	    var _this2 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    (0, _searchStudentSummary2.default)({
	      schoolId: schoolId,
	      studentState: 'all',
	      searchKeyword: this.props.searchText,
	      itemPerPage: 10,
	      pageNumber: 1
	    }).then(function (res) {
	      if (res.result === 'success') {
	        var searchedNumber = res.total_row;
	
	        _this2.setState({
	          students: res.list.map(function (student) {
	            return new _Student2.default(student);
	          }),
	          searchedNumber: searchedNumber
	        });
	
	        _this2.props.onSearch(null, {
	          searchedNumber: searchedNumber
	        });
	      }
	    }).catch(function (err) {
	      _this2.props.onSearch(err, {});
	    });
	  };
	
	  StudentResult.prototype.render = function render() {
	    var _state = this.state,
	        _state$students = _state.students,
	        students = _state$students === undefined ? [] : _state$students,
	        _state$searchedNumber = _state.searchedNumber,
	        searchedNumber = _state$searchedNumber === undefined ? 0 : _state$searchedNumber;
	
	
	    if (!searchedNumber) {
	      return _react2.default.createElement('span', null);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'SearchResult--category StudentResult' },
	      _react2.default.createElement(
	        'div',
	        { className: 'SearchResult--category--title' },
	        __('Students', _locale2.default),
	        ' (',
	        searchedNumber,
	        ')'
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'StudentResult--list' },
	        students.map(function (student, key) {
	          return _react2.default.createElement(
	            'li',
	            { key: key, className: 'SearchResult--category--item StudentResult--list--item' },
	            _react2.default.createElement(_StudentName2.default, { name: student.name, id: student.id })
	          );
	        })
	      ),
	      searchedNumber > students.length && _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'a',
	          null,
	          __('View more', _locale2.default),
	          '...'
	        )
	      )
	    );
	  };
	
	  return StudentResult;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StudentResult);
	module.exports = exports['default'];

/***/ },

/***/ "3N7T":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"StudentResult--list":"StudentResult--list","StudentResult--list--item":"StudentResult--list--item"};

/***/ },

/***/ "jv3a":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'StudentResult',
	  code: 'CN',
	  text: {
	    '{ticket_amount}': '{ticket_amount}人'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "bIlh":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'Header',
	  code: 'CN',
	  text: {
	    'Upgrade to Paid Versions': '升级付费版',
	    'Free': '免费版',
	    'Premium': '高级版',
	    'Change School': '切换学校',
	    'School Information': '学校信息',
	    'School Settings': '学校设置',
	    'Create New School': '创建新学校',
	    '$79 USD / month per school': '每学校每个月 $79 USD',
	    'New': '新增',
	    'Smart Check-in': '智能签到',
	    'Students': '学员',
	    'Teachers': '老师',
	    'Classes': '班级',
	    'Private Classes': '私课',
	    'Classrooms': '教室',
	    'Announcements': '公告',
	    'Posters': '海报',
	    'Contacts': '联系人',
	    'Privacy Policy': '隐私政策',
	    'Account Settings': '帐号设定',
	    'Sign Out': '登出',
	    "Free Trial ({daysLeft} days left)": '免费试用版还剩{daysLeft}天',
	    'Upgrade': '升级',
	    'Subscribe': '订阅升级',
	    'Need Subscription': '需要订阅'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "6eRx":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Header--left--brand":"Header--left--brand","Header--left--logoWrapper":"Header--left--logoWrapper","Header--left--schoolName":"Header--left--schoolName","Header--left--toggle":"Header--left--toggle","Header--left--version":"Header--left--version","Header--left--upgradeButton":"Header--left--upgradeButton","Header--right--account":"Header--right--account","Header":"Header","upgrade-message":"upgrade-message","close-upgrade-message":"close-upgrade-message","icon-info-circled":"icon-info-circled","Header__searchActive":"Header__searchActive","Header--left":"Header--left","caret":"caret","open":"open","Header--search":"Header--search","icon-search":"icon-search","icon-cancel":"icon-cancel","Header--right":"Header--right","Header--right--tools":"Header--right--tools","smart-check-in__R":"smart-check-in__R","Header--right--create":"Header--right--create","dropdown-toggle":"dropdown-toggle","btn":"btn","Header--right--notification":"Header--right--notification","notification-icon":"notification-icon","bell-icon-wrapper":"bell-icon-wrapper","dot":"dot","dropdown-menu":"dropdown-menu","switchLanguages":"switchLanguages"};

/***/ },

/***/ "dZ0O":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalProvider = __webpack_require__("Twi2");
	
	var _ModalProvider2 = _interopRequireDefault(_ModalProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalProvider2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "Twi2":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalBody = __webpack_require__("BJMJ");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalProvider = function (_React$Component) {
	  _inherits(ModalProvider, _React$Component);
	
	  function ModalProvider(props) {
	    _classCallCheck(this, ModalProvider);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalProvider.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(_ModalBody2.default, this.props)
	    );
	  };
	
	  return ModalProvider;
	}(_react2.default.Component);
	
	exports.default = ModalProvider;
	module.exports = exports['default'];

/***/ },

/***/ "BJMJ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("JgPM");
	
	var _ModalContent = __webpack_require__("Xf7u");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _locale = __webpack_require__("PEYl");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _ducks = __webpack_require__("yDaX");
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _registerTeacher = __webpack_require__("wLQu");
	
	var _registerTeacher2 = _interopRequireDefault(_registerTeacher);
	
	var _updateTeacher = __webpack_require__("6VVj");
	
	var _updateTeacher2 = _interopRequireDefault(_updateTeacher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchTeacher: function fetchTeacher(schoolId, state) {
	      return dispatch((0, _ducks.fetchTeacher)(schoolId, state));
	    }
	  };
	};
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      disabledBtn: false
	    };
	    return _this;
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel,
	        mode = _props.mode;
	
	
	    var schoolId = localStorage.getItem('schoolId');
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'create-teacher-modal',
	        isShowingModal: show,
	
	        onCloseModalClick: dismiss,
	        fixedWidth: 600,
	        overlayColor: '#000',
	
	        hasHeader: true,
	        headerTitle: this.props.mode == 'create' ? __('Create Teacher', _locale2.default) : __('Edit Teacher', _locale2.default),
	        headerType: 'bold',
	        footerType: 'grey',
	        hasFooter: true,
	        footerButtons: [{
	          title: __('Complete', 'appwrapper'),
	          className: 'btn btn-primary pull-right',
	          onClick: function onClick() {
	            var validateResult = _this2.validate();
	            if (!validateResult.ok) {
	              return;
	            }
	            _this2.setState({ disabledBtn: true });
	
	            if (typeof _this2.formData === 'undefined') {
	              return _this2.props.dismiss();
	            }
	
	            if (_this2.formData.profile_photo && _this2.formData.profile_photo.file) {
	              _this2.formData.photo = _this2.formData.profile_photo.file;
	              delete _this2.formData.profile_photo;
	            }
	
	            if (mode == 'create') {
	              _this2.formData.tPhone = _this2.formData.phoneParsed.country_code.toString() + _this2.formData.phoneParsed.national_number.toString();
	              if (_this2.formData.tPhone.length < 2) {
	                delete _this2.formData.tPhone;
	              }
	              delete _this2.formData.phoneParsed;
	
	              (0, _registerTeacher2.default)(schoolId, _this2.formData).then(function (res) {
	                if (res.id) {
	                  _this2.props.fetchTeacher({ schoolId: schoolId, amount_per_page: 25, current_page_number: 1 }, 'current');
	                  _this2.props.proceed();
	                } else if (res.result == 'failure' && res.reason == 'another teacher with the same phone number exists.') {
	                  _alert.alert.warning(__('Phone number already existed', _locale2.default));
	                  _this2.setState({ disabledBtn: false });
	                } else if (res.result == 'failure' && res.reason == 'teacher with the same phone has been archived') {
	                  _alert.alert.warning(__('Phone number already existed in Archived Teacher', _locale2.default));
	                  _this2.setState({ disabledBtn: false });
	                }
	              });
	            } else if (mode == 'update') {
	              if (_this2.formData.phoneParsed.national_number !== '') {
	                _this2.formData.stPhone = _this2.formData.phoneParsed.country_code.toString() + _this2.formData.phoneParsed.national_number.toString();
	              } else {
	                _this2.formData.stPhone = '';
	              }
	              if (_this2.formData) {
	                var _formData = _this2.formData,
	                    id = _formData.id,
	                    tName = _formData.tName,
	                    tGender = _formData.tGender,
	                    tEmail = _formData.tEmail,
	                    photo = _formData.photo,
	                    stPhone = _formData.stPhone;
	
	                var newFormData = { stName: tName, stGender: tGender, stEmail: tEmail, photo: photo, stPhone: stPhone };
	                (0, _updateTeacher2.default)(_this2.props.teacherId, newFormData).then(function (res) {
	                  if (res.id) {
	                    _this2.props.fetchTeacher({ schoolId: schoolId, amount_per_page: 25, current_page_number: 1 }, 'current');
	                    _this2.props.proceed();
	                  } else if (res.result == 'failure' && res.reason == 'another teacher with the same phone number exists.') {
	                    _alert.alert.warning(__('Phone number already existed', _locale2.default));
	                    _this2.setState({ disabledBtn: false });
	                  } else if (res.result == 'failure' && res.reason == 'teacher with the same phone has been archived') {
	                    _alert.alert.warning(__('Phone number already existed in Archived Teacher', _locale2.default));
	                    _this2.setState({ disabledBtn: false });
	                  }
	                });
	              } else {
	                _this2.props.proceed();
	              }
	            }
	          },
	          isDisabled: function isDisabled() {
	            return _this2.state.disabledBtn;
	          }
	        }]
	      },
	      _react2.default.createElement(_ModalContent2.default, _extends({}, this.props, {
	        onFormChange: function onFormChange(stateFromModalContent) {
	          _this2.formData = stateFromModalContent;
	        },
	        getValidationRef: function getValidationRef(fn) {
	          _this2.validate = fn;
	        }
	      }))
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactConfirm.confirmable)(ModalBody));
	module.exports = exports['default'];

/***/ },

/***/ "JgPM":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "Xf7u":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("PEYl");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _isEmpty = __webpack_require__("lHK6");
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var DEFAULT_REGION_CODE = 'ca';
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    var phoneParsed = void 0;
	    if (props.mode === 'create') {
	      phoneParsed = { country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE };
	    } else if (props.mode === 'update') {
	      phoneParsed = (0, _isEmpty2.default)(props.data.stPhone_parsed) ? { country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE } : props.data.stPhone_parsed;
	    }
	
	    _this.state = {
	      formData: props.data ? _extends({}, props.data, { phoneParsed: phoneParsed }) : { phoneParsed: { country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE } }
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  ModalContent.prototype.onChange = function onChange(formData) {
	    var _this2 = this;
	
	    this.setState({
	      formData: _extends({}, this.state.formData, formData)
	    }, function () {
	      _this2.props.onFormChange(formData);
	    });
	  };
	
	  ModalContent.prototype.render = function render() {
	    var formData = this.state.formData;
	
	    var schema = [{
	      name: 'tName',
	      label: __('Teacher Name', _locale2.default),
	      type: 'text',
	      required: true
	    }, {
	      name: 'tGender',
	      label: __('Gender', _locale2.default),
	      type: 'gender',
	      required: true
	    }, {
	      name: 'tEmail',
	      label: __('Email', _locale2.default),
	      type: 'text',
	      required: false
	    }, {
	      name: 'profile_photo',
	      label: __('Teacher Photo', _locale2.default),
	      type: 'imageUploader',
	      options: {
	        aspectRatioHeight: 1,
	        aspectRatioWidth: 1
	      }
	    }, {
	      name: 'phoneParsed',
	      label: __('Phone Number', _locale2.default),
	      type: 'phone',
	      required: false,
	      tip: __("Enter a phone number to invite the teacher to download the ClassTopBase mobile App. The teacher could then change the attendance, as well as sending and receiving announcements and schedules. You could change teacher's permissions inside the permissions settings", _locale2.default)
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'create-teacher-modal-content' },
	      _react2.default.createElement(_Form2.default, {
	        onChange: this.onChange,
	        schema: schema,
	        formData: formData,
	        formStyle: 'outline',
	        getValidationRef: this.props.getValidationRef
	      })
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "PEYl":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'CreateTeacherModal',
	  code: 'CN',
	  text: {
	    'Create Teacher': '新增老师',
	    'Edit Teacher': '编辑老师',
	    'Teacher Name': '老师姓名',
	    'Gender': '性别',
	    'Email': '邮件地址',
	    'Phone Number': '手机号',
	    "Enter a phone number to invite the teacher to download the ClassTopBase mobile App. The teacher could then change the attendance, as well as sending and receiving announcements and schedules. You could change teacher's permissions inside the permissions settings": '填写手机号可以邀请老师下载手机端APP, 老师可以用APP给自己和学生签到, 接收通知和课表, 您可以在权限设置里安排老师的权限',
	    'Phone number already existed': '此手机号已存在',
	    'Phone number already existed in Archived Teacher': '添加的老师已经在历史老师里面，如有需要请恢复',
	    'Teacher Photo': '老师头像'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "wLQu":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = registerTeacher;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GENDER = ['male', 'female', 'other', 'n/a'];
	var INVITE = ['not_invite', 'invite'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  tName: _joiBrowser2.default.string().required(),
	  tPhone: _joiBrowser2.default.string().allow(''),
	  tGender: _joiBrowser2.default.string().valid(GENDER).required(),
	  tEmail: _joiBrowser2.default.string().allow(''),
	  invite_or_not: _joiBrowser2.default.string().allow(''),
	  photo: _joiBrowser2.default.object()
	});
	
	function registerTeacher(schoolId, teacherInfo) {
	
	  if (!schoolId) {
	    throw 'Missing school ID';
	  }
	
	  var validateResult = _joiBrowser2.default.validate(teacherInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	  var toServer = _extends({}, teacherInfo, {
	    tGender: GENDER.indexOf(teacherInfo.tGender)
	  });
	
	  if (toServer.photo) {
	    return updateWithUpload(schoolId, toServer);
	  } else {
	    return update(schoolId, toServer);
	  }
	}
	
	function updateWithUpload(schoolId, toServer) {
	  var API_URL = void 0;
	  if (false) {
	    API_URL = 'https://saas.classtop.com:3001/sapi';
	  } else {
	    API_URL = 'https://school.classtop.com:3001/sapi';
	  }
	
	  return new Promise(function (resolve, reject) {
	    var data = new FormData();
	
	    _.each(toServer, function (value, name) {
	      if (name === 'photo') {
	        data.append('photo', toServer.photo, 'photo');
	      } else if (typeof value !== 'undefined') {
	        data.append(name, value);
	      }
	    });
	
	    _axios2.default.post(API_URL + '/rgst_tch/' + schoolId + '/', data, {
	      headers: {
	        'Authorization': 'JWT ' + localStorage.getItem('token'),
	        'Content-Type': 'multipart/form-data'
	      }
	    }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	      console.error(err);
	    });
	  });
	}
	
	function update(schoolId, toServer) {
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/rgst_tch/' + schoolId + '/',
	      'method': 'POST',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "6VVj":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = updateTeacher;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GENDER = ['male', 'female', 'other', 'n/a'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  stName: _joiBrowser2.default.string(),
	  stPhone: _joiBrowser2.default.string().allow(''),
	  stGender: _joiBrowser2.default.any().allow(''),
	  stEmail: _joiBrowser2.default.string().allow(''),
	  archived: _joiBrowser2.default.boolean().allow(''),
	  stState: _joiBrowser2.default.number().integer().allow(''),
	  photo: _joiBrowser2.default.object()
	});
	
	function updateTeacher(teacherId, teacherInfo) {
	
	  if (!teacherId) {
	    throw 'Missing teacher ID';
	  }
	
	  var validateResult = _joiBrowser2.default.validate(teacherInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, teacherInfo);
	
	  if (typeof teacherInfo.stGender != 'undefined') {
	    toServer.stGender = typeof teacherInfo.stGender === 'string' ? GENDER.indexOf(teacherInfo.stGender) : teacherInfo.stGender;
	  }
	
	  if (toServer.photo) {
	    return updateWithUpload(teacherId, toServer);
	  } else {
	    return update(teacherId, toServer);
	  }
	
	  function updateWithUpload(teacherId, toServer) {
	    var API_URL = void 0;
	    if (false) {
	      API_URL = 'https://saas.classtop.com:3001/sapi';
	    } else {
	      API_URL = 'https://school.classtop.com:3001/sapi';
	    }
	
	    return new Promise(function (resolve, reject) {
	      var data = new FormData();
	
	      _.each(toServer, function (value, name) {
	        if (name === 'photo') {
	          data.append('photo', toServer.photo, 'photo');
	        } else if (typeof value !== 'undefined') {
	          data.append(name, value);
	        }
	      });
	
	      _axios2.default.put(API_URL + '/u_tch/' + teacherId + '/', data, {
	        headers: {
	          'Authorization': 'JWT ' + localStorage.getItem('token'),
	          'Content-Type': 'multipart/form-data'
	        }
	      }).then(function (res) {
	        resolve(res.data);
	      }).catch(function (err) {
	        reject(err);
	        console.error(err);
	      });
	    });
	  }
	  function update(teacherId, toServer) {
	
	    return new Promise(function (resolve, reject) {
	      _axios2.default.put(_config.APIAddress, { 'uri': '/u_tch/' + teacherId + '/',
	        'method': 'PUT',
	        'data': JSON.stringify(toServer),
	        'token': localStorage.getItem('token') }).then(function (res) {
	        resolve(res.data);
	      }).catch(function (err) {
	        reject(err);
	      });
	    });
	  }
	}

/***/ },

/***/ "q1HF":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalProvider = __webpack_require__("AMXM");
	
	var _ModalProvider2 = _interopRequireDefault(_ModalProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalProvider2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "AMXM":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalBody = __webpack_require__("lKQQ");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalProvider = function (_React$Component) {
	  _inherits(ModalProvider, _React$Component);
	
	  function ModalProvider(props) {
	    _classCallCheck(this, ModalProvider);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalProvider.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(_ModalBody2.default, this.props)
	    );
	  };
	
	  return ModalProvider;
	}(_react2.default.Component);
	
	exports.default = ModalProvider;
	module.exports = exports['default'];

/***/ },

/***/ "lKQQ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("Gc6k");
	
	var _ModalContent = __webpack_require__("s1xD");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _locale = __webpack_require__("ChZW");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _addClassroom = __webpack_require__("u0HH");
	
	var _addClassroom2 = _interopRequireDefault(_addClassroom);
	
	var _editClassroom = __webpack_require__("gPCp");
	
	var _editClassroom2 = _interopRequireDefault(_editClassroom);
	
	var _ducks = __webpack_require__("I0d0");
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchClassroom: function fetchClassroom(schoolId) {
	      return dispatch((0, _ducks.fetchClassroom)(schoolId));
	    }
	  };
	};
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      disabledBtn: false
	    };
	    return _this;
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel,
	        mode = _props.mode;
	
	
	    var language = localStorage.getItem('language');
	    var schoolId = localStorage.getItem('schoolId');
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'create-classroom-modal',
	        isShowingModal: show,
	
	        onCloseModalClick: dismiss,
	        fixedWidth: 600,
	        overlayColor: '#000',
	
	        hasHeader: true,
	        headerTitle: this.props.mode == 'create' ? __('Create Classroom', _locale2.default) : __('Edit Classroom', _locale2.default),
	        headerType: 'bold',
	        footerType: 'grey',
	        hasFooter: true,
	        footerButtons: [{
	          title: __('Complete', 'appwrapper'),
	          className: 'btn btn-primary pull-right',
	          onClick: function onClick() {
	            _this2.setState({ disabledBtn: true });
	
	            var validateResult = _this2.validate();
	
	            if (!validateResult.ok) {
	              _this2.setState({ disabledBtn: false });
	              return;
	            }
	
	            if (mode == 'create') {
	              (0, _addClassroom2.default)(schoolId, _this2.formData).then(function (res) {
	                _this2.props.fetchClassroom({ schoolId: schoolId, amount_per_page: 25, current_page_number: 1 });
	                _this2.props.proceed();
	              });
	            } else if (mode == 'update') {
	              if (_this2.formData) {
	                var newFormData = { alias_name: _this2.formData.name };
	                (0, _editClassroom2.default)(_this2.props.data.school_classroom_id, newFormData).then(function (res) {
	                  _this2.props.fetchClassroom({ schoolId: schoolId, amount_per_page: 25, current_page_number: 1 });
	                  _this2.props.proceed();
	                });
	              } else {
	                _this2.props.dismiss();
	              }
	            }
	          },
	          isDisabled: function isDisabled() {
	            return _this2.state.disabledBtn;
	          }
	        }]
	      },
	      _react2.default.createElement(_ModalContent2.default, _extends({}, this.props, {
	        onFormChange: function onFormChange(stateFromModalContent) {
	          _this2.formData = stateFromModalContent;
	        },
	        getValidationRef: function getValidationRef(fn) {
	          _this2.validate = fn;
	        }
	      }))
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactConfirm.confirmable)(ModalBody));
	module.exports = exports['default'];

/***/ },

/***/ "Gc6k":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "s1xD":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("ChZW");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      formData: props.data ? { name: props.data.name } : {}
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  ModalContent.prototype.onChange = function onChange(formData) {
	    var _this2 = this;
	
	    this.setState({
	      formData: _extends({}, this.state.formDate, {
	        name: formData.name
	      })
	    }, function () {
	      _this2.props.onFormChange(formData);
	    });
	  };
	
	  ModalContent.prototype.render = function render() {
	    var formData = this.state.formData;
	
	    var schema = [{
	      name: 'name',
	      label: __('Class Name', _locale2.default),
	      type: 'text',
	      required: true
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'create-classroom-modal-content' },
	      _react2.default.createElement(_Form2.default, {
	        onChange: this.onChange,
	        schema: schema,
	        formData: formData,
	        formStyle: 'outline',
	        getValidationRef: this.props.getValidationRef
	      })
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "ChZW":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'CreateClassroom',
	  code: 'CN',
	  text: {
	    'Create Classroom': '新增教室',
	    'Edit Classroom': '编辑教室',
	    'Class Name': '教室名称'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "u0HH":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = addClassroom;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  country: _joiBrowser2.default.string().allow(''),
	  province: _joiBrowser2.default.string().allow(''),
	  city: _joiBrowser2.default.string().allow(''),
	  street: _joiBrowser2.default.string().allow(''),
	  suit_number: _joiBrowser2.default.string().allow(''),
	  post_code: _joiBrowser2.default.string().allow(''),
	  name: _joiBrowser2.default.string().allow(''),
	  description: _joiBrowser2.default.string().allow(''),
	  area_in_square_foot: _joiBrowser2.default.string().allow(''),
	  seating_capacity: _joiBrowser2.default.string().allow(''),
	  status: _joiBrowser2.default.string().allow(''), // 0：停用，1：自用，2：出租；3：自用+出租混合（当设为2或3时，才需要填单价个价格单位）
	  price_per_unit: _joiBrowser2.default.string().allow(''),
	  currency_unit: _joiBrowser2.default.string().allow(''), // 0:CAD, 1:USD, 2:RMB
	  price_unit: _joiBrowser2.default.string().allow('') // 0:按小时计价，1：按次计价，2：按天计价
	});
	
	function addClassroom(schoolId, classroomInfo) {
	
	  if (!schoolId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school ID')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(classroomInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/classroom_list/" + schoolId + "/",
	      'data': JSON.stringify(classroomInfo),
	      'method': 'POST',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "gPCp":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = editClassroom;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  "alias_name": _joiBrowser2.default.string().required(),
	  "description_alias": _joiBrowser2.default.string().allow(''),
	  "status": _joiBrowser2.default.string().allow(''), // 0：停用；1：启用,
	  "school": _joiBrowser2.default.string().allow(''),
	  "space": _joiBrowser2.default.string().allow('')
	});
	
	function editClassroom(classroomId, classroomInfo) {
	
	  if (!classroomId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing classroom Id')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(classroomInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/classroom_detail/" + classroomId + "/",
	      'method': 'PUT',
	      'data': JSON.stringify(classroomInfo),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "j/11":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("glHc");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalProvider = __webpack_require__("CWxl");
	
	var _ModalProvider2 = _interopRequireDefault(_ModalProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalProvider2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "glHc":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("kKt6");
	
	var _ModalContent = __webpack_require__("9aQb");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _locale = __webpack_require__("y3ce");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _addAnnouncement2 = __webpack_require__("/Cga");
	
	var _updateAnnouncement2 = __webpack_require__("eVF0");
	
	var _getAnnouncementList = __webpack_require__("sYDS");
	
	var _setCurrentTabState2 = __webpack_require__("d4iu");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentTabState: state.announcementList.currentTabState
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    addAnnouncement: function addAnnouncement(schoolId, announcementInfo, cb) {
	      return dispatch((0, _addAnnouncement2.addAnnouncement)(schoolId, announcementInfo, cb));
	    },
	    updateAnnouncement: function updateAnnouncement(announcementId, announcementInfo, currentTabState, callback) {
	      return dispatch((0, _updateAnnouncement2.updateAnnouncement)(announcementId, announcementInfo, currentTabState, callback));
	    },
	    fetchAnnouncementList: function fetchAnnouncementList(announcementInfo, currentTabState) {
	      return dispatch((0, _getAnnouncementList.fetchAnnouncementList)(announcementInfo, currentTabState));
	    },
	    setCurrentTabState: function setCurrentTabState(currentTabState) {
	      return dispatch((0, _setCurrentTabState2.setCurrentTabState)(currentTabState));
	    }
	  };
	};
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      disabledBtn: false
	    };
	    return _this;
	  }
	
	  ModalBody.prototype.onSubmit = function onSubmit(data, state) {
	    var _this2 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _props = this.props,
	        dismiss = _props.dismiss,
	        dispatch = _props.dispatch,
	        currentTabState = _props.currentTabState,
	        setCurrentTabState = _props.setCurrentTabState;
	
	    if (!this.formData) {
	      this.setState({ disabledBtn: false });
	      return _alert.alert.warning(__('All Fields with * Must Be Filled', _locale2.default));
	    }
	
	    var _formData = this.formData,
	        title = _formData.title,
	        content = _formData.content,
	        class_id_list = _formData.class_id_list;
	
	
	    if (!title || !content || class_id_list.length <= 0) {
	      this.setState({ disabledBtn: false });
	      return _alert.alert.warning(__('All Fields with * Must Be Filled', _locale2.default));
	    }
	
	    if (data) {
	      var newData = _extends({}, this.formData, { send_to: 'all', state: state });
	      if (newData.class_id_list[0].value == 0) {
	        newData = _extends({}, newData, { class_id_list: 'all' });
	      }
	
	      this.props.updateAnnouncement(data.id, newData, currentTabState, function () {
	        var tabIndex = void 0;
	        if (currentTabState.tabName === 'published') {
	          tabIndex = 1;
	        } else if (currentTabState.tabName === 'draft') {
	          tabIndex = 2;
	        } else {
	          tabIndex = 0;
	        }
	        setCurrentTabState({ tabName: currentTabState.tabName, tabIndex: tabIndex });
	        _this2.props.proceed();
	      });
	    } else {
	      var _newData = _extends({}, this.formData, { send_to: 'all', state: state });
	      if (_newData.class_id_list[0] == 0) {
	        _newData = _extends({}, _newData, { class_id_list: 'all' });
	      }
	      this.props.addAnnouncement(schoolId, _newData, function () {
	        var tabIndex = void 0;
	        if (state === 'published') {
	          if (currentTabState.tabName === 'published' || currentTabState.tabName === 'draft') {
	            tabIndex = 1;
	            _this2.props.fetchAnnouncementList({ schoolId: Number(schoolId), param: 'all', amount_per_page: 12, page_number: 1, state: 'published' });
	          } else {
	            tabIndex = 0;
	            _this2.props.fetchAnnouncementList({ schoolId: Number(schoolId), param: 'all', amount_per_page: 12, page_number: 1 });
	          }
	        } else {
	          if (currentTabState.tabName === 'published' || currentTabState.tabName === 'draft') {
	            tabIndex = 2;
	            _this2.props.fetchAnnouncementList({ schoolId: Number(schoolId), param: 'all', amount_per_page: 12, page_number: 1, state: 'draft' });
	          } else {
	            tabIndex = 0;
	            _this2.props.fetchAnnouncementList({ schoolId: Number(schoolId), param: 'all', amount_per_page: 12, page_number: 1 });
	          }
	        }
	        setCurrentTabState({ tabName: currentTabState.tabName, tabIndex: tabIndex });
	        _this2.props.proceed();
	      });
	    }
	  };
	
	  ModalBody.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props2 = this.props,
	        show = _props2.show,
	        proceed = _props2.proceed,
	        dismiss = _props2.dismiss,
	        cancel = _props2.cancel,
	        data = _props2.data,
	        allowEdit = _props2.allowEdit,
	        selectedIndex = _props2.selectedIndex;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'announcement-modal',
	        hasHeader: true,
	        hasFooter: allowEdit,
	
	        headerTitle: __("Announcement Content", _locale2.default),
	        headerIcon: 'fa icon-megaphone',
	
	        fixedWidth: 550,
	        contentHeight: 450,
	        onCloseModalClick: dismiss,
	
	        footerType: 'grey',
	        isShowingModal: show,
	        footerButtons: allowEdit && [{
	          title: __('Publish', _locale2.default),
	          className: 'btn btn-primary pull-right',
	          onClick: function onClick() {
	            _this3.setState({ disabledBtn: true });
	            var state = 'published';
	            _this3.onSubmit(data, state);
	          }
	        }, {
	          title: __('Save', _locale2.default),
	          className: 'btn btn-default pull-right',
	          onClick: function onClick() {
	            _this3.setState({ disabledBtn: true });
	            var state = 'draft';
	            _this3.onSubmit(data, state);
	          },
	          isDisabled: function isDisabled() {
	            return _this3.state.disabledBtn;
	          }
	        }] },
	      _react2.default.createElement(_ModalContent2.default, _extends({}, this.props, {
	        onFormChange: function onFormChange(stateFromModalContent) {
	          _this3.formData = stateFromModalContent;
	        } }))
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactConfirm.confirmable)(ModalBody));
	module.exports = exports['default'];

/***/ },

/***/ "kKt6":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"announcement-modal-content":"announcement-modal-content","title-label":"title-label","for-label":"for-label","contents-label":"contents-label","row":"row","announcement-editor":"announcement-editor","quill":"quill","ql-container":"ql-container","content-section":"content-section","targetClass":"targetClass"};

/***/ },

/***/ "9aQb":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MIN_INTERVAL_FOR_LEGIT_INPUT = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _alert = __webpack_require__("BGi1");
	
	var _locale = __webpack_require__("y3ce");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _DropdownSelect = __webpack_require__("y7rH");
	
	var _DropdownSelect2 = _interopRequireDefault(_DropdownSelect);
	
	var _ReactSelect = __webpack_require__("Z40E");
	
	var _ReactSelect2 = _interopRequireDefault(_ReactSelect);
	
	var _getClassBy = __webpack_require__("OC/R");
	
	var _getClassBy2 = _interopRequireDefault(_getClassBy);
	
	var _reactQuill = __webpack_require__("TWqO");
	
	var _reactQuill2 = _interopRequireDefault(_reactQuill);
	
	__webpack_require__("kKt6");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// import Editor from 'vendor/react-medium-editor';
	
	
	var MIN_INTERVAL_FOR_LEGIT_INPUT = exports.MIN_INTERVAL_FOR_LEGIT_INPUT = 200;
	
	var ModalContent = function (_Component) {
	  _inherits(ModalContent, _Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      dropdownOption: [],
	      accouncementInfo: {
	        title: '',
	        content: '',
	        class_id_list: []
	      }
	    };
	    return _this;
	  }
	
	  ModalContent.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _props = this.props,
	        data = _props.data,
	        class_id_list = _props.class_id_list,
	        onFormChange = _props.onFormChange;
	
	    var arr = [];
	    (0, _getClassBy2.default)({ schoolId: schoolId, type: 'all', state: 'current', detail: 0 }).then(function (res) {
	      if (res.classCount > 0) {
	        arr.push({ label: __('All', _locale2.default), value: 0 });
	        res.classList.map(function (cls) {
	          arr.push({ label: cls.className, value: cls.classID });
	        });
	        _this2.setState({ dropdownOption: arr });
	      }
	    });
	
	    if (data) {
	      this.setState({
	        accouncementInfo: _extends({}, this.state.accouncementInfo, {
	          title: data.title,
	          content: data.content,
	          class_id_list: class_id_list == 'all' ? [{ label: __('All', _locale2.default), value: 0 }] : class_id_list
	        })
	      }, function () {
	        onFormChange(_this2.state.accouncementInfo);
	      });
	    }
	  };
	
	  ModalContent.prototype.renderTargetClass = function renderTargetClass() {
	    if (this.props.class_id_list !== 'all' && this.props.data.send_to.length > 0) {
	      var classList = this.props.data.send_to.map(function (cls) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'targetClass' },
	          cls.class_name
	        );
	      });
	      return classList;
	    }
	    return _react2.default.createElement(
	      'span',
	      { className: 'targetClass' },
	      __('All', _locale2.default)
	    );
	  };
	
	  ModalContent.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props2 = this.props,
	        onFormChange = _props2.onFormChange,
	        allowEdit = _props2.allowEdit,
	        data = _props2.data;
	    var _state = this.state,
	        dropdownOption = _state.dropdownOption,
	        accouncementInfo = _state.accouncementInfo;
	    var title = accouncementInfo.title,
	        content = accouncementInfo.content,
	        class_id_list = accouncementInfo.class_id_list;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'announcement-modal-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container-fluid' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-3' },
	            _react2.default.createElement(
	              'span',
	              { className: 'title-label' },
	              __('Title', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'c-red' },
	              '*'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-9' },
	            _react2.default.createElement('input', {
	              disabled: !allowEdit,
	              className: 'form-control title',
	              placeholder: __('Please enter announcement title', _locale2.default),
	              value: title,
	              onChange: function onChange(e) {
	                _this3.setState({
	                  accouncementInfo: _extends({}, _this3.state.accouncementInfo, {
	                    title: e.target.value
	                  })
	                }, function () {
	                  onFormChange(_this3.state.accouncementInfo);
	                });
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-3' },
	            _react2.default.createElement(
	              'span',
	              { className: 'for-label' },
	              __('For', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'c-red' },
	              '*'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-9 ' },
	            allowEdit && _react2.default.createElement(_ReactSelect2.default, {
	              value: class_id_list,
	              noCaret: false,
	              options: dropdownOption,
	              onChange: function onChange(id) {
	                if (id.length >= 2 && id[0] == 0) {
	                  id.shift();
	                } else if (id.length >= 1 && id[0] != 0 && id.includes(0)) {
	                  for (var i = 0; i <= id.length; i++) {
	                    id.shift();
	                  }
	                }
	
	                _this3.setState({
	                  accouncementInfo: _extends({}, _this3.state.accouncementInfo, {
	                    class_id_list: id
	                  })
	                }, function () {
	                  onFormChange(_this3.state.accouncementInfo);
	                });
	              },
	              multi: true,
	              placeholder: __('Please select announcement target', _locale2.default)
	            }),
	            !allowEdit && _react2.default.createElement(
	              'div',
	              { className: 'content-section' },
	              this.renderTargetClass()
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-3' },
	            _react2.default.createElement(
	              'span',
	              { className: 'contents-label' },
	              __('Content', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'c-red' },
	              '*'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-9' },
	            !allowEdit && _react2.default.createElement('div', { className: 'content-section', dangerouslySetInnerHTML: { __html: content } }),
	            allowEdit && _react2.default.createElement(_reactQuill2.default, {
	              value: content || '',
	              onChange: function onChange(value) {
	                _this3.setState({
	                  accouncementInfo: _extends({}, _this3.state.accouncementInfo, {
	                    content: value
	                  })
	                }, function () {
	                  onFormChange(_this3.state.accouncementInfo);
	                });
	              }
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return ModalContent;
	}(_react.Component);
	
	exports.default = ModalContent;

/***/ },

/***/ "y3ce":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'AnnouncementModal',
	  code: 'CN',
	  text: {
	    'Announcement Content': '公告内容',
	    'For': '公告对象',
	    'Title': '公告标题',
	    'All': '全体师生',
	    'Please select announcement target': '请选择公告对象',
	    'Please enter announcement title': '请输入公告标题',
	    'Please enter announcement content': '请输入公告内容',
	    'Content': '公告内容',
	    'Publish': '发布',
	    'Save': '保存为草稿',
	    'All Fields with * Must Be Filled': '带*号的字段必须填写',
	    '': ''
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "CWxl":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalBody = __webpack_require__("glHc");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalProvider = function (_React$Component) {
	  _inherits(ModalProvider, _React$Component);
	
	  function ModalProvider(props) {
	    _classCallCheck(this, ModalProvider);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalProvider.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        otherProps = _objectWithoutProperties(_props, ['children']);
	
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(_ModalBody2.default, this.props)
	    );
	  };
	
	  return ModalProvider;
	}(_react2.default.Component);
	
	exports.default = ModalProvider;
	module.exports = exports['default'];

/***/ },

/***/ "qmPG":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("6psT");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "6psT":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("kOwV");
	
	var _ModalContent = __webpack_require__("YKcE");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'poster-type-modal',
	        hasHeader: true,
	        headerTitle: __("Select Poster Type", "poster"),
	        headerIcon: 'fa icon-picture',
	        fixedWidth: 800,
	        contentHeight: 380,
	        onCloseModalClick: dismiss,
	
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, this.props)
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "kOwV":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"poster-type-content":"poster-type-content","type-container":"type-container","type-container-disable":"type-container-disable","type-title":"type-title","type-description":"type-description","type-btn":"type-btn","disabled":"disabled"};

/***/ },

/***/ "YKcE":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	__webpack_require__("kOwV");
	
	var _createPoster = __webpack_require__("NYMm");
	
	var _createPoster2 = _interopRequireDefault(_createPoster);
	
	var _createContent = __webpack_require__("SquY");
	
	var _createContent2 = _interopRequireDefault(_createContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent() {
	    _classCallCheck(this, ModalContent);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalContent.prototype.onCreatePoster = function onCreatePoster(data) {
	    var schoolId = localStorage.getItem('schoolId');
	    var dismiss = this.props.dismiss;
	
	
	    var emptyPoster = {
	      template: '',
	      poster_type: '',
	      title: '',
	      state: '',
	      show_spots_left: '',
	      show_page_view: ''
	    };
	
	    var newPoster = _extends({}, emptyPoster, {
	      poster_type: data
	    });
	
	    (0, _createPoster2.default)(schoolId, newPoster).then(function (res) {
	      if (res.result == 'success') {
	        var poster_id = res.poster_id;
	
	        //
	        // The first element by default is a text
	        //
	
	        var firstContent = {
	          index: 1,
	          content_type: 'text',
	          text: ''
	        };
	        (0, _createContent2.default)(poster_id, firstContent).then(function (res) {
	          _reactRouter.browserHistory.push({ pathname: '/edit-poster/' + poster_id });
	          dismiss();
	        });
	      }
	    }).catch(function (err) {});
	  };
	
	  ModalContent.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'poster-type-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-5 type-container text-center enabled', onClick: function onClick() {
	              _this2.onCreatePoster('basic');
	            } },
	          _react2.default.createElement(
	            'h2',
	            { className: 'type-title' },
	            __('Basic Poster', 'poster')
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'type-description' },
	            __('Create a poster that contains only texts and pictures', 'poster')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-5 type-container text-center', onClick: function onClick() {
	              _this2.onCreatePoster('registration');
	            } },
	          _react2.default.createElement(
	            'h2',
	            { className: 'type-title' },
	            __('Enrollment Registration', 'poster')
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'type-description' },
	            __('Create a poster that allows users to register for classes or events', 'poster')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-5 type-container-disable text-center disabled' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'type-title' },
	            __('Event Registration', 'poster')
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'type-description' },
	            __('Create a poster that allows users to register tickets', 'poster')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-5 type-container-disable text-center disabled' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'type-title' },
	            __('Survey', 'poster')
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'type-description' },
	            __('Create a poster that contains a survey or questionnaire', 'poster')
	          )
	        )
	      )
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "NYMm":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = exports.SHOW_PAGE_VIEW = exports.SHOW_SPOTS_LEFT = exports.STATE = exports.POSTER_TYPE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createPoster;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var POSTER_TYPE = exports.POSTER_TYPE = ["registration", "ticket", 'survey', 'basic', 'web_page', 'web_article'];
	var STATE = exports.STATE = ["draft", "published", "closed"];
	var SHOW_SPOTS_LEFT = exports.SHOW_SPOTS_LEFT = ['no', 'yes'];
	var SHOW_PAGE_VIEW = exports.SHOW_PAGE_VIEW = ['no', 'yes'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  template: _joiBrowser2.default.number().integer().allow(''),
	  poster_type: _joiBrowser2.default.string().valid(POSTER_TYPE).allow(''),
	  title: _joiBrowser2.default.string().allow(''),
	  state: _joiBrowser2.default.string().valid(STATE).allow(''),
	  show_spots_left: _joiBrowser2.default.string().valid(SHOW_SPOTS_LEFT).allow(''),
	  show_page_view: _joiBrowser2.default.string().valid(SHOW_PAGE_VIEW).allow(''),
	  page_setting: _joiBrowser2.default.object().allow('').allow(null),
	  theme_setting: _joiBrowser2.default.object().allow('').allow(null)
	});
	
	function createPoster(schoolId, posterInfo) {
	
	  if (!schoolId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school ID')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(posterInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, posterInfo, {
	    poster_type: posterInfo.poster_type ? POSTER_TYPE.indexOf(posterInfo.poster_type) : 0,
	    state: posterInfo.state ? STATE.indexOf(posterInfo.state) : 0,
	    show_spots_left: posterInfo.show_spots_left ? SHOW_SPOTS_LEFT.indexOf(posterInfo.show_spots_left) : 1,
	    show_page_view: posterInfo.show_page_view ? SHOW_PAGE_VIEW.indexOf(posterInfo.show_page_view) : 1
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/create_poster/" + schoolId + "/",
	      'method': 'POST',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "r8r1":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalProvider = __webpack_require__("XoCf");
	
	var _ModalProvider2 = _interopRequireDefault(_ModalProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalProvider2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "XoCf":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalBody = __webpack_require__("Snuh");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalProvider = function (_React$Component) {
	  _inherits(ModalProvider, _React$Component);
	
	  function ModalProvider(props) {
	    _classCallCheck(this, ModalProvider);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalProvider.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        otherProps = _objectWithoutProperties(_props, ['children']);
	
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(_ModalBody2.default, this.props)
	    );
	  };
	
	  return ModalProvider;
	}(_react2.default.Component);
	
	exports.default = ModalProvider;
	module.exports = exports['default'];

/***/ },

/***/ "Snuh":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	var _reactRedux = __webpack_require__("4n+p");
	
	__webpack_require__("zDX4");
	
	var _ModalContent = __webpack_require__("0/+1");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _locale = __webpack_require__("G5eR");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _addClient = __webpack_require__("0iTc");
	
	var _addClient2 = _interopRequireDefault(_addClient);
	
	var _editClient = __webpack_require__("+NDk");
	
	var _editClient2 = _interopRequireDefault(_editClient);
	
	var _ducks = __webpack_require__("tCuI");
	
	var _getClientDetail = __webpack_require__("3heM");
	
	var _getClientDetail2 = _interopRequireDefault(_getClientDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    clientList: state.clientList
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchClientList: function fetchClientList(obj) {
	      return dispatch((0, _ducks.fetchClientList)(obj));
	    }
	  };
	};
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      disabledBtn: false,
	      customFormData: {}
	    };
	
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    _this.onCustomDataChange = _this.onCustomDataChange.bind(_this);
	
	    return _this;
	  }
	
	  ModalBody.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    if (this.props.clientId) {
	      (0, _getClientDetail2.default)(this.props.clientId).then(function (res) {
	        _this2.setState({ customFormData: res.custom_data });
	      });
	    }
	  };
	
	  ModalBody.prototype.onSubmit = function onSubmit() {
	    var _this3 = this;
	
	    if (this.formData == undefined) {
	      return _alert.alert.warning(__('All Fields with * Must Be Filled', _locale2.default)).then(function () {
	        _this3.setState({ disabledBtn: false });
	      });
	    }
	
	    if (this.formData.mobile_parsed.national_number && this.formData.mobile_parsed.national_number.length < 5) {
	      return _alert.alert.warning(__('Please enter a valid phone number', _locale2.default)).then(function () {
	        _this3.setState({ disabledBtn: false });
	      });
	    }
	    var customDataValidateResult = this.customDataValidate();
	
	    if (!customDataValidateResult.ok) {
	      this.setState({ disabledBtn: false });
	      return;
	    }
	    var schoolId = localStorage.getItem('schoolId');
	    var _formData = this.formData,
	        mobile_parsed = _formData.mobile_parsed,
	        tag_name_list = _formData.tag_name_list,
	        gender = _formData.gender,
	        first_name = _formData.first_name,
	        last_name = _formData.last_name,
	        date_of_birth = _formData.date_of_birth;
	
	    var newPhone = mobile_parsed.national_number ? mobile_parsed.country_code.toString() + mobile_parsed.national_number.toString() : '';
	
	    var newTags = [];
	    if (tag_name_list.length > 0) {
	      tag_name_list.map(function (tag) {
	        newTags.push(tag.text);
	      });
	    }
	
	    if (!first_name || !last_name || !gender || !mobile_parsed) {
	      return _alert.alert.warning(__('All Fields with * Must Be Filled', _locale2.default)).then(function () {
	        _this3.setState({ disabledBtn: false });
	      });
	    }
	
	    if (gender == '') {
	      delete this.formData.gender;
	    }
	    delete this.formData.mobile_parsed;
	
	    var newData = _extends({}, this.formData, { mobile: newPhone, tag_name_list: newTags, custom_data: this.state.customFormData });
	    var addorEdit = this.props.clientId ? _editClient2.default : _addClient2.default;
	    var Id = this.props.clientId ? this.props.clientId : schoolId;
	
	    addorEdit(Id, newData).then(function (res) {
	      if (res.result == 'success') {
	        _this3.props.proceed();
	      }
	    });
	  };
	
	  ModalBody.prototype.onCustomDataChange = function onCustomDataChange(customFormData) {
	    this.setState({
	      customFormData: _extends({}, this.state.customFormData, customFormData)
	    });
	  };
	
	  ModalBody.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel,
	        type = _props.type;
	    var customFormData = this.state.customFormData;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'attendance-scam-modal',
	        hasHeader: true,
	        hasFooter: true,
	        headerTitle: type === 'edit' ? __("Edit Contact", _locale2.default) : __("Add Contact", _locale2.default),
	        fixedWidth: 600,
	        contentHeight: 530,
	        onCloseModalClick: dismiss,
	        footerType: 'grey',
	        footerButtons: [{
	          title: __('Save', _locale2.default),
	          className: 'btn btn-primary pull-right',
	          onClick: function onClick() {
	            _this4.setState({ disabledBtn: true }, function () {
	              _this4.onSubmit();
	            });
	          },
	          isDisabled: function isDisabled() {
	            return _this4.state.disabledBtn;
	          }
	        }, {
	          title: __('Cancel', _locale2.default),
	          className: 'btn btn-default pull-right',
	          onClick: function onClick() {
	            dismiss();
	          }
	        }],
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, _extends({}, this.props, {
	        onCustomDataChange: this.onCustomDataChange
	        //scrollingContainerRef={this.modalContentRef}
	        , customFormData: customFormData,
	        getCustomDataValidationRef: function getCustomDataValidationRef(fn) {
	          _this4.customDataValidate = fn;
	        },
	        onFormChange: function onFormChange(stateFromModalContent) {
	          _this4.formData = stateFromModalContent;
	        }
	      }))
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactConfirm.confirmable)(ModalBody));
	module.exports = exports['default'];

/***/ },

/***/ "zDX4":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"potential-client-modal-content":"potential-client-modal-content","gender":"gender","name":"name","DOB":"DOB","potential-client-tags":"potential-client-tags","parent-name":"parent-name","contact-num":"contact-num","remarks":"remarks","name-label":"name-label","gender-label":"gender-label","DOB-label":"DOB-label","tags-label":"tags-label","input-label":"input-label","remarks-label":"remarks-label","basic-info":"basic-info","tagsClass":"tagsClass","react-tel-input":"react-tel-input","selected-flag":"selected-flag","talk-bubble":"talk-bubble","showHint":"showHint","noShow":"noShow","Form":"Form","col-sm-9":"col-sm-9","control-label":"control-label"};

/***/ },

/***/ "0/+1":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("zDX4");
	
	var _locale = __webpack_require__("G5eR");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _Name = __webpack_require__("Ivgm");
	
	var _Name2 = _interopRequireDefault(_Name);
	
	var _Gender = __webpack_require__("yUzp");
	
	var _Gender2 = _interopRequireDefault(_Gender);
	
	var _DOBPicker = __webpack_require__("Rn4c");
	
	var _DOBPicker2 = _interopRequireDefault(_DOBPicker);
	
	var _index = __webpack_require__("xp4B");
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Input = __webpack_require__("n/J4");
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Remarks = __webpack_require__("ZTVs");
	
	var _Remarks2 = _interopRequireDefault(_Remarks);
	
	var _PhoneNumber = __webpack_require__("GM/A");
	
	var _PhoneNumber2 = _interopRequireDefault(_PhoneNumber);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _getClientDetail = __webpack_require__("3heM");
	
	var _getClientDetail2 = _interopRequireDefault(_getClientDetail);
	
	var _getClientCustomFields = __webpack_require__("083y");
	
	var _getClientCustomFields2 = _interopRequireDefault(_getClientCustomFields);
	
	var _CheckboxForCustomField = __webpack_require__("yZ7h");
	
	var _CheckboxForCustomField2 = _interopRequireDefault(_CheckboxForCustomField);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var DEFAULT_REGION_CODE = 'ca';
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      suggestions: [],
	      clientInfo: {
	        first_name: '',
	        last_name: '',
	        gender: 'male',
	        date_of_birth: '',
	        // mobile: '1',
	        mobile_parsed: { country_code: "1", national_number: "", region_code: DEFAULT_REGION_CODE },
	        email: '',
	        guardian_name: '',
	        guardian_mobile: '',
	        guardian_email: '',
	        remark: '',
	        tag_name_list: []
	      },
	      showHint: false,
	      testNo: '',
	      customFieldSchema: []
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onNameChange = _this.onNameChange.bind(_this);
	    _this.onMobileChange = _this.onMobileChange.bind(_this);
	    _this.handleDelete = _this.handleDelete.bind(_this);
	    _this.handleAddition = _this.handleAddition.bind(_this);
	    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
	
	    return _this;
	  }
	
	  ModalContent.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    this.loadCustomFieldSchema();
	
	    if (this.props.clientId) {
	      (0, _getClientDetail2.default)(this.props.clientId).then(function (res) {
	        var convertedGender = '';
	        if (res.gender == 0) {
	          convertedGender = 'male';
	        } else if (res.gender == 1) {
	          convertedGender = 'female';
	        } else {
	          convertedGender = 'n/a';
	        }
	
	        var convertedTag = [];
	        if (res.tag_name_list) {
	          res.tag_name_list.map(function (tag) {
	            convertedTag.push({ id: tag, text: tag });
	          });
	        }
	
	        _this2.setState({
	          clientInfo: _extends({}, _this2.state.clientInfo, {
	            first_name: res.first_name,
	            last_name: res.last_name,
	            gender: convertedGender,
	            date_of_birth: res.birthday ? (0, _moment2.default)(res.birthday).format('YYYY-MM-DD') : '',
	            mobile_parsed: res.mobile_parsed,
	            email: res.email,
	            guardian_name: res.guardian_name,
	            guardian_email: res.guardian_email,
	            remark: res.remark,
	            tag_name_list: convertedTag
	          })
	        }, function () {
	          _this2.props.onFormChange(_this2.state.clientInfo);
	        });
	      });
	    }
	
	    if (this.props.clientList) {
	      var clientList = this.props.clientList;
	      var tag_list = clientList.tag_list;
	
	
	      var newTagList = [];
	      tag_list.map(function (tag) {
	        newTagList.push({ id: tag.name, text: tag.name });
	      });
	
	      this.setState({ suggestions: newTagList });
	    }
	  };
	
	  ModalContent.prototype.loadCustomFieldSchema = function loadCustomFieldSchema() {
	    var _this3 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    (0, _getClientCustomFields2.default)(schoolId).then(function (res) {
	      if (res && res.contact_custom_fields) {
	        var fields = res.contact_custom_fields.fields;
	
	
	        var customFieldSchema = [];
	
	        fields.map(function (field, index) {
	          var id = field.id,
	              label = field.label,
	              type = field.type,
	              options = field.options,
	              required = field.required;
	
	
	          if (typeof label === 'string' && label.length > 0) {
	            switch (type) {
	              case "text":
	                customFieldSchema.push({ name: id, label: label, type: 'text', required: required });
	                break;
	              case "select":
	                var optionArr = options.map(function (option, i) {
	                  return {
	                    value: option,
	                    label: option
	                  };
	                });
	
	                // add an empty value in the beginning
	                optionArr = [{}].concat(optionArr);
	
	                customFieldSchema.push({
	                  name: id,
	                  required: required,
	                  label: label,
	                  type: 'select',
	                  options: optionArr
	                });
	
	                break;
	              case "checkbox":
	                customFieldSchema.push({
	                  name: id,
	                  label: label,
	                  type: 'custom',
	                  required: required,
	                  component: function component(value, onChange, item, props) {
	                    return _react2.default.createElement(_CheckboxForCustomField2.default, { value: value, onChange: onChange, item: field });
	                  }
	                });
	                break;
	            }
	          }
	        });
	
	        _this3.setState({
	          customFieldSchema: customFieldSchema
	        });
	      }
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  ModalContent.prototype.onChange = function onChange(name) {
	    var _this4 = this;
	
	    var onFormChange = this.props.onFormChange;
	
	
	    return function (value) {
	      var _extends2;
	
	      var newValue = void 0;
	
	      if (name == 'date_of_birth') {
	        newValue = (0, _moment2.default)(value).format('YYYY-MM-DD');
	      } else if (name == 'gender') {
	        newValue = value;
	      } else if (name == 'guardian_name') {
	        newValue = value;
	      } else {
	        newValue = value.target.value;
	      }
	
	      _this4.setState({
	        clientInfo: _extends({}, _this4.state.clientInfo, (_extends2 = {}, _extends2[name] = newValue, _extends2))
	      }, function () {
	        onFormChange(_this4.state.clientInfo);
	      });
	    };
	  };
	
	  ModalContent.prototype.onNameChange = function onNameChange(_ref) {
	    var _this5 = this;
	
	    var firstName = _ref.firstName,
	        lastName = _ref.lastName;
	
	    this.setState({
	      clientInfo: _extends({}, this.state.clientInfo, {
	        'first_name': firstName,
	        'last_name': lastName
	      })
	    }, function () {
	      _this5.props.onFormChange(_this5.state.clientInfo);
	    });
	  };
	
	  ModalContent.prototype.onMobileChange = function onMobileChange(value) {
	    var _this6 = this;
	
	    this.setState({
	      clientInfo: _extends({}, this.state.clientInfo, {
	        mobile_parsed: value
	      })
	    }, function () {
	      _this6.props.onFormChange(_this6.state.clientInfo);
	    });
	  };
	
	  ModalContent.prototype.handleDelete = function handleDelete(i) {
	    var _this7 = this;
	
	    var onFormChange = this.props.onFormChange;
	    var clientInfo = this.state.clientInfo;
	    var tag_name_list = clientInfo.tag_name_list;
	
	    this.setState({
	      clientInfo: _extends({}, this.state.clientInfo, {
	        tag_name_list: tag_name_list.filter(function (tag, index) {
	          return index !== i;
	        })
	      })
	    }, function () {
	      onFormChange(_this7.state.clientInfo);
	    });
	  };
	
	  ModalContent.prototype.handleAddition = function handleAddition(tag) {
	    var _this8 = this;
	
	    var onFormChange = this.props.onFormChange;
	    var clientInfo = this.state.clientInfo;
	    var tag_name_list = clientInfo.tag_name_list;
	
	    this.setState({
	      clientInfo: _extends({}, this.state.clientInfo, {
	        tag_name_list: [].concat(tag_name_list, [tag])
	      })
	    }, function () {
	      onFormChange(_this8.state.clientInfo);
	    });
	  };
	
	  ModalContent.prototype.handleInputFocus = function handleInputFocus() {
	    this.setState({ showHint: true });
	  };
	
	  ModalContent.prototype.render = function render() {
	    var _state = this.state,
	        clientInfo = _state.clientInfo,
	        suggestions = _state.suggestions,
	        showHint = _state.showHint,
	        customFieldSchema = _state.customFieldSchema;
	    var first_name = clientInfo.first_name,
	        last_name = clientInfo.last_name,
	        gender = clientInfo.gender,
	        date_of_birth = clientInfo.date_of_birth,
	        tag_name_list = clientInfo.tag_name_list,
	        mobile_parsed = clientInfo.mobile_parsed,
	        guardian_name = clientInfo.guardian_name,
	        remark = clientInfo.remark;
	    var _props = this.props,
	        customFormData = _props.customFormData,
	        onCustomDataChange = _props.onCustomDataChange,
	        scrollingContainerRef = _props.scrollingContainerRef,
	        getCustomDataValidationRef = _props.getCustomDataValidationRef;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'potential-client-modal-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'basic-info' },
	        __('Basic Information', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-3 name-label' },
	          __('Name', _locale2.default),
	          _react2.default.createElement(
	            'span',
	            { className: 'c-red' },
	            '*'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-9' },
	          _react2.default.createElement(_Name2.default, { className: 'name', value: { firstName: first_name, lastName: last_name }, onChange: this.onNameChange })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-3 gender-label' },
	          __('Gender', _locale2.default),
	          _react2.default.createElement(
	            'span',
	            { className: 'c-red' },
	            '*'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-9' },
	          _react2.default.createElement(_Gender2.default, { className: 'gender', value: gender, onChange: this.onChange('gender') })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row DOB' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-3 DOB-label' },
	          __('Date of Birth', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-9' },
	          _react2.default.createElement(_DOBPicker2.default, { className: 'form-control', value: date_of_birth, onChange: this.onChange('date_of_birth') })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row contact-num' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-3 input-label' },
	          __('Contact Number', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-9' },
	          _react2.default.createElement(_PhoneNumber2.default, { className: 'form-control', defaultCountry: 'ca', value: mobile_parsed, onChange: this.onMobileChange, onlyCountries: ['ca', 'us'], disableAreaCodes: true })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row talk-bubble' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-9' },
	          _react2.default.createElement(
	            'p',
	            { className: showHint ? 'showHint' : 'noShow' },
	            __("Please press 'Enter' to create a new tag", _locale2.default)
	          )
	        )
	      ),
	      _react2.default.createElement(_index2.default, {
	        tags: tag_name_list,
	        label: __('Tag', _locale2.default),
	        tagContainerClass: 'form-control',
	        className: 'potential-client-tags',
	        placeholder: __('Add new tag for easier searching, ex: Language Class', _locale2.default),
	        suggestions: suggestions,
	        handleDelete: this.handleDelete,
	        handleAddition: this.handleAddition,
	        handleInputFocus: this.handleInputFocus
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-3 input-label' },
	          __('Parent Name', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-9' },
	          _react2.default.createElement(_Input2.default, { type: 'text', className: 'parent-name', value: guardian_name, onChange: this.onChange('guardian_name') })
	        )
	      ),
	      _react2.default.createElement(_Remarks2.default, { label: __('Remarks', _locale2.default), inputClassName: 'form-control', rows: 6, className: 'remarks', value: remark, onChange: this.onChange('remark') }),
	      _react2.default.createElement(
	        'div',
	        { className: 'basic-info' },
	        __('Other Info', _locale2.default)
	      ),
	      _react2.default.createElement(_Form2.default, {
	        onChange: onCustomDataChange,
	        schema: customFieldSchema,
	        formData: customFormData,
	        formStyle: 'inline',
	        getValidationRef: getCustomDataValidationRef,
	        scrollingContainerRef: scrollingContainerRef
	      })
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "G5eR":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
	  id: "potentialClientModal",
	  code: "CN",
	  text: {
	    'Add Contact': '新增联系人',
	    'Edit Contact': '编辑联系人',
	    'Basic Information': '基本信息',
	    'Name': '姓名',
	    'Gender': '性别',
	    'Date of Birth': '生日',
	    'Tag': '标签',
	    'Parent Name': '家长姓名',
	    'Contact Number': '联系电话',
	    'Remarks': '备注',
	    'Save': '保存',
	    'Cancel': '取消',
	    'Male': '男',
	    'Female': '女',
	    'Add new tag for easier searching, ex: Language Class': '填写标签便于筛选与查找 ex: 语文初级班',
	    'All Fields with * Must Be Filled': '带*号的字段必须填写',
	    "Please press 'Enter' to create a new tag": "请按'Enter'来创建一个新标签",
	    "Please enter a valid phone number": "请输入正确的电话号码",
	    "Other Info": "其他信息"
	  }
	};
	module.exports = exports["default"];

/***/ },

/***/ "Rn4c":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <DOBPicker />
	                    *
	                    * @parent anybody
	                    * @stateful
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDatepicker = __webpack_require__("rAVN");
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__("V/K8");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__("f1j2");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_DATE = 'YYYY-MM-DD';
	
	var DOBPicker = (_temp = _class = function (_React$Component) {
	  _inherits(DOBPicker, _React$Component);
	
	  function DOBPicker(props) {
	    _classCallCheck(this, DOBPicker);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  DOBPicker.prototype.render = function render() {
	    var _props = this.props,
	        value = _props.value,
	        onChange = _props.onChange,
	        _props$dateFormat = _props.dateFormat,
	        dateFormat = _props$dateFormat === undefined ? DEFAULT_DATE : _props$dateFormat,
	        _props$placeholderTex = _props.placeholderText,
	        placeholderText = _props$placeholderTex === undefined ? DEFAULT_DATE : _props$placeholderTex,
	        className = _props.className;
	
	
	    var selected = void 0;
	
	    if (value instanceof _moment2.default) {
	      selected = value;
	    } else if (typeof value === 'string' && value.length > 0) {
	      selected = (0, _moment2.default)(value, dateFormat);
	    } else {
	      selected = value;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'dob-picker' },
	      _react2.default.createElement(_reactDatepicker2.default, {
	        className: (0, _classnames2.default)('form-control ' + className),
	        selected: selected,
	        onChange: onChange,
	        dateFormat: dateFormat,
	        showMonthDropdown: true,
	        placeholderText: placeholderText,
	        showYearDropdown: true,
	        maxDate: (0, _moment2.default)(),
	        yearDropdownItemNumber: 50,
	        scrollableYearDropdown: true })
	    );
	  };
	
	  return DOBPicker;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = DOBPicker;
	module.exports = exports['default'];

/***/ },

/***/ "f1j2":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dob-picker":"dob-picker","react-datepicker-wrapper":"react-datepicker-wrapper","react-datepicker__input-container":"react-datepicker__input-container","react-datepicker":"react-datepicker","react-datepicker__header":"react-datepicker__header","react-datepicker__month":"react-datepicker__month","react-datepicker__day-name":"react-datepicker__day-name","react-datepicker__day":"react-datepicker__day","react-datepicker__current-month":"react-datepicker__current-month","react-datepicker__navigation":"react-datepicker__navigation","react-datepicker__navigation--previous":"react-datepicker__navigation--previous","react-datepicker__navigation--next":"react-datepicker__navigation--next","react-datepicker__navigation--years-upcoming":"react-datepicker__navigation--years-upcoming","react-datepicker__navigation--years-previous":"react-datepicker__navigation--years-previous","react-datepicker__year-option":"react-datepicker__year-option"};

/***/ },

/***/ "083y":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getClientCustomFields;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getClientCustomFields(schoolId) {
	
	  if (!schoolId) {
	    throw 'missing school ID';
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/contact_custom_fields/' + schoolId + '/',
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "0iTc":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = addClient;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GENDER = ['male', 'female', 'other', 'n/a'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  "first_name": _joiBrowser2.default.string().required(),
	  "last_name": _joiBrowser2.default.string().required(),
	  "gender": _joiBrowser2.default.string().valid(GENDER).required(),
	  "date_of_birth": _joiBrowser2.default.string().allow(''),
	  "mobile": _joiBrowser2.default.string().allow(''),
	  "email": _joiBrowser2.default.string().allow(''),
	  "guardian_name": _joiBrowser2.default.string().allow(''),
	  "guardian_mobile": _joiBrowser2.default.string().allow(''),
	  "guardian_email": _joiBrowser2.default.string().allow(''),
	  "remark": _joiBrowser2.default.string().allow(''),
	  "tag_name_list": _joiBrowser2.default.array().allow(''),
	  "custom_data": _joiBrowser2.default.object().allow(null)
	
	});
	
	function addClient(schoolId, clientInfo) {
	
	  if (!schoolId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school Id')
	      });
	    });
	  }
	
	  /*
	  let validateResult = Joi.validate(clientInfo, schema);
	   if (validateResult.error) {
	    return new Promise((resolve, reject)=> {
	      reject(validateResult);
	    });
	  }
	  */
	
	  if (Array.isArray(clientInfo.custom_data)) {
	    clientInfo.custom_data = {};
	  }
	
	  var toServer = _extends({}, clientInfo, {
	    gender: clientInfo.gender ? GENDER.indexOf(clientInfo.gender) : 3
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/contact_lst/" + schoolId + "/",
	      'method': 'POST',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "EnYG":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("0UEY");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "0UEY":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("8bO9");
	
	var _ModalContent = __webpack_require__("/pIq");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _locale = __webpack_require__("Il5u");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel;
	
	
	    var language = localStorage.getItem('language');
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'attendance-scan-message-modal',
	        isShowingModal: show // if you want to show it when component mounts, set it true
	
	        , onCloseModalClick: dismiss,
	        fixedHeight: language == 'CN' ? 550 : 620,
	        fixedWidth: 600,
	        overlayColor: '#000',
	
	        hasHeader: true,
	        hasFooter: false,
	        headerType: 'bold',
	        headerTitle: __('Continue Attendance Scan', _locale2.default)
	      },
	      _react2.default.createElement(_ModalContent2.default, this.props)
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "8bO9":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"attendance-scan-message-modal":"attendance-scan-message-modal","header":"header","close-button":"close-button","classtop-modal-content":"classtop-modal-content","attendance-scan-message-modal-content":"attendance-scan-message-modal-content","btn-container":"btn-container","input-container":"input-container"};

/***/ },

/***/ "/pIq":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("Il5u");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _AttendanceScan = __webpack_require__("VWHN");
	
	var _AttendanceScan2 = _interopRequireDefault(_AttendanceScan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent() {
	    _classCallCheck(this, ModalContent);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalContent.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'attendance-scan-message-modal-content' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'text-center' },
	        __('Attention Notes', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          __('Please make sure that the scanner is connected to the computer that is using ClasstopBase. The computer will recognize the Scanner when you plug it into a USB slot. Make sure the light on the scanner tunes on after being plugged in.', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          __('When using Smart Check In and Scan Payment functions, please log in to ClasstopBase on an Administrator account with the corresponding permissions to operate these functions.', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          __('Smart Check In will sign in students for a class that is about to start, or one that is already in progress (in which case the student will be marked as late). However, if the lesson has already finished, students can not sign in with Smart Check In. You can manually sign in the student in the Class Channel on ClasstopBase.', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          __('When using Smart Check In and Scan Payment functions on your browser, please make sure that the corresponding window remains open, and the browser or tab is not closed, or minimized during use.', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          __('Please click “I Understand” to start scanning.', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'text-center btn-container' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary', onClick: function onClick() {
	                _this2.props.dismiss();
	                (0, _AttendanceScan2.default)();
	              } },
	            __('I understand', _locale2.default)
	          )
	        )
	      )
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "Il5u":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'AttendanceScanMessage',
	  code: 'CN',
	  text: {
	    "Continue Attendance Scan": "进行扫码签到",
	    'Attention Notes': '注意事项',
	    'Please make sure that the scanner is connected to the computer that is using ClasstopBase. The computer will recognize the Scanner when you plug it into a USB slot. Make sure the light on the scanner tunes on after being plugged in.': '请确认扫码仪已成功连接到本电脑，电脑显示有 USB Key Module 设备连接，并且扫码仪指示灯点亮',
	    'When using Smart Check In and Scan Payment functions, please log in to ClasstopBase on an Administrator account with the corresponding permissions to operate these functions.': '在使用智能签到以及扫码付款时，确保是以校长账户或拥有相应权限的管理员账户登录',
	    'Smart Check In will sign in students for a class that is about to start, or one that is already in progress (in which case the student will be marked as late). However, if the lesson has already finished, students can not sign in with Smart Check In. You can manually sign in the student in the Class Channel on ClasstopBase.': '智能签到会对该学生当天、未签到的、距离当时时间最近的一节还未上的课或正在上的课（做迟到处理）进行签到，已经下课的无法签到，可在班级频道内手动补签到',
	    'When using Smart Check In and Scan Payment functions on your browser, please make sure that the corresponding window remains open, and the browser or tab is not closed, or minimized during use.': '请在智能签到以及扫码付款时，确保扫码界面打开，浏览器必须在当前页面，不能最小化',
	    'Please click “I Understand” to start scanning.': '请点击“我知道了”进去扫码界面',
	    'Don’t remind me next time': '下次不要再提醒我',
	    'I understand': '我知道了'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "VWHN":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalProvider = __webpack_require__("Oct8");
	
	var _ModalProvider2 = _interopRequireDefault(_ModalProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalProvider2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "Oct8":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalBody = __webpack_require__("K4Dq");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalProvider = function (_React$Component) {
	  _inherits(ModalProvider, _React$Component);
	
	  function ModalProvider(props) {
	    _classCallCheck(this, ModalProvider);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalProvider.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(_ModalBody2.default, this.props)
	    );
	  };
	
	  return ModalProvider;
	}(_react2.default.Component);
	
	exports.default = ModalProvider;
	module.exports = exports['default'];

/***/ },

/***/ "K4Dq":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("cN55");
	
	var _ModalContent = __webpack_require__("tm66");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ducks = __webpack_require__("yhkM");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import getTimetable from 'controllers/school/getTimetable'
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel,
	        dispatch = _props.dispatch;
	
	
	    var schoolId = localStorage.getItem('schoolId');
	    var start_date = (0, _moment2.default)(new Date()).startOf('month').format('YYYY-MM-DD');
	    var end_date = (0, _moment2.default)(new Date()).endOf('month').format('YYYY-MM-DD');
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'attendance-scan-modal',
	        hasHeader: true,
	
	        headerTitle: __("Smart Check In", "attendanceScan"),
	        headerIcon: 'fa icon-qrcode',
	        fixedWidth: 600,
	        contentHeight: 550,
	        onCloseModalClick: function onCloseModalClick() {
	          dispatch((0, _ducks.fetchSchedule)(schoolId, { start_date: start_date, end_date: end_date }));
	          dismiss();
	        },
	
	        footerType: 'grey',
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, null)
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactConfirm.confirmable)(ModalBody));
	module.exports = exports['default'];

/***/ },

/***/ "cN55":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"attendance-scan-modal-content":"attendance-scan-modal-content","scan-image":"scan-image","scan-note-red":"scan-note-red","circle-container":"circle-container","circle1":"circle1","blink-animation":"blink-animation","circle2":"circle2","circle3":"circle3","circle4":"circle4","circle5":"circle5","pulse":"pulse","noShowCheck":"noShowCheck","showCheck":"showCheck"};

/***/ },

/***/ "tm66":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MIN_INTERVAL_FOR_LEGIT_INPUT = undefined;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Scan2x = __webpack_require__("MmVP");
	
	var _Scan2x2 = _interopRequireDefault(_Scan2x);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("cN55");
	
	var _addAttendanceScan = __webpack_require__("FVDq");
	
	var _addAttendanceScan2 = _interopRequireDefault(_addAttendanceScan);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var MIN_INTERVAL_FOR_LEGIT_INPUT = exports.MIN_INTERVAL_FOR_LEGIT_INPUT = 200;
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      table: [],
	      scanSuccess: false
	    };
	
	    _this.recordScanner = _this.recordScanner.bind(_this);
	    _this.submitBarcode = _this.submitBarcode.bind(_this);
	    _this.legitInput = '';
	    return _this;
	  }
	
	  ModalContent.prototype.componentDidMount = function componentDidMount() {
	    if (localStorage.getItem('scan_table')) {
	      var scanTable = localStorage.getItem('scan_table');
	      var schoolId = localStorage.getItem('schoolId');
	
	      var table = JSON.parse(scanTable);
	      if (table[0].schoolId == schoolId) {
	        this.setState({ table: table });
	      }
	    }
	  };
	
	  ModalContent.prototype.componentWillMount = function componentWillMount() {
	    window.addEventListener('keypress', this.recordScanner);
	  };
	
	  ModalContent.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('keypress', this.recordScanner);
	  };
	
	  ModalContent.prototype.recordScanner = function recordScanner(e) {
	    var _this2 = this;
	
	    e.preventDefault();
	
	    clearTimeout(this.recordScannerTimeout);
	
	    if (e.charCode === 13) {
	      this.submitBarcode(this.legitInput);
	      return;
	    }
	    this.legitInput += e.key;
	
	    this.recordScannerTimeout = setTimeout(function () {
	      _this2.submitBarcode(_this2.legitInput);
	    }, MIN_INTERVAL_FOR_LEGIT_INPUT);
	  };
	
	  ModalContent.prototype.submitBarcode = function submitBarcode(code) {
	    var _this3 = this;
	
	    var table = this.state.table;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var current_time = new _moment2.default().format("HH:mm");
	    this.legitInput = '';
	
	    (0, _addAttendanceScan2.default)(schoolId, { code: code }).then(function (res) {
	      if (res.result == 'success') {
	        _this3.setState({ scanSuccess: true });
	        setTimeout(function () {
	          _this3.setState({ scanSuccess: false });
	        }, 1000);
	
	        var _schoolId = localStorage.getItem('schoolId');
	        var obj = {
	          schoolId: _schoolId,
	          name: res.student_name || res.teacher_name,
	          class: res.class_name || '',
	          lesson: res.lesson_name || '',
	          clock: res.operation_type || '',
	          time: current_time
	        };
	
	        var newTable = [obj].concat(_this3.state.table);
	
	        if (newTable.length > 6) {
	          newTable.pop();
	        }
	        _this3.setState({ hideTable: true }, function () {
	          _this3.setState({ table: newTable, hideTable: false }, function () {
	            localStorage.setItem('scan_table', JSON.stringify(_this3.state.table));
	          });
	        });
	      } else if (res.result == 'failure' && res.reason == 'student has no lesson or has checked in') {
	        _alert.alert.warning(__('Student has already checked in or has no lesson', 'attendanceScan'));
	      } else if (res.result == 'failure' && res.reason == 'Invalid code or not a student of this school') {
	        _alert.alert.warning(__('Student does not exist in school or invalid code', 'attendanceScan'));
	      } else if (res.result == 'failure' && res.reason == 'you have missed the lesson') {
	        _alert.alert.warning(__('Student has missed the lesson', 'attendanceScan'));
	      }
	    });
	  };
	
	  ModalContent.prototype.render = function render() {
	    var _state = this.state,
	        table = _state.table,
	        hideTable = _state.hideTable,
	        scanSuccess = _state.scanSuccess;
	
	    var successClass = scanSuccess === true ? 'showCheck' : 'noShowCheck';
	
	    var fields = [{
	      name: 'name',
	      title: __('Students', 'attendanceScan')
	    }, {
	      name: 'class',
	      title: __('Class', 'attendanceScan')
	    }, {
	      name: 'lesson',
	      title: __('Lesson', 'attendanceScan')
	    }, {
	      name: 'clock',
	      title: __('Clock In/Clock Out', 'attendanceScan'),
	      getTdContent: function getTdContent(_ref) {
	        var data = _ref.trData;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          data.clock === 1 ? __('Clock In', 'attendanceScan') : __('Clock Out', 'attendanceScan')
	        );
	      }
	    }, {
	      name: 'time',
	      title: __('Time', 'attendanceScan')
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'attendance-scan-modal-content' },
	      _react2.default.createElement('img', { src: _Scan2x2.default, className: 'scan-image' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'text-center circle-container' },
	        _react2.default.createElement('div', { className: 'circle1' }),
	        _react2.default.createElement('div', { className: 'circle2' }),
	        _react2.default.createElement('div', { className: 'circle3' }),
	        _react2.default.createElement('div', { className: 'circle4' }),
	        _react2.default.createElement('div', { className: 'circle5' }),
	        _react2.default.createElement('img', { className: successClass, src: __webpack_require__("dVIu") })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'scan-note-red text-center' },
	        __('Scanning for attendance, please do not close this window', 'attendanceScan')
	      ),
	      hideTable != true && _react2.default.createElement(_UI.Table, {
	        data: table,
	        fields: fields,
	        className: 'scan-table',
	        settingWidth: '15%',
	        useMultiSelection: false,
	        oneSettingPerRow: false,
	        dropdownGuideWidth: 160,
	        dropdownGuideHeight: 228,
	        usePagination: false
	      })
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;

/***/ },

/***/ "MmVP":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Scan@2x.2b47927c.png";

/***/ },

/***/ "FVDq":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = addLessonAttendance;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  "code": _joiBrowser2.default.string().required()
	});
	
	function addLessonAttendance(schoolId, studentCode) {
	
	  if (!schoolId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school Id')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(studentCode, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/lsn_check_scan/" + schoolId + "/",
	      'method': 'POST',
	      'data': JSON.stringify(studentCode),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "biI2":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalProvider = __webpack_require__("j/ux");
	
	var _ModalProvider2 = _interopRequireDefault(_ModalProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalProvider2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "j/ux":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalBody = __webpack_require__("EGFK");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalProvider = function (_React$Component) {
	  _inherits(ModalProvider, _React$Component);
	
	  function ModalProvider(props) {
	    _classCallCheck(this, ModalProvider);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalProvider.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(_ModalBody2.default, this.props)
	    );
	  };
	
	  return ModalProvider;
	}(_react2.default.Component);
	
	exports.default = ModalProvider;
	module.exports = exports['default'];

/***/ },

/***/ "EGFK":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	var _confirm = __webpack_require__("yMGN");
	
	__webpack_require__("tLSZ");
	
	var _ModalContent = __webpack_require__("1tRS");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _registerSchool2 = __webpack_require__("xNAE");
	
	var _registerSchool3 = _interopRequireDefault(_registerSchool2);
	
	var _addSubscription = __webpack_require__("g9St");
	
	var _addSubscription2 = _interopRequireDefault(_addSubscription);
	
	var _getUserByToken = __webpack_require__("v34H");
	
	var _getUserByToken2 = _interopRequireDefault(_getUserByToken);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _user = __webpack_require__("2F2H");
	
	var _MyStoreCheckout = __webpack_require__("o0wt");
	
	var _MyStoreCheckout2 = _interopRequireDefault(_MyStoreCheckout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    gSubscription: state.gSubscription
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchUserByToken: function fetchUserByToken() {
	      return dispatch((0, _user.fetchUserByToken)());
	    }
	  };
	};
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      creatingSchool: false
	    };
	
	    _this.registerSchool = _this.registerSchool.bind(_this);
	    _this.tryRegisteringSchool = _this.tryRegisteringSchool.bind(_this);
	    _this.afterCreatingSchool = _this.afterCreatingSchool.bind(_this);
	    return _this;
	  }
	
	  // Running recursively
	  // Look where it's running recursively
	
	
	  ModalBody.prototype.tryRegisteringSchool = function tryRegisteringSchool() {
	    var _this2 = this;
	
	    var gSubscription = this.props.gSubscription;
	    var saas_version = gSubscription.result.saas_version;
	
	
	    if (saas_version === 1) {
	      (0, _addSubscription2.default)({ plan_codename: "regular_usd_monthly", quantity: 1 }).then(function (res) {
	        if (res.result === 'success') {
	          _this2.registerSchool();
	        } else if (res.reason === 'credit card rejected, please change other card and try again later') {
	          _alert.alert.warning(__('Payment rejected, please change other card and try again later', 'changeschool')).then(function (res) {
	            (0, _MyStoreCheckout2.default)({
	              onSuccess: function onSuccess(res) {
	                _this2.registerSchool();
	              }
	            });
	          });
	        } else if (res.reason === 'user has no payment method.') {
	          (0, _MyStoreCheckout2.default)({
	            onSuccess: function onSuccess(res) {
	              _this2.registerSchool();
	            }
	          });
	        }
	      }).catch(function (err) {});
	    } else {
	      this.registerSchool();
	    }
	  };
	
	  ModalBody.prototype.registerSchool = function registerSchool() {
	    var _this3 = this;
	
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel,
	        dispatch = _props.dispatch;
	
	
	    if (typeof this.formData == 'undefined') {
	      return _alert.alert.warning(__('All field must be filled!', 'appwrapper')).then(function () {
	        _this3.setState({ creatingSchool: false });
	      });
	    }
	
	    var _formData = this.formData,
	        title = _formData.title,
	        description = _formData.description,
	        suitAgeLower = _formData.suitAgeLower,
	        city = _formData.city,
	        email = _formData.email,
	        phone = _formData.phone;
	
	
	    var newFormData = _extends({}, this.formData, { phone: phone.country_code + phone.national_number });
	
	    if (title == '' || description == '' || suitAgeLower == '' || city == '' || email == '' || phone.length <= 5) {
	      return _alert.alert.warning(__('All field must be filled!', 'appwrapper')).then(function () {
	        _this3.setState({ creatingSchool: false });
	      });
	    }
	    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
	      return _alert.alert.warning(__('Invalid email address!', 'appwrapper')).then(function () {
	        _this3.setState({ creatingSchool: false });
	      });
	    }
	    (0, _registerSchool3.default)(newFormData).then(function (res) {
	      _this3.setState({ creatingSchool: false });
	      _this3.props.fetchUserByToken();
	      _alert.alert.success(__('School Created', 'changeschool')).then(function () {
	        _this3.afterCreatingSchool();
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }).catch(function (error) {
	      _this3.setState({
	        creatingSchool: false
	      });
	      _alert.alert.warning(__('Please Enter Valid Information', 'changeschool'));
	    });
	  };
	
	  ModalBody.prototype.afterCreatingSchool = function afterCreatingSchool() {
	    var _props2 = this.props,
	        show = _props2.show,
	        proceed = _props2.proceed,
	        dismiss = _props2.dismiss,
	        cancel = _props2.cancel,
	        dispatch = _props2.dispatch;
	
	    proceed({
	      schoolCreated: true
	    });
	  };
	
	  ModalBody.prototype.footerContent = function footerContent() {
	    var gSubscription = this.props.gSubscription;
	
	
	    if (!gSubscription.result) {
	      return _react2.default.createElement('div', null);
	    }
	
	    if (gSubscription.result.saas_version === 1) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'price-on-createschool-modal' },
	        __('$79 USD / month per school', 'changeschool')
	      );
	    }
	  };
	
	  ModalBody.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props3 = this.props,
	        show = _props3.show,
	        proceed = _props3.proceed,
	        dismiss = _props3.dismiss,
	        cancel = _props3.cancel,
	        user = _props3.user,
	        gSubscription = _props3.gSubscription,
	        dispatch = _props3.dispatch;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'createschool-modal',
	        hasHeader: true,
	        hasFooter: true,
	        headerTitle: __("Create School", "changeschool"),
	        headerIcon: 'fa icon-bank',
	        fixedWidth: 600,
	        contentHeight: 450,
	        onCloseModalClick: dismiss,
	
	        footerType: 'grey',
	        footerButtons: [{
	          title: __('Complete', 'appwrapper'),
	          className: 'btn btn-primary pull-right',
	          isDisabled: function isDisabled() {
	            return _this4.state.creatingSchool === true;
	          },
	          onClick: function onClick() {
	            _this4.tryRegisteringSchool();
	            _this4.setState({
	              creatingSchool: true
	            });
	          }
	        }],
	        footerCustomContent: this.footerContent(),
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, {
	        onFormChange: function onFormChange(stateFromModalContent) {
	          _this4.formData = stateFromModalContent.params;
	        }
	      })
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactConfirm.confirmable)(ModalBody));
	module.exports = exports['default'];

/***/ },

/***/ "tLSZ":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"createschool-modal":"createschool-modal","price-on-createschool-modal":"price-on-createschool-modal","school-name":"school-name","pull-left":"pull-left","school-success-icon":"school-success-icon","pull-right":"pull-right","age":"age"};

/***/ },

/***/ "1tRS":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("tLSZ");
	
	var _reactCountryRegionSelector = __webpack_require__("bv3b");
	
	var _timezone = __webpack_require__("Vr+E");
	
	var _timezone2 = _interopRequireDefault(_timezone);
	
	var _currency = __webpack_require__("hpCb");
	
	var _currency2 = _interopRequireDefault(_currency);
	
	var _registerSchool = __webpack_require__("xNAE");
	
	var _registerSchool2 = _interopRequireDefault(_registerSchool);
	
	var _PhoneNumber = __webpack_require__("GM/A");
	
	var _PhoneNumber2 = _interopRequireDefault(_PhoneNumber);
	
	var _locale = __webpack_require__("tkfk");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	//;
	
	
	var DEFAULT_REGION_CODE = 'ca';
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      params: {
	        title: '',
	        description: '',
	        schoolType: 0,
	        country: 'Canada',
	        province: 'British Columbia',
	        city: '',
	        timezone: 'America/Vancouver',
	        currency: 'CAD',
	        suitAgeLower: '',
	        phone: { country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE },
	        email: ''
	      }
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  ModalContent.prototype.onChange = function onChange(name) {
	    var _this2 = this;
	
	    return function (e) {
	      var _extends6;
	
	      var onFormChange = _this2.props.onFormChange;
	
	
	      if (name == 'suitAgeLower') {
	        if (e.target.value > 0) {
	          var _extends2;
	
	          return _this2.setState({
	            params: _extends({}, _this2.state.params, (_extends2 = {}, _extends2[name] = e.target.value, _extends2))
	          }, function () {
	            onFormChange(_this2.state);
	          });
	        }
	      } else if (name == 'country') {
	        var _extends3;
	
	        return _this2.setState({
	          params: _extends({}, _this2.state.params, (_extends3 = {}, _extends3[name] = e, _extends3))
	        }, function () {
	          onFormChange(_this2.state);
	        });
	      } else if (name == 'province') {
	        var _extends4;
	
	        return _this2.setState({
	          params: _extends({}, _this2.state.params, (_extends4 = {}, _extends4[name] = e, _extends4))
	        }, function () {
	          onFormChange(_this2.state);
	        });
	      } else if (name == 'phone') {
	        var _extends5;
	
	        return _this2.setState({
	          params: _extends({}, _this2.state.params, (_extends5 = {}, _extends5[name] = e, _extends5))
	        }, function () {
	          onFormChange(_this2.state);
	        });
	      }
	
	      _this2.setState({
	        params: _extends({}, _this2.state.params, (_extends6 = {}, _extends6[name] = e.target.value, _extends6))
	      }, function () {
	        onFormChange(_this2.state);
	      });
	    };
	  };
	
	  ModalContent.prototype.selectTimeZone = function selectTimeZone() {
	    var timezone = [];
	    for (var i = 0; i < _timezone2.default.length; i++) {
	      timezone.push(_react2.default.createElement(
	        'option',
	        { key: i, value: _timezone2.default[i] },
	        _timezone2.default[i]
	      ));
	    }
	    return _react2.default.createElement(
	      'select',
	      { type: 'text', className: 'form-control', value: this.state.timezone, onChange: this.onChange('timezone') },
	      timezone
	    );
	  };
	
	  ModalContent.prototype.renderCurrency = function renderCurrency() {
	    var currency2 = [];
	    for (var i = 0; i < _currency2.default.length; i++) {
	      currency2.push(_react2.default.createElement(
	        'option',
	        { key: i, value: _currency2.default[i].code },
	        _currency2.default[i].code
	      ));
	    }
	    return _react2.default.createElement(
	      'select',
	      { type: 'text', className: 'form-control', value: this.state.params.currency, onChange: this.onChange('currency') },
	      currency2
	    );
	  };
	
	  ModalContent.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'custom-modal-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-lg-6 col-md-6 create-school-input-left' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'label',
	              { className: 'pull-left' },
	              __('School Name', 'appwrapper')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-3 school-name' },
	            _react2.default.createElement('img', { className: 'school-success-icon', src: this.state.params.title ? __webpack_require__("dVIu") : __webpack_require__("/FAr") })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-9 school-name-input' },
	            _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: '', value: this.state.params.title, onChange: this.onChange('title') })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'label',
	              { className: 'pull-left' },
	              __('School Description', 'appwrapper')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-3 school-name' },
	            _react2.default.createElement('img', { className: 'school-success-icon', src: this.state.params.description ? __webpack_require__("dVIu") : __webpack_require__("g/hk") })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-9 school-name-input' },
	            _react2.default.createElement('textarea', { type: 'text', className: 'form-control', value: this.state.params.description, onChange: this.onChange('description') })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'label',
	              { className: 'pull-left' },
	              __('Student Enrollment Age Limit', 'appwrapper'),
	              '  '
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-3 school-name' },
	            _react2.default.createElement('img', { className: 'school-success-icon', src: this.state.params.suitAgeLower ? __webpack_require__("dVIu") : __webpack_require__("DZpP") })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-9 school-name-input' },
	            _react2.default.createElement('input', { type: 'number', min: '0', placeholder: '0', className: 'form-control', value: this.state.params.suitAgeLower, onChange: this.onChange('suitAgeLower') }),
	            _react2.default.createElement(
	              'span',
	              { className: 'pull-right age' },
	              __('Years Old', 'appwrapper')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'label',
	              { className: 'pull-left' },
	              __('School Email', _locale2.default)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-3 school-name' },
	            _react2.default.createElement('img', { className: 'school-success-icon', src: /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.params.email) ? __webpack_require__("dVIu") : __webpack_require__("MDFB") })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-9 school-name-input' },
	            _react2.default.createElement('input', { type: 'email', className: 'form-control', value: this.state.params.email, onChange: this.onChange('email') })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'label',
	              { className: 'pull-left' },
	              __('School Phone No.', _locale2.default)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-3 school-name' },
	            _react2.default.createElement('img', { className: 'school-success-icon', src: this.state.params.phone.national_number.length > 5 ? __webpack_require__("dVIu") : __webpack_require__("iHTr") })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-9 school-name-input' },
	            _react2.default.createElement(_PhoneNumber2.default, { className: 'form-control', value: this.state.params.phone, onChange: this.onChange('phone'), defaultCountry: 'ca' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-lg-6 col-md-6 create-school-input-right' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'label',
	              { className: 'pull-left' },
	              __('Country', 'appwrapper')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-3 school-name' },
	            _react2.default.createElement('img', { className: 'school-success-icon', src: __webpack_require__("dVIu") })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-9 school-name-input' },
	            _react2.default.createElement(_reactCountryRegionSelector.CountryDropdown, {
	              defaultOptionLabel: 'Canada',
	              value: this.state.params.country,
	              classes: 'form-control',
	              onChange: this.onChange('country')
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'label',
	              { className: 'pull-left' },
	              __('Province/States', 'appwrapper')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-3 school-name' },
	            _react2.default.createElement('img', { className: 'school-success-icon', src: this.state.params.province ? __webpack_require__("dVIu") : __webpack_require__("LM+x") })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-9 school-name-input' },
	            _react2.default.createElement(_reactCountryRegionSelector.RegionDropdown, {
	              defaultOptionLabel: 'select a region',
	              country: this.state.params.country,
	              value: this.state.params.province,
	              classes: 'form-control',
	              onChange: this.onChange('province')
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12', style: { marginTop: '19px' } },
	            _react2.default.createElement(
	              'label',
	              { className: 'pull-left' },
	              __('City', 'appwrapper')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-3 school-name' },
	            _react2.default.createElement('img', { className: 'school-success-icon', src: this.state.params.city ? __webpack_require__("dVIu") : __webpack_require__("HPk7") })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-9 school-name-input' },
	            _react2.default.createElement('input', { type: 'text', className: 'form-control', value: this.state.params.city, onChange: this.onChange('city') })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'label',
	              { className: 'pull-left' },
	              __('Time Zone (Cannot Change After Saved)', 'appwrapper')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-3 school-name' },
	            _react2.default.createElement('img', { className: 'school-success-icon', src: __webpack_require__("dVIu") })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-9 school-name-input' },
	            this.selectTimeZone()
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'label',
	              { className: 'pull-left' },
	              __('Currency (Cannot Change After Saved)', 'appwrapper')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-3 school-name' },
	            _react2.default.createElement('img', { className: 'school-success-icon', src: __webpack_require__("dVIu") })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-9 school-name-input' },
	            this.renderCurrency()
	          )
	        )
	      )
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "tkfk":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'CreateSchoolModal',
	  code: 'CN',
	  text: {
	    'School Email': '学校邮箱',
	    'School Phone No.': '学校电话号码'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "/FAr":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1@2x.61967bd1.png";

/***/ },

/***/ "g/hk":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2@2x.b436bf99.png";

/***/ },

/***/ "DZpP":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3@2x.b6466ca4.png";

/***/ },

/***/ "MDFB":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4@2x.d8f1baa7.png";

/***/ },

/***/ "iHTr":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5@2x.9c8135b3.png";

/***/ },

/***/ "LM+x":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6@2x.23095ab9.png";

/***/ },

/***/ "HPk7":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8@2x.9476f33b.png";

/***/ },

/***/ "o0wt":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _CheckoutModalStripeWrapper = __webpack_require__("KBRT");
	
	var _CheckoutModalStripeWrapper2 = _interopRequireDefault(_CheckoutModalStripeWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_CheckoutModalStripeWrapper2.default);
	
	/**
	opts = {
	  onSuccess: function fired when transaction successful
	}
	*/

	module.exports = exports["default"];

/***/ },

/***/ "KBRT":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStripeElements = __webpack_require__("iEJf");
	
	var _CheckoutModal = __webpack_require__("OTko");
	
	var _CheckoutModal2 = _interopRequireDefault(_CheckoutModal);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <CheckoutModalStripeWrapper />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Header
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var key = '';
	var indicator = '';
	
	var api_key = '';
	
	if (false) {
	  key = "pk_test_smD2brB7NmCVjHNZcZ8Iu4BD";
	} else {
	  try {
	    api_key = __webpack_require__("z/kV");
	    key = api_key.STRIPE_API_KEY;
	    indicator = api_key.INDICATOR;
	  } catch (e) {
	    alert(e);
	  }
	}
	
	var CheckoutModalStripeWrapper = function (_React$Component) {
	  _inherits(CheckoutModalStripeWrapper, _React$Component);
	
	  function CheckoutModalStripeWrapper(props) {
	    _classCallCheck(this, CheckoutModalStripeWrapper);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  CheckoutModalStripeWrapper.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('input', { type: 'hidden', value: indicator }),
	      _react2.default.createElement(
	        _reactStripeElements.StripeProvider,
	        { apiKey: key },
	        _react2.default.createElement(
	          _reactStripeElements.Elements,
	          null,
	          _react2.default.createElement(_CheckoutModal2.default, this.props)
	        )
	      )
	    );
	  };
	
	  return CheckoutModalStripeWrapper;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(CheckoutModalStripeWrapper);
	module.exports = exports['default'];

/***/ },

/***/ "OTko":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStripeElements = __webpack_require__("iEJf");
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _processPayment = __webpack_require__("o8ZW");
	
	var _processPayment2 = _interopRequireDefault(_processPayment);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("Ue+K");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PLAN_CODENAME = 'regular_usd_monthly';
	
	// This is how you modify the style of CardElement
	// You can't do it with plain CSS
	var cardElementStyle = {
	  base: {
	    iconColor: '#D2D2D2',
	    fontWeight: 300,
	    '::placeholder': {
	      fontWeight: 300,
	      color: '#D2D2D2',
	      fontSize: '12px',
	      lineHeight: '13px'
	    }
	  }
	};
	
	var PRICE = '$79';
	
	var locale = {
	  id: 'OrderOverview',
	  code: 'CN',
	  text: {
	    'All payments are processed through Stripe. The connection is secure and encrypted. We do not collect any of your information.': '所有付款都通过 Stripe 处理。付款连接是安全并且加密的。我们不会收集您的任何信息。',
	    'month per school': '每个学校一个月',
	    'Privacy Policy': '隐私政策',
	    'Note: 5% tax will be applied on every transaction': '提示: 每次付款会额外收取5%的税金'
	  }
	};
	
	var CheckoutModal = function (_React$Component) {
	  _inherits(CheckoutModal, _React$Component);
	
	  function CheckoutModal(props) {
	    _classCallCheck(this, CheckoutModal);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      email: '',
	      class: 'form-control email-input',
	      processingPayment: false
	    };
	
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    _this.onChangeEmail = _this.onChangeEmail.bind(_this);
	    return _this;
	  }
	
	  CheckoutModal.prototype.onChangeEmail = function onChangeEmail(event) {
	    var validation = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    if (validation.test(event.target.value)) {
	      this.setState({ class: 'form-control email-input' });
	    } else {
	      this.setState({ class: 'form-control email-input email-error' });
	    }
	
	    this.state.email = event.target.value;
	    this.setState({ email: this.state.email });
	  };
	
	  CheckoutModal.prototype.onSubmit = function onSubmit(ev) {
	    var _this2 = this;
	
	    var _props = this.props,
	        proceed = _props.proceed,
	        dismissModal = _props.dismiss,
	        cancel = _props.cancel,
	        onSuccess = _props.onSuccess;
	
	
	    ev.preventDefault();
	
	    if (!this.state.email) {
	      this.setState({ class: 'form-control email-input email-error' });
	      ev.preventDefault();
	      return;
	    }
	
	    // We could pass customer to createToken()
	    // let customer = {}
	    this.setState({ processingPayment: true });
	    this.props.stripe.createToken().then(function (payload) {
	      (0, _processPayment2.default)({
	        source: payload.token.id,
	        email: _this2.state.email,
	        plan_codename: PLAN_CODENAME,
	        quantity: 1
	      }).then(function (success) {
	        dismissModal();
	        _alert.alert.success("", __('Your purchase is successful!', 'checkoutform')).then(function () {
	          // instead of closing the whole thing we redirect/refresh the window
	
	          if (typeof onSuccess == 'function') {
	            onSuccess();
	          }
	        });
	      }).catch(function (err) {});
	    }).catch(function () {
	      return;
	    });
	  };
	
	  CheckoutModal.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props2 = this.props,
	        show = _props2.show,
	        proceed = _props2.proceed,
	        dismiss = _props2.dismiss,
	        cancel = _props2.cancel;
	
	
	    var currentLocale = localStorage.getItem('language');
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'checkout-modal',
	
	        hasHeader: true,
	        hasFooter: true,
	        headerTitle: __("Upgrade to Premium", "teacher"),
	        headerIcon: 'fa icon-credit-card',
	        fixedWidth: 500,
	        onCloseModalClick: dismiss,
	
	        footerType: 'grey',
	        footerButtons: [{
	          title: __("Submit Payment", "checkoutform"),
	          className: "btn btn-primary pull-right",
	          isDisabled: function isDisabled() {
	            return _this3.state.processingPayment;
	          },
	          onClick: this.onSubmit
	        }],
	        isShowingModal: show,
	        footerCustomContent: _react2.default.createElement(
	          'div',
	          { className: 'price-on-modal' },
	          PRICE + " / " + __("month per school", locale)
	        )
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'row upgrade-info' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12', style: { marginBottom: '20px' } },
	          _react2.default.createElement(
	            'label',
	            null,
	            __('Email Address', 'checkoutform', null, true)
	          ),
	          _react2.default.createElement('input', { placeholder: 'name@mail.com', className: this.state.class, type: 'email', value: this.state.email, onChange: this.onChangeEmail })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12', style: { marginBottom: '20px' } },
	          _react2.default.createElement(
	            'label',
	            null,
	            __('Credit or Debit Card', 'checkoutform', null, true)
	          ),
	          _react2.default.createElement(_reactStripeElements.CardElement, { className: 'stripe-cardnumber', style: cardElementStyle })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 secure-msg' },
	          __('Note: 5% tax will be applied on every transaction', locale)
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'col-md-12 secure-msg' },
	          __('All payments are processed through Stripe. The connection is secure and encrypted. We do not collect any of your information.', locale),
	          _react2.default.createElement(
	            'a',
	            { target: '__blank', href: '/privacy-' + currentLocale.toLowerCase() },
	            __('Privacy Policy', locale)
	          )
	        )
	      )
	    );
	  };
	
	  return CheckoutModal;
	}(_react2.default.Component);
	
	exports.default = (0, _reactStripeElements.injectStripe)(CheckoutModal);
	module.exports = exports['default'];

/***/ },

/***/ "o8ZW":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = processPayment;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	var _savePaymentMethod = __webpack_require__("K8mP");
	
	var _savePaymentMethod2 = _interopRequireDefault(_savePaymentMethod);
	
	var _addSubscription = __webpack_require__("g9St");
	
	var _addSubscription2 = _interopRequireDefault(_addSubscription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	// NOTE:
	// This is a chained controller with 2 controllers in a row. The backend
	// MUST take care of 2 consecutive processes like this...
	// but for now, we just cope with what we have...
	//
	function processPayment(_ref) {
	  var source = _ref.source,
	      email = _ref.email,
	      plan_codename = _ref.plan_codename,
	      quantity = _ref.quantity;
	
	  return new Promise(function (resolve, reject) {
	    (0, _savePaymentMethod2.default)({ source: source, email: email }).then(function (success) {
	      (0, _addSubscription2.default)({ plan_codename: plan_codename, quantity: quantity }).then(function (res) {
	        resolve(res);
	      }).catch(function (err) {
	        reject(err);
	      });
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "K8mP":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = savePaymentMethod;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
		source: _joiBrowser2.default.string().required(),
		email: _joiBrowser2.default.string().required()
	});
	
	function savePaymentMethod(paymentMethod) {
		var validateResult = _joiBrowser2.default.validate(paymentMethod, schema);
	
		if (validateResult.error) {
			return new Promise(function (resolve, reject) {
				reject(validateResult);
			});
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/payment_method/',
				'method': 'POST',
				'data': JSON.stringify(paymentMethod),
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res.data.result == "success", res);
			}).catch(function (err) {
				reject(err);
			});
		});
	}

/***/ },

/***/ "Ue+K":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"checkout-modal":"checkout-modal","stripe-cardnumber":"stripe-cardnumber","email-error":"email-error","price-on-modal":"price-on-modal","secure-msg":"secure-msg"};

/***/ },

/***/ "z/kV":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var STRIPE_API_KEY = exports.STRIPE_API_KEY = 'pk_live_piQTEiigCiB4So9ouc30EHAf'; // June 28, 2018
	var INDICATOR = exports.INDICATOR = 'yes';

/***/ },

/***/ "FG4y":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "logo_blue@2x.4c69a222.png";

/***/ },

/***/ "zrmO":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _alert = __webpack_require__("BGi1");
	
	var _locale = __webpack_require__("XxsS");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("/gsv");
	
	var _UI = __webpack_require__("OM1Z");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var NoPermission = function (_Component) {
	  _inherits(NoPermission, _Component);
	
	  function NoPermission(props) {
	    _classCallCheck(this, NoPermission);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  NoPermission.prototype.render = function render() {
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      { className: 'no-permission-container' },
	      _react2.default.createElement(
	        'span',
	        null,
	        ':('
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        __('Oops!', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        __('You do not have the permission to visit this page, please contact the school principal for permission', _locale2.default)
	      )
	    );
	  };
	
	  return NoPermission;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NoPermission);
	module.exports = exports['default'];

/***/ },

/***/ "XxsS":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'NoPermissionPage',
	  code: 'CN',
	  text: {
	    'Oops!': '啊哦！',
	    'You do not have the permission to visit this page, please contact the school principal for permission': '您没有权限访问此页面，请与学校校长联系以获得权限'
	
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "/gsv":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"no-permission-container":"no-permission-container","locale-EN":"locale-EN"};

/***/ },

/***/ "12fy":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MyStoreCheckout = __webpack_require__("o0wt");
	
	var _MyStoreCheckout2 = _interopRequireDefault(_MyStoreCheckout);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _locale = __webpack_require__("MXDL");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _CreateSchool = __webpack_require__("biI2");
	
	var _CreateSchool2 = _interopRequireDefault(_CreateSchool);
	
	var _StartFreeTrial = __webpack_require__("40HN");
	
	var _StartFreeTrial2 = _interopRequireDefault(_StartFreeTrial);
	
	__webpack_require__("mRfb");
	
	var _user = __webpack_require__("2F2H");
	
	var _schoolDetail = __webpack_require__("8VNP");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	var _subscription = __webpack_require__("ue3W");
	
	var _confirmTeacher = __webpack_require__("7MKa");
	
	var _confirmTeacher2 = _interopRequireDefault(_confirmTeacher);
	
	var _deleteSchool = __webpack_require__("+3nq");
	
	var _deleteSchool2 = _interopRequireDefault(_deleteSchool);
	
	var _startTrial = __webpack_require__("s4Vs");
	
	var _startTrial2 = _interopRequireDefault(_startTrial);
	
	var _getSubscription2 = __webpack_require__("h7zY");
	
	var _getSubscription3 = _interopRequireDefault(_getSubscription2);
	
	var _R = __webpack_require__("nRUD");
	
	var _femaleUserIcon = __webpack_require__("iEF/");
	
	var _femaleUserIcon2 = _interopRequireDefault(_femaleUserIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ChangeSchool />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is ...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @redux
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    gSubscription: state.gSubscription
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    clearSchoolDetail: function clearSchoolDetail() {
	      return dispatch((0, _schoolDetail.clearSchoolDetail)());
	    },
	    fetchUserByToken: function fetchUserByToken() {
	      return dispatch((0, _user.fetchUserByToken)());
	    },
	    getSubscription: function getSubscription() {
	      return dispatch((0, _subscription.getSubscription)());
	    }
	  };
	};
	
	var ChangeSchool = function (_React$Component) {
	  _inherits(ChangeSchool, _React$Component);
	
	  function ChangeSchool(props) {
	    _classCallCheck(this, ChangeSchool);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      manageSchool: false
	    };
	
	    _this.selectSchool = _this.selectSchool.bind(_this);
	    _this.addSchool = _this.addSchool.bind(_this);
	    _this.printSchoolRole = _this.printSchoolRole.bind(_this);
	    _this.toggleManageSchool = _this.toggleManageSchool.bind(_this);
	    _this.acceptInvitation = _this.acceptInvitation.bind(_this);
	    return _this;
	  }
	
	  ChangeSchool.prototype.componentWillMount = function componentWillMount() {
	    localStorage.removeItem('SchoolId');
	    localStorage.removeItem('role');
	    if (global['--subscription-refresher']) {
	      clearInterval(global['--subscription-refresher']);
	    }
	    this.props.clearSchoolDetail();
	    this.props.getSubscription();
	  };
	
	  ChangeSchool.prototype.componentDidMount = function componentDidMount() {
	    //prevent user from hitting the browser back button
	    history.pushState(null, null, location.href);
	    window.onpopstate = function () {
	      history.go(1);
	    };
	  };
	
	  ChangeSchool.prototype.selectSchool = function selectSchool(school) {
	    var _this2 = this;
	
	    return function (e) {
	      if (_this2.state.manageSchool) {
	        e.preventDefault();
	        return;
	      }
	      (0, _getSubscription3.default)(school.school_id).then(function (res) {
	        var _res$data = res.data,
	            is_valid = _res$data.is_valid,
	            maximum_amount = _res$data.maximum_amount,
	            saas_version = _res$data.saas_version;
	
	
	        if (is_valid && maximum_amount.maximum_school !== 0) {
	          localStorage.setItem('schoolId', school.school_id);
	          localStorage.setItem('role', _this2.printSchoolRole(school));
	          window.location.href = '/dashboard';
	        } else if (!is_valid && saas_version === 0) {
	          if (school.role_group[0].name === 'school_owner') {
	            _alert.alert.warning(__('Your free trial is over, please subscribe to one of the plan for further usage, thank you!', _locale2.default)).then(function (res) {
	              _reactRouter.browserHistory.push('/account-settings');
	            });
	            return;
	          } else {
	            _alert.alert.warning(__("This school's free trial is over, please inform the school owner to subscribe one of the plan for further usage, thank you!", _locale2.default));
	            return;
	          }
	        } else {
	          if (school.role_group[0].name === 'school_owner') {
	            _alert.alert.warning(__('Your account is no longer active, please update your payment credit card info for further usage, thank you!', _locale2.default)).then(function (res) {
	              _reactRouter.browserHistory.push('/account-settings');
	            });
	            return;
	          } else {
	            _alert.alert.warning(__("This school's account is no longer active, please contact the school's owner, thank you!", _locale2.default));
	            return;
	          }
	        }
	      });
	    };
	  };
	
	  ChangeSchool.prototype.toggleManageSchool = function toggleManageSchool() {
	    var _props$gSubscription$ = this.props.gSubscription.result,
	        is_valid = _props$gSubscription$.is_valid,
	        maximum_amount = _props$gSubscription$.maximum_amount,
	        saas_version = _props$gSubscription$.saas_version;
	
	
	    if (is_valid && maximum_amount.maximum_school !== 0) {
	      this.setState({
	        manageSchool: this.state.manageSchool !== true
	      });
	    } else if (!is_valid && saas_version === 0) {
	      _alert.alert.warning(__('Your free trial is over, please subscribe to one of the plan for further usage, thank you!', _locale2.default)).then(function (res) {
	        _reactRouter.browserHistory.push('/account-settings');
	      });
	    } else {
	      _alert.alert.warning(__('Your account is no longer active, please update your payment credit card info for further usage, thank you!', _locale2.default)).then(function (res) {
	        _reactRouter.browserHistory.push('/account-settings');
	      });
	    }
	  };
	
	  ChangeSchool.prototype.addSchool = function addSchool() {
	    var _this3 = this;
	
	    var _props = this.props,
	        user = _props.user,
	        gSubscription = _props.gSubscription;
	    var school_owned_amount = user.result.school_owned_amount;
	    var _gSubscription$result = gSubscription.result,
	        is_valid = _gSubscription$result.is_valid,
	        saas_version = _gSubscription$result.saas_version,
	        maximum_amount = _gSubscription$result.maximum_amount;
	    var maximum_school = maximum_amount.maximum_school;
	
	
	    if (!is_valid && !(0, _R.isOnlyTeacher)()) {
	      if (saas_version === 0) {
	        _alert.alert.warning(__('Your free trial is over, please subscribe to one of the plan for further usage, thank you!', _locale2.default)).then(function (res) {
	          _reactRouter.browserHistory.push('/account-settings');
	        });
	      } else {
	        _alert.alert.warning(__('Your account is no longer active, please update your payment credit card info for further usage, thank you!', _locale2.default)).then(function (res) {
	          _reactRouter.browserHistory.push('/account-settings');
	        });
	      }
	    } else if (!is_valid && saas_version === 0 && school_owned_amount === 0 && (0, _R.isOnlyTeacher)()) {
	      (0, _StartFreeTrial2.default)().then(function () {
	        (0, _startTrial2.default)().then(function (res) {
	          if (res.result === 'success') {
	            _this3.props.fetchUserByToken();
	            _this3.props.getSubscription();
	            _this3.createSchool();
	          } else {
	            _alert.alert.warning(__('You have used the free trial', _locale2.default));
	          }
	        });
	      });
	    } else if (saas_version === 1 || school_owned_amount < maximum_school) {
	      return this.createSchool();
	    } else {
	      _alert.alert.message(__('You are about go over the school limit, please upgrade to higher subscription plan to add more schools', 'header'), __('Upgrade Subscription Plan', 'header'));
	    }
	  };
	
	  ChangeSchool.prototype.createSchool = function createSchool() {
	    var _this4 = this;
	
	    (0, _CreateSchool2.default)().then(function (res) {
	      if (res && res.schoolCreated) {
	        _this4.props.fetchUserByToken();
	        _this4.props.getSubscription();
	      }
	    }).catch(function (error) {
	      console.error(error);
	    });
	  };
	
	  ChangeSchool.prototype.removeSchool = function removeSchool(school) {
	    var _this5 = this;
	
	    return function (e) {
	      (0, _confirm.confirm)(__('Are you sure you want to delete school? This process cannot be undone.', _locale2.default), __('', _locale2.default)).then(function () {
	        (0, _deleteSchool2.default)(school.school_id).then(function (res) {
	          _this5.props.fetchUserByToken();
	          _this5.props.getSubscription();
	        }).catch(function (err) {
	          console.error(err);
	        });
	      }).catch();
	    };
	  };
	
	  ChangeSchool.prototype.printSchoolRole = function printSchoolRole(school) {
	    var _school$role_group = school.role_group,
	        role_group = _school$role_group === undefined ? [] : _school$role_group;
	
	
	    if (role_group.length > 0 && role_group[0]) {
	      if (role_group[0].name == 'school_owner') {
	        return __('Principal', _locale2.default);
	      } else {
	        return __('Teacher', _locale2.default);
	      }
	    }
	  };
	
	  ChangeSchool.prototype.acceptInvitation = function acceptInvitation(school) {
	    var _this6 = this;
	
	    return function () {
	      _this6.setState({
	        confirming: true
	      });
	
	      (0, _confirm.confirm)(__('Proceed to accept the invitation?', _locale2.default), __('Accept', _locale2.default)).then(function () {
	        (0, _confirmTeacher2.default)(school.school_teacher_id, { confirm_or_not: 'confirmed' }).then(function (res) {
	          _this6.props.fetchUserByToken();
	          _this6.props.getSubscription();
	        }).catch(function (err) {
	          _this6.setState({
	            confirming: true
	          });
	        });
	      }).catch(function () {
	        _this6.setState({ confirming: false });
	      });
	    };
	  };
	
	  ChangeSchool.prototype.declineInvitation = function declineInvitation(school) {
	    var _this7 = this;
	
	    return function () {
	      _this7.setState({
	        confirming: true
	      });
	
	      (0, _confirm.confirm)(__('Proceed to decline the invitation?', _locale2.default), __('Decline', _locale2.default)).then(function () {
	        (0, _confirmTeacher2.default)(school.school_teacher_id, { confirm_or_not: 'declined' }).then(function (res) {
	          _this7.props.fetchUserByToken();
	          _this7.props.getSubscription();
	        }).catch(function (err) {
	          _this7.setState({
	            confirming: true
	          });
	        });
	      }).catch(function () {
	        _this7.setState({ confirming: false });
	      });
	    };
	  };
	
	  ChangeSchool.prototype.render = function render() {
	    var _this8 = this;
	
	    var _props2 = this.props,
	        user = _props2.user,
	        gSubscription = _props2.gSubscription;
	    var saas_version = gSubscription.result.saas_version;
	    var _user$result = user.result,
	        _user$result$school_l = _user$result.school_list,
	        school_list = _user$result$school_l === undefined ? [] : _user$result$school_l,
	        _user$result$teacher_ = _user$result.teacher_to_be_confirmed,
	        teacher_to_be_confirmed = _user$result$teacher_ === undefined ? [] : _user$result$teacher_,
	        school_owned_amount = _user$result.school_owned_amount;
	    var _state = this.state,
	        manageSchool = _state.manageSchool,
	        confirming = _state.confirming;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'ChangeSchool' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        __('My Schools', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'ChangeSchool--list' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'SchoolList' },
	          teacher_to_be_confirmed.map(function (school, key) {
	            return _react2.default.createElement(
	              'li',
	              { key: key },
	              _react2.default.createElement(
	                'div',
	                { className: 'SchoolList--item SchoolList--item__toConfirm' },
	                _react2.default.createElement('img', { src: school.school_logo_thumbnail_1x || _femaleUserIcon2.default, className: 'SchoolList--item--logo' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'SchoolList--item--name' },
	                  school.school_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'SchoolList--item--role' },
	                  __('Teacher', _locale2.default)
	                ),
	                confirming !== true && _react2.default.createElement(
	                  'div',
	                  { className: 'SchoolList--item--confirm' },
	                  _react2.default.createElement(
	                    'a',
	                    { className: 'btn btn-default', onClick: _this8.declineInvitation(school) },
	                    __('Decline', _locale2.default)
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    { className: 'btn btn-primary btn-success', onClick: _this8.acceptInvitation(school) },
	                    __('Accept', _locale2.default)
	                  )
	                )
	              )
	            );
	          }),
	          school_list.map(function (school, key) {
	            var userCanDeleteSchool = manageSchool === true && school.role_group && school.role_group[0] && school.role_group[0].name == 'school_owner';
	
	            return _react2.default.createElement(
	              'li',
	              { key: key, onClick: _this8.selectSchool(school) },
	              _react2.default.createElement(
	                'div',
	                { className: 'SchoolList--item' },
	                _react2.default.createElement('img', { src: school.school_logo || _femaleUserIcon2.default, className: 'SchoolList--item--logo' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'SchoolList--item--name' },
	                  school.school_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'SchoolList--item--role' },
	                  _this8.printSchoolRole(school)
	                ),
	                userCanDeleteSchool && _react2.default.createElement(
	                  'a',
	                  { className: 'SchoolList--item--remove', onClick: _this8.removeSchool(school) },
	                  _react2.default.createElement('i', { className: 'fa icon-trash' }),
	                  ' ',
	                  __('Delete', _locale2.default)
	                )
	              )
	            );
	          }),
	          manageSchool !== true && _react2.default.createElement(
	            'li',
	            { className: 'SchoolList--create', onClick: this.addSchool },
	            _react2.default.createElement(
	              'div',
	              { className: 'SchoolList--create--plus' },
	              _react2.default.createElement('i', { className: 'fa icon-plus' })
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              __('Create New School', _locale2.default)
	            ),
	            saas_version === 1 && school_owned_amount >= 1 && _react2.default.createElement(
	              'span',
	              { className: 'SchoolList--create--price' },
	              __('$79 USD / month per school', _locale2.default)
	            )
	          )
	        )
	      ),
	      school_owned_amount > 0 && _react2.default.createElement(
	        'section',
	        { className: 'ChangeSchool--manage' },
	        _react2.default.createElement(
	          'a',
	          { className: 'btn-link', onClick: this.toggleManageSchool },
	          manageSchool !== true && __('Delete School', _locale2.default),
	          manageSchool == true && __('Confirm', _locale2.default)
	        )
	      )
	    );
	  };
	
	  return ChangeSchool;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChangeSchool);
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "MXDL":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'ChangeSchool',
	  code: 'CN',
	  text: {
	    'My Schools': '我的学校',
	    'Principal': '校长',
	    "Teacher": '老师',
	    'Create New School': '创建新学校',
	    '$79 USD / month per school': '每学校每个月 $79 USD',
	    "Delete School": '删除学校',
	    'Confirm': '确认',
	    'Decline': '拒绝',
	    'Accept': '接受',
	    'Proceed to delete school?': '确认删除学校？',
	    'Proceed to decline the invitation?': '确认拒绝邀请吗？',
	    'Proceed to accept the invitation?': '确认接受邀请吗？',
	    'Delete': '删除',
	    'Are you sure you want to delete school? This process cannot be undone.': '您确认要删除学校吗？这个操作无法撤回。',
	    'You are about go over the school limit, please upgrade to higher subscription plan to add more schools': '您已超出现计划包含的学校上限，请先升级至更高计划再创建更多学校。',
	    'Upgrade Subscription Plan': '需要升级计划',
	    'Your free trial is over, please subscribe to one of the plan for further usage, thank you!': '您的试用期已结束, 请订阅我们的服务计划后继续使用, 谢谢!',
	    "This school's free trial is over, please inform the school owner to subscribe one of the plan for further usage, thank you!": '此学校的试用期已结束, 请通知学校校长订阅服务计划后继续使用, 谢谢!',
	    "Your account is no longer active, please update your payment credit card info for further usage, thank you!": '您的订阅服务已到期, 请更新您的付款信用卡信息后继续使用, 谢谢!',
	    "This school's account is no longer active, please contact the school's owner, thank you!": '此学校的订阅服务已到期, 请联系学校校长, 谢谢!',
	    'You have used the free trial': '您已经使用过体验版'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "40HN":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("kNML");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "kNML":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	__webpack_require__("YrYI");
	
	var _ModalContent = __webpack_require__("uvkY");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'start-free-trial-modal',
	        hasHeader: true
	        // hasFooter={true}
	
	        , headerTitle: __("Create Your School", "planDetails"),
	        headerIcon: 'fa icon-bank',
	        fixedWidth: 743,
	        contentHeight: 490,
	        onCloseModalClick: dismiss,
	
	        footerType: 'grey',
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, {
	        onFormChange: function onFormChange() {
	          return proceed();
	        }
	      })
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "YrYI":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"start-free-trial-modal":"start-free-trial-modal","classtop-modal-content":"classtop-modal-content","trail-section":"trail-section","section-title":"section-title","feature-title":"feature-title","check-icon":"check-icon","close-icon":"close-icon","section-description":"section-description","included-features":"included-features","btn-start-trial":"btn-start-trial"};

/***/ },

/***/ "uvkY":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("YrYI");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	//;
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent() {
	    _classCallCheck(this, ModalContent);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalContent.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'custom-modal-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container-fluid' },
	        _react2.default.createElement(
	          'div',
	          { className: 'trail-section' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section-title' },
	            __('Create your school by starting your 14 days free trail now!', 'planDetails')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section-description' },
	            _react2.default.createElement(
	              'div',
	              { className: 'included-features' },
	              _react2.default.createElement(
	                'div',
	                { className: 'feature-title' },
	                __('Features that are included in free trial', 'planDetails'),
	                ':'
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('i', { className: 'fa icon-ok check-icon' }),
	                  __('All basic plan features', 'planDetails')
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('i', { className: 'fa icon-ok check-icon' }),
	                  __('{amount} Registered Students', 'planDetails', { amount: 80 })
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('i', { className: 'fa icon-ok check-icon' }),
	                  __('{amount} Registered Teachers', 'planDetails', { amount: 40 })
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('i', { className: 'fa icon-ok check-icon' }),
	                  __('{amount} Campus', 'planDetails', { amount: 1 })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'excluded-features' },
	              _react2.default.createElement(
	                'div',
	                { className: 'feature-title' },
	                __('Features that are NOT included', 'planDetails'),
	                ':'
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('i', { className: 'fa icon-cancel close-icon' }),
	                  __('No Posters', 'planDetails')
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('i', { className: 'fa icon-cancel close-icon' }),
	                  __('No Contacts', 'planDetails')
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('i', { className: 'fa icon-cancel close-icon' }),
	                  __('No Smart Check-in', 'planDetails')
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('i', { className: 'fa icon-cancel close-icon' }),
	                  __('No Recent Activity Logs', 'planDetails')
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary btn-start-trial', onClick: this.props.onFormChange },
	            __('Start My Trial', 'planDetails')
	          )
	        )
	      )
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "mRfb":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ChangeSchool":"ChangeSchool","ChangeSchool--manage":"ChangeSchool--manage","SchoolList":"SchoolList","SchoolList--item":"SchoolList--item","SchoolList--create":"SchoolList--create","SchoolList--item--confirm":"SchoolList--item--confirm","SchoolList--item--logo":"SchoolList--item--logo","SchoolList--item--name":"SchoolList--item--name","SchoolList--item--role":"SchoolList--item--role","SchoolList--item--remove":"SchoolList--item--remove","SchoolList--create--plus":"SchoolList--create--plus","SchoolList--create--price":"SchoolList--create--price"};

/***/ },

/***/ "lOrV":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _reactToggleSwitch = __webpack_require__("VkEr");
	
	var _reactToggleSwitch2 = _interopRequireDefault(_reactToggleSwitch);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _validator = __webpack_require__("+b6B");
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _sendUsernameVerification = __webpack_require__("/jes");
	
	var _sendUsernameVerification2 = _interopRequireDefault(_sendUsernameVerification);
	
	var _getPaymentMethod = __webpack_require__("Ml0e");
	
	var _getPaymentMethod2 = _interopRequireDefault(_getPaymentMethod);
	
	var _checkSubscription = __webpack_require__("qjg1");
	
	var _checkSubscription2 = _interopRequireDefault(_checkSubscription);
	
	var _changePhone = __webpack_require__("Atig");
	
	var _changePhone2 = _interopRequireDefault(_changePhone);
	
	var _changeEmail = __webpack_require__("ORkM");
	
	var _changeEmail2 = _interopRequireDefault(_changeEmail);
	
	var _changePassword = __webpack_require__("Dt/w");
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	var _getUserInfo = __webpack_require__("T8PI");
	
	var _getUserInfo2 = _interopRequireDefault(_getUserInfo);
	
	var _schoolDetail = __webpack_require__("8VNP");
	
	var _alert = __webpack_require__("BGi1");
	
	var _PhoneNumber = __webpack_require__("GM/A");
	
	var _PhoneNumber2 = _interopRequireDefault(_PhoneNumber);
	
	var _planSubscriptionCard = __webpack_require__("6yGS");
	
	var _planSubscriptionCard2 = _interopRequireDefault(_planSubscriptionCard);
	
	var _SubscriptionPayment = __webpack_require__("C8Wz");
	
	var _SubscriptionPayment2 = _interopRequireDefault(_SubscriptionPayment);
	
	var _stripePayment = __webpack_require__("MElV");
	
	var _stripePayment2 = _interopRequireDefault(_stripePayment);
	
	var _subscription = __webpack_require__("ue3W");
	
	var _user = __webpack_require__("2F2H");
	
	var _constants = __webpack_require__("K30H");
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _isEmpty = __webpack_require__("lHK6");
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _R = __webpack_require__("nRUD");
	
	__webpack_require__("rUyQ");
	
	var _locale = __webpack_require__("LFx6");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_COUNTRY_CODE = '1';
	var DEFAULT_REGION_CODE = 'CA';
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    subscription: state.gSubscription
	  };
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getSubscription: function getSubscription() {
	      return dispatch((0, _subscription.getSubscription)());
	    },
	    fetchUserByToken: function fetchUserByToken() {
	      return dispatch((0, _user.fetchUserByToken)());
	    },
	    clearSchoolDetail: function clearSchoolDetail() {
	      return dispatch((0, _schoolDetail.clearSchoolDetail)());
	    }
	  };
	};
	
	var AccountSettings = function (_Component) {
	  _inherits(AccountSettings, _Component);
	
	  function AccountSettings(props) {
	    _classCallCheck(this, AccountSettings);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      userInfo: {},
	      pin: '',
	      newEmail: '',
	      password: '',
	      resend: false,
	      counterTime: 59,
	      selectedIndex: 0,
	      selectedBillCycle: 'yearly',
	      showUpdateCard: false,
	      currentPaymentMethod: {},
	      plansCanBeSubscribed: [],
	      currentPlanInfo: {},
	      changePhoneNumber: false,
	      changeEmail: false,
	      changePassword: false,
	      showOldPassword: false,
	      showNewPassword: false,
	      oldPassword: '',
	      newPassword: '',
	      newPhoneNumber: { country_code: DEFAULT_COUNTRY_CODE, national_number: '', region_code: DEFAULT_REGION_CODE },
	      isProcessingPhone: false,
	      isProcessingEmail: false,
	      isProcessingPassword: false,
	      isProcessingCard: false,
	      plans: [{
	        version: 'Basic',
	        monthlyPrice: '30',
	        monthlyPlanCodename: 'basic_30usd_monthly',
	        yearlyPrice: '27',
	        yearlyPlanCodename: 'basic_324usd_yearly',
	        studentAmount: 80,
	        teacherAmount: 40,
	        schoolAmount: 1,
	        saasVersionMonthly: 3,
	        saasVersionYearly: 4
	      }, {
	        version: 'Professional',
	        monthlyPrice: '180',
	        monthlyPlanCodename: 'professional_180usd_monthly',
	        yearlyPrice: '162',
	        yearlyPlanCodename: 'professional_1944usd_yearly',
	        studentAmount: 500,
	        teacherAmount: 'unlimited',
	        schoolAmount: 5,
	        saasVersionMonthly: 5,
	        saasVersionYearly: 6
	      }, {
	        version: 'Premium',
	        monthlyPrice: '360',
	        monthlyPlanCodename: 'premium_360usd_monthly',
	        yearlyPrice: '324',
	        yearlyPlanCodename: 'premium_3888usd_yearly',
	        studentAmount: 1500,
	        teacherAmount: 'unlimited',
	        schoolAmount: 5,
	        saasVersionMonthly: 7,
	        saasVersionYearly: 8
	      }],
	      oldVersionPlan: {
	        version: 'Discount Plan',
	        monthlyPrice: '79',
	        monthlyPlanCodename: 'regular_usd_monthly',
	        yearlyPrice: '79',
	        yearlyPlanCodename: 'regular_usd_monthly',
	        studentAmount: 'unlimited',
	        teacherAmount: 'unlimited',
	        schoolAmount: 1,
	        additionalMsg: __('Additional campus costs $79 per month', _locale2.default)
	      }
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onSelectTab = _this.onSelectTab.bind(_this);
	    _this.onPlanChanged = _this.onPlanChanged.bind(_this);
	    _this.toggleSwitch = _this.toggleSwitch.bind(_this);
	    _this.onPaymentMethodChanged = _this.onPaymentMethodChanged.bind(_this);
	    _this.changeUserPhone = _this.changeUserPhone.bind(_this);
	    _this.changeUserEmail = _this.changeUserEmail.bind(_this);
	    _this.sendVerificationCode = _this.sendVerificationCode.bind(_this);
	    _this.changeUserPassword = _this.changeUserPassword.bind(_this);
	    return _this;
	  }
	
	  AccountSettings.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    localStorage.removeItem('SchoolId');
	    localStorage.removeItem('role');
	    this.props.clearSchoolDetail();
	    this.props.getSubscription();
	    (0, _getUserInfo2.default)().then(function (res) {
	      if (res) {
	        _this2.setState({ userInfo: res });
	      }
	    });
	    (0, _getPaymentMethod2.default)().then(function (res) {
	      if (res.result && res.result === 'no payment method') {
	        _this2.setState({ currentPaymentMethod: {} });
	      } else {
	        _this2.setState({ currentPaymentMethod: res[0] });
	      }
	    });
	    (0, _checkSubscription2.default)().then(function (res) {
	      _this2.setState({ plansCanBeSubscribed: res.plans_can_be_subscribed });
	    });
	  };
	
	  AccountSettings.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.subscription.result !== this.props.subscription.result) {
	      var currentVersion = _constants.SAAS_VERSIONS[nextProps.subscription.result.saas_version];
	      if (currentVersion.billCycle) {
	        this.setState({ selectedBillCycle: currentVersion.billCycle });
	      }
	      if (currentVersion.planCodename) {
	        this.setState({ currentVersionName: currentVersion.planCodename });
	      }
	      this.setState({ currentPlanInfo: currentVersion });
	    }
	  };
	
	  AccountSettings.prototype.onChange = function onChange(name) {
	    var _this3 = this;
	
	    return function (e) {
	      var _this3$setState;
	
	      _this3.setState((_this3$setState = {}, _this3$setState[name] = e.target.value, _this3$setState));
	    };
	  };
	
	  AccountSettings.prototype.changeUserPhone = function changeUserPhone() {
	    var _this4 = this;
	
	    var _state = this.state,
	        newPhoneNumber = _state.newPhoneNumber,
	        pin = _state.pin;
	    var fetchUserByToken = this.props.fetchUserByToken;
	
	    var phoneNumber = newPhoneNumber.country_code + newPhoneNumber.national_number;
	    _alert.alert.warning(__('Are you sure to change the username?', _locale2.default)).then(function (res) {
	      _this4.setState({ isProcessingPhone: true });
	      (0, _changePhone2.default)({
	        phone: phoneNumber,
	        code: pin
	      }).then(function (res) {
	        _this4.setState({ isProcessingPhone: false });
	        if (res.result === 'success') {
	          _alert.alert.success(__('Account username has been changed successfully!', _locale2.default));
	          localStorage.setItem('token', res.new_token);
	          fetchUserByToken();
	          _this4.setState({
	            changePhoneNumber: false,
	            newPhoneNumber: { country_code: DEFAULT_COUNTRY_CODE, national_number: '', region_code: DEFAULT_REGION_CODE },
	            pin: ''
	          });
	        } else {
	          var errorMsg = '';
	          if (res.reason === 'phone number has been used.') {
	            errorMsg = __('This phone number has been used!', _locale2.default);
	          } else {
	            errorMsg = __('Invalid pin!', _locale2.default);
	          }
	          _alert.alert.fail(errorMsg, __('Failed to changed account username!', _locale2.default));
	        }
	      }).catch(function (err) {
	        _this4.setState({ isProcessingPhone: false });
	      });
	    });
	  };
	
	  AccountSettings.prototype.changeUserPassword = function changeUserPassword() {
	    var _this5 = this;
	
	    var _state2 = this.state,
	        oldPassword = _state2.oldPassword,
	        newPassword = _state2.newPassword;
	
	    _alert.alert.warning(__('Are you sure to change the password?', _locale2.default)).then(function (res) {
	      _this5.setState({ isProcessingPassword: true });
	      (0, _changePassword2.default)({
	        old_password: oldPassword,
	        new_password: newPassword,
	        confirm_password: newPassword
	      }).then(function (res) {
	        _this5.setState({ isProcessingPassword: false });
	        if (res.result === 'success') {
	          _alert.alert.success(__('Account password has been changed successfully!', _locale2.default));
	          _this5.setState({ changePassword: false, oldPassword: '', newPassword: '', showOldPassword: false, showNewPassword: false });
	        } else {
	          var errorMsg = '';
	          switch (res.reason) {
	            case 'old password is wrong':
	              errorMsg = __('Invalid current password', _locale2.default);
	              break;
	            case 'new password is too short':
	              errorMsg = __('New password is too short', _locale2.default);
	              break;
	            case 'new password is the same as old one':
	              errorMsg = __('New password can not be the same as the current passowrd', _locale2.default);
	              break;
	            case 'new password is the same as username':
	              errorMsg = __('New password can not be the same as the username', _locale2.default);
	              break;
	            default:
	              return;
	          }
	          _alert.alert.fail(errorMsg, __('Failed to change password!', _locale2.default));
	        }
	      }).catch(function (err) {
	        _this5.setState({ isProcessingPassword: false });
	      });
	    });
	  };
	
	  AccountSettings.prototype.onSelectTab = function onSelectTab(selectedIndex) {
	    this.setState({ selectedIndex: selectedIndex });
	  };
	
	  AccountSettings.prototype.onPlanChanged = function onPlanChanged(planCodename, saasVersion) {
	    var _this6 = this;
	
	    var saas_version = this.props.subscription.result.saas_version;
	    var _state3 = this.state,
	        plansCanBeSubscribed = _state3.plansCanBeSubscribed,
	        currentPaymentMethod = _state3.currentPaymentMethod;
	
	    var selectedPlanInfo = _constants.SAAS_VERSIONS[saasVersion];
	    if (plansCanBeSubscribed && plansCanBeSubscribed.includes(planCodename)) {
	      (0, _SubscriptionPayment2.default)({ currentPaymentMethod: currentPaymentMethod, selectedPlanInfo: selectedPlanInfo, saasVersion: saas_version }).then(function (res) {
	        _this6.props.getSubscription();
	        (0, _getPaymentMethod2.default)().then(function (res) {
	          if (res && res.length > 0) {
	            _this6.setState({ currentPaymentMethod: res[0] });
	          }
	        });
	        (0, _checkSubscription2.default)().then(function (res) {
	          _this6.setState({ plansCanBeSubscribed: res.plans_can_be_subscribed });
	        });
	      });
	    } else {
	      _alert.alert.warning(__('You are unable to subscribe to this plan. If you would like to change, please contact our support team.', _locale2.default));
	    }
	  };
	
	  AccountSettings.prototype.toggleSwitch = function toggleSwitch() {
	    var selectedBillCycle = this.state.selectedBillCycle;
	
	    if (selectedBillCycle === 'yearly') {
	      this.setState({ selectedBillCycle: 'monthly' });
	    } else {
	      this.setState({ selectedBillCycle: 'yearly' });
	    }
	  };
	
	  AccountSettings.prototype.setVerificationCounter = function setVerificationCounter() {
	    var _this7 = this;
	
	    this.setState({ resend: true });
	    this.timmer = setInterval(function () {
	      if (_this7.state.counterTime > 0) {
	        _this7.setState({ counterTime: _this7.state.counterTime - 1 });
	      } else {
	        _this7.setState({ resend: false, counterTime: 59 });
	        _this7.clearCounter();
	      }
	    }, 1000);
	  };
	
	  AccountSettings.prototype.clearCounter = function clearCounter() {
	    clearInterval(this.timmer);
	  };
	
	  AccountSettings.prototype.changeUserEmail = function changeUserEmail() {
	    var _this8 = this;
	
	    var newEmail = this.state.newEmail;
	
	
	    _alert.alert.warning(__('Are you sure to change the email?', _locale2.default)).then(function (res) {
	      _this8.setState({ isProcessingEmail: true });
	      (0, _changeEmail2.default)({ email: newEmail }).then(function (res) {
	        _this8.setState({ isProcessingEmail: false });
	        if (res.result === 'success') {
	          _alert.alert.success(__('Email has been changed successfully!', _locale2.default));
	          (0, _getUserInfo2.default)().then(function (res) {
	            if (res) {
	              _this8.setState({ changeEmail: false, userInfo: res, newEmail: '' });
	            }
	          });
	        } else {
	          _alert.alert.fail(__('This email has been used!', _locale2.default), __('Failed to change email!', _locale2.default));
	        }
	      }).catch(function (err) {
	        _this8.setState({ isProcessingEmail: false });
	      });
	    });
	  };
	
	  AccountSettings.prototype.onPaymentMethodChanged = function onPaymentMethodChanged() {
	    var _this9 = this;
	
	    var showUpdateCard = this.state.showUpdateCard;
	
	    _alert.alert.success(__('Credit card info has been updated successfully!', _locale2.default));
	    (0, _getPaymentMethod2.default)().then(function (res) {
	      if (res && res.length > 0) {
	        _this9.setState({ currentPaymentMethod: res[0] });
	      }
	      _this9.setState({ showUpdateCard: !showUpdateCard });
	    });
	  };
	
	  AccountSettings.prototype.sendVerificationCode = function sendVerificationCode() {
	    var _this10 = this;
	
	    var newPhoneNumber = this.state.newPhoneNumber;
	
	
	    (0, _sendUsernameVerification2.default)({
	      phone: newPhoneNumber.country_code + newPhoneNumber.national_number,
	      check_phone: 'sendIfUserNotExist'
	    }).then(function (res) {
	      if (res.result === 'success') {
	        _this10.setVerificationCounter();
	      } else {
	        _alert.alert.fail(__('Phone number is invalid or has been used', _locale2.default), __('Failed to send verification code!', _locale2.default));
	      }
	    });
	  };
	
	  AccountSettings.prototype.renderChangePhone = function renderChangePhone() {
	    var _this11 = this;
	
	    var _state4 = this.state,
	        changePhoneNumber = _state4.changePhoneNumber,
	        newPhoneNumber = _state4.newPhoneNumber,
	        resend = _state4.resend,
	        counterTime = _state4.counterTime,
	        pin = _state4.pin,
	        isProcessingPhone = _state4.isProcessingPhone;
	    var username = this.props.user.result.username;
	
	    var phoneNumber = newPhoneNumber.country_code + newPhoneNumber.national_number;
	    return _react2.default.createElement(
	      'div',
	      { className: 'phone-setting' },
	      isProcessingPhone && _react2.default.createElement(
	        'div',
	        { className: 'loading-wrapper' },
	        _react2.default.createElement(_Loading2.default, null)
	      ),
	      !changePhoneNumber && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          __('Phone Number', _locale2.default)
	        ),
	        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: username, disabled: true }),
	        _react2.default.createElement(
	          'div',
	          { className: 'change-btn', onClick: function onClick() {
	              return _this11.setState({ changePhoneNumber: true });
	            } },
	          __('Update Phone Number', _locale2.default)
	        )
	      ),
	      changePhoneNumber && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            __('Enter New Phone Number', _locale2.default)
	          ),
	          _react2.default.createElement(_PhoneNumber2.default, { defaultCountry: 'ca', value: newPhoneNumber, onChange: function onChange(phone) {
	              _this11.setState({ newPhoneNumber: phone });
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'verification-wrapper' },
	          _react2.default.createElement(
	            'div',
	            null,
	            __('Enter Verification Code', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'verification-code' },
	            _react2.default.createElement('input', { type: 'text', className: 'form-control pin-input', placeholder: __('6 digits', _locale2.default), autoComplete: 'off', value: pin, onChange: function onChange(e) {
	                return _this11.setState({ pin: e.target.value });
	              } }),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-no-margin', onClick: this.sendVerificationCode, disabled: resend || phoneNumber.length < 6 },
	              !resend ? __("Send Code", 'passwordsettings') : __('Resend in {counterTime} s', 'passwordsettings', { counterTime: counterTime })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary', onClick: this.changeUserPhone, disabled: phoneNumber.length < 6 || pin.length < 6 },
	          __('Update', _locale2.default)
	        )
	      )
	    );
	  };
	
	  AccountSettings.prototype.renderChangeEmail = function renderChangeEmail() {
	    var _this12 = this;
	
	    var _state5 = this.state,
	        changeEmail = _state5.changeEmail,
	        userInfo = _state5.userInfo,
	        newEmail = _state5.newEmail,
	        isProcessingEmail = _state5.isProcessingEmail;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'email-setting' },
	      isProcessingEmail && _react2.default.createElement(
	        'div',
	        { className: 'loading-wrapper' },
	        _react2.default.createElement(_Loading2.default, null)
	      ),
	      !changeEmail && userInfo && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          __('Email', _locale2.default)
	        ),
	        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: userInfo.email, disabled: true }),
	        _react2.default.createElement(
	          'div',
	          { className: 'change-btn', onClick: function onClick() {
	              return _this12.setState({ changeEmail: true });
	            } },
	          __('Update Email', _locale2.default)
	        )
	      ),
	      changeEmail && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          __('Enter New Email', _locale2.default)
	        ),
	        _react2.default.createElement('input', { type: 'text', className: 'form-control', autoComplete: 'off', placeholder: 'eg. name@mail.com', value: newEmail, onChange: function onChange(e) {
	            return _this12.setState({ newEmail: e.target.value });
	          } }),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary', onClick: this.changeUserEmail, disabled: !_validator2.default.isEmail(newEmail.trim()) },
	          __('Update', _locale2.default)
	        )
	      )
	    );
	  };
	
	  AccountSettings.prototype.renderChangePassword = function renderChangePassword() {
	    var _this13 = this;
	
	    var _state6 = this.state,
	        changePassword = _state6.changePassword,
	        showNewPassword = _state6.showNewPassword,
	        showOldPassword = _state6.showOldPassword,
	        oldPassword = _state6.oldPassword,
	        newPassword = _state6.newPassword,
	        isProcessingPassword = _state6.isProcessingPassword;
	
	    var passwordPlaceholder = '11111111';
	    return _react2.default.createElement(
	      'div',
	      { className: 'password-setting' },
	      isProcessingPassword && _react2.default.createElement(
	        'div',
	        { className: 'loading-wrapper' },
	        _react2.default.createElement(_Loading2.default, null)
	      ),
	      !changePassword && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          __('Password', _locale2.default)
	        ),
	        _react2.default.createElement('input', { className: 'form-control', type: 'password', value: passwordPlaceholder, disabled: true }),
	        _react2.default.createElement(
	          'div',
	          { className: 'change-btn', onClick: function onClick() {
	              return _this13.setState({ changePassword: true });
	            } },
	          __('Update Password', _locale2.default)
	        )
	      ),
	      changePassword && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          __('Enter Current Password', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group password' },
	          _react2.default.createElement(
	            'span',
	            { className: 'password-icon' },
	            _react2.default.createElement('i', { className: 'icon-lock' })
	          ),
	          _react2.default.createElement('input', { type: showOldPassword ? 'text' : 'password', autoComplete: 'off', placeholder: __('At least 6 characters', _locale2.default), className: 'form-control', value: oldPassword,
	            onChange: function onChange(e) {
	              _this13.setState({
	                oldPassword: e.target.value
	              });
	            }
	          }),
	          _react2.default.createElement(
	            'span',
	            { className: 'toggle-text', onClick: function onClick() {
	                return _this13.setState({ showOldPassword: !showOldPassword });
	              } },
	            showOldPassword ? 'hide' : 'show'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          __('Enter New Password', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group password' },
	          _react2.default.createElement(
	            'span',
	            { className: 'password-icon' },
	            _react2.default.createElement('i', { className: 'icon-lock' })
	          ),
	          _react2.default.createElement('input', { type: showNewPassword ? 'text' : 'password', autoComplete: 'off', placeholder: __('At least 6 characters', _locale2.default), className: 'form-control', value: newPassword,
	            onChange: function onChange(e) {
	              _this13.setState({
	                newPassword: e.target.value
	              });
	            }
	          }),
	          _react2.default.createElement(
	            'span',
	            { className: 'toggle-text', onClick: function onClick() {
	                return _this13.setState({ showNewPassword: !showNewPassword });
	              } },
	            showNewPassword ? 'hide' : 'show'
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary', onClick: this.changeUserPassword, disabled: newPassword.trim().length < 6 || oldPassword.trim().length < 6 },
	          __('Update', _locale2.default)
	        )
	      )
	    );
	  };
	
	  AccountSettings.prototype.render = function render() {
	    var _this14 = this;
	
	    var _props$subscription$r = this.props.subscription.result,
	        saas_version = _props$subscription$r.saas_version,
	        current_period_end = _props$subscription$r.current_period_end;
	    var _state7 = this.state,
	        oldVersionPlan = _state7.oldVersionPlan,
	        plans = _state7.plans,
	        selectedBillCycle = _state7.selectedBillCycle,
	        showUpdateCard = _state7.showUpdateCard,
	        currentPaymentMethod = _state7.currentPaymentMethod,
	        currentVersionName = _state7.currentVersionName,
	        currentPlanInfo = _state7.currentPlanInfo;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'personal-setting-page' },
	      _react2.default.createElement(
	        'h3',
	        null,
	        __('Account Settings', _locale2.default)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'account-setting' },
	        this.renderChangePhone(),
	        this.renderChangeEmail(),
	        this.renderChangePassword()
	      ),
	      !(0, _isEmpty2.default)(currentPaymentMethod) && _react2.default.createElement(
	        'div',
	        { className: 'active-card-section' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'section-title' },
	          __('Active Card', _locale2.default)
	        ),
	        !showUpdateCard && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'active-card' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-labels' },
	              _react2.default.createElement(
	                'div',
	                null,
	                __('Card number', _locale2.default)
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                __('Expiry date', _locale2.default)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-details' },
	              _react2.default.createElement(
	                'div',
	                null,
	                '**** **** **** ',
	                currentPaymentMethod.last4
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                currentPaymentMethod.exp_month,
	                '/',
	                currentPaymentMethod.exp_year
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary', onClick: function onClick() {
	                return _this14.setState({ showUpdateCard: !showUpdateCard });
	              } },
	            __('Update Card', _locale2.default)
	          )
	        ),
	        showUpdateCard && _react2.default.createElement(_stripePayment2.default, { currentPaymentMethod: currentPaymentMethod, onPaymentMethodChanged: this.onPaymentMethodChanged })
	      ),
	      ((0, _R.isValidUser)() || saas_version === 0) && _react2.default.createElement(
	        'div',
	        { className: 'plans-switch-section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'plans-header' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'section-title' },
	            __('Account Subscription', _locale2.default)
	          ),
	          saas_version !== 1 && _react2.default.createElement(
	            'div',
	            { className: 'switch-wrapper' },
	            _react2.default.createElement(
	              'span',
	              { className: selectedBillCycle === 'monthly' ? 'selected' : '' },
	              __('Monthly', _locale2.default)
	            ),
	            _react2.default.createElement(_reactToggleSwitch2.default, { onClick: this.toggleSwitch, on: selectedBillCycle === 'yearly' }),
	            _react2.default.createElement(
	              'span',
	              { className: selectedBillCycle === 'yearly' ? 'selected' : '' },
	              __('Yearly', _locale2.default)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'plans-wrapper row' },
	          saas_version !== 1 && plans.map(function (plan) {
	            return _react2.default.createElement(_planSubscriptionCard2.default, { key: plan.version, data: plan, billCycle: selectedBillCycle, currentVersionName: currentVersionName, onPlanChanged: _this14.onPlanChanged, className: 'switch' });
	          }),
	          saas_version == 1 && _react2.default.createElement(_planSubscriptionCard2.default, { data: oldVersionPlan, billCycle: 'monthly', currentVersionName: currentVersionName, onPlanChanged: this.onPlanChanged, className: 'switch' })
	        )
	      ),
	      saas_version === 0 && !(0, _R.isOnlyTeacher)() && _react2.default.createElement(
	        'div',
	        { className: 'current-plan' },
	        _react2.default.createElement(
	          'div',
	          { className: 'plan-labels' },
	          _react2.default.createElement(
	            'div',
	            null,
	            __('Plan Name', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            __('Trial End', _locale2.default)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'plan-details' },
	          _react2.default.createElement(
	            'div',
	            null,
	            __(currentPlanInfo.name, 'settings')
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _moment2.default)(current_period_end).format('YYYY-MM-DD')
	          )
	        )
	      ),
	      saas_version !== 0 && !(0, _R.isOnlyTeacher)() && _react2.default.createElement(
	        'div',
	        { className: 'current-plan' },
	        _react2.default.createElement(
	          'div',
	          { className: 'plan-labels' },
	          _react2.default.createElement(
	            'div',
	            null,
	            __('Current Plan', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            __('Price', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            __('Billing Cycle', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            __('Next Billing Date', _locale2.default)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'plan-details' },
	          _react2.default.createElement(
	            'div',
	            null,
	            __(currentPlanInfo.name, 'settings')
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            __('USD', 'settings'),
	            '$',
	            currentPlanInfo.price,
	            __('/month', 'settings')
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            __(currentPlanInfo.billCycle, 'settings')
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _moment2.default)(current_period_end).format('YYYY-MM-DD')
	          )
	        )
	      )
	    );
	  };
	
	  return AccountSettings;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AccountSettings);
	module.exports = exports['default'];

/***/ },

/***/ "/jes":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = sendUsernameVerification;
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _config = __webpack_require__("hxne");
	
	var _apiKeys = __webpack_require__("Z5zl");
	
	var wapiKeys = _interopRequireWildcard(_apiKeys);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wapiKey =  false ? wapiKeys.dev_key : wapiKeys.prod_key;
	var STATUS = ['sendWithoutCheck', 'sendIfUserExist', 'sendIfUserNotExist'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  phone: _joiBrowser2.default.string().required(),
	  check_phone: _joiBrowser2.default.string().valid(STATUS).required()
	});
	
	function sendUsernameVerification(params) {
	  var validateResult = _joiBrowser2.default.validate(params, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	  var query = _queryString2.default.stringify({
	    phone: params.phone,
	    check_phone: STATUS.indexOf(params.check_phone),
	    language: localStorage.getItem('language') === 'CN' ? 'zh' : 'en'
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.WAPIAddress, { 'uri': '/mobile_verification/?' + query,
	      'method': 'GET',
	      'token': localStorage.getItem('token'),
	      'wapiKey': wapiKey
	    }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "Z5zl":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var dev_key = exports.dev_key = "Test-g#A+&xk*Yn4qjTVP29C7cUBSs=5yLQpJ";
	var prod_key = exports.prod_key = "Prod-s7yTIrEthG3!Rd^4KV9&ZukU2J6Wmo*a";

/***/ },

/***/ "Ml0e":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getPaymentMethod;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getPaymentMethod() {
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': "/payment_method/",
				'method': 'GET',
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res.data);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports["default"];

/***/ },

/***/ "qjg1":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = checkSubscription;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function checkSubscription() {
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/change_subscription/',
				'method': 'GET',
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res.data);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports["default"];

/***/ },

/***/ "Atig":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = changePhone;
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _apiKeys = __webpack_require__("Z5zl");
	
	var wapiKeys = _interopRequireWildcard(_apiKeys);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wapiKey =  false ? wapiKeys.dev_key : wapiKeys.prod_key;
	//import { language, apiUrl, wapiKey, request } from '../../controller-config';
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  phone: _joiBrowser2.default.string().required(),
	  code: _joiBrowser2.default.string().required()
	});
	
	function changePhone(opts) {
	  var validateResult = _joiBrowser2.default.validate(opts, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    // request({
	    //   url: `${apiUrl}/wapi/v1/change_mobile/`,
	    //   method: 'PUT',
	    //   data: opts,
	    //   header: {
	    //     'content-type': 'application/json',
	    //     "WAPI-KEY": wapiKey,
	    //     'authorization': 'JWT ' + token
	    //   },
	    //   success(res) {
	    //     resolve(res.data)
	    //   }
	    // })
	
	    _axios2.default.put(_config.WAPIAddress, { 'uri': '/change_mobile/',
	      'method': 'PUT',
	      'data': JSON.stringify(opts),
	      'token': localStorage.getItem('token'),
	      'wapiKey': wapiKey
	    }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "ORkM":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = changeEmail;
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _apiKeys = __webpack_require__("Z5zl");
	
	var wapiKeys = _interopRequireWildcard(_apiKeys);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wapiKey =  false ? wapiKeys.dev_key : wapiKeys.prod_key;
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  email: _joiBrowser2.default.string().required()
	});
	
	function changeEmail(params) {
	  var validateResult = _joiBrowser2.default.validate(params, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.WAPIAddress, { 'uri': '/change_email/',
	      'method': 'PUT',
	      'data': JSON.stringify(params),
	      'token': localStorage.getItem('token'),
	      'wapiKey': wapiKey
	    }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "Dt/w":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = changePassword;
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _apiKeys = __webpack_require__("Z5zl");
	
	var wapiKeys = _interopRequireWildcard(_apiKeys);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wapiKey =  false ? wapiKeys.dev_key : wapiKeys.prod_key;
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  old_password: _joiBrowser2.default.string().required(),
	  new_password: _joiBrowser2.default.string().required(),
	  confirm_password: _joiBrowser2.default.string().required()
	});
	
	function changePassword(params) {
	
	  var validateResult = _joiBrowser2.default.validate(params, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	
	    _axios2.default.put(_config.WAPIAddress, { 'uri': '/change_password/',
	      'method': 'PUT',
	      'data': JSON.stringify(params),
	      'token': localStorage.getItem('token'),
	      'wapiKey': wapiKey
	    }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "T8PI":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getUserInfo;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _apiKeys = __webpack_require__("Z5zl");
	
	var wapiKeys = _interopRequireWildcard(_apiKeys);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wapiKey =  false ? wapiKeys.dev_key : wapiKeys.prod_key;
	
	function getUserInfo() {
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.WAPIAddress, { 'uri': '/user_info/',
	      'method': 'GET',
	      'token': localStorage.getItem('token'),
	      'wapiKey': wapiKey
	    }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "6yGS":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("+93P");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlanSubscriptionCard = function (_Component) {
	  _inherits(PlanSubscriptionCard, _Component);
	
	  function PlanSubscriptionCard(props) {
	    _classCallCheck(this, PlanSubscriptionCard);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  PlanSubscriptionCard.prototype.renderBtn = function renderBtn(planCodename, saasVersion) {
	    var _props = this.props,
	        onPlanChanged = _props.onPlanChanged,
	        currentVersionName = _props.currentVersionName;
	
	
	    if (currentVersionName === planCodename) {
	      return _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary', disabled: true },
	        __('Current Plan', 'settings')
	      );
	    } else {
	      return _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary', onClick: function onClick() {
	            return onPlanChanged(planCodename, saasVersion);
	          } },
	        __('Choose Plan', 'settings')
	      );
	    }
	  };
	
	  PlanSubscriptionCard.prototype.render = function render() {
	    var _props2 = this.props,
	        billCycle = _props2.billCycle,
	        data = _props2.data;
	    var version = data.version,
	        monthlyPrice = data.monthlyPrice,
	        yearlyPrice = data.yearlyPrice,
	        studentAmount = data.studentAmount,
	        teacherAmount = data.teacherAmount,
	        schoolAmount = data.schoolAmount,
	        monthlyPlanCodename = data.monthlyPlanCodename,
	        yearlyPlanCodename = data.yearlyPlanCodename,
	        additionalMsg = data.additionalMsg,
	        saasVersionMonthly = data.saasVersionMonthly,
	        saasVersionYearly = data.saasVersionYearly;
	
	    var imagePath = void 0;
	    if (version === 'Basic') {
	      imagePath = __webpack_require__("NOmL");
	    } else if (version === 'Professional') {
	      imagePath = __webpack_require__("kHdb");
	    } else {
	      imagePath = __webpack_require__("N72A");
	    }
	    var planCodename = billCycle === 'monthly' ? monthlyPlanCodename : yearlyPlanCodename;
	    var saasVersion = billCycle === 'monthly' ? saasVersionMonthly : saasVersionYearly;
	    return _react2.default.createElement(
	      'div',
	      { className: 'plan-wrapper col-md-4' },
	      _react2.default.createElement('div', { className: 'icon-wrapper', style: { backgroundImage: 'url(' + imagePath + ')' } }),
	      _react2.default.createElement(
	        'div',
	        { className: 'plan-title' },
	        __(version, 'settings')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'plan-price' },
	        '$',
	        billCycle === 'monthly' ? monthlyPrice : yearlyPrice,
	        _react2.default.createElement(
	          'span',
	          { className: 'dollar' },
	          __('USD', 'settings')
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'plan-cycle' },
	        billCycle === 'monthly' ? __('per month, billed monthly', 'settings') : __('per month, billed yearly', 'settings')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'plan-detail' },
	        _react2.default.createElement(
	          'div',
	          null,
	          studentAmount === 'unlimited' ? __('Unlimited', 'settings') : studentAmount,
	          ' ',
	          __('Registered Students', 'settings')
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          teacherAmount === 'unlimited' ? __('Unlimited', 'settings') : teacherAmount,
	          ' ',
	          __('Registered Teachers', 'settings')
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          schoolAmount,
	          ' ',
	          __('Campus', 'settings')
	        ),
	        additionalMsg && _react2.default.createElement(
	          'div',
	          { className: 'additional-msg' },
	          additionalMsg
	        )
	      ),
	      this.renderBtn(planCodename, saasVersion)
	    );
	  };
	
	  return PlanSubscriptionCard;
	}(_react.Component);
	
	exports.default = PlanSubscriptionCard;
	module.exports = exports['default'];

/***/ },

/***/ "+93P":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"plan-wrapper":"plan-wrapper","icon-wrapper":"icon-wrapper","school-icon":"school-icon","plan-title":"plan-title","plan-price":"plan-price","plan-cycle":"plan-cycle","plan-detail":"plan-detail","additional-msg":"additional-msg","dollar":"dollar"};

/***/ },

/***/ "NOmL":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "school1.9522981d.png";

/***/ },

/***/ "kHdb":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "school2.57d79452.png";

/***/ },

/***/ "N72A":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "school3.07181ce8.png";

/***/ },

/***/ "C8Wz":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _PaymentModalStripeWrapper = __webpack_require__("+mWt");
	
	var _PaymentModalStripeWrapper2 = _interopRequireDefault(_PaymentModalStripeWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_PaymentModalStripeWrapper2.default);
	
	/**
	opts = {
	  onSuccess: function fired when transaction successful
	}
	*/

	module.exports = exports["default"];

/***/ },

/***/ "+mWt":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStripeElements = __webpack_require__("iEJf");
	
	var _PaymentModal = __webpack_require__("uFCo");
	
	var _PaymentModal2 = _interopRequireDefault(_PaymentModal);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <CheckoutModalStripeWrapper />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Header
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var key = '';
	var indicator = '';
	
	var api_key = '';
	
	if (false) {
	  key = "pk_test_smD2brB7NmCVjHNZcZ8Iu4BD";
	} else {
	  try {
	    api_key = __webpack_require__("z/kV");
	    key = api_key.STRIPE_API_KEY;
	    indicator = api_key.INDICATOR;
	  } catch (e) {
	    alert(e);
	  }
	}
	
	var PaymentModalModalStripeWrapper = function (_React$Component) {
	  _inherits(PaymentModalModalStripeWrapper, _React$Component);
	
	  function PaymentModalModalStripeWrapper(props) {
	    _classCallCheck(this, PaymentModalModalStripeWrapper);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  PaymentModalModalStripeWrapper.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('input', { type: 'hidden', value: indicator }),
	      _react2.default.createElement(
	        _reactStripeElements.StripeProvider,
	        { apiKey: key },
	        _react2.default.createElement(
	          _reactStripeElements.Elements,
	          null,
	          _react2.default.createElement(_PaymentModal2.default, this.props)
	        )
	      )
	    );
	  };
	
	  return PaymentModalModalStripeWrapper;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(PaymentModalModalStripeWrapper);
	module.exports = exports['default'];

/***/ },

/***/ "uFCo":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStripeElements = __webpack_require__("iEJf");
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _addPaymentMethod = __webpack_require__("ZNb7");
	
	var _addPaymentMethod2 = _interopRequireDefault(_addPaymentMethod);
	
	var _deletePaymentMethod = __webpack_require__("bgWI");
	
	var _deletePaymentMethod2 = _interopRequireDefault(_deletePaymentMethod);
	
	var _changeSubscription = __webpack_require__("sshy");
	
	var _changeSubscription2 = _interopRequireDefault(_changeSubscription);
	
	var _addSubscription = __webpack_require__("g9St");
	
	var _addSubscription2 = _interopRequireDefault(_addSubscription);
	
	var _alert = __webpack_require__("BGi1");
	
	var _constants = __webpack_require__("K30H");
	
	__webpack_require__("GQeB");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isEmpty = __webpack_require__("lHK6");
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// This is how you modify the style of CardElement
	// You can't do it with plain CSS
	var cardElementStyle = {
	  base: {
	    iconColor: '#D2D2D2',
	    fontWeight: 300,
	    '::placeholder': {
	      fontWeight: 300,
	      color: '#D2D2D2',
	      fontSize: '12px',
	      lineHeight: '13px'
	    }
	  }
	};
	var locale = {
	  id: 'OrderOverview',
	  code: 'CN',
	  text: {
	    'All payments are processed through Stripe. The connection is secure and encrypted. We do not collect any of your information.': '所有付款都通过 Stripe 处理。付款连接是安全并且加密的。我们不会收集您的任何信息。',
	    'Privacy Policy': '隐私政策',
	    'Note: 5% tax will be applied on every transaction': '提示: 每次付款会额外收取5%的税金'
	  }
	};
	
	var CheckoutModal = function (_React$Component) {
	  _inherits(CheckoutModal, _React$Component);
	
	  function CheckoutModal(props) {
	    _classCallCheck(this, CheckoutModal);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      email: '',
	      class: 'form-control email-input',
	      processingPayment: false,
	      selectedTab: 'monthly',
	      selectedPlanInfo: {}
	    };
	
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    _this.onChangeEmail = _this.onChangeEmail.bind(_this);
	    _this.onTabChange = _this.onTabChange.bind(_this);
	    return _this;
	  }
	
	  CheckoutModal.prototype.componentWillMount = function componentWillMount() {
	    this.setState({ selectedPlanInfo: this.props.selectedPlanInfo, selectedTab: this.props.selectedPlanInfo.billCycle });
	  };
	
	  CheckoutModal.prototype.onChangeEmail = function onChangeEmail(event) {
	    var validation = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    if (validation.test(event.target.value)) {
	      this.setState({ class: 'form-control email-input' });
	    } else {
	      this.setState({ class: 'form-control email-input email-error' });
	    }
	
	    this.state.email = event.target.value;
	    this.setState({ email: this.state.email });
	  };
	
	  CheckoutModal.prototype.onTabChange = function onTabChange() {
	    var _state = this.state,
	        selectedTab = _state.selectedTab,
	        selectedPlanInfo = _state.selectedPlanInfo;
	
	    if (selectedTab === 'monthly') {
	      var yearlyPlan = _constants.SAAS_VERSIONS.find(function (version) {
	        return version.name === selectedPlanInfo.name && version.billCycle === 'yearly';
	      });
	      this.setState({ selectedTab: 'yearly', selectedPlanInfo: yearlyPlan });
	    } else {
	      var monthlyPlan = _constants.SAAS_VERSIONS.find(function (version) {
	        return version.name === selectedPlanInfo.name && version.billCycle === 'monthly';
	      });
	      this.setState({ selectedTab: 'monthly', selectedPlanInfo: monthlyPlan });
	    }
	  };
	
	  CheckoutModal.prototype.onSubmit = function onSubmit(ev) {
	    var _this2 = this;
	
	    var _props = this.props,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel,
	        onSuccess = _props.onSuccess,
	        currentPaymentMethod = _props.currentPaymentMethod,
	        saasVersion = _props.saasVersion;
	    var selectedPlanInfo = this.state.selectedPlanInfo;
	
	    ev.preventDefault();
	
	    if (!this.state.email) {
	      this.setState({ class: 'form-control email-input email-error' });
	      ev.preventDefault();
	      return;
	    }
	
	    // We could pass customer to createToken()
	    // let customer = {}
	    this.setState({ processingPayment: true });
	    this.props.stripe.createToken().then(function (payload) {
	      (0, _addPaymentMethod2.default)({
	        source: payload.token.id,
	        email: _this2.state.email,
	        set_default: 'set_default'
	      }).then(function (res) {
	        if (res.result === 'success') {
	          if (!(0, _isEmpty2.default)(currentPaymentMethod)) {
	            (0, _deletePaymentMethod2.default)(currentPaymentMethod.id).then(function (res) {});
	          }
	          var subscriptionCtrl = saasVersion === 0 ? _addSubscription2.default : _changeSubscription2.default;
	
	          subscriptionCtrl({ plan_codename: selectedPlanInfo.planCodename }).then(function (res) {
	            _this2.setState({ processingPayment: false });
	            if (res.result === 'success') {
	              _alert.alert.success(__('You are on {planName} now!', 'settings', { planName: __(selectedPlanInfo.name, 'settings') }), __('Congratulations!', 'settings')).then(function () {
	                proceed();
	              });
	            } else {
	              _alert.alert.fail(__('Your current account can not be changed to this plan!', 'settings'), __('Failed to change plan!', 'settings')).then(function () {
	                dismiss();
	              });
	            }
	          });
	        } else {
	          return;
	        }
	      });
	    }).catch(function () {
	      _this2.setState({ processingPayment: false });
	      return;
	    });
	  };
	
	  CheckoutModal.prototype.render = function render() {
	    var _props2 = this.props,
	        show = _props2.show,
	        proceed = _props2.proceed,
	        dismiss = _props2.dismiss,
	        cancel = _props2.cancel;
	    var _state2 = this.state,
	        selectedTab = _state2.selectedTab,
	        processingPayment = _state2.processingPayment,
	        selectedPlanInfo = _state2.selectedPlanInfo;
	
	    var currentLocale = localStorage.getItem('language');
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'payment-modal',
	
	        hasHeader: true,
	        hasFooter: true,
	        headerTitle: __("Subscribe to {name}", "settings", { name: __(selectedPlanInfo.name, 'settings') }),
	        headerIcon: 'fa icon-credit-card',
	        fixedWidth: 500,
	        onCloseModalClick: dismiss,
	
	        footerType: 'grey',
	        footerButtons: [{
	          title: __("Pay", "checkoutform"),
	          className: "btn btn-primary pull-right pay-btn",
	          isDisabled: function isDisabled() {
	            return processingPayment;
	          },
	          onClick: this.onSubmit
	        }],
	        loading: processingPayment,
	        isShowingModal: show
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'payment-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'tabs' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tab ' + (selectedTab === 'monthly' ? 'selected' : ''), onClick: this.onTabChange },
	            __('Monthly', 'settings')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab ' + (selectedTab === 'yearly' ? 'selected' : ''), onClick: this.onTabChange },
	            __('Yearly', 'settings')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'payment-info' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              __('Per Month', 'settings')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'info-text' },
	              '$',
	              selectedPlanInfo.price,
	              _react2.default.createElement(
	                'span',
	                { className: 'dollar' },
	                __('USD', 'settings')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              __("Today's total", 'settings')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'info-text' },
	              '$',
	              selectedTab === 'monthly' ? selectedPlanInfo.price : selectedPlanInfo.price * 12,
	              _react2.default.createElement(
	                'span',
	                { className: 'dollar' },
	                __('USD', 'settings')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              __("Next billing date", 'settings')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'info-text' },
	              selectedTab === 'monthly' ? (0, _moment2.default)().add(1, 'M').format('YYYY-MM-DD') : (0, _moment2.default)().add(1, 'Y').format('YYYY-MM-DD')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'email-section' },
	          _react2.default.createElement(
	            'div',
	            null,
	            __('Email Address', 'checkoutform', null, true)
	          ),
	          _react2.default.createElement('input', { placeholder: 'name@mail.com', className: this.state.class, type: 'email', value: this.state.email, onChange: this.onChangeEmail })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-section' },
	          _react2.default.createElement(
	            'div',
	            null,
	            __('Credit Card', 'checkoutform', null, true)
	          ),
	          _react2.default.createElement(_reactStripeElements.CardElement, { className: 'stripe-cardnumber', style: cardElementStyle })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'secure-msg' },
	          __('Note: 5% tax will be applied on every transaction', locale)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'secure-msg' },
	          __('All payments are processed through Stripe. The connection is secure and encrypted. We do not collect any of your information.', locale),
	          _react2.default.createElement(
	            'a',
	            { target: '__blank', href: '/privacy-' + currentLocale.toLowerCase() },
	            __('Privacy Policy', locale)
	          )
	        )
	      )
	    );
	  };
	
	  return CheckoutModal;
	}(_react2.default.Component);
	
	exports.default = (0, _reactStripeElements.injectStripe)(CheckoutModal);
	module.exports = exports['default'];

/***/ },

/***/ "bgWI":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = deletePaymentMethod;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deletePaymentMethod(paymentMethodId) {
	
		if (typeof paymentMethodId == 'undefined') {
			throw new Error('Missing paymentMethodId');
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': "/u_payment_method/" + paymentMethodId + "/",
				'method': 'DELETE',
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res.data.result == "success", res);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports["default"];

/***/ },

/***/ "sshy":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = changeSubscription;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  plan_codename: _joiBrowser2.default.string().required(),
	  quantity: _joiBrowser2.default.number().integer().allow('')
	});
	
	function changeSubscription(paymentInfo) {
	
	  var validateResult = _joiBrowser2.default.validate(paymentInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/change_subscription/',
	      'method': 'POST',
	      'data': JSON.stringify(paymentInfo),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "GQeB":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"payment-modal":"payment-modal","stripe-cardnumber":"stripe-cardnumber","email-error":"email-error","price-on-modal":"price-on-modal","secure-msg":"secure-msg","pay-btn":"pay-btn","payment-wrapper":"payment-wrapper","tabs":"tabs","tab":"tab","selected":"selected","payment-info":"payment-info","info-text":"info-text","card-section":"card-section","email-section":"email-section","dollar":"dollar"};

/***/ },

/***/ "MElV":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStripeElements = __webpack_require__("iEJf");
	
	var _paymentForm = __webpack_require__("xeF2");
	
	var _paymentForm2 = _interopRequireDefault(_paymentForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <CheckoutModalStripeWrapper />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Header
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var key = '';
	var indicator = '';
	
	var api_key = '';
	
	if (false) {
	  key = "pk_test_smD2brB7NmCVjHNZcZ8Iu4BD";
	} else {
	  try {
	    api_key = __webpack_require__("z/kV");
	    key = api_key.STRIPE_API_KEY;
	    indicator = api_key.INDICATOR;
	  } catch (e) {
	    alert(e);
	  }
	}
	
	var StripePayment = function (_React$Component) {
	  _inherits(StripePayment, _React$Component);
	
	  function StripePayment(props) {
	    _classCallCheck(this, StripePayment);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  StripePayment.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('input', { type: 'hidden', value: indicator }),
	      _react2.default.createElement(
	        _reactStripeElements.StripeProvider,
	        { apiKey: key },
	        _react2.default.createElement(
	          _reactStripeElements.Elements,
	          null,
	          _react2.default.createElement(_paymentForm2.default, this.props)
	        )
	      )
	    );
	  };
	
	  return StripePayment;
	}(_react2.default.Component);
	
	exports.default = StripePayment;
	module.exports = exports['default'];

/***/ },

/***/ "xeF2":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStripeElements = __webpack_require__("iEJf");
	
	var _addPaymentMethod = __webpack_require__("ZNb7");
	
	var _addPaymentMethod2 = _interopRequireDefault(_addPaymentMethod);
	
	var _deletePaymentMethod = __webpack_require__("bgWI");
	
	var _deletePaymentMethod2 = _interopRequireDefault(_deletePaymentMethod);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	__webpack_require__("rUyQ");
	
	var _isEmpty = __webpack_require__("lHK6");
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _locale = __webpack_require__("LFx6");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// This is how you modify the style of CardElement
	// You can't do it with plain CSS
	var cardElementStyle = {
	  base: {
	    iconColor: '#D2D2D2',
	    fontWeight: 300,
	    '::placeholder': {
	      fontWeight: 300,
	      color: '#D2D2D2',
	      fontSize: '12px',
	      lineHeight: '13px'
	    }
	  }
	};
	
	var PaymentForm = function (_React$Component) {
	  _inherits(PaymentForm, _React$Component);
	
	  function PaymentForm(props) {
	    _classCallCheck(this, PaymentForm);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      email: '',
	      class: 'form-control email-input',
	      processingPayment: false,
	      isValidEmail: true,
	      isValidCard: true
	    };
	
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    _this.onChangeEmail = _this.onChangeEmail.bind(_this);
	    return _this;
	  }
	
	  PaymentForm.prototype.onChangeEmail = function onChangeEmail(event) {
	    var validation = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    if (validation.test(event.target.value)) {
	      this.setState({ class: 'form-control email-input' });
	    } else {
	      this.setState({ class: 'form-control email-input email-error' });
	    }
	
	    this.state.email = event.target.value;
	    this.setState({ email: this.state.email });
	  };
	
	  PaymentForm.prototype.onSubmit = function onSubmit(ev) {
	    var _this2 = this;
	
	    var _props = this.props,
	        currentPaymentMethod = _props.currentPaymentMethod,
	        onPaymentMethodChanged = _props.onPaymentMethodChanged;
	    var isValidEmail = this.state.isValidEmail;
	
	    ev.preventDefault();
	
	    if (!this.state.email) {
	      this.setState({ class: 'form-control email-input email-error' });
	      ev.preventDefault();
	      return;
	    }
	    this.setState({ processingPayment: true });
	    if (isValidEmail) {
	      this.props.stripe.createToken().then(function (payload) {
	        if (payload.token) {
	          _this2.setState({ isValidCard: true });
	          (0, _addPaymentMethod2.default)({
	            source: payload.token.id,
	            email: _this2.state.email,
	            set_default: 'set_default'
	          }).then(function (res) {
	            _this2.setState({ processingPayment: false });
	            if (res.result === 'success' && (0, _isEmpty2.default)(currentPaymentMethod)) {
	              (0, _deletePaymentMethod2.default)(currentPaymentMethod.id).then(function (res) {
	                onPaymentMethodChanged();
	              });
	            } else {
	              onPaymentMethodChanged();
	            }
	          });
	        } else {
	          _this2.setState({ isValidCard: false, processingPayment: false });
	        }
	      }).catch(function () {
	        _this2.setState({ isValidCard: false, processingPayment: false });
	        return;
	      });
	    }
	  };
	
	  PaymentForm.prototype.render = function render() {
	    var processingPayment = this.state.processingPayment;
	
	    var currentLocale = localStorage.getItem('language');
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'update-card-wrapper' },
	      processingPayment && _react2.default.createElement(
	        'div',
	        { className: 'loading-wrapper' },
	        _react2.default.createElement(_Loading2.default, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'email-section' },
	        _react2.default.createElement(
	          'div',
	          null,
	          __('Email Address', 'checkoutform', null, true)
	        ),
	        _react2.default.createElement('input', { placeholder: 'name@mail.com', className: this.state.class, type: 'email', value: this.state.email, onChange: this.onChangeEmail })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'card-section' },
	        _react2.default.createElement(
	          'div',
	          null,
	          __('Credit Card', 'checkoutform', null, true)
	        ),
	        _react2.default.createElement(_reactStripeElements.CardElement, { className: 'stripe-cardnumber', style: cardElementStyle })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'secure-msg' },
	        __('All payments are processed through Stripe. The connection is secure and encrypted. We do not collect any of your information.', _locale2.default),
	        _react2.default.createElement(
	          'a',
	          { target: '__blank', href: '/privacy-' + currentLocale.toLowerCase() },
	          __('Privacy Policy', _locale2.default)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'update-btn' },
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary', onClick: this.onSubmit },
	          __('Update', _locale2.default)
	        )
	      )
	    );
	  };
	
	  return PaymentForm;
	}(_react2.default.Component);
	
	exports.default = (0, _reactStripeElements.injectStripe)(PaymentForm);
	module.exports = exports['default'];

/***/ },

/***/ "rUyQ":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"personal-setting-page":"personal-setting-page","loading-wrapper":"loading-wrapper","section-title":"section-title","personal-setting-container":"personal-setting-container","btn-default":"btn-default","btn-primary":"btn-primary","input-group":"input-group","active-card-section":"active-card-section","plans-switch-section":"plans-switch-section","account-setting":"account-setting","phone-setting":"phone-setting","email-setting":"email-setting","password-setting":"password-setting","password":"password","password-icon":"password-icon","toggle-text":"toggle-text","change-btn":"change-btn","verification-wrapper":"verification-wrapper","btn-no-margin":"btn-no-margin","pin-input":"pin-input","verification-code":"verification-code","plans-header":"plans-header","switch-wrapper":"switch-wrapper","switch":"switch","switch-toggle":"switch-toggle","selected":"selected","plans-wrapper":"plans-wrapper","cancel-btn":"cancel-btn","active-card":"active-card","current-plan":"current-plan","plan-labels":"plan-labels","card-labels":"card-labels","plan-details":"plan-details","card-details":"card-details","update-card-wrapper":"update-card-wrapper","stripe-cardnumber":"stripe-cardnumber","email-error":"email-error","secure-msg":"secure-msg","card-section":"card-section","email-section":"email-section","dollar":"dollar"};

/***/ },

/***/ "LFx6":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'AccountSettings',
	  code: 'CN',
	  text: {
	    'Account username has been changed successfully!': '登录手机号更改成功!',
	    'This phone number has been used!': '此手机号已被使用!',
	    'Invalid pin!': '验证码无效!',
	    'Failed to changed account username!': '更改登录手机号失败!',
	    'Account password has been changed successfully!': '修改密码成功!',
	    'Invalid current password': '老密码错误',
	    'New password is too short': '新密码太短',
	    'New password can not be the same as the current passowrd': '新老密码不能一样',
	    'New password can not be the same as the username': '新密码不能喝用户名一样',
	    'Failed to change password!': '修改密码失败',
	    'You are unable to subscribe to this plan. If you would like to change, please contact our support team.': '您现有的计划不支持改变成此计划，如果有需要，请联系客服人员。',
	    'Are you sure to change the username?': '您是否确定更改登录手机号?',
	    'Are you sure to change the password?': '您是否确定更改登录密码?',
	    'Are you sure to change the email?': '您是否确定更改邮箱?',
	    'Email has been changed successfully!': '邮箱更改成功!',
	    'This email has been used!': '此邮箱已被使用!',
	    'Failed to change email!': '更改邮箱失败',
	    'Credit card info has been updated successfully!': '更改信用卡信息成功!',
	    'Phone number is invalid or has been used': '电话号码无效或此号码已被使用',
	    'Failed to send verification code!': '发送验证码失败',
	    'Phone Number': '手机号',
	    'Update Phone Number': '更改手机',
	    '6 digits': '6位数字',
	    'Enter New Phone Number': '输入新手机号',
	    'Enter Verification Code': '输入验证码',
	    'Update': '更改',
	    'Email': '邮箱',
	    'Update Email': '更改邮箱',
	    'Enter New Email': '输入新邮箱',
	    'Password': '密码',
	    'Update Password': '更改密码',
	    'Enter Current Password': '输入当前密码',
	    'Enter New Password': '输入新密码',
	    'At least 6 characters': '至少6个字符',
	    'Active Card': '已绑定信用卡',
	    'Card number': '卡号',
	    'Expiry date': '有效日期',
	    'Account Subscription': '账户订阅',
	    'Monthly': '月付',
	    'Yearly': '年付',
	    'Plan Name': '计划名称',
	    'Trial End': '试用结束日期',
	    'Account Settings': '账户设置',
	    'Price': '价格',
	    'Billing Cycle': '收费周期',
	    'Next Billing Date': '下次扣款日期',
	    'Current Plan': '当前计划',
	    'Additional campus costs $79 per month': '每个额外校区, 79美元/月',
	    'Update Card': '更改信用卡',
	    "All payments are processed through Stripe. The connection is secure and encrypted. We do not collect any of your information.": "所有付款都通过 Stripe 处理。付款连接是安全并且加密的。我们不会收集您的任何信息。",
	    'month per school': '每个学校一个月',
	    'Privacy Policy': '隐私政策',
	    'Free Trial': '免费试用版'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "nhSS":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = __webpack_require__("7t+N");
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var PrivacyCN = function (_React$Component) {
	  _inherits(PrivacyCN, _React$Component);
	
	  function PrivacyCN(props) {
	    _classCallCheck(this, PrivacyCN);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  PrivacyCN.prototype.componentDidMount = function componentDidMount() {
	    $('.nav-panel-item').removeClass('active');
	  };
	
	  PrivacyCN.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {};
	
	  PrivacyCN.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { is: true, 'class': 'inner-content' },
	      _react2.default.createElement(
	        'div',
	        { is: true, 'class': 'panel theme-panel' },
	        _react2.default.createElement(
	          'div',
	          { is: true, 'class': 'panel-body privacy-panel' },
	          _react2.default.createElement(
	            'div',
	            { is: true, 'class': 'top-header' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              '\u9690\u79C1\u653F\u7B56'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'ClassTopBase \u5C0A\u91CD\u5E76\u4FDD\u62A4\u6240\u6709\u4F7F\u7528\u670D\u52A1\u7528\u6237\u7684\u4E2A\u4EBA\u9690\u79C1\u6743\u3002\u4E3A\u4E86\u7ED9\u60A8\u63D0\u4F9B\u66F4\u51C6\u786E\u3001\u66F4\u6709\u4E2A\u6027\u5316\u7684\u670D\u52A1\uFF0C ClassTopBase \u4F1A\u6309\u7167\u672C\u9690\u79C1\u6743\u653F\u7B56\u7684\u89C4\u5B9A\u4F7F\u7528\u548C\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u4F46 ClassTopBase \u5C06\u4EE5\u9AD8\u5EA6\u7684\u52E4\u52C9\u3001\u5BA1\u614E\u4E49\u52A1\u5BF9\u5F85\u8FD9\u4E9B\u4FE1\u606F\u3002 \u9664\u672C\u9690\u79C1\u6743\u653F\u7B56\u53E6\u6709\u89C4\u5B9A\u5916\uFF0C\u5728\u672A\u5F81\u5F97\u60A8\u4E8B\u5148\u8BB8\u53EF\u7684\u60C5\u51B5\u4E0B\uFF0CClassTopBase \u4E0D\u4F1A\u5C06\u8FD9\u4E9B\u4FE1\u606F\u5BF9\u5916\u62AB\u9732\u6216\u5411\u7B2C\u4E09\u65B9\u63D0\u4F9B\u3002ClassTopBase \u4F1A\u4E0D\u65F6\u66F4\u65B0\u672C\u9690\u79C1\u6743\u653F\u7B56\u3002 \u60A8\u5728\u540C\u610F ClassTopBase \u670D\u52A1\u4F7F\u7528\u534F\u8BAE\u4E4B\u65F6\uFF0C\u5373\u89C6\u4E3A\u60A8\u5DF2\u7ECF\u540C\u610F\u672C\u9690\u79C1\u6743\u653F\u7B56\u5168\u90E8\u5185\u5BB9\u3002\u672C\u9690\u79C1\u6743\u653F\u7B56\u5C5E\u4E8E ClassTopBase \u670D\u52A1\u4F7F\u7528\u534F\u8BAE\u4E0D\u53EF\u5206\u5272\u7684\u4E00\u90E8\u5206\u3002'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              '1. \u9002\u7528\u8303\u56F4'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'a) \u5728\u60A8\u4F7F\u7528 ClassTopBase \u8F6F\u4EF6\u670D\u52A1\uFF0C\u6216\u8BBF\u95EE ClassTopBase \u5E73\u53F0\u7F51\u9875\u65F6\uFF0CClassTopBase \u81EA\u52A8\u63A5\u6536\u5E76\u8BB0\u5F55\u7684\u60A8\u7684\u6D4F\u89C8\u5668\u548C\u8BA1\u7B97\u673A\u4E0A\u7684\u4FE1\u606F\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u60A8\u7684 IP \u5730\u5740\u3001\u6D4F\u89C8\u5668\u7684\u7C7B\u578B\u3001\u4F7F\u7528\u7684\u8BED\u8A00\u3001\u8BBF\u95EE\u65E5\u671F\u548C\u65F6\u95F4\u3001\u8F6F\u786C\u4EF6\u7279\u5F81\u4FE1\u606F\u53CA\u60A8\u9700\u6C42\u7684\u7F51\u9875\u8BB0\u5F55\u7B49\u6570\u636E\u3002',
	              _react2.default.createElement('br', null),
	              'b) ClassTopBase \u901A\u8FC7\u5408\u6CD5\u9014\u5F84\u4ECE\u5546\u4E1A\u4F19\u4F34\u5904\u53D6\u5F97\u7684\u7528\u6237\u4E2A\u4EBA\u6570\u636E\u3002'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              '2. \u4FE1\u606F\u4F7F\u7528'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'a) ClassTopBase \u4E0D\u4F1A\u5411\u4EFB\u4F55\u65E0\u5173\u7B2C\u4E09\u65B9\u63D0\u4F9B\u3001\u51FA\u552E\u3001\u51FA\u79DF\u3001\u5206\u4EAB\u6216\u4EA4\u6613\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9664\u975E\u4E8B\u5148\u5F97\u5230\u60A8\u7684\u8BB8\u53EF\uFF0C\u6216\u8BE5\u7B2C\u4E09\u65B9\u548C ClassTopBase\uFF08\u542B ClassTopBase \u5173\u8054\u516C\u53F8\uFF09\u5355\u72EC\u6216\u5171\u540C\u4E3A\u60A8\u63D0\u4F9B\u670D\u52A1\uFF0C\u4E14\u5728\u8BE5\u670D\u52A1\u7ED3\u675F\u540E\uFF0C\u5176\u5C06\u88AB\u7981\u6B62\u8BBF\u95EE\u5305\u62EC\u5176\u4EE5\u524D\u80FD\u591F\u8BBF\u95EE\u7684\u6240\u6709\u8FD9\u4E9B\u8D44\u6599\u3002',
	              _react2.default.createElement('br', null),
	              'b) ClassTopBase \u4EA6\u4E0D\u5141\u8BB8\u4EFB\u4F55\u7B2C\u4E09\u65B9\u4EE5\u4EFB\u4F55\u624B\u6BB5\u6536\u96C6\u3001\u7F16\u8F91\u3001\u51FA\u552E\u6216\u8005\u65E0\u507F\u4F20\u64AD\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u4EFB\u4F55 ClassTopBase \u5E73\u53F0\u7528\u6237\u5982\u4ECE\u4E8B\u4E0A\u8FF0\u6D3B\u52A8\uFF0C\u4E00\u7ECF\u53D1\u73B0\uFF0C\u6211\u53F8\u6709\u6743\u7ACB\u5373\u7EC8\u6B62\u4E0E\u8BE5\u7528\u6237\u7684\u670D\u52A1\u534F\u8BAE\u3002',
	              _react2.default.createElement('br', null),
	              'c) \u4E3A\u670D\u52A1\u7528\u6237\u7684\u76EE\u7684\uFF0CClassTopBase \u53EF\u80FD\u901A\u8FC7\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5411\u60A8\u63D0\u4F9B\u60A8\u611F\u5174\u8DA3\u7684\u4FE1\u606F\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u5411\u60A8\u53D1\u51FA\u4EA7\u54C1\u548C\u670D\u52A1\u4FE1\u606F\uFF0C\u6216\u8005\u4E0E\u6211\u53F8\u5408\u4F5C\u4F19\u4F34\u5171\u4EAB\u4FE1\u606F\u4EE5\u4FBF\u4ED6\u4EEC\u5411\u60A8\u53D1\u9001\u6709\u5173\u5176\u4EA7\u54C1\u548C\u670D\u52A1\u7684\u4FE1\u606F\uFF08\u540E\u8005\u9700\u8981\u60A8\u7684\u4E8B\u5148\u540C\u610F\uFF09\u3002'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              '3. \u4FE1\u606F\u62AB\u9732'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '\u5728\u5982\u4E0B\u60C5\u51B5\u4E0B\uFF0CClassTopBase \u5C06\u4F9D\u636E\u60A8\u7684\u4E2A\u4EBA\u610F\u613F\u6216\u6CD5\u5F8B\u7684\u89C4\u5B9A\u5168\u90E8\u6216\u90E8\u5206\u7684\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A',
	              _react2.default.createElement('br', null),
	              'a) \u7ECF\u60A8\u4E8B\u5148\u540C\u610F\uFF0C\u5411\u7B2C\u4E09\u65B9\u62AB\u9732\uFF1B',
	              _react2.default.createElement('br', null),
	              'b) \u4E3A\u63D0\u4F9B\u60A8\u6240\u8981\u6C42\u7684\u4EA7\u54C1\u548C\u670D\u52A1\uFF0C\u800C\u5FC5\u987B\u548C\u7B2C\u4E09\u65B9\u5206\u4EAB\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1B',
	              _react2.default.createElement('br', null),
	              'c) \u6839\u636E\u6CD5\u5F8B\u7684\u6709\u5173\u89C4\u5B9A\uFF0C\u6216\u8005\u884C\u653F\u6216\u53F8\u6CD5\u673A\u6784\u7684\u8981\u6C42\uFF0C\u5411\u7B2C\u4E09\u65B9\u6216\u8005\u884C\u653F\u3001\u53F8\u6CD5\u673A\u6784\u62AB\u9732\uFF1B ',
	              _react2.default.createElement('br', null),
	              'd) \u5982\u60A8\u51FA\u73B0\u8FDD\u53CD\u52A0\u62FF\u5927\u6709\u5173\u6CD5\u5F8B\u3001\u6CD5\u89C4\u6216\u8005 ClassTopBase \u670D\u52A1\u534F\u8BAE\u6216\u76F8\u5173\u89C4\u5219\u7684\u60C5\u51B5\uFF0C\u9700\u8981\u5411\u7B2C\u4E09\u65B9\u62AB\u9732\uFF1B   ',
	              _react2.default.createElement('br', null),
	              'e) \u5982\u60A8\u662F\u9002\u683C\u7684\u77E5\u8BC6\u4EA7\u6743\u6295\u8BC9\u4EBA\u5E76\u5DF2\u63D0\u8D77\u6295\u8BC9\uFF0C\u5E94\u88AB\u6295\u8BC9\u4EBA\u8981\u6C42\uFF0C\u5411\u88AB\u6295\u8BC9\u4EBA\u62AB\u9732\uFF0C\u4EE5\u4FBF\u53CC\u65B9\u5904\u7406\u53EF\u80FD\u7684\u6743\u5229\u7EA0\u7EB7\uFF1B ',
	              _react2.default.createElement('br', null),
	              'f) \u5728 ClassTopBase \u5E73\u53F0\u4E0A\u521B\u5EFA\u7684\u67D0\u4E00\u4EA4\u6613\u4E2D\uFF0C\u5982\u4EA4\u6613\u4EFB\u4F55\u4E00\u65B9\u5C65\u884C\u6216\u90E8\u5206\u5C65\u884C\u4E86\u4EA4\u6613\u4E49\u52A1\u5E76\u63D0\u51FA\u4FE1\u606F\u62AB\u9732\u8BF7\u6C42\u7684\uFF0CClassTopBase \u6709\u6743\u51B3\u5B9A\u5411\u8BE5\u7528\u6237\u63D0\u4F9B\u5176\u4EA4\u6613\u5BF9\u65B9\u7684\u8054\u7EDC\u65B9\u5F0F\u7B49\u5FC5\u8981\u4FE1\u606F\uFF0C\u4EE5\u4FC3\u6210\u4EA4\u6613\u7684\u5B8C\u6210\u6216\u7EA0\u7EB7\u7684\u89E3\u51B3\u3002',
	              _react2.default.createElement('br', null),
	              'g) \u5176\u5B83 ClassTopBase \u6839\u636E\u6CD5\u5F8B\u3001\u6CD5\u89C4\u6216\u8005\u7F51\u7AD9\u653F\u7B56\u8BA4\u4E3A\u5408\u9002\u7684\u62AB\u9732\u3002'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              '4. \u4FE1\u606F\u5B58\u50A8\u548C\u4EA4\u6362'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'ClassTopBase \u6536\u96C6\u7684\u6709\u5173\u60A8\u7684\u4FE1\u606F\u548C\u8D44\u6599\u5C06\u4FDD\u5B58\u5728 ClassTopBase \u53CA\uFF08\u6216\uFF09\u5176\u5173\u8054\u516C\u53F8\u7684\u670D\u52A1\u5668\u4E0A\uFF0C\u8FD9\u4E9B\u4FE1\u606F\u548C\u8D44\u6599\u53EF\u80FD\u4F20\u9001\u81F3\u60A8\u6240\u5728\u56FD\u5BB6\u3001\u5730\u533A\u6216 ClassTopBase \u6536\u96C6\u4FE1\u606F\u548C\u8D44\u6599\u6240\u5728\u5730\u7684\u5883\u5916\u5E76\u5728\u5883\u5916\u88AB\u8BBF\u95EE\u3001\u5B58\u50A8\u548C\u5C55\u793A\u3002'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              '5. \u4FE1\u606F\u5B89\u5168'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'a) ClassTopBase \u5E10\u53F7\u5747\u6709\u5B89\u5168\u4FDD\u62A4\u529F\u80FD\uFF0C\u8BF7\u59A5\u5584\u4FDD\u7BA1\u60A8\u7684\u7528\u6237\u540D\u53CA\u5BC6\u7801\u4FE1\u606F\u3002ClassTopBase \u5C06\u901A\u8FC7\u5BF9\u7528\u6237\u5BC6\u7801\u8FDB\u884C\u52A0\u5BC6\u7B49\u5B89\u5168\u63AA\u65BD\u786E\u4FDD\u60A8\u7684\u4FE1\u606F\u4E0D\u4E22\u5931\uFF0C\u4E0D\u88AB\u6EE5\u7528\u548C\u53D8\u9020\u3002\u5C3D\u7BA1\u6709\u524D\u8FF0\u5B89\u5168\u63AA\u65BD\uFF0C\u4F46\u540C\u65F6\u4E5F\u8BF7\u60A8\u6CE8\u610F\u5728\u4FE1\u606F\u7F51\u7EDC\u4E0A\u4E0D\u5B58\u5728\u201C\u5B8C\u5584\u7684\u5B89\u5168\u63AA\u65BD\u201D\u3002',
	              _react2.default.createElement('br', null),
	              'b) \u5728\u4F7F\u7528 ClassTopBase \u7F51\u7EDC\u670D\u52A1\u8FDB\u884C\u7F51\u4E0A\u4EA4\u6613\u65F6\uFF0C\u60A8\u4E0D\u53EF\u907F\u514D\u7684\u8981\u5411\u4EA4\u6613\u5BF9\u65B9\u6216\u6F5C\u5728\u7684\u4EA4\u6613\u5BF9\u65B9\u62AB\u9732\u81EA\u5DF1\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5982\u8054\u7EDC\u65B9\u5F0F\u6216\u8005\u90AE\u653F\u5730\u5740\u3002\u8BF7\u60A8\u59A5\u5584\u4FDD\u62A4\u81EA\u5DF1\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4EC5\u5728\u5FC5\u8981\u7684\u60C5\u5F62\u4E0B\u5411\u4ED6\u4EBA\u63D0\u4F9B\u3002\u5982\u60A8\u53D1\u73B0\u81EA\u5DF1\u7684\u4E2A\u4EBA\u4FE1\u606F\u6CC4\u5BC6\uFF0C\u5C24\u5176\u662F ClassTopBase \u7528\u6237\u540D\u53CA\u5BC6\u7801\u53D1\u751F\u6CC4\u9732\uFF0C\u8BF7\u60A8\u7ACB\u5373\u8054\u7EDC ClassTopBase \u5BA2\u670D\uFF0C\u4EE5\u4FBF ClassTopBase \u91C7\u53D6\u76F8\u5E94\u63AA\u65BD'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return PrivacyCN;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PrivacyCN);
	module.exports = exports['default'];

/***/ },

/***/ "WPCA":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = __webpack_require__("7t+N");
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var PrivacyEN = function (_React$Component) {
	  _inherits(PrivacyEN, _React$Component);
	
	  function PrivacyEN(props) {
	    _classCallCheck(this, PrivacyEN);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  PrivacyEN.prototype.componentDidMount = function componentDidMount() {
	    $('.nav-panel-item').removeClass('active');
	  };
	
	  PrivacyEN.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {};
	
	  PrivacyEN.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { is: true, 'class': 'inner-content' },
	      _react2.default.createElement(
	        'div',
	        { is: true, 'class': 'panel theme-panel' },
	        _react2.default.createElement(
	          'div',
	          { is: true, 'class': 'panel-body privacy-panel' },
	          _react2.default.createElement(
	            'div',
	            { is: true, 'class': 'top-header' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Privacy Policy'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              ' ClassTop INC. built the ClassTopBase app as a Free app. This SERVICE is provided by ClassTop INC. at no cost and is intended for use as is.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'This page is used to inform website visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at ClassTopBase unless otherwise defined in this Privacy Policy.'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Information Collection and Use'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information. The information that we request is will be retained by us and used as described in this privacy policy.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'The app does use third party services that may collect information used to identify you.'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Log Data'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'We want to inform you that whenever you use our Service, in a case of an error in the app we collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (\u201CIP\u201D) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Cookies'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your device internal memory.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'This Service does not use these \u201Ccookies\u201D explicitly. However, the app may use third party code and libraries that use \u201Ccookies\u201D to collection information and to improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Service Providers'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              ' We may employ third-party companies and individuals due to the following reasons:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'To facilitate our Service;'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'To provide the Service on our behalf;'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'To perform Service-related services; or'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'To assist us in analyzing how our Service is used.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'We want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Security'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Links to Other Sites'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Children\u2019s Privacy'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'These Services do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Changes to This Privacy Policy'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Contact Us'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us.'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return PrivacyEN;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PrivacyEN);
	module.exports = exports['default'];

/***/ },

/***/ "ZxDm":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"MainContainer":"MainContainer","sideMenuHidden":"sideMenuHidden","noSideMenu":"noSideMenu","Content":"Content","upgrade-plan":"upgrade-plan","LoginPageWrapper":"LoginPageWrapper","searchOverlay":"searchOverlay","locale-CN":"locale-CN"};

/***/ },

/***/ "T1vP":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
	  "items": [{
	    "title": "Classtop",
	    "path": "/",
	    "component": "ChangeSchool/index.js"
	  }, {
	    "title": "Student",
	    "path": "/student",
	    "component": "Student/index.js",
	    "permissionRequired": ["student_channel"]
	  }, {
	    "title": "Student Settings",
	    "path": "/student-settings",
	    "permissionRequired": ["edit_school_setting"],
	    "component": "StudentSettings/index.js"
	  }, {
	    "title": "Class",
	    "path": "/class",
	    "permissionRequired": ["class_channel"],
	    "component": "Class/index.js"
	  }, {
	    "title": "Class",
	    "path": "/class/:classState",
	    "permissionRequired": ["class_channel"],
	    "component": "Class/index.js"
	  }, {
	    "title": "One to One",
	    "path": "/one_one",
	    "permissionRequired": ["private_class_channel"],
	    "component": "ClassOne/index.js"
	  }, {
	    "title": "One to One",
	    "path": "/one_one/:classState",
	    "permissionRequired": ["private_class_channel"],
	    "component": "ClassOne/index.js"
	  }, {
	    "title": "Teacher",
	    "path": "/teacher",
	    "permissionRequired": ["teacher_channel"],
	    "component": "Teacher/index.js"
	  }, {
	    "title": "Attendance",
	    "path": "/teacher/attendance/:teacherId",
	    "permissionRequired": ["teacher_channel", "read_teacher_check_in_record"],
	    "component": "Teacher/Attendance/index.js"
	  }, {
	    "title": "Class Details",
	    "path": "/class-detail/:classId",
	    "permissionRequired": ["class_channel", "read_class_detail"],
	    "component": "ClassDetail/index.js"
	  }, {
	    "title": "Class One Details",
	    "path": "/class-one-detail/:classId",
	    "permissionRequired": ["private_class_channel", "read_private_class_detail"],
	    "component": "ClassOneDetail/index.js"
	  }, {
	    "title": "Classroom",
	    "path": "/classroom",
	    "permissionRequired": ["classroom_channel"],
	    "component": "Classroom/index.js"
	  }, {
	    "title": "Finance",
	    "path": "/finance",
	    "permissionRequired": ["finance_channel"],
	    "component": "Finance/index.js"
	  }, {
	    "title": "Monthly Finance",
	    "path": "/monthly-finance",
	    "permissionRequired": ["finance_channel"],
	    "component": "MonthlyFinance/index.js"
	  }, {
	    "title": "School Settings",
	    "path": "/school-settings",
	    "permissionRequired": ["school_setting_channel"],
	    "component": "SchoolSettings/index.js"
	  }, {
	    "title": "School Information",
	    "path": "/school-information",
	    "permissionRequired": ["school_setting_channel", "edit_school_setting"],
	    "component": "SchoolInformation/index.js"
	  }, {
	    "title": "Website",
	    "path": "/website",
	    "permissionRequired": ["website"],
	    "notForBasicUser": true, // to check if the user is on basic plan or free trial, restrict the route when true
	    "component": "Website/index.js"
	  }, {
	    "title": "Schedule",
	    "path": "/schedule",
	    "permissionRequired": ["timetable_channel"],
	    "component": "Schedule/index.js"
	  }, {
	    "title": "Print Schedule",
	    "path": "/print-schedule",
	    "permissionRequired": ["timetable_channel"],
	    "component": "PrintSchedule/index.js"
	  }, {
	    "title": "Announcement",
	    "path": "/announcement",
	    "permissionRequired": ["announcement_channel"],
	    "component": "Announcement/index.js"
	  }, {
	    "title": "Activity Log",
	    "path": "/logs",
	    "permissionRequired": ["operation_log_channel"],
	    "notForBasicUser": true,
	    "component": "Logs/index.js"
	  }, {
	    "title": "Dashboard",
	    "path": "/dashboard",
	    "component": "Dashboard/index.js"
	  }, {
	    "title": "Privacy EN",
	    "path": "/privacy-en",
	    "component": "PrivacyPolicy/en.js"
	  }, {
	    "title": "Privacy CN",
	    "path": "/privacy-cn",
	    "component": "PrivacyPolicy/cn.js"
	  }, {
	    "title": "Poster",
	    "path": "/poster",
	    "permissionRequired": ["poster_channel"],
	    "notForBasicUser": true,
	    "component": "Poster/index.js"
	  }, {
	    "title": "Poster",
	    "path": "/edit-poster/:posterId",
	    "permissionRequired": ["poster_channel"],
	    "notForBasicUser": true,
	    "component": "Poster/EditPoster/index.js"
	  }, {
	    "title": "Poster Preview",
	    "path": "/poster-preview/:posterId",
	    "permissionRequired": ["poster_channel"],
	    "notForBasicUser": true,
	    "component": "Poster/SaasPosterPreview/index.js"
	  }, {
	    "title": "Registration Table",
	    "path": "/registration-table/:posterId",
	    "permissionRequired": ["poster_channel"],
	    "notForBasicUser": true,
	    "component": "Poster/RegistrationTable/index.js"
	  }, {
	    "title": "Total Registration Table",
	    "path": "/registration-table/",
	    "permissionRequired": ["poster_channel"],
	    "notForBasicUser": true,
	    "component": "Poster/RegistrationTable/index.js"
	  }, {
	    "title": 'Contacts',
	    "path": '/contacts',
	    "component": 'PotentialClient/index.js',
	    "notForBasicUser": true,
	    "permissionRequired": ["contact_channel"]
	  }, {
	    "title": 'Contacts',
	    "path": '/contact-settings',
	    "component": 'PotentialClientSettings/index.js',
	    "notForBasicUser": true,
	    "permissionRequired": ["contact_channel"]
	  }, {
	    "title": 'Import Student',
	    "path": '/import-student',
	    "component": 'ImportStudent/index.js',
	    "permissionRequired": ["create_student", "edit_school_setting"]
	  }, {
	    "title": "UI Library",
	    "path": "/ui-library",
	    "component": "UILibrary/index.js"
	  }, {
	    "title": "Account Settings",
	    "path": "/account-settings",
	    "component": "AccountSettings/index.js"
	  }, {
	    "title": "No Permission",
	    "path": "/no-permission",
	    "component": "NoPermission/index.js"
	  }, {
	    "title": "Registration Terms and Conditions",
	    "path": "/registration-agreement",
	    "component": "RegistrationAgreement/index.js",
	    "permissionRequired": ["edit_school_setting"]
	  }, {
	    "title": "Waiting List",
	    "path": "/waiting-list",
	    "component": "WaitingList/index.js"
	    // "permissionRequired": ["edit_school_setting"],    
	  }, {
	    "title": "Teacher Career",
	    "path": "/teacher-career",
	    "component": "TeacherCareer/index.js"
	    // "permissionRequired": ["edit_school_setting"],    
	  }, {
	    "title": "Payment Information",
	    "path": "/custom-payment-info",
	    "component": "PaymentInformation/index.js"
	    // "permissionRequired": ["edit_school_setting"],    
	  }]
	};
	module.exports = exports["default"];

/***/ },

/***/ 5:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./AccountSettings/AccountSettings.scss": "rUyQ",
		"./AccountSettings/index": "lOrV",
		"./AccountSettings/index.js": "lOrV",
		"./AccountSettings/locale": "LFx6",
		"./AccountSettings/locale.js": "LFx6",
		"./AccountSettings/paymentForm": "xeF2",
		"./AccountSettings/paymentForm.js": "xeF2",
		"./AccountSettings/stripePayment": "MElV",
		"./AccountSettings/stripePayment.js": "MElV",
		"./Announcement/Announcement.scss": "w2MC",
		"./Announcement/AnnouncementCard": "UXfg",
		"./Announcement/AnnouncementCard.js": "UXfg",
		"./Announcement/AnnouncementCard.scss": "cNYk",
		"./Announcement/DefaultTab": "rhuv",
		"./Announcement/DefaultTab.js": "rhuv",
		"./Announcement/constant": "ENiu",
		"./Announcement/constant.js": "ENiu",
		"./Announcement/images/Announcement.png": "JsbR",
		"./Announcement/images/Announcement_en@2x.png": "z9ID",
		"./Announcement/index": "9ZkX",
		"./Announcement/index.js": "9ZkX",
		"./Announcement/locale": "m3Lh",
		"./Announcement/locale.js": "m3Lh",
		"./Announcement/redux/actions/addAnnouncement": "/Cga",
		"./Announcement/redux/actions/addAnnouncement.js": "/Cga",
		"./Announcement/redux/actions/deleteAnnouncement": "y2+x",
		"./Announcement/redux/actions/deleteAnnouncement.js": "y2+x",
		"./Announcement/redux/actions/getAnnouncementList": "sYDS",
		"./Announcement/redux/actions/getAnnouncementList.js": "sYDS",
		"./Announcement/redux/actions/searchAnnouncement": "EV0/",
		"./Announcement/redux/actions/searchAnnouncement.js": "EV0/",
		"./Announcement/redux/actions/setCurrentTabState": "d4iu",
		"./Announcement/redux/actions/setCurrentTabState.js": "d4iu",
		"./Announcement/redux/actions/updateAnnouncement": "eVF0",
		"./Announcement/redux/actions/updateAnnouncement.js": "eVF0",
		"./Announcement/redux/reducer": "pzkK",
		"./Announcement/redux/reducer.js": "pzkK",
		"./ChangeSchool/ChangeSchool.scss": "mRfb",
		"./ChangeSchool/index": "12fy",
		"./ChangeSchool/index.js": "12fy",
		"./ChangeSchool/locale": "MXDL",
		"./ChangeSchool/locale.js": "MXDL",
		"./Class/Class.scss": "aCad",
		"./Class/ClassTable/ClassDateTd": "pxBc",
		"./Class/ClassTable/ClassDateTd.js": "pxBc",
		"./Class/ClassTable/ClassNameTd": "SsX8",
		"./Class/ClassTable/ClassNameTd.js": "SsX8",
		"./Class/ClassTable/ClassStatusTd": "kWiG",
		"./Class/ClassTable/ClassStatusTd.js": "kWiG",
		"./Class/ClassTable/ClassTeacherListTd": "roHl",
		"./Class/ClassTable/ClassTeacherListTd.js": "roHl",
		"./Class/ClassTable/HadLessonTd": "HcTH",
		"./Class/ClassTable/HadLessonTd.js": "HcTH",
		"./Class/ClassTable/index": "6E2x",
		"./Class/ClassTable/index.js": "6E2x",
		"./Class/DefaultTab": "e6Cv",
		"./Class/DefaultTab.js": "e6Cv",
		"./Class/constant": "pDIt",
		"./Class/constant.js": "pDIt",
		"./Class/ducks": "wTtZ",
		"./Class/ducks.js": "wTtZ",
		"./Class/images/Class@2x.png": "uNdX",
		"./Class/images/class_en@2x.png": "19ka",
		"./Class/index": "CpZZ",
		"./Class/index.js": "CpZZ",
		"./Class/locale": "4A/Z",
		"./Class/locale.js": "4A/Z",
		"./Class/table-settings": "W43I",
		"./Class/table-settings.js": "W43I",
		"./ClassDetail/ClassDetail.scss": "7HkZ",
		"./ClassDetail/ClassInfoFields": "QRb/",
		"./ClassDetail/ClassInfoFields.js": "QRb/",
		"./ClassDetail/DefaultTab": "siMa",
		"./ClassDetail/DefaultTab.js": "siMa",
		"./ClassDetail/LessonTable/StudentAmountTd": "2EBe",
		"./ClassDetail/LessonTable/StudentAmountTd.js": "2EBe",
		"./ClassDetail/LessonTable/TeacherListTd": "Eceu",
		"./ClassDetail/LessonTable/TeacherListTd.js": "Eceu",
		"./ClassDetail/LessonTable/index": "bBLv",
		"./ClassDetail/LessonTable/index.js": "bBLv",
		"./ClassDetail/LessonTable/table-settings": "x2Kx",
		"./ClassDetail/LessonTable/table-settings.js": "x2Kx",
		"./ClassDetail/StudentTable/LessonStatusTd": "/raN",
		"./ClassDetail/StudentTable/LessonStatusTd.js": "/raN",
		"./ClassDetail/StudentTable/StudentTable.scss": "i/UM",
		"./ClassDetail/StudentTable/ducks": "6mZg",
		"./ClassDetail/StudentTable/ducks.js": "6mZg",
		"./ClassDetail/StudentTable/index": "Mvxf",
		"./ClassDetail/StudentTable/index.js": "Mvxf",
		"./ClassDetail/StudentTable/table-settings": "vx51",
		"./ClassDetail/StudentTable/table-settings.js": "vx51",
		"./ClassDetail/TeacherTable/ducks": "DPWa",
		"./ClassDetail/TeacherTable/ducks.js": "DPWa",
		"./ClassDetail/TeacherTable/index": "TW8w",
		"./ClassDetail/TeacherTable/index.js": "TW8w",
		"./ClassDetail/TeacherTable/table-settings": "y9xV",
		"./ClassDetail/TeacherTable/table-settings.js": "y9xV",
		"./ClassDetail/ducks": "lDbx",
		"./ClassDetail/ducks.js": "lDbx",
		"./ClassDetail/index": "fWyM",
		"./ClassDetail/index.js": "fWyM",
		"./ClassDetail/locale": "qEX0",
		"./ClassDetail/locale.js": "qEX0",
		"./ClassOne/ClassOne.scss": "DeMY",
		"./ClassOne/ClassOneTable/ClassOneDateTd": "7uof",
		"./ClassOne/ClassOneTable/ClassOneDateTd.js": "7uof",
		"./ClassOne/ClassOneTable/ClassOneNameTd": "DA52",
		"./ClassOne/ClassOneTable/ClassOneNameTd.js": "DA52",
		"./ClassOne/ClassOneTable/ClassOneStatusTd": "21YX",
		"./ClassOne/ClassOneTable/ClassOneStatusTd.js": "21YX",
		"./ClassOne/ClassOneTable/ClassOneTeacherListTd": "7rsq",
		"./ClassOne/ClassOneTable/ClassOneTeacherListTd.js": "7rsq",
		"./ClassOne/ClassOneTable/HadLessonTd": "hYPf",
		"./ClassOne/ClassOneTable/HadLessonTd.js": "hYPf",
		"./ClassOne/ClassOneTable/index": "Mxt6",
		"./ClassOne/ClassOneTable/index.js": "Mxt6",
		"./ClassOne/DefaultTab": "OG8y",
		"./ClassOne/DefaultTab.js": "OG8y",
		"./ClassOne/constant": "cwv3",
		"./ClassOne/constant.js": "cwv3",
		"./ClassOne/images/Private_class@2x.png": "9sfX",
		"./ClassOne/images/private_en@2x.png": "OG2L",
		"./ClassOne/index": "J+P4",
		"./ClassOne/index.js": "J+P4",
		"./ClassOne/locale": "Ru2+",
		"./ClassOne/locale.js": "Ru2+",
		"./ClassOne/table-settings": "vuXa",
		"./ClassOne/table-settings.js": "vuXa",
		"./ClassOneDetail/index": "Re4n",
		"./ClassOneDetail/index.js": "Re4n",
		"./Classroom/Classroom.scss": "/k15",
		"./Classroom/ClassroomTable/ClassroomTable.scss": "qPto",
		"./Classroom/ClassroomTable/index": "37mE",
		"./Classroom/ClassroomTable/index.js": "37mE",
		"./Classroom/DefaultTab": "nQdd",
		"./Classroom/DefaultTab.js": "nQdd",
		"./Classroom/constant": "Fg9y",
		"./Classroom/constant.js": "Fg9y",
		"./Classroom/ducks": "I0d0",
		"./Classroom/ducks.js": "I0d0",
		"./Classroom/images/Classroom@2x.png": "0dUj",
		"./Classroom/images/classroom_en@2x.png": "/lYJ",
		"./Classroom/index": "j+FQ",
		"./Classroom/index.js": "j+FQ",
		"./Classroom/locale": "Nj5O",
		"./Classroom/locale.js": "Nj5O",
		"./Classroom/table-settings": "4J1v",
		"./Classroom/table-settings.js": "4J1v",
		"./Dashboard/ducks": "Y5Sn",
		"./Dashboard/ducks.js": "Y5Sn",
		"./Dashboard/index": "Hvm5",
		"./Dashboard/index.js": "Hvm5",
		"./Dashboard/locale": "pthR",
		"./Dashboard/locale.js": "pthR",
		"./Dashboard/statisticDisplay": "jPUq",
		"./Dashboard/statisticDisplay.js": "jPUq",
		"./Dashboard/style.scss": "DNRm",
		"./Finance/index": "7JCM",
		"./Finance/index.js": "7JCM",
		"./ImportStudent/ImportDataTable": "6YbS",
		"./ImportStudent/ImportDataTable.js": "6YbS",
		"./ImportStudent/ImportDataTable.scss": "t2fR",
		"./ImportStudent/ImportStudent.scss": "wwyS",
		"./ImportStudent/csvTemplate": "Stwu",
		"./ImportStudent/csvTemplate.js": "Stwu",
		"./ImportStudent/index": "27YW",
		"./ImportStudent/index.js": "27YW",
		"./ImportStudent/locale": "Wgx6",
		"./ImportStudent/locale.js": "Wgx6",
		"./Login/Login.scss": "9pbx",
		"./Login/index": "ixZ5",
		"./Login/index.js": "ixZ5",
		"./Login/locale": "xDtR",
		"./Login/locale.js": "xDtR",
		"./Logs/ducks": "vvL0",
		"./Logs/ducks.js": "vvL0",
		"./Logs/index": "Y4ah",
		"./Logs/index.js": "Y4ah",
		"./Logs/locale": "/jR7",
		"./Logs/locale.js": "/jR7",
		"./MonthlyFinance/index": "vev/",
		"./MonthlyFinance/index.js": "vev/",
		"./MonthlyFinance/monthly.scss": "7Rn2",
		"./NoPermission/NoPermission.scss": "/gsv",
		"./NoPermission/index": "zrmO",
		"./NoPermission/index.js": "zrmO",
		"./NoPermission/locale": "XxsS",
		"./NoPermission/locale.js": "XxsS",
		"./PaymentInformation/PaymentInformation.scss": "SL3g",
		"./PaymentInformation/index": "ylUr",
		"./PaymentInformation/index.js": "ylUr",
		"./PaymentInformation/locale": "1/Q7",
		"./PaymentInformation/locale.js": "1/Q7",
		"./Poster/DefaultTab": "VtFU",
		"./Poster/DefaultTab.js": "VtFU",
		"./Poster/EditPoster-archieve/AdvanceSettings": "NrvF",
		"./Poster/EditPoster-archieve/AdvanceSettings.js": "NrvF",
		"./Poster/EditPoster-archieve/DefaultEditor.scss": "DaH7",
		"./Poster/EditPoster-archieve/EditItem": "OSsy",
		"./Poster/EditPoster-archieve/EditItem.js": "OSsy",
		"./Poster/EditPoster-archieve/EditPoster.scss": "rNQa",
		"./Poster/EditPoster-archieve/OtherSettings": "esxL",
		"./Poster/EditPoster-archieve/OtherSettings.js": "esxL",
		"./Poster/EditPoster-archieve/RegistrationSetting": "jgoK",
		"./Poster/EditPoster-archieve/RegistrationSetting.js": "jgoK",
		"./Poster/EditPoster-archieve/Template": "43rz",
		"./Poster/EditPoster-archieve/Template.js": "43rz",
		"./Poster/EditPoster-archieve/TicketList": "SxNW",
		"./Poster/EditPoster-archieve/TicketList.js": "SxNW",
		"./Poster/EditPoster-archieve/TicketList.scss": "cmbB",
		"./Poster/EditPoster-archieve/ducks": "ygJX",
		"./Poster/EditPoster-archieve/ducks.js": "ygJX",
		"./Poster/EditPoster-archieve/index": "yA0B",
		"./Poster/EditPoster-archieve/index.js": "yA0B",
		"./Poster/EditPoster-archieve/locale": "7sYR",
		"./Poster/EditPoster-archieve/locale.js": "7sYR",
		"./Poster/EditPoster/EditPoster.scss": "avJc",
		"./Poster/EditPoster/Item": "K6Gm",
		"./Poster/EditPoster/Item.js": "K6Gm",
		"./Poster/EditPoster/Register/AdvanceSettings": "pYqi",
		"./Poster/EditPoster/Register/AdvanceSettings.js": "pYqi",
		"./Poster/EditPoster/Register/DefaultEditor.scss": "Wab1",
		"./Poster/EditPoster/Register/EditPoster.scss": "1SKC",
		"./Poster/EditPoster/Register/OtherSettings": "SGXh",
		"./Poster/EditPoster/Register/OtherSettings.js": "SGXh",
		"./Poster/EditPoster/Register/RegistrationSetting": "/J0p",
		"./Poster/EditPoster/Register/RegistrationSetting.js": "/J0p",
		"./Poster/EditPoster/Register/TicketList": "0rOf",
		"./Poster/EditPoster/Register/TicketList.js": "0rOf",
		"./Poster/EditPoster/Register/TicketList.scss": "hacQ",
		"./Poster/EditPoster/Register/locale": "4208",
		"./Poster/EditPoster/Register/locale.js": "4208",
		"./Poster/EditPoster/ducks": "srt+",
		"./Poster/EditPoster/ducks.js": "srt+",
		"./Poster/EditPoster/index": "OD49",
		"./Poster/EditPoster/index.js": "OD49",
		"./Poster/EditPoster/locale": "AfbW",
		"./Poster/EditPoster/locale.js": "AfbW",
		"./Poster/Poster.scss": "d05b",
		"./Poster/PosterList/PosterCard": "xrS3",
		"./Poster/PosterList/PosterCard.js": "xrS3",
		"./Poster/PosterList/PosterCard.scss": "JJH7",
		"./Poster/PosterList/PosterList.scss": "xBPE",
		"./Poster/PosterList/index": "VBOl",
		"./Poster/PosterList/index.js": "VBOl",
		"./Poster/PosterList/locale": "wrvU",
		"./Poster/PosterList/locale.js": "wrvU",
		"./Poster/RegistrationTable/ContactName": "Q38M",
		"./Poster/RegistrationTable/ContactName.js": "Q38M",
		"./Poster/RegistrationTable/RegistrationStatus": "YiFN",
		"./Poster/RegistrationTable/RegistrationStatus.js": "YiFN",
		"./Poster/RegistrationTable/RegistrationTable.scss": "NjDa",
		"./Poster/RegistrationTable/ducks": "2yUR",
		"./Poster/RegistrationTable/ducks.js": "2yUR",
		"./Poster/RegistrationTable/index": "2DGK",
		"./Poster/RegistrationTable/index.js": "2DGK",
		"./Poster/RegistrationTable/locale": "z80C",
		"./Poster/RegistrationTable/locale.js": "z80C",
		"./Poster/RegistrationTable/table-settings": "Qq2/",
		"./Poster/RegistrationTable/table-settings.js": "Qq2/",
		"./Poster/SaasPosterPreview/SaasPosterPreview.scss": "lHNU",
		"./Poster/SaasPosterPreview/index": "NT6U",
		"./Poster/SaasPosterPreview/index.js": "NT6U",
		"./Poster/constant": "q61+",
		"./Poster/constant.js": "q61+",
		"./Poster/ducks": "W/Ox",
		"./Poster/ducks.js": "W/Ox",
		"./Poster/images/poster@2x.png": "pTVQ",
		"./Poster/images/poster_en@2x.png": "Tupr",
		"./Poster/index": "WBJk",
		"./Poster/index.js": "WBJk",
		"./PotentialClient/ClientInfoTD": "G2NP",
		"./PotentialClient/ClientInfoTD.js": "G2NP",
		"./PotentialClient/PotentialClient.scss": "PETx",
		"./PotentialClient/TagListTD": "Pn1/",
		"./PotentialClient/TagListTD.js": "Pn1/",
		"./PotentialClient/TagsField": "ITiw",
		"./PotentialClient/TagsField.js": "ITiw",
		"./PotentialClient/constant": "EjrW",
		"./PotentialClient/constant.js": "EjrW",
		"./PotentialClient/ducks": "tCuI",
		"./PotentialClient/ducks.js": "tCuI",
		"./PotentialClient/images/potential-cn.png": "bhhv",
		"./PotentialClient/images/potential-en.png": "EoL8",
		"./PotentialClient/index": "Fltp",
		"./PotentialClient/index.js": "Fltp",
		"./PotentialClient/locale": "aKPj",
		"./PotentialClient/locale.js": "aKPj",
		"./PotentialClient/table-fields": "kugd",
		"./PotentialClient/table-fields.js": "kugd",
		"./PotentialClient/table-settings": "WcKJ",
		"./PotentialClient/table-settings.js": "WcKJ",
		"./PotentialClientSettings/BasicInfo": "4UYp",
		"./PotentialClientSettings/BasicInfo.js": "4UYp",
		"./PotentialClientSettings/PotentialClientSettings.scss": "em7t",
		"./PotentialClientSettings/basicInfoFields": "Nbbr",
		"./PotentialClientSettings/basicInfoFields.js": "Nbbr",
		"./PotentialClientSettings/index": "TnzW",
		"./PotentialClientSettings/index.js": "TnzW",
		"./PotentialClientSettings/locale": "NTCD",
		"./PotentialClientSettings/locale.js": "NTCD",
		"./PrintSchedule/PrintControl": "/oro",
		"./PrintSchedule/PrintControl.js": "/oro",
		"./PrintSchedule/PrintControl.scss": "Lazm",
		"./PrintSchedule/PrintSchedule-print.scss": "IqYw",
		"./PrintSchedule/PrintSchedule.scss": "tmjJ",
		"./PrintSchedule/index": "npo+",
		"./PrintSchedule/index.js": "npo+",
		"./PrintSchedule/locale": "Y1Zm",
		"./PrintSchedule/locale.js": "Y1Zm",
		"./PrivacyPolicy/cn": "nhSS",
		"./PrivacyPolicy/cn.js": "nhSS",
		"./PrivacyPolicy/en": "WPCA",
		"./PrivacyPolicy/en.js": "WPCA",
		"./RegistrationAgreement/RegistrationAgreement.scss": "FNRm",
		"./RegistrationAgreement/index": "ArLH",
		"./RegistrationAgreement/index.js": "ArLH",
		"./RegistrationAgreement/locale": "RrvO",
		"./RegistrationAgreement/locale.js": "RrvO",
		"./Schedule/Schedule": "Ap3v",
		"./Schedule/Schedule.js": "Ap3v",
		"./Schedule/Schedule.scss": "1S4H",
		"./Schedule/Toolbar": "uZpg",
		"./Schedule/Toolbar.js": "uZpg",
		"./Schedule/convertScheduleToRbcEvents": "Bv0y",
		"./Schedule/convertScheduleToRbcEvents.js": "Bv0y",
		"./Schedule/ducks": "yhkM",
		"./Schedule/ducks.js": "yhkM",
		"./Schedule/getScheduleOption": "741Q",
		"./Schedule/getScheduleOption.js": "741Q",
		"./Schedule/index": "BU77",
		"./Schedule/index.js": "BU77",
		"./Schedule/test-events": "Zrtp",
		"./Schedule/test-events.js": "Zrtp",
		"./SchoolInformation/SchoolInformation": "C8DA",
		"./SchoolInformation/SchoolInformation.js": "C8DA",
		"./SchoolInformation/SchoolInformationForm": "HHty",
		"./SchoolInformation/SchoolInformationForm.js": "HHty",
		"./SchoolInformation/SchoolInformationForm.scss": "1rEC",
		"./SchoolInformation/index": "Hq4q",
		"./SchoolInformation/index.js": "Hq4q",
		"./SchoolSettings/Permissions/Permissions.scss": "aSEF",
		"./SchoolSettings/Permissions/index": "eCVO",
		"./SchoolSettings/Permissions/index.js": "eCVO",
		"./SchoolSettings/Permissions/locale": "mLe8",
		"./SchoolSettings/Permissions/locale.js": "mLe8",
		"./SchoolSettings/index": "8y+r",
		"./SchoolSettings/index.js": "8y+r",
		"./SchoolSettings/locale": "e4m9",
		"./SchoolSettings/locale.js": "e4m9",
		"./Student/DefaultTab": "+mk/",
		"./Student/DefaultTab.js": "+mk/",
		"./Student/Student.scss": "S5pW",
		"./Student/StudentTable/ClassInfoTd": "n5V7",
		"./Student/StudentTable/ClassInfoTd.js": "n5V7",
		"./Student/StudentTable/ClassStatusTd": "e/Ic",
		"./Student/StudentTable/ClassStatusTd.js": "e/Ic",
		"./Student/StudentTable/PaymentTd": "u5QA",
		"./Student/StudentTable/PaymentTd.js": "u5QA",
		"./Student/StudentTable/StudentInfoTd": "0vxt",
		"./Student/StudentTable/StudentInfoTd.js": "0vxt",
		"./Student/StudentTable/index": "8JRb",
		"./Student/StudentTable/index.js": "8JRb",
		"./Student/StudentTable/student-table.scss": "A9k/",
		"./Student/archive-student": "GDgk",
		"./Student/archive-student.js": "GDgk",
		"./Student/constants": "AvVx",
		"./Student/constants.js": "AvVx",
		"./Student/ducks": "Qttv",
		"./Student/ducks.js": "Qttv",
		"./Student/enroll-student-to-class": "PhAh",
		"./Student/enroll-student-to-class.js": "PhAh",
		"./Student/exit-class": "YFf2",
		"./Student/exit-class.js": "YFf2",
		"./Student/hotline": "Ywk3",
		"./Student/hotline.js": "Ywk3",
		"./Student/images/student@2x.png": "etGk",
		"./Student/images/student_en@2x.png": "tfRU",
		"./Student/index": "7No8",
		"./Student/index.js": "7No8",
		"./Student/locale": "aMEQ",
		"./Student/locale.js": "aMEQ",
		"./Student/payment": "PWBe",
		"./Student/payment.js": "PWBe",
		"./Student/refund": "qP8b",
		"./Student/refund.js": "qP8b",
		"./Student/student-table-field": "27cS",
		"./Student/student-table-field.js": "27cS",
		"./Student/table-settings": "nQH9",
		"./Student/table-settings.js": "nQH9",
		"./Student/unarchive-student": "JMLs",
		"./Student/unarchive-student.js": "JMLs",
		"./StudentSettings/BasicInfo": "psoL",
		"./StudentSettings/BasicInfo.js": "psoL",
		"./StudentSettings/StudentSettings.scss": "xv0/",
		"./StudentSettings/basicInfoFields": "jAvG",
		"./StudentSettings/basicInfoFields.js": "jAvG",
		"./StudentSettings/index": "ai00",
		"./StudentSettings/index.js": "ai00",
		"./StudentSettings/locale": "NFNt",
		"./StudentSettings/locale.js": "NFNt",
		"./Teacher/Attendance/AttendTime": "dg0h",
		"./Teacher/Attendance/AttendTime.js": "dg0h",
		"./Teacher/Attendance/Attendance": "gjj1",
		"./Teacher/Attendance/Attendance.js": "gjj1",
		"./Teacher/Attendance/AttendanceLessonTime": "4Kje",
		"./Teacher/Attendance/AttendanceLessonTime.js": "4Kje",
		"./Teacher/Attendance/AttendanceStatus": "zeU0",
		"./Teacher/Attendance/AttendanceStatus.js": "zeU0",
		"./Teacher/Attendance/attendance.scss": "sfhh",
		"./Teacher/Attendance/ducks": "vw3Y",
		"./Teacher/Attendance/ducks.js": "vw3Y",
		"./Teacher/Attendance/index": "2Mtk",
		"./Teacher/Attendance/index.js": "2Mtk",
		"./Teacher/Attendance/locale": "wqLs",
		"./Teacher/Attendance/locale.js": "wqLs",
		"./Teacher/DefaultTab": "Avda",
		"./Teacher/DefaultTab.js": "Avda",
		"./Teacher/Teacher.scss": "zMdR",
		"./Teacher/TeacherTable/TeacherNameTd": "4OTs",
		"./Teacher/TeacherTable/TeacherNameTd.js": "4OTs",
		"./Teacher/TeacherTable/TeacherStatusTd": "KpAq",
		"./Teacher/TeacherTable/TeacherStatusTd.js": "KpAq",
		"./Teacher/TeacherTable/TeacherTable.scss": "2rzK",
		"./Teacher/TeacherTable/index": "+FMu",
		"./Teacher/TeacherTable/index.js": "+FMu",
		"./Teacher/constant": "wCrB",
		"./Teacher/constant.js": "wCrB",
		"./Teacher/ducks": "yDaX",
		"./Teacher/ducks.js": "yDaX",
		"./Teacher/images/teacher@2x.png": "iITC",
		"./Teacher/images/teacher_en@2x.png": "hvBK",
		"./Teacher/index": "BTGU",
		"./Teacher/index.js": "BTGU",
		"./Teacher/locale": "+Qis",
		"./Teacher/locale.js": "+Qis",
		"./Teacher/table-settings": "dwer",
		"./Teacher/table-settings.js": "dwer",
		"./TeacherCareer/TeacherCareer.scss": "xIJ8",
		"./TeacherCareer/index": "NlCa",
		"./TeacherCareer/index.js": "NlCa",
		"./TeacherCareer/locale": "kqyU",
		"./TeacherCareer/locale.js": "kqyU",
		"./UILibrary/example/data": "nDiK",
		"./UILibrary/example/data.js": "nDiK",
		"./UILibrary/example/field": "vjG/",
		"./UILibrary/example/field.js": "vjG/",
		"./UILibrary/index": "2+Qn",
		"./UILibrary/index.js": "2+Qn",
		"./Upgrade/Upgrade.scss": "P1vu",
		"./Upgrade/images/community.jpg": "mwYU",
		"./Upgrade/images/handshake.jpg": "xZ00",
		"./Upgrade/index": "KV/b",
		"./Upgrade/index.js": "KV/b",
		"./WaitingList/WaitingList.scss": "FE8H",
		"./WaitingList/index": "AUQq",
		"./WaitingList/index.js": "AUQq",
		"./WaitingList/locale": "Dqj5",
		"./WaitingList/locale.js": "Dqj5",
		"./Website/AddComponent/AddComponent.scss": "IMk+",
		"./Website/AddComponent/index": "WHlH",
		"./Website/AddComponent/index.js": "WHlH",
		"./Website/AddComponent/locale": "eYxN",
		"./Website/AddComponent/locale.js": "eYxN",
		"./Website/ComponentEditor/ComponentEditor.scss": "pPi2",
		"./Website/ComponentEditor/index": "pxxT",
		"./Website/ComponentEditor/index.js": "pxxT",
		"./Website/ComponentEditor/locale": "O9nS",
		"./Website/ComponentEditor/locale.js": "O9nS",
		"./Website/EditPageOnSideMenu/EditPageOnSideMenu.scss": "lGU1",
		"./Website/EditPageOnSideMenu/index": "y9jc",
		"./Website/EditPageOnSideMenu/index.js": "y9jc",
		"./Website/EditPageOnSideMenu/locale": "ro1o",
		"./Website/EditPageOnSideMenu/locale.js": "ro1o",
		"./Website/NavSetting/NavSetting.scss": "H94+",
		"./Website/NavSetting/index": "CUBd",
		"./Website/NavSetting/index.js": "CUBd",
		"./Website/PageEditor/PageEditor.scss": "O2q3",
		"./Website/PageEditor/index": "qZd9",
		"./Website/PageEditor/index.js": "qZd9",
		"./Website/PageEditor/locale": "bsDf",
		"./Website/PageEditor/locale.js": "bsDf",
		"./Website/Preview/Preview.scss": "aDmQ",
		"./Website/Preview/index": "/OJU",
		"./Website/Preview/index.js": "/OJU",
		"./Website/SelectTheme/SelectTheme.scss": "Ao9G",
		"./Website/SelectTheme/images/theme1.jpg": "7yNn",
		"./Website/SelectTheme/index": "u3wL",
		"./Website/SelectTheme/index.js": "u3wL",
		"./Website/ThemeSetting/ThemeSetting.scss": "d2qg",
		"./Website/ThemeSetting/index": "ZtKT",
		"./Website/ThemeSetting/index.js": "ZtKT",
		"./Website/Website.scss": "D/tK",
		"./Website/WebsiteSetting/WebsiteSetting.scss": "sKzI",
		"./Website/WebsiteSetting/index": "DEdD",
		"./Website/WebsiteSetting/index.js": "DEdD",
		"./Website/WebsiteSideMenu/MultiLevelSideMenu.scss": "eSMJ",
		"./Website/WebsiteSideMenu/index": "fU3o",
		"./Website/WebsiteSideMenu/index.js": "fU3o",
		"./Website/defaultSettingSchema": "Wa4b",
		"./Website/defaultSettingSchema.js": "Wa4b",
		"./Website/index": "zRW5",
		"./Website/index.js": "zRW5",
		"./Website/locale": "aEdv",
		"./Website/locale.js": "aEdv"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 5;


/***/ },

/***/ "w2MC":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"announcement-container":"announcement-container","Select--single":"Select--single","react-tabs__tab-list":"react-tabs__tab-list","sort-by":"sort-by","sort-by-label":"sort-by-label","createBtn":"createBtn"};

/***/ },

/***/ "UXfg":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _locale = __webpack_require__("m3Lh");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	var _Announcement = __webpack_require__("j/11");
	
	var _Announcement2 = _interopRequireDefault(_Announcement);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	__webpack_require__("cNYk");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnnouncementCard = function (_React$Component) {
	  _inherits(AnnouncementCard, _React$Component);
	
	  function AnnouncementCard(props) {
	    _classCallCheck(this, AnnouncementCard);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  AnnouncementCard.prototype.renderSendTo = function renderSendTo() {
	    var data = this.props.data;
	    var send_to = data.send_to;
	
	
	    if (send_to == 'all') {
	      return __('All Teachers and Students', _locale2.default);
	    } else {
	      return send_to.map(function (cls, index) {
	        return _react2.default.createElement(
	          'span',
	          { key: index, className: 'send-to-name' },
	          cls.class_name
	        );
	      });
	    }
	  };
	
	  AnnouncementCard.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        deleteAnnouncement = _props.deleteAnnouncement,
	        updateAnnouncement = _props.updateAnnouncement,
	        announcementState = _props.announcementState;
	    var title = data.title,
	        creator_name = data.creator_name,
	        created_at = data.created_at,
	        updated_at = data.updated_at,
	        content = data.content,
	        send_to = data.send_to,
	        id = data.id,
	        state = data.state;
	
	    var publishedTime = (0, _moment2.default)(created_at).format(__('MMM DD, YYYY', _locale2.default));
	    var cardState = state == 0 ? 'draft' : 'published';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'announcement-card-list' },
	      _react2.default.createElement(
	        'div',
	        { className: 'card', onClick: function onClick() {
	            var class_id_list = void 0;
	            if (send_to == 'all') {
	              class_id_list = 'all';
	            } else {
	              class_id_list = [];
	              send_to.map(function (cls) {
	                class_id_list.push(cls.class_id);
	              });
	            }
	            if (state == 0) {
	              if ((0, _R.userCan)('edit_announcement')) {
	                (0, _Announcement2.default)({ data: data, class_id_list: class_id_list, allowEdit: true });
	              } else {
	                _alert.alert.warning(__('You do not have permission to edit announcement', _locale2.default)).then(function () {}).catch(function () {});
	              }
	            } else {
	              (0, _Announcement2.default)({ data: data, class_id_list: class_id_list, allowEdit: false });
	            }
	          } },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            title
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'publish-info' },
	          _react2.default.createElement(
	            'span',
	            null,
	            __('Publisher: {name}', _locale2.default, { name: creator_name })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'date' },
	            __('Published Time: {time}', _locale2.default, { time: publishedTime })
	          )
	        ),
	        _react2.default.createElement('div', { className: 'content', dangerouslySetInnerHTML: { __html: content } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-footer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'send-to' },
	            __('Send To: ', _locale2.default),
	            this.renderSendTo()
	          ),
	          state == 0 && _react2.default.createElement(
	            _R2.default,
	            { can: 'delete_announcement', by: 'alert' },
	            _react2.default.createElement('i', { className: 'fa icon-trash pull-right', onClick: function onClick(e) {
	                e.stopPropagation();
	
	                (0, _confirm.confirm)(__('Proceed to delete announcement?', _locale2.default)).then(function () {
	                  deleteAnnouncement(id);
	                }).catch(function (err) {});
	              } })
	          ),
	          state == 0 && _react2.default.createElement(
	            _R2.default,
	            { can: 'edit_announcement', by: 'alert' },
	            _react2.default.createElement(
	              'button',
	              { className: 'send-btn pull-right', onClick: function onClick(e) {
	                  e.stopPropagation();
	
	                  var class_id_list = void 0;
	                  if (send_to == 'all') {
	                    class_id_list = 'all';
	                  } else {
	                    class_id_list = [];
	                    send_to.map(function (cls) {
	                      class_id_list.push(cls.class_id);
	                    });
	                  }
	
	                  (0, _confirm.confirm)(__('Proceed to publish announcement?', _locale2.default)).then(function () {
	                    updateAnnouncement(id, { send_to: 'all', class_id_list: class_id_list, title: title, content: content, state: 'published' });
	                  }).catch(function (err) {});
	                } },
	              __('Send', _locale2.default)
	            )
	          ),
	          state == 1 && _react2.default.createElement(
	            'span',
	            { className: 'pull-right sent' },
	            __('Sent', _locale2.default)
	          )
	        )
	      )
	    );
	  };
	
	  return AnnouncementCard;
	}(_react2.default.Component);
	
	exports.default = AnnouncementCard;
	module.exports = exports['default'];

/***/ },

/***/ "m3Lh":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'AnnouncementPage',
	  code: 'CN',
	  text: {
	    'Announcement List': '公告列表',
	    'Search Announcement': '搜索公告',
	    'All': '全部公告',
	    'Published': '已发布公告',
	    'Draft': '草稿公告',
	    'New Announcement': '新建公告',
	    'MMM DD, YYYY': 'YYYY年MM月DD日',
	    'ddd, MMM DD YYYY': 'YYYY年MM月DD日ddd',
	    'Publisher: {name}': '发布者：{name}',
	    'Published Time: {time}': '发布时间：{time}',
	    'Proceed to delete announcement?': '确认删除公告？',
	    'All Teachers and Students': '全体师生',
	    'Send To: ': '发送至：',
	    'Proceed to publish announcement?': '确认发布公告？',
	    'Search by title': '请输入公告标题搜索',
	    'Send': '发送',
	    'Sent': '已发送',
	    'You do not have permission to edit announcement': '您无权修改公告',
	    'Sort by': '排序',
	    'Creation Time: Newest to Oldest': '按创建时间：由新到旧',
	    'Creation Time: Oldest to Newest': '按创建时间：由旧到新'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "cNYk":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"announcement-card-container":"announcement-card-container","announcement-card-list":"announcement-card-list","card":"card","content":"content","title":"title","publish-info":"publish-info","date":"date","send-to":"send-to","icon-trash":"icon-trash","icon-pencil":"icon-pencil","icon-mail":"icon-mail","send-to-name":"send-to-name","title-draft":"title-draft","title-publish":"title-publish","card-footer":"card-footer","sent":"sent","send-btn":"send-btn"};

/***/ },

/***/ "rhuv":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _OnBoardingNatural = __webpack_require__("PwUp");
	
	var _OnBoardingNatural2 = _interopRequireDefault(_OnBoardingNatural);
	
	var _constant = __webpack_require__("ENiu");
	
	var _getAnnouncementList = __webpack_require__("sYDS");
	
	var _deleteAnnouncement2 = __webpack_require__("y2+x");
	
	var _updateAnnouncement2 = __webpack_require__("eVF0");
	
	var _AnnouncementCard = __webpack_require__("UXfg");
	
	var _AnnouncementCard2 = _interopRequireDefault(_AnnouncementCard);
	
	var _reactJsPagination = __webpack_require__("bgMy");
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	__webpack_require__("w2MC");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var itemsCountPerPage = 12;
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    announcementList: state.announcementList,
	    currentTabState: state.announcementList.currentTabState
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchAnnouncementList: function fetchAnnouncementList(schoolId, param, amount_per_page, page_number, state, order_by, title_keyword) {
	      return dispatch((0, _getAnnouncementList.fetchAnnouncementList)(schoolId, param, amount_per_page, page_number, state, order_by, title_keyword));
	    },
	    deleteAnnouncement: function deleteAnnouncement(announcementId, currentTabState) {
	      return dispatch((0, _deleteAnnouncement2.deleteAnnouncement)(announcementId, currentTabState));
	    },
	    updateAnnouncement: function updateAnnouncement(announcementId, announcementInfo, currentTabState) {
	      return dispatch((0, _updateAnnouncement2.updateAnnouncement)(announcementId, announcementInfo, currentTabState));
	    }
	  };
	};
	
	var DefaultTab = function (_Component) {
	  _inherits(DefaultTab, _Component);
	
	  function DefaultTab(props) {
	    _classCallCheck(this, DefaultTab);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      activePage: 1
	    };
	
	    _this.handlePageChange = _this.handlePageChange.bind(_this);
	    return _this;
	  }
	
	  DefaultTab.prototype.componentWillMount = function componentWillMount() {
	    var _props = this.props,
	        announcementState = _props.announcementState,
	        orderBy = _props.orderBy,
	        keyword = _props.keyword;
	    var activePage = this.state.activePage;
	
	    var schoolId = localStorage.getItem('schoolId');
	    if (announcementState == 'all') {
	      this.props.fetchAnnouncementList({ schoolId: Number(schoolId), param: 'all', amount_per_page: itemsCountPerPage, page_number: activePage, order_by: orderBy, title_keyword: keyword });
	    } else {
	      this.props.fetchAnnouncementList({ schoolId: Number(schoolId), param: 'all', amount_per_page: itemsCountPerPage, page_number: activePage, state: announcementState, order_by: orderBy, title_keyword: keyword });
	    }
	  };
	
	  DefaultTab.prototype.handlePageChange = function handlePageChange(pageNumber) {
	    var _props2 = this.props,
	        announcementState = _props2.announcementState,
	        orderBy = _props2.orderBy,
	        keyword = _props2.keyword;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    this.setState({ activePage: pageNumber });
	    if (announcementState == 'all') {
	      this.props.fetchAnnouncementList({ schoolId: Number(schoolId), param: 'all', amount_per_page: itemsCountPerPage, page_number: pageNumber, order_by: orderBy, title_keyword: keyword });
	    } else {
	      this.props.fetchAnnouncementList({ schoolId: Number(schoolId), param: 'all', amount_per_page: itemsCountPerPage, page_number: pageNumber, state: announcementState, order_by: orderBy, title_keyword: keyword });
	    }
	  };
	
	  DefaultTab.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props3 = this.props,
	        announcementList = _props3.announcementList,
	        announcementState = _props3.announcementState;
	    var list = announcementList.list,
	        fetching = announcementList.fetching,
	        count = announcementList.count,
	        hasPermission = announcementList.hasPermission,
	        school_has_announcement = announcementList.school_has_announcement;
	
	    var content = _constant.onBoardingContents[announcementState];
	    var activePage = this.state.activePage;
	
	
	    if (fetching) {
	      return _react2.default.createElement(_Loading2.default, null);
	    }
	
	    if (school_has_announcement == false && content || !hasPermission) {
	      return _react2.default.createElement(_OnBoardingNatural2.default, { isShown: true, title: content.title, text: content.text, image: content.image, showArrow: content.showArrow });
	    } else {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'row announcement-card-container' },
	          list.map(function (announcement, index) {
	            return _react2.default.createElement(_AnnouncementCard2.default, {
	              key: index,
	              data: announcement,
	              deleteAnnouncement: function deleteAnnouncement(announcementId) {
	                _this2.props.deleteAnnouncement(announcementId, _this2.props.currentTabState);
	              },
	              updateAnnouncement: function updateAnnouncement(announcementId, announcementInfo) {
	                _this2.props.updateAnnouncement(announcementId, announcementInfo, _this2.props.currentTabState);
	              },
	              announcementState: announcementState
	            });
	          })
	        ),
	        _react2.default.createElement(_reactJsPagination2.default, {
	          innerClass: 'pagination pull-right',
	          activePage: activePage,
	          itemsCountPerPage: itemsCountPerPage,
	          totalItemsCount: count,
	          pageRangeDisplayed: 5,
	          onChange: this.handlePageChange
	        })
	      );
	    }
	  };
	
	  return DefaultTab;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DefaultTab);
	module.exports = exports['default'];

/***/ },

/***/ "ENiu":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var locale = {
	  id: 'AnnouncementConstant',
	  code: 'CN',
	  text: {
	    "./images/Announcement_en@2x.png": "./images/Announcement.png",
	    'Automatic Mailing (to students) and SMS (to teachers) Announcement System': '自动发邮件（针对学员）与短信（针对老师）的公告系统',
	    'Here you can create announcements for all teachers and students, as well as specific classes. When the announcement is published, the system will automatically send the announcement via email to students and SMS to teachers': '在这里您可以创建针对全体老师和学生的公告，也可针对指定班级发布公告。在您创建的公告发布的时候，系统会自动将公告内容给学生发邮件、给老师发手机短信。'
	  }
	};
	
	var onBoardingContents = exports.onBoardingContents = {
	  // we show this when student state is 'current'
	  all: {
	    title: __('Automatic Mailing (to students) and SMS (to teachers) Announcement System', locale),
	    text: __('Here you can create announcements for all teachers and students, as well as specific classes. When the announcement is published, the system will automatically send the announcement via email to students and SMS to teachers', locale),
	    image: __webpack_require__(6)(__('./images/Announcement_en@2x.png', locale)),
	    showArrow: true
	  }
	};

/***/ },

/***/ 6:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./Announcement.scss": "w2MC",
		"./AnnouncementCard": "UXfg",
		"./AnnouncementCard.js": "UXfg",
		"./AnnouncementCard.scss": "cNYk",
		"./DefaultTab": "rhuv",
		"./DefaultTab.js": "rhuv",
		"./constant": "ENiu",
		"./constant.js": "ENiu",
		"./images/Announcement.png": "JsbR",
		"./images/Announcement_en@2x.png": "z9ID",
		"./index": "9ZkX",
		"./index.js": "9ZkX",
		"./locale": "m3Lh",
		"./locale.js": "m3Lh",
		"./redux/actions/addAnnouncement": "/Cga",
		"./redux/actions/addAnnouncement.js": "/Cga",
		"./redux/actions/deleteAnnouncement": "y2+x",
		"./redux/actions/deleteAnnouncement.js": "y2+x",
		"./redux/actions/getAnnouncementList": "sYDS",
		"./redux/actions/getAnnouncementList.js": "sYDS",
		"./redux/actions/searchAnnouncement": "EV0/",
		"./redux/actions/searchAnnouncement.js": "EV0/",
		"./redux/actions/setCurrentTabState": "d4iu",
		"./redux/actions/setCurrentTabState.js": "d4iu",
		"./redux/actions/updateAnnouncement": "eVF0",
		"./redux/actions/updateAnnouncement.js": "eVF0",
		"./redux/reducer": "pzkK",
		"./redux/reducer.js": "pzkK"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 6;


/***/ },

/***/ "JsbR":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Announcement.13d6e068.png";

/***/ },

/***/ "z9ID":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Announcement_en@2x.bb69cbf8.png";

/***/ },

/***/ "9ZkX":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DefaultTab = __webpack_require__("rhuv");
	
	var _DefaultTab2 = _interopRequireDefault(_DefaultTab);
	
	var _locale = __webpack_require__("m3Lh");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _Announcement = __webpack_require__("j/11");
	
	var _Announcement2 = _interopRequireDefault(_Announcement);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _searchAnnouncement2 = __webpack_require__("EV0/");
	
	var _getAnnouncementList = __webpack_require__("sYDS");
	
	var _setCurrentTabState2 = __webpack_require__("d4iu");
	
	var _searchAnnouncement3 = __webpack_require__("ujpM");
	
	var _searchAnnouncement4 = _interopRequireDefault(_searchAnnouncement3);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _FilterBy = __webpack_require__("SdD8");
	
	var _FilterBy2 = _interopRequireDefault(_FilterBy);
	
	__webpack_require__("w2MC");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tabNames = ['all', 'published', 'draft'];
	var FILTERS = ['text:searchKeyword'];
	
	var FILTER_OPTIONS = {
	  'text:searchKeyword': {
	    placeholder: __('Search Announcement', _locale2.default),
	    valueMinLength: 2
	  }
	};
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentTabState: state.announcementList.currentTabState
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchAnnouncementList: function fetchAnnouncementList(schoolId, param, amount_per_page, page_number, state, order_by, title_keyword) {
	      return dispatch((0, _getAnnouncementList.fetchAnnouncementList)(schoolId, param, amount_per_page, page_number, state, order_by, title_keyword));
	    },
	    searchAnnouncement: function searchAnnouncement(schoolId, param, amount_per_page, page_number, state, title_keyword) {
	      return dispatch((0, _searchAnnouncement2.searchAnnouncement)(schoolId, param, amount_per_page, page_number, state, title_keyword));
	    },
	    setCurrentTabState: function setCurrentTabState(currentTabState) {
	      return dispatch((0, _setCurrentTabState2.setCurrentTabState)(currentTabState));
	    }
	  };
	};
	
	var Announcement = function (_Component) {
	  _inherits(Announcement, _Component);
	
	  function Announcement(props) {
	    _classCallCheck(this, Announcement);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      options: [],
	      tabIndex: 0,
	      orderBy: 0,
	      filterData: {},
	      keyword: '',
	      pagination: {
	        activePage: 1
	      }
	    };
	    _this.onFilterChange = _this.onFilterChange.bind(_this);
	    (0, _setCurrentTabState2.setCurrentTabState)({ tabName: 'all', tabIndex: 0 });
	    return _this;
	  }
	
	  Announcement.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.currentTabState !== nextProps.currentTabState) {
	      this.setState({ tabIndex: nextProps.currentTabState.tabIndex });
	    }
	  };
	
	  // onOptionSelected(data){
	  //   const schoolId = localStorage.getItem('schoolId')
	  //   const { tabIndex } = this.state;
	  //   if(!data){
	  //     this.setState({selectedOption: ''})
	  //     if(tabNames[tabIndex] !== 'all') {
	  //       return this.props.fetchAnnouncementList({schoolId: Number(schoolId), param: 'all', state: tabNames[tabIndex], amount_per_page: 12, page_number: 1})
	  //     }else {
	  //       return this.props.fetchAnnouncementList({schoolId: Number(schoolId), param: 'all', amount_per_page: 12, page_number: 1})
	  //     }
	  //   }
	
	  //   this.setState({selectedOption: data})
	  //   if(tabNames[tabIndex] !== 'all') {
	  //     this.props.searchAnnouncement({schoolId: Number(schoolId), param: 'all', amount_per_page:12, page_number: 1, state: tabNames[tabIndex], title_keyword: data.label})
	  //   }else {
	  //     this.props.searchAnnouncement({schoolId: Number(schoolId), param: 'all', amount_per_page:12, page_number: 1, title_keyword: data.label})
	  //   }
	  //   this.setState({options: []})
	  // }
	
	  // onInputChange(value){
	  //   const schoolId = localStorage.getItem('schoolId')
	  //   const {tabIndex} = this.state;
	  //   if(value == ''){
	  //     return value
	  //   }
	  //   if(tabNames[tabIndex] !== 'all') {
	  //     searchAnnouncementCTRL({schoolId: Number(schoolId), param: 'all', amount_per_page:50, page_number: 1, state: tabNames[tabIndex], title_keyword: value})
	  //     .then((res) => {
	  //       if(res.result_list){
	  //         let options = []
	  //         res.result_list.map((announcement) => {
	  //           options.push({value: announcement.id, label: announcement.title})
	  //         })
	  //         this.setState({options})
	  //       }
	  //     })
	  //   }else {
	  //     searchAnnouncementCTRL({schoolId: Number(schoolId), param: 'all', amount_per_page:50, page_number: 1, title_keyword: value})
	  //     .then((res) => {
	  //       if(res.result_list){
	  //         let options = []
	  //         res.result_list.map((announcement) => {
	  //           options.push({value: announcement.id, label: announcement.title})
	  //         })
	  //         this.setState({options})
	  //       }
	  //     })
	  //   }
	  // }
	
	  Announcement.prototype.onTabChange = function onTabChange(tabIndex) {
	    var setCurrentTabState = this.props.setCurrentTabState;
	    var orderBy = this.state.orderBy;
	
	
	    var tabName = void 0;
	    if (tabIndex === 0) {
	      tabName = 'all';
	    } else if (tabIndex === 1) {
	      tabName = 'published';
	    } else {
	      tabName = 'draft';
	    }
	    setCurrentTabState({ tabName: tabName, tabIndex: tabIndex });
	    this.setState({
	      orderBy: orderBy,
	      filterData: _extends({}, this.state.filterData, {
	        searchKeyword: ''
	      }),
	      keyword: ''
	    });
	  };
	
	  Announcement.prototype.onFilterChange = function onFilterChange(_ref) {
	    var _this2 = this;
	
	    var filterData = _ref.filterData;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _state = this.state,
	        orderBy = _state.orderBy,
	        tabIndex = _state.tabIndex;
	
	
	    this.setState({
	      filterData: filterData,
	      keyword: filterData['searchKeyword']
	    }, function () {
	      _this2.props.fetchAnnouncementList({
	        schoolId: Number(schoolId),
	        param: 'all',
	        state: tabNames[tabIndex],
	        amount_per_page: 12,
	        page_number: 1,
	        order_by: orderBy,
	        title_keyword: _this2.state.keyword
	      });
	    });
	  };
	
	  Announcement.prototype.render = function render() {
	    var _this3 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _state2 = this.state,
	        tabIndex = _state2.tabIndex,
	        filterData = _state2.filterData,
	        pagination = _state2.pagination,
	        keyword = _state2.keyword;
	
	
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      { className: 'announcement-container' },
	      _react2.default.createElement(
	        'div',
	        null,
	        __("Announcement List", _locale2.default)
	      ),
	      _react2.default.createElement(
	        _UI.Tabs,
	        { selectedIndex: tabIndex, onSelect: function onSelect(tabIndex) {
	            return _this3.onTabChange(tabIndex);
	          } },
	        _react2.default.createElement(
	          _UI.TabList,
	          null,
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('All', _locale2.default)
	          ),
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('Published', _locale2.default)
	          ),
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('Draft', _locale2.default)
	          ),
	          _react2.default.createElement(
	            _R2.default,
	            { can: 'create_announcement', by: 'disable' },
	            _react2.default.createElement(
	              'button',
	              { bsStyle: 'primary', className: 'btn btn-primary pull-right createBtn', onClick: function onClick() {
	                  (0, _Announcement2.default)({ allowEdit: true }).then(function () {
	                    _this3.setState({
	                      filterData: _extends({}, _this3.state.filterData, {
	                        searchKeyword: ''
	                      }),
	                      keyword: ''
	                    }, function () {
	                      _this3.props.fetchAnnouncementList({
	                        schoolId: Number(schoolId),
	                        param: 'all',
	                        state: tabNames[tabIndex],
	                        amount_per_page: 12,
	                        page_number: 1,
	                        order_by: _this3.state.orderBy
	                      });
	                    });
	                  });
	                } },
	              __("New Announcement", _locale2.default)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-right' },
	            _react2.default.createElement(_FilterBy2.default, {
	              filterData: filterData,
	              filters: FILTERS,
	              options: FILTER_OPTIONS,
	              onChange: this.onFilterChange })
	          ),
	          _react2.default.createElement(
	            'select',
	            { className: 'form-control sort-by pull-right', value: this.state.orderBy, onChange: function onChange(e) {
	                _this3.setState({ orderBy: e.target.value }, function () {
	                  _this3.props.fetchAnnouncementList({
	                    schoolId: Number(schoolId),
	                    param: 'all',
	                    state: tabNames[tabIndex],
	                    amount_per_page: 12,
	                    page_number: 1,
	                    order_by: _this3.state.orderBy,
	                    title_keyword: keyword
	                  });
	                });
	              } },
	            _react2.default.createElement(
	              'option',
	              { key: '0', value: '0' },
	              __('Creation Time: Newest to Oldest', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'option',
	              { key: '1', value: '1' },
	              __('Creation Time: Oldest to Newest', _locale2.default)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-right sort-by-label' },
	            __('Sort by', _locale2.default)
	          )
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { announcementState: 'all', orderBy: this.state.orderBy, pagination: pagination, keyword: keyword })
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { announcementState: 'published', orderBy: this.state.orderBy, pagination: pagination, keyword: keyword })
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { announcementState: 'draft', orderBy: this.state.orderBy, pagination: pagination, keyword: keyword })
	        )
	      )
	    );
	  };
	
	  return Announcement;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Announcement);
	module.exports = exports['default'];

/***/ },

/***/ "y2+x":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_DELETE_ANNOUNCEMENT = exports.SUCCESS_DELETE_ANNOUNCEMENT = exports.START_DELETE_ANNOUNCEMENT = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Import controller
	
	
	exports.deleteAnnouncement = deleteAnnouncement;
	
	var _deleteAnnouncement = __webpack_require__("p4yS");
	
	var _deleteAnnouncement2 = _interopRequireDefault(_deleteAnnouncement);
	
	var _getAnnouncementList = __webpack_require__("sYDS");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	var START_DELETE_ANNOUNCEMENT = exports.START_DELETE_ANNOUNCEMENT = 'START_DELETE_ANNOUNCEMENT';
	var SUCCESS_DELETE_ANNOUNCEMENT = exports.SUCCESS_DELETE_ANNOUNCEMENT = 'SUCCESS_DELETE_ANNOUNCEMENT';
	var FAILED_DELETE_ANNOUNCEMENT = exports.FAILED_DELETE_ANNOUNCEMENT = 'FAILED_DELETE_ANNOUNCEMENT';
	
	var schoolId = localStorage.getItem('schoolId');
	// Action Creator
	function deleteAnnouncement(announcementId, currentTabState) {
	  return function (dispatch) {
	
	    dispatch({
	      type: START_DELETE_ANNOUNCEMENT,
	      payload: { deleting: true }
	    });
	
	    (0, _deleteAnnouncement2.default)(announcementId).then(function (result) {
	      dispatch({
	        type: SUCCESS_DELETE_ANNOUNCEMENT,
	        payload: _extends({}, result, { deleting: false })
	      });
	      if (currentTabState.tabName === 'draft') {
	        dispatch((0, _getAnnouncementList.fetchAnnouncementList)({ schoolId: Number(schoolId), param: 'all', amount_per_page: 12, page_number: 1, state: currentTabState.tabName }));
	      } else {
	        dispatch((0, _getAnnouncementList.fetchAnnouncementList)({ schoolId: Number(schoolId), param: 'all', amount_per_page: 12, page_number: 1 }));
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_DELETE_ANNOUNCEMENT,
	        payload: err
	      });
	    });
	  };
	}

/***/ },

/***/ "p4yS":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = deleteAnnouncement;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deleteAnnouncement(announcementId) {
	
	  if (!announcementId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing announcement Id')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/announcement_detail/" + announcementId + "/",
	      'method': 'DELETE',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "aCad":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"class-container":"class-container","Select--single":"Select--single","react-tabs__tab-list":"react-tabs__tab-list","icon-info-circled":"icon-info-circled","sort-by":"sort-by","sort-by-label":"sort-by-label","createBtn":"createBtn"};

/***/ },

/***/ "pxBc":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassDateTd = function (_Component) {
	  _inherits(ClassDateTd, _Component);
	
	  function ClassDateTd(props) {
	    _classCallCheck(this, ClassDateTd);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  ClassDateTd.prototype.render = function render() {
	    var classInfo = this.props.classInfo;
	    var earliest_date = classInfo.earliest_date,
	        latest_date = classInfo.latest_date;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'class-date' },
	      earliest_date && latest_date && _react2.default.createElement(
	        'span',
	        null,
	        earliest_date,
	        ' - ',
	        latest_date
	      )
	    );
	  };
	
	  return ClassDateTd;
	}(_react.Component);
	
	exports.default = ClassDateTd;
	module.exports = exports['default'];

/***/ },

/***/ "SsX8":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _reactTooltip = __webpack_require__("Hh2+");
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _locale = __webpack_require__("4A/Z");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassNameTd = function (_Component) {
	  _inherits(ClassNameTd, _Component);
	
	  function ClassNameTd(props) {
	    _classCallCheck(this, ClassNameTd);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  ClassNameTd.prototype.render = function render() {
	    var classInfo = this.props.classInfo;
	    var className = classInfo.className,
	        classID = classInfo.classID,
	        consumption_type = classInfo.consumption_type;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'class-status' },
	      _react2.default.createElement(
	        'button',
	        { className: 'btn-link', onClick: function onClick() {
	            return _reactRouter.browserHistory.push('/class-detail/' + classID);
	          }, disabled: !(0, _R.userCan)('read_class_detail') },
	        className
	      ),
	      !consumption_type && _react2.default.createElement(
	        'i',
	        { className: 'fa icon-info-circled', 'data-tip': true, 'data-for': toString(classID) },
	        _react2.default.createElement(_reactTooltip2.default, {
	          id: toString(classID),
	          effect: 'solid',
	          place: 'right',
	          type: 'info',
	          getContent: function getContent() {
	            return __('We have upgraded our class functionality, please set class tuition fee to facilitate the statistics of tuition consumption', _locale2.default);
	          }
	        })
	      )
	    );
	  };
	
	  return ClassNameTd;
	}(_react.Component);
	
	exports.default = ClassNameTd;
	module.exports = exports['default'];

/***/ },

/***/ "4A/Z":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'ClassPage',
	  code: 'CN',
	  text: {
	    'Search Class': '搜索班级名称',
	    "We have upgraded our class functionality, please set class tuition fee to facilitate the statistics of tuition consumption": '我们对班级功能进行了升级，请设置班级学费标准以方便进行学费消耗统计。',
	    'Sort by': '排序',
	    'Creation Time: Newest to Oldest': '按创建时间：由新到旧',
	    'Creation Time: Oldest to Newest': '按创建时间：由旧到新',
	    'Name: A-Z': '按名称：由A到Z',
	    'Name: Z-A': '按名称：由Z到A',
	
	    'Closed': '已关闭班级',
	    'Current': '当期班级'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "kWiG":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassStatusTd = function (_Component) {
	  _inherits(ClassStatusTd, _Component);
	
	  function ClassStatusTd(props) {
	    _classCallCheck(this, ClassStatusTd);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  ClassStatusTd.prototype.render = function render() {
	    var classInfo = this.props.classInfo;
	    var totalQuantity = classInfo.totalQuantity,
	        usedLessonTimes = classInfo.usedLessonTimes;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'class-status' },
	      usedLessonTimes + '/' + totalQuantity + ' ' + __('', 'classdetail')
	    );
	  };
	
	  return ClassStatusTd;
	}(_react.Component);
	
	exports.default = ClassStatusTd;
	module.exports = exports['default'];

/***/ },

/***/ "roHl":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassTeacherListTd = function (_Component) {
	  _inherits(ClassTeacherListTd, _Component);
	
	  function ClassTeacherListTd(props) {
	    _classCallCheck(this, ClassTeacherListTd);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  ClassTeacherListTd.prototype.render = function render() {
	    var classInfo = this.props.classInfo;
	    var teacherList = classInfo.teacherList;
	
	
	    return _react2.default.createElement(
	      _R2.default,
	      { can: 'read_class_teacher' },
	      _react2.default.createElement(
	        'div',
	        { className: 'class-teacher-list' },
	        teacherList.map(function (teacher) {
	          return _react2.default.createElement(
	            'p',
	            { key: teacher.id },
	            teacher.stName
	          );
	        })
	      )
	    );
	  };
	
	  return ClassTeacherListTd;
	}(_react.Component);
	
	exports.default = ClassTeacherListTd;
	module.exports = exports['default'];

/***/ },

/***/ "HcTH":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HadLessonTd = function (_Component) {
	  _inherits(HadLessonTd, _Component);
	
	  function HadLessonTd(props) {
	    _classCallCheck(this, HadLessonTd);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  HadLessonTd.prototype.render = function render() {
	    var classInfo = this.props.classInfo;
	    var has_lesson = classInfo.has_lesson;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'class-has-lesson' },
	      has_lesson == true ? __('Scheduled', 'class') : __('Not Scheduled', 'class')
	    );
	  };
	
	  return HadLessonTd;
	}(_react.Component);
	
	exports.default = HadLessonTd;
	module.exports = exports['default'];

/***/ },

/***/ "6E2x":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _UI = __webpack_require__("OM1Z");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	var _ClassDateTd = __webpack_require__("pxBc");
	
	var _ClassDateTd2 = _interopRequireDefault(_ClassDateTd);
	
	var _ClassTeacherListTd = __webpack_require__("roHl");
	
	var _ClassTeacherListTd2 = _interopRequireDefault(_ClassTeacherListTd);
	
	var _ClassStatusTd = __webpack_require__("kWiG");
	
	var _ClassStatusTd2 = _interopRequireDefault(_ClassStatusTd);
	
	var _HadLessonTd = __webpack_require__("HcTH");
	
	var _HadLessonTd2 = _interopRequireDefault(_HadLessonTd);
	
	var _ClassNameTd = __webpack_require__("SsX8");
	
	var _ClassNameTd2 = _interopRequireDefault(_ClassNameTd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var ClassTable = function (_Component) {
	  _inherits(ClassTable, _Component);
	
	  function ClassTable(props) {
	    _classCallCheck(this, ClassTable);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  ClassTable.prototype.render = function render() {
	    var _props = this.props,
	        tableData = _props.tableData,
	        dispatch = _props.dispatch,
	        settings = _props.settings,
	        onPageChange = _props.onPageChange,
	        onItemsCountPerPageChange = _props.onItemsCountPerPageChange,
	        settingWidth = _props.settingWidth,
	        pagination = _props.pagination,
	        fetching = _props.fetching;
	
	
	    var fields = [{
	      name: 'className',
	      title: __('Class Name', 'class'),
	      getTdProps: function getTdProps(_ref) {
	        var tbodyData = _ref.tbodyData;
	
	        return {
	          className: "class-info",
	          style: {
	            width: "15%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref2) {
	        var classInfo = _ref2.trData;
	
	        return _react2.default.createElement(_ClassNameTd2.default, { classInfo: classInfo });
	      }
	    }, {
	      name: 'earliest_day',
	      title: __('Date', 'class'),
	      getTdContent: function getTdContent(_ref3) {
	        var classInfo = _ref3.trData;
	
	        return _react2.default.createElement(_ClassDateTd2.default, { classInfo: classInfo });
	      }
	    }, {
	      name: 'totalQuantity',
	      title: __('Lesson Status', 'class'),
	      getTdContent: function getTdContent(_ref4) {
	        var classInfo = _ref4.trData;
	
	        return _react2.default.createElement(_ClassStatusTd2.default, { classInfo: classInfo });
	      }
	    }, {
	      name: 'teacherList',
	      title: __('Teachers', 'class'),
	      getTdContent: function getTdContent(_ref5) {
	        var classInfo = _ref5.trData;
	
	        return _react2.default.createElement(_ClassTeacherListTd2.default, { classInfo: classInfo });
	      }
	    }, {
	      name: 'studentCount',
	      title: __('Students', 'class'),
	      getTdContent: function getTdContent(_ref6) {
	        var classInfo = _ref6.trData;
	
	        return classInfo.studentCount + __('', 'createnewclass');
	      }
	    }, {
	      name: 'has_lesson',
	      title: __('Status', 'class'),
	      getTdContent: function getTdContent(_ref7) {
	        var classInfo = _ref7.trData;
	
	        return _react2.default.createElement(_HadLessonTd2.default, { classInfo: classInfo });
	      }
	    }];
	
	    return _react2.default.createElement(_UI.Table, {
	      data: tableData,
	      fields: fields,
	      fetching: fetching,
	      className: 'teacher-table',
	      settingThTitle: __('Settings', 'class', null, true),
	      settingWidth: settingWidth,
	      settings: settings,
	      useMultiSelection: false,
	      oneSettingPerRow: false,
	      dropdownGuideWidth: 160,
	      dropdownGuideHeight: 228,
	
	      pagination: pagination,
	      usePagination: true,
	      onPageChange: onPageChange,
	      onItemsCountPerPageChange: onItemsCountPerPageChange
	    });
	  };
	
	  return ClassTable;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ClassTable);
	module.exports = exports['default'];

/***/ },

/***/ "e6Cv":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _ducks = __webpack_require__("wTtZ");
	
	var _OnBoardingNatural = __webpack_require__("PwUp");
	
	var _OnBoardingNatural2 = _interopRequireDefault(_OnBoardingNatural);
	
	var _constant = __webpack_require__("pDIt");
	
	var _ClassTable = __webpack_require__("6E2x");
	
	var _ClassTable2 = _interopRequireDefault(_ClassTable);
	
	var _tableSettings = __webpack_require__("W43I");
	
	var _tableSettings2 = _interopRequireDefault(_tableSettings);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    classList: state.classList
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchClass: function fetchClass(opts) {
	      return dispatch((0, _ducks.fetchClass)(opts));
	    }
	  };
	};
	
	var DefaultTab = function (_Component) {
	  _inherits(DefaultTab, _Component);
	
	  function DefaultTab(props) {
	    _classCallCheck(this, DefaultTab);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.fetchClassList = _this.fetchClassList.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.onItemsCountPerPageChange = _this.onItemsCountPerPageChange.bind(_this);
	    return _this;
	  }
	
	  DefaultTab.prototype.componentWillMount = function componentWillMount() {
	    this.fetchClassList(1);
	  };
	
	  DefaultTab.prototype.fetchClassList = function fetchClassList(newPageNumber, newAmountPerPage) {
	    var itemsCountPerPage = this.props.classList.pagination.itemsCountPerPage;
	    var _props = this.props,
	        classState = _props.classState,
	        orderBy = _props.orderBy,
	        keyword = _props.keyword;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    this.props.fetchClass({
	      schoolId: schoolId,
	      type: 'group',
	      state: classState,
	      amount_per_page: newAmountPerPage || itemsCountPerPage,
	      current_page_number: newPageNumber,
	      order_by: orderBy,
	      keyword: keyword
	    });
	  };
	
	  DefaultTab.prototype.onPageChange = function onPageChange(activePage) {
	    if (activePage == this.props.classList.pagination.activePage) {
	      return;
	    }
	
	    this.fetchClassList(activePage);
	  };
	
	  DefaultTab.prototype.onItemsCountPerPageChange = function onItemsCountPerPageChange(itemsCountPerPage) {
	    this.fetchClassList(1, itemsCountPerPage);
	  };
	
	  DefaultTab.prototype.render = function render() {
	    var _props2 = this.props,
	        classState = _props2.classState,
	        classList = _props2.classList;
	    var fetching = classList.fetching,
	        hasPermission = classList.hasPermission,
	        school_has_class = classList.school_has_class,
	        pagination = classList.pagination;
	
	    this.tableSettings = _tableSettings2.default.call(this, classState);
	    var content = _constant.onBoardingContents[classState] || {};
	    if (school_has_class == false && content || hasPermission == false) {
	      return _react2.default.createElement(_OnBoardingNatural2.default, { isShown: true, title: content.title, text: content.text, image: content.image, showArrow: content.showArrow });
	    } else {
	      return _react2.default.createElement(_ClassTable2.default, {
	        tableData: classList.list,
	        fetching: fetching,
	        settings: this.tableSettings,
	        settingWidth: _tableSettings.SETTING_WIDTH,
	        pagination: pagination,
	        onPageChange: this.onPageChange,
	        onItemsCountPerPageChange: this.onItemsCountPerPageChange
	      });
	    }
	  };
	
	  return DefaultTab;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DefaultTab);
	module.exports = exports['default'];

/***/ },

/***/ "pDIt":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var locale = {
	  id: 'ClassConstant',
	  code: 'CN',
	  text: {
	    "./images/class_en@2x.png": "./images/Class@2x.png",
	    'Class Management is Suitable for all Teaching Scenarios': '适用于所有教学场景的班级体系',
	    'Class Management allows you to create classes, schedule lessons, auditions. attendance, appoint teachers and classrooms. Each class can be designed to be billed by lesson, date, or hour to keep track of the class status. It will also remind you when there is conflict between different classes.': '创建班级，排课，补课，试听，签到，设置任课教师，教室。大到几千人，小到几个人。可按期，按次，按时等跟踪课程进度。智能冲突系统可有效的提醒学校资源的重叠使用。自由的排课系统满足任何您需要的班级体系。'
	
	  }
	};
	
	var onBoardingContents = exports.onBoardingContents = {
	  // we show this when student state is 'current'
	  current: {
	    title: __('Class Management is Suitable for all Teaching Scenarios', locale),
	    text: __('Class Management allows you to create classes, schedule lessons, auditions. attendance, appoint teachers and classrooms. Each class can be designed to be billed by lesson, date, or hour to keep track of the class status. It will also remind you when there is conflict between different classes.', locale),
	    image: __webpack_require__(7)(__('./images/class_en@2x.png', locale)),
	    showArrow: true
	  }
	};

/***/ },

/***/ 7:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./Class.scss": "aCad",
		"./ClassTable/ClassDateTd": "pxBc",
		"./ClassTable/ClassDateTd.js": "pxBc",
		"./ClassTable/ClassNameTd": "SsX8",
		"./ClassTable/ClassNameTd.js": "SsX8",
		"./ClassTable/ClassStatusTd": "kWiG",
		"./ClassTable/ClassStatusTd.js": "kWiG",
		"./ClassTable/ClassTeacherListTd": "roHl",
		"./ClassTable/ClassTeacherListTd.js": "roHl",
		"./ClassTable/HadLessonTd": "HcTH",
		"./ClassTable/HadLessonTd.js": "HcTH",
		"./ClassTable/index": "6E2x",
		"./ClassTable/index.js": "6E2x",
		"./DefaultTab": "e6Cv",
		"./DefaultTab.js": "e6Cv",
		"./constant": "pDIt",
		"./constant.js": "pDIt",
		"./ducks": "wTtZ",
		"./ducks.js": "wTtZ",
		"./images/Class@2x.png": "uNdX",
		"./images/class_en@2x.png": "19ka",
		"./index": "CpZZ",
		"./index.js": "CpZZ",
		"./locale": "4A/Z",
		"./locale.js": "4A/Z",
		"./table-settings": "W43I",
		"./table-settings.js": "W43I"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 7;


/***/ },

/***/ "uNdX":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Class@2x.1af51552.png";

/***/ },

/***/ "19ka":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "class_en@2x.84c1efdd.png";

/***/ },

/***/ "CpZZ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DefaultTab = __webpack_require__("e6Cv");
	
	var _DefaultTab2 = _interopRequireDefault(_DefaultTab);
	
	var _CreateClass = __webpack_require__("dFGx");
	
	var _CreateClass2 = _interopRequireDefault(_CreateClass);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _ducks = __webpack_require__("wTtZ");
	
	var _FilterBy = __webpack_require__("SdD8");
	
	var _FilterBy2 = _interopRequireDefault(_FilterBy);
	
	__webpack_require__("aCad");
	
	var _locale = __webpack_require__("4A/Z");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _UI = __webpack_require__("OM1Z");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FILTERS = ['text:searchKeyword'];
	
	var FILTER_OPTIONS = {
	  'text:searchKeyword': {
	    placeholder: __('Search Class', _locale2.default),
	    valueMinLength: 2
	  }
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    classList: state.classList
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchClass: function fetchClass(opts) {
	      return dispatch((0, _ducks.fetchClass)(opts));
	    }
	  };
	};
	
	var Class = function (_Component) {
	  _inherits(Class, _Component);
	
	  function Class(props) {
	    _classCallCheck(this, Class);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      selectedIndex: 0,
	      orderBy: 0,
	      filterData: {},
	      keyword: ''
	    };
	    _this.onSelectTab = _this.onSelectTab.bind(_this);
	    _this.onFilterChange = _this.onFilterChange.bind(_this);
	    return _this;
	  }
	
	  Class.prototype.onSelectTab = function onSelectTab(selectedIndex) {
	    var orderBy = this.state.orderBy;
	
	
	    this.setState({
	      selectedIndex: selectedIndex,
	      orderBy: orderBy,
	      filterData: _extends({}, this.state.filterData, {
	        searchKeyword: ''
	      }),
	      keyword: ''
	    });
	  };
	
	  Class.prototype.onFilterChange = function onFilterChange(_ref) {
	    var _this2 = this;
	
	    var filterData = _ref.filterData;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _state = this.state,
	        selectedIndex = _state.selectedIndex,
	        orderBy = _state.orderBy;
	    var itemsCountPerPage = this.props.classList.pagination.itemsCountPerPage;
	
	
	    this.setState({
	      filterData: filterData,
	      keyword: filterData['searchKeyword']
	    }, function () {
	      _this2.props.fetchClass({
	        schoolId: schoolId,
	        type: 'group',
	        state: selectedIndex == 0 ? 'current' : 'archived',
	        keyword: _this2.state.keyword,
	        amount_per_page: itemsCountPerPage,
	        current_page_number: 1,
	        order_by: orderBy
	      });
	    });
	  };
	
	  Class.prototype.render = function render() {
	    var _this3 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _props$classList$pagi = this.props.classList.pagination,
	        activePage = _props$classList$pagi.activePage,
	        itemsCountPerPage = _props$classList$pagi.itemsCountPerPage;
	    var _state2 = this.state,
	        selectedIndex = _state2.selectedIndex,
	        filterData = _state2.filterData,
	        keyword = _state2.keyword,
	        orderBy = _state2.orderBy;
	
	
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      { className: 'class-container' },
	      _react2.default.createElement(
	        'div',
	        null,
	        __("Class List", "class")
	      ),
	      _react2.default.createElement(
	        _UI.Tabs,
	        { defaultIndex: selectedIndex, onSelect: this.onSelectTab },
	        _react2.default.createElement(
	          _UI.TabList,
	          null,
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('Current', _locale2.default)
	          ),
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('Closed', _locale2.default)
	          ),
	          _react2.default.createElement(
	            _R2.default,
	            { can: 'create_class', by: 'disable' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary pull-right createBtn', onClick: function onClick() {
	                  (0, _CreateClass2.default)({ mode: 'create' }).then(function () {
	                    _this3.setState({
	                      filterData: _extends({}, _this3.state.filterData, {
	                        searchKeyword: ''
	                      }),
	                      keyword: ''
	                    }, function () {
	                      _this3.props.fetchClass({
	                        schoolId: schoolId,
	                        type: 'group',
	                        state: selectedIndex == 0 ? 'current' : 'archived',
	                        amount_per_page: itemsCountPerPage,
	                        current_page_number: activePage,
	                        order_by: orderBy
	                      });
	                    });
	                  });
	                } },
	              __("New Class", "class")
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-right' },
	            _react2.default.createElement(_FilterBy2.default, {
	              filterData: filterData,
	              filters: FILTERS,
	              options: FILTER_OPTIONS,
	              onChange: this.onFilterChange })
	          ),
	          _react2.default.createElement(
	            'select',
	            { className: 'form-control sort-by pull-right', value: orderBy,
	              onChange: function onChange(e) {
	                _this3.setState({ orderBy: e.target.value }, function () {
	                  _this3.props.fetchClass({
	                    schoolId: schoolId,
	                    type: 'group',
	                    state: selectedIndex == 0 ? 'current' : 'archived',
	                    amount_per_page: itemsCountPerPage,
	                    current_page_number: activePage,
	                    order_by: _this3.state.orderBy,
	                    keyword: keyword
	                  });
	                });
	              } },
	            _react2.default.createElement(
	              'option',
	              { key: '0', value: '0' },
	              __('Creation Time: Newest to Oldest', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'option',
	              { key: '1', value: '1' },
	              __('Creation Time: Oldest to Newest', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'option',
	              { key: '2', value: '2' },
	              __('Name: A-Z', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'option',
	              { key: '3', value: '3' },
	              __('Name: Z-A', _locale2.default)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-right sort-by-label' },
	            __('Sort by', _locale2.default)
	          )
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { classState: 'current', orderBy: orderBy, keyword: keyword })
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { classState: 'archived', orderBy: orderBy, keyword: keyword })
	        )
	      )
	    );
	  };
	
	  return Class;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Class);
	module.exports = exports['default'];

/***/ },

/***/ "W43I":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SETTING_WIDTH = undefined;
	
	exports.default = function (classState) {
	
	  if (classState == 'archived') {
	    return getArchivedClassTableSettings.call(this);
	  }
	
	  return getDefaultTableSettings.call(this);
	};
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _closeAndArchiveClass = __webpack_require__("0t0r");
	
	var _closeAndArchiveClass2 = _interopRequireDefault(_closeAndArchiveClass);
	
	var _alert = __webpack_require__("BGi1");
	
	var _R = __webpack_require__("nRUD");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SETTING_WIDTH = exports.SETTING_WIDTH = "14%";
	
	// 'this' refers to DefaultTab
	function getDefaultTableSettings() {
	  var TabComponent = this;
	  // 'this props' refers to DefaultTab.props
	  var pagination = this.props.classList.pagination;
	
	  return [{
	    title: __('Add Lesson', 'class'),
	    onClick: function onClick(_ref) {
	      var classDetail = _ref.trData;
	
	      _reactRouter.browserHistory.push({
	        pathname: '/class-detail/' + classDetail.classID,
	        state: {
	          openCreateLessonDock: true
	        }
	      });
	    },
	    isDisabled: function isDisabled() {
	      return !(0, _R.userCan)('create_lesson');
	    }
	  }, {
	    title: __("Attendance", "class"),
	    onClick: function onClick(_ref2) {
	      var classInfo = _ref2.trData;
	
	      _reactRouter.browserHistory.push('/class-detail/' + classInfo.classID);
	    },
	    isDisabled: function isDisabled(_ref3) {
	      var classInfo = _ref3.trData;
	
	      return classInfo.has_lesson == false || !(0, _R.userCan)('manually_check_in');
	    }
	  }, {
	    title: __("Close", "class"),
	    onClick: function onClick(_ref4) {
	      var classInfo = _ref4.trData;
	
	      (0, _closeAndArchiveClass2.default)(classInfo, 'group').then(function () {
	        TabComponent.fetchClassList(pagination.activePage);
	      }).catch(function (err) {
	        _alert.alert.error(err);
	      });
	    },
	    isDisabled: function isDisabled() {
	      return !(0, _R.userCan)('close_class');
	    }
	  }];
	}
	
	// Specifically used for archived student table
	function getArchivedClassTableSettings() {
	  var TabComponent = this;
	  var dispatch = this.props.dispatch;
	
	
	  return [];
	}

/***/ },

/***/ "0t0r":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = closeAndArchiveClass;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _archiveClass = __webpack_require__("NsSZ");
	
	var _archiveClass2 = _interopRequireDefault(_archiveClass);
	
	var _ClassDetail = __webpack_require__("715+");
	
	var _ClassDetail2 = _interopRequireDefault(_ClassDetail);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _locale = __webpack_require__("vE6O");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FEE_TYPES = ['per_day', 'per_time', 'per_hour']; /*
	                                                       FROM TB-539
	                                                       Michael Qin
	                                                       4 days ago (feb 19, 2018)
	                                                       修改补充：新的流程快设计完了，逻辑改变挺大的，暂时的解决方案如下：
	                                                       在班级列表的操作里添加“删除”按钮
	                                                       点击删除弹出提示框，提示两点信息，1，如果有未完成的课节要提示，2，告知删除后的班级去了已删除tab下，按钮为，取消与确定。
	                                                       删除完的班级或私课不会删除学校里的学生。
	                                                     */
	
	
	var Warning = function Warning(warning) {
	  return _react2.default.createElement(
	    'div',
	    { style: { color: 'red' } },
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement('i', { className: 'fa icon-attention-circled' }),
	      warning
	    )
	  );
	};
	
	function closeAndArchiveClass(classInfo, classType) {
	
	  var classDetail = new _ClassDetail2.default(classInfo);
	
	  var id = classDetail.id,
	      feeType = classDetail.feeType,
	      totalQuantity = classDetail.totalQuantity,
	      totalHours = classDetail.totalHours,
	      usedLessonHours = classDetail.usedLessonHours,
	      usedLessonTimes = classDetail.usedLessonTimes,
	      name = classDetail.name;
	
	
	  var lessonLeft = 0;
	  var message = '';
	
	  switch (FEE_TYPES[feeType]) {
	    case 'per_day':
	      lessonLeft = totalQuantity - usedLessonTimes;
	      break;
	    case 'per_time':
	      lessonLeft = totalQuantity - usedLessonTimes;
	      break;
	    case 'per_hour':
	      lessonLeft = totalQuantity - usedLessonHours;
	      break;
	    default:
	      break;
	  }
	
	  if (lessonLeft > 0) {
	    message = Warning(__(' This class still has at least one unfinished lesson', 'closeClass'));
	  }
	
	  var title = '';
	  var content = '';
	  var content2 = '';
	
	  if (classType == 'group') {
	    title = __('Close Class', _locale2.default);
	    content = __("After closing the class, you can find it under the 'Closed Class", _locale2.default);
	    content2 = __('Are you sure you want to close the class below?', _locale2.default);
	  } else {
	    title = __('Close Private Class', _locale2.default);
	    content = __("After closing the class, you can find it under the 'Closed Private Class", _locale2.default);
	    content2 = __('Are you sure you want to close the private class below?', _locale2.default);
	  }
	
	  return new Promise(function (resolve, reject) {
	    (0, _confirm.confirm)(_react2.default.createElement(
	      'div',
	      null,
	      message,
	      _react2.default.createElement(
	        'p',
	        null,
	        content
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        content2
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          name
	        )
	      )
	    ), title).then(function () {
	      (0, _archiveClass2.default)(id, classType).then(function (_ref) {
	        var data = _ref.data;
	
	        resolve(data);
	      }).catch(function (err) {
	        console.error(err);
	        reject(err);
	      });
	    }).catch(function () {});
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "NsSZ":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = archiveClass;
	
	var _config = __webpack_require__("hxne");
	
	var _updateClass = __webpack_require__("PjEN");
	
	var _updateClass2 = _interopRequireDefault(_updateClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function archiveClass(classId, classType) {
	
	  if (!classId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing class Id (number)')
	      });
	    });
	  }
	
	  return (0, _updateClass2.default)({
	    classId: classId,
	    type: classType,
	    state: 'archive'
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "PjEN":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = updateClass;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATE = ['archive', 'unarchive'];
	var TYPE = ['group', '1on1'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  classId: _joiBrowser2.default.number().integer().required(),
	  type: _joiBrowser2.default.string().valid(TYPE),
	  state: _joiBrowser2.default.string().valid(STATE)
	});
	
	function updateClass(opts) {
	
	  var validateResult = _joiBrowser2.default.validate(opts, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var type = TYPE.indexOf(opts.type);
	
	  var toServer = _extends({}, opts, {
	    state: STATE.indexOf(opts.state)
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/u_clsstt/' + opts.classId + '/' + type + '/',
	      'method': 'PUT',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "vE6O":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'closeAndArchiveClass',
	  code: 'CN',
	  text: {
	    'Close Class': '关闭班级',
	    "After closing the class, you can find it under the 'Closed Class": "关闭班级后，此班级会显示在 '已关闭班级'",
	    'Are you sure you want to close the class below?': '确认关闭班级？',
	    'Close Private Class': '关闭私课',
	    "After closing the class, you can find it under the 'Closed Private Class": "关闭私课后，此私课会显示在 '关闭私课'",
	    'Are you sure you want to close the private class below?': '确认关闭私课？',
	    '': ''
	
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "7HkZ":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"classDetail":"classDetail","fetching":"fetching","class-detail-esc":"class-detail-esc","class-detail-name":"class-detail-name","class-detail-header":"class-detail-header","lesson-teacher-list":"lesson-teacher-list","student-amount-list":"student-amount-list","icon-users":"icon-users"};

/***/ },

/***/ "QRb/":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getClassInfoFields;
	
	var _constants = __webpack_require__("K30H");
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getClassInfoFields() {
	  var language = localStorage.getItem('language');
	  return {
	    date: {
	      title: __('Date', 'class'),
	      render: function render(opts) {
	        if (opts.data.startDateTime && opts.data.endDateTime) {
	          var startDate = opts.data.startDateTime.slice(0, 10);
	          var endDate = opts.data.endDateTime.slice(0, 10);
	          return opts.data.startDateTime && opts.data.endDateTime ? startDate + " – " + endDate : '';
	        }
	      }
	    },
	    classTeacherList: {
	      title: __('Teacher', 'changeschool'),
	      render: function render(opts) {
	        if ((0, _R.userCan)(opts.data.cType == 0 ? 'read_class_teacher' : 'read_private_class_teacher')) {
	          if (opts.data.classTeacherList) {
	            return opts.data.classTeacherList.map(function (teacher) {
	              return teacher.stName;
	            }).join(', ');
	          }
	        }
	      }
	    },
	    studentList: {
	      title: __('Student', 'schedule'),
	      render: function render(opts) {
	        if (opts.data.classStudentList[0]) {
	          var extraNotation = '';
	          if (opts.data.classStudentList.length > 1) {
	            extraNotation = ' (+' + (opts.data.classStudentList.length - 1) + ')';
	          }
	          return '' + opts.data.classStudentList[0].ssName + extraNotation;
	        } else {
	          return '';
	        }
	      }
	    },
	    total_lesson_amount: {
	      title: __('Lesson Amount', 'class')
	    },
	    lessonCheckinedCount: {
	      title: __('Past Lesson Counts', 'classdetail'),
	      render: function render(opts) {
	        return opts.data.lessonCheckinedCount ? opts.data.lessonCheckinedCount : '0';
	      }
	    },
	    payment_reminder: {
	      title: __('Payment Reminder', 'classdetail'),
	      render: function render(opts) {
	        var fieldValue = void 0;
	        if (opts.data.feeType == 0) {
	          fieldValue = language == 'CN' ? '提前' + opts.data.costAlertRange + '天提醒' : opts.data.costAlertRange > 1 ? opts.data.costAlertRange + ' days in advance' : opts.data.costAlertRange + ' day in advance';
	        } else if (opts.data.feeType == 1) {
	          fieldValue = language == 'CN' ? '提前' + opts.data.costAlertRange + '节课提醒' : opts.data.costAlertRange > 1 ? opts.data.costAlertRange + ' lessons in advance' : opts.data.costAlertRange + ' lesson in advance';
	        } else {
	          fieldValue = language == 'CN' ? '提前' + opts.data.costAlertRange + '小时提醒' : opts.data.costAlertRange > 1 ? opts.data.costAlertRange + ' hours in advance' : opts.data.costAlertRange + ' hour in advance';
	        }
	        return fieldValue;
	      }
	    },
	    complettion_rule: {
	      title: __('Lesson Completion Rules', 'createnewclass'),
	      className: 'col-sm-6',
	      render: function render(opts) {
	        return _constants.COST_RULE[opts.data.costRule] + ', ' + _constants.ABSENT_RULE[opts.data.absentFlag] + ', ' + _constants.CANCEL_RULE[opts.data.cancelFlag];
	      }
	    }
	  };
	}
	module.exports = exports['default'];

/***/ },

/***/ "siMa":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _UI = __webpack_require__("OM1Z");
	
	var _TeacherTable = __webpack_require__("TW8w");
	
	var _TeacherTable2 = _interopRequireDefault(_TeacherTable);
	
	var _LessonTable = __webpack_require__("bBLv");
	
	var _LessonTable2 = _interopRequireDefault(_LessonTable);
	
	var _StudentTable = __webpack_require__("Mvxf");
	
	var _StudentTable2 = _interopRequireDefault(_StudentTable);
	
	var _tableSettings = __webpack_require__("x2Kx");
	
	var _tableSettings2 = _interopRequireDefault(_tableSettings);
	
	var _tableSettings3 = __webpack_require__("vx51");
	
	var _tableSettings4 = _interopRequireDefault(_tableSettings3);
	
	var _tableSettings5 = __webpack_require__("y9xV");
	
	var _tableSettings6 = _interopRequireDefault(_tableSettings5);
	
	var _ducks = __webpack_require__("6mZg");
	
	var _ducks2 = __webpack_require__("DPWa");
	
	var _ducks3 = __webpack_require__("lDbx");
	
	var _locale = __webpack_require__("qEX0");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    gSubscription: state.gSubscription,
	    classStudentDetail: state.classStudentDetail,
	    classTeacherDetail: state.classTeacherDetail,
	    schoolDetail: state.schoolDetail
	  };
	};
	
	var DefaultTab = function (_Component) {
	  _inherits(DefaultTab, _Component);
	
	  function DefaultTab(props) {
	    _classCallCheck(this, DefaultTab);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  DefaultTab.prototype.componentWillMount = function componentWillMount() {
	    var _props = this.props,
	        dispatch = _props.dispatch,
	        title = _props.title,
	        onTabChange = _props.onTabChange;
	
	    var classId = this.props.params.classId;
	
	    if (title == 'student') {
	      dispatch((0, _ducks.fetchClassStudent)(Number(classId)));
	    } else if (title == 'teacher') {
	      dispatch((0, _ducks2.fetchClassTeacher)(Number(classId)));
	    } else if (title === 'pastLesson') {
	      onTabChange('past');
	    } else if (title === 'currentLesson') {
	      onTabChange('current');
	    }
	  };
	
	  DefaultTab.prototype.render = function render() {
	    var _props2 = this.props,
	        title = _props2.title,
	        dispatch = _props2.dispatch,
	        classDetail = _props2.classDetail,
	        pagination = _props2.pagination,
	        onPageChange = _props2.onPageChange,
	        onItemsCountPerPageChange = _props2.onItemsCountPerPageChange;
	    var fetching = classDetail.fetching;
	
	    if (title == 'currentLesson') {
	      var _classDetail = this.props.classDetail;
	      var detail = _classDetail.detail;
	
	      this.lessonTableSettings = _tableSettings2.default.call(this);
	      this.lessonsState = 'current';
	
	      return _react2.default.createElement(_LessonTable2.default, _extends({
	        state: this.lessonsState,
	        tableData: detail,
	        settings: this.lessonTableSettings,
	        dispatch: dispatch,
	        fetching: fetching,
	        pagination: pagination,
	        usePagination: true,
	        onPageChange: onPageChange,
	        onItemsCountPerPageChange: onItemsCountPerPageChange
	      }, this.props));
	    } else if (title === 'pastLesson') {
	      var _classDetail2 = this.props.classDetail;
	      var _detail = _classDetail2.detail;
	
	      this.lessonTableSettings = _tableSettings2.default.call(this);
	      this.lessonsState = 'past';
	
	      return _react2.default.createElement(_LessonTable2.default, _extends({
	        state: this.lessonsState,
	        tableData: _detail,
	        settings: this.lessonTableSettings,
	        dispatch: dispatch,
	        fetching: fetching,
	        pagination: pagination,
	        usePagination: true,
	        onPageChange: onPageChange,
	        onItemsCountPerPageChange: onItemsCountPerPageChange
	      }, this.props));
	    } else if (title == 'student') {
	      var classStudentDetail = this.props.classStudentDetail;
	      var _detail2 = classStudentDetail.detail;
	
	      this.studentTableSettings = _tableSettings4.default.call(this);
	
	      var arr = [];
	      if (_detail2.classStudentList) {
	        _detail2.classStudentList.map(function (student) {
	          if (student.classStudentState == 1) {
	            arr.push(student);
	          }
	        });
	      }
	
	      var newdetail = _extends({}, _detail2, { classStudentList: arr });
	      return _react2.default.createElement(_StudentTable2.default, _extends({ tableData: newdetail, classDetail: classDetail, settings: this.studentTableSettings }, this.props));
	    } else if (title == 'pastStudent') {
	      var _classStudentDetail = this.props.classStudentDetail;
	      var _detail3 = _classStudentDetail.detail;
	
	      this.studentTableSettings = _tableSettings4.default.call(this);
	
	      var _arr = [];
	      if (_detail3.classStudentList) {
	        _detail3.classStudentList.map(function (student) {
	          if (student.classStudentState == 0) {
	            _arr.push(student);
	          }
	        });
	      }
	
	      var _newdetail = _extends({}, _detail3, { classStudentList: _arr });
	
	      return _react2.default.createElement(_StudentTable2.default, _extends({ tableData: _newdetail, classDetail: classDetail, settings: this.studentTableSettings }, this.props));
	    } else if (title == 'teacher') {
	      var classTeacherDetail = this.props.classTeacherDetail;
	      var _detail4 = classTeacherDetail.detail;
	
	      this.teacherTableSettings = _tableSettings6.default.call(this);
	      return _react2.default.createElement(_TeacherTable2.default, _extends({
	        tableData: _detail4,
	        classDetail: classDetail,
	        settings: this.teacherTableSettings
	      }, this.props));
	    }
	  };
	
	  return DefaultTab;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(DefaultTab);
	module.exports = exports['default'];

/***/ },

/***/ "TW8w":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _SelectTeacher = __webpack_require__("okp6");
	
	var _SelectTeacher2 = _interopRequireDefault(_SelectTeacher);
	
	var _Teacher = __webpack_require__("xSer");
	
	var _Teacher2 = _interopRequireDefault(_Teacher);
	
	var _updateClassTeacher = __webpack_require__("DLIB");
	
	var _updateClassTeacher2 = _interopRequireDefault(_updateClassTeacher);
	
	var _ducks = __webpack_require__("DPWa");
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CONTROLLER_WIDTH = '150px';
	
	var TeacherTable = function (_Component) {
	  _inherits(TeacherTable, _Component);
	
	  function TeacherTable(props) {
	    _classCallCheck(this, TeacherTable);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  TeacherTable.prototype.render = function render() {
	    var _props = this.props,
	        tableData = _props.tableData,
	        dispatch = _props.dispatch,
	        settings = _props.settings,
	        params = _props.params,
	        classDetail = _props.classDetail;
	    var classTeacherList = tableData.classTeacherList;
	
	    var _ref = classDetail.detail || {},
	        cType = _ref.cType,
	        cState = _ref.cState;
	
	    var classId = params.classId;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    if (!classTeacherList) {
	      return _react2.default.createElement('div', null);
	    }
	
	    var fields = [{
	      name: 'stName',
	      title: __('Teacher Name', 'teacher')
	    }];
	
	    return _react2.default.createElement(_UI.Table, {
	      data: classTeacherList,
	      fields: fields,
	      className: 'teacher-table',
	      settingThTitle: __('Settings', 'class', null, true),
	      settingWidth: CONTROLLER_WIDTH,
	      settings: settings,
	      useMultiSelection: false,
	      oneSettingPerRow: false,
	      dropdownGuideWidth: 160,
	      dropdownGuideHeight: 228,
	      usePagination: false,
	      hasTopUtilSection: true,
	      topUtilSection: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'lesson-student-table' },
	          _react2.default.createElement(
	            'span',
	            { className: 'title' },
	            __('Teachers: ', 'studentTable')
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'student-count' },
	            classTeacherList.length
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary', style: { visibility: 'hidden' } },
	            'TEST'
	          ),
	          _react2.default.createElement(
	            _R2.default,
	            { can: cType == 0 ? 'assign_teacher_to_class' : 'assign_teacher_to_private_class', by: 'disable' },
	            _react2.default.createElement(
	              'button',
	              { className: 'pull-right btn btn-primary', disabled: cState == 0 ? true : false, onClick: function onClick() {
	                  (0, _SelectTeacher2.default)({
	                    schoolId: schoolId,
	                    selectMultiple: true,
	                    selected: classTeacherList.map(function (s) {
	                      return new _Teacher2.default(s);
	                    })
	                  }).then(function (res) {
	                    var arr = [];
	                    res.map(function (teacher) {
	                      arr.push({ teacher_id: teacher.id, class_or_not: true });
	                    });
	                    (0, _updateClassTeacher2.default)(classId, { changes: arr }).then(function (res) {
	                      dispatch((0, _ducks.fetchClassTeacher)(classId));
	                    });
	                  });
	                } },
	              __('New Teacher', 'studentTable')
	            )
	          )
	        )
	      )
	    });
	  };
	
	  return TeacherTable;
	}(_react.Component);
	
	exports.default = TeacherTable;
	module.exports = exports['default'];

/***/ },

/***/ "DLIB":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = updateClassTeacher;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  changes: _joiBrowser2.default.array().required()
	});
	
	function updateClassTeacher(classID, teacherInfo) {
	
	  if (!classID) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing class Id')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(teacherInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/u_add_multi_clstch/" + classID + "/",
	      'data': JSON.stringify(teacherInfo),
	      'method': 'POST',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "bBLv":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	var _TeacherListTd = __webpack_require__("Eceu");
	
	var _TeacherListTd2 = _interopRequireDefault(_TeacherListTd);
	
	var _StudentAmountTd = __webpack_require__("2EBe");
	
	var _StudentAmountTd2 = _interopRequireDefault(_StudentAmountTd);
	
	var _StudentInfoFloat = __webpack_require__("xtYq");
	
	var _StudentInfoFloat2 = _interopRequireDefault(_StudentInfoFloat);
	
	var _AddLesson = __webpack_require__("shHd");
	
	var _AddLesson2 = _interopRequireDefault(_AddLesson);
	
	var _LessonEditTime = __webpack_require__("0Crp");
	
	var _LessonEditTime2 = _interopRequireDefault(_LessonEditTime);
	
	var _LessonEditColor = __webpack_require__("JbjC");
	
	var _LessonEditColor2 = _interopRequireDefault(_LessonEditColor);
	
	var _LessonEditTeacher = __webpack_require__("M5FJ");
	
	var _LessonEditTeacher2 = _interopRequireDefault(_LessonEditTeacher);
	
	var _LessonEditStudent = __webpack_require__("m5cN");
	
	var _LessonEditStudent2 = _interopRequireDefault(_LessonEditStudent);
	
	var _LessonEditClassroom = __webpack_require__("ZFIi");
	
	var _LessonEditClassroom2 = _interopRequireDefault(_LessonEditClassroom);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _deleteMultiLesson = __webpack_require__("+zO1");
	
	var _deleteMultiLesson2 = _interopRequireDefault(_deleteMultiLesson);
	
	var _ducks = __webpack_require__("lDbx");
	
	var _getLessonStudentList = __webpack_require__("9pkU");
	
	var _getLessonStudentList2 = _interopRequireDefault(_getLessonStudentList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CONTROLLER_WIDTH = '150px';
	
	var LessonTable = function (_Component) {
	  _inherits(LessonTable, _Component);
	
	  function LessonTable(props) {
	    _classCallCheck(this, LessonTable);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      selectedLesson: {
	        selected: []
	      },
	      float: {},
	      deleting: false,
	      student_list: [],
	      openFloatModal: false,
	      fetchingStudentList: false,
	      floatTarget: null
	    };
	
	    _this.openFloat = _this.openFloat.bind(_this);
	    _this.closeFloat = _this.closeFloat.bind(_this);
	    _this.addLesson = _this.addLesson.bind(_this);
	    return _this;
	  }
	
	  LessonTable.prototype.openFloat = function openFloat(lesson_id, lesson_number) {
	    var _this2 = this;
	
	    return function (e) {
	      e.preventDefault();
	      _this2.setState({
	        floatTarget: e.currentTarget,
	        lesson_number: lesson_number,
	        fetchingStudentList: true,
	        openFloatModal: true
	      });
	      (0, _getLessonStudentList2.default)(lesson_id).then(function (res) {
	        _this2.setState({ student_list: res.student_list, fetchingStudentList: false }, function () {
	          _this2.forceUpdate();
	        });
	      });
	    };
	  };
	
	  LessonTable.prototype.closeFloat = function closeFloat() {
	    this.setState({ student_list: [], lesson_number: 0, openFloatModal: false, floatTarget: null });
	  };
	
	  LessonTable.prototype.addLesson = function addLesson() {
	    var _props = this.props,
	        tableData = _props.tableData,
	        dispatch = _props.dispatch,
	        state = _props.state,
	        pagination = _props.pagination;
	    var classID = tableData.classID;
	
	
	    (0, _AddLesson2.default)({ chooseClass: false, classDetail: tableData }).then(function (data) {
	      dispatch((0, _ducks.fetchClassLesson)(classID, {
	        amount_per_page: pagination.itemsCountPerPage,
	        current_page_number: pagination.activePage,
	        after_today: state === 'current' ? 1 : 0
	      }));
	    });
	  };
	
	  LessonTable.prototype.render = function render() {
	    var _this3 = this,
	        _React$createElement;
	
	    var _props2 = this.props,
	        tableData = _props2.tableData,
	        dispatch = _props2.dispatch,
	        settings = _props2.settings,
	        fetching = _props2.fetching,
	        pagination = _props2.pagination,
	        usePagination = _props2.usePagination,
	        onPageChange = _props2.onPageChange,
	        onItemsCountPerPageChange = _props2.onItemsCountPerPageChange;
	
	    var state = this.props.state === 'current' ? 1 : 0;
	
	    if (!tableData) {
	      return _react2.default.createElement('div', null);
	    }
	
	    var fields = [{
	      name: 'number',
	      title: __('Lesson', 'classdetail'),
	      getTdContent: function getTdContent(_ref) {
	        var trIndex = _ref.trIndex,
	            trData = _ref.trData;
	        var calendar_color = trData.calendar_color,
	            lesson_number = trData.lesson_number;
	
	
	        return _react2.default.createElement(
	          'span',
	          null,
	          __('Lesson', 'classdetail') + ' ' + lesson_number
	        );
	      },
	      getTdProps: function getTdProps(_ref2) {
	        var trData = _ref2.trData;
	        var lesson_status = trData.lesson_status;
	
	        return {
	          style: { width: "10%", opacity: lesson_status === 1 ? 0.35 : 1 }
	        };
	      }
	    }, {
	      name: 'date',
	      title: __('Lesson Date', 'classdetail'),
	      getTdContent: function getTdContent(_ref3) {
	        var lessonInfo = _ref3.trData;
	
	        return lessonInfo.lesson_start_time.slice(0, 11);
	      },
	      getTdProps: function getTdProps(_ref4) {
	        var trData = _ref4.trData;
	        var lesson_status = trData.lesson_status;
	
	        return {
	          style: { width: "12%", opacity: lesson_status === 1 ? 0.35 : 1 }
	        };
	      }
	    }, {
	      name: 'lesson_time',
	      title: __('Lesson Time', 'classdetail'),
	      getTdContent: function getTdContent(_ref5) {
	        var lessonInfo = _ref5.trData;
	
	        return lessonInfo.lesson_start_time.slice(11, 16) + " – " + lessonInfo.lesson_end_time.slice(11, 16);
	      },
	      getTdProps: function getTdProps(_ref6) {
	        var trData = _ref6.trData;
	        var lesson_status = trData.lesson_status;
	
	        return {
	          style: { width: "12%", opacity: lesson_status === 1 ? 0.35 : 1 }
	        };
	      }
	    }, {
	      name: 'teacher_list',
	      title: __('Teacher', 'teacher'),
	      getTdContent: function getTdContent(_ref7) {
	        var lessonInfo = _ref7.trData;
	
	        return _react2.default.createElement(_TeacherListTd2.default, _extends({ lessonInfo: lessonInfo }, _this3.props));
	      },
	      getTdProps: function getTdProps(_ref8) {
	        var trData = _ref8.trData;
	        var lesson_status = trData.lesson_status;
	
	        return {
	          style: { width: "15%", opacity: lesson_status === 1 ? 0.35 : 1 }
	        };
	      }
	    }, {
	      name: 'classroom_name',
	      title: __('Classroom', 'classdetail'),
	      getTdContent: function getTdContent(_ref9) {
	        var lessonInfo = _ref9.trData;
	
	        return lessonInfo.classroom_name ? lessonInfo.classroom_name : '';
	      },
	      getTdProps: function getTdProps(_ref10) {
	        var trData = _ref10.trData;
	        var lesson_status = trData.lesson_status;
	
	        return {
	          style: { width: "15%", opacity: lesson_status === 1 ? 0.35 : 1 }
	        };
	      }
	    }, {
	      name: 'student_amount',
	      title: __('Student Counts', 'classdetail'),
	      getTdContent: function getTdContent(_ref11) {
	        var lessonInfo = _ref11.trData;
	
	        return _react2.default.createElement(_StudentAmountTd2.default, _extends({ lessonInfo: lessonInfo, openFloat: _this3.openFloat }, _this3.props));
	      },
	      getTdProps: function getTdProps(_ref12) {
	        var trData = _ref12.trData;
	        var lesson_status = trData.lesson_status;
	
	        return {
	          style: { width: "10%", opacity: lesson_status === 1 ? 0.35 : 1 }
	        };
	      }
	    }];
	
	    var _state = this.state,
	        student_list = _state.student_list,
	        openFloatModal = _state.openFloatModal,
	        floatTarget = _state.floatTarget,
	        lesson_number = _state.lesson_number,
	        selectedLesson = _state.selectedLesson,
	        deleting = _state.deleting,
	        fetchingStudentList = _state.fetchingStudentList;
	    var selected = selectedLesson.selected;
	    var cState = tableData.cState,
	        classID = tableData.classID,
	        cType = tableData.cType;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    var lesson_id_list = [];
	    selected.map(function (lesson) {
	      lesson_id_list.push(lesson.lesson_id);
	    });
	
	    if (deleting) {
	      return _react2.default.createElement(_Loading2.default, null);
	    }
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_UI.Table, (_React$createElement = {
	        data: tableData.lessonList,
	        fields: fields,
	        className: 'teacher-table',
	        settingThTitle: __('Settings', 'class'),
	        settingWidth: CONTROLLER_WIDTH,
	        settings: settings,
	        useMultiSelection: false,
	        oneSettingPerRow: false,
	        dropdownGuideWidth: 160,
	        dropdownGuideHeight: 228,
	        usePagination: usePagination,
	        pagination: pagination,
	        onPageChange: onPageChange,
	        onItemsCountPerPageChange: onItemsCountPerPageChange
	      }, _React$createElement['useMultiSelection'] = true, _React$createElement.fetching = fetching, _React$createElement.onTrSelect = function onTrSelect(selected) {
	        _this3.setState({ selectedLesson: selected });
	      }, _React$createElement.getCheckboxTdProps = function getCheckboxTdProps(_ref13) {
	        var trData = _ref13.trData;
	        var calendar_color = trData.calendar_color,
	            lesson_status = trData.lesson_status;
	
	        return {
	          style: { borderLeft: '4.5px solid ' + calendar_color, opacity: lesson_status === 1 ? 0.35 : 1 }
	        };
	      }, _React$createElement.getCheckboxDisabled = function getCheckboxDisabled(_ref14) {
	        var trData = _ref14.trData;
	        var lesson_status = trData.lesson_status;
	
	        if (lesson_status === 1) {
	          return true;
	        } else {
	          return false;
	        }
	      }, _React$createElement.hasTopUtilSection = true, _React$createElement.topUtilSection = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _R2.default,
	          { can: cType == 0 ? 'edit_lesson' : 'edit_private_lesson', by: 'disable' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-default', disabled: selected.length == 0 ? true : false, onClick: function onClick() {
	                (0, _LessonEditTime2.default)({ selected: selected, classID: classID, dispatch: dispatch, pagination: pagination, state: state }).then(function () {
	                  _this3.setState({
	                    selectedLesson: _extends({}, _this3.state.selectedLesson, {
	                      selected: []
	                    })
	                  });
	                });
	              } },
	            __('Reset Time', 'lessonTable')
	          )
	        ),
	        _react2.default.createElement(
	          _R2.default,
	          { can: cType == 0 ? 'edit_lesson' : 'edit_private_lesson', by: 'disable' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-default', disabled: selected.length == 0 ? true : false, onClick: function onClick() {
	                (0, _LessonEditTeacher2.default)({ schoolId: schoolId, selectMultiple: true, lesson_id_list: lesson_id_list, classID: classID, dispatch: dispatch, pagination: pagination, state: state }).then(function () {
	                  _this3.setState({
	                    selectedLesson: _extends({}, _this3.state.selectedLesson, {
	                      selected: []
	                    })
	                  });
	                });
	              } },
	            __('Reset Teacher', 'lessonTable')
	          )
	        ),
	        _react2.default.createElement(
	          _R2.default,
	          { can: cType == 0 ? 'edit_lesson' : 'edit_private_lesson', by: 'disable' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-default', disabled: selected.length == 0 ? true : false, onClick: function onClick() {
	                (0, _LessonEditClassroom2.default)({ schoolId: schoolId, lesson_id_list: lesson_id_list, classID: classID, dispatch: dispatch, pagination: pagination, state: state }).then(function () {
	                  _this3.setState({
	                    selectedLesson: _extends({}, _this3.state.selectedLesson, {
	                      selected: []
	                    })
	                  });
	                });
	              } },
	            __('Reset Classroom', 'lessonTable')
	          )
	        ),
	        cType == 0 && _react2.default.createElement(
	          _R2.default,
	          { can: 'edit_lesson', by: 'disable' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-default', disabled: selected.length == 0 ? true : false, onClick: function onClick() {
	                (0, _LessonEditStudent2.default)({ schoolId: schoolId, selectMultiple: true, lesson_id_list: lesson_id_list, classID: classID, dispatch: dispatch, pagination: pagination, state: state }).then(function () {
	                  _this3.setState({
	                    selectedLesson: _extends({}, _this3.state.selectedLesson, {
	                      selected: []
	                    })
	                  });
	                });
	              } },
	            __('Reset Students', 'lessonTable')
	          )
	        ),
	        _react2.default.createElement(
	          _R2.default,
	          { can: cType == 0 ? 'edit_lesson' : 'edit_private_lesson', by: 'disable' },
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-default',
	              disabled: selected.length == 0 ? true : false,
	              onClick: function onClick() {
	                (0, _LessonEditColor2.default)({ classID: classID, lesson_id_list: lesson_id_list, dispatch: dispatch, pagination: pagination, state: state }).then(function () {
	                  _this3.setState({
	                    selectedLesson: _extends({}, _this3.state.selectedLesson, {
	                      selected: []
	                    })
	                  });
	                });
	              } },
	            __('Reset Color', 'lessonTable')
	          )
	        ),
	        _react2.default.createElement(
	          _R2.default,
	          { can: cType == 0 ? 'edit_lesson' : 'edit_private_lesson', by: 'disable' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-default', disabled: selected.length == 0 ? true : false, onClick: function onClick() {
	                (0, _confirm.confirm)(__('Deleted lessons are unrecoverable, proceed to delete?', 'lessonTable'), __('Delete Lessons', 'lessonTable')).then(function () {
	                  _this3.setState({ deleting: true });
	                  (0, _deleteMultiLesson2.default)({ lesson_id_list: lesson_id_list }).then(function (res) {
	                    _this3.setState({
	                      selectedLesson: _extends({}, _this3.state.selectedLesson, {
	                        selected: []
	                      }),
	                      deleting: false
	                    });
	                    if (res.result == 'success') {
	                      dispatch((0, _ducks.fetchClassLesson)(classID, {
	                        amount_per_page: pagination.itemsCountPerPage,
	                        current_page_number: pagination.activePage,
	                        after_today: state
	                      }));
	                    }
	                  });
	                });
	              } },
	            __('Delete Lessons', 'lessonTable')
	          )
	        ),
	        _react2.default.createElement(
	          _R2.default,
	          { can: cType == 0 ? 'create_lesson' : 'create_private_lesson', by: 'disable' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary pull-right', onClick: this.addLesson, disabled: cState == 0 ? true : false },
	            __('Add Lesson', 'class')
	          )
	        )
	      ), _React$createElement)),
	      _react2.default.createElement(_StudentInfoFloat2.default, {
	        studentInfo: student_list,
	        lessonNumber: lesson_number,
	        show: openFloatModal,
	        target: floatTarget,
	        onCloseFloat: this.closeFloat,
	        isLoading: fetchingStudentList
	      })
	    );
	  };
	
	  return LessonTable;
	}(_react.Component);
	
	exports.default = LessonTable;
	module.exports = exports['default'];

/***/ },

/***/ "Eceu":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _NameCircle = __webpack_require__("Wsaj");
	
	var _NameCircle2 = _interopRequireDefault(_NameCircle);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeacherListTd = function (_Component) {
	  _inherits(TeacherListTd, _Component);
	
	  function TeacherListTd(props) {
	    _classCallCheck(this, TeacherListTd);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  TeacherListTd.prototype.render = function render() {
	    var _props = this.props,
	        lessonInfo = _props.lessonInfo,
	        classDetail = _props.classDetail;
	    var cType = classDetail.detail.cType;
	    var teacher_list = lessonInfo.teacher_list;
	
	    var maxZIndex = teacher_list.length;
	
	    if ((0, _R.userCan)(cType == 0 ? 'read_class_teacher' : 'read_private_class_teacher')) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'lesson-teacher-list' },
	        teacher_list.map(function (teacher, index) {
	          return _react2.default.createElement(_NameCircle2.default, {
	            key: index,
	            firstName: teacher.stName,
	            showFullName: false,
	            style: { zIndex: maxZIndex - index }
	          });
	        })
	      );
	    } else {
	      return _react2.default.createElement('div', null);
	    }
	  };
	
	  return TeacherListTd;
	}(_react.Component);
	
	exports.default = TeacherListTd;
	module.exports = exports['default'];

/***/ },

/***/ "2EBe":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StudentAmountTd = function (_Component) {
	  _inherits(StudentAmountTd, _Component);
	
	  function StudentAmountTd(props) {
	    _classCallCheck(this, StudentAmountTd);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  StudentAmountTd.prototype.render = function render() {
	    var _props = this.props,
	        lessonInfo = _props.lessonInfo,
	        classDetail = _props.classDetail,
	        openFloat = _props.openFloat;
	    var student_amount = lessonInfo.student_amount,
	        lesson_number = lessonInfo.lesson_number;
	
	
	    if (classDetail.detail.cType == 0 && (0, _R.userCan)('read_class_student') || classDetail.detail.cType !== 0) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'student-amount-list', onClick: openFloat(lessonInfo.lesson_id, lesson_number) },
	        _react2.default.createElement('i', { className: 'fa icon-users' }),
	        _react2.default.createElement(
	          'span',
	          null,
	          __('{student}', 'registrationTable', { student: student_amount })
	        )
	      );
	    } else {
	      return _react2.default.createElement('div', null);
	    }
	  };
	
	  return StudentAmountTd;
	}(_react.Component);
	
	exports.default = StudentAmountTd;
	module.exports = exports['default'];

/***/ },

/***/ "xtYq":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Float = __webpack_require__("oGSK");
	
	var _Float2 = _interopRequireDefault(_Float);
	
	__webpack_require__("PcKN");
	
	var _UI = __webpack_require__("OM1Z");
	
	var _StudentInfo = __webpack_require__("R3ni");
	
	var _StudentInfo2 = _interopRequireDefault(_StudentInfo);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var StudentInfoFloat = function (_Component) {
	  _inherits(StudentInfoFloat, _Component);
	
	  function StudentInfoFloat(props) {
	    _classCallCheck(this, StudentInfoFloat);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      studentInfo: props.studentInfo
	    };
	    return _this;
	  }
	
	  StudentInfoFloat.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.studentInfo !== this.props.studentInfo) {
	      this.setState({ studentInfo: nextProps.studentInfo });
	    }
	  };
	
	  StudentInfoFloat.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        target = _props.target,
	        onCloseFloat = _props.onCloseFloat;
	
	
	    return _react2.default.createElement(
	      _Float2.default,
	      {
	        container: global['--classtop-main-section'],
	        show: show,
	        target: target,
	        floatWidth: 250,
	        onCloseFloat: onCloseFloat
	      },
	      this.renderFloatContent()
	    );
	  };
	
	  StudentInfoFloat.prototype.renderFloatContent = function renderFloatContent() {
	    var _props2 = this.props,
	        lessonNumber = _props2.lessonNumber,
	        onCloseFloat = _props2.onCloseFloat,
	        isLoading = _props2.isLoading;
	    var studentInfo = this.state.studentInfo;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'studentInfo-float container-fluid' },
	      _react2.default.createElement(
	        'span',
	        { className: 'header' },
	        __('Lesson {lesson_amount}, {student_amount} students', 'lesson', { lesson_amount: lessonNumber, student_amount: studentInfo.length })
	      ),
	      _react2.default.createElement('i', { className: 'fa icon-cancel pull-right', onClick: onCloseFloat }),
	      _react2.default.createElement(
	        'ul',
	        null,
	        !isLoading && studentInfo.map(function (student, index) {
	          return _react2.default.createElement(
	            'li',
	            { key: index, onClick: function onClick() {
	                (0, _StudentInfo2.default)({ id: student.student_id });
	              } },
	            student.student_name
	          );
	        }),
	        isLoading && _react2.default.createElement(_Loading2.default, null)
	      )
	    );
	  };
	
	  return StudentInfoFloat;
	}(_react.Component);
	
	exports.default = StudentInfoFloat;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "PcKN":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"studentInfo-float":"studentInfo-float","header":"header","icon-cancel":"icon-cancel"};

/***/ },

/***/ "shHd":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    // disablePrivateClass,
	    // disableClass,
	    // mode
	
	  };
	
	  opts.mode = _DockBody.CREATE;
	
	  if (opts.classDetail && opts.classDetail instanceof _ClassDetail2.default !== true) {
	    // we used {...opts.classDetail } because it has to be a new object
	    return modal(_extends({}, opts, {
	      classDetail: new _ClassDetail2.default(opts.classDetail)
	    }));
	  }
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ClassDetail = __webpack_require__("715+");
	
	var _ClassDetail2 = _interopRequireDefault(_ClassDetail);
	
	var _DockBody = __webpack_require__("eHAp");
	
	var _DockBody2 = _interopRequireDefault(_DockBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_DockBody2.default);
	
	module.exports = exports['default'];

/***/ },

/***/ "eHAp":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.UPDATE = exports.CREATE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _getAllClass = __webpack_require__("oS9b");
	
	var _getAllClass2 = _interopRequireDefault(_getAllClass);
	
	var _EditLesson = __webpack_require__("/ulD");
	
	var _EditLesson2 = _interopRequireDefault(_EditLesson);
	
	var _getClassTeacherStudent = __webpack_require__("TnP3");
	
	var _getClassTeacherStudent2 = _interopRequireDefault(_getClassTeacherStudent);
	
	var _getLessonStudentList = __webpack_require__("9pkU");
	
	var _getLessonStudentList2 = _interopRequireDefault(_getLessonStudentList);
	
	var _Lesson = __webpack_require__("g5LE");
	
	var _Lesson2 = _interopRequireDefault(_Lesson);
	
	var _locale = __webpack_require__("wyHZ");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _filter = __webpack_require__("RyI1");
	
	var _filter2 = _interopRequireDefault(_filter);
	
	__webpack_require__("9oJb");
	
	var _ClassDetail = __webpack_require__("715+");
	
	var _ClassDetail2 = _interopRequireDefault(_ClassDetail);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <DockBody />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IMPORTANT: This component takes props from react-confirm
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This component is also shared by ../UpdateLesson
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - Tell me about what this dock does...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	//
	
	
	var CREATE = exports.CREATE = 'CREATE';
	var UPDATE = exports.UPDATE = 'UPDATE';
	
	var DockBody = function (_React$Component) {
	  _inherits(DockBody, _React$Component);
	
	  function DockBody(props) {
	    _classCallCheck(this, DockBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._renderChooseClass = _this._renderChooseClass.bind(_this);
	    _this._onSelectClass = _this._onSelectClass.bind(_this);
	    _this._reselectClass = _this._reselectClass.bind(_this);
	    _this.loadClassDetail = _this.loadClassDetail.bind(_this);
	    _this.afterSubmit = _this.afterSubmit.bind(_this);
	    _this.loadLessonStudentList = _this.loadLessonStudentList.bind(_this);
	
	    var classDetail = props.classDetail,
	        lesson = props.lesson;
	
	
	    _this.state = {
	      classDetail: classDetail,
	      lesson: lesson
	    };
	    return _this;
	  }
	
	  DockBody.prototype.afterSubmit = function afterSubmit(data) {
	    this.props.proceed(data);
	  };
	
	  DockBody.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var classDetail = _ref.classDetail,
	        lesson = _ref.lesson;
	
	    if (classDetail) {
	      this.setState({
	        classDetail: classDetail
	      });
	    }
	
	    if (lesson) {
	      this.setState({
	        lesson: lesson
	      });
	    }
	  };
	
	  DockBody.prototype.componentWillMount = function componentWillMount() {
	    var _props = this.props,
	        classId = _props.classId,
	        classDetail = _props.classDetail,
	        mode = _props.mode;
	    var lesson = this.state.lesson;
	
	
	    if (!classDetail && mode == UPDATE) {
	      this.loadClassDetail(classId);
	    }
	
	    //
	    // if the student list is empty we need to get student List
	    //
	    if (lesson && !lesson.studentList) {
	      this.loadLessonStudentList(lesson.id);
	    }
	  };
	
	  DockBody.prototype._onSelectClass = function _onSelectClass(classDetailArr) {
	    var classSelected = classDetailArr[0];
	
	    this.loadClassDetail(classSelected.id);
	  };
	
	  //
	  // load studentList onto list
	  //
	
	
	  DockBody.prototype.loadLessonStudentList = function loadLessonStudentList(lessonId) {
	    var _this2 = this;
	
	    var mode = this.props.mode;
	
	
	    this.setState({
	      fetchingStudentList: true
	    }, function () {
	      (0, _getLessonStudentList2.default)(lessonId).then(function (_ref2) {
	        var student_list = _ref2.student_list;
	
	        var lesson = _this2.state.lesson.toObject();
	
	        if (mode === CREATE) {
	          lesson.studentList = (0, _filter2.default)(student_list || [], function (student) {
	            return student.already_been_in_lesson === true;
	          });
	        } else {
	          lesson.studentList = student_list;
	        }
	
	        _this2.setState({
	          lesson: new _Lesson2.default(lesson),
	          fetchingStudentList: false
	        });
	      });
	    });
	  };
	
	  DockBody.prototype.loadClassDetail = function loadClassDetail(classId) {
	    var _this3 = this;
	
	    this.setState({
	      fetchingClassInfo: true
	    });
	
	    (0, _getClassTeacherStudent2.default)(classId).then(function (classDetail) {
	      _this3.setState({
	        classDetail: classDetail,
	        fetchingClassInfo: false
	      });
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  DockBody.prototype._reselectClass = function _reselectClass() {
	    this.setState({
	      classDetail: undefined
	    });
	  };
	
	  DockBody.prototype.render = function render() {
	    var _props2 = this.props,
	        isVisible = _props2.isVisible,
	        show = _props2.show,
	        dismiss = _props2.dismiss,
	        mode = _props2.mode,
	        chooseClass = _props2.chooseClass;
	    var _state = this.state,
	        classDetail = _state.classDetail,
	        lesson = _state.lesson,
	        fetchingClassInfo = _state.fetchingClassInfo,
	        fetchingStudentList = _state.fetchingStudentList,
	        loading = _state.loading;
	
	
	    var dockTitle = void 0;
	
	    if (chooseClass !== false) {
	      if (!classDetail) {
	        dockTitle = _react2.default.createElement(
	          'a',
	          null,
	          __('Class', 'schedule')
	        );
	      } else {
	        if (mode === CREATE) {
	          dockTitle = _react2.default.createElement(
	            'a',
	            { onClick: this._reselectClass },
	            _react2.default.createElement('i', { className: 'fa icon-angle-left' }),
	            '  ' + __('Search Class', 'schedule')
	          );
	        }
	      }
	    }
	
	    if (mode === UPDATE) {
	      dockTitle = __('Edit Lesson', _locale2.default);
	    }
	
	    var stillLoading = loading === true || fetchingStudentList === true || fetchingClassInfo === true;
	
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(
	        _UI.Dock,
	        {
	          className: 'add-lesson-dock',
	          dockTitle: dockTitle,
	          position: 'right',
	          isVisible: show,
	          size: 0.28,
	          onCloseDockClick: function onCloseDockClick() {
	            dismiss();
	          },
	          useDefaultCloseButton: true
	        },
	        stillLoading && _react2.default.createElement(_Loading2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'dock-content' },
	          !classDetail && stillLoading !== true && chooseClass !== false && _react2.default.createElement(
	            'div',
	            { className: 'class-list' },
	            this._renderChooseClass()
	          ),
	          classDetail && stillLoading !== true && this._renderLessonForm()
	        )
	      )
	    );
	  };
	
	  DockBody.prototype._renderChooseClass = function _renderChooseClass() {
	    var _props3 = this.props,
	        disablePrivateClass = _props3.disablePrivateClass,
	        disableClass = _props3.disableClass;
	
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    var opts = {
	      itemName: '',
	      searchPlaceholder: __('Search Class', 'schedule'),
	      itemList: [],
	      selected: [],
	      getItemLabel: function getItemLabel(item) {
	        return item.name;
	      },
	      fetchItems: function fetchItems(cb) {
	        (0, _getAllClass2.default)(schoolId).then(function (data) {
	          var classList = [];
	          (data['class list'] || []).map(function (cls) {
	            var add = true;
	            if (cls.cType == 1 && disablePrivateClass) {
	              add = false;
	            }
	            if (cls.cType == 0 && disableClass) {
	              add = false;
	            }
	
	            if (add) {
	              classList.push(new _ClassDetail2.default(cls));
	            }
	          });
	          cb(classList); // the default must be an empty array
	        }).catch(function (err) {
	          console.error(err);
	        });
	      },
	      isSelectedSortable: false,
	      components: {
	        SelectItem: function SelectItem(_ref3) {
	          var item = _ref3.item,
	              getItemLabel = _ref3.getItemLabel,
	              selected = _ref3.selected,
	              onClickSelect = _ref3.onClickSelect,
	              selectText = _ref3.selectText,
	              selectedText = _ref3.selectedText;
	
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'select-item', onClick: onClickSelect },
	            _react2.default.createElement(
	              'div',
	              { className: 'class-icon' },
	              item.type === 0 && _react2.default.createElement('i', { className: 'fa icon-users' }),
	              item.type === 1 && _react2.default.createElement('i', { className: 'fa icon-user' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item-class-name' },
	              item.name
	            ),
	            _react2.default.createElement('i', { className: 'fa icon-angle-right', style: { float: 'right' } })
	          );
	        }
	
	      }
	    };
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'action-title' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          __('Select Class To Add Lesson', 'schedule')
	        )
	      ),
	      _react2.default.createElement(_UI.SearchList, _extends({}, opts, { selectMultiple: false, onSelect: this._onSelectClass })),
	      _react2.default.createElement('div', { className: 'dock-footer' })
	    );
	  };
	
	  DockBody.prototype._renderLessonForm = function _renderLessonForm() {
	    var _state2 = this.state,
	        classDetail = _state2.classDetail,
	        lesson = _state2.lesson,
	        loading = _state2.loading;
	    var _props4 = this.props,
	        startDate = _props4.startDate,
	        studentList = _props4.studentList,
	        teacherList = _props4.teacherList;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('lesson-form', { 'loading': loading }) },
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        _react2.default.createElement(_EditLesson2.default, {
	          startDate: startDate,
	          studentList: studentList,
	          teacherList: teacherList,
	          lesson: lesson,
	          classDetail: classDetail,
	          afterSubmit: this.afterSubmit
	        })
	      )
	    );
	  };
	
	  return DockBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(DockBody);

/***/ },

/***/ "/ulD":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CREATE = exports.UPDATE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp; /**
	                    * <EditLesson />
	                    *
	                    * TODO: REFACTOR IT PLEASE
	                    *
	                    * This form allows user to choose a class, if chooseClass = true.
	                    * It returns an object which can be sent to API to add lesson.
	                    *
	                    * @parent anybody
	                    * @stateful
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("9bC3");
	
	var _UI = __webpack_require__("OM1Z");
	
	var _ClassDetail = __webpack_require__("715+");
	
	var _ClassDetail2 = _interopRequireDefault(_ClassDetail);
	
	var _Teacher = __webpack_require__("xSer");
	
	var _Teacher2 = _interopRequireDefault(_Teacher);
	
	var _Student = __webpack_require__("PT2B");
	
	var _Student2 = _interopRequireDefault(_Student);
	
	var _Lesson = __webpack_require__("g5LE");
	
	var _Lesson2 = _interopRequireDefault(_Lesson);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _sortBy = __webpack_require__("KBYM");
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _deleteLesson2 = __webpack_require__("mIYp");
	
	var _deleteLesson3 = _interopRequireDefault(_deleteLesson2);
	
	var _updateLessonWithTime = __webpack_require__("9dt9");
	
	var _updateLessonWithTime2 = _interopRequireDefault(_updateLessonWithTime);
	
	var _addMultipleLessonWithTime = __webpack_require__("Sbwa");
	
	var _addMultipleLessonWithTime2 = _interopRequireDefault(_addMultipleLessonWithTime);
	
	var _locale = __webpack_require__("vGN4");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FREQUENCY = ['daily', 'weekly', 'monthly'];
	
	var UPDATE = exports.UPDATE = 'UPDATE';
	var CREATE = exports.CREATE = 'CREATE';
	
	var EditLesson = (_temp = _class = function (_React$Component) {
	  _inherits(EditLesson, _React$Component);
	
	  function EditLesson(props) {
	    _classCallCheck(this, EditLesson);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.conflictDetailToSummary = _this.conflictDetailToSummary.bind(_this);
	    _this.deleteLesson = _this.deleteLesson.bind(_this);
	    _this.processFormData = _this.processFormData.bind(_this);
	    _this.getUiSchema = _this.getUiSchema.bind(_this);
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    _this.onError = _this.onError.bind(_this);
	    _this.getUiLogic = _this.getUiLogic.bind(_this);
	
	    var lesson = props.lesson,
	        classDetail = props.classDetail,
	        startDate = props.startDate,
	        studentList = props.studentList,
	        teacherList = props.teacherList;
	
	
	    _this.state = {
	      lesson: lesson,
	      formData: {},
	      processedFormData: {},
	      conflictedSummary: {
	        conflicted_classroom_result: false,
	        conflicted_teacher_summary: [],
	        conflicted_student_summary: []
	      }
	    };
	
	    if (typeof lesson !== 'undefined') {
	      _this.state.mode = UPDATE;
	
	      var teacher_id_list = [];
	      var student_id_list = [];
	
	      if (!lesson.teacherList && props.teacherList) {
	        teacherList.map(function (teacher) {
	          teacher_id_list.push({ id: teacher.teacher_id, stName: teacher.teacher_name });
	        });
	      }
	      if (!lesson.studentList && props.studentList) {
	        studentList.map(function (student) {
	          student_id_list.push({ id: student.student_id, student_name: student.student_name });
	        });
	      }
	
	      _this.state.formData = {
	        lesson_date: lesson.getDate(),
	        time_range_str: lesson.getStartTime() + ':::' + lesson.getEndTime(),
	        teacher_id_list_str: lesson.teacherList ? JSON.stringify(lesson.teacherList) : JSON.stringify(teacher_id_list),
	        student_id_list_str: lesson.studentList ? JSON.stringify(lesson.studentList) : JSON.stringify(student_id_list),
	        calendar_color: lesson.calendarColor,
	        note: lesson.note
	      };
	
	      if (lesson.classroomId) {
	        _this.state.formData.classroom_id_str = JSON.stringify([lesson.getClassroom()]);
	      }
	    } else if (typeof lesson === 'undefined' && props.classDetail) {
	      var _props$classDetail = props.classDetail,
	          classroomId = _props$classDetail.classroomId,
	          _teacherList = _props$classDetail.teacherList,
	          _studentList = _props$classDetail.studentList;
	
	
	      _this.state.formData = {
	        date_range_str: startDate + ':::' + startDate,
	        time_range_str: (0, _moment2.default)('900', 'hmm').format('HH:mm') + ':::' + (0, _moment2.default)('930', 'hmm').format('HH:mm'),
	        teacher_id_list_str: JSON.stringify(_teacherList),
	        student_id_list_str: JSON.stringify(_studentList)
	      };
	      _this.state.mode = CREATE;
	    }
	
	    _this.processFormData(_this.state.formData);
	    return _this;
	  }
	
	  EditLesson.prototype.deleteLesson = function deleteLesson() {
	    var _this2 = this;
	
	    var name = this.props.classDetail.name;
	    var lesson = this.state.lesson;
	
	
	    (0, _confirm.confirm)(__("Delete {name}'s Lesson?", 'classdetail', { name: name }), __('Delete Lesson', 'classdetail')).then(function () {
	      (0, _deleteLesson3.default)(lesson.id).then(function (data) {
	        // start_datetime is required to load schedule again
	        _this2.props.afterSubmit(_extends({}, data, { start_datetime: lesson.startTime }));
	      });
	    });
	  };
	
	  EditLesson.prototype.onError = function onError(errors) {
	    if (Array.isArray(errors) && errors.length > 0) {
	      var property = errors[errors.length - 1].property;
	
	      var name = property.replace('.', 'root_');
	      var $errorLabel = document.querySelectorAll('[for="' + name + '"]');
	
	      if ($errorLabel.length > 0) {
	        this.lessonFormRef.scrollTop = this.lessonFormRef.scrollTop + $errorLabel[0].getBoundingClientRect().top - 120;
	      }
	    }
	  };
	
	  EditLesson.prototype.onSubmit = function onSubmit(_ref) {
	    var _this3 = this;
	
	    var formData = _ref.formData;
	
	    var cls = this.state.classDetail || this.props.classDetail;
	
	    var id = cls.id;
	    var _state = this.state,
	        mode = _state.mode,
	        lesson = _state.lesson;
	
	
	    this.setState({
	      loading: true
	    });
	
	    var convertedForm = this.processFormData(formData);
	
	    if (mode === UPDATE) {
	      var toSubmit = {
	        start_datetime: convertedForm.start_datetime,
	        end_datetime: convertedForm.end_datetime,
	        teacher_id_list: convertedForm.teacher_id_list,
	        student_id_list: convertedForm.student_id_list,
	        classroom_id: convertedForm.classroom_id,
	        new_name: lesson.name,
	        calendar_color: convertedForm.calendar_color,
	        note: convertedForm.note
	      };
	
	      (0, _updateLessonWithTime2.default)(lesson.id, toSubmit).then(function (_ref2) {
	        var data = _ref2.data;
	
	        _this3.setState({
	          loading: false
	        }, function () {
	          if (data.conflicted_result === true) {
	            _this3.handleConflicts(_this3.conflictDetailToSummary(data), formData);
	          } else {
	            _this3.props.afterSubmit(data);
	          }
	        });
	      });
	    } else if (mode === CREATE) {
	      delete convertedForm.start_datetime;
	      delete convertedForm.end_datetime;
	      delete convertedForm.scheduling;
	
	      if (convertedForm.start_date == 'undefined' || convertedForm.start_time == 'undefined' || convertedForm.end_date == 'undefined' || convertedForm.end_time == 'undefined') {
	        return _alert.alert.warning(__('All Fields with * Must Be Filled', _locale2.default)).then(function () {
	          _this3.setState({ loading: false });
	        });
	      }
	
	      (0, _addMultipleLessonWithTime2.default)(id, convertedForm).then(function (_ref3) {
	        var data = _ref3.data;
	
	        _this3.setState({
	          loading: false
	        }, function () {
	          if (data.new_lesson_id_list && data.new_lesson_id_list.length == 0) {
	            _alert.alert.warning(__('The start and end date of the scheduling did not cover the class date selected, so a total of 0 lessons were created', _locale2.default)).then(function () {});
	          } else if (data.result === 'success') {
	            _this3.props.afterSubmit(data);
	          } else if (data.result === 'conflicted') {
	            _this3.handleConflicts(_this3.conflictDetailToSummary(data.summary), formData);
	          } else if (data.result == 'failure' && data.reason == 'start_time must be earlier than end_time') {
	            _alert.alert.warning(__('End Time Must Be Later Than Start Time', _locale2.default)).then(function () {});
	          }
	        });
	      }).catch(function (err) {
	        console.error(err);
	      });
	    }
	  };
	
	  EditLesson.prototype.handleConflicts = function handleConflicts(conflictedSummary, formData) {
	    var _this4 = this;
	
	    _alert.alert.warning(__('There are conflicts while creating a lesson.', 'classdetail'));
	    this.setState({
	      conflictedSummary: conflictedSummary
	    }, function () {
	      _this4.processFormData(formData);
	    });
	  };
	
	  //
	  // What is this?
	  // When you update one lesson with updateLessonWithTime(), it only returns conflict details
	  // and no summary while addMultipleLessonWithTime() does get a summary which is more useful
	  // for us. So we will have to convert "detail" to "summary."
	  //
	
	
	  EditLesson.prototype.conflictDetailToSummary = function conflictDetailToSummary(detail) {
	    var student = detail.student,
	        teacher = detail.teacher,
	        classroom = detail.classroom;
	
	    return {
	      conflicted_student_summary: (student.conflicted_student_list || []).map(function (s) {
	        return s.student_id;
	      }),
	      conflicted_teacher_summary: (teacher.conflicted_teacher_list || []).map(function (s) {
	        return s.teacher_id;
	      }),
	      conflicted_classroom_result: classroom.result
	    };
	  };
	
	  // onChange -> processFormData(do up the logic here) -> generateUISchema
	
	
	  EditLesson.prototype.processFormData = function processFormData(formData) {
	    var lesson_date = formData.lesson_date,
	        date_range_str = formData.date_range_str,
	        scheduling = formData.scheduling,
	        frequency = formData.frequency,
	        every = formData.every,
	        note = formData.note,
	        which_day_str = formData.which_day_str,
	        teacher_id_list_str = formData.teacher_id_list_str,
	        student_id_list_str = formData.student_id_list_str,
	        classroom_id_str = formData.classroom_id_str,
	        time_range_str = formData.time_range_str,
	        calendar_color = formData.calendar_color;
	    var mode = this.state.mode;
	
	    //
	    // We're going to convert formData into a format that we want
	    //
	
	    var start_date = void 0,
	        end_date = void 0;
	    if (date_range_str) {
	      var dateRanges = date_range_str.split(':::');
	      start_date = dateRanges[0];
	      end_date = dateRanges[1];
	    }
	
	    if (formData.scheduling === false) {
	      formData.date_range_str = start_date + ':::' + start_date;
	      end_date = start_date;
	    }
	
	    var which_day = void 0;
	    if (which_day_str) {
	      which_day = (0, _sortBy2.default)(JSON.parse(which_day_str));
	    }
	
	    var start_time = void 0,
	        end_time = void 0;
	    if (time_range_str) {
	      var timeRanges = time_range_str.split(':::');
	      start_time = timeRanges[0];
	      end_time = timeRanges[1];
	    }
	
	    var start_datetime = void 0,
	        end_datetime = void 0;
	    if (lesson_date && start_time && end_time) {
	      start_datetime = lesson_date + ' ' + start_time;
	      end_datetime = lesson_date + ' ' + end_time;
	    }
	
	    var classroom_id = void 0;
	    if (classroom_id_str) {
	      var classrooms = JSON.parse(classroom_id_str);
	      if (classrooms.length > 0) {
	        classroom_id = classrooms[0].id;
	      }
	    }
	
	    var teacher_id_list = void 0;
	    if (teacher_id_list_str) {
	      var teachers = JSON.parse(teacher_id_list_str);
	      teacher_id_list = teachers.map(function (teacherRaw) {
	        var teacher = new _Teacher2.default(teacherRaw);
	        return teacher.id;
	      });
	    }
	
	    var student_id_list = void 0;
	    if (student_id_list_str) {
	      var students = JSON.parse(student_id_list_str);
	      student_id_list = students.map(function (studentRaw) {
	        var student = new _Student2.default(studentRaw);
	        return student.id;
	      });
	    }
	
	    if (start_datetime) {
	      start_datetime = (0, _moment2.default)(start_datetime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm:ss');
	    }
	
	    if (end_datetime) {
	      end_datetime = (0, _moment2.default)(end_datetime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm:ss');
	    }
	
	    var converted = {
	      scheduling: scheduling,
	      frequency: frequency,
	      start_date: start_date,
	      start_datetime: start_datetime,
	      end_datetime: end_datetime,
	      every: every,
	      end_date: end_date,
	      start_time: start_time,
	      end_time: end_time,
	      which_day: which_day,
	      classroom_id: classroom_id,
	      student_id_list: student_id_list,
	      teacher_id_list: teacher_id_list,
	      note: note,
	      calendar_color: calendar_color
	    };
	
	    var uiLogic = this.getUiLogic(converted);
	
	    if (uiLogic.scheduling == true) {
	      formData.scheduling = true;
	    } else {
	      delete formData.scheduling;
	    }
	
	    var filtered = this.getUiSchema(converted, uiLogic);
	
	    this.setState({
	      processedFormData: filtered,
	      formData: formData
	    });
	
	    return filtered;
	  };
	
	  EditLesson.prototype.getUiLogic = function getUiLogic(converted) {
	    var scheduling = converted.scheduling,
	        frequency = converted.frequency,
	        start_date = converted.start_date,
	        start_datetime = converted.start_datetime,
	        end_datetime = converted.end_datetime,
	        every = converted.every,
	        end_date = converted.end_date,
	        start_time = converted.start_time,
	        end_time = converted.end_time,
	        which_day = converted.which_day,
	        classroom_id = converted.classroom_id,
	        teacher_id_list = converted.teacher_id_list,
	        student_id_list = converted.student_id_list,
	        calendar_color = converted.calendar_color;
	
	
	    var uiLogic = {
	      scheduling: false
	
	      // =========================================================
	      // When start_date and end_date are the same,
	      // we don't do scheduling
	    };if (start_date && end_date) {
	      uiLogic.scheduling = start_date !== end_date;
	      uiLogic.sameDate = start_date === end_date;
	    }
	    // =========================================================
	
	    // =========================================================
	    // When classType is 1on1, we disable selecting student
	    var classDetail = this.props.classDetail;
	
	
	    var classType = classDetail.getClassTypeStr();
	
	    uiLogic.classType = classType;
	
	    uiLogic.disableSelectingStudent = classType == '1on1';
	    // =========================================================
	
	    return uiLogic;
	  };
	
	  EditLesson.prototype.getUiSchema = function getUiSchema(processedFormData, uiLogic) {
	    var frequency = processedFormData.frequency,
	        start_date = processedFormData.start_date,
	        end_date = processedFormData.end_date,
	        classroom_id = processedFormData.classroom_id;
	    var _state2 = this.state,
	        mode = _state2.mode,
	        conflictedSummary = _state2.conflictedSummary;
	    var classDetail = this.props.classDetail;
	    var type = classDetail.type;
	
	    //
	    // STEP 1. Decide which 'every' and which 'which_day' should be used
	    //
	
	    var every = {
	      'ui:widget': 'dropdownselect',
	      shown: false,
	      inline: true
	    };
	
	    var which_day_str = {
	      shown: false
	
	      // we will store all the required fields
	    };var required = [];
	
	    if (mode === CREATE) {
	      if (uiLogic.scheduling == true) {
	        required = ['frequency'].concat(required);
	
	        if (FREQUENCY[frequency] == 'daily') {
	          required = ['every'].concat(required);
	          every = _extends({}, every, {
	            'ui:options': {
	              selectOptions: [{ value: 1, label: __('1 day', 'classdetail') }, { value: 2, label: __('2 days', 'classdetail') }, { value: 3, label: __('3 days', 'classdetail') }, { value: 4, label: __('4 days', 'classdetail') }, { value: 5, label: __('5 days', 'classdetail') }, { value: 6, label: __('6 days', 'classdetail') }]
	            },
	            shown: true
	          });
	        }
	
	        if (FREQUENCY[frequency] == 'weekly') {
	          required = ['every', 'which_day_str'].concat(required);
	          every = _extends({}, every, {
	            'ui:options': {
	              selectOptions: [{ value: 1, label: __('1 week', 'classdetail') }, { value: 2, label: __('2 weeks', 'classdetail') }, { value: 3, label: __('3 weeks', 'classdetail') }, { value: 4, label: __('4 weeks', 'classdetail') }, { value: 5, label: __('5 weeks', 'classdetail') }, { value: 6, label: __('6 weeks', 'classdetail') }]
	            },
	            shown: true
	          });
	
	          which_day_str = _extends({}, which_day_str, {
	            'ui:widget': 'selectDaysInWeek',
	            shown: true
	          });
	        }
	
	        if (FREQUENCY[frequency] == 'monthly') {
	          required = ['which_day_str'].concat(required);
	          which_day_str = _extends({}, which_day_str, {
	            'ui:widget': 'selectDaysInMonth',
	            shown: true
	          });
	        }
	      }
	    } // if (mode==='CREATE')
	
	
	    //
	    // STEP 3. Get required and REMOVE data that's not used
	    //
	    if (uiLogic.scheduling) {
	      processedFormData.frequency = processedFormData.frequency || 0;
	      processedFormData.every = processedFormData.every || 1;
	      processedFormData.which_day = processedFormData.which_day || [];
	    }
	
	    if (uiLogic.classType == 'multi') {
	      required = required.concat([
	        //
	        // NOTE: student and teacher are not required to input
	        // 'student_id_list_str',
	        // 'teacher_id_list_str',
	        //
	      ]);
	    } else if (uiLogic.classType == '1on1') {
	      //
	      // STEP 3-1. if classtype is '1on1'
	      //
	      // processedFormData.student_id_list = classDetail.getStudentIdList(); // because student cannot be modified we use the ids from classDetail
	      // NOTE: removed because now we allow adding extra students to private class
	    }
	
	    if (mode === CREATE) {
	      required = ['date_range_str', 'time_range_str'].concat(required);
	    } else if (mode === UPDATE) {
	      required = ['lesson_date', 'time_range_str'].concat(required);
	    }
	
	    var updateSpecificFields = void 0;
	    var createSpecificFields = void 0;
	
	    if (mode === CREATE) {
	      createSpecificFields = {
	        date_range_str: {
	          title: __('Date', 'DateRange'),
	          type: 'string'
	        },
	        frequency: {
	          title: __('Frequency', 'classdetail'),
	          type: 'number'
	
	        },
	        every: {
	          type: 'number',
	          title: __('Every', 'classdetail')
	        },
	        which_day_str: {
	          type: 'string',
	          title: __('Select', 'classdetail')
	        }
	      };
	    }
	    if (mode === UPDATE) {
	      updateSpecificFields = {
	        lesson_date: {
	          type: 'string',
	          title: __('Date', 'DateRange')
	        }
	      };
	    }
	
	    //
	    // STEP 4. Set Schema. note that we're passing studentList as itemList
	    //
	    this.schema = {
	      type: 'object',
	      required: required,
	      properties: _extends({}, updateSpecificFields, createSpecificFields, {
	
	        teacher_id_list_str: {
	          title: __('Teachers', 'class'),
	          type: 'string',
	          itemList: classDetail.teacherList, // to be used in SelectClassTeacher modal
	          mixin: function mixin(item) {
	            return item;
	          }
	        },
	        student_id_list_str: {
	          title: __('Students', 'class'),
	          type: 'string'
	        },
	        classroom_id_str: {
	          title: __('Classroom', 'classdetail'),
	          type: 'string'
	        },
	        time_range_str: {
	          title: __('Time', 'TimeRange'),
	          type: 'string'
	        },
	        calendar_color: {
	          title: __('Lesson Color', 'schedule'),
	          type: 'string'
	        },
	        scheduling: {
	          title: __('Batch Scheduling', 'classdetail'),
	          type: 'boolean'
	        },
	        note: {
	          title: __('Note', 'EditLessonForm'),
	          type: 'string'
	        }
	      })
	
	      //
	      // STEP 5. return UI Schema
	      //
	    };this.uiSchema = {
	      items: {
	        lesson_date: {
	          'ui:widget': 'datepicker',
	          shown: mode === UPDATE
	        },
	        date_range_str: {
	          'ui:widget': 'daterange',
	          'ui:options': {
	            orientation: "vertical",
	            verticalHeight: 568,
	            minimumNights: 0 // THIS allow selecting a same date
	          },
	          shown: mode === CREATE,
	          afterContent: uiLogic.sameDate === true ? _react2.default.createElement(
	            'div',
	            { className: 'same-dates-message' },
	            _react2.default.createElement('i', { className: 'fa icon-calendar' }),
	            ' ',
	            __('Same date will only create single lesson', 'schedule')
	          ) : ''
	        },
	
	        time_range_str: {
	          className: 'col-sm-12',
	          'ui:widget': 'timerange',
	          'ui:options': {
	            'minuteStep': 5
	          }
	        },
	
	        frequency: {
	          'ui:widget': 'dropdownselect',
	          'ui:options': {
	            selectOptions: [{ value: FREQUENCY.indexOf('daily'), label: __('By Day', 'classdetail') }, { value: FREQUENCY.indexOf('weekly'), label: __('By Week', 'classdetail') }, { value: FREQUENCY.indexOf('monthly'), label: __('By Month', 'classdetail') }]
	          },
	          shown: uiLogic.scheduling === true,
	          inline: true
	        },
	
	        every: every,
	
	        which_day_str: which_day_str,
	
	        classroom_id_str: {
	          className: 'col-sm-12',
	          'ui:widget': 'selectClassroom',
	          'ui:options': {
	            conflictedIDs: conflictedSummary.conflicted_classroom_result === true ? [classroom_id] : []
	          },
	          shown: true,
	          afterContent: conflictedSummary.conflicted_classroom_result === true ? _react2.default.createElement(
	            'div',
	            { className: 'error-message' },
	            __('The classroom is in use during this period.', 'classdetail')
	          ) : _react2.default.createElement('div', null)
	        },
	
	        teacher_id_list_str: {
	          className: 'col-sm-12',
	          'ui:widget': 'selectClassTeacher',
	          'ui:options': {
	            selectMultiple: true,
	            conflictedIDs: conflictedSummary.conflicted_teacher_summary
	          },
	          shown: true,
	          afterContent: conflictedSummary.conflicted_teacher_summary.length > 0 ? _react2.default.createElement(
	            'div',
	            { className: 'error-message' },
	            __('One or more teachers are occupied during this period.', 'classdetail')
	          ) : _react2.default.createElement('div', null)
	        },
	
	        student_id_list_str: {
	          className: 'col-sm-12',
	          'ui:widget': 'selectClassStudent',
	          'ui:options': {
	            selectMultiple: true,
	            // selectMultiple: type == 0 ? true : false,
	            conflictedIDs: conflictedSummary.conflicted_student_summary
	            // disableSelect: uiLogic.disableSelectingStudent, // NOTE: as per FDT's request, we removed the restriction
	          },
	          shown: true,
	          afterContent: conflictedSummary.conflicted_student_summary.length > 0 ? _react2.default.createElement(
	            'div',
	            { className: 'error-message' },
	            __('One or more students are occupied during this period.', 'classdetail')
	          ) : _react2.default.createElement('div', null)
	        },
	
	        note: {
	          className: 'col-sm-12',
	          'ui:widget': 'textarea',
	          shown: true,
	          'ui:options': {
	            maxlength: 255
	          }
	        },
	
	        calendar_color: {
	          className: 'col-sm-12',
	          'ui:widget': 'colorpicker',
	          'ui:options': {
	            width: '100%'
	          },
	          shown: true
	        }
	
	      }
	    };
	
	    return processedFormData;
	  };
	
	  EditLesson.prototype.render = function render() {
	    var _this5 = this;
	
	    var _props = this.props,
	        classDetail = _props.classDetail,
	        _props$lesson = _props.lesson,
	        lesson = _props$lesson === undefined ? {} : _props$lesson;
	    var _state3 = this.state,
	        formData = _state3.formData,
	        mode = _state3.mode,
	        loading = _state3.loading;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('add-lesson-form'), 'data-dev-note': 'LOCATED in template/Forms/EditLesson.js', ref: function ref(f) {
	          _this5.lessonFormRef = f;
	        } },
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        mode === CREATE && _react2.default.createElement(
	          'h5',
	          null,
	          __('Add New Lesson', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'h3',
	          { className: 'add-lesson-class-name' },
	          lesson.title || classDetail.name
	        ),
	        _react2.default.createElement(
	          _UI.Form,
	          {
	            fetching: loading,
	            formData: formData,
	            onSubmit: this.onSubmit,
	            onError: this.onError,
	            schema: this.schema,
	            uiSchema: this.uiSchema,
	            onChange: this.processFormData,
	            getSubmitButton: function getSubmitButton(s) {
	              _this5.submit = s;
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'button-section' },
	            _react2.default.createElement(
	              _UI.Button,
	              { type: 'submit', bsStyle: 'primary' },
	              __('Save', 'teacher')
	            ),
	            mode === UPDATE && _react2.default.createElement(
	              _UI.Button,
	              { bsStyle: 'link', className: 'danger', onClick: this.deleteLesson },
	              __('Delete Lesson', 'classdetail')
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return EditLesson;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = EditLesson;

/***/ },

/***/ "9bC3":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"add-lesson-form":"add-lesson-form","same-dates-message":"same-dates-message","Select-value":"Select-value","Select-menu-outer":"Select-menu-outer","button-section":"button-section"};

/***/ },

/***/ "g5LE":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Mediator2 = __webpack_require__("ek+r");
	
	var _Mediator3 = _interopRequireDefault(_Mediator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Lesson = function (_Mediator) {
	  _inherits(Lesson, _Mediator);
	
	  function Lesson(rawData) {
	    var _ret;
	
	    _classCallCheck(this, Lesson);
	
	    var _this = _possibleConstructorReturn(this, _Mediator.call(this, rawData));
	
	    _this.setVersion('v1', ['classroom_id', 'classroom_name', 'lesson_end_time', 'lesson_start_time', 'lesson_id', 'lesson_iso_weekday', 'lesson_minutes', 'lesson_name', 'lesson_number', 'lesson_status', 'student_absent_amount', 'student_amount', 'student_attend_amount', 'student_call_sick_amount', 'student_late_amount', 'student_list', 'teacher_unchecked_amount', 'teacher_list', 'teacher_checked_amount', 'calendar_color', 'note'], {});
	
	    _this.setVersion('v2', ['allDay', 'class_name', 'class_type', 'classroom_name', 'id', 'lCalendarColor', 'lClass', 'lClassroom', 'lDuration', 'lEndTime', 'lName', 'lStartTime', 'lState', 'lesson_number', 'student_amount', 'teacher_list', 'title', 'note'], {});
	
	    _this.__schema = {
	      id: { alias: ['lesson_id', 'id'] },
	      name: { alias: ['lesson_name', 'name', 'lName'] },
	      title: { alias: ['title'] },
	      endTime: { alias: ['lesson_end_time', 'end_time', 'lEndTime'] },
	      startTime: { alias: ['lesson_start_time', 'start_time', 'lStartTime'] },
	      isoWeekday: { alias: ['lesson_iso_weekday', 'iso_weekday'] },
	      minutes: { alias: ['lesson_minutes', 'minutes'] },
	      lessonNumber: { alias: ['lesson_number'] },
	      status: { alias: ['lesson_status', 'status', 'lState'] },
	
	      allDay: { alias: ['allDay'] },
	      duration: { alias: ['lDuration', 'duration'] },
	
	      classId: { alias: ['lClass'] },
	      className: { alias: ['class_name'] },
	      classType: { alias: ['class_type'] },
	
	      classroomId: { alias: ['classroom_id', 'lClassroom'] },
	      classroomName: { alias: ['classroom_name', 'classroom_name'] },
	
	      studentAbsentAmount: { alias: ['student_absent_amount'] },
	      studentAmount: { alias: ['student_amount'] },
	      studentAttendAmount: { alias: ['student_attend_amount'] },
	      studentCallSickAmount: { alias: ['student_call_sick_amount'] },
	      studentLateAmount: { alias: ['student_late_amount'] },
	      studentList: { alias: ['student_list', 'studentList'] },
	
	      teacherList: { alias: ['teacher_list'] },
	      teacherCheckedAmount: { alias: ['teacher_checked_amount'] },
	      teacherUncheckedAmount: { alias: ['teacher_checked_amount'] },
	
	      calendarColor: { alias: ['calendar_color', 'calendarColor'] },
	      note: { alias: ['note'] }
	    };
	
	    return _ret = _this.create(), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Lesson.prototype.getDate = function getDate() {
	    var startTime = this.__privateData.startTime;
	
	    if (startTime) {
	      var parts = startTime.split(" ");
	      return parts[0];
	    }
	  };
	
	  Lesson.prototype.getStartTime = function getStartTime() {
	    var startTime = this.__privateData.startTime;
	
	    if (startTime) {
	      var parts = startTime.split(" ");
	      // return parts[1].substring(0, parts[1].length - 3);
	      return parts[1];
	    }
	  };
	
	  Lesson.prototype.getEndTime = function getEndTime() {
	    var endTime = this.__privateData.endTime;
	
	    if (endTime) {
	      var parts = endTime.split(" ");
	      return parts[1];
	    }
	  };
	
	  Lesson.prototype.getClassroom = function getClassroom() {
	    return {
	      id: this.__privateData.classroomId,
	      name: this.__privateData.classroomName
	    };
	  };
	
	  Lesson.prototype.getTeacherIdList = function getTeacherIdList() {
	    if (Array.isArray(this.__privateData.teacherList)) {
	      return this.__privateData.teacherList.map(function (teacher) {
	        return teacher.id;
	      });
	    } else {
	      return [];
	    }
	  };
	
	  Lesson.prototype.getStudentIdList = function getStudentIdList() {
	    if (Array.isArray(this.__privateData.studentList)) {
	      return this.__privateData.studentList.map(function (student) {
	        return student.id;
	      });
	    } else {
	      return [];
	    }
	  };
	
	  return Lesson;
	}(_Mediator3.default);
	
	exports.default = Lesson;
	module.exports = exports['default'];

/***/ },

/***/ "mIYp":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = deleteLesson;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deleteLesson(lessonId) {
	
	  if (!lessonId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing lesson Id')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/d_clslss/" + lessonId + "/",
	      'method': 'DELETE',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "9dt9":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = updateLessonWithTime;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  "new_name": _joiBrowser2.default.string().allow(''),
	  "start_datetime": _joiBrowser2.default.string().allow(''),
	  "end_datetime": _joiBrowser2.default.string().allow(''),
	  "teacher_id_list": _joiBrowser2.default.array().items(_joiBrowser2.default.number().integer()),
	  "student_id_list": _joiBrowser2.default.array().items(_joiBrowser2.default.number().integer()),
	  "classroom_id": _joiBrowser2.default.number().integer().allow(''),
	  "calendar_color": _joiBrowser2.default.string().allow(''),
	  "note": _joiBrowser2.default.string().allow('')
	});
	
	function updateLessonWithTime(lessonId, lessonInfo) {
	
	  if (!lessonId) {
	    throw 'missing lesson(event) ID';
	  }
	
	  var validateResult = _joiBrowser2.default.validate(lessonInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, lessonInfo);
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/u_lss_with_time/' + lessonId + '/',
	      'method': 'PUT',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "Sbwa":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = addMultipleLessonWithTime;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  'frequency': _joiBrowser2.default.number().integer(),
	  'every': _joiBrowser2.default.number().integer(),
	  'which_day': _joiBrowser2.default.array().items(_joiBrowser2.default.number().integer()),
	  'start_date': _joiBrowser2.default.string().allow(''),
	  'end_date': _joiBrowser2.default.string().allow(''),
	  'start_time': _joiBrowser2.default.string().allow(''),
	  'end_time': _joiBrowser2.default.string().allow(''),
	  'student_id_list': _joiBrowser2.default.array().items(_joiBrowser2.default.number().integer()),
	  'teacher_id_list': _joiBrowser2.default.array().items(_joiBrowser2.default.number().integer()),
	  'classroom_id': _joiBrowser2.default.number().integer(),
	  'calendar_color': _joiBrowser2.default.string().allow(''),
	  "note": _joiBrowser2.default.string().allow('')
	});
	
	function addMultipleLessonWithTime(classId, lessonInfo) {
	
	  if (!classId) {
	    throw 'missing a class ID';
	  }
	
	  var validateResult = _joiBrowser2.default.validate(lessonInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, lessonInfo, {
	    frequency: lessonInfo.frequency ? lessonInfo.frequency : 0
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/add_multi_lsn_with_time/' + classId + '/',
	      'method': 'POST',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "vGN4":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'EditLessonForm',
	  code: 'CN',
	  text: {
	    'Add New Lesson': '排新课节',
	    'Note': '备注',
	    'The start and end date of the scheduling did not cover the class date selected, so a total of 0 lessons were created': '您设置的批量排课起止日期未覆盖您选择的上课日期，所以共排了0节课。',
	    'End Time Must Be Later Than Start Time': '结束时间必须晚于开始时间',
	    'All Fields with * Must Be Filled': '带*號的字段必須填寫',
	    '': ''
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "9pkU":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getLessonStudentList;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getLessonStudentList(lessonId) {
	
	  if (!lessonId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing lesson Id (number)')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/g_chc/" + lessonId + "/",
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "wyHZ":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'AddLessonDock',
	  code: 'CN',
	  text: {
	    'Edit Lesson': '编辑课节'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "9oJb":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"add-lesson-dock":"add-lesson-dock","lesson-form":"lesson-form","content":"content","loading":"loading","add-lesson-class-name":"add-lesson-class-name","class-list":"class-list","searchbar-wrapper":"searchbar-wrapper","select-list":"select-list","select-item":"select-item","class-icon":"class-icon","icon-angle-right":"icon-angle-right","item-class-name":"item-class-name","fa":"fa","form-group":"form-group","form-field":"form-field"};

/***/ },

/***/ "0Crp":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("Ht05");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "Ht05":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("VYwO");
	
	var _ModalContent = __webpack_require__("bcAE");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'attendance-modal',
	        hasHeader: false,
	        hasFooter: false,
	        fixedWidth: 460,
	        contentHeight: 220,
	        onCloseModalClick: dismiss,
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, this.props)
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "VYwO":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"lesson-rest-time-content":"lesson-rest-time-content","header":"header","btn-wrapper":"btn-wrapper","success":"success","error":"error"};

/***/ },

/***/ "bcAE":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TimeRange = __webpack_require__("eL63");
	
	var _TimeRange2 = _interopRequireDefault(_TimeRange);
	
	var _updateMultiLesson = __webpack_require__("uJIf");
	
	var _updateMultiLesson2 = _interopRequireDefault(_updateMultiLesson);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ducks = __webpack_require__("lDbx");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      start_time: '',
	      end_time: '',
	      status: 'success',
	      errorMessage: ''
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    return _this;
	  }
	
	  ModalContent.prototype.onChange = function onChange(res) {
	    var start_time = (0, _moment2.default)(res.startTime, 'HH:mm').format('HH:mm:ss');
	    var end_time = (0, _moment2.default)(res.endTime, 'HH:mm').format('HH:mm:ss');
	
	    this.setState({ start_time: start_time, end_time: end_time });
	  };
	
	  ModalContent.prototype.onSubmit = function onSubmit() {
	    var _this2 = this;
	
	    var _props = this.props,
	        classID = _props.classID,
	        selected = _props.selected,
	        dismiss = _props.dismiss,
	        dispatch = _props.dispatch,
	        proceed = _props.proceed,
	        pagination = _props.pagination,
	        state = _props.state;
	    var _state = this.state,
	        start_time = _state.start_time,
	        end_time = _state.end_time;
	
	    var lesson_id_list = [];
	    selected.map(function (lesson) {
	      lesson_id_list.push(lesson.lesson_id);
	    });
	
	    (0, _updateMultiLesson2.default)(classID, { lesson_id_list: lesson_id_list, start_time: start_time, end_time: end_time, conflict_tag: 'allLessonNotAdd' }).then(function (res) {
	      if (res.result == 'failure' && res.reason == 'can not change time of lessons in the same date') {
	        _this2.setState({ status: 'error', errorMessage: __('Unable to change lesson time on the same date', 'lessonTable') });
	      } else if (res.result == 'edit failed because of conflict') {
	        _this2.setState({ status: 'error', errorMessage: __('Conflict', 'lessonTable') });
	      } else {
	        dispatch((0, _ducks.fetchClassLesson)(classID, {
	          amount_per_page: pagination.itemsCountPerPage,
	          current_page_number: pagination.activePage,
	          after_today: state
	        }));
	        proceed();
	        // dismiss()
	      }
	    });
	  };
	
	  ModalContent.prototype.render = function render() {
	    var dismiss = this.props.dismiss;
	    var _state2 = this.state,
	        status = _state2.status,
	        errorMessage = _state2.errorMessage;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'lesson-rest-time-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'header text-center' },
	        __('Reset Lesson Time', 'lessonTable')
	      ),
	      _react2.default.createElement(_TimeRange2.default, { onChange: this.onChange }),
	      _react2.default.createElement(
	        'div',
	        { className: status },
	        errorMessage
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'text-center btn-wrapper' },
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-default', onClick: function onClick() {
	              dismiss();
	            } },
	          __('Cancel', 'lessonTable')
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary', onClick: this.onSubmit },
	          __('Save', 'lessonTable')
	        )
	      )
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "uJIf":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Joi$object$keys;
	
	exports.default = updateMultiLesson;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONFLICT_TAG = ['addRegardless', 'allLessonNotAdd', 'conflictNotAdd'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys((_Joi$object$keys = {
	  "lesson_id_list": _joiBrowser2.default.array().items(_joiBrowser2.default.number().integer()).required(),
	  "student_id_list": _joiBrowser2.default.array().items(_joiBrowser2.default.number().integer()).allow(''),
	  "teacher_id_list": _joiBrowser2.default.array().items(_joiBrowser2.default.number().integer()).allow(''),
	  "classroom_id": _joiBrowser2.default.number().integer().allow(''),
	  "calendar_color": _joiBrowser2.default.string().allow(''),
	  "start_time": _joiBrowser2.default.string().allow(''),
	  "end_time": _joiBrowser2.default.string().allow(''),
	  "note": _joiBrowser2.default.string().allow(''),
	  "conflict_tag": _joiBrowser2.default.string().valid(CONFLICT_TAG).allow('')
	}, _Joi$object$keys["note"] = _joiBrowser2.default.string().allow(''), _Joi$object$keys));
	
	function updateMultiLesson(classId, classInfo) {
	
	  if (!classId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing class ID')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(classInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, classInfo, {
	    conflict_tag: CONFLICT_TAG.indexOf(classInfo.conflict_tag)
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/u_multi_lsns/" + classId + "/",
	      'method': 'PUT',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "JbjC":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("ATK4");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "ATK4":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("ZUzN");
	
	var _ModalContent = __webpack_require__("Ldud");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'attendance-modal',
	        hasHeader: false,
	        hasFooter: false,
	        fixedWidth: 460,
	        contentHeight: 350,
	        onCloseModalClick: dismiss,
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, this.props)
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "ZUzN":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"lesson-reset-color-content":"lesson-reset-color-content","header":"header","btn-wrapper":"btn-wrapper","circle-picker":"circle-picker","content":"content"};

/***/ },

/***/ "Ldud":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ColorPicker = __webpack_require__("ytvc");
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	var _updateMultiLesson = __webpack_require__("uJIf");
	
	var _updateMultiLesson2 = _interopRequireDefault(_updateMultiLesson);
	
	var _ducks = __webpack_require__("lDbx");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      calendar_color: ''
	    };
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    return _this;
	  }
	
	  ModalContent.prototype.onSubmit = function onSubmit() {
	    var _props = this.props,
	        dismiss = _props.dismiss,
	        dispatch = _props.dispatch,
	        classID = _props.classID,
	        lesson_id_list = _props.lesson_id_list,
	        proceed = _props.proceed,
	        pagination = _props.pagination,
	        state = _props.state;
	
	    (0, _updateMultiLesson2.default)(classID, { lesson_id_list: lesson_id_list, calendar_color: this.state.calendar_color, conflict_tag: 'allLessonNotAdd' }).then(function (res) {
	      dispatch((0, _ducks.fetchClassLesson)(classID, {
	        amount_per_page: pagination.itemsCountPerPage,
	        current_page_number: pagination.activePage,
	        after_today: state
	      }));
	      proceed();
	    });
	  };
	
	  ModalContent.prototype.render = function render() {
	    var _this2 = this;
	
	    var dismiss = this.props.dismiss;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'lesson-reset-color-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'header text-center' },
	        __('Reset Color', 'lessonTable')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'content text-center' },
	        __('Lesson color will be displayed in the calendar, making it organized and easy to view', 'lessonTable')
	      ),
	      _react2.default.createElement(_ColorPicker2.default, { className: 'text-center', value: this.state.calendar_color, onChange: function onChange(res) {
	          _this2.setState({ calendar_color: res });
	        } }),
	      _react2.default.createElement(
	        'div',
	        { className: 'text-center btn-wrapper' },
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-default', onClick: function onClick() {
	              dismiss();
	            } },
	          __('Cancel', 'lessonTable')
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary', onClick: this.onSubmit },
	          __('Save', 'lessonTable')
	        )
	      )
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "M5FJ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	// User can select a teacher
	// a wraper of SelectItemModal
	//
	// eg.
	// SelectTeacher({ schoolId })
	//  .then()
	//  .catch()
	//
	
	
	exports.default = function (opts) {
	  var schoolId = opts.schoolId,
	      selectMultiple = opts.selectMultiple,
	      classID = opts.classID,
	      lesson_id_list = opts.lesson_id_list,
	      dispatch = opts.dispatch,
	      pagination = opts.pagination,
	      state = opts.state,
	      _opts$amount_per_page = opts.amount_per_page,
	      amount_per_page = _opts$amount_per_page === undefined ? 25 : _opts$amount_per_page;
	
	
	  var conflicted = {};
	
	  // this will return a promise
	  return (0, _SelectItem2.default)(_extends({
	    headerTitle: __('Reset Lesson Teacher', 'lessonTable'),
	    headerIcon: 'fa icon-chalkboard-teacher',
	    itemName: __('Teacher', 'schedule'),
	    searchPlaceholder: __('Search Teacher', 'schedule'),
	    selectMultiple: selectMultiple,
	    backendSearch: true,
	    fetchItems: function fetchItems(cb, opts) {
	      var searchKeyword = opts.searchKeyword,
	          currentPageNumber = opts.currentPageNumber;
	
	
	      (0, _getCurrentTeacher2.default)({
	        schoolId: schoolId,
	        current_page_number: currentPageNumber,
	        keyword: searchKeyword,
	        amount_per_page: amount_per_page
	      }).then(function (data) {
	        var list = data.list,
	            page_amount = data.page_amount;
	
	
	        var pageMeta = {
	          maxPageNumber: page_amount
	        };
	        cb(list, pageMeta);
	      }).catch(function (err) {
	        console.error(err);
	      });
	    },
	    showName: true,
	    getItemLabel: function getItemLabel(teacher) {
	      return teacher.tName;
	    },
	    onConfirm: function onConfirm(props, Modal) {
	      var teacherArr = [];
	      props.selected.map(function (t) {
	        teacherArr.push(t.id);
	      });
	      if (teacherArr.length == 0) {
	        return props.proceed();
	      }
	      (0, _updateMultiLesson2.default)(classID, { lesson_id_list: lesson_id_list, teacher_id_list: teacherArr, conflict_tag: 'allLessonNotAdd' }).then(function (res) {
	        if (res.result == 'edit failed because of conflict') {
	          res.conflicted_detail.map(function (conflict) {
	            conflict.conflicted_detail.teacher.conflicted_teacher_list.map(function (teacher) {
	              conflicted[teacher.teacher_id] = true;
	            });
	          });
	          Modal.forceUpdate();
	        } else {
	          dispatch((0, _ducks.fetchClassLesson)(classID, {
	            amount_per_page: pagination.itemsCountPerPage,
	            current_page_number: pagination.activePage,
	            after_today: state
	          }));
	          props.proceed();
	        }
	      });
	    },
	    components: {
	      SelectItem: function SelectItem(_ref, Modal) {
	        var item = _ref.item,
	            getItemLabel = _ref.getItemLabel,
	            selected = _ref.selected,
	            onClickSelect = _ref.onClickSelect,
	            selectText = _ref.selectText,
	            selectedText = _ref.selectedText,
	            mixin = _ref.mixin;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'select-item' },
	          _react2.default.createElement(
	            'div',
	            null,
	            item.tName
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'select-button' },
	            conflicted[item.id] && _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              __('Conflict', 'classdetail')
	            ),
	            selected && _react2.default.createElement(
	              'span',
	              { className: 'btn-link currently-selected', onClick: onClickSelect },
	              selectText || __('Selected', 'SelectItemModal')
	            ),
	            !selected && _react2.default.createElement(
	              'span',
	              { className: 'btn-link', onClick: onClickSelect },
	              selectedText || __('Select', 'SelectItemModal')
	            )
	          )
	        );
	      }
	    }
	
	  }, opts));
	};
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectItem = __webpack_require__("k6Ef");
	
	var _SelectItem2 = _interopRequireDefault(_SelectItem);
	
	var _getCurrentTeacher = __webpack_require__("PRcT");
	
	var _getCurrentTeacher2 = _interopRequireDefault(_getCurrentTeacher);
	
	var _updateMultiLesson = __webpack_require__("uJIf");
	
	var _updateMultiLesson2 = _interopRequireDefault(_updateMultiLesson);
	
	var _ducks = __webpack_require__("lDbx");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ },

/***/ "m5cN":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	//
	// User can select a student.
	// a wraper of SelectItemModal
	//
	// eg.
	// SelectStudent({ schoolId })
	//  .then()
	//  .catch()
	//
	
	
	exports.default = function (opts) {
	  var schoolId = opts.schoolId,
	      selectMultiple = opts.selectMultiple,
	      classID = opts.classID,
	      lesson_id_list = opts.lesson_id_list,
	      dispatch = opts.dispatch,
	      pagination = opts.pagination,
	      state = opts.state,
	      _opts$itemPerPage = opts.itemPerPage,
	      itemPerPage = _opts$itemPerPage === undefined ? 25 : _opts$itemPerPage;
	
	
	  var conflicted = {};
	  // this will return a promise
	  return (0, _SelectItem2.default)(_extends({
	    headerTitle: __('Reset Lesson Student', 'lessonTable'),
	    headerIcon: 'fa icon-book-reader',
	    itemName: __('Student', 'schedule'),
	    searchPlaceholder: __('Search Student', 'schedule'),
	    selectMultiple: selectMultiple,
	    showName: true,
	    backendSearch: true,
	    getItemLabel: function getItemLabel(student) {
	      return student.sName;
	    },
	    fetchItems: function fetchItems(cb, opts) {
	      var searchKeyword = opts.searchKeyword,
	          currentPageNumber = opts.currentPageNumber;
	
	
	      (0, _getStudentSummary2.default)({
	        schoolId: schoolId,
	        itemPerPage: itemPerPage,
	        searchKeyword: searchKeyword,
	        pageNumber: currentPageNumber,
	        studentState: 'all_not_archived'
	      }).then(function (data) {
	        var pageMeta = {
	          maxPageNumber: data.pageAmount
	        };
	        if (currentPageNumber > data.pageAmount) {
	          return cb([], pageMeta);
	        }
	        var list = data.list;
	
	        cb(list, pageMeta);
	      }).catch(function (err) {
	        console.error(err);
	      });
	    },
	    onConfirm: function onConfirm(props, Modal) {
	      var studentArr = [];
	      props.selected.map(function (s) {
	        studentArr.push(s.schoolStudentID);
	      });
	      (0, _updateMultiLesson2.default)(classID, { lesson_id_list: lesson_id_list, student_id_list: studentArr, conflict_tag: 'allLessonNotAdd' }).then(function (res) {
	        if (res.result == 'edit failed because of conflict') {
	          res.conflicted_detail.map(function (conflict) {
	            conflict.conflicted_detail.student.conflicted_student_list.map(function (student) {
	              conflicted[student.student_id] = true;
	            });
	          });
	          Modal.forceUpdate();
	        } else {
	          dispatch((0, _ducks.fetchClassLesson)(classID, {
	            amount_per_page: pagination.itemsCountPerPage,
	            current_page_number: pagination.activePage,
	            after_today: state
	          }));
	          props.proceed();
	        }
	      });
	    },
	    components: {
	      SelectItem: function SelectItem(_ref, Modal) {
	        var item = _ref.item,
	            getItemLabel = _ref.getItemLabel,
	            selected = _ref.selected,
	            onClickSelect = _ref.onClickSelect,
	            selectText = _ref.selectText,
	            selectedText = _ref.selectedText,
	            mixin = _ref.mixin;
	
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'select-item' },
	          _react2.default.createElement(
	            'div',
	            null,
	            item.sName
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'select-button' },
	            conflicted[item.schoolStudentID] && _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              __('Conflict', 'classdetail')
	            ),
	            selected && _react2.default.createElement(
	              'span',
	              { className: 'btn-link currently-selected', onClick: onClickSelect },
	              selectText || __('Selected', 'SelectItemModal')
	            ),
	            !selected && _react2.default.createElement(
	              'span',
	              { className: 'btn-link', onClick: onClickSelect },
	              selectedText || __('Select', 'SelectItemModal')
	            )
	          )
	        );
	      }
	    }
	
	  }, opts));
	};
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectItem = __webpack_require__("k6Ef");
	
	var _SelectItem2 = _interopRequireDefault(_SelectItem);
	
	var _getStudentSummary = __webpack_require__("/y3Y");
	
	var _getStudentSummary2 = _interopRequireDefault(_getStudentSummary);
	
	var _updateMultiLesson = __webpack_require__("uJIf");
	
	var _updateMultiLesson2 = _interopRequireDefault(_updateMultiLesson);
	
	var _ducks = __webpack_require__("lDbx");
	
	var _Student = __webpack_require__("PT2B");
	
	var _Student2 = _interopRequireDefault(_Student);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ },

/***/ "ZFIi":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	// User can select a classroom.
	// a wraper of SelectItemModal
	//
	// eg.
	// SelectClass({ schoolId })
	//  .then()
	//  .catch()
	//
	
	
	exports.default = function (opts) {
	  var schoolId = opts.schoolId,
	      selectMultiple = opts.selectMultiple,
	      classID = opts.classID,
	      lesson_id_list = opts.lesson_id_list,
	      dispatch = opts.dispatch,
	      pagination = opts.pagination,
	      state = opts.state;
	
	
	  var conflicted = {};
	
	  // this will return a promise
	  return (0, _SelectItem2.default)(_extends({
	    headerTitle: __('Reset Lesson Classroom', 'lessonTable'),
	    headerIcon: 'fa icon-chalkboard',
	    itemName: __('Classroom', 'schedule'),
	    searchPlaceholder: __('Search Classroom', 'schedule'),
	    getItemLabel: function getItemLabel(item) {
	      return item.name;
	    },
	    fetchItems: function fetchItems(cb) {
	      (0, _getClassroom2.default)({ schoolId: schoolId }).then(function (_ref) {
	        var classroom_list = _ref.classroom_list;
	
	        cb(classroom_list.map(function (classroom) {
	          return new _Classroom2.default(classroom);
	        }));
	      }).catch(function (err) {
	        console.error(err);
	      });
	    },
	    onConfirm: function onConfirm(props, Modal) {
	      (0, _updateMultiLesson2.default)(classID, { lesson_id_list: lesson_id_list, classroom_id: props.items[0].id, conflict_tag: 'allLessonNotAdd' }).then(function (res) {
	        if (res.result == 'edit failed because of conflict') {
	          conflicted = {};
	          conflicted[props.items[0].id] = true;
	          Modal.forceUpdate();
	        } else {
	          dispatch((0, _ducks.fetchClassLesson)(classID, {
	            amount_per_page: pagination.itemsCountPerPage,
	            current_page_number: pagination.activePage,
	            after_today: state
	          }));
	          props.proceed();
	        }
	      });
	    },
	    components: {
	      SelectItem: function SelectItem(_ref2) {
	        var item = _ref2.item,
	            getItemLabel = _ref2.getItemLabel,
	            selected = _ref2.selected,
	            onClickSelect = _ref2.onClickSelect,
	            selectText = _ref2.selectText,
	            selectedText = _ref2.selectedText,
	            mixin = _ref2.mixin;
	
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'select-item' },
	          _react2.default.createElement(
	            'div',
	            null,
	            item.name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'select-button' },
	            conflicted[item.id] && _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              __('Conflict', 'classdetail')
	            ),
	            selected && _react2.default.createElement(
	              'span',
	              { className: 'btn-link currently-selected', onClick: onClickSelect },
	              selectText || __('Selected', 'SelectItemModal')
	            ),
	            !selected && _react2.default.createElement(
	              'span',
	              { className: 'btn-link', onClick: onClickSelect },
	              selectedText || __('Select', 'SelectItemModal')
	            )
	          )
	        );
	      }
	    }
	
	  }, opts));
	};
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectItem = __webpack_require__("k6Ef");
	
	var _SelectItem2 = _interopRequireDefault(_SelectItem);
	
	var _getClassroom = __webpack_require__("QWKB");
	
	var _getClassroom2 = _interopRequireDefault(_getClassroom);
	
	var _Classroom = __webpack_require__("WLpk");
	
	var _Classroom2 = _interopRequireDefault(_Classroom);
	
	var _updateMultiLesson = __webpack_require__("uJIf");
	
	var _updateMultiLesson2 = _interopRequireDefault(_updateMultiLesson);
	
	var _ducks = __webpack_require__("lDbx");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ },

/***/ "+zO1":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = deleteMultiLesson;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  "lesson_id_list": _joiBrowser2.default.array().items(_joiBrowser2.default.number().integer()).required()
	});
	
	function deleteMultiLesson(lessonInfo) {
	
	  var validateResult = _joiBrowser2.default.validate(lessonInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/delete_multi_lsn_with_time/",
	      'method': 'POST',
	      'data': JSON.stringify(lessonInfo),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "Mvxf":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	var _LessonStatusTd = __webpack_require__("/raN");
	
	var _LessonStatusTd2 = _interopRequireDefault(_LessonStatusTd);
	
	var _SelectStudent = __webpack_require__("BgXg");
	
	var _SelectStudent2 = _interopRequireDefault(_SelectStudent);
	
	var _Student = __webpack_require__("PT2B");
	
	var _Student2 = _interopRequireDefault(_Student);
	
	var _addStudentToMultiClass = __webpack_require__("CANW");
	
	var _addStudentToMultiClass2 = _interopRequireDefault(_addStudentToMultiClass);
	
	var _ducks = __webpack_require__("6mZg");
	
	__webpack_require__("i/UM");
	
	var _StudentName = __webpack_require__("hBDJ");
	
	var _StudentName2 = _interopRequireDefault(_StudentName);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _locale = __webpack_require__("qEX0");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _CreateClass = __webpack_require__("dFGx");
	
	var _CreateClass2 = _interopRequireDefault(_CreateClass);
	
	var _CreateClassOne = __webpack_require__("sbFW");
	
	var _CreateClassOne2 = _interopRequireDefault(_CreateClassOne);
	
	var _reactTooltip = __webpack_require__("Hh2+");
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CONTROLLER_WIDTH = '150px';
	
	var StudentTable = function (_Component) {
	  _inherits(StudentTable, _Component);
	
	  function StudentTable(props) {
	    _classCallCheck(this, StudentTable);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.fields = [{
	      name: 'schoolStudentName',
	      title: __('Class Student', 'classdetail'),
	      getTdProps: function getTdProps(_ref) {
	        var trData = _ref.trData;
	        var classStudentState = trData.classStudentState;
	
	        return {
	          style: { width: "16%", opacity: classStudentState === 0 ? 0.35 : 1 }
	        };
	      },
	      getTdContent: function getTdContent(_ref2) {
	        var studentInfo = _ref2.trData;
	
	        return _react2.default.createElement(
	          _R2.default,
	          { can: 'read_class_student', by: 'disable' },
	          _react2.default.createElement(_StudentName2.default, { id: studentInfo.schoolStudentID, name: studentInfo.schoolStudentName, checkStudentUpdate: function checkStudentUpdate(isUpdated) {
	              _this.checkStudentUpdate(isUpdated);
	            } })
	        );
	      }
	    }, {
	      name: 'arrangeLessonCount',
	      title: __('Lesson Count', 'classdetail'),
	      getTdProps: function getTdProps(_ref3) {
	        var trData = _ref3.trData;
	        var classStudentState = trData.classStudentState;
	
	        return {
	          style: { width: "16%", opacity: classStudentState === 0 ? 0.35 : 1 }
	        };
	      }
	    }, {
	      name: 'class_status',
	      title: __('Class Status', 'student'),
	      getTdProps: function getTdProps(_ref4) {
	        var trData = _ref4.trData;
	        var classStudentState = trData.classStudentState;
	
	        return {
	          style: { width: "16%", opacity: classStudentState === 0 ? 0.35 : 1 }
	        };
	      },
	      getTdContent: function getTdContent(_ref5) {
	        var studentInfo = _ref5.trData;
	
	        return _react2.default.createElement(_LessonStatusTd2.default, { studentInfo: studentInfo });
	      }
	    }, {
	      name: 'tuition_consumption',
	      title: __('Used/Paid', _locale2.default),
	      getTdProps: function getTdProps(_ref6) {
	        var trData = _ref6.trData;
	        var classStudentState = trData.classStudentState;
	
	        return {
	          style: { width: "16%", opacity: classStudentState === 0 ? 0.35 : 1 }
	        };
	      },
	      getTdContent: function getTdContent(_ref7) {
	        var studentInfo = _ref7.trData;
	
	        var currency = _this.props.schoolDetail.detail.currency;
	        var tuition_consumption = studentInfo.tuition_consumption;
	        var paidInFee = studentInfo.paidInFee;
	        var id = 'student-id-' + studentInfo.schoolStudentID;
	
	        if (tuition_consumption === null) {
	          return _react2.default.createElement(
	            'div',
	            { style: { cursor: 'pointer' }, onClick: function onClick() {
	                if (_this.props.classDetail.detail.cType == 0) {
	                  (0, _CreateClass2.default)({ mode: 'update', id: _this.props.classDetail.detail.classID });
	                } else if (_this.props.classDetail.detail.cType == 1) {
	                  (0, _CreateClassOne2.default)({ mode: 'update', id: _this.props.classDetail.detail.classID });
	                }
	              } },
	            __('Setup', _locale2.default)
	          );
	        } else {
	          if (studentInfo.total_discount_amount > 0) {
	            return _react2.default.createElement(
	              'div',
	              null,
	              tuition_consumption + '/' + paidInFee + currency,
	              _react2.default.createElement('i', { className: 'fa icon-tag', 'data-tip': true, 'data-for': id }),
	              _react2.default.createElement(_reactTooltip2.default, {
	                id: id,
	                effect: 'solid',
	                place: 'bottom',
	                type: 'info',
	                getContent: function getContent() {
	                  return __('Discounted', _locale2.default) + ' ' + studentInfo.total_discount_amount + ' ' + currency;
	                }
	              })
	            );
	          } else {
	            return _react2.default.createElement(
	              'div',
	              null,
	              tuition_consumption + '/' + paidInFee + currency
	            );
	          }
	        }
	      }
	    }, {
	      name: 'usedLessonCount',
	      title: __('Checked In', 'classdetail'),
	      getTdProps: function getTdProps(_ref8) {
	        var trData = _ref8.trData;
	        var classStudentState = trData.classStudentState;
	
	        return {
	          style: { width: "16%", opacity: classStudentState === 0 ? 0.35 : 1 }
	        };
	      }
	    }];
	    return _this;
	  }
	
	  StudentTable.prototype.checkStudentUpdate = function checkStudentUpdate(isUpdated) {
	    var _props = this.props,
	        tableData = _props.tableData,
	        dispatch = _props.dispatch;
	    var classID = tableData.classID;
	
	    if (isUpdated) {
	      dispatch((0, _ducks.fetchClassStudent)(classID));
	    }
	  };
	
	  StudentTable.prototype.render = function render() {
	    var _props2 = this.props,
	        tableData = _props2.tableData,
	        dispatch = _props2.dispatch,
	        settings = _props2.settings,
	        classDetail = _props2.classDetail,
	        title = _props2.title;
	    var classStudentList = tableData.classStudentList,
	        classID = tableData.classID;
	    var _classDetail$detail = classDetail.detail,
	        cType = _classDetail$detail.cType,
	        cState = _classDetail$detail.cState;
	
	
	    if (!classStudentList) {
	      return _react2.default.createElement('div', null);
	    }
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    return _react2.default.createElement(_UI.Table, {
	      data: classStudentList,
	      fields: this.fields,
	      className: 'classdetail-student-table',
	      settingThTitle: __('Settings', 'class'),
	      settingWidth: CONTROLLER_WIDTH,
	      settings: settings,
	      useMultiSelection: false,
	      oneSettingPerRow: false,
	      dropdownGuideWidth: 160,
	      dropdownGuideHeight: 228,
	      usePagination: false,
	      hasTopUtilSection: true,
	      topUtilSection: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'lesson-student-table' },
	          _react2.default.createElement(
	            'span',
	            { className: 'title' },
	            __('Students: ', 'studentTable')
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'student-count' },
	            classStudentList.length
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary', style: { visibility: 'hidden' } },
	            'TEST'
	          ),
	          title == 'student' && _react2.default.createElement(
	            _R2.default,
	            { can: 'assign_student_to_class', by: 'disable' },
	            _react2.default.createElement(
	              'button',
	              { className: 'pull-right btn btn-primary', disabled: cState == 0 ? true : false, onClick: function onClick() {
	                  (0, _SelectStudent2.default)({
	                    schoolId: schoolId,
	                    selectMultiple: true,
	                    selected: classStudentList.map(function (s) {
	                      return new _Student2.default(s);
	                    })
	                  }).then(function (res) {
	                    var arr = [];
	                    res.map(function (student) {
	                      arr.push(student.id);
	                    });
	                    (0, _addStudentToMultiClass2.default)(classID, arr).then(function (res) {
	                      dispatch((0, _ducks.fetchClassStudent)(classID));
	                    });
	                  });
	                } },
	              __('New Student', 'student')
	            )
	          )
	        )
	      )
	    });
	  };
	
	  return StudentTable;
	}(_react.Component);
	
	exports.default = StudentTable;
	module.exports = exports['default'];

/***/ },

/***/ "/raN":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__("K30H");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LessonStatusTd = function (_Component) {
	  _inherits(LessonStatusTd, _Component);
	
	  function LessonStatusTd(props) {
	    _classCallCheck(this, LessonStatusTd);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  LessonStatusTd.prototype.render = function render() {
	    var studentInfo = this.props.studentInfo;
	    var usedTotalQuantity = studentInfo.usedTotalQuantity,
	        paidTotalQuantity = studentInfo.paidTotalQuantity,
	        class_feeType = studentInfo.class_feeType,
	        classStudentFeeState = studentInfo.classStudentFeeState,
	        days_left = studentInfo.days_left;
	
	
	    if (class_feeType == 0) {
	      var status = __('Remaining ', 'classdetail');
	      var newDaysLeft = days_left;
	      if (days_left < 0) {
	        // status = __('Overdue ', 'classdetail')
	        newDaysLeft = 0;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'student-lesson-status' },
	        status + newDaysLeft + ' ' + _constants.QUANTITY_NAME_S[class_feeType]
	      );
	    } else {
	      return _react2.default.createElement(
	        'div',
	        { className: 'student-lesson-status' },
	        usedTotalQuantity + "/" + paidTotalQuantity + ' ' + _constants.QUANTITY_NAME_S[class_feeType]
	      );
	    }
	  };
	
	  return LessonStatusTd;
	}(_react.Component);
	
	exports.default = LessonStatusTd;
	module.exports = exports['default'];

/***/ },

/***/ "i/UM":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"lesson-student-table":"lesson-student-table","title":"title","student-count":"student-count","icon-users":"icon-users","icon-tag":"icon-tag"};

/***/ },

/***/ "qEX0":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'ClassDetail',
	  code: 'CN',
	  text: {
	    'Used/Paid': '已消耗/已缴学费',
	    'Setup': '未设置',
	    'Class Description': '班级简介',
	    'Discounted': '折扣'
	
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "x2Kx":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getDefaultTableSettings;
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _UpdateLesson = __webpack_require__("B6SM");
	
	var _UpdateLesson2 = _interopRequireDefault(_UpdateLesson);
	
	var _Attendance = __webpack_require__("wCrv");
	
	var _Attendance2 = _interopRequireDefault(_Attendance);
	
	var _deleteLesson = __webpack_require__("mIYp");
	
	var _deleteLesson2 = _interopRequireDefault(_deleteLesson);
	
	var _ducks = __webpack_require__("lDbx");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _R = __webpack_require__("nRUD");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDefaultTableSettings() {
	  var _this = this;
	
	  var TabComponent = this;
	  var _props = this.props,
	      dispatch = _props.dispatch,
	      pagination = _props.pagination;
	  var classId = this.props.params.classId;
	
	  var state = this.lessonsState === 'current' ? 1 : 0;
	  return [{
	    title: __('Edit', 'class'),
	    onClick: function onClick(_ref) {
	      var lesson = _ref.trData;
	      var classDetail = _this.props.classDetail;
	
	      (0, _UpdateLesson2.default)({ lesson: lesson, classDetail: classDetail.detail }).then(function (res) {
	        dispatch((0, _ducks.fetchClassLesson)(classId, {
	          amount_per_page: pagination.itemsCountPerPage,
	          current_page_number: pagination.activePage,
	          after_today: state
	        }));
	      });
	    },
	    isDisabled: function isDisabled(_ref2) {
	      var lessonInfo = _ref2.trData;
	
	      return lessonInfo.lesson_status == 1 || !(0, _R.userCan)('edit_lesson');
	    }
	  }, {
	    title: __('Check In', 'classdetail'),
	    onClick: function onClick(_ref3) {
	      var lessonInfo = _ref3.trData;
	
	      (0, _Attendance2.default)({
	        lessonId: lessonInfo.lesson_id
	      }).then(function () {
	        dispatch((0, _ducks.fetchClassLesson)(classId, {
	          amount_per_page: pagination.itemsCountPerPage,
	          current_page_number: pagination.activePage,
	          after_today: state
	        }));
	      });
	    },
	    isDisabled: function isDisabled(_ref4) {
	      var lessonInfo = _ref4.trData;
	
	      return !(0, _R.userCan)('manually_check_in') || _this.props.classDetail.detail.cState == 0;
	    }
	  }, {
	    title: __('Delete', 'classroom'),
	    onClick: function onClick(_ref5) {
	      var lessonInfo = _ref5.trData;
	
	      (0, _confirm.confirm)(__('Deleted lessons are unrecoverable, proceed to delete?', 'lessonTable')).then(function () {
	        (0, _deleteLesson2.default)(lessonInfo.lesson_id).then(function (res) {
	          dispatch((0, _ducks.fetchClassLesson)(classId, {
	            amount_per_page: pagination.itemsCountPerPage,
	            current_page_number: pagination.activePage,
	            after_today: state
	          }));
	        });
	      });
	    },
	    isDisabled: function isDisabled(_ref6) {
	      var lessonInfo = _ref6.trData;
	
	      return lessonInfo.lesson_status == 1 || !(0, _R.userCan)('edit_lesson');
	    }
	  }];
	}
	module.exports = exports['default'];

/***/ },

/***/ "B6SM":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  opts.mode = _DockBody.UPDATE;
	  // if there is no opts.classDetail, there should be at least classId to load it!
	  if (!opts.classDetail && !opts.classId) {
	    throw new Error('While opts.classDetail is missing, opts.classId is also missing which is needed to fetch classDetail');
	  }
	
	  if (opts.classDetail) {
	    opts.classDetail = new _ClassDetail2.default(opts.classDetail);
	  }
	
	  if (opts.lesson) {
	    opts.lesson = new _Lesson2.default(opts.lesson);
	  }
	
	  opts.chooseClass = false;
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _DockBody = __webpack_require__("eHAp");
	
	var _DockBody2 = _interopRequireDefault(_DockBody);
	
	var _Lesson = __webpack_require__("g5LE");
	
	var _Lesson2 = _interopRequireDefault(_Lesson);
	
	var _ClassDetail = __webpack_require__("715+");
	
	var _ClassDetail2 = _interopRequireDefault(_ClassDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	// Update Lesson Docker
	// This is a wrapper that updates docker.
	// All the logic is inside of AddLesson Dock
	//
	//
	var modal = (0, _reactConfirm.createConfirmation)(_DockBody2.default);
	
	module.exports = exports['default'];

/***/ },

/***/ "wCrv":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (!opts.lessonId) {
	    throw new Error('opts.lessonId is missing.');
	  }
	
	  if (!opts.classDetail) {
	    opts.needToLoadClassDetail = true;
	  }
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalProvider = __webpack_require__("IH5I");
	
	var _ModalProvider2 = _interopRequireDefault(_ModalProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// requires lesson ID to use this modal
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalProvider2.default);
	
	module.exports = exports['default'];

/***/ },

/***/ "IH5I":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalBody = __webpack_require__("Z2GV");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalProvider = function (_React$Component) {
	  _inherits(ModalProvider, _React$Component);
	
	  function ModalProvider(props) {
	    _classCallCheck(this, ModalProvider);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalProvider.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        otherProps = _objectWithoutProperties(_props, ['children']);
	
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(_ModalBody2.default, this.props)
	    );
	  };
	
	  return ModalProvider;
	}(_react2.default.Component);
	
	exports.default = ModalProvider;
	module.exports = exports['default'];

/***/ },

/***/ "Z2GV":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("ZQC/");
	
	var _ModalContent = __webpack_require__("DP95");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ducks = __webpack_require__("yuEY");
	
	var _ducks2 = __webpack_require__("lDbx");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    attendanceDetail: state.lessonAttendanceDetail,
	    classDetail: state.classLessonDetail
	  };
	};
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalBody.prototype.componentWillMount = function componentWillMount() {
	    var _props = this.props,
	        lessonId = _props.lessonId,
	        classId = _props.classId,
	        classDetail = _props.classDetail;
	    var dispatch = this.props.dispatch;
	
	    dispatch((0, _ducks.fetchLessonAttendance)(lessonId));
	
	    // NOTE: Ryan,
	    // Redux state classLessonDetail does not always have states,
	    // sometimes it is empty. Then we use classId to fetch it.
	    if (Object.keys(classDetail.detail).length < 1) {
	      if (!classId) {
	        throw new Error('classLessonDetail in Redux is empty. You need to pass opts.classId to this modal in order to load the class.');
	      }
	      dispatch((0, _ducks2.fetchClassLesson)(classId, {
	        amount_per_page: 25,
	        current_page_number: 1
	      }));
	    }
	  };
	
	  ModalBody.prototype.render = function render() {
	    var _props2 = this.props,
	        show = _props2.show,
	        proceed = _props2.proceed,
	        dismiss = _props2.dismiss,
	        cancel = _props2.cancel,
	        lessonId = _props2.lessonId,
	        dispatch = _props2.dispatch;
	    var _props$attendanceDeta = this.props.attendanceDetail,
	        fetching = _props$attendanceDeta.fetching,
	        start_datetime = _props$attendanceDeta.start_datetime;
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'attendance-modal',
	        hasHeader: true,
	        hasFooter: true,
	        headerTitle: __("Attendance", "classdetail"),
	        headerIcon: 'fa icon-ok',
	        fixedWidth: 560,
	        contentHeight: 370,
	        onCloseModalClick: function onCloseModalClick() {
	          return proceed({ start_datetime: start_datetime });
	        },
	        footerType: 'grey',
	        footerButtons: [{
	          title: __('Complete', 'appwrapper'),
	          className: 'btn btn-primary pull-right',
	          onClick: function onClick() {
	            proceed({ start_datetime: start_datetime });
	          }
	        }],
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, _extends({
	        fetching: fetching
	      }, this.props))
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactConfirm.confirmable)(ModalBody));
	module.exports = exports['default'];

/***/ },

/***/ "ZQC/":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"attendance-modal-content":"attendance-modal-content","attendance-student-name":"attendance-student-name","attendance-teacher-name":"attendance-teacher-name","textarea-btn":"textarea-btn","attend-checkbox":"attend-checkbox","attend-remarks":"attend-remarks","attended-label":"attended-label","checkbox-input":"checkbox-input","attend-teacher-remarks":"attend-teacher-remarks","student-list-section":"student-list-section","teacher-list-section":"teacher-list-section","attendance-rule-section":"attendance-rule-section","attendance-time-section":"attendance-time-section","attendance-student-seciton":"attendance-student-seciton","attendance-student-label":"attendance-student-label","attendance-teacher-label":"attendance-teacher-label","checkmark":"checkmark","name-section-wrapper":"name-section-wrapper","checkbox-section-wrapper":"checkbox-section-wrapper","checkbox-section":"checkbox-section"};

/***/ },

/***/ "DP95":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__("K30H");
	
	var _addLessonAttendance = __webpack_require__("H/20");
	
	var _addLessonAttendance2 = _interopRequireDefault(_addLessonAttendance);
	
	var _getStudentCheckNotes = __webpack_require__("oBdt");
	
	var _getStudentCheckNotes2 = _interopRequireDefault(_getStudentCheckNotes);
	
	var _getTeacherCheckNotes = __webpack_require__("mBVo");
	
	var _getTeacherCheckNotes2 = _interopRequireDefault(_getTeacherCheckNotes);
	
	var _addStudentCheckNotes = __webpack_require__("8TXJ");
	
	var _addStudentCheckNotes2 = _interopRequireDefault(_addStudentCheckNotes);
	
	var _addTeacherCheckNotes = __webpack_require__("umqi");
	
	var _addTeacherCheckNotes2 = _interopRequireDefault(_addTeacherCheckNotes);
	
	var _ducks = __webpack_require__("yuEY");
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	__webpack_require__("ZQC/");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      open_student_note: {},
	      open_teacher_note: {},
	      student_note: '',
	      teacher_note: '',
	      teacherCheckedIn: {},
	      studentCheckedIn: {},
	      studentAbsent: {},
	      teacherAbsent: {},
	      studentAbsentWithoutNotice: {},
	      status: ''
	    };
	
	    _this.onStudentRemarkChange = _this.onStudentRemarkChange.bind(_this);
	    _this.onTeacherRemarkChange = _this.onTeacherRemarkChange.bind(_this);
	    _this.onChangeCheckInStatus = _this.onChangeCheckInStatus.bind(_this);
	    return _this;
	  }
	
	  ModalContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var attendanceDetail = _ref.attendanceDetail;
	
	    if (this.props.attendanceDetail !== attendanceDetail) {
	      var student_list = attendanceDetail.student_list,
	          teacher_list = attendanceDetail.teacher_list;
	
	
	      if (student_list && teacher_list) {
	        var open_student_note = {};
	        var open_teacher_note = {};
	        var teacherCheckedIn = {};
	        var studentCheckedIn = {};
	        var studentAbsent = {};
	        var studentAbsentWithoutNotice = {};
	        var teacherAbsent = {};
	
	        student_list.forEach(function (student) {
	          open_student_note[student.student_id] = false;
	          studentCheckedIn[student.student_id] = student.check_in_status === 1 || student.check_in_status === 3;
	          studentAbsent[student.student_id] = student.check_in_status === 2;
	          studentAbsentWithoutNotice[student.student_id] = student.check_in_status === 4;
	        });
	
	        teacher_list.forEach(function (teacher) {
	          open_teacher_note[teacher.teacher_id] = false;
	          teacherCheckedIn[teacher.teacher_id] = teacher.check_in_status === 1;
	          teacherAbsent[teacher.teacher_id] = teacher.check_in_status === 2;
	        });
	
	        this.setState({
	          open_student_note: open_student_note,
	          open_teacher_note: open_teacher_note,
	          studentCheckedIn: studentCheckedIn,
	          teacherCheckedIn: teacherCheckedIn,
	          studentAbsent: studentAbsent,
	          studentAbsentWithoutNotice: studentAbsentWithoutNotice,
	          teacherAbsent: teacherAbsent
	        });
	      }
	    }
	  };
	
	  ModalContent.prototype.onStudentRemarkChange = function onStudentRemarkChange(event) {
	    this.setState({ student_note: event.target.value });
	  };
	
	  ModalContent.prototype.onTeacherRemarkChange = function onTeacherRemarkChange(event) {
	    this.setState({ teacher_note: event.target.value });
	  };
	
	  ModalContent.prototype.renderStudentNote = function renderStudentNote(student_id) {
	    var _this2 = this;
	
	    var student_note = this.state.student_note;
	
	    var lessonId = this.props.attendanceDetail.lesson_id;
	
	    if (this.state.open_student_note[student_id]) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('textarea', { className: 'form-control', value: this.state.student_note, onChange: this.onStudentRemarkChange }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid textarea-btn' },
	          _react2.default.createElement('i', { className: 'pull-right fa icon-ok', onClick: function onClick() {
	              (0, _addStudentCheckNotes2.default)(lessonId, student_id, { checkin_note: student_note }).then(function (res) {
	                _this2.setState({ open_student_note: { student_id: false } });
	              });
	            } }),
	          _react2.default.createElement('i', { className: 'pull-right fa icon-cancel', onClick: function onClick() {
	              _this2.setState({ open_student_note: { student_id: false } });
	            } })
	        )
	      );
	    }
	  };
	
	  ModalContent.prototype.renderTeacherNote = function renderTeacherNote(teacher_id) {
	    var _this3 = this;
	
	    var teacher_note = this.state.teacher_note;
	
	    var lessonId = this.props.attendanceDetail.lesson_id;
	
	    if (this.state.open_teacher_note[teacher_id]) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('textarea', { className: 'form-control', value: this.state.teacher_note, onChange: this.onTeacherRemarkChange }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid textarea-btn' },
	          _react2.default.createElement('i', { className: 'pull-right fa icon-ok', onClick: function onClick() {
	              (0, _addTeacherCheckNotes2.default)(lessonId, teacher_id, { checkin_note: teacher_note }).then(function (res) {
	                _this3.setState({ open_teacher_note: { teacher_id: false } });
	              });
	            } }),
	          _react2.default.createElement('i', { className: 'pull-right fa icon-cancel', onClick: function onClick() {
	              _this3.setState({ open_teacher_note: { teacher_id: false } });
	            } })
	        )
	      );
	    }
	  };
	
	  ModalContent.prototype.onStudentRemarksExpand = function onStudentRemarksExpand(student) {
	    var _this4 = this;
	
	    return function () {
	      var lessonId = _this4.props.attendanceDetail.lesson_id;
	      var student_id = student.student_id;
	      var open_student_note = _this4.state.open_student_note;
	
	      (0, _getStudentCheckNotes2.default)(lessonId, student_id).then(function (res) {
	        var _open_student_note;
	
	        _this4.setState({
	          student_note: res.checkin_note,
	          open_student_note: (_open_student_note = {}, _open_student_note[student_id] = open_student_note[student_id] !== true, _open_student_note)
	        });
	      });
	    };
	  };
	
	  ModalContent.prototype.onTeacherRemarksExpand = function onTeacherRemarksExpand(teacher) {
	    var _this5 = this;
	
	    return function () {
	      var lessonId = _this5.props.attendanceDetail.lesson_id;
	      var teacher_id = teacher.teacher_id;
	      var open_teacher_note = _this5.state.open_teacher_note;
	
	      (0, _getTeacherCheckNotes2.default)(lessonId, teacher_id).then(function (res) {
	        var _open_teacher_note;
	
	        _this5.setState({
	          teacher_note: res.checkin_note,
	          open_teacher_note: (_open_teacher_note = {}, _open_teacher_note[teacher_id] = open_teacher_note[teacher_id] !== true, _open_teacher_note)
	        });
	      });
	    };
	  };
	
	  ModalContent.prototype.onChangeCheckInStatus = function onChangeCheckInStatus(studentId) {
	    var _this6 = this;
	
	    return function (event) {
	      var dispatch = _this6.props.dispatch;
	
	      var lessonId = _this6.props.attendanceDetail.lesson_id;
	      var status = event.target.value;
	
	      (0, _addLessonAttendance2.default)(lessonId, { is_teacher: 'student', id: studentId, check_in_status: status }).then(function (res) {
	        dispatch((0, _ducks.fetchLessonAttendance)(lessonId));
	      });
	    };
	  };
	
	  ModalContent.prototype.renderStudentSection = function renderStudentSection() {
	    var _this7 = this;
	
	    var attendanceDetail = this.props.attendanceDetail;
	    var _state = this.state,
	        studentCheckedIn = _state.studentCheckedIn,
	        studentAbsent = _state.studentAbsent,
	        studentAbsentWithoutNotice = _state.studentAbsentWithoutNotice;
	
	
	    return attendanceDetail.student_list.map(function (student, index) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid student-list-section', key: student.student_id },
	        _react2.default.createElement(
	          'div',
	          { className: 'name-section-wrapper' },
	          _react2.default.createElement(
	            'span',
	            { className: 'attendance-student-name' },
	            student.student_name
	          ),
	          _react2.default.createElement('span', { className: 'attend-remarks' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'checkbox-section-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'checkbox-section' },
	            _react2.default.createElement(
	              'label',
	              { className: 'control' },
	              _react2.default.createElement('input', {
	                type: 'checkbox',
	                className: 'checkbox-input',
	                value: attendanceDetail.lesson_id,
	                id: 's-attended-' + index,
	                checked: studentCheckedIn[student.student_id],
	                onClick: function onClick(event) {
	                  var lesson_id = attendanceDetail.lesson_id;
	                  var student_id = student.student_id;
	
	                  if (!_this7.state.studentCheckedIn[student_id]) {
	                    var _extends2, _extends3, _extends4;
	
	                    _this7.setState({
	                      studentCheckedIn: _extends({}, _this7.state.studentCheckedIn, (_extends2 = {}, _extends2[student_id] = true, _extends2)),
	                      studentAbsent: _extends({}, _this7.state.studentAbsent, (_extends3 = {}, _extends3[student_id] = false, _extends3)),
	                      studentAbsentWithoutNotice: _extends({}, _this7.state.studentAbsentWithoutNotice, (_extends4 = {}, _extends4[student_id] = false, _extends4))
	                    });
	                  } else {
	                    var _extends5;
	
	                    _this7.setState({
	                      studentCheckedIn: _extends({}, _this7.state.studentCheckedIn, (_extends5 = {}, _extends5[student_id] = false, _extends5))
	                    });
	                  }
	                  if (event.target.checked) {
	                    (0, _addLessonAttendance2.default)(lesson_id, { is_teacher: 'student', id: student_id, check_in_status: 'attended' });
	                  } else {
	                    (0, _addLessonAttendance2.default)(lesson_id, { is_teacher: 'student', id: student_id, check_in_status: 'unchecked' });
	                  }
	                }
	              }),
	              _react2.default.createElement('span', { className: 'checkmark' }),
	              _react2.default.createElement(
	                'label',
	                { className: 'attended-label', htmlFor: 's-attended-' + index },
	                __('Attended', 'classdetail')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'checkbox-section' },
	            _react2.default.createElement(
	              'label',
	              { className: 'control' },
	              _react2.default.createElement('input', {
	                type: 'checkbox',
	                className: 'checkbox-input',
	                value: attendanceDetail.lesson_id,
	                id: 's-absent-with-excuse-' + index,
	                checked: studentAbsent[student.student_id],
	                onClick: function onClick(event) {
	                  var lesson_id = attendanceDetail.lesson_id;
	                  var student_id = student.student_id;
	
	                  if (!_this7.state.studentAbsent[student_id]) {
	                    var _extends6, _extends7, _extends8;
	
	                    _this7.setState({
	                      studentAbsent: _extends({}, _this7.state.studentAbsent, (_extends6 = {}, _extends6[student_id] = true, _extends6)),
	                      studentCheckedIn: _extends({}, _this7.state.studentCheckedIn, (_extends7 = {}, _extends7[student_id] = false, _extends7)),
	                      studentAbsentWithoutNotice: _extends({}, _this7.state.studentAbsentWithoutNotice, (_extends8 = {}, _extends8[student_id] = false, _extends8))
	
	                    });
	                  } else {
	                    var _extends9;
	
	                    _this7.setState({
	                      studentAbsent: _extends({}, _this7.state.studentAbsent, (_extends9 = {}, _extends9[student_id] = false, _extends9))
	                    });
	                  }
	
	                  if (event.target.checked) {
	                    (0, _addLessonAttendance2.default)(lesson_id, { is_teacher: 'student', id: student_id, check_in_status: 'absent (with excuse)' });
	                  } else {
	                    (0, _addLessonAttendance2.default)(lesson_id, { is_teacher: 'student', id: student_id, check_in_status: 'unchecked' });
	                  }
	                }
	              }),
	              _react2.default.createElement('span', { className: 'checkmark' }),
	              _react2.default.createElement(
	                'label',
	                { className: 'attended-label', htmlFor: 's-absent-with-excuse-' + index },
	                __('Absent (with excuse)', 'teacherAttendance')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'checkbox-section' },
	            _react2.default.createElement(
	              'label',
	              { className: 'control' },
	              _react2.default.createElement('input', {
	                type: 'checkbox',
	                className: 'checkbox-input',
	                value: attendanceDetail.lesson_id,
	                id: 's-absent-without-notice-' + index,
	                checked: studentAbsentWithoutNotice[student.student_id],
	                onClick: function onClick(event) {
	                  var lesson_id = attendanceDetail.lesson_id;
	                  var student_id = student.student_id;
	
	                  if (!_this7.state.studentAbsentWithoutNotice[student_id]) {
	                    var _extends10, _extends11, _extends12;
	
	                    _this7.setState({
	                      studentAbsentWithoutNotice: _extends({}, _this7.state.studentAbsentWithoutNotice, (_extends10 = {}, _extends10[student_id] = true, _extends10)),
	                      studentCheckedIn: _extends({}, _this7.state.studentCheckedIn, (_extends11 = {}, _extends11[student_id] = false, _extends11)),
	                      studentAbsent: _extends({}, _this7.state.studentAbsent, (_extends12 = {}, _extends12[student_id] = false, _extends12))
	                    });
	                  } else {
	                    var _extends13;
	
	                    _this7.setState({
	                      studentAbsentWithoutNotice: _extends({}, _this7.state.studentAbsentWithoutNotice, (_extends13 = {}, _extends13[student_id] = false, _extends13))
	                    });
	                  }
	
	                  if (event.target.checked) {
	                    (0, _addLessonAttendance2.default)(lesson_id, { is_teacher: 'student', id: student_id, check_in_status: 'absent (without notice)' });
	                  } else {
	                    (0, _addLessonAttendance2.default)(lesson_id, { is_teacher: 'student', id: student_id, check_in_status: 'unchecked' });
	                  }
	                }
	              }),
	              _react2.default.createElement('span', { className: 'checkmark' }),
	              _react2.default.createElement(
	                'label',
	                { className: 'attended-label', htmlFor: 's-absent-without-notice-' + index },
	                __('Absent (without notice)', 'teacherAttendance')
	              )
	            )
	          )
	        ),
	        _this7.renderStudentNote(student.student_id)
	      );
	    });
	  };
	
	  ModalContent.prototype.renderTeacherSection = function renderTeacherSection() {
	    var _this8 = this;
	
	    var attendanceDetail = this.props.attendanceDetail;
	    var _state2 = this.state,
	        teacherCheckedIn = _state2.teacherCheckedIn,
	        teacherAbsent = _state2.teacherAbsent;
	
	
	    return attendanceDetail.teacher_list.map(function (teacher, index) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid teacher-list-section', key: teacher.teacher_id },
	        _react2.default.createElement(
	          'div',
	          { className: 'name-section-wrapper' },
	          _react2.default.createElement(
	            'span',
	            { className: 'attendance-teacher-name' },
	            teacher.teacher_name
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'attend-teacher-remarks' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn-link', onClick: _this8.onTeacherRemarksExpand(teacher) },
	              __('Remark', 'classdetail')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'checkbox-section-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'checkbox-section' },
	            _react2.default.createElement(
	              'label',
	              { className: 'control' },
	              _react2.default.createElement('input', {
	                type: 'checkbox',
	                className: 'checkbox-input',
	                value: attendanceDetail.lesson_id,
	                id: 't-attended-' + index,
	                checked: teacherCheckedIn[teacher.teacher_id],
	                onClick: function onClick(event) {
	                  var lesson_id = attendanceDetail.lesson_id;
	                  var teacher_id = teacher.teacher_id;
	
	                  if (!teacherCheckedIn[teacher.teacher_id]) {
	                    var _extends14, _extends15;
	
	                    _this8.setState({
	                      teacherCheckedIn: _extends({}, _this8.state.teacherCheckedIn, (_extends14 = {}, _extends14[teacher_id] = true, _extends14)),
	                      teacherAbsent: _extends({}, _this8.state.teacherAbsent, (_extends15 = {}, _extends15[teacher_id] = false, _extends15))
	                    });
	                  } else {
	                    var _extends16;
	
	                    _this8.setState({
	                      teacherCheckedIn: _extends({}, _this8.state.teacherCheckedIn, (_extends16 = {}, _extends16[teacher_id] = false, _extends16))
	                    });
	                  }
	
	                  if (event.target.checked) {
	                    (0, _addLessonAttendance2.default)(lesson_id, { is_teacher: 'teacher', id: teacher_id, check_in_status: 'attended' });
	                  } else {
	                    (0, _addLessonAttendance2.default)(lesson_id, { is_teacher: 'teacher', id: teacher_id, check_in_status: 'unchecked' });
	                  }
	                }
	              }),
	              _react2.default.createElement('span', { className: 'checkmark' }),
	              _react2.default.createElement(
	                'label',
	                { className: 'attended-label', htmlFor: 't-attended-' + index },
	                __('Attended', 'classdetail')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'checkbox-section' },
	            _react2.default.createElement(
	              'label',
	              { className: 'control' },
	              _react2.default.createElement('input', {
	                type: 'checkbox',
	                className: 'checkbox-input',
	                value: attendanceDetail.lesson_id,
	                id: 't-absent-with-excuse-' + index,
	                checked: teacherAbsent[teacher.teacher_id],
	                onClick: function onClick(event) {
	                  var lesson_id = attendanceDetail.lesson_id;
	                  var teacher_id = teacher.teacher_id;
	
	
	                  if (!teacherAbsent[teacher.teacher_id]) {
	                    var _extends17, _extends18;
	
	                    _this8.setState({
	                      teacherAbsent: _extends({}, _this8.state.teacherAbsent, (_extends17 = {}, _extends17[teacher_id] = true, _extends17)),
	                      teacherCheckedIn: _extends({}, _this8.state.teacherCheckedIn, (_extends18 = {}, _extends18[teacher_id] = false, _extends18))
	                    });
	                  } else {
	                    var _extends19;
	
	                    _this8.setState({
	                      teacherAbsent: _extends({}, _this8.state.teacherAbsent, (_extends19 = {}, _extends19[teacher_id] = false, _extends19))
	                    });
	                  }
	                  if (event.target.checked) {
	                    (0, _addLessonAttendance2.default)(lesson_id, { is_teacher: 'teacher', id: teacher_id, check_in_status: 'absent (with excuse)' });
	                  } else {
	                    (0, _addLessonAttendance2.default)(lesson_id, { is_teacher: 'teacher', id: teacher_id, check_in_status: 'unchecked' });
	                  }
	                }
	              }),
	              _react2.default.createElement('span', { className: 'checkmark' }),
	              _react2.default.createElement(
	                'label',
	                { className: 'attended-label', htmlFor: 't-absent-with-excuse-' + index },
	                __('Absent (with excuse)', 'teacherAttendance')
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'checkbox-section' })
	        ),
	        _this8.renderTeacherNote(teacher.teacher_id)
	      );
	    });
	  };
	
	  ModalContent.prototype.render = function render() {
	    var _props$classDetail = this.props.classDetail,
	        detail = _props$classDetail.detail,
	        fetching = _props$classDetail.fetching;
	
	    var classDetail = detail;
	    var attendanceDetail = this.props.attendanceDetail;
	    if (!attendanceDetail || !classDetail || Object.keys(classDetail).length < 1 || fetching == true || !attendanceDetail.start_datetime) {
	      return _react2.default.createElement(_Loading2.default, null);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'attendance-modal-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container-fluid' },
	        _react2.default.createElement(
	          'div',
	          { className: 'attendance-rule-section' },
	          _react2.default.createElement(
	            'strong',
	            { className: 'attendance-rule-label' },
	            __('Lesson Completion Rule: ', 'classdetail')
	          ),
	          _constants.COST_RULE[classDetail.costRule] + ' | ' + _constants.ABSENT_RULE[classDetail.absentFlag] + " | " + _constants.CANCEL_RULE[classDetail.cancelFlag]
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'attendance-time-section' },
	          _react2.default.createElement(
	            'strong',
	            null,
	            __('Lesson Time: ', 'classdetail')
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            __('{lsnStartDate1} - {lsnStartDate2} - {lsnStartDate3}  {lsnStartTime} - {lsnEndTime}', 'classdetail', {
	              lsnStartDate1: attendanceDetail.start_datetime.slice(0, 4),
	              lsnStartDate2: attendanceDetail.start_datetime.slice(5, 7),
	              lsnStartDate3: attendanceDetail.start_datetime.slice(8, 10),
	              lsnStartTime: attendanceDetail.start_datetime.slice(11, 18),
	              lsnEndTime: attendanceDetail.end_datetime.slice(11, 18) })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'attendance-student-seciton' },
	          _react2.default.createElement(
	            'div',
	            { className: 'attendance-student-label' },
	            _react2.default.createElement(
	              'strong',
	              null,
	              __('Students', 'class')
	            )
	          ),
	          this.renderStudentSection()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'attendance-teacher-seciton' },
	          _react2.default.createElement(
	            'div',
	            { className: 'attendance-teacher-label' },
	            _react2.default.createElement(
	              'strong',
	              null,
	              __('Teacher', 'changeschool')
	            )
	          ),
	          this.renderTeacherSection()
	        )
	      )
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "H/20":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = exports.STATUS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = addLessonAttendance;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TARGET = ['student', 'teacher'];
	var STATUS = exports.STATUS = ['unchecked', 'attended', 'absent (with excuse)', 'late', 'absent (without notice)'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  "is_teacher": _joiBrowser2.default.string().valid(TARGET).required(),
	  "id": _joiBrowser2.default.number().integer().required(),
	  "check_in_status": _joiBrowser2.default.string().valid(STATUS).allow('')
	});
	
	function addLessonAttendance(lessonId, lessonInfo) {
	
	  if (!lessonId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing lesson Id (number)')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(lessonInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var checkInState = void 0;
	  var isTeacher = TARGET.indexOf(lessonInfo.is_teacher);
	  if (isTeacher === 0) {
	    if (lessonInfo.check_in_status == 'unchecked') {
	      checkInState = 0;
	    } else if (lessonInfo.check_in_status == 'attended' || lessonInfo.check_in_status == 'late') {
	      checkInState = 1;
	    } else if (lessonInfo.check_in_status == 'absent (with excuse)') {
	      checkInState = 2;
	    } else {
	      checkInState = 4;
	    }
	  } else {
	    if (lessonInfo.check_in_status == 'unchecked' || lessonInfo.check_in_status == 'absent (without notice)') {
	      checkInState = 0;
	    } else if (lessonInfo.check_in_status == 'attended' || lessonInfo.check_in_status == 'late') {
	      checkInState = 1;
	    } else {
	      checkInState = 2;
	    }
	  }
	  var toServer = _extends({}, lessonInfo, {
	    is_teacher: isTeacher,
	    check_in_status: checkInState
	  });
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/g_chc/" + lessonId + "/",
	      'method': 'POST',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "oBdt":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getStudentCheckNotes;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStudentCheckNotes(lessonId, studentId) {
	
	  if (!lessonId || !studentId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing lesson Id (number) or student Id (number)')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/scheck_note/" + lessonId + "/" + studentId + "/",
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "mBVo":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getTeacherCheckNotes;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTeacherCheckNotes(lessonId, teacherId) {
	
	  if (!lessonId || !teacherId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing lesson Id (number) or teacher Id (number)')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/tcheck_note/" + lessonId + "/" + teacherId + "/",
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "8TXJ":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = addLessonAttendance;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  "checkin_note": _joiBrowser2.default.string().allow('')
	});
	
	function addLessonAttendance(lessonId, studentId, notes) {
	
	  if (!lessonId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing lesson Id (number)')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(notes, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/scheck_note/" + lessonId + "/" + studentId + "/",
	      'method': 'POST',
	      'data': JSON.stringify(notes),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "umqi":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = addLessonAttendance;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  "checkin_note": _joiBrowser2.default.string().allow('')
	});
	
	function addLessonAttendance(lessonId, teacherId, notes) {
	
	  if (!lessonId || !teacherId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing lesson Id or teacher Id')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(notes, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/tcheck_note/" + lessonId + "/" + teacherId + "/",
	      'method': 'POST',
	      'data': JSON.stringify(notes),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "vx51":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getDefaultTableSettings;
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	var _removeStudentFromClass = __webpack_require__("3og2");
	
	var _removeStudentFromClass2 = _interopRequireDefault(_removeStudentFromClass);
	
	var _ducks = __webpack_require__("6mZg");
	
	var _NewPayment = __webpack_require__("BztD");
	
	var _NewPayment2 = _interopRequireDefault(_NewPayment);
	
	var _StudentInfo = __webpack_require__("R3ni");
	
	var _StudentInfo2 = _interopRequireDefault(_StudentInfo);
	
	var _R = __webpack_require__("nRUD");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDefaultTableSettings() {
	  var _this = this;
	
	  var TabComponent = this;
	  var dispatch = this.props.dispatch;
	
	  var classId = this.props.params.classId;
	
	  return [{
	    title: __('Student Detail', 'classdetail'),
	    onClick: function onClick(_ref) {
	      var studentInfo = _ref.trData;
	      var schoolStudentID = studentInfo.schoolStudentID;
	
	      (0, _StudentInfo2.default)({ id: schoolStudentID }).then(function (res) {
	        if (res.isUpdated) {
	          dispatch((0, _ducks.fetchClassStudent)(classId));
	        }
	      });
	    },
	    isDisabled: function isDisabled() {
	      return !(0, _R.userCan)('read_class_student');
	    }
	  }, {
	    title: __('Exit Class', 'classdetail'),
	    onClick: function onClick(_ref2) {
	      var student = _ref2.trData;
	
	      if (student.paidInFee > 0) {
	        (0, _confirm.confirm)(__('This student has paid tuition, do you wish to refund?', 'studentTable')).then(function () {
	          var classDetail = _this.props.classDetail.detail;
	          var user_id = _this.props.user.result.user_id;
	
	          var student_name = student.schoolStudentName;
	
	          (0, _NewPayment2.default)({
	            student: student,
	            classDetail: classDetail,
	            user_id: user_id,
	            paymentType: _NewPayment.REFUND,
	            confirmTitle: __('Refund & Exit Class', 'classdetail'),
	            confirmText: __('Proceed to refund and remove the student, {student_name}, from class?', 'classdetail', { student_name: student_name })
	          }).then(function () {
	            // STEP 2. use controller to call backend
	            (0, _removeStudentFromClass2.default)(Number(classId), Number(student.schoolStudentID)).then(function (res) {
	              _alert.alert.success(__('The student {student_name} has been removed from the class.', 'student', { student_name: student_name }), __('Exit Class Successful', 'student')).then(function () {
	                dispatch((0, _ducks.fetchClassStudent)(Number(classId)));
	              });;
	            }).catch(function (err) {
	              console.error(err);
	            });
	          });
	        }).catch(function () {
	          var schoolStudentName = student.schoolStudentName;
	
	          (0, _confirm.confirm)(__('Exit Student: {name} From Class?', 'classdetail', { name: schoolStudentName })).then(function () {
	            (0, _removeStudentFromClass2.default)(Number(classId), Number(student.schoolStudentID)).then(function (res) {
	              dispatch((0, _ducks.fetchClassStudent)(classId));
	            });
	          }).catch(function () {});
	        });
	      } else {
	        var schoolStudentName = student.schoolStudentName;
	
	        (0, _confirm.confirm)(__('Exit Student: {name} From Class?', 'classdetail', { name: schoolStudentName })).then(function () {
	          (0, _removeStudentFromClass2.default)(Number(classId), Number(student.schoolStudentID)).then(function (res) {
	            dispatch((0, _ducks.fetchClassStudent)(classId));
	          });
	        }).catch(function () {});
	      }
	    },
	    isDisabled: function isDisabled(_ref3) {
	      var studentInfo = _ref3.trData;
	
	      return studentInfo.classStudentState == 0 || !(0, _R.userCan)('archive_student_from_class');
	    }
	  }];
	}
	module.exports = exports['default'];

/***/ },

/***/ "y9xV":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getDefaultTableSettings;
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _updateClassTeacher = __webpack_require__("oN1n");
	
	var _updateClassTeacher2 = _interopRequireDefault(_updateClassTeacher);
	
	var _ducks = __webpack_require__("DPWa");
	
	var _ducks2 = __webpack_require__("lDbx");
	
	var _R = __webpack_require__("nRUD");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDefaultTableSettings() {
	  var TabComponent = this;
	  var _props = this.props,
	      dispatch = _props.dispatch,
	      classDetail = _props.classDetail;
	  var cType = classDetail.detail.cType;
	
	  var classId = this.props.params.classId;
	  return [{
	    title: __('Exit Class', 'classdetail'),
	    onClick: function onClick(_ref) {
	      var teacherInfo = _ref.trData;
	      var stName = teacherInfo.stName;
	
	      (0, _confirm.confirm)(__('Exit Teacher: {name} From Class?', 'classdetail', { name: stName })).then(function () {
	        (0, _updateClassTeacher2.default)(classId, teacherInfo.id, { state: 'archive' }).then(function (res) {
	          dispatch((0, _ducks.fetchClassTeacher)(classId));
	          //dispatch(fetchClassLesson(classId))
	        }).catch(function (err) {});
	      });
	    },
	    isDisabled: function isDisabled() {
	      return !(0, _R.userCan)(cType == 0 ? 'archive_teacher_from_class' : 'archive_teacher_from_private_class');
	    }
	  }];
	}
	module.exports = exports['default'];

/***/ },

/***/ "oN1n":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = updateClassTeacher;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATE = ['archive', 'unarchive'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  state: _joiBrowser2.default.string().valid(STATE).required()
	});
	
	function updateClassTeacher(classId, teacherId, state) {
	
	  var validateResult = _joiBrowser2.default.validate(state, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, state, {
	    state: STATE.indexOf(state.state)
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/u_add_clstch/" + classId + "/" + teacherId + "/",
	      'method': 'PUT',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "fWyM":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _ClassInfo = __webpack_require__("FI9r");
	
	var _ClassInfo2 = _interopRequireDefault(_ClassInfo);
	
	var _ClassInfoFields = __webpack_require__("QRb/");
	
	var _ClassInfoFields2 = _interopRequireDefault(_ClassInfoFields);
	
	var _DefaultTab = __webpack_require__("siMa");
	
	var _DefaultTab2 = _interopRequireDefault(_DefaultTab);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AddLesson = __webpack_require__("shHd");
	
	var _AddLesson2 = _interopRequireDefault(_AddLesson);
	
	var _ducks = __webpack_require__("lDbx");
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _Transition = __webpack_require__("X/qO");
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _isEqual = __webpack_require__("hygk");
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _CreateClass = __webpack_require__("dFGx");
	
	var _CreateClass2 = _interopRequireDefault(_CreateClass);
	
	var _CreateClassOne = __webpack_require__("sbFW");
	
	var _CreateClassOne2 = _interopRequireDefault(_CreateClassOne);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _ClassDescription = __webpack_require__("1WDO");
	
	var _ClassDescription2 = _interopRequireDefault(_ClassDescription);
	
	var _UI = __webpack_require__("OM1Z");
	
	__webpack_require__("7HkZ");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    gSubscription: state.gSubscription,
	    classDetail: state.classLessonDetail
	  };
	};
	
	var locale = {
	  id: 'ClassDetail',
	  code: 'CN',
	  text: {
	    'Class': '班级'
	  }
	};
	
	var ClassDetail = function (_Component) {
	  _inherits(ClassDetail, _Component);
	
	  function ClassDetail(props) {
	    _classCallCheck(this, ClassDetail);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      classDetail: props.classDetail,
	      pageState: 'current',
	      pagination: {
	        activePage: 1,
	        itemsCountPerPage: 25,
	        totalItemsCount: 0
	      }
	    };
	
	    if (props.location && props.location.state) {
	      _this.state.addLessonWhenOpen = props.location.state.openCreateLessonDock;
	    }
	    _this.onTabChange = _this.onTabChange.bind(_this);
	    _this.onItemsCountPerPageChange = _this.onItemsCountPerPageChange.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    return _this;
	  }
	
	  ClassDetail.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var _this2 = this;
	
	    var classDetail = _ref.classDetail;
	
	    if (classDetail.detail && !(0, _isEqual2.default)(classDetail.detail, this.props.classDetail.detail)) {
	      this.setState(function (prevState) {
	        return {
	          classDetail: classDetail,
	          pagination: _extends({}, prevState.pagination, { totalItemsCount: classDetail.detail.lessonCount })
	        };
	      }, function () {
	        if (_this2.state.addLessonWhenOpen == true) {
	          _this2.setState({
	            addLessonWhenOpen: false
	          }, function () {
	            _this2.addLesson(classDetail);
	          });
	        }
	      });
	    }
	  };
	
	  ClassDetail.prototype.componentDidMount = function componentDidMount() {
	    var dispatch = this.props.dispatch;
	    var pagination = this.state.pagination;
	
	    var classId = this.props.params.classId;
	
	    dispatch((0, _ducks.fetchClassLesson)(classId, {
	      amount_per_page: pagination.itemsCountPerPage,
	      current_page_number: 1,
	      after_today: 1
	    }));
	  };
	
	  ClassDetail.prototype.onTabChange = function onTabChange(state) {
	    var dispatch = this.props.dispatch;
	    var pagination = this.state.pagination;
	
	    var classId = this.props.params.classId;
	    this.setState(function (prevState) {
	      return {
	        pageState: state,
	        pagination: _extends({}, prevState.pagination, { activePage: 1, totalItemsCount: 0 })
	      };
	    });
	    dispatch((0, _ducks.fetchClassLesson)(classId, {
	      amount_per_page: pagination.itemsCountPerPage,
	      current_page_number: 1,
	      after_today: state === 'current' ? 1 : 0
	    }));
	  };
	
	  ClassDetail.prototype.onPageChange = function onPageChange(pageNum) {
	    var dispatch = this.props.dispatch;
	    var _state = this.state,
	        pagination = _state.pagination,
	        pageState = _state.pageState;
	
	    var classId = this.props.params.classId;
	    this.setState(function (prevState) {
	      return { pagination: _extends({}, prevState.pagination, { activePage: pageNum }) };
	    }, function () {
	      dispatch((0, _ducks.fetchClassLesson)(classId, {
	        amount_per_page: pagination.itemsCountPerPage,
	        current_page_number: pageNum,
	        after_today: pageState === 'current' ? 1 : 0
	      }));
	    });
	  };
	
	  ClassDetail.prototype.onItemsCountPerPageChange = function onItemsCountPerPageChange(count) {
	    var dispatch = this.props.dispatch;
	
	    var classId = this.props.params.classId;
	    var _state2 = this.state,
	        pagination = _state2.pagination,
	        pageState = _state2.pageState;
	
	    this.setState(function (prevState) {
	      return {
	        pagination: _extends({}, prevState.pagination, { itemsCountPerPage: count })
	      };
	    });
	    dispatch((0, _ducks.fetchClassLesson)(classId, {
	      amount_per_page: count,
	      current_page_number: pagination.activePage,
	      after_today: pageState === 'current' ? 1 : 0
	    }));
	  };
	  // needed for automatically open the modal when '排课' is clicked from the class list
	
	
	  ClassDetail.prototype.addLesson = function addLesson(classDetail) {
	    var pagination = this.state.pagination;
	    var dispatch = this.props.dispatch;
	
	    var _ref2 = classDetail || this.props.classDetail,
	        detail = _ref2.detail,
	        fetching = _ref2.fetching;
	
	    (0, _AddLesson2.default)({ chooseClass: false, classDetail: detail }).then(function () {
	      dispatch((0, _ducks.fetchClassLesson)(detail.classID, {
	        amount_per_page: pagination.itemsCountPerPage,
	        current_page_number: pagination.activePage,
	        after_today: 1
	      }));
	    });
	  };
	
	  ClassDetail.prototype.renderExitNavigation = function renderExitNavigation(cType, cState) {
	    var returningPath = '';
	    if (this.props.location.state != undefined) {
	      returningPath = this.props.location.state.returningPath;
	    }
	
	    if (cType == 0 && cState == 1) {
	      return returningPath || '/class';
	    } else if (cType == 0 && cState == 0) {
	      return returningPath || '/class';
	    } else if (cType == 1 && cState == 1) {
	      return returningPath || '/one_one';
	    } else if (cType == 1 && cState == 0) {
	      return returningPath || '/one_one';
	    }
	  };
	
	  ClassDetail.prototype.render = function render() {
	    var _state3 = this.state,
	        pagination = _state3.pagination,
	        pageState = _state3.pageState;
	    var detail = this.state.classDetail.detail;
	    var fetching = this.props.classDetail.fetching;
	    var cType = detail.cType,
	        cState = detail.cState;
	
	    var shouldShowStudentTab = cType === 0;
	
	    if (cType == 1) {
	      this.fields = _ClassInfoFields2.default.call(this);
	    } else {
	      this.fields = _ClassInfoFields2.default.call(this);
	      delete this.fields.studentList;
	    }
	
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      null,
	      fetching && _react2.default.createElement(_Loading2.default, { onPanel: true }),
	      _react2.default.createElement(
	        _Transition2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('classDetail', { fetching: fetching }) },
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid class-detail-esc' },
	            _react2.default.createElement(
	              'div',
	              { className: 'bread-crumbs' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: this.renderExitNavigation(cType, cState) },
	                cType == 0 ? __('Class', 'editclass') : __('Private Class', 'editone')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                ' / '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                detail.className
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { className: 'pull-right', to: this.renderExitNavigation(cType, cState) },
	                _react2.default.createElement('i', { className: 'fa icon-cancel' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid class-detail-header' },
	            _react2.default.createElement(
	              'span',
	              { className: 'class-detail-name' },
	              detail.className
	            ),
	            _react2.default.createElement(
	              _R2.default,
	              { can: 'edit_class', by: 'disable' },
	              _react2.default.createElement(
	                'button',
	                { className: 'pull-right btn btn-default',
	                  onClick: function onClick() {
	                    if (cType == 0) {
	                      (0, _CreateClass2.default)({ mode: 'update', id: detail.classID, pageState: pageState, pagination: pagination });
	                    } else if (cType == 1) {
	                      (0, _CreateClassOne2.default)({ mode: 'update', id: detail.classID, pageState: pageState, pagination: pagination });
	                    }
	                  },
	                  disabled: !(0, _R.userCan)(cType == 0 ? 'edit_class' : 'edit_private_class') || cState == 0
	                },
	                cType == 0 ? __('Edit Class', 'editclass') : __('Edit Private Class', 'editone')
	              )
	            ),
	            ("production") === 'development' && _react2.default.createElement(
	              'button',
	              { className: 'pull-right btn', onClick: function onClick() {
	                  (0, _ClassDescription2.default)({ id: detail.classID });
	                } },
	              __('Class Description', 'class')
	            )
	          ),
	          _react2.default.createElement(_ClassInfo2.default, { data: detail, fields: this.fields }),
	          _react2.default.createElement(
	            _UI.Tabs,
	            null,
	            _react2.default.createElement(
	              _UI.TabList,
	              null,
	              _react2.default.createElement(
	                _UI.Tab,
	                null,
	                __('Upcoming Lesson', 'classdetail')
	              ),
	              _react2.default.createElement(
	                _UI.Tab,
	                null,
	                __('Past Lesson', 'classdetail')
	              ),
	              shouldShowStudentTab && _react2.default.createElement(
	                _UI.Tab,
	                { disabled: !(0, _R.userCan)('read_class_student') },
	                __('Students', 'class')
	              ),
	              shouldShowStudentTab && _react2.default.createElement(
	                _UI.Tab,
	                { disabled: !(0, _R.userCan)('read_class_student') },
	                __('Past Students', 'class')
	              ),
	              _react2.default.createElement(
	                _UI.Tab,
	                { disabled: !(0, _R.userCan)(cType == 0 ? 'read_class_teacher' : 'read_private_class_teacher') },
	                __('Teacher', 'changeschool')
	              )
	            ),
	            _react2.default.createElement(
	              _UI.TabPanel,
	              null,
	              _react2.default.createElement(_DefaultTab2.default, _extends({ title: "currentLesson" }, this.props, { onTabChange: this.onTabChange, pagination: pagination, onPageChange: this.onPageChange, onItemsCountPerPageChange: this.onItemsCountPerPageChange }))
	            ),
	            _react2.default.createElement(
	              _UI.TabPanel,
	              null,
	              _react2.default.createElement(_DefaultTab2.default, _extends({ title: "pastLesson" }, this.props, { onTabChange: this.onTabChange, pagination: pagination, onPageChange: this.onPageChange, onItemsCountPerPageChange: this.onItemsCountPerPageChange }))
	            ),
	            shouldShowStudentTab && _react2.default.createElement(
	              _UI.TabPanel,
	              null,
	              _react2.default.createElement(_DefaultTab2.default, _extends({ title: "student" }, this.props))
	            ),
	            shouldShowStudentTab && _react2.default.createElement(
	              _UI.TabPanel,
	              null,
	              _react2.default.createElement(_DefaultTab2.default, _extends({ title: "pastStudent" }, this.props))
	            ),
	            _react2.default.createElement(
	              _UI.TabPanel,
	              null,
	              _react2.default.createElement(_DefaultTab2.default, _extends({ title: "teacher" }, this.props))
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ClassDetail;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ClassDetail);
	module.exports = exports['default'];

/***/ },

/***/ "FI9r":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InfoField = __webpack_require__("lhZq");
	
	var _InfoField2 = _interopRequireDefault(_InfoField);
	
	var _forOwn = __webpack_require__("AVgl");
	
	var _forOwn2 = _interopRequireDefault(_forOwn);
	
	__webpack_require__("XM/K");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ClassInfo />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Pass data (object) then fields (object).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * fields structure:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * fields = {
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *   studentName: {
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *      title: __('Student Name'),
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *      className: 'student-name',
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *      hide: true, // if true, it will hide. Use it for conditional rendering.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *      render: (opts)=>{ return <CustomField />; } // a callback function when you can return "customized" field value
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *   }
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * }
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Example:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * const FIELDS = {
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *   totalPrice: {
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     title: __('Class Price', 'classdetail'),
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     render: (opts)=>{
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *       // render() is used only if you wanted to modify value.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *       //
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *       return '$' + opts.value;
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     }
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *   }
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * }
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ClassInfoDisplay data={classInfo} fields={FIELDS} />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ClassInfo = function (_React$Component) {
	  _inherits(ClassInfo, _React$Component);
	
	  function ClassInfo(props) {
	    _classCallCheck(this, ClassInfo);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ClassInfo.prototype.componentWillMount = function componentWillMount() {};
	
	  ClassInfo.prototype.render = function render() {
	    var _this2 = this;
	
	    var Fields = [];
	
	    var _props = this.props,
	        data = _props.data,
	        fields = _props.fields;
	
	
	    (0, _forOwn2.default)(fields, function (field, key) {
	      if (field.hide !== true) {
	
	        var value = void 0;
	        if (typeof field.render == 'function') {
	          value = field.render(_extends({}, _this2.props, { value: data[key], field: field }));
	        } else {
	          value = data[key] || '';
	        }
	
	        Fields.push(_react2.default.createElement(_InfoField2.default, {
	          className: field.className || 'col-sm-3',
	          label: field.title,
	          value: value || '',
	          key: key }));
	      }
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'info-display class-info-display' },
	      Fields
	    );
	  };
	
	  return ClassInfo;
	}(_react2.default.Component);
	
	exports.default = ClassInfo;
	module.exports = exports['default'];

/***/ },

/***/ "lhZq":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("H8dy");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <InfoField />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var InfoField = function (_React$Component) {
	  _inherits(InfoField, _React$Component);
	
	  function InfoField(props) {
	    _classCallCheck(this, InfoField);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  InfoField.prototype.render = function render() {
	
	    var labelContent = void 0,
	        valueContent = void 0;
	
	    var _props = this.props,
	        label = _props.label,
	        value = _props.value,
	        className = _props.className;
	
	
	    if (typeof value == 'function') {
	      valueContent = label(label);
	    } else {
	      valueContent = value;
	    }
	
	    if (typeof label == 'function') {
	      labelContent = label(value);
	    } else {
	      labelContent = label;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('info-field', className), style: { height: '70px' } },
	      _react2.default.createElement(
	        'label',
	        null,
	        labelContent
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'info-value' },
	        valueContent
	      )
	    );
	  };
	
	  return InfoField;
	}(_react2.default.Component);
	
	exports.default = InfoField;
	module.exports = exports['default'];

/***/ },

/***/ "H8dy":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"info-field":"info-field"};

/***/ },

/***/ "XM/K":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"info-display":"info-display","col-sm-3":"col-sm-3","class-info-display":"class-info-display","col-sm-9":"col-sm-9"};

/***/ },

/***/ "1WDO":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("D6BP");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "D6BP":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	var _ModalContent = __webpack_require__("JDgw");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _getClassDescription = __webpack_require__("HEN8");
	
	var _getClassDescription2 = _interopRequireDefault(_getClassDescription);
	
	var _updateClassDescription = __webpack_require__("MjKe");
	
	var _updateClassDescription2 = _interopRequireDefault(_updateClassDescription);
	
	var _locale = __webpack_require__("iKJ7");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("yGx/");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      classData: {}
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  ModalBody.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    (0, _getClassDescription2.default)(this.props.id).then(function (res) {
	      var arr = { description: res.description, on_website: res.on_website == 0 ? false : true };
	      _this2.setState({ classData: arr });
	    });
	  };
	
	  ModalBody.prototype.onChange = function onChange(value) {
	    this.setState({ classData: value });
	  };
	
	  ModalBody.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel,
	        id = _props.id;
	    var classData = this.state.classData;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'teacher-description-modal',
	        hasHeader: true,
	        hasFooter: true,
	        headerTitle: __("Class Description", _locale2.default),
	        headerIcon: 'fa icon-indent-right',
	        fixedWidth: 500,
	        contentHeight: 300,
	        onCloseModalClick: dismiss,
	        footerType: 'grey',
	        footerButtons: [{
	          title: __('Save', _locale2.default),
	          className: 'btn btn-primary pull-right',
	          onClick: function onClick() {
	            var data = { description: classData.description, on_website: classData.on_website ? 1 : 0 };
	            (0, _updateClassDescription2.default)(id, data).then(function (res) {
	              if (res.result == 'success') {
	                dismiss();
	              }
	            });
	          }
	        }, {
	          title: __('Cancel', _locale2.default),
	          className: 'btn btn-default pull-right',
	          onClick: function onClick() {
	            _this3.props.dismiss();
	          }
	        }],
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, _extends({}, this.props, {
	        classData: this.state.classData,
	        onChange: this.onChange,
	        onFormChange: function onFormChange(stateFromModalContent) {
	          _this3.formData = stateFromModalContent;
	        }
	      }))
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "JDgw":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _locale = __webpack_require__("iKJ7");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("yGx/");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalContent.prototype.render = function render() {
	    var _props = this.props,
	        classData = _props.classData,
	        onChange = _props.onChange;
	
	
	    var schema = [{
	      name: 'description',
	      label: __('Description', _locale2.default),
	      type: 'textarea',
	      required: false
	    }, {
	      name: 'on_website',
	      placeholder: __('Do you want to display this on website', _locale2.default),
	      type: 'checkbox',
	      required: false
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'teacher-description-modal-content' },
	      _react2.default.createElement(_Form2.default, {
	        onChange: onChange,
	        schema: schema,
	        formData: classData,
	        formStyle: 'outline',
	        getValidationRef: this.props.getValidationRef
	      })
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "iKJ7":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'ClassDescriptionModal',
	  code: 'CN',
	  text: {
	    'Class Description': '班级简介',
	    'Save': '保存',
	    'Cancel': '取消',
	    'Description': '简介',
	    'Do you want to display this on website': '是否要在官网上展示'
	
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "yGx/":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "HEN8":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getClassDescription;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getClassDescription(classId) {
	
	  if (!classId) {
	    throw 'Missing class ID';
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/class_detail/" + classId,
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "MjKe":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = updateClassDescription;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  description: _joiBrowser2.default.string().required(),
	  on_website: _joiBrowser2.default.number().allow('')
	});
	
	function updateClassDescription(classId, classInfo) {
	
	  if (!classId) {
	    throw 'Missing class ID';
	  }
	
	  var validateResult = _joiBrowser2.default.validate(classInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/class_detail/" + classId + "/",
	      'method': 'PUT',
	      'data': JSON.stringify(classInfo),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "DeMY":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"class-one-container":"class-one-container","Select--single":"Select--single","react-tabs__tab-list":"react-tabs__tab-list","icon-info-circled":"icon-info-circled","sort-by":"sort-by","sort-by-label":"sort-by-label","createBtn":"createBtn"};

/***/ },

/***/ "7uof":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassOneDateTd = function (_Component) {
	  _inherits(ClassOneDateTd, _Component);
	
	  function ClassOneDateTd(props) {
	    _classCallCheck(this, ClassOneDateTd);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  ClassOneDateTd.prototype.render = function render() {
	    var classInfo = this.props.classInfo;
	    var earliest_date = classInfo.earliest_date,
	        latest_date = classInfo.latest_date;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'class-date' },
	      earliest_date && latest_date && _react2.default.createElement(
	        'span',
	        null,
	        earliest_date,
	        ' - ',
	        latest_date
	      )
	    );
	  };
	
	  return ClassOneDateTd;
	}(_react.Component);
	
	exports.default = ClassOneDateTd;
	module.exports = exports['default'];

/***/ },

/***/ "DA52":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactTooltip = __webpack_require__("Hh2+");
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _locale = __webpack_require__("Ru2+");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassOneNameTd = function (_Component) {
	  _inherits(ClassOneNameTd, _Component);
	
	  function ClassOneNameTd(props) {
	    _classCallCheck(this, ClassOneNameTd);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  ClassOneNameTd.prototype.render = function render() {
	    var classInfo = this.props.classInfo;
	    var className = classInfo.className,
	        classID = classInfo.classID,
	        consumption_type = classInfo.consumption_type;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'class-status' },
	      _react2.default.createElement(
	        'button',
	        { className: 'btn-link', onClick: function onClick() {
	            return _reactRouter.browserHistory.push('/class-one-detail/' + classID);
	          }, disabled: !(0, _R.userCan)('read_private_class_detail') },
	        className
	      ),
	      !consumption_type && _react2.default.createElement(
	        'i',
	        { className: 'fa icon-info-circled', 'data-tip': true, 'data-for': toString(classID) },
	        _react2.default.createElement(_reactTooltip2.default, {
	          id: toString(classID),
	          effect: 'solid',
	          place: 'right',
	          type: 'info',
	          getContent: function getContent() {
	            return __('We have upgraded our class functionality, please set class tuition fee to facilitate the statistics of tuition consumption', _locale2.default);
	          }
	        })
	      )
	    );
	  };
	
	  return ClassOneNameTd;
	}(_react.Component);
	
	exports.default = ClassOneNameTd;
	module.exports = exports['default'];

/***/ },

/***/ "Ru2+":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'ClassOnePage',
	  code: 'CN',
	  text: {
	    'Search Private Class': '搜索私课名称',
	    "We have upgraded our class functionality, please set class tuition fee to facilitate the statistics of tuition consumption": '我们对班级功能进行了升级，请设置班级学费标准以方便进行学费消耗统计。',
	    'Sort by': '排序',
	    'Creation Time: Newest to Oldest': '按创建时间：由新到旧',
	    'Creation Time: Oldest to Newest': '按创建时间：由旧到新',
	    'Name: A-Z': '按名称：由A到Z',
	    'Name: Z-A': '按名称：由Z到A',
	
	    'Current': '当期私课',
	    'Closed': '已关闭私课'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "21YX":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassOneStatusTd = function (_Component) {
	  _inherits(ClassOneStatusTd, _Component);
	
	  function ClassOneStatusTd(props) {
	    _classCallCheck(this, ClassOneStatusTd);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  ClassOneStatusTd.prototype.render = function render() {
	    var classInfo = this.props.classInfo;
	    var totalQuantity = classInfo.totalQuantity,
	        usedLessonTimes = classInfo.usedLessonTimes;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'class-status' },
	      usedLessonTimes + '/' + totalQuantity + ' ' + __('', 'classdetail')
	    );
	  };
	
	  return ClassOneStatusTd;
	}(_react.Component);
	
	exports.default = ClassOneStatusTd;
	module.exports = exports['default'];

/***/ },

/***/ "7rsq":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassOneTeacherListTd = function (_Component) {
	  _inherits(ClassOneTeacherListTd, _Component);
	
	  function ClassOneTeacherListTd(props) {
	    _classCallCheck(this, ClassOneTeacherListTd);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  ClassOneTeacherListTd.prototype.render = function render() {
	    var classInfo = this.props.classInfo;
	    var teacherList = classInfo.teacherList;
	
	
	    return _react2.default.createElement(
	      _R2.default,
	      { can: 'read_class_teacher' },
	      _react2.default.createElement(
	        'div',
	        { className: 'class-teacher-list' },
	        teacherList.map(function (teacher, i) {
	          return _react2.default.createElement(
	            'p',
	            { key: i },
	            teacher.stName
	          );
	        })
	      )
	    );
	  };
	
	  return ClassOneTeacherListTd;
	}(_react.Component);
	
	exports.default = ClassOneTeacherListTd;
	module.exports = exports['default'];

/***/ },

/***/ "hYPf":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HadLessonTd = function (_Component) {
	  _inherits(HadLessonTd, _Component);
	
	  function HadLessonTd(props) {
	    _classCallCheck(this, HadLessonTd);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  HadLessonTd.prototype.render = function render() {
	    var classInfo = this.props.classInfo;
	    var has_lesson = classInfo.has_lesson;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'class-has-lesson' },
	      has_lesson == true ? __('Scheduled', 'class') : __('Not Scheduled', 'class')
	    );
	  };
	
	  return HadLessonTd;
	}(_react.Component);
	
	exports.default = HadLessonTd;
	module.exports = exports['default'];

/***/ },

/***/ "Mxt6":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _UI = __webpack_require__("OM1Z");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	var _ClassOneNameTd = __webpack_require__("DA52");
	
	var _ClassOneNameTd2 = _interopRequireDefault(_ClassOneNameTd);
	
	var _ClassOneDateTd = __webpack_require__("7uof");
	
	var _ClassOneDateTd2 = _interopRequireDefault(_ClassOneDateTd);
	
	var _ClassOneStatusTd = __webpack_require__("21YX");
	
	var _ClassOneStatusTd2 = _interopRequireDefault(_ClassOneStatusTd);
	
	var _ClassOneTeacherListTd = __webpack_require__("7rsq");
	
	var _ClassOneTeacherListTd2 = _interopRequireDefault(_ClassOneTeacherListTd);
	
	var _HadLessonTd = __webpack_require__("hYPf");
	
	var _HadLessonTd2 = _interopRequireDefault(_HadLessonTd);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CONTROLLER_WIDTH = '14%';
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var ClassOneTable = function (_Component) {
	  _inherits(ClassOneTable, _Component);
	
	  function ClassOneTable(props) {
	    _classCallCheck(this, ClassOneTable);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  ClassOneTable.prototype.render = function render() {
	    var _props = this.props,
	        tableData = _props.tableData,
	        dispatch = _props.dispatch,
	        settings = _props.settings,
	        pagination = _props.pagination,
	        onPageChange = _props.onPageChange,
	        onItemsCountPerPageChange = _props.onItemsCountPerPageChange,
	        fetching = _props.fetching;
	
	
	    var fields = [{
	      name: 'className',
	      title: __('Class Name', 'class'),
	      getTdProps: function getTdProps(_ref) {
	        var tbodyData = _ref.tbodyData;
	
	        return {
	          className: "class-info",
	          style: {
	            width: "15%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref2) {
	        var classInfo = _ref2.trData;
	
	        //return <span />
	        return _react2.default.createElement(_ClassOneNameTd2.default, { classInfo: classInfo });
	      }
	    }, {
	      name: 'earliest_day',
	      title: __('Date', 'class'),
	      getTdContent: function getTdContent(_ref3) {
	        var classInfo = _ref3.trData;
	
	        //return <span />
	        return _react2.default.createElement(_ClassOneDateTd2.default, { classInfo: classInfo });
	      }
	    }, {
	      name: 'totalQuantity',
	      title: __('Lesson Status', 'class'),
	      getTdContent: function getTdContent(_ref4) {
	        var classInfo = _ref4.trData;
	
	        //return <span />
	        return _react2.default.createElement(_ClassOneStatusTd2.default, { classInfo: classInfo });
	      }
	    }, {
	      name: 'teacherCount',
	      title: __('Teachers', 'class'),
	      getTdContent: function getTdContent(_ref5) {
	        var classInfo = _ref5.trData;
	
	        //return <span />
	        return _react2.default.createElement(_ClassOneTeacherListTd2.default, { classInfo: classInfo });
	      }
	    }, {
	      name: 'studentName',
	      title: __('Students', 'class'),
	      getTdProps: function getTdProps(_ref6) {
	        var tbodyData = _ref6.tbodyData;
	
	        return {
	          className: "class-info",
	          style: {
	            width: "10%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(opts) {
	        if (opts.tdData) {
	          var plusSign = '';
	          if (opts.trData.studentCount > 1) {
	            plusSign = ' (+' + (opts.trData.studentCount - 1) + ')';
	          }
	
	          return '' + opts.tdData + plusSign;
	        } else {
	          return '';
	        }
	      }
	    }, {
	      name: 'has_lesson',
	      title: __('Status', 'class'),
	      getTdContent: function getTdContent(_ref7) {
	        var classInfo = _ref7.trData;
	
	        //return <span />
	        return _react2.default.createElement(_HadLessonTd2.default, { classInfo: classInfo });
	      }
	    }];
	
	    return _react2.default.createElement(_UI.Table, {
	      data: tableData,
	      fields: fields,
	      className: 'teacher-table',
	      settingThTitle: __('Settings', 'class', null, true),
	      settingWidth: CONTROLLER_WIDTH,
	      settings: settings,
	      useMultiSelection: false,
	      oneSettingPerRow: false,
	      dropdownGuideWidth: 160,
	      dropdownGuideHeight: 228,
	      fetching: fetching,
	
	      pagination: pagination,
	      usePagination: true,
	      onPageChange: onPageChange,
	      onItemsCountPerPageChange: onItemsCountPerPageChange
	    });
	  };
	
	  return ClassOneTable;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ClassOneTable);
	module.exports = exports['default'];

/***/ },

/***/ "OG8y":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _ducks = __webpack_require__("wTtZ");
	
	var _OnBoardingNatural = __webpack_require__("PwUp");
	
	var _OnBoardingNatural2 = _interopRequireDefault(_OnBoardingNatural);
	
	var _constant = __webpack_require__("cwv3");
	
	var _ClassOneTable = __webpack_require__("Mxt6");
	
	var _ClassOneTable2 = _interopRequireDefault(_ClassOneTable);
	
	var _tableSettings = __webpack_require__("vuXa");
	
	var _tableSettings2 = _interopRequireDefault(_tableSettings);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    classList: state.classList
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchClass: function fetchClass(opts) {
	      return dispatch((0, _ducks.fetchClass)(opts));
	    }
	  };
	};
	
	var DefaultTab = function (_Component) {
	  _inherits(DefaultTab, _Component);
	
	  function DefaultTab(props) {
	    _classCallCheck(this, DefaultTab);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.fetchClassList = _this.fetchClassList.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.onItemsCountPerPageChange = _this.onItemsCountPerPageChange.bind(_this);
	    return _this;
	  }
	
	  DefaultTab.prototype.componentWillMount = function componentWillMount() {
	    this.fetchClassList(1);
	  };
	
	  DefaultTab.prototype.fetchClassList = function fetchClassList(newPageNumber, newAmountPerPage) {
	    var itemsCountPerPage = this.props.classList.pagination.itemsCountPerPage;
	    var _props = this.props,
	        classState = _props.classState,
	        orderBy = _props.orderBy,
	        keyword = _props.keyword;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    this.props.fetchClass({
	      schoolId: schoolId,
	      type: '1on1',
	      state: classState,
	      amount_per_page: newAmountPerPage || itemsCountPerPage,
	      current_page_number: newPageNumber,
	      order_by: orderBy,
	      keyword: keyword
	    });
	  };
	
	  DefaultTab.prototype.onPageChange = function onPageChange(activePage) {
	    if (activePage == this.props.classList.pagination.activePage) {
	      return;
	    }
	
	    this.fetchClassList(activePage);
	  };
	
	  DefaultTab.prototype.onItemsCountPerPageChange = function onItemsCountPerPageChange(itemsCountPerPage) {
	    this.fetchClassList(1, itemsCountPerPage);
	  };
	
	  DefaultTab.prototype.render = function render() {
	    var _props2 = this.props,
	        classState = _props2.classState,
	        classList = _props2.classList;
	    var fetching = classList.fetching,
	        hasPermission = classList.hasPermission,
	        school_has_class = classList.school_has_class,
	        pagination = classList.pagination;
	
	
	    this.tableSettings = _tableSettings2.default.call(this, classState);
	    var content = _constant.onBoardingContents[classState] || {};
	    if (school_has_class == false && content || hasPermission == false) {
	      return _react2.default.createElement(_OnBoardingNatural2.default, {
	        isShown: true,
	        title: content.title,
	        text: content.text,
	        image: content.image,
	        showArrow: content.showArrow
	      });
	    } else {
	      return _react2.default.createElement(_ClassOneTable2.default, {
	        fetching: fetching,
	        tableData: classList.list,
	        settings: this.tableSettings,
	        pagination: pagination,
	        onPageChange: this.onPageChange,
	        onItemsCountPerPageChange: this.onItemsCountPerPageChange
	      });
	    }
	  };
	
	  return DefaultTab;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DefaultTab);
	module.exports = exports['default'];

/***/ },

/***/ "cwv3":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var locale = {
	  id: 'ClassOneConstant',
	  code: 'CN',
	  text: {
	    "./images/private_en@2x.png": "./images/Private_class@2x.png",
	    'Flexible Private Class Management': '灵活多变的私课',
	    'Private Class Management is not limited to just one on one lesson, it can also be used as auditions, interviews, and more. Just like Class Management, it allows you to appoint teacher and classrooms.': '私课不仅仅指一对一的教学形式，这里还可以用于补课，试听，对谈等多种应用方式。别忘了，老师，教室和授课时间也是影响私课的重要因素哦。'
	  }
	};
	
	var onBoardingContents = exports.onBoardingContents = {
	  // we show this when student state is 'current'
	  current: {
	    title: __('Flexible Private Class Management', locale),
	    text: __('Private Class Management is not limited to just one on one lesson, it can also be used as auditions, interviews, and more. Just like Class Management, it allows you to appoint teacher and classrooms.', locale),
	    image: __webpack_require__(8)(__('./images/private_en@2x.png', locale)),
	    showArrow: true
	  }
	};

/***/ },

/***/ 8:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./ClassOne.scss": "DeMY",
		"./ClassOneTable/ClassOneDateTd": "7uof",
		"./ClassOneTable/ClassOneDateTd.js": "7uof",
		"./ClassOneTable/ClassOneNameTd": "DA52",
		"./ClassOneTable/ClassOneNameTd.js": "DA52",
		"./ClassOneTable/ClassOneStatusTd": "21YX",
		"./ClassOneTable/ClassOneStatusTd.js": "21YX",
		"./ClassOneTable/ClassOneTeacherListTd": "7rsq",
		"./ClassOneTable/ClassOneTeacherListTd.js": "7rsq",
		"./ClassOneTable/HadLessonTd": "hYPf",
		"./ClassOneTable/HadLessonTd.js": "hYPf",
		"./ClassOneTable/index": "Mxt6",
		"./ClassOneTable/index.js": "Mxt6",
		"./DefaultTab": "OG8y",
		"./DefaultTab.js": "OG8y",
		"./constant": "cwv3",
		"./constant.js": "cwv3",
		"./images/Private_class@2x.png": "9sfX",
		"./images/private_en@2x.png": "OG2L",
		"./index": "J+P4",
		"./index.js": "J+P4",
		"./locale": "Ru2+",
		"./locale.js": "Ru2+",
		"./table-settings": "vuXa",
		"./table-settings.js": "vuXa"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 8;


/***/ },

/***/ "9sfX":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Private_class@2x.f7081682.png";

/***/ },

/***/ "OG2L":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "private_en@2x.f95c972d.png";

/***/ },

/***/ "J+P4":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DefaultTab = __webpack_require__("OG8y");
	
	var _DefaultTab2 = _interopRequireDefault(_DefaultTab);
	
	var _CreateClassOne = __webpack_require__("sbFW");
	
	var _CreateClassOne2 = _interopRequireDefault(_CreateClassOne);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _ducks = __webpack_require__("wTtZ");
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _FilterBy = __webpack_require__("SdD8");
	
	var _FilterBy2 = _interopRequireDefault(_FilterBy);
	
	var _locale = __webpack_require__("Ru2+");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("DeMY");
	
	var _UI = __webpack_require__("OM1Z");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FILTERS = ['text:searchKeyword'];
	
	var FILTER_OPTIONS = {
	  'text:searchKeyword': {
	    placeholder: __('Search Private Class', _locale2.default),
	    valueMinLength: 2
	  }
	};
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    classList: state.classList
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchClass: function fetchClass(opts) {
	      return dispatch((0, _ducks.fetchClass)(opts));
	    }
	  };
	};
	
	var ClassOne = function (_Component) {
	  _inherits(ClassOne, _Component);
	
	  function ClassOne(props) {
	    _classCallCheck(this, ClassOne);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      selectedOption: '',
	      selectedIndex: 0,
	      orderBy: 0,
	      filterData: {},
	      keyword: ''
	    };
	
	    _this.onSelectTab = _this.onSelectTab.bind(_this);
	    _this.onFilterChange = _this.onFilterChange.bind(_this);
	    return _this;
	  }
	
	  ClassOne.prototype.onFilterChange = function onFilterChange(_ref) {
	    var _this2 = this;
	
	    var filterData = _ref.filterData;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _state = this.state,
	        selectedIndex = _state.selectedIndex,
	        orderBy = _state.orderBy;
	    var itemsCountPerPage = this.props.classList.pagination.itemsCountPerPage;
	
	
	    this.setState({
	      filterData: filterData,
	      keyword: filterData['searchKeyword']
	    }, function () {
	      _this2.props.fetchClass({
	        schoolId: schoolId,
	        type: '1on1',
	        state: selectedIndex == 0 ? 'current' : 'archived',
	        keyword: _this2.state.keyword,
	        amount_per_page: itemsCountPerPage,
	        current_page_number: 1,
	        order_by: orderBy
	      });
	    });
	  };
	
	  ClassOne.prototype.onSelectTab = function onSelectTab(selectedIndex) {
	    var orderBy = this.state.orderBy;
	
	
	    this.setState({
	      selectedIndex: selectedIndex,
	      orderBy: orderBy,
	      filterData: _extends({}, this.state.filterData, {
	        searchKeyword: ''
	      }),
	      keyword: ''
	    });
	  };
	
	  ClassOne.prototype.render = function render() {
	    var _this3 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _props$classList$pagi = this.props.classList.pagination,
	        activePage = _props$classList$pagi.activePage,
	        itemsCountPerPage = _props$classList$pagi.itemsCountPerPage;
	    var _state2 = this.state,
	        selectedOption = _state2.selectedOption,
	        selectedIndex = _state2.selectedIndex,
	        filterData = _state2.filterData,
	        keyword = _state2.keyword,
	        orderBy = _state2.orderBy;
	
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      { className: 'class-one-container' },
	      _react2.default.createElement(
	        'div',
	        null,
	        __("Private Class List", "classone")
	      ),
	      _react2.default.createElement(
	        _UI.Tabs,
	        { defaultIndex: selectedIndex, onSelect: this.onSelectTab },
	        _react2.default.createElement(
	          _UI.TabList,
	          null,
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('Current', _locale2.default)
	          ),
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('Closed', _locale2.default)
	          ),
	          _react2.default.createElement(
	            _R2.default,
	            { can: 'create_private_class', by: 'disable' },
	            _react2.default.createElement(
	              'button',
	              { className: ' btn btn-primary pull-right createBtn', onClick: function onClick() {
	                  (0, _CreateClassOne2.default)({ mode: 'create' }).then(function () {
	                    _this3.setState({
	                      filterData: _extends({}, _this3.state.filterData, {
	                        searchKeyword: ''
	                      }),
	                      keyword: ''
	                    }, function () {
	                      _this3.props.fetchClass({
	                        schoolId: schoolId,
	                        type: '1on1',
	                        state: selectedIndex == 0 ? 'current' : 'archived',
	                        amount_per_page: itemsCountPerPage,
	                        current_page_number: activePage,
	                        order_by: orderBy
	                      });
	                    });
	                  });
	                } },
	              __("New Private Class", "classone")
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-right' },
	            _react2.default.createElement(_FilterBy2.default, {
	              filterData: filterData,
	              filters: FILTERS,
	              options: FILTER_OPTIONS,
	              onChange: this.onFilterChange })
	          ),
	          _react2.default.createElement(
	            'select',
	            { className: 'form-control sort-by pull-right', value: orderBy, disabled: selectedOption, onChange: function onChange(e) {
	                _this3.setState({ orderBy: e.target.value }, function () {
	                  _this3.props.fetchClass({
	                    schoolId: schoolId,
	                    type: '1on1',
	                    state: selectedIndex == 0 ? 'current' : 'archived',
	                    amount_per_page: itemsCountPerPage,
	                    current_page_number: activePage,
	                    order_by: _this3.state.orderBy,
	                    keyword: keyword
	                  });
	                });
	              } },
	            _react2.default.createElement(
	              'option',
	              { key: '0', value: '0' },
	              __('Creation Time: Newest to Oldest', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'option',
	              { key: '1', value: '1' },
	              __('Creation Time: Oldest to Newest', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'option',
	              { key: '2', value: '2' },
	              __('Name: A-Z', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'option',
	              { key: '3', value: '3' },
	              __('Name: Z-A', _locale2.default)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-right sort-by-label' },
	            __('Sort by', _locale2.default)
	          )
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { classState: 'current', orderBy: orderBy, keyword: keyword })
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { classState: 'archived', orderBy: orderBy, keyword: keyword })
	        )
	      )
	    );
	  };
	
	  return ClassOne;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ClassOne);
	module.exports = exports['default'];

/***/ },

/***/ "vuXa":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (classState) {
	
	  if (classState == 'archived') {
	    return getArchivedPrivateClassTableSettings.call(this);
	  }
	
	  return getDefaultTableSettings.call(this);
	};
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _alert = __webpack_require__("BGi1");
	
	var _closeAndArchiveClass = __webpack_require__("0t0r");
	
	var _closeAndArchiveClass2 = _interopRequireDefault(_closeAndArchiveClass);
	
	var _R = __webpack_require__("nRUD");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 'this' refers to DefaultTab
	function getDefaultTableSettings() {
	  var TabComponent = this;
	  // 'this props' refers to DefaultTab.props
	  var pagination = this.props.classList.pagination;
	
	
	  return [{
	    title: __('Add Lesson', 'class'),
	    onClick: function onClick(_ref) {
	      var classInfo = _ref.trData;
	
	      _reactRouter.browserHistory.push({
	        pathname: '/class-one-detail/' + classInfo.classID,
	        state: {
	          openCreateLessonDock: true
	        }
	      });
	    },
	    isDisabled: function isDisabled() {
	      return !(0, _R.userCan)('create_private_lesson');
	    }
	  }, {
	    title: __("Attendance", "class"),
	    onClick: function onClick(_ref2) {
	      var classInfo = _ref2.trData;
	
	      _reactRouter.browserHistory.push('/class-one-detail/' + classInfo.classID);
	    },
	    isDisabled: function isDisabled(_ref3) {
	      var classInfo = _ref3.trData;
	
	      return classInfo.has_lesson == false || !(0, _R.userCan)('manually_check_in');
	    }
	  }, {
	    title: __("Close", "classone"),
	    onClick: function onClick(_ref4) {
	      var classInfo = _ref4.trData;
	
	      (0, _closeAndArchiveClass2.default)(classInfo, '1on1').then(function () {
	        TabComponent.fetchClassList(pagination.activePage);
	      }).catch(function (err) {
	        _alert.alert.error(err);
	      });
	    },
	    isDisabled: function isDisabled() {
	      return !(0, _R.userCan)('close_private_class');
	    }
	  }];
	}
	
	// Specifically used for archived student table
	function getArchivedPrivateClassTableSettings() {
	  var TabComponent = this;
	  var dispatch = this.props.dispatch;
	
	
	  return [
	    // {
	    //   title: __("View", "classone"),
	    //   onClick: ({ trData: classInfo })=>{
	    //     browserHistory.push({
	    //       pathname: `/class-detail/${classInfo.classID}`,
	    //       state: {returningPath: '/one_one/deleted'}
	    //     });
	    //   }
	    // },
	    // {
	    // 	title: __('Restore', 'teacher'),
	    // 	onClick: ({ trData: classInfo }) => {
	    //     confirm(__('Proceed to restore private class?', 'classone'), __("Restore", "teacher"))
	    //     .then(() => {
	    //       unarchivePrivateClass(classInfo.classID)
	    //       .then((result) => {
	    //         const schoolId = localStorage.getItem('schoolId')
	    //         dispatch(fetchClass(schoolId, '1on1', 'archived'))
	    //       })
	    //       .catch((err)=>{
	    //         console.error(err);
	    //       });
	    //     })
	    //     .catch((err)=>{
	    //       console.error(err);
	    //     })
	    //   }
	    // },
	  ];
	}
	module.exports = exports['default'];

/***/ },

/***/ "Re4n":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _ClassDetail = __webpack_require__("fWyM");
	
	var _ClassDetail2 = _interopRequireDefault(_ClassDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	var ClassOneDetail = function (_Component) {
	  _inherits(ClassOneDetail, _Component);
	
	  function ClassOneDetail() {
	    _classCallCheck(this, ClassOneDetail);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ClassOneDetail.prototype.render = function render() {
	    return _react2.default.createElement(_ClassDetail2.default, _extends({ params: this.props.params }, this.props));
	  };
	
	  return ClassOneDetail;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ClassOneDetail);
	module.exports = exports['default'];

/***/ },

/***/ "/k15":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"classroom-container":"classroom-container","Select--single":"Select--single","react-tabs__tab-list":"react-tabs__tab-list","sort-by":"sort-by","sort-by-label":"sort-by-label","createBtn":"createBtn"};

/***/ },

/***/ "qPto":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "37mE":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _UI = __webpack_require__("OM1Z");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("qPto");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var ClassroomTable = function (_Component) {
	  _inherits(ClassroomTable, _Component);
	
	  function ClassroomTable(props) {
	    _classCallCheck(this, ClassroomTable);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  ClassroomTable.prototype.render = function render() {
	    var _props = this.props,
	        tableData = _props.tableData,
	        settings = _props.settings,
	        pagination = _props.pagination,
	        onItemsCountPerPageChange = _props.onItemsCountPerPageChange,
	        onPageChange = _props.onPageChange;
	
	
	    var fields = [{
	      name: "name",
	      title: __('Classroom Name', 'classroom')
	    }];
	
	    var CONTROLLER_WIDTH = '200px';
	
	    return _react2.default.createElement(_UI.Table, {
	      data: tableData,
	      fields: fields,
	      className: 'teacher-table',
	      settingThTitle: __('Settings', 'class', null, true),
	      settingWidth: CONTROLLER_WIDTH,
	      settings: settings,
	      useMultiSelection: false,
	      oneSettingPerRow: false,
	
	      dropdownGuideWidth: 160,
	      dropdownGuideHeight: 228,
	
	      usePagination: true,
	      pagination: pagination,
	      onItemsCountPerPageChange: onItemsCountPerPageChange,
	      onPageChange: onPageChange
	    });
	  };
	
	  return ClassroomTable;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ClassroomTable);
	module.exports = exports['default'];

/***/ },

/***/ "nQdd":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _OnBoardingNatural = __webpack_require__("PwUp");
	
	var _OnBoardingNatural2 = _interopRequireDefault(_OnBoardingNatural);
	
	var _constant = __webpack_require__("Fg9y");
	
	var _ducks = __webpack_require__("I0d0");
	
	var _ClassroomTable = __webpack_require__("37mE");
	
	var _ClassroomTable2 = _interopRequireDefault(_ClassroomTable);
	
	var _tableSettings = __webpack_require__("4J1v");
	
	var _tableSettings2 = _interopRequireDefault(_tableSettings);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    gSubscription: state.gSubscription,
	    classroomList: state.classroomList
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchClassroom: function fetchClassroom(opts) {
	      return dispatch((0, _ducks.fetchClassroom)(opts));
	    }
	  };
	};
	
	var DefaultTab = function (_Component) {
	  _inherits(DefaultTab, _Component);
	
	  function DefaultTab(props) {
	    _classCallCheck(this, DefaultTab);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.fetchClassroomList = _this.fetchClassroomList.bind(_this);
	    _this.onItemsCountPerPageChange = _this.onItemsCountPerPageChange.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    return _this;
	  }
	
	  DefaultTab.prototype.componentWillMount = function componentWillMount() {
	    this.fetchClassroomList(1);
	  };
	
	  DefaultTab.prototype.fetchClassroomList = function fetchClassroomList(newPageNumber, newAmountPerPage) {
	    var schoolId = localStorage.getItem('schoolId');
	    var _props = this.props,
	        keyword = _props.keyword,
	        classroomList = _props.classroomList,
	        orderBy = _props.orderBy;
	    var itemsCountPerPage = classroomList.pagination.itemsCountPerPage;
	
	
	    this.props.fetchClassroom({
	      schoolId: schoolId,
	      amount_per_page: newAmountPerPage || itemsCountPerPage,
	      current_page_number: newPageNumber,
	      order_by: orderBy,
	      keyword: keyword
	    });
	  };
	
	  DefaultTab.prototype.onPageChange = function onPageChange(activePage) {
	    if (activePage == this.props.classroomList.pagination.activePage) {
	      return;
	    }
	
	    this.fetchClassroomList(activePage);
	  };
	
	  DefaultTab.prototype.onItemsCountPerPageChange = function onItemsCountPerPageChange(itemsCountPerPage) {
	    this.fetchClassroomList(1, itemsCountPerPage);
	  };
	
	  DefaultTab.prototype.render = function render() {
	    var classroomList = this.props.classroomList;
	    var fetching = classroomList.fetching,
	        hasPermission = classroomList.hasPermission,
	        school_has_classroom = classroomList.school_has_classroom,
	        pagination = classroomList.pagination;
	
	
	    this.tableSettings = _tableSettings2.default.call(this);
	    var content = _constant.onBoardingContents || {};
	
	    if (fetching) {
	      return _react2.default.createElement(_Loading2.default, null);
	    }
	
	    if (school_has_classroom == false && content || hasPermission == false) {
	      return _react2.default.createElement(_OnBoardingNatural2.default, {
	        isShown: true,
	        title: content.title,
	        text: content.text,
	        image: content.image,
	        showArrow: content.showArrow
	      });
	    } else {
	      return _react2.default.createElement(_ClassroomTable2.default, {
	        tableData: classroomList.list,
	        settings: this.tableSettings,
	        pagination: pagination,
	        onItemsCountPerPageChange: this.onItemsCountPerPageChange,
	        onPageChange: this.onPageChange
	      });
	    }
	  };
	
	  return DefaultTab;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DefaultTab);
	module.exports = exports['default'];

/***/ },

/***/ "Fg9y":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var locale = {
	  id: 'ClassroomConstant',
	  code: 'CN',
	  text: {
	    "./images/classroom_en@2x.png": "./images/Classroom@2x.png",
	    'Personalized Classroom Management': '个性化的教室',
	    'Effective Classroom Management allows you to manage your school for efficiently. Depends on the purpose, you can create a classroom for different events as well.': '有效的教室管理可以节省不必要的资源浪费。根据不同的用途，定制个性化的教室/场地名称。也可以在课表里根据教室来筛选课程。'
	  }
	};
	
	var onBoardingContents = exports.onBoardingContents = {
	  title: __('Personalized Classroom Management', locale),
	  text: __('Effective Classroom Management allows you to manage your school for efficiently. Depends on the purpose, you can create a classroom for different events as well.', locale),
	  image: __webpack_require__(9)(__('./images/classroom_en@2x.png', locale)),
	  showArrow: true
	};

/***/ },

/***/ 9:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./Classroom.scss": "/k15",
		"./ClassroomTable/ClassroomTable.scss": "qPto",
		"./ClassroomTable/index": "37mE",
		"./ClassroomTable/index.js": "37mE",
		"./DefaultTab": "nQdd",
		"./DefaultTab.js": "nQdd",
		"./constant": "Fg9y",
		"./constant.js": "Fg9y",
		"./ducks": "I0d0",
		"./ducks.js": "I0d0",
		"./images/Classroom@2x.png": "0dUj",
		"./images/classroom_en@2x.png": "/lYJ",
		"./index": "j+FQ",
		"./index.js": "j+FQ",
		"./locale": "Nj5O",
		"./locale.js": "Nj5O",
		"./table-settings": "4J1v",
		"./table-settings.js": "4J1v"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 9;


/***/ },

/***/ "0dUj":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Classroom@2x.eee5a930.png";

/***/ },

/***/ "/lYJ":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "classroom_en@2x.a6c1c208.png";

/***/ },

/***/ "j+FQ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DefaultTab = __webpack_require__("nQdd");
	
	var _DefaultTab2 = _interopRequireDefault(_DefaultTab);
	
	var _CreateClassroom = __webpack_require__("q1HF");
	
	var _CreateClassroom2 = _interopRequireDefault(_CreateClassroom);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _SearchBar = __webpack_require__("EM0x");
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _locale = __webpack_require__("Nj5O");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("/k15");
	
	var _ducks = __webpack_require__("I0d0");
	
	var _getClassroom = __webpack_require__("QWKB");
	
	var _getClassroom2 = _interopRequireDefault(_getClassroom);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _FilterBy = __webpack_require__("SdD8");
	
	var _FilterBy2 = _interopRequireDefault(_FilterBy);
	
	var _UI = __webpack_require__("OM1Z");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FILTERS = ['text:searchKeyword'];
	
	var FILTER_OPTIONS = {
	  'text:searchKeyword': {
	    placeholder: __('Search Classroom', _locale2.default),
	    valueMinLength: 2
	  }
	};
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    classroomList: state.classroomList
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchClassroom: function fetchClassroom(opts) {
	      return dispatch((0, _ducks.fetchClassroom)(opts));
	    }
	  };
	};
	
	var Classroom = function (_Component) {
	  _inherits(Classroom, _Component);
	
	  function Classroom(props) {
	    _classCallCheck(this, Classroom);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      options: [],
	      orderBy: 0,
	      filterData: {},
	      keyword: ''
	    };
	    _this.onFilterChange = _this.onFilterChange.bind(_this);
	    return _this;
	  }
	
	  Classroom.prototype.onFilterChange = function onFilterChange(_ref) {
	    var _this2 = this;
	
	    var filterData = _ref.filterData;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var orderBy = this.state.orderBy;
	    var itemsCountPerPage = this.props.classroomList.pagination.itemsCountPerPage;
	
	
	    this.setState({
	      filterData: filterData,
	      keyword: filterData['searchKeyword']
	    }, function () {
	      _this2.props.fetchClassroom({
	        schoolId: schoolId,
	        amount_per_page: itemsCountPerPage,
	        current_page_number: 1,
	        order_by: orderBy,
	        keyword: _this2.state.keyword
	      });
	    });
	  };
	
	  Classroom.prototype.render = function render() {
	    var _this3 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _props$classroomList$ = this.props.classroomList.pagination,
	        activePage = _props$classroomList$.activePage,
	        itemsCountPerPage = _props$classroomList$.itemsCountPerPage;
	    var _state = this.state,
	        filterData = _state.filterData,
	        orderBy = _state.orderBy,
	        keyword = _state.keyword;
	
	
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      { className: 'classroom-container' },
	      _react2.default.createElement(
	        'div',
	        null,
	        __("Classroom List", "classroom")
	      ),
	      _react2.default.createElement(
	        _UI.Tabs,
	        null,
	        _react2.default.createElement(
	          _UI.TabList,
	          null,
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('Classroom', 'classroom')
	          ),
	          _react2.default.createElement(
	            _R2.default,
	            { can: 'create_classroom', by: 'disable' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary pull-right createBtn', onClick: function onClick() {
	                  (0, _CreateClassroom2.default)({ mode: 'create' }).then(function () {
	                    _this3.setState({
	                      filterData: _extends({}, _this3.state.filterData, {
	                        searchKeyword: ''
	                      }),
	                      keyword: ''
	                    }, function () {
	                      _this3.props.fetchClassroom({
	                        schoolId: schoolId,
	                        amount_per_page: itemsCountPerPage,
	                        current_page_number: activePage,
	                        order_by: _this3.state.orderBy
	                      });
	                    });
	                  });
	                } },
	              __('New Classroom', 'classroom')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-right' },
	            _react2.default.createElement(_FilterBy2.default, {
	              filterData: filterData,
	              filters: FILTERS,
	              options: FILTER_OPTIONS,
	              onChange: this.onFilterChange })
	          ),
	          _react2.default.createElement(
	            'select',
	            { className: 'form-control sort-by pull-right', value: orderBy, onChange: function onChange(e) {
	                _this3.setState({ orderBy: e.target.value }, function () {
	                  _this3.props.fetchClassroom({
	                    schoolId: schoolId,
	                    amount_per_page: itemsCountPerPage,
	                    current_page_number: activePage,
	                    order_by: _this3.state.orderBy,
	                    keyword: keyword
	                  });
	                });
	              } },
	            _react2.default.createElement(
	              'option',
	              { key: '0', value: '0' },
	              __('Creation Time: Newest to Oldest', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'option',
	              { key: '1', value: '1' },
	              __('Creation Time: Oldest to Newest', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'option',
	              { key: '2', value: '2' },
	              __('Name: A-Z', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'option',
	              { key: '3', value: '3' },
	              __('Name: Z-A', _locale2.default)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-right sort-by-label' },
	            __('Sort by', _locale2.default)
	          )
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { orderBy: orderBy, keyword: keyword })
	        )
	      )
	    );
	  };
	
	  return Classroom;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Classroom);
	module.exports = exports['default'];

/***/ },

/***/ "Nj5O":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'ClassroomPage',
	  code: 'CN',
	  text: {
	    'Search Classroom': '搜索教室名称',
	    'Sort by': '排序',
	    'Creation Time: Newest to Oldest': '按创建时间：由新到旧',
	    'Creation Time: Oldest to Newest': '按创建时间：由旧到新',
	    'Name: A-Z': '按名称：由A到Z',
	    'Name: Z-A': '按名称：由Z到A'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "4J1v":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  return getDefaultTableSettings.call(this);
	};
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	var _ducks = __webpack_require__("I0d0");
	
	var _deleteClassroom = __webpack_require__("pogM");
	
	var _deleteClassroom2 = _interopRequireDefault(_deleteClassroom);
	
	var _CreateClassroom = __webpack_require__("q1HF");
	
	var _CreateClassroom2 = _interopRequireDefault(_CreateClassroom);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDefaultTableSettings() {
	  var _this = this;
	
	  var TabComponent = this;
	  var dispatch = this.props.dispatch;
	
	
	  return [{
	    title: __('Edit', 'student'),
	    onClick: function onClick(_ref) {
	      var classroom = _ref.trData;
	
	      (0, _CreateClassroom2.default)({ mode: 'update', data: classroom });
	    },
	    isDisabled: function isDisabled(opts) {
	      return !(0, _R.userCan)('edit_classroom');
	    }
	  }, {
	    title: __("Delete", "classroom"),
	    onClick: function onClick(_ref2) {
	      var classroom = _ref2.trData;
	
	      (0, _confirm.confirm)(__('Proceed to delete classroom?', 'classroom'), __("Delete", "classroom")).then(function () {
	        (0, _deleteClassroom2.default)(classroom.school_classroom_id).then(function (result) {
	          var schoolId = localStorage.getItem('schoolId');
	          _this.props.fetchClassroom({ schoolId: schoolId });
	        }).catch(function (err) {
	          console.error(err);
	        });
	      }).catch(function (err) {
	        console.error(err);
	      });
	    },
	    isDisabled: function isDisabled(opts) {
	      return !(0, _R.userCan)('delete_classroom');
	    }
	  }];
	}
	module.exports = exports['default'];

/***/ },

/***/ "pogM":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = deleteClassroom;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deleteClassroom(classroomId) {
	
	  if (!classroomId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing classroom Id (number)')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/classroom_detail/" + classroomId + "/",
	      'method': 'DELETE',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "Hvm5":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _reactD3Components = __webpack_require__("+Ei8");
	
	var _d = __webpack_require__("Za4h");
	
	var _d2 = _interopRequireDefault(_d);
	
	var _round = __webpack_require__("dAKm");
	
	var _round2 = _interopRequireDefault(_round);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _NotificationToast = __webpack_require__("OLzW");
	
	var _NotificationToast2 = _interopRequireDefault(_NotificationToast);
	
	var _ActivityLog = __webpack_require__("zYlc");
	
	var _ActivityLog2 = _interopRequireDefault(_ActivityLog);
	
	var _CalendarDailyView = __webpack_require__("XXpB");
	
	var _CalendarDailyView2 = _interopRequireDefault(_CalendarDailyView);
	
	var _statisticDisplay = __webpack_require__("jPUq");
	
	var _statisticDisplay2 = _interopRequireDefault(_statisticDisplay);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _ducks = __webpack_require__("vvL0");
	
	var _ducks2 = __webpack_require__("Y5Sn");
	
	var _getTimetable = __webpack_require__("sxrQ");
	
	var _getTimetable2 = _interopRequireDefault(_getTimetable);
	
	var _EmptyDataPlaceholder = __webpack_require__("38y+");
	
	var _EmptyDataPlaceholder2 = _interopRequireDefault(_EmptyDataPlaceholder);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _locale = __webpack_require__("pthR");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("DNRm");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AMOUNT_PER_PAGE = 5;
	var PAGE_RANGE_DISPLAYED = 5;
	var CHART_MARGIN = { top: 30, bottom: 50, left: 30, right: 30 };
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    schoolLog: state.schoolLog,
	    schedule: state.schedule,
	    schoolStatistic: state.schoolStatistic
	  };
	};
	var CHECKIN_COLORS = ['#16388b', '#FEB64D'];
	var REGI_COLORS = ['#16388b', '#FB617F', '#FEB64D'];
	var colorScaleCheckin = _d2.default.scale.ordinal().range(CHECKIN_COLORS);
	var colorScaleRegi = _d2.default.scale.ordinal().range(REGI_COLORS);
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getSchoolLog: function getSchoolLog(schoolId, params) {
	      return dispatch((0, _ducks.getSchoolLog)(schoolId, params));
	    },
	    fetchSchoolStatistic: function fetchSchoolStatistic(schoolId) {
	      return dispatch((0, _ducks2.fetchSchoolStatistic)(schoolId));
	    }
	  };
	};
	
	var Dashboard = function (_Component) {
	  _inherits(Dashboard, _Component);
	
	  function Dashboard(props) {
	    _classCallCheck(this, Dashboard);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      lessonInfo: {},
	      activePage: 1,
	      checkinStatistic: [],
	      regiStatistic: [],
	      showCheckInDateRange: 7,
	      showRegiDateRange: 7,
	      statisticFromServer: {},
	      hasValidCheckinStatistic: false,
	      hasValidRegiStatistic: false,
	      chartSize: {
	        width: null,
	        height: 300
	      }
	    };
	    _this.showNotification = _this.showNotification.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.onDateFilterChange = _this.onDateFilterChange.bind(_this);
	    _this.showCheckinTooltip = _this.showCheckinTooltip.bind(_this);
	    _this.showRegiTooltip = _this.showRegiTooltip.bind(_this);
	    return _this;
	  }
	
	  Dashboard.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    if (!nextProps.schoolStatistic.statistic) {
	      return null;
	    }
	    if (nextProps.schoolStatistic.statistic !== this.props.schoolStatistic.statistic) {
	      this.setState({
	        statisticFromServer: nextProps.schoolStatistic.statistic
	      }, function () {
	        _this2.formatCheckinStatistic();
	        _this2.formatRegiStatistic();
	      });
	    }
	  };
	
	  Dashboard.prototype.componentWillMount = function componentWillMount() {
	    var _this3 = this;
	
	    window.addEventListener('resize', function () {
	      _this3.resizeChart();
	    });
	    if ((0, _R.userCan)('timetable_channel')) {
	      this.fetchSchedule();
	    }
	    if ((0, _R.userCan)('operation_log_channel')) {
	      this.fetchLogs();
	    }
	    this.fetchStatistic();
	  };
	
	  Dashboard.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _this4 = this;
	
	    window.removeEventListener('resize', function () {
	      return _this4.resizeChart();
	    });
	  };
	
	  Dashboard.prototype.resizeChart = function resizeChart() {
	    var width = this.chartWrapperNode.clientWidth - CHART_MARGIN.left - CHART_MARGIN.right;
	    var chartSize = this.state.chartSize;
	
	    if (width !== chartSize.width) {
	      this.setState({
	        chartSize: _extends({}, this.state.chartSize, { width: width })
	      });
	    }
	  };
	
	  Dashboard.prototype.formatCheckinStatistic = function formatCheckinStatistic() {
	    var checkInData = [{
	      label: 'Attend',
	      values: []
	    }, {
	      label: 'Absent',
	      values: []
	    }];
	    var showCheckInDateRange = this.state.showCheckInDateRange;
	
	    var checkInStatisObject = this.state.statisticFromServer.check_in_data_30days_ago;
	    var keys = Object.keys(checkInStatisObject);
	    var hasValidCheckinStatistic = false;
	    for (var i = 0; i < showCheckInDateRange; i++) {
	      var date = (0, _moment2.default)(keys[i]).format('MM/DD');
	      var item = checkInStatisObject[keys[i]];
	      var absentPercentage = item.absent_amount + item.counted_amount > 0 ? item.absent_amount / (item.absent_amount + item.counted_amount) : 0;
	      var attendPercentage = item.absent_amount + item.counted_amount > 0 ? item.counted_amount / (item.absent_amount + item.counted_amount) : 0;
	      if (absentPercentage > 0 || attendPercentage > 0) {
	        hasValidCheckinStatistic = true;
	      }
	      var absentItem = {
	        x: date,
	        y: absentPercentage * 100
	      };
	      var attendItem = {
	        x: date,
	        y: attendPercentage * 100
	      };
	      checkInData[0].values.unshift(attendItem);
	      checkInData[1].values.unshift(absentItem);
	    }
	    this.setState({
	      checkinStatistic: checkInData,
	      hasValidCheckinStatistic: hasValidCheckinStatistic
	    });
	  };
	
	  Dashboard.prototype.formatRegiStatistic = function formatRegiStatistic() {
	    var regiData = [{
	      label: 'FromReception',
	      values: []
	    }, {
	      label: 'FromPoster',
	      values: []
	    }, {
	      label: 'FromContact',
	      values: []
	    }];
	    var showRegiDateRange = this.state.showRegiDateRange;
	
	    var regiStatisObject = this.state.statisticFromServer.student_registration_data_30days_ago;
	    var keys = Object.keys(regiStatisObject);
	    var hasValidRegiStatistic = false;
	    for (var i = 0; i < showRegiDateRange; i++) {
	      var date = (0, _moment2.default)(keys[i]).format('MM/DD');
	      var item = regiStatisObject[keys[i]];
	      if (item.converted_from_contact > 0 || item.registered_at_reception > 0 || item.registered_from_poster > 0) {
	        hasValidRegiStatistic = true;
	      }
	      var fromContactItem = {
	        x: date,
	        y: item.converted_from_contact
	      };
	      var fromReceptionItem = {
	        x: date,
	        y: item.registered_at_reception
	      };
	      var fromPosterItem = {
	        x: date,
	        y: item.registered_from_poster
	      };
	      regiData[0].values.unshift(fromReceptionItem);
	      regiData[1].values.unshift(fromPosterItem);
	      regiData[2].values.unshift(fromContactItem);
	    }
	    this.setState({
	      regiStatistic: regiData,
	      hasValidRegiStatistic: hasValidRegiStatistic
	    });
	  };
	
	  Dashboard.prototype.fetchStatistic = function fetchStatistic() {
	    var schoolId = localStorage.getItem('schoolId');
	    this.props.fetchSchoolStatistic(schoolId);
	  };
	
	  Dashboard.prototype.fetchSchedule = function fetchSchedule() {
	    var _this5 = this;
	
	    var activePage = this.state.activePage;
	
	    var currentDate = (0, _moment2.default)().format('YYYY-MM-DD');
	    var schoolId = localStorage.getItem('schoolId');
	    var params = {
	      start_date: currentDate,
	      end_date: currentDate,
	      page_or_not: 1,
	      amount_per_page: AMOUNT_PER_PAGE,
	      page_number: activePage
	    };
	    (0, _getTimetable2.default)(schoolId, params).then(function (res) {
	      res.data.result_list.map(function (item) {
	        item.title = item.class_name + ' (' + __('Lesson', _locale2.default) + ' ' + item.lIndex + ')';
	      });
	      _this5.setState({
	        lessonInfo: res.data
	      });
	    });
	  };
	
	  Dashboard.prototype.fetchLogs = function fetchLogs() {
	    var schoolId = localStorage.getItem('schoolId');
	    var activePage = this.state.activePage;
	
	    var params = {
	      current_page_number: activePage,
	      amount_per_page: AMOUNT_PER_PAGE
	    };
	    this.props.getSchoolLog(schoolId, params);
	  };
	
	  Dashboard.prototype.onPageChange = function onPageChange(pageNumber) {
	    var _this6 = this;
	
	    this.setState({ activePage: pageNumber }, function () {
	      _this6.fetchSchedule();
	    });
	  };
	
	  Dashboard.prototype.showNotification = function showNotification() {
	    this.toast.showToast('this is a test', {
	      onClose: function onClose() {
	        return;
	      }
	    });
	  };
	
	  Dashboard.prototype.onDateFilterChange = function onDateFilterChange(type, e) {
	    var _setState,
	        _this7 = this;
	
	    var key = type === 'checkin' ? 'showCheckInDateRange' : 'showRegiDateRange';
	    this.setState((_setState = {}, _setState[key] = e.target.value, _setState), function () {
	      if (type === 'checkin') {
	        _this7.formatCheckinStatistic();
	      } else {
	        _this7.formatRegiStatistic();
	      }
	    });
	  };
	
	  Dashboard.prototype.renderSelect = function renderSelect(type) {
	    var _this8 = this;
	
	    var _state = this.state,
	        showCheckInDateRange = _state.showCheckInDateRange,
	        showRegiDateRange = _state.showRegiDateRange;
	
	    var currentDateRange = type === 'checkin' ? showCheckInDateRange : showRegiDateRange;
	    return _react2.default.createElement(
	      'select',
	      { className: 'select', onChange: function onChange(e) {
	          return _this8.onDateFilterChange(type, e);
	        }, value: currentDateRange },
	      _react2.default.createElement(
	        'option',
	        { value: '7' },
	        __('Past {numberOfDays} days', _locale2.default, { numberOfDays: 7 })
	      ),
	      _react2.default.createElement(
	        'option',
	        { value: '30' },
	        __('Past {numberOfDays} days', _locale2.default, { numberOfDays: 30 })
	      )
	    );
	  };
	
	  Dashboard.prototype.setTickValues = function setTickValues(type) {
	    var _state2 = this.state,
	        regiStatistic = _state2.regiStatistic,
	        checkinStatistic = _state2.checkinStatistic;
	
	    var tickValues = [];
	    var currentTicks = type === 'checkin' ? checkinStatistic[0].values : regiStatistic[0].values;
	    var length = currentTicks.length;
	    if (length >= 30) {
	      for (var i = 0; i < length; i++) {
	        if (i === 0 || i % 3 === 0) {
	          tickValues.push(currentTicks[i].x);
	        } else {
	          tickValues.push('');
	        }
	      }
	    } else {
	      var _i = 0;
	      while (_i < length) {
	        tickValues.push(currentTicks[_i].x);
	        _i++;
	      }
	    }
	    return tickValues;
	  };
	
	  Dashboard.prototype.showCheckinTooltip = function showCheckinTooltip(x, y, y0) {
	    var checkinStatisticFromServer = this.state.statisticFromServer.check_in_data_30days_ago;
	    var hoveredData = {};
	    for (var key in checkinStatisticFromServer) {
	      if (x === (0, _moment2.default)(key).format('MM/DD')) {
	        hoveredData = checkinStatisticFromServer[key];
	        break;
	      }
	    }
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'tooltipDate' },
	        __('Date', _locale2.default),
	        ': ',
	        x
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        __('Attending Rate', _locale2.default),
	        ': ',
	        (0, _round2.default)(hoveredData.counted_amount / (hoveredData.counted_amount + hoveredData.absent_amount) * 100, 2),
	        '%'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        __('Absent Rate', _locale2.default),
	        ': ',
	        (0, _round2.default)(hoveredData.absent_amount / (hoveredData.counted_amount + hoveredData.absent_amount) * 100, 2),
	        '%'
	      )
	    );
	  };
	
	  Dashboard.prototype.showRegiTooltip = function showRegiTooltip(x, y, y0) {
	    var regiStatisticFromServer = this.state.statisticFromServer.student_registration_data_30days_ago;
	    var hoveredData = {};
	    for (var key in regiStatisticFromServer) {
	      if (x === (0, _moment2.default)(key).format('MM/DD')) {
	        hoveredData = regiStatisticFromServer[key];
	        break;
	      }
	    }
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'tooltipDate' },
	        __('Date', _locale2.default),
	        ': ',
	        x
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        __('From Reception', _locale2.default),
	        ': ',
	        hoveredData.registered_at_reception
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        __('From Poster', _locale2.default),
	        ': ',
	        hoveredData.registered_from_poster
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        __('From Contact', _locale2.default),
	        ': ',
	        hoveredData.converted_from_contact
	      )
	    );
	  };
	
	  Dashboard.prototype.renderChart = function renderChart(type) {
	    var _this9 = this;
	
	    var _state3 = this.state,
	        checkinStatistic = _state3.checkinStatistic,
	        regiStatistic = _state3.regiStatistic,
	        hasValidCheckinStatistic = _state3.hasValidCheckinStatistic,
	        hasValidRegiStatistic = _state3.hasValidRegiStatistic,
	        chartSize = _state3.chartSize;
	
	    if (type === 'checkin') {
	      return _react2.default.createElement(
	        'div',
	        { className: 'chart-wrapper block-wrapper', ref: function ref(_ref) {
	            return _this9.chartWrapperNode = _ref;
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'description-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'graph-title' },
	            __('Attending and Absent Rate for All Classes', _locale2.default)
	          ),
	          hasValidCheckinStatistic && _react2.default.createElement(
	            'div',
	            { className: 'graph-labels' },
	            _react2.default.createElement(
	              'div',
	              { className: 'graph-label' },
	              _react2.default.createElement('div', { className: 'circle', style: { backgroundColor: CHECKIN_COLORS[0] } }),
	              __('Attending Rate', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'graph-label' },
	              _react2.default.createElement('div', { className: 'circle', style: { backgroundColor: CHECKIN_COLORS[1] } }),
	              __('Absent Rate', _locale2.default)
	            )
	          )
	        ),
	        hasValidCheckinStatistic && _react2.default.createElement(_reactD3Components.BarChart, {
	          data: checkinStatistic,
	          width: chartSize.width || this.chartWrapperNode.clientWidth - CHART_MARGIN.left - CHART_MARGIN.right,
	          height: chartSize.height,
	          margin: CHART_MARGIN,
	          colorByLabel: true,
	          barPadding: 0.2,
	          colorScale: colorScaleCheckin,
	          tooltipHtml: this.showCheckinTooltip,
	          tooltipOffset: { top: 10, left: 10 },
	          xAxis: { tickValues: this.setTickValues('checkin') },
	          yAxis: { tickArguments: [5] }
	        }),
	        !hasValidCheckinStatistic && _react2.default.createElement(_EmptyDataPlaceholder2.default, { title: __('No Checkin Data', _locale2.default), icon: 'icon-clipboard-check' }),
	        this.renderSelect(type)
	      );
	    } else if (type === 'regi') {
	      return _react2.default.createElement(
	        'div',
	        { className: 'chart-wrapper block-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'description-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'graph-title' },
	            __('New Student Registration Data', _locale2.default)
	          ),
	          hasValidRegiStatistic && _react2.default.createElement(
	            'div',
	            { className: 'graph-labels' },
	            _react2.default.createElement(
	              'div',
	              { className: 'graph-label' },
	              _react2.default.createElement('div', { className: 'circle', style: { backgroundColor: REGI_COLORS[0] } }),
	              __('From Reception', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'graph-label' },
	              _react2.default.createElement('div', { className: 'circle', style: { backgroundColor: REGI_COLORS[1] } }),
	              __('From Poster', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'graph-label' },
	              _react2.default.createElement('div', { className: 'circle', style: { backgroundColor: REGI_COLORS[2] } }),
	              __('From Contact', _locale2.default)
	            )
	          )
	        ),
	        hasValidRegiStatistic && _react2.default.createElement(_reactD3Components.BarChart, {
	          data: regiStatistic,
	          width: chartSize.width || this.chartWrapperNode.clientWidth - CHART_MARGIN.left - CHART_MARGIN.right,
	          height: chartSize.height,
	          margin: CHART_MARGIN,
	          barPadding: 0.2,
	          colorByLabel: true,
	          colorScale: colorScaleRegi,
	          tooltipHtml: this.showRegiTooltip,
	          tooltipOffset: { top: 10, left: 10 },
	          xAxis: { tickValues: this.setTickValues('regi') },
	          yAxis: { tickArguments: [5], tickFormat: _d2.default.format('d') }
	        }),
	        !hasValidRegiStatistic && _react2.default.createElement(_EmptyDataPlaceholder2.default, { title: __('No New Registration', _locale2.default), icon: 'icon-perm_contact_calendar' }),
	        this.renderSelect(type)
	      );
	    } else {
	      return null;
	    }
	  };
	
	  Dashboard.prototype.renderLogs = function renderLogs() {
	    var schoolLog = this.props.schoolLog;
	    var result_list = schoolLog.logs.result_list;
	
	    if ((0, _R.userCan)('operation_log_channel')) {
	      if (!schoolLog.fetching && result_list) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'header' },
	            _react2.default.createElement(
	              'span',
	              null,
	              __("Recent Activity Log", _locale2.default)
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/logs/' },
	              __("More", _locale2.default)
	            )
	          ),
	          Object.keys(result_list).length > 0 && _react2.default.createElement(_ActivityLog2.default, { resultList: result_list }),
	          Object.keys(result_list).length === 0 && _react2.default.createElement(_EmptyDataPlaceholder2.default, { title: __('No Activity Log', _locale2.default), icon: 'icon-assignment' })
	        );
	      } else {
	        return null;
	      }
	    } else {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'header' },
	          _react2.default.createElement(
	            'span',
	            null,
	            __("Recent Activity Log", _locale2.default)
	          )
	        ),
	        _react2.default.createElement(_EmptyDataPlaceholder2.default, { title: __('No Permission', _locale2.default), icon: 'icon-assignment' })
	      );
	    }
	  };
	
	  Dashboard.prototype.render = function render() {
	    var lessonInfo = this.state.lessonInfo;
	    var _props = this.props,
	        schoolStatistic = _props.schoolStatistic,
	        schoolLog = _props.schoolLog;
	
	    var pagination = {
	      activePage: this.state.activePage,
	      itemsCountPerPage: AMOUNT_PER_PAGE,
	      totalItemsCount: lessonInfo.total_amount,
	      pageRangeDisplayed: PAGE_RANGE_DISPLAYED
	    };
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      { title: __('Dashboard', _locale2.default) },
	      _react2.default.createElement(
	        'div',
	        { className: 'main-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'left-container' },
	          !schoolStatistic.fetching && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_statisticDisplay2.default, { data: schoolStatistic.statistic }),
	            this.renderChart('checkin'),
	            this.renderChart('regi')
	          ),
	          schoolStatistic.fetching && _react2.default.createElement(_Loading2.default, null)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'right-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'schedule-wrapper block-wrapper', style: { position: lessonInfo && lessonInfo.total_amount > 0 ? 'static' : 'relative' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'header' },
	              __("Today's Lessons", _locale2.default)
	            ),
	            (0, _R.userCan)('timetable_channel') && _react2.default.createElement(_CalendarDailyView2.default, {
	              data: lessonInfo,
	              pagination: pagination,
	              onPageChange: this.onPageChange,
	              placeholderTitle: __('No Lesson Data', _locale2.default)
	            }),
	            !(0, _R.userCan)('timetable_channel') && _react2.default.createElement(_EmptyDataPlaceholder2.default, { title: __('No Permission', _locale2.default), icon: 'icon-chalkboard' })
	          ),
	          !(0, _R.isBasicUser)() && _react2.default.createElement(
	            'div',
	            { className: 'log-wrapper block-wrapper' },
	            this.renderLogs()
	          )
	        )
	      )
	    );
	  };
	
	  return Dashboard;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Dashboard);
	module.exports = exports['default'];

/***/ },

/***/ "OLzW":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToastify = __webpack_require__("/Fjh");
	
	__webpack_require__("u1FZ");
	
	__webpack_require__("rdPs");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotificationToast = function (_Component) {
	  _inherits(NotificationToast, _Component);
	
	  function NotificationToast() {
	    _classCallCheck(this, NotificationToast);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  NotificationToast.prototype.showToast = function showToast(content) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    (0, _reactToastify.toast)(content, options);
	  };
	
	  NotificationToast.prototype.render = function render() {
	    var _props = this.props,
	        autoClose = _props.autoClose,
	        draggable = _props.draggable,
	        position = _props.position;
	
	    return _react2.default.createElement(_reactToastify.ToastContainer, {
	      position: position,
	      autoClose: autoClose,
	      draggable: draggable,
	      className: 'containerStyle',
	      toastClassName: 'toastStyle'
	    });
	  };
	
	  return NotificationToast;
	}(_react.Component);
	
	exports.default = NotificationToast;
	module.exports = exports['default'];

/***/ },

/***/ "rdPs":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"toastStyle":"toastStyle","Toastify__toast-container--top-right":"Toastify__toast-container--top-right"};

/***/ },

/***/ "zYlc":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("chMa");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _StudentInfo = __webpack_require__("R3ni");
	
	var _StudentInfo2 = _interopRequireDefault(_StudentInfo);
	
	var _TeacherInfo = __webpack_require__("fPvc");
	
	var _TeacherInfo2 = _interopRequireDefault(_TeacherInfo);
	
	var _ContactInfo = __webpack_require__("zoTr");
	
	var _ContactInfo2 = _interopRequireDefault(_ContactInfo);
	
	__webpack_require__("slD+");
	
	__webpack_require__("rKyg");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TRANSLATED_FROM_DATA = {
	  'edit': 'edited',
	  'import': 'imported',
	  'create': 'created',
	  'delete': 'deleted',
	  'remove': 'removed',
	  'archive': 'archived',
	  'add': 'added',
	  'accept': 'accepted',
	  'deny': 'denied',
	  'publish': 'published',
	  'unpublish': 'unpublished',
	  'recover': 'recovered',
	  'invite': 'invited',
	  'convert': 'transfered',
	  'teacher': 'teacher',
	  'student': 'student',
	  'class': 'class',
	  'school': 'school',
	  'poster': 'poster',
	  'group': 'permission group',
	  'group_list': 'permission group',
	  'private_class': 'private class',
	  'contact_notes': 'contact notes',
	  'school_setting': 'terms and conditions',
	  'student_custom_fields': 'student custom fields',
	  'contact_custom_fields': 'contact custom fields',
	  'record_charge': 'recorded a charge',
	  'record_refund': 'recorded a refund',
	  'initiate_charge': 'initiated a charge',
	  'initiate_refund': 'initiated a refund',
	  'student_task': 'planning task',
	  'lesson': 'lesson',
	  'lesson_list': 'lessons',
	  'student_list': 'students',
	  'trade_record_note': 'transaction remark with the receipt number',
	  'contact_tag': 'contact tag',
	  'contact': 'contact',
	  'announcement': 'announcement',
	  'classroom': 'classroom',
	  'attendee': 'poster attendee'
	};
	
	var TRANSLATE_CONNECTING_WORD = {
	  'create': 'for',
	  'delete': 'from',
	  'edit': 'in'
	};
	
	var TRANSLATE_CLASS_ARCHIVE = {
	  'archive': 'closed'
	};
	
	var ActivityLog = function (_Component) {
	  _inherits(ActivityLog, _Component);
	
	  function ActivityLog(props) {
	    _classCallCheck(this, ActivityLog);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.onClick = _this.onClick.bind(_this);
	    _this.renderLog = _this.renderLog.bind(_this);
	    return _this;
	  }
	
	  ActivityLog.prototype.onClick = function onClick(opts) {
	    return function () {
	      var type = opts.type,
	          id = opts.id;
	
	      switch (type) {
	        case 'school':
	          _reactRouter.browserHistory.push('/school-information');
	          break;
	        case 'classroom':
	          _reactRouter.browserHistory.push('/classroom');
	          break;
	        case 'announcement':
	          _reactRouter.browserHistory.push('/announcement');
	          break;
	        case 'poster':
	          _reactRouter.browserHistory.push('/poster');
	          break;
	        case 'group':
	        case 'group_list':
	          _reactRouter.browserHistory.push('/school-settings');
	          break;
	        case 'trade_record_note':
	          _reactRouter.browserHistory.push('/finance');
	          break;
	        case 'contact_tag':
	          _reactRouter.browserHistory.push('/contacts');
	          break;
	        case 'class':
	          _reactRouter.browserHistory.push('/class-detail/' + id);
	          break;
	        case 'private_class':
	          _reactRouter.browserHistory.push('/class-one-detail/' + id);
	          break;
	        case 'student':
	        case 'trade_record':
	        case 'student_task':
	        case 'student_list':
	          (0, _StudentInfo2.default)({ id: id });
	          break;
	        case 'contact':
	        case 'contact_notes':
	          (0, _ContactInfo2.default)({ id: id });
	          break;
	        case 'teacher':
	          (0, _TeacherInfo2.default)({ id: id });
	          break;
	        default:
	          _reactRouter.browserHistory.push('/');
	      }
	    };
	  };
	
	  ActivityLog.prototype.renderLog = function renderLog(list) {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      list.map(function (log) {
	        var operator_name = log.operator_name,
	            log_context = log.log_context;
	        var object_type = log_context.object_type,
	            operation = log_context.operation,
	            target_name_list = log_context.target_name_list,
	            object_name = log_context.object_name,
	            object_name_list = log_context.object_name_list,
	            object_id = log_context.object_id,
	            belong_to_name = log_context.belong_to_name,
	            belong_to_id = log_context.belong_to_id,
	            belong_to_type = log_context.belong_to_type,
	            object_id_list = log_context.object_id_list,
	            target_type = log_context.target_type,
	            target_name = log_context.target_name;
	
	
	        switch (true) {
	          case object_type === 'class' && operation === 'add':
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('i', { className: 'icon-users' }),
	                target_name_list.length > 1 ? __('{name} {operation} multiple students to {object_type}: ', _locale2.default, {
	                  name: operator_name === 'Principal' ? __('Principal', _locale2.default) : operator_name,
	                  operation: __(TRANSLATED_FROM_DATA[operation], _locale2.default),
	                  object_type: __(TRANSLATED_FROM_DATA[object_type], _locale2.default)
	                }) : __('{name} {operation} student {studentName} to {object_type}: ', _locale2.default, {
	                  name: operator_name === 'Principal' ? __('Principal', _locale2.default) : operator_name,
	                  operation: __(TRANSLATED_FROM_DATA[operation], _locale2.default),
	                  studentName: target_name_list.join(', '),
	                  object_type: __(TRANSLATED_FROM_DATA[object_type], _locale2.default)
	                }),
	                _react2.default.createElement(
	                  'a',
	                  { onClick: _this2.onClick({ id: object_id, type: object_type }) },
	                  object_name
	                )
	              )
	            );
	            break;
	
	          case (object_type === 'student' || object_type === 'teacher') && operation === 'remove':
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('i', { className: 'icon-book-reader' }),
	                __('{name} {operation} {object_type} {object_name} from {target_type} {target_name}', _locale2.default, {
	                  name: operator_name === 'Principal' ? __('Principal', _locale2.default) : operator_name,
	                  operation: __(TRANSLATED_FROM_DATA[operation], _locale2.default),
	                  object_type: __(TRANSLATED_FROM_DATA[object_type], _locale2.default),
	                  object_name: object_name,
	                  target_type: __(TRANSLATED_FROM_DATA[target_type], _locale2.default),
	                  target_name: target_name
	                })
	              )
	            );
	            break;
	
	          case object_type === 'invitation':
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('i', { className: 'icon-mail-alt' }),
	                __('{name} {operation} {object_type}', _locale2.default, {
	                  name: operator_name === 'Principal' ? __('Principal', _locale2.default) : operator_name,
	                  operation: __(TRANSLATED_FROM_DATA[operation], _locale2.default),
	                  object_type: __(object_type, _locale2.default)
	                })
	              )
	            );
	            break;
	
	          case object_type === 'contact_notes':
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('i', { className: 'icon-perm_contact_calendar' }),
	                __('{name} {operation} {object_type} for ', _locale2.default, {
	                  name: operator_name === 'Principal' ? __('Principal', _locale2.default) : operator_name,
	                  operation: __(TRANSLATED_FROM_DATA[operation], _locale2.default),
	                  object_type: __(TRANSLATED_FROM_DATA[object_type], _locale2.default)
	                }),
	                _react2.default.createElement(
	                  'a',
	                  { onClick: _this2.onClick({ id: belong_to_id, type: object_type }) },
	                  belong_to_name
	                )
	              )
	            );
	            break;
	
	          case object_type === 'school_setting':
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('i', { className: 'icon-cog' }),
	                __('{name} {operation} {object_type}', _locale2.default, {
	                  name: operator_name === 'Principal' ? __('Principal', _locale2.default) : operator_name,
	                  operation: __(TRANSLATED_FROM_DATA[operation], _locale2.default),
	                  object_type: __(TRANSLATED_FROM_DATA[object_name], _locale2.default)
	                })
	              )
	            );
	            break;
	
	          case object_type === 'trade_record':
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                (operation === 'record_charge' || operation === 'record_refund') && _react2.default.createElement('i', { className: 'icon-assignment' }),
	                (operation === 'initiate_charge' || operation === 'initiate_refund') && _react2.default.createElement('i', { className: 'icon-money-bill' }),
	                __('{name} {operation} for {belong_to_type} ', _locale2.default, {
	                  name: operator_name === 'Principal' ? __('Principal', _locale2.default) : operator_name,
	                  operation: __(TRANSLATED_FROM_DATA[operation], _locale2.default),
	                  belong_to_type: __(TRANSLATED_FROM_DATA[belong_to_type], _locale2.default)
	                }),
	                _react2.default.createElement(
	                  'a',
	                  { onClick: _this2.onClick({ id: belong_to_id, type: object_type }) },
	                  belong_to_name
	                )
	              )
	            );
	            break;
	
	          case object_type === 'student_task' || object_type === 'lesson' || object_type === 'lesson_list':
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                object_type === 'student_task' && _react2.default.createElement('i', { className: 'icon-calendar-check-o' }),
	                (object_type === 'lesson' || object_type === 'lesson_list') && _react2.default.createElement('i', { className: 'icon-book' }),
	                object_type === 'lesson_list' && object_name_list.length > 1 ? __('{name} {operation} multple {object_type} {connecting_word} {belong_to_type} ', _locale2.default, {
	                  name: operator_name === 'Principal' ? __('Principal', _locale2.default) : operator_name,
	                  operation: __(TRANSLATED_FROM_DATA[operation], _locale2.default),
	                  object_type: __(TRANSLATED_FROM_DATA[object_type], _locale2.default),
	                  connecting_word: TRANSLATE_CONNECTING_WORD[operation],
	                  belong_to_type: __(TRANSLATED_FROM_DATA[belong_to_type], _locale2.default)
	                }) : __('{name} {operation} {object_type} {object_name} {connecting_word} {belong_to_type} ', _locale2.default, {
	                  name: operator_name === 'Principal' ? __('Principal', _locale2.default) : operator_name,
	                  operation: __(TRANSLATED_FROM_DATA[operation], _locale2.default),
	                  object_type: object_type === 'student_task' ? __(TRANSLATED_FROM_DATA[object_type], _locale2.default) : '',
	                  object_name: object_type === 'student_task' ? object_name : __('lesson', _locale2.default) + object_name_list,
	                  connecting_word: TRANSLATE_CONNECTING_WORD[operation],
	                  belong_to_type: __(TRANSLATED_FROM_DATA[belong_to_type], _locale2.default)
	                }),
	                _react2.default.createElement(
	                  'a',
	                  { onClick: _this2.onClick({ id: belong_to_id, type: belong_to_type }) },
	                  belong_to_name
	                )
	              )
	            );
	            break;
	
	          case (object_type === 'student' || object_type === 'teacher') && operation === 'archive':
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                object_type === 'student' && _react2.default.createElement('i', { className: 'icon-book-reader' }),
	                object_type === 'teacher' && _react2.default.createElement('i', { className: 'icon-chalkboard-teacher' }),
	                __('{object_name} {operation} {object_type} ', _locale2.default, {
	                  object_name: operator_name === 'Principal' ? __('Principal', _locale2.default) : operator_name,
	                  operation: __(TRANSLATED_FROM_DATA[operation], _locale2.default),
	                  object_type: __(TRANSLATED_FROM_DATA[object_type], _locale2.default)
	                }),
	                _react2.default.createElement(
	                  'a',
	                  { onClick: _this2.onClick({ id: object_id, type: object_type }) },
	                  object_name
	                )
	              )
	            );
	            break;
	
	          case (object_type === 'class' || object_type === 'private_class') && operation === 'archive':
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                object_type === 'class' && _react2.default.createElement('i', { className: 'icon-users' }),
	                object_type === 'private_class' && _react2.default.createElement('i', { className: 'icon-user-friends' }),
	                __('{object_name} {operation} {object_type} ', _locale2.default, {
	                  object_name: operator_name === 'Principal' ? __('Principal', _locale2.default) : operator_name,
	                  operation: __(TRANSLATE_CLASS_ARCHIVE[operation], _locale2.default),
	                  object_type: __(TRANSLATED_FROM_DATA[object_type], _locale2.default)
	                }),
	                _react2.default.createElement(
	                  'a',
	                  { onClick: _this2.onClick({ id: object_id, type: object_type }) },
	                  object_name
	                )
	              )
	            );
	            break;
	
	          case object_type === 'student' && operation === 'import':
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('i', { className: 'icon-book-reader' }),
	                __('{name} {operation} multiple {object_type} ', _locale2.default, {
	                  name: operator_name === 'Principal' ? __('Principal', _locale2.default) : operator_name,
	                  operation: __(TRANSLATED_FROM_DATA[operation], _locale2.default),
	                  object_type: __(TRANSLATED_FROM_DATA[object_type], _locale2.default)
	                })
	              )
	            );
	            break;
	
	          case object_type === 'class' || object_type === 'private_class' || object_type === 'student' || object_type === 'teacher' || object_type === 'classroom' || object_type === 'announcement' || object_type === 'contact' || object_type === 'contact_tag' || object_type === 'trade_record_note' || object_type === 'group' || object_type === 'poster' || object_type === 'school' || object_type === 'attendee':
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                object_type === 'student' && _react2.default.createElement('i', { className: 'icon-book-reader' }),
	                object_type === 'teacher' && _react2.default.createElement('i', { className: 'icon-chalkboard-teacher' }),
	                object_type === 'announcement' && _react2.default.createElement('i', { className: 'icon-megaphone' }),
	                (object_type === 'contact' || object_type === 'contact_tag' || object_type === 'attendee') && _react2.default.createElement('i', { className: 'icon-perm_contact_calendar' }),
	                object_type === 'group' && _react2.default.createElement('i', { className: 'icon-cog' }),
	                object_type === 'poster' && _react2.default.createElement('i', { className: 'icon-link-ext-alt' }),
	                object_type === 'school' && _react2.default.createElement('i', { className: 'icon-account_balance' }),
	                object_type === 'classroom' && _react2.default.createElement('i', { className: 'icon-chalkboard' }),
	                object_type === 'class' && _react2.default.createElement('i', { className: 'icon-users' }),
	                object_type === 'private_class' && _react2.default.createElement('i', { className: 'icon-user-friends' }),
	                object_type === 'trade_record_note' && _react2.default.createElement('i', { className: 'icon-assignment' }),
	                __('{name} {operation} {object_type} ', _locale2.default, {
	                  name: operator_name === 'Principal' ? __('Principal', _locale2.default) : operator_name,
	                  operation: __(TRANSLATED_FROM_DATA[operation], _locale2.default),
	                  object_type: __(TRANSLATED_FROM_DATA[object_type], _locale2.default)
	                }),
	                operation !== 'convert' && operation !== 'delete' && _react2.default.createElement(
	                  'a',
	                  { onClick: _this2.onClick({ id: object_id, type: object_type }) },
	                  object_name
	                ),
	                (operation === 'convert' || operation === 'delete') && _react2.default.createElement(
	                  'span',
	                  null,
	                  object_name
	                )
	              )
	            );
	            break;
	
	          case object_type === 'group_list':
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('i', { className: 'icon-cog' }),
	                __('{name} {operation} {object_type} ', _locale2.default, {
	                  name: operator_name === 'Principal' ? __('Principal', _locale2.default) : operator_name,
	                  operation: __(TRANSLATED_FROM_DATA[operation], _locale2.default),
	                  object_type: __(TRANSLATED_FROM_DATA[object_type], _locale2.default)
	                }),
	                _react2.default.createElement(
	                  'a',
	                  { onClick: _this2.onClick({ id: object_id_list, type: object_type }) },
	                  object_name_list
	                ),
	                __("'s member", _locale2.default)
	              )
	            );
	            break;
	
	          case object_type === 'student_list' && operation === 'archive':
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('i', { className: 'icon-book-reader' }),
	                object_name_list.length > 1 ? __('{object_name} {operation} multiple {object_type}', _locale2.default, {
	                  object_name: operator_name === 'Principal' ? __('Principal', _locale2.default) : operator_name,
	                  operation: __(TRANSLATED_FROM_DATA[operation], _locale2.default),
	                  object_type: __(TRANSLATED_FROM_DATA[object_type], _locale2.default)
	                }) : __('{object_name} {operation} {object_type} ', _locale2.default, {
	                  object_name: operator_name === 'Principal' ? __('Principal', _locale2.default) : operator_name,
	                  operation: __(TRANSLATED_FROM_DATA[operation], _locale2.default),
	                  object_type: __(TRANSLATED_FROM_DATA[object_type], _locale2.default)
	                }),
	                object_name_list.length === 1 && _react2.default.createElement(
	                  'a',
	                  { onClick: _this2.onClick({ id: object_id_list, type: object_type }) },
	                  object_name_list
	                )
	              )
	            );
	            break;
	
	          case object_type === 'student_list':
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('i', { className: 'icon-book-reader' }),
	                object_name_list.length > 1 ? __('{name} {operation} multiple {object_type} ', _locale2.default, {
	                  name: operator_name === 'Principal' ? __('Principal', _locale2.default) : operator_name,
	                  operation: __(TRANSLATED_FROM_DATA[operation], _locale2.default),
	                  object_type: __(TRANSLATED_FROM_DATA[object_type], _locale2.default)
	                }) : __('{name} {operation} {object_type} ', _locale2.default, {
	                  name: operator_name === 'Principal' ? __('Principal', _locale2.default) : operator_name,
	                  operation: __(TRANSLATED_FROM_DATA[operation], _locale2.default),
	                  object_type: __(TRANSLATED_FROM_DATA[object_type], _locale2.default)
	                }),
	                object_name_list.length === 1 && _react2.default.createElement(
	                  'a',
	                  { onClick: _this2.onClick({ id: object_id_list, type: object_type }) },
	                  object_name_list
	                )
	              )
	            );
	            break;
	
	          default:
	            return _react2.default.createElement(
	              'div',
	              { style: { color: 'red' } },
	              'ERROR!!!'
	            );
	        }
	      })
	    );
	  };
	
	  ActivityLog.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        resultList = _props.resultList,
	        _props$hideTime = _props.hideTime,
	        hideTime = _props$hideTime === undefined ? false : _props$hideTime;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'activityLogContainer' },
	      Object.keys(resultList).map(function (date) {
	
	        var newLog = resultList[date];
	        return _react2.default.createElement(
	          'div',
	          { key: date, className: 'log-date-section' },
	          !hideTime && _react2.default.createElement(
	            'h3',
	            null,
	            date
	          ),
	          Object.keys(newLog).map(function (time) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'log-min-section' },
	              !hideTime && _react2.default.createElement(
	                'span',
	                null,
	                time
	              ),
	              _this3.renderLog(newLog[time])
	            );
	          })
	        );
	      })
	    );
	  };
	
	  return ActivityLog;
	}(_react.Component);
	
	exports.default = ActivityLog;
	module.exports = exports['default'];

/***/ },

/***/ "chMa":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'ActivityLog',
	  code: 'CN',
	  text: {
	    'Principal': '校长',
	
	    // operation
	    'created': '创建了',
	    'edited': '编辑了',
	    'deleted': '删除了',
	    'closed': '关闭了',
	    'added': '加入了',
	    'accepted': '接受了',
	    'denied': '拒绝了',
	    'published': '发布了',
	    'unpublished': '下架了',
	    'recovered': '恢复了',
	    'invited': '邀请了',
	    'transfered': '转化了',
	    'removed': '退班了',
	    'archived': '转移了',
	    'imported': '导入了',
	    // object_type
	    'teacher': '老师',
	    'student': '学生',
	    'class': '班级',
	    'private class': '私课',
	    'contact notes': '联系人备忘',
	    'invitation': '学校邀请',
	    'student custom fields': '学员自定义字段',
	    'contact custom fields': '联系人自定义字段',
	    'terms and conditions': '注册条款',
	    'recorded a charge': '记录了一笔学生收款',
	    'recorded a refund': '记录了一笔学生退款',
	    'initiated a charge': '发起了一笔学生收款',
	    'initiated a refund': '发起了一笔学生退款',
	    'planning task': '时间规划事项',
	    'lesson': '课节',
	    'lessons': '课节',
	    'school': '学校',
	    'poster': '海报',
	    'permissions': '权限',
	    'permission group': '权限组',
	    'transaction remark with the receipt number': '交易备注 收据号',
	    'contact tag': '联系人标签',
	    'contact': '联系人',
	    'announcement': '公告',
	    'classroom': '教室',
	    'students': '学生',
	    'poster attendee': '海报报名人',
	    '{name} {operation} {object_type} ': '{name}{operation}{object_type}：',
	    '{name} {operation} student {studentName} to {object_type}: ': '{name}将学生{studentName}{operation}{object_type}：',
	    '{name} {operation} multiple students to {object_type}: ': '{name}将多个学生{operation}{object_type}：',
	
	    '{name} {operation} {object_type} for ': '{name}{operation}一个{object_type}，联系人',
	    '{name} {operation} {object_type}': '{name}{operation}{object_type}',
	
	    '{name} {operation} for {belong_to_type} ': '{name}{operation}：{belong_to_type}',
	
	    '{name} {operation} {object_type} {object_name} {connecting_word} {belong_to_type} ': '{name}{operation}{object_type} {object_name} 给{belong_to_type}：',
	    '{name} {operation} multple {object_type} {connecting_word} {belong_to_type} ': '{name}{operation}多个{object_type}给{belong_to_type}：',
	
	    "'s member": '的成员',
	
	    '{name} {operation} multiple {object_type} ': '{name}{operation}多个{object_type}',
	    '{name} {operation} {object_type} {object_name} from {target_type} {target_name}': '{name}将{object_type}{object_name}从{target_type}{target_name}里{operation}',
	
	    // specifictly for operation archive, can't think of a better way to do it 
	    '{object_name} {operation} {object_type} ': '{object_name}{operation}{object_type}到历史{object_type}：',
	    '{object_name} {operation} multiple {object_type}': '{object_name}{operation}多个{object_type}到历史{object_type}'
	
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "fPvc":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	
	  if (opts.teacher && opts.teacher instanceof _Teacher2.default !== true) {
	    return modal(_extends({}, opts, {
	      teacherData: new _Teacher2.default(opts.teacher)
	    }));
	  }
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _Teacher = __webpack_require__("xSer");
	
	var _Teacher2 = _interopRequireDefault(_Teacher);
	
	var _DockProvider = __webpack_require__("JVAR");
	
	var _DockProvider2 = _interopRequireDefault(_DockProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_DockProvider2.default);
	
	// if only is given, the dock will load studentData from backend
	module.exports = exports['default'];

/***/ },

/***/ "JVAR":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DockBody = __webpack_require__("LE7b");
	
	var _DockBody2 = _interopRequireDefault(_DockBody);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DockProvider = function (_React$Component) {
	  _inherits(DockProvider, _React$Component);
	
	  function DockProvider(props) {
	    _classCallCheck(this, DockProvider);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  DockProvider.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(_DockBody2.default, this.props)
	    );
	  };
	
	  return DockProvider;
	}(_react2.default.Component);
	
	exports.default = DockProvider;
	module.exports = exports['default'];

/***/ },

/***/ "LE7b":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _Transition = __webpack_require__("X/qO");
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _lodash = __webpack_require__("M4fF");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Attendance = __webpack_require__("gjj1");
	
	var _Attendance2 = _interopRequireDefault(_Attendance);
	
	var _VerticalInfoGrid = __webpack_require__("VUlR");
	
	var _VerticalInfoGrid2 = _interopRequireDefault(_VerticalInfoGrid);
	
	var _CourseRecord = __webpack_require__("YLWT");
	
	var _CourseRecord2 = _interopRequireDefault(_CourseRecord);
	
	var _clockTimeTable = __webpack_require__("+7r6");
	
	var _clockTimeTable2 = _interopRequireDefault(_clockTimeTable);
	
	var _TeacherHeader = __webpack_require__("+Yme");
	
	var _TeacherHeader2 = _interopRequireDefault(_TeacherHeader);
	
	var _Teacher = __webpack_require__("xSer");
	
	var _Teacher2 = _interopRequireDefault(_Teacher);
	
	var _locale = __webpack_require__("orly");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _CreateTeacher = __webpack_require__("dZ0O");
	
	var _CreateTeacher2 = _interopRequireDefault(_CreateTeacher);
	
	var _fetchTeacherInfo2 = __webpack_require__("2xNr");
	
	__webpack_require__("HSGh");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <DockBody />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var GENDERS = [__('Male', _locale2.default), __('Female', _locale2.default), __('Others', _locale2.default), __('N/A', _locale2.default)];
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    teacherInfo: state.teacherInfo
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchTeacherInfo: function fetchTeacherInfo(teacherId, state, callback) {
	      return dispatch((0, _fetchTeacherInfo2.fetchTeacherInfo)(teacherId, state, callback));
	    }
	  };
	};
	
	var DockBody = function (_React$Component) {
	  _inherits(DockBody, _React$Component);
	
	  function DockBody(props) {
	    _classCallCheck(this, DockBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      selectedIndex: 0,
	      teacher: props.teacherData,
	      fields: [],
	      fetching: false
	    };
	
	    _this.onSelectTab = _this.onSelectTab.bind(_this);
	    _this.onClickEdit = _this.onClickEdit.bind(_this);
	    return _this;
	  }
	
	  DockBody.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var id = this.props.id;
	
	    this.props.fetchTeacherInfo(id, 'all', function () {
	      var newTeacher = new _Teacher2.default(_extends({}, _this2.props.teacherInfo));
	      _this2.setState({
	        fetching: false,
	        teacher: newTeacher
	      });
	    });
	  };
	
	  DockBody.prototype.onSelectTab = function onSelectTab(selectedIndex) {
	    this.setState({ selectedIndex: selectedIndex });
	  };
	
	  DockBody.prototype.onClickEdit = function onClickEdit() {
	    var _this3 = this;
	
	    var teacher = this.state.teacher;
	
	    var convertedTeacher = teacher.toFormData('v1');
	    (0, _CreateTeacher2.default)({ mode: 'update', data: convertedTeacher, teacherId: teacher.id }).then(function (res) {
	      _this3.props.fetchTeacherInfo(_this3.props.id, 'all', function () {
	        var newTeacher = new _Teacher2.default(_extends({}, _this3.props.teacherInfo));
	        _this3.setState({
	          fetching: false,
	          teacher: newTeacher
	        });
	      });
	    }).catch(function () {});
	  };
	
	  DockBody.prototype.render = function render() {
	    var _props = this.props,
	        isVisible = _props.isVisible,
	        show = _props.show,
	        dismiss = _props.dismiss,
	        mode = _props.mode,
	        id = _props.id,
	        name = _props.name;
	    var _state = this.state,
	        fetching = _state.fetching,
	        fields = _state.fields,
	        selectedIndex = _state.selectedIndex;
	
	
	    var teacher = this.state.teacher || {};
	
	    var basicInfo = [];
	
	    if (teacher) {
	      basicInfo = [{ label: __('Name', _locale2.default), value: teacher.name }, { label: __('Gender', _locale2.default), value: __(GENDERS[teacher.gender], _locale2.default) }, { label: __('Phone', _locale2.default), value: teacher.phone }, { label: __('Email', _locale2.default), value: teacher.email }];
	    }
	
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(
	        _UI.Dock,
	        {
	          dockStyle: { minWidth: 760, maxWidth: 880 },
	          className: 'teacherInfoDock',
	          position: 'right',
	          isVisible: show,
	          size: 0.62,
	          overlayOpacity: 0.2,
	          onCloseDockClick: function onCloseDockClick() {
	            dismiss();
	          },
	          useClosingTag: true,
	          dockTitle: _react2.default.createElement(_TeacherHeader2.default, { teacher: teacher, onClickEdit: this.onClickEdit }),
	          useDefaultCloseButton: false
	        },
	        _react2.default.createElement(
	          _Transition2.default,
	          null,
	          _react2.default.createElement(
	            _UI.Tabs,
	            { defaultIndex: selectedIndex, onSelect: this.onSelectTab },
	            _react2.default.createElement(
	              _UI.TabList,
	              null,
	              _react2.default.createElement(
	                _UI.Tab,
	                null,
	                __("Info", _locale2.default)
	              ),
	              _react2.default.createElement(
	                _UI.Tab,
	                { title: 'You do not have permission.', disabled: !(0, _R.userCan)('read_student_class') },
	                __("Courses", _locale2.default)
	              ),
	              _react2.default.createElement(
	                _UI.Tab,
	                { title: 'You do not have permission.', disabled: !(0, _R.userCan)('read_teacher_check_in_record') },
	                __('Attendance', _locale2.default)
	              ),
	              _react2.default.createElement(
	                _UI.Tab,
	                null,
	                __('Clock Card', _locale2.default)
	              )
	            ),
	            _react2.default.createElement(
	              _UI.TabPanel,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'studentDetail' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  __('Basic Info', _locale2.default)
	                ),
	                _react2.default.createElement(_VerticalInfoGrid2.default, { data: basicInfo })
	              )
	            ),
	            _react2.default.createElement(
	              _UI.TabPanel,
	              null,
	              _react2.default.createElement(_CourseRecord2.default, { teacherId: teacher.id, teacherInfo: teacher })
	            ),
	            _react2.default.createElement(
	              _UI.TabPanel,
	              null,
	              _react2.default.createElement(_Attendance2.default, { state: 'teacher', teacherId: teacher.id, teacherInfo: teacher })
	            ),
	            _react2.default.createElement(
	              _UI.TabPanel,
	              null,
	              _react2.default.createElement(_clockTimeTable2.default, { teacherId: teacher.id, teacherInfo: teacher })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return DockBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactConfirm.confirmable)(DockBody));
	module.exports = exports['default'];

/***/ },

/***/ "YLWT":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("orly");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _currentClassTable = __webpack_require__("Zw8u");
	
	var _currentClassTable2 = _interopRequireDefault(_currentClassTable);
	
	var _pastClassTable = __webpack_require__("kRVU");
	
	var _pastClassTable2 = _interopRequireDefault(_pastClassTable);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _fetchTeacherInfo2 = __webpack_require__("2xNr");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    teacherInfo: state.teacherInfo
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchTeacherInfo: function fetchTeacherInfo(teacherId, state, callback) {
	      return dispatch((0, _fetchTeacherInfo2.fetchTeacherInfo)(teacherId, state, callback));
	    }
	  };
	};
	
	var CourseRecord = function (_Component) {
	  _inherits(CourseRecord, _Component);
	
	  function CourseRecord(props) {
	    _classCallCheck(this, CourseRecord);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      showCurrentTable: true,
	      showPastTable: false,
	      currentClassList: [],
	      pastClassList: []
	    };
	
	    _this.fetchTeacherInfofromTable = _this.fetchTeacherInfofromTable.bind(_this);
	    return _this;
	  }
	
	  CourseRecord.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var teacherId = this.props.teacherId;
	
	
	    this.props.fetchTeacherInfo(teacherId, 'current_class', function () {
	      _this2.setState({ currentClassList: _this2.props.teacherInfo.class_list });
	    });
	
	    this.props.fetchTeacherInfo(teacherId, 'past_class', function () {
	      _this2.setState({ pastClassList: _this2.props.teacherInfo.class_list });
	    });
	  };
	
	  CourseRecord.prototype.fetchTeacherInfofromTable = function fetchTeacherInfofromTable(classState) {
	    var _this3 = this;
	
	    var teacherId = this.props.teacherId;
	
	
	    if (classState == 'current_class') {
	      this.props.fetchTeacherInfo(teacherId, 'current_class', function () {
	        _this3.setState({ currentClassList: _this3.props.teacherInfo.class_list });
	      });
	    } else if (classState == 'past_class') {
	      this.props.fetchTeacherInfo(teacherId, 'past_class', function () {
	        _this3.setState({ currentClassList: _this3.props.teacherInfo.class_list });
	      });
	    }
	  };
	
	  CourseRecord.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props = this.props,
	        teacherId = _props.teacherId,
	        studentInfo = _props.studentInfo;
	    var _state = this.state,
	        showCurrentTable = _state.showCurrentTable,
	        showPastTable = _state.showPastTable,
	        currentClassList = _state.currentClassList,
	        pastClassList = _state.pastClassList;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'studentCourseRecord' },
	      _react2.default.createElement(
	        'div',
	        { className: 'currrentClass' },
	        _react2.default.createElement(
	          'div',
	          { className: 'currentClassHeader' },
	          showCurrentTable && _react2.default.createElement('i', { className: 'fa icon-angle-down', onClick: function onClick() {
	              _this4.setState({ showCurrentTable: false });
	            } }),
	          showCurrentTable === false && _react2.default.createElement('i', { className: 'fa icon-angle-right', onClick: function onClick() {
	              _this4.setState({ showCurrentTable: true });
	            } }),
	          _react2.default.createElement(
	            'span',
	            null,
	            __('Current Class', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'badge' },
	            currentClassList.length
	          )
	        ),
	        _react2.default.createElement(_currentClassTable2.default, { showTable: showCurrentTable, teacherId: teacherId, classList: currentClassList, fetchTeacherInfo: this.fetchTeacherInfofromTable })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'pastClass' },
	        _react2.default.createElement(
	          'div',
	          { className: 'pastClassHeader' },
	          showPastTable && _react2.default.createElement('i', { className: 'fa icon-angle-down', onClick: function onClick() {
	              _this4.setState({ showPastTable: false });
	            } }),
	          showPastTable === false && _react2.default.createElement('i', { className: 'fa icon-angle-right', onClick: function onClick() {
	              _this4.setState({ showPastTable: true });
	            } }),
	          _react2.default.createElement(
	            'span',
	            null,
	            __('Past Class', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'badge' },
	            pastClassList.length
	          )
	        ),
	        _react2.default.createElement(_pastClassTable2.default, { showTable: showPastTable, teacherId: teacherId, classList: pastClassList, fetchTeacherInfo: this.fetchTeacherInfofromTable })
	      )
	    );
	  };
	
	  return CourseRecord;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CourseRecord);
	module.exports = exports['default'];

/***/ },

/***/ "orly":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'TeacherDockInfo',
	  code: 'CN',
	  text: {
	    'Info': '老师档案',
	    'Courses': '课程记录',
	    'Attendance': '签到记录',
	    'Clock Card': '打卡记录',
	
	    'Name': '姓名',
	    'Gender': '性别',
	    'Phone': '联系电话',
	    'Email': '联系邮箱',
	
	    'Current Class': '当期班级',
	    'Past Class': '结业班级',
	    'Class': '班级',
	    'Exit Class': '退班',
	
	    'Proceed to exit teacher from class?': '确认将老师退班？',
	
	    'Basic Info': '基本信息',
	    'Edit': '编辑',
	    'Delete': '删除',
	    'Teacher Description': '老师简介',
	
	    'Clock In/Out': '打卡',
	    'Proceed to delete this record?': '确认删除此纪录？',
	    'Date': '日期',
	    'Time': '时间',
	    'Clock In/Clock Out': '上班/下班',
	    'Operator': '操作者',
	    'Clock In': '上班',
	    'Clock Out': '下班',
	    'Principal': '校长',
	    'Calculate Salary': '计算工资',
	    'Work Start Time': '工作开始时间',
	    'Work End Time': '工作结束时间',
	    'Working Days': '工作日期',
	    'Work End Time must be later than Work Start Time': '工作结束时间必须晚于工作开始时间',
	    'Monday': '星期一',
	    'Tuesday': '星期二',
	    'Wednesday': '星期三',
	    'Thursday': '星期四',
	    'Friday': '星期五',
	    'Saturaday': '星期六',
	    'Sunday': '星期日',
	    'Total Salary': '总工资',
	    'Get Statistic': '获取统计',
	    'Total Work Duration': '总工作时间',
	    'Abnormal Amount': '打卡异常数',
	    'Absent Amount': '缺勤数',
	    'Absent Duration': '缺勤时间',
	    'Late Amount': '迟到数',
	    'Late Duration': '迟到时间',
	    'Leave Early Amount': '早退数',
	    'Leave Early Duration': '早退时间',
	    'times': '次',
	    'h': '小时',
	    'Male': '男',
	    'Female': '女',
	    'Others': '其他',
	    'N/A': '未提供'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "Zw8u":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _updateClassTeacher = __webpack_require__("oN1n");
	
	var _updateClassTeacher2 = _interopRequireDefault(_updateClassTeacher);
	
	var _locale = __webpack_require__("orly");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	var currentClassTable = function (_Component) {
	  _inherits(currentClassTable, _Component);
	
	  function currentClassTable(props) {
	    _classCallCheck(this, currentClassTable);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      fetching: false
	    };
	    return _this;
	  }
	
	  currentClassTable.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        showTable = _props.showTable,
	        teacherId = _props.teacherId,
	        classList = _props.classList;
	
	
	    var fields = [{
	      name: 'ctClass__cName',
	      title: __('Class', _locale2.default)
	    }];
	
	    var settings = [{
	      title: __('Exit Class', _locale2.default),
	      onClick: function onClick(_ref) {
	        var teacher = _ref.trData;
	
	        (0, _confirm.confirm)(__('Proceed to exit teacher from class?', _locale2.default)).then(function () {
	          (0, _updateClassTeacher2.default)(teacher.ctClass, teacherId, { state: 'archive' }).then(function (res) {
	            _this2.props.fetchTeacherInfo('current_class');
	          }).catch(function (err) {});
	        }).catch(function () {});
	      },
	      isDisabled: function isDisabled(_ref2) {
	        var teacher = _ref2.trData;
	
	        return !(0, _R.userCan)('archive_teacher_from_class');
	      }
	    }];
	
	    if (showTable) {
	      return _react2.default.createElement(_UI.Table, {
	        data: classList,
	        fields: fields,
	        className: 'currentClassTable',
	        settingThTitle: ' ',
	        settingWidth: '15%',
	        settings: settings,
	        useMultiSelection: false,
	        oneSettingPerRow: false,
	        usePagination: false,
	        hideDropdownCaret: true,
	        fetching: this.state.fetching,
	        dropdownGuideWidth: 160,
	        dropdownGuideHeight: 228
	      });
	    } else {
	      return _react2.default.createElement('div', null);
	    }
	  };
	
	  return currentClassTable;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(currentClassTable);
	module.exports = exports['default'];

/***/ },

/***/ "kRVU":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("orly");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _UI = __webpack_require__("OM1Z");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pastClassTable = function (_Component) {
	  _inherits(pastClassTable, _Component);
	
	  function pastClassTable(props) {
	    _classCallCheck(this, pastClassTable);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      classList: [],
	      fetching: false
	    };
	    return _this;
	  }
	
	  pastClassTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var classList = _ref.classList;
	
	    if (classList) {
	      this.setState({ classList: classList, fetching: false });
	    }
	  };
	
	  pastClassTable.prototype.render = function render() {
	    var _props = this.props,
	        showTable = _props.showTable,
	        classList = _props.classList;
	
	
	    var fields = [{
	      name: 'ctClass__cName',
	      title: __('Class', _locale2.default),
	      getTdProps: function getTdProps(_ref2) {
	        var tbodyData = _ref2.tbodyData;
	
	        return {
	          style: {
	            width: "35%"
	          }
	        };
	      }
	    }];
	
	    if (classList.length == 0) {
	      return _react2.default.createElement('div', null);
	    }
	
	    if (showTable) {
	      return _react2.default.createElement(_UI.Table, {
	        data: classList,
	        fields: fields,
	        className: 'pastClassTable',
	        settingThTitle: ' ',
	        settingWidth: '15%',
	        settings: '',
	        useMultiSelection: false,
	        oneSettingPerRow: false,
	        fetching: this.state.fetching,
	        hideDropdownCaret: true,
	        usePagination: false,
	
	        dropdownGuideWidth: 160,
	        dropdownGuideHeight: 228
	      });
	    } else {
	      return _react2.default.createElement('div', null);
	    }
	  };
	
	  return pastClassTable;
	}(_react.Component);
	
	exports.default = pastClassTable;
	module.exports = exports['default'];

/***/ },

/***/ "+7r6":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _ClockInOut = __webpack_require__("TFFZ");
	
	var _ClockInOut2 = _interopRequireDefault(_ClockInOut);
	
	var _FilterBy = __webpack_require__("SdD8");
	
	var _FilterBy2 = _interopRequireDefault(_FilterBy);
	
	var _getClockTime = __webpack_require__("Q545");
	
	var _getClockTime2 = _interopRequireDefault(_getClockTime);
	
	var _deleteClockTime = __webpack_require__("aUnq");
	
	var _deleteClockTime2 = _interopRequireDefault(_deleteClockTime);
	
	var _clockCardStatistic = __webpack_require__("wG99");
	
	var _clockCardStatistic2 = _interopRequireDefault(_clockCardStatistic);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _locale = __webpack_require__("orly");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	var ITEMSCOUNTPERPAGE = 100;
	
	var clockTimeTable = function (_Component) {
	  _inherits(clockTimeTable, _Component);
	
	  function clockTimeTable(props) {
	    _classCallCheck(this, clockTimeTable);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      fetching: false,
	      clockTimeList: [],
	      startDate: (0, _moment2.default)().subtract(30, 'days').format('YYYY-MM-DD'),
	      endDate: null,
	      data: null,
	      page: 1,
	      count: 0,
	      filterData: {
	        daterange: {}
	      },
	      filterTypes: ['daterange'],
	      showClockCardStatistic: false
	    };
	
	    _this.openClockInOutModal = _this.openClockInOutModal.bind(_this);
	    _this.onFilterChange = _this.onFilterChange.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.showClockCardStatistic = _this.showClockCardStatistic.bind(_this);
	    return _this;
	  }
	
	  clockTimeTable.prototype.componentDidMount = function componentDidMount() {
	    this.fetchClockTime();
	  };
	
	  clockTimeTable.prototype.fetchClockTime = function fetchClockTime() {
	    var _this2 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _state = this.state,
	        startDate = _state.startDate,
	        endDate = _state.endDate,
	        page = _state.page;
	    var teacherId = this.props.teacherId;
	
	
	    (0, _getClockTime2.default)(schoolId, {
	      page: page,
	      start_date: startDate,
	      end_date: endDate,
	      teacher: teacherId
	    }).then(function (res) {
	      _this2.setState({ clockTimeList: res.results, count: res.count });
	    }).catch(function (err) {});
	  };
	
	  clockTimeTable.prototype.openClockInOutModal = function openClockInOutModal() {
	    var _this3 = this;
	
	    var teacherId = this.props.teacherId;
	
	    var dataToModal = this.state.data === null ? { teacher: teacherId } : this.state.data;
	    var MODE = this.state.data === null ? 'create' : 'update';
	
	    (0, _ClockInOut2.default)({ data: dataToModal, mode: MODE }).then(function (res) {
	      if (res.result === 'success') {
	        _this3.fetchClockTime();
	      }
	      _this3.setState({ data: null });
	    }).catch(function (err) {
	      _this3.setState({ data: null });
	    });
	  };
	
	  clockTimeTable.prototype.showClockCardStatistic = function showClockCardStatistic() {
	    this.setState(function (state) {
	      return { showClockCardStatistic: !state.showClockCardStatistic };
	    });
	  };
	
	  clockTimeTable.prototype.onFilterChange = function onFilterChange(change) {
	    var _this4 = this;
	
	    var filterData = change.filterData;
	
	
	    var startDate = void 0;
	    var endDate = void 0;
	
	    if (filterData.daterange.startDate && !filterData.daterange.endDate || !filterData.daterange.startDate && filterData.daterange.endDate) {
	      return;
	    }
	
	    if (filterData.daterange) {
	      if (filterData.daterange.endDate && filterData.daterange.startDate) {
	        startDate = (0, _moment2.default)(filterData.daterange.startDate).format('YYYY-MM-DD');
	        endDate = (0, _moment2.default)(filterData.daterange.endDate).format('YYYY-MM-DD');
	      } else if (filterData.daterange.endDate === null && filterData.daterange.startDate === null) {
	        startDate = (0, _moment2.default)().subtract(30, 'days').format('YYYY-MM-DD');
	        endDate = null;
	      }
	    }
	
	    this.setState({
	      filterData: filterData,
	      startDate: startDate,
	      endDate: endDate
	    }, function () {
	      _this4.fetchClockTime();
	    });
	  };
	
	  clockTimeTable.prototype.onPageChange = function onPageChange(activePage) {
	    var _this5 = this;
	
	    this.setState({ page: activePage }, function () {
	      _this5.fetchClockTime();
	    });
	  };
	
	  clockTimeTable.prototype.render = function render() {
	    var _this6 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _state2 = this.state,
	        filterData = _state2.filterData,
	        startDate = _state2.startDate,
	        endDate = _state2.endDate,
	        count = _state2.count,
	        page = _state2.page,
	        showClockCardStatistic = _state2.showClockCardStatistic;
	    var _props = this.props,
	        teacherId = _props.teacherId,
	        teacherInfo = _props.teacherInfo;
	
	    var daterangeOptions = {
	      startDate: filterData.daterange.startDate || (0, _moment2.default)(startDate),
	      endDatePlaceholderText: __('Today', 'teacherAttendance')
	    };
	    var pagination = { totalItemsCount: count, activePage: page, itemsCountPerPage: ITEMSCOUNTPERPAGE, showItemCount: false };
	
	    var fields = [{
	      name: 'date',
	      title: __('Date', _locale2.default),
	      getTdContent: function getTdContent(_ref) {
	        var data = _ref.trData;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          (0, _moment2.default)(data.punched_at).format('YYYY-MM-DD')
	        );
	      }
	    }, {
	      name: 'time',
	      title: __('Time', _locale2.default),
	      getTdContent: function getTdContent(_ref2) {
	        var data = _ref2.trData;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          (0, _moment2.default)(data.punched_at).format('hh:mm a')
	        );
	      }
	    }, {
	      name: 'operation_type',
	      title: __('Clock In/Clock Out', _locale2.default),
	      getTdContent: function getTdContent(_ref3) {
	        var data = _ref3.trData;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          data.operation_type === 1 ? __('Clock In', _locale2.default) : __('Clock Out', _locale2.default)
	        );
	      }
	    }, {
	      name: 'name',
	      title: __('Operator', _locale2.default),
	      getTdContent: function getTdContent(_ref4) {
	        var data = _ref4.trData;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          data.operator_name ? data.operator_name : __('Principal', _locale2.default)
	        );
	      }
	    }];
	
	    var settings = [{
	      title: __('Edit', _locale2.default),
	      onClick: function onClick(_ref5) {
	        var data = _ref5.trData;
	
	        _this6.setState({ data: data }, function () {
	          _this6.openClockInOutModal();
	        });
	      }
	    }, {
	      title: __('Delete', _locale2.default),
	      onClick: function onClick(_ref6) {
	        var data = _ref6.trData;
	
	        (0, _confirm.confirm)(__('Proceed to delete this record?', _locale2.default)).then(function () {
	          (0, _deleteClockTime2.default)(schoolId, data.id).then(function (res) {
	            _this6.fetchClockTime();
	          }).catch(function (err) {});
	        }).catch(function () {});
	      }
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'clockTimeTableContainer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'clockTimeHeader' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          __('Clock Card', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-default', disabled: teacherInfo.archived, onClick: this.showClockCardStatistic },
	            __('Calculate Salary', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-default', disabled: teacherInfo.archived, onClick: this.openClockInOutModal },
	            __('Clock In/Out', _locale2.default)
	          )
	        )
	      ),
	      _react2.default.createElement(_FilterBy2.default, {
	        filterData: this.state.filterData,
	        filters: this.state.filterTypes,
	        options: { daterange: daterangeOptions },
	        schoolId: schoolId,
	        onChange: this.onFilterChange
	      }),
	      _react2.default.createElement(_clockCardStatistic2.default, {
	        startDate: startDate,
	        endDate: endDate,
	        teacherId: teacherId,
	        isShow: showClockCardStatistic
	      }),
	      _react2.default.createElement(_UI.Table, {
	        data: this.state.clockTimeList,
	        fields: fields,
	        className: 'clockTimeTable',
	        settingThTitle: ' ',
	        settingWidth: '15%',
	        settings: settings,
	        useMultiSelection: false,
	        oneSettingPerRow: false,
	        hideDropdownCaret: true,
	        fetching: this.state.fetching,
	        dropdownGuideWidth: 160,
	        dropdownGuideHeight: 228,
	        hasTopUtilSection: true,
	        pagination: pagination,
	        usePagination: true,
	        onPageChange: this.onPageChange
	      })
	    );
	  };
	
	  return clockTimeTable;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(clockTimeTable);
	module.exports = exports['default'];

/***/ },

/***/ "TFFZ":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("9xNu");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "9xNu":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	var _ModalContent = __webpack_require__("uBI0");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _updateClockTime = __webpack_require__("vrvL");
	
	var _updateClockTime2 = _interopRequireDefault(_updateClockTime);
	
	var _addClockTime = __webpack_require__("beTu");
	
	var _addClockTime2 = _interopRequireDefault(_addClockTime);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _locale = __webpack_require__("yEjT");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("HPu4");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      clockData: props.data.id ? props.data : { teacher: props.data.teacher }
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  ModalBody.prototype.componentDidMount = function componentDidMount() {};
	
	  ModalBody.prototype.onChange = function onChange(value) {
	    this.setState({ clockData: value });
	  };
	
	  ModalBody.prototype.filterDataBeforeSubmit = function filterDataBeforeSubmit() {
	    var schoolId = localStorage.getItem('schoolId');
	    var clockData = this.state.clockData;
	    var _props = this.props,
	        mode = _props.mode,
	        proceed = _props.proceed;
	
	
	    var validateResult = this.validate();
	    if (!validateResult.ok) {
	      return;
	    }
	
	    if (mode === 'create') {
	      (0, _addClockTime2.default)(schoolId, clockData).then(function (res) {
	        if (res.reason === 'it is an future punch') {
	          _alert.alert.warning(__('Cannot Clock In in Advance', _locale2.default)).then(function () {});
	        } else {
	          proceed(res);
	        }
	      }).catch(function (err) {});
	    } else if (mode === 'update') {
	      var dataToSubmit = {
	        teacher: clockData.teacher,
	        operation_type: clockData.operation_type,
	        punched_at: (0, _moment2.default)(clockData.punched_at).format('YYYY-MM-DD HH:mm'),
	        note: clockData.note
	      };
	      var clockId = clockData.id;
	
	      (0, _updateClockTime2.default)(schoolId, clockId, dataToSubmit).then(function (res) {
	        if (res.reason === 'it is an future punch') {
	          _alert.alert.warning(__('Cannot Clock In in Advance', _locale2.default)).then(function () {});
	        } else {
	          proceed(res);
	        }
	      }).catch(function (err) {});
	    }
	  };
	
	  ModalBody.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props2 = this.props,
	        show = _props2.show,
	        proceed = _props2.proceed,
	        dismiss = _props2.dismiss,
	        cancel = _props2.cancel;
	    var clockData = this.state.clockData;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'clockInOut-modal',
	        hasHeader: true,
	        hasFooter: true,
	        headerTitle: __("Clock In/Out", _locale2.default),
	        fixedWidth: 500,
	        contentHeight: 460,
	        onCloseModalClick: proceed,
	        footerType: 'grey',
	        footerButtons: [{
	          title: __('Save', _locale2.default),
	          className: 'btn btn-primary pull-right',
	          onClick: function onClick() {
	            _this2.filterDataBeforeSubmit();
	          }
	        }, {
	          title: __('Cancel', _locale2.default),
	          className: 'btn btn-default pull-right',
	          onClick: function onClick() {
	            _this2.props.proceed();
	          }
	        }],
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, _extends({}, this.props, {
	        clockData: clockData,
	        onChange: this.onChange,
	        onFormChange: function onFormChange(stateFromModalContent) {
	          _this2.formData = stateFromModalContent;
	        },
	        getValidationRef: function getValidationRef(fn) {
	          _this2.validate = fn;
	        }
	      }))
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "uBI0":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _locale = __webpack_require__("yEjT");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("HPu4");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalContent.prototype.render = function render() {
	    var _props = this.props,
	        onChange = _props.onChange,
	        clockData = _props.clockData;
	
	
	    var schema = [{
	      name: 'operation_type',
	      label: __('Options', _locale2.default),
	      type: 'radio',
	      options: [{ "label": __('Clock In', _locale2.default), "value": 1 }, { "label": __('Clock Out', _locale2.default), "value": 2 }],
	      required: true
	    }, {
	      name: 'punched_at',
	      label: __('Date and Time', _locale2.default),
	      type: 'dateTime',
	      required: true
	    }, {
	      name: 'note',
	      label: __('Notes', _locale2.default),
	      type: 'textarea',
	      required: false
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'clockInOut-modal-content' },
	      _react2.default.createElement(_Form2.default, {
	        onChange: onChange,
	        schema: schema,
	        formData: clockData,
	        formStyle: 'outline',
	        getValidationRef: this.props.getValidationRef
	      })
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "yEjT":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'ClockInOutModal',
	  code: 'CN',
	  text: {
	    'Clock In/Out': '打卡',
	    'Options': '打卡选项',
	    'Clock In': '上班',
	    'Clock Out': '下班',
	    'Date and Time': '日期和时间',
	    'Notes': '备注',
	    'Save': '保存',
	    'Cancel': '取消',
	    'Cannot Clock In in Advance': '无法提前打卡'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "HPu4":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "vrvL":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = updateClockTime;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  teacher: _joiBrowser2.default.number().integer().required(),
	  operation_type: _joiBrowser2.default.number().integer().required(''),
	  punched_at: _joiBrowser2.default.string().required(),
	  note: _joiBrowser2.default.string().allow('')
	});
	
	function updateClockTime(schoolId, clockId, clockInfo) {
	
	  if (!schoolId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school Id')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(clockInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/school/' + schoolId + '/teacher_punch/' + clockId + '/',
	      'method': 'PUT',
	      'data': JSON.stringify(clockInfo),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "beTu":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = addClockTime;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  teacher: _joiBrowser2.default.number().integer().required(),
	  operation_type: _joiBrowser2.default.number().integer().required(''),
	  punched_at: _joiBrowser2.default.string().required(),
	  note: _joiBrowser2.default.string().allow('')
	});
	
	function addClockTime(schoolId, clockInfo) {
	
	  if (!schoolId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school Id')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(clockInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/school/' + schoolId + '/teacher_punch/',
	      'method': 'POST',
	      'data': JSON.stringify(clockInfo),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "Q545":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getClockTime;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACCENDING = 1;
	var DECENDING = 0;
	
	function getClockTime(schoolId, params) {
	
	  if (!schoolId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school Id')
	      });
	    });
	  }
	
	  var query = _queryString2.default.stringify({
	    page: params.page,
	    start_date: params.start_date,
	    end_date: params.end_date,
	    teacher: params.teacher,
	    sort_by: ACCENDING,
	    statistics: params.statistics || 0,
	    weekday: params.weekday || [],
	    start_work_time: params.start_work_time || '',
	    end_work_time: params.end_work_time || ''
	  }, { strict: false, encode: false });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/school/' + schoolId + '/teacher_punch/?' + query,
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "aUnq":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = deleteClockTime;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deleteClockTime(schoolId, clockId) {
	
	  if (!schoolId || !clockId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school or clock Id')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/school/" + schoolId + "/teacher_punch/" + clockId + "/",
	      'method': 'DELETE',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "wG99":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _locale = __webpack_require__("orly");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _getClockTime = __webpack_require__("Q545");
	
	var _getClockTime2 = _interopRequireDefault(_getClockTime);
	
	var _alert = __webpack_require__("BGi1");
	
	var _Salary = __webpack_require__("lkGD");
	
	var _Salary2 = _interopRequireDefault(_Salary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClockCardStatistic = function (_Component) {
	  _inherits(ClockCardStatistic, _Component);
	
	  function ClockCardStatistic(props) {
	    _classCallCheck(this, ClockCardStatistic);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      clockCardData: {
	        work_dates: [{ value: '1', label: __('Monday', _locale2.default) }, { value: '2', label: __('Tuesday', _locale2.default) }, { value: '3', label: __('Wednesday', _locale2.default) }, { value: '4', label: __('Thursday', _locale2.default) }, { value: '5', label: __('Friday', _locale2.default) }],
	        work_start_time: (0, _moment2.default)('9:00 am', 'h:mm a'),
	        work_end_time: (0, _moment2.default)('5:00 pm', 'h:mm a')
	      },
	      clockCardStatistic: null,
	      totalPrice: 0
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.getStatistic = _this.getStatistic.bind(_this);
	    _this.calculateSalary = _this.calculateSalary.bind(_this);
	    return _this;
	  }
	
	  ClockCardStatistic.prototype.onChange = function onChange(value) {
	    this.setState({ clockCardData: value });
	  };
	
	  ClockCardStatistic.prototype.getStatistic = function getStatistic() {
	    var _this2 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _props = this.props,
	        startDate = _props.startDate,
	        endDate = _props.endDate,
	        teacherId = _props.teacherId;
	    var clockCardData = this.state.clockCardData;
	    var work_dates = clockCardData.work_dates,
	        work_start_time = clockCardData.work_start_time,
	        work_end_time = clockCardData.work_end_time;
	
	    var validation = this.validate();
	    if ((0, _moment2.default)(work_start_time).isBefore(work_end_time)) {
	      if (validation.ok) {
	        var weekday = work_dates.map(function (item) {
	          return item.value;
	        });
	        (0, _getClockTime2.default)(schoolId, {
	          page: 1,
	          start_date: startDate,
	          end_date: endDate || (0, _moment2.default)().format('YYYY-MM-DD'),
	          teacher: teacherId,
	          statistics: 1,
	          weekday: weekday,
	          start_work_time: (0, _moment2.default)(work_start_time).format('HH:mm'),
	          end_work_time: (0, _moment2.default)(work_end_time).format('HH:mm')
	        }).then(function (res) {
	          if (res) {
	            _this2.setState(function (prevState) {
	              if (prevState.clockCardStatistic !== res) {
	                return _extends({}, prevState, { clockCardStatistic: res, totalPrice: 0 });
	              }
	            });
	          }
	        });
	      }
	    } else {
	      _alert.alert.warning(__('Work End Time must be later than Work Start Time', _locale2.default));
	    }
	  };
	
	  ClockCardStatistic.prototype.calculateSalary = function calculateSalary() {
	    var _this3 = this;
	
	    (0, _Salary2.default)({ statistics: this.state.clockCardStatistic, salaryCalculatorType: 'clockCard' }).then(function (_ref) {
	      var data = _ref.data;
	
	      if (data) {
	        _this3.setState({ totalPrice: data });
	      } else {
	        _this3.setState({ totalPrice: 0 });
	      }
	    }).catch(function (e) {});
	  };
	
	  ClockCardStatistic.prototype.render = function render() {
	    var _this4 = this;
	
	    var schema = [{
	      name: 'work_dates',
	      label: __('Working Days', _locale2.default),
	      type: 'weekdateSelect',
	      required: true
	    }, {
	      name: 'work_start_time',
	      label: __('Work Start Time', _locale2.default),
	      type: 'timepicker',
	      required: true
	    }, {
	      name: 'work_end_time',
	      label: __('Work End Time', _locale2.default),
	      type: 'timepicker',
	      required: true
	    }];
	    var _state = this.state,
	        clockCardData = _state.clockCardData,
	        clockCardStatistic = _state.clockCardStatistic,
	        totalPrice = _state.totalPrice;
	    var isShow = this.props.isShow;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'clockInOut-modal-content', style: { display: isShow ? 'block' : 'none' } },
	      _react2.default.createElement(_Form2.default, {
	        onChange: this.onChange,
	        schema: schema,
	        formData: clockCardData,
	        formStyle: 'outline',
	        getValidationRef: function getValidationRef(ref) {
	          return _this4.validate = ref;
	        }
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'statistic-btn-wrapper' },
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary statistic', onClick: this.getStatistic },
	          __('Get Statistic', _locale2.default)
	        )
	      ),
	      clockCardStatistic && _react2.default.createElement(
	        'div',
	        { className: 'statistic-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'statistic-items-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'item-label' },
	            _react2.default.createElement(
	              'span',
	              null,
	              __('Total Work Duration', _locale2.default),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'statistic-count' },
	              clockCardStatistic.work_duration,
	              ' ',
	              __('h', _locale2.default)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'item-label' },
	            _react2.default.createElement(
	              'span',
	              null,
	              __('Abnormal Amount', _locale2.default),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'statistic-count' },
	              clockCardStatistic.abnormal_amount,
	              ' ',
	              __('times', _locale2.default)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'statistic-items-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'item-label' },
	            _react2.default.createElement(
	              'span',
	              null,
	              __('Absent Amount', _locale2.default),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'statistic-count' },
	              clockCardStatistic.absent_amount,
	              ' ',
	              __('times', _locale2.default)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'item-value' },
	            _react2.default.createElement(
	              'span',
	              null,
	              __('Absent Duration', _locale2.default),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'statistic-count' },
	              clockCardStatistic.absent_duration,
	              ' ',
	              __('h', _locale2.default)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'statistic-items-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'item-label' },
	            _react2.default.createElement(
	              'span',
	              null,
	              __('Late Amount', _locale2.default),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'statistic-count' },
	              clockCardStatistic.late_amount,
	              ' ',
	              __('times', _locale2.default)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'item-value' },
	            _react2.default.createElement(
	              'span',
	              null,
	              __('Late Duration', _locale2.default),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'statistic-count' },
	              clockCardStatistic.late_duration,
	              ' ',
	              __('h', _locale2.default)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'statistic-items-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'item-label' },
	            _react2.default.createElement(
	              'span',
	              null,
	              __('Leave Early Amount', _locale2.default),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'statistic-count' },
	              clockCardStatistic.leave_early_amount,
	              ' ',
	              __('times', _locale2.default)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'item-value' },
	            _react2.default.createElement(
	              'span',
	              null,
	              __('Leave Early Duration', _locale2.default),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'statistic-count' },
	              clockCardStatistic.leave_early_duration,
	              ' ',
	              __('h', _locale2.default)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'total-salary-wrapper' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary calculate', onClick: this.calculateSalary },
	            __('Calculate Salary', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            __('Total Salary', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'total-salary' },
	            '$',
	            parseFloat(totalPrice).toFixed(2)
	          )
	        )
	      )
	    );
	  };
	
	  return ClockCardStatistic;
	}(_react.Component);
	
	exports.default = ClockCardStatistic;
	module.exports = exports['default'];

/***/ },

/***/ "+Yme":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <StudentHeader
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _locale = __webpack_require__("orly");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _StudentModalHeader = __webpack_require__("CwGh");
	
	var _StudentModalHeader2 = _interopRequireDefault(_StudentModalHeader);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _TeacherDescription = __webpack_require__("ai4t");
	
	var _TeacherDescription2 = _interopRequireDefault(_TeacherDescription);
	
	var _wallet = __webpack_require__("7EYa");
	
	var _wallet2 = _interopRequireDefault(_wallet);
	
	var _pencil = __webpack_require__("QIHI");
	
	var _pencil2 = _interopRequireDefault(_pencil);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	var TeacherHeader = (_temp = _class = function (_React$Component) {
	  _inherits(TeacherHeader, _React$Component);
	
	  function TeacherHeader(props) {
	    _classCallCheck(this, TeacherHeader);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  TeacherHeader.prototype.componentWillMount = function componentWillMount() {};
	
	  TeacherHeader.prototype.render = function render() {
	    var _props = this.props,
	        _props$teacher = _props.teacher,
	        teacher = _props$teacher === undefined ? {} : _props$teacher,
	        onClickPayment = _props.onClickPayment,
	        onClickEdit = _props.onClickEdit,
	        user = _props.user;
	
	    var teacherLoaded = typeof teacher.id !== 'undefined';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'studentInfoDockHeader' },
	      _react2.default.createElement(_StudentModalHeader2.default, { name: teacher.name, gender: teacher.gender, profilePhoto: teacher.profilePhotoThumbnail8x, profileThumbnail: teacher.profilePhotoThumbnail2x, type: 'teacher' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'studentInfoHeaderBtn' },
	        ("production") === 'development' && _react2.default.createElement(
	          _R2.default,
	          { can: 'edit_teacher', by: 'disable' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn', disabled: teacher.archived, onClick: function onClick() {
	                (0, _TeacherDescription2.default)({ id: teacher.id });
	              } },
	            __('Teacher Description', _locale2.default)
	          )
	        ),
	        teacherLoaded && _react2.default.createElement(
	          _R2.default,
	          { can: 'edit_teacher', by: 'disable' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn', disabled: teacher.archived, onClick: onClickEdit },
	            __('Edit', _locale2.default)
	          )
	        )
	      )
	    );
	  };
	
	  return TeacherHeader;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(TeacherHeader);
	module.exports = exports['default'];

/***/ },

/***/ "ai4t":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("83o8");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "83o8":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	var _ModalContent = __webpack_require__("+sI4");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _getTeacherDescription = __webpack_require__("kb24");
	
	var _getTeacherDescription2 = _interopRequireDefault(_getTeacherDescription);
	
	var _updateTeacherDescription = __webpack_require__("CMHr");
	
	var _updateTeacherDescription2 = _interopRequireDefault(_updateTeacherDescription);
	
	var _locale = __webpack_require__("pNgG");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("Q8G/");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      teacherData: {}
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  ModalBody.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    (0, _getTeacherDescription2.default)(this.props.id).then(function (res) {
	      var arr = { description: res.description, on_website: res.on_website == 0 ? false : true };
	      _this2.setState({ teacherData: arr });
	    });
	  };
	
	  ModalBody.prototype.onChange = function onChange(value) {
	    this.setState({ teacherData: value });
	  };
	
	  ModalBody.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel,
	        id = _props.id;
	    var teacherData = this.state.teacherData;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'teacher-description-modal',
	        hasHeader: true,
	        hasFooter: true,
	        headerTitle: __("Teacher Description", _locale2.default),
	        headerIcon: 'fa icon-indent-right',
	        fixedWidth: 500,
	        contentHeight: 300,
	        onCloseModalClick: dismiss,
	        footerType: 'grey',
	        footerButtons: [{
	          title: __('Save', _locale2.default),
	          className: 'btn btn-primary pull-right',
	          onClick: function onClick() {
	            var data = { description: teacherData.description, on_website: teacherData.on_website ? 1 : 0 };
	            (0, _updateTeacherDescription2.default)(id, data).then(function (res) {
	              if (res.result == 'success') {
	                dismiss();
	              }
	            });
	          }
	        }, {
	          title: __('Cancel', _locale2.default),
	          className: 'btn btn-default pull-right',
	          onClick: function onClick() {
	            _this3.props.dismiss();
	          }
	        }],
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, _extends({}, this.props, {
	        teacherData: this.state.teacherData,
	        onChange: this.onChange,
	        onFormChange: function onFormChange(stateFromModalContent) {
	          _this3.formData = stateFromModalContent;
	        }
	      }))
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "+sI4":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _locale = __webpack_require__("pNgG");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("Q8G/");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalContent.prototype.render = function render() {
	    var _props = this.props,
	        teacherData = _props.teacherData,
	        onChange = _props.onChange;
	
	
	    var schema = [{
	      name: 'description',
	      label: __('Description', _locale2.default),
	      type: 'textarea',
	      required: false
	    }, {
	      name: 'on_website',
	      placeholder: __('Do you want to display this on website', _locale2.default),
	      type: 'checkbox',
	      required: false
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'teacher-description-modal-content' },
	      _react2.default.createElement(_Form2.default, {
	        onChange: onChange,
	        schema: schema,
	        formData: teacherData,
	        formStyle: 'outline',
	        getValidationRef: this.props.getValidationRef
	      })
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "pNgG":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'TeacherDescriptionModal',
	  code: 'CN',
	  text: {
	    'Teacher Description': '老师简介',
	    'Save': '保存',
	    'Cancel': '取消',
	    'Description': '简介',
	    'Do you want to display this on website': '是否要在官网上展示'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "Q8G/":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "kb24":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getTeacherDescription;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTeacherDescription(teacherId) {
	
	  if (!teacherId) {
	    throw 'Missing teacher ID';
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/teacher_detail/" + teacherId,
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "CMHr":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = updateTeacherDescription;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  description: _joiBrowser2.default.string().allow(''),
	  on_website: _joiBrowser2.default.number().allow('')
	});
	
	function updateTeacherDescription(teacherId, teacherInfo) {
	
	  if (!teacherId) {
	    throw 'Missing teacher ID';
	  }
	
	  var validateResult = _joiBrowser2.default.validate(teacherInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/teacher_detail/" + teacherId + "/",
	      'method': 'PUT',
	      'data': JSON.stringify(teacherInfo),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "HSGh":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"teacherInfoDock":"teacherInfoDock","dock-header":"dock-header","dock-body":"dock-body","basicInfo":"basicInfo","react-tabs":"react-tabs","react-tabs__tab-list":"react-tabs__tab-list","react-tabs__tab":"react-tabs__tab","react-tabs__tab--selected":"react-tabs__tab--selected","tab-panel-content":"tab-panel-content","studentInfoDockHeader":"studentInfoDockHeader","studentInfoHeaderBtn":"studentInfoHeaderBtn","studentCourseRecord":"studentCourseRecord","icon-angle-down":"icon-angle-down","icon-angle-right":"icon-angle-right","badge":"badge","currentClassHeader":"currentClassHeader","pastClassHeader":"pastClassHeader","teacher-attendance-table-container":"teacher-attendance-table-container","studentTuitionRecord":"studentTuitionRecord","transactionDate":"transactionDate","tuitionClass":"tuitionClass","transactionNumber":"transactionNumber","sendReceipt":"sendReceipt","tuitionYear":"tuitionYear","tutionFilter":"tutionFilter","tuitionSort":"tuitionSort","tuitionCalendar":"tuitionCalendar","tuitionReceipt":"tuitionReceipt","icon-barcode":"icon-barcode","icon-calendar":"icon-calendar","fa-sort-amount-asc":"fa-sort-amount-asc","icon-folder":"icon-folder","rmp-popup":"rmp-popup","month-picker":"month-picker","rmp-container":"rmp-container","clockTimeTableContainer":"clockTimeTableContainer","clockTimeHeader":"clockTimeHeader","clockInOut-modal-content":"clockInOut-modal-content","control-label":"control-label","btn":"btn","btn-primary":"btn-primary","statistic":"statistic","statistic-container":"statistic-container","statistic-items-wrapper":"statistic-items-wrapper","item-label":"item-label","item-value":"item-value","total-salary-wrapper":"total-salary-wrapper","statistic-count":"statistic-count","calculate":"calculate","total-salary":"total-salary"};

/***/ },

/***/ "zoTr":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(_extends({}, opts));
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _DockProvider = __webpack_require__("5FgE");
	
	var _DockProvider2 = _interopRequireDefault(_DockProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_DockProvider2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "5FgE":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DockBody = __webpack_require__("EKc1");
	
	var _DockBody2 = _interopRequireDefault(_DockBody);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DockProvider = function (_React$Component) {
	  _inherits(DockProvider, _React$Component);
	
	  function DockProvider(props) {
	    _classCallCheck(this, DockProvider);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  DockProvider.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(_DockBody2.default, this.props)
	    );
	  };
	
	  return DockProvider;
	}(_react2.default.Component);
	
	exports.default = DockProvider;
	module.exports = exports['default'];

/***/ },

/***/ "EKc1":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _Transition = __webpack_require__("X/qO");
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _lodash = __webpack_require__("M4fF");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _store = __webpack_require__("olkN");
	
	var _store2 = _interopRequireDefault(_store);
	
	var _VerticalInfoGrid = __webpack_require__("VUlR");
	
	var _VerticalInfoGrid2 = _interopRequireDefault(_VerticalInfoGrid);
	
	var _ContactHeader = __webpack_require__("gZ3k");
	
	var _ContactHeader2 = _interopRequireDefault(_ContactHeader);
	
	var _index = __webpack_require__("JX/d");
	
	var _index2 = _interopRequireDefault(_index);
	
	var _locale = __webpack_require__("X7I/");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _fetchContactInfo2 = __webpack_require__("LP1D");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _PotentialClient = __webpack_require__("r8r1");
	
	var _PotentialClient2 = _interopRequireDefault(_PotentialClient);
	
	var _getClientCustomFields = __webpack_require__("083y");
	
	var _getClientCustomFields2 = _interopRequireDefault(_getClientCustomFields);
	
	__webpack_require__("/3Ty");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <DockBody />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var GENDERS = [__('Male', _locale2.default), __('Female', _locale2.default), __('Others', _locale2.default), __('N/A', _locale2.default)];
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    contactInfo: state.contactInfo
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchContactInfo: function fetchContactInfo(contactId, callback) {
	      return dispatch((0, _fetchContactInfo2.fetchContactInfo)(contactId, callback));
	    }
	  };
	};
	
	var DockBody = function (_React$Component) {
	  _inherits(DockBody, _React$Component);
	
	  function DockBody(props) {
	    _classCallCheck(this, DockBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      selectedIndex: 0,
	      contact: props.contactData,
	      fields: [],
	      fetching: false
	    };
	
	    _this.onSelectTab = _this.onSelectTab.bind(_this);
	    _this.onClickEdit = _this.onClickEdit.bind(_this);
	    return _this;
	  }
	
	  DockBody.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var id = this.props.id;
	
	
	    this.props.fetchContactInfo(id, function () {
	      _this2.setState({ contact: _this2.props.contactInfo });
	    });
	    this.getCustomFields();
	  };
	
	  DockBody.prototype.onSelectTab = function onSelectTab(selectedIndex) {
	    this.setState({ selectedIndex: selectedIndex });
	  };
	
	  DockBody.prototype.onClickEdit = function onClickEdit() {
	    var _this3 = this;
	
	    var contact = this.state.contact;
	
	
	    (0, _PotentialClient2.default)({ clientId: contact.id, type: 'edit' }).then(function () {
	      _this3.props.fetchContactInfo(_this3.props.id, function () {
	        _this3.setState({ contact: _this3.props.contactInfo });
	      });
	    });
	  };
	
	  DockBody.prototype.getCustomFields = function getCustomFields() {
	    var _this4 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    (0, _getClientCustomFields2.default)(schoolId).then(function (_ref) {
	      var contact_custom_fields = _ref.contact_custom_fields;
	      var _contact_custom_field = contact_custom_fields.fields,
	          fields = _contact_custom_field === undefined ? [] : _contact_custom_field;
	
	
	      _this4.setState({
	        fields: fields
	      });
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  DockBody.prototype.render = function render() {
	    var _props = this.props,
	        isVisible = _props.isVisible,
	        show = _props.show,
	        dismiss = _props.dismiss,
	        mode = _props.mode,
	        id = _props.id,
	        name = _props.name,
	        proceed = _props.proceed;
	    var _state = this.state,
	        fetching = _state.fetching,
	        contact = _state.contact,
	        fields = _state.fields,
	        selectedIndex = _state.selectedIndex;
	
	
	    var basicInfo = [];
	    var otherInfo = [];
	
	    if (contact) {
	      basicInfo = [{ label: __('Name', _locale2.default), value: contact.first_name + ' ' + contact.last_name }, { label: __('Gender', _locale2.default), value: __(GENDERS[contact.gender], _locale2.default) }, { label: __('Date of Birth', _locale2.default), value: contact.birthday }, { label: __('Phone No.', _locale2.default), value: contact.mobile }, { label: __('Email', _locale2.default), value: contact.email }, { label: __('Guardian Email', _locale2.default), value: contact.guardian_email }, { label: __('Guardian Phone No.', _locale2.default), value: contact.guardian_mobile }, { label: __('Guardian Name', _locale2.default), value: contact.guardian_name }, { label: __('Tag', _locale2.default), value: contact.tag_name_list.join(', ') }, { label: __('Created At', _locale2.default), value: (0, _moment2.default)(contact.created_at).format('YYYY-MM-DD hh:mm A') }, { label: __('Remarks', _locale2.default), value: contact.remark }];
	      fields.map(function (field) {
	        var label = field.label,
	            id = field.id,
	            type = field.type;
	
	
	        if (contact.custom_data) {
	          var value = contact.custom_data[id];
	
	          if (type === 'checkbox') {
	            try {
	              var arrayValue = JSON.parse(value);
	              value = arrayValue.toString();
	            } catch (e) {}
	          }
	
	          if (label) {
	            otherInfo.push({ label: label, value: value });
	          }
	        }
	      });
	    }
	
	    if (!contact) {
	      return _react2.default.createElement('div', null);
	    }
	
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(
	        _UI.Dock,
	        {
	          dockStyle: { minWidth: 760, maxWidth: 880 },
	          className: 'contactInfoDock',
	          position: 'right',
	          isVisible: show,
	          size: 0.62,
	          overlayOpacity: 0.2,
	          onCloseDockClick: function onCloseDockClick() {
	            proceed();
	          },
	          useClosingTag: true,
	          dockTitle: _react2.default.createElement(_ContactHeader2.default, { contact: contact, onClickEdit: this.onClickEdit }),
	          useDefaultCloseButton: false
	        },
	        fetching && _react2.default.createElement(_Loading2.default, null),
	        !fetching && _react2.default.createElement(
	          _Transition2.default,
	          null,
	          _react2.default.createElement(
	            _UI.Tabs,
	            { defaultIndex: selectedIndex, onSelect: this.onSelectTab },
	            _react2.default.createElement(
	              _UI.TabList,
	              null,
	              _react2.default.createElement(
	                _UI.Tab,
	                null,
	                __("Info", _locale2.default)
	              ),
	              _react2.default.createElement(
	                _UI.Tab,
	                null,
	                __("Notes", _locale2.default)
	              )
	            ),
	            _react2.default.createElement(
	              _UI.TabPanel,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'studentDetail' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  __('Basic Info', _locale2.default)
	                ),
	                _react2.default.createElement(_VerticalInfoGrid2.default, { data: basicInfo }),
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  __('Other Info', _locale2.default)
	                ),
	                _react2.default.createElement(_VerticalInfoGrid2.default, { data: otherInfo })
	              )
	            ),
	            _react2.default.createElement(
	              _UI.TabPanel,
	              null,
	              _react2.default.createElement(_index2.default, { contactId: contact.id })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return DockBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactConfirm.confirmable)(DockBody));
	module.exports = exports['default'];

/***/ },

/***/ "gZ3k":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <StudentHeader
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _locale = __webpack_require__("X7I/");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _StudentModalHeader = __webpack_require__("CwGh");
	
	var _StudentModalHeader2 = _interopRequireDefault(_StudentModalHeader);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _pencil = __webpack_require__("QIHI");
	
	var _pencil2 = _interopRequireDefault(_pencil);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	var ContactHeader = (_temp = _class = function (_React$Component) {
	  _inherits(ContactHeader, _React$Component);
	
	  function ContactHeader(props) {
	    _classCallCheck(this, ContactHeader);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ContactHeader.prototype.componentWillMount = function componentWillMount() {};
	
	  ContactHeader.prototype.render = function render() {
	    var _props = this.props,
	        _props$contact = _props.contact,
	        contact = _props$contact === undefined ? {} : _props$contact,
	        onClickPayment = _props.onClickPayment,
	        onClickEdit = _props.onClickEdit,
	        user = _props.user;
	
	
	    var contactLoaded = typeof contact.id !== 'undefined';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'studentInfoDockHeader' },
	      _react2.default.createElement(_StudentModalHeader2.default, { name: contact.first_name + ' ' + contact.last_name, gender: contact.gender }),
	      _react2.default.createElement(
	        'div',
	        { className: 'studentInfoHeaderBtn' },
	        contactLoaded && _react2.default.createElement(
	          _R2.default,
	          { can: 'edit_contact', by: 'disable' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn', onClick: onClickEdit },
	            __('Edit', _locale2.default)
	          )
	        )
	      )
	    );
	  };
	
	  return ContactHeader;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ContactHeader);
	module.exports = exports['default'];

/***/ },

/***/ "X7I/":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'ContactDockInfo',
	  code: 'CN',
	  text: {
	    'Info': '联系人档案',
	    'Edit': '编辑',
	
	    'Basic Info': '基本信息',
	    "Other Info": "其他信息",
	    'Name': '姓名',
	    'Gender': '性别',
	    'Date of Birth': '生日',
	    'Phone No.': '联系电话',
	    'Email': '联系邮箱',
	    'Guardian Name': '家长姓名',
	    'Guardian Email': '家长邮箱',
	    'Guardian Phone No.': '家长电话',
	    'Remarks': '备注',
	    'Tag': '标签',
	    'Created At': '创建时间',
	
	    'Notes': '备忘',
	    'Male': '男',
	    'Female': '女',
	    'Other': '其他',
	    'N/A': '未提供'
	
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "JX/d":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _ContactTimeline = __webpack_require__("TN1v");
	
	var _ContactTimeline2 = _interopRequireDefault(_ContactTimeline);
	
	var _reactQuill = __webpack_require__("TWqO");
	
	var _reactQuill2 = _interopRequireDefault(_reactQuill);
	
	var _fetchContactNotes2 = __webpack_require__("YC01");
	
	var _addContactNotes2 = __webpack_require__("ayZH");
	
	var _deleteContactNotes2 = __webpack_require__("dCVY");
	
	var _updateContactNotes2 = __webpack_require__("Radp");
	
	var _OnBoardingNatural = __webpack_require__("PwUp");
	
	var _OnBoardingNatural2 = _interopRequireDefault(_OnBoardingNatural);
	
	var _constant = __webpack_require__("QvXh");
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	__webpack_require__("sCQd");
	
	var _locale = __webpack_require__("8o+C");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    contactNotes: state.contactNotes,
	    disabledBtn: false
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchContactNotes: function fetchContactNotes(contactId, callback) {
	      return dispatch((0, _fetchContactNotes2.fetchContactNotes)(contactId, callback));
	    },
	    addContactNotes: function addContactNotes(contactId, params, callback) {
	      return dispatch((0, _addContactNotes2.addContactNotes)(contactId, params, callback));
	    },
	    deleteContactNotes: function deleteContactNotes(index, contactId, callback) {
	      return dispatch((0, _deleteContactNotes2.deleteContactNotes)(index, contactId, callback));
	    },
	    updateContactNotes: function updateContactNotes(contactId, params, callback) {
	      return dispatch((0, _updateContactNotes2.updateContactNotes)(contactId, params, callback));
	    }
	  };
	};
	
	var ContactNotes = function (_React$Component) {
	  _inherits(ContactNotes, _React$Component);
	
	  function ContactNotes(props) {
	    _classCallCheck(this, ContactNotes);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      status: 'view',
	      content: '',
	      taskId: ''
	    };
	
	    _this.getContactNotes = _this.getContactNotes.bind(_this);
	    _this.editTask = _this.editTask.bind(_this);
	    _this.deleteTask = _this.deleteTask.bind(_this);
	    return _this;
	  }
	
	  ContactNotes.prototype.componentDidMount = function componentDidMount() {
	    this.getContactNotes();
	  };
	
	  ContactNotes.prototype.getContactNotes = function getContactNotes() {
	    var contactId = this.props.contactId;
	
	
	    this.props.fetchContactNotes(contactId, function () {});
	  };
	
	  ContactNotes.prototype.editTask = function editTask(taskId, task) {
	    this.setState({ status: 'edit', content: task.content, taskId: taskId });
	  };
	
	  ContactNotes.prototype.deleteTask = function deleteTask(key, taskId) {
	    var _this2 = this;
	
	    (0, _confirm.confirm)(__('Proceed to delete notes?', _locale2.default)).then(function () {
	      _this2.props.deleteContactNotes(key, taskId);
	      _this2.getContactNotes();
	    }).catch(function () {});
	  };
	
	  ContactNotes.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        contactNotes = _props.contactNotes,
	        contactId = _props.contactId;
	    var result_list = contactNotes.result_list,
	        total_amount = contactNotes.total_amount,
	        hasPermission = contactNotes.hasPermission;
	    var _state = this.state,
	        status = _state.status,
	        content = _state.content,
	        taskId = _state.taskId,
	        disabledBtn = _state.disabledBtn;
	
	    var onBoardingContent = _constant.onBoardingContents;
	
	    if (total_amount == 0 && onBoardingContent && status != 'add' || !hasPermission) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'contact-notes-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'contact-notes-header' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'pull-left' },
	            __('Contact Notes', _locale2.default)
	          ),
	          _react2.default.createElement(
	            _R2.default,
	            { can: 'edit_contact_notes', by: 'disable' },
	            _react2.default.createElement(
	              'button',
	              { className: ' pull-right btn btn-primary', onClick: function onClick() {
	                  _this3.setState({ status: 'add', content: '' });
	                } },
	              __('Add', _locale2.default)
	            )
	          )
	        ),
	        _react2.default.createElement(_OnBoardingNatural2.default, { isShown: true, title: onBoardingContent.title, text: onBoardingContent.text, image: onBoardingContent.image, showArrow: onBoardingContent.showArrow })
	      );
	    } else {
	      return _react2.default.createElement(
	        'div',
	        { className: 'contact-notes-container' },
	        status == 'view' && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'contact-notes-header' },
	            _react2.default.createElement(
	              'h4',
	              { className: 'pull-left' },
	              __('Contact Notes', _locale2.default)
	            ),
	            _react2.default.createElement(
	              _R2.default,
	              { can: 'edit_contact_notes', by: 'disable' },
	              _react2.default.createElement(
	                'button',
	                { className: ' pull-right btn btn-primary', onClick: function onClick() {
	                    _this3.setState({ status: 'add', content: '' });
	                  } },
	                __('Add', _locale2.default)
	              )
	            )
	          ),
	          _react2.default.createElement(_ContactTimeline2.default, {
	            tasks: result_list,
	            editTask: this.editTask,
	            deleteTask: this.deleteTask
	          })
	        ),
	        status == 'add' && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            { style: { marginBottom: '20px' } },
	            __('Add Contact Notes', _locale2.default)
	          ),
	          _react2.default.createElement(_reactQuill2.default, { value: content, onChange: function onChange(value) {
	              _this3.setState({ content: value });
	            } }),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary', disabled: disabledBtn, onClick: function onClick() {
	                _this3.setState({ disabledBtn: true });
	                _this3.props.addContactNotes(contactId, { content: content }, function () {
	                  _this3.getContactNotes();
	                  _this3.setState({ status: 'view', content: '', disabledBtn: false });
	                });
	              } },
	            __('Save', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-default', onClick: function onClick() {
	                _this3.setState({ status: 'view', content: '' });
	              } },
	            __('Cancel', _locale2.default)
	          )
	        ),
	        status == 'edit' && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            { style: { marginBottom: '20px' } },
	            __('Edit Contact Notes', _locale2.default)
	          ),
	          _react2.default.createElement(_reactQuill2.default, { value: content, onChange: function onChange(value) {
	              _this3.setState({ content: value });
	            } }),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary', disabled: disabledBtn, onClick: function onClick() {
	                _this3.setState({ disabledBtn: true });
	                _this3.props.updateContactNotes(taskId, { content: content }, function () {
	                  _this3.getContactNotes();
	                  _this3.setState({ status: 'view', content: '', disabledBtn: false });
	                });
	              } },
	            __('Save', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-default', onClick: function onClick() {
	                _this3.setState({ status: 'view', content: '' });
	              } },
	            __('Cancel', _locale2.default)
	          )
	        )
	      );
	    }
	  };
	
	  return ContactNotes;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ContactNotes);
	module.exports = exports['default'];

/***/ },

/***/ "TN1v":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactEventTimeline = __webpack_require__("kCet");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _locale = __webpack_require__("FNK1");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("TYkA");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactTimeline = function (_Component) {
	  _inherits(ContactTimeline, _Component);
	
	  function ContactTimeline(props) {
	    _classCallCheck(this, ContactTimeline);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  ContactTimeline.prototype.render = function render() {
	    var _props = this.props,
	        tasks = _props.tasks,
	        deleteTask = _props.deleteTask,
	        editTask = _props.editTask;
	
	
	    if (!tasks) {
	      return _react2.default.createElement('div', null);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('react-timeline-container', {}) },
	      _react2.default.createElement(
	        _reactEventTimeline.Timeline,
	        { className: 'Timeline', lineColor: '#EBEBED', lineStyle: { width: 1 } },
	        tasks.map(function (task, key) {
	
	          return _react2.default.createElement(
	            'div',
	            { key: key },
	            _react2.default.createElement(
	              _reactEventTimeline.TimelineEvent,
	              {
	                className: 'timeline-event-container',
	                title: _react2.default.createElement(
	                  'div',
	                  { className: 'createdAt' },
	                  (0, _moment2.default)(task.created_at).format('YYYY-MM-DD hh:mm A')
	                ),
	                contentStyle: { boxShadow: 'none', padding: '0px' },
	                bubbleStyle: { background: 'none', color: 'white', fontSize: '15px', border: 'none' },
	                titleStyle: { color: '#11151E', fontSize: '20px', fontWeight: '600' },
	                createdAt: task.editor_name + ' ' + __('created this note', _locale2.default),
	                icon: _react2.default.createElement('img', { className: 'school-success-icon', src: __webpack_require__("6v1f") })
	              },
	              _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: task.content } }),
	              _react2.default.createElement(
	                _R2.default,
	                { can: 'edit_contact_notes', by: 'disable' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn-link', onClick: function onClick() {
	                      editTask(task.id, task);
	                    } },
	                  __('Edit', _locale2.default)
	                )
	              ),
	              _react2.default.createElement(
	                _R2.default,
	                { can: 'edit_contact_notes', by: 'disable' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn-link', onClick: function onClick() {
	                      deleteTask(key, task.id);
	                    } },
	                  __('Delete', _locale2.default)
	                )
	              )
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return ContactTimeline;
	}(_react.Component);
	
	exports.default = ContactTimeline;
	module.exports = exports['default'];

/***/ },

/***/ "FNK1":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'ContactTimeLine',
	  code: 'CN',
	  text: {
	    'Edit': '编辑',
	    'Delete': '删除',
	    'created this note': '创建了这个备忘'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "TYkA":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"contact-notes-container":"contact-notes-container","fetching":"fetching","Timeline":"Timeline","timeline-event-container":"timeline-event-container","task-container":"task-container","createdAt":"createdAt","timeline-content":"timeline-content","btn-container":"btn-container","btn":"btn","timeline-title":"timeline-title","person-charge":"person-charge","short-task":"short-task","icon-angle-down":"icon-angle-down","icon-angle-right":"icon-angle-right","icon-angle-up":"icon-angle-up"};

/***/ },

/***/ "6v1f":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "note@2x.9399b7cd.png";

/***/ },

/***/ "Radp":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FAILED_UPDATE_CONTACT_NOTES = exports.SUCCESS_UPDATE_CONTACT_NOTES = exports.START_UPDATE_CONTACT_NOTES = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.updateContactNotes = updateContactNotes;
	
	var _updateContactNotes = __webpack_require__("XkST");
	
	var _updateContactNotes2 = _interopRequireDefault(_updateContactNotes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var START_UPDATE_CONTACT_NOTES = exports.START_UPDATE_CONTACT_NOTES = 'START_UPDATE_CONTACT_NOTES';
	var SUCCESS_UPDATE_CONTACT_NOTES = exports.SUCCESS_UPDATE_CONTACT_NOTES = 'SUCCESS_UPDATE_CONTACT_NOTES';
	var FAILED_UPDATE_CONTACT_NOTES = exports.FAILED_UPDATE_CONTACT_NOTES = 'FAILED_UPDATE_CONTACT_NOTES';
	
	var schoolId = localStorage.getItem('schoolId');
	
	function updateContactNotes(contactId, params, callback) {
	  return function (dispatch) {
	
	    dispatch({
	      type: START_UPDATE_CONTACT_NOTES
	      // payload: {updating: true, announcementInfo}
	    });
	
	    (0, _updateContactNotes2.default)(contactId, params).then(function (result) {
	      dispatch({
	        type: SUCCESS_UPDATE_CONTACT_NOTES,
	        payload: _extends({}, result, { updating: false })
	      });
	
	      if (typeof callback == 'function') {
	        callback();
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_UPDATE_CONTACT_NOTES,
	        payload: err
	      });
	    });
	  };
	}

/***/ },

/***/ "XkST":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = updateContactNotes;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  "content": _joiBrowser2.default.string().required()
	});
	
	function updateContactNotes(contactId, params) {
	
	  if (!contactId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing contactId Id')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(params, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/contact_notes_detail/" + contactId + "/",
	      'method': 'PUT',
	      'data': JSON.stringify(params),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "QvXh":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var locale = {
	  id: 'ContactNotesConstant',
	  code: 'CN',
	  text: {
	    "./images/note-eng.jpg": "./images/note-cn.jpg",
	    'Contact Notes': '联系人备忘',
	    'Here you can track the progress of your communication with your contacts and create notes for late review': '在这里您可以追踪记录您与联系人交流的经过，建立备忘，方便之后进行复查。'
	  }
	};
	
	var onBoardingContents = exports.onBoardingContents = {
	  title: __('Contact Notes', locale),
	  text: __('Here you can track the progress of your communication with your contacts and create notes for late review', locale),
	  image: __webpack_require__(10)(__('./images/note-eng.jpg', locale)),
	  showArrow: true
	};

/***/ },

/***/ 10:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./ContactNotes.scss": "KdoX",
		"./constant": "QvXh",
		"./constant.js": "QvXh",
		"./images/note-cn.jpg": "FuPC",
		"./images/note-eng.jpg": "Fe8q",
		"./index": "JX/d",
		"./index.js": "JX/d",
		"./locale": "8o+C",
		"./locale.js": "8o+C",
		"./redux/actions/addContactNotes": "ayZH",
		"./redux/actions/addContactNotes.js": "ayZH",
		"./redux/actions/deleteContactNotes": "dCVY",
		"./redux/actions/deleteContactNotes.js": "dCVY",
		"./redux/actions/fetchContactNotes": "YC01",
		"./redux/actions/fetchContactNotes.js": "YC01",
		"./redux/actions/updateContactNotes": "Radp",
		"./redux/actions/updateContactNotes.js": "Radp",
		"./redux/reducer": "vA13",
		"./redux/reducer.js": "vA13",
		"./style.scss": "sCQd"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 10;


/***/ },

/***/ "KdoX":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"contact-notes-container":"contact-notes-container"};

/***/ },

/***/ "FuPC":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "note-cn.40320b1d.jpg";

/***/ },

/***/ "Fe8q":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "note-eng.10f0bc69.jpg";

/***/ },

/***/ "8o+C":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'ContactNotes',
	  code: 'CN',
	  text: {
	    'Add': '创建备忘',
	    'Contact Notes': '联系人备忘',
	    'Add Contact Notes': '创建联系人备忘',
	    'Edit Contact Notes': '编辑联系人备忘',
	    'Save': '保存',
	    'Cancel': '取消',
	    'Proceed to delete notes?': '确认删除备忘？'
	
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "sCQd":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"contact-notes-container":"contact-notes-container","Select--single":"Select--single","react-tabs__tab-list":"react-tabs__tab-list","contact-notes-header":"contact-notes-header","btn-primary":"btn-primary","quill":"quill","ql-container":"ql-container"};

/***/ },

/***/ "/3Ty":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"contactInfoDock":"contactInfoDock","dock-header":"dock-header","dock-body":"dock-body","basicInfo":"basicInfo","react-tabs":"react-tabs","react-tabs__tab-list":"react-tabs__tab-list","react-tabs__tab":"react-tabs__tab","react-tabs__tab--selected":"react-tabs__tab--selected","tab-panel-content":"tab-panel-content","studentDetail":"studentDetail","studentInfoDockHeader":"studentInfoDockHeader","studentInfoHeaderBtn":"studentInfoHeaderBtn","studentCourseRecord":"studentCourseRecord","icon-down-open":"icon-down-open","icon-angle-right":"icon-angle-right","badge":"badge","currentClassHeader":"currentClassHeader","pastClassHeader":"pastClassHeader","teacher-attendance-table-container":"teacher-attendance-table-container","studentTuitionRecord":"studentTuitionRecord","transactionDate":"transactionDate","tuitionClass":"tuitionClass","transactionNumber":"transactionNumber","sendReceipt":"sendReceipt","tuitionYear":"tuitionYear","tutionFilter":"tutionFilter","tuitionSort":"tuitionSort","tuitionCalendar":"tuitionCalendar","tuitionReceipt":"tuitionReceipt","icon-barcode":"icon-barcode","icon-calendar":"icon-calendar","icon-sort-alt-up":"icon-sort-alt-up","icon-folder":"icon-folder","rmp-popup":"rmp-popup","month-picker":"month-picker","rmp-container":"rmp-container"};

/***/ },

/***/ "slD+":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "rKyg":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"activityLogContainer":"activityLogContainer","log-date-section":"log-date-section","log-min-section":"log-min-section"};

/***/ },

/***/ "XXpB":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactJsPagination = __webpack_require__("bgMy");
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _LessonFloat = __webpack_require__("Jxru");
	
	var _LessonFloat2 = _interopRequireDefault(_LessonFloat);
	
	var _Lesson = __webpack_require__("g5LE");
	
	var _Lesson2 = _interopRequireDefault(_Lesson);
	
	var _EmptyDataPlaceholder = __webpack_require__("38y+");
	
	var _EmptyDataPlaceholder2 = _interopRequireDefault(_EmptyDataPlaceholder);
	
	__webpack_require__("TawE");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CalendarDailyView = function (_Component) {
	  _inherits(CalendarDailyView, _Component);
	
	  function CalendarDailyView(props) {
	    _classCallCheck(this, CalendarDailyView);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      lessonEvent: {},
	      showLessonFloat: false,
	      currentTarget: null
	    };
	    _this._closeFloat = _this._closeFloat.bind(_this);
	    return _this;
	  }
	
	  CalendarDailyView.prototype._onLessonClick = function _onLessonClick(lesson, targetRef) {
	    var _this2 = this;
	
	    this.setState({
	      lessonEvent: new _Lesson2.default(lesson)
	    }, function () {
	      _this2.setState({
	        showLessonFloat: true,
	        currentTarget: targetRef
	      });
	    });
	  };
	
	  CalendarDailyView.prototype._closeFloat = function _closeFloat() {
	    this.setState({
	      showLessonFloat: false,
	      lessonEvent: null,
	      currentTarget: null
	    });
	  };
	
	  CalendarDailyView.prototype._renderPaginationToolbar = function _renderPaginationToolbar() {
	    var _props = this.props,
	        pagination = _props.pagination,
	        onPageChange = _props.onPageChange;
	    var activePage = pagination.activePage,
	        itemsCountPerPage = pagination.itemsCountPerPage,
	        totalItemsCount = pagination.totalItemsCount,
	        pageRangeDisplayed = pagination.pageRangeDisplayed;
	
	    return _react2.default.createElement(_reactJsPagination2.default, {
	      activePage: activePage,
	      itemsCountPerPage: itemsCountPerPage,
	      totalItemsCount: totalItemsCount,
	      pageRangeDisplayed: pageRangeDisplayed,
	      onChange: onPageChange
	    });
	  };
	
	  CalendarDailyView.prototype.renderLessonList = function renderLessonList(result_list) {
	    var _this3 = this;
	
	    var _state = this.state,
	        lessonEvent = _state.lessonEvent,
	        showLessonFloat = _state.showLessonFloat,
	        currentTarget = _state.currentTarget;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      result_list.map(function (lesson) {
	        var targetRef = void 0;
	        return _react2.default.createElement(
	          'div',
	          { className: 'lesson_container', onClick: function onClick() {
	              return _this3._onLessonClick(lesson, targetRef);
	            }, ref: function ref(_ref) {
	              return targetRef = _ref;
	            }, style: { borderLeft: '6px solid ' + (lesson.lCalendarColor ? lesson.lCalendarColor : 'rgb(33, 150, 243)') } },
	          _react2.default.createElement(
	            'div',
	            { className: 'time' },
	            (0, _moment2.default)(lesson.lStartTime).format('HH:mm a'),
	            ' - ',
	            (0, _moment2.default)(lesson.lEndTime).format('HH:mm a')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'lesson_name' },
	            lesson.title
	          )
	        );
	      }),
	      _react2.default.createElement(_LessonFloat2.default, {
	        lesson: lessonEvent,
	        show: showLessonFloat,
	        target: currentTarget,
	        onCloseFloat: this._closeFloat
	      }),
	      this._renderPaginationToolbar()
	    );
	  };
	
	  CalendarDailyView.prototype.render = function render() {
	    var placeholderTitle = this.props.placeholderTitle;
	    var result_list = this.props.data.result_list;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'calendar_container' },
	      result_list && result_list.length == 0 && _react2.default.createElement(_EmptyDataPlaceholder2.default, { title: placeholderTitle, icon: 'icon-chalkboard' }),
	      result_list && result_list.length > 0 && this.renderLessonList(result_list)
	    );
	  };
	
	  return CalendarDailyView;
	}(_react.Component);
	
	exports.default = CalendarDailyView;
	module.exports = exports['default'];

/***/ },

/***/ "Jxru":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <LessonFloat
	                         lesson={lesson}
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Float = __webpack_require__("oGSK");
	
	var _Float2 = _interopRequireDefault(_Float);
	
	__webpack_require__("jhXJ");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _Attendance = __webpack_require__("wCrv");
	
	var _Attendance2 = _interopRequireDefault(_Attendance);
	
	var _UpdateLesson = __webpack_require__("B6SM");
	
	var _UpdateLesson2 = _interopRequireDefault(_UpdateLesson);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _getLessonAttendance = __webpack_require__("NQer");
	
	var _getLessonAttendance2 = _interopRequireDefault(_getLessonAttendance);
	
	var _isEmpty = __webpack_require__("lHK6");
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LessonFloat = (_temp = _class = function (_React$Component) {
	  _inherits(LessonFloat, _React$Component);
	
	  function LessonFloat(props) {
	    _classCallCheck(this, LessonFloat);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      studentAmount: '',
	      teacherList: [],
	      studentList: []
	    };
	
	    _this.renderFloatContent = _this.renderFloatContent.bind(_this);
	    return _this;
	  }
	
	  LessonFloat.prototype.componentDidMount = function componentDidMount() {};
	
	  LessonFloat.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    if (!(0, _isEmpty2.default)(nextProps.lesson) && nextProps.lesson !== null) {
	      (0, _getLessonAttendance2.default)(nextProps.lesson.id).then(function (res) {
	        _this2.setState({
	          studentAmount: res.student_amount,
	          teacherList: res.teacher_list,
	          studentList: res.student_list
	        });
	      }).catch(function (err) {});
	    }
	  };
	
	  LessonFloat.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        target = _props.target,
	        lesson = _props.lesson,
	        onCloseFloat = _props.onCloseFloat;
	
	
	    return _react2.default.createElement(
	      _Float2.default,
	      {
	        container: global['--classtop-main-section'],
	        show: show,
	        target: target,
	        floatWidth: 400,
	        onCloseFloat: onCloseFloat
	      },
	      this.renderFloatContent()
	    );
	  };
	
	  LessonFloat.prototype.renderFloatContent = function renderFloatContent() {
	    var _props2 = this.props,
	        onCloseFloat = _props2.onCloseFloat,
	        onChange = _props2.onChange,
	        lesson = _props2.lesson;
	
	
	    if (!lesson) {
	      return _react2.default.createElement('div', null);
	    }
	
	    var _state = this.state,
	        teacherList = _state.teacherList,
	        studentList = _state.studentList,
	        studentAmount = _state.studentAmount;
	    var calendarColor = lesson.calendarColor,
	        title = lesson.title,
	        classroomName = lesson.classroomName,
	        startTime = lesson.startTime,
	        endTime = lesson.endTime,
	        id = lesson.id,
	        classId = lesson.classId,
	        status = lesson.status,
	        classType = lesson.classType;
	
	
	    var startTimeStr = (0, _moment2.default)(startTime).format('HH:mm a');
	    var endTimeStr = (0, _moment2.default)(endTime).format('HH:mm a');
	
	    var teacherNames = [];
	    if (teacherList) {
	      teacherNames = teacherList.map(function (teacher) {
	        return teacher.teacher_name;
	      });
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'lesson-detail-float' },
	      _react2.default.createElement(
	        'div',
	        { className: 'title-section', style: { backgroundColor: calendarColor } },
	        title,
	        _react2.default.createElement('i', {
	          className: 'fa icon-cancel',
	          style: { WebkitTextStrokeColor: calendarColor },
	          onClick: onCloseFloat
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'detail-section' },
	        _react2.default.createElement(
	          'dl',
	          null,
	          _react2.default.createElement(
	            'dt',
	            null,
	            __('Start Time', 'LessonFloat')
	          ),
	          _react2.default.createElement(
	            'dd',
	            null,
	            startTimeStr
	          )
	        ),
	        _react2.default.createElement(
	          'dl',
	          null,
	          _react2.default.createElement(
	            'dt',
	            null,
	            __('End Time', 'LessonFloat')
	          ),
	          _react2.default.createElement(
	            'dd',
	            null,
	            endTimeStr
	          )
	        ),
	        _react2.default.createElement(
	          'dl',
	          null,
	          _react2.default.createElement(
	            'dt',
	            null,
	            __('Number of Student', 'LessonFloat')
	          ),
	          _react2.default.createElement(
	            'dd',
	            null,
	            studentAmount
	          )
	        ),
	        classroomName && _react2.default.createElement(
	          'dl',
	          null,
	          _react2.default.createElement(
	            'dt',
	            null,
	            __('Classroom', 'LessonFloat')
	          ),
	          _react2.default.createElement(
	            'dd',
	            null,
	            classroomName
	          )
	        ),
	        teacherNames.length > 0 && _react2.default.createElement(
	          'dl',
	          null,
	          _react2.default.createElement(
	            'dt',
	            null,
	            __('Teacher', 'LessonFloat')
	          ),
	          _react2.default.createElement(
	            'dd',
	            null,
	            teacherNames.join(', ')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'controller-section' },
	          _react2.default.createElement(
	            _R2.default,
	            { can: 'manually_check_in', by: 'disable', tooltipPosition: 'left' },
	            _react2.default.createElement(
	              _UI.Button,
	              { bsStyle: 'default', onClick: function onClick(e) {
	                  (0, _Attendance2.default)({ lessonId: id, classId: classId }).then(function (a) {
	                    onChange(a);
	                  });
	                  onCloseFloat();
	                } },
	              __('Attendance', 'LessonFloat')
	            )
	          ),
	          (classType == 0 && (0, _R.userCan)('edit_lesson') || classType == 1 && (0, _R.userCan)('edit_private_lesson')) && _react2.default.createElement(
	            _UI.Button,
	            { bsStyle: 'default', disabled: status == 1 ? true : false, onClick: function onClick() {
	                (0, _UpdateLesson2.default)({ lesson: lesson, classId: lesson.classId, studentList: studentList, teacherList: teacherList }).then(function (res) {
	                  onChange(res);
	                });
	                onCloseFloat();
	              } },
	            __('Edit', 'LessonFloat')
	          )
	        )
	      )
	    );
	  };
	
	  return LessonFloat;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = LessonFloat;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "jhXJ":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"lesson-detail-float":"lesson-detail-float","title-section":"title-section","detail-section":"detail-section","controller-section":"controller-section"};

/***/ },

/***/ "38y+":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("dqR2");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmptyDataPlaceholder = function (_React$Component) {
	  _inherits(EmptyDataPlaceholder, _React$Component);
	
	  function EmptyDataPlaceholder(props) {
	    _classCallCheck(this, EmptyDataPlaceholder);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  EmptyDataPlaceholder.prototype.render = function render() {
	    var _props = this.props,
	        title = _props.title,
	        icon = _props.icon;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'placeholder' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('i', { className: (0, _classnames2.default)(icon, 'icon') })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'placeholder-title' },
	        title
	      )
	    );
	  };
	
	  return EmptyDataPlaceholder;
	}(_react2.default.Component);
	
	exports.default = EmptyDataPlaceholder;
	module.exports = exports['default'];

/***/ },

/***/ "dqR2":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"placeholder":"placeholder","placeholder-title":"placeholder-title","icon":"icon"};

/***/ },

/***/ "TawE":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"calendar_container":"calendar_container","lesson_container":"lesson_container","time":"time","lesson_name":"lesson_name"};

/***/ },

/***/ "jPUq":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _alert = __webpack_require__("BGi1");
	
	var _locale = __webpack_require__("pthR");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StatisticDisplay = function (_Component) {
	  _inherits(StatisticDisplay, _Component);
	
	  function StatisticDisplay() {
	    _classCallCheck(this, StatisticDisplay);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  StatisticDisplay.prototype.navigateToPage = function navigateToPage(page) {
	    _reactRouter.browserHistory.push('/' + page + '/');
	  };
	
	  StatisticDisplay.prototype.render = function render() {
	    var _this2 = this;
	
	    var data_up_to_now = this.props.data.data_up_to_now;
	
	    if (data_up_to_now) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'statistic-container block-wrapper' },
	        _react2.default.createElement(
	          _R2.default,
	          { can: 'student_channel', by: 'alert', className: 'r-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'data-wrapper', onClick: function onClick() {
	                return _this2.navigateToPage('student');
	              } },
	            _react2.default.createElement(
	              'span',
	              { className: 'number' },
	              data_up_to_now.student_amount
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'description' },
	              __('Registered Students', _locale2.default)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _R2.default,
	          { can: 'teacher_channel', by: 'alert' },
	          _react2.default.createElement(
	            'div',
	            { className: 'data-wrapper', onClick: function onClick() {
	                return _this2.navigateToPage('teacher');
	              } },
	            _react2.default.createElement(
	              'span',
	              { className: 'number' },
	              data_up_to_now.teacher_amount
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'description' },
	              __('Registered Teachers', _locale2.default)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _R2.default,
	          { can: 'class_channel', by: 'alert' },
	          _react2.default.createElement(
	            'div',
	            { className: 'data-wrapper', onClick: function onClick() {
	                return _this2.navigateToPage('class');
	              } },
	            _react2.default.createElement(
	              'span',
	              { className: 'number' },
	              data_up_to_now.class_amount
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'description' },
	              __('Classes', _locale2.default)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _R2.default,
	          { can: 'private_class_channel', by: 'alert' },
	          _react2.default.createElement(
	            'div',
	            { className: 'data-wrapper', onClick: function onClick() {
	                return _this2.navigateToPage('one_one');
	              } },
	            _react2.default.createElement(
	              'span',
	              { className: 'number' },
	              data_up_to_now.private_class_amount
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'description' },
	              __('Private Classes', _locale2.default)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _R2.default,
	          { can: 'contact_channel', by: 'alert' },
	          _react2.default.createElement(
	            'div',
	            { className: 'data-wrapper', onClick: function onClick() {
	                if ((0, _R.isBasicUser)()) {
	                  _alert.alert.warning(__('Please upgrade to higher subscription plan to unlock this feature', _locale2.default));
	                } else {
	                  _this2.navigateToPage('contacts');
	                }
	              } },
	            _react2.default.createElement(
	              'span',
	              { className: 'number' },
	              data_up_to_now.contact_amount
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'description' },
	              __('Contacts', _locale2.default)
	            )
	          )
	        )
	      );
	    } else {
	      return _react2.default.createElement('span', null);
	    }
	  };
	
	  return StatisticDisplay;
	}(_react.Component);
	
	exports.default = StatisticDisplay;
	module.exports = exports['default'];

/***/ },

/***/ "pthR":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'Dashboard',
	  code: 'CN',
	  text: {
	    'Dashboard': '仪表盘',
	    "Today's Lessons": '当日课程',
	    "Recent Activity Log": '最近的操作记录',
	    "More": "查看更多",
	    'Registered Students': '在读学生',
	    'Registered Teachers': '在职老师',
	    'Classes': '班级',
	    'Private Classes': '私课',
	    'Contacts': '联系人',
	    'Date': '日期',
	    'Percentage': '百分比',
	    'Past {numberOfDays} days': '过去{numberOfDays}天',
	    'Quantity': '数量',
	    'Attending Rate': '出勤率',
	    'Absent Rate': '缺勤率',
	    'From Poster': '海报报名',
	    'From Reception': '直接添加',
	    'From Contact': '联系人转换',
	    'No Lesson Data': '暂无课程数据',
	    'No New Registration': '暂无新注册学生',
	    'No Activity Log': '暂无操作记录',
	    'No Checkin Data': '暂无签到数据',
	    'Attending and Absent Rate for All Classes': '所有班级出勤率与缺勤率',
	    'New Student Registration Data': '新学生注册数据',
	    'No Permission': '无权限',
	    'Please upgrade to higher subscription plan to unlock this feature': '请升级您的计划以解锁此功能',
	    'Lesson': '课节'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "DNRm":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main-container":"main-container","header":"header","left-container":"left-container","statistic-container":"statistic-container","data-wrapper":"data-wrapper","number":"number","select":"select","chart-wrapper":"chart-wrapper","right-container":"right-container","schedule-wrapper":"schedule-wrapper","log-wrapper":"log-wrapper","block-wrapper":"block-wrapper","description":"description","tooltip":"tooltip","tooltipDate":"tooltipDate","circle":"circle","description-wrapper":"description-wrapper","graph-labels":"graph-labels","graph-label":"graph-label"};

/***/ },

/***/ "7JCM":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FinanceTable = __webpack_require__("W6dJ");
	
	var _FinanceTable2 = _interopRequireDefault(_FinanceTable);
	
	var _UI = __webpack_require__("OM1Z");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Finance = function (_Component) {
	  _inherits(Finance, _Component);
	
	  function Finance(props) {
	    _classCallCheck(this, Finance);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  Finance.prototype.render = function render() {
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      { title: __('Financial Management', 'finance') },
	      _react2.default.createElement(
	        _UI.Tabs,
	        null,
	        _react2.default.createElement(_FinanceTable2.default, { type: 'all_record' })
	      )
	    );
	  };
	
	  return Finance;
	}(_react.Component);
	
	exports.default = Finance;
	module.exports = exports['default'];

/***/ },

/***/ "W6dJ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _reactBootstrap = __webpack_require__("3kvR");
	
	var _UI = __webpack_require__("OM1Z");
	
	var _constants = __webpack_require__("K30H");
	
	var _ducks = __webpack_require__("7wYd");
	
	var _tableSettings = __webpack_require__("qNmV");
	
	var _tableSettings2 = _interopRequireDefault(_tableSettings);
	
	var _FilterBy = __webpack_require__("SdD8");
	
	var _FilterBy2 = _interopRequireDefault(_FilterBy);
	
	var _Export = __webpack_require__("M4e5");
	
	var _Export2 = _interopRequireDefault(_Export);
	
	var _OnBoardingNatural = __webpack_require__("PwUp");
	
	var _OnBoardingNatural2 = _interopRequireDefault(_OnBoardingNatural);
	
	var _constant = __webpack_require__("EO26");
	
	var _StudentName = __webpack_require__("hBDJ");
	
	var _StudentName2 = _interopRequireDefault(_StudentName);
	
	__webpack_require__("gBSJ");
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _locale = __webpack_require__("CT6A");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CONTROLLER_WIDTH = '10%';
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    gSubscription: state.gSubscription,
	    financeTable: state.financeTable
	  };
	};
	
	var FinanceTable = function (_Component) {
	  _inherits(FinanceTable, _Component);
	
	  function FinanceTable(props) {
	    _classCallCheck(this, FinanceTable);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      filterData: {},
	      fetchTradeRecordParams: {
	        student_id_list: props.type == 'student_record' ? props.studentIds : null
	      }
	    };
	
	    if (props.type == 'student_record') {
	      if (!Array.isArray(props.studentIds)) {
	        throw new Error('When type is \'student_record\', eg: studentIds={[1,2,3]} is required.');
	      }
	      _this.state.defaultFilterTypes = ['class', 'daterange', 'text:transaction_number'];
	    } else if (props.type == 'all_record') {
	      _this.state.defaultFilterTypes = ['student', 'class', 'daterange', 'text:transaction_number'];
	    }
	
	    _this.state.filterTypes = _this.state.defaultFilterTypes;
	
	    _this.fetchTradeRecord = _this.fetchTradeRecord.bind(_this);;
	    _this.onFilterChange = _this.onFilterChange.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.onItemsCountPerPageChange = _this.onItemsCountPerPageChange.bind(_this);
	    _this.filterOptions = {
	      class: {
	        selectMultiple: true,
	        disabled: !(0, _R.userCan)('class_channel') || !(0, _R.userCan)('private_class_channel')
	      },
	      student: {
	        selectMultiple: true,
	        onlyFetchCurrent: false,
	        disabled: !(0, _R.userCan)('student_channel')
	      },
	      'text:transaction_number': {
	        placeholder: __('E-Receipt Number', 'finance')
	      }
	    };
	    return _this;
	  }
	
	  FinanceTable.prototype.componentWillMount = function componentWillMount() {
	    this.fetchTradeRecord();
	  };
	
	  FinanceTable.prototype.exportTradeRecord = function exportTradeRecord(format) {
	    var fetchTradeRecordParams = this.state.fetchTradeRecordParams;
	
	
	    (0, _Export2.default)({
	      type: 'finance',
	      title: 'Export Transaction Records',
	      format: format,
	      params: fetchTradeRecordParams
	    });
	  };
	
	  FinanceTable.prototype.fetchTradeRecord = function fetchTradeRecord(paginationIn) {
	    var pagination = this.props.financeTable.pagination;
	    var _props = this.props,
	        dispatch = _props.dispatch,
	        studentId = _props.studentId;
	    var fetchTradeRecordParams = this.state.fetchTradeRecordParams;
	
	
	    var paginationParams = _extends({}, pagination, paginationIn);
	    var schoolId = localStorage.getItem('schoolId');
	
	    dispatch((0, _ducks.fetchTradeRecord)(schoolId, fetchTradeRecordParams, paginationParams));
	  };
	
	  FinanceTable.prototype.onPageChange = function onPageChange(activePage) {
	    if (activePage == this.props.financeTable.activePage) {
	      return;
	    }
	
	    this.fetchTradeRecord({
	      activePage: activePage
	    });
	  };
	
	  FinanceTable.prototype.onItemsCountPerPageChange = function onItemsCountPerPageChange(itemsCountPerPage) {
	    this.fetchTradeRecord({
	      itemsCountPerPage: itemsCountPerPage
	    });
	  };
	
	  FinanceTable.prototype.onFilterChange = function onFilterChange(_ref) {
	    var _this2 = this;
	
	    var filterData = _ref.filterData,
	        lastFilterChanged = _ref.lastFilterChanged;
	
	    this.setState({
	      filterData: filterData,
	      lastFilterChanged: lastFilterChanged
	    }, function () {
	      _this2.filterList();
	    });
	  };
	
	  FinanceTable.prototype.filterList = function filterList() {
	    var _this3 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _state$filterData = this.state.filterData,
	        _state$filterData$stu = _state$filterData.student,
	        student = _state$filterData$stu === undefined ? {} : _state$filterData$stu,
	        daterange = _state$filterData.daterange,
	        transaction_number = _state$filterData.transaction_number;
	
	    var cls = this.state.filterData.class || {};
	    var lastFilterChanged = this.state.lastFilterChanged;
	    var type = this.props.type;
	
	
	    var filterTypes = Array.from(this.state.filterTypes);
	
	    if (type == 'all_record') {
	      if (lastFilterChanged == 'student') {
	        filterTypes = ['student', 'class', 'daterange', 'text:transaction_number'];
	      }
	
	      if (lastFilterChanged == 'class') {
	        filterTypes = ['student', 'class', 'daterange', 'text:transaction_number'];
	      }
	
	      if (!student.IDs && !cls.IDs) {
	        filterTypes = this.state.defaultFilterTypes;
	      }
	    }
	
	    var startEndDate = {};
	
	    if (daterange && daterange.startDate && daterange.endDate) {
	      startEndDate = {
	        start_date: daterange.startDate.format('YYYY-MM-DD'),
	        end_date: daterange.endDate.format('YYYY-MM-DD')
	      };
	    }
	
	    this.setState({
	      filterTypes: filterTypes,
	      fetchTradeRecordParams: _extends({
	        student_id_list: type == 'student_record' ? this.props.studentIds : student.IDs,
	        class_id_list: cls.IDs,
	        transaction_number: transaction_number
	      }, startEndDate)
	    }, function () {
	      _this3.fetchTradeRecord(_this3.state.fetchTradeRecordParams);
	    });
	  };
	
	  FinanceTable.prototype.checkStudentUpdate = function checkStudentUpdate(isUpdated) {
	    if (isUpdated) {
	      this.fetchTradeRecord();
	    }
	  };
	
	  FinanceTable.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props2 = this.props,
	        dispatch = _props2.dispatch,
	        type = _props2.type;
	
	
	    var fields = [{
	      name: 'transaction_date',
	      title: __('Date', 'class')
	    }, {
	      name: 'transaction_number',
	      title: __('E-Receipt No.', 'finance')
	    }, {
	      name: 'student_name',
	      title: __('Student', 'finance'),
	      getTdContent: function getTdContent(_ref2) {
	        var financeInfo = _ref2.trData;
	        var trStudent = financeInfo.trStudent,
	            student_name = financeInfo.student_name;
	
	        return _react2.default.createElement(_StudentName2.default, { id: trStudent, name: student_name, checkStudentUpdate: function checkStudentUpdate(isUpdated) {
	            return _this4.checkStudentUpdate(isUpdated);
	          } });
	      }
	    }, {
	      name: 'class_name',
	      title: __('Class', 'student'),
	      getTdContent: function getTdContent(_ref3) {
	        var financeInfo = _ref3.trData;
	
	        return financeInfo.class_name ? financeInfo.class_name : __('School Credit', 'PaymentModal');
	      }
	    }, {
	      name: 'trType',
	      title: __('Charge/Refund', 'finance'),
	      getTdContent: function getTdContent(_ref4) {
	        var financeInfo = _ref4.trData;
	
	        return financeInfo.trType == 1 ? __('Charge', 'finance') : __('Refund', 'finance');
	      }
	    }, {
	      name: 'trTransactionAmount',
	      title: __('Amount', 'finance'),
	      getTdContent: function getTdContent(_ref5) {
	        var financeInfo = _ref5.trData;
	
	        return financeInfo.trTransactionAmount.replace(/\.00/, '') + 'CAD';
	      }
	    }, {
	      name: 'discount_amount',
	      title: __('Discount Price', _locale2.default),
	      getTdContent: function getTdContent(_ref6) {
	        var financeInfo = _ref6.trData;
	
	        return financeInfo.discount_amount.replace(/\.00/, '') + 'CAD';
	      }
	    }, {
	      name: 'source_or_direction',
	      title: __('Payment Methods', 'finance'),
	      getTdContent: function getTdContent(_ref7) {
	        var financeInfo = _ref7.trData;
	
	        return _constants.PAYMENT_METHOD[financeInfo.source_or_direction];
	      }
	    }, {
	      name: 'trQuantity',
	      title: __('Purchased Lessons', 'finance'),
	      getTdContent: function getTdContent(_ref8) {
	        var financeInfo = _ref8.trData;
	
	        if (financeInfo.class_name.length == 0) {
	          return 'N/A';
	        } else if (financeInfo.trEndDate) {
	          return __('To', 'finance') + ' ' + financeInfo.trEndDate;
	        } else {
	          return Math.round(financeInfo.trQuantity) + __('', 'classdetail');
	        }
	      }
	    }, {
	      name: 'operator_name',
	      title: __('Operator', 'finance')
	    }];
	
	    var content = _constant.onBoardingContents;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _props$financeTable = this.props.financeTable,
	        _props$financeTable$l = _props$financeTable.list,
	        list = _props$financeTable$l === undefined ? [] : _props$financeTable$l,
	        _props$financeTable$f = _props$financeTable.fetching,
	        fetching = _props$financeTable$f === undefined ? false : _props$financeTable$f,
	        pagination = _props$financeTable.pagination,
	        hasPermission = _props$financeTable.hasPermission,
	        school_has_traderecord = _props$financeTable.school_has_traderecord;
	
	    this.tableSettings = _tableSettings2.default.call(this);
	
	    if (school_has_traderecord == false && content || hasPermission == false) {
	      return _react2.default.createElement(_OnBoardingNatural2.default, {
	        isShown: true,
	        title: content.title,
	        text: content.text,
	        image: content.image,
	        showArrow: content.showArrow
	      });
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'finance-table' },
	      _react2.default.createElement(
	        'div',
	        { className: 'util-section' },
	        _react2.default.createElement(_FilterBy2.default, {
	          filterData: this.state.filterData,
	          selectMultiple: true,
	          filters: this.state.filterTypes,
	          options: this.filterOptions,
	          schoolId: schoolId,
	          onChange: this.onFilterChange
	        }),
	        _react2.default.createElement(
	          _reactBootstrap.Dropdown,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Dropdown.Toggle,
	            { className: 'btn-defult expand-to-right expand-to-down' },
	            __('Export Record', _locale2.default)
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Dropdown.Menu,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.MenuItem,
	              {
	                eventKey: 'export-record',
	                onSelect: function onSelect() {
	                  _this4.exportTradeRecord('excel');
	                },
	                disabled: !(0, _R.userCan)('export_trade_record') || list.length === 0
	              },
	              __('To Excel', _locale2.default)
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.MenuItem,
	              {
	                eventKey: 'export-record',
	                onSelect: function onSelect() {
	                  _this4.exportTradeRecord('csv');
	                },
	                disabled: !(0, _R.userCan)('export_trade_record') || list.length === 0 },
	              __('To CSV', _locale2.default)
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_UI.Table, {
	        data: list,
	        fields: fields,
	        className: 'teacher-table',
	        settingThTitle: __('Settings', 'class'),
	        settingWidth: CONTROLLER_WIDTH,
	        settings: this.tableSettings,
	        useMultiSelection: false,
	        oneSettingPerRow: false,
	        fetching: fetching,
	
	        dropdownGuideWidth: 160,
	        dropdownGuideHeight: 228,
	
	        pagination: pagination,
	        usePagination: true,
	        onPageChange: this.onPageChange,
	        onItemsCountPerPageChange: this.onItemsCountPerPageChange
	      })
	    );
	  };
	
	  return FinanceTable;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(FinanceTable);
	module.exports = exports['default'];

/***/ },

/***/ "qNmV":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var _this = this;
	
	  return [{
	    title: __('Remarks', 'classdetail'),
	    hasAlert: function hasAlert(_ref) {
	      var trData = _ref.trData;
	
	      return trData.trRemark && trData.trRemark.length > 0;
	    },
	    onClick: function onClick(_ref2) {
	      var financeInfo = _ref2.trData;
	
	      (0, _Remarks2.default)({ id: financeInfo.id, type: 'finance' }).then(function (res) {
	        _this.fetchTradeRecord();
	      });
	    },
	    isDisabled: function isDisabled(opts) {
	      return !(0, _R.userCan)('edit_trade_record_note');
	    }
	  }, {
	    title: __('Send', 'finance'),
	    onClick: function onClick(_ref3) {
	      var financeInfo = _ref3.trData;
	
	      (0, _TransactionSummary2.default)({
	        id: financeInfo.id,
	        student: financeInfo.student_name,
	        transaction_number: financeInfo.transaction_number,
	        operator_name: financeInfo.operator_name,
	        student_email: financeInfo.student_email
	      });
	    },
	    isDisabled: function isDisabled(opts) {
	      return !(0, _R.userCan)('send_trade_record_email');
	    }
	  }];
	};
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	var _Remarks = __webpack_require__("EAm8");
	
	var _Remarks2 = _interopRequireDefault(_Remarks);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TransactionSummary = __webpack_require__("nWN0");
	
	var _TransactionSummary2 = _interopRequireDefault(_TransactionSummary);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ },

/***/ "EO26":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var locale = {
	  id: 'FinanceConstant',
	  code: 'CN',
	  text: {
	    "./images/finance-en.png": "./images/finance-cn.png",
	    'Real-Time Accurate Financial Management': '实时精确的财务管理',
	    'Here you can view all of your school’s payment details and monthly summary. You can easily filter your income and expenditure details and send transaction records to parents and students.': '您可以在这查看您学校所有的收支明细以及月度汇总。您可以对收支明细方便地进行筛选，还可以给家长学生发送交易记录。'
	  }
	};
	
	var onBoardingContents = exports.onBoardingContents = {
	  title: __('Real-Time Accurate Financial Management', locale),
	  text: __('Here you can view all of your school’s payment details and monthly summary. You can easily filter your income and expenditure details and send transaction records to parents and students.', locale),
	  image: __webpack_require__(11)(__('./images/finance-en.png', locale)),
	  showArrow: false
	};

/***/ },

/***/ 11:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./FinanceTable.scss": "gBSJ",
		"./constant": "EO26",
		"./constant.js": "EO26",
		"./ducks": "7wYd",
		"./ducks.js": "7wYd",
		"./images/finance-cn.png": "FY1h",
		"./images/finance-en.png": "67k3",
		"./index": "W6dJ",
		"./index.js": "W6dJ",
		"./locale": "CT6A",
		"./locale.js": "CT6A",
		"./table-settings": "qNmV",
		"./table-settings.js": "qNmV"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 11;


/***/ },

/***/ "gBSJ":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"finance-table":"finance-table","filter-by":"filter-by","filter-by-field":"filter-by-field","util-section":"util-section"};

/***/ },

/***/ "FY1h":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "finance-cn.1c991af8.png";

/***/ },

/***/ "67k3":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "finance-en.b13632b1.png";

/***/ },

/***/ "CT6A":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'FinanceTable',
	  code: 'CN',
	  text: {
	    'Discount Price': '折扣金额',
	    'Export Record': '导出记录',
	    'To Excel': 'Excel格式',
	    'To CSV': 'CSV格式'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "6YbS":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <ImportDataTable 
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children 
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _locale = __webpack_require__("Wgx6");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("t2fR");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GENDER = ['Male', 'Female', 'Other', 'None'];
	
	var ImportDataTable = (_temp = _class = function (_React$Component) {
	  _inherits(ImportDataTable, _React$Component);
	
	  function ImportDataTable(props) {
	    _classCallCheck(this, ImportDataTable);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ImportDataTable.prototype.componentWillMount = function componentWillMount() {};
	
	  ImportDataTable.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        fields = _props.fields,
	        theads = _props.theads,
	        errors = _props.errors,
	        filename = _props.filename;
	
	
	    var errorNum = 0;
	
	    _.each(errors, function (err) {
	      if (err) {
	        errorNum += Object.keys(err).length;
	      }
	    });
	
	    var rowNum = data.length;
	
	    var hasError = errorNum > 0;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'ImportDataTable' },
	      hasError && _react2.default.createElement(
	        'div',
	        { className: 'errorNotice' },
	        _react2.default.createElement('i', { className: 'fa icon-attention-circled' }),
	        '  ',
	        __('Your import, file {filename} has {rowNum} rows, and {errorNum} errors.', _locale2.default, { filename: filename, rowNum: rowNum, errorNum: errorNum })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'TableWrapper' },
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement('th', null),
	              theads.map(function (_ref, key) {
	                var label = _ref.label,
	                    required = _ref.required;
	
	                return _react2.default.createElement(
	                  'th',
	                  { key: key },
	                  label,
	                  ' ',
	                  required && _react2.default.createElement(
	                    'span',
	                    { className: 'required' },
	                    '*'
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            data.map(function (tr, trIdx) {
	              var error = errors[trIdx];
	              return _react2.default.createElement(
	                'tr',
	                { key: trIdx, className: (0, _classnames2.default)({ hasError: typeof error !== 'undefined' }) },
	                _react2.default.createElement(
	                  'td',
	                  { className: 'trIndex' },
	                  trIdx + 1
	                ),
	                tr.map(function (td, tdIdx) {
	                  var keyName = fields[tdIdx];
	                  var hasError = false;
	
	                  if (error && error[keyName]) {
	                    hasError = true;
	                  }
	
	                  if (keyName === 'gender') {
	                    td = __(GENDER[td], _locale2.default);
	                  }
	
	                  return _react2.default.createElement(
	                    'td',
	                    { key: tdIdx, className: (0, _classnames2.default)({ hasError: hasError }) },
	                    td
	                  );
	                })
	              );
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return ImportDataTable;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = ImportDataTable;
	module.exports = exports['default'];

/***/ },

/***/ "Wgx6":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'ImportStudent',
	  code: 'CN',
	  text: {
	    'Follow the CSV template provided below': '请遵循提供的CSV表格模板格式',
	    "If you would like to import students with customized data fields, please set it up at 'Administration'-->'Students'-->'Student Custom Fields'": "如果您的学生资料包括自定义项, 导入前请先在 '教务管理' --> '学员' --> '学员自定义字段' 进行设定",
	    "Date has to be in format of 'YYYY-MM-DD'": "日期/生日格式必须为 'YYYY-MM-DD'",
	    "Gender has to be either letter 'M' or 'F' or 'N/A'": "学生性别必须为字母 'M' 或 'F' 或 'N/A' (M代表男, F代表女, N/A代表未提供)",
	    "Email has to be in format of 'xxxx@xxx.xxx'": "邮件格式必须为 'xxxx@xxx.xxx'",
	    'Student Import Rules': '批量上传学生规则',
	    'Modify your CSV file with our CSV template to help you import students at once': '您可以通过下载CSV表格模板，将学生数据按规则填入CSV表格中，一次性导入系统',
	    'Drag and drop your CSV file here': '拖拽包含学员信息的CSV表格到这里',
	    'Phone number is consisted with a Country code following by the phone number (numbers only, no space or other characters)': '电话号码格式为: 国家区号加上本地电话号 (必须为数字, 不能包含空格和任何其他字符)',
	    "Value of the 'select' (single choice) custom field has to be only one of its choices": "单选项的自定义字段输入值只能为其众多选项之一",
	    "Value of the 'checkbox' (multiple choice) custom field has to be one or more of its choices, seperated by comma. For example: 'english, math, science'": "多选项的自定义字段输入值可以为其所有选项的一个或多个, 并用逗号隔开, 例如: '篮球, 滑雪, 游泳'",
	    'Or select a file from your computer...': '或者在您的电脑中选择CSV表格',
	    'We found errors in your data. Please make sure to enter correct information.': '我们在即将导入的数据中发现了一些错误，请确认这些信息是否符合导入规则或是否有错误。',
	    'Your import, file {filename} has {rowNum} rows, and {errorNum} errors.': '您即将导入的CSV表格文件({filename})中有{rowNum}行，有{errorNum}个错误。',
	    'Please review your data and click confirm to import.': '请检查您的数据，无误后单击确认开始导入',
	    'Student Imports': '学生导入',
	
	    'Remove': '删除',
	    'Upload': '上传',
	    'Finish': '完成',
	    'Download CSV template': '下载CSV表格模板',
	
	    'Upload CSV': '上传CSV',
	    'Import': '导入',
	
	    'Male': '男',
	    'Female': '女',
	    'Other': '其他',
	    'None': '无',
	    'Required column contains empty fields': '此必填项存在空数据',
	    'Gender must be M or F': '性别必须为 M 或 F',
	    'Contains invalid phone numbers (A country code followed by phone number, numbers only, no space or other characters)': '此项数据中的手机号码格式存在错误(国家区号加上电话号码, 只能为数字, 不能包含空格和其他字符)',
	    "Contains invalid date format (it has to be in format of 'YYYY-MM-DD')": "此项数据中日期格式存在错误 (格式为: 'YYYY-MM-DD')",
	    "Contains invalid email format (it has to be in format of 'xxxx@xxx.xxx')": "此项数据中邮箱格式存在错误 (格式为: 'xxxx@xxx.xxx')",
	    'Contains invalid selection options': '此项数据中包含错误的单选项',
	    "Contains invalid checkbox options": '此项数据中包含错误的多选项',
	    'Step {currentStep} of {totalStep}:': '进度 {currentStep}/{totalStep}：',
	    'Which column contains the {label} of your students?': '右边哪一列数据包含学生的{label}',
	    'Previous step': '上一步',
	    'Skip this step': '跳过此步',
	    'Basic Fields Mapping': '基本资料项匹配',
	    'Custom Fields Mapping': '自定义资料项匹配',
	    'Field Type': '类型',
	    'Options': '选项',
	    'text': '文本',
	    'select': '单选',
	    'checkbox': '多选',
	    'Back to Basic Fields': '回到基本资料',
	    'Back to Custom Fields': '回到自定义资料',
	    'Firstname': '名字',
	    'Lastname': '姓氏',
	    'Gender': '性别',
	    'DOB': '生日',
	    'Student Phone': '学生电话',
	    'Student Email': '学生邮箱',
	    'Unit No.': '房间号',
	    'Street': '街道名',
	    "City": '城市',
	    'Province/State': '省/州',
	    'Country': '国家',
	    'Postal Code': '邮编',
	    'Nickname': '学员昵称',
	    'Remark': '备注',
	    'Primary Guardian Name': '家长1姓名',
	    'Primary Guardian Phone': '家长1电话',
	    'Primary Guardian Email': '家长1邮箱',
	    'Primary Guardian Relationship': '家长1关系',
	    'Secondary Guardian Name': '家长2姓名',
	    'Secondary Guardian Phone': '家长2电话',
	    'Secondary Guardian Email': '家长2邮箱',
	    'Secondary Guardian Relationship': '家长2关系',
	    'Map Basic Fields': '匹配基本资料项',
	    'Map Custom Fields': '匹配自定义资料项',
	    'Select this column': '选择此项',
	    '{number} more rows': '还有{number}行数据',
	    'Column': '列',
	    'Mapped as': '匹配至',
	    'Ready to Import': '准备上传',
	    'Import Successful': '导入成功',
	    'We have imported all your students': '我们已成功上传您所有的学生。'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "t2fR":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ImportDataTable":"ImportDataTable","TableWrapper":"TableWrapper","errorNotice":"errorNotice","required":"required","hasError":"hasError","trIndex":"trIndex"};

/***/ },

/***/ "wwyS":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ImportStudent":"ImportStudent","columnPicker":"columnPicker","Steps":"Steps","BreadCrumbs":"BreadCrumbs","Instruction":"Instruction","hasButton":"hasButton","DownloadBtn":"DownloadBtn","ConfirmBtn":"ConfirmBtn","RestartBtn":"RestartBtn","UploadZone":"UploadZone","Warning":"Warning","file":"file","deleteIconWrapper":"deleteIconWrapper","deleteIcon":"deleteIcon","mappingSteps":"mappingSteps","mappingButtons":"mappingButtons","mappedField":"mappedField","btn":"btn","columValue":"columValue","previousBtn":"previousBtn","nextBtn":"nextBtn","moreRowsText":"moreRowsText","colunmHeader":"colunmHeader","progressWrapper":"progressWrapper","sectionHeader":"sectionHeader","UploadZoneContent":"UploadZoneContent","importTitle":"importTitle","Step-1":"Step-1"};

/***/ },

/***/ "Stwu":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCsv = __webpack_require__("xdcN");
	
	var _locale = __webpack_require__("Wgx6");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <AttendanceTable
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var CSVTemplate = function (_React$Component) {
	  _inherits(CSVTemplate, _React$Component);
	
	  function CSVTemplate(props) {
	    _classCallCheck(this, CSVTemplate);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      currentStudentList: [],
	      currentStudentListDetail: {},
	      pastStudentList: [],
	      pastStudentListDetail: {},
	      doneFetchingCurrentStudents: false,
	      doneFetchingPastStudents: false,
	      customizedFields: [],
	      downloaded: false
	    };
	    _this.csvHeader = [];
	    _this.csvCurrentStudentList = [];
	    _this.csvPastStudentList = [];
	    _this.currentPageForCurrentList = 1;
	    _this.currentPageForPastList = 1;
	    _this.headers = [{ label: __('Firstname', _locale2.default), key: 'firstname' }, { label: __('Lastname', _locale2.default), key: 'lastname' }, { label: __('Gender', _locale2.default), key: 'gender' }, { label: __('DOB', _locale2.default), key: 'dob' }, { label: __('Student Phone', _locale2.default), key: 'studentPhone' }, { label: __('Nickname', _locale2.default), key: 'nickname' }, { label: __('Student Email', _locale2.default), key: 'studentEmail' }, { label: __('Street', _locale2.default), key: 'street' }, { label: __('Unit No.', _locale2.default), key: 'unitNum' }, { label: __('City', _locale2.default), key: 'city' }, { label: __('Province/State', _locale2.default), key: 'province' }, { label: __('Country', _locale2.default), key: 'country' }, { label: __('Postal Code', _locale2.default), key: 'postalCode' }, { label: __('Remark', _locale2.default), key: 'remark' }, { label: __('Primary Guardian Name', _locale2.default), key: 'guardian1Name' }, { label: __('Primary Guardian Relationship', _locale2.default), key: 'guardian1Relationship' }, { label: __('Primary Guardian Phone', _locale2.default), key: 'guardian1Phone' }, { label: __('Primary Guardian Email', _locale2.default), key: 'guardian1Email' }, { label: __('Secondary Guardian Name', _locale2.default), key: 'guardian2Name' }, { label: __('Secondary Guardian Relationship', _locale2.default), key: 'guardian2Relationship' }, { label: __('Secondary Guardian Phone', _locale2.default), key: 'guardian2Phone' }, { label: __('Secondary Guardian Email', _locale2.default), key: 'guardian2Email' }];
	    _this.data = [{
	      firstname: 'Nick',
	      lastname: 'Lee',
	      gender: 'M',
	      dob: '2001-01-01',
	      studentPhone: '16047280000',
	      nickname: 'Nicky',
	      studentEmail: 'nicklee@gmail.com',
	      street: '5611 Oak Street',
	      unitNum: '#1600',
	      city: 'Vancouver',
	      province: 'BC',
	      country: 'Canada',
	      postalCode: 'V5H0A3',
	      remark: 'He is interested in programming',
	      guardian1Name: 'Amy Lee',
	      guardian1Relationship: 'mother',
	      guardian1Phone: '16043211111',
	      guardian1Email: 'amylee@gmail.com',
	      guardian2Name: 'John Lee',
	      guardian2Relationship: 'father',
	      guardian2Phone: '17789909898',
	      guardian2Email: 'johnlee@gmail.cokm'
	    }];
	    if (_this.props.customFields && _this.props.customFields.fields) {
	      _this.props.customFields.fields.forEach(function (field) {
	        _this.headers.push({
	          label: field.label,
	          key: field.label
	        });
	        _this.data[0][field.label] = '-';
	      });
	    }
	    return _this;
	  }
	
	  CSVTemplate.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'downloadBtnWrapper' },
	      _react2.default.createElement(
	        _reactCsv.CSVLink,
	        {
	          data: this.data,
	          headers: this.headers,
	          filename: 'Student-Import-Template.csv',
	          className: 'btn btn-primary',
	          target: '_self'
	        },
	        __('Download CSV template', _locale2.default)
	      )
	    );
	  };
	
	  return CSVTemplate;
	}(_react2.default.Component);
	
	exports.default = CSVTemplate;
	module.exports = exports['default'];

/***/ },

/***/ "27YW":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp; /**
	                    * <ImportStudent 
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children 
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _papaparse = __webpack_require__("lxTf");
	
	var _papaparse2 = _interopRequireDefault(_papaparse);
	
	var _downloadjs = __webpack_require__("sJst");
	
	var _downloadjs2 = _interopRequireDefault(_downloadjs);
	
	var _lodash = __webpack_require__("M4fF");
	
	var _Steps = __webpack_require__("g0/6");
	
	var _Steps2 = _interopRequireDefault(_Steps);
	
	__webpack_require__("wwyS");
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _Transition = __webpack_require__("X/qO");
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _reactDropzone = __webpack_require__("KTM0");
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _basicInfoFields = __webpack_require__("jAvG");
	
	var _basicInfoFields2 = _interopRequireDefault(_basicInfoFields);
	
	var _locale = __webpack_require__("Wgx6");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _alert = __webpack_require__("BGi1");
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _createBulkStudent = __webpack_require__("WpLP");
	
	var _createBulkStudent2 = _interopRequireDefault(_createBulkStudent);
	
	var _getStudentCustomFields = __webpack_require__("61c/");
	
	var _getStudentCustomFields2 = _interopRequireDefault(_getStudentCustomFields);
	
	var _csvTemplate = __webpack_require__("Stwu");
	
	var _csvTemplate2 = _interopRequireDefault(_csvTemplate);
	
	var _UI = __webpack_require__("OM1Z");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ACCEPT_MIME = 'text/csv';
	var MAX_SIZE = 5 * 1000 * 1000;
	var MIN_SIZE = 0;
	
	var DEFAULT_SEP = ';';
	
	// The every field must be submitted to the controller
	// so we must add these empty fields
	var EMPTY_STUDENT = {
	  ssFirstName: '',
	  ssLastName: '',
	  ssNickName: '',
	  ssGender: 3,
	  ssBirthday: null,
	  ssPhone: '',
	  ssHomePhone: '',
	  ssEmail: '',
	  ssSource: '',
	  ssSocialType: 0,
	  ssSocialID: '',
	  ssCountry: '',
	  ssProvince: '',
	  ssCity: '',
	  ssPostcode: '',
	  ssAddress: '',
	  ssRemark: '',
	  ssStudentCreateTime: null,
	  ssSuitNumber: '',
	  ssCode: '',
	  ssSchool: '',
	  ssStudent: '',
	
	  custom_data: {},
	
	  ssParentsName: '',
	  ssGuardianRelation: '',
	  ssParentsEmail: '',
	  ssParentsPhone: '',
	
	  ssParents2Name: '',
	  ssGuardian2Relation: '',
	  ssParents2Email: '',
	  ssParents2Phone: ''
	};
	
	var STUDENT_TO_SERVER = {
	  firstName: 'ssFirstName',
	  lastName: 'ssLastName',
	  nickName: 'ssNickName',
	  gender: 'ssGender',
	  dob: 'ssBirthday',
	  countryCode: 'ssPhone',
	  phone: 'ssPhone',
	  email: 'ssEmail',
	  country: 'ssCountry',
	  province: 'ssProvince',
	  city: 'ssCity',
	  postalCode: 'ssPostcode',
	  address: 'ssAddress',
	  remark: 'ssRemark',
	  suiteNumber: 'ssSuitNumber',
	  customDate: 'custom_data',
	  primaryGuardianName: 'ssParentsName',
	  primaryGuardianRelationship: 'ssGuardianRelation',
	  primaryGuardianEmail: 'ssParentsEmail',
	  primaryGuardianPhone: 'ssParentsPhone',
	  secondaryGuardianName: 'ssParents2Name',
	  secondaryGuardianRelationship: 'ssGuardian2Relation',
	  secondaryGuardianEmail: 'ssParents2Email',
	  secondaryGuardianPhone: 'ssParents2Phone'
	};
	var COUNTRY_CODE = ['1', '961', '61', '65'];
	var GENDER = ['M', 'F', 'N/A'];
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    subscription: state.gSubscription,
	    user: state.user
	  };
	};
	
	var ImportStudent = (_temp = _class = function (_React$Component) {
	  _inherits(ImportStudent, _React$Component);
	
	  function ImportStudent(props) {
	    _classCallCheck(this, ImportStudent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      activeStep: 0,
	      totalStep: 0,
	      fetching: true,
	      customFields: [],
	      file: undefined,
	      importedDataLabels: [],
	      selectedOption: [],
	      fieldColumns: [],
	      currentBasicMappingStep: 0,
	      currentCustomMappingStep: 0,
	      students: [],
	      hasCustomFields: false
	    };
	
	    _this.needToUpdateCustomField = false;
	
	    _this.goToNextStage = _this.goToNextStage.bind(_this);
	    _this.goToPreviousStage = _this.goToPreviousStage.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.onImport = _this.onImport.bind(_this);
	    _this.removeFile = _this.removeFile.bind(_this);
	    _this.processCSVData = _this.processCSVData.bind(_this);
	    _this.getFields = _this.getFields.bind(_this);
	    _this.execCreateBulkStudent = _this.execCreateBulkStudent.bind(_this);
	    _this.note = [__("Follow the CSV template provided below", _locale2.default), __("If you would like to import students with customized data fields, please set it up at 'Administration'-->'Students'-->'Student Custom Fields'", _locale2.default), __("Date has to be in format of 'YYYY-MM-DD'", _locale2.default), __("Gender has to be either letter 'M' or 'F' or 'N/A'", _locale2.default), __("Email has to be in format of 'xxxx@xxx.xxx'", _locale2.default), __("Phone number is consisted with a Country code following by the phone number (numbers only, no space or other characters)", _locale2.default), __("Value of the 'select' (single choice) custom field has to be only one of its choices", _locale2.default), __("Value of the 'checkbox' (multiple choice) custom field has to be one or more of its choices, seperated by comma. For example: 'english, math, science'", _locale2.default)];
	    return _this;
	  }
	
	  ImportStudent.prototype.componentWillMount = function componentWillMount() {
	    this.fetchSetting();
	  };
	
	  ImportStudent.prototype.fetchSetting = function fetchSetting() {
	    var _this2 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    (0, _getStudentCustomFields2.default)(schoolId).then(function (_ref) {
	      var student_fields_setting = _ref.student_fields_setting;
	
	      _this2.student_fields_setting = {};
	      if (student_fields_setting && student_fields_setting.fields.length > 0) {
	        _this2.student_fields_setting = student_fields_setting;
	        _this2.setState({
	          hasCustomFields: true
	        }, function () {
	          _this2.getFields();
	        });
	      } else {
	        _this2.getFields();
	      }
	      _this2.setState({
	        fetching: false
	      });
	    });
	  };
	
	  ImportStudent.prototype.removeFile = function removeFile() {
	    this.setState({
	      file: undefined,
	      activeStep: 0,
	      currentBasicMappingStep: 0,
	      currentCustomMappingStep: 0
	    });
	  };
	
	  ImportStudent.prototype.goToNextStage = function goToNextStage() {
	    this.setState({
	      activeStep: this.state.activeStep + 1
	    });
	  };
	
	  ImportStudent.prototype.goToPreviousStage = function goToPreviousStage(stage) {
	    var _state = this.state,
	        students = _state.students,
	        basicFields = _state.basicFields,
	        fieldColumns = _state.fieldColumns,
	        currentBasicMappingStep = _state.currentBasicMappingStep,
	        currentCustomMappingStep = _state.currentCustomMappingStep,
	        customFields = _state.customFields;
	
	    var columns = fieldColumns;
	
	    if (stage === 'basic') {
	      var toServerAttribute = STUDENT_TO_SERVER[basicFields[currentBasicMappingStep].name];
	      students.map(function (student) {
	        student[toServerAttribute] = '';
	      });
	      if (basicFields[currentBasicMappingStep].mappedColumnIndex !== null) {
	        columns[basicFields[currentBasicMappingStep].mappedColumnIndex].mappedfield = {};
	      }
	    } else {
	      students.map(function (student) {
	        student['custom_data'][customFields[currentCustomMappingStep].id] = '';
	      });
	      if (customFields[currentCustomMappingStep].mappedColumnIndex) {
	        columns[customFields[currentCustomMappingStep].mappedColumnIndex].mappedfield = {};
	      }
	    }
	    this.setState({
	      activeStep: stage === 'basic' ? 1 : 2,
	      fieldColumns: columns
	    });
	  };
	
	  ImportStudent.prototype.onDrop = function onDrop(accept, reject) {
	    var _this3 = this;
	
	    if (reject.length > 0) {
	      // TODO:
	    } else if (accept.length > 0) {
	      this.setState({
	        file: accept[0]
	      }, function () {
	        _this3.onImport();
	      });
	    }
	  };
	
	  ImportStudent.prototype.execCreateBulkStudent = function execCreateBulkStudent() {
	    var _this4 = this;
	
	    var students = this.state.students;
	    var subscription = this.props.subscription;
	    var _subscription$result = subscription.result,
	        saas_version = _subscription$result.saas_version,
	        maximum_amount = _subscription$result.maximum_amount,
	        existing_amount = _subscription$result.existing_amount,
	        is_valid = _subscription$result.is_valid;
	    var maximum_student = maximum_amount.maximum_student;
	    var student_amount = existing_amount.student_amount;
	
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    if (is_valid && (saas_version === 1 || maximum_student === null || student_amount + students.length <= maximum_student)) {
	      var studentsToServer = students.map(function (student) {
	        if (Object.keys(student.custom_data).length > 0) {
	          Object.keys(student.custom_data).forEach(function (key) {
	            if (student.custom_data[key] === '') {
	              delete student.custom_data[key];
	            }
	          });
	        }
	        return student;
	      });
	      (0, _createBulkStudent2.default)(schoolId, students).then(function (_ref2) {
	        var result = _ref2.result;
	
	        _this4.setState({
	          fetching: false
	        });
	        if (result === 'success') {
	          _reactRouter.browserHistory.push('/student');
	        } else {
	          _alert2.default.fail(__('Failed to import', _locale2.default, { num: studentArr.length }), __('Import Failed', _locale2.default));
	        }
	      });
	    } else {
	      _alert2.default.message(__('You are about go over the student limit, please upgrade to higher subscription plan to add more students', 'header'), __('Upgrade Subscription Plan', 'header'));
	    }
	  };
	
	  ImportStudent.prototype.getFields = function getFields() {
	    var _this5 = this;
	
	    var basicFields = [];
	    var customFields = [];
	    var tableFields = [];
	    var tableTheads = [];
	    var hasCustomFields = this.state.hasCustomFields;
	
	    _basicInfoFields2.default.map(function (_ref3) {
	      var name = _ref3.name,
	          label = _ref3.label,
	          required = _ref3.required,
	          isImportField = _ref3.isImportField;
	
	      if (isImportField && name !== 'countryCode') {
	        basicFields.push({ name: name, label: label, required: required, mappedColumnIndex: null });
	        _this5.setState({ selectedOption: [].concat(_this5.state.selectedOption, [null]) });
	      }
	    });
	    if (hasCustomFields) {
	      this.student_fields_setting.fields.map(function (field) {
	        var id = field.id,
	            label = field.label,
	            required = field.required;
	
	        customFields.push(_extends({}, field, { name: id }));
	        tableTheads.push({ label: label, required: required });
	        tableFields.push(id);
	      });
	    }
	    this.setState({
	      basicFields: basicFields,
	      customFields: customFields,
	      tableTheads: tableTheads,
	      tableFields: tableFields
	    });
	  };
	
	  ImportStudent.prototype.onImport = function onImport() {
	    var _this6 = this;
	
	    var file = this.state.file;
	
	
	    this.setState({
	      fetching: true
	    });
	    _papaparse2.default.parse(file, {
	      complete: function complete(_ref4) {
	        var data = _ref4.data,
	            errors = _ref4.errors,
	            meta = _ref4.meta;
	
	        if (errors.length > 0) {
	          _this6.setState({
	            fetching: false
	          });
	          // TODO:
	        } else {
	          if (data.length > 0) {
	            var fieldColumns = [];
	            var formatedLabels = data[0].map(function (item, index) {
	              return { value: index, label: item };
	            });
	            _this6.setState({ importedDataLabels: formatedLabels });
	            var rowValues = data.slice(1);
	            formatedLabels.map(function (_ref5) {
	              var value = _ref5.value,
	                  label = _ref5.label;
	
	              var column = [];
	              rowValues.map(function (row) {
	                column.push(row[value]);
	              });
	              fieldColumns.push({ name: label, value: column, mappedfield: {} });
	            });
	            _this6.setState({ fieldColumns: fieldColumns });
	          }
	          _this6.processCSVData(data);
	        }
	        _this6.setState({ fetching: false });
	        _this6.goToNextStage();
	      }
	    });
	  };
	
	  ImportStudent.prototype.processCSVData = function processCSVData() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var customFields = this.state.customFields;
	
	    var students = [];
	
	    data.slice(1).map(function (row, realIdx) {
	      var customData = {};
	      customFields.map(function (_ref6) {
	        var id = _ref6.id;
	
	        customData[id] = '';
	      });
	      var emptyStudent = _extends({}, EMPTY_STUDENT, { custom_data: customData });
	      students.push(emptyStudent);
	    });
	    this.setState({ students: students });
	  };
	
	  ImportStudent.prototype.nextBasicStep = function nextBasicStep() {
	    var _state2 = this.state,
	        currentBasicMappingStep = _state2.currentBasicMappingStep,
	        basicFields = _state2.basicFields,
	        hasCustomFields = _state2.hasCustomFields;
	
	    if (currentBasicMappingStep == basicFields.length - 1) {
	      if (hasCustomFields) {
	        this.goToNextStage();
	      } else {
	        this.setState({
	          activeStep: this.state.activeStep + 2
	        });
	      }
	    } else {
	      this.setState({ currentBasicMappingStep: currentBasicMappingStep + 1 });
	    }
	  };
	
	  ImportStudent.prototype.previousBasicStep = function previousBasicStep() {
	    var _state3 = this.state,
	        students = _state3.students,
	        basicFields = _state3.basicFields,
	        fieldColumns = _state3.fieldColumns,
	        currentBasicMappingStep = _state3.currentBasicMappingStep;
	
	
	    var toServerAttribute = STUDENT_TO_SERVER[basicFields[currentBasicMappingStep - 1].name];
	    students.map(function (student) {
	      student[toServerAttribute] = '';
	    });
	    var columns = fieldColumns;
	    if (basicFields[currentBasicMappingStep - 1].mappedColumnIndex !== null) {
	      columns[basicFields[currentBasicMappingStep - 1].mappedColumnIndex].mappedfield = {};
	    }
	    this.setState({ currentBasicMappingStep: currentBasicMappingStep - 1, fieldColumns: columns });
	  };
	
	  ImportStudent.prototype.nextCustomStep = function nextCustomStep() {
	    var _state4 = this.state,
	        currentCustomMappingStep = _state4.currentCustomMappingStep,
	        customFields = _state4.customFields;
	
	    if (currentCustomMappingStep == customFields.length - 1) {
	      this.goToNextStage();
	    } else {
	      this.setState({ currentCustomMappingStep: currentCustomMappingStep + 1 });
	    }
	  };
	
	  ImportStudent.prototype.previousCustomStep = function previousCustomStep() {
	    var _state5 = this.state,
	        students = _state5.students,
	        currentCustomMappingStep = _state5.currentCustomMappingStep,
	        customFields = _state5.customFields,
	        fieldColumns = _state5.fieldColumns;
	
	    students.map(function (student) {
	      student['custom_data'][customFields[currentCustomMappingStep - 1].id] = '';
	    });
	    var columns = fieldColumns;
	    if (customFields[currentCustomMappingStep - 1].mappedColumnIndex) {
	      columns[customFields[currentCustomMappingStep - 1].mappedColumnIndex].mappedfield = {};
	    }
	    this.setState({ currentCustomMappingStep: currentCustomMappingStep - 1, fieldColumns: columns });
	  };
	
	  ImportStudent.prototype.validatePhoneNumber = function validatePhoneNumber(number) {
	    var validateResult = COUNTRY_CODE.map(function (code) {
	      var isValidPhone = false;
	      if ((0, _lodash.startsWith)(number, code)) {
	        isValidPhone = true;
	      }
	      return isValidPhone;
	    });
	    return validateResult.includes(true);
	  };
	
	  ImportStudent.prototype.validateBasicInputs = function validateBasicInputs(column) {
	    var _this7 = this;
	
	    var _state6 = this.state,
	        basicFields = _state6.basicFields,
	        currentBasicMappingStep = _state6.currentBasicMappingStep;
	
	    var isValid = true;
	    if (basicFields[currentBasicMappingStep].required) {
	      column.value.forEach(function (value) {
	        if (value.length < 1) {
	          isValid = false;
	        }
	      });
	      if (!isValid) {
	        return { result: isValid, error: __('Required column contains empty fields', _locale2.default) };
	      }
	    }
	    switch (basicFields[currentBasicMappingStep].name) {
	      case 'gender':
	        if (column.value.length > 0) {
	          column.value.forEach(function (value) {
	            if (!GENDER.includes(value)) {
	              isValid = false;
	            }
	          });
	        }
	        return { result: isValid, error: !isValid ? __('Gender must be M, F or N/A', _locale2.default) : '' };
	      case 'phone':
	      case 'primaryGuardianPhone':
	      case 'secondaryGuardianPhone':
	        var phoneReg = /^\d+$/;
	        column.value.forEach(function (value) {
	          if ((!_this7.validatePhoneNumber(value) || !phoneReg.test(value)) && value.length > 5) {
	            isValid = false;
	          }
	        });
	        return { result: isValid, error: !isValid ? __('Contains invalid phone numbers (A country code followed by phone number, numbers only, no space or other characters)', _locale2.default) : '' };
	      case 'dob':
	        var dobReg = /(\d{4})-(\d{2})-(\d{2})/;
	        column.value.forEach(function (value) {
	          if (!dobReg.test(value) && value.length > 0) {
	            isValid = false;
	          }
	        });
	        return { result: isValid, error: !isValid ? __("Contains invalid date format (it has to be in format of 'YYYY-MM-DD')", _locale2.default) : '' };
	      case 'email':
	      case 'primaryGuardianEmail':
	      case 'secondaryGuardianEmail':
	        var emailReg = /\S+@\S+\.\S+/;
	        column.value.forEach(function (value) {
	          if (!emailReg.test(value) && value.length > 0) {
	            isValid = false;
	          }
	        });
	        return { result: isValid, error: !isValid ? __("Contains invalid email format (it has to be in format of 'xxxx@xxx.xxx')", _locale2.default) : '' };
	      default:
	        return { result: true, error: '' };
	
	    }
	  };
	
	  ImportStudent.prototype.validateCustomInputs = function validateCustomInputs(column) {
	    var _state7 = this.state,
	        customFields = _state7.customFields,
	        currentCustomMappingStep = _state7.currentCustomMappingStep;
	
	    var isValid = true;
	    if (customFields[currentCustomMappingStep].required) {
	      column.value.forEach(function (value) {
	        if (value.length < 1) {
	          isValid = false;
	        }
	      });
	      if (!isValid) {
	        return { result: isValid, error: __('Required column contains empty fields', _locale2.default) };
	      }
	    }
	    switch (customFields[currentCustomMappingStep].type) {
	      case 'select':
	        column.value.forEach(function (value) {
	          var trimedValue = value.trim();
	          if (!customFields[currentCustomMappingStep].options.includes(trimedValue) && trimedValue.length > 0) {
	            isValid = false;
	          }
	        });
	        return { result: isValid, error: !isValid ? __("Contains invalid selection options", _locale2.default) : '' };
	      case 'checkbox':
	        column.value.forEach(function (value) {
	          if ((0, _lodash.difference)(value.split(',').map(function (item) {
	            return item.trim();
	          }), customFields[currentCustomMappingStep].options).length >= value.split(',').length && value.length > 0) {
	            isValid = false;
	          }
	        });
	        return { result: isValid, error: !isValid ? __("Contains invalid checkbox options", _locale2.default) : '' };
	      default:
	        return { result: true, error: '' };
	    }
	  };
	
	  ImportStudent.prototype.mapColumn = function mapColumn(column, index) {
	    var _state8 = this.state,
	        students = _state8.students,
	        basicFields = _state8.basicFields,
	        customFields = _state8.customFields,
	        fieldColumns = _state8.fieldColumns,
	        currentBasicMappingStep = _state8.currentBasicMappingStep,
	        currentCustomMappingStep = _state8.currentCustomMappingStep,
	        activeStep = _state8.activeStep,
	        hasCustomFields = _state8.hasCustomFields;
	
	    var validation = void 0;
	    if (activeStep === 1) {
	      var toServerAttribute = STUDENT_TO_SERVER[basicFields[currentBasicMappingStep].name];
	      validation = this.validateBasicInputs(column);
	      if (validation.result == true) {
	        students.map(function (student, index) {
	          if (basicFields[currentBasicMappingStep].name === 'gender') {
	            if (column.value[index] === 'M') {
	              student[toServerAttribute] = 0;
	            } else if (column.value[index] === 'F') {
	              student[toServerAttribute] = 1;
	            } else {
	              student[toServerAttribute] = 3;
	            }
	          } else if (basicFields[currentBasicMappingStep].name === 'dob' && column.value[index].length === 0) {
	            student[toServerAttribute] = null;
	          } else {
	            student[toServerAttribute] = column.value[index];
	          }
	        });
	        var columns = fieldColumns;
	        columns[index].selected = true;
	        columns[index].mappedfield = basicFields[currentBasicMappingStep];
	        var fields = basicFields;
	        fields[currentBasicMappingStep].mappedColumnIndex = index;
	        if (currentBasicMappingStep == basicFields.length - 1) {
	          this.setState({ fieldColumns: columns, basicFields: fields });
	          if (hasCustomFields) {
	            this.goToNextStage();
	          } else {
	            this.setState({
	              activeStep: this.state.activeStep + 2
	            });
	          }
	        } else {
	          this.setState({ currentBasicMappingStep: currentBasicMappingStep + 1, fieldColumns: columns, basicFields: fields });
	        }
	      } else {
	        _alert2.default.fail(__(validation.error, _locale2.default));
	      }
	    } else if (activeStep === 2) {
	      validation = this.validateCustomInputs(column);
	      if (validation.result == true) {
	        students.map(function (student, index) {
	          var customFieldId = customFields[currentCustomMappingStep].id;
	          if (customFields[currentCustomMappingStep].type === 'checkbox') {
	            student['custom_data'][customFieldId] = JSON.stringify(column.value[index].replace(/ *, */g, ",").split(','));
	          } else {
	            student['custom_data'][customFieldId] = column.value[index];
	          }
	        });
	        var _columns = fieldColumns;
	        _columns[index].selected = true;
	        _columns[index].mappedfield = customFields[currentCustomMappingStep];
	        var _fields = customFields;
	        _fields[currentCustomMappingStep].mappedColumnIndex = index;
	        if (currentCustomMappingStep == customFields.length - 1) {
	          this.setState({ fieldColumns: _columns, customFields: _fields });
	          this.goToNextStage();
	        } else {
	          this.setState({ currentCustomMappingStep: currentCustomMappingStep + 1, fieldColumns: _columns, customFields: _fields });
	        }
	      } else {
	        _alert2.default.fail(__(validation.error, _locale2.default));
	      }
	    }
	  };
	
	  ImportStudent.prototype.renderColumnPicker = function renderColumnPicker() {
	    var _this8 = this;
	
	    var fieldColumns = this.state.fieldColumns;
	
	    return fieldColumns.map(function (column, index) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'col-sm-4 columnPicker' },
	        _react2.default.createElement(
	          'h4',
	          { className: 'colunmHeader' },
	          __('Column', _locale2.default),
	          ' ',
	          index + 1
	        ),
	        _react2.default.createElement(
	          'table',
	          { style: { height: 220 } },
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement('th', { style: { width: '20%' } }),
	            _react2.default.createElement(
	              'th',
	              { style: { width: '80%' } },
	              column.name
	            )
	          ),
	          column.value.map(function (value, i) {
	            if (i < 5) {
	              return _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  i + 1
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'columValue' },
	                  value
	                )
	              );
	            }
	            return;
	          })
	        ),
	        column.value.length > 5 && _react2.default.createElement(
	          'div',
	          { className: 'moreRowsText' },
	          __('{number} more rows', _locale2.default, { number: column.value.length - 5 })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mappedField' },
	          Object.keys(column.mappedfield).length === 0 && _react2.default.createElement(
	            'button',
	            { className: 'btn', onClick: function onClick() {
	                return _this8.mapColumn(column, index);
	              } },
	            __('Select this column', _locale2.default)
	          ),
	          Object.keys(column.mappedfield).length > 0 && _react2.default.createElement(
	            'p',
	            null,
	            __('Mapped as', _locale2.default),
	            ' ',
	            column.mappedfield.label,
	            ' '
	          )
	        )
	      );
	    });
	  };
	
	  ImportStudent.prototype.renderMappingDescription = function renderMappingDescription() {
	    var _this9 = this;
	
	    var _state9 = this.state,
	        activeStep = _state9.activeStep,
	        currentBasicMappingStep = _state9.currentBasicMappingStep,
	        basicFields = _state9.basicFields,
	        customFields = _state9.customFields,
	        currentCustomMappingStep = _state9.currentCustomMappingStep,
	        hasCustomFields = _state9.hasCustomFields;
	
	    if (activeStep === 1) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-9 sectionHeader' },
	            __('Basic Fields Mapping', _locale2.default)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'progressWrapper' },
	          __('Step {currentStep} of {totalStep}:', _locale2.default, { currentStep: currentBasicMappingStep + 1, totalStep: basicFields.length, label: basicFields[currentBasicMappingStep].label }),
	          _react2.default.createElement(
	            'h2',
	            null,
	            __('{label}', _locale2.default, { currentStep: currentBasicMappingStep + 1, totalStep: basicFields.length, label: basicFields[currentBasicMappingStep].label })
	          ),
	          __('Which column contains the {label} of your students?', _locale2.default, { currentStep: currentBasicMappingStep + 1, totalStep: basicFields.length, label: basicFields[currentBasicMappingStep].label })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mappingButtons' },
	          currentBasicMappingStep > 0 && _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn previousBtn', onClick: function onClick() {
	                return _this9.previousBasicStep();
	              } },
	            __('Previous step', _locale2.default)
	          ),
	          currentBasicMappingStep < basicFields.length && _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn btn-primary nextBtn', onClick: function onClick() {
	                return _this9.nextBasicStep();
	              }, disabled: basicFields[currentBasicMappingStep].required },
	            __('Skip this step', _locale2.default)
	          )
	        )
	      );
	    } else if (activeStep === 2 && customFields.length > 0) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-9 sectionHeader' },
	            __('Custom Fields Mapping', _locale2.default)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'progressWrapper' },
	          __('Step {currentStep} of {totalStep}: ', _locale2.default, { currentStep: currentCustomMappingStep + 1, totalStep: customFields.length, label: customFields[currentCustomMappingStep].label }),
	          _react2.default.createElement(
	            'h3',
	            null,
	            __(customFields[currentCustomMappingStep].label, _locale2.default)
	          ),
	          __('Which column contains the {label} of your students?', _locale2.default, { currentStep: currentCustomMappingStep + 1, totalStep: customFields.length, label: customFields[currentCustomMappingStep].label })
	        ),
	        customFields[currentCustomMappingStep].type !== 'text' && _react2.default.createElement(
	          'div',
	          null,
	          __('Options', _locale2.default),
	          ': ',
	          customFields[currentCustomMappingStep].options.toString()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mappingButtons' },
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn previousBtn', onClick: function onClick() {
	                if (currentCustomMappingStep === 0) {
	                  _this9.goToPreviousStage('basic');
	                } else {
	                  _this9.previousCustomStep();
	                }
	              } },
	            currentCustomMappingStep === 0 ? __('Back to Basic Fields', _locale2.default) : __('Previous step', _locale2.default)
	          ),
	          currentCustomMappingStep < customFields.length && _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn btn-primary nextBtn', onClick: function onClick() {
	                return _this9.nextCustomStep();
	              }, disabled: customFields[currentCustomMappingStep].required },
	            __('Skip this step', _locale2.default)
	          )
	        )
	      );
	    } else {
	      return null;
	    }
	  };
	
	  ImportStudent.prototype.render = function render() {
	    var _this10 = this;
	
	    var _state10 = this.state,
	        activeStep = _state10.activeStep,
	        fetching = _state10.fetching,
	        file = _state10.file,
	        fieldColumns = _state10.fieldColumns,
	        hasCustomFields = _state10.hasCustomFields;
	
	
	    var steps = [{
	      label: __('Upload CSV', _locale2.default)
	    }, {
	      label: __('Map Basic Fields', _locale2.default)
	    }, {
	      label: __('Map Custom Fields', _locale2.default)
	    }, {
	      label: __('Import', _locale2.default)
	    }];
	
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      { className: 'ImportStudent' },
	      fetching && _react2.default.createElement(_Loading2.default, null),
	      fetching !== true && _react2.default.createElement(
	        _Transition2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'ImportStudentContent' },
	          _react2.default.createElement(
	            'div',
	            { className: 'BreadCrumbs' },
	            _react2.default.createElement(_Steps2.default, { steps: steps, activeStep: activeStep })
	          ),
	          activeStep === 0 && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              null,
	              __('Student Imports', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'importTitle' },
	              __("Modify your CSV file with our CSV template to help you import students at once", _locale2.default)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col-sm-8 Instruction', { hasButton: activeStep === 1 }) },
	              _react2.default.createElement(
	                'p',
	                null,
	                __('Student Import Rules', _locale2.default),
	                ': '
	              ),
	              this.note.map(function (note, key) {
	                return _react2.default.createElement(
	                  'p',
	                  { key: key },
	                  key + 1,
	                  '. ',
	                  __(note, _locale2.default)
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'Step-0' },
	              !file && _react2.default.createElement(
	                'div',
	                { className: 'UploadZone' },
	                _react2.default.createElement(_csvTemplate2.default, { customFields: this.student_fields_setting }),
	                _react2.default.createElement(_reactDropzone2.default, {
	                  accept: ACCEPT_MIME,
	                  multiple: false,
	                  className: 'zone',
	                  maxSize: MAX_SIZE,
	                  minSize: MIN_SIZE,
	                  onDrop: this.onDrop,
	                  children: _react2.default.createElement(
	                    'div',
	                    { className: 'UploadZoneContent' },
	                    _react2.default.createElement(
	                      'h2',
	                      null,
	                      __('Drag and drop your CSV file here', _locale2.default)
	                    ),
	                    _react2.default.createElement(
	                      'a',
	                      null,
	                      __('Or select a file from your computer...', _locale2.default)
	                    )
	                  )
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'Step-1 col-sm-4' },
	              file && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'file' },
	                  _react2.default.createElement('i', { className: 'fa icon-doc-text-text-o' }),
	                  ' ',
	                  file.name,
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'deleteIconWrapper', onClick: this.removeFile },
	                    _react2.default.createElement('i', { className: 'fa icon-cancel deleteIcon' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mappingSteps' },
	                  this.renderMappingDescription()
	                )
	              ),
	              activeStep === 3 && _react2.default.createElement(
	                'div',
	                { className: 'mappingSteps' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-9 sectionHeader' },
	                    __('Ready to Import', _locale2.default),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'mappingButtons' },
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'btn', onClick: function onClick() {
	                            return hasCustomFields ? _this10.goToPreviousStage('custom') : _this10.goToPreviousStage('basic');
	                          } },
	                        hasCustomFields ? __('Back to Custom Fields', _locale2.default) : __('Back to Basic Fields', _locale2.default)
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-primary', onClick: function onClick() {
	                            return _this10.execCreateBulkStudent();
	                          } },
	                        __('Import', _locale2.default)
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            file && fieldColumns && _react2.default.createElement(
	              'div',
	              { className: 'col-sm-8', style: { paddingLeft: 10, paddingRight: 10 } },
	              this.renderColumnPicker()
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ImportStudent;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(ImportStudent);
	module.exports = exports['default'];

/***/ },

/***/ "g0/6":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <Steps 
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children 
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("AQeU");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Steps = (_temp = _class = function (_React$Component) {
	  _inherits(Steps, _React$Component);
	
	  function Steps(props) {
	    _classCallCheck(this, Steps);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Steps.prototype.componentWillMount = function componentWillMount() {};
	
	  Steps.prototype.render = function render() {
	    var _props = this.props,
	        _props$steps = _props.steps,
	        steps = _props$steps === undefined ? [] : _props$steps,
	        activeStep = _props.activeStep,
	        className = _props.className;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('Steps', className) },
	      steps.map(function (_ref, idx) {
	        var label = _ref.label;
	
	        var complete = activeStep > idx;
	        return _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('StepItem', { active: activeStep === idx, complete: complete }), key: idx },
	          _react2.default.createElement(
	            'div',
	            { className: 'StepIndex' },
	            !complete && idx + 1,
	            complete && _react2.default.createElement('i', { className: 'fa icon-ok' })
	          ),
	          ' ',
	          _react2.default.createElement(
	            'span',
	            null,
	            label
	          )
	        );
	      })
	    );
	  };
	
	  return Steps;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = Steps;
	module.exports = exports['default'];

/***/ },

/***/ "AQeU":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Steps":"Steps","StepItem":"StepItem","StepIndex":"StepIndex","active":"active","complete":"complete","icon-ok":"icon-ok"};

/***/ },

/***/ "jAvG":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _locale = __webpack_require__("NFNt");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	  label: __('First Name', _locale2.default),
	  name: 'firstName',
	  required: true,
	  isImportField: true
	}, {
	  label: __('Last Name', _locale2.default),
	  name: 'lastName',
	  required: true,
	  isImportField: true
	}, {
	  label: __('Name', _locale2.default),
	  required: true,
	  isSettingItem: true
	}, {
	  label: __('Gender', _locale2.default),
	  name: 'gender',
	  // required: true,
	  isImportField: true,
	  isSettingItem: true
	}, {
	  label: __('DOB', _locale2.default),
	  name: 'dob',
	  // required: true,
	  isImportField: true,
	  isSettingItem: true
	}, {
	  label: __('Country Code', _locale2.default),
	  name: 'countryCode',
	  //required: true,
	  isImportField: true
	}, {
	  label: __('Mobile Number', _locale2.default),
	  name: 'phone',
	  //required: true,
	  isImportField: true,
	  isSettingItem: true
	}, {
	  label: __('Nickname', _locale2.default),
	  name: 'nickName',
	  isImportField: true,
	  isSettingItem: true
	}, {
	  label: __('Email', _locale2.default),
	  name: 'email',
	  required: false,
	  isImportField: true,
	  isSettingItem: true
	}, {
	  label: __('Current Address', _locale2.default),
	  isSettingItem: true
	}, {
	  label: __('Street', _locale2.default),
	  name: 'address',
	  isImportField: true
	}, {
	  label: __('Unit No.', _locale2.default),
	  name: 'suiteNumber',
	  isImportField: true
	}, {
	  label: __('City', _locale2.default),
	  name: 'city',
	  isImportField: true
	}, {
	  label: __('Province/States', _locale2.default),
	  name: 'province',
	  isImportField: true
	}, {
	  label: __('Country', _locale2.default),
	  name: 'country',
	  isImportField: true
	}, {
	  label: __('Postal Code', _locale2.default),
	  name: 'postalCode',
	  isImportField: true
	}, {
	  label: __('Remark', _locale2.default),
	  name: 'remark',
	  isImportField: true,
	  isSettingItem: true
	}, {
	  label: __('Primary Guardian Name', _locale2.default),
	  name: 'primaryGuardianName',
	  isImportField: true,
	  isSettingItem: true
	}, {
	  label: __('Primary Guardian Relationship', _locale2.default),
	  name: 'primaryGuardianRelationship',
	  isImportField: true,
	  isSettingItem: true
	}, {
	  label: __('Primary Guardian Phone', _locale2.default),
	  name: 'primaryGuardianPhone',
	  isImportField: true,
	  isSettingItem: true
	}, {
	  label: __('Primary Guardian Email', _locale2.default),
	  name: 'primaryGuardianEmail',
	  isImportField: true,
	  isSettingItem: true
	}, {
	  label: __('Secondary Guardian Name', _locale2.default),
	  name: 'secondaryGuardianName',
	  isImportField: true,
	  isSettingItem: true
	}, {
	  label: __('Secondary Guardian Relationship', _locale2.default),
	  name: 'secondaryGuardianRelationship',
	  isImportField: true,
	  isSettingItem: true
	}, {
	  label: __('Secondary Guardian Phone', _locale2.default),
	  name: 'secondaryGuardianPhone',
	  isImportField: true,
	  isSettingItem: true
	}, {
	  label: __('Secondary Guardian Email', _locale2.default),
	  name: 'secondaryGuardianEmail',
	  isImportField: true,
	  isSettingItem: true
	}];
	module.exports = exports['default'];

/***/ },

/***/ "NFNt":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
	  id: "StudentSettings",
	  code: "CN",
	  text: {
	    'Student': '学员',
	    'Input Fields Setting': '学生报名信息设置',
	    'Basic Info': '基本信息',
	    'Name': '学员姓名',
	    'Last Name': '学员姓',
	    'First Name': '学员名',
	    'Gender': '学员性别',
	    'DOB': '学员生日',
	    'Mobile Number': '学员手机',
	    'Nickname': '学员昵称',
	    'Email': '学生邮箱',
	    'Current Address': '现居地址',
	
	    'Country': '国家',
	    'Province/States': '地区',
	    'City': '城市',
	    'Street': '街道地址',
	    'Unit No.': '门牌号',
	    'Postal Code': '邮政编码',
	
	    'Remark': '备注',
	    'Primary Guardian Name': '家长1姓名',
	    'Primary Guardian Relationship': '家长1亲属关系',
	    'Primary Guardian Phone': '家长1电话',
	    'Primary Guardian Email': '家长1邮箱',
	    'Secondary Guardian Name': '家长2姓名',
	    'Secondary Guardian Relationship': '家长2亲属关系',
	    'Secondary Guardian Phone': '家长2电话',
	    'Secondary Guardian Email': '家长2邮箱',
	
	    'Country Code': '国家代码',
	
	    'Save': '保存'
	  }
	};
	module.exports = exports["default"];

/***/ },

/***/ "WpLP":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = createBulkStudent;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	var _updateStudentInfo = __webpack_require__("kxXT");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.array().items(_updateStudentInfo.schema);
	
	function createBulkStudent(schoolId, studentArray) {
	
	  if (!schoolId) {
	    throw 'missing school ID';
	  }
	  var validateResult = _joiBrowser2.default.validate(studentArray, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/stu_bulk_create/' + schoolId + '/',
	      'method': 'POST',
	      'data': JSON.stringify(studentArray),
	      'token': localStorage.getItem('token') }).then(function (_ref) {
	      var data = _ref.data;
	
	      resolve(data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "Y4ah":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _reactJsPagination = __webpack_require__("bgMy");
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _ducks = __webpack_require__("vvL0");
	
	var _locale = __webpack_require__("/jR7");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _typescript = __webpack_require__("wK0m");
	
	var _FilterBy = __webpack_require__("SdD8");
	
	var _FilterBy2 = _interopRequireDefault(_FilterBy);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _ActivityLog = __webpack_require__("zYlc");
	
	var _ActivityLog2 = _interopRequireDefault(_ActivityLog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var itemsCountPerPage = 20;
	
	var FILTER_OPTIONS = {
	  teacher: {
	    selectMultiple: false,
	    onlyFetchCurrent: false
	  }
	};
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    schoolLog: state.schoolLog,
	    subscription: state.gSubscription
	
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getSchoolLog: function getSchoolLog(schoolId, params) {
	      return dispatch((0, _ducks.getSchoolLog)(schoolId, params));
	    }
	  };
	};
	
	var Logs = function (_Component) {
	  _inherits(Logs, _Component);
	
	  function Logs(props) {
	    _classCallCheck(this, Logs);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      filterData: {},
	      filterTypes: ['teacher', 'daterange'],
	      activePage: 1
	    };
	
	    _this.onFilterChange = _this.onFilterChange.bind(_this);
	    _this.handlePageChange = _this.handlePageChange.bind(_this);
	    _this.isOutsideRange = _this.isOutsideRange.bind(_this);
	    _this.fetchLogs = _this.fetchLogs.bind(_this);
	
	    return _this;
	  }
	
	  Logs.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    this.setState({
	      defaultStartDate: (0, _moment2.default)().subtract(29, 'days')
	    }, function () {
	      _this2.fetchLogs();
	    });
	  };
	
	  Logs.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this3 = this;
	
	    if (JSON.stringify(this.props.subscription.result) !== JSON.stringify(nextProps.subscription.result)) {
	      this.setState({
	        defaultStartDate: (0, _moment2.default)().subtract(29, 'days')
	      }, function () {
	        _this3.fetchLogs();
	      });
	    }
	  };
	
	  Logs.prototype.onFilterChange = function onFilterChange(_ref) {
	    var _this4 = this;
	
	    var filterData = _ref.filterData;
	
	    this.setState({
	      filterData: filterData
	    }, function () {
	      _this4.fetchLogs();
	    });
	  };
	
	  Logs.prototype.fetchLogs = function fetchLogs() {
	    var schoolId = localStorage.getItem('schoolId');
	    var _state = this.state,
	        filterData = _state.filterData,
	        activePage = _state.activePage;
	    var teacher = filterData.teacher,
	        daterange = filterData.daterange;
	
	
	    var startEndDate = {
	      start_date: this.state.defaultStartDate.format('YYYY-MM-DD')
	    };
	    if (daterange && daterange.startDate && daterange.endDate) {
	      startEndDate = {
	        start_date: daterange.startDate.format('YYYY-MM-DD'),
	        end_date: daterange.endDate.format('YYYY-MM-DD')
	      };
	    }
	    var params = _extends({
	      school_teacher: teacher ? teacher.IDs[0] : null,
	      current_page_number: activePage,
	      amount_per_page: itemsCountPerPage
	    }, startEndDate);
	    this.props.getSchoolLog(schoolId, params);
	  };
	
	  Logs.prototype.handlePageChange = function handlePageChange(pageNumber) {
	    var _this5 = this;
	
	    this.setState({ activePage: pageNumber }, function () {
	      _this5.fetchLogs();
	    });
	  };
	
	  Logs.prototype.isOutsideRange = function isOutsideRange(day) {
	    var startingDate = (0, _moment2.default)().subtract(30, 'days');
	    return day.isAfter((0, _moment2.default)()) || day.isBefore(startingDate);
	  };
	
	  Logs.prototype.render = function render() {
	    var schoolId = localStorage.getItem('schoolId');
	    var _state2 = this.state,
	        activePage = _state2.activePage,
	        filterData = _state2.filterData;
	    var _props$schoolLog = this.props.schoolLog,
	        fetching = _props$schoolLog.fetching,
	        logs = _props$schoolLog.logs;
	
	    var totalTaskAmount = logs.total_task_amount;
	    var daterangeOptions = {
	      startDate: filterData.daterange && filterData.daterange.startDate ? filterData.daterange.startDate : this.state.defaultStartDate,
	      endDate: filterData.daterange && filterData.daterange.endDate ? filterData.daterange.endDate : '',
	      // endDatePlaceholderText: __('Today', 'teacherAttendance'),
	      isOutsideRange: this.isOutsideRange
	    };
	    var result_list = this.props.schoolLog.logs.result_list;
	
	
	    if (!result_list || fetching) {
	      return _react2.default.createElement(_Loading2.default, null);
	    }
	
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      { className: 'log-container', title: __('Activity Log', _locale2.default) },
	      _react2.default.createElement(_FilterBy2.default, {
	        filterData: this.state.filterData,
	        selectMultiple: true,
	        filters: this.state.filterTypes,
	        options: _extends({}, FILTER_OPTIONS, { daterange: daterangeOptions }),
	        schoolId: schoolId,
	        onChange: this.onFilterChange
	      }),
	      _react2.default.createElement(_ActivityLog2.default, { resultList: result_list }),
	      _react2.default.createElement(_reactJsPagination2.default, {
	        innerClass: 'pagination pull-left',
	        activePage: activePage,
	        itemsCountPerPage: itemsCountPerPage,
	        totalItemsCount: totalTaskAmount,
	        pageRangeDisplayed: 5,
	        onChange: this.handlePageChange
	      })
	    );
	  };
	
	  return Logs;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Logs);
	module.exports = exports['default'];

/***/ },

/***/ "/jR7":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'Log',
	  code: 'CN',
	  text: {
	    'Activity Log': '操作记录'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ 12:
/***/ function(module, exports) {

	/* (ignored) */

/***/ },

/***/ 13:
/***/ function(module, exports) {

	/* (ignored) */

/***/ },

/***/ 14:
/***/ function(module, exports) {

	/* (ignored) */

/***/ },

/***/ 15:
/***/ function(module, exports) {

	/* (ignored) */

/***/ },

/***/ "ZoQJ":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _alert = __webpack_require__("BGi1");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _datetime = __webpack_require__("2RW8");
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		alert: _alert.alert,
		confirm: _confirm2.default,
		datetime: _datetime2.default
	};
	module.exports = exports["default"];

/***/ },

/***/ "2RW8":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.getDay = getDay;
	exports.getTime = getTime;
	exports.getTimeIn24 = getTimeIn24;
	function getDay(date) {
	  var month = '0';
	  if (date.getMonth() <= 8) {
	    month += (date.getMonth() + 1).toString();
	  } else {
	    month = (date.getMonth() + 1).toString();
	  }
	  var day = '0';
	  if (date.getDate() < 10) {
	    day += date.getDate().toString();
	  } else {
	    day = date.getDate().toString();
	  }
	  return date.getFullYear() + '-' + month + '-' + day;
	}
	
	function getTime(date) {
	  return date.toLocaleTimeString();
	}
	
	function getTimeIn24(date) {
	  return date.toTimeString();
	}

/***/ },

/***/ 16:
/***/ function(module, exports) {

	/* (ignored) */

/***/ },

/***/ "vev/":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _reactMonthPicker = __webpack_require__("M2KA");
	
	var _reactMonthPicker2 = _interopRequireDefault(_reactMonthPicker);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SchoolAction = __webpack_require__("4ydO");
	
	var _index = __webpack_require__("VPji");
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__("Rwn/");
	
	__webpack_require__("7Rn2");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LANGUAGE = localStorage.getItem('language');
	var MONTHS = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    monthlyFinance: state.schMonthlyFinance
	  };
	};
	
	var locale = {
	  id: 'MonthlyFinance',
	  code: 'CN',
	  text: {
	    'MMMM YYYY': 'YYYY年MM月',
	    '': ''
	
	  }
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getMonthlyFinance: function getMonthlyFinance(schoolId, params) {
	      return dispatch((0, _SchoolAction.getSchoolMonthlyFinanceAction)(schoolId, params));
	    }
	  };
	};
	
	var MonthlyFinance = function (_React$Component) {
	  _inherits(MonthlyFinance, _React$Component);
	
	  function MonthlyFinance(props) {
	    _classCallCheck(this, MonthlyFinance);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      selectedYear: (0, _moment2.default)().subtract(1, 'months').get('year'),
	      selectedMonth: (0, _moment2.default)().subtract(1, 'months').get('month') + 1
	    };
	
	    _this.onDateChanged = _this.onDateChanged.bind(_this);
	    _this.onDateClicked = _this.onDateClicked.bind(_this);
	    return _this;
	  }
	
	  MonthlyFinance.prototype.componentDidMount = function componentDidMount() {
	    this.props.getMonthlyFinance(localStorage.getItem('schoolId'), {
	      start_date: (0, _moment2.default)().subtract(1, 'months').format("YYYY-MM-01"),
	      end_date: (0, _moment2.default)().subtract(1, 'months').endOf('month').format("YYYY-MM-DD"),
	      paging_or_not: 0,
	      summary: 1
	    });
	  };
	
	  MonthlyFinance.prototype.onDateClicked = function onDateClicked() {
	    this.refs.pickAMonth.show();
	  };
	
	  MonthlyFinance.prototype.onDateChanged = function onDateChanged(year, month) {
	
	    var newMonth = void 0;
	    var searchDate = void 0;
	    if (month < 10) {
	      newMonth = '0' + month;
	    } else {
	      newMonth = month;
	    }
	
	    searchDate = year + '-' + newMonth + '-01';
	
	    this.setState({ selectedYear: year, selectedMonth: month });
	    this.props.getMonthlyFinance(localStorage.getItem('schoolId'), {
	      start_date: (0, _moment2.default)(searchDate).format('YYYY-MM-DD'),
	      end_date: (0, _moment2.default)(searchDate).endOf('month').format("YYYY-MM-DD"),
	      paging_or_not: 0,
	      summary: 1
	    });
	    this.refs.pickAMonth.dismiss();
	  };
	
	  MonthlyFinance.prototype.render = function render() {
	    var _state = this.state,
	        selectedYear = _state.selectedYear,
	        selectedMonth = _state.selectedMonth;
	
	    return _react2.default.createElement(
	      _index2.default,
	      { className: 'monthly', title: __('Monthly Summary', 'monthlyFinance') },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-19 col-md-9' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            (0, _moment2.default)(selectedYear + '-' + selectedMonth, 'YYYY-MM').format(__('MMMM YYYY', locale))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-3 col-md-3', style: { marginTop: '32px', textAlign: 'right', color: '#255FEE' } },
	          _react2.default.createElement(
	            'div',
	            { onClick: this.onDateClicked, style: { cursor: 'pointer' } },
	            _react2.default.createElement('i', { className: 'fa icon-calendar fa-lg', 'aria-hidden': 'true' }),
	            _react2.default.createElement(
	              'span',
	              { style: { marginLeft: '10px' } },
	              __('Search by Date', 'monthlyFinance', null, true)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactMonthPicker2.default, {
	              ref: 'pickAMonth',
	              years: { min: { year: 2014, month: 1 }, max: { year: (0, _moment2.default)().subtract(1, 'months').get('year'), month: (0, _moment2.default)().subtract(1, 'months').get('month') + 1 } },
	              value: { year: this.state.selectedYear, month: this.state.selectedMonth },
	              lang: MONTHS,
	              theme: 'dark',
	              onChange: this.onDateChanged
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row', style: { fontSize: '24px', marginTop: '64px' } },
	        _react2.default.createElement(
	          'p',
	          { className: 'col-lg-6 col-md-6', style: { textAlign: 'left', color: '#9B9B9B' } },
	          __('Monthly Income', 'monthlyFinance', null, true)
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'col-lg-6 col-md-6', style: { textAlign: 'right' } },
	          this.props.monthlyFinance.total_income >= 0 ? '+' : '-',
	          this.props.monthlyFinance.total_income,
	          ' CAD'
	        )
	      ),
	      _react2.default.createElement('hr', { style: { borderColor: '#F2F2F2' } }),
	      _react2.default.createElement(
	        'div',
	        { className: 'row', style: { fontSize: '24px', marginTop: '50px' } },
	        _react2.default.createElement(
	          'p',
	          { className: 'col-lg-6 col-md-6', style: { textAlign: 'left', color: '#9B9B9B' } },
	          __('Monthly Spending', 'monthlyFinance', null, true)
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'col-lg-6 col-md-6', style: { textAlign: 'right' } },
	          this.props.monthlyFinance.total_refund >= 0 ? '-' : '+',
	          this.props.monthlyFinance.total_refund,
	          ' CAD'
	        )
	      ),
	      _react2.default.createElement('hr', { style: { borderColor: '#F2F2F2' } }),
	      _react2.default.createElement(
	        'div',
	        { className: 'row', style: { fontSize: '24px', marginTop: '50px' } },
	        _react2.default.createElement(
	          'p',
	          { className: 'col-lg-6 col-md-6', style: { textAlign: 'left', color: '#9B9B9B' } },
	          __('Net Income', 'monthlyFinance', null, true)
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'col-lg-6 col-md-6', style: { textAlign: 'right', color: '#FCAF3D' } },
	          this.props.monthlyFinance.total_income - this.props.monthlyFinance.total_refund >= 0 ? '+' : '-',
	          this.props.monthlyFinance.total_income - this.props.monthlyFinance.total_refund,
	          ' CAD'
	        )
	      ),
	      _react2.default.createElement('hr', { style: { borderColor: '#F2F2F2' } })
	    );
	  };
	
	  return MonthlyFinance;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MonthlyFinance);
	module.exports = exports['default'];

/***/ },

/***/ "7Rn2":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"monthly":"monthly","fa-lg":"fa-lg"};

/***/ },

/***/ "SL3g":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "ylUr":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("1/Q7");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("SL3g");
	
	var _UI = __webpack_require__("OM1Z");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentInformation = function (_Component) {
	  _inherits(PaymentInformation, _Component);
	
	  function PaymentInformation(props) {
	    _classCallCheck(this, PaymentInformation);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {};
	
	    return _this;
	  }
	
	  PaymentInformation.prototype.componentDidMount = function componentDidMount() {};
	
	  PaymentInformation.prototype.render = function render() {
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      { className: 'payment-information-container' },
	      _react2.default.createElement(
	        'div',
	        null,
	        'payment infomation'
	      )
	    );
	  };
	
	  return PaymentInformation;
	}(_react.Component);
	
	exports.default = PaymentInformation;
	module.exports = exports['default'];

/***/ },

/***/ "1/Q7":
/***/ function(module, exports) {

	"use strict";

/***/ },

/***/ "VtFU":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _OnBoardingNatural = __webpack_require__("PwUp");
	
	var _OnBoardingNatural2 = _interopRequireDefault(_OnBoardingNatural);
	
	var _constant = __webpack_require__("q61+");
	
	var _ducks = __webpack_require__("W/Ox");
	
	var _PosterList = __webpack_require__("VBOl");
	
	var _PosterList2 = _interopRequireDefault(_PosterList);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _updatePoster = __webpack_require__("xsdH");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	var _unlinkPoster2 = __webpack_require__("Jq3S");
	
	var _unlinkPoster3 = _interopRequireDefault(_unlinkPoster2);
	
	var _deletePoster2 = __webpack_require__("TOyY");
	
	var _deletePoster3 = _interopRequireDefault(_deletePoster2);
	
	var _reactJsPagination = __webpack_require__("bgMy");
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    gSubscription: state.gSubscription,
	    posterList: state.posterList
	  };
	};
	
	var DEFAULT_AMOUNT_PER_PAGE = 12;
	var locale = {
	  id: 'PosterList',
	  code: 'CN',
	  text: {
	    'There is at least one order made under the post. You cannot delete a post with an order.': '此海报已有人报名。无法删除。',
	    'There is at least one order made under the post. You cannot unlink a post with an order.': '此海报已有人报名。无法下架。'
	  }
	};
	
	var DefaultTab = function (_Component) {
	  _inherits(DefaultTab, _Component);
	
	  function DefaultTab(props) {
	    _classCallCheck(this, DefaultTab);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      activePage: 1
	    };
	    _this.fetchPosterList = _this.fetchPosterList.bind(_this);
	    _this.unlinkPoster = _this.unlinkPoster.bind(_this);
	    _this.deletePoster = _this.deletePoster.bind(_this);
	    _this.handlePageChange = _this.handlePageChange.bind(_this);
	    return _this;
	  }
	
	  DefaultTab.prototype.componentWillMount = function componentWillMount() {
	    this.fetchPosterList();
	  };
	
	  DefaultTab.prototype.fetchPosterList = function fetchPosterList() {
	    var _props = this.props,
	        dispatch = _props.dispatch,
	        posterState = _props.posterState;
	
	    var schoolId = localStorage.getItem('schoolId');
	    dispatch((0, _ducks.fetchPosterList)(schoolId, _updatePoster.STATE.indexOf(posterState), DEFAULT_AMOUNT_PER_PAGE, this.state.activePage));
	  };
	
	  DefaultTab.prototype.handlePageChange = function handlePageChange(pageNumber) {
	    var _this2 = this;
	
	    var _props2 = this.props,
	        dispatch = _props2.dispatch,
	        posterState = _props2.posterState;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    this.setState({ activePage: pageNumber }, function () {
	      dispatch((0, _ducks.fetchPosterList)(schoolId, _updatePoster.STATE.indexOf(posterState), DEFAULT_AMOUNT_PER_PAGE, _this2.state.activePage));
	    });
	  };
	
	  DefaultTab.prototype.onSelect = function onSelect(poster) {
	    _reactRouter.browserHistory.push('/poster-preview/' + poster.id);
	  };
	
	  DefaultTab.prototype.deletePoster = function deletePoster(id) {
	    var _this3 = this;
	
	    var dispatch = this.props.dispatch;
	
	
	    return function () {
	      (0, _confirm.confirm)(__('Are you sure you want to delete the poster?', 'poster'), __('Delete', 'poster')).then(function () {
	        (0, _deletePoster3.default)(id).then(function (res) {
	          if (res.result === "success") {
	            _this3.fetchPosterList();
	          } else {
	            _alert.alert.fail(__('There is at least one order made under the post. You cannot delete a post with an order.', locale));
	          }
	        });
	      }).catch(function (err) {});
	    };
	  };
	
	  DefaultTab.prototype.unlinkPoster = function unlinkPoster(id) {
	    var _this4 = this;
	
	    var dispatch = this.props.dispatch;
	
	
	    return function () {
	      (0, _confirm.confirm)(__('Are you sure you want to unlink the poster? The link will become invisible.', 'poster'), __('Unlink', 'poster')).then(function () {
	        (0, _unlinkPoster3.default)(id).then(function (res) {
	          var result = res.result,
	              reason = res.reason;
	
	          if (result === "success") {
	            _this4.fetchPosterList();
	          }
	          if (result === "failure" && reason === "The poster ticket(s) have(s) been ordered.") {
	            _alert.alert.fail(__('There is at least one order made under the post. You cannot unlink a post with an order.', locale));
	          }
	        });
	      });
	    };
	  };
	
	  DefaultTab.prototype.render = function render() {
	    var _props3 = this.props,
	        posterState = _props3.posterState,
	        posterList = _props3.posterList;
	    var count = posterList.count,
	        fetching = posterList.fetching,
	        list = posterList.list,
	        hasPermission = posterList.hasPermission,
	        school_has_poster = posterList.school_has_poster;
	
	
	    var content = _constant.onBoardingContents[posterState] || {};
	
	    if (fetching) {
	      return _react2.default.createElement(_Loading2.default, { onPanel: true });
	    }
	
	    if (content && school_has_poster == 0 || !hasPermission) {
	      return _react2.default.createElement(_OnBoardingNatural2.default, {
	        isShown: true,
	        title: content.title,
	        text: content.text,
	        image: content.image,
	        showArrow: content.showArrow
	      });
	    } else {
	      return _react2.default.createElement(
	        'div',
	        { className: 'poster--list--container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(_PosterList2.default, {
	            list: list,
	            count: count,
	            onSelect: this.onSelect,
	            onDelete: this.deletePoster,
	            onUnlink: this.unlinkPoster,
	            onFetch: this.fetchPosterList
	          })
	        ),
	        _react2.default.createElement(_reactJsPagination2.default, {
	          innerClass: 'pagination pull-right',
	          activePage: this.state.activePage,
	          itemsCountPerPage: DEFAULT_AMOUNT_PER_PAGE,
	          totalItemsCount: count,
	          pageRangeDisplayed: 5,
	          onChange: this.handlePageChange
	        })
	      );
	    }
	  };
	
	  return DefaultTab;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(DefaultTab);
	module.exports = exports['default'];

/***/ },

/***/ "q61+":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var locale = {
	  id: 'PosterConstant',
	  code: 'CN',
	  text: {
	    "./images/poster_en@2x.png": "./images/poster@2x.png",
	    "Create a Beautiful Poster Design Is Simple": '无需设计师也能制作精美营销海报',
	    "Not only will you be able to create a beautiful poster to share, it can also be used to sign up classes and activities, buying event tickets, and published surveys. Posters can be saved as a draft, or published and shared on WeChat, Facebook, and Twitter. Let's get started!": '不仅能排出精美的宣传海报，还附带各种报名功能，如课程/班级的报名注册，活动的报名，在线售票，以及调查问卷，制作好的海报可以存为草稿定时发布和分享到 Wechat, Facebook and Twitter 上。还等什么，快来体验吧'
	  }
	};
	
	var onBoardingContents = exports.onBoardingContents = {
	  // we show this when student state is 'current'
	  all: {
	    title: __('Create a Beautiful Poster Design Is Simple', locale),
	    text: __("Not only will you be able to create a beautiful poster to share, it can also be used to sign up classes and activities, buying event tickets, and published surveys. Posters can be saved as a draft, or published and shared on WeChat, Facebook, and Twitter. Let's get started!", locale),
	    image: __webpack_require__(17)(__('./images/poster_en@2x.png', locale)),
	    showArrow: true
	  }
	};

/***/ },

/***/ 17:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./DefaultTab": "VtFU",
		"./DefaultTab.js": "VtFU",
		"./EditPoster-archieve/AdvanceSettings": "NrvF",
		"./EditPoster-archieve/AdvanceSettings.js": "NrvF",
		"./EditPoster-archieve/DefaultEditor.scss": "DaH7",
		"./EditPoster-archieve/EditItem": "OSsy",
		"./EditPoster-archieve/EditItem.js": "OSsy",
		"./EditPoster-archieve/EditPoster.scss": "rNQa",
		"./EditPoster-archieve/OtherSettings": "esxL",
		"./EditPoster-archieve/OtherSettings.js": "esxL",
		"./EditPoster-archieve/RegistrationSetting": "jgoK",
		"./EditPoster-archieve/RegistrationSetting.js": "jgoK",
		"./EditPoster-archieve/Template": "43rz",
		"./EditPoster-archieve/Template.js": "43rz",
		"./EditPoster-archieve/TicketList": "SxNW",
		"./EditPoster-archieve/TicketList.js": "SxNW",
		"./EditPoster-archieve/TicketList.scss": "cmbB",
		"./EditPoster-archieve/ducks": "ygJX",
		"./EditPoster-archieve/ducks.js": "ygJX",
		"./EditPoster-archieve/index": "yA0B",
		"./EditPoster-archieve/index.js": "yA0B",
		"./EditPoster-archieve/locale": "7sYR",
		"./EditPoster-archieve/locale.js": "7sYR",
		"./EditPoster/EditPoster.scss": "avJc",
		"./EditPoster/Item": "K6Gm",
		"./EditPoster/Item.js": "K6Gm",
		"./EditPoster/Register/AdvanceSettings": "pYqi",
		"./EditPoster/Register/AdvanceSettings.js": "pYqi",
		"./EditPoster/Register/DefaultEditor.scss": "Wab1",
		"./EditPoster/Register/EditPoster.scss": "1SKC",
		"./EditPoster/Register/OtherSettings": "SGXh",
		"./EditPoster/Register/OtherSettings.js": "SGXh",
		"./EditPoster/Register/RegistrationSetting": "/J0p",
		"./EditPoster/Register/RegistrationSetting.js": "/J0p",
		"./EditPoster/Register/TicketList": "0rOf",
		"./EditPoster/Register/TicketList.js": "0rOf",
		"./EditPoster/Register/TicketList.scss": "hacQ",
		"./EditPoster/Register/locale": "4208",
		"./EditPoster/Register/locale.js": "4208",
		"./EditPoster/ducks": "srt+",
		"./EditPoster/ducks.js": "srt+",
		"./EditPoster/index": "OD49",
		"./EditPoster/index.js": "OD49",
		"./EditPoster/locale": "AfbW",
		"./EditPoster/locale.js": "AfbW",
		"./Poster.scss": "d05b",
		"./PosterList/PosterCard": "xrS3",
		"./PosterList/PosterCard.js": "xrS3",
		"./PosterList/PosterCard.scss": "JJH7",
		"./PosterList/PosterList.scss": "xBPE",
		"./PosterList/index": "VBOl",
		"./PosterList/index.js": "VBOl",
		"./PosterList/locale": "wrvU",
		"./PosterList/locale.js": "wrvU",
		"./RegistrationTable/ContactName": "Q38M",
		"./RegistrationTable/ContactName.js": "Q38M",
		"./RegistrationTable/RegistrationStatus": "YiFN",
		"./RegistrationTable/RegistrationStatus.js": "YiFN",
		"./RegistrationTable/RegistrationTable.scss": "NjDa",
		"./RegistrationTable/ducks": "2yUR",
		"./RegistrationTable/ducks.js": "2yUR",
		"./RegistrationTable/index": "2DGK",
		"./RegistrationTable/index.js": "2DGK",
		"./RegistrationTable/locale": "z80C",
		"./RegistrationTable/locale.js": "z80C",
		"./RegistrationTable/table-settings": "Qq2/",
		"./RegistrationTable/table-settings.js": "Qq2/",
		"./SaasPosterPreview/SaasPosterPreview.scss": "lHNU",
		"./SaasPosterPreview/index": "NT6U",
		"./SaasPosterPreview/index.js": "NT6U",
		"./constant": "q61+",
		"./constant.js": "q61+",
		"./ducks": "W/Ox",
		"./ducks.js": "W/Ox",
		"./images/poster@2x.png": "pTVQ",
		"./images/poster_en@2x.png": "Tupr",
		"./index": "WBJk",
		"./index.js": "WBJk"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 17;


/***/ },

/***/ "NrvF":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Fields = __webpack_require__("8/2o");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__("cmbB");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdvanceSettings = function (_Component) {
	  _inherits(AdvanceSettings, _Component);
	
	  function AdvanceSettings(props) {
	    _classCallCheck(this, AdvanceSettings);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  AdvanceSettings.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props$data = this.props.data,
	        startDate = _props$data.startDate,
	        startTime = _props$data.startTime,
	        endDate = _props$data.endDate,
	        endTime = _props$data.endTime,
	        price = _props$data.price,
	        noEndTime = _props$data.noEndTime,
	        auto_wait_list = _props$data.auto_wait_list;
	    var _props = this.props,
	        onChange = _props.onChange,
	        type = _props.type;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'advance-settings-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 advance-title' },
	          __('Advance Settings', 'ticket')
	        ),
	        _react2.default.createElement('hr', { className: 'advance-hr' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 advance-label' },
	          __('Registration Start Time', 'ticket')
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-6' },
	          _react2.default.createElement(_Fields.DatePicker, { value: startDate, onChange: onChange('startDate') })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-6' },
	          _react2.default.createElement(_Fields.TimePicker, { value: startTime, onChange: onChange('startTime') })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row' },
	        _react2.default.createElement(
	          'span',
	          { className: 'advance-label' },
	          __('Registration End Time', 'ticket')
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'no-end-time' },
	          _react2.default.createElement('input', { type: 'checkbox', onChange: onChange('noEndTime'), checked: noEndTime }),
	          _react2.default.createElement(
	            'span',
	            { className: 'advance-label' },
	            __('No End Time', 'ticket')
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-6' },
	          _react2.default.createElement(_Fields.DatePicker, { value: endDate, onChange: onChange('endDate'), disabled: noEndTime === true })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-6' },
	          _react2.default.createElement(_Fields.TimePicker, { value: endTime, onChange: onChange('endTime'), disabled: noEndTime === true })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 advance-label' },
	          __('Price', 'ticket'),
	          type == 'fixedAmount' && _react2.default.createElement(
	            'span',
	            { className: 'red' },
	            '*'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-6' },
	          _react2.default.createElement(_Fields.Money, { outputType: 'string', value: price, onChange: onChange('price') })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 advance-label wait-list-label' },
	          __('Waiting List', 'ticket'),
	          _react2.default.createElement(
	            'span',
	            { className: 'red' },
	            '*'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 wait-list' },
	          _react2.default.createElement('input', { type: 'radio', value: 'enterWaitList', onChange: onChange('auto_wait_list'), checked: auto_wait_list === 'enterWaitList' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'advance-label wait-list-input' },
	            __('Allow Waiting List', 'ticket')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 wait-list' },
	          _react2.default.createElement('input', { type: 'radio', value: 'noWaitList', onChange: onChange('auto_wait_list'), checked: auto_wait_list === 'noWaitList' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'advance-label wait-list-input' },
	            __('No Waiting List', 'ticket')
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row text-center' },
	        _react2.default.createElement('hr', { className: 'advance-hr' }),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn-link close-advance', onClick: function onClick() {
	              _this2.props.callbackFromParent({ showingAdvance: false });
	            } },
	          _react2.default.createElement('i', { className: 'fa icon-up-big' }),
	          __('Close Advance Settings', 'ticket')
	        )
	      )
	    );
	  };
	
	  return AdvanceSettings;
	}(_react.Component);
	
	exports.default = AdvanceSettings;
	module.exports = exports['default'];

/***/ },

/***/ "cmbB":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ticket-content":"ticket-content","ticket-title":"ticket-title","ticket-container":"ticket-container","btn-row":"btn-row","register-btn":"register-btn","icon-plus":"icon-plus","register-btn-fee":"register-btn-fee","registration-setting-icon":"registration-setting-icon","price-description":"price-description","registration-setting-content":"registration-setting-content","registration-setting-trash":"registration-setting-trash","registration-setting-cog":"registration-setting-cog","advance-settings-content":"advance-settings-content","advance-title":"advance-title","advance-hr":"advance-hr","other-setting-title":"other-setting-title","other-setting-description":"other-setting-description","advance-label":"advance-label","close-advance":"close-advance","red":"red","no-end-time":"no-end-time","wait-list":"wait-list","wait-list-label":"wait-list-label","wait-list-input":"wait-list-input","icon-up-big":"icon-up-big","plus-1":"plus-1","plus-2":"plus-2"};

/***/ },

/***/ "DaH7":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"default-editor":"default-editor","poster-title":"poster-title","medium-editor-element":"medium-editor-element","medium-editor-placeholder":"medium-editor-placeholder","edit-item":"edit-item","add-item":"add-item","add-text":"add-text","add-item-btn":"add-item-btn","icon-picture":"icon-picture","icon-plus":"icon-plus","icon-font":"icon-font","image":"image","edit-item-trash":"edit-item-trash"};

/***/ },

/***/ "OSsy":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EDITOR_BUTTONS = undefined;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDropzone = __webpack_require__("KTM0");
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _alert = __webpack_require__("BGi1");
	
	var _ImageCropper = __webpack_require__("jlVy");
	
	var _ImageCropper2 = _interopRequireDefault(_ImageCropper);
	
	var _createContent = __webpack_require__("SquY");
	
	var _createContent2 = _interopRequireDefault(_createContent);
	
	var _uploadPicture = __webpack_require__("JmXh");
	
	var _uploadPicture2 = _interopRequireDefault(_uploadPicture);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _ducks = __webpack_require__("ygJX");
	
	var _reactMediumEditor = __webpack_require__("U1Qd");
	
	var _reactMediumEditor2 = _interopRequireDefault(_reactMediumEditor);
	
	var _draftjsToHtml = __webpack_require__("II9e");
	
	var _draftjsToHtml2 = _interopRequireDefault(_draftjsToHtml);
	
	var _htmlToDraftjs = __webpack_require__("0geS");
	
	var _htmlToDraftjs2 = _interopRequireDefault(_htmlToDraftjs);
	
	__webpack_require__("kGEI");
	
	__webpack_require__("HTQn");
	
	var _locale = __webpack_require__("7sYR");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { Editor } from 'react-draft-wysiwyg';
	// import { EditorState, convertToRaw, ContentState } from 'draft-js';
	
	var ACCEPT_MIME = 'image/png,image/jpeg';
	var MAX_SIZE = 5 * 1000 * 1000;
	var MIN_SIZE = 0;
	
	var EDITOR_BUTTONS = exports.EDITOR_BUTTONS = ['removeFormat', 'bold', 'italic', 'justifyCenter', 'justifyLeft', 'h2', 'h3', 'orderedlist', 'unorderedlist'];
	
	var EditItem = function (_Component) {
	  _inherits(EditItem, _Component);
	
	  function EditItem(props) {
	    _classCallCheck(this, EditItem);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.selectImage = _this.selectImage.bind(_this);
	    _this.renderEditor = _this.renderEditor.bind(_this);
	    _this.onTextChange = _this.onTextChange.bind(_this);
	    _this.removeSelf = _this.removeSelf.bind(_this);
	
	    var _props$content = props.content,
	        text = _props$content.text,
	        image_url = _props$content.image_url,
	        video_url = _props$content.video_url,
	        content_type = _props$content.content_type;
	
	
	    _this.state = {
	      creating: false,
	      text: text,
	      image_url: image_url,
	      video_url: video_url,
	      content_type: content_type
	    };
	    return _this;
	  }
	
	  EditItem.prototype.selectImage = function selectImage(accepted, rejected) {
	    var _this2 = this;
	
	    if (rejected.length > 0) {
	      _alert.alert.warning(__('Image file must be png/jpeg under 5 MB', 'image'), __('Image not qualified', 'image'));
	      return;
	    } else if (accepted.length === 0) {
	      _alert.alert.warning('', __('No Image Selected'));
	      return;
	    }
	
	    var _props = this.props,
	        onImageChange = _props.onImageChange,
	        index = _props.index,
	        location = _props.location,
	        params = _props.params,
	        removeItemWithoutConfirm = _props.removeItemWithoutConfirm;
	
	
	    var posterId = params.posterId;
	
	    (0, _ImageCropper2.default)({
	      file: accepted[0],
	      removeItem: removeItemWithoutConfirm
	    }).then(function (_ref) {
	      var file = _ref.file,
	          imageUrl = _ref.imageUrl,
	          dataUrl = _ref.dataUrl;
	      var _props2 = _this2.props,
	          onImageChange = _props2.onImageChange,
	          index = _props2.index,
	          addItem = _props2.addItem,
	          content = _props2.content;
	
	
	      if (file) {
	        _this2.setState({
	          creating: true
	        });
	
	        (0, _uploadPicture2.default)(posterId, file).then(function (res) {
	          addItem(index, {
	            content_type: 'picture',
	            image_url: res.save_to
	          });
	
	          // STEP 3. CREATING COMPLETE
	          _this2.setState({
	            creating: false
	          });
	        });
	      }
	    }).catch(function (err) {});
	  };
	
	  EditItem.prototype.renderTrash = function renderTrash() {
	    var _this3 = this;
	
	    var _props3 = this.props,
	        emptyContentsCount = _props3.emptyContentsCount,
	        index = _props3.index,
	        removeItem = _props3.removeItem,
	        posterDetail = _props3.posterDetail,
	        contentId = _props3.contentId;
	    var contentList = posterDetail.contentList;
	    var content_type = this.props.content.content_type;
	
	
	    if (emptyContentsCount > 1 || contentList.length > 0) {
	      return _react2.default.createElement('i', { className: 'fa icon-trash edit-item-trash', onClick: function onClick() {
	          _this3.removeSelf();
	        } });
	    }
	  };
	
	  EditItem.prototype.removeSelf = function removeSelf() {
	    var _props4 = this.props,
	        index = _props4.index,
	        contentId = _props4.contentId,
	        content = _props4.content,
	        removeItem = _props4.removeItem;
	    var content_type = content.content_type;
	
	    removeItem(index, contentId, content_type);
	  };
	
	  EditItem.prototype.removeSelfWithoutConfirm = function removeSelfWithoutConfirm() {
	    var _props5 = this.props,
	        index = _props5.index,
	        contentId = _props5.contentId,
	        content = _props5.content,
	        removeItemWithoutConfirm = _props5.removeItemWithoutConfirm;
	    var content_type = content.content_type;
	
	    removeItemWithoutConfirm(index, contentId);
	  };
	
	  EditItem.prototype.onTextChange = function onTextChange(text, medium, e) {
	    var _props6 = this.props,
	        index = _props6.index,
	        onContentChange = _props6.onContentChange,
	        contentId = _props6.contentId,
	        removeItem = _props6.removeItem;
	    var content_type = this.props.content.content_type;
	
	
	    if (e.inputType === 'deleteContentBackward' && text.length === 0 || e.inputType === 'input' && text == '<p><br></p>') {
	      removeItem(index, contentId, content_type);
	      return;
	    }
	
	    onContentChange(index, {
	      text: text,
	      id: contentId
	    });
	  };
	
	  EditItem.prototype.renderEditor = function renderEditor() {
	    var _this4 = this;
	
	    var _props7 = this.props,
	        index = _props7.index,
	        removeItem = _props7.removeItem,
	        emptyContentsCount = _props7.emptyContentsCount,
	        posterDetail = _props7.posterDetail,
	        contentId = _props7.contentId,
	        params = _props7.params,
	        dispatch = _props7.dispatch,
	        onEditEnd = _props7.onEditEnd,
	        onEditStart = _props7.onEditStart,
	        content = _props7.content;
	    var text = content.text,
	        image_url = content.image_url,
	        video_url = content.video_url,
	        content_type = content.content_type,
	        textView = content.textView;
	    var creating = this.state.creating;
	    var posterId = params.posterId;
	
	
	    if (creating == true) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'creating-section text-center' },
	        _react2.default.createElement(_Loading2.default, null)
	      );
	    }
	
	    if (content_type == 'text') {
	      var _state = this.state,
	          editorState = _state.editorState,
	          _textView = _state.textView;
	
	      return _react2.default.createElement(_reactMediumEditor2.default, {
	        ref: function ref(r) {
	          if (r) {
	            _this4.textEditorRef = r;
	          }
	        },
	        onChange: this.onTextChange,
	        text: text,
	        options: {
	          placeholder: {
	            text: __('Enter Your Text', _locale2.default),
	            hideOnClick: false
	          },
	          toolbar: {
	            buttons: EDITOR_BUTTONS
	          }
	        }
	      });
	    } else if (content_type == 'picture') {
	      return _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'image' },
	          _react2.default.createElement('img', { width: '100%', src: image_url })
	        ),
	        this.renderTrash()
	      );
	    }
	  };
	
	  EditItem.prototype.render = function render() {
	    var textView = this.state.textView;
	    var _props$content2 = this.props.content,
	        id = _props$content2.id,
	        content_type = _props$content2.content_type;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('edit-item', { 'do-not-drag-my-parent': textView !== true && content_type !== 'picture' }) },
	      content_type === 'text' && _react2.default.createElement(
	        'div',
	        { className: 'add-item' },
	        _react2.default.createElement(_reactDropzone2.default, {
	          accept: ACCEPT_MIME,
	          multiple: false,
	          className: 'zone',
	          maxSize: MAX_SIZE,
	          minSize: MIN_SIZE,
	          onDrop: this.selectImage,
	          children: _react2.default.createElement(
	            'div',
	            { className: 'add-item-btn' },
	            _react2.default.createElement('i', { className: 'fa icon-picture' }),
	            _react2.default.createElement('i', { className: 'fa icon-plus' })
	          )
	        })
	      ),
	      this.renderEditor()
	    );
	  };
	
	  return EditItem;
	}(_react.Component);
	
	exports.default = EditItem;

/***/ },

/***/ "JmXh":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function uploadPicture(posterId, file, _onUploadProgress) {
	
	  var API_URL = void 0;
	
	  if (false) {
	    API_URL = 'http://saas.classtop.com:3000/sapi';
	  } else {
	    API_URL = 'https://school.classtop.com:3001/sapi';
	  }
	
	  if (!posterId) {
	    throw 'Missing poster ID';
	  }
	
	  if (!file) {
	    throw 'Missing blob';
	  }
	
	  return new Promise(function (resolve, reject) {
	    var data = new FormData();
	    data.append('pic', file, 'upload.png');
	    _axios2.default.post(API_URL + '/upload_pic/' + posterId + '/', data, {
	      'onUploadProgress': function onUploadProgress(progress) {
	        if (typeof _onUploadProgress == 'function') {
	          progress.ratio = progress.loaded / progress.total;
	          _onUploadProgress(progress);
	        }
	      },
	      headers: {
	        'Authorization': 'JWT ' + localStorage.getItem('token'),
	        'Content-Type': 'multipart/form-data'
	      }
	    }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {});
	  });
	}
	exports.default = uploadPicture;
	module.exports = exports['default'];

/***/ },

/***/ "ygJX":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.UPDATE_CONTENT_ITEM_ID = exports.UPDATE_CONTENT_ITEM = exports.ADD_CONTENT_ITEM = exports.REMOVE_CONTENT_ITEM = exports.FAILED_UPDATE_TICKET = exports.SUCCESS_UPDATE_TICKET = exports.START_UPDATE_TICKET = exports.FAILED_DELETE_TICKET = exports.SUCCESS_DELETE_TICKET = exports.START_DELETE_TICKET = exports.FAILED_CREATE_TICKET = exports.SUCCESS_CREATE_TICKET = exports.START_CREATE_TICKET = exports.UPDATE_TICKET_CONTENT = exports.REMOVE_TICKET_FROM_TICKET_LIST = exports.ADD_TICKET_TO_TICKET_LIST = exports.DELETE_TICKET = exports.UPDATE_TICKET = exports.CREATE_TICKET = exports.UPDATE_TITLE = exports.FAILED_FETCH_POSTER_DETAIL = exports.SUCCESS_FETCH_POSTER_DETAIL = exports.START_FETCH_POSTER_DETAIL = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchPosterDetail = fetchPosterDetail;
	exports.updateTitle = updateTitle;
	exports.updateContentItem = updateContentItem;
	exports.removeContentItem = removeContentItem;
	exports.addContentItem = addContentItem;
	exports.createTicket = createTicket;
	exports.deleteTicket = deleteTicket;
	exports.updateTicket = updateTicket;
	exports.default = posterDetail;
	
	var _getPosterDetail = __webpack_require__("+5oY");
	
	var _getPosterDetail2 = _interopRequireDefault(_getPosterDetail);
	
	var _createTicket = __webpack_require__("8x3i");
	
	var _createTicket2 = _interopRequireDefault(_createTicket);
	
	var _deleteTicket = __webpack_require__("V2aK");
	
	var _deleteTicket2 = _interopRequireDefault(_deleteTicket);
	
	var _updateTicket = __webpack_require__("bYN+");
	
	var _updateTicket2 = _interopRequireDefault(_updateTicket);
	
	var _updateContent = __webpack_require__("fQnq");
	
	var _updateContent2 = _interopRequireDefault(_updateContent);
	
	var _deleteContent = __webpack_require__("+ilL");
	
	var _deleteContent2 = _interopRequireDefault(_deleteContent);
	
	var _createContent = __webpack_require__("SquY");
	
	var _createContent2 = _interopRequireDefault(_createContent);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// calling both current and archived teacher
	var START_FETCH_POSTER_DETAIL = exports.START_FETCH_POSTER_DETAIL = 'START_FETCH_POSTER_DETAIL';
	var SUCCESS_FETCH_POSTER_DETAIL = exports.SUCCESS_FETCH_POSTER_DETAIL = 'SUCCESS_FETCH_POSTER_DETAIL';
	var FAILED_FETCH_POSTER_DETAIL = exports.FAILED_FETCH_POSTER_DETAIL = 'FAILED_FETCH_POSTER_DETAIL';
	
	var UPDATE_TITLE = exports.UPDATE_TITLE = "UPDATE_TITLE";
	
	var CREATE_TICKET = exports.CREATE_TICKET = "CREATE_TICKET";
	var UPDATE_TICKET = exports.UPDATE_TICKET = "UPDATE_TICKET";
	var DELETE_TICKET = exports.DELETE_TICKET = "DELETE_TICKET";
	
	var ADD_TICKET_TO_TICKET_LIST = exports.ADD_TICKET_TO_TICKET_LIST = 'ADD_TICKET_TO_TICKET_LIST';
	var REMOVE_TICKET_FROM_TICKET_LIST = exports.REMOVE_TICKET_FROM_TICKET_LIST = 'REMOVE_TICKET_FROM_TICKET_LIST';
	var UPDATE_TICKET_CONTENT = exports.UPDATE_TICKET_CONTENT = 'UPDATE_TICKET_CONTENT';
	
	var START_CREATE_TICKET = exports.START_CREATE_TICKET = 'START_CREATE_TICKET';
	var SUCCESS_CREATE_TICKET = exports.SUCCESS_CREATE_TICKET = 'SUCCESS_CREATE_TICKET';
	var FAILED_CREATE_TICKET = exports.FAILED_CREATE_TICKET = 'FAILED_CREATE_TICKET';
	
	var START_DELETE_TICKET = exports.START_DELETE_TICKET = 'START_DELETE_TICKET';
	var SUCCESS_DELETE_TICKET = exports.SUCCESS_DELETE_TICKET = 'SUCCESS_DELETE_TICKET';
	var FAILED_DELETE_TICKET = exports.FAILED_DELETE_TICKET = 'FAILED_DELETE_TICKET';
	
	var START_UPDATE_TICKET = exports.START_UPDATE_TICKET = 'START_UPDATE_TICKET';
	var SUCCESS_UPDATE_TICKET = exports.SUCCESS_UPDATE_TICKET = 'SUCCESS_UPDATE_TICKET';
	var FAILED_UPDATE_TICKET = exports.FAILED_UPDATE_TICKET = 'FAILED_UPDATE_TICKET';
	
	var REMOVE_CONTENT_ITEM = exports.REMOVE_CONTENT_ITEM = 'REMOVE_CONTENT_ITEM';
	var ADD_CONTENT_ITEM = exports.ADD_CONTENT_ITEM = 'ADD_CONTENT_ITEM';
	var UPDATE_CONTENT_ITEM = exports.UPDATE_CONTENT_ITEM = 'UPDATE_CONTENT_ITEM';
	
	var UPDATE_CONTENT_ITEM_ID = exports.UPDATE_CONTENT_ITEM_ID = 'UPDATE_CONTENT_ITEM_ID'; // when create a new content item, a new object(A) is inserted into an array before calling an API. When API is called and returns an ID for newly created item, we update that ID in object(A)
	function fetchPosterDetail(posterId) {
	
	  return function (dispatch) {
	
	    dispatch({
	      type: START_FETCH_POSTER_DETAIL
	    });
	
	    (0, _getPosterDetail2.default)(posterId).then(function (result) {
	      dispatch({
	        type: SUCCESS_FETCH_POSTER_DETAIL,
	        payload: _extends({}, result)
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_FETCH_POSTER_DETAIL,
	        payload: err
	      });
	    });
	  };
	}
	
	function updateTitle(title) {
	  return function (dispatch) {
	    dispatch({
	      type: UPDATE_TITLE,
	      title: title
	    });
	  };
	}
	
	function updateContentItem(index, contentId, contentItemChanges) {
	  return function (dispatch) {
	    dispatch({
	      type: UPDATE_CONTENT_ITEM,
	      index: index,
	      contentItemChanges: contentItemChanges
	    });
	
	    delete contentItemChanges.id; // ID is not allowed
	
	    (0, _updateContent2.default)(contentId, contentItemChanges).then(function (res) {});
	  };
	}
	
	function removeContentItem(index, contentId) {
	  return function (dispatch) {
	    dispatch({
	      type: REMOVE_CONTENT_ITEM,
	      index: index
	    });
	
	    // this.countEmptyItem()
	    if (contentId) {
	      (0, _deleteContent2.default)(contentId).then(function () {});
	    }
	  };
	}
	
	function addContentItem(index, posterId, newContentItem, dontCallAPI) {
	  return function (dispatch) {
	    dispatch({
	      type: ADD_CONTENT_ITEM,
	      index: index,
	      newContentItem: newContentItem
	    });
	
	    newContentItem.index = index;
	
	    if (dontCallAPI !== true) {
	      (0, _createContent2.default)(posterId, newContentItem).then(function (res) {
	        dispatch({
	          type: UPDATE_CONTENT_ITEM_ID,
	          index: index,
	          id: res.content_block_id
	        });
	      });
	      // this.countEmptyItem()
	    }
	  };
	}
	
	function createTicket(posterId, ticket) {
	
	  return function (dispatch) {
	    dispatch({
	      type: START_CREATE_TICKET
	    });
	
	    dispatch({
	      type: CREATE_TICKET,
	      ticket: ticket
	    });
	
	    (0, _createTicket2.default)(posterId, ticket).then(function (result) {
	      dispatch({
	        type: SUCCESS_CREATE_TICKET,
	        payload: _extends({}, result)
	      });
	
	      dispatch({
	        type: UPDATE_TICKET,
	        ticket: _extends({}, ticket, {
	          id: result.ticket_id
	        })
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_CREATE_TICKET,
	        payload: err
	      });
	    });
	  };
	}
	
	function deleteTicket(ticketId, ticketIndexInArray) {
	
	  return function (dispatch) {
	
	    dispatch({
	      type: START_DELETE_TICKET,
	      ticketIndexInArray: ticketIndexInArray
	    });
	
	    dispatch({
	      type: DELETE_TICKET,
	      ticketIndexInArray: ticketIndexInArray
	    });
	
	    (0, _deleteTicket2.default)(ticketId).then(function (result) {
	      dispatch({
	        type: SUCCESS_DELETE_TICKET,
	        payload: _extends({}, result)
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_DELETE_TICKET,
	        payload: err
	      });
	    });
	  };
	}
	
	function updateTicket(ticketId, ticket) {
	
	  return function (dispatch) {
	
	    dispatch({
	      type: START_UPDATE_TICKET
	    });
	
	    dispatch({
	      type: UPDATE_TICKET,
	      ticket: ticket
	    });
	
	    (0, _updateTicket2.default)(ticketId, convertTicketToServer(ticket)).then(function (result) {
	      dispatch({
	        type: SUCCESS_UPDATE_TICKET,
	        payload: _extends({}, result)
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: FAILED_UPDATE_TICKET,
	        payload: err
	      });
	    });
	  };
	}
	
	var initState = {
	  contentList: [],
	  detail: {}
	
	};
	
	var POSTER_TYPE = ["registration", "ticket", 'survey', 'basic'];
	
	function posterDetail() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    // ===================================
	    //  actions for fetching poster detail
	    // ===================================
	    case START_FETCH_POSTER_DETAIL:
	      {
	        return _extends({}, state, {
	          fetching: true,
	          contentList: [],
	          ticketList: [],
	          detail: {},
	          poster_type: undefined,
	          title: undefined
	        });
	      }
	    case SUCCESS_FETCH_POSTER_DETAIL:
	      {
	        var _action$payload = action.payload,
	            poster_info = _action$payload.poster_info,
	            content = _action$payload.content,
	            ticket = _action$payload.ticket;
	
	
	        return _extends({}, state, {
	          title: poster_info.title,
	          hasTitle: typeof poster_info.title === 'string' && poster_info.title.length > 0,
	          detail: poster_info,
	          contentList: content,
	          ticketList: ticket.map(function (ticketFromServer) {
	            return convertTicketFromServer(ticketFromServer);
	          }),
	          poster_type: POSTER_TYPE[poster_info.poster_type],
	          fetching: false
	        });
	      }
	    case FAILED_FETCH_POSTER_DETAIL:
	      {
	        return state;
	      }
	
	    // ===================================
	    //  updating content editor part
	    //  of posterdetail
	    // ===================================
	    case UPDATE_TITLE:
	      {
	        var title = action.title;
	
	
	        return _extends({}, state, {
	          title: title,
	          hasTitle: typeof title === 'string' && title.length > 0
	        });
	        break;
	      }
	
	    case UPDATE_CONTENT_ITEM:
	      {
	        var index = action.index,
	            contentItemChanges = action.contentItemChanges;
	
	
	        return _extends({}, state, {
	          contentList: state.contentList.map(function (item, i) {
	            return i === index ? _extends({}, item, contentItemChanges) : item;
	          })
	        });
	
	        break;
	      }
	
	    case UPDATE_CONTENT_ITEM_ID:
	      {
	        var _index = action.index,
	            id = action.id;
	
	        return _extends({}, state, {
	          contentList: state.contentList.map(function (item, i) {
	            return i === _index ? _extends({}, item, { id: id }) : item;
	          })
	        });
	      }
	
	    case ADD_CONTENT_ITEM:
	      {
	        var _index2 = action.index,
	            newContentItem = action.newContentItem;
	
	
	        return _extends({}, state, {
	          contentList: [].concat(state.contentList.slice(0, _index2), [newContentItem], state.contentList.slice(_index2))
	        });
	
	        break;
	      }
	
	    case REMOVE_CONTENT_ITEM:
	      {
	        var _index3 = action.index;
	
	
	        return _extends({}, state, {
	          contentList: [].concat(state.contentList.slice(0, _index3), state.contentList.slice(_index3 + 1))
	        });
	
	        break;
	      }
	
	    // ===================================
	    //  actions for local states for ticket
	    // ===================================
	    case CREATE_TICKET:
	      {
	        return _extends({}, state, {
	          ticketList: [].concat(state.ticketList, [action.ticket])
	        });
	      }
	
	    case UPDATE_TICKET:
	      {
	        var _index4 = action.ticket.index;
	
	
	        return _extends({}, state, {
	          ticketList: state.ticketList.map(function (existingTicket, i) {
	            return _index4 === i + 1 ? _extends({}, existingTicket, action.ticket) : existingTicket;
	          })
	        });
	      }
	
	    case DELETE_TICKET:
	      {
	        var ticketIndexInArray = action.ticketIndexInArray;
	
	
	        return _extends({}, state, {
	          ticketList: [].concat(state.ticketList.slice(0, ticketIndexInArray), state.ticketList.slice(ticketIndexInArray + 1))
	        });
	      }
	    // ===================================
	    //  actions for API calls creating ticket
	    // ===================================
	    case START_CREATE_TICKET:
	      {
	        return _extends({}, state, {
	          loading: true
	        });
	      }
	    case SUCCESS_CREATE_TICKET:
	      {
	        var _action$payload2 = action.payload,
	            ticket_id = _action$payload2.ticket_id,
	            _index5 = _action$payload2.index;
	
	        return _extends({}, state, {
	          loading: false
	        });
	      }
	    case FAILED_CREATE_TICKET:
	      {
	        return _extends({}, state, {
	          loading: false
	        });
	      }
	
	    // ===================================
	    //  actions for API calls deleting ticket
	    // ===================================
	    case START_DELETE_TICKET:
	      {
	        return _extends({}, state, {
	          loading: true,
	          ticketList: [].concat(state.ticketList.slice(0, action.ticketIndexInArray), state.ticketList.slice(action.ticketIndexInArray + 1))
	        });
	      }
	    case SUCCESS_DELETE_TICKET:
	      {
	        return _extends({}, state, {
	          loading: false
	        });
	      }
	    case FAILED_DELETE_TICKET:
	      {
	        return _extends({}, state, {
	          loading: false
	        });
	      }
	
	    // ===================================
	    //  actions for API calls updating ticket
	    // ===================================
	    case START_UPDATE_TICKET:
	      {
	        return _extends({}, state, {
	          loading: true
	        });
	      }
	    case SUCCESS_UPDATE_TICKET:
	      {
	        return _extends({}, state, {
	          loading: false
	        });
	      }
	    case FAILED_UPDATE_TICKET:
	      {
	        return _extends({}, state, {
	          loading: false
	        });
	      }
	
	    default:
	      return _extends({}, state);
	  }
	}
	
	function convertTicketFromServer(opts) {
	  var id = opts.id,
	      index = opts.index,
	      title = opts.title,
	      amount = opts.amount,
	      price = opts.price,
	      auto_wait_list = opts.auto_wait_list,
	      start_at = opts.start_at,
	      end_at = opts.end_at,
	      price_type = opts.price_type;
	
	
	  var endDate = void 0,
	      endTime = void 0;
	
	  if (end_at) {
	    var endMoment = (0, _moment2.default)(end_at);
	    endDate = endMoment.format('YYYY-MM-DD');
	    endTime = endMoment.format('HH:mm:ss');
	  }
	
	  var startDate = void 0,
	      startTime = void 0;
	
	  if (start_at) {
	    var startMoment = (0, _moment2.default)(start_at);
	    startDate = startMoment.format('YYYY-MM-DD');
	    startTime = startMoment.format('HH:mm:ss');
	  }
	
	  var PRICE_TYPE = ['freeOrPayOffline', 'fixedAmount', 'noFixAmount'];
	
	  return {
	    id: id,
	    index: index,
	    title: title,
	    amount: amount,
	    price: price,
	    auto_wait_list: auto_wait_list,
	    noEndTime: !end_at ? true : false,
	    startDate: startDate,
	    startTime: startTime,
	    endDate: endDate,
	    endTime: endTime,
	    price_type: PRICE_TYPE[price_type]
	  };
	}
	
	function convertTicketToServer(_ref) {
	  var index = _ref.index,
	      title = _ref.title,
	      amount = _ref.amount,
	      price = _ref.price,
	      startDate = _ref.startDate,
	      startTime = _ref.startTime,
	      endDate = _ref.endDate,
	      endTime = _ref.endTime,
	      auto_wait_list = _ref.auto_wait_list,
	      noEndTime = _ref.noEndTime;
	
	  var noStartTime = !startDate || !startTime;
	
	  var obj = {
	    index: index,
	    title: title,
	    amount: Number(amount),
	    price: price,
	    auto_wait_list: auto_wait_list,
	    start_at: noStartTime ? null : startDate + ' ' + startTime,
	    end_at: noEndTime ? null : endDate + ' ' + endTime
	  };
	
	  if (obj.noEndTime == false) {
	    obj.end_at = endDate + ' ' + endTime;
	  }
	
	  return obj;
	}

/***/ },

/***/ "U1Qd":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp;
	
	var _objectAssign = __webpack_require__("BEQ0");
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _blacklist = __webpack_require__("fci+");
	
	var _blacklist2 = _interopRequireDefault(_blacklist);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("O27J");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	if (typeof document !== 'undefined') {
	  var MediumEditor = __webpack_require__("kLCq");
	}
	
	var ReactMediumEditor = (_temp = _class = function (_React$Component) {
	  _inherits(ReactMediumEditor, _React$Component);
	
	  function ReactMediumEditor(props) {
	    _classCallCheck(this, ReactMediumEditor);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      text: _this.props.text
	    };
	
	    _this.onKeydown = _this.onKeydown.bind(_this);
	    return _this;
	  }
	
	  ReactMediumEditor.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var dom = _reactDom2.default.findDOMNode(this);
	    this.dom = dom;
	
	    this.medium = new MediumEditor(dom, this.props.options);
	    this.medium.subscribe('editableInput', function (e) {
	      _this2._updated = true;
	      _this2.change(dom.innerHTML, e);
	    });
	    // dom.addEventListener('keydown', this.onKeydown);
	  };
	
	  ReactMediumEditor.prototype.onKeydown = function onKeydown(e) {
	    var onKeydown = this.props.onKeydown;
	
	
	    if (typeof onKeydown === 'function') {
	      onKeydown(e);
	    }
	  };
	
	  ReactMediumEditor.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.medium.restoreSelection();
	  };
	
	  ReactMediumEditor.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.medium.destroy();
	    // this.dom.removeEventListener('keypress', this.onKeydown);
	  };
	
	  ReactMediumEditor.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.text !== this.state.text && !this._updated) {
	      this.setState({ text: nextProps.text });
	    }
	
	    if (this._updated) this._updated = false;
	  };
	
	  ReactMediumEditor.prototype.render = function render() {
	    var tag = this.props.tag;
	    var props = (0, _blacklist2.default)(this.props, 'options', 'text', 'tag', 'contentEditable', 'dangerouslySetInnerHTML');
	
	    (0, _objectAssign2.default)(props, {
	      dangerouslySetInnerHTML: { __html: this.state.text }
	    });
	
	    if (this.medium) {
	      this.medium.saveSelection();
	    }
	
	    return _react2.default.createElement(tag, props);
	  };
	
	  ReactMediumEditor.prototype.change = function change(text, e) {
	    if (this.props.onChange) this.props.onChange(text, this.medium, e);
	  };
	
	  return ReactMediumEditor;
	}(_react2.default.Component), _class.defaultProps = {
	  tag: 'div'
	}, _temp);
	exports.default = ReactMediumEditor;
	module.exports = exports['default'];

/***/ },

/***/ "7sYR":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
			id: 'posterList',
			code: 'CN',
			text: {
					'{ticket_amount}': '{ticket_amount}人',
					'Enter Your Text': '输入文字',
					'MMM DD, YYYY': 'YYYY年MM月DD日',
					'ddd, MMM DD YYYY': 'YYYY年MM月DD日 ddd',
					'Delete Content': '删除内容',
					'Are you sure you want to delete the picture above?': '你确定要删除上面的图片吗？',
					'Are you sure you want to delete the picture?': '你确定要删除此图片吗？',
					'Create New Registration Poster': '创建课程报名海报',
					'Create New Basic Poster': '创建普通海报',
					'Create New Poster': '创建课程报名海报',
					'Save': '保存',
					'Publish': '发布',
					'Preview': '预览',
					'Poster Content': '海报内容',
					'Poster Templates': '海报模板',
					'Enter Poster Title': '输入海报标题',
					'Poster Content: Select Picture or Text': '选择图片或文字添加海报内容',
					'Last Updated: ': '最后更改日期：',
					'Add Content': '添加图文',
					'Unable to Edit Published Poster': '已发布的海报无法编辑',
					'Cancel uploading image?': '取消上传图片？'
			}
	};
	module.exports = exports['default'];

/***/ },

/***/ "rNQa":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"poster-container":"poster-container","create-poster-title":"create-poster-title","header-title":"header-title","container-fluid":"container-fluid","header":"header","buttons":"buttons","template":"template","col-xs-6":"col-xs-6","title":"title","creating-section":"creating-section","content-section":"content-section","default-section":"default-section","choose-item":"choose-item","poster-content":"poster-content","icon-wrapper":"icon-wrapper","zone":"zone","icon-picture":"icon-picture","icon-font":"icon-font","select-type":"select-type","poster-date":"poster-date","add-section-btn":"add-section-btn","add-section-btn-container":"add-section-btn-container","icon-plus":"icon-plus","edit-item":"edit-item","dragged":"dragged"};

/***/ },

/***/ "esxL":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _updatePoster = __webpack_require__("xsdH");
	
	var _updatePoster2 = _interopRequireDefault(_updatePoster);
	
	__webpack_require__("cmbB");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    posterDetail: state.posterDetail
	  };
	};
	
	var OtherSettings = function (_Component) {
	  _inherits(OtherSettings, _Component);
	
	  function OtherSettings(props) {
	    _classCallCheck(this, OtherSettings);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      show_spots_left: _this.props.posterDetail.detail.show_spots_left == 1 ? 'yes' : 'no',
	      show_page_view: _this.props.posterDetail.detail.show_page_view == 1 ? 'yes' : 'no',
	      posterId: _this.props.posterDetail.detail.id
	    };
	    return _this;
	  }
	
	  OtherSettings.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        show_spots_left = _state.show_spots_left,
	        show_page_view = _state.show_page_view,
	        posterId = _state.posterId;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'other-settings-content' },
	      _react2.default.createElement(
	        'p',
	        { className: 'ticket-title' },
	        __('Other Settings', 'ticket')
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'other-setting-title' },
	        __('Registration Progress', 'ticket')
	      ),
	      _react2.default.createElement('input', { type: 'checkbox', checked: show_spots_left == 'yes', onClick: function onClick() {
	          show_spots_left == 'yes' ? (0, _updatePoster2.default)(posterId, { show_spots_left: 'no' }).then(function (res) {
	            _this2.setState({ show_spots_left: 'no' });
	          }) : (0, _updatePoster2.default)(posterId, { show_spots_left: 'yes' }).then(function (res) {
	            _this2.setState({ show_spots_left: 'yes' });
	          });
	        } }),
	      _react2.default.createElement(
	        'span',
	        { className: 'other-setting-description' },
	        __('Show Registration Progress on Poster', 'ticket')
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'other-setting-title' },
	        __('Read Count', 'ticket')
	      ),
	      _react2.default.createElement('input', { type: 'checkbox', checked: show_page_view == 'yes', onClick: function onClick() {
	          show_page_view == 'yes' ? (0, _updatePoster2.default)(posterId, { show_page_view: 'no' }).then(function (res) {
	            _this2.setState({ show_page_view: 'no' });
	          }) : (0, _updatePoster2.default)(posterId, { show_page_view: 'yes' }).then(function (res) {
	            _this2.setState({ show_page_view: 'yes' });
	          });
	        } }),
	      _react2.default.createElement(
	        'span',
	        { className: 'other-setting-description' },
	        __('Show Read Count on Poster', 'ticket')
	      )
	    );
	  };
	
	  return OtherSettings;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(OtherSettings);
	module.exports = exports['default'];

/***/ },

/***/ "jgoK":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Fields = __webpack_require__("8/2o");
	
	var _AdvanceSettings = __webpack_require__("NrvF");
	
	var _AdvanceSettings2 = _interopRequireDefault(_AdvanceSettings);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__("cmbB");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RegistrationSetting = function (_Component) {
	  _inherits(RegistrationSetting, _Component);
	
	  function RegistrationSetting(props) {
	    _classCallCheck(this, RegistrationSetting);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    var _props$ticket = props.ticket,
	        title = _props$ticket.title,
	        amount = _props$ticket.amount,
	        startDate = _props$ticket.startDate,
	        startTime = _props$ticket.startTime,
	        endDate = _props$ticket.endDate,
	        endTime = _props$ticket.endTime,
	        price = _props$ticket.price,
	        noEndTime = _props$ticket.noEndTime,
	        auto_wait_list = _props$ticket.auto_wait_list,
	        index = _props$ticket.index,
	        ticketLength = _props$ticket.ticketLength;
	
	
	    _this.state = {
	      showingAdvance: true,
	      data: _extends({}, props.ticket, {
	        title: title || '',
	        amount: amount || '',
	        startDate: startDate ? startDate : (0, _moment2.default)().format('YYYY-MM-DD'),
	        startTime: startTime ? startTime : '09:00:00',
	        endDate: endDate || (0, _moment2.default)().format('YYYY-MM-DD'),
	        endTime: endTime || '10:00:00',
	        price: price || 0,
	        noEndTime: noEndTime || true,
	        auto_wait_list: auto_wait_list == 1 ? 'enterWaitList' : 'noWaitList' || 'enterWaitList',
	        index: index
	      })
	
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.showingAdvanceCallback = _this.showingAdvanceCallback.bind(_this);
	    return _this;
	  }
	
	  RegistrationSetting.prototype.onChange = function onChange(name) {
	    var _this2 = this;
	
	    var onTicketChange = this.props.onTicketChange;
	
	
	    return function (value) {
	      var _extends2;
	
	      var newValue = void 0;
	
	      if (name == 'startDate' || name == 'endDate') {
	        if (value instanceof _moment2.default) {
	          newValue = value.format('YYYY-MM-DD');
	        }
	      } else if (name == 'startTime' || name == 'endTime') {
	        if (value instanceof _moment2.default) {
	          newValue = value.format('HH:mm:ss');
	        }
	      } else if (name == 'noEndTime') {
	        newValue = value.target.checked;
	      } else if (name == 'auto_wait_list') {
	        newValue = value.target.value;
	      } else if (name == 'price') {
	        if (value == '') {
	          newValue = '0';
	        } else {
	          newValue = value.replace('$', '');
	        }
	      } else {
	        newValue = value;
	      }
	
	      _this2.setState({
	        data: _extends({}, _this2.state.data, (_extends2 = {}, _extends2[name] = newValue, _extends2))
	      }, function () {
	        onTicketChange(_this2.state.data);
	      });
	    };
	  };
	
	  RegistrationSetting.prototype.showingAdvanceCallback = function showingAdvanceCallback(data) {
	    this.setState(data);
	  };
	
	  RegistrationSetting.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        showingAdvance = _state.showingAdvance,
	        data = _state.data;
	    var title = data.title,
	        price = data.price,
	        amount = data.amount;
	    var _props = this.props,
	        onTicketChange = _props.onTicketChange,
	        ticket = _props.ticket,
	        onRemoveTicket = _props.onRemoveTicket,
	        type = _props.type;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'registration-setting-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-4' },
	          _react2.default.createElement(_Fields.SimpleInput, { value: title, onChange: this.onChange('title'), placeholder: __('Dance Class, English Class, etc', 'ticket') })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-3' },
	          _react2.default.createElement(_Fields.Quantity, { value: amount, onChange: this.onChange('amount'), suffix: __('', 'ticket') })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-3 price-description' },
	          type == 'freeOrPayOffline' ? __('Pay Offline', 'ticket') : __('Pay Online', 'ticket')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-2 registration-setting-icon' },
	          _react2.default.createElement('i', { className: 'fa icon-cog registration-setting-cog', onClick: function onClick() {
	              if (showingAdvance == false) {
	                _this3.setState({ showingAdvance: true });
	              } else {
	                _this3.setState({ showingAdvance: false });
	              }
	            } }),
	          _react2.default.createElement('i', { className: 'fa icon-trash registration-setting-trash', onClick: onRemoveTicket })
	        )
	      ),
	      showingAdvance == true && _react2.default.createElement(_AdvanceSettings2.default, { type: type, data: data, onChange: this.onChange, callbackFromParent: this.showingAdvanceCallback })
	    );
	  };
	
	  return RegistrationSetting;
	}(_react.Component);
	
	exports.default = RegistrationSetting;
	module.exports = exports['default'];

/***/ },

/***/ "43rz":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_Component) {
	  _inherits(Template, _Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Template.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'title' },
	        __('Poster Templates', 'createposter')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-6' },
	          _react2.default.createElement('div', { className: 'template' }),
	          _react2.default.createElement('div', { className: 'template' }),
	          _react2.default.createElement('div', { className: 'template' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-6' },
	          _react2.default.createElement('div', { className: 'template' }),
	          _react2.default.createElement('div', { className: 'template' }),
	          _react2.default.createElement('div', { className: 'template' })
	        )
	      )
	    );
	  };
	
	  return Template;
	}(_react.Component);
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ },

/***/ "SxNW":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RegistrationSetting = __webpack_require__("jgoK");
	
	var _RegistrationSetting2 = _interopRequireDefault(_RegistrationSetting);
	
	var _OtherSettings = __webpack_require__("esxL");
	
	var _OtherSettings2 = _interopRequireDefault(_OtherSettings);
	
	__webpack_require__("cmbB");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	var TicketList = function (_Component) {
	  _inherits(TicketList, _Component);
	
	  function TicketList(props) {
	    _classCallCheck(this, TicketList);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  TicketList.prototype.renderRegistrationSetting = function renderRegistrationSetting() {
	    var _props = this.props,
	        ticketList = _props.ticketList,
	        onTicketChange = _props.onTicketChange,
	        removeTicket = _props.removeTicket;
	
	    return ticketList.map(function (ticket, index) {
	      return _react2.default.createElement(_RegistrationSetting2.default, {
	        key: index,
	        ticket: ticket,
	        onTicketChange: onTicketChange(index, ticket.id),
	        onRemoveTicket: removeTicket(index, ticket),
	        type: ticket.price_type
	      });
	    });
	  };
	
	  TicketList.prototype.render = function render() {
	    var showingBasic = this.state.showingBasic;
	    var _props2 = this.props,
	        _props2$ticketList = _props2.ticketList,
	        ticketList = _props2$ticketList === undefined ? [] : _props2$ticketList,
	        onTicketChange = _props2.onTicketChange,
	        addTicket = _props2.addTicket;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'ticket-content' },
	      _react2.default.createElement(
	        'p',
	        { className: 'ticket-title' },
	        __('Registration Setup', 'ticket'),
	        _react2.default.createElement(
	          'span',
	          { className: 'red' },
	          '*'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'container-fluid ticket-container' },
	        ticketList.length > 0 && _react2.default.createElement(
	          'div',
	          { className: 'row btn-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-4' },
	            __('Registration Title', 'ticket'),
	            _react2.default.createElement(
	              'span',
	              { className: 'red' },
	              '*'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-3' },
	            __('Amount of People', 'ticket'),
	            _react2.default.createElement(
	              'span',
	              null,
	              __(' (No limit if empty)', 'ticket')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-3' },
	            __('Price Description', 'ticket')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-2' },
	            __('Settings', 'ticket')
	          )
	        ),
	        this.renderRegistrationSetting(),
	        _react2.default.createElement(
	          'div',
	          { className: 'row btn-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-5 register-btn text-center', onClick: function onClick() {
	                addTicket('freeOrPayOffline');
	              } },
	            _react2.default.createElement('i', { className: 'fa icon-plus plus-1' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'registration-reg' },
	              __('Registration', 'ticket')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-5 register-btn text-center', onClick: function onClick() {
	                addTicket('fixedAmount');
	              } },
	            _react2.default.createElement('i', { className: 'fa icon-plus plus-2' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'registration-with-fee' },
	              __('Registration with Fees', 'ticket')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_OtherSettings2.default, null)
	    );
	  };
	
	  return TicketList;
	}(_react.Component);
	
	exports.default = TicketList;
	module.exports = exports['default'];

/***/ },

/***/ "yA0B":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _Transition = __webpack_require__("X/qO");
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _alert = __webpack_require__("BGi1");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _TicketList = __webpack_require__("SxNW");
	
	var _TicketList2 = _interopRequireDefault(_TicketList);
	
	var _EditItem = __webpack_require__("OSsy");
	
	var _EditItem2 = _interopRequireDefault(_EditItem);
	
	__webpack_require__("rNQa");
	
	var _PanelWrapper = __webpack_require__("VPji");
	
	var _PanelWrapper2 = _interopRequireDefault(_PanelWrapper);
	
	var _updatePoster = __webpack_require__("xsdH");
	
	var _updatePoster2 = _interopRequireDefault(_updatePoster);
	
	var _ducks = __webpack_require__("ygJX");
	
	var _locale = __webpack_require__("7sYR");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("DaH7");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ATTENTION: HOW THIS ITEMS ARE DRAGGED.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * There is no device/props to tell DragSortableList to distinguish which item is draggable or not.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * So instead, we modify the very first childnode of each draggable item to tell which item is not
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * draggable. Here that first childnode is <EditItem />. By adding class 'do-not-drag-my-parent,'
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * The item is not draggable anymore.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    posterDetail: state.posterDetail
	  };
	};
	
	var EditPoster = function (_Component) {
	  _inherits(EditPoster, _Component);
	
	  function EditPoster(props) {
	    _classCallCheck(this, EditPoster);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      date: '',
	      title: '',
	      text: '',
	      result: false,
	      content_block_id: '',
	      poster_type: '',
	      contents: []
	    };
	
	    _this.onTitleChange = _this.onTitleChange.bind(_this);
	    _this.onContentChange = _this.onContentChange.bind(_this);
	    _this.onImageChange = _this.onImageChange.bind(_this);
	    _this.addItem = _this.addItem.bind(_this);
	    _this.countEmptyItem = _this.countEmptyItem.bind(_this);
	    _this.onTicketChange = _this.onTicketChange.bind(_this);
	    _this.addTicket = _this.addTicket.bind(_this);
	    _this.removeTicket = _this.removeTicket.bind(_this);
	    _this.savePoster = _this.savePoster.bind(_this);
	    _this.removeItem = _this.removeItem.bind(_this);
	    _this.removeItemWithoutConfirm = _this.removeItemWithoutConfirm.bind(_this);
	    _this.insertTextContentWhereItNeeded = _this.insertTextContentWhereItNeeded.bind(_this);
	    _this.combineTextContentIfTheyAreSideBySide = _this.combineTextContentIfTheyAreSideBySide.bind(_this);
	
	    return _this;
	  }
	
	  EditPoster.prototype.componentDidMount = function componentDidMount() {
	    var posterId = this.props.params.posterId;
	    this.props.fetchPosterDetail(posterId);
	  };
	
	  EditPoster.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var posterDetail = _ref.posterDetail;
	
	    if (posterDetail.detail.state == 1) {
	      _alert.alert.fail(__('Unable to Edit Published Poster', _locale2.default)).then(function (res) {
	        _reactRouter.browserHistory.push('/poster');
	      });
	    }
	
	    if (posterDetail) {
	      this.setState({
	        title: posterDetail.title,
	        contents: posterDetail.contentList.length == 0 ? [{}] : posterDetail.contentList
	      });
	    }
	  };
	
	  EditPoster.prototype.renderPosterDate = function renderPosterDate() {
	
	    if (!this.props.posterDetail.detail) {
	      return _react2.default.createElement(_Loading2.default, null);
	    }
	
	    var updated_at = this.props.posterDetail.detail.updated_at;
	    var newDate = (0, _moment2.default)(updated_at).format(__('MMM DD, YYYY', 'dateFormat'));
	    return newDate;
	  };
	
	  // dontCallAPI is true, when we add a temporary item
	
	
	  EditPoster.prototype.addItem = function addItem(index, newContentItem, dontCallAPI) {
	    var posterId = this.props.params.posterId;
	
	
	    this.props.addContentItem(index, posterId, newContentItem, dontCallAPI);
	  };
	
	  EditPoster.prototype.removeItem = function removeItem(index, contentId, content_type) {
	    var _this2 = this;
	
	    var textContentLength = this.getTextContentNum();
	
	    if (textContentLength === 1 && content_type === 'string') {
	      return;
	    }
	
	    if (content_type === 'picture') {
	      (0, _confirm.confirm)(__('Are you sure you want to delete the picture?', _locale2.default), __('Delete Content', _locale2.default)).then(function () {
	        _this2.execRemoveItem(index, contentId);
	      }).catch(function () {});
	      return;
	    }
	
	    if (content_type === 'text') {
	      this.execRemoveItem(index, contentId);
	    }
	  };
	
	  EditPoster.prototype.getContent = function getContent(index) {
	    return this.state.contents[index];
	  };
	
	  EditPoster.prototype.getTextContentNum = function getTextContentNum() {
	    var num = 0;
	    this.state.contents.map(function (item) {
	      if (item.content_type == 'text') {
	        num++;
	      }
	    });
	    return num;
	  };
	
	  EditPoster.prototype.removeItemWithoutConfirm = function removeItemWithoutConfirm(index, contentId) {
	    this.execRemoveItem(index, contentId);
	  };
	
	  EditPoster.prototype.execRemoveItem = function execRemoveItem(index, contentId) {
	    // if this is a last text item. We do not delete it
	    this.props.removeContentItem(index, contentId);
	  };
	
	  EditPoster.prototype.countEmptyItem = function countEmptyItem() {
	    var emptyContents = this.state.contents.filter(function (content) {
	      return !content.content_type;
	    });
	    this.setState({ emptyContentsCount: emptyContents.length });
	  };
	
	  EditPoster.prototype.onTitleChange = function onTitleChange(event) {
	    var posterId = this.props.params.posterId;
	    var title = event.target.value;
	
	    clearTimeout(this.updateTextTimeout);
	    this.props.updateTitle(title);
	
	    this.updateTextTimeout = setTimeout(function () {
	      (0, _updatePoster2.default)(posterId, { title: title }).then(function (res) {});
	    }, 500);
	  };
	
	  EditPoster.prototype.onContentChange = function onContentChange(index, contentItemChanges) {
	    var _this3 = this;
	
	    var posterId = this.props.params.posterId;
	
	
	    clearTimeout(this.updateTextTimeout);
	
	    var contents = this.state.contents;
	
	    var contentId = contents[index].content_block_id || contents[index].id;
	
	    this.updateTextTimeout = setTimeout(function () {
	      _this3.props.updateContentItem(index, contentId, contentItemChanges);
	    }, 500);
	  };
	
	  EditPoster.prototype.onImageChange = function onImageChange(index, contentItemChanges) {
	    this.onContentChange(index, contentItemChanges);
	  };
	
	  EditPoster.prototype.addTicket = function addTicket(type) {
	    var params = this.props.params;
	    var posterId = params.posterId;
	    var _props$posterDetail$t = this.props.posterDetail.ticketList,
	        ticketList = _props$posterDetail$t === undefined ? [] : _props$posterDetail$t;
	
	
	    this.props.createTicket(posterId, { title: '', index: ticketList.length + 1, price_type: type });
	  };
	
	  EditPoster.prototype.removeTicket = function removeTicket(index, ticket) {
	    var _this4 = this;
	
	    return function () {
	      var endDate = ticket.endDate,
	          endTime = ticket.endTime,
	          title = ticket.title,
	          price = ticket.price;
	
	      var priceFloat = typeof price === 'undefined' ? price : parseFloat(price);
	
	      if (endDate || endTime || title || priceFloat) {
	        (0, _confirm.confirm)(__('Proceed to delete this registration?', 'ticket')).then(function () {
	          _this4.props.deleteTicket(ticket.id, index);
	        });
	      } else {
	        _this4.props.deleteTicket(ticket.id, index);
	      }
	    };
	  };
	
	  EditPoster.prototype.onTicketChange = function onTicketChange(index, ticketId) {
	    var _this5 = this;
	
	    return function (newSettings) {
	      clearTimeout(_this5.updateTextTimeout);
	
	      _this5.updateTextTimeout = setTimeout(function () {
	        _this5.props.updateTicket(ticketId, newSettings);
	      }, 500);
	    };
	  };
	
	  EditPoster.prototype.savePoster = function savePoster() {
	    var params = this.props.params;
	    var posterId = params.posterId;
	
	
	    _reactRouter.browserHistory.push('/poster');
	  };
	
	  EditPoster.prototype.insertTextContentWhereItNeeded = function insertTextContentWhereItNeeded() {
	    var contents = this.state.contents;
	
	    var length = contents.length;
	    var lastContent = this.getContent(length - 1) || {};
	
	    // Case 1:
	    // if the last content is not a 'text' content
	    if (lastContent.content_type === 'picture') {
	      this.addItem(length, {
	        content_type: 'text',
	        text: '<p><br></p>'
	      });
	    }
	  };
	
	  EditPoster.prototype.combineTextContentIfTheyAreSideBySide = function combineTextContentIfTheyAreSideBySide() {
	    var contents = this.state.contents;
	
	    var length = contents.length;
	    var lastContent = this.getContent(length - 1) || {};
	
	    // Case 1:
	    // if the last content is not a 'text' content
	    if (lastContent.content_type === 'picture') {
	      this.addItem(length, {
	        content_type: 'text',
	        text: '<p><br></p>'
	      });
	    }
	  };
	
	  EditPoster.prototype.getPosterTitle = function getPosterTitle() {
	    var poster_type = this.props.posterDetail.poster_type;
	
	
	    switch (poster_type) {
	      case 'basic':
	        return __('Create New Basic Poster', _locale2.default);
	        break;
	      case 'registration':
	        return __('Create New Registration Poster', _locale2.default);
	        break;
	    }
	  };
	
	  EditPoster.prototype.render = function render() {
	    var _this6 = this;
	
	    var _state = this.state,
	        emptyContentsCount = _state.emptyContentsCount,
	        contents = _state.contents;
	    var _props$posterDetail = this.props.posterDetail,
	        ticketList = _props$posterDetail.ticketList,
	        poster_type = _props$posterDetail.poster_type,
	        fetching = _props$posterDetail.fetching,
	        hasTitle = _props$posterDetail.hasTitle;
	    var params = this.props.params;
	    var posterId = params.posterId;
	
	
	    if (fetching !== true) {
	      this.insertTextContentWhereItNeeded();
	      // this.combineTextContentIfTheyAreSideBySide();
	    }
	
	    var EditItems = contents.map(function (content, key) {
	      return _react2.default.createElement(_EditItem2.default, _extends({
	        content: content,
	        contentId: content.id,
	        key: key
	      }, _this6.props, {
	        addItem: _this6.addItem,
	        removeItem: _this6.removeItem,
	        removeItemWithoutConfirm: _this6.removeItemWithoutConfirm,
	        index: key,
	        emptyContentsCount: emptyContentsCount,
	        contentId: content.content_block_id ? content.content_block_id : content.id,
	        onContentChange: function onContentChange(index, value) {
	          _this6.onContentChange(index, value);
	        },
	        onImageChange: function onImageChange(index, value) {
	          _this6.onImageChange(index, value);
	        } }));
	    });
	
	    if (fetching) {
	      return _react2.default.createElement(
	        _PanelWrapper2.default,
	        null,
	        _react2.default.createElement(_Loading2.default, null)
	      );
	    }
	
	    return _react2.default.createElement(
	      _PanelWrapper2.default,
	      null,
	      _react2.default.createElement(
	        _Transition2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid poster-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'header' },
	            _react2.default.createElement(
	              'span',
	              { className: 'create-poster-title' },
	              this.getPosterTitle()
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'poster-date' },
	              __('Last Updated: ', _locale2.default),
	              this.renderPosterDate()
	            ),
	            hasTitle === true && _react2.default.createElement(
	              'div',
	              { className: 'buttons' },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-default', onClick: this.savePoster },
	                __('Save', _locale2.default)
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: '/poster-preview/' + posterId, target: '_blank' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn-warning', onClick: function onClick() {} },
	                  __('Preview', _locale2.default)
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary', onClick: function onClick() {
	                    (0, _updatePoster2.default)(posterId, { state: 'published' }).then(function (res) {
	                      _reactRouter.browserHistory.push('/poster');
	                    });
	                  } },
	                __('Publish', _locale2.default)
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-8' },
	              _react2.default.createElement(
	                'div',
	                { className: 'default-editor' },
	                _react2.default.createElement('input', {
	                  className: 'form-control poster-title',
	                  placeholder: __('Enter Poster Title', _locale2.default),
	                  value: this.state.title,
	                  onChange: this.onTitleChange
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'EditItemList' },
	                  EditItems
	                ),
	                _react2.default.createElement(
	                  _Transition2.default,
	                  null,
	                  poster_type == 'registration' && hasTitle && _react2.default.createElement(_TicketList2.default, {
	                    ticketList: ticketList,
	                    onTicketChange: this.onTicketChange,
	                    addTicket: this.addTicket,
	                    removeTicket: this.removeTicket
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return EditPoster;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchPosterDetail: _ducks.fetchPosterDetail,
	  updateTitle: _ducks.updateTitle,
	  updateTicket: _ducks.updateTicket,
	  createTicket: _ducks.createTicket,
	  deleteTicket: _ducks.deleteTicket,
	
	  updateContentItem: _ducks.updateContentItem,
	  removeContentItem: _ducks.removeContentItem,
	  addContentItem: _ducks.addContentItem
	})(EditPoster);
	module.exports = exports['default'];

/***/ },

/***/ "avJc":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"EditPoster":"EditPoster","ContentSection":"ContentSection","RegisterSection":"RegisterSection","ContentList":"ContentList","hasOneItem":"hasOneItem","DeleteButton":"DeleteButton","PosterEditItem":"PosterEditItem","active":"active","icon-trash":"icon-trash","ContentEditor":"ContentEditor","quill":"quill","ql-container":"ql-container","ql-tooltip":"ql-tooltip","ql-editing":"ql-editing","PosterEditItemBg":"PosterEditItemBg","PreviewContent":"PreviewContent","TitleControlSection":"TitleControlSection","edit-poster-header":"edit-poster-header","icon-picture":"icon-picture","icon-font":"icon-font","add-btn-container":"add-btn-container","image-btn":"image-btn","zone":"zone","ql-toolbar":"ql-toolbar","ql-snow":"ql-snow","text-section":"text-section"};

/***/ },

/***/ "K6Gm":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp; /**
	                    * <TextItem
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDropzone = __webpack_require__("KTM0");
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _ImageCropper = __webpack_require__("jlVy");
	
	var _ImageCropper2 = _interopRequireDefault(_ImageCropper);
	
	var _uploadPicture = __webpack_require__("JmXh");
	
	var _uploadPicture2 = _interopRequireDefault(_uploadPicture);
	
	var _alert = __webpack_require__("BGi1");
	
	var _reactSortable = __webpack_require__("XNaT");
	
	var _locale = __webpack_require__("AfbW");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ACCEPT_MIME = 'image/png,image/jpeg';
	var MAX_SIZE = 5 * 1000 * 1000;
	var MIN_SIZE = 0;
	
	var Item = (_temp = _class = function (_React$Component) {
	  _inherits(Item, _React$Component);
	
	  function Item(props) {
	    _classCallCheck(this, Item);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.selectImage = _this.selectImage.bind(_this);
	    return _this;
	  }
	
	  Item.prototype.componentWillMount = function componentWillMount() {};
	
	  Item.prototype.selectImage = function selectImage(accepted, rejected) {
	    var _this2 = this;
	
	    if (rejected.length > 0) {
	      _alert.alert.warning(__('Image file must be png/jpeg under 5 MB', 'image'), __('Image not qualified', 'image'));
	      return;
	    } else if (accepted.length === 0) {
	      _alert.alert.warning('', __('No Image Selected'));
	      return;
	    }
	
	    (0, _ImageCropper2.default)({
	      file: accepted[0]
	    }).then(function (_ref) {
	      var file = _ref.file,
	          imageUrl = _ref.imageUrl,
	          dataUrl = _ref.dataUrl;
	      var _props = _this2.props,
	          addItem = _props.addItem,
	          posterId = _props.posterId;
	
	
	      if (file) {
	        _this2.setState({
	          creating: true
	        });
	
	        (0, _uploadPicture2.default)(posterId, file).then(function (res) {
	          addItem('picture', {
	            image_url: res.save_to
	          });
	
	          // STEP 3. CREATING COMPLETE
	          _this2.setState({
	            creating: false
	          });
	        });
	      }
	    }).catch(function (err) {});
	  };
	
	  Item.prototype.render = function render() {
	    var _props2 = this.props,
	        item = _props2.item,
	        addItem = _props2.addItem,
	        removeItem = _props2.removeItem,
	        onClick = _props2.onClick,
	        showAddOption = _props2.showAddOption;
	    var text = item.text,
	        content_type = item.content_type,
	        image_url = item.image_url,
	        index = item.index;
	
	
	    var contentText = index === 1 && text === '' ? '<p>' + __('Please start to edit your poster at right side editor', _locale2.default) + '</p>' : text;
	
	    var Content = _react2.default.createElement(
	      'div',
	      { className: 'PreviewContent', 'data-qr-json': JSON.stringify(item) },
	      content_type === 'picture' && _react2.default.createElement('img', { src: image_url, className: 'PosterEditItemBg' }),
	      _react2.default.createElement(
	        'a',
	        null,
	        _react2.default.createElement(_reactDropzone2.default, {
	          accept: ACCEPT_MIME,
	          multiple: false,
	          className: 'zone',
	          maxSize: MAX_SIZE,
	          minSize: MIN_SIZE,
	          onDrop: this.selectImage
	        })
	      ),
	      _react2.default.createElement('i', { className: 'DeleteButton fa icon-trash', onClick: removeItem }),
	      content_type == 'text' && _react2.default.createElement('div', { className: 'text-section', dangerouslySetInnerHTML: { __html: contentText } })
	    );
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'li',
	        _extends({ className: (0, _classnames2.default)('PosterEditItem', { "active": showAddOption[item.id] == true }) }, this.props),
	        Content
	      ),
	      showAddOption[item.id] && _react2.default.createElement(
	        'div',
	        { className: 'text-center add-btn-container' },
	        _react2.default.createElement('i', { className: 'fa icon-font', onClick: function onClick() {
	            addItem('text');
	          } }),
	        _react2.default.createElement(
	          'a',
	          { className: 'image-btn' },
	          _react2.default.createElement(_reactDropzone2.default, {
	            accept: ACCEPT_MIME,
	            multiple: false,
	            className: 'zone',
	            maxSize: MAX_SIZE,
	            minSize: MIN_SIZE,
	            onDrop: this.selectImage,
	            children: _react2.default.createElement(
	              'div',
	              { className: 'add-item-btn' },
	              _react2.default.createElement('i', { className: 'fa icon-picture' })
	            )
	          })
	        )
	      )
	    );
	  };
	
	  return Item;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = (0, _reactSortable.sortable)(Item);
	module.exports = exports['default'];

/***/ },

/***/ "AfbW":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'EditPoster',
	  code: 'CN',
	  text: {
	    'Poster': '海报',
	    'Edit Poster': '编辑海报',
	    'Poster Title': '海报标题',
	    'Poster Content': '海报内容',
	    'Save': '保存至草稿',
	    'Publish': '发布',
	    'Preview': '预览',
	    'Enter poster title': '输入海报标题',
	    'Please start to edit your poster at right side editor': '请在右边编辑框内开始编辑海报',
	    'Proceed to delete item?': '你确定要删除这个项目吗？',
	    'Delete Item': '删除项目',
	    'Please enter poster title': '您尚未输入海报标题',
	    'Please enter registration setup': '您尚未输入报名设置',
	    'Please enter registration title': '您尚未输入报名设置标题',
	    'Please enter registration price': '您尚未输入报名设置价格',
	    'This poster has people registered, you can not edit poster': '当前海报已经有人报名了，您无法再次编辑海报。'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "pYqi":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Fields = __webpack_require__("8/2o");
	
	var _TimePicker = __webpack_require__("ryd0");
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__("hacQ");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdvanceSettings = function (_Component) {
	  _inherits(AdvanceSettings, _Component);
	
	  function AdvanceSettings(props) {
	    _classCallCheck(this, AdvanceSettings);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  AdvanceSettings.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props$data = this.props.data,
	        startDate = _props$data.startDate,
	        startTime = _props$data.startTime,
	        endDate = _props$data.endDate,
	        endTime = _props$data.endTime,
	        price = _props$data.price,
	        noEndTime = _props$data.noEndTime,
	        auto_wait_list = _props$data.auto_wait_list;
	    var _props = this.props,
	        onChange = _props.onChange,
	        type = _props.type;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'advance-settings-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 advance-title' },
	          __('Advance Settings', 'ticket')
	        ),
	        _react2.default.createElement('hr', { className: 'advance-hr' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 advance-label' },
	          __('Registration Start Time', 'ticket')
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-6' },
	          _react2.default.createElement(_Fields.DatePicker, { value: startDate, onChange: onChange('startDate') })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-6' },
	          _react2.default.createElement(_TimePicker2.default, { value: (0, _moment2.default)(startTime, 'hh:mm:ss'), onChange: onChange('startTime') })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row' },
	        _react2.default.createElement(
	          'span',
	          { className: 'advance-label' },
	          __('Registration End Time', 'ticket')
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'no-end-time' },
	          _react2.default.createElement(
	            'label',
	            { className: 'control' },
	            _react2.default.createElement('input', { type: 'checkbox', onChange: onChange('noEndTime'), checked: noEndTime }),
	            _react2.default.createElement('span', { className: 'checkmark' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'advance-label' },
	              __('No End Time', 'ticket')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-6' },
	          _react2.default.createElement(_Fields.DatePicker, { value: endDate, onChange: onChange('endDate'), disabled: noEndTime === true })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-6' },
	          _react2.default.createElement(_TimePicker2.default, { value: (0, _moment2.default)(endTime, 'hh:mm:ss'), onChange: onChange('endTime'), disabled: noEndTime === true })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 advance-label' },
	          __('Price', 'ticket'),
	          type == 'fixedAmount' && _react2.default.createElement(
	            'span',
	            { className: 'red' },
	            '*'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-6' },
	          _react2.default.createElement(_Fields.Money, { outputType: 'string', value: price, onChange: onChange('price') })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 advance-label wait-list-label' },
	          __('Waiting List', 'ticket'),
	          _react2.default.createElement(
	            'span',
	            { className: 'red' },
	            '*'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 wait-list' },
	          _react2.default.createElement(
	            'label',
	            { className: 'control' },
	            _react2.default.createElement('input', { type: 'radio', value: 'enterWaitList', onChange: onChange('auto_wait_list'), checked: auto_wait_list === 'enterWaitList' }),
	            _react2.default.createElement('span', { className: 'radiomark' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'advance-label wait-list-input' },
	              __('Allow Waiting List', 'ticket')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 wait-list' },
	          _react2.default.createElement(
	            'label',
	            { className: 'control' },
	            _react2.default.createElement('input', { type: 'radio', value: 'noWaitList', onChange: onChange('auto_wait_list'), checked: auto_wait_list === 'noWaitList' }),
	            _react2.default.createElement('span', { className: 'radiomark' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'advance-label wait-list-input' },
	              __('No Waiting List', 'ticket')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row text-center' },
	        _react2.default.createElement('hr', { className: 'advance-hr' }),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn-link close-advance', onClick: function onClick() {
	              _this2.props.callbackFromParent({ showingAdvance: false });
	            } },
	          _react2.default.createElement('i', { className: 'fa icon-up-big' }),
	          __('Close Advance Settings', 'ticket')
	        )
	      )
	    );
	  };
	
	  return AdvanceSettings;
	}(_react.Component);
	
	exports.default = AdvanceSettings;
	module.exports = exports['default'];

/***/ },

/***/ "hacQ":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ticket-content":"ticket-content","ticket-container":"ticket-container","other-settings-content":"other-settings-content","btn-row":"btn-row","register-btn":"register-btn","icon-plus":"icon-plus","register-btn-fee":"register-btn-fee","registration-setting-icon":"registration-setting-icon","price-description":"price-description","registration-setting-content":"registration-setting-content","registration-setting-trash":"registration-setting-trash","registration-setting-cog":"registration-setting-cog","advance-settings-content":"advance-settings-content","advance-title":"advance-title","advance-hr":"advance-hr","other-setting-title":"other-setting-title","other-setting-description":"other-setting-description","advance-label":"advance-label","close-advance":"close-advance","red":"red","no-end-time":"no-end-time","wait-list":"wait-list","wait-list-label":"wait-list-label","wait-list-input":"wait-list-input","icon-up-big":"icon-up-big","plus-1":"plus-1","plus-2":"plus-2"};

/***/ },

/***/ "Wab1":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"default-editor":"default-editor","poster-title":"poster-title","medium-editor-element":"medium-editor-element","medium-editor-placeholder":"medium-editor-placeholder","edit-item":"edit-item","add-item":"add-item","add-text":"add-text","add-item-btn":"add-item-btn","icon-picture":"icon-picture","icon-plus":"icon-plus","icon-font":"icon-font","image":"image","edit-item-trash":"edit-item-trash"};

/***/ },

/***/ "1SKC":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"poster-container":"poster-container","create-poster-title":"create-poster-title","header-title":"header-title","container-fluid":"container-fluid","header":"header","buttons":"buttons","template":"template","col-xs-6":"col-xs-6","title":"title","creating-section":"creating-section","content-section":"content-section","default-section":"default-section","choose-item":"choose-item","poster-content":"poster-content","icon-wrapper":"icon-wrapper","zone":"zone","icon-picture":"icon-picture","icon-font":"icon-font","select-type":"select-type","poster-date":"poster-date","add-section-btn":"add-section-btn","add-section-btn-container":"add-section-btn-container","icon-plus":"icon-plus","edit-item":"edit-item","dragged":"dragged"};

/***/ },

/***/ "SGXh":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _updatePoster = __webpack_require__("xsdH");
	
	var _updatePoster2 = _interopRequireDefault(_updatePoster);
	
	__webpack_require__("hacQ");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    posterDetail: state.posterDetail
	  };
	};
	
	var OtherSettings = function (_Component) {
	  _inherits(OtherSettings, _Component);
	
	  function OtherSettings(props) {
	    _classCallCheck(this, OtherSettings);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  OtherSettings.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (props.posterDetail) {
	      this.state = {
	        show_spots_left: props.posterDetail.detail.show_spots_left == 1 ? 'yes' : 'no',
	        show_page_view: props.posterDetail.detail.show_page_view == 1 ? 'yes' : 'no',
	        posterId: props.posterDetail.detail.id
	      };
	    }
	  };
	
	  OtherSettings.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        show_spots_left = _state.show_spots_left,
	        show_page_view = _state.show_page_view,
	        posterId = _state.posterId;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'other-settings-content' },
	      _react2.default.createElement(
	        'h3',
	        { className: 'ticket-title' },
	        __('Other Settings', 'ticket')
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'other-setting-title' },
	        __('Registration Progress', 'ticket')
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: 'control' },
	        _react2.default.createElement('input', { type: 'checkbox', checked: show_spots_left == 'yes', onClick: function onClick() {
	            show_spots_left == 'yes' ? (0, _updatePoster2.default)(posterId, { show_spots_left: 'no' }).then(function (res) {
	              _this2.setState({ show_spots_left: 'no' });
	            }) : (0, _updatePoster2.default)(posterId, { show_spots_left: 'yes' }).then(function (res) {
	              _this2.setState({ show_spots_left: 'yes' });
	            });
	          } }),
	        _react2.default.createElement('span', { className: 'checkmark' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'other-setting-description' },
	          __('Show Registration Progress on Poster', 'ticket')
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'other-setting-title' },
	        __('Read Count', 'ticket')
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: 'control' },
	        _react2.default.createElement('input', { type: 'checkbox', checked: show_page_view == 'yes', onClick: function onClick() {
	            show_page_view == 'yes' ? (0, _updatePoster2.default)(posterId, { show_page_view: 'no' }).then(function (res) {
	              _this2.setState({ show_page_view: 'no' });
	            }) : (0, _updatePoster2.default)(posterId, { show_page_view: 'yes' }).then(function (res) {
	              _this2.setState({ show_page_view: 'yes' });
	            });
	          } }),
	        _react2.default.createElement('span', { className: 'checkmark' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'other-setting-description' },
	          __('Show Read Count on Poster', 'ticket')
	        )
	      )
	    );
	  };
	
	  return OtherSettings;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(OtherSettings);
	module.exports = exports['default'];

/***/ },

/***/ "/J0p":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Fields = __webpack_require__("8/2o");
	
	var _AdvanceSettings = __webpack_require__("pYqi");
	
	var _AdvanceSettings2 = _interopRequireDefault(_AdvanceSettings);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__("hacQ");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RegistrationSetting = function (_Component) {
	  _inherits(RegistrationSetting, _Component);
	
	  function RegistrationSetting(props) {
	    _classCallCheck(this, RegistrationSetting);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    var _props$ticket = props.ticket,
	        title = _props$ticket.title,
	        amount = _props$ticket.amount,
	        startDate = _props$ticket.startDate,
	        startTime = _props$ticket.startTime,
	        endDate = _props$ticket.endDate,
	        endTime = _props$ticket.endTime,
	        price = _props$ticket.price,
	        noEndTime = _props$ticket.noEndTime,
	        auto_wait_list = _props$ticket.auto_wait_list,
	        index = _props$ticket.index,
	        ticketLength = _props$ticket.ticketLength;
	
	
	    _this.state = {
	      showingAdvance: true,
	      data: _extends({}, props.ticket, {
	        title: title || '',
	        amount: amount || '',
	        startDate: startDate ? startDate : (0, _moment2.default)().format('YYYY-MM-DD'),
	        startTime: startTime ? startTime : (0, _moment2.default)().format('00:00:00'),
	        endDate: endDate || (0, _moment2.default)().format('YYYY-MM-DD'),
	        endTime: endTime || '00:00:00',
	        price: price || 0,
	        noEndTime: noEndTime || true,
	        auto_wait_list: auto_wait_list == 1 ? 'enterWaitList' : 'noWaitList' || 'enterWaitList',
	        index: index
	      })
	
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.showingAdvanceCallback = _this.showingAdvanceCallback.bind(_this);
	    return _this;
	  }
	
	  RegistrationSetting.prototype.onChange = function onChange(name) {
	    var _this2 = this;
	
	    var onTicketChange = this.props.onTicketChange;
	
	
	    return function (value) {
	      var _extends2;
	
	      var newValue = void 0;
	
	      if (name == 'startDate' || name == 'endDate') {
	        if (value instanceof _moment2.default) {
	          newValue = value.format('YYYY-MM-DD');
	        }
	      } else if (name == 'startTime' || name == 'endTime') {
	        if (value instanceof _moment2.default) {
	          newValue = value.format('HH:mm:ss');
	        }
	      } else if (name == 'noEndTime') {
	        newValue = value.target.checked;
	      } else if (name == 'auto_wait_list') {
	        newValue = value.target.value;
	      } else if (name == 'price') {
	        if (value == '') {
	          newValue = '0';
	        } else {
	          newValue = value.replace('$', '');
	        }
	      } else {
	        newValue = value;
	      }
	
	      _this2.setState({
	        data: _extends({}, _this2.state.data, (_extends2 = {}, _extends2[name] = newValue, _extends2))
	      }, function () {
	        onTicketChange(_this2.state.data);
	      });
	    };
	  };
	
	  RegistrationSetting.prototype.showingAdvanceCallback = function showingAdvanceCallback(data) {
	    this.setState(data);
	  };
	
	  RegistrationSetting.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        showingAdvance = _state.showingAdvance,
	        data = _state.data;
	    var title = data.title,
	        price = data.price,
	        amount = data.amount;
	    var _props = this.props,
	        onTicketChange = _props.onTicketChange,
	        ticket = _props.ticket,
	        onRemoveTicket = _props.onRemoveTicket,
	        type = _props.type;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'registration-setting-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row btn-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-4' },
	          _react2.default.createElement(_Fields.SimpleInput, { value: title, onChange: this.onChange('title'), placeholder: __('Dance Class, English Class, etc', 'ticket') })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-3' },
	          _react2.default.createElement(_Fields.Quantity, { value: amount, onChange: this.onChange('amount'), suffix: __('', 'ticket') })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-3 price-description' },
	          type == 'freeOrPayOffline' ? __('Pay Offline', 'ticket') : __('Pay Online', 'ticket')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-2 registration-setting-icon' },
	          _react2.default.createElement('i', { className: 'fa icon-cog registration-setting-cog', onClick: function onClick() {
	              if (showingAdvance == false) {
	                _this3.setState({ showingAdvance: true });
	              } else {
	                _this3.setState({ showingAdvance: false });
	              }
	            } }),
	          _react2.default.createElement('i', { className: 'fa icon-trash registration-setting-trash', onClick: onRemoveTicket })
	        )
	      ),
	      showingAdvance == true && _react2.default.createElement(_AdvanceSettings2.default, { type: type, data: data, onChange: this.onChange, callbackFromParent: this.showingAdvanceCallback })
	    );
	  };
	
	  return RegistrationSetting;
	}(_react.Component);
	
	exports.default = RegistrationSetting;
	module.exports = exports['default'];

/***/ },

/***/ "0rOf":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RegistrationSetting = __webpack_require__("/J0p");
	
	var _RegistrationSetting2 = _interopRequireDefault(_RegistrationSetting);
	
	var _OtherSettings = __webpack_require__("SGXh");
	
	var _OtherSettings2 = _interopRequireDefault(_OtherSettings);
	
	__webpack_require__("hacQ");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	var TicketList = function (_Component) {
	  _inherits(TicketList, _Component);
	
	  function TicketList(props) {
	    _classCallCheck(this, TicketList);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  TicketList.prototype.renderRegistrationSetting = function renderRegistrationSetting() {
	    var _props = this.props,
	        ticketList = _props.ticketList,
	        onTicketChange = _props.onTicketChange,
	        removeTicket = _props.removeTicket;
	
	
	    return ticketList.map(function (ticket, index) {
	      if (index === 0) {
	        return _react2.default.createElement(_RegistrationSetting2.default, {
	          key: index,
	          ticket: ticket,
	          onTicketChange: onTicketChange(index, ticket.id),
	          onRemoveTicket: removeTicket(index, ticket),
	          type: ticket.price_type
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'row btn-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-4' },
	            __('Registration Title', 'ticket'),
	            _react2.default.createElement(
	              'span',
	              { className: 'red' },
	              '*'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-3' },
	            __('Amount of People', 'ticket'),
	            _react2.default.createElement(
	              'span',
	              null,
	              __(' (No limit if empty)', 'ticket')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-3' },
	            __('Price Description', 'ticket')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-2' },
	            __('Settings', 'ticket')
	          )
	        ),
	        _react2.default.createElement(_RegistrationSetting2.default, {
	          key: index,
	          ticket: ticket,
	          onTicketChange: onTicketChange(index, ticket.id),
	          onRemoveTicket: removeTicket(index, ticket),
	          type: ticket.price_type
	        })
	      );
	    });
	  };
	
	  TicketList.prototype.render = function render() {
	    var showingBasic = this.state.showingBasic;
	    var _props2 = this.props,
	        _props2$ticketList = _props2.ticketList,
	        ticketList = _props2$ticketList === undefined ? [] : _props2$ticketList,
	        onTicketChange = _props2.onTicketChange,
	        addTicket = _props2.addTicket;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'ticket-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'ticket-container' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'ticket-title' },
	          __('Registration Setup', 'ticket'),
	          _react2.default.createElement(
	            'span',
	            { className: 'red' },
	            '*'
	          )
	        ),
	        ticketList.length > 0 && _react2.default.createElement(
	          'div',
	          { className: 'row btn-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-4' },
	            __('Registration Title', 'ticket'),
	            _react2.default.createElement(
	              'span',
	              { className: 'red' },
	              '*'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-3' },
	            __('Amount of People', 'ticket'),
	            _react2.default.createElement(
	              'span',
	              null,
	              __(' (No limit if empty)', 'ticket')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-3' },
	            __('Price Description', 'ticket')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-2' },
	            __('Settings', 'ticket')
	          )
	        ),
	        this.renderRegistrationSetting(),
	        _react2.default.createElement(
	          'div',
	          { className: 'row btn-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-5 btn text-center', onClick: function onClick() {
	                addTicket('freeOrPayOffline');
	              } },
	            _react2.default.createElement(
	              'span',
	              { className: 'registration-reg' },
	              __('Registration', 'ticket')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-5 btn text-center', onClick: function onClick() {
	                addTicket('fixedAmount');
	              } },
	            _react2.default.createElement(
	              'span',
	              { className: 'registration-with-fee' },
	              __('Registration with Fees', 'ticket')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_OtherSettings2.default, null)
	    );
	  };
	
	  return TicketList;
	}(_react.Component);
	
	exports.default = TicketList;
	module.exports = exports['default'];

/***/ },

/***/ "4208":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
			id: 'posterList',
			code: 'CN',
			text: {
					'{ticket_amount}': '{ticket_amount}人',
					'Enter Your Text': '输入文字',
					'MMM DD, YYYY': 'YYYY年MM月DD日',
					'ddd, MMM DD YYYY': 'YYYY年MM月DD日 ddd',
					'Delete Content': '删除内容',
					'Are you sure you want to delete the picture above?': '你确定要删除上面的图片吗？',
					'Are you sure you want to delete the picture?': '你确定要删除此图片吗？',
					'Create New Registration Poster': '创建课程报名海报',
					'Create New Basic Poster': '创建普通海报',
					'Create New Poster': '创建课程报名海报',
					'Save': '保存',
					'Publish': '发布',
					'Preview': '预览',
					'Poster Content': '海报内容',
					'Poster Templates': '海报模板',
					'Enter Poster Title': '输入海报标题',
					'Poster Content: Select Picture or Text': '选择图片或文字添加海报内容',
					'Last Updated: ': '最后更改日期：',
					'Add Content': '添加图文',
					'Unable to Edit Published Poster': '已发布的海报无法编辑',
					'Cancel uploading image?': '取消上传图片？'
			}
	};
	module.exports = exports['default'];

/***/ },

/***/ "OD49":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp; /**
	                    * <EditPoster
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactQuill = __webpack_require__("TWqO");
	
	var _reactQuill2 = _interopRequireDefault(_reactQuill);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	__webpack_require__("9BT8");
	
	var _TicketList = __webpack_require__("0rOf");
	
	var _TicketList2 = _interopRequireDefault(_TicketList);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _Item = __webpack_require__("K6Gm");
	
	var _Item2 = _interopRequireDefault(_Item);
	
	__webpack_require__("avJc");
	
	var _updatePoster = __webpack_require__("xsdH");
	
	var _updatePoster2 = _interopRequireDefault(_updatePoster);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _reactDropzone = __webpack_require__("KTM0");
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _ImageCropper = __webpack_require__("jlVy");
	
	var _ImageCropper2 = _interopRequireDefault(_ImageCropper);
	
	var _uploadPicture = __webpack_require__("JmXh");
	
	var _uploadPicture2 = _interopRequireDefault(_uploadPicture);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _PanelWrapper = __webpack_require__("VPji");
	
	var _PanelWrapper2 = _interopRequireDefault(_PanelWrapper);
	
	var _alert = __webpack_require__("BGi1");
	
	var _ducks = __webpack_require__("srt+");
	
	var _lodash = __webpack_require__("M4fF");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _locale = __webpack_require__("AfbW");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ACCEPT_MIME = 'image/png,image/jpeg';
	var MAX_SIZE = 5 * 1000 * 1000;
	var MIN_SIZE = 0;
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    posterDetail: state.posterDetail
	  };
	};
	
	var EditPoster = (_temp = _class = function (_React$Component) {
	  _inherits(EditPoster, _React$Component);
	
	  function EditPoster(props) {
	    _classCallCheck(this, EditPoster);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      itemBeingEdited: {},
	      showAddOption: {},
	      lastItem: false
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.addItem = _this.addItem.bind(_this);
	    _this.removeItem = _this.removeItem.bind(_this);
	    _this.openEditor = _this.openEditor.bind(_this);
	    _this.updateText = _this.updateText.bind(_this);
	    _this.onSort = _this.onSort.bind(_this);
	    _this.addTicket = _this.addTicket.bind(_this);
	    _this.removeTicket = _this.removeTicket.bind(_this);
	    _this.onTicketChange = _this.onTicketChange.bind(_this);
	    _this.onTitleChange = _this.onTitleChange.bind(_this);
	
	    var posterId = _this.props.routeParams.posterId;
	
	    _this.posterId = posterId; //
	
	    return _this;
	  }
	
	  EditPoster.prototype.onChange = function onChange(ref) {};
	
	  EditPoster.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    this.props.fetchPosterDetail(this.posterId, function () {
	      var _showAddOption;
	
	      var lastItem = _this2.props.posterDetail.contentList.length == 1;
	      _this2.setState({
	        itemBeingEdited: _this2.props.posterDetail.contentList[0],
	        showAddOption: (_showAddOption = {}, _showAddOption[_this2.props.posterDetail.contentList[0].id] = true, _showAddOption),
	        lastItem: lastItem
	      });
	    });
	  };
	
	  EditPoster.prototype.openEditor = function openEditor(itemBeingEditedIndex, itemBeingEdited) {
	    var _this3 = this;
	
	    return function () {
	      var _showAddOption2;
	
	      _this3.setState({
	        itemBeingEditedIndex: itemBeingEditedIndex,
	        itemBeingEdited: itemBeingEdited,
	        showAddOption: (_showAddOption2 = {}, _showAddOption2[itemBeingEdited.id] = true, _showAddOption2)
	      });
	    };
	  };
	
	  EditPoster.prototype.addItem = function addItem(index) {
	    var _this4 = this;
	
	    return function (type, contentIn) {
	      if (type == 'picture') {
	        _this4.props.addContentItem(index, _this4.posterId, _extends({ content_type: "picture" }, contentIn));
	      }
	      if (type == 'text') {
	        _this4.props.addContentItem(index, _this4.posterId, _extends({ content_type: "text" }, contentIn));
	      }
	    };
	  };
	
	  EditPoster.prototype.removeItem = function removeItem(index, contentId) {
	    var _this5 = this;
	
	    return function () {
	      (0, _confirm2.default)(__('Proceed to delete item?', _locale2.default), __('Delete Item', _locale2.default)).then(function () {
	        _this5.setState({ itemBeingEdited: {} });
	        _this5.props.removeContentItem(index, contentId, _this5.posterId);
	      }).catch(function () {});
	    };
	  };
	
	  //
	  // ticket: START
	  //
	
	
	  EditPoster.prototype.addTicket = function addTicket(type) {
	    var _props$posterDetail$t = this.props.posterDetail.ticketList,
	        ticketList = _props$posterDetail$t === undefined ? [] : _props$posterDetail$t;
	
	
	    this.props.createTicket(this.posterId, { title: '', index: ticketList.length + 1, price_type: type });
	  };
	
	  EditPoster.prototype.removeTicket = function removeTicket(index, ticket) {
	    var _this6 = this;
	
	    return function () {
	      var endDate = ticket.endDate,
	          endTime = ticket.endTime,
	          title = ticket.title,
	          price = ticket.price;
	
	      var priceFloat = typeof price === 'undefined' ? price : parseFloat(price);
	
	      if (endDate || endTime || title || priceFloat) {
	        (0, _confirm2.default)(__('Proceed to delete this registration?', 'ticket')).then(function () {
	          _this6.props.deleteTicket(ticket.id, index);
	        });
	      } else {
	        _this6.props.deleteTicket(ticket.id, index);
	      }
	    };
	  };
	
	  EditPoster.prototype.onTicketChange = function onTicketChange(index, ticketId) {
	    var _this7 = this;
	
	    return function (newSettings) {
	      clearTimeout(_this7.updateTextTimeout);
	
	      _this7.updateTextTimeout = setTimeout(function () {
	        _this7.props.updateTicket(ticketId, newSettings);
	      }, 500);
	    };
	  };
	  //
	  // ticket: END
	  //
	
	  EditPoster.prototype.updateText = function updateText(text) {
	    var _this8 = this;
	
	    if (!text) {
	      return;
	    }
	
	    var _state = this.state,
	        itemBeingEdited = _state.itemBeingEdited,
	        itemBeingEditedIndex = _state.itemBeingEditedIndex;
	    var content_type = itemBeingEdited.content_type;
	
	
	    clearTimeout(this.updateTextTimeout);
	
	    this.setState({
	      itemBeingEdited: _extends({}, itemBeingEdited, {
	        text: text
	      }),
	      updating: true
	    });
	
	    this.updateTextTimeout = setTimeout(function () {
	      _this8.props.updateContentItem(itemBeingEditedIndex, itemBeingEdited.id, {
	        content_type: content_type,
	        text: text
	      });
	
	      _this8.setState({
	        updating: false
	      });
	    }, 250);
	  };
	
	  EditPoster.prototype.onTitleChange = function onTitleChange(event) {
	    var _this9 = this;
	
	    var title = event.target.value;
	
	    clearTimeout(this.updateTextTimeout);
	    this.props.updateTitle(title);
	
	    this.updateTextTimeout = setTimeout(function () {
	      (0, _updatePoster2.default)(_this9.posterId, { title: title }).then(function (res) {});
	    }, 500);
	  };
	
	  EditPoster.prototype.onSort = function onSort(newOrder) {
	    this.newOrder = newOrder;
	  };
	
	  EditPoster.prototype.onDragEnd = function onDragEnd(item) {
	    var _this10 = this;
	
	    return function () {
	      _this10.props.updateOrder(_this10.newOrder, item);
	    };
	  };
	
	  EditPoster.prototype.selectImage = function selectImage(accepted, rejected) {
	    var _this11 = this;
	
	    if (rejected.length > 0) {
	      _alert.alert.warning(__('Image file must be png/jpeg under 5 MB', 'image'), __('Image not qualified', 'image'));
	      return;
	    } else if (accepted.length === 0) {
	      _alert.alert.warning('', __('No Image Selected'));
	      return;
	    }
	
	    (0, _ImageCropper2.default)({
	      file: accepted[0]
	    }).then(function (_ref) {
	      var file = _ref.file,
	          imageUrl = _ref.imageUrl,
	          dataUrl = _ref.dataUrl;
	      var _props = _this11.props,
	          addItem = _props.addItem,
	          posterId = _props.posterId;
	
	
	      if (file) {
	        _this11.setState({
	          creating: true
	        });
	
	        (0, _uploadPicture2.default)(posterId, file).then(function (res) {
	          addItem('picture', {
	            image_url: res.save_to
	          });
	
	          // STEP 3. CREATING COMPLETE
	          _this11.setState({
	            creating: false
	          });
	        });
	      }
	    }).catch(function (err) {});
	  };
	
	  EditPoster.prototype.render = function render() {
	    var _this12 = this;
	
	    var _props$posterDetail = this.props.posterDetail,
	        _props$posterDetail$c = _props$posterDetail.contentList,
	        contentList = _props$posterDetail$c === undefined ? [] : _props$posterDetail$c,
	        _props$posterDetail$t2 = _props$posterDetail.ticketList,
	        ticketList = _props$posterDetail$t2 === undefined ? [] : _props$posterDetail$t2,
	        title = _props$posterDetail.title,
	        fetching = _props$posterDetail.fetching,
	        poster_type = _props$posterDetail.poster_type;
	    var _state2 = this.state,
	        _state2$itemBeingEdit = _state2.itemBeingEdited,
	        itemBeingEdited = _state2$itemBeingEdit === undefined ? [] : _state2$itemBeingEdit,
	        showAddOption = _state2.showAddOption;
	
	    var hasOneItem = contentList.length === 1;
	
	    var hasTitle = true;
	    var hasPrice = true;
	    if (ticketList) {
	      ticketList.map(function (ticket) {
	        if (!ticket.title) {
	          hasTitle = false;
	        }
	        if (ticket.price_type == 'fixedAmount' && Number(ticket.price) <= 0) {
	          hasPrice = false;
	        }
	      });
	    }
	
	    return _react2.default.createElement(
	      _PanelWrapper2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'bread-crumbs' },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/poster' },
	          __('Poster', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          ' / '
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          __('Edit Poster', _locale2.default)
	        ),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { className: 'pull-right', to: '/poster' },
	          _react2.default.createElement('i', { className: 'fa icon-cancel' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'EditPoster' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          __('Poster Title', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'pull-right btn btn-primary', onClick: function onClick() {
	              if (!title) {
	                return _alert.alert.warning(__('Please enter poster title', _locale2.default));
	              }
	              if (poster_type == 'registration' && ticketList.length <= 0) {
	                return _alert.alert.warning(__('Please enter registration setup', _locale2.default));
	              }
	              if (ticketList && !hasTitle) {
	                return _alert.alert.warning(__('Please enter registration title', _locale2.default));
	              }
	              if (ticketList && (!hasTitle || !hasPrice)) {
	                return _alert.alert.warning(__('Please enter registration price', _locale2.default));
	              }
	              (0, _updatePoster2.default)(_this12.posterId, { title: title, state: 'published' }).then(function () {
	                _reactRouter.browserHistory.push('/poster');
	              });
	            } },
	          __('Publish', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'pull-right btn btn-orange', onClick: function onClick() {
	              if (!title) {
	                return _alert.alert.warning(__('Please enter poster title', _locale2.default));
	              }
	              if (poster_type == 'registration' && ticketList.length <= 0) {
	                return _alert.alert.warning(__('Please enter registration setup', _locale2.default));
	              }
	              if (ticketList && !hasTitle) {
	                return _alert.alert.warning(__('Please enter registration title', _locale2.default));
	              }
	              if (ticketList && (!hasTitle || !hasPrice)) {
	                return _alert.alert.warning(__('Please enter registration price', _locale2.default));
	              }
	              (0, _updatePoster2.default)(_this12.posterId, { title: title, state: 'draft' }).then(function (res) {
	                // if(res.result == 'failure' && res.reason == 'The poster ticket(s) have(s) been ordered.'){
	                //   alert.warning(__('This poster has people registered, you can not edit poster', locale))
	                // } else {
	                // }
	                _reactRouter.browserHistory.push('/poster');
	              });
	            } },
	          __('Save', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: '/poster-preview/' + this.posterId, target: '_blank', className: 'pull-right btn btn-default' },
	          __('Preview', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'edit-poster-header' },
	          _react2.default.createElement(
	            'section',
	            { className: 'TitleControlSection' },
	            _react2.default.createElement('input', { className: 'form-control', value: title, onChange: this.onTitleChange, placeholder: __('Enter poster title', _locale2.default), maxLength: '200' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'text-count pull-right' },
	              (title || '').length,
	              ' / 200'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          __('Poster Content', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'ContentSection' },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('ContentList', { hasOneItem: hasOneItem }) },
	            _react2.default.createElement(
	              'ul',
	              { className: 'sortable-list' },
	              contentList.map(function (item, index) {
	                return _react2.default.createElement(_Item2.default, {
	                  key: index,
	                  item: item,
	                  onClick: _this12.openEditor(index, item),
	                  addItem: _this12.addItem(index),
	                  removeItem: _this12.removeItem(index, item.id),
	                  posterId: _this12.posterId,
	                  showAddOption: showAddOption
	                  // react-sortable props:h
	                  , sortId: index,
	                  items: contentList,
	                  onSortItems: _this12.onSort,
	                  onDragEnd: _this12.onDragEnd(item)
	                });
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ContentEditor' },
	            itemBeingEdited.content_type == 'picture' && _react2.default.createElement('img', { src: itemBeingEdited.image_url }),
	            itemBeingEdited.content_type == 'text' && _react2.default.createElement(_reactQuill2.default, { value: itemBeingEdited.text || '', onChange: this.updateText })
	          )
	        ),
	        poster_type !== 'basic' && _react2.default.createElement('hr', null),
	        poster_type !== 'basic' && _react2.default.createElement(
	          'section',
	          { className: 'RegisterSection' },
	          _react2.default.createElement(_TicketList2.default, {
	            ticketList: ticketList,
	            onTicketChange: this.onTicketChange,
	            addTicket: this.addTicket,
	            removeTicket: this.removeTicket
	          })
	        )
	      )
	    );
	  };
	
	  return EditPoster;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  updateOrder: _ducks.updateOrder,
	
	  fetchPosterDetail: _ducks.fetchPosterDetail,
	
	  updateTitle: _ducks.updateTitle,
	  updateTicket: _ducks.updateTicket,
	  createTicket: _ducks.createTicket,
	  deleteTicket: _ducks.deleteTicket,
	
	  updateContentItem: _ducks.updateContentItem,
	  removeContentItem: _ducks.removeContentItem,
	  addContentItem: _ducks.addContentItem
	})(EditPoster);
	module.exports = exports['default'];

/***/ },

/***/ "d05b":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon-ticket":"icon-ticket","poster--list--container":"poster--list--container","row":"row"};

/***/ },

/***/ "xrS3":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _updatePoster2 = __webpack_require__("xsdH");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactBackgroundImageLoader = __webpack_require__("SoiV");
	
	var _reactBackgroundImageLoader2 = _interopRequireDefault(_reactBackgroundImageLoader);
	
	var _ShareOnSocialMedia = __webpack_require__("ejl9");
	
	var _ShareOnSocialMedia2 = _interopRequireDefault(_ShareOnSocialMedia);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _locale = __webpack_require__("wrvU");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("JJH7");
	
	var _constants = __webpack_require__("qI5z");
	
	var _alert = __webpack_require__("BGi1");
	
	var _ducks = __webpack_require__("W/Ox");
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <PosterCard />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent PosterList
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    updatePoster: function updatePoster(index, posterId, posterInfo, callback) {
	      return dispatch((0, _ducks.updatePoster)(index, posterId, posterInfo, callback));
	    }
	  };
	};
	
	var PosterCard = function (_React$Component) {
	  _inherits(PosterCard, _React$Component);
	
	  function PosterCard(props) {
	    _classCallCheck(this, PosterCard);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.posterTypeVerbose = [__('Enrollment Registration', 'poster.type'), __('Event Registration', 'poster.type'), __('Survey', 'poster.type'), __('Basic Poster', 'poster.type')];
	    _this.posterStateVerbose = [__('Draft', 'poster'), __('Published', 'poster'), __('Closed', 'poster')];
	    return _this;
	  }
	
	  PosterCard.prototype.getPageUrl = function getPageUrl(id) {
	    var language = localStorage.getItem('language');
	
	    if (false) {
	      return 'https://posterdev.classtop.com/' + id + '?language=' + language;
	    } else {
	      return 'https://poster.classtop.com/' + id + '?language=' + language;
	    }
	  };
	
	  PosterCard.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        onDelete = _props.onDelete,
	        onUnlink = _props.onUnlink,
	        poster = _props.poster,
	        index = _props.index;
	    var id = poster.id,
	        title = poster.title,
	        state = poster.state,
	        poster_type = poster.poster_type,
	        cover_image = poster.cover_image,
	        updated_at = poster.updated_at,
	        has_order = poster.has_order;
	
	
	    var ticket_amount = poster.order_ticket_total_amount;
	    if (ticket_amount == null) {
	      ticket_amount = 0;
	    }
	
	    var stateVerbose = _updatePoster2.STATE[state];
	    var localeCode = localStorage.getItem('language');
	    var dateMoment = (0, _moment2.default)(updated_at).locale(_constants.MOMENT_LOCALE[localeCode] || 'en').format(__('ddd, MMM DD YYYY', _locale2.default));
	    return _react2.default.createElement(
	      'div',
	      { className: 'poster-card-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'poster-card' },
	        _react2.default.createElement(
	          _R2.default,
	          { can: state === 0 ? 'edit_poster' : 'poster_channel', by: 'alert' },
	          _react2.default.createElement(
	            'a',
	            { href: state === 1 ? 'poster-preview/' + id : 'edit-poster/' + id, target: state === 1 ? '_blank' : '', onClick: function onClick(e) {
	                if (has_order && state !== 1) {
	                  e.preventDefault();
	                  _alert.alert.warning(__('You cannot edit poster that has been registered', _locale2.default));
	                }
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'poster-content' },
	              _react2.default.createElement(
	                'span',
	                { className: (0, _classnames2.default)('poster-state', { 'draft': state === 0, 'published': state === 1 }) },
	                this.posterStateVerbose[state]
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'poster-type' },
	                this.posterTypeVerbose[poster_type]
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'image-wrapper' },
	                _react2.default.createElement('div', { className: 'image-overlay' }),
	                _react2.default.createElement(_reactBackgroundImageLoader2.default, { src: cover_image, className: 'image' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'date' },
	                dateMoment
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('title', { 'draft': state === 0, 'published': state === 1 }) },
	                title
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'setting-section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'setting-content' },
	            poster_type !== 3 && _react2.default.createElement(
	              'div',
	              { className: 'card-button', onClick: function onClick() {
	                  _reactRouter.browserHistory.push('/registration-table/' + id);
	                } },
	              __('Registered: ', _locale2.default),
	              __('{ticket_amount}', _locale2.default, { ticket_amount: ticket_amount })
	            ),
	            stateVerbose != 'closed' && _react2.default.createElement(
	              _R2.default,
	              { can: state === 0 ? 'edit_poster' : 'poster_channel', by: 'alert' },
	              _react2.default.createElement(
	                'div',
	                { className: state === 0 ? 'draft' : 'published', onClick: function onClick() {
	                    if (stateVerbose == 'draft') {
	                      _this2.props.updatePoster(index, id, { state: 'published' }, function () {
	                        _this2.props.onFetch();
	                      });
	                    }
	                  } },
	                state === 0 ? __('Publish', _locale2.default) : __('Published', _locale2.default)
	              )
	            ),
	            state !== 1 && _react2.default.createElement(
	              _R2.default,
	              { can: 'edit_poster', by: 'alert' },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn-link poster-button', onClick: onDelete(id) },
	                __('Delete', _locale2.default)
	              )
	            ),
	            state === 1 && _react2.default.createElement(
	              _R2.default,
	              { can: 'edit_poster', by: 'alert' },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn-link poster-button', onClick: onUnlink(id) },
	                __('Close', _locale2.default)
	              )
	            ),
	            state === 1 && _react2.default.createElement(
	              'button',
	              { className: 'btn-link poster-button', onClick: function onClick() {
	                  (0, _ShareOnSocialMedia2.default)({ pageUrl: _this2.getPageUrl(id), pageTitle: title });
	                } },
	              __('Share', _locale2.default)
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return PosterCard;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PosterCard);
	module.exports = exports['default'];

/***/ },

/***/ "ejl9":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (!opts.pageTitle || !opts.pageUrl) {
	    throw new Error('pageTitle and pageUrl are not defined.');
	  }
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("exPK");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports['default'];

/***/ },

/***/ "exPK":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("lL9/");
	
	var _ModalContent = __webpack_require__("n5qA");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var locale = {
	  id: "ShareOnSocialMedia",
	  code: 'CN',
	  text: {
	    'Share': '分享'
	  }
	};
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        isShowingModal: show // if you want to show it when component mounts, set it true
	        , overlayOpacity: 0.15
	
	        // allowCloseByClickingShadow={false}
	        // useDefaultClosebutton={true} 
	        , onCloseModalClick: dismiss
	        // fixedHeight={300}
	        , fixedWidth: 500
	        // overlayColor="#000"
	        // contentHeight={300} 
	
	        , hasHeader: true,
	        headerType: 'bold' // default, bold 
	        , headerTitle: __('Share', locale),
	        headerIcon: 'fa icon-share' // class for icon tag
	        // headerClassName=""
	        // headerCustomContent={}
	
	        , hasFooter: false
	      },
	      _react2.default.createElement(_ModalContent2.default, this.props)
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "lL9/":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"share-on-social-media-content":"share-on-social-media-content","social-media-button":"social-media-button","btn":"btn","QrCodeWrapper":"QrCodeWrapper"};

/***/ },

/***/ "n5qA":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SocialMediaButton = __webpack_require__("1or1");
	
	var _SocialMediaButton2 = _interopRequireDefault(_SocialMediaButton);
	
	var _QrCode = __webpack_require__("rkYD");
	
	var _QrCode2 = _interopRequireDefault(_QrCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent() {
	    _classCallCheck(this, ModalContent);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalContent.prototype.render = function render() {
	    var _props = this.props,
	        pageTitle = _props.pageTitle,
	        pageUrl = _props.pageUrl;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'share-on-social-media-content' },
	      _react2.default.createElement(_SocialMediaButton2.default, { buttons: ['facebook', 'twitter', 'wechat'], pageUrl: pageUrl, pageTitle: pageTitle }),
	      _react2.default.createElement('input', { type: 'text', value: pageUrl, className: 'form-control' })
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "1or1":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * SocialMediaButton
	                    *    buttons={['facebook', 'twitter', 'wechat']}
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _locale = __webpack_require__("ZI/r");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _QrCode = __webpack_require__("2ySh");
	
	var _QrCode2 = _interopRequireDefault(_QrCode);
	
	__webpack_require__("W5Ro");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SocialMediaButton = (_temp = _class = function (_React$Component) {
	  _inherits(SocialMediaButton, _React$Component);
	
	  function SocialMediaButton(props) {
	    _classCallCheck(this, SocialMediaButton);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.renderButtons = _this.renderButtons.bind(_this);
	    _this.targets = {};
	    _this.state = {
	      show: false,
	      data: null
	    };
	    return _this;
	  }
	
	  SocialMediaButton.prototype.componentWillMount = function componentWillMount() {};
	
	  SocialMediaButton.prototype.renderButtons = function renderButtons() {
	    var _this2 = this;
	
	    var _props = this.props,
	        buttons = _props.buttons,
	        pageUrl = _props.pageUrl,
	        pageTitle = _props.pageTitle;
	
	
	    var url = encodeURI(pageUrl);
	    var title = encodeURI(pageTitle);
	
	    var BUTTONS = {
	      'facebook': {
	        label: __('Facebook', _locale2.default),
	        icon: 'fa icon-facebook',
	        onClick: function onClick() {
	          _this2.windowOpen('https://www.facebook.com/sharer/sharer.php?u=' + url + '&quote=' + title, { name: "Share on Facebook" });
	        }
	      },
	      'twitter': {
	        label: __('Twitter', _locale2.default),
	        icon: 'fa icon-twitter',
	        onClick: function onClick() {
	          _this2.windowOpen('https://twitter.com/intent/tweet?url=' + url, { name: "Share on Twitter" });
	        }
	      },
	      'wechat': {
	        label: __('WeChat', _locale2.default),
	        icon: 'fa icon-wechat',
	        onClick: function onClick() {
	          (0, _QrCode2.default)({
	            title: __('Share on WeChat', _locale2.default),
	            icon: 'fa icon-wechat',
	            value: pageUrl,
	            showDownloadBtn: true
	          });
	        }
	      }
	    };
	
	    return buttons.map(function (buttonName, key) {
	      var _BUTTONS$buttonName = BUTTONS[buttonName],
	          icon = _BUTTONS$buttonName.icon,
	          label = _BUTTONS$buttonName.label,
	          onClick = _BUTTONS$buttonName.onClick;
	
	      return _react2.default.createElement(
	        'a',
	        { className: 'btn btn-default', key: key, onClick: onClick, ref: function ref(_ref) {
	            _this2.targets[buttonName] = _ref;
	          } },
	        _react2.default.createElement('i', { className: icon }),
	        ' ',
	        label
	      );
	    });
	  };
	
	  SocialMediaButton.prototype.render = function render() {
	    var _props2 = this.props,
	        container = _props2.container,
	        pageUrl = _props2.pageUrl;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'social-media-button' },
	      this.renderButtons()
	    );
	  };
	
	  SocialMediaButton.prototype.windowOpen = function windowOpen(url, _ref2, onShareWindowClose) {
	    var name = _ref2.name,
	        _ref2$height = _ref2.height,
	        height = _ref2$height === undefined ? 400 : _ref2$height,
	        _ref2$width = _ref2.width,
	        width = _ref2$width === undefined ? 550 : _ref2$width;
	
	    /* eslint-disable no-mixed-operators */
	    var left = window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2;
	    var top = window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2;
	    /* eslint-enable no-mixed-operators */
	
	    var config = {
	      height: height,
	      width: width,
	      left: left,
	      top: top,
	      location: 'no',
	      toolbar: 'no',
	      status: 'no',
	      directories: 'no',
	      menubar: 'no',
	      scrollbars: 'yes',
	      resizable: 'no',
	      centerscreen: 'yes',
	      chrome: 'yes'
	    };
	
	    var shareDialog = window.open(url, this.isInternetExplorerBefore(10) ? '' : name, Object.keys(config).map(function (key) {
	      return key + '=' + config[key];
	    }).join(', '));
	
	    if (onShareWindowClose) {
	      var interval = window.setInterval(function () {
	        try {
	          if (shareDialog === null || shareDialog.closed) {
	            window.clearInterval(interval);
	            onShareWindowClose(shareDialog);
	          }
	        } catch (e) {
	          /* eslint-disable no-console */
	          console.error(e);
	          /* eslint-enable no-console */
	        }
	      }, 1000);
	    }
	
	    return shareDialog;
	  };
	
	  SocialMediaButton.prototype.isInternetExplorerBefore = function isInternetExplorerBefore(version) {
	    var iematch = /MSIE ([0-9]+)/g.exec(window.navigator.userAgent);
	
	    return iematch ? +iematch[1] < version : false;
	  };
	
	  return SocialMediaButton;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = SocialMediaButton;
	module.exports = exports['default'];

/***/ },

/***/ "ZI/r":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'shareOnSocialNetwork',
	  code: 'CN',
	  text: {
	    'Facebook': '脸书分享',
	    'Twitter': '推特分享',
	    'WeChat': '微信分享',
	
	    'Share on WeChat': '微信分享'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "2ySh":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (typeof opts.value === "undefined") {
	    throw new Error('opts missing value for QR code.');
	  }
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("ttXV");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "ttXV":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("vGJu");
	
	var _ModalContent = __webpack_require__("Ke8X");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _locale = __webpack_require__("jvJB");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        title = _props.title,
	        icon = _props.icon,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        isShowingModal: show // if you want to show it when component mounts, set it true
	        , className: 'QRModal'
	
	        // allowCloseByClickingShadow={false}
	        // useDefaultClosebutton={true} 
	        , onCloseModalClick: dismiss
	        // fixedHeight={300}
	        , fixedWidth: 250
	        // overlayColor="#000"
	        // contentHeight={300} 
	
	        , hasHeader: true,
	        headerType: 'bold' // default, bold 
	        , headerTitle: title,
	        headerIcon: icon // class for icon tag
	        // headerClassName=""
	        // headerCustomContent={}
	
	        , hasFooter: true,
	        footerType: 'bold' // grey, transparent, bold
	        // footerClassName=""
	        // footerCustomContent={}
	      },
	      _react2.default.createElement(_ModalContent2.default, this.props)
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "vGJu":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"QRModal":"QRModal","custom-modal-content":"custom-modal-content"};

/***/ },

/***/ "Ke8X":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _QrCode = __webpack_require__("rkYD");
	
	var _QrCode2 = _interopRequireDefault(_QrCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent() {
	    _classCallCheck(this, ModalContent);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalContent.prototype.render = function render() {
	    var _props = this.props,
	        value = _props.value,
	        showDownloadBtn = _props.showDownloadBtn;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'custom-modal-content' },
	      _react2.default.createElement(_QrCode2.default, { value: value, showDownloadBtn: showDownloadBtn })
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "rkYD":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp; /**
	                    * <QrCode 
	                    *	/>
	                    *
	                    * This is a wrapper component to display a png QR code instead of HTML canvas 
	                    *
	                    * @parent anybody
	                    * @children 
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _qrcode = __webpack_require__("09s/");
	
	var _qrcode2 = _interopRequireDefault(_qrcode);
	
	var _uniqid = __webpack_require__("2bpm");
	
	var _uniqid2 = _interopRequireDefault(_uniqid);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _domToImage = __webpack_require__("sTcZ");
	
	var _domToImage2 = _interopRequireDefault(_domToImage);
	
	__webpack_require__("D8Gs");
	
	var _locale = __webpack_require__("7cQi");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QrCode = (_temp = _class = function (_React$Component) {
	  _inherits(QrCode, _React$Component);
	
	  function QrCode(props) {
	    _classCallCheck(this, QrCode);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      showCanvas: true
	    };
	    return _this;
	  }
	
	  QrCode.prototype.componentWillMount = function componentWillMount() {
	    this.canvasID = (0, _uniqid2.default)('canvas-');
	  };
	
	  QrCode.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    // when component is mounted and the canvas is generated, convert the image
	    if (typeof this.ref.firstChild.toBlob !== 'function') {
	      Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
	        value: function value(callback, type, quality) {
	          var canvas = this;
	          setTimeout(function () {
	
	            var binStr = atob(canvas.toDataURL(type, quality).split(',')[1]),
	                len = binStr.length,
	                arr = new Uint8Array(len);
	
	            for (var i = 0; i < len; i++) {
	              arr[i] = binStr.charCodeAt(i);
	            }
	            callback(new Blob([arr], { type: type || 'image/png' }));
	          });
	        }
	      });
	    }
	    this.ref.firstChild.toBlob(function (blob) {
	      var filename = 'qrcode.png';
	      var contentType = 'application/octet-stream';
	      var urlCreator = window.URL || window.webkitURL;
	      var file = new File([blob], filename, { type: contentType, lastModified: Date.now() });
	      var imageUrl = urlCreator.createObjectURL(file);
	
	      var img = new Image();
	      img.src = imageUrl;
	      img.setAttribute('download', 'qrcode.png');
	      _this2.targetRef.appendChild(img);
	      _this2.setState({
	        showCanvas: false
	      });
	      if (_this2.props.showDownloadBtn) {
	        _this2.targetRef.appendChild(document.createElement("br"));
	        var downloadBtn = document.createElement('a');
	        downloadBtn.textContent = __('Download QR Code', _locale2.default);
	        downloadBtn.className = 'downloadBtn';
	        downloadBtn.addEventListener('click', function (ev) {
	          downloadBtn.href = imageUrl;
	          downloadBtn.download = "qrcode.png";
	        }, false);
	
	        _this2.targetRef.appendChild(downloadBtn);
	      }
	    });
	
	    return;
	
	    _domToImage2.default.toBlob(this.ref.firstChild).then(function (blob) {}).catch(function (error) {
	      console.error('oops, something went wrong!', error);
	    });
	  };
	
	  QrCode.prototype.render = function render() {
	    var _this3 = this;
	
	    var showCanvas = this.state.showCanvas;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'QrCode' },
	      _react2.default.createElement(
	        'div',
	        { className: 'QrCodeCanvas', style: { display: showCanvas === true ? 'block' : 'none' }, ref: function ref(r) {
	            if (r) _this3.ref = r;
	          } },
	        _react2.default.createElement(_qrcode2.default, _extends({ id: this.canvasID }, this.props))
	      ),
	      _react2.default.createElement('div', { className: 'QrCodeImage', style: { display: showCanvas === true ? 'none' : 'block' }, ref: function ref(r) {
	          if (r) _this3.targetRef = r;
	        } })
	    );
	  };
	
	  return QrCode;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = QrCode;
	module.exports = exports['default'];

/***/ },

/***/ "D8Gs":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"QrCode":"QrCode","QrCodeCanvas":"QrCodeCanvas","QrCodeImage":"QrCodeImage","downloadBtn":"downloadBtn"};

/***/ },

/***/ "7cQi":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'QrCode',
	  code: 'CN',
	  text: {
	    'Download QR Code': '下载二维码'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "jvJB":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'QrCodeModal',
	  code: 'CN',
	  text: {
	    'Close': '关闭'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "W5Ro":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"social-media-button":"social-media-button","btn-default":"btn-default"};

/***/ },

/***/ "wrvU":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'posterList',
	  code: 'CN',
	  text: {
	    '{ticket_amount}': '{ticket_amount}票',
	    '{attendee_amount}': '{attendee_amount}人',
	    'MMM DD, YYYY': 'YYYY年MM月DD日',
	    'ddd, MMM DD YYYY': 'YYYY年MM月DD日 ddd',
	    'Publish': '发布',
	    'Published': '已发布',
	    'You cannot edit poster that has been registered': '当前海报已经有人报名了，您无法再次编辑海报。',
	    'Close': '下架',
	    'Share': '分享',
	    'Delete': '删除',
	    'Registered: ': '已报名：'
	
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "JJH7":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"poster-card-wrapper":"poster-card-wrapper","poster-card":"poster-card","image-wrapper":"image-wrapper","image-overlay":"image-overlay","image":"image","poster-content":"poster-content","date":"date","title":"title","published":"published","draft":"draft","poster-type":"poster-type","setting-section":"setting-section","setting-content":"setting-content","poster-button":"poster-button","button":"button","poster-state":"poster-state","card-button":"card-button"};

/***/ },

/***/ "qI5z":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var MOMENT_LOCALE = exports.MOMENT_LOCALE = {
	  'EN': 'en',
	  'CN': 'zh-cn'
	};

/***/ },

/***/ "xBPE":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"poster-list-wrapper":"poster-list-wrapper","poster-list":"poster-list"};

/***/ },

/***/ "VBOl":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <PosterList />
	                    *
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("xBPE");
	
	var _PosterCard = __webpack_require__("xrS3");
	
	var _PosterCard2 = _interopRequireDefault(_PosterCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PosterList = (_temp = _class = function (_React$Component) {
	  _inherits(PosterList, _React$Component);
	
	  function PosterList(props) {
	    _classCallCheck(this, PosterList);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  PosterList.prototype.componentWillMount = function componentWillMount() {};
	
	  PosterList.prototype.render = function render() {
	    var _props = this.props,
	        list = _props.list,
	        count = _props.count,
	        onSelect = _props.onSelect,
	        onDelete = _props.onDelete,
	        onUnlink = _props.onUnlink,
	        onFetch = _props.onFetch;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'poster-list-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'poster-list' },
	        list.map(function (poster, key) {
	          return _react2.default.createElement(_PosterCard2.default, { index: key, key: key, poster: poster, onSelect: onSelect, onDelete: onDelete, onUnlink: onUnlink, onFetch: onFetch });
	        })
	      )
	    );
	  };
	
	  return PosterList;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = PosterList;
	module.exports = exports['default'];

/***/ },

/***/ "Q38M":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactName = function (_Component) {
	  _inherits(ContactName, _Component);
	
	  function ContactName(props) {
	    _classCallCheck(this, ContactName);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  ContactName.prototype.render = function render() {
	    var attendeeInfo = this.props.attendeeInfo;
	    var attendee_name = attendeeInfo.attendee_name;
	
	
	    var full_name = attendee_name.split(' ');
	    var initial = full_name[0][0] + full_name[1][0];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'class-status' },
	      _react2.default.createElement(
	        'div',
	        { className: 'initial' },
	        initial
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        attendee_name
	      )
	    );
	  };
	
	  return ContactName;
	}(_react.Component);
	
	exports.default = ContactName;
	module.exports = exports['default'];

/***/ },

/***/ "YiFN":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RegistrationStatus = function (_Component) {
	  _inherits(RegistrationStatus, _Component);
	
	  function RegistrationStatus(props) {
	    _classCallCheck(this, RegistrationStatus);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  RegistrationStatus.prototype.renderStatus = function renderStatus() {
	    var attendeeInfo = this.props.attendeeInfo;
	    var state = attendeeInfo.state;
	
	
	    if (state === 0) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'wait-list text-center' },
	        __('Waiting List', 'registrationTable')
	      );
	    } else if (state == 2) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'register-sucess text-center' },
	        __('Success', 'registrationTable')
	      );
	    } else if (state == 4) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'transferred text-center' },
	        __('Transferred', 'registrationTable')
	      );
	    }
	  };
	
	  RegistrationStatus.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'class-status' },
	      this.renderStatus()
	    );
	  };
	
	  return RegistrationStatus;
	}(_react.Component);
	
	exports.default = RegistrationStatus;
	module.exports = exports['default'];

/***/ },

/***/ "NjDa":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"registration-table-container":"registration-table-container","dropdown-select":"dropdown-select","filter-by":"filter-by","util-section":"util-section","sort-by-wrapper":"sort-by-wrapper","sort-by":"sort-by","poster-title":"poster-title","class-status":"class-status","register-sucess":"register-sucess","wait-list":"wait-list","transferred":"transferred","initial":"initial","filter-by-field":"filter-by-field","btn-default":"btn-default","dropdown":"dropdown","expand-to-right":"expand-to-right","dropdown-menu":"dropdown-menu","registration-table-close":"registration-table-close","icon-cancel":"icon-cancel"};

/***/ },

/***/ "2DGK":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _tableSettings = __webpack_require__("Qq2/");
	
	var _tableSettings2 = _interopRequireDefault(_tableSettings);
	
	var _ducks = __webpack_require__("2yUR");
	
	var _RegistrationStatus = __webpack_require__("YiFN");
	
	var _RegistrationStatus2 = _interopRequireDefault(_RegistrationStatus);
	
	var _ContactName = __webpack_require__("Q38M");
	
	var _ContactName2 = _interopRequireDefault(_ContactName);
	
	var _FilterBy = __webpack_require__("SdD8");
	
	var _FilterBy2 = _interopRequireDefault(_FilterBy);
	
	var _DropdownSelect = __webpack_require__("y7rH");
	
	var _DropdownSelect2 = _interopRequireDefault(_DropdownSelect);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _RegistrationTableFloat = __webpack_require__("MbO4");
	
	var _RegistrationTableFloat2 = _interopRequireDefault(_RegistrationTableFloat);
	
	var _UI = __webpack_require__("OM1Z");
	
	__webpack_require__("NjDa");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var locale = {
	  id: 'RegistrationTable',
	  code: 'CN',
	  text: {
	    'Show All': '全部',
	    'Poster': '海报'
	  }
	};
	
	var AMOUNT_PER_PAGE = 25;
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    attendee_list: state.attendeeList
	  };
	};
	
	var RegistrationTable = function (_Component) {
	  _inherits(RegistrationTable, _Component);
	
	  function RegistrationTable(props) {
	    _classCallCheck(this, RegistrationTable);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      filterData: {},
	      currentTypeShown: -1,
	      status: 6,
	      pagination: {
	        activePage: 1,
	        itemsCountPerPage: 25,
	        totalItemsCount: 0
	      },
	      posterId: props.params.posterId || null,
	      singlePoster: props.params.posterId ? true : false,
	      keyword: '',
	      orderBy: 0
	    };
	
	    _this.onFilterChange = _this.onFilterChange.bind(_this);
	    _this.onSelectChange = _this.onSelectChange.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.onItemsCountPerPageChange = _this.onItemsCountPerPageChange.bind(_this);
	    _this.dropdownOptions = [];
	    if (_this.state.singlePoster) {
	      _this.filters = ['text:searchKeyword', 'registrationStatus'];
	
	      _this.filter_options = {
	        'text:searchKeyword': {
	          placeholder: __('Search Name, Email, or Phone No.', 'registrationTable'),
	          valueMinLength: 2
	        },
	        registrationStatus: {
	          selectMultiple: false
	        }
	      };
	    } else {
	      _this.filters = ['text:searchKeyword', 'registrationStatus', 'poster'];
	
	      _this.filter_options = {
	        'text:searchKeyword': {
	          placeholder: __('Search Name, Email, or Phone No.', 'registrationTable'),
	          valueMinLength: 2
	        },
	        registrationStatus: {
	          selectMultiple: false
	        },
	        poster: {
	          selectMultiple: false
	        }
	      };
	    }
	    return _this;
	  }
	
	  RegistrationTable.prototype.componentDidMount = function componentDidMount() {
	    var dispatch = this.props.dispatch;
	    var _state = this.state,
	        posterId = _state.posterId,
	        orderBy = _state.orderBy;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    dispatch((0, _ducks.fetchAttendeeList)(schoolId, {
	      posterId: posterId,
	      state: 6,
	      amount_per_page: AMOUNT_PER_PAGE,
	      order_by: orderBy,
	      page_number: 1
	    }));
	  };
	
	  RegistrationTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var _this2 = this;
	
	    var attendee_list = _ref.attendee_list;
	
	    this.setState(function (prevState) {
	      return {
	        pagination: _extends({}, prevState.pagination, { totalItemsCount: attendee_list.count })
	      };
	    });
	    this.originalList = attendee_list.list;
	    this.list = [].concat(this.originalList);
	
	    this.dropdownOptions = [{ label: __('Show All', locale), value: -1 }];
	
	    // create dropdown options
	    this.labelPerOptionID = {};
	
	    if (this.list) {
	      this.list.map(function (lst) {
	        if (!_this2.labelPerOptionID[lst.ticket_id]) {
	          _this2.dropdownOptions.push({
	            label: lst.ticket_title,
	            value: lst.ticket_id
	          });
	          _this2.labelPerOptionID[lst.ticket_id] = lst.ticket_title;
	        }
	      });
	    }
	  };
	
	  RegistrationTable.prototype.onFilterChange = function onFilterChange(_ref2) {
	    var _this3 = this;
	
	    var filterData = _ref2.filterData;
	    var _props = this.props,
	        dispatch = _props.dispatch,
	        params = _props.params;
	    var orderBy = this.state.orderBy;
	
	    var schoolId = localStorage.getItem('schoolId');
	    this.setState(function (prevState) {
	      return {
	        pagination: _extends({}, prevState.pagination, { activePage: 1 }),
	        filterData: filterData,
	        posterId: filterData.poster ? filterData.poster.IDs[0] : params.posterId,
	        keyword: filterData['searchKeyword']
	      };
	    }, function () {
	      dispatch((0, _ducks.fetchAttendeeList)(schoolId, {
	        posterId: _this3.state.posterId,
	        state: filterData.registrationStatus ? filterData.registrationStatus.items[0].value : 6,
	        amount_per_page: _this3.state.pagination.itemsCountPerPage,
	        page_number: _this3.state.pagination.activePage,
	        kw: _this3.state.keyword,
	        order_by: orderBy
	      }));
	    });
	
	    // this.list = this.props.attendee_list.list
	    // this.forceUpdate()
	
	    // let multiple_search = ''
	    // if(filterData.multiple_search){
	    // 	multiple_search = filterData.multiple_search.toLowerCase()
	    // }
	
	    // let newArray = []
	
	    // if(filterData.multiple_search && filterData.multiple_search.trim() != '' ){
	    // 	this.list.filter((result) => {
	    // 		const {attendee_name = '', contact_email = '', contact_phone = ''} = result
	    //     if(attendee_name.toLowerCase().indexOf(multiple_search.toLowerCase()) > -1
	    //       || contact_email.toLowerCase().indexOf(multiple_search.toLowerCase()) > -1
	    //       || contact_phone.toLowerCase().indexOf(multiple_search.toLowerCase()) > -1){
	    // 			newArray.push(result)
	
	    // 		}
	    //   })
	
	    //   this.list = [ ...newArray ];
	    //   this.forceUpdate()
	    // }
	  };
	
	  RegistrationTable.prototype.onSelectChange = function onSelectChange(ticketIDToShow) {
	    var newArray = [];
	
	    if (ticketIDToShow == -1) {
	      this.list = [].concat(this.originalList);
	
	      this.setState({
	        currentTypeShown: -1
	      });
	
	      return;
	    }
	
	    this.originalList.filter(function (res) {
	      var ticket_id = res.ticket_id;
	
	      if (ticket_id == ticketIDToShow) {
	        newArray.push(res);
	      }
	    });
	
	    this.list = [].concat(newArray);
	    this.setState({
	      currentTypeShown: ticketIDToShow
	    });
	  };
	
	  RegistrationTable.prototype.onPageChange = function onPageChange(pageNum) {
	    var _this4 = this;
	
	    var dispatch = this.props.dispatch;
	    var _state2 = this.state,
	        posterId = _state2.posterId,
	        orderBy = _state2.orderBy;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _state3 = this.state,
	        pagination = _state3.pagination,
	        filterData = _state3.filterData,
	        keyword = _state3.keyword;
	
	
	    this.setState(function (prevState) {
	      return {
	        pagination: _extends({}, prevState.pagination, { activePage: pageNum })
	      };
	    }, function () {
	      dispatch((0, _ducks.fetchAttendeeList)(schoolId, {
	        posterId: posterId,
	        state: filterData.registrationStatus ? filterData.registrationStatus.items[0].value : 6,
	        amount_per_page: pagination.itemsCountPerPage,
	        page_number: _this4.state.pagination.activePage,
	        kw: keyword,
	        order_by: orderBy
	      }));
	    });
	  };
	
	  RegistrationTable.prototype.onItemsCountPerPageChange = function onItemsCountPerPageChange(count) {
	    var _this5 = this;
	
	    var dispatch = this.props.dispatch;
	    var _state4 = this.state,
	        posterId = _state4.posterId,
	        filterData = _state4.filterData,
	        keyword = _state4.keyword,
	        orderBy = _state4.orderBy;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    this.setState(function (prevState) {
	      return {
	        pagination: _extends({}, prevState.pagination, { itemsCountPerPage: count })
	      };
	    }, function () {
	      dispatch((0, _ducks.fetchAttendeeList)(schoolId, {
	        posterId: posterId,
	        state: filterData.registrationStatus ? filterData.registrationStatus.items[0].value : 6,
	        amount_per_page: _this5.state.pagination.itemsCountPerPage,
	        page_number: _this5.state.activePage,
	        order_by: orderBy,
	        kw: keyword
	      }));
	    });
	  };
	
	  RegistrationTable.prototype.render = function render() {
	    var _this6 = this;
	
	    var _props2 = this.props,
	        attendee_list = _props2.attendee_list,
	        dispatch = _props2.dispatch;
	    var posterTitle = attendee_list.posterTitle;
	    var _state5 = this.state,
	        openFloatModal = _state5.openFloatModal,
	        floatTarget = _state5.floatTarget,
	        attendeeInfo = _state5.attendeeInfo,
	        pagination = _state5.pagination,
	        singlePoster = _state5.singlePoster,
	        orderBy = _state5.orderBy,
	        posterId = _state5.posterId,
	        filterData = _state5.filterData,
	        keyword = _state5.keyword,
	        activePage = _state5.activePage;
	
	
	    var fields = [{
	      name: 'poster_title',
	      title: __('Poster Title', 'registrationTable'),
	      getTdProps: function getTdProps(_ref3) {
	        var tbodyData = _ref3.tbodyData;
	
	        return {
	          style: {
	            width: "15%"
	          }
	        };
	      }
	    }, {
	      name: 'ticket_title',
	      title: __('Item', 'registrationTable'),
	      getTdProps: function getTdProps(_ref4) {
	        var tbodyData = _ref4.tbodyData;
	
	        return {
	          style: {
	            width: "15%"
	          }
	        };
	      }
	    }, {
	      name: 'attendee_name',
	      title: __('Applicant', 'registrationTable'),
	      getTdProps: function getTdProps(_ref5) {
	        var tbodyData = _ref5.tbodyData;
	
	        return {
	          style: {
	            width: "15%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref6) {
	        var attendeeInfo = _ref6.trData;
	
	        return _react2.default.createElement(_ContactName2.default, { attendeeInfo: attendeeInfo });
	      }
	    }, {
	      name: 'contact_name',
	      title: __('Contact Name', 'registrationTable'),
	      getTdProps: function getTdProps(_ref7) {
	        var tbodyData = _ref7.tbodyData;
	
	        return {
	          style: {
	            width: "10%"
	          }
	        };
	      }
	
	    }, {
	      name: 'contact_email',
	      title: __('Contact Email', 'registrationTable'),
	      getTdProps: function getTdProps(_ref8) {
	        var tbodyData = _ref8.tbodyData;
	
	        return {
	          style: {
	            width: "20%"
	          }
	        };
	      }
	    }, {
	      name: 'contact_phone',
	      title: __('Contact Phone No.', 'registrationTable'),
	      getTdProps: function getTdProps(_ref9) {
	        var tbodyData = _ref9.tbodyData;
	
	        return {
	          style: {
	            width: "15%"
	          }
	        };
	      }
	    }, {
	      name: 'state',
	      title: __('Status', 'registrationTable'),
	      getTdProps: function getTdProps(_ref10) {
	        var tbodyData = _ref10.tbodyData;
	
	        return {
	          style: {
	            width: "12%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref11) {
	        var attendeeInfo = _ref11.trData;
	
	        return _react2.default.createElement(_RegistrationStatus2.default, { attendeeInfo: attendeeInfo });
	      }
	    }];
	
	    this.tableSettings = _tableSettings2.default.call(this);
	    var schoolId = localStorage.getItem('schoolId');
	
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      { className: 'registration-table-container' },
	      singlePoster && _react2.default.createElement(
	        'div',
	        { className: 'bread-crumbs' },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/poster' },
	          _react2.default.createElement(
	            'span',
	            null,
	            __('Poster', locale)
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          ' / '
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          posterTitle
	        )
	      ),
	      !singlePoster && _react2.default.createElement(
	        'div',
	        null,
	        __('Poster Registration List', 'registrationTable')
	      ),
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { className: 'registration-table-close pull-right', to: '/poster' },
	        _react2.default.createElement('i', { className: 'fa icon-cancel' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'poster-title' },
	        posterTitle
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'util-section' },
	        _react2.default.createElement(_FilterBy2.default, {
	          filterData: this.state.filterData,
	          filters: this.filters,
	          options: this.filter_options,
	          schoolId: schoolId,
	          onChange: this.onFilterChange
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'sort-by-wrapper' },
	          _react2.default.createElement(
	            'span',
	            null,
	            __('Sort by', 'registrationTable')
	          ),
	          _react2.default.createElement(
	            'select',
	            {
	              className: 'form-control sort-by',
	              value: orderBy,
	              onChange: function onChange(e) {
	                _this6.setState({ orderBy: e.target.value }, function () {
	                  dispatch((0, _ducks.fetchAttendeeList)(schoolId, {
	                    posterId: posterId,
	                    state: filterData.registrationStatus ? filterData.registrationStatus.items[0].value : 6,
	                    amount_per_page: pagination.itemsCountPerPage,
	                    page_number: activePage,
	                    order_by: _this6.state.orderBy,
	                    kw: keyword
	                  }));
	                });
	              } },
	            _react2.default.createElement(
	              'option',
	              { key: '0', value: '0' },
	              __('Creation Time: Newest to Oldest', 'registrationTable')
	            ),
	            _react2.default.createElement(
	              'option',
	              { key: '1', value: '1' },
	              __('Creation Time: Oldest to Newest', 'registrationTable')
	            )
	          )
	        )
	      ),
	      this.props.attendee_list.fetching ? _react2.default.createElement(_Loading2.default, null) : _react2.default.createElement(_UI.Table, {
	        data: this.list,
	        fields: fields,
	        crqassName: 'registration-table',
	        settingThTitle: __('Settings', 'class', null, true),
	        settingWidth: '150px',
	        settings: this.tableSettings,
	        useMultiSelection: false,
	        oneSettingPerRow: false,
	        dropdownGuideWidth: 160,
	        dropdownGuideHeight: 228,
	        pagination: pagination,
	        usePagination: true,
	        onPageChange: this.onPageChange,
	        onItemsCountPerPageChange: this.onItemsCountPerPageChange
	      }),
	      _react2.default.createElement(_RegistrationTableFloat2.default, {
	        attendeeInfo: attendeeInfo,
	        show: openFloatModal,
	        target: floatTarget,
	        onCloseFloat: function onCloseFloat() {
	          _this6.setState({ openFloatModal: false });
	        }
	      })
	    );
	  };
	
	  return RegistrationTable;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(RegistrationTable);
	module.exports = exports['default'];

/***/ },

/***/ "Qq2/":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
		var _this = this;
	
		var dispatch = this.props.dispatch;
		var _state = this.state,
		    posterId = _state.posterId,
		    pagination = _state.pagination,
		    filterData = _state.filterData,
		    keyword = _state.keyword,
		    orderBy = _state.orderBy;
		var itemsCountPerPage = pagination.itemsCountPerPage;
	
		var schoolId = localStorage.getItem('schoolId');
	
		return [{
			title: __('Detail', 'registrationTable'),
			onClick: function onClick(_ref, event) {
				var attendeeInfo = _ref.trData;
	
				_this.setState({ openFloatModal: true, floatTarget: event.target, attendeeInfo: attendeeInfo }, function () {
					_this.forceUpdate();
				});
			}
		}, {
			title: __('Transfer Student', 'registrationTable'),
			onClick: function onClick(_ref2) {
				var attendeeInfo = _ref2.trData;
	
				(0, _confirm.confirm)(__('Proceed to transfer student?', _locale2.default)).then(function () {
					(0, _updateAttendee2.default)(attendeeInfo.attendee_id, { state: 'transferred' }).then(function (res) {
						dispatch((0, _ducks.fetchAttendeeList)(schoolId, {
							posterId: posterId,
							state: filterData.registrationStatus ? filterData.registrationStatus.items[0].value : 6,
							amount_per_page: itemsCountPerPage,
							page_number: 1,
							order_by: orderBy,
							kw: keyword
						}));
					});
				}).catch(function () {});
			},
			isDisabled: function isDisabled(_ref3) {
				var attendeeInfo = _ref3.trData;
	
				return attendeeInfo.state == 4 || !(0, _R.userCan)('convert_attendee_to_student');
			}
	
		}];
	};
	
	var _confirm = __webpack_require__("yMGN");
	
	var _ducks = __webpack_require__("2yUR");
	
	var _updateAttendee = __webpack_require__("7iET");
	
	var _updateAttendee2 = _interopRequireDefault(_updateAttendee);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _locale = __webpack_require__("z80C");
	
	var _locale2 = _interopRequireDefault(_locale);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ },

/***/ "7iET":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = updateAttendee;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CHECK_IN_STATE = ['notAttend', 'attended'];
	var STATE = ['waitList', 'registeredNotConfirmed', 'registered', 'cancelled', 'transferred', 'registeredNotSuccess'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  check_in_state: _joiBrowser2.default.string().valid(CHECK_IN_STATE).allow(''),
	  state: _joiBrowser2.default.string().valid(STATE).allow('')
	});
	
	function updateAttendee(attendeeId, attendeeInfo) {
	
	  if (!attendeeId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing ticket ID')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(attendeeInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, attendeeInfo);
	
	  if (typeof attendeeInfo.check_in_state != 'undefined') {
	    toServer.check_in_state = CHECK_IN_STATE.indexOf(attendeeInfo.check_in_state);
	  }
	  if (typeof attendeeInfo.state != 'undefined') {
	    toServer.state = STATE.indexOf(attendeeInfo.state);
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/u_attendee/" + attendeeId + "/",
	      'method': 'PUT',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "z80C":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'RegistrationTable',
	  code: 'CN',
	  text: {
	    'Proceed to transfer student?': '确认转为学员？'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "MbO4":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Float = __webpack_require__("oGSK");
	
	var _Float2 = _interopRequireDefault(_Float);
	
	__webpack_require__("XsBs");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _UI = __webpack_require__("OM1Z");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RegistrationTableFloat = (_temp = _class = function (_React$Component) {
	  _inherits(RegistrationTableFloat, _React$Component);
	
	  function RegistrationTableFloat(props) {
	    _classCallCheck(this, RegistrationTableFloat);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.renderFloatContent = _this.renderFloatContent.bind(_this);
	    return _this;
	  }
	
	  RegistrationTableFloat.prototype.componentWillMount = function componentWillMount() {};
	
	  RegistrationTableFloat.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        target = _props.target,
	        onCloseFloat = _props.onCloseFloat;
	
	
	    return _react2.default.createElement(
	      _Float2.default,
	      {
	        container: global['--classtop-main-section'],
	        show: show,
	        target: target,
	        floatWidth: 250,
	        onCloseFloat: onCloseFloat
	      },
	      this.renderFloatContent()
	    );
	  };
	
	  RegistrationTableFloat.prototype.renderFloatContent = function renderFloatContent() {
	    var _props$attendeeInfo = this.props.attendeeInfo,
	        attendeeInfo = _props$attendeeInfo === undefined ? {} : _props$attendeeInfo;
	    var attendee_name = attendeeInfo.attendee_name,
	        attendee_email = attendeeInfo.attendee_email,
	        attendee_phone = attendeeInfo.attendee_phone,
	        date_of_birth = attendeeInfo.date_of_birth;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'attendee-detail-float container-fluid' },
	      _react2.default.createElement(
	        'div',
	        { className: 'attendee_name' },
	        attendee_name
	      ),
	      _react2.default.createElement('hr', null),
	      _react2.default.createElement(
	        'div',
	        { className: 'birthday' },
	        _react2.default.createElement(
	          'p',
	          { className: 'birthday-label' },
	          __('Date of Birth', 'registrationTable')
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'birthday-input' },
	          date_of_birth ? (0, _moment2.default)(date_of_birth).format(__('MMM DD, YYYY', 'dateFormat')) : 'N/A'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'phoneNo' },
	        _react2.default.createElement(
	          'p',
	          { className: 'phone-label' },
	          __('Phone No.', 'registrationTable')
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'phone-input' },
	          attendee_phone
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'email' },
	        _react2.default.createElement(
	          'p',
	          { className: 'email-label' },
	          __('Email', 'registrationTable')
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'email-input' },
	          attendee_email
	        )
	      )
	    );
	  };
	
	  return RegistrationTableFloat;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = RegistrationTableFloat;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "XsBs":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"attendee-detail-float":"attendee-detail-float","attendee_name":"attendee_name","birthday-label":"birthday-label","email-label":"email-label","phone-label":"phone-label","birthday-input":"birthday-input","email-input":"email-input","phone-input":"phone-input"};

/***/ },

/***/ "lHNU":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"saas-poster-preview":"saas-poster-preview","preview-buttons":"preview-buttons","button":"button","edit":"edit","share":"share"};

/***/ },

/***/ "NT6U":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <SaasPosterPreview />
	                    *
	                    * This is a SAAS wrapper for <PosterPreview /> in /shared.
	                    *
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("lHNU");
	
	var _FullPanelWrapper = __webpack_require__("Suno");
	
	var _FullPanelWrapper2 = _interopRequireDefault(_FullPanelWrapper);
	
	var _UtilHeader = __webpack_require__("PhxH");
	
	var _UtilHeader2 = _interopRequireDefault(_UtilHeader);
	
	var _PosterView = __webpack_require__("ZurG");
	
	var _PosterView2 = _interopRequireDefault(_PosterView);
	
	var _getPosterDetail = __webpack_require__("+5oY");
	
	var _getPosterDetail2 = _interopRequireDefault(_getPosterDetail);
	
	var _Transition = __webpack_require__("X/qO");
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _ShareOnSocialMedia = __webpack_require__("ejl9");
	
	var _ShareOnSocialMedia2 = _interopRequireDefault(_ShareOnSocialMedia);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SaasPosterPreview = (_temp = _class = function (_React$Component) {
	  _inherits(SaasPosterPreview, _React$Component);
	
	  function SaasPosterPreview(props) {
	    _classCallCheck(this, SaasPosterPreview);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.fetchPosterDetail = _this.fetchPosterDetail.bind(_this);
	    _this.state = {
	      loading: true,
	      posterDetail: {}
	    };
	    return _this;
	  }
	
	  SaasPosterPreview.prototype.componentWillMount = function componentWillMount() {
	    this.fetchPosterDetail();
	  };
	
	  SaasPosterPreview.prototype.fetchPosterDetail = function fetchPosterDetail() {
	    var _this2 = this;
	
	    var posterId = this.props.params.posterId;
	
	    (0, _getPosterDetail2.default)(posterId).then(function (posterDetail) {
	      _this2.setState({
	        loading: false,
	        posterDetail: posterDetail
	      }, function () {
	        _this2.setPageUrl();
	      });
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  SaasPosterPreview.prototype.setPageUrl = function setPageUrl() {
	    var id = this.state.posterDetail.poster_info.id;
	
	
	    var language = localStorage.getItem('language');
	
	    var pageUrl = void 0;
	
	    if (false) {
	      pageUrl = 'https://posterdev.classtop.com/' + id + '?language=' + language;
	    } else {
	      pageUrl = 'https://poster.classtop.com/' + id + '?language=' + language;
	    }
	
	    this.setState({
	      pageUrl: pageUrl
	    });
	  };
	
	  SaasPosterPreview.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        loading = _state.loading,
	        posterDetail = _state.posterDetail,
	        scrollTop = _state.scrollTop,
	        pageUrl = _state.pageUrl;
	    var _posterDetail$poster_ = posterDetail.poster_info,
	        poster_info = _posterDetail$poster_ === undefined ? {} : _posterDetail$poster_;
	    // <PosterView posterDetail={posterDetail} top={(scrollTop > 88) ? 75 : 0} position={scrollTop > 88 ? 'fixed' : 'relative'} />
	
	    var showShare = poster_info.state === 1;
	    var showEdit = poster_info.state !== 1;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'saas-poster-preview' },
	      _react2.default.createElement(
	        _FullPanelWrapper2.default,
	        { onScroll: function onScroll(scrollTop) {
	            _this3.setState({
	              scrollTop: scrollTop
	            });
	          } },
	        _react2.default.createElement(
	          _Transition2.default,
	          null,
	          loading === true && _react2.default.createElement(_Loading2.default, null),
	          loading !== true && _react2.default.createElement(
	            _UtilHeader2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'preview-buttons' },
	              showShare && _react2.default.createElement(
	                'div',
	                { className: 'btn share', onClick: function onClick() {
	                    (0, _ShareOnSocialMedia2.default)({ pageTitle: poster_info.title, pageUrl: pageUrl });
	                  } },
	                __('Share', 'poster')
	              )
	            )
	          ),
	          loading !== true && _react2.default.createElement(_PosterView2.default, { posterDetail: posterDetail })
	        )
	      )
	    );
	  };
	
	  return SaasPosterPreview;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = SaasPosterPreview;
	module.exports = exports['default'];

/***/ },

/***/ "Suno":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <FullPanelWrapper 
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children 
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("BlTD");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FullPanelWrapper = (_temp = _class = function (_React$Component) {
	  _inherits(FullPanelWrapper, _React$Component);
	
	  function FullPanelWrapper(props) {
	    _classCallCheck(this, FullPanelWrapper);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      scrolled: 0
	    };
	    return _this;
	  }
	
	  FullPanelWrapper.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var onScroll = this.props.onScroll;
	
	
	    this.ref.onscroll = function () {
	      var scrollTop = _this2.ref.scrollTop;
	      if (typeof onScroll === "function") {
	        onScroll(scrollTop);
	      }
	    };
	  };
	
	  FullPanelWrapper.prototype.render = function render() {
	    var _this3 = this;
	
	    var topOffset = this.props.topOffset;
	    var scrolled = this.state.scrolled;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'full-panel-wrapper', ref: function ref(r) {
	          if (r) _this3.ref = r;
	        } },
	      this.props.children
	    );
	  };
	
	  return FullPanelWrapper;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = FullPanelWrapper;
	module.exports = exports['default'];

/***/ },

/***/ "BlTD":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"full-panel-wrapper":"full-panel-wrapper"};

/***/ },

/***/ "PhxH":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <UtilHeader />
	                    *
	                    * Fixed absolute header that sticks to the container
	                    * 
	                    * @parent anybody
	                    * @children 
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("EUxR");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UtilHeader = (_temp = _class = function (_React$Component) {
	  _inherits(UtilHeader, _React$Component);
	
	  function UtilHeader(props) {
	    _classCallCheck(this, UtilHeader);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  UtilHeader.prototype.componentWillMount = function componentWillMount() {};
	
	  UtilHeader.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'util-header' },
	      this.props.children
	    );
	  };
	
	  return UtilHeader;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = UtilHeader;
	module.exports = exports['default'];

/***/ },

/***/ "EUxR":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"util-header":"util-header"};

/***/ },

/***/ "ZurG":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp; /**
	                    * <PosterPreview />
	                    *
	                    * SHARED: This is shared with Yellow Page.
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("3+NE");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ProfileInfo = __webpack_require__("Idmx");
	
	var _ProfileInfo2 = _interopRequireDefault(_ProfileInfo);
	
	var _DateCard = __webpack_require__("l5sO");
	
	var _DateCard2 = _interopRequireDefault(_DateCard);
	
	var _DateCardMobile = __webpack_require__("I4kK");
	
	var _DateCardMobile2 = _interopRequireDefault(_DateCardMobile);
	
	var _Register = __webpack_require__("C3cl");
	
	var _Register2 = _interopRequireDefault(_Register);
	
	var _SocialMediaButton = __webpack_require__("1or1");
	
	var _SocialMediaButton2 = _interopRequireDefault(_SocialMediaButton);
	
	var _OrderOverview = __webpack_require__("niOo");
	
	var _OrderOverview2 = _interopRequireDefault(_OrderOverview);
	
	var _alert = __webpack_require__("BGi1");
	
	var _RegisterClassModal = __webpack_require__("T9OU");
	
	var _RegisterClassModal2 = _interopRequireDefault(_RegisterClassModal);
	
	var _locale = __webpack_require__("ncso");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PosterPreview = (_temp = _class = function (_React$Component) {
	  _inherits(PosterPreview, _React$Component);
	
	  function PosterPreview(props) {
	    _classCallCheck(this, PosterPreview);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.posterTypeVerbose = [__('Enrollment Registration', _locale2.default), __('Event Registration', _locale2.default), __('Survey', _locale2.default), __('Basic Poster', _locale2.default)];
	
	    var _props$posterDetail = props.posterDetail,
	        poster_info = _props$posterDetail.poster_info,
	        content = _props$posterDetail.content,
	        ticket = _props$posterDetail.ticket;
	
	
	    _this.state = _extends({
	      poster_info: poster_info,
	      content: content,
	      ticket: ticket
	    }, _this.getPosterVerbose(poster_info));
	
	    _this.getPosterVerbose = _this.getPosterVerbose.bind(_this);
	    _this.renderDateInfo = _this.renderDateInfo.bind(_this);
	    _this.renderMobileDateInfo = _this.renderMobileDateInfo.bind(_this);
	    _this.setOrderInfo = _this.setOrderInfo.bind(_this);
	    _this.onClickRegister = _this.onClickRegister.bind(_this);
	    return _this;
	  }
	
	  PosterPreview.prototype.onClickRegister = function onClickRegister(e) {
	    var _this2 = this;
	
	    var posterDetail = this.props.posterDetail;
	    var school = posterDetail.poster_info.school;
	    var ticket = posterDetail.ticket;
	
	
	    var hasPayment = false;
	    ticket.map(function (t) {
	      if (t.price_type != 0) {
	        hasPayment = true;
	      }
	    });
	
	    var browser_type = void 0;
	    var mobile = false;
	    if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
	      mobile = true;
	    }
	
	    if (/micromessenger/i.test(navigator.userAgent)) {
	      browser_type = 'weChatBrowser';
	    } else if (mobile) {
	      browser_type = 'mobileBroswer';
	    } else {
	      browser_type = 'pcBrowser';
	    }
	
	    if (hasPayment == true && browser_type == 'weChatBrowser') {
	      _alert.alert.message(__('Unable to process online payment on WeChat, please register with PC broswers', _locale2.default)).then(function () {}).catch(function () {});
	    } else {
	      (0, _RegisterClassModal2.default)({
	        posterDetail: posterDetail,
	        schoolId: school
	      }).then(function (res) {
	        var result = res.result,
	            orderInfo = res.orderInfo,
	            order_number = res.order_number;
	
	        if (result === 'success') {
	          _this2.setOrderInfo(orderInfo, order_number);
	        } else {}
	      });
	    }
	  };
	
	  PosterPreview.prototype.componentWillMount = function componentWillMount() {
	    this.setPageUrl();
	  };
	
	  PosterPreview.prototype.setOrderInfo = function setOrderInfo(orderInfo, order_number) {
	    this.setState({
	      orderInfo: orderInfo,
	      order_number: order_number
	    });
	  };
	
	  PosterPreview.prototype.setPageUrl = function setPageUrl() {
	    var id = this.state.poster_info.id;
	
	
	    var pageUrl = void 0;
	
	    var language = localStorage.getItem('language');
	
	    if (false) {
	      pageUrl = 'https://posterdev.classtop.com/' + id + '?language=' + language;
	    } else {
	      pageUrl = 'https://poster.classtop.com/' + id + '?language=' + language;
	    }
	
	    this.setState({
	      pageUrl: pageUrl
	    });
	  };
	
	  PosterPreview.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        content = _state.content,
	        ticket = _state.ticket,
	        type = _state.type,
	        title = _state.title,
	        school_logo = _state.school_logo,
	        school_name = _state.school_name,
	        creadAt = _state.creadAt,
	        updatedAt = _state.updatedAt,
	        poster_info = _state.poster_info,
	        orderInfo = _state.orderInfo,
	        pageUrl = _state.pageUrl,
	        order_number = _state.order_number;
	    var _props = this.props,
	        _props$stickyDate = _props.stickyDate,
	        stickyDate = _props$stickyDate === undefined ? false : _props$stickyDate,
	        _props$scrollTop = _props.scrollTop,
	        scrollTop = _props$scrollTop === undefined ? 0 : _props$scrollTop,
	        _props$top = _props.top,
	        top = _props$top === undefined ? 0 : _props$top,
	        _props$position = _props.position,
	        position = _props$position === undefined ? 'relative' : _props$position,
	        hideShareButtons = _props.hideShareButtons,
	        posterDetail = _props.posterDetail;
	    var poster_type = poster_info.poster_type,
	        state = poster_info.state;
	
	
	    var sharable = state === 1;
	
	    var showDateColumn = poster_type !== 3;
	    var showRegister = poster_type !== 3;
	
	    if (orderInfo) {
	      // confirmation page
	      return _react2.default.createElement(_OrderOverview2.default, { orderInfo: orderInfo, poster_info: poster_info, order_number: order_number, posterDetail: posterDetail });
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'poster-view' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container poster-content' },
	        showDateColumn && _react2.default.createElement(
	          'div',
	          { className: 'col-md-3 hidden-sm hidden-xs' },
	          _react2.default.createElement(
	            'div',
	            { className: 'date-info', style: { top: top, position: position } },
	            this.renderDateInfo(),
	            ticket.length > 0 && _react2.default.createElement(
	              'a',
	              { className: 'btn btn-primary register-now', onClick: this.onClickRegister },
	              __('Register Now', _locale2.default)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)({ 'col-md-9': showDateColumn, 'col-md-12': !showDateColumn }) },
	          _react2.default.createElement(
	            'section',
	            { className: 'title-section hide-on-mobile' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              type
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'poster-title' },
	              title
	            )
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: 'info-section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'user-column' },
	              _react2.default.createElement(_ProfileInfo2.default, { picture: school_logo, name: school_name, pictureHeight: 36, pictureWidth: 36 })
	            ),
	            _react2.default.createElement('div', { className: 'share-column' })
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: 'mobile-date-info visible-xs' },
	            this.renderMobileDateInfo()
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: 'content-section' },
	            content.map(function (item, key) {
	              return _this3.renderContentItem(item, key);
	            })
	          )
	        )
	      ),
	      ticket.length > 0 && _react2.default.createElement(
	        'div',
	        { className: 'floating-register-btn visible-xs' },
	        _react2.default.createElement(
	          'a',
	          { className: 'btn btn-primary register-now', onClick: this.onClickRegister },
	          __('Register Now', _locale2.default)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'poster-footer hidden-xs' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          showDateColumn && _react2.default.createElement('div', { className: 'col-md-3 date-info' }),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)({ 'col-md-9': showDateColumn, 'col-md-12': !showDateColumn }, 'footer-content') },
	            showRegister && _react2.default.createElement(_Register2.default, { posterDetail: this.props.posterDetail, setOrderInfo: this.setOrderInfo, onClickRegister: this.onClickRegister }),
	            hideShareButtons !== true && sharable && _react2.default.createElement(_SocialMediaButton2.default, { buttons: ['facebook', 'twitter', 'wechat'], pageUrl: pageUrl, pageTitle: title })
	          )
	        )
	      )
	    );
	  };
	
	  PosterPreview.prototype.getPosterVerbose = function getPosterVerbose(poster) {
	    var title = poster.title,
	        poster_type = poster.poster_type,
	        created_at = poster.created_at,
	        updated_at = poster.updated_at,
	        publisher_name = poster.publisher_name,
	        logo = poster.logo,
	        school_name = poster.school_name,
	        school_logo = poster.school_logo,
	        school = poster.school;
	
	
	    return {
	      title: title,
	      school_name: school_name,
	      school_logo: school_logo,
	      schoolId: school,
	      type: this.posterTypeVerbose[poster_type],
	      creadAt: (0, _moment2.default)(created_at).format(__('MMM DD, YYYY', 'dateFormat')),
	      updatedAt: (0, _moment2.default)(updated_at).format(__('MMM DD, YYYY', 'dateFormat'))
	    };
	  };
	
	  PosterPreview.prototype.renderDateInfo = function renderDateInfo() {
	    var _this4 = this;
	
	    var _state2 = this.state,
	        ticket = _state2.ticket,
	        creadAt = _state2.creadAt,
	        updatedAt = _state2.updatedAt,
	        poster_info = _state2.poster_info;
	
	
	    return ticket.map(function (item, key) {
	      return _react2.default.createElement(_DateCard2.default, { ticket: item, key: key, show_spots_left: _this4.props.posterDetail.poster_info.show_spots_left });
	    });
	  };
	
	  PosterPreview.prototype.renderMobileDateInfo = function renderMobileDateInfo() {
	    var _this5 = this;
	
	    var _state3 = this.state,
	        ticket = _state3.ticket,
	        creadAt = _state3.creadAt,
	        updatedAt = _state3.updatedAt,
	        poster_info = _state3.poster_info;
	
	
	    return ticket.map(function (item, key) {
	      return _react2.default.createElement(_DateCardMobile2.default, { ticket: item, key: key, show_spots_left: _this5.props.posterDetail.poster_info.show_spots_left });
	    });
	  };
	
	  PosterPreview.prototype.renderContentItem = function renderContentItem(content, key) {
	    var _content$content_type = content.content_type,
	        content_type = _content$content_type === undefined ? "text" : _content$content_type,
	        image_url = content.image_url,
	        text = content.text;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'poster-content-item', key: key },
	      (content_type === "text" || content_type === 0) && _react2.default.createElement('div', { className: 'content-type-text', dangerouslySetInnerHTML: { __html: text } }),
	      (content_type === "picture" || content_type === 1) && _react2.default.createElement(
	        'div',
	        { className: 'content-type-picture' },
	        _react2.default.createElement('img', { src: image_url })
	      )
	    );
	  };
	
	  return PosterPreview;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = PosterPreview;
	module.exports = exports['default'];

/***/ },

/***/ "3+NE":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"poster-view":"poster-view","date-info":"date-info","title-section":"title-section","poster-title":"poster-title","info-section":"info-section","content-section":"content-section","content-type-picture":"content-type-picture","content-type-text":"content-type-text","poster-content":"poster-content","col-md-9":"col-md-9","col-md-12":"col-md-12","poster-footer":"poster-footer","footer-content":"footer-content","floating-register-btn":"floating-register-btn","register-now":"register-now"};

/***/ },

/***/ "Idmx":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <ProfileInfo  />
	                    *
	                    * @parent anybody
	                    * @children 
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("cf2U");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfileInfo = (_temp = _class = function (_React$Component) {
	  _inherits(ProfileInfo, _React$Component);
	
	  function ProfileInfo(props) {
	    _classCallCheck(this, ProfileInfo);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ProfileInfo.prototype.componentWillMount = function componentWillMount() {};
	
	  ProfileInfo.prototype.render = function render() {
	    var _props = this.props,
	        name = _props.name,
	        picture = _props.picture,
	        _props$pictureHeight = _props.pictureHeight,
	        pictureHeight = _props$pictureHeight === undefined ? 5 : _props$pictureHeight,
	        _props$pictureWidth = _props.pictureWidth,
	        pictureWidth = _props$pictureWidth === undefined ? 5 : _props$pictureWidth;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'profile-info' },
	      _react2.default.createElement('img', { className: 'profile-picture', src: picture, width: pictureWidth, height: pictureHeight }),
	      _react2.default.createElement(
	        'div',
	        { className: 'profile-text' },
	        ' ',
	        name
	      )
	    );
	  };
	
	  return ProfileInfo;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = ProfileInfo;
	module.exports = exports['default'];

/***/ },

/***/ "cf2U":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"profile-info":"profile-info","profile-picture":"profile-picture","profile-text":"profile-text"};

/***/ },

/***/ "l5sO":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _locale = __webpack_require__("ncso");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("AcCi");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <DateCard
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Preview/index.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var DateCard = function (_React$Component) {
	  _inherits(DateCard, _React$Component);
	
	  function DateCard(props) {
	    _classCallCheck(this, DateCard);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  DateCard.prototype.componentWillMount = function componentWillMount() {};
	
	  DateCard.prototype.getDateVerbose = function getDateVerbose(start_at) {
	    var m = (0, _moment2.default)(start_at);
	
	    var startDay = m.format('DD');
	    var startMonthYearWeekday = m.format(__('MMMM YYYY, ddd', 'dateFormat'));
	    var startTime = m.locale('en').format(__('h:mm A'));
	
	    if (startDay.toLowerCase().indexOf('invalid') > -1) {
	      startDay = 'N/A';
	    }
	
	    if (startMonthYearWeekday.toLowerCase().indexOf('invalid') > -1) {
	      startMonthYearWeekday = 'N/A';
	    }
	
	    if (startTime.toLowerCase().indexOf('invalid') > -1) {
	      startTime = 'N/A';
	    }
	
	    return {
	      startDay: startDay,
	      startMonthYearWeekday: startMonthYearWeekday,
	      startTime: startTime
	    };
	  };
	
	  DateCard.prototype.render = function render() {
	    var _props$ticket = this.props.ticket,
	        title = _props$ticket.title,
	        start_at = _props$ticket.start_at,
	        ordered_amount = _props$ticket.ordered_amount,
	        price = _props$ticket.price;
	    var show_spots_left = this.props.show_spots_left;
	
	    var _getDateVerbose = this.getDateVerbose(start_at),
	        startDay = _getDateVerbose.startDay,
	        startMonthYearWeekday = _getDateVerbose.startMonthYearWeekday,
	        startTime = _getDateVerbose.startTime;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'poster-view-date-card' },
	      _react2.default.createElement(
	        'h4',
	        null,
	        __("Registration Start Time", _locale2.default)
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        startTime
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        startDay,
	        ' ',
	        startMonthYearWeekday
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        title
	      ),
	      _react2.default.createElement('hr', null),
	      _react2.default.createElement(
	        'h2',
	        { className: 'course-fee' },
	        __('Course Fee: ${price}', _locale2.default, { price: price })
	      ),
	      show_spots_left == 1 && _react2.default.createElement(
	        'h2',
	        null,
	        __("Total Registered: {numberStr}", _locale2.default, {
	          numberStr: ordered_amount || 0
	        })
	      )
	    );
	  };
	
	  return DateCard;
	}(_react2.default.Component);
	
	exports.default = DateCard;
	module.exports = exports['default'];

/***/ },

/***/ "ncso":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _text;
	
	exports.default = {
	  id: "PosterView",
	  code: "CN",
	  text: (_text = {
	    'Registration Start Time': '报名开始时间',
	    'Total Registered: {numberStr}': '目前报名: {numberStr}人',
	    'Total Registered: ': '目前报名人数: '
	
	  }, _text["Registration Start Time"] = '报名开始日期', _text['Total Registered'] = '目前报名', _text['Course Fee: ${price}'] = '课程费用: ${price}', _text['Item'] = '项目', _text['Items'] = '项目', _text['Register Now'] = '立即报名', _text['Registered'] = '报名人数', _text['Deadline'] = '报名结束日期', _text['None'] = '无限期', _text['Note: Currently we only accept online registration and offline payment.'] = '提示：报名目前只接受线上注册，线下缴费。', _text["Basic Poster"] = '普通海报', _text["Enrollment Registration"] = '招生注册', _text["Event Registration"] = '活动门票', _text["Survey"] = '调查投票', _text['Sorry we are unable to take WeChat registertion at the monment, please register with PC broswers'] = '抱歉我们暂时不支持微信付款报名，请用电脑浏览器打开报名。', _text[''] = '', _text['Confirm'] = '确认', _text['No Limit'] = '无上限', _text)
	};
	module.exports = exports["default"];

/***/ },

/***/ "AcCi":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"date-info":"date-info","sticky":"sticky","register-now":"register-now","poster-view-date-card":"poster-view-date-card","course-fee":"course-fee"};

/***/ },

/***/ "I4kK":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _locale = __webpack_require__("ncso");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("mk72");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <DateCardMobile
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Preview/index.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var DateCardMobile = function (_React$Component) {
	  _inherits(DateCardMobile, _React$Component);
	
	  function DateCardMobile(props) {
	    _classCallCheck(this, DateCardMobile);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  DateCardMobile.prototype.componentWillMount = function componentWillMount() {};
	
	  DateCardMobile.prototype.render = function render() {
	    var _props$ticket = this.props.ticket,
	        title = _props$ticket.title,
	        start_at = _props$ticket.start_at,
	        ordered_amount = _props$ticket.ordered_amount;
	    var show_spots_left = this.props.show_spots_left;
	
	
	    var dateStr = '';
	    var timeStr = '';
	
	    if (start_at) {
	      dateStr = (0, _moment2.default)(start_at).format('DD MMMM YYYY, ddd').toUpperCase();
	      timeStr = (0, _moment2.default)(start_at).format('hh:mm A').toUpperCase();
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'poster-view-date-card-mobile' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-xs-12' },
	        _react2.default.createElement(
	          'h5',
	          null,
	          title
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-xs-6' },
	        _react2.default.createElement(
	          'label',
	          null,
	          __("Registration Start Time", _locale2.default)
	        ),
	        _react2.default.createElement(
	          'h5',
	          null,
	          dateStr
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            timeStr
	          )
	        )
	      ),
	      show_spots_left == 1 && _react2.default.createElement(
	        'div',
	        { className: 'col-xs-6' },
	        _react2.default.createElement(
	          'label',
	          null,
	          __("Total Registered", _locale2.default)
	        ),
	        _react2.default.createElement(
	          'h5',
	          null,
	          __('Total Registered: ', _locale2.default),
	          ordered_amount || 0
	        )
	      )
	    );
	  };
	
	  return DateCardMobile;
	}(_react2.default.Component);
	
	exports.default = DateCardMobile;
	module.exports = exports['default'];

/***/ },

/***/ "mk72":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"poster-view-date-card-mobile":"poster-view-date-card-mobile"};

/***/ },

/***/ "C3cl":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <Register 
	                    *    posterDetail={}
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children 
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("Wo8s");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Register = (_temp = _class = function (_React$Component) {
	  _inherits(Register, _React$Component);
	
	  function Register(props) {
	    _classCallCheck(this, Register);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.renderTicket = _this.renderTicket.bind(_this);
	
	    return _this;
	  }
	
	  Register.prototype.componentWillMount = function componentWillMount() {};
	
	  Register.prototype.renderTicket = function renderTicket(item, index) {
	    var title = item.title,
	        ordered_amount = item.ordered_amount,
	        amount = item.amount,
	        end_at = item.end_at;
	
	
	    var indexStr = index + 1 > 9 ? index : '0' + (index + 1);
	
	    var endDateStr = end_at ? _react2.default.createElement(
	      'span',
	      { className: 'date' },
	      (0, _moment2.default)(end_at).locale('en').format('MMM DD YYYY, ddd')
	    ) : __('None', 'poster.register');
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'ticket-item', key: index },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-1 index' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          indexStr
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-4' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          item.title || "  "
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-4' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          __('Deadline', 'poster.register'),
	          ': ',
	          endDateStr
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-3' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          __('Registered', 'poster.register'),
	          ': ',
	          ordered_amount || 0,
	          ' / ',
	          amount || "",
	          amount === 0 && __('No Limit', 'poster.register')
	        )
	      )
	    );
	  };
	
	  Register.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props$posterDetail$t = this.props.posterDetail.ticket,
	        ticket = _props$posterDetail$t === undefined ? [] : _props$posterDetail$t;
	    var onClickRegister = this.props.onClickRegister;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'poster-register-list' },
	      _react2.default.createElement(
	        'section',
	        { className: 'header' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          ticket.length > 0 ? __('Items', 'poster.register') : __('Item', 'poster.register')
	        ),
	        ticket.length > 0 && _react2.default.createElement(
	          'a',
	          { className: 'btn btn-primary register-now', onClick: onClickRegister },
	          __('Register Now', 'poster.register')
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'ticket-item-list' },
	        ticket.length > 0 && ticket.map(function (item, key) {
	          return _this2.renderTicket(item, key);
	        })
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'footer' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          __('Note: Currently we only accept online registration and offline payment.', 'poster.register')
	        )
	      )
	    );
	  };
	
	  return Register;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = Register;
	module.exports = exports['default'];

/***/ },

/***/ "Wo8s":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"poster-register-list":"poster-register-list","register-now":"register-now","header":"header","ticket-item-list":"ticket-item-list","index":"index","ticket-item":"ticket-item","date":"date"};

/***/ },

/***/ "niOo":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp; /**
	                    * <OrderOverview
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("VBZu");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _posterOrderPay = __webpack_require__("UdMv");
	
	var _posterOrderPay2 = _interopRequireDefault(_posterOrderPay);
	
	var _weChatPosterPayment = __webpack_require__("GrNJ");
	
	var _weChatPosterPayment2 = _interopRequireDefault(_weChatPosterPayment);
	
	var _aliPosterPayment = __webpack_require__("3yzB");
	
	var _aliPosterPayment2 = _interopRequireDefault(_aliPosterPayment);
	
	var _RegisterClassModal = __webpack_require__("T9OU");
	
	var _RegisterClassModal2 = _interopRequireDefault(_RegisterClassModal);
	
	var _alert = __webpack_require__("BGi1");
	
	var _confirm = __webpack_require__("yMGN");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var locale = {
	  id: 'OrderOverview',
	  code: 'CN',
	  text: {
	    "Registration Successful": "报名成功",
	    "You will need to pay the registration fee at the school after register online. Please contact school for more information.": "此海报报名为线上注册，线下缴费，请联系校方缴费。",
	    "After you pay your registration fee online, it means you have successfully registered.": "此海报报名为线上缴费，缴费成功后即报名成功。",
	    "If you had any questions, please contact us.": "如果对报名有任何问题，也请尽快联系我们",
	    "DOB": "生日",
	    "Name": "名称",
	    "Email": "邮件",
	    "Mobile Number": "手机",
	    'Attendee Info': '报名人资料',
	    "Contact Info": "联系人资料",
	    'Order Summary': '订单详情',
	    'Order Price': '订单价格',
	    'Total Price: ${price}': '总价：${price}',
	    'Payment Method': '付款方式',
	    'WeChat Pay': '微信支付',
	    'Alipay': '支付宝支付',
	    'Pay': '付款',
	    'Edit': '编辑',
	    'Payment Successful!': '付款成功！',
	    'This school has not integrate weChat Pay and AliPay, please contact our product specialist': '此学校未开通微信支付和支付宝支付，请联系我们的产品专家',
	    'Unexpected error, please try again': '提交之后未能成功，可能由于信息错误引起，请再试一次',
	    'Please make sure to have Aplipay App to continue payment': '请确认已有支付宝APP，才可使用支付宝支付',
	    'Unable to use Alipay within WeChat, please use a broswer': '无法在微信上使用支付宝支付，请使用浏览器',
	    'For WeChat Pay option, please use a PC browser': '请使用电脑桌面端浏览器进行微信支付',
	    '': ''
	  }
	};
	
	var OrderOverview = (_temp = _class = function (_React$Component) {
	  _inherits(OrderOverview, _React$Component);
	
	  function OrderOverview(props) {
	    _classCallCheck(this, OrderOverview);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    var price_type = props.orderInfo.price_type;
	
	    var PRICE_TYPE = ['freeOrPayOffline', 'fixedAmount', 'noFixAmount'];
	
	    _this.state = {
	      schoolInfo: {},
	      paymentType: PRICE_TYPE[price_type],
	      priceList: [],
	      paymentMethod: 'weChatPay',
	      paySuccessful: false
	    };
	
	    _this.renderAttendee = _this.renderAttendee.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.startPaymentProcess = _this.startPaymentProcess.bind(_this);
	    return _this;
	  }
	
	  OrderOverview.prototype.componentWillMount = function componentWillMount() {
	    var browser_type = void 0;
	    var mobile = false;
	    if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
	      mobile = true;
	    }
	    // window.innerWidth <= 800 && window.innerHeight <= 650
	
	    if (/micromessenger/i.test(navigator.userAgent)) {
	      browser_type = 'weChatBrowser';
	    } else if (mobile) {
	      browser_type = 'mobileBroswer';
	    } else {
	      browser_type = 'pcBrowser';
	    }
	
	    this.setState({
	      browser_type: browser_type
	    });
	  };
	
	  OrderOverview.prototype.renderAttendee = function renderAttendee() {
	    var orderInfo = this.props.orderInfo;
	
	
	    return orderInfo.order.attendee.map(function (item, key) {
	      var first_name = item.first_name,
	          last_name = item.last_name,
	          email = item.email,
	          phone = item.phone,
	          date_of_birth = item.date_of_birth;
	
	
	      var DOBstr = "";
	      if (date_of_birth) {
	        DOBstr = (0, _moment2.default)(date_of_birth, 'YYYY-MM-DD').format('MMMM DD, YYYY');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'attendee-info', key: key },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              'label',
	              null,
	              __('Name', locale)
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              first_name,
	              ' ',
	              last_name
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              'label',
	              null,
	              __('DOB', locale)
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              DOBstr
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'label',
	            null,
	            __('Email', locale)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            email
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'label',
	            null,
	            __('Mobile Number', locale)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            phone
	          )
	        )
	      );
	    });
	  };
	
	  OrderOverview.prototype.getTicketPurchaseList = function getTicketPurchaseList() {
	    var _props$orderInfo = this.props.orderInfo,
	        ticketInfo = _props$orderInfo.ticketInfo,
	        order = _props$orderInfo.order;
	    var ticket = order.ticket;
	
	
	    if (!Array.isArray(ticket)) {
	      return [];
	    }
	
	    return ticket.map(function (_ref, index) {
	      var amount = _ref.amount,
	          price = _ref.price;
	
	      return _extends({}, ticketInfo[index], {
	        amount: amount,
	        price: price
	      });
	    });
	  };
	
	  OrderOverview.prototype.onChange = function onChange(e) {
	    this.setState({ paymentMethod: e.target.value });
	  };
	
	  OrderOverview.prototype.startPaymentProcess = function startPaymentProcess() {
	    var _this2 = this;
	
	    var _state = this.state,
	        paymentMethod = _state.paymentMethod,
	        browser_type = _state.browser_type;
	    var order_number = this.props.order_number;
	
	
	    (0, _posterOrderPay2.default)(order_number, { payment_method: paymentMethod, browser_type: browser_type }).then(function (res) {
	      if (res.result == 'submit successfully') {
	        if (paymentMethod == 'weChatPay') {
	
	          (0, _weChatPosterPayment2.default)({ url: res.payment_returned_url, order_number: order_number, type: 'wechatpay', browser_type: browser_type }).then(function (res) {
	            _this2.setState({ paySuccessful: true });
	          });
	        } else if (paymentMethod == 'alipay') {
	          window.open(res.payment_returned_url);
	          (0, _aliPosterPayment2.default)({ url: res.payment_returned_url, order_number: order_number, type: 'alipay' }).then(function (res) {
	            _this2.setState({ paySuccessful: true });
	          });
	        }
	      } else if (res.result == 'failure') {
	        // failure reason
	        if (res.reason == 'payment_method is not supported with this browser_type.') {} else if (res.reason == 'please open it again with mobile browser.') {} else if (res.reason == 'this order can not be paid.') {} else if (res.reason == 'this order can not be paid by Wechat/Alipay.') {
	          _alert.alert.warning(__('This school has not integrate weChat Pay and AliPay, please contact our product specialist', locale));
	        } else if (res.reason == 'please confirm info and submit again') {
	          _alert.alert.warning(__('Unexpected error, please try again', locale));
	        }
	      }
	    });
	  };
	
	  OrderOverview.prototype.orderSummary = function orderSummary() {
	    var _this3 = this;
	
	    var ticketPurchaseList = this.getTicketPurchaseList();
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h3',
	        null,
	        __('Order Price', locale)
	      ),
	      ticketPurchaseList.map(function (tix, i) {
	        _this3.priceList = [];
	        _this3.priceList.push(tix.amount * tix.price);
	        return _react2.default.createElement(
	          'div',
	          { key: i },
	          _react2.default.createElement(
	            'div',
	            { className: 'tix-title' },
	            _react2.default.createElement(
	              'span',
	              null,
	              tix.title
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'pull-right' },
	              tix.amount + ' x $' + tix.price
	            )
	          )
	        );
	      }),
	      _react2.default.createElement(
	        'span',
	        { className: 'tix-total-price pull-right' },
	        __('Total Price: ${price}', locale, { price: this.priceList })
	      )
	    );
	  };
	
	  OrderOverview.prototype.renderPayButton = function renderPayButton() {
	    var _this4 = this;
	
	    var _state2 = this.state,
	        paymentType = _state2.paymentType,
	        paymentMethod = _state2.paymentMethod,
	        browser_type = _state2.browser_type;
	    var order_number = this.props.order_number;
	
	
	    var isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
	      return p.toString() === "[object SafariRemoteNotification]";
	    }(!window['safari'] || typeof safari !== 'undefined' && safari.pushNotification);
	
	    if (browser_type == 'pcBrowser' && isSafari && paymentMethod == 'alipay' || browser_type == 'mobileBroswer' && paymentMethod == 'alipay') {
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'block' } },
	        browser_type == 'mobileBroswer' && _react2.default.createElement(
	          'span',
	          null,
	          __('Please make sure to have Aplipay App to continue payment', locale)
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'btn btn-primary btn-block', target: '_blank', onClick: function onClick() {
	              (0, _aliPosterPayment2.default)({ order_number: order_number, type: 'alipay' }).then(function (res) {
	                _this4.setState({ paySuccessful: true });
	              });
	            }, href: '/alipay-redirect?order_number=' + order_number + '&payment_method=' + paymentMethod + '&browser_type=' + browser_type },
	          __('Pay', locale)
	        )
	      );
	    } else {
	      return _react2.default.createElement(
	        'div',
	        null,
	        browser_type == 'weChatBrowserBroswer' && _react2.default.createElement(
	          'span',
	          null,
	          __('Unable to use Alipay within WeChat, please use a broswer', locale)
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary btn-block', onClick: this.startPaymentProcess },
	          __('Pay', locale)
	        )
	      );
	    }
	  };
	
	  OrderOverview.prototype.render = function render() {
	    var _props = this.props,
	        orderInfo = _props.orderInfo,
	        poster_info = _props.poster_info,
	        posterDetail = _props.posterDetail,
	        order_number = _props.order_number;
	    var _orderInfo$order = orderInfo.order,
	        recipient = _orderInfo$order.recipient,
	        ticketInfo = _orderInfo$order.ticketInfo,
	        ticket = _orderInfo$order.ticket;
	    var title = poster_info.title,
	        school_logo = poster_info.school_logo,
	        school_name = poster_info.school_name,
	        school_address = poster_info.school_address,
	        school_city = poster_info.school_city,
	        school_province = poster_info.school_province,
	        school_postal_code = poster_info.school_postal_code,
	        school_email = poster_info.school_email,
	        school_phone = poster_info.school_phone,
	        school_suite_num = poster_info.school_suite_num,
	        school_website = poster_info.school_website,
	        school = poster_info.school;
	    var _state3 = this.state,
	        paymentType = _state3.paymentType,
	        priceList = _state3.priceList,
	        paymentMethod = _state3.paymentMethod,
	        paySuccessful = _state3.paySuccessful,
	        paymentUrl = _state3.paymentUrl,
	        browser_type = _state3.browser_type;
	
	
	    var ticketPurchaseList = this.getTicketPurchaseList();
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'poster-order-overview' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          paymentType == 'freeOrPayOffline' ? __("Registration Successful", locale) : __('Order Summary', locale)
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          paymentType == 'freeOrPayOffline' ? __("You will need to pay the registration fee at the school after register online. Please contact school for more information.", locale) : __('After you pay your registration fee online, it means you have successfully registered.', locale)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'order-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h2',
	                null,
	                title,
	                paymentType != 'freeOrPayOffline' && _react2.default.createElement(
	                  'span',
	                  { className: 'tix-edit pull-right', onClick: function onClick() {
	                      (0, _RegisterClassModal2.default)({ posterDetail: posterDetail, schoolId: school, orderInfo: orderInfo });
	                    } },
	                  __('Edit', locale)
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row col-sm-12' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  __('Attendee Info', locale)
	                ),
	                this.renderAttendee(),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'recipient-info' },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    __('Contact Info', locale)
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row col-sm-12' },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        __('Name', locale)
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        recipient.full_name
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        __('Email', locale)
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        recipient.email
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        __('Mobile Number', locale)
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        recipient.phone
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          paymentType == 'freeOrPayOffline' && _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6 pull-right' },
	            _react2.default.createElement(
	              'div',
	              { className: 'school-info' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                __('If you had any questions, please contact us.', locale)
	              ),
	              _react2.default.createElement(
	                'h5',
	                null,
	                school_name
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                school_address,
	                ' ',
	                school_suite_num,
	                ' ',
	                school_city,
	                ' ',
	                school_province,
	                ' ',
	                school_postal_code
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                school_website
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                school_email
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                school_phone
	              )
	            )
	          ),
	          paymentType != 'freeOrPayOffline' && paySuccessful == false && _react2.default.createElement(
	            'div',
	            { className: 'col-sm-5' },
	            this.orderSummary(),
	            _react2.default.createElement(
	              'div',
	              { className: 'school-info' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                __('Payment Method', locale)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'radio' },
	                browser_type == 'pcBrowser' && _react2.default.createElement(
	                  'label',
	                  { className: 'wechat-pay' },
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    value: 'weChatPay',
	                    name: 'optradio',
	                    checked: paymentMethod == 'weChatPay',
	                    onChange: this.onChange
	                  }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    __('WeChat Pay', locale)
	                  )
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'alipay' },
	                  _react2.default.createElement('input', { type: 'radio', value: 'alipay', name: 'optradio', onChange: this.onChange, disabled: browser_type == 'weChatBrowser' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    __('Alipay', locale)
	                  )
	                ),
	                browser_type != 'pcBrowser' && _react2.default.createElement(
	                  'p',
	                  null,
	                  __('For WeChat Pay option, please use a PC browser', locale)
	                )
	              ),
	              this.renderPayButton()
	            )
	          ),
	          paySuccessful == true && _react2.default.createElement(
	            'div',
	            { className: 'col-sm-5' },
	            _react2.default.createElement(
	              'div',
	              { className: 'school-info' },
	              this.orderSummary(),
	              _react2.default.createElement(
	                'h3',
	                null,
	                __('Payment Successful!', locale)
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return OrderOverview;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = OrderOverview;
	module.exports = exports['default'];

/***/ },

/***/ "VBZu":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"poster-order-overview":"poster-order-overview","container":"container","order-content":"order-content","attendee-info":"attendee-info","recipient-info":"recipient-info","school-info":"school-info","radio":"radio","wechat-pay":"wechat-pay","alipay":"alipay","tix-title":"tix-title","tix-total-price":"tix-total-price","col-sm-5":"col-sm-5","tix-edit":"tix-edit"};

/***/ },

/***/ "UdMv":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = posterOrderPay;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PAYMENT_METHOD = ['weChatPay', 'alipay'];
	var BROSWER_TYPE = ['pcBrowser', 'mobileBroswer', 'weChatBrowser'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
		payment_method: _joiBrowser2.default.string().valid(PAYMENT_METHOD).required(),
		browser_type: _joiBrowser2.default.string().valid(BROSWER_TYPE).required()
	});
	
	function posterOrderPay(orderNumber, params) {
	
		var validateResult = _joiBrowser2.default.validate(params, schema);
	
		if (validateResult.error) {
			return new Promise(function (resolve, reject) {
				reject(validateResult);
			});
		}
	
		var toServer = _extends({}, params, {
			payment_method: PAYMENT_METHOD.indexOf(params.payment_method),
			browser_type: BROSWER_TYPE.indexOf(params.browser_type)
		});
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/poster_order_pay/' + orderNumber + '/',
				'method': 'POST',
				'data': JSON.stringify(toServer),
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res.data);
			}).catch(function (err) {
				reject(err);
			});
		});
	}

/***/ },

/***/ "GrNJ":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("tbf7");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "tbf7":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("gO/+");
	
	var _ModalContent = __webpack_require__("i0zT");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _locale = __webpack_require__("tAYn");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel,
	        url = _props.url,
	        order_number = _props.order_number;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'wechat-poster-payment-modal',
	        hasHeader: true,
	
	        headerTitle: __("Register", _locale2.default),
	        headerIcon: 'fa icon-ticket',
	        fixedWidth: 400,
	        contentHeight: 400,
	        onCloseModalClick: dismiss,
	
	        footerType: 'grey',
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, this.props)
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "gO/+":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wechat-poster-payment-modal":"wechat-poster-payment-modal","modal-float-body":"modal-float-body","classtop-modal-content":"classtop-modal-content","wechat-poster-payment-modal-content":"wechat-poster-payment-modal-content","wechat-pay-title":"wechat-pay-title","btn":"btn","header":"header","close-button":"close-button","wechat-poster-success-modal-content":"wechat-poster-success-modal-content"};

/***/ },

/***/ "i0zT":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _alert = __webpack_require__("BGi1");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _QrCode = __webpack_require__("rkYD");
	
	var _QrCode2 = _interopRequireDefault(_QrCode);
	
	var _locale = __webpack_require__("tAYn");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _getPosterOrderPay = __webpack_require__("Qhbz");
	
	var _getPosterOrderPay2 = _interopRequireDefault(_getPosterOrderPay);
	
	__webpack_require__("gO/+");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      step: 1
	    };
	
	    _this.checkPayment = _this.checkPayment.bind(_this);
	    return _this;
	  }
	
	  ModalContent.prototype.componentDidMount = function componentDidMount() {
	    var checkPayment = setInterval(this.checkPayment, 5000);
	    this.setState({ checkPayment: checkPayment });
	  };
	
	  ModalContent.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearInterval(this.state.checkPayment);
	  };
	
	  ModalContent.prototype.checkPayment = function checkPayment() {
	    var _this2 = this;
	
	    var order_number = this.props.order_number;
	
	
	    (0, _getPosterOrderPay2.default)(order_number).then(function (res) {
	      if (res.payment_result == 'success') {
	        clearInterval(_this2.state.checkPayment);
	        _this2.setState({ step: 2 });
	      }
	    });
	  };
	
	  ModalContent.prototype.render = function render() {
	    var _props = this.props,
	        url = _props.url,
	        dismiss = _props.dismiss,
	        proceed = _props.proceed,
	        browser_type = _props.browser_type;
	    var step = this.state.step;
	
	
	    if (step == 1) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'wechat-poster-payment-modal-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wechat-pay-title' },
	          __('Please Use WeChat Scan Pay', _locale2.default)
	        ),
	        _react2.default.createElement(_QrCode2.default, { value: url }),
	        browser_type == 'mobileBroswer' && _react2.default.createElement('img', { src: __webpack_require__("qWZl") })
	      );
	    } else if (step == 2) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'wechat-poster-success-modal-content text-center' },
	        _react2.default.createElement('img', { src: __webpack_require__("fBwy") }),
	        _react2.default.createElement(
	          'p',
	          null,
	          __('Payment Successful', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary btn-block', onClick: function onClick() {
	              proceed({ paySuccessful: true });
	              dismiss();
	            } },
	          __('Complete', _locale2.default)
	        )
	      );
	    }
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "tAYn":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'posterPaymentModal',
	  code: 'CN',
	  text: {
	    'Register': '报名',
	    'Please Use WeChat Scan Pay': '请使用微信扫码支付',
	    'Payment Successful': '扫码已完成，支付成功',
	    'Complete': '完成',
	    '': ''
	
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "Qhbz":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getPosterOrderPay;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getPosterOrderPay(order_number) {
	
		if (!order_number) {
			return new Promise(function (resolve, reject) {
				reject({
					error: new Error('Missing order_number')
				});
			});
		}
	
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': "/poster_order_pay/" + order_number,
				'method': 'GET',
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res.data);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports["default"];

/***/ },

/***/ "qWZl":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "paymentProcess.5c4fcc78.jpg";

/***/ },

/***/ "fBwy":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Group@2x.896cf366.png";

/***/ },

/***/ "3yzB":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("dq09");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports["default"];

/***/ },

/***/ "dq09":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("KI3W");
	
	var _ModalContent = __webpack_require__("SWQM");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _locale = __webpack_require__("Ftgq");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      height: 200
	    };
	
	    _this.handleHeight = _this.handleHeight.bind(_this);
	    return _this;
	  }
	
	  ModalBody.prototype.handleHeight = function handleHeight(height) {
	    this.setState({ height: height });
	  };
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel,
	        order_number = _props.order_number;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'ali-poster-payment-modal',
	        hasHeader: true,
	
	        headerTitle: __("Register", _locale2.default),
	        headerIcon: 'fa icon-ticket',
	        fixedWidth: 450,
	        contentHeight: this.state.height,
	        onCloseModalClick: dismiss,
	
	        footerType: 'grey',
	        isShowingModal: show },
	      _react2.default.createElement(_ModalContent2.default, _extends({}, this.props, { onHeightChange: this.handleHeight }))
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "KI3W":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ali-poster-payment-modal":"ali-poster-payment-modal","modal-float-body":"modal-float-body","classtop-modal-content":"classtop-modal-content","ali-poster-payment-modal-content":"ali-poster-payment-modal-content","btn":"btn","ali-poster-success-modal-content":"ali-poster-success-modal-content","header":"header","close-button":"close-button","ali-pay-title":"ali-pay-title"};

/***/ },

/***/ "SWQM":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _alert = __webpack_require__("BGi1");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _locale = __webpack_require__("Ftgq");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _getPosterOrderPay = __webpack_require__("Qhbz");
	
	var _getPosterOrderPay2 = _interopRequireDefault(_getPosterOrderPay);
	
	__webpack_require__("KI3W");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      step: 1
	    };
	    return _this;
	  }
	
	  ModalContent.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        dismiss = _props.dismiss,
	        order_number = _props.order_number,
	        onHeightChange = _props.onHeightChange,
	        proceed = _props.proceed;
	    var step = this.state.step;
	
	
	    if (step == 1) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ali-poster-payment-modal-content text-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ali-pay-title' },
	          __('Please complete the payment in Alipay and confirm the payment', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-default', onClick: function onClick() {
	              dismiss();
	            } },
	          __('Cancel', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary', onClick: function onClick() {
	              (0, _getPosterOrderPay2.default)(order_number).then(function (res) {
	                if (res.payment_result == 'success') {
	                  _this2.setState({ step: 2 }, onHeightChange(400));
	                } else {
	                  _alert.alert.warning(__('Payment unsuccessful, please try again', _locale2.default));
	                }
	              });
	            } },
	          __('Success', _locale2.default)
	        )
	      );
	    } else if (step == 2) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ali-poster-success-modal-content text-center' },
	        _react2.default.createElement('img', { src: __webpack_require__("X5fy") }),
	        _react2.default.createElement(
	          'p',
	          null,
	          __('Payment Successful', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary btn-block', onClick: function onClick() {
	              proceed({ paySuccessful: true });
	              dismiss();
	            } },
	          __('Complete', _locale2.default)
	        )
	      );
	    }
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "Ftgq":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'aliPosterPaymentModal',
	  code: 'CN',
	  text: {
	    'Register': '报名',
	    'Payment Successful': '扫码已完成，支付成功',
	    'Complete': '完成',
	    'Please complete the payment in Alipay and confirm the payment': '请在支付宝界面完成支付，并在此确认是否支付成功',
	    'Success': '支付已成功',
	    'Cancel': '取消支付',
	    'Payment unsuccessful, please try again': '支付未成功，请在试一次'
	
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "X5fy":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Group@2x.896cf366.png";

/***/ },

/***/ "T9OU":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	
	  if (!opts.schoolId) {
	    throw new Error('opts.schoolId is missing');
	  }
	
	  return modal(opts);
	};
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _ModalBody = __webpack_require__("RWT4");
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = (0, _reactConfirm.createConfirmation)(_ModalBody2.default);
	
	module.exports = exports['default'];

/***/ },

/***/ "RWT4":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alert = __webpack_require__("BGi1");
	
	__webpack_require__("2Uby");
	
	var _ModalContent = __webpack_require__("KsQJ");
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _reactConfirm = __webpack_require__("sfvs");
	
	var _locale = __webpack_require__("ZghS");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _confirm = __webpack_require__("yMGN");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var localeCN = {
	  id: "ResgisterOnPosterModal",
	  code: "CN",
	  text: {
	    "Are you sure you want to close?": "你确认关闭吗？"
	  }
	};
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody(props) {
	    _classCallCheck(this, ModalBody);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        proceed = _props.proceed,
	        dismiss = _props.dismiss,
	        cancel = _props.cancel;
	
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: 'register-on-poster-modal',
	        isShowingModal: show // if you want to show it when component mounts, set it true
	        , allowCloseByClickingShadow: false
	
	        // useDefaultClosebutton={true}
	        // fixedHeight={300}
	        // fixedWidth={300}
	        // overlayColor="#11151E"
	        // contentHeight={300}
	        , overlayOpacity: 0.25,
	
	        hasHeader: true,
	        headerType: 'bold' // default, bold
	        , headerTitle: __('Register', _locale2.default),
	        headerIcon: 'fa icon-ticket' // class for icon tag
	        // headerClassName=""
	        // headerCustomContent={}
	
	        // hasFooter={true}
	        // footerType="bold" // grey, transparent, bold
	        // footerClassName=""
	        // footerCustomContent={}
	        , onCloseModalClick: function onCloseModalClick() {
	          (0, _confirm.confirm)(__('Are you sure you want to close?', localeCN)).then(function () {
	            dismiss();
	          }).catch(function (err) {});
	        }
	      },
	      _react2.default.createElement(_ModalContent2.default, this.props)
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	exports.default = (0, _reactConfirm.confirmable)(ModalBody);
	module.exports = exports['default'];

/***/ },

/***/ "2Uby":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"register-on-poster-modal":"register-on-poster-modal","modal-float-body":"modal-float-body","content-wrapper":"content-wrapper","content":"content","classtop-modal-content":"classtop-modal-content","ticket-form-accordion-content":"ticket-form-accordion-content","ticket-form-accordion-header":"ticket-form-accordion-header","upper":"upper","bottom":"bottom","ticket-price":"ticket-price","deadline-date":"deadline-date","add-applicant-button":"add-applicant-button","form-list-wrapper":"form-list-wrapper","form-list":"form-list","form-group":"form-group","required":"required","application-form-wrapper":"application-form-wrapper","application-form":"application-form","delete-applicant":"delete-applicant","isLastForm":"isLastForm","recipient-info-content":"recipient-info-content","hasError":"hasError","flag-dropdown":"flag-dropdown","error-msg":"error-msg"};

/***/ },

/***/ "KsQJ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TicketFormAccordion = __webpack_require__("FPGN");
	
	var _TicketFormAccordion2 = _interopRequireDefault(_TicketFormAccordion);
	
	var _alert = __webpack_require__("BGi1");
	
	var _locale = __webpack_require__("ZghS");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _placeOrder = __webpack_require__("vcaa");
	
	var _placeOrder2 = _interopRequireDefault(_placeOrder);
	
	var _Input = __webpack_require__("xQmu");
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _validator = __webpack_require__("+b6B");
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _Transition = __webpack_require__("X/qO");
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _OrderOverview = __webpack_require__("niOo");
	
	var _OrderOverview2 = _interopRequireDefault(_OrderOverview);
	
	var _PhoneNumber = __webpack_require__("GM/A");
	
	var _PhoneNumber2 = _interopRequireDefault(_PhoneNumber);
	
	__webpack_require__("1yZZ");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ModalContent />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Modal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var DEFAULT_REGION_CODE = 'ca';
	
	var validateRules = {
	  full_name: ['required'],
	  email: ['required', 'email'],
	  phoneParsed: ['required', 'phoneParsed']
	};
	
	var PHONE_LOCALE = 'en-CA';
	
	var ModalContent = function (_React$Component) {
	  _inherits(ModalContent, _React$Component);
	
	  function ModalContent(props) {
	    _classCallCheck(this, ModalContent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.attendeeArray = [];
	    _this.validateFns = [];
	
	    var poster_info = props.posterDetail.poster_info;
	
	
	    _this.state = {
	      submitting: false,
	      recipientFormError: {},
	      attendeeNumber: props.orderInfo ? props.orderInfo.order.attendee.length : 0,
	      paymentType: 'weChatPay',
	      orderInfo: {},
	      poster_info: poster_info,
	      ticket: props.orderInfo ? props.orderInfo.order.ticket : [],
	      attendee: props.orderInfo ? props.orderInfo.order.attendee : [],
	      recipient: props.orderInfo ? props.orderInfo.order.recipient : { full_name: '', email: '', phoneParsed: { country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE } }
	    };
	
	    _this.onAttendeeChange = _this.onAttendeeChange.bind(_this);
	    _this.onRecipientChange = _this.onRecipientChange.bind(_this);
	    _this.dealWithFailure = _this.dealWithFailure.bind(_this);
	    _this.submit = _this.submit.bind(_this);
	    _this.validate = _this.validate.bind(_this);
	
	    return _this;
	  }
	
	  ModalContent.prototype.onAttendeeChange = function onAttendeeChange(index) {
	    var _this2 = this;
	
	    return function (applications) {
	      _this2.attendeeArray[index] = applications;
	
	      var attendeeNumber = 0;
	      _this2.attendeeArray.map(function (arrays) {
	        attendeeNumber += arrays.length;
	      });
	
	      _this2.setState({
	        attendeeNumber: attendeeNumber
	      });
	    };
	  };
	
	  ModalContent.prototype.onRecipientChange = function onRecipientChange(name) {
	    var _this3 = this;
	
	    return function (e) {
	      if (name == 'phoneParsed') {
	        var _extends2;
	
	        _this3.setState({
	          recipient: _extends({}, _this3.state.recipient, (_extends2 = {}, _extends2[name] = e, _extends2))
	        });
	      } else {
	        var _extends3;
	
	        _this3.setState({
	          recipient: _extends({}, _this3.state.recipient, (_extends3 = {}, _extends3[name] = e.target.value, _extends3))
	        });
	      }
	    };
	  };
	
	  ModalContent.prototype.renderClassList = function renderClassList() {
	    var _this4 = this;
	
	    var ticket = this.props.posterDetail.ticket;
	
	
	    return ticket.map(function (item, key) {
	      return _react2.default.createElement(_TicketFormAccordion2.default, {
	        attendee: _this4.state.attendee,
	        ticket: item,
	        key: key,
	        onChange: _this4.onAttendeeChange(key),
	        registerValidate: function registerValidate(validateFn) {
	          _this4.validateFns.push(validateFn(_this4.validate));
	        }
	      });
	    });
	  };
	
	  ModalContent.prototype.validate = function validate(formData, validateRules) {
	
	    var canSubmit = true;
	    var formError = {};
	
	    _.each(validateRules, function (rules, name) {
	      var value = formData[name];
	      var newError = void 0;
	
	      rules.map(function (rule) {
	
	        switch (rule) {
	          case 'required':
	            if (typeof value == 'undefined' || value == '') {
	              canSubmit = false;
	              newError = __('This field must not be empty.', _locale2.default);
	            }
	            break;
	          case 'email':
	            if (value && !_validator2.default.isEmail(value)) {
	              canSubmit = false;
	              newError = __('A valid email is required.', _locale2.default);
	            }
	            break;
	        }
	
	        if (newError) {
	          formError[name] = newError;
	        }
	      });
	    });
	
	    return { canSubmit: canSubmit, formError: formError };
	  };
	
	  ModalContent.prototype.submit = function submit() {
	    var _this5 = this;
	
	    var _props = this.props,
	        proceed = _props.proceed,
	        schoolId = _props.schoolId;
	    var ticket = this.props.posterDetail.ticket;
	
	
	    var canSubmitAttendee = true;
	
	    // validate all the attendee forms
	    this.validateFns.map(function (validateFn) {
	      canSubmitAttendee = validateFn();
	    });
	
	    // validate contact info form
	    var result = this.validate(this.state.recipient, validateRules);
	    var canSubmitRecipient = result.canSubmit;
	
	    if (!canSubmitAttendee || !canSubmitRecipient) {
	      this.setState({
	        recipientFormError: result.formError
	      });
	
	      return;
	    }
	
	    // formatting
	    var newAttendees = [];
	    this.attendeeArray.map(function (attendees) {
	      newAttendees = [].concat(newAttendees, attendees);
	    });
	    this.state.attendee = newAttendees;
	
	    var ticketNumbers = {};
	
	    // calculating tickets
	    this.state.attendee.map(function (attendee) {
	      if (attendee.ticket_id) {
	        if (typeof ticketNumbers[attendee.ticket_id] == 'undefined') {
	          ticketNumbers[attendee.ticket_id] = 0;
	        }
	        ticketNumbers[attendee.ticket_id]++;
	      } else {
	        throw new Error("attendee is missing ticket_id");
	      }
	    });
	
	    var arr = [];
	
	    ticket.map(function (item) {
	      var id = item.id,
	          price = item.price;
	
	      if (ticketNumbers[id]) {
	        arr.push({ ticket_id: id, price: parseFloat(price), amount: ticketNumbers[id] });
	        _this5.setState({ ticket: arr });
	      }
	    });
	
	    // reformatting
	    // if attendee's email or phone is empty, we use recipient's phone and email
	    this.state.attendee.map(function (attendee) {
	      attendee.phone = attendee.phoneParsed.national_number.length > 2 ? attendee.phoneParsed.country_code + attendee.phoneParsed.national_number : _this5.state.recipient.phoneParsed.country_code + _this5.state.recipient.phoneParsed.national_number;
	      attendee.email = attendee.email || _this5.state.recipient.email;
	
	      delete attendee.phoneParsed;
	    });
	
	    this.setState({
	      submitting: true
	    });
	
	    var newRecipient = _extends({}, this.state.recipient, { phone: this.state.recipient.phoneParsed.country_code + this.state.recipient.phoneParsed.national_number });
	    delete newRecipient.phoneParsed;
	
	    // make atteendee, recipent, ticket into one object for API
	    var order = { ticket: arr, recipient: newRecipient, attendee: this.state.attendee };
	
	    (0, _placeOrder2.default)(schoolId, order).then(function (_ref) {
	      var result = _ref.result,
	          reason = _ref.reason,
	          order_number = _ref.order_number;
	
	      _this5.setState({
	        submitting: false
	      });
	      if (result == 'failure') {
	        _this5.dealWithFailure(reason);
	      }
	      if (result == 'success') {
	        proceed({ result: result, orderInfo: { result: result, order: order, price_type: ticket[0].price_type, ticketInfo: ticket }, order_number: order_number });
	      }
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  ModalContent.prototype.dealWithFailure = function dealWithFailure(reason) {
	    switch (reason) {
	      case 'no slot left':
	        _alert.alert.fail(__('No more space left.', _locale2.default), __('Registration Failed', _locale2.default));
	        break;
	      case 'no contact info':
	        _alert.alert.fail(__('Contact info is missing.', _locale2.default), __('Registration Failed', _locale2.default));
	        break;
	    }
	  };
	
	  ModalContent.prototype.render = function render() {
	    var _state = this.state,
	        submitting = _state.submitting,
	        recipientFormError = _state.recipientFormError,
	        attendeeNumber = _state.attendeeNumber,
	        recipient = _state.recipient;
	    var full_name = recipient.full_name,
	        email = recipient.email,
	        phoneParsed = recipient.phoneParsed;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'Register-Class-Modal-Content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'class-list' },
	        this.renderClassList()
	      ),
	      _react2.default.createElement(
	        _Transition2.default,
	        { type: 'expand' },
	        (attendeeNumber > 0 || this.props.orderInfo) && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'recipient-info' },
	            _react2.default.createElement(
	              'div',
	              { className: 'recipient-info-content' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                __('Contact Info', _locale2.default)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col-sm-12 form-group', { hasError: recipientFormError['full_name'] }) },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  __('Full Name', _locale2.default),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'required' },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'text', value: full_name, onChange: this.onRecipientChange('full_name') }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'error-msg' },
	                  recipientFormError['full_name']
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col-sm-12 form-group', { hasError: recipientFormError['email'] }) },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  __('Email', _locale2.default),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'required' },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'text', value: email, onChange: this.onRecipientChange('email') }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'error-msg' },
	                  recipientFormError['email']
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col-sm-12 form-group', { hasError: recipientFormError['phone'] }) },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  __('Phone', _locale2.default),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'required' },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement(_PhoneNumber2.default, {
	                  inputStyle: { height: '40px' },
	                  className: 'form-control',
	                  defaultCountry: 'ca',
	                  value: phoneParsed,
	                  onChange: this.onRecipientChange('phoneParsed'),
	                  onlyCountries: ['ca', 'us'],
	                  disableAreaCodes: true
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'error-msg' },
	                  recipientFormError['phone']
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary', disabled: submitting, onClick: this.submit },
	                !submitting && __('Next', _locale2.default),
	                submitting && __('Next', _locale2.default)
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ModalContent;
	}(_react2.default.Component);
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ },

/***/ "FPGN":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp; /**
	                    * <TicketFormAccordion
	                    *    ticket={}
	                    *	/>
	                    *
	                    * @parent /ModalContent
	                    * @stateful
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _locale = __webpack_require__("ZghS");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ApplicationForm = __webpack_require__("w5oq");
	
	var _ApplicationForm2 = _interopRequireDefault(_ApplicationForm);
	
	var _placeOrder = __webpack_require__("vcaa");
	
	var _placeOrder2 = _interopRequireDefault(_placeOrder);
	
	var _Transition = __webpack_require__("X/qO");
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddApplicant = function AddApplicant(_ref) {
	  var currentNumber = _ref.currentNumber,
	      onClick = _ref.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'add-applicant-button', onClick: onClick },
	    _react2.default.createElement(
	      'span',
	      null,
	      currentNumber || 0
	    ),
	    _react2.default.createElement('i', { className: 'fa icon-plus' })
	  );
	};
	
	var TicketFormAccordion = (_temp = _class = function (_React$Component) {
	  _inherits(TicketFormAccordion, _React$Component);
	
	  function TicketFormAccordion(props) {
	    _classCallCheck(this, TicketFormAccordion);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.addApplicant = _this.addApplicant.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	
	    _this.state = {
	      applications: props.attendee || [],
	      applicationErrors: []
	    };
	    return _this;
	  }
	
	  TicketFormAccordion.prototype.onChange = function onChange(index) {
	    var _this2 = this;
	
	    return function (formData) {
	      var applications = _this2.state.applications;
	      applications[index] = _extends({}, applications[index], formData);
	
	      _this2.setState({
	        applications: applications
	      }, function () {
	        _this2.props.onChange(applications);
	      });
	    };
	  };
	
	  TicketFormAccordion.prototype.onDelete = function onDelete(index) {
	    var _this3 = this;
	
	    var _state = this.state,
	        applications = _state.applications,
	        applicationErrors = _state.applicationErrors;
	
	    (0, _confirm.confirm)(__('Are you sure you want to remove the applicant?', _locale2.default)).then(function (res) {
	      _this3.setState({
	        applications: [].concat(applications.slice(0, index), applications.slice(index + 1)),
	        applicationErrors: [].concat(applicationErrors.slice(0, index), applicationErrors.slice(index + 1))
	      }, function () {
	        _this3.props.onChange(_this3.state.applications);
	      });
	    }).catch(function () {});
	  };
	
	  TicketFormAccordion.prototype.addApplicant = function addApplicant() {
	    var _this4 = this;
	
	    var _props$ticket = this.props.ticket,
	        id = _props$ticket.id,
	        end_at = _props$ticket.end_at,
	        amount = _props$ticket.amount,
	        auto_wait_list = _props$ticket.auto_wait_list,
	        max_per_order = _props$ticket.max_per_order;
	
	
	    var newApplicant = {
	      ticket_id: id,
	      custom_data: {}
	    };
	
	    if (end_at && (0, _moment2.default)(end_at).format('YYYY-MM-DD HH:mm') < (0, _moment2.default)().format('YYYY-MM-DD HH:mm')) {
	      return _alert.alert.fail(__('Registration is closed', _locale2.default));
	    }
	
	    var applicants = [].concat(this.state.applications, [_extends({}, newApplicant)]);
	
	    if (auto_wait_list == 0 && max_per_order !== null && applicants.length > max_per_order) {
	      return _alert.alert.fail(__('No more space left.', _locale2.default));
	    }
	
	    this.setState({
	      applications: applicants,
	      applicationErrors: [].concat(this.state.applicationErrors, [{}])
	    }, function () {
	      _this4.props.onChange(_this4.state.applications);
	    });
	  };
	
	  TicketFormAccordion.prototype.render = function render() {
	    var _this5 = this;
	
	    var registerValidate = this.props.registerValidate;
	    var _state2 = this.state,
	        applications = _state2.applications,
	        applicationErrors = _state2.applicationErrors;
	    var _props$ticket2 = this.props.ticket,
	        title = _props$ticket2.title,
	        ticket_type = _props$ticket2.ticket_type,
	        start_at = _props$ticket2.start_at,
	        end_at = _props$ticket2.end_at,
	        auto_wait_list = _props$ticket2.auto_wait_list;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'ticket-form-accordion-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'ticket-form-accordion-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ticket-form-accordion-header' },
	          _react2.default.createElement(
	            'section',
	            { className: 'upper' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              title || "N/A"
	            ),
	            _react2.default.createElement(AddApplicant, { onClick: this.addApplicant, currentNumber: applications.length })
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: 'bottom' },
	            _react2.default.createElement(
	              'div',
	              { className: 'deadline-date' },
	              end_at && __('Deadline', _locale2.default) + ': ' + (0, _moment2.default)(end_at).locale('en').format('DD MMMM YYYY, ddd hh:mm A'),
	              !end_at && __('Deadline: N/A', _locale2.default)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-list-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-list' },
	            _react2.default.createElement(
	              _Transition2.default,
	              { type: 'expand' },
	              applications.map(function (formData, key) {
	                var isLastForm = !(applications.length > 1 && key != applications.length - 1);
	                return _react2.default.createElement(_ApplicationForm2.default, {
	                  onChange: _this5.onChange(key),
	                  key: key,
	                  isLastForm: isLastForm,
	                  onDelete: function onDelete(key) {
	                    return _this5.onDelete(key);
	                  },
	                  formData: applications[key],
	                  formError: applicationErrors[key],
	                  index: key,
	                  registerValidate: registerValidate
	                });
	              })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return TicketFormAccordion;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = TicketFormAccordion;
	module.exports = exports['default'];

/***/ },

/***/ "ZghS":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _text;
	
	exports.default = {
	  id: "RegisterOnPosterModal",
	  code: "CN",
	  text: (_text = {
	    'Register': '报名',
	    'Deadline': '报名结束日期',
	    'Deadline: N/A': '报名结束日期: 无限期',
	    'Applicant Information': '报名人资料',
	    'Last Name': '姓',
	    'First Name': '名',
	    'Date Of Birth': '生日',
	    'Applicant\'s Email': '报名人邮件',
	    'Applicant\'s Phone': '报名人电话',
	    'Contact Person Information': '联系人资料',
	    'Submit': '提交',
	    "Next": '下一步',
	
	    'Contact Info': '联系人资料',
	    'Full Name': '姓名',
	    'Email': '邮件',
	    'Phone': '电话'
	  }, _text["Submit"] = '提交', _text['Submitting...'] = '正在提交...', _text['This field must not be empty.'] = '此项不能为空', _text['A valid phone number is required.'] = '请输入正确的电话号码', _text['A valid email is required.'] = '请输入正确的邮件地址', _text['Are you sure you want to remove the applicant?'] = '确认删除此报名人？', _text['No more space left.'] = '报名名额已满', _text['Contact info is missing.'] = '请填写联系人信息', _text['Registration Failed'] = '注册失败', _text['Registration is closed'] = '报名已结束', _text)
	};
	module.exports = exports["default"];

/***/ },

/***/ "w5oq":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp; /**
	                    * <ApplicationForm
	                    *	 onChange={}
	                    *	/>
	                    *
	                    * @parent TicketFormAccordion
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _locale = __webpack_require__("ZghS");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _DOBPicker = __webpack_require__("Rn4c");
	
	var _DOBPicker2 = _interopRequireDefault(_DOBPicker);
	
	var _PhoneNumber = __webpack_require__("GM/A");
	
	var _PhoneNumber2 = _interopRequireDefault(_PhoneNumber);
	
	var _lodash = __webpack_require__("M4fF");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	__webpack_require__("/Tj7");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_REGION_CODE = 'ca';
	var validateRules = {
	  first_name: ['required'],
	  last_name: ['required'],
	  email: ['email'],
	  phone: ['phone']
	};
	
	var ApplicationForm = (_temp = _class = function (_React$Component) {
	  _inherits(ApplicationForm, _React$Component);
	
	  function ApplicationForm(props) {
	    _classCallCheck(this, ApplicationForm);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    var formData = _extends({}, props.formData, { phoneParsed: { country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE } });
	
	    _this.state = {
	      formData: formData,
	      formError: {}
	    };
	
	    _this.onTextChange = _this.onTextChange.bind(_this);
	    _this.onValueChange = _this.onValueChange.bind(_this);
	    _this.onPhoneChange = _this.onPhoneChange.bind(_this);
	    _this.input = _this.input.bind(_this);
	    return _this;
	  }
	
	  // we register our validation function, when the component is loaded.
	  // these functions are saved in an array which is iterated as the form
	  // is submitted.
	
	
	  ApplicationForm.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.props.registerValidate(function (validateFunction) {
	      return function () {
	        var formData = _this2.state.formData;
	
	        var _validateFunction = validateFunction(formData, validateRules),
	            canSubmit = _validateFunction.canSubmit,
	            formError = _validateFunction.formError;
	
	        _this2.setState({
	          formError: formError
	        });
	
	        return canSubmit;
	      };
	    });
	  };
	
	  ApplicationForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var formData = _ref.formData;
	
	    this.setState({
	      formData: _extends({}, this.state.formData)
	    });
	  };
	
	  ApplicationForm.prototype.onTextChange = function onTextChange(name) {
	    var _this3 = this;
	
	    return function (_ref2) {
	      var _extends2;
	
	      var target = _ref2.target;
	
	      _this3.setState({
	        formData: _extends({}, _this3.state.formData, (_extends2 = {}, _extends2[name] = target.value, _extends2))
	      }, function () {
	        _this3.props.onChange(_this3.state.formData);
	      });
	    };
	  };
	
	  ApplicationForm.prototype.onValueChange = function onValueChange(name) {
	    var _this4 = this;
	
	    return function (value) {
	      var _extends3;
	
	      _this4.setState({
	        formData: _extends({}, _this4.state.formData, (_extends3 = {}, _extends3[name] = value, _extends3))
	      }, function () {
	        _this4.props.onChange(_this4.state.formData);
	      });
	    };
	  };
	
	  ApplicationForm.prototype.onPhoneChange = function onPhoneChange(name) {
	    var _this5 = this;
	
	    return function (value) {
	      var _extends4;
	
	      _this5.setState({
	        formData: _extends({}, _this5.state.formData, (_extends4 = {}, _extends4[name] = value, _extends4))
	      }, function () {
	        _this5.props.onChange(_this5.state.formData);
	      });
	    };
	  };
	
	  ApplicationForm.prototype.render = function render() {
	    var _this6 = this;
	
	    var _props = this.props,
	        isLastForm = _props.isLastForm,
	        index = _props.index,
	        onDelete = _props.onDelete;
	    var _state = this.state,
	        formData = _state.formData,
	        formError = _state.formError;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'application-form-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('application-form', { isLastForm: isLastForm }) },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 form-group' },
	          _react2.default.createElement(
	            'h5',
	            null,
	            __('Applicant Information', _locale2.default),
	            ' ',
	            index + 1
	          ),
	          _react2.default.createElement('i', { className: 'fa icon-cancel', onClick: function onClick() {
	              return onDelete(index);
	            } })
	        ),
	        this.input({ label: __('First Name', _locale2.default), name: 'first_name', className: 'col-sm-6', required: true }),
	        this.input({ label: __('Last Name', _locale2.default), name: 'last_name', className: 'col-sm-6', required: true }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col-sm-12 form-group', { hasError: formError['date_of_birth'] }) },
	          _react2.default.createElement(
	            'label',
	            null,
	            __('Date Of Birth', _locale2.default)
	          ),
	          _react2.default.createElement(_DOBPicker2.default, { value: formData['date_of_birth'], onChange: function onChange(momentObj) {
	              _this6.onValueChange('date_of_birth')(momentObj.format('YYYY-MM-DD'));
	            } })
	        ),
	        this.input({ label: __('Applicant\'s Email', _locale2.default), name: 'email', className: 'col-sm-12' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 form-group' },
	          _react2.default.createElement(
	            'label',
	            null,
	            __('Applicant\'s Phone', _locale2.default)
	          ),
	          _react2.default.createElement(_PhoneNumber2.default, {
	            inputStyle: { height: '40px' },
	            className: 'form-control',
	            defaultCountry: 'ca',
	            value: formData['phoneParsed'],
	            onChange: this.onPhoneChange('phoneParsed'),
	            onlyCountries: ['ca', 'us'],
	            disableAreaCodes: true
	          })
	        )
	      )
	    );
	  };
	
	  ApplicationForm.prototype.input = function input(_ref3) {
	    var label = _ref3.label,
	        name = _ref3.name,
	        className = _ref3.className,
	        required = _ref3.required;
	    var _state2 = this.state,
	        formData = _state2.formData,
	        formError = _state2.formError;
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(className || '', 'form-group', { hasError: formError[name] }) },
	      _react2.default.createElement(
	        'label',
	        null,
	        label,
	        required && _react2.default.createElement(
	          'span',
	          { className: 'required' },
	          '*'
	        )
	      ),
	      _react2.default.createElement('input', { value: formData[name], type: 'text', onChange: this.onTextChange(name) }),
	      _react2.default.createElement(
	        'div',
	        { className: 'error-msg' },
	        formError[name]
	      )
	    );
	  };
	
	  return ApplicationForm;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = ApplicationForm;
	module.exports = exports['default'];

/***/ },

/***/ "/Tj7":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"application-form-wrapper":"application-form-wrapper","react-tel-input":"react-tel-input","selected-flag":"selected-flag","flag":"flag","icon-cancel":"icon-cancel","PhoneNumberInput--country-list":"PhoneNumberInput--country-list"};

/***/ },

/***/ "vcaa":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = placeOrder;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ticketSchema = {
	  ticket_id: _joiBrowser2.default.number().integer().required(),
	  amount: _joiBrowser2.default.number().integer().required(),
	  price: _joiBrowser2.default.number().allow('')
	};
	
	var attendeeSchema = {
	  ticket_id: _joiBrowser2.default.number().integer().required(),
	  first_name: _joiBrowser2.default.string().required(),
	  last_name: _joiBrowser2.default.string().required(),
	  date_of_birth: _joiBrowser2.default.string(),
	  phone: _joiBrowser2.default.string(),
	  email: _joiBrowser2.default.string(),
	  custom_data: _joiBrowser2.default.object().required()
	};
	
	var recipientSchema = _joiBrowser2.default.object().keys({
	  full_name: _joiBrowser2.default.string(),
	  phone: _joiBrowser2.default.string().required(),
	  email: _joiBrowser2.default.string().required(),
	  suite_num: _joiBrowser2.default.string().allow(''),
	  address: _joiBrowser2.default.string(),
	  city: _joiBrowser2.default.string(),
	  province: _joiBrowser2.default.string(),
	  postal_code: _joiBrowser2.default.string()
	});
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  ticket: _joiBrowser2.default.array().min(1).items(_joiBrowser2.default.object(ticketSchema)),
	  attendee: _joiBrowser2.default.array().min(1).items(_joiBrowser2.default.object(attendeeSchema)),
	  recipient: recipientSchema
	});
	
	function placeOrder(schoolId, orderInfo) {
	
	  if (!schoolId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school ID')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(orderInfo, schema);
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/place_order/" + schoolId + "/",
	      'method': 'POST',
	      'data': JSON.stringify(orderInfo),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "xQmu":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <Input />
	                    * 
	                    * customized text input
	                    *
	                    * @parent anybody
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Input = (_temp = _class = function (_React$Component) {
	  _inherits(Input, _React$Component);
	
	  function Input(props) {
	    _classCallCheck(this, Input);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Input.prototype.componentWillMount = function componentWillMount() {};
	
	  Input.prototype.render = function render() {
	    return _react2.default.createElement('div', null);
	  };
	
	  return Input;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = Input;
	module.exports = exports['default'];

/***/ },

/***/ "1yZZ":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Register-Class-Modal-Content":"Register-Class-Modal-Content","react-tel-input":"react-tel-input","selected-flag":"selected-flag","flag":"flag"};

/***/ },

/***/ "pTVQ":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "poster@2x.0f9917f2.png";

/***/ },

/***/ "Tupr":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "poster_en@2x.1ef6c0c7.png";

/***/ },

/***/ "WBJk":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _DefaultTab = __webpack_require__("VtFU");
	
	var _DefaultTab2 = _interopRequireDefault(_DefaultTab);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	__webpack_require__("d05b");
	
	var _alert = __webpack_require__("BGi1");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _Restricted = __webpack_require__("7gME");
	
	var _Restricted2 = _interopRequireDefault(_Restricted);
	
	var _PosterType = __webpack_require__("qmPG");
	
	var _PosterType2 = _interopRequireDefault(_PosterType);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _UI = __webpack_require__("OM1Z");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var Poster = function (_Component) {
	  _inherits(Poster, _Component);
	
	  function Poster(props) {
	    _classCallCheck(this, Poster);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  Poster.prototype.render = function render() {
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        __("Posters", "header.sidemenu")
	      ),
	      _react2.default.createElement(
	        _UI.Tabs,
	        null,
	        _react2.default.createElement(
	          _UI.TabList,
	          null,
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('All', 'poster')
	          ),
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('Published', 'poster')
	          ),
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('Draft', 'poster')
	          ),
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('Closed', 'poster')
	          ),
	          _react2.default.createElement(
	            _R2.default,
	            { can: 'create_poster', by: 'disable' },
	            _react2.default.createElement(
	              _UI.Button,
	              { bsStyle: 'primary', className: 'pull-right', onClick: function onClick() {
	                  (0, _PosterType2.default)();
	                } },
	              __("New Poster", "poster")
	            )
	          ),
	          _react2.default.createElement(
	            _UI.Button,
	            { bsStyle: 'primary', className: 'pull-right', onClick: function onClick() {
	                _reactRouter.browserHistory.push('/registration-table/');
	              } },
	            __("Registration List", "registrationTable")
	          )
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { posterState: 'all' })
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { posterState: 'published' })
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { posterState: 'draft' })
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { posterState: 'closed' })
	        )
	      )
	    );
	  };
	
	  return Poster;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Poster);
	module.exports = exports['default'];

/***/ },

/***/ "7gME":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	var Restricted = function (_Component) {
	  _inherits(Restricted, _Component);
	
	  function Restricted(props) {
	    _classCallCheck(this, Restricted);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  Restricted.prototype.render = function render() {
	    var rolesPerSchool = this.props.user.rolesPerSchool;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var role = rolesPerSchool[schoolId];
	    var _props = this.props,
	        by = _props.by,
	        except = _props.except;
	
	
	    var children = void 0;
	    if (Array.isArray(this.props.children)) {
	      children = this.props.children[0];
	    } else {
	      children = this.props.children;
	    }
	
	    if (by == 'disable' && except.indexOf(role) == -1) {
	      children = _react2.default.cloneElement(children, { disabled: true });
	      return _react.Children.only(children);
	    }
	
	    if (by == 'hide' && except.indexOf(role) == -1) {
	      return _react2.default.createElement('span', null);
	    }
	
	    return children;
	  };
	
	  return Restricted;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Restricted);
	module.exports = exports['default'];

/***/ },

/***/ "Jq3S":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = unlinkPoster;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _updatePoster = __webpack_require__("xsdH");
	
	var _updatePoster2 = _interopRequireDefault(_updatePoster);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function unlinkPoster(posterId) {
	
	  if (!posterId) {
	    throw new Error('Missing posterId');
	  }
	
	  return (0, _updatePoster2.default)(posterId, {
	    state: "closed"
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "TOyY":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = deletePoster;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deletePoster(posterId) {
	
	  if (!posterId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing poster ID')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/u_poster/" + posterId + "/",
	      'method': 'DELETE',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "G2NP":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _ContactInfo = __webpack_require__("zoTr");
	
	var _ContactInfo2 = _interopRequireDefault(_ContactInfo);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - This goes into <td> of "student" column and display
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *   an avatar, student's name and age
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent Table (but passed by student-table-field)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	//
	
	
	var MALE_IMG = __webpack_require__("X56S");
	var FEMALE_IMG = __webpack_require__("Irbd");
	var NEUTRAL_IMG = __webpack_require__("bReY");
	
	var ClientInfoTD = function (_React$Component) {
		_inherits(ClientInfoTD, _React$Component);
	
		function ClientInfoTD(props) {
			_classCallCheck(this, ClientInfoTD);
	
			return _possibleConstructorReturn(this, _React$Component.call(this, props));
		}
	
		ClientInfoTD.prototype.render = function render() {
			var _props = this.props,
			    client = _props.client,
			    fetchClientList = _props.fetchClientList;
			var name = client.name,
			    gender = client.gender,
			    contact_id = client.contact_id;
	
	
			var image = void 0;
			if (gender == 0) {
				image = 'url(' + MALE_IMG + ')';
			} else if (gender == 1) {
				image = 'url(' + FEMALE_IMG + ')';
			} else if (gender == 3) {
				image = 'url(' + NEUTRAL_IMG + ')';
			}
	
			return _react2.default.createElement(
				'div',
				{ className: 'client-info-container' },
				_react2.default.createElement('div', { className: 'portrait', style: {
						backgroundImage: image
					} }),
				_react2.default.createElement(
					'div',
					{ className: 'text-container' },
					_react2.default.createElement(
						'div',
						{ className: 'name' },
						_react2.default.createElement(
							_R2.default,
							{ can: 'read_contact_detail', by: 'disable' },
							_react2.default.createElement(
								'button',
								{ className: 'btn-link', style: { cursor: 'pointer' },
									onClick: function onClick() {
										(0, _ContactInfo2.default)({ id: contact_id, name: name }).then(function (res) {
											fetchClientList();
										});
									} },
								name
							)
						)
					)
				)
			);
		};
	
		return ClientInfoTD;
	}(_react2.default.Component);
	
	exports.default = ClientInfoTD;
	module.exports = exports['default'];

/***/ },

/***/ "PETx":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"potential-client-container":"potential-client-container","setting-dropdown":"setting-dropdown","dropdown-menu":"dropdown-menu","pc-header":"pc-header","pc-settings":"pc-settings","col-xs-3":"col-xs-3","client-dropdown":"client-dropdown","portrait":"portrait","name":"name","client-info-container":"client-info-container","name-search":"name-search","Select--single":"Select--single","tags-field-content":"tags-field-content","tags-field-header":"tags-field-header","tags-field-title":"tags-field-title","tags-field-container":"tags-field-container","icon-align-right":"icon-align-right","tag-container":"tag-container","control":"control","client-tag-TD":"client-tag-TD","tags":"tags"};

/***/ },

/***/ "Pn1/":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagListTD = function (_React$Component) {
			_inherits(TagListTD, _React$Component);
	
			function TagListTD(props) {
					_classCallCheck(this, TagListTD);
	
					return _possibleConstructorReturn(this, _React$Component.call(this, props));
			}
	
			TagListTD.prototype.render = function render() {
					var client = this.props.client;
					var tag_name_list = client.tag_name_list;
	
	
					return _react2.default.createElement(
							'div',
							{ className: 'client-tag-TD' },
							tag_name_list.map(function (tag) {
									return _react2.default.createElement(
											'span',
											{ key: tag, className: 'tags' },
											tag
									);
							})
					);
			};
	
			return TagListTD;
	}(_react2.default.Component);
	
	exports.default = TagListTD;
	module.exports = exports['default'];

/***/ },

/***/ "ITiw":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("aKPj");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _R = __webpack_require__("nRUD");
	
	__webpack_require__("PETx");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagsField = function (_Component) {
	  _inherits(TagsField, _Component);
	
	  function TagsField(props) {
	    _classCallCheck(this, TagsField);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      toggledEdit: {},
	      name: ''
	    };
	
	    _this.toggledEdit = _this.toggledEdit.bind(_this);
	    return _this;
	  }
	
	  TagsField.prototype.toggledEdit = function toggledEdit(key, name) {
	    var _this2 = this;
	
	    return function () {
	      if ((0, _R.userCan)('edit_contact_tag')) {
	        var _toggledEdit;
	
	        _this2.setState({
	          toggledEdit: (_toggledEdit = {}, _toggledEdit[key] = _this2.state.toggledEdit[key] !== true, _toggledEdit),
	          name: name
	        });
	      }
	    };
	  };
	
	  TagsField.prototype.render = function render() {
	    var _this3 = this;
	
	    if (!this.props.tagList) {
	      return _react2.default.createElement('div', null);
	    }
	
	    var _props = this.props,
	        tagList = _props.tagList,
	        tag_id_list = _props.tag_id_list;
	    var _state = this.state,
	        toggledEdit = _state.toggledEdit,
	        name = _state.name;
	
	
	    var tags = [];
	    tagList.map(function (tag) {
	      tags.push({ id: tag.name, text: tag.name, tagId: tag.id });
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'tags-field-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'tags-field-header' },
	        _react2.default.createElement(
	          'span',
	          { className: 'tags-field-title' },
	          __('Tags Filter', _locale2.default)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'tags-field-container' },
	        tags.map(function (tag, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'tag-container', key: tag.tagId },
	            toggledEdit[tag.tagId] !== true && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'control' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  value: tag.tagId,
	                  checked: tag_id_list.indexOf(tag.tagId) > -1,
	                  onClick: function onClick(event) {
	                    return _this3.props.onTagChange(event, tag.tagId);
	                  }
	                }),
	                _react2.default.createElement('span', { className: 'checkmark' }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  tag.text
	                )
	              ),
	              _react2.default.createElement('i', { className: 'fa icon-trash pull-right ' + ((0, _R.userCan)('edit_contact_tag') ? '' : 'disabled'), onClick: function onClick() {
	                  if ((0, _R.userCan)('edit_contact_tag')) {
	                    (0, _confirm.confirm)(__('Proceed to delete tag?', _locale2.default)).then(function () {
	                      _this3.props.deleteTag(index, tag.tagId, tag.text);
	                    }).catch(function () {});
	                  }
	                } }),
	              _react2.default.createElement('i', { className: 'fa icon-cog pull-right ' + ((0, _R.userCan)('edit_contact_tag') ? '' : 'disabled'), onClick: _this3.toggledEdit(tag.tagId, tag.text) })
	            ),
	            toggledEdit[tag.tagId] == true && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('input', { className: 'form-control', value: name, style: { width: '80%', display: 'inline-block' }, onChange: function onChange(e) {
	                  _this3.setState({ name: e.target.value });
	                } }),
	              _react2.default.createElement('i', { className: 'fa icon-ok pull-right', style: { lineHeight: '30px' }, onClick: function onClick() {
	                  _this3.props.editTag(index, tag.tagId, tag.text, { tag_name: name }, _this3.toggledEdit(tag.tagId));
	                } }),
	              _react2.default.createElement('i', { className: 'fa icon-cancel pull-right', style: { lineHeight: '30px' }, onClick: _this3.toggledEdit(tag.tagId, tag.text) })
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return TagsField;
	}(_react.Component);
	
	exports.default = TagsField;
	module.exports = exports['default'];

/***/ },

/***/ "aKPj":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
			id: "potentialClientTable",
			code: "CN",
			text: {
					'Contacts': '联系人',
					'New Contact': '新增联系人',
					'Name': '学员',
					'Age': '年龄',
					'Guardian Name': '家长姓名',
					'Contact Number': '联系电话',
					'Tags': '标签',
					'Tags Filter': '标签过滤',
					'Edit Contact': '编辑联系人',
					'Add Class': '加入班级',
					'Transfer to student': '转为学员',
					'Delete': '删除',
					'You are over the student limit, please upgrade to premium version': '您目前的学员上限为50个学员, 添加更多学员请升级为高级版',
					'Search contacts': '搜索联系人',
					'Proceed to delete contact: {client}?': '您确认要删除联系人 {client} 吗？',
					'Delete Contact': '删除联系人',
					'Proceed to transfer to student?': '确认转为学员？',
					'Proceed to delete tag?': '确认要删除标签吗？',
					'Contact Custom Fields': '联系人自定义字段'
			}
	};
	module.exports = exports["default"];

/***/ },

/***/ "EjrW":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var locale = {
	  id: 'PotentialClientConstant',
	  code: 'CN',
	  text: {
	    "./images/potential-en.png": "./images/potential-cn.png",
	    'Never Miss Any New Contact': '不再错过每一位联系人',
	    'ClassTopBase can help you record every potential client, you can easily track them, no need to worry about missing anyone.': 'ClassTopBase 可以帮您记录每一位潜在用户，方便您对潜在用户进行追踪，不错过任何一位。'
	  }
	};
	
	var onBoardingContents = exports.onBoardingContents = {
	  title: __('Never Miss Any New Contact', locale),
	  text: __('ClassTopBase can help you record every potential client, you can easily track them, no need to worry about missing anyone.', locale),
	  image: __webpack_require__(18)(__('./images/potential-en.png', locale)),
	  showArrow: true
	};

/***/ },

/***/ 18:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./ClientInfoTD": "G2NP",
		"./ClientInfoTD.js": "G2NP",
		"./PotentialClient.scss": "PETx",
		"./TagListTD": "Pn1/",
		"./TagListTD.js": "Pn1/",
		"./TagsField": "ITiw",
		"./TagsField.js": "ITiw",
		"./constant": "EjrW",
		"./constant.js": "EjrW",
		"./ducks": "tCuI",
		"./ducks.js": "tCuI",
		"./images/potential-cn.png": "bhhv",
		"./images/potential-en.png": "EoL8",
		"./index": "Fltp",
		"./index.js": "Fltp",
		"./locale": "aKPj",
		"./locale.js": "aKPj",
		"./table-fields": "kugd",
		"./table-fields.js": "kugd",
		"./table-settings": "WcKJ",
		"./table-settings.js": "WcKJ"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 18;


/***/ },

/***/ "bhhv":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "potential-cn.53491011.png";

/***/ },

/***/ "EoL8":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "potential-en.aab431af.png";

/***/ },

/***/ "Fltp":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _reactRedux = __webpack_require__("4n+p");
	
	__webpack_require__("PETx");
	
	var _UI = __webpack_require__("OM1Z");
	
	var _locale = __webpack_require__("aKPj");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _tableSettings = __webpack_require__("WcKJ");
	
	var _tableSettings2 = _interopRequireDefault(_tableSettings);
	
	var _tableFields = __webpack_require__("kugd");
	
	var _tableFields2 = _interopRequireDefault(_tableFields);
	
	var _TagsField = __webpack_require__("ITiw");
	
	var _TagsField2 = _interopRequireDefault(_TagsField);
	
	var _PotentialClient = __webpack_require__("r8r1");
	
	var _PotentialClient2 = _interopRequireDefault(_PotentialClient);
	
	var _ducks = __webpack_require__("tCuI");
	
	var _searchByTag = __webpack_require__("rXDo");
	
	var _searchByTag2 = _interopRequireDefault(_searchByTag);
	
	var _OnBoardingNatural = __webpack_require__("PwUp");
	
	var _OnBoardingNatural2 = _interopRequireDefault(_OnBoardingNatural);
	
	var _constant = __webpack_require__("EjrW");
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _reactBootstrap = __webpack_require__("3kvR");
	
	var _FilterBy = __webpack_require__("SdD8");
	
	var _FilterBy2 = _interopRequireDefault(_FilterBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    clientList: state.clientList
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchClientList: function fetchClientList(obj) {
	      return dispatch((0, _ducks.fetchClientList)(obj));
	    },
	    deleteClientTag: function deleteClientTag(index, tagId, tagName) {
	      return dispatch((0, _ducks.deleteClientTag)(index, tagId, tagName));
	    },
	    editClientTag: function editClientTag(index, tagId, oldTagName, tagName, callback) {
	      return dispatch((0, _ducks.editClientTag)(index, tagId, oldTagName, tagName, callback));
	    }
	  };
	};
	var FILTERS = ['text:searchKeyword'];
	var FILTER_OPTIONS = {
	  'text:searchKeyword': {
	    placeholder: __('Search contacts', _locale2.default),
	    valueMinLength: 2
	  }
	};
	
	var PotentialClient = function (_Component) {
	  _inherits(PotentialClient, _Component);
	
	  function PotentialClient(props) {
	    _classCallCheck(this, PotentialClient);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      list: [],
	      tag_id_list: [],
	      options: [],
	      selectedOption: '',
	      pagination: {
	        itemsCountPerPage: 25,
	        activePage: 1,
	        totalItemsCount: 0
	      },
	      keyword: '',
	      filterData: {}
	    };
	
	    _this.onTagChange = _this.onTagChange.bind(_this);
	    _this.fetchClientList = _this.fetchClientList.bind(_this);
	    _this.onItemsCountPerPageChange = _this.onItemsCountPerPageChange.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.onFilterChange = _this.onFilterChange.bind(_this);
	    return _this;
	  }
	
	  PotentialClient.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _state = this.state,
	        tag_id_list = _state.tag_id_list,
	        pagination = _state.pagination;
	    var activePage = pagination.activePage,
	        itemsCountPerPage = pagination.itemsCountPerPage;
	
	    if (tag_id_list.length == 0) {
	      this.fetchClientList();
	    } else {
	      (0, _searchByTag2.default)(schoolId, { student_state: 'not_transfer', tag_id_list: tag_id_list, amount_per_page: itemsCountPerPage, page_number: activePage }).then(function (res) {
	        _this2.setState({
	          list: res.result_list,
	          pagination: {
	            itemsCountPerPage: itemsCountPerPage,
	            activePage: res.current_page_number,
	            totalItemsCount: res.total_amount
	          }
	        });
	      });
	    }
	  };
	
	  PotentialClient.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var clientList = _ref.clientList;
	
	    if (this.state.list !== clientList.list) {
	      this.setState({ list: clientList.list, pagination: clientList.pagination });
	    }
	    if (this.state.pagination !== clientList.pagination) {
	      this.setState({ pagination: clientList.pagination });
	    }
	  };
	
	  PotentialClient.prototype.fetchClientList = function fetchClientList() {
	    var _state2 = this.state,
	        pagination = _state2.pagination,
	        keyword = _state2.keyword;
	    var activePage = pagination.activePage,
	        itemsCountPerPage = pagination.itemsCountPerPage;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    this.props.fetchClientList({
	      schoolId: schoolId,
	      student_state: 'notTransfer',
	      amount_per_page: itemsCountPerPage,
	      page_number: activePage,
	      keyword: keyword
	    });
	  };
	
	  PotentialClient.prototype.onFilterChange = function onFilterChange(_ref2) {
	    var _this3 = this;
	
	    var filterData = _ref2.filterData;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _state3 = this.state,
	        tag_id_list = _state3.tag_id_list,
	        pagination = _state3.pagination;
	    var itemsCountPerPage = pagination.itemsCountPerPage;
	
	
	    this.setState(function (prevState) {
	      return {
	        pagination: _extends({}, prevState.pagination, { activePage: 1 }),
	        filterData: filterData,
	        keyword: filterData['searchKeyword'],
	        tag_id_list: []
	      };
	    }, function () {
	      _this3.fetchClientList();
	    });
	  };
	
	  PotentialClient.prototype.onTagChange = function onTagChange(event, tagId) {
	    var _this4 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _state4 = this.state,
	        tag_id_list = _state4.tag_id_list,
	        pagination = _state4.pagination;
	    var activePage = pagination.activePage,
	        itemsCountPerPage = pagination.itemsCountPerPage;
	
	    this.setState({
	      filterData: _extends({}, this.state.filterData, {
	        searchKeyword: ''
	      }),
	      keyword: ''
	    });
	    if (event.target.checked) {
	      this.setState({
	        tag_id_list: tag_id_list.concat([tagId])
	      }, function () {
	        (0, _searchByTag2.default)(schoolId, { student_state: 'not_transfer', tag_id_list: _this4.state.tag_id_list, amount_per_page: itemsCountPerPage, page_number: activePage }).then(function (res) {
	          _this4.setState({
	            list: res.result_list,
	            pagination: {
	              itemsCountPerPage: itemsCountPerPage,
	              activePage: res.current_page_number,
	              totalItemsCount: res.total_amount
	            }
	          });
	        });
	      });
	    } else {
	      this.setState({
	        tag_id_list: tag_id_list.filter(function (val) {
	          return val !== tagId;
	        })
	      }, function () {
	        if (_this4.state.tag_id_list.length == 0) {
	          _this4.fetchClientList();
	        } else {
	          (0, _searchByTag2.default)(schoolId, { student_state: 'not_transfer', tag_id_list: _this4.state.tag_id_list, amount_per_page: itemsCountPerPage, page_number: activePage }).then(function (res) {
	            _this4.setState({
	              list: res.result_list,
	              pagination: {
	                itemsCountPerPage: itemsCountPerPage,
	                activePage: res.current_page_number,
	                totalItemsCount: res.total_amount
	              }
	            });
	          });
	        }
	      });
	    }
	  };
	
	  PotentialClient.prototype.onItemsCountPerPageChange = function onItemsCountPerPageChange(itemsCountPerPage) {
	    var _this5 = this;
	
	    var _state5 = this.state,
	        tag_id_list = _state5.tag_id_list,
	        pagination = _state5.pagination;
	    var activePage = pagination.activePage;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    this.setState(function (prevState) {
	      return {
	        pagination: _extends({}, prevState.pagination, { itemsCountPerPage: itemsCountPerPage })
	      };
	    }, function () {
	      if (tag_id_list.length === 0) {
	        _this5.fetchClientList();
	      } else {
	        (0, _searchByTag2.default)(schoolId, { student_state: 'not_transfer', tag_id_list: tag_id_list, amount_per_page: itemsCountPerPage, page_number: activePage }).then(function (res) {
	          _this5.setState({
	            list: res.result_list,
	            pagination: {
	              itemsCountPerPage: itemsCountPerPage,
	              activePage: res.current_page_number,
	              totalItemsCount: res.total_amount
	            }
	          });
	        });
	      }
	    });
	  };
	
	  PotentialClient.prototype.onPageChange = function onPageChange(activePage) {
	    var _this6 = this;
	
	    var _state6 = this.state,
	        pagination = _state6.pagination,
	        tag_id_list = _state6.tag_id_list;
	    var itemsCountPerPage = pagination.itemsCountPerPage;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    if (activePage !== pagination.activePage) {
	      this.setState(function (prevState) {
	        return {
	          pagination: _extends({}, prevState.pagination, { activePage: activePage })
	        };
	      }, function () {
	        if (tag_id_list.length === 0) {
	          _this6.fetchClientList();
	        } else {
	          (0, _searchByTag2.default)(schoolId, { student_state: 'not_transfer', tag_id_list: tag_id_list, amount_per_page: itemsCountPerPage, page_number: activePage }).then(function (res) {
	            _this6.setState({
	              list: res.result_list,
	              pagination: {
	                itemsCountPerPage: itemsCountPerPage,
	                activePage: res.current_page_number,
	                totalItemsCount: res.total_amount
	              }
	            });
	          });
	        }
	      });
	    }
	  };
	
	  PotentialClient.prototype.render = function render() {
	    var _this7 = this;
	
	    var clientList = this.props.clientList;
	    var tag_list = clientList.tag_list,
	        hasPermission = clientList.hasPermission,
	        school_has_contact = clientList.school_has_contact,
	        fetching = clientList.fetching;
	    var _state7 = this.state,
	        list = _state7.list,
	        tag_id_list = _state7.tag_id_list,
	        pagination = _state7.pagination,
	        filterData = _state7.filterData;
	
	    var content = _constant.onBoardingContents || {};
	    this.studentFields = _tableFields2.default.call(this);
	    this.tableSettings = _tableSettings2.default.call(this);
	
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      { className: 'potential-client-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'pc-header' },
	        _react2.default.createElement(
	          'div',
	          { className: 'pc-title' },
	          __('Contacts', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pc-settings' },
	          _react2.default.createElement(_FilterBy2.default, {
	            filterData: filterData,
	            filters: FILTERS,
	            options: FILTER_OPTIONS,
	            onChange: this.onFilterChange }),
	          _react2.default.createElement(
	            _R2.default,
	            { can: 'create_contact', by: 'disable' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary pull-right',
	                onClick: function onClick() {
	                  (0, _PotentialClient2.default)({ type: 'create' }).then(function (res) {
	                    _this7.fetchClientList();
	                  });
	                } },
	              _react2.default.createElement('i', { className: 'fa icon-plus' }),
	              __('New Contact', _locale2.default)
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Dropdown,
	            { id: 'setting-dropdown', className: 'pull-right' },
	            _react2.default.createElement(
	              _reactBootstrap.Dropdown.Toggle,
	              { className: 'expand-to-right expand-to-down' },
	              _react2.default.createElement('i', { className: 'fa icon-cog', style: { marginRight: 5 } })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Dropdown.Menu,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.MenuItem,
	                { eventKey: 'contact-settings', onSelect: function onSelect() {
	                    _reactRouter.browserHistory.push('/contact-settings');
	                  }, disabled: !(0, _R.userCan)('edit_contact_custom_field') },
	                __('Contact Custom Fields', _locale2.default)
	              )
	            )
	          )
	        )
	      ),
	      (school_has_contact == false && content || hasPermission == false) && _react2.default.createElement(_OnBoardingNatural2.default, {
	        isShown: true,
	        title: content.title,
	        text: content.text,
	        image: content.image,
	        showArrow: content.showArrow
	      }),
	      (school_has_contact || !hasPermission) && _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-9' },
	          _react2.default.createElement(_UI.Table, {
	            data: list,
	            fields: this.studentFields,
	            settings: this.tableSettings,
	            fetching: fetching,
	            className: 'potential-client-table',
	            settingThTitle: ' ',
	            settingWidth: '100px',
	            oneSettingPerRow: false,
	            hideDropdownCaret: false,
	            pagination: pagination,
	            usePagination: true,
	            onPageChange: this.onPageChange,
	            onItemsCountPerPageChange: this.onItemsCountPerPageChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-3' },
	          _react2.default.createElement(_TagsField2.default, {
	            tagList: tag_list,
	            onTagChange: this.onTagChange,
	            tag_id_list: tag_id_list,
	            deleteTag: this.props.deleteClientTag,
	            editTag: this.props.editClientTag
	          })
	        )
	      )
	    );
	  };
	
	  return PotentialClient;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PotentialClient);
	module.exports = exports['default'];

/***/ },

/***/ "WcKJ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  return getDefaultTableSettings.call(this);
	};
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	var _locale = __webpack_require__("aKPj");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _PotentialClient = __webpack_require__("r8r1");
	
	var _PotentialClient2 = _interopRequireDefault(_PotentialClient);
	
	var _transferToStudent = __webpack_require__("70Tr");
	
	var _transferToStudent2 = _interopRequireDefault(_transferToStudent);
	
	var _deleteClient = __webpack_require__("eeWk");
	
	var _deleteClient2 = _interopRequireDefault(_deleteClient);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDefaultTableSettings() {
	  var _this = this;
	
	  var schoolId = localStorage.getItem('schoolId');
	  var _state = this.state,
	      keyword = _state.keyword,
	      pagination = _state.pagination;
	  var itemsCountPerPage = pagination.itemsCountPerPage;
	
	
	  var dropdown = [{
	    title: __("Edit Contact", _locale2.default),
	    onClick: function onClick(_ref) {
	      var client = _ref.trData;
	
	      (0, _PotentialClient2.default)({ clientId: client.contact_id, type: 'edit', pagination: pagination, keyword: keyword }).then(function (res) {
	        _this.props.fetchClientList({
	          schoolId: schoolId,
	          student_state: 'notTransfer',
	          amount_per_page: itemsCountPerPage,
	          page_number: 1,
	          keyword: keyword
	        });
	      });
	    },
	    isDisabled: function isDisabled(opts) {
	      return !(0, _R.userCan)('edit_contact');
	    }
	  }, {
	    title: __("Transfer to student", _locale2.default),
	    onClick: function onClick(_ref2) {
	      var client = _ref2.trData;
	
	      (0, _confirm.confirm)(__('Proceed to transfer to student?', _locale2.default), __("Transfer to student", _locale2.default)).then(function (res) {
	        (0, _transferToStudent2.default)(client.contact_id, { student_state: 'transferred' }).then(function (res) {
	          if (res.result == 'success') {
	            _this.props.fetchClientList({
	              schoolId: schoolId,
	              student_state: 'notTransfer',
	              amount_per_page: itemsCountPerPage,
	              page_number: 1,
	              keyword: keyword
	            });
	          } else if (res.result == 'failure' && res.reason == 'need to upgrade to higher SaaS version.') {
	            _alert.alert.warning(__('You are about go over the student limit, please upgrade to higher subscription plan to add more students', 'header'));
	          }
	        });
	      }).catch(function () {});
	    },
	    isDisabled: function isDisabled(opts) {
	      return !(0, _R.userCan)('convert_contact_to_student');
	    }
	  }, {
	    title: __("Delete", _locale2.default),
	    onClick: function onClick(_ref3) {
	      var client = _ref3.trData;
	
	      (0, _confirm.confirm)(__('Proceed to delete contact: {client}?', _locale2.default, { client: client.name }), __('Delete Contact', _locale2.default)).then(function () {
	        (0, _deleteClient2.default)(client.contact_id).then(function (res) {
	          if (res.result == 'success') {
	            _this.props.fetchClientList({
	              schoolId: schoolId,
	              student_state: 'notTransfer',
	              amount_per_page: itemsCountPerPage,
	              page_number: 1,
	              keyword: keyword
	            });
	          }
	        });
	      }).catch(function () {});
	    },
	    isDisabled: function isDisabled(opts) {
	      return !(0, _R.userCan)('edit_contact');
	    }
	  }];
	
	  return [{
	    title: __('Options', 'teacher'),
	    id: "client-dropdown",
	    dropdown: dropdown
	  }];
	}
	module.exports = exports['default'];

/***/ },

/***/ "70Tr":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = transferToStudent;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STUDENT_STATE = ['not_transfer', 'transferred'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  "student_state": _joiBrowser2.default.string().valid(STUDENT_STATE).required()
	
	});
	
	function transferToStudent(clientId, clientInfo) {
	
	  if (!clientId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing client Id')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(clientInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, clientInfo, {
	    student_state: STUDENT_STATE.indexOf(clientInfo.student_state)
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/contact_to_customer/" + clientId + "/",
	      'method': 'POST',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "eeWk":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = deleteClient;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deleteClient(clientId) {
	
	  if (!clientId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing client Id')
	      });
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/contact_detail/" + clientId + "/",
	      'method': 'DELETE',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "kugd":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  return getDefaultTableFields.call(this);
	};
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	var _locale = __webpack_require__("aKPj");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _ClientInfoTD = __webpack_require__("G2NP");
	
	var _ClientInfoTD2 = _interopRequireDefault(_ClientInfoTD);
	
	var _TagListTD = __webpack_require__("Pn1/");
	
	var _TagListTD2 = _interopRequireDefault(_TagListTD);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDefaultTableFields() {
	  var _this = this;
	
	  var TabComponent = this;
	  var dispatch = this.props.dispatch;
	
	
	  return [{
	    name: 'name',
	    title: __('Name', _locale2.default),
	    getTdProps: function getTdProps(_ref) {
	      var tbodyData = _ref.tbodyData;
	
	      return {
	        style: { width: "27%" }
	      };
	    },
	    getTdContent: function getTdContent(_ref2) {
	      var data = _ref2.trData;
	
	      return _react2.default.createElement(_ClientInfoTD2.default, { client: data, fetchClientList: _this.fetchClientList });
	    }
	  }, {
	    name: 'age',
	    title: __('Age', _locale2.default),
	    getTdProps: function getTdProps(_ref3) {
	      var tbodyData = _ref3.tbodyData;
	
	      return {
	        style: { width: "7%" }
	      };
	    }
	  }, {
	    name: 'mobile',
	    title: __('Contact Number', _locale2.default),
	    getTdProps: function getTdProps(_ref4) {
	      var tbodyData = _ref4.tbodyData;
	
	      return {
	        style: { width: "15%" }
	      };
	    }
	  }, {
	    name: 'guardian_name',
	    title: __('Guardian Name', _locale2.default),
	    getTdProps: function getTdProps(_ref5) {
	      var tbodyData = _ref5.tbodyData;
	
	      return {
	        style: { width: "15%" }
	      };
	    }
	  }, {
	    name: 'tag_name_list',
	    title: __('Tags', _locale2.default),
	    getTdProps: function getTdProps(_ref6) {
	      var tbodyData = _ref6.tbodyData;
	
	      return {
	        style: { width: "27%" }
	      };
	    },
	    getTdContent: function getTdContent(_ref7) {
	      var data = _ref7.trData;
	
	      return _react2.default.createElement(_TagListTD2.default, { client: data });
	    }
	  }];
	}
	module.exports = exports["default"];

/***/ },

/***/ "rXDo":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = searchByTag;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STUDENT_STATE = ['not_transfer', 'transferred'];
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  "student_state": _joiBrowser2.default.string().valid(STUDENT_STATE).required(),
	  "tag_id_list": _joiBrowser2.default.array().required(),
	  "amount_per_page": _joiBrowser2.default.number().integer().required(),
	  "page_number": _joiBrowser2.default.number().integer().required()
	});
	
	function searchByTag(schoolId, clientInfo) {
	
	  if (!schoolId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing school Id')
	      });
	    });
	  }
	
	  var validateResult = _joiBrowser2.default.validate(clientInfo, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  var toServer = _extends({}, clientInfo, {
	    student_state: STUDENT_STATE.indexOf(clientInfo.student_state)
	  });
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': "/contact_tag_filter/" + schoolId + "/",
	      'method': 'POST',
	      'data': JSON.stringify(toServer),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "4UYp":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <BasicInfo	/>
	                    *
	                    *
	                    * @parent anybody
	                    * @children 
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _basicInfoFields = __webpack_require__("Nbbr");
	
	var _basicInfoFields2 = _interopRequireDefault(_basicInfoFields);
	
	var _FieldItem = __webpack_require__("3NyY");
	
	var _FieldItem2 = _interopRequireDefault(_FieldItem);
	
	var _Panel = __webpack_require__("6jUu");
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _locale = __webpack_require__("NTCD");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BasicInfo = (_temp = _class = function (_React$Component) {
	  _inherits(BasicInfo, _React$Component);
	
	  function BasicInfo(props) {
	    _classCallCheck(this, BasicInfo);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  BasicInfo.prototype.componentWillMount = function componentWillMount() {};
	
	  BasicInfo.prototype.render = function render() {
	    var FieldItems = [];
	
	    _basicInfoFields2.default.map(function (field, index) {
	      var label = field.label,
	          required = field.required,
	          isSettingItem = field.isSettingItem;
	
	      if (isSettingItem) {
	        FieldItems.push(_react2.default.createElement(_FieldItem2.default, { key: index,
	          label: label,
	          required: required
	        }));
	      }
	    });
	
	    return _react2.default.createElement(
	      _Panel2.default,
	      { title: __('Basic Info', _locale2.default) },
	      _react2.default.createElement(
	        'div',
	        { className: 'basic-info' },
	        FieldItems
	      )
	    );
	  };
	
	  return BasicInfo;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = BasicInfo;
	module.exports = exports['default'];

/***/ },

/***/ "Nbbr":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _locale = __webpack_require__("NTCD");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	  label: __('First Name', _locale2.default),
	  name: 'firstName',
	  required: true,
	  isImportField: true
	}, {
	  label: __('Last Name', _locale2.default),
	  name: 'lastName',
	  required: true,
	  isImportField: true
	}, {
	  label: __('Name', _locale2.default),
	  required: true,
	  isSettingItem: true
	}, {
	  label: __('Gender', _locale2.default),
	  name: 'gender',
	  required: true,
	  isImportField: true,
	  isSettingItem: true
	}, {
	  label: __('DOB', _locale2.default),
	  name: 'dob',
	  isImportField: true,
	  isSettingItem: true
	}, {
	  label: __('Contact Number', _locale2.default),
	  name: 'phone',
	  isImportField: true,
	  isSettingItem: true
	}, {
	  label: __('Tag', _locale2.default),
	  name: 'tag',
	  isImportField: true,
	  isSettingItem: true
	}, {
	  label: __('Parent Name', _locale2.default),
	  name: 'email',
	  isImportField: true,
	  isSettingItem: true
	}, {
	  label: __('Remark', _locale2.default),
	  name: 'remark',
	  isImportField: true,
	  isSettingItem: true
	}];
	module.exports = exports['default'];

/***/ },

/***/ "NTCD":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
	  id: "StudentSettings",
	  code: "CN",
	  text: {
	    'Student': '学员',
	    'Input Fields Setting': '学生报名信息设置',
	    'Basic Info': '基本信息',
	    'Name': '学员姓名',
	    'Last Name': '学员姓',
	    'First Name': '学员名',
	    'Gender': '学员性别',
	    'DOB': '学员生日',
	    'Contact Number': '联系电话',
	    'Tag': '标签',
	    'Parent Name': '家长姓名',
	    'Remark': '备注',
	    'Save': '保存',
	    'Contact': '联系人',
	    'Contact Custom Fields': '联系人自定义字段'
	  }
	};
	module.exports = exports["default"];

/***/ },

/***/ "3NyY":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp; /**
	                    * <FieldItem />
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("Ci3R");
	
	var _locale = __webpack_require__("Si1/");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _FieldEditor = __webpack_require__("OVGT");
	
	var _FieldEditor2 = _interopRequireDefault(_FieldEditor);
	
	var _reactSortable = __webpack_require__("XNaT");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DragDots = _react2.default.createElement(
	  'svg',
	  { viewBox: '0 0 32 32' },
	  _react2.default.createElement('rect', { height: '4', width: '4', y: '4', x: '0' }),
	  _react2.default.createElement('rect', { height: '4', width: '4', y: '12', x: '0' }),
	  _react2.default.createElement('rect', { height: '4', width: '4', y: '20', x: '0' }),
	  _react2.default.createElement('rect', { height: '4', width: '4', y: '28', x: '0' }),
	  _react2.default.createElement('rect', { height: '4', width: '4', y: '4', x: '8' }),
	  _react2.default.createElement('rect', { height: '4', width: '4', y: '12', x: '8' }),
	  _react2.default.createElement('rect', { height: '4', width: '4', y: '20', x: '8' }),
	  _react2.default.createElement('rect', { height: '4', width: '4', y: '28', x: '8' })
	);
	
	var FieldItem = (_temp = _class = function (_React$Component) {
	  _inherits(FieldItem, _React$Component);
	
	  function FieldItem(props) {
	    _classCallCheck(this, FieldItem);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  FieldItem.prototype.componentWillMount = function componentWillMount() {};
	
	  FieldItem.prototype.render = function render() {
	    var _props = this.props,
	        movable = _props.movable,
	        editable = _props.editable,
	        toggleEdit = _props.toggleEdit,
	        onRemove = _props.onRemove,
	        onChange = _props.onChange,
	        isEditing = _props.isEditing,
	        index = _props.index,
	        options = _props.options,
	        type = _props.type,
	        label = _props.label,
	        required = _props.required,
	        isSortable = _props.isSortable,
	        onMouseDownOnBars = _props.onMouseDownOnBars,
	        onMouseUpOnBars = _props.onMouseUpOnBars,
	        saveField = _props.saveField;
	
	
	    return _react2.default.createElement(
	      'li',
	      _extends({ className: 'field-item-wrapper' }, this.props),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('field-item', { isSortable: isSortable }) },
	        isSortable && _react2.default.createElement(
	          'div',
	          { className: 'dragHandle', onMouseDown: onMouseDownOnBars },
	          DragDots
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'fieldLabelDisplay' },
	          label || __('New Field', _locale2.default)
	        ),
	        required && _react2.default.createElement(
	          'span',
	          { className: 'required' },
	          ' *'
	        ),
	        editable && _react2.default.createElement(
	          'span',
	          { className: 'controller' },
	          _react2.default.createElement('i', { className: 'fa icon-cancel', onClick: onRemove }),
	          _react2.default.createElement('i', { className: 'fa icon-cog', onClick: toggleEdit })
	        )
	      ),
	      isEditing && _react2.default.createElement(_FieldEditor2.default, {
	        index: index,
	        type: type,
	        label: label,
	        required: required,
	        onChange: onChange,
	        options: options,
	        saveField: saveField
	      })
	    );
	  };
	
	  return FieldItem;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = (0, _reactSortable.sortable)(FieldItem);
	module.exports = exports['default'];

/***/ },

/***/ "Ci3R":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"field-item-wrapper":"field-item-wrapper","field-item":"field-item","isSortable":"isSortable","dragHandle":"dragHandle","required":"required","icon-cancel":"icon-cancel","icon-cog":"icon-cog"};

/***/ },

/***/ "Si1/":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _text;
	
	exports.default = {
	  id: "StudentSettings",
	  code: "CN",
	  text: (_text = {
	    'Other Info': '其他信息',
	    'Add New': '添加',
	    'New Field': '新标题',
	    'Type': '类型',
	    'Label': '标题'
	  }, _text["New Field"] = '新标题', _text['Set As Required'] = '设为必填', _text['Options'] = '选项', _text['Add Option'] = '添加选项', _text['Text'] = '文本框', _text['Select One'] = '单选框', _text['Select Multiple'] = '复选框', _text['Remove Field'] = '删除框', _text['Are you sure you want to remove the field?'] = '你确定要删除此框？', _text['Save'] = '保存', _text)
	};
	module.exports = exports["default"];

/***/ },

/***/ "OVGT":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <FieldEditor
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _locale = __webpack_require__("Si1/");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _ReactSelect = __webpack_require__("Z40E");
	
	var _ReactSelect2 = _interopRequireDefault(_ReactSelect);
	
	__webpack_require__("gT3L");
	
	__webpack_require__("1mDL");
	
	var _includes = __webpack_require__("q+Dy");
	
	var _includes2 = _interopRequireDefault(_includes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TYPES = [{ value: 'text', label: __('Text', _locale2.default) }, { value: 'select', label: __('Select One', _locale2.default) }, { value: 'checkbox', label: __('Select Multiple', _locale2.default) }];
	
	var FieldEditor = (_temp = _class = function (_React$Component) {
	  _inherits(FieldEditor, _React$Component);
	
	  function FieldEditor(props) {
	    _classCallCheck(this, FieldEditor);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.addOption = _this.addOption.bind(_this);
	    _this.removeOption = _this.removeOption.bind(_this);
	    _this.onOptionChange = _this.onOptionChange.bind(_this);
	    _this.toggleRequired = _this.toggleRequired.bind(_this);
	    return _this;
	  }
	
	  FieldEditor.prototype.componentDidMount = function componentDidMount() {
	    var label = this.props.label;
	
	    if (label == '') {
	      this.fieldLabelElem.focus();
	    }
	  };
	
	  FieldEditor.prototype.onChange = function onChange(name, value) {
	    var _fieldValue;
	
	    var _props = this.props,
	        index = _props.index,
	        onChange = _props.onChange;
	
	
	    onChange({
	      index: index,
	      fieldValue: (_fieldValue = {}, _fieldValue[name] = value, _fieldValue)
	    });
	  };
	
	  FieldEditor.prototype.toggleRequired = function toggleRequired(e) {
	    var required = this.props.required;
	
	
	    this.onChange('required', required === false);
	  };
	
	  FieldEditor.prototype.addOption = function addOption() {
	    var options = this.props.options;
	
	
	    this.onChange('options', [].concat(options, ['']));
	  };
	
	  FieldEditor.prototype.removeOption = function removeOption(optionIndex) {
	    var _this2 = this;
	
	    return function () {
	      var options = _this2.props.options;
	
	      var newOptions = [].concat(options);
	
	      newOptions.splice(optionIndex, 1);
	
	      _this2.onChange('options', newOptions);
	    };
	  };
	
	  FieldEditor.prototype.onOptionChange = function onOptionChange(optionIndex) {
	    var _this3 = this;
	
	    return function (e) {
	      var newOptions = [].concat(_this3.props.options);
	      newOptions[optionIndex] = e.target.value;
	      _this3.onChange('options', newOptions);
	    };
	  };
	
	  FieldEditor.prototype.validateInput = function validateInput() {
	    var _props2 = this.props,
	        type = _props2.type,
	        label = _props2.label,
	        options = _props2.options;
	
	    if (label.length > 0) {
	      if ((type === 'checkbox' || type === 'select') && options.length === 0 || (0, _includes2.default)(options, '')) {
	        return true;
	      }
	      return false;
	    } else {
	      return true;
	    }
	  };
	
	  FieldEditor.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props3 = this.props,
	        index = _props3.index,
	        type = _props3.type,
	        label = _props3.label,
	        options = _props3.options,
	        required = _props3.required,
	        saveField = _props3.saveField;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'field-editor-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'field-editor' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            null,
	            __('Type', _locale2.default),
	            ':'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'fieldType' },
	            _react2.default.createElement(_ReactSelect2.default, { value: type, onChange: function onChange(value) {
	                _this4.onChange('type', value);
	              }, options: TYPES })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'fieldRequired' },
	            _react2.default.createElement(
	              'label',
	              { className: 'control' },
	              __('Set As Required', _locale2.default),
	              _react2.default.createElement('input', { type: 'checkbox', checked: required, onClick: this.toggleRequired }),
	              _react2.default.createElement('span', { className: 'checkmark' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            null,
	            __('Label', _locale2.default),
	            ':'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'fieldLabel' },
	            _react2.default.createElement('input', {
	              className: 'form-control',
	              ref: function ref(r) {
	                if (r) _this4.fieldLabelElem = r;
	              },
	              onChange: function onChange(e) {
	                _this4.onChange('label', e.target.value);
	              }, value: label, placeholder: __('New Field', _locale2.default)
	            })
	          )
	        ),
	        (type === 'checkbox' || type === 'select') && _react2.default.createElement(
	          'div',
	          { className: 'form-group elastic' },
	          _react2.default.createElement(
	            'label',
	            null,
	            __('Options', _locale2.default),
	            ':'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'fieldOptions' },
	            options.map(function (option, index) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'optionInput', key: index },
	                _react2.default.createElement('input', {
	                  value: options[index],
	                  className: 'form-control',
	                  onChange: _this4.onOptionChange(index),
	                  autoFocus: true
	                }),
	                _react2.default.createElement('i', { className: 'fa icon-cancel remove', onClick: _this4.removeOption(index) })
	              );
	            }),
	            _react2.default.createElement(
	              'a',
	              { onClick: this.addOption },
	              __('Add Option', _locale2.default)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary btn-sm', disabled: this.validateInput(), onClick: function onClick() {
	              saveField();
	            } },
	          __('Save', _locale2.default)
	        )
	      )
	    );
	  };
	
	  return FieldEditor;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = FieldEditor;
	module.exports = exports['default'];

/***/ },

/***/ "gT3L":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"field-editor-wrapper":"field-editor-wrapper","field-editor":"field-editor","form-group":"form-group","elastic":"elastic","Select":"Select","fieldLabel":"fieldLabel","fieldType":"fieldType","fieldRequired":"fieldRequired","checkmark":"checkmark","fieldOptions":"fieldOptions","optionInput":"optionInput","remove":"remove"};

/***/ },

/***/ "1mDL":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"locale-EN":"locale-EN","field-editor-wrapper":"field-editor-wrapper"};

/***/ },

/***/ "6jUu":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <Panel 
	                    *		// please describe props here
	                    *	/>
	                    *
	                    * - When there is a nesting tr, we use tbody as a row.
	                    *
	                    * @parent anybody
	                    * @children 
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("mgtn");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Panel = (_temp = _class = function (_React$Component) {
	  _inherits(Panel, _React$Component);
	
	  function Panel(props) {
	    _classCallCheck(this, Panel);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Panel.prototype.componentWillMount = function componentWillMount() {};
	
	  Panel.prototype.render = function render() {
	    var _props = this.props,
	        title = _props.title,
	        titleContent = _props.titleContent;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'classtop-panel' },
	      _react2.default.createElement(
	        'section',
	        { className: 'title-section' },
	        _react2.default.createElement(
	          'h5',
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'title-content' },
	          titleContent
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'content-section' },
	        this.props.children
	      )
	    );
	  };
	
	  return Panel;
	}(_react2.default.Component), _class.defaultProps = {
	  title: _react.PropTypes.string,
	  color: _react.PropTypes.string
	}, _temp);
	exports.default = Panel;
	module.exports = exports['default'];

/***/ },

/***/ "mgtn":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"classtop-panel":"classtop-panel","title-section":"title-section","btn":"btn","title-content":"title-content"};

/***/ },

/***/ "em7t":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"potential-client-settings":"potential-client-settings","classtop-panel":"classtop-panel","content-section":"content-section","bread-crumbs":"bread-crumbs"};

/***/ },

/***/ "TnzW":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp; /**
	                    * <StudentSettings />
	                    *
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PanelWrapper = __webpack_require__("VPji");
	
	var _PanelWrapper2 = _interopRequireDefault(_PanelWrapper);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _Panel = __webpack_require__("6jUu");
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _CustomField = __webpack_require__("CEBJ");
	
	var _CustomField2 = _interopRequireDefault(_CustomField);
	
	var _getClientCustomFields = __webpack_require__("083y");
	
	var _getClientCustomFields2 = _interopRequireDefault(_getClientCustomFields);
	
	var _updateClientCustomFields = __webpack_require__("BPz5");
	
	var _updateClientCustomFields2 = _interopRequireDefault(_updateClientCustomFields);
	
	var _BasicInfo = __webpack_require__("4UYp");
	
	var _BasicInfo2 = _interopRequireDefault(_BasicInfo);
	
	var _locale = __webpack_require__("NTCD");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("em7t");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StudentSettings = (_temp = _class = function (_React$Component) {
	  _inherits(StudentSettings, _React$Component);
	
	  function StudentSettings(props) {
	    _classCallCheck(this, StudentSettings);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      fetchingCustomField: false,
	      setting: {}
	    };
	    return _this;
	  }
	
	  StudentSettings.prototype.componentWillMount = function componentWillMount() {
	    this.fetchSetting();
	  };
	
	  StudentSettings.prototype.fetchSetting = function fetchSetting() {
	    var _this2 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    (0, _getClientCustomFields2.default)(schoolId).then(function (res) {
	      var setting = void 0;
	      if (res.contact_custom_fields && res.contact_custom_fields.fields) {
	        setting = _extends({}, res.contact_custom_fields);
	      } else {
	        setting = {
	          fields: []
	        };
	      }
	      _this2.setState({
	        setting: setting,
	        fetchingCustomField: false
	      });
	    });
	  };
	
	  StudentSettings.prototype.updateSetting = function updateSetting() {
	    var schoolId = localStorage.getItem('schoolId');
	    var toServer = this.state.setting;
	
	    (0, _updateClientCustomFields2.default)(schoolId, toServer).then(function (res) {});
	  };
	
	  StudentSettings.prototype.onChange = function onChange(opts) {
	
	    var newFields = this.state.setting.fields;
	
	    var index = opts.index,
	        fieldValue = opts.fieldValue;
	
	
	    newFields[index] = _extends({}, newFields[index], fieldValue);
	
	    this.setState({
	      setting: _extends({}, this.state.setting, {
	        fields: newFields
	      })
	    });
	  };
	
	  StudentSettings.prototype.updateField = function updateField(newFields) {
	    var _this3 = this;
	
	    this.setState({
	      setting: _extends({}, this.state.setting, {
	        fields: newFields
	      })
	    }, function () {
	      _this3.updateSetting();
	    });
	  };
	
	  StudentSettings.prototype.render = function render() {
	    var _this4 = this;
	
	    var _state = this.state,
	        setting = _state.setting,
	        fetchingCustomField = _state.fetchingCustomField;
	    var fields = setting.fields;
	
	    return _react2.default.createElement(
	      _PanelWrapper2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'potential-client-settings' },
	        _react2.default.createElement(
	          'div',
	          { className: 'bread-crumbs' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/contacts' },
	            __('Contact', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            ' / '
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            __('Contact Custom Fields', _locale2.default)
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { className: 'registration-table-close pull-right', to: '/contacts' },
	            _react2.default.createElement('i', { className: 'fa icon-cancel' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(_BasicInfo2.default, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(_CustomField2.default, {
	              fields: fields,
	              closeEditorsWhenAddNewItem: true,
	              isSortable: true //if it is able to drag and drop
	              , fetching: fetchingCustomField,
	              onChange: function onChange(opts) {
	                return _this4.onChange(opts);
	              },
	              updateField: function updateField(newFields) {
	                return _this4.updateField(newFields);
	              },
	              saveField: function saveField() {
	                return _this4.updateSetting();
	              }
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return StudentSettings;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = StudentSettings;
	module.exports = exports['default'];

/***/ },

/***/ "CEBJ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <CustomField />
	                    *
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    * 
	                    * fields format : [{
	                    *  id: number,
	                    *  type: can be either 'text' or 'checkbox' or 'select'
	                    *  label: string
	                    *  required: boolen,
	                    *  options: [string]
	                    * },]
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("Si1/");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _Panel = __webpack_require__("6jUu");
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _FieldItem = __webpack_require__("3NyY");
	
	var _FieldItem2 = _interopRequireDefault(_FieldItem);
	
	var _map = __webpack_require__("2247");
	
	var _map2 = _interopRequireDefault(_map);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _uniqid = __webpack_require__("2bpm");
	
	var _uniqid2 = _interopRequireDefault(_uniqid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomField = (_temp = _class = function (_React$Component) {
	  _inherits(CustomField, _React$Component);
	
	  function CustomField(props) {
	    _classCallCheck(this, CustomField);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onDragStart = _this.onDragStart.bind(_this);
	    _this.onDragEnd = _this.onDragEnd.bind(_this);
	    _this.onSort = _this.onSort.bind(_this);
	    _this.addFieldItem = _this.addFieldItem.bind(_this);
	    _this.removeFieldItem = _this.removeFieldItem.bind(_this);
	    _this.toggleFieldItemEditor = _this.toggleFieldItemEditor.bind(_this);
	
	    _this.state = {
	      toggledEditor: {},
	      draggableIndex: -1
	    };
	    return _this;
	  }
	
	  CustomField.prototype.addFieldItem = function addFieldItem() {
	    var _props = this.props,
	        closeEditorsWhenAddNewItem = _props.closeEditorsWhenAddNewItem,
	        updateField = _props.updateField;
	
	    var fields = this.props.fields;
	    var toggledEditor = this.state.toggledEditor;
	
	
	    if (closeEditorsWhenAddNewItem) {
	      toggledEditor = {};
	    }
	
	    toggledEditor[0] = true;
	
	    var newFields = [{
	      id: (0, _uniqid2.default)(),
	      type: 'text',
	      label: '',
	      required: false,
	      options: []
	    }].concat(fields);
	    updateField(newFields);
	    this.setState({
	      toggledEditor: toggledEditor
	    });
	  };
	
	  CustomField.prototype.onSort = function onSort(fields) {
	    var updateField = this.props.updateField;
	
	    updateField(fields);
	  };
	
	  CustomField.prototype.removeFieldItem = function removeFieldItem(index) {
	    var _this2 = this;
	
	    var updateField = this.props.updateField;
	
	    (0, _confirm2.default)(__('Are you sure you want to remove the field?', _locale2.default), __('Remove Field', _locale2.default)).then(function () {
	      var fields = _this2.props.fields;
	      var toggledEditor = {};
	      var newFields = fields.slice(0);
	      newFields.splice(index, 1);
	      updateField(newFields);
	      _this2.setState({
	        toggledEditor: toggledEditor
	      });
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  CustomField.prototype.toggleFieldItemEditor = function toggleFieldItemEditor(index) {
	    var toggledEditor = this.state.toggledEditor;
	
	    if (!toggledEditor[index]) {
	      toggledEditor[index] = true;
	    } else {
	      toggledEditor[index] = false;
	    }
	
	    this.setState({
	      toggledEditor: toggledEditor
	    });
	  };
	
	  CustomField.prototype.onDragStart = function onDragStart(index) {
	    var _this3 = this;
	
	    return function () {
	      var toggledEditor = _this3.state.toggledEditor;
	
	
	      var editorStateBeforeDragged = toggledEditor[index];
	
	      toggledEditor[index] = false;
	
	      _this3.setState({
	        draggableIndex: index,
	        editorStateBeforeDragged: editorStateBeforeDragged
	      });
	    };
	  };
	
	  CustomField.prototype.onDragEnd = function onDragEnd() {
	    this.setState({
	      draggableIndex: -1
	    });
	  };
	
	  CustomField.prototype.saveField = function saveField(index) {
	    var saveField = this.props.saveField;
	
	    saveField();
	    this.toggleFieldItemEditor(index);
	  };
	
	  CustomField.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props2 = this.props,
	        isSortable = _props2.isSortable,
	        fetching = _props2.fetching,
	        fields = _props2.fields,
	        onChange = _props2.onChange;
	    var _state = this.state,
	        toggledEditor = _state.toggledEditor,
	        draggableIndex = _state.draggableIndex;
	
	    var items = (0, _map2.default)(fields, function (field, index) {
	      var _ref = field || {},
	          label = _ref.label,
	          type = _ref.type,
	          options = _ref.options,
	          required = _ref.required;
	
	      return _react2.default.createElement(_FieldItem2.default, {
	        key: index,
	        sortId: index,
	        index: index,
	        items: fields,
	        label: label,
	        type: type,
	        options: options,
	        required: required,
	        editable: true,
	        onChange: onChange,
	        onSortItems: _this4.onSort,
	        isSortable: isSortable,
	        draggable: index === draggableIndex,
	        onMouseDownOnBars: _this4.onDragStart(index),
	        onDragEnd: _this4.onDragEnd,
	        saveField: function saveField() {
	          return _this4.saveField(index);
	        },
	        onRemove: function onRemove() {
	          _this4.removeFieldItem(index);
	        },
	        toggleEdit: function toggleEdit() {
	          _this4.toggleFieldItemEditor(index);
	        },
	        isEditing: toggledEditor[index]
	      });
	    });
	
	    return _react2.default.createElement(
	      _Panel2.default,
	      {
	        title: __('Other Info', _locale2.default),
	        titleContent: _react2.default.createElement(
	          'button',
	          { disabled: fetching, onClick: this.addFieldItem, className: 'btn-sm btn-primary' },
	          __('Add New', _locale2.default)
	        )
	      },
	      _react2.default.createElement(
	        'ul',
	        { className: 'other-info sortable-list' },
	        fetching && _react2.default.createElement(_Loading2.default, null),
	        !fetching && items
	      )
	    );
	  };
	
	  return CustomField;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = CustomField;
	module.exports = exports['default'];

/***/ },

/***/ "BPz5":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = updateClientCustomFields;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateClientCustomFields(schoolId, setting) {
	
	  if (!schoolId) {
	    throw 'missing school ID';
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/contact_custom_fields/' + schoolId + '/',
	      'method': 'PUT',
	      'data': JSON.stringify({
	        contact_custom_fields: setting
	      }),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "/oro":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _locale = __webpack_require__("Y1Zm");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _FilterBy = __webpack_require__("SdD8");
	
	var _FilterBy2 = _interopRequireDefault(_FilterBy);
	
	__webpack_require__("Lazm");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <PrintControl 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var FILTERS = ['classroom', 'class', 'teacher'];
	
	var FILTER_OPTIONS = {
	  classroom: {
	    selectMultiple: true
	  },
	  class: {
	    selectMultiple: true
	  },
	  teacher: {
	    selectMultiple: true
	  }
	};
	
	var PrintControl = function (_React$Component) {
	  _inherits(PrintControl, _React$Component);
	
	  function PrintControl(props) {
	    _classCallCheck(this, PrintControl);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {};
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  PrintControl.prototype.componentWillMount = function componentWillMount() {};
	
	  PrintControl.prototype.onChange = function onChange(newSetting) {
	    this.props.onChange(newSetting);
	  };
	
	  PrintControl.prototype.render = function render() {
	    var _this2 = this;
	
	    var setting = this.props.setting;
	
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    var schemaLeft = [{
	      name: 'scheduleType',
	      label: __('Choose type:', _locale2.default),
	      type: 'radio',
	      fieldStyle: 'inline',
	      options: [{ label: __("Weekly", _locale2.default), value: 'weekly' }, { label: __("Daily", _locale2.default), value: 'daily' }],
	      defaultValue: 'weekly'
	    }, {
	      name: 'filter',
	      type: 'custom',
	      className: 'Filter',
	      component: function component() {
	        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var _onChange = arguments[1];
	
	        return _react2.default.createElement(_FilterBy2.default, {
	          filterData: value,
	          selectMultiple: true,
	          filters: FILTERS,
	          options: FILTER_OPTIONS,
	          schoolId: schoolId,
	          onChange: function onChange(data) {
	            _onChange(data.filterData);
	          } });
	      }
	    }];
	
	    var schemaRight = [{
	      name: 'displayLessonName',
	      placeholder: __('Show Lesson Name', _locale2.default),
	      type: 'checkbox',
	      fieldStyle: 'inline',
	      defaultValue: true
	    }, {
	      name: 'displayTeacherName',
	      placeholder: __('Show Teacher Name', _locale2.default),
	      type: 'checkbox',
	      fieldStyle: 'inline',
	      defaultValue: true
	    }, {
	      name: 'displayClassroom',
	      placeholder: __('Show Classroom', _locale2.default),
	      type: 'checkbox',
	      fieldStyle: 'inline',
	      defaultValue: true
	    }, {
	      name: 'print',
	      type: 'custom',
	      component: function component() {
	        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var onChange = arguments[1];
	
	        return _react2.default.createElement(
	          'a',
	          { className: 'btn btn-primary', onClick: _this2.props.onPrint },
	          __('Print', _locale2.default)
	        );
	      }
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'PrintControl' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-2' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            __('Print Class Schedule', _locale2.default)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement(_Form2.default, {
	            onChange: this.onChange,
	            schema: schemaLeft,
	            formData: setting,
	            formStyle: 'outline',
	            getValidationRef: function getValidationRef(fn) {
	              _this2.validate = fn;
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6 DisplayOptions' },
	          _react2.default.createElement(
	            'label',
	            null,
	            __('Display Options:', _locale2.default)
	          ),
	          _react2.default.createElement(_Form2.default, {
	            onChange: this.onChange,
	            schema: schemaRight,
	            formData: setting,
	            formStyle: 'outline',
	            getValidationRef: function getValidationRef(fn) {
	              _this2.validate = fn;
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return PrintControl;
	}(_react2.default.Component);
	
	exports.default = PrintControl;
	module.exports = exports['default'];

/***/ },

/***/ "Y1Zm":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'PrintSchedule',
	  code: 'CN',
	  text: {
	    'Print Class Schedule': '课表打印',
	    'Choose Type': '选择课表',
	    'Weekly': '周课表',
	    'Daily': '日课表',
	    'Display Options': '显示选项',
	    'Print': '打印',
	    'Show Lesson Name': '显示课节名称',
	    'Show Teacher Name': '显示老师姓名',
	    'Show Classroom': '显示教室',
	    'Choose type:': '选择类型',
	    'Display Options:': '展示设置'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "Lazm":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PrintControl":"PrintControl","DisplayOptions":"DisplayOptions","filter-by-field":"filter-by-field","dropdown-icon":"dropdown-icon"};

/***/ },

/***/ "IqYw":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "tmjJ":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PrintSchedule":"PrintSchedule","full-panel-wrapper":"full-panel-wrapper"};

/***/ },

/***/ "npo+":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FullPanelWrapper = __webpack_require__("Suno");
	
	var _FullPanelWrapper2 = _interopRequireDefault(_FullPanelWrapper);
	
	var _PrintControl = __webpack_require__("/oro");
	
	var _PrintControl2 = _interopRequireDefault(_PrintControl);
	
	var _WeeklySchedule = __webpack_require__("bPRN");
	
	var _WeeklySchedule2 = _interopRequireDefault(_WeeklySchedule);
	
	var _DailySchedule = __webpack_require__("7Xq2");
	
	var _DailySchedule2 = _interopRequireDefault(_DailySchedule);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	__webpack_require__("tmjJ");
	
	__webpack_require__("IqYw");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <PrintSchedule
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    schoolDetail: state.schoolDetail
	  };
	};
	
	var PrintSchedule = function (_React$Component) {
	  _inherits(PrintSchedule, _React$Component);
	
	  function PrintSchedule(props) {
	    _classCallCheck(this, PrintSchedule);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onSettingChange = _this.onSettingChange.bind(_this);
	    _this.print = _this.print.bind(_this);
	
	    _this.state = {
	      setting: {
	        scheduleType: 'weekly',
	        displayTeacherName: true,
	        displayClassroom: true,
	        displayLessonName: true,
	        filter: {}
	      }
	    };
	    return _this;
	  }
	
	  PrintSchedule.prototype.onSettingChange = function onSettingChange(newSetting) {
	    this.setState({
	      setting: _extends({}, this.state.setting, newSetting)
	    });
	  };
	
	  PrintSchedule.prototype.componentWillMount = function componentWillMount() {};
	
	  PrintSchedule.prototype.print = function print() {
	    setTimeout(window.print, 250);
	  };
	
	  PrintSchedule.prototype.render = function render() {
	    var setting = this.state.setting;
	    var scheduleType = setting.scheduleType;
	    var _props$schoolDetail$d = this.props.schoolDetail.detail,
	        title = _props$schoolDetail$d.title,
	        logo = _props$schoolDetail$d.logo;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'PrintSchedule' },
	      _react2.default.createElement(
	        _FullPanelWrapper2.default,
	        null,
	        _react2.default.createElement(_PrintControl2.default, { setting: setting, onChange: this.onSettingChange, onPrint: this.print }),
	        _react2.default.createElement(
	          'div',
	          { className: 'printMe landscape' },
	          scheduleType === 'weekly' && _react2.default.createElement(_WeeklySchedule2.default, { schoolName: title, schoolLogo: logo, setting: setting }),
	          scheduleType === 'daily' && _react2.default.createElement(_DailySchedule2.default, { schoolName: title, schoolLogo: logo, setting: setting })
	        )
	      )
	    );
	  };
	
	  return PrintSchedule;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PrintSchedule);
	module.exports = exports['default'];

/***/ },

/***/ "bPRN":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getTimetable = __webpack_require__("sxrQ");
	
	var _getTimetable2 = _interopRequireDefault(_getTimetable);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _filterEvents = __webpack_require__("yVev");
	
	var _filterEvents2 = _interopRequireDefault(_filterEvents);
	
	var _locale = __webpack_require__("b4Rb");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _isEqual = __webpack_require__("hygk");
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	__webpack_require__("gLVm");
	
	__webpack_require__("Mztg");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <WeeklySchedule
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var WeeklySchedule = function (_React$Component) {
	  _inherits(WeeklySchedule, _React$Component);
	
	  function WeeklySchedule(props) {
	    _classCallCheck(this, WeeklySchedule);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    var start_date = (0, _moment2.default)().startOf('week');
	    var end_date = (0, _moment2.default)().endOf('week');
	
	    _this.state = {
	      start_date: start_date.format('YYYY-MM-DD'),
	      end_date: end_date.format('YYYY-MM-DD'),
	      list: [],
	      monday: [],
	      tuesday: [],
	      wednesday: [],
	      thursday: [],
	      friday: [],
	      saturday: [],
	      sunday: []
	    };
	
	    _this.filter = props.setting.filter;
	
	    _this.fetchSchedule = _this.fetchSchedule.bind(_this);
	    return _this;
	  }
	
	  WeeklySchedule.prototype.componentWillMount = function componentWillMount() {
	    this.fetchSchedule();
	    // getLessonAttendance
	  };
	
	  WeeklySchedule.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var setting = _ref.setting;
	
	    if (!(0, _isEqual2.default)(this.filter, setting.filter)) {
	      this.filter = setting.filter;
	      this.sortList();
	    }
	  };
	
	  WeeklySchedule.prototype.fetchSchedule = function fetchSchedule() {
	    var _this2 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _state = this.state,
	        start_date = _state.start_date,
	        end_date = _state.end_date;
	    var setting = this.props.setting;
	
	
	    (0, _getTimetable2.default)(schoolId, { start_date: start_date, end_date: end_date, detail: 1 }).then(function (res) {
	
	      _this2.setState({ list: res.data.result_list }, function () {
	        _this2.sortList();
	      });
	    });
	  };
	
	  WeeklySchedule.prototype.sortList = function sortList() {
	    var list = this.state.list;
	
	    var monday = [];
	    var tuesday = [];
	    var wednesday = [];
	    var thursday = [];
	    var friday = [];
	    var saturday = [];
	    var sunday = [];
	
	    var filteredList = (0, _filterEvents2.default)(list, this.filter);
	
	    filteredList.map(function (item) {
	      if ((0, _moment2.default)(item.lStartTime).format('dddd') == 'Monday') {
	        monday.push(item);
	      } else if ((0, _moment2.default)(item.lStartTime).format('dddd') == 'Tuesday') {
	        tuesday.push(item);
	      } else if ((0, _moment2.default)(item.lStartTime).format('dddd') == 'Wednesday') {
	        wednesday.push(item);
	      } else if ((0, _moment2.default)(item.lStartTime).format('dddd') == 'Thursday') {
	        thursday.push(item);
	      } else if ((0, _moment2.default)(item.lStartTime).format('dddd') == 'Friday') {
	        friday.push(item);
	      } else if ((0, _moment2.default)(item.lStartTime).format('dddd') == 'Saturday') {
	        saturday.push(item);
	      } else if ((0, _moment2.default)(item.lStartTime).format('dddd') == 'Sunday') {
	        sunday.push(item);
	      }
	    });
	
	    this.setState({ monday: monday, tuesday: tuesday, wednesday: wednesday, thursday: thursday, friday: friday, saturday: saturday, sunday: sunday });
	  };
	
	  WeeklySchedule.prototype.renderColumn = function renderColumn(date, list) {
	    var _props$setting = this.props.setting,
	        displayClassroom = _props$setting.displayClassroom,
	        displayLessonName = _props$setting.displayLessonName,
	        displayTeacherName = _props$setting.displayTeacherName;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'columnHeader' },
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          { className: 'date-li' },
	          (0, _moment2.default)(date).format('ddd DD')
	        ),
	        list.map(function (item) {
	          var calendarColor = item.calendarColor,
	              class_name = item.class_name,
	              lName = item.lName,
	              lStartTime = item.lStartTime,
	              lEndTime = item.lEndTime,
	              classroom_name = item.classroom_name,
	              teacher_list = item.teacher_list;
	
	          return _react2.default.createElement(
	            'li',
	            { className: 'lesson-li avoid-break' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('div', { className: 'border', style: { backgroundColor: calendarColor || '#9B9B9B' } }),
	              displayLessonName && _react2.default.createElement(
	                'h5',
	                null,
	                class_name,
	                ' ',
	                '(' + lName + ')'
	              ),
	              _react2.default.createElement(
	                'h6',
	                null,
	                (0, _moment2.default)(lStartTime).format('hh:mm') + ' - ' + (0, _moment2.default)(lEndTime).format('hh:mm')
	              ),
	              displayClassroom && _react2.default.createElement(
	                'div',
	                { className: 'classroom' },
	                __('Classroom', _locale2.default),
	                ': ',
	                classroom_name ? _react2.default.createElement(
	                  'p',
	                  null,
	                  classroom_name
	                ) : ' N/A'
	              ),
	              displayTeacherName && _react2.default.createElement(
	                'div',
	                { className: 'teacherList' },
	                __('Teacher', _locale2.default),
	                ':',
	                teacher_list.length > 0 ? teacher_list.map(function (teacher) {
	                  return _react2.default.createElement(
	                    'p',
	                    null,
	                    teacher.stName || ''
	                  );
	                }) : ' N/A'
	              )
	            )
	          );
	        })
	      )
	    );
	  };
	
	  WeeklySchedule.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        schoolName = _props.schoolName,
	        schoolLogo = _props.schoolLogo;
	    var _state2 = this.state,
	        start_date = _state2.start_date,
	        end_date = _state2.end_date,
	        monday = _state2.monday,
	        tuesday = _state2.tuesday,
	        wednesday = _state2.wednesday,
	        thursday = _state2.thursday,
	        friday = _state2.friday,
	        saturday = _state2.saturday,
	        sunday = _state2.sunday;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'WeeklySchedule' },
	      _react2.default.createElement(
	        'div',
	        { className: 'schedule-header' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('img', { src: schoolLogo, className: 'schoolLogo pull-left' }),
	          _react2.default.createElement(
	            'h2',
	            { className: 'pull-left' },
	            schoolName
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-right changeWeek dontPrintMe' },
	            _react2.default.createElement(
	              'a',
	              { href: '#', onClick: function onClick() {
	                  _this3.setState({
	                    start_date: (0, _moment2.default)(start_date).subtract('days', 7).format('YYYY-MM-DD'),
	                    end_date: (0, _moment2.default)(end_date).subtract('days', 7).format('YYYY-MM-DD')
	                  }, function () {
	                    (0, _getTimetable2.default)(schoolId, {
	                      start_date: _this3.state.start_date,
	                      end_date: _this3.state.end_date,
	                      detail: 1
	                    }).then(function (res) {
	                      _this3.setState({ list: res.data.result_list }, function () {
	                        _this3.sortList();
	                      });
	                    });
	                  });
	                } },
	              _react2.default.createElement('i', { className: 'fa icon-left-dir' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                __('Previous Week', _locale2.default)
	              )
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '#', onClick: function onClick() {
	                  _this3.setState({
	                    start_date: (0, _moment2.default)().startOf('week').format('YYYY-MM-DD'),
	                    end_date: (0, _moment2.default)().endOf('week').format('YYYY-MM-DD')
	                  }, function () {
	                    (0, _getTimetable2.default)(schoolId, { start_date: _this3.state.start_date, end_date: _this3.state.end_date, detail: 1 }).then(function (res) {
	                      _this3.setState({ list: res.data.result_list }, function () {
	                        _this3.sortList();
	                      });
	                    });
	                  });
	                } },
	              _react2.default.createElement(
	                'span',
	                null,
	                __('This Week', _locale2.default)
	              )
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '#', onClick: function onClick() {
	                  _this3.setState({
	                    start_date: (0, _moment2.default)(start_date).add('days', 7).format('YYYY-MM-DD'),
	                    end_date: (0, _moment2.default)(end_date).add('days', 7).format('YYYY-MM-DD')
	                  }, function () {
	                    (0, _getTimetable2.default)(schoolId, {
	                      start_date: _this3.state.start_date,
	                      end_date: _this3.state.end_date,
	                      detail: 1
	                    }).then(function (res) {
	                      _this3.setState({ list: res.data.result_list }, function () {
	                        _this3.sortList();
	                      });
	                    });
	                  });
	                } },
	              _react2.default.createElement(
	                'span',
	                null,
	                __('Next Week', _locale2.default)
	              ),
	              _react2.default.createElement('i', { className: 'fa icon-right-dir' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'scheduleTitle' },
	          __('Weekly Schedule', _locale2.default)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'schedule-content' },
	        this.renderColumn(start_date, sunday),
	        this.renderColumn((0, _moment2.default)(start_date, "YYYY-MM-DD").add('days', 1), monday),
	        this.renderColumn((0, _moment2.default)(start_date, "YYYY-MM-DD").add('days', 2), tuesday),
	        this.renderColumn((0, _moment2.default)(start_date, "YYYY-MM-DD").add('days', 3), wednesday),
	        this.renderColumn((0, _moment2.default)(start_date, "YYYY-MM-DD").add('days', 4), thursday),
	        this.renderColumn((0, _moment2.default)(start_date, "YYYY-MM-DD").add('days', 5), friday),
	        this.renderColumn((0, _moment2.default)(start_date, "YYYY-MM-DD").add('days', 6), saturday)
	      )
	    );
	  };
	
	  return WeeklySchedule;
	}(_react2.default.Component);
	
	exports.default = WeeklySchedule;
	module.exports = exports['default'];

/***/ },

/***/ "yVev":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (eventsToFilter, setting) {
	  var teacherForFiltering = setting.teacher,
	      classroomForFiltering = setting.classroom,
	      classForFiltering = setting.class;
	
	
	  return eventsToFilter.filter(function (evt) {
	    var toInclude = true;
	
	    if (teacherForFiltering && teacherForFiltering.IDs.length > 0) {
	      var found = _.find(evt.teacher_list, function (teacher) {
	        return teacherForFiltering.IDs.indexOf(teacher.id) > -1;
	      });
	
	      if (!found) {
	        return false;
	      }
	    }
	
	    if (classForFiltering && classForFiltering.IDs.length > 0) {
	      if (classForFiltering.IDs.indexOf(evt.lClass) === -1) {
	        return false;
	      }
	    }
	
	    if (classroomForFiltering && classroomForFiltering.IDs.length > 0) {
	      if (classroomForFiltering.IDs.indexOf(evt.lClassroom) === -1) {
	        return false;
	      }
	    }
	
	    return toInclude;
	  });
	};
	
	module.exports = exports["default"]; /**
	                                      * Filter events by data from FilterBy
	                                      *
	                                      * @param {array} events
	                                      * @param {object} data from FilterBy
	                                      */

/***/ },

/***/ "b4Rb":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'ScheduleDisplayer',
	  code: 'CN',
	  text: {
	
	    "Weekly Schedule": "周课表",
	    "Daily Schedule": "日课表",
	    'Next Week': '下一周',
	    'This Week': '这周',
	    'Previous Week': '上一周',
	    'Tomorrow': '明天',
	    'Today': '今天',
	    'Yesterday': '昨天',
	    'Morning': '上午',
	    'Afternoon': '下午',
	    'Teacher': '老师',
	    'Classroom': '教室'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "gLVm":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"WeeklySchedule":"WeeklySchedule","schoolLogo":"schoolLogo","schedule-header":"schedule-header","scheduleTitle":"scheduleTitle","schedule-content":"schedule-content","columnHeader":"columnHeader","date-li":"date-li","lesson-li":"lesson-li","border":"border","teacherList":"teacherList","changeWeek":"changeWeek","icon-left-dir":"icon-left-dir","icon-right-dir":"icon-right-dir"};

/***/ },

/***/ "Mztg":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"DailySchedule":"DailySchedule","WeeklySchedule":"WeeklySchedule","schoolLogo":"schoolLogo"};

/***/ },

/***/ "7Xq2":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getTimetable = __webpack_require__("sxrQ");
	
	var _getTimetable2 = _interopRequireDefault(_getTimetable);
	
	var _filterEvents = __webpack_require__("yVev");
	
	var _filterEvents2 = _interopRequireDefault(_filterEvents);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _locale = __webpack_require__("b4Rb");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _isEqual = __webpack_require__("hygk");
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	__webpack_require__("orVH");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <DailySchedule
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var DailySchedule = function (_React$Component) {
	  _inherits(DailySchedule, _React$Component);
	
	  function DailySchedule(props) {
	    _classCallCheck(this, DailySchedule);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      date: (0, _moment2.default)().format('YYYY-MM-DD'),
	      list: [],
	      morningList: [],
	      afternoonList: []
	    };
	
	    _this.filter = props.setting.filter;
	
	    _this.fetchSchedule = _this.fetchSchedule.bind(_this);
	
	    return _this;
	  }
	
	  DailySchedule.prototype.componentWillMount = function componentWillMount() {
	    this.fetchSchedule();
	  };
	
	  DailySchedule.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var setting = _ref.setting;
	
	    if (!(0, _isEqual2.default)(this.filter, setting.filter)) {
	      this.filter = setting.filter;
	      this.sortTime();
	    }
	  };
	
	  DailySchedule.prototype.fetchSchedule = function fetchSchedule() {
	    var _this2 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var date = this.state.date;
	
	    (0, _getTimetable2.default)(schoolId, { start_date: date, end_date: date, detail: 1 }).then(function (res) {
	      _this2.setState({ list: res.data.result_list }, function () {
	        _this2.sortTime();
	      });
	    });
	  };
	
	  DailySchedule.prototype.sortTime = function sortTime() {
	    var list = this.state.list;
	
	    var morningList = [];
	    var afternoonList = [];
	
	    var filteredList = (0, _filterEvents2.default)(list, this.filter);
	
	    filteredList.map(function (item) {
	      if ((0, _moment2.default)(item.lStartTime).format('HH:mm') < '12:00') {
	        morningList.push(item);
	      } else {
	        afternoonList.push(item);
	      }
	    });
	
	    this.setState({ morningList: morningList, afternoonList: afternoonList });
	  };
	
	  DailySchedule.prototype.renderColumn = function renderColumn(time, list) {
	    var _props$setting = this.props.setting,
	        displayClassroom = _props$setting.displayClassroom,
	        displayLessonName = _props$setting.displayLessonName,
	        displayTeacherName = _props$setting.displayTeacherName;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'columnHeader' },
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          { className: 'date-li' },
	          time
	        ),
	        list.map(function (item) {
	          var calendarColor = item.calendarColor,
	              class_name = item.class_name,
	              lName = item.lName,
	              lStartTime = item.lStartTime,
	              lEndTime = item.lEndTime,
	              classroom_name = item.classroom_name,
	              teacher_list = item.teacher_list;
	
	          return _react2.default.createElement(
	            'li',
	            { className: 'lesson-li' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement('div', { className: 'border', style: { backgroundColor: calendarColor || '#9B9B9B' } }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-6' },
	                displayLessonName && _react2.default.createElement(
	                  'h5',
	                  null,
	                  class_name,
	                  ' ',
	                  '(' + lName + ')'
	                ),
	                _react2.default.createElement(
	                  'h6',
	                  null,
	                  (0, _moment2.default)(lStartTime).format('hh:mm') + ' - ' + (0, _moment2.default)(lEndTime).format('hh:mm')
	                ),
	                displayClassroom && _react2.default.createElement(
	                  'div',
	                  { className: 'classroom' },
	                  __('Classroom', _locale2.default),
	                  ': ',
	                  classroom_name ? _react2.default.createElement(
	                    'p',
	                    null,
	                    classroom_name
	                  ) : ' N/A'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-6' },
	                displayTeacherName && _react2.default.createElement(
	                  'div',
	                  { className: 'teacherList' },
	                  __('Teacher', _locale2.default),
	                  ':',
	                  teacher_list.length > 0 ? teacher_list.map(function (teacher) {
	                    return _react2.default.createElement(
	                      'p',
	                      null,
	                      teacher.stName || ''
	                    );
	                  }) : ' N/A'
	                )
	              )
	            )
	          );
	        })
	      )
	    );
	  };
	
	  DailySchedule.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        schoolName = _props.schoolName,
	        schoolLogo = _props.schoolLogo;
	    var _state = this.state,
	        morningList = _state.morningList,
	        afternoonList = _state.afternoonList,
	        date = _state.date;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'DailySchedule' },
	      _react2.default.createElement(
	        'div',
	        { className: 'schedule-header' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('img', { src: schoolLogo, className: 'schoolLogo pull-left' }),
	          _react2.default.createElement(
	            'h2',
	            { className: 'pull-left' },
	            schoolName
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-right changeDay dontPrintMe' },
	            _react2.default.createElement(
	              'a',
	              { href: '#', onClick: function onClick() {
	                  _this3.setState({
	                    date: (0, _moment2.default)(date).subtract('days', 1).format('YYYY-MM-DD')
	                  }, function () {
	                    (0, _getTimetable2.default)(schoolId, {
	                      start_date: _this3.state.date,
	                      end_date: _this3.state.date,
	                      detail: 1
	                    }).then(function (res) {
	                      _this3.setState({ list: res.data.result_list }, function () {
	                        _this3.sortTime();
	                      });
	                    });
	                  });
	                } },
	              _react2.default.createElement('i', { className: 'fa icon-left-dir' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                __('Yesterday', _locale2.default)
	              )
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '#', onClick: function onClick() {
	                  _this3.setState({
	                    date: (0, _moment2.default)().format('YYYY-MM-DD')
	                  }, function () {
	                    (0, _getTimetable2.default)(schoolId, { start_date: _this3.state.date, end_date: _this3.state.date, detail: 1 }).then(function (res) {
	                      _this3.setState({ list: res.data.result_list }, function () {
	                        _this3.sortTime();
	                      });
	                    });
	                  });
	                } },
	              _react2.default.createElement(
	                'span',
	                null,
	                __('Today', _locale2.default)
	              )
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '#', onClick: function onClick() {
	                  _this3.setState({
	                    date: (0, _moment2.default)(date).add('days', 1).format('YYYY-MM-DD')
	                  }, function () {
	                    (0, _getTimetable2.default)(schoolId, {
	                      start_date: _this3.state.date,
	                      end_date: _this3.state.date,
	                      detail: 1
	                    }).then(function (res) {
	                      _this3.setState({ list: res.data.result_list }, function () {
	                        _this3.sortTime();
	                      });
	                    });
	                  });
	                } },
	              _react2.default.createElement(
	                'span',
	                null,
	                __('Tomorrow', _locale2.default)
	              ),
	              _react2.default.createElement('i', { className: 'fa icon-right-dir' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'text-center scheduleTitle' },
	          (0, _moment2.default)(date).format('MMM DD ddd')
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'schedule-content' },
	        this.renderColumn(__('Morning', _locale2.default), morningList),
	        this.renderColumn(__('Afternoon', _locale2.default), afternoonList)
	      )
	    );
	  };
	
	  return DailySchedule;
	}(_react2.default.Component);
	
	exports.default = DailySchedule;
	module.exports = exports['default'];

/***/ },

/***/ "orVH":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"DailySchedule":"DailySchedule","schoolLogo":"schoolLogo","schedule-header":"schedule-header","scheduleTitle":"scheduleTitle","schedule-content":"schedule-content","columnHeader":"columnHeader","row":"row","date-li":"date-li","lesson-li":"lesson-li","border":"border","changeDay":"changeDay","icon-left-dir":"icon-left-dir","icon-right-dir":"icon-right-dir"};

/***/ },

/***/ "FNRm":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"terms-title":"terms-title","save-btn":"save-btn","footer-section":"footer-section","control":"control","checkmark":"checkmark"};

/***/ },

/***/ "ArLH":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _PanelWrapper = __webpack_require__("VPji");
	
	var _PanelWrapper2 = _interopRequireDefault(_PanelWrapper);
	
	var _reactQuill = __webpack_require__("TWqO");
	
	var _reactQuill2 = _interopRequireDefault(_reactQuill);
	
	var _getSchoolSettings = __webpack_require__("yY2/");
	
	var _getSchoolSettings2 = _interopRequireDefault(_getSchoolSettings);
	
	var _updateSchoolSettings = __webpack_require__("gl/q");
	
	var _updateSchoolSettings2 = _interopRequireDefault(_updateSchoolSettings);
	
	var _alert = __webpack_require__("BGi1");
	
	var _locale = __webpack_require__("RrvO");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("FNRm");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RegistrationAgreement = function (_Component) {
	    _inherits(RegistrationAgreement, _Component);
	
	    function RegistrationAgreement(props) {
	        _classCallCheck(this, RegistrationAgreement);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {
	            agreementContent: '',
	            isShowIpad: 0
	        };
	        return _this;
	    }
	
	    RegistrationAgreement.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        var schoolId = localStorage.getItem('schoolId');
	        (0, _getSchoolSettings2.default)(schoolId).then(function (result) {
	            _this2.setState({ agreementContent: result.registration_instruction, isShowIpad: result.show_registration_instruction });
	        });
	    };
	
	    RegistrationAgreement.prototype.updateAgreement = function updateAgreement() {
	        var schoolId = localStorage.getItem('schoolId');
	        (0, _updateSchoolSettings2.default)(schoolId, { registration_instruction: this.state.agreementContent, show_registration_instruction: this.state.isShowIpad }).then(function (result) {
	            if (result.data.result === 'success') {
	                _alert.alert.success('', __('Updated Successfully!', _locale2.default));
	            } else {
	                _alert.alert.warning('', __('Failed to update!', _locale2.default));
	            }
	        });
	    };
	
	    RegistrationAgreement.prototype.render = function render() {
	        var _this3 = this;
	
	        return _react2.default.createElement(
	            _PanelWrapper2.default,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'terms-title' },
	                __('Student Registration Terms and Conditions', _locale2.default)
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'terms-editer' },
	                _react2.default.createElement(_reactQuill2.default, {
	                    value: this.state.agreementContent,
	                    onChange: function onChange(value) {
	                        _this3.setState({ agreementContent: value });
	                    },
	                    style: styles.textEditerStyle
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'footer-section' },
	                _react2.default.createElement(
	                    'label',
	                    { className: 'control' },
	                    _react2.default.createElement('input', { type: 'checkbox', checked: this.state.isShowIpad == 1,
	                        onChange: function onChange(e) {
	                            if (_this3.state.isShowIpad == 0) {
	                                _this3.setState({ isShowIpad: 1 });
	                            } else {
	                                _this3.setState({ isShowIpad: 0 });
	                            }
	                        }
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' }),
	                    __('Apply to student self-registration form', _locale2.default)
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-primary pull-right', onClick: function onClick() {
	                            return _this3.updateAgreement();
	                        } },
	                    __('Save', _locale2.default)
	                )
	            )
	        );
	    };
	
	    return RegistrationAgreement;
	}(_react.Component);
	
	var styles = {
	    textEditerStyle: {
	        width: '80%',
	        height: 500,
	        paddingBottom: 50
	    }
	};
	exports.default = RegistrationAgreement;
	module.exports = exports['default'];

/***/ },

/***/ "gl/q":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = updateSchoolSettings;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  student_fields_setting: _joiBrowser2.default.object().allow('').allow(null),
	  contact_custom_fields: _joiBrowser2.default.object().allow('').allow(null),
	  show_registration_instruction: _joiBrowser2.default.number().integer(),
	  registration_instruction: _joiBrowser2.default.string().allow('').allow(null),
	
	  website_locale: _joiBrowser2.default.string().allow('').allow(null),
	  website_url: _joiBrowser2.default.string().allow('').allow(null),
	  website_theme_name: _joiBrowser2.default.string().allow('').allow(null),
	  website_theme_settings: _joiBrowser2.default.object().allow('').allow(null),
	  website_nav_settings: _joiBrowser2.default.object().allow('').allow(null),
	  notification_convert_contact: _joiBrowser2.default.number().integer().allow(null)
	});
	
	function updateSchoolSettings(schoolId, schoolSettings) {
	  if (!schoolId) {
	    throw 'Missing school ID';
	  }
	
	  var validateResult = _joiBrowser2.default.validate(schoolSettings, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/school_settings/' + schoolId + '/',
	      'method': 'PUT',
	      'data': JSON.stringify(schoolSettings),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "RrvO":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'RegistrationAgreement',
	  code: 'CN',
	  text: {
	    'Updated Successfully!': '更新成功!',
	    'Failed to update!': '更新失败！',
	    'Student Registration Terms and Conditions': '学员报名须知与条款',
	    'Save': '保存',
	    'Apply to student self-registration form': '在学员在自主注册表格显示此条款'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "Ap3v":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _UI = __webpack_require__("OM1Z");
	
	var _find = __webpack_require__("kbi+");
	
	var _find2 = _interopRequireDefault(_find);
	
	var _ducks = __webpack_require__("yhkM");
	
	var _alert = __webpack_require__("BGi1");
	
	var _Toolbar = __webpack_require__("uZpg");
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	__webpack_require__("1S4H");
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ClassCalendar = __webpack_require__("MVOh");
	
	var _ClassCalendar2 = _interopRequireDefault(_ClassCalendar);
	
	var _getScheduleOption = __webpack_require__("741Q");
	
	var _getScheduleOption2 = _interopRequireDefault(_getScheduleOption);
	
	var _convertScheduleToRbcEvents = __webpack_require__("Bv0y");
	
	var _convertScheduleToRbcEvents2 = _interopRequireDefault(_convertScheduleToRbcEvents);
	
	var _updateLessonWithTime = __webpack_require__("9dt9");
	
	var _updateLessonWithTime2 = _interopRequireDefault(_updateLessonWithTime);
	
	var _getLessonStudentList = __webpack_require__("9pkU");
	
	var _getLessonStudentList2 = _interopRequireDefault(_getLessonStudentList);
	
	var _Lesson = __webpack_require__("g5LE");
	
	var _Lesson2 = _interopRequireDefault(_Lesson);
	
	var _datetime = __webpack_require__("2RW8");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Schedule
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is ...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent routes
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @redux
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    schedule: state.schedule
	  };
	};
	
	var DEFAULT_VIEW_DATE = new Date();
	
	var Schedule = function (_React$Component) {
	  _inherits(Schedule, _React$Component);
	
	  function Schedule(props) {
	    _classCallCheck(this, Schedule);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._transformEvents = _this._transformEvents.bind(_this);
	
	    _this.fetchScheduleFromServer = _this.fetchScheduleFromServer.bind(_this);
	
	    _this.moveEvent = _this.moveEvent.bind(_this);
	
	    _this.onNavigate = _this.onNavigate.bind(_this);
	
	    var scheduleOption = _this.props.scheduleOption;
	
	
	    _this.state = {
	      scheduleOption: scheduleOption || (0, _getScheduleOption2.default)(new Date()),
	      events: [],
	      date: DEFAULT_VIEW_DATE
	    };
	    return _this;
	  }
	
	  Schedule.prototype._transformEvents = function _transformEvents(props) {
	    var schedule = props.schedule;
	    var _schedule$filterData = schedule.filterData,
	        teacherForFiltering = _schedule$filterData.teacher,
	        studentForFiltering = _schedule$filterData.student,
	        classroomForFiltering = _schedule$filterData.classroom,
	        classForFiltering = _schedule$filterData.class;
	    var loggedinTeacherId = schedule.loggedinTeacherId;
	
	    //
	    // STEP 1. Filtering
	    //
	    // Loop through all the events and if any filtering criteria
	    // are not fulfilled, we will filter it out because the condition
	    // is &&.
	    //
	    // An event is actually a lesson, for now. In the future,
	    // there will be more 'events' other than a lesson
	    //
	    // When we filter by student which is slightly different from the above.
	    // studentForFiltering is fetched from getTimetable API and we will
	    // have to filter out of studentForFiltering.
	    //
	
	    var eventsToFilter = void 0;
	    if (studentForFiltering) {
	      eventsToFilter = studentForFiltering.events;
	    } else if (teacherForFiltering) {
	      eventsToFilter = teacherForFiltering.events;
	    } else {
	      eventsToFilter = schedule.events;
	    }
	
	    var events = eventsToFilter.filter(function (evt) {
	      var toInclude = true;
	
	      if (classForFiltering && classForFiltering.IDs.length > 0) {
	        if (classForFiltering.IDs.indexOf(evt.lClass) === -1) {
	          return false;
	        }
	      }
	
	      if (classroomForFiltering && classroomForFiltering.IDs.length > 0) {
	        if (classroomForFiltering.IDs.indexOf(evt.lClassroom) === -1) {
	          return false;
	        }
	      }
	
	      return toInclude;
	    });
	
	    //
	    // STEP 2. Trandform
	    //
	    // We must chage the schedule into a format react-big-calendar would understand.
	    //
	    events = (0, _convertScheduleToRbcEvents2.default)(events);
	
	    //
	    // STEP 3. Update to state to reflect the change in DOM
	    //
	    this.setState({
	      events: events
	    });
	  };
	
	  Schedule.prototype.alreadyCheckedInAlert = function alreadyCheckedInAlert() {
	    _alert.alert.warning(__('Attended lesson cannot be moved', 'schedule'));
	  };
	
	  Schedule.prototype.conflictedEventAlert = function conflictedEventAlert(conflicts) {
	    _alert.alert.warning(__('There was a conflict while moving the lesson.', 'schedule'), __('Conflicts', 'schedule'));
	  };
	
	  Schedule.prototype.moveEvent = function moveEvent(_ref) {
	    var _this2 = this;
	
	    var event = _ref.event,
	        start = _ref.start,
	        end = _ref.end;
	
	    if (event.lState === 1) {
	      this.alreadyCheckedInAlert();
	      return;
	    }
	
	    var lesson = new _Lesson2.default(event);
	
	    var name = lesson.name,
	        classroomId = lesson.classroomId,
	        calendarColor = lesson.calendarColor;
	
	
	    var params = {
	      new_name: name,
	      start_datetime: (0, _datetime.getDay)(start) + ' ' + (0, _datetime.getTimeIn24)(start).split(' ')[0],
	      end_datetime: (0, _datetime.getDay)(end) + ' ' + (0, _datetime.getTimeIn24)(end).split(' ')[0],
	      classroom_id: classroomId ? Number(classroomId) : '',
	      calendar_color: calendarColor,
	      student_id_list: [],
	      teacher_id_list: lesson.getTeacherIdList()
	
	      // We need to load up student list inside the lesson
	      // since lesson doesn't come with it
	    };(0, _getLessonStudentList2.default)(event.id).then(function (_ref2) {
	      var student_list = _ref2.student_list;
	
	      var studentIdList = [];
	      if (student_list) {
	        studentIdList = student_list.map(function (student) {
	          return student.student_id;
	        });
	      }
	
	      params.student_id_list = studentIdList;
	
	      (0, _updateLessonWithTime2.default)(event.id, params).then(function (_ref3) {
	        var data = _ref3.data;
	
	        // CASE 1. Lesson has already been checked in
	        if (data.reason && data.reason.indexOf('checked in') > -1) {
	          _this2.alreadyCheckedInAlert();
	          return;
	        }
	
	        // CASE 2. Conflicts
	        if (data.conflicted_result === true) {
	          _this2.conflictedEventAlert(data);
	          return;
	        }
	
	        // CASE 3. all good, it moved, let's fetch the new data
	        _this2.fetchScheduleFromServer();
	      }).catch(function (err) {
	        console.error(err);
	      });
	    });
	  };
	
	  Schedule.prototype.onNavigate = function onNavigate(dateIn) {
	    var _this3 = this;
	
	    var date = void 0;
	    if (typeof dateIn === 'string') {
	      date = (0, _moment2.default)(dateIn, 'YYYY-MM-DD hh:mm:ss').toDate();
	    } else if (dateIn instanceof Date) {
	      date = dateIn;
	    }
	
	    if (date !== this.state.date) {
	      this.setState({
	        scheduleOption: (0, _getScheduleOption2.default)(date),
	        date: date || this.state.date // if date is empty, we use original data in stata
	      }, function () {
	        _this3.fetchScheduleFromServer();
	      });
	    }
	  };
	
	  Schedule.prototype.componentWillMount = function componentWillMount() {
	    this.fetchScheduleFromServer();
	  };
	
	  Schedule.prototype.fetchScheduleFromServer = function fetchScheduleFromServer() {
	    var dispatch = this.props.dispatch;
	    var scheduleOption = this.state.scheduleOption;
	
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    dispatch((0, _ducks.fetchSchedule)(schoolId, scheduleOption));
	  };
	
	  Schedule.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this._transformEvents(nextProps);
	  };
	
	  Schedule.prototype.render = function render() {
	    var _state = this.state,
	        events = _state.events,
	        date = _state.date;
	    var fetching = this.props.schedule.fetching;
	
	
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        __('Schedules', 'header.sidemenu')
	      ),
	      _react2.default.createElement(_ClassCalendar2.default, {
	        fetching: fetching,
	        events: events,
	        timeslots: 4,
	        date: date,
	        components: {
	          toolbar: _Toolbar2.default
	        },
	        onEventDrop: this.moveEvent,
	        onNavigate: this.onNavigate
	      })
	    );
	  };
	
	  return Schedule;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Schedule);
	module.exports = exports['default'];

/***/ },

/***/ "uZpg":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _constants = __webpack_require__("hYBH");
	
	var _UI = __webpack_require__("OM1Z");
	
	var _SelectItem = __webpack_require__("k6Ef");
	
	var _SelectItem2 = _interopRequireDefault(_SelectItem);
	
	var _FilterBy = __webpack_require__("SdD8");
	
	var _FilterBy2 = _interopRequireDefault(_FilterBy);
	
	var _AddLesson = __webpack_require__("shHd");
	
	var _AddLesson2 = _interopRequireDefault(_AddLesson);
	
	var _getScheduleOption = __webpack_require__("741Q");
	
	var _getScheduleOption2 = _interopRequireDefault(_getScheduleOption);
	
	var _getTimetable = __webpack_require__("sxrQ");
	
	var _getTimetable2 = _interopRequireDefault(_getTimetable);
	
	var _ducks = __webpack_require__("yhkM");
	
	var _SelectTeacher = __webpack_require__("okp6");
	
	var _SelectTeacher2 = _interopRequireDefault(_SelectTeacher);
	
	var _SelectClass = __webpack_require__("/wCL");
	
	var _SelectClass2 = _interopRequireDefault(_SelectClass);
	
	var _SelectClassroom = __webpack_require__("wPVy");
	
	var _SelectClassroom2 = _interopRequireDefault(_SelectClassroom);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Toolbar />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - It is an entirely recreated custom toolbar for react-big-calendar.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - There are inputs that allow users to filter timetable.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent react-big-calenar
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @redux
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// //
	
	
	var DEFAULT_TAB_INDEX = 0;
	
	var VIEWS = ['month', 'week', 'day'];
	
	var FILTERS = ['classroom', 'class', 'teacher', 'student'];
	
	var FILTERS_FOR_TEACHER = ['classroom', 'class'];
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    schedule: state.schedule,
	    user: state.user
	  };
	};
	
	var Toolbar = function (_React$Component) {
	  _inherits(Toolbar, _React$Component);
	
	  function Toolbar(props) {
	    _classCallCheck(this, Toolbar);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._changeView = _this._changeView.bind(_this);
	    _this._onFilterChange = _this._onFilterChange.bind(_this);
	    _this._renderPrevNowNextButton = _this._renderPrevNowNextButton.bind(_this);
	
	    _this.displayFilteredData = _this.displayFilteredData.bind(_this);
	
	    _this.state = {
	      filterData: {}
	    };
	    _this.filterOptions = {
	      classroom: {
	        selectMultiple: true,
	        disabled: !(0, _R.userCan)('classroom_channel')
	      },
	      class: {
	        selectMultiple: true,
	        disabled: !(0, _R.userCan)('class_channel') || !(0, _R.userCan)('private_class_channel')
	      },
	      teacher: {
	        selectMultiple: true,
	        disabled: !(0, _R.userCan)('teacher_channel')
	
	      },
	      student: {
	        selectMultiple: false,
	        disabled: !(0, _R.userCan)('student_channel')
	      }
	    };
	    return _this;
	  }
	
	  Toolbar.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var _this2 = this;
	
	    var user = _ref.user,
	        date = _ref.date;
	    var _props = this.props,
	        dispatch = _props.dispatch,
	        schedule = _props.schedule;
	    var displayedDate = this.state.displayedDate;
	
	
	    if (displayedDate != date) {
	      this.setState({
	        displayedDate: date
	      }, function () {
	        _this2.displayFilteredData();
	      });
	    }
	
	    if (user.result && user.result.school_list) {
	      var schoolId = localStorage.getItem('schoolId');
	      var currentSchool = void 0;
	      user.result.school_list.map(function (school) {
	        if (school.school_id == schoolId) {
	          currentSchool = school;
	        }
	      });
	
	      if (currentSchool && schedule.loggedinTeacherId != currentSchool.school_teacher_id) {
	        if (currentSchool.school_teacher_id) {
	          dispatch({
	            type: _ducks.SET_LOGGEDIN_TEACHER_ID,
	            loggedinTeacherId: currentSchool.school_teacher_id
	          });
	        }
	      }
	    }
	  };
	
	  Toolbar.prototype._changeView = function _changeView(tabIndex) {
	    this.props.onViewChange(VIEWS[tabIndex]);
	  };
	
	  Toolbar.prototype.onNavigate = function onNavigate(type) {
	    var onNavigate = this.props.onNavigate;
	
	
	    onNavigate(type);
	  };
	
	  Toolbar.prototype._onFilterChange = function _onFilterChange(_ref2) {
	    var _this3 = this;
	
	    var filterData = _ref2.filterData;
	
	    this.setState({
	      filterData: filterData
	    }, function () {
	      _this3.displayFilteredData();
	    });
	  };
	
	  Toolbar.prototype.displayFilteredData = function displayFilteredData() {
	    var _this4 = this;
	
	    var filterData = this.state.filterData;
	
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    if (filterData.student) {
	      var schoolStudentID = filterData.student.IDs;
	
	      var date = this.state.displayedDate;
	
	      // a student is selected for filtering
	
	      var scheduleOption = _extends({}, (0, _getScheduleOption2.default)(date), {
	        // filter_type: 'filter_by_student',
	        student_id: schoolStudentID
	      });
	
	      (0, _getTimetable2.default)(schoolId, scheduleOption).then(function (_ref3) {
	        var data = _ref3.data;
	
	        filterData.student = _extends({}, filterData.student, {
	          events: data.result_list
	        });
	
	        _this4.props.dispatch((0, _ducks.setFilterData)(filterData));
	      }).catch(function (error) {
	        console.error(error);
	      });
	    } else if (filterData.teacher) {
	      var teacherIDs = filterData.teacher.IDs;
	      var _date = this.state.displayedDate;
	
	      var _scheduleOption = _extends({}, (0, _getScheduleOption2.default)(_date), {
	        // filter_type: 'filter_by_student',
	        teacher_id: teacherIDs
	      });
	
	      (0, _getTimetable2.default)(schoolId, _scheduleOption).then(function (_ref4) {
	        var data = _ref4.data;
	
	        filterData.teacher = _extends({}, filterData.teacher, {
	          events: data.result_list
	        });
	
	        _this4.props.dispatch((0, _ducks.setFilterData)(filterData));
	      }).catch(function (error) {
	        console.error(error);
	      });
	    } else {
	      this.props.dispatch((0, _ducks.setFilterData)(filterData));
	    }
	  };
	
	  Toolbar.prototype._renderPrevNowNextButton = function _renderPrevNowNextButton(changeDateType) {
	    var _this5 = this;
	
	    var date = this.props.date;
	
	
	    var prev = void 0;
	    var now = void 0;
	    var next = void 0;
	
	    switch (changeDateType) {
	      case 'month':
	        prev = __("Previous Month", "schedule.calendar");
	        next = __("Next Month", "schedule.calendar");
	        break;
	      case 'week':
	        prev = __("Previous Week", "schedule.calendar");
	        next = __("Next Week", "schedule.calendar");
	        break;
	      case 'day':
	        prev = __("Yesterday", "schedule.calendar");
	        next = __("Tomorrow", "schedule.calendar");
	        break;
	    }
	
	    //
	    // TODO: Refactor it
	    //
	    return _react2.default.createElement(
	      'span',
	      { className: 'navigate-date' },
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'change-date-button btn-link',
	          onClick: function onClick() {
	            _this5.onNavigate('PREV');
	          }
	        },
	        _react2.default.createElement('i', { className: 'change-date-arrow fa icon-left-dir' }),
	        prev
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'change-date-button btn-link',
	          onClick: function onClick() {
	            _this5.onNavigate('TODAY');
	          }
	        },
	        __("Today", "schedule.calendar")
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'change-date-button btn-link',
	          onClick: function onClick() {
	            _this5.onNavigate('NEXT');
	          }
	        },
	        next,
	        _react2.default.createElement('i', { className: 'change-date-arrow fa icon-right-dir' })
	      )
	    );
	  };
	
	  Toolbar.prototype.render = function render() {
	    var _this6 = this;
	
	    var _props2 = this.props,
	        label = _props2.label,
	        onNavigate = _props2.onNavigate;
	    var loggedinTeacherId = this.props.schedule.loggedinTeacherId;
	    var filterData = this.state.filterData;
	
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    var Filter = _react2.default.createElement(_FilterBy2.default, {
	      filterData: filterData,
	      selectMultiple: true,
	      filters: FILTERS,
	      options: this.filterOptions,
	      schoolId: schoolId,
	      onChange: this._onFilterChange });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'classtop-rbc-toolbar' },
	      _react2.default.createElement(
	        'div',
	        { className: 'date-label' },
	        label
	      ),
	      _react2.default.createElement(
	        _UI.Tabs,
	        { defaultIndex: DEFAULT_TAB_INDEX, onSelect: this._changeView },
	        _react2.default.createElement(
	          _UI.TabList,
	          null,
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('month', 'schedule.calendar')
	          ),
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('week', 'schedule.calendar')
	          ),
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('day', 'schedule.calendar')
	          ),
	          _react2.default.createElement(
	            _UI.Button,
	            { bsStyle: 'default', className: 'add-lesson pull-right',
	              disabled: (0, _R.userCan)('create_lesson') !== true && (0, _R.userCan)('create_private_lesson') !== true,
	              onClick: function onClick() {
	                (0, _AddLesson2.default)({
	                  disablePrivateClass: (0, _R.userCan)('create_private_lesson') != true,
	                  disableClass: (0, _R.userCan)('create_lesson') != true
	                }).then(function (result) {
	                  _this6.onNavigate('TODAY');
	                });
	              } },
	            _react2.default.createElement('i', { className: 'fa icon-plus' }),
	            ' ',
	            __('Add Lesson', 'schedule')
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: '/print-schedule', target: '_blank', className: 'btn btn-primary pull-right' },
	            __('Print Schedule', 'schedule')
	          )
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          Filter,
	          this._renderPrevNowNextButton('month')
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          Filter,
	          this._renderPrevNowNextButton('week')
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          Filter,
	          this._renderPrevNowNextButton('day')
	        )
	      )
	    );
	  };
	
	  return Toolbar;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Toolbar);
	module.exports = exports['default'];

/***/ },

/***/ "hYBH":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var navigate = exports.navigate = {
	  PREVIOUS: 'PREV',
	  NEXT: 'NEXT',
	  TODAY: 'TODAY',
	  DATE: 'DATE'
	};
	
	var views = exports.views = {
	  MONTH: 'month',
	  WEEK: 'week',
	  WORK_WEEK: 'work_week',
	  DAY: 'day',
	  AGENDA: 'agenda'
	};

/***/ },

/***/ "741Q":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (today) {
	  var start_date = (0, _moment2.default)(today).startOf('month').format(DATE_FORMAT);
	  var end_date = (0, _moment2.default)(today).endOf('month').format(DATE_FORMAT);
	
	  if (!today instanceof Date) {
	    throw new Error('today must be an instance of Date.');
	  }
	
	  return {
	    start_date: start_date,
	    end_date: end_date,
	    page_or_not: 0
	  };
	};
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DATE_FORMAT = 'YYYY-MM-DD';
	
	module.exports = exports['default'];

/***/ },

/***/ "1S4H":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"rbc-calendar":"rbc-calendar","filter-by":"filter-by","filter-by-field":"filter-by-field","rbc-day-bg":"rbc-day-bg","classtop-rbc-toolbar":"classtop-rbc-toolbar","react-tabs__tab-list":"react-tabs__tab-list","add-lesson":"add-lesson","navigate-date":"navigate-date","change-date-button":"change-date-button","change-date-arrow":"change-date-arrow","date-label":"date-label"};

/***/ },

/***/ "MVOh":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__("PJh5");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactBigCalendar = __webpack_require__("f1fD");
	
	var _reactBigCalendar2 = _interopRequireDefault(_reactBigCalendar);
	
	__webpack_require__("R110");
	
	__webpack_require__("9F/P");
	
	var _dragAndDrop = __webpack_require__("1NG5");
	
	var _dragAndDrop2 = _interopRequireDefault(_dragAndDrop);
	
	var _Event = __webpack_require__("+L25");
	
	var _Event2 = _interopRequireDefault(_Event);
	
	var _color = __webpack_require__("9Otz");
	
	var _color2 = _interopRequireDefault(_color);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _Transition = __webpack_require__("X/qO");
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	__webpack_require__("KIGD");
	
	var _LessonFloat = __webpack_require__("Jxru");
	
	var _LessonFloat2 = _interopRequireDefault(_LessonFloat);
	
	var _Lesson = __webpack_require__("g5LE");
	
	var _Lesson2 = _interopRequireDefault(_Lesson);
	
	var _AddLesson = __webpack_require__("shHd");
	
	var _AddLesson2 = _interopRequireDefault(_AddLesson);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ClassCalendar
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	//
	
	
	//
	// language
	//
	
	_reactBigCalendar2.default.momentLocalizer(_moment2.default);
	
	var formats = {
	  eventTimeRangeFormat: function eventTimeRangeFormat(_ref, culture, local) {
	    var start = _ref.start,
	        end = _ref.end;
	    return '';
	  }
	};
	
	var Calendar = (0, _dragAndDrop2.default)(_reactBigCalendar2.default);
	
	var DEFAULT_VIEW = 'month';
	
	var ClassCalendar = function (_React$Component) {
	  _inherits(ClassCalendar, _React$Component);
	
	  function ClassCalendar(props) {
	    _classCallCheck(this, ClassCalendar);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._eventPropGetter = _this._eventPropGetter.bind(_this);
	    _this.onSelectSlot = _this.onSelectSlot.bind(_this);
	    _this.onSelectEvent = _this.onSelectEvent.bind(_this);
	    _this.closeFloat = _this.closeFloat.bind(_this);
	
	    _this.state = {};
	    return _this;
	  }
	
	  ClassCalendar.prototype.onSelectSlot = function onSelectSlot(slot) {
	    var _this2 = this;
	
	    (0, _AddLesson2.default)({
	      startDate: (0, _moment2.default)(slot.start).format('YYYY-MM-DD'),
	      disablePrivateClass: (0, _R.userCan)('create_private_lesson') != true,
	      disableClass: (0, _R.userCan)('create_lesson') != true
	    }).then(function (result) {
	      _this2.props.onNavigate(result.response_datetime);
	    });
	  };
	
	  ClassCalendar.prototype.onSelectEvent = function onSelectEvent(lessonRaw, _ref2) {
	    var currentTarget = _ref2.currentTarget;
	
	    this.setState({
	      showLessonFloat: true,
	      lessonEventTarget: currentTarget,
	      lessonEvent: new _Lesson2.default(lessonRaw)
	    });
	  };
	
	  ClassCalendar.prototype.closeFloat = function closeFloat() {
	    this.setState({
	      showLessonFloat: false,
	      lessonEventTarget: null,
	      lessonEvent: null
	    });
	  };
	
	  //
	  // event is a reserved word in javascript
	  //
	
	
	  ClassCalendar.prototype._eventPropGetter = function _eventPropGetter(evnt) {
	    return {
	      style: {
	        borderLeft: "6px solid " + (evnt.calendarColor || "#2196F3"),
	        backgroundColor: (0, _color2.default)(evnt.calendarColor || "#aaa").fade(0.88)
	      }
	    };
	  };
	
	  ClassCalendar.prototype.render = function render() {
	    var _props = this.props,
	        events = _props.events,
	        timeslots = _props.timeslots,
	        onEventDrop = _props.onEventDrop,
	        components = _props.components,
	        onNavigate = _props.onNavigate,
	        fetching = _props.fetching,
	        date = _props.date;
	    var _state = this.state,
	        showLessonFloat = _state.showLessonFloat,
	        lessonEventTarget = _state.lessonEventTarget,
	        lessonEvent = _state.lessonEvent;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('class-calendar', { 'fetching': fetching }) },
	      fetching && _react2.default.createElement(_Loading2.default, { onPanel: true }),
	      _react2.default.createElement(Calendar, {
	        selectable: true,
	        popup: true,
	        events: events,
	        defaultView: DEFAULT_VIEW,
	        min: new Date(0, 0, 0, 6, 0, 0, 0),
	        max: new Date(0, 0, 0, 23, 59, 59, 59),
	        date: date,
	        views: ['month', 'week', 'day'],
	        step: 15,
	        components: _extends({
	          event: _Event2.default
	        }, components),
	        timeslots: timeslots,
	        onNavigate: onNavigate,
	        onSelectSlot: this.onSelectSlot,
	        onSelectEvent: this.onSelectEvent,
	        onEventDrop: onEventDrop,
	        formats: formats,
	        eventPropGetter: this._eventPropGetter
	      }),
	      _react2.default.createElement(_LessonFloat2.default, {
	        lesson: lessonEvent,
	        show: showLessonFloat,
	        target: lessonEventTarget,
	        onCloseFloat: this.closeFloat,
	        onChange: function onChange(res) {
	          if (res) {
	            onNavigate(res.start_datetime);
	          } else {
	            onNavigate();
	          }
	        }
	      })
	    );
	  };
	
	  return ClassCalendar;
	}(_react2.default.Component);
	
	exports.default = ClassCalendar;
	module.exports = exports['default'];

/***/ },

/***/ "f1fD":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Calendar = __webpack_require__("kZBB");
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _EventWrapper = __webpack_require__("toeV");
	
	var _EventWrapper2 = _interopRequireDefault(_EventWrapper);
	
	var _BackgroundWrapper = __webpack_require__("0+GY");
	
	var _BackgroundWrapper2 = _interopRequireDefault(_BackgroundWrapper);
	
	var _localizer = __webpack_require__("HcfL");
	
	var _moment = __webpack_require__("CD9V");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _globalize = __webpack_require__("wbDg");
	
	var _globalize2 = _interopRequireDefault(_globalize);
	
	var _move = __webpack_require__("xDXj");
	
	var _move2 = _interopRequireDefault(_move);
	
	var _constants = __webpack_require__("hYBH");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.assign(_Calendar2.default, {
	  setLocalizer: _localizer.set,
	  globalizeLocalizer: _globalize2.default,
	  momentLocalizer: _moment2.default,
	  Views: _constants.views,
	  Navigate: _constants.navigate,
	  move: _move2.default,
	  components: {
	    eventWrapper: _EventWrapper2.default,
	    dayWrapper: _BackgroundWrapper2.default,
	    dateCellWrapper: _BackgroundWrapper2.default
	  }
	});
	
	exports.default = _Calendar2.default;
	module.exports = exports['default'];

/***/ },

/***/ "kZBB":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp2, _initialiseProps;
	
	// 
	// Customized start
	//
	
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uncontrollable = __webpack_require__("8TnK");
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes3 = __webpack_require__("OBNG");
	
	var _helpers = __webpack_require__("FRUJ");
	
	var _constants = __webpack_require__("hYBH");
	
	var _formats = __webpack_require__("0kEA");
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _messages = __webpack_require__("m1jL");
	
	var _messages2 = _interopRequireDefault(_messages);
	
	var _move = __webpack_require__("xDXj");
	
	var _move2 = _interopRequireDefault(_move);
	
	var _Views = __webpack_require__("CEYp");
	
	var _Views2 = _interopRequireDefault(_Views);
	
	var _EventWrapper = __webpack_require__("toeV");
	
	var _EventWrapper2 = _interopRequireDefault(_EventWrapper);
	
	var _BackgroundWrapper = __webpack_require__("0+GY");
	
	var _BackgroundWrapper2 = _interopRequireDefault(_BackgroundWrapper);
	
	var _omit = __webpack_require__("Dc7M");
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _defaults = __webpack_require__("Lpou");
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	var _transform = __webpack_require__("k3HL");
	
	var _transform2 = _interopRequireDefault(_transform);
	
	var _mapValues = __webpack_require__("94Kh");
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _classtopReactBigCalendar = __webpack_require__("I8UM");
	
	__webpack_require__("drs3");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// 
	// Customzied end
	//
	
	function viewNames(_views) {
	  return !Array.isArray(_views) ? Object.keys(_views) : _views;
	}
	
	function isValidView(view, _ref) {
	  var _views = _ref.views;
	
	  var names = viewNames(_views);
	  return names.indexOf(view) !== -1;
	}
	
	var now = new Date();
	
	/**
	 * react-big-calendar is full featured Calendar component for managing events and dates. It uses
	 * modern `flexbox` for layout making it super responsive and performant. Leaving most of the layout heavy lifting
	 * to the browser. __note:__ The default styles use `height: 100%` which means your container must set an explicit
	 * height (feel free to adjust the styles to suit your specific needs).
	 *
	 * Big Calendar is unopiniated about editing and moving events, prefering to let you implement it in a way that makes
	 * the most sense to your app. It also tries not to be prescriptive about your event data structures, just tell it
	 * how to find the start and end datetimes and you can pass it whatever you want.
	 *
	 * One thing to note is that, `react-big-calendar` treats event start/end dates as an _exclusive_ range.
	 * which means that the event spans up to, but not including, the end date. In the case
	 * of displaying events on whole days, end dates are rounded _up_ to the next day. So an
	 * event ending on `Apr 8th 12:00:00 am` will not appear on the 8th, whereas one ending
	 * on `Apr 8th 12:01:00 am` will. If you want _inclusive_ ranges consider providing a
	 * function `endAccessor` that returns the end date + 1 day for those events that end at midnight.
	 */
	var Calendar = (_temp2 = _class = function (_React$Component) {
	  _inherits(Calendar, _React$Component);
	
	  function Calendar() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Calendar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Calendar.prototype.render = function render() {
	    var _props = this.props,
	        view = _props.view,
	        toolbar = _props.toolbar,
	        events = _props.events,
	        culture = _props.culture,
	        _props$components = _props.components,
	        components = _props$components === undefined ? {} : _props$components,
	        _props$formats = _props.formats,
	        formats = _props$formats === undefined ? {} : _props$formats,
	        _props$messages = _props.messages,
	        messages = _props$messages === undefined ? {} : _props$messages,
	        style = _props.style,
	        className = _props.className,
	        elementProps = _props.elementProps,
	        current = _props.date,
	        length = _props.length,
	        props = _objectWithoutProperties(_props, ['view', 'toolbar', 'events', 'culture', 'components', 'formats', 'messages', 'style', 'className', 'elementProps', 'date', 'length']);
	
	    formats = (0, _formats2.default)(formats);
	    messages = (0, _messages2.default)(messages);
	
	    var View = this.getView();
	    var names = viewNames(this.props.views);
	
	    var viewComponents = (0, _defaults2.default)(components[view] || {}, (0, _omit2.default)(components, names), {
	      eventWrapper: _EventWrapper2.default,
	      dayWrapper: _BackgroundWrapper2.default,
	      dateCellWrapper: _BackgroundWrapper2.default
	    });
	
	    var CalToolbar = components.toolbar || _classtopReactBigCalendar.Toolbar;
	    var label = View.title(current, { formats: formats, culture: culture, length: length });
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, elementProps, {
	        className: (0, _classnames2.default)('rbc-calendar', className, {
	          'rbc-rtl': props.rtl
	        }),
	        style: style
	      }),
	      toolbar && _react2.default.createElement(CalToolbar, {
	        date: current,
	        view: view,
	        views: names,
	        label: label,
	        onViewChange: this.handleViewChange,
	        onNavigate: this.handleNavigate,
	        messages: messages
	      }),
	      _react2.default.createElement(View, _extends({
	        ref: 'view'
	      }, props, formats, {
	        messages: messages,
	        culture: culture,
	        formats: undefined,
	        events: events,
	        date: current,
	        length: length,
	        components: viewComponents,
	        getDrilldownView: this.getDrilldownView,
	        onNavigate: this.handleNavigate,
	        onDrillDown: this.handleDrillDown,
	        onSelectEvent: this.handleSelectEvent,
	        onDoubleClickEvent: this.handleDoubleClickEvent,
	        onSelectSlot: this.handleSelectSlot,
	        onShowMore: this._showMore
	      }))
	    );
	  };
	
	  return Calendar;
	}(_react2.default.Component), _class.defaultProps = {
	  elementProps: {},
	  popup: false,
	  toolbar: true,
	  view: _constants.views.MONTH,
	  views: [_constants.views.MONTH, _constants.views.WEEK, _constants.views.DAY, _constants.views.AGENDA],
	  date: now,
	  step: 30,
	  length: 30,
	
	  drilldownView: _constants.views.DAY,
	
	  titleAccessor: 'title',
	  allDayAccessor: 'allDay',
	  startAccessor: 'start',
	  endAccessor: 'end',
	
	  longPressThreshold: 250
	}, _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.getViews = function () {
	    var views = _this2.props.views;
	
	    if (Array.isArray(views)) {
	      return (0, _transform2.default)(views, function (obj, name) {
	        return obj[name] = _Views2.default[name];
	      }, {});
	    }
	
	    if ((typeof views === 'undefined' ? 'undefined' : _typeof(views)) === 'object') {
	      return (0, _mapValues2.default)(views, function (value, key) {
	        if (value === true) {
	          return _Views2.default[key];
	        }
	
	        return value;
	      });
	    }
	
	    return _Views2.default;
	  };
	
	  this.getView = function () {
	    var views = _this2.getViews();
	
	    return views[_this2.props.view];
	  };
	
	  this.getDrilldownView = function (date) {
	    var _props2 = _this2.props,
	        view = _props2.view,
	        drilldownView = _props2.drilldownView,
	        getDrilldownView = _props2.getDrilldownView;
	
	
	    if (!getDrilldownView) return drilldownView;
	
	    return getDrilldownView(date, view, Object.keys(_this2.getViews()));
	  };
	
	  this.handleNavigate = function (action, newDate) {
	    var _props3 = _this2.props,
	        view = _props3.view,
	        date = _props3.date,
	        onNavigate = _props3.onNavigate,
	        props = _objectWithoutProperties(_props3, ['view', 'date', 'onNavigate']);
	
	    var ViewComponent = _this2.getView();
	
	    date = (0, _move2.default)(ViewComponent, _extends({}, props, {
	      action: action,
	      date: newDate || date
	    }));
	
	    onNavigate(date, view, action);
	  };
	
	  this.handleViewChange = function (view) {
	    if (view !== _this2.props.view && isValidView(view, _this2.props)) _this2.props.onView(view);
	  };
	
	  this.handleSelectEvent = function () {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    (0, _helpers.notify)(_this2.props.onSelectEvent, args);
	  };
	
	  this.handleDoubleClickEvent = function () {
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    (0, _helpers.notify)(_this2.props.onDoubleClickEvent, args);
	  };
	
	  this.handleSelectSlot = function (slotInfo) {
	    (0, _helpers.notify)(_this2.props.onSelectSlot, slotInfo);
	  };
	
	  this.handleDrillDown = function (date, view) {
	    var onDrillDown = _this2.props.onDrillDown;
	
	    if (onDrillDown) {
	      onDrillDown(date, view, _this2.drilldownView);
	      return;
	    }
	    if (view) _this2.handleViewChange(view);
	
	    _this2.handleNavigate(_constants.navigate.DATE, date);
	  };
	}, _temp2);
	exports.default = (0, _uncontrollable2.default)(Calendar, {
	  view: 'onView',
	  date: 'onNavigate',
	  selected: 'onSelectEvent'
	});
	module.exports = exports['default'];

/***/ },

/***/ "OBNG":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.views = exports.dateRangeFormat = exports.dateFormat = exports.accessor = exports.eventComponent = exports.elementType = undefined;
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _localizer = __webpack_require__("HcfL");
	
	var _localizer2 = _interopRequireDefault(_localizer);
	
	var _elementType = __webpack_require__("Gw9Y");
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _all = __webpack_require__("mj2h");
	
	var _all2 = _interopRequireDefault(_all);
	
	var _constants = __webpack_require__("hYBH");
	
	var _createChainableTypeChecker = __webpack_require__("3h+7");
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.elementType = _elementType2.default;
	
	// export contextShape = React.PropTypes.shape({
	//   formats: React.PropTypes.object.isRequired,
	//   messages: React.PropTypes.object.isRequired,
	//   accessors: React.PropTypes.shape({
	//     titleAccessor: accessor,
	//     startAccessor: accessor,
	//     endAccessor: accessor,
	//     allDayAccessor: accessor,
	//   }).isRequired,
	// }).isRequired,
	
	var eventComponent = exports.eventComponent = _propTypes2.default.oneOfType([_elementType2.default, _propTypes2.default.shape({
	  month: _elementType2.default,
	  week: _elementType2.default,
	  day: _elementType2.default,
	  agenda: _elementType2.default
	})]);
	
	var viewNames = Object.keys(_constants.views).map(function (k) {
	  return _constants.views[k];
	});
	
	var accessor = exports.accessor = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]);
	
	var dateFormat = exports.dateFormat = (0, _createChainableTypeChecker2.default)(function () {
	  return _localizer2.default.propType && _localizer2.default.propType.apply(_localizer2.default, arguments);
	});
	
	var dateRangeFormat = exports.dateRangeFormat = _propTypes2.default.func;
	
	/**
	 * accepts either an array of builtin view names:
	 *
	 * ```
	 * views={['month', 'day', 'agenda']}
	 * ```
	 *
	 * or an object hash of the view name and the component (or boolean for builtin)
	 *
	 * ```
	 * views={{
	 *   month: true,
	 *   week: false,
	 *   workweek: WorkWeekViewComponent,
	 * }}
	 * ```
	 */
	var views = exports.views = _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.oneOf(viewNames)), (0, _all2.default)(_propTypes2.default.object, function (props, name) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var prop = props[name],
	      err = void 0;
	
	  Object.keys(prop).every(function (key) {
	    var isBuiltinView = viewNames.indexOf(key) !== -1 && typeof prop[key] === 'boolean';
	
	    return isBuiltinView || !(err = _elementType2.default.apply(undefined, [prop, key].concat(args)));
	  });
	
	  return err || null;
	})]);

/***/ },

/***/ "HcfL":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.set = set;
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__("crWv");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var localePropType = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]);
	
	function _format(localizer, formatter, value, format, culture) {
	  var result = typeof format === 'function' ? format(value, culture, localizer) : formatter.call(localizer, value, format, culture);
	
	  (0, _invariant2.default)(result == null || typeof result === 'string', '`localizer format(..)` must return a string, null, or undefined');
	
	  return result;
	}
	
	var DateLocalizer = function DateLocalizer(spec) {
	  var _this = this;
	
	  _classCallCheck(this, DateLocalizer);
	
	  (0, _invariant2.default)(typeof spec.format === 'function', 'date localizer `format(..)` must be a function');
	  (0, _invariant2.default)(typeof spec.parse === 'function', 'date localizer `parse(..)` must be a function');
	  (0, _invariant2.default)(typeof spec.firstOfWeek === 'function', 'date localizer `firstOfWeek(..)` must be a function');
	
	  this.propType = spec.propType || localePropType;
	
	  this.formats = spec.formats;
	  this.startOfWeek = spec.firstOfWeek;
	
	  this.format = function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _format.apply(undefined, [_this, spec.format].concat(args));
	  };
	
	  this.parse = function (value, format, culture) {
	    var result = spec.parse.call(_this, value, format, culture);
	
	    (0, _invariant2.default)(result == null || result instanceof Date && !isNaN(result.getTime()), 'date localizer `parse(..)` must return a valid Date, null, or undefined');
	
	    return result;
	  };
	};
	
	var localizer = {
	  parse: error,
	  format: error,
	  startOfWeek: error
	};
	
	function set(newLocalizer) {
	  if (!newLocalizer.__isLocalizer__) {
	    newLocalizer = new DateLocalizer(newLocalizer);
	    newLocalizer.__isLocalizer__ = true;
	  }
	
	  localizer = newLocalizer;
	  return localizer;
	}
	
	var exp = {
	  parse: function parse() {
	    var _localizer;
	
	    return (_localizer = localizer).parse.apply(_localizer, arguments);
	  },
	  format: function format() {
	    var _localizer2;
	
	    return (_localizer2 = localizer).format.apply(_localizer2, arguments);
	  },
	  startOfWeek: function startOfWeek() {
	    var _localizer3;
	
	    return (_localizer3 = localizer).startOfWeek.apply(_localizer3, arguments);
	  }
	};
	
	exports.default = exp;
	
	
	function error() {
	  throw new Error('You have not selected a localization strategy for Big Calendar. ' + 'Please use either of the two included.');
	}

/***/ },

/***/ "FRUJ":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.notify = notify;
	exports.instanceId = instanceId;
	exports.isFirstFocusedRender = isFirstFocusedRender;
	var idCount = 0;
	
	function uniqueId(prefix) {
	  return '' + ((prefix == null ? '' : prefix) + ++idCount);
	}
	
	function notify(handler, args) {
	  handler && handler.apply(null, [].concat(args));
	}
	
	function instanceId(component) {
	  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  component.__id || (component.__id = uniqueId('rw_'));
	  return (component.props.id || component.__id) + suffix;
	}
	
	function isFirstFocusedRender(component) {
	  return component._firstFocus || component.state.focused && (component._firstFocus = true);
	}

/***/ },

/***/ "0kEA":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.set = set;
	exports.default = format;
	
	var _dates = __webpack_require__("4PJJ");
	
	var _dates2 = _interopRequireDefault(_dates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function inSame12Hr(start, end) {
	  var s = 12 - _dates2.default.hours(start);
	  var e = 12 - _dates2.default.hours(end);
	  return s <= 0 && e <= 0 || s >= 0 && e >= 0;
	}
	
	var dateRangeFormat = function dateRangeFormat(_ref, culture, local) {
	  var start = _ref.start,
	      end = _ref.end;
	  return local.format(start, 'd', culture) + ' — ' + local.format(end, 'd', culture);
	};
	
	var timeRangeFormat = function timeRangeFormat(_ref2, culture, local) {
	  var start = _ref2.start,
	      end = _ref2.end;
	  return local.format(start, 'h:mmtt', culture) + ' — ' + local.format(end, inSame12Hr(start, end) ? 'h:mm' : 'h:mmtt', culture);
	};
	
	var timeRangeStartFormat = function timeRangeStartFormat(_ref3, culture, local) {
	  var start = _ref3.start,
	      end = _ref3.end;
	  return local.format(start, 'h:mmtt', culture) + ' — ';
	};
	
	var timeRangeEndFormat = function timeRangeEndFormat(_ref4, culture, local) {
	  var start = _ref4.start,
	      end = _ref4.end;
	  return ' — ' + local.format(end, 'h:mmtt', culture);
	};
	
	var weekRangeFormat = function weekRangeFormat(_ref5, culture, local) {
	  var start = _ref5.start,
	      end = _ref5.end;
	  return local.format(start, 'MMM dd', culture) + ' - ' + local.format(end, _dates2.default.eq(start, end, 'month') ? 'dd' : 'MMM dd', culture);
	};
	
	var formats = {
	
	  dateFormat: 'dd',
	  dayFormat: 'ddd dd/MM',
	  weekdayFormat: 'ddd',
	
	  selectRangeFormat: timeRangeFormat,
	  eventTimeRangeFormat: timeRangeFormat,
	  eventTimeRangeStartFormat: timeRangeStartFormat,
	  eventTimeRangeEndFormat: timeRangeEndFormat,
	
	  timeGutterFormat: 'h:mm tt',
	
	  monthHeaderFormat: 'MMMM yyyy',
	  dayHeaderFormat: 'dddd MMM dd',
	  dayRangeHeaderFormat: weekRangeFormat,
	  agendaHeaderFormat: dateRangeFormat,
	
	  agendaDateFormat: 'ddd MMM dd',
	  agendaTimeFormat: 'hh:mm tt',
	  agendaTimeRangeFormat: timeRangeFormat
	};
	
	function set(_formats) {
	  var _formats2;
	
	  if (arguments.length > 1) _formats = (_formats2 = {}, _formats2[_formats] = arguments[1], _formats2);
	
	  Object.assign(formats, _formats);
	}
	
	function format(fmts) {
	  return _extends({}, formats, fmts);
	}

/***/ },

/***/ "4PJJ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint no-fallthrough: off */
	
	
	var _dateArithmetic = __webpack_require__("uyOA");
	
	var _dateArithmetic2 = _interopRequireDefault(_dateArithmetic);
	
	var _localizer = __webpack_require__("HcfL");
	
	var _localizer2 = _interopRequireDefault(_localizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLI = {
	  seconds: 1000,
	  minutes: 1000 * 60,
	  hours: 1000 * 60 * 60,
	  day: 1000 * 60 * 60 * 24
	};
	
	var MONTHS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
	
	var dates = _extends({}, _dateArithmetic2.default, {
	  monthsInYear: function monthsInYear(year) {
	    var date = new Date(year, 0, 1);
	
	    return MONTHS.map(function (i) {
	      return dates.month(date, i);
	    });
	  },
	  firstVisibleDay: function firstVisibleDay(date, culture) {
	    var firstOfMonth = dates.startOf(date, 'month');
	
	    return dates.startOf(firstOfMonth, 'week', _localizer2.default.startOfWeek(culture));
	  },
	  lastVisibleDay: function lastVisibleDay(date, culture) {
	    var endOfMonth = dates.endOf(date, 'month');
	
	    return dates.endOf(endOfMonth, 'week', _localizer2.default.startOfWeek(culture));
	  },
	  visibleDays: function visibleDays(date, culture) {
	    var current = dates.firstVisibleDay(date, culture),
	        last = dates.lastVisibleDay(date, culture),
	        days = [];
	
	    while (dates.lte(current, last, 'day')) {
	      days.push(current);
	      current = dates.add(current, 1, 'day');
	    }
	
	    return days;
	  },
	  ceil: function ceil(date, unit) {
	    var floor = dates.startOf(date, unit);
	
	    return dates.eq(floor, date) ? floor : dates.add(floor, 1, unit);
	  },
	  range: function range(start, end) {
	    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
	
	    var current = start,
	        days = [];
	
	    while (dates.lte(current, end, unit)) {
	      days.push(current);
	      current = dates.add(current, 1, unit);
	    }
	
	    return days;
	  },
	  merge: function merge(date, time) {
	    if (time == null && date == null) return null;
	
	    if (time == null) time = new Date();
	    if (date == null) date = new Date();
	
	    date = dates.startOf(date, 'day');
	    date = dates.hours(date, dates.hours(time));
	    date = dates.minutes(date, dates.minutes(time));
	    date = dates.seconds(date, dates.seconds(time));
	    return dates.milliseconds(date, dates.milliseconds(time));
	  },
	  sameMonth: function sameMonth(dateA, dateB) {
	    return dates.eq(dateA, dateB, 'month');
	  },
	  isToday: function isToday(date) {
	    return dates.eq(date, dates.today(), 'day');
	  },
	  eqTime: function eqTime(dateA, dateB) {
	    return dates.hours(dateA) === dates.hours(dateB) && dates.minutes(dateA) === dates.minutes(dateB) && dates.seconds(dateA) === dates.seconds(dateB);
	  },
	  isJustDate: function isJustDate(date) {
	    return dates.hours(date) === 0 && dates.minutes(date) === 0 && dates.seconds(date) === 0 && dates.milliseconds(date) === 0;
	  },
	  duration: function duration(start, end, unit, firstOfWeek) {
	    if (unit === 'day') unit = 'date';
	    return Math.abs(dates[unit](start, undefined, firstOfWeek) - dates[unit](end, undefined, firstOfWeek));
	  },
	  diff: function diff(dateA, dateB, unit) {
	    if (!unit || unit === 'milliseconds') return Math.abs(+dateA - +dateB);
	
	    // the .round() handles an edge case
	    // with DST where the total won't be exact
	    // since one day in the range may be shorter/longer by an hour
	    return Math.round(Math.abs(+dates.startOf(dateA, unit) / MILLI[unit] - +dates.startOf(dateB, unit) / MILLI[unit]));
	  },
	  total: function total(date, unit) {
	    var ms = date.getTime(),
	        div = 1;
	
	    switch (unit) {
	      case 'week':
	        div *= 7;
	      case 'day':
	        div *= 24;
	      case 'hours':
	        div *= 60;
	      case 'minutes':
	        div *= 60;
	      case 'seconds':
	        div *= 1000;
	    }
	
	    return ms / div;
	  },
	  week: function week(date) {
	    var d = new Date(date);
	    d.setHours(0, 0, 0);
	    d.setDate(d.getDate() + 4 - (d.getDay() || 7));
	    return Math.ceil(((d - new Date(d.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
	  },
	  today: function today() {
	    return dates.startOf(new Date(), 'day');
	  },
	  yesterday: function yesterday() {
	    return dates.add(dates.startOf(new Date(), 'day'), -1, 'day');
	  },
	  tomorrow: function tomorrow() {
	    return dates.add(dates.startOf(new Date(), 'day'), 1, 'day');
	  }
	});
	
	exports.default = dates;
	module.exports = exports['default'];

/***/ },

/***/ "m1jL":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.set = set;
	exports.result = result;
	exports.default = messages;
	
	var _invariant = __webpack_require__("crWv");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultMessages = {
	  date: 'Date',
	  time: 'Time',
	  event: 'Event',
	  allDay: 'all day',
	  week: 'week',
	  work_week: 'work week',
	  day: 'day',
	  month: 'month',
	  previous: 'back',
	  next: 'next',
	  yesterday: 'yesterday',
	  tomorrow: 'tomorrow',
	  today: 'today',
	  agenda: 'agenda',
	
	  showMore: function showMore(total) {
	    return '+' + total + ' more';
	  }
	};
	
	function set(key, msg) {
	  (0, _invariant2.default)(messages.hasOwnProperty(key), 'The message key: "' + key + '" is not a valid message name. ' + ('valid keys are: ' + Object.keys(messages).join(', ')));
	
	  messages[key] = msg;
	}
	
	function result(msg) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return typeof msg === 'function' ? msg(args) : msg;
	}
	
	function messages(msgs) {
	  return _extends({}, defaultMessages, msgs);
	}

/***/ },

/***/ "xDXj":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = moveDate;
	
	var _invariant = __webpack_require__("crWv");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _constants = __webpack_require__("hYBH");
	
	var _Views = __webpack_require__("CEYp");
	
	var _Views2 = _interopRequireDefault(_Views);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function moveDate(View, _ref) {
	  var action = _ref.action,
	      date = _ref.date,
	      props = _objectWithoutProperties(_ref, ['action', 'date']);
	
	  View = typeof View === 'string' ? _Views2.default[View] : View;
	
	  switch (action) {
	    case _constants.navigate.TODAY:
	      date = new Date();
	      break;
	    case _constants.navigate.DATE:
	      break;
	    default:
	      (0, _invariant2.default)(View && typeof View.navigate === 'function', 'Calendar View components must implement a static `.navigate(date, action)` method.s');
	      date = View.navigate(date, action, props);
	  }
	  return date;
	}
	module.exports = exports['default'];

/***/ },

/***/ "CEYp":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _VIEWS;
	
	var _constants = __webpack_require__("hYBH");
	
	var _Month = __webpack_require__("0b7y");
	
	var _Month2 = _interopRequireDefault(_Month);
	
	var _Day = __webpack_require__("wad3");
	
	var _Day2 = _interopRequireDefault(_Day);
	
	var _Week = __webpack_require__("PMxY");
	
	var _Week2 = _interopRequireDefault(_Week);
	
	var _WorkWeek = __webpack_require__("6n5U");
	
	var _WorkWeek2 = _interopRequireDefault(_WorkWeek);
	
	var _Agenda = __webpack_require__("1oB+");
	
	var _Agenda2 = _interopRequireDefault(_Agenda);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VIEWS = (_VIEWS = {}, _VIEWS[_constants.views.MONTH] = _Month2.default, _VIEWS[_constants.views.WEEK] = _Week2.default, _VIEWS[_constants.views.WORK_WEEK] = _WorkWeek2.default, _VIEWS[_constants.views.DAY] = _Day2.default, _VIEWS[_constants.views.AGENDA] = _Agenda2.default, _VIEWS);
	
	exports.default = VIEWS;
	module.exports = exports['default'];

/***/ },

/***/ "0b7y":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp, _initialiseProps;
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("O27J");
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dates = __webpack_require__("4PJJ");
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizer = __webpack_require__("HcfL");
	
	var _localizer2 = _interopRequireDefault(_localizer);
	
	var _chunk = __webpack_require__("O3gb");
	
	var _chunk2 = _interopRequireDefault(_chunk);
	
	var _constants = __webpack_require__("hYBH");
	
	var _helpers = __webpack_require__("FRUJ");
	
	var _position = __webpack_require__("+ltG");
	
	var _position2 = _interopRequireDefault(_position);
	
	var _requestAnimationFrame = __webpack_require__("lSD1");
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _Popup = __webpack_require__("Fhac");
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Overlay = __webpack_require__("JHr2");
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _DateContentRow = __webpack_require__("ZuRK");
	
	var _DateContentRow2 = _interopRequireDefault(_DateContentRow);
	
	var _Header = __webpack_require__("TpKw");
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _DateHeader = __webpack_require__("r76b");
	
	var _DateHeader2 = _interopRequireDefault(_DateHeader);
	
	var _propTypes3 = __webpack_require__("OBNG");
	
	var _eventLevels = __webpack_require__("SjBY");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var eventsForWeek = function eventsForWeek(evts, start, end, props) {
	  return evts.filter(function (e) {
	    return (0, _eventLevels.inRange)(e, start, end, props);
	  });
	};
	
	var propTypes = {
	  events: _propTypes2.default.array.isRequired,
	  date: _propTypes2.default.instanceOf(Date),
	
	  min: _propTypes2.default.instanceOf(Date),
	  max: _propTypes2.default.instanceOf(Date),
	
	  step: _propTypes2.default.number,
	  now: _propTypes2.default.instanceOf(Date),
	
	  scrollToTime: _propTypes2.default.instanceOf(Date),
	  eventPropGetter: _propTypes2.default.func,
	  dayPropGetter: _propTypes2.default.func,
	
	  culture: _propTypes2.default.string,
	  dayFormat: _propTypes3.dateFormat,
	
	  rtl: _propTypes2.default.bool,
	  width: _propTypes2.default.number,
	
	  titleAccessor: _propTypes3.accessor.isRequired,
	  allDayAccessor: _propTypes3.accessor.isRequired,
	  startAccessor: _propTypes3.accessor.isRequired,
	  endAccessor: _propTypes3.accessor.isRequired,
	
	  selected: _propTypes2.default.object,
	  selectable: _propTypes2.default.oneOf([true, false, 'ignoreEvents']),
	  longPressThreshold: _propTypes2.default.number,
	
	  onNavigate: _propTypes2.default.func,
	  onSelectSlot: _propTypes2.default.func,
	  onSelectEvent: _propTypes2.default.func,
	  onDoubleClickEvent: _propTypes2.default.func,
	  onShowMore: _propTypes2.default.func,
	  onDrillDown: _propTypes2.default.func,
	  getDrilldownView: _propTypes2.default.func.isRequired,
	
	  dateFormat: _propTypes3.dateFormat,
	
	  weekdayFormat: _propTypes3.dateFormat,
	  popup: _propTypes2.default.bool,
	
	  messages: _propTypes2.default.object,
	  components: _propTypes2.default.object.isRequired,
	  popupOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  })])
	};
	
	var MonthView = (_temp = _class = function (_React$Component) {
	  _inherits(MonthView, _React$Component);
	
	  function MonthView() {
	    _classCallCheck(this, MonthView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args)));
	
	    _initialiseProps.call(_this);
	
	    _this._bgRows = [];
	    _this._pendingSelection = [];
	    _this.state = {
	      rowLimit: 5,
	      needLimitMeasure: true
	    };
	    return _this;
	  }
	
	  MonthView.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var date = _ref.date;
	
	    this.setState({
	      needLimitMeasure: !_dates2.default.eq(date, this.props.date)
	    });
	  };
	
	  MonthView.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var running = void 0;
	
	    if (this.state.needLimitMeasure) this.measureRowLimit(this.props);
	
	    window.addEventListener('resize', this._resizeListener = function () {
	      if (!running) {
	        (0, _requestAnimationFrame2.default)(function () {
	          running = false;
	          _this2.setState({ needLimitMeasure: true }); //eslint-disable-line
	        });
	      }
	    }, false);
	  };
	
	  MonthView.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this.state.needLimitMeasure) this.measureRowLimit(this.props);
	  };
	
	  MonthView.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('resize', this._resizeListener, false);
	  };
	
	  MonthView.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        date = _props.date,
	        culture = _props.culture,
	        weekdayFormat = _props.weekdayFormat,
	        className = _props.className,
	        month = _dates2.default.visibleDays(date, culture),
	        weeks = (0, _chunk2.default)(month, 7);
	
	    this._weekCount = weeks.length;
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('rbc-month-view', className) },
	      _react2.default.createElement(
	        'div',
	        { className: 'rbc-row rbc-month-header' },
	        this.renderHeaders(weeks[0], weekdayFormat, culture)
	      ),
	      weeks.map(function (week, idx) {
	        return _this3.renderWeek(week, idx);
	      }),
	      this.props.popup && this.renderOverlay()
	    );
	  };
	
	  MonthView.prototype.renderHeaders = function renderHeaders(row, format, culture) {
	    var first = row[0];
	    var last = row[row.length - 1];
	    var HeaderComponent = this.props.components.header || _Header2.default;
	
	    return _dates2.default.range(first, last, 'day').map(function (day, idx) {
	      return _react2.default.createElement(
	        'div',
	        { key: 'header_' + idx, className: 'rbc-header', style: (0, _eventLevels.segStyle)(1, 7) },
	        _react2.default.createElement(HeaderComponent, {
	          date: day,
	          label: _localizer2.default.format(day, format, culture),
	          localizer: _localizer2.default,
	          format: format,
	          culture: culture
	        })
	      );
	    });
	  };
	
	  MonthView.prototype.renderOverlay = function renderOverlay() {
	    var _this4 = this;
	
	    var overlay = this.state && this.state.overlay || {};
	    var components = this.props.components;
	
	
	    return _react2.default.createElement(
	      _Overlay2.default,
	      {
	        rootClose: true,
	        placement: 'bottom',
	        container: this,
	        show: !!overlay.position,
	        onHide: function onHide() {
	          return _this4.setState({ overlay: null });
	        }
	      },
	      _react2.default.createElement(_Popup2.default, _extends({}, this.props, {
	        eventComponent: components.event,
	        eventWrapperComponent: components.eventWrapper,
	        position: overlay.position,
	        events: overlay.events,
	        slotStart: overlay.date,
	        slotEnd: overlay.end,
	        onSelect: this.handleSelectEvent
	      }))
	    );
	  };
	
	  MonthView.prototype.measureRowLimit = function measureRowLimit() {
	    this.setState({
	      needLimitMeasure: false,
	      rowLimit: this.refs.slotRow.getRowLimit()
	    });
	  };
	
	  MonthView.prototype.selectDates = function selectDates(slotInfo) {
	    var slots = this._pendingSelection.slice();
	
	    this._pendingSelection = [];
	
	    slots.sort(function (a, b) {
	      return +a - +b;
	    });
	
	    (0, _helpers.notify)(this.props.onSelectSlot, {
	      slots: slots,
	      start: slots[0],
	      end: slots[slots.length - 1],
	      action: slotInfo.action
	    });
	  };
	
	  MonthView.prototype.clearSelection = function clearSelection() {
	    clearTimeout(this._selectTimer);
	    this._pendingSelection = [];
	  };
	
	  return MonthView;
	}(_react2.default.Component), _class.displayName = 'MonthView', _class.defaultProps = {
	  now: new Date()
	}, _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.getContainer = function () {
	    return (0, _reactDom.findDOMNode)(_this5);
	  };
	
	  this.renderWeek = function (week, weekIdx) {
	    var _props2 = _this5.props,
	        events = _props2.events,
	        components = _props2.components,
	        selectable = _props2.selectable,
	        titleAccessor = _props2.titleAccessor,
	        startAccessor = _props2.startAccessor,
	        endAccessor = _props2.endAccessor,
	        allDayAccessor = _props2.allDayAccessor,
	        eventPropGetter = _props2.eventPropGetter,
	        dayPropGetter = _props2.dayPropGetter,
	        messages = _props2.messages,
	        selected = _props2.selected,
	        now = _props2.now,
	        date = _props2.date,
	        longPressThreshold = _props2.longPressThreshold;
	    var _state = _this5.state,
	        needLimitMeasure = _state.needLimitMeasure,
	        rowLimit = _state.rowLimit;
	
	
	    events = eventsForWeek(events, week[0], week[week.length - 1], _this5.props);
	    events.sort(function (a, b) {
	      return (0, _eventLevels.sortEvents)(a, b, _this5.props);
	    });
	
	    return _react2.default.createElement(_DateContentRow2.default, {
	      key: weekIdx,
	      ref: weekIdx === 0 ? 'slotRow' : undefined,
	      container: _this5.getContainer,
	      className: 'rbc-month-row',
	      now: now,
	      date: date,
	      range: week,
	      events: events,
	      maxRows: rowLimit,
	      selected: selected,
	      selectable: selectable,
	      messages: messages,
	      titleAccessor: titleAccessor,
	      startAccessor: startAccessor,
	      endAccessor: endAccessor,
	      allDayAccessor: allDayAccessor,
	      eventPropGetter: eventPropGetter,
	      dayPropGetter: dayPropGetter,
	      renderHeader: _this5.readerDateHeading,
	      renderForMeasure: needLimitMeasure,
	      onShowMore: _this5.handleShowMore,
	      onSelect: _this5.handleSelectEvent,
	      onDoubleClick: _this5.handleDoubleClickEvent,
	      onSelectSlot: _this5.handleSelectSlot,
	      eventComponent: components.event,
	      eventWrapperComponent: components.eventWrapper,
	      dateCellWrapper: components.dateCellWrapper,
	      longPressThreshold: longPressThreshold
	    });
	  };
	
	  this.readerDateHeading = function (_ref2) {
	    var date = _ref2.date,
	        className = _ref2.className,
	        props = _objectWithoutProperties(_ref2, ['date', 'className']);
	
	    var _props3 = _this5.props,
	        currentDate = _props3.date,
	        getDrilldownView = _props3.getDrilldownView,
	        dateFormat = _props3.dateFormat,
	        culture = _props3.culture;
	
	
	    var isOffRange = _dates2.default.month(date) !== _dates2.default.month(currentDate);
	    var isCurrent = _dates2.default.eq(date, currentDate, 'day');
	    var drilldownView = getDrilldownView(date);
	    var label = _localizer2.default.format(date, dateFormat, culture);
	    var DateHeaderComponent = _this5.props.components.dateHeader || _DateHeader2.default;
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, props, {
	        className: (0, _classnames2.default)(className, isOffRange && 'rbc-off-range', isCurrent && 'rbc-current')
	      }),
	      _react2.default.createElement(DateHeaderComponent, {
	        label: label,
	        date: date,
	        drilldownView: drilldownView,
	        isOffRange: isOffRange,
	        onDrillDown: function onDrillDown(e) {
	          return _this5.handleHeadingClick(date, drilldownView, e);
	        } })
	    );
	  };
	
	  this.handleSelectSlot = function (range, slotInfo) {
	    _this5._pendingSelection = _this5._pendingSelection.concat(range);
	
	    clearTimeout(_this5._selectTimer);
	    _this5._selectTimer = setTimeout(function () {
	      return _this5.selectDates(slotInfo);
	    });
	  };
	
	  this.handleHeadingClick = function (date, view, e) {
	    e.preventDefault();
	    _this5.clearSelection();
	    (0, _helpers.notify)(_this5.props.onDrillDown, [date, view]);
	  };
	
	  this.handleSelectEvent = function () {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    _this5.clearSelection();
	    (0, _helpers.notify)(_this5.props.onSelectEvent, args);
	  };
	
	  this.handleDoubleClickEvent = function () {
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    _this5.clearSelection();
	    (0, _helpers.notify)(_this5.props.onDoubleClickEvent, args);
	  };
	
	  this.handleShowMore = function (events, date, cell, slot) {
	    var _props4 = _this5.props,
	        popup = _props4.popup,
	        onDrillDown = _props4.onDrillDown,
	        onShowMore = _props4.onShowMore,
	        getDrilldownView = _props4.getDrilldownView;
	    //cancel any pending selections so only the event click goes through.
	
	    _this5.clearSelection();
	
	    if (popup) {
	      var position = (0, _position2.default)(cell, (0, _reactDom.findDOMNode)(_this5));
	
	      _this5.setState({
	        overlay: { date: date, events: events, position: position }
	      });
	    } else {
	      (0, _helpers.notify)(onDrillDown, [date, getDrilldownView(date) || _constants.views.DAY]);
	    }
	
	    (0, _helpers.notify)(onShowMore, [events, date, slot]);
	  };
	}, _temp);
	
	
	MonthView.navigate = function (date, action) {
	  switch (action) {
	    case _constants.navigate.PREVIOUS:
	      return _dates2.default.add(date, -1, 'month');
	
	    case _constants.navigate.NEXT:
	      return _dates2.default.add(date, 1, 'month');
	
	    default:
	      return date;
	  }
	};
	
	MonthView.title = function (date, _ref3) {
	  var formats = _ref3.formats,
	      culture = _ref3.culture;
	  return _localizer2.default.format(date, formats.monthHeaderFormat, culture);
	};
	
	exports.default = MonthView;
	module.exports = exports['default'];

/***/ },

/***/ "Fhac":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _offset = __webpack_require__("5zLc");
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _scrollTop = __webpack_require__("lJsr");
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _scrollLeft = __webpack_require__("mkah");
	
	var _scrollLeft2 = _interopRequireDefault(_scrollLeft);
	
	var _EventCell = __webpack_require__("H3l1");
	
	var _EventCell2 = _interopRequireDefault(_EventCell);
	
	var _selection = __webpack_require__("RGiR");
	
	var _localizer = __webpack_require__("HcfL");
	
	var _localizer2 = _interopRequireDefault(_localizer);
	
	var _propTypes3 = __webpack_require__("OBNG");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  position: _propTypes2.default.object,
	  popupOffset: _propTypes2.default.number,
	  events: _propTypes2.default.array,
	  selected: _propTypes2.default.object,
	  eventComponent: _propTypes3.elementType,
	  eventWrapperComponent: _propTypes3.elementType,
	  dayHeaderFormat: _propTypes3.dateFormat
	};
	
	var Popup = function (_React$Component) {
	  _inherits(Popup, _React$Component);
	
	  function Popup() {
	    _classCallCheck(this, Popup);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Popup.prototype.componentDidMount = function componentDidMount() {
	    var _props$popupOffset = this.props.popupOffset,
	        popupOffset = _props$popupOffset === undefined ? 5 : _props$popupOffset,
	        _getOffset = (0, _offset2.default)(this.refs.root),
	        top = _getOffset.top,
	        left = _getOffset.left,
	        width = _getOffset.width,
	        height = _getOffset.height,
	        viewBottom = window.innerHeight + (0, _scrollTop2.default)(window),
	        viewRight = window.innerWidth + (0, _scrollLeft2.default)(window),
	        bottom = top + height,
	        right = left + width;
	
	    if (bottom > viewBottom || right > viewRight) {
	      var topOffset = void 0,
	          leftOffset = void 0;
	
	      if (bottom > viewBottom) topOffset = bottom - viewBottom + (popupOffset.y || +popupOffset || 0);
	      if (right > viewRight) leftOffset = right - viewRight + (popupOffset.x || +popupOffset || 0);
	
	      this.setState({ topOffset: topOffset, leftOffset: leftOffset }); //eslint-disable-line
	    }
	  };
	
	  Popup.prototype.render = function render() {
	    var _props = this.props,
	        events = _props.events,
	        selected = _props.selected,
	        eventComponent = _props.eventComponent,
	        eventWrapperComponent = _props.eventWrapperComponent,
	        props = _objectWithoutProperties(_props, ['events', 'selected', 'eventComponent', 'eventWrapperComponent']);
	
	    var _props$position = this.props.position,
	        left = _props$position.left,
	        width = _props$position.width,
	        top = _props$position.top,
	        topOffset = (this.state || {}).topOffset || 0,
	        leftOffset = (this.state || {}).leftOffset || 0;
	
	
	    var style = {
	      top: Math.max(0, top - topOffset),
	      left: left - leftOffset,
	      minWidth: width + width / 2
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { ref: 'root', style: style, className: 'rbc-overlay' },
	      _react2.default.createElement(
	        'div',
	        { className: 'rbc-overlay-header' },
	        _localizer2.default.format(props.slotStart, props.dayHeaderFormat, props.culture)
	      ),
	      events.map(function (event, idx) {
	        return _react2.default.createElement(_EventCell2.default, _extends({ key: idx
	        }, props, {
	          event: event,
	          eventComponent: eventComponent,
	          eventWrapperComponent: eventWrapperComponent,
	          selected: (0, _selection.isSelected)(event, selected)
	        }));
	      })
	    );
	  };
	
	  return Popup;
	}(_react2.default.Component);
	
	exports.default = Popup;
	module.exports = exports['default'];

/***/ },

/***/ "H3l1":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dates = __webpack_require__("4PJJ");
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _propTypes3 = __webpack_require__("OBNG");
	
	var _accessors = __webpack_require__("Gtmz");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  event: _propTypes2.default.object.isRequired,
	  slotStart: _propTypes2.default.instanceOf(Date),
	  slotEnd: _propTypes2.default.instanceOf(Date),
	
	  selected: _propTypes2.default.bool,
	  eventPropGetter: _propTypes2.default.func,
	  titleAccessor: _propTypes3.accessor,
	  allDayAccessor: _propTypes3.accessor,
	  startAccessor: _propTypes3.accessor,
	  endAccessor: _propTypes3.accessor,
	
	  eventComponent: _propTypes3.elementType,
	  eventWrapperComponent: _propTypes3.elementType.isRequired,
	  onSelect: _propTypes2.default.func,
	  onDoubleClick: _propTypes2.default.func
	};
	
	var EventCell = function (_React$Component) {
	  _inherits(EventCell, _React$Component);
	
	  function EventCell() {
	    _classCallCheck(this, EventCell);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  EventCell.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        event = _props.event,
	        selected = _props.selected,
	        eventPropGetter = _props.eventPropGetter,
	        startAccessor = _props.startAccessor,
	        endAccessor = _props.endAccessor,
	        titleAccessor = _props.titleAccessor,
	        slotStart = _props.slotStart,
	        slotEnd = _props.slotEnd,
	        onSelect = _props.onSelect,
	        _onDoubleClick = _props.onDoubleClick,
	        Event = _props.eventComponent,
	        EventWrapper = _props.eventWrapperComponent,
	        props = _objectWithoutProperties(_props, ['className', 'event', 'selected', 'eventPropGetter', 'startAccessor', 'endAccessor', 'titleAccessor', 'slotStart', 'slotEnd', 'onSelect', 'onDoubleClick', 'eventComponent', 'eventWrapperComponent']);
	
	    var title = (0, _accessors.accessor)(event, titleAccessor),
	        end = (0, _accessors.accessor)(event, endAccessor),
	        start = (0, _accessors.accessor)(event, startAccessor),
	        isAllDay = (0, _accessors.accessor)(event, props.allDayAccessor),
	        continuesPrior = _dates2.default.lt(start, slotStart, 'day'),
	        continuesAfter = _dates2.default.gte(end, slotEnd, 'day');
	
	    if (eventPropGetter) var _eventPropGetter = eventPropGetter(event, start, end, selected),
	          style = _eventPropGetter.style,
	          xClassName = _eventPropGetter.className;
	
	    return _react2.default.createElement(
	      EventWrapper,
	      { event: event },
	      _react2.default.createElement(
	        'div',
	        {
	          style: _extends({}, props.style, style),
	          className: (0, _classnames2.default)('rbc-event', className, xClassName, {
	            'rbc-selected': selected,
	            'rbc-event-allday': isAllDay || _dates2.default.diff(start, _dates2.default.ceil(end, 'day'), 'day') > 1,
	            'rbc-event-continues-prior': continuesPrior,
	            'rbc-event-continues-after': continuesAfter
	          }),
	          onClick: function onClick(e) {
	            e.preventDefault();onSelect(event, e);
	          },
	          onDoubleClick: function onDoubleClick(e) {
	            return _onDoubleClick(event, e);
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'rbc-event-content', title: title },
	          Event ? _react2.default.createElement(Event, { event: event, title: title }) : title
	        )
	      )
	    );
	  };
	
	  return EventCell;
	}(_react2.default.Component);
	
	exports.default = EventCell;
	module.exports = exports['default'];

/***/ },

/***/ "Gtmz":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.accessor = accessor;
	function accessor(data, field) {
	  var value = null;
	
	  if (typeof field === 'function') value = field(data);else if (typeof field === 'string' && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && data != null && field in data) value = data[field];
	
	  return value;
	}

/***/ },

/***/ "RGiR":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isSelected = isSelected;
	exports.slotWidth = slotWidth;
	exports.getCellAtX = getCellAtX;
	exports.pointInBox = pointInBox;
	exports.dateCellSelection = dateCellSelection;
	function isSelected(event, selected) {
	  if (!event || selected == null) return false;
	  return [].concat(selected).indexOf(event) !== -1;
	}
	
	function slotWidth(rowBox, slots) {
	  var rowWidth = rowBox.right - rowBox.left;
	  var cellWidth = rowWidth / slots;
	
	  return cellWidth;
	}
	
	function getCellAtX(rowBox, x, cellWidth, rtl, slots) {
	  return rtl ? slots - 1 - Math.floor((x - rowBox.left) / cellWidth) : Math.floor((x - rowBox.left) / cellWidth);
	}
	
	function pointInBox(box, _ref) {
	  var x = _ref.x,
	      y = _ref.y;
	
	  return y >= box.top && y <= box.bottom && x >= box.left && x <= box.right;
	}
	
	function dateCellSelection(start, rowBox, box, slots, rtl) {
	  var startIdx = -1;
	  var endIdx = -1;
	  var lastSlotIdx = slots - 1;
	
	  var cellWidth = slotWidth(rowBox, slots);
	
	  // cell under the mouse
	  var currentSlot = getCellAtX(rowBox, box.x, cellWidth, rtl, slots);
	
	  // Identify row as either the initial row
	  // or the row under the current mouse point
	  var isCurrentRow = rowBox.top < box.y && rowBox.bottom > box.y;
	  var isStartRow = rowBox.top < start.y && rowBox.bottom > start.y;
	
	  // this row's position relative to the start point
	  var isAboveStart = start.y > rowBox.bottom;
	  var isBelowStart = rowBox.top > start.y;
	  var isBetween = box.top < rowBox.top && box.bottom > rowBox.bottom;
	
	  // this row is between the current and start rows, so entirely selected
	  if (isBetween) {
	    startIdx = 0;
	    endIdx = lastSlotIdx;
	  }
	
	  if (isCurrentRow) {
	    if (isBelowStart) {
	      startIdx = 0;
	      endIdx = currentSlot;
	    } else if (isAboveStart) {
	      startIdx = currentSlot;
	      endIdx = lastSlotIdx;
	    }
	  }
	
	  if (isStartRow) {
	    // select the cell under the initial point
	    startIdx = endIdx = rtl ? lastSlotIdx - Math.floor((start.x - rowBox.left) / cellWidth) : Math.floor((start.x - rowBox.left) / cellWidth);
	
	    if (isCurrentRow) {
	      if (currentSlot < startIdx) startIdx = currentSlot;else endIdx = currentSlot; //select current range
	    }
	    // the current row is below start row
	    else if (start.y < box.y) {
	        // select cells to the right of the start cell
	        endIdx = lastSlotIdx;
	      } else {
	        // select cells to the left of the start cell
	        startIdx = 0;
	      }
	  }
	
	  return { startIdx: startIdx, endIdx: endIdx };
	}

/***/ },

/***/ "ZuRK":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _height = __webpack_require__("r9ks");
	
	var _height2 = _interopRequireDefault(_height);
	
	var _querySelectorAll = __webpack_require__("YLvi");
	
	var _querySelectorAll2 = _interopRequireDefault(_querySelectorAll);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("O27J");
	
	var _dates = __webpack_require__("4PJJ");
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _propTypes3 = __webpack_require__("OBNG");
	
	var _eventLevels2 = __webpack_require__("SjBY");
	
	var _BackgroundCells = __webpack_require__("MAON");
	
	var _BackgroundCells2 = _interopRequireDefault(_BackgroundCells);
	
	var _EventRow = __webpack_require__("2qQ0");
	
	var _EventRow2 = _interopRequireDefault(_EventRow);
	
	var _EventEndingRow = __webpack_require__("AHgI");
	
	var _EventEndingRow2 = _interopRequireDefault(_EventEndingRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isSegmentInSlot = function isSegmentInSlot(seg, slot) {
	  return seg.left <= slot && seg.right >= slot;
	};
	
	var propTypes = {
	  date: _propTypes2.default.instanceOf(Date),
	  events: _propTypes2.default.array.isRequired,
	  range: _propTypes2.default.array.isRequired,
	
	  rtl: _propTypes2.default.bool,
	  renderForMeasure: _propTypes2.default.bool,
	  renderHeader: _propTypes2.default.func,
	
	  container: _propTypes2.default.func,
	  selected: _propTypes2.default.object,
	  selectable: _propTypes2.default.oneOf([true, false, 'ignoreEvents']),
	  longPressThreshold: _propTypes2.default.number,
	
	  onShowMore: _propTypes2.default.func,
	  onSelectSlot: _propTypes2.default.func,
	  onSelectEnd: _propTypes2.default.func,
	  onSelectStart: _propTypes2.default.func,
	  dayPropGetter: _propTypes2.default.func,
	
	  now: _propTypes2.default.instanceOf(Date).isRequired,
	  startAccessor: _propTypes3.accessor.isRequired,
	  endAccessor: _propTypes3.accessor.isRequired,
	
	  dateCellWrapper: _propTypes3.elementType,
	  eventComponent: _propTypes3.elementType,
	  eventWrapperComponent: _propTypes3.elementType.isRequired,
	  minRows: _propTypes2.default.number.isRequired,
	  maxRows: _propTypes2.default.number.isRequired
	};
	
	var defaultProps = {
	  minRows: 0,
	  maxRows: Infinity
	};
	
	var DateContentRow = function (_React$Component) {
	  _inherits(DateContentRow, _React$Component);
	
	  function DateContentRow() {
	    _classCallCheck(this, DateContentRow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args)));
	
	    _this.handleSelectSlot = function (slot) {
	      var _this$props = _this.props,
	          range = _this$props.range,
	          onSelectSlot = _this$props.onSelectSlot;
	
	
	      onSelectSlot(range.slice(slot.start, slot.end + 1), slot);
	    };
	
	    _this.handleShowMore = function (slot) {
	      var _this$props2 = _this.props,
	          range = _this$props2.range,
	          onShowMore = _this$props2.onShowMore;
	
	      var row = (0, _querySelectorAll2.default)((0, _reactDom.findDOMNode)(_this), '.rbc-row-bg')[0];
	
	      var cell = void 0;
	      if (row) cell = row.children[slot - 1];
	
	      var events = _this.segments.filter(function (seg) {
	        return isSegmentInSlot(seg, slot);
	      }).map(function (seg) {
	        return seg.event;
	      });
	
	      onShowMore(events, range[slot - 1], cell, slot);
	    };
	
	    _this.createHeadingRef = function (r) {
	      _this.headingRow = r;
	    };
	
	    _this.createEventRef = function (r) {
	      _this.eventRow = r;
	    };
	
	    _this.getContainer = function () {
	      var container = _this.props.container;
	
	      return container ? container() : (0, _reactDom.findDOMNode)(_this);
	    };
	
	    _this.renderHeadingCell = function (date, index) {
	      var _this$props3 = _this.props,
	          renderHeader = _this$props3.renderHeader,
	          range = _this$props3.range;
	
	
	      return renderHeader({
	        date: date,
	        key: 'header_' + index,
	        style: (0, _eventLevels2.segStyle)(1, range.length),
	        className: (0, _classnames2.default)('rbc-date-cell', _dates2.default.eq(date, _this.props.now, 'day') && 'rbc-now' // FIXME use props.now
	        )
	      });
	    };
	
	    _this.renderDummy = function () {
	      var _this$props4 = _this.props,
	          className = _this$props4.className,
	          range = _this$props4.range,
	          renderHeader = _this$props4.renderHeader;
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          'div',
	          { className: 'rbc-row-content' },
	          renderHeader && _react2.default.createElement(
	            'div',
	            { className: 'rbc-row', ref: _this.createHeadingRef },
	            range.map(_this.renderHeadingCell)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'rbc-row', ref: _this.createEventRef },
	            _react2.default.createElement(
	              'div',
	              { className: 'rbc-row-segment', style: (0, _eventLevels2.segStyle)(1, range.length) },
	              _react2.default.createElement(
	                'div',
	                { className: 'rbc-event' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'rbc-event-content' },
	                  '\xA0'
	                )
	              )
	            )
	          )
	        )
	      );
	    };
	
	    return _this;
	  }
	
	  DateContentRow.prototype.getRowLimit = function getRowLimit() {
	    var eventHeight = (0, _height2.default)(this.eventRow);
	    var headingHeight = this.headingRow ? (0, _height2.default)(this.headingRow) : 0;
	    var eventSpace = (0, _height2.default)((0, _reactDom.findDOMNode)(this)) - headingHeight;
	
	    return Math.max(Math.floor(eventSpace / eventHeight), 1);
	  };
	
	  DateContentRow.prototype.render = function render() {
	    var _props = this.props,
	        date = _props.date,
	        rtl = _props.rtl,
	        events = _props.events,
	        range = _props.range,
	        className = _props.className,
	        selectable = _props.selectable,
	        dayPropGetter = _props.dayPropGetter,
	        renderForMeasure = _props.renderForMeasure,
	        startAccessor = _props.startAccessor,
	        endAccessor = _props.endAccessor,
	        renderHeader = _props.renderHeader,
	        minRows = _props.minRows,
	        maxRows = _props.maxRows,
	        dateCellWrapper = _props.dateCellWrapper,
	        eventComponent = _props.eventComponent,
	        eventWrapperComponent = _props.eventWrapperComponent,
	        onSelectStart = _props.onSelectStart,
	        onSelectEnd = _props.onSelectEnd,
	        longPressThreshold = _props.longPressThreshold,
	        props = _objectWithoutProperties(_props, ['date', 'rtl', 'events', 'range', 'className', 'selectable', 'dayPropGetter', 'renderForMeasure', 'startAccessor', 'endAccessor', 'renderHeader', 'minRows', 'maxRows', 'dateCellWrapper', 'eventComponent', 'eventWrapperComponent', 'onSelectStart', 'onSelectEnd', 'longPressThreshold']);
	
	    if (renderForMeasure) return this.renderDummy();
	
	    var _endOfRange = (0, _eventLevels2.endOfRange)(range),
	        first = _endOfRange.first,
	        last = _endOfRange.last;
	
	    var segments = this.segments = events.map(function (evt) {
	      return (0, _eventLevels2.eventSegments)(evt, first, last, {
	        startAccessor: startAccessor,
	        endAccessor: endAccessor
	      }, range);
	    });
	
	    var _eventLevels = (0, _eventLevels2.eventLevels)(segments, Math.max(maxRows - 1, 1)),
	        levels = _eventLevels.levels,
	        extra = _eventLevels.extra;
	
	    while (levels.length < minRows) {
	      levels.push([]);
	    }return _react2.default.createElement(
	      'div',
	      { className: className },
	      _react2.default.createElement(_BackgroundCells2.default, {
	        date: date,
	        rtl: rtl,
	        range: range,
	        selectable: selectable,
	        container: this.getContainer,
	        dayPropGetter: dayPropGetter,
	        onSelectStart: onSelectStart,
	        onSelectEnd: onSelectEnd,
	        onSelectSlot: this.handleSelectSlot,
	        cellWrapperComponent: dateCellWrapper,
	        longPressThreshold: longPressThreshold
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'rbc-row-content' },
	        renderHeader && _react2.default.createElement(
	          'div',
	          { className: 'rbc-row', ref: this.createHeadingRef },
	          range.map(this.renderHeadingCell)
	        ),
	        levels.map(function (segs, idx) {
	          return _react2.default.createElement(_EventRow2.default, _extends({}, props, {
	            key: idx,
	            start: first,
	            end: last,
	            segments: segs,
	            slots: range.length,
	            eventComponent: eventComponent,
	            eventWrapperComponent: eventWrapperComponent,
	            startAccessor: startAccessor,
	            endAccessor: endAccessor
	          }));
	        }),
	        !!extra.length && _react2.default.createElement(_EventEndingRow2.default, _extends({}, props, {
	          start: first,
	          end: last,
	          segments: extra,
	          onShowMore: this.handleShowMore,
	          eventComponent: eventComponent,
	          eventWrapperComponent: eventWrapperComponent,
	          startAccessor: startAccessor,
	          endAccessor: endAccessor
	        }))
	      )
	    );
	  };
	
	  return DateContentRow;
	}(_react2.default.Component);
	
	DateContentRow.defaultProps = defaultProps;
	
	exports.default = DateContentRow;
	module.exports = exports['default'];

/***/ },

/***/ "SjBY":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.endOfRange = endOfRange;
	exports.eventSegments = eventSegments;
	exports.segStyle = segStyle;
	exports.eventLevels = eventLevels;
	exports.inRange = inRange;
	exports.segsOverlap = segsOverlap;
	exports.sortEvents = sortEvents;
	
	var _findIndex = __webpack_require__("KgVm");
	
	var _findIndex2 = _interopRequireDefault(_findIndex);
	
	var _dates = __webpack_require__("4PJJ");
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _accessors = __webpack_require__("Gtmz");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function endOfRange(dateRange) {
	  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'day';
	
	  return {
	    first: dateRange[0],
	    last: _dates2.default.add(dateRange[dateRange.length - 1], 1, unit)
	  };
	}
	
	function eventSegments(event, first, last, _ref, range) {
	  var startAccessor = _ref.startAccessor,
	      endAccessor = _ref.endAccessor;
	
	  var slots = _dates2.default.diff(first, last, 'day');
	  var start = _dates2.default.max(_dates2.default.startOf((0, _accessors.accessor)(event, startAccessor), 'day'), first);
	  var end = _dates2.default.min(_dates2.default.ceil((0, _accessors.accessor)(event, endAccessor), 'day'), last);
	
	  var padding = (0, _findIndex2.default)(range, function (x) {
	    return _dates2.default.eq(x, start, 'day');
	  });
	  var span = _dates2.default.diff(start, end, 'day');
	
	  span = Math.min(span, slots);
	  span = Math.max(span, 1);
	
	  return {
	    event: event,
	    span: span,
	    left: padding + 1,
	    right: Math.max(padding + span, 1)
	  };
	}
	
	function segStyle(span, slots) {
	  var per = span / slots * 100 + '%';
	  return { WebkitFlexBasis: per, flexBasis: per, maxWidth: per }; // IE10/11 need max-width. flex-basis doesn't respect box-sizing
	}
	
	function eventLevels(rowSegments) {
	  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
	
	  var i = void 0,
	      j = void 0,
	      seg = void 0,
	      levels = [],
	      extra = [];
	
	  for (i = 0; i < rowSegments.length; i++) {
	    seg = rowSegments[i];
	
	    for (j = 0; j < levels.length; j++) {
	      if (!segsOverlap(seg, levels[j])) break;
	    }if (j >= limit) {
	      extra.push(seg);
	    } else {
	      (levels[j] || (levels[j] = [])).push(seg);
	    }
	  }
	
	  for (i = 0; i < levels.length; i++) {
	    levels[i].sort(function (a, b) {
	      return a.left - b.left;
	    }); //eslint-disable-line
	  }
	
	  return { levels: levels, extra: extra };
	}
	
	function inRange(e, start, end, _ref2) {
	  var startAccessor = _ref2.startAccessor,
	      endAccessor = _ref2.endAccessor;
	
	  var eStart = _dates2.default.startOf((0, _accessors.accessor)(e, startAccessor), 'day');
	  var eEnd = (0, _accessors.accessor)(e, endAccessor);
	
	  var startsBeforeEnd = _dates2.default.lte(eStart, end, 'day');
	  var endsAfterStart = _dates2.default.gte(eEnd, start, 'day');
	
	  return startsBeforeEnd && endsAfterStart;
	}
	
	function segsOverlap(seg, otherSegs) {
	  return otherSegs.some(function (otherSeg) {
	    return otherSeg.left <= seg.right && otherSeg.right >= seg.left;
	  });
	}
	
	function sortEvents(evtA, evtB, _ref3) {
	  var startAccessor = _ref3.startAccessor,
	      endAccessor = _ref3.endAccessor,
	      allDayAccessor = _ref3.allDayAccessor;
	
	  var startSort = +_dates2.default.startOf((0, _accessors.accessor)(evtA, startAccessor), 'day') - +_dates2.default.startOf((0, _accessors.accessor)(evtB, startAccessor), 'day');
	
	  var durA = _dates2.default.diff((0, _accessors.accessor)(evtA, startAccessor), _dates2.default.ceil((0, _accessors.accessor)(evtA, endAccessor), 'day'), 'day');
	
	  var durB = _dates2.default.diff((0, _accessors.accessor)(evtB, startAccessor), _dates2.default.ceil((0, _accessors.accessor)(evtB, endAccessor), 'day'), 'day');
	
	  return startSort // sort by start Day first
	  || Math.max(durB, 1) - Math.max(durA, 1) // events spanning multiple days go first
	  || !!(0, _accessors.accessor)(evtB, allDayAccessor) - !!(0, _accessors.accessor)(evtA, allDayAccessor) // then allDay single day events
	  || +(0, _accessors.accessor)(evtA, startAccessor) - +(0, _accessors.accessor)(evtB, startAccessor); // then sort by start time
	}

/***/ },

/***/ "MAON":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("O27J");
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dates = __webpack_require__("4PJJ");
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _eventLevels = __webpack_require__("SjBY");
	
	var _helpers = __webpack_require__("FRUJ");
	
	var _propTypes3 = __webpack_require__("OBNG");
	
	var _selection = __webpack_require__("RGiR");
	
	var _Selection = __webpack_require__("yEJm");
	
	var _Selection2 = _interopRequireDefault(_Selection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BackgroundCells = function (_React$Component) {
	  _inherits(BackgroundCells, _React$Component);
	
	  function BackgroundCells(props, context) {
	    _classCallCheck(this, BackgroundCells);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.state = {
	      selecting: false
	    };
	    return _this;
	  }
	
	  BackgroundCells.prototype.componentDidMount = function componentDidMount() {
	    this.props.selectable && this._selectable();
	  };
	
	  BackgroundCells.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._teardownSelectable();
	  };
	
	  BackgroundCells.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.selectable && !this.props.selectable) this._selectable();
	
	    if (!nextProps.selectable && this.props.selectable) this._teardownSelectable();
	  };
	
	  BackgroundCells.prototype.render = function render() {
	    var _props = this.props,
	        range = _props.range,
	        Wrapper = _props.cellWrapperComponent,
	        dayPropGetter = _props.dayPropGetter,
	        currentDate = _props.date;
	    var _state = this.state,
	        selecting = _state.selecting,
	        startIdx = _state.startIdx,
	        endIdx = _state.endIdx;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'rbc-row-bg' },
	      range.map(function (date, index) {
	        var selected = selecting && index >= startIdx && index <= endIdx;
	
	        var _ref = dayPropGetter && dayPropGetter(date) || {},
	            className = _ref.className,
	            dayStyles = _ref.style;
	
	        var segmStyles = (0, _eventLevels.segStyle)(1, range.length);
	        var styles = Object.assign({}, dayStyles, segmStyles);
	
	        return _react2.default.createElement(
	          Wrapper,
	          {
	            key: index,
	            value: date,
	            range: range
	          },
	          _react2.default.createElement('div', {
	            style: styles,
	            className: (0, _classnames2.default)('rbc-day-bg', className, selected && 'rbc-selected-cell', _dates2.default.isToday(date) && 'rbc-today', currentDate && _dates2.default.month(currentDate) !== _dates2.default.month(date) && 'rbc-off-range-bg')
	          })
	        );
	      })
	    );
	  };
	
	  BackgroundCells.prototype._selectable = function _selectable() {
	    var _this2 = this;
	
	    var node = (0, _reactDom.findDOMNode)(this);
	    var selector = this._selector = new _Selection2.default(this.props.container, {
	      longPressThreshold: this.props.longPressThreshold
	    });
	
	    var selectorClicksHandler = function selectorClicksHandler(point, actionType) {
	      if (!(0, _Selection.isEvent)((0, _reactDom.findDOMNode)(_this2), point)) {
	        var rowBox = (0, _Selection.getBoundsForNode)(node);
	        var _props2 = _this2.props,
	            range = _props2.range,
	            rtl = _props2.rtl;
	
	
	        if ((0, _selection.pointInBox)(rowBox, point)) {
	          var width = (0, _selection.slotWidth)((0, _Selection.getBoundsForNode)(node), range.length);
	          var currentCell = (0, _selection.getCellAtX)(rowBox, point.x, width, rtl, range.length);
	
	          _this2._selectSlot({
	            startIdx: currentCell,
	            endIdx: currentCell,
	            action: actionType
	          });
	        }
	      }
	
	      _this2._initial = {};
	      _this2.setState({ selecting: false });
	    };
	
	    selector.on('selecting', function (box) {
	      var _props3 = _this2.props,
	          range = _props3.range,
	          rtl = _props3.rtl;
	
	
	      var startIdx = -1;
	      var endIdx = -1;
	
	      if (!_this2.state.selecting) {
	        (0, _helpers.notify)(_this2.props.onSelectStart, [box]);
	        _this2._initial = { x: box.x, y: box.y };
	      }
	      if (selector.isSelected(node)) {
	        var nodeBox = (0, _Selection.getBoundsForNode)(node);
	
	        var _dateCellSelection = (0, _selection.dateCellSelection)(_this2._initial, nodeBox, box, range.length, rtl);
	
	        startIdx = _dateCellSelection.startIdx;
	        endIdx = _dateCellSelection.endIdx;
	      }
	
	      _this2.setState({
	        selecting: true,
	        startIdx: startIdx, endIdx: endIdx
	      });
	    });
	
	    selector.on('beforeSelect', function (box) {
	      if (_this2.props.selectable !== 'ignoreEvents') return;
	
	      return !(0, _Selection.isEvent)((0, _reactDom.findDOMNode)(_this2), box);
	    });
	
	    selector.on('click', function (point) {
	      return selectorClicksHandler(point, 'click');
	    });
	
	    selector.on('doubleClick', function (point) {
	      return selectorClicksHandler(point, 'doubleClick');
	    });
	
	    selector.on('select', function () {
	      _this2._selectSlot(_extends({}, _this2.state, { action: 'select' }));
	      _this2._initial = {};
	      _this2.setState({ selecting: false });
	      (0, _helpers.notify)(_this2.props.onSelectEnd, [_this2.state]);
	    });
	  };
	
	  BackgroundCells.prototype._teardownSelectable = function _teardownSelectable() {
	    if (!this._selector) return;
	    this._selector.teardown();
	    this._selector = null;
	  };
	
	  BackgroundCells.prototype._selectSlot = function _selectSlot(_ref2) {
	    var endIdx = _ref2.endIdx,
	        startIdx = _ref2.startIdx,
	        action = _ref2.action;
	
	    if (endIdx !== -1 && startIdx !== -1) this.props.onSelectSlot && this.props.onSelectSlot({
	      start: startIdx,
	      end: endIdx,
	      action: action
	    });
	  };
	
	  return BackgroundCells;
	}(_react2.default.Component);
	
	exports.default = BackgroundCells;
	module.exports = exports['default'];

/***/ },

/***/ "yEJm":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.isEvent = isEvent;
	exports.objectsCollide = objectsCollide;
	exports.getBoundsForNode = getBoundsForNode;
	
	var _contains = __webpack_require__("ZPUX");
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _closest = __webpack_require__("2pIN");
	
	var _closest2 = _interopRequireDefault(_closest);
	
	var _events = __webpack_require__("wkV6");
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function addEventListener(type, handler) {
	  var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
	
	  _events2.default.on(target, type, handler);
	  return {
	    remove: function remove() {
	      _events2.default.off(target, type, handler);
	    }
	  };
	}
	
	function isOverContainer(container, x, y) {
	  return !container || (0, _contains2.default)(container, document.elementFromPoint(x, y));
	}
	
	function isEvent(node, _ref) {
	  var clientX = _ref.clientX,
	      clientY = _ref.clientY;
	
	  var target = document.elementFromPoint(clientX, clientY);
	  return !!(0, _closest2.default)(target, '.rbc-event', node);
	}
	
	function getEventCoordinates(e) {
	  var target = e;
	
	  if (e.touches && e.touches.length) {
	    target = e.touches[0];
	  }
	
	  return {
	    clientX: target.clientX,
	    clientY: target.clientY,
	    pageX: target.pageX,
	    pageY: target.pageY
	  };
	}
	
	var clickTolerance = 5;
	var clickInterval = 250;
	
	var Selection = function () {
	  function Selection(node) {
	    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        _ref2$global = _ref2.global,
	        global = _ref2$global === undefined ? false : _ref2$global,
	        _ref2$longPressThresh = _ref2.longPressThreshold,
	        longPressThreshold = _ref2$longPressThresh === undefined ? 250 : _ref2$longPressThresh;
	
	    _classCallCheck(this, Selection);
	
	    this.container = node;
	    this.globalMouse = !node || global;
	    this.longPressThreshold = longPressThreshold;
	
	    this._listeners = Object.create(null);
	
	    this._handleInitialEvent = this._handleInitialEvent.bind(this);
	    this._handleMoveEvent = this._handleMoveEvent.bind(this);
	    this._handleTerminatingEvent = this._handleTerminatingEvent.bind(this);
	    this._keyListener = this._keyListener.bind(this);
	
	    // Fixes an iOS 10 bug where scrolling could not be prevented on the window.
	    // https://github.com/metafizzy/flickity/issues/457#issuecomment-254501356
	    this._onTouchMoveWindowListener = addEventListener('touchmove', function () {}, window);
	    this._onKeyDownListener = addEventListener('keydown', this._keyListener);
	    this._onKeyUpListener = addEventListener('keyup', this._keyListener);
	    this._addInitialEventListener();
	  }
	
	  Selection.prototype.on = function on(type, handler) {
	    var handlers = this._listeners[type] || (this._listeners[type] = []);
	
	    handlers.push(handler);
	
	    return {
	      remove: function remove() {
	        var idx = handlers.indexOf(handler);
	        if (idx !== -1) handlers.splice(idx, 1);
	      }
	    };
	  };
	
	  Selection.prototype.emit = function emit(type) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var result = void 0;
	    var handlers = this._listeners[type] || [];
	    handlers.forEach(function (fn) {
	      if (result === undefined) result = fn.apply(undefined, args);
	    });
	    return result;
	  };
	
	  Selection.prototype.teardown = function teardown() {
	    this.listeners = Object.create(null);
	    this._onTouchMoveWindowListener && this._onTouchMoveWindowListener.remove();
	    this._onInitialEventListener && this._onInitialEventListener.remove();
	    this._onEndListener && this._onEndListener.remove();
	    this._onMoveListener && this._onMoveListener.remove();
	    this._onKeyUpListener && this._onKeyUpListener.remove();
	    this._onKeyDownListener && this._onKeyDownListener.remove();
	  };
	
	  Selection.prototype.isSelected = function isSelected(node) {
	    var box = this._selectRect;
	
	    if (!box || !this.selecting) return false;
	
	    return objectsCollide(box, getBoundsForNode(node));
	  };
	
	  Selection.prototype.filter = function filter(items) {
	    var box = this._selectRect;
	
	    //not selecting
	    if (!box || !this.selecting) return [];
	
	    return items.filter(this.isSelected, this);
	  };
	
	  // Adds a listener that will call the handler only after the user has pressed on the screen
	  // without moving their finger for 250ms.
	
	
	  Selection.prototype._addLongPressListener = function _addLongPressListener(handler, initialEvent) {
	    var _this = this;
	
	    var timer = null;
	    var touchMoveListener = null;
	    var touchEndListener = null;
	    var handleTouchStart = function handleTouchStart(initialEvent) {
	      timer = setTimeout(function () {
	        cleanup();
	        handler(initialEvent);
	      }, _this.longPressThreshold);
	      touchMoveListener = addEventListener('touchmove', function () {
	        return cleanup();
	      });
	      touchEndListener = addEventListener('touchend', function () {
	        return cleanup();
	      });
	    };
	    var touchStartListener = addEventListener('touchstart', handleTouchStart);
	    var cleanup = function cleanup() {
	      if (timer) {
	        clearTimeout(timer);
	      }
	      if (touchMoveListener) {
	        touchMoveListener.remove();
	      }
	      if (touchEndListener) {
	        touchEndListener.remove();
	      }
	
	      timer = null;
	      touchMoveListener = null;
	      touchEndListener = null;
	    };
	
	    if (initialEvent) {
	      handleTouchStart(initialEvent);
	    }
	
	    return {
	      remove: function remove() {
	        cleanup();
	        touchStartListener.remove();
	      }
	    };
	  };
	
	  // Listen for mousedown and touchstart events. When one is received, disable the other and setup
	  // future event handling based on the type of event.
	
	
	  Selection.prototype._addInitialEventListener = function _addInitialEventListener() {
	    var _this2 = this;
	
	    var mouseDownListener = addEventListener('mousedown', function (e) {
	      _this2._onInitialEventListener.remove();
	      _this2._handleInitialEvent(e);
	      _this2._onInitialEventListener = addEventListener('mousedown', _this2._handleInitialEvent);
	    });
	    var touchStartListener = addEventListener('touchstart', function (e) {
	      _this2._onInitialEventListener.remove();
	      _this2._onInitialEventListener = _this2._addLongPressListener(_this2._handleInitialEvent, e);
	    });
	
	    this._onInitialEventListener = {
	      remove: function remove() {
	        mouseDownListener.remove();
	        touchStartListener.remove();
	      }
	    };
	  };
	
	  Selection.prototype._handleInitialEvent = function _handleInitialEvent(e) {
	    var _getEventCoordinates = getEventCoordinates(e),
	        clientX = _getEventCoordinates.clientX,
	        clientY = _getEventCoordinates.clientY,
	        pageX = _getEventCoordinates.pageX,
	        pageY = _getEventCoordinates.pageY;
	
	    var node = this.container(),
	        collides = void 0,
	        offsetData = void 0;
	
	    // Right clicks
	    if (e.which === 3 || e.button === 2 || !isOverContainer(node, clientX, clientY)) return;
	
	    if (!this.globalMouse && node && !(0, _contains2.default)(node, e.target)) {
	      var _normalizeDistance = normalizeDistance(0),
	          top = _normalizeDistance.top,
	          left = _normalizeDistance.left,
	          bottom = _normalizeDistance.bottom,
	          right = _normalizeDistance.right;
	
	      offsetData = getBoundsForNode(node);
	
	      collides = objectsCollide({
	        top: offsetData.top - top,
	        left: offsetData.left - left,
	        bottom: offsetData.bottom + bottom,
	        right: offsetData.right + right
	      }, { top: pageY, left: pageX });
	
	      if (!collides) return;
	    }
	
	    var result = this.emit('beforeSelect', this._initialEventData = {
	      isTouch: /^touch/.test(e.type),
	      x: pageX,
	      y: pageY,
	      clientX: clientX,
	      clientY: clientY
	    });
	
	    if (result === false) return;
	
	    switch (e.type) {
	      case 'mousedown':
	        this._onEndListener = addEventListener('mouseup', this._handleTerminatingEvent);
	        this._onMoveListener = addEventListener('mousemove', this._handleMoveEvent);
	        break;
	      case 'touchstart':
	        this._handleMoveEvent(e);
	        this._onEndListener = addEventListener('touchend', this._handleTerminatingEvent);
	        this._onMoveListener = addEventListener('touchmove', this._handleMoveEvent);
	        break;
	      default:
	        break;
	    }
	  };
	
	  Selection.prototype._handleTerminatingEvent = function _handleTerminatingEvent(e) {
	    var _getEventCoordinates2 = getEventCoordinates(e),
	        pageX = _getEventCoordinates2.pageX,
	        pageY = _getEventCoordinates2.pageY;
	
	    this.selecting = false;
	
	    this._onEndListener && this._onEndListener.remove();
	    this._onMoveListener && this._onMoveListener.remove();
	
	    if (!this._initialEventData) return;
	
	    var inRoot = !this.container || (0, _contains2.default)(this.container(), e.target);
	    var bounds = this._selectRect;
	    var click = this.isClick(pageX, pageY);
	
	    this._initialEventData = null;
	
	    if (click && !inRoot) {
	      return this.emit('reset');
	    }
	
	    if (click && inRoot) {
	      return this._handleClickEvent(e);
	    }
	
	    // User drag-clicked in the Selectable area
	    if (!click) return this.emit('select', bounds);
	  };
	
	  Selection.prototype._handleClickEvent = function _handleClickEvent(e) {
	    var _getEventCoordinates3 = getEventCoordinates(e),
	        pageX = _getEventCoordinates3.pageX,
	        pageY = _getEventCoordinates3.pageY,
	        clientX = _getEventCoordinates3.clientX,
	        clientY = _getEventCoordinates3.clientY;
	
	    var now = new Date().getTime();
	
	    if (this._lastClickData && now - this._lastClickData.timestamp < clickInterval) {
	      // Double click event
	      this._lastClickData = null;
	      return this.emit('doubleClick', {
	        x: pageX,
	        y: pageY,
	        clientX: clientX,
	        clientY: clientY
	      });
	    }
	
	    // Click event
	    this._lastClickData = {
	      timestamp: now
	    };
	    return this.emit('click', {
	      x: pageX,
	      y: pageY,
	      clientX: clientX,
	      clientY: clientY
	    });
	  };
	
	  Selection.prototype._handleMoveEvent = function _handleMoveEvent(e) {
	    var _initialEventData = this._initialEventData,
	        x = _initialEventData.x,
	        y = _initialEventData.y;
	
	    var _getEventCoordinates4 = getEventCoordinates(e),
	        pageX = _getEventCoordinates4.pageX,
	        pageY = _getEventCoordinates4.pageY;
	
	    var w = Math.abs(x - pageX);
	    var h = Math.abs(y - pageY);
	
	    var left = Math.min(pageX, x),
	        top = Math.min(pageY, y),
	        old = this.selecting;
	
	    this.selecting = true;
	    this._selectRect = {
	      top: top,
	      left: left,
	      x: pageX,
	      y: pageY,
	      right: left + w,
	      bottom: top + h
	    };
	
	    if (!old) {
	      this.emit('selectStart', this._initialEventData);
	    }
	
	    if (!this.isClick(pageX, pageY)) this.emit('selecting', this._selectRect);
	
	    e.preventDefault();
	  };
	
	  Selection.prototype._keyListener = function _keyListener(e) {
	    this.ctrl = e.metaKey || e.ctrlKey;
	  };
	
	  Selection.prototype.isClick = function isClick(pageX, pageY) {
	    var _initialEventData2 = this._initialEventData,
	        x = _initialEventData2.x,
	        y = _initialEventData2.y,
	        isTouch = _initialEventData2.isTouch;
	
	    return !isTouch && Math.abs(pageX - x) <= clickTolerance && Math.abs(pageY - y) <= clickTolerance;
	  };
	
	  return Selection;
	}();
	
	/**
	 * Resolve the disance prop from either an Int or an Object
	 * @return {Object}
	 */
	
	
	function normalizeDistance() {
	  var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  if ((typeof distance === 'undefined' ? 'undefined' : _typeof(distance)) !== 'object') distance = { top: distance, left: distance, right: distance, bottom: distance };
	
	  return distance;
	}
	
	/**
	 * Given two objects containing "top", "left", "offsetWidth" and "offsetHeight"
	 * properties, determine if they collide.
	 * @param  {Object|HTMLElement} a
	 * @param  {Object|HTMLElement} b
	 * @return {bool}
	 */
	function objectsCollide(nodeA, nodeB) {
	  var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	  var _getBoundsForNode = getBoundsForNode(nodeA),
	      aTop = _getBoundsForNode.top,
	      aLeft = _getBoundsForNode.left,
	      _getBoundsForNode$rig = _getBoundsForNode.right,
	      aRight = _getBoundsForNode$rig === undefined ? aLeft : _getBoundsForNode$rig,
	      _getBoundsForNode$bot = _getBoundsForNode.bottom,
	      aBottom = _getBoundsForNode$bot === undefined ? aTop : _getBoundsForNode$bot;
	
	  var _getBoundsForNode2 = getBoundsForNode(nodeB),
	      bTop = _getBoundsForNode2.top,
	      bLeft = _getBoundsForNode2.left,
	      _getBoundsForNode2$ri = _getBoundsForNode2.right,
	      bRight = _getBoundsForNode2$ri === undefined ? bLeft : _getBoundsForNode2$ri,
	      _getBoundsForNode2$bo = _getBoundsForNode2.bottom,
	      bBottom = _getBoundsForNode2$bo === undefined ? bTop : _getBoundsForNode2$bo;
	
	  return !(
	  // 'a' bottom doesn't touch 'b' top
	  aBottom - tolerance < bTop ||
	  // 'a' top doesn't touch 'b' bottom
	  aTop + tolerance > bBottom ||
	  // 'a' right doesn't touch 'b' left
	  aRight - tolerance < bLeft ||
	  // 'a' left doesn't touch 'b' right
	  aLeft + tolerance > bRight);
	}
	
	/**
	 * Given a node, get everything needed to calculate its boundaries
	 * @param  {HTMLElement} node
	 * @return {Object}
	 */
	function getBoundsForNode(node) {
	  if (!node.getBoundingClientRect) return node;
	
	  var rect = node.getBoundingClientRect(),
	      left = rect.left + pageOffset('left'),
	      top = rect.top + pageOffset('top');
	
	  return {
	    top: top,
	    left: left,
	    right: (node.offsetWidth || 0) + left,
	    bottom: (node.offsetHeight || 0) + top
	  };
	}
	
	function pageOffset(dir) {
	  if (dir === 'left') return window.pageXOffset || document.body.scrollLeft || 0;
	  if (dir === 'top') return window.pageYOffset || document.body.scrollTop || 0;
	}
	exports.default = Selection;

/***/ },

/***/ "2qQ0":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EventRowMixin = __webpack_require__("I5YU");
	
	var _EventRowMixin2 = _interopRequireDefault(_EventRowMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventRow = (_temp = _class = function (_React$Component) {
	  _inherits(EventRow, _React$Component);
	
	  function EventRow() {
	    _classCallCheck(this, EventRow);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  EventRow.prototype.render = function render() {
	    var _this2 = this;
	
	    var segments = this.props.segments;
	
	
	    var lastEnd = 1;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'rbc-row' },
	      segments.reduce(function (row, _ref, li) {
	        var event = _ref.event,
	            left = _ref.left,
	            right = _ref.right,
	            span = _ref.span;
	
	        var key = '_lvl_' + li;
	        var gap = left - lastEnd;
	
	        var content = _EventRowMixin2.default.renderEvent(_this2.props, event);
	
	        if (gap) row.push(_EventRowMixin2.default.renderSpan(_this2.props, gap, key + '_gap'));
	
	        row.push(_EventRowMixin2.default.renderSpan(_this2.props, span, key, content));
	
	        lastEnd = right + 1;
	
	        return row;
	      }, [])
	    );
	  };
	
	  return EventRow;
	}(_react2.default.Component), _class.defaultProps = _extends({}, _EventRowMixin2.default.defaultProps), _temp);
	exports.default = EventRow;
	module.exports = exports['default'];

/***/ },

/***/ "I5YU":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("O27J");
	
	var _EventCell = __webpack_require__("H3l1");
	
	var _EventCell2 = _interopRequireDefault(_EventCell);
	
	var _height = __webpack_require__("r9ks");
	
	var _height2 = _interopRequireDefault(_height);
	
	var _propTypes3 = __webpack_require__("OBNG");
	
	var _eventLevels = __webpack_require__("SjBY");
	
	var _selection = __webpack_require__("RGiR");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	exports.default = {
	  propTypes: {
	    slots: _propTypes2.default.number.isRequired,
	    end: _propTypes2.default.instanceOf(Date),
	    start: _propTypes2.default.instanceOf(Date),
	
	    selected: _propTypes2.default.object,
	    eventPropGetter: _propTypes2.default.func,
	    titleAccessor: _propTypes3.accessor,
	    allDayAccessor: _propTypes3.accessor,
	    startAccessor: _propTypes3.accessor,
	    endAccessor: _propTypes3.accessor,
	
	    eventComponent: _propTypes3.elementType,
	    eventWrapperComponent: _propTypes3.elementType.isRequired,
	    onSelect: _propTypes2.default.func,
	    onDoubleClick: _propTypes2.default.func
	  },
	
	  defaultProps: {
	    segments: [],
	    selected: {},
	    slots: 7
	  },
	
	  renderEvent: function renderEvent(props, event) {
	    var eventPropGetter = props.eventPropGetter,
	        selected = props.selected,
	        start = props.start,
	        end = props.end,
	        startAccessor = props.startAccessor,
	        endAccessor = props.endAccessor,
	        titleAccessor = props.titleAccessor,
	        allDayAccessor = props.allDayAccessor,
	        eventComponent = props.eventComponent,
	        eventWrapperComponent = props.eventWrapperComponent,
	        onSelect = props.onSelect,
	        onDoubleClick = props.onDoubleClick;
	
	
	    return _react2.default.createElement(_EventCell2.default, {
	      event: event,
	      eventWrapperComponent: eventWrapperComponent,
	      eventPropGetter: eventPropGetter,
	      onSelect: onSelect,
	      onDoubleClick: onDoubleClick,
	      selected: (0, _selection.isSelected)(event, selected),
	      startAccessor: startAccessor,
	      endAccessor: endAccessor,
	      titleAccessor: titleAccessor,
	      allDayAccessor: allDayAccessor,
	      slotStart: start,
	      slotEnd: end,
	      eventComponent: eventComponent
	    });
	  },
	  renderSpan: function renderSpan(props, len, key) {
	    var content = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
	    var slots = props.slots;
	
	
	    return _react2.default.createElement(
	      'div',
	      { key: key, className: 'rbc-row-segment', style: (0, _eventLevels.segStyle)(Math.abs(len), slots) },
	      content
	    );
	  },
	  getRowHeight: function getRowHeight() {
	    (0, _height2.default)((0, _reactDom.findDOMNode)(this));
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "AHgI":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EventRowMixin = __webpack_require__("I5YU");
	
	var _EventRowMixin2 = _interopRequireDefault(_EventRowMixin);
	
	var _eventLevels = __webpack_require__("SjBY");
	
	var _messages = __webpack_require__("m1jL");
	
	var _messages2 = _interopRequireDefault(_messages);
	
	var _range = __webpack_require__("tVBY");
	
	var _range2 = _interopRequireDefault(_range);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isSegmentInSlot = function isSegmentInSlot(seg, slot) {
	  return seg.left <= slot && seg.right >= slot;
	};
	var eventsInSlot = function eventsInSlot(segments, slot) {
	  return segments.filter(function (seg) {
	    return isSegmentInSlot(seg, slot);
	  }).length;
	};
	
	var EventEndingRow = (_temp = _class = function (_React$Component) {
	  _inherits(EventEndingRow, _React$Component);
	
	  function EventEndingRow() {
	    _classCallCheck(this, EventEndingRow);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  EventEndingRow.prototype.render = function render() {
	    var _props = this.props,
	        segments = _props.segments,
	        slotCount = _props.slots;
	
	    var rowSegments = (0, _eventLevels.eventLevels)(segments).levels[0];
	
	    var current = 1,
	        lastEnd = 1,
	        row = [];
	
	    while (current <= slotCount) {
	      var key = '_lvl_' + current;
	
	      var _ref = rowSegments.filter(function (seg) {
	        return isSegmentInSlot(seg, current);
	      })[0] || {},
	          event = _ref.event,
	          left = _ref.left,
	          right = _ref.right,
	          span = _ref.span; //eslint-disable-line
	
	      if (!event) {
	        current++;
	        continue;
	      }
	
	      var gap = Math.max(0, left - lastEnd);
	
	      if (this.canRenderSlotEvent(left, span)) {
	        var content = _EventRowMixin2.default.renderEvent(this.props, event);
	
	        if (gap) {
	          row.push(_EventRowMixin2.default.renderSpan(this.props, gap, key + '_gap'));
	        }
	
	        row.push(_EventRowMixin2.default.renderSpan(this.props, span, key, content));
	
	        lastEnd = current = right + 1;
	      } else {
	        if (gap) {
	          row.push(_EventRowMixin2.default.renderSpan(this.props, gap, key + '_gap'));
	        }
	
	        row.push(_EventRowMixin2.default.renderSpan(this.props, 1, key, this.renderShowMore(segments, current)));
	        lastEnd = current = current + 1;
	      }
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'rbc-row' },
	      row
	    );
	  };
	
	  EventEndingRow.prototype.canRenderSlotEvent = function canRenderSlotEvent(slot, span) {
	    var segments = this.props.segments;
	
	
	    return (0, _range2.default)(slot, slot + span).every(function (s) {
	      var count = eventsInSlot(segments, s);
	
	      return count === 1;
	    });
	  };
	
	  EventEndingRow.prototype.renderShowMore = function renderShowMore(segments, slot) {
	    var _this2 = this;
	
	    var messages = (0, _messages2.default)(this.props.messages);
	    var count = eventsInSlot(segments, slot);
	
	    return count ? _react2.default.createElement(
	      'a',
	      {
	        key: 'sm_' + slot,
	        href: '#',
	        className: 'rbc-show-more',
	        onClick: function onClick(e) {
	          return _this2.showMore(slot, e);
	        }
	      },
	      messages.showMore(count)
	    ) : false;
	  };
	
	  EventEndingRow.prototype.showMore = function showMore(slot, e) {
	    e.preventDefault();
	    this.props.onShowMore(slot);
	  };
	
	  return EventEndingRow;
	}(_react2.default.Component), _class.defaultProps = _extends({}, _EventRowMixin2.default.defaultProps), _temp);
	exports.default = EventEndingRow;
	module.exports = exports['default'];

/***/ },

/***/ "TpKw":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WEEKDAYS = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
	
	var Header = function Header(_ref) {
	  var label = _ref.label,
	      date = _ref.date;
	
	  var weekdayClass = 'rbc-weekday-' + WEEKDAYS[date.getDay()];
	  return _react2.default.createElement(
	    'span',
	    { className: weekdayClass },
	    label
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ },

/***/ "r76b":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DateHeader = function DateHeader(_ref) {
	  var label = _ref.label,
	      drilldownView = _ref.drilldownView,
	      onDrillDown = _ref.onDrillDown;
	
	  if (!drilldownView) {
	    return _react2.default.createElement(
	      'span',
	      null,
	      label
	    );
	  }
	
	  return _react2.default.createElement(
	    'a',
	    { href: '#', onClick: onDrillDown },
	    label
	  );
	};
	
	exports.default = DateHeader;
	module.exports = exports['default'];

/***/ },

/***/ "wad3":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dates = __webpack_require__("4PJJ");
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _constants = __webpack_require__("hYBH");
	
	var _TimeGrid = __webpack_require__("u0gy");
	
	var _TimeGrid2 = _interopRequireDefault(_TimeGrid);
	
	var _localizer = __webpack_require__("HcfL");
	
	var _localizer2 = _interopRequireDefault(_localizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Day = function (_React$Component) {
	  _inherits(Day, _React$Component);
	
	  function Day() {
	    _classCallCheck(this, Day);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Day.prototype.render = function render() {
	    var _props = this.props,
	        date = _props.date,
	        props = _objectWithoutProperties(_props, ['date']);
	
	    return _react2.default.createElement(_TimeGrid2.default, _extends({}, props, { range: [_dates2.default.startOf(date, 'day')], eventOffset: 10 }));
	  };
	
	  return Day;
	}(_react2.default.Component);
	
	Day.navigate = function (date, action) {
	  switch (action) {
	    case _constants.navigate.PREVIOUS:
	      return _dates2.default.add(date, -1, 'day');
	
	    case _constants.navigate.NEXT:
	      return _dates2.default.add(date, 1, 'day');
	
	    default:
	      return date;
	  }
	};
	
	Day.title = function (date, _ref) {
	  var formats = _ref.formats,
	      culture = _ref.culture;
	  return _localizer2.default.format(date, formats.dayHeaderFormat, culture);
	};
	
	exports.default = Day;
	module.exports = exports['default'];

/***/ },

/***/ "u0gy":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDom = __webpack_require__("O27J");
	
	var _dates = __webpack_require__("4PJJ");
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizer = __webpack_require__("HcfL");
	
	var _localizer2 = _interopRequireDefault(_localizer);
	
	var _DayColumn = __webpack_require__("8xSr");
	
	var _DayColumn2 = _interopRequireDefault(_DayColumn);
	
	var _TimeColumn = __webpack_require__("GvwJ");
	
	var _TimeColumn2 = _interopRequireDefault(_TimeColumn);
	
	var _DateContentRow = __webpack_require__("ZuRK");
	
	var _DateContentRow2 = _interopRequireDefault(_DateContentRow);
	
	var _Header = __webpack_require__("TpKw");
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _width = __webpack_require__("yvZl");
	
	var _width2 = _interopRequireDefault(_width);
	
	var _scrollbarSize = __webpack_require__("y6rd");
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _messages = __webpack_require__("m1jL");
	
	var _messages2 = _interopRequireDefault(_messages);
	
	var _propTypes3 = __webpack_require__("OBNG");
	
	var _helpers = __webpack_require__("FRUJ");
	
	var _accessors = __webpack_require__("Gtmz");
	
	var _eventLevels = __webpack_require__("SjBY");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimeGrid = (_temp = _class = function (_Component) {
	  _inherits(TimeGrid, _Component);
	
	  function TimeGrid(props) {
	    _classCallCheck(this, TimeGrid);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleSelectAllDaySlot = function (slots, slotInfo) {
	      var onSelectSlot = _this.props.onSelectSlot;
	
	      (0, _helpers.notify)(onSelectSlot, {
	        slots: slots,
	        start: slots[0],
	        end: slots[slots.length - 1],
	        action: slotInfo.action
	      });
	    };
	
	    _this.state = { gutterWidth: undefined, isOverflowing: null };
	    _this.handleSelectEvent = _this.handleSelectEvent.bind(_this);
	    _this.handleDoubleClickEvent = _this.handleDoubleClickEvent.bind(_this);
	    _this.handleHeaderClick = _this.handleHeaderClick.bind(_this);
	    return _this;
	  }
	
	  TimeGrid.prototype.componentWillMount = function componentWillMount() {
	    this._gutters = [];
	    this.calculateScroll();
	  };
	
	  TimeGrid.prototype.componentDidMount = function componentDidMount() {
	    this.checkOverflow();
	
	    if (this.props.width == null) {
	      this.measureGutter();
	    }
	    this.applyScroll();
	
	    this.positionTimeIndicator();
	    this.triggerTimeIndicatorUpdate();
	  };
	
	  TimeGrid.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.clearTimeout(this._timeIndicatorTimeout);
	  };
	
	  TimeGrid.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this.props.width == null && !this.state.gutterWidth) {
	      this.measureGutter();
	    }
	
	    this.applyScroll();
	    this.positionTimeIndicator();
	    //this.checkOverflow()
	  };
	
	  TimeGrid.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _props = this.props,
	        range = _props.range,
	        scrollToTime = _props.scrollToTime;
	    // When paginating, reset scroll
	
	    if (!_dates2.default.eq(nextProps.range[0], range[0], 'minute') || !_dates2.default.eq(nextProps.scrollToTime, scrollToTime, 'minute')) {
	      this.calculateScroll();
	    }
	  };
	
	  TimeGrid.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props2 = this.props,
	        events = _props2.events,
	        range = _props2.range,
	        width = _props2.width,
	        startAccessor = _props2.startAccessor,
	        endAccessor = _props2.endAccessor,
	        allDayAccessor = _props2.allDayAccessor,
	        showMultiDayTimes = _props2.showMultiDayTimes;
	
	
	    width = width || this.state.gutterWidth;
	
	    var start = range[0],
	        end = range[range.length - 1];
	
	    this.slots = range.length;
	
	    var allDayEvents = [],
	        rangeEvents = [];
	
	    events.forEach(function (event) {
	      if ((0, _eventLevels.inRange)(event, start, end, _this2.props)) {
	        var eStart = (0, _accessors.accessor)(event, startAccessor),
	            eEnd = (0, _accessors.accessor)(event, endAccessor);
	
	        if ((0, _accessors.accessor)(event, allDayAccessor) || _dates2.default.isJustDate(eStart) && _dates2.default.isJustDate(eEnd) || !showMultiDayTimes && !_dates2.default.eq(eStart, eEnd, 'day')) {
	          allDayEvents.push(event);
	        } else {
	          rangeEvents.push(event);
	        }
	      }
	    });
	
	    allDayEvents.sort(function (a, b) {
	      return (0, _eventLevels.sortEvents)(a, b, _this2.props);
	    });
	
	    var gutterRef = function gutterRef(ref) {
	      return _this2._gutters[1] = ref && (0, _reactDom.findDOMNode)(ref);
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'rbc-time-view' },
	      this.renderHeader(range, allDayEvents, width),
	      _react2.default.createElement(
	        'div',
	        { ref: 'content', className: 'rbc-time-content' },
	        _react2.default.createElement('div', { ref: 'timeIndicator', className: 'rbc-current-time-indicator' }),
	        _react2.default.createElement(_TimeColumn2.default, _extends({}, this.props, {
	          showLabels: true,
	          style: { width: width },
	          ref: gutterRef,
	          className: 'rbc-time-gutter'
	        })),
	        this.renderEvents(range, rangeEvents, this.props.now)
	      )
	    );
	  };
	
	  TimeGrid.prototype.renderEvents = function renderEvents(range, events, today) {
	    var _this3 = this;
	
	    var _props3 = this.props,
	        min = _props3.min,
	        max = _props3.max,
	        endAccessor = _props3.endAccessor,
	        startAccessor = _props3.startAccessor,
	        components = _props3.components;
	
	
	    return range.map(function (date, idx) {
	      var daysEvents = events.filter(function (event) {
	        return _dates2.default.inRange(date, (0, _accessors.accessor)(event, startAccessor), (0, _accessors.accessor)(event, endAccessor), 'day');
	      });
	
	      return _react2.default.createElement(_DayColumn2.default, _extends({}, _this3.props, {
	        min: _dates2.default.merge(date, min),
	        max: _dates2.default.merge(date, max),
	        eventComponent: components.event,
	        eventWrapperComponent: components.eventWrapper,
	        dayWrapperComponent: components.dayWrapper,
	        className: (0, _classnames2.default)({ 'rbc-now': _dates2.default.eq(date, today, 'day') }),
	        style: (0, _eventLevels.segStyle)(1, _this3.slots),
	        key: idx,
	        date: date,
	        events: daysEvents
	      }));
	    });
	  };
	
	  TimeGrid.prototype.renderHeader = function renderHeader(range, events, width) {
	    var _this4 = this;
	
	    var _props4 = this.props,
	        messages = _props4.messages,
	        rtl = _props4.rtl,
	        selectable = _props4.selectable,
	        components = _props4.components,
	        now = _props4.now;
	
	    var _ref = this.state || {},
	        isOverflowing = _ref.isOverflowing;
	
	    var style = {};
	    if (isOverflowing) style[rtl ? 'marginLeft' : 'marginRight'] = (0, _scrollbarSize2.default)() + 'px';
	
	    return _react2.default.createElement(
	      'div',
	      {
	        ref: 'headerCell',
	        className: (0, _classnames2.default)('rbc-time-header', isOverflowing && 'rbc-overflowing'),
	        style: style
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'rbc-row' },
	        _react2.default.createElement('div', {
	          className: 'rbc-label rbc-header-gutter',
	          style: { width: width }
	        }),
	        this.renderHeaderCells(range)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'rbc-row' },
	        _react2.default.createElement(
	          'div',
	          {
	            ref: function ref(_ref2) {
	              return _this4._gutters[0] = _ref2;
	            },
	            className: 'rbc-label rbc-header-gutter',
	            style: { width: width }
	          },
	          (0, _messages2.default)(messages).allDay
	        ),
	        _react2.default.createElement(_DateContentRow2.default, {
	          now: now,
	          minRows: 2,
	          range: range,
	          rtl: this.props.rtl,
	          events: events,
	          className: 'rbc-allday-cell',
	          selectable: selectable,
	          onSelectSlot: this.handleSelectAllDaySlot,
	          dateCellWrapper: components.dateCellWrapper,
	          dayPropGetter: this.props.dayPropGetter,
	          eventComponent: this.props.components.event,
	          eventWrapperComponent: this.props.components.eventWrapper,
	          titleAccessor: this.props.titleAccessor,
	          startAccessor: this.props.startAccessor,
	          endAccessor: this.props.endAccessor,
	          allDayAccessor: this.props.allDayAccessor,
	          eventPropGetter: this.props.eventPropGetter,
	          selected: this.props.selected,
	          onSelect: this.handleSelectEvent,
	          onDoubleClick: this.handleDoubleClickEvent,
	          longPressThreshold: this.props.longPressThreshold
	        })
	      )
	    );
	  };
	
	  TimeGrid.prototype.renderHeaderCells = function renderHeaderCells(range) {
	    var _this5 = this;
	
	    var _props5 = this.props,
	        dayFormat = _props5.dayFormat,
	        culture = _props5.culture,
	        components = _props5.components,
	        dayPropGetter = _props5.dayPropGetter,
	        getDrilldownView = _props5.getDrilldownView;
	
	    var HeaderComponent = components.header || _Header2.default;
	
	    return range.map(function (date, i) {
	      var drilldownView = getDrilldownView(date);
	      var label = _localizer2.default.format(date, dayFormat, culture);
	
	      var _ref3 = dayPropGetter && dayPropGetter(date) || {},
	          className = _ref3.className,
	          dayStyles = _ref3.style;
	
	      var header = _react2.default.createElement(HeaderComponent, {
	        date: date,
	        label: label,
	        localizer: _localizer2.default,
	        format: dayFormat,
	        culture: culture
	      });
	
	      return _react2.default.createElement(
	        'div',
	        {
	          key: i,
	          className: (0, _classnames2.default)('rbc-header', className, _dates2.default.isToday(date) && 'rbc-today'),
	          style: Object.assign({}, dayStyles, (0, _eventLevels.segStyle)(1, _this5.slots))
	        },
	        drilldownView ? _react2.default.createElement(
	          'a',
	          {
	            href: '#',
	            onClick: function onClick(e) {
	              return _this5.handleHeaderClick(date, drilldownView, e);
	            }
	          },
	          header
	        ) : _react2.default.createElement(
	          'span',
	          null,
	          header
	        )
	      );
	    });
	  };
	
	  TimeGrid.prototype.handleHeaderClick = function handleHeaderClick(date, view, e) {
	    e.preventDefault();
	    (0, _helpers.notify)(this.props.onDrillDown, [date, view]);
	  };
	
	  TimeGrid.prototype.handleSelectEvent = function handleSelectEvent() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    (0, _helpers.notify)(this.props.onSelectEvent, args);
	  };
	
	  TimeGrid.prototype.handleDoubleClickEvent = function handleDoubleClickEvent() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    (0, _helpers.notify)(this.props.onDoubleClickEvent, args);
	  };
	
	  TimeGrid.prototype.handleSelectAlldayEvent = function handleSelectAlldayEvent() {
	    //cancel any pending selections so only the event click goes through.
	    this.clearSelection();
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    (0, _helpers.notify)(this.props.onSelectEvent, args);
	  };
	
	  TimeGrid.prototype.clearSelection = function clearSelection() {
	    clearTimeout(this._selectTimer);
	    this._pendingSelection = [];
	  };
	
	  TimeGrid.prototype.measureGutter = function measureGutter() {
	    var width = this.state.gutterWidth;
	    var gutterCells = this._gutters;
	
	    if (!width) {
	      width = Math.max.apply(Math, gutterCells.map(_width2.default));
	
	      if (width) {
	        this.setState({ gutterWidth: width });
	      }
	    }
	  };
	
	  TimeGrid.prototype.applyScroll = function applyScroll() {
	    if (this._scrollRatio) {
	      var content = this.refs.content;
	
	      content.scrollTop = content.scrollHeight * this._scrollRatio;
	      // Only do this once
	      this._scrollRatio = null;
	    }
	  };
	
	  TimeGrid.prototype.calculateScroll = function calculateScroll() {
	    var _props6 = this.props,
	        min = _props6.min,
	        max = _props6.max,
	        scrollToTime = _props6.scrollToTime;
	
	
	    var diffMillis = scrollToTime - _dates2.default.startOf(scrollToTime, 'day');
	    var totalMillis = _dates2.default.diff(max, min);
	
	    this._scrollRatio = diffMillis / totalMillis;
	  };
	
	  TimeGrid.prototype.checkOverflow = function checkOverflow() {
	    var _this6 = this;
	
	    if (this._updatingOverflow) return;
	
	    var isOverflowing = this.refs.content.scrollHeight > this.refs.content.clientHeight;
	
	    if (this.state.isOverflowing !== isOverflowing) {
	      this._updatingOverflow = true;
	      this.setState({ isOverflowing: isOverflowing }, function () {
	        _this6._updatingOverflow = false;
	      });
	    }
	  };
	
	  TimeGrid.prototype.positionTimeIndicator = function positionTimeIndicator() {
	    var _props7 = this.props,
	        rtl = _props7.rtl,
	        min = _props7.min,
	        max = _props7.max;
	
	    var now = new Date();
	
	    var secondsGrid = _dates2.default.diff(max, min, 'seconds');
	    var secondsPassed = _dates2.default.diff(now, min, 'seconds');
	
	    var timeIndicator = this.refs.timeIndicator;
	    var factor = secondsPassed / secondsGrid;
	    var timeGutter = this._gutters[this._gutters.length - 1];
	
	    if (timeGutter && now >= min && now <= max) {
	      var pixelHeight = timeGutter.offsetHeight;
	      var offset = Math.floor(factor * pixelHeight);
	
	      timeIndicator.style.display = 'block';
	      timeIndicator.style[rtl ? 'left' : 'right'] = 0;
	      timeIndicator.style[rtl ? 'right' : 'left'] = timeGutter.offsetWidth + 'px';
	      timeIndicator.style.top = offset + 'px';
	    } else {
	      timeIndicator.style.display = 'none';
	    }
	  };
	
	  TimeGrid.prototype.triggerTimeIndicatorUpdate = function triggerTimeIndicatorUpdate() {
	    var _this7 = this;
	
	    // Update the position of the time indicator every minute
	    this._timeIndicatorTimeout = window.setTimeout(function () {
	      _this7.positionTimeIndicator();
	
	      _this7.triggerTimeIndicatorUpdate();
	    }, 60000);
	  };
	
	  return TimeGrid;
	}(_react.Component), _class.defaultProps = {
	  step: 30,
	  min: _dates2.default.startOf(new Date(), 'day'),
	  max: _dates2.default.endOf(new Date(), 'day'),
	  scrollToTime: _dates2.default.startOf(new Date(), 'day'),
	  /* these 2 are needed to satisfy requirements from TimeColumn required props
	   * There is a strange bug in React, using ...TimeColumn.defaultProps causes weird crashes
	   */
	  type: 'gutter',
	  now: new Date()
	}, _temp);
	exports.default = TimeGrid;
	module.exports = exports['default'];

/***/ },

/***/ "8xSr":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp2, _initialiseProps;
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("O27J");
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Selection = __webpack_require__("yEJm");
	
	var _Selection2 = _interopRequireDefault(_Selection);
	
	var _dates = __webpack_require__("4PJJ");
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _selection = __webpack_require__("RGiR");
	
	var _localizer = __webpack_require__("HcfL");
	
	var _localizer2 = _interopRequireDefault(_localizer);
	
	var _helpers = __webpack_require__("FRUJ");
	
	var _propTypes3 = __webpack_require__("OBNG");
	
	var _accessors = __webpack_require__("Gtmz");
	
	var _dayViewLayout = __webpack_require__("71MT");
	
	var _dayViewLayout2 = _interopRequireDefault(_dayViewLayout);
	
	var _TimeColumn = __webpack_require__("GvwJ");
	
	var _TimeColumn2 = _interopRequireDefault(_TimeColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function snapToSlot(date, step) {
	  var roundTo = 1000 * 60 * step;
	  return new Date(Math.floor(date.getTime() / roundTo) * roundTo);
	}
	
	function startsAfter(date, max) {
	  return _dates2.default.gt(_dates2.default.merge(max, date), max, 'minutes');
	}
	
	var DayColumn = (_temp2 = _class = function (_React$Component) {
	  _inherits(DayColumn, _React$Component);
	
	  function DayColumn() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DayColumn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DayColumn.prototype.componentDidMount = function componentDidMount() {
	    this.props.selectable && this._selectable();
	  };
	
	  DayColumn.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._teardownSelectable();
	  };
	
	  DayColumn.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.selectable && !this.props.selectable) this._selectable();
	    if (!nextProps.selectable && this.props.selectable) this._teardownSelectable();
	  };
	
	  DayColumn.prototype.render = function render() {
	    var _props = this.props,
	        min = _props.min,
	        max = _props.max,
	        step = _props.step,
	        now = _props.now,
	        selectRangeFormat = _props.selectRangeFormat,
	        culture = _props.culture,
	        dayPropGetter = _props.dayPropGetter,
	        props = _objectWithoutProperties(_props, ['min', 'max', 'step', 'now', 'selectRangeFormat', 'culture', 'dayPropGetter']);
	
	    this._totalMin = _dates2.default.diff(min, max, 'minutes');
	    var _state = this.state,
	        selecting = _state.selecting,
	        startSlot = _state.startSlot,
	        endSlot = _state.endSlot;
	
	    var slotStyle = this._slotStyle(startSlot, endSlot);
	
	    var selectDates = {
	      start: this.state.startDate,
	      end: this.state.endDate
	    };
	
	    var _ref = dayPropGetter && dayPropGetter(max) || {},
	        className = _ref.className,
	        style = _ref.style;
	
	    return _react2.default.createElement(
	      _TimeColumn2.default,
	      _extends({}, props, {
	        className: (0, _classnames2.default)('rbc-day-slot', className, _dates2.default.isToday(max) && 'rbc-today'),
	        style: style,
	        now: now,
	        min: min,
	        max: max,
	        step: step
	      }),
	      this.renderEvents(),
	      selecting && _react2.default.createElement(
	        'div',
	        { className: 'rbc-slot-selection', style: slotStyle },
	        _react2.default.createElement(
	          'span',
	          null,
	          _localizer2.default.format(selectDates, selectRangeFormat, culture)
	        )
	      )
	    );
	  };
	
	  return DayColumn;
	}(_react2.default.Component), _class.defaultProps = {
	  dragThroughEvents: true,
	  timeslots: 2
	}, _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.state = { selecting: false };
	
	  this.renderEvents = function () {
	    var _props2 = _this2.props,
	        events = _props2.events,
	        min = _props2.min,
	        max = _props2.max,
	        showMultiDayTimes = _props2.showMultiDayTimes,
	        culture = _props2.culture,
	        eventPropGetter = _props2.eventPropGetter,
	        selected = _props2.selected,
	        messages = _props2.messages,
	        eventComponent = _props2.eventComponent,
	        eventTimeRangeFormat = _props2.eventTimeRangeFormat,
	        eventTimeRangeStartFormat = _props2.eventTimeRangeStartFormat,
	        eventTimeRangeEndFormat = _props2.eventTimeRangeEndFormat,
	        EventWrapper = _props2.eventWrapperComponent,
	        isRtl = _props2.rtl,
	        step = _props2.step,
	        timeslots = _props2.timeslots,
	        startAccessor = _props2.startAccessor,
	        endAccessor = _props2.endAccessor,
	        titleAccessor = _props2.titleAccessor;
	
	
	    var EventComponent = eventComponent;
	
	    var styledEvents = (0, _dayViewLayout2.default)({
	      events: events,
	      startAccessor: startAccessor,
	      endAccessor: endAccessor,
	      min: min,
	      showMultiDayTimes: showMultiDayTimes,
	      totalMin: _this2._totalMin,
	      step: step,
	      timeslots: timeslots
	    });
	
	    return styledEvents.map(function (_ref2, idx) {
	      var _extends2;
	
	      var event = _ref2.event,
	          style = _ref2.style;
	
	      var _eventTimeRangeFormat = eventTimeRangeFormat;
	      var _continuesPrior = false;
	      var _continuesAfter = false;
	      var start = (0, _accessors.accessor)(event, startAccessor);
	      var end = (0, _accessors.accessor)(event, endAccessor);
	
	      if (start < min) {
	        start = min;
	        _continuesPrior = true;
	        _eventTimeRangeFormat = eventTimeRangeEndFormat;
	      }
	
	      if (end > max) {
	        end = max;
	        _continuesAfter = true;
	        _eventTimeRangeFormat = eventTimeRangeStartFormat;
	      }
	
	      var continuesPrior = (0, _dayViewLayout.startsBefore)(start, min);
	      var continuesAfter = startsAfter(end, max);
	
	      var title = (0, _accessors.accessor)(event, titleAccessor);
	      var label = void 0;
	      if (_continuesPrior && _continuesAfter) {
	        label = messages.allDay;
	      } else {
	        label = _localizer2.default.format({ start: start, end: end }, _eventTimeRangeFormat, culture);
	      }
	
	      var _isSelected = (0, _selection.isSelected)(event, selected);
	
	      if (eventPropGetter) var _eventPropGetter = eventPropGetter(event, start, end, _isSelected),
	            xStyle = _eventPropGetter.style,
	            className = _eventPropGetter.className;
	
	      var height = style.height,
	          top = style.top,
	          width = style.width,
	          xOffset = style.xOffset;
	
	
	      return _react2.default.createElement(
	        EventWrapper,
	        { event: event, key: 'evt_' + idx },
	        _react2.default.createElement(
	          'div',
	          {
	            style: _extends({}, xStyle, (_extends2 = {
	              top: top + '%',
	              height: height + '%'
	            }, _extends2[isRtl ? 'right' : 'left'] = Math.max(0, xOffset) + '%', _extends2.width = width + '%', _extends2)),
	            title: (typeof label === 'string' ? label + ': ' : '') + title,
	            onClick: function onClick(e) {
	              return _this2._select(event, e);
	            },
	            onDoubleClick: function onDoubleClick(e) {
	              return _this2._doubleClick(event, e);
	            },
	            className: (0, _classnames2.default)('rbc-event', className, {
	              'rbc-selected': _isSelected,
	              'rbc-event-continues-earlier': continuesPrior,
	              'rbc-event-continues-later': continuesAfter,
	              'rbc-event-continues-day-prior': _continuesPrior,
	              'rbc-event-continues-day-after': _continuesAfter
	            })
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'rbc-event-label' },
	            label
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'rbc-event-content' },
	            EventComponent ? _react2.default.createElement(EventComponent, { event: event, title: title }) : title
	          )
	        )
	      );
	    });
	  };
	
	  this._slotStyle = function (startSlot, endSlot) {
	    var top = startSlot / _this2._totalMin * 100;
	    var bottom = endSlot / _this2._totalMin * 100;
	
	    return {
	      top: top + '%',
	      height: bottom - top + '%'
	    };
	  };
	
	  this._selectable = function () {
	    var node = (0, _reactDom.findDOMNode)(_this2);
	    var selector = _this2._selector = new _Selection2.default(function () {
	      return (0, _reactDom.findDOMNode)(_this2);
	    }, {
	      longPressThreshold: _this2.props.longPressThreshold
	    });
	
	    var maybeSelect = function maybeSelect(box) {
	      var onSelecting = _this2.props.onSelecting;
	      var current = _this2.state || {};
	      var state = selectionState(box);
	      var start = state.startDate,
	          end = state.endDate;
	
	
	      if (onSelecting) {
	        if (_dates2.default.eq(current.startDate, start, 'minutes') && _dates2.default.eq(current.endDate, end, 'minutes') || onSelecting({ start: start, end: end }) === false) return;
	      }
	
	      _this2.setState(state);
	    };
	
	    var selectionState = function selectionState(_ref3) {
	      var y = _ref3.y;
	      var _props3 = _this2.props,
	          step = _props3.step,
	          min = _props3.min,
	          max = _props3.max;
	
	      var _getBoundsForNode = (0, _Selection.getBoundsForNode)(node),
	          top = _getBoundsForNode.top,
	          bottom = _getBoundsForNode.bottom;
	
	      var mins = _this2._totalMin;
	
	      var range = Math.abs(top - bottom);
	
	      var current = (y - top) / range;
	
	      current = snapToSlot(minToDate(mins * current, min), step);
	
	      if (!_this2.state.selecting) _this2._initialDateSlot = current;
	
	      var initial = _this2._initialDateSlot;
	
	      if (_dates2.default.eq(initial, current, 'minutes')) current = _dates2.default.add(current, step, 'minutes');
	
	      var start = _dates2.default.max(min, _dates2.default.min(initial, current));
	      var end = _dates2.default.min(max, _dates2.default.max(initial, current));
	
	      return {
	        selecting: true,
	        startDate: start,
	        endDate: end,
	        startSlot: (0, _dayViewLayout.positionFromDate)(start, min, _this2._totalMin),
	        endSlot: (0, _dayViewLayout.positionFromDate)(end, min, _this2._totalMin)
	      };
	    };
	
	    var selectorClicksHandler = function selectorClicksHandler(box, actionType) {
	      if (!(0, _Selection.isEvent)((0, _reactDom.findDOMNode)(_this2), box)) _this2._selectSlot(_extends({}, selectionState(box), { action: actionType }));
	
	      _this2.setState({ selecting: false });
	    };
	
	    selector.on('selecting', maybeSelect);
	    selector.on('selectStart', maybeSelect);
	
	    selector.on('beforeSelect', function (box) {
	      if (_this2.props.selectable !== 'ignoreEvents') return;
	
	      return !(0, _Selection.isEvent)((0, _reactDom.findDOMNode)(_this2), box);
	    });
	
	    selector.on('click', function (box) {
	      return selectorClicksHandler(box, 'click');
	    });
	
	    selector.on('doubleClick', function (box) {
	      return selectorClicksHandler(box, 'doubleClick');
	    });
	
	    selector.on('select', function () {
	      if (_this2.state.selecting) {
	        _this2._selectSlot(_extends({}, _this2.state, { action: 'select' }));
	        _this2.setState({ selecting: false });
	      }
	    });
	  };
	
	  this._teardownSelectable = function () {
	    if (!_this2._selector) return;
	    _this2._selector.teardown();
	    _this2._selector = null;
	  };
	
	  this._selectSlot = function (_ref4) {
	    var startDate = _ref4.startDate,
	        endDate = _ref4.endDate,
	        action = _ref4.action;
	
	    var current = startDate,
	        slots = [];
	
	    while (_dates2.default.lte(current, endDate)) {
	      slots.push(current);
	      current = _dates2.default.add(current, _this2.props.step, 'minutes');
	    }
	
	    (0, _helpers.notify)(_this2.props.onSelectSlot, {
	      slots: slots,
	      start: startDate,
	      end: endDate,
	      action: action
	    });
	  };
	
	  this._select = function () {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    (0, _helpers.notify)(_this2.props.onSelectEvent, args);
	  };
	
	  this._doubleClick = function () {
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    (0, _helpers.notify)(_this2.props.onDoubleClickEvent, args);
	  };
	}, _temp2);
	
	
	function minToDate(min, date) {
	  var dt = new Date(date),
	      totalMins = _dates2.default.diff(_dates2.default.startOf(date, 'day'), date, 'minutes');
	
	  dt = _dates2.default.hours(dt, 0);
	  dt = _dates2.default.minutes(dt, totalMins + min);
	  dt = _dates2.default.seconds(dt, 0);
	  return _dates2.default.milliseconds(dt, 0);
	}
	
	exports.default = DayColumn;
	module.exports = exports['default'];

/***/ },

/***/ "71MT":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.startsBefore = startsBefore;
	exports.positionFromDate = positionFromDate;
	exports.default = getStyledEvents;
	
	var _accessors = __webpack_require__("Gtmz");
	
	var _dates = __webpack_require__("4PJJ");
	
	var _dates2 = _interopRequireDefault(_dates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function startsBefore(date, min) {
	  return _dates2.default.lt(_dates2.default.merge(min, date), min, 'minutes');
	}
	
	function positionFromDate(date, min, total) {
	  if (startsBefore(date, min)) return 0;
	
	  var diff = _dates2.default.diff(min, _dates2.default.merge(min, date), 'minutes');
	  return Math.min(diff, total);
	}
	
	/**
	 * Events will be sorted primarily according to earliest start time.
	 * If two events start at the same time, the one with the longest duration will
	 * be placed first.
	 */
	var sort = function sort(events, _ref) {
	  var startAccessor = _ref.startAccessor,
	      endAccessor = _ref.endAccessor;
	  return events.sort(function (a, b) {
	    var startA = +(0, _accessors.accessor)(a, startAccessor);
	    var startB = +(0, _accessors.accessor)(b, startAccessor);
	    if (startA === startB) {
	      return +(0, _accessors.accessor)(b, endAccessor) - +(0, _accessors.accessor)(a, endAccessor);
	    }
	
	    return startA - startB;
	  });
	};
	
	var getSlot = function getSlot(event, accessor, min, totalMin) {
	  return event && positionFromDate((0, _accessors.accessor)(event, accessor), min, totalMin);
	};
	
	/**
	 * Two events are considered siblings if the difference between their
	 * start time is less than (step*timeslots) hour.
	 */
	var isSibling = function isSibling(idx1, idx2, _ref2) {
	  var events = _ref2.events,
	      startAccessor = _ref2.startAccessor,
	      endAccessor = _ref2.endAccessor,
	      min = _ref2.min,
	      totalMin = _ref2.totalMin,
	      step = _ref2.step,
	      timeslots = _ref2.timeslots;
	
	  var event1 = events[idx1];
	  var event2 = events[idx2];
	
	  if (!event1 || !event2) return false;
	
	  var start1 = getSlot(event1, startAccessor, min, totalMin);
	  var start2 = getSlot(event2, startAccessor, min, totalMin);
	  var end1 = getSlot(event1, endAccessor, min, totalMin);
	
	  return Math.abs(start1 - start2) < step * timeslots && start2 < end1;
	};
	
	/**
	 * An event is considered a child of another event if its start time is
	 * more than (step*timeslots) hour later than the other event's start time,
	 * but before its end time.
	 */
	var isChild = function isChild(parentIdx, childIdx, _ref3) {
	  var events = _ref3.events,
	      startAccessor = _ref3.startAccessor,
	      endAccessor = _ref3.endAccessor,
	      min = _ref3.min,
	      totalMin = _ref3.totalMin,
	      step = _ref3.step,
	      timeslots = _ref3.timeslots;
	
	  if (isSibling(parentIdx, childIdx, { events: events, startAccessor: startAccessor, endAccessor: endAccessor, min: min, totalMin: totalMin, step: step, timeslots: timeslots })) return false;
	
	  var parentEnd = getSlot(events[parentIdx], endAccessor, min, totalMin);
	  var childStart = getSlot(events[childIdx], startAccessor, min, totalMin);
	
	  return parentEnd > childStart;
	};
	
	/**
	 * Given an event index, siblings directly following it will be found and
	 * returned as an array of indexes.
	 */
	var getSiblings = function getSiblings(idx, _ref4) {
	  var events = _ref4.events,
	      startAccessor = _ref4.startAccessor,
	      endAccessor = _ref4.endAccessor,
	      min = _ref4.min,
	      totalMin = _ref4.totalMin,
	      step = _ref4.step,
	      timeslots = _ref4.timeslots;
	
	  var nextIdx = idx;
	  var siblings = [];
	
	  while (isSibling(idx, ++nextIdx, { events: events, startAccessor: startAccessor, endAccessor: endAccessor, min: min, totalMin: totalMin, step: step, timeslots: timeslots })) {
	    siblings.push(nextIdx);
	  }
	
	  return siblings;
	};
	
	/**
	 * Given an event index, and a start search position, all child events to that
	 * event will be found and placed into groups of siblings.
	 * The return value is an array of child group arrays, as well as the largest
	 * size of the child groups.
	 */
	var getChildGroups = function getChildGroups(idx, nextIdx, _ref5) {
	  var events = _ref5.events,
	      startAccessor = _ref5.startAccessor,
	      endAccessor = _ref5.endAccessor,
	      min = _ref5.min,
	      totalMin = _ref5.totalMin,
	      step = _ref5.step,
	      timeslots = _ref5.timeslots;
	
	  var groups = [];
	  var nbrOfColumns = 0;
	
	  while (isChild(idx, nextIdx, { events: events, startAccessor: startAccessor, endAccessor: endAccessor, min: min, totalMin: totalMin, step: step, timeslots: timeslots })) {
	    var childGroup = [nextIdx];
	    var siblingIdx = nextIdx;
	
	    while (isSibling(nextIdx, ++siblingIdx, { events: events, startAccessor: startAccessor, endAccessor: endAccessor, min: min, totalMin: totalMin, step: step, timeslots: timeslots })) {
	      childGroup.push(siblingIdx);
	    }
	
	    nbrOfColumns = Math.max(nbrOfColumns, childGroup.length);
	    groups.push(childGroup);
	    nextIdx = siblingIdx;
	  }
	
	  return { childGroups: groups, nbrOfChildColumns: nbrOfColumns };
	};
	
	var constructEvent = function constructEvent(title, start, end) {
	  return {
	    title: title,
	    start: start,
	    end: end
	  };
	};
	
	var handleMultiDayEvents = function handleMultiDayEvents(title, start, end, current) {
	  var s = new Date(start);
	  var e = new Date(end);
	  var c = new Date(current);
	
	  // use noon to compare dates to avoid DST issues
	  s.setHours(12, 0, 0, 0);
	  e.setHours(12, 0, 0, 0);
	  c.setHours(12, 0, 0, 0);
	
	  // if current day is at the start, but spans multiple days, correct the end
	  if (+c === +s && c < e) {
	    return constructEvent(title, start, _dates2.default.endOf(start, 'day'));
	  }
	
	  // if current day is in between start and end dates, span all day
	  else if (c > s && c < e) {
	      return constructEvent(title, current, _dates2.default.endOf(current, 'day'));
	    }
	
	    // if current day is at the end of a multi day event, start at midnight to the end
	    else if (c > s && +c === +e) {
	        return constructEvent(title, current, end);
	      }
	};
	
	/**
	 * Returns height and top offset, both in percentage, for an event at
	 * the specified index.
	 */
	var getYStyles = function getYStyles(idx, _ref6) {
	  var events = _ref6.events,
	      startAccessor = _ref6.startAccessor,
	      endAccessor = _ref6.endAccessor,
	      min = _ref6.min,
	      showMultiDayTimes = _ref6.showMultiDayTimes,
	      totalMin = _ref6.totalMin,
	      step = _ref6.step;
	
	  var event = events[idx];
	
	  var startDate = (0, _accessors.accessor)(event, startAccessor); // start date
	  var endDate = (0, _accessors.accessor)(event, endAccessor); // end date
	  var currentDate = new Date(min); // min is the current date at midnight
	
	  var multiDayEvent = void 0;
	  if (showMultiDayTimes) {
	    multiDayEvent = handleMultiDayEvents(event.title, startDate, endDate, currentDate);
	  }
	
	  var start = getSlot(multiDayEvent || event, startAccessor, min, totalMin);
	  var end = Math.max(getSlot(multiDayEvent || event, endAccessor, min, totalMin), start + step);
	  var top = start / totalMin * 100;
	  var bottom = end / totalMin * 100;
	
	  var height = bottom - top;
	
	  return {
	    top: top,
	    height: height
	  };
	};
	
	/**
	 * Takes an array of unsorted events, and returns a sorted array
	 * containing the same events, but with an additional style property.
	 * These styles will position the events similarly to Google Calendar.
	 *
	 * The algorithm will start by sorting the array, and then iterating over it.
	 * Starting at the first event, each of its siblings and children, placed in
	 * groups of siblings, will be found. Both are needed in order to calculate the
	 * width of the first event. When the width is known, its siblings will be
	 * given the same width, but with an incremental x-offset.
	 *
	 * Each group of children will be looking to move as far away from its original
	 * parent as possible. A move can be made to one of the parent's siblings, if
	 * that sibling is also a parent to the child group. This will make room for
	 * more events.
	 *
	 * When a child group knows its parent, it looks at the space occupied by that
	 * parent, and calculates the remaning available space and divides that among
	 * each other.
	 *
	 * All widths and x-offsets are calculated without taking overlapping into
	 * account. Overlapping is added in the end according to the OVERLAP_MULTIPLIER.
	 * If that is set to 0, the events won't overlap or grow.
	 *
	 * When one of these rounds are finished, all events connected have been
	 * traversed, so the cursor will be moved past all of them.
	 */
	function getStyledEvents(_ref7) {
	  var unsortedEvents = _ref7.events,
	      startAccessor = _ref7.startAccessor,
	      endAccessor = _ref7.endAccessor,
	      min = _ref7.min,
	      totalMin = _ref7.totalMin,
	      showMultiDayTimes = _ref7.showMultiDayTimes,
	      step = _ref7.step,
	      timeslots = _ref7.timeslots;
	
	  var OVERLAP_MULTIPLIER = 0.2;
	  var events = sort(unsortedEvents, { startAccessor: startAccessor, endAccessor: endAccessor });
	  var helperArgs = { events: events, startAccessor: startAccessor, endAccessor: endAccessor, min: min, showMultiDayTimes: showMultiDayTimes, totalMin: totalMin, step: step, timeslots: timeslots };
	  var styledEvents = [];
	  var idx = 0;
	
	  // One iteration will cover all connected events.
	
	  var _loop = function _loop() {
	    var siblings = getSiblings(idx, helperArgs);
	
	    var _getChildGroups = getChildGroups(idx, idx + siblings.length + 1, helperArgs),
	        childGroups = _getChildGroups.childGroups,
	        nbrOfChildColumns = _getChildGroups.nbrOfChildColumns;
	
	    var nbrOfColumns = Math.max(nbrOfChildColumns, siblings.length) + 1;
	    // Set styles to top level events.
	    [idx].concat(siblings).forEach(function (eventIdx, siblingIdx) {
	      var width = 100 / nbrOfColumns;
	      var xAdjustment = width * (nbrOfColumns > 1 ? OVERLAP_MULTIPLIER : 0);
	
	      var _getYStyles = getYStyles(eventIdx, helperArgs),
	          top = _getYStyles.top,
	          height = _getYStyles.height;
	
	      styledEvents[eventIdx] = {
	        event: events[eventIdx],
	        style: {
	          top: top,
	          height: height,
	          width: width + xAdjustment,
	          xOffset: width * siblingIdx - xAdjustment
	        }
	      };
	    });
	    childGroups.forEach(function (group) {
	      var parentIdx = idx;
	      var siblingIdx = 0;
	
	      // Move child group to sibling if possible, since this will makes
	      // room for more events.
	      while (isChild(siblings[siblingIdx], group[0], helperArgs)) {
	        parentIdx = siblings[siblingIdx];
	        siblingIdx++;
	      }
	
	      // Set styles to child events.
	      group.forEach(function (eventIdx, i) {
	        var parentStyle = styledEvents[parentIdx].style;
	
	        var spaceOccupiedByParent = parentStyle.width + parentStyle.xOffset;
	        var columns = Math.min(group.length, nbrOfColumns);
	        var width = (120 - spaceOccupiedByParent) / columns;
	        var xAdjustment = spaceOccupiedByParent * OVERLAP_MULTIPLIER;
	
	        var _getYStyles2 = getYStyles(eventIdx, helperArgs),
	            top = _getYStyles2.top,
	            height = _getYStyles2.height;
	
	        styledEvents[eventIdx] = {
	          event: events[eventIdx],
	          style: {
	            top: top,
	            height: height,
	            width: width + xAdjustment,
	            xOffset: spaceOccupiedByParent + width * i - xAdjustment
	          }
	        };
	      });
	    });
	
	    // Move past all events we just went through
	    idx += 1 + siblings.length + childGroups.reduce(function (total, group) {
	      return total + group.length;
	    }, 0);
	  };
	
	  while (idx < events.length) {
	    _loop();
	  }
	  return styledEvents;
	}

/***/ },

/***/ "GvwJ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dates = __webpack_require__("4PJJ");
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _propTypes3 = __webpack_require__("OBNG");
	
	var _BackgroundWrapper = __webpack_require__("0+GY");
	
	var _BackgroundWrapper2 = _interopRequireDefault(_BackgroundWrapper);
	
	var _TimeSlotGroup = __webpack_require__("TS0i");
	
	var _TimeSlotGroup2 = _interopRequireDefault(_TimeSlotGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimeColumn = (_temp = _class = function (_Component) {
	  _inherits(TimeColumn, _Component);
	
	  function TimeColumn() {
	    _classCallCheck(this, TimeColumn);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TimeColumn.prototype.renderTimeSliceGroup = function renderTimeSliceGroup(key, isNow, date) {
	    var _props = this.props,
	        dayWrapperComponent = _props.dayWrapperComponent,
	        timeslots = _props.timeslots,
	        showLabels = _props.showLabels,
	        step = _props.step,
	        slotPropGetter = _props.slotPropGetter,
	        dayPropGetter = _props.dayPropGetter,
	        timeGutterFormat = _props.timeGutterFormat,
	        culture = _props.culture;
	
	
	    return _react2.default.createElement(_TimeSlotGroup2.default, {
	      key: key,
	      isNow: isNow,
	      value: date,
	      step: step,
	      slotPropGetter: slotPropGetter,
	      dayPropGetter: dayPropGetter,
	      culture: culture,
	      timeslots: timeslots,
	      showLabels: showLabels,
	      timeGutterFormat: timeGutterFormat,
	      dayWrapperComponent: dayWrapperComponent
	    });
	  };
	
	  TimeColumn.prototype.render = function render() {
	    var _props2 = this.props,
	        className = _props2.className,
	        children = _props2.children,
	        style = _props2.style,
	        now = _props2.now,
	        min = _props2.min,
	        max = _props2.max,
	        step = _props2.step,
	        timeslots = _props2.timeslots;
	
	    var totalMin = _dates2.default.diff(min, max, 'minutes');
	    var numGroups = Math.ceil(totalMin / (step * timeslots));
	    var renderedSlots = [];
	    var groupLengthInMinutes = step * timeslots;
	
	    var date = min;
	    var next = date;
	    var isNow = false;
	
	    for (var i = 0; i < numGroups; i++) {
	      isNow = _dates2.default.inRange(now, date, _dates2.default.add(next, groupLengthInMinutes - 1, 'minutes'), 'minutes');
	
	      next = _dates2.default.add(date, groupLengthInMinutes, 'minutes');
	      renderedSlots.push(this.renderTimeSliceGroup(i, isNow, date));
	
	      date = next;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(className, 'rbc-time-column'),
	        style: style
	      },
	      renderedSlots,
	      children
	    );
	  };
	
	  return TimeColumn;
	}(_react.Component), _class.defaultProps = {
	  step: 30,
	  timeslots: 2,
	  showLabels: false,
	  type: 'day',
	  className: '',
	  dayWrapperComponent: _BackgroundWrapper2.default
	}, _temp);
	exports.default = TimeColumn;
	module.exports = exports['default'];

/***/ },

/***/ "0+GY":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BackgroundWrapper = function (_React$Component) {
	  _inherits(BackgroundWrapper, _React$Component);
	
	  function BackgroundWrapper() {
	    _classCallCheck(this, BackgroundWrapper);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BackgroundWrapper.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return BackgroundWrapper;
	}(_react2.default.Component);
	
	exports.default = BackgroundWrapper;
	module.exports = exports['default'];

/***/ },

/***/ "TS0i":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TimeSlot = __webpack_require__("amBA");
	
	var _TimeSlot2 = _interopRequireDefault(_TimeSlot);
	
	var _dates = __webpack_require__("4PJJ");
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizer = __webpack_require__("HcfL");
	
	var _localizer2 = _interopRequireDefault(_localizer);
	
	var _propTypes3 = __webpack_require__("OBNG");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimeSlotGroup = (_temp = _class = function (_Component) {
	  _inherits(TimeSlotGroup, _Component);
	
	  function TimeSlotGroup() {
	    _classCallCheck(this, TimeSlotGroup);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TimeSlotGroup.prototype.renderSlice = function renderSlice(slotNumber, content, value) {
	    var _props = this.props,
	        dayWrapperComponent = _props.dayWrapperComponent,
	        showLabels = _props.showLabels,
	        isNow = _props.isNow,
	        culture = _props.culture,
	        slotPropGetter = _props.slotPropGetter;
	
	    return _react2.default.createElement(_TimeSlot2.default, {
	      key: slotNumber,
	      slotPropGetter: slotPropGetter,
	      dayWrapperComponent: dayWrapperComponent,
	      showLabel: showLabels && !slotNumber,
	      content: content,
	      culture: culture,
	      isNow: isNow,
	      value: value
	    });
	  };
	
	  TimeSlotGroup.prototype.renderSlices = function renderSlices() {
	    var ret = [];
	    var sliceLength = this.props.step;
	    var sliceValue = this.props.value;
	    for (var i = 0; i < this.props.timeslots; i++) {
	      var content = _localizer2.default.format(sliceValue, this.props.timeGutterFormat, this.props.culture);
	      ret.push(this.renderSlice(i, content, sliceValue));
	      sliceValue = _dates2.default.add(sliceValue, sliceLength, 'minutes');
	    }
	    return ret;
	  };
	
	  TimeSlotGroup.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'rbc-timeslot-group' },
	      this.renderSlices()
	    );
	  };
	
	  return TimeSlotGroup;
	}(_react.Component), _class.defaultProps = {
	  timeslots: 2,
	  step: 30,
	  isNow: false,
	  showLabels: false
	}, _temp);
	exports.default = TimeSlotGroup;
	module.exports = exports['default'];

/***/ },

/***/ "amBA":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes3 = __webpack_require__("OBNG");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimeSlot = (_temp = _class = function (_Component) {
	  _inherits(TimeSlot, _Component);
	
	  function TimeSlot() {
	    _classCallCheck(this, TimeSlot);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TimeSlot.prototype.render = function render() {
	    var _props = this.props,
	        value = _props.value,
	        slotPropGetter = _props.slotPropGetter;
	
	    var Wrapper = this.props.dayWrapperComponent;
	
	    var _ref = slotPropGetter && slotPropGetter(value) || {},
	        className = _ref.className,
	        style = _ref.style;
	
	    return _react2.default.createElement(
	      Wrapper,
	      { value: value },
	      _react2.default.createElement(
	        'div',
	        {
	          style: style,
	          className: (0, _classnames2.default)('rbc-time-slot', className, this.props.showLabel && 'rbc-label', this.props.isNow && 'rbc-now')
	        },
	        this.props.showLabel && _react2.default.createElement(
	          'span',
	          null,
	          this.props.content
	        )
	      )
	    );
	  };
	
	  return TimeSlot;
	}(_react.Component), _class.defaultProps = {
	  isNow: false,
	  showLabel: false,
	  content: ''
	}, _temp);
	exports.default = TimeSlot;
	module.exports = exports['default'];

/***/ },

/***/ "PMxY":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dates = __webpack_require__("4PJJ");
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizer = __webpack_require__("HcfL");
	
	var _localizer2 = _interopRequireDefault(_localizer);
	
	var _constants = __webpack_require__("hYBH");
	
	var _TimeGrid = __webpack_require__("u0gy");
	
	var _TimeGrid2 = _interopRequireDefault(_TimeGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Week = (_temp = _class = function (_React$Component) {
	  _inherits(Week, _React$Component);
	
	  function Week() {
	    _classCallCheck(this, Week);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Week.prototype.render = function render() {
	    var _props = this.props,
	        date = _props.date,
	        props = _objectWithoutProperties(_props, ['date']);
	
	    var range = Week.range(date, this.props);
	
	    return _react2.default.createElement(_TimeGrid2.default, _extends({}, props, { range: range, eventOffset: 15 }));
	  };
	
	  Week.range = function range(date, _ref) {
	    var culture = _ref.culture;
	
	    var firstOfWeek = _localizer2.default.startOfWeek(culture);
	    var start = _dates2.default.startOf(date, 'week', firstOfWeek);
	    var end = _dates2.default.endOf(date, 'week', firstOfWeek);
	
	    return _dates2.default.range(start, end);
	  };
	
	  return Week;
	}(_react2.default.Component), _class.defaultProps = _TimeGrid2.default.defaultProps, _temp);
	
	
	Week.navigate = function (date, action) {
	  switch (action) {
	    case _constants.navigate.PREVIOUS:
	      return _dates2.default.add(date, -1, 'week');
	
	    case _constants.navigate.NEXT:
	      return _dates2.default.add(date, 1, 'week');
	
	    default:
	      return date;
	  }
	};
	
	Week.title = function (date, _ref2) {
	  var formats = _ref2.formats,
	      culture = _ref2.culture;
	
	  var _Week$range = Week.range(date, { culture: culture }),
	      start = _Week$range[0],
	      rest = _Week$range.slice(1);
	
	  return _localizer2.default.format({ start: start, end: rest.pop() }, formats.dayRangeHeaderFormat, culture);
	};
	
	exports.default = Week;
	module.exports = exports['default'];

/***/ },

/***/ "6n5U":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Week = __webpack_require__("PMxY");
	
	var _Week2 = _interopRequireDefault(_Week);
	
	var _TimeGrid = __webpack_require__("u0gy");
	
	var _TimeGrid2 = _interopRequireDefault(_TimeGrid);
	
	var _localizer = __webpack_require__("HcfL");
	
	var _localizer2 = _interopRequireDefault(_localizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function workWeekRange(date, options) {
	  return _Week2.default.range(date, options).filter(function (d) {
	    return [6, 0].indexOf(d.getDay()) === -1;
	  });
	}
	
	var WorkWeek = (_temp = _class = function (_React$Component) {
	  _inherits(WorkWeek, _React$Component);
	
	  function WorkWeek() {
	    _classCallCheck(this, WorkWeek);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  WorkWeek.prototype.render = function render() {
	    var _props = this.props,
	        date = _props.date,
	        props = _objectWithoutProperties(_props, ['date']);
	
	    var range = workWeekRange(date, this.props);
	
	    return _react2.default.createElement(_TimeGrid2.default, _extends({}, props, { range: range, eventOffset: 15 }));
	  };
	
	  return WorkWeek;
	}(_react2.default.Component), _class.defaultProps = _TimeGrid2.default.defaultProps, _temp);
	
	
	WorkWeek.navigate = _Week2.default.navigate;
	
	WorkWeek.title = function (date, _ref) {
	  var formats = _ref.formats,
	      culture = _ref.culture;
	
	  var _workWeekRange = workWeekRange(date, { culture: culture }),
	      start = _workWeekRange[0],
	      rest = _workWeekRange.slice(1);
	
	  return _localizer2.default.format({ start: start, end: rest.pop() }, formats.dayRangeHeaderFormat, culture);
	};
	
	exports.default = WorkWeek;
	module.exports = exports['default'];

/***/ },

/***/ "1oB+":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _class2 = __webpack_require__("tk9j");
	
	var _class3 = _interopRequireDefault(_class2);
	
	var _width = __webpack_require__("yvZl");
	
	var _width2 = _interopRequireDefault(_width);
	
	var _scrollbarSize = __webpack_require__("y6rd");
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _localizer = __webpack_require__("HcfL");
	
	var _localizer2 = _interopRequireDefault(_localizer);
	
	var _messages = __webpack_require__("m1jL");
	
	var _messages2 = _interopRequireDefault(_messages);
	
	var _dates = __webpack_require__("4PJJ");
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _constants = __webpack_require__("hYBH");
	
	var _accessors = __webpack_require__("Gtmz");
	
	var _propTypes3 = __webpack_require__("OBNG");
	
	var _eventLevels = __webpack_require__("SjBY");
	
	var _selection = __webpack_require__("RGiR");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Agenda = (_temp2 = _class = function (_React$Component) {
	  _inherits(Agenda, _React$Component);
	
	  function Agenda() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Agenda);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderDay = function (day, events, dayKey) {
	      var _this$props = _this.props,
	          culture = _this$props.culture,
	          components = _this$props.components,
	          titleAccessor = _this$props.titleAccessor,
	          agendaDateFormat = _this$props.agendaDateFormat,
	          eventPropGetter = _this$props.eventPropGetter,
	          startAccessor = _this$props.startAccessor,
	          endAccessor = _this$props.endAccessor,
	          selected = _this$props.selected;
	
	
	      var EventComponent = components.event;
	      var DateComponent = components.date;
	
	      events = events.filter(function (e) {
	        return (0, _eventLevels.inRange)(e, day, day, _this.props);
	      });
	
	      return events.map(function (event, idx) {
	        var _ref = eventPropGetter ? eventPropGetter(event, (0, _accessors.accessor)(event, startAccessor), (0, _accessors.accessor)(event, endAccessor), (0, _selection.isSelected)(event, selected)) : {},
	            className = _ref.className,
	            style = _ref.style;
	
	        var dateLabel = idx === 0 && _localizer2.default.format(day, agendaDateFormat, culture);
	        var first = idx === 0 ? _react2.default.createElement(
	          'td',
	          { rowSpan: events.length, className: 'rbc-agenda-date-cell' },
	          DateComponent ? _react2.default.createElement(DateComponent, { day: day, label: dateLabel }) : dateLabel
	        ) : false;
	
	        var title = (0, _accessors.accessor)(event, titleAccessor);
	
	        return _react2.default.createElement(
	          'tr',
	          { key: dayKey + '_' + idx, className: className, style: style },
	          first,
	          _react2.default.createElement(
	            'td',
	            { className: 'rbc-agenda-time-cell' },
	            _this.timeRangeLabel(day, event)
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'rbc-agenda-event-cell' },
	            EventComponent ? _react2.default.createElement(EventComponent, { event: event, title: title }) : title
	          )
	        );
	      }, []);
	    }, _this.timeRangeLabel = function (day, event) {
	      var _this$props2 = _this.props,
	          endAccessor = _this$props2.endAccessor,
	          startAccessor = _this$props2.startAccessor,
	          allDayAccessor = _this$props2.allDayAccessor,
	          culture = _this$props2.culture,
	          messages = _this$props2.messages,
	          components = _this$props2.components;
	
	
	      var labelClass = '',
	          TimeComponent = components.time,
	          label = (0, _messages2.default)(messages).allDay;
	
	      var start = (0, _accessors.accessor)(event, startAccessor);
	      var end = (0, _accessors.accessor)(event, endAccessor);
	
	      if (!(0, _accessors.accessor)(event, allDayAccessor)) {
	        if (_dates2.default.eq(start, end, 'day')) {
	          label = _localizer2.default.format({ start: start, end: end }, _this.props.agendaTimeRangeFormat, culture);
	        } else if (_dates2.default.eq(day, start, 'day')) {
	          label = _localizer2.default.format(start, _this.props.agendaTimeFormat, culture);
	        } else if (_dates2.default.eq(day, end, 'day')) {
	          label = _localizer2.default.format(end, _this.props.agendaTimeFormat, culture);
	        }
	      }
	
	      if (_dates2.default.gt(day, start, 'day')) labelClass = 'rbc-continues-prior';
	      if (_dates2.default.lt(day, end, 'day')) labelClass += ' rbc-continues-after';
	
	      return _react2.default.createElement(
	        'span',
	        { className: labelClass.trim() },
	        TimeComponent ? _react2.default.createElement(TimeComponent, { event: event, day: day, label: label }) : label
	      );
	    }, _this._adjustHeader = function () {
	      var header = _this.refs.header;
	      var firstRow = _this.refs.tbody.firstChild;
	
	      if (!firstRow) return;
	
	      var isOverflowing = _this.refs.content.scrollHeight > _this.refs.content.clientHeight;
	      var widths = _this._widths || [];
	
	      _this._widths = [(0, _width2.default)(firstRow.children[0]), (0, _width2.default)(firstRow.children[1])];
	
	      if (widths[0] !== _this._widths[0] || widths[1] !== _this._widths[1]) {
	        _this.refs.dateCol.style.width = _this._widths[0] + 'px';
	        _this.refs.timeCol.style.width = _this._widths[1] + 'px';
	      }
	
	      if (isOverflowing) {
	        _class3.default.addClass(header, 'rbc-header-overflowing');
	        header.style.marginRight = (0, _scrollbarSize2.default)() + 'px';
	      } else {
	        _class3.default.removeClass(header, 'rbc-header-overflowing');
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Agenda.prototype.componentDidMount = function componentDidMount() {
	    this._adjustHeader();
	  };
	
	  Agenda.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._adjustHeader();
	  };
	
	  Agenda.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        length = _props.length,
	        date = _props.date,
	        events = _props.events,
	        startAccessor = _props.startAccessor;
	
	    var messages = (0, _messages2.default)(this.props.messages);
	    var end = _dates2.default.add(date, length, 'day');
	
	    var range = _dates2.default.range(date, end, 'day');
	
	    events = events.filter(function (event) {
	      return (0, _eventLevels.inRange)(event, date, end, _this2.props);
	    });
	
	    events.sort(function (a, b) {
	      return +(0, _accessors.accessor)(a, startAccessor) - +(0, _accessors.accessor)(b, startAccessor);
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'rbc-agenda-view' },
	      _react2.default.createElement(
	        'table',
	        { ref: 'header' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              { className: 'rbc-header', ref: 'dateCol' },
	              messages.date
	            ),
	            _react2.default.createElement(
	              'th',
	              { className: 'rbc-header', ref: 'timeCol' },
	              messages.time
	            ),
	            _react2.default.createElement(
	              'th',
	              { className: 'rbc-header' },
	              messages.event
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'rbc-agenda-content', ref: 'content' },
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'tbody',
	            { ref: 'tbody' },
	            range.map(function (day, idx) {
	              return _this2.renderDay(day, events, idx);
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return Agenda;
	}(_react2.default.Component), _class.defaultProps = {
	  length: 30
	}, _temp2);
	
	
	Agenda.navigate = function (date, action, _ref2) {
	  var _ref2$length = _ref2.length,
	      length = _ref2$length === undefined ? Agenda.defaultProps.length : _ref2$length;
	
	  switch (action) {
	    case _constants.navigate.PREVIOUS:
	      return _dates2.default.add(date, -length, 'day');
	
	    case _constants.navigate.NEXT:
	      return _dates2.default.add(date, length, 'day');
	
	    default:
	      return date;
	  }
	};
	
	Agenda.title = function (start, _ref3) {
	  var _ref3$length = _ref3.length,
	      length = _ref3$length === undefined ? Agenda.defaultProps.length : _ref3$length,
	      formats = _ref3.formats,
	      culture = _ref3.culture;
	
	  var end = _dates2.default.add(start, length, 'day');
	  return _localizer2.default.format({ start: start, end: end }, formats.agendaHeaderFormat, culture);
	};
	
	exports.default = Agenda;
	module.exports = exports['default'];

/***/ },

/***/ "toeV":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventWrapper = function (_React$Component) {
	  _inherits(EventWrapper, _React$Component);
	
	  function EventWrapper() {
	    _classCallCheck(this, EventWrapper);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  EventWrapper.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return EventWrapper;
	}(_react2.default.Component);
	
	exports.default = EventWrapper;
	module.exports = exports['default'];

/***/ },

/***/ "I8UM":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Toolbar = __webpack_require__("MCuB");
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		Toolbar: _Toolbar2.default
	};
	module.exports = exports["default"];

/***/ },

/***/ "MCuB":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__("KSGD");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _constants = __webpack_require__("hYBH");
	
	__webpack_require__("2s5a");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClasstopToolbar = function (_React$Component) {
	  _inherits(ClasstopToolbar, _React$Component);
	
	  function ClasstopToolbar(props) {
	    _classCallCheck(this, ClasstopToolbar);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.navigate = function (action) {
	      _this.props.onNavigate(action);
	    };
	
	    _this.view = function (view) {
	      _this.props.onViewChange(view);
	    };
	
	    return _this;
	  }
	
	  ClasstopToolbar.prototype.render = function render() {
	    var _props = this.props,
	        messages = _props.messages,
	        label = _props.label;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'rbc-toolbar' },
	      _react2.default.createElement(
	        'div',
	        { className: 'toolbar-top-section' },
	        _react2.default.createElement(
	          'span',
	          { className: 'selecting-view' },
	          this.viewNamesGroup(messages)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'rbc-toolbar-label date-label' },
	          label
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'toolbar-bottom-section' },
	        _react2.default.createElement(
	          'span',
	          { className: 'navigate-date' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'change-date-button btn-link',
	              onClick: this.navigate.bind(null, _constants.navigate.PREVIOUS)
	            },
	            _react2.default.createElement('i', { className: 'change-date-arrow fa icon-left-dir' }),
	            __("Previous Week", "schedule.calendar")
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'change-date-button btn-link',
	              onClick: this.navigate.bind(null, _constants.navigate.TODAY)
	            },
	            __("Today", "schedule.calendar")
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'change-date-button btn-link',
	              onClick: this.navigate.bind(null, _constants.navigate.NEXT)
	            },
	            __("Next Week", "schedule.calendar"),
	            _react2.default.createElement('i', { className: 'change-date-arrow fa icon-right-dir' })
	          )
	        )
	      )
	    );
	  };
	
	  ClasstopToolbar.prototype.viewNamesGroup = function viewNamesGroup(messages) {
	    var _this2 = this;
	
	    var viewNames = this.props.views;
	    var view = this.props.view;
	
	    if (viewNames.length > 1) {
	      return viewNames.map(function (name) {
	        return _react2.default.createElement(
	          'div',
	          { key: name,
	            className: (0, _classnames2.default)('tab-select-button', { 'rbc-active': view === name }),
	            onClick: _this2.view.bind(null, name)
	          },
	          __(messages[name], "schedule.calendar")
	        );
	      });
	    }
	  };
	
	  return ClasstopToolbar;
	}(_react2.default.Component);
	
	exports.default = ClasstopToolbar;
	module.exports = exports['default'];

/***/ },

/***/ "2s5a":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"rbc-toolbar":"rbc-toolbar","toolbar-top-section":"toolbar-top-section","toolbar-bottom-section":"toolbar-bottom-section","selecting-view":"selecting-view","tab-select-button":"tab-select-button","rbc-active":"rbc-active","date-label":"date-label"};

/***/ },

/***/ "drs3":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"rbc-day-slot":"rbc-day-slot","rbc-time-slot":"rbc-time-slot","rbc-time-view":"rbc-time-view","rbc-time-header":"rbc-time-header","rbc-row":"rbc-row","rbc-time-content":"rbc-time-content","rbc-timeslot-group":"rbc-timeslot-group","rbc-header":"rbc-header","rbc-today":"rbc-today","rbc-weekday-sun":"rbc-weekday-sun","rbc-weekday-sat":"rbc-weekday-sat","rbc-header-gutter":"rbc-header-gutter"};

/***/ },

/***/ "CD9V":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.formats = undefined;
	
	exports.default = function (moment) {
	  var locale = function locale(m, c) {
	    return c ? m.locale(c) : m;
	  };
	
	  (0, _formats.set)(formats);
	
	  return (0, _localizer.set)({
	    firstOfWeek: function firstOfWeek(culture) {
	      var data = culture ? moment.localeData(culture) : moment.localeData();
	      return data ? data.firstDayOfWeek() : 0;
	    },
	    parse: function parse(value, format, culture) {
	      return locale(moment(value, format), culture).toDate();
	    },
	    format: function format(value, _format, culture) {
	      return locale(moment(value), culture).format(_format);
	    }
	  });
	};
	
	var _dates = __webpack_require__("4PJJ");
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _formats = __webpack_require__("0kEA");
	
	var _localizer = __webpack_require__("HcfL");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateRangeFormat = function dateRangeFormat(_ref, culture, local) {
	  var start = _ref.start,
	      end = _ref.end;
	  return local.format(start, 'L', culture) + ' — ' + local.format(end, 'L', culture);
	};
	
	var timeRangeFormat = function timeRangeFormat(_ref2, culture, local) {
	  var start = _ref2.start,
	      end = _ref2.end;
	  return local.format(start, 'LT', culture) + ' — ' + local.format(end, 'LT', culture);
	};
	
	var timeRangeStartFormat = function timeRangeStartFormat(_ref3, culture, local) {
	  var start = _ref3.start,
	      end = _ref3.end;
	  return local.format(start, 'h:mma', culture) + ' — ';
	};
	
	var timeRangeEndFormat = function timeRangeEndFormat(_ref4, culture, local) {
	  var start = _ref4.start,
	      end = _ref4.end;
	  return ' — ' + local.format(end, 'h:mma', culture);
	};
	
	var weekRangeFormat = function weekRangeFormat(_ref5, culture, local) {
	  var start = _ref5.start,
	      end = _ref5.end;
	  return local.format(start, 'MMM DD', culture) + ' - ' + local.format(end, _dates2.default.eq(start, end, 'month') ? 'DD' : 'MMM DD', culture);
	};
	
	var formats = exports.formats = {
	  dateFormat: 'DD',
	  dayFormat: 'ddd DD/MM',
	  weekdayFormat: 'ddd',
	
	  selectRangeFormat: timeRangeFormat,
	  eventTimeRangeFormat: timeRangeFormat,
	  eventTimeRangeStartFormat: timeRangeStartFormat,
	  eventTimeRangeEndFormat: timeRangeEndFormat,
	
	  timeGutterFormat: 'LT',
	
	  monthHeaderFormat: 'MMMM YYYY',
	  dayHeaderFormat: 'dddd MMM DD',
	  dayRangeHeaderFormat: weekRangeFormat,
	  agendaHeaderFormat: dateRangeFormat,
	
	  agendaDateFormat: 'ddd MMM DD',
	  agendaTimeFormat: 'LT',
	  agendaTimeRangeFormat: timeRangeFormat
	};

/***/ },

/***/ "wbDg":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.formats = undefined;
	
	exports.default = function (globalize) {
	  var locale = function locale(culture) {
	    return culture ? globalize(culture) : globalize;
	  };
	
	  // return the first day of the week from the locale data. Defaults to 'world'
	  // territory if no territory is derivable from CLDR.
	  // Failing to use CLDR supplemental (not loaded?), revert to the original
	  // method of getting first day of week.
	  function firstOfWeek(culture) {
	    try {
	      var days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
	      var cldr = locale(culture).cldr;
	      var territory = cldr.attributes.territory;
	      var weekData = cldr.get('supplemental').weekData;
	      var firstDay = weekData.firstDay[territory || '001'];
	      return days.indexOf(firstDay);
	    } catch (e) {
	      (0, _warning2.default)(true, 'Failed to accurately determine first day of the week.\n            Is supplemental data loaded into CLDR?');
	      // maybe cldr supplemental is not loaded? revert to original method
	      var date = new Date();
	      //cldr-data doesn't seem to be zero based
	      var localeDay = Math.max(parseInt(locale(culture).formatDate(date, { raw: 'e' }), 10) - 1, 0);
	
	      return Math.abs(date.getDay() - localeDay);
	    }
	  }
	
	  if (!globalize.load) return (0, _oldGlobalize2.default)(globalize);
	
	  (0, _formats.set)(formats);
	
	  return (0, _localizer.set)({
	    firstOfWeek: firstOfWeek,
	
	    parse: function parse(value, format, culture) {
	      format = typeof format === 'string' ? { raw: format } : format;
	      return locale(culture).parseDate(value, format);
	    },
	    format: function format(value, _format, culture) {
	      _format = typeof _format === 'string' ? { raw: _format } : _format;
	      return locale(culture).formatDate(value, _format);
	    }
	  });
	};
	
	var _dates = __webpack_require__("4PJJ");
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _oldGlobalize = __webpack_require__("4arq");
	
	var _oldGlobalize2 = _interopRequireDefault(_oldGlobalize);
	
	var _warning = __webpack_require__("GvBW");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _formats = __webpack_require__("0kEA");
	
	var _localizer = __webpack_require__("HcfL");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateRangeFormat = function dateRangeFormat(_ref, culture, local) {
	  var start = _ref.start,
	      end = _ref.end;
	  return local.format(start, { date: 'short' }, culture) + ' — ' + local.format(end, { date: 'short' }, culture);
	};
	
	var timeRangeFormat = function timeRangeFormat(_ref2, culture, local) {
	  var start = _ref2.start,
	      end = _ref2.end;
	  return local.format(start, { time: 'short' }, culture) + ' — ' + local.format(end, { time: 'short' }, culture);
	};
	
	var timeRangeStartFormat = function timeRangeStartFormat(_ref3, culture, local) {
	  var start = _ref3.start,
	      end = _ref3.end;
	  return local.format(start, { time: 'short' }, culture) + ' — ';
	};
	
	var timeRangeEndFormat = function timeRangeEndFormat(_ref4, culture, local) {
	  var start = _ref4.start,
	      end = _ref4.end;
	  return ' — ' + local.format(end, { time: 'short' }, culture);
	};
	
	var weekRangeFormat = function weekRangeFormat(_ref5, culture, local) {
	  var start = _ref5.start,
	      end = _ref5.end;
	  return local.format(start, 'MMM dd', culture) + ' — ' + local.format(end, _dates2.default.eq(start, end, 'month') ? 'dd' : 'MMM dd', culture);
	};
	
	var formats = exports.formats = {
	  dateFormat: 'dd',
	  dayFormat: 'eee dd/MM',
	  weekdayFormat: 'eee',
	
	  selectRangeFormat: timeRangeFormat,
	  eventTimeRangeFormat: timeRangeFormat,
	  eventTimeRangeStartFormat: timeRangeStartFormat,
	  eventTimeRangeEndFormat: timeRangeEndFormat,
	
	  timeGutterFormat: { time: 'short' },
	
	  monthHeaderFormat: 'MMMM yyyy',
	  dayHeaderFormat: 'eeee MMM dd',
	  dayRangeHeaderFormat: weekRangeFormat,
	  agendaHeaderFormat: dateRangeFormat,
	
	  agendaDateFormat: 'eee MMM dd',
	  agendaTimeFormat: { time: 'short' },
	  agendaTimeRangeFormat: timeRangeFormat
	};

/***/ },

/***/ "4arq":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.formats = undefined;
	
	exports.default = function (globalize) {
	
	  function getCulture(culture) {
	    return culture ? globalize.findClosestCulture(culture) : globalize.culture();
	  }
	
	  function firstOfWeek(culture) {
	    culture = getCulture(culture);
	    return culture && culture.calendar.firstDay || 0;
	  }
	
	  (0, _formats.set)(formats);
	
	  return (0, _localizer.set)({
	    firstOfWeek: firstOfWeek,
	
	    parse: function parse(value, format, culture) {
	      return globalize.parseDate(value, format, culture);
	    },
	    format: function format(value, _format, culture) {
	      return globalize.format(value, _format, culture);
	    }
	  });
	};
	
	var _dates = __webpack_require__("4PJJ");
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _formats = __webpack_require__("0kEA");
	
	var _localizer = __webpack_require__("HcfL");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateRangeFormat = function dateRangeFormat(_ref, culture, local) {
	  var start = _ref.start,
	      end = _ref.end;
	  return local.format(start, 'd', culture) + ' — ' + local.format(end, 'd', culture);
	};
	
	var timeRangeFormat = function timeRangeFormat(_ref2, culture, local) {
	  var start = _ref2.start,
	      end = _ref2.end;
	  return local.format(start, 't', culture) + ' — ' + local.format(end, 't', culture);
	};
	
	var timeRangeStartFormat = function timeRangeStartFormat(_ref3, culture, local) {
	  var start = _ref3.start,
	      end = _ref3.end;
	  return local.format(start, 't', culture) + ' — ';
	};
	
	var timeRangeEndFormat = function timeRangeEndFormat(_ref4, culture, local) {
	  var start = _ref4.start,
	      end = _ref4.end;
	  return ' — ' + local.format(end, 't', culture);
	};
	
	var weekRangeFormat = function weekRangeFormat(_ref5, culture, local) {
	  var start = _ref5.start,
	      end = _ref5.end;
	  return local.format(start, 'MMM dd', culture) + ' - ' + local.format(end, _dates2.default.eq(start, end, 'month') ? 'dd' : 'MMM dd', culture);
	};
	
	var formats = exports.formats = {
	  dateFormat: 'dd',
	  dayFormat: 'ddd dd/MM',
	  weekdayFormat: 'ddd',
	
	  selectRangeFormat: timeRangeFormat,
	  eventTimeRangeFormat: timeRangeFormat,
	  eventTimeRangeStartFormat: timeRangeStartFormat,
	  eventTimeRangeEndFormat: timeRangeEndFormat,
	
	  timeGutterFormat: 't',
	
	  monthHeaderFormat: 'Y',
	  dayHeaderFormat: 'dddd MMM dd',
	  dayRangeHeaderFormat: weekRangeFormat,
	  agendaHeaderFormat: dateRangeFormat,
	
	  agendaDateFormat: 'ddd MMM dd',
	  agendaTimeFormat: 't',
	  agendaTimeRangeFormat: timeRangeFormat
	};

/***/ },

/***/ "R110":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "9F/P":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "+L25":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Event = function (_React$Component) {
		_inherits(Event, _React$Component);
	
		function Event(props) {
			_classCallCheck(this, Event);
	
			return _possibleConstructorReturn(this, _React$Component.call(this, props));
		}
	
		Event.prototype.componentDidMount = function componentDidMount() {};
	
		Event.prototype.render = function render() {
			var _props = this.props,
			    title = _props.title,
			    event = _props.event;
	
	
			var startTime = event.lStartTime.split(" ")[1];
			var endTime = event.lEndTime.split(" ")[1];
			return _react2.default.createElement(
				"div",
				{ className: "classtop-event-content" },
				_react2.default.createElement(
					"div",
					null,
					title
				),
				_react2.default.createElement(
					"div",
					null,
					startTime,
					" - ",
					endTime
				),
				_react2.default.createElement(
					"div",
					null,
					event.state
				)
			);
		};
	
		return Event;
	}(_react2.default.Component);
	
	exports.default = Event;
	module.exports = exports["default"];

/***/ },

/***/ "KIGD":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"class-calendar":"class-calendar","rbc-month-header":"rbc-month-header","rbc-month-row":"rbc-month-row","rbc-overlay":"rbc-overlay","rbc-month-view":"rbc-month-view","rbc-off-range-bg":"rbc-off-range-bg","rbc-event":"rbc-event","fetching":"fetching"};

/***/ },

/***/ "Bv0y":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = convertScheduleToRbcEvents;
	function convertScheduleToRbcEvents(schedule) {
	
	  return schedule.map(function (r) {
	
	    var state = r.lState == 1 ? __("Attended", "schedule.calendar") : '';
	
	    return _extends({
	      title: r.class_name + ' (' + __("Lesson", "schedule.calendar") + r.lesson_number + ')',
	      state: state,
	      allDay: false,
	      start: new Date(r.lStartTime.replace(/-/g, '/')),
	      end: new Date(r.lEndTime.replace(/-/g, '/'))
	    }, r);
	  });
	}
	module.exports = exports["default"];

/***/ },

/***/ "BU77":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Schedule = __webpack_require__("Ap3v");
	
	var _Schedule2 = _interopRequireDefault(_Schedule);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Schedule2.default;
	module.exports = exports["default"];

/***/ },

/***/ "Zrtp":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = [{
	   "title": "12年级数学 (Lesson1)",
	   "allDay": false,
	   "start": "2018-01-02T14:00:00.000Z",
	   "end": "2018-01-02T15:00:00.000Z",
	   "id": 968,
	   "lName": "Lesson 1",
	   "lStartTime": "2018-01-02 06:00",
	   "lEndTime": "2018-01-02 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 717,
	   "lClassroom": null,
	   "class_name": "12年级数学",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 1,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "Yes! 500 (Lesson1)",
	   "allDay": false,
	   "start": "2018-01-02T14:00:00.000Z",
	   "end": "2018-01-02T15:00:00.000Z",
	   "id": 1000,
	   "lName": "Lesson 1",
	   "lStartTime": "2018-01-02 06:00",
	   "lEndTime": "2018-01-02 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 731,
	   "lClassroom": null,
	   "class_name": "Yes! 500",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 1,
	   "teacher_list": []
	}, {
	   "title": "ABC A (Lesson1)",
	   "allDay": false,
	   "start": "2018-01-02T14:00:00.000Z",
	   "end": "2018-01-02T15:00:00.000Z",
	   "id": 1037,
	   "lName": "Lesson 1",
	   "lStartTime": "2018-01-02 06:00",
	   "lEndTime": "2018-01-02 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 741,
	   "lClassroom": null,
	   "class_name": "ABC A",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 1,
	   "lesson_number": 1,
	   "teacher_list": []
	}, {
	   "title": "Peeling potatoes (Lesson5)",
	   "allDay": false,
	   "start": "2018-01-02T21:00:00.000Z",
	   "end": "2018-01-02T23:00:00.000Z",
	   "id": 895,
	   "lName": "Lesson 5",
	   "lStartTime": "2018-01-02 13:00",
	   "lEndTime": "2018-01-02 15:00",
	   "lDuration": "120.0",
	   "lState": 0,
	   "lCalendarColor": "#8bc34a",
	   "lClass": 656,
	   "lClassroom": 58,
	   "class_name": "Peeling potatoes",
	   "class_type": 0,
	   "calendarColor": "#8bc34a",
	   "classroom_name": "Room R",
	   "student_amount": 0,
	   "lesson_number": 5,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "12年级数学 (Lesson2)",
	   "allDay": false,
	   "start": "2018-01-04T14:00:00.000Z",
	   "end": "2018-01-04T15:00:00.000Z",
	   "id": 969,
	   "lName": "Lesson 2",
	   "lStartTime": "2018-01-04 06:00",
	   "lEndTime": "2018-01-04 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 717,
	   "lClassroom": null,
	   "class_name": "12年级数学",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 2,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "Class 3 (Lesson1)",
	   "allDay": false,
	   "start": "2018-01-04T14:00:00.000Z",
	   "end": "2018-01-04T15:00:00.000Z",
	   "id": 993,
	   "lName": "Lesson 1",
	   "lStartTime": "2018-01-04 06:00",
	   "lEndTime": "2018-01-04 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 727,
	   "lClassroom": null,
	   "class_name": "Class 3",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 1,
	   "teacher_list": []
	}, {
	   "title": "Yes! 500 (Lesson2)",
	   "allDay": false,
	   "start": "2018-01-04T14:00:00.000Z",
	   "end": "2018-01-04T15:00:00.000Z",
	   "id": 1001,
	   "lName": "Lesson 2",
	   "lStartTime": "2018-01-04 06:00",
	   "lEndTime": "2018-01-04 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 731,
	   "lClassroom": null,
	   "class_name": "Yes! 500",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 2,
	   "teacher_list": []
	}, {
	   "title": "Peeling potatoes (Lesson6)",
	   "allDay": false,
	   "start": "2018-01-04T21:00:00.000Z",
	   "end": "2018-01-04T23:00:00.000Z",
	   "id": 896,
	   "lName": "Lesson 6",
	   "lStartTime": "2018-01-04 13:00",
	   "lEndTime": "2018-01-04 15:00",
	   "lDuration": "120.0",
	   "lState": 0,
	   "lCalendarColor": "#8bc34a",
	   "lClass": 656,
	   "lClassroom": 58,
	   "class_name": "Peeling potatoes",
	   "class_type": 0,
	   "calendarColor": "#8bc34a",
	   "classroom_name": "Room R",
	   "student_amount": 0,
	   "lesson_number": 6,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "12年级数学 (Lesson3)",
	   "allDay": false,
	   "start": "2018-01-06T14:00:00.000Z",
	   "end": "2018-01-06T15:00:00.000Z",
	   "id": 970,
	   "lName": "Lesson 3",
	   "lStartTime": "2018-01-06 06:00",
	   "lEndTime": "2018-01-06 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 717,
	   "lClassroom": null,
	   "class_name": "12年级数学",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 3,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "Class 3 (Lesson2)",
	   "allDay": false,
	   "start": "2018-01-06T14:00:00.000Z",
	   "end": "2018-01-06T15:00:00.000Z",
	   "id": 994,
	   "lName": "Lesson 2",
	   "lStartTime": "2018-01-06 06:00",
	   "lEndTime": "2018-01-06 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 727,
	   "lClassroom": null,
	   "class_name": "Class 3",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 2,
	   "teacher_list": []
	}, {
	   "title": "Yes! 500 (Lesson3)",
	   "allDay": false,
	   "start": "2018-01-06T14:00:00.000Z",
	   "end": "2018-01-06T15:00:00.000Z",
	   "id": 1002,
	   "lName": "Lesson 3",
	   "lStartTime": "2018-01-06 06:00",
	   "lEndTime": "2018-01-06 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 731,
	   "lClassroom": null,
	   "class_name": "Yes! 500",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 3,
	   "teacher_list": []
	}, {
	   "title": "12年级数学 (Lesson4)",
	   "allDay": false,
	   "start": "2018-01-09T14:00:00.000Z",
	   "end": "2018-01-09T15:00:00.000Z",
	   "id": 971,
	   "lName": "Lesson 4",
	   "lStartTime": "2018-01-09 06:00",
	   "lEndTime": "2018-01-09 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 717,
	   "lClassroom": null,
	   "class_name": "12年级数学",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 4,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "Class 3 (Lesson3)",
	   "allDay": false,
	   "start": "2018-01-09T14:00:00.000Z",
	   "end": "2018-01-09T15:00:00.000Z",
	   "id": 995,
	   "lName": "Lesson 3",
	   "lStartTime": "2018-01-09 06:00",
	   "lEndTime": "2018-01-09 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 727,
	   "lClassroom": null,
	   "class_name": "Class 3",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 3,
	   "teacher_list": []
	}, {
	   "title": "Yes! 500 (Lesson4)",
	   "allDay": false,
	   "start": "2018-01-09T14:00:00.000Z",
	   "end": "2018-01-09T15:00:00.000Z",
	   "id": 1003,
	   "lName": "Lesson 4",
	   "lStartTime": "2018-01-09 06:00",
	   "lEndTime": "2018-01-09 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 731,
	   "lClassroom": null,
	   "class_name": "Yes! 500",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 4,
	   "teacher_list": []
	}, {
	   "title": "Peeling potatoes (Lesson7)",
	   "allDay": false,
	   "start": "2018-01-09T21:00:00.000Z",
	   "end": "2018-01-09T23:00:00.000Z",
	   "id": 897,
	   "lName": "Lesson 7",
	   "lStartTime": "2018-01-09 13:00",
	   "lEndTime": "2018-01-09 15:00",
	   "lDuration": "120.0",
	   "lState": 0,
	   "lCalendarColor": "#8bc34a",
	   "lClass": 656,
	   "lClassroom": 58,
	   "class_name": "Peeling potatoes",
	   "class_type": 0,
	   "calendarColor": "#8bc34a",
	   "classroom_name": "Room R",
	   "student_amount": 0,
	   "lesson_number": 7,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "12年级数学 (Lesson5)",
	   "allDay": false,
	   "start": "2018-01-11T14:00:00.000Z",
	   "end": "2018-01-11T15:00:00.000Z",
	   "id": 972,
	   "lName": "Lesson 5",
	   "lStartTime": "2018-01-11 06:00",
	   "lEndTime": "2018-01-11 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 717,
	   "lClassroom": null,
	   "class_name": "12年级数学",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 5,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "Class 3 (Lesson4)",
	   "allDay": false,
	   "start": "2018-01-11T14:00:00.000Z",
	   "end": "2018-01-11T15:00:00.000Z",
	   "id": 996,
	   "lName": "Lesson 4",
	   "lStartTime": "2018-01-11 06:00",
	   "lEndTime": "2018-01-11 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 727,
	   "lClassroom": null,
	   "class_name": "Class 3",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 4,
	   "teacher_list": []
	}, {
	   "title": "Yes! 500 (Lesson5)",
	   "allDay": false,
	   "start": "2018-01-11T14:00:00.000Z",
	   "end": "2018-01-11T15:00:00.000Z",
	   "id": 1004,
	   "lName": "Lesson 5",
	   "lStartTime": "2018-01-11 06:00",
	   "lEndTime": "2018-01-11 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 731,
	   "lClassroom": null,
	   "class_name": "Yes! 500",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 5,
	   "teacher_list": []
	}, {
	   "title": "Peeling potatoes (Lesson8)",
	   "allDay": false,
	   "start": "2018-01-11T21:00:00.000Z",
	   "end": "2018-01-11T23:00:00.000Z",
	   "id": 898,
	   "lName": "Lesson 8",
	   "lStartTime": "2018-01-11 13:00",
	   "lEndTime": "2018-01-11 15:00",
	   "lDuration": "120.0",
	   "lState": 0,
	   "lCalendarColor": "#8bc34a",
	   "lClass": 656,
	   "lClassroom": 58,
	   "class_name": "Peeling potatoes",
	   "class_type": 0,
	   "calendarColor": "#8bc34a",
	   "classroom_name": "Room R",
	   "student_amount": 0,
	   "lesson_number": 8,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "12年级数学 (Lesson6)",
	   "allDay": false,
	   "start": "2018-01-13T14:00:00.000Z",
	   "end": "2018-01-13T15:00:00.000Z",
	   "id": 973,
	   "lName": "Lesson 6",
	   "lStartTime": "2018-01-13 06:00",
	   "lEndTime": "2018-01-13 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 717,
	   "lClassroom": null,
	   "class_name": "12年级数学",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 6,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "Class 3 (Lesson5)",
	   "allDay": false,
	   "start": "2018-01-13T14:00:00.000Z",
	   "end": "2018-01-13T15:00:00.000Z",
	   "id": 997,
	   "lName": "Lesson 5",
	   "lStartTime": "2018-01-13 06:00",
	   "lEndTime": "2018-01-13 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 727,
	   "lClassroom": null,
	   "class_name": "Class 3",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 5,
	   "teacher_list": []
	}, {
	   "title": "Yes! 500 (Lesson6)",
	   "allDay": false,
	   "start": "2018-01-13T14:00:00.000Z",
	   "end": "2018-01-13T15:00:00.000Z",
	   "id": 1005,
	   "lName": "Lesson 6",
	   "lStartTime": "2018-01-13 06:00",
	   "lEndTime": "2018-01-13 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 731,
	   "lClassroom": null,
	   "class_name": "Yes! 500",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 6,
	   "teacher_list": []
	}, {
	   "title": "12年级数学 (Lesson7)",
	   "allDay": false,
	   "start": "2018-01-16T14:00:00.000Z",
	   "end": "2018-01-16T15:00:00.000Z",
	   "id": 974,
	   "lName": "Lesson 7",
	   "lStartTime": "2018-01-16 06:00",
	   "lEndTime": "2018-01-16 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 717,
	   "lClassroom": null,
	   "class_name": "12年级数学",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 7,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "Class 3 (Lesson6)",
	   "allDay": false,
	   "start": "2018-01-16T14:00:00.000Z",
	   "end": "2018-01-16T15:00:00.000Z",
	   "id": 998,
	   "lName": "Lesson 6",
	   "lStartTime": "2018-01-16 06:00",
	   "lEndTime": "2018-01-16 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 727,
	   "lClassroom": null,
	   "class_name": "Class 3",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 6,
	   "teacher_list": []
	}, {
	   "title": "Yes! 500 (Lesson7)",
	   "allDay": false,
	   "start": "2018-01-16T14:00:00.000Z",
	   "end": "2018-01-16T15:00:00.000Z",
	   "id": 1006,
	   "lName": "Lesson 7",
	   "lStartTime": "2018-01-16 06:00",
	   "lEndTime": "2018-01-16 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 731,
	   "lClassroom": null,
	   "class_name": "Yes! 500",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 7,
	   "teacher_list": []
	}, {
	   "title": "Peeling potatoes (Lesson9)",
	   "allDay": false,
	   "start": "2018-01-16T21:00:00.000Z",
	   "end": "2018-01-16T23:00:00.000Z",
	   "id": 899,
	   "lName": "Lesson 9",
	   "lStartTime": "2018-01-16 13:00",
	   "lEndTime": "2018-01-16 15:00",
	   "lDuration": "120.0",
	   "lState": 0,
	   "lCalendarColor": "#8bc34a",
	   "lClass": 656,
	   "lClassroom": 58,
	   "class_name": "Peeling potatoes",
	   "class_type": 0,
	   "calendarColor": "#8bc34a",
	   "classroom_name": "Room R",
	   "student_amount": 0,
	   "lesson_number": 9,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "12年级数学 (Lesson8)",
	   "allDay": false,
	   "start": "2018-01-18T14:00:00.000Z",
	   "end": "2018-01-18T15:00:00.000Z",
	   "id": 975,
	   "lName": "Lesson 8",
	   "lStartTime": "2018-01-18 06:00",
	   "lEndTime": "2018-01-18 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 717,
	   "lClassroom": null,
	   "class_name": "12年级数学",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 8,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "Class 3 (Lesson7)",
	   "allDay": false,
	   "start": "2018-01-18T14:00:00.000Z",
	   "end": "2018-01-18T15:00:00.000Z",
	   "id": 999,
	   "lName": "Lesson 7",
	   "lStartTime": "2018-01-18 06:00",
	   "lEndTime": "2018-01-18 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 727,
	   "lClassroom": null,
	   "class_name": "Class 3",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 7,
	   "teacher_list": []
	}, {
	   "title": "Yes! 500 (Lesson8)",
	   "allDay": false,
	   "start": "2018-01-18T14:00:00.000Z",
	   "end": "2018-01-18T15:00:00.000Z",
	   "id": 1007,
	   "lName": "Lesson 8",
	   "lStartTime": "2018-01-18 06:00",
	   "lEndTime": "2018-01-18 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 731,
	   "lClassroom": null,
	   "class_name": "Yes! 500",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 8,
	   "teacher_list": []
	}, {
	   "title": "Peeling potatoes (Lesson10)",
	   "allDay": false,
	   "start": "2018-01-18T21:00:00.000Z",
	   "end": "2018-01-18T23:00:00.000Z",
	   "id": 900,
	   "lName": "Lesson 10",
	   "lStartTime": "2018-01-18 13:00",
	   "lEndTime": "2018-01-18 15:00",
	   "lDuration": "120.0",
	   "lState": 0,
	   "lCalendarColor": "#8bc34a",
	   "lClass": 656,
	   "lClassroom": 58,
	   "class_name": "Peeling potatoes",
	   "class_type": 0,
	   "calendarColor": "#8bc34a",
	   "classroom_name": "Room R",
	   "student_amount": 0,
	   "lesson_number": 10,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "12年级数学 (Lesson9)",
	   "allDay": false,
	   "start": "2018-01-20T14:00:00.000Z",
	   "end": "2018-01-20T15:00:00.000Z",
	   "id": 976,
	   "lName": "Lesson 9",
	   "lStartTime": "2018-01-20 06:00",
	   "lEndTime": "2018-01-20 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 717,
	   "lClassroom": null,
	   "class_name": "12年级数学",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 9,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "Yes! 500 (Lesson9)",
	   "allDay": false,
	   "start": "2018-01-20T14:00:00.000Z",
	   "end": "2018-01-20T15:00:00.000Z",
	   "id": 1008,
	   "lName": "Lesson 9",
	   "lStartTime": "2018-01-20 06:00",
	   "lEndTime": "2018-01-20 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 731,
	   "lClassroom": null,
	   "class_name": "Yes! 500",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 9,
	   "teacher_list": []
	}, {
	   "title": "12年级数学 (Lesson10)",
	   "allDay": false,
	   "start": "2018-01-23T14:00:00.000Z",
	   "end": "2018-01-23T15:00:00.000Z",
	   "id": 977,
	   "lName": "Lesson 10",
	   "lStartTime": "2018-01-23 06:00",
	   "lEndTime": "2018-01-23 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 717,
	   "lClassroom": null,
	   "class_name": "12年级数学",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 10,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "Yes! 500 (Lesson10)",
	   "allDay": false,
	   "start": "2018-01-23T14:00:00.000Z",
	   "end": "2018-01-23T15:00:00.000Z",
	   "id": 1009,
	   "lName": "Lesson 10",
	   "lStartTime": "2018-01-23 06:00",
	   "lEndTime": "2018-01-23 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 731,
	   "lClassroom": null,
	   "class_name": "Yes! 500",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 10,
	   "teacher_list": []
	}, {
	   "title": "12年级数学 (Lesson11)",
	   "allDay": false,
	   "start": "2018-01-25T14:00:00.000Z",
	   "end": "2018-01-25T15:00:00.000Z",
	   "id": 978,
	   "lName": "Lesson 11",
	   "lStartTime": "2018-01-25 06:00",
	   "lEndTime": "2018-01-25 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 717,
	   "lClassroom": null,
	   "class_name": "12年级数学",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 11,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "Yes! 500 (Lesson11)",
	   "allDay": false,
	   "start": "2018-01-25T14:00:00.000Z",
	   "end": "2018-01-25T15:00:00.000Z",
	   "id": 1010,
	   "lName": "Lesson 11",
	   "lStartTime": "2018-01-25 06:00",
	   "lEndTime": "2018-01-25 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 731,
	   "lClassroom": null,
	   "class_name": "Yes! 500",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 11,
	   "teacher_list": []
	}, {
	   "title": "12年级数学 (Lesson12)",
	   "allDay": false,
	   "start": "2018-01-27T14:00:00.000Z",
	   "end": "2018-01-27T15:00:00.000Z",
	   "id": 979,
	   "lName": "Lesson 12",
	   "lStartTime": "2018-01-27 06:00",
	   "lEndTime": "2018-01-27 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 717,
	   "lClassroom": null,
	   "class_name": "12年级数学",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 12,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "Yes! 500 (Lesson12)",
	   "allDay": false,
	   "start": "2018-01-27T14:00:00.000Z",
	   "end": "2018-01-27T15:00:00.000Z",
	   "id": 1011,
	   "lName": "Lesson 12",
	   "lStartTime": "2018-01-27 06:00",
	   "lEndTime": "2018-01-27 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 731,
	   "lClassroom": null,
	   "class_name": "Yes! 500",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 12,
	   "teacher_list": []
	}, {
	   "title": "12年级数学 (Lesson13)",
	   "allDay": false,
	   "start": "2018-01-30T14:00:00.000Z",
	   "end": "2018-01-30T15:00:00.000Z",
	   "id": 980,
	   "lName": "Lesson 13",
	   "lStartTime": "2018-01-30 06:00",
	   "lEndTime": "2018-01-30 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 717,
	   "lClassroom": null,
	   "class_name": "12年级数学",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 13,
	   "teacher_list": [{
	      "id": 282,
	      "stName": "Ryan Lee"
	   }]
	}, {
	   "title": "Yes! 500 (Lesson13)",
	   "allDay": false,
	   "start": "2018-01-30T14:00:00.000Z",
	   "end": "2018-01-30T15:00:00.000Z",
	   "id": 1012,
	   "lName": "Lesson 13",
	   "lStartTime": "2018-01-30 06:00",
	   "lEndTime": "2018-01-30 07:00",
	   "lDuration": "60.0",
	   "lState": 0,
	   "lCalendarColor": "",
	   "lClass": 731,
	   "lClassroom": null,
	   "class_name": "Yes! 500",
	   "class_type": 0,
	   "calendarColor": "",
	   "classroom_name": "",
	   "student_amount": 0,
	   "lesson_number": 13,
	   "teacher_list": []
	}];
	module.exports = exports["default"];

/***/ },

/***/ "C8DA":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _SchoolInformationForm = __webpack_require__("HHty");
	
	var _SchoolInformationForm2 = _interopRequireDefault(_SchoolInformationForm);
	
	var _PanelWrapper = __webpack_require__("VPji");
	
	var _PanelWrapper2 = _interopRequireDefault(_PanelWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * this is school information
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent routes
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var mapStateToProps = function mapStateToProps(state) {
		return {
			all: state
		};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
		return {};
	};
	
	var SchoolInformation = function (_React$Component) {
		_inherits(SchoolInformation, _React$Component);
	
		function SchoolInformation(props) {
			_classCallCheck(this, SchoolInformation);
	
			return _possibleConstructorReturn(this, _React$Component.call(this, props));
		}
	
		SchoolInformation.prototype.render = function render() {
			return _react2.default.createElement(
				_PanelWrapper2.default,
				null,
				_react2.default.createElement(_SchoolInformationForm2.default, null)
			);
		};
	
		return SchoolInformation;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SchoolInformation);
	module.exports = exports['default'];

/***/ },

/***/ "HHty":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _getSchoolDetail = __webpack_require__("eF4U");
	
	var _getSchoolDetail2 = _interopRequireDefault(_getSchoolDetail);
	
	var _getSchoolTypes = __webpack_require__("1arY");
	
	var _getSchoolTypes2 = _interopRequireDefault(_getSchoolTypes);
	
	var _logoUploader = __webpack_require__("ZmcG");
	
	var _logoUploader2 = _interopRequireDefault(_logoUploader);
	
	var _updateSchoolDetail = __webpack_require__("k5ft");
	
	var _updateSchoolDetail2 = _interopRequireDefault(_updateSchoolDetail);
	
	var _schoolDetail = __webpack_require__("8VNP");
	
	__webpack_require__("1rEC");
	
	var _getSchoolSettings = __webpack_require__("yY2/");
	
	var _getSchoolSettings2 = _interopRequireDefault(_getSchoolSettings);
	
	var _updateSchoolSettings = __webpack_require__("gl/q");
	
	var _updateSchoolSettings2 = _interopRequireDefault(_updateSchoolSettings);
	
	var _UI = __webpack_require__("OM1Z");
	
	var _Transition = __webpack_require__("X/qO");
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent SchoolInformation
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var DEFAULT_REGION_CODE = 'ca';
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    updateSchoolInfo: function updateSchoolInfo(schoolDetail) {
	      return dispatch((0, _schoolDetail.updateSchoolInfo)(schoolDetail));
	    }
	  };
	};
	
	var SchoolInformationForm = function (_React$Component) {
	  _inherits(SchoolInformationForm, _React$Component);
	
	  function SchoolInformationForm(props) {
	    _classCallCheck(this, SchoolInformationForm);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    _this.getSchema = _this.getSchema.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onSettingChange = _this.onSettingChange.bind(_this);
	    _this.convertForForm = _this.convertForForm.bind(_this);
	    _this.updateSchool = _this.updateSchool.bind(_this);
	    _this.convertSettingsForFrontend = _this.convertSettingsForFrontend.bind(_this);
	    _this.convertSettingsForBackend = _this.convertSettingsForBackend.bind(_this);
	
	    _this.state = {
	      formData: { phone_parsed: { country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE } },
	      settingFormData: {},
	      categories: [],
	      fetching: false
	    };
	    return _this;
	  }
	
	  SchoolInformationForm.prototype.getSchema = function getSchema() {
	    var categories = this.state.categories;
	
	
	    this.schema = [{
	      name: 'logo',
	      label: __('School Logo', 'schoolInformation.form'),
	      type: 'imageUploader',
	      options: {
	        aspectRatioHeight: 1,
	        aspectRatioWidth: 1
	      }
	    }, {
	      name: 'title',
	      label: __('School Name', 'schoolInformation.form'),
	      type: 'text',
	      required: false
	    }, {
	      name: 'description',
	      label: __('About School', 'schoolInformation.form'),
	      type: 'textarea',
	      required: false
	    }, {
	      name: 'phone_parsed',
	      label: __('School Phone Number', 'schoolInformation.form'),
	      type: 'phone',
	      required: false
	    }, {
	      name: 'email',
	      label: __('School Email', 'schoolInformation.form'),
	      type: 'email',
	      required: false
	    }, {
	      name: 'timezone',
	      label: __('Time Zone', 'schoolInformation.form'),
	      type: 'text',
	      required: false,
	      disabled: true
	    }, {
	      name: 'homepage',
	      label: __('School Website', 'schoolInformation.form'),
	      type: 'text',
	      required: false
	    }, {
	      name: 'categories',
	      label: __('Class Categories', 'schoolInformation.form'),
	      type: 'select',
	      required: false,
	      options: categories
	    }, {
	      name: 'ageLimitStr',
	      label: __('Student Age', 'schoolInformation.form'),
	      type: 'agelimit'
	    }, {
	      name: 'addressStr',
	      label: __('Address', 'schoolInformation.form'),
	      type: 'address'
	    }, {
	      name: 'openHours',
	      label: __('Open Hours', 'schoolInformation.form'),
	      type: 'openhours'
	    }];
	
	    this.settingSchema = [{
	      name: 'notification_convert_contact',
	      label: __('Notify admin via email when contact converted to student', 'schoolInformation.form'),
	      type: 'checkbox'
	    }];
	  };
	
	  SchoolInformationForm.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    this.setState({
	      fetching: true
	    });
	
	    (0, _getSchoolTypes2.default)().then(function (result) {
	      var categories = result.map(function (type) {
	        return {
	          label: __(type.codename, 'schooltypes'),
	          value: type.id
	        };
	      });
	
	      (0, _getSchoolSettings2.default)(schoolId).then(function (schoolSettings) {
	        (0, _getSchoolDetail2.default)(schoolId).then(function (schoolInfo) {
	          _this2.setState({
	            fetching: false,
	            formData: _extends({}, schoolInfo),
	            settingFormData: schoolSettings,
	            categories: categories
	          });
	        });
	      });
	    });
	  };
	
	  SchoolInformationForm.prototype.convertForForm = function convertForForm(data) {
	    var title = data.title,
	        description = data.description,
	        phone = data.phone,
	        phone_parsed = data.phone_parsed,
	        email = data.email,
	        timezone = data.timezone,
	        openHours = data.openHours,
	        logo = data.logo,
	        currency = data.currency,
	        address = data.address,
	        suit_number = data.suit_number,
	        postcode = data.postcode,
	        city = data.city,
	        province = data.province,
	        country = data.country,
	        categories = data.categories,
	        homepage = data.homepage,
	        enable = data.enable,
	        suitAgeLower = data.suitAgeLower,
	        suitAgeUpper = data.suitAgeUpper;
	
	
	    var dataForForm = {
	      title: title,
	      description: description,
	      phone: phone,
	      phone_parsed: phone_parsed,
	      email: email,
	      timezone: timezone,
	      openHours: openHours,
	      logo: logo,
	      currency: currency,
	      categories: categories,
	
	      addressStr: {
	        country: country,
	        city: city,
	        province: province,
	        street: address,
	        unit: suit_number,
	        postalCode: postcode
	      },
	
	      ageLimitStr: {
	        min: suitAgeLower,
	        max: suitAgeUpper
	      }
	
	      // homepageStr: JSON.stringify({
	      //   homepage,
	      //   enable,
	      // }),
	
	    };
	
	    return dataForForm;
	  };
	
	  SchoolInformationForm.prototype.convertForSubmit = function convertForSubmit(data) {
	    var title = data.title,
	        description = data.description,
	        phone = data.phone,
	        phone_parsed = data.phone_parsed,
	        email = data.email,
	        timezone = data.timezone,
	        openHours = data.openHours,
	        logo = data.logo,
	        currency = data.currency,
	        homepage = data.homepage,
	        categories = data.categories,
	        addressStr = data.addressStr,
	        ageLimitStr = data.ageLimitStr;
	
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    var dataForSubmit = {
	      title: title,
	      description: description,
	      phone: phone,
	      phone_parsed: phone_parsed,
	      email: email,
	      timezone: timezone,
	      logo: logo,
	      // schoolType,
	
	      country: addressStr.country,
	      city: addressStr.city,
	      province: addressStr.province,
	      address: addressStr.street,
	      suit_number: addressStr.unit,
	      postcode: addressStr.postalCode,
	
	      suitAgeLower: ageLimitStr.min,
	      suitAgeUpper: ageLimitStr.max,
	
	      categories: categories,
	      homepage: homepage,
	      openHours: openHours
	
	      // These values below are not allow to submit yet
	      // currency,
	      // enable: homepageObj.enable,
	    };
	
	    return dataForSubmit;
	  };
	
	  SchoolInformationForm.prototype.convertSettingsForBackend = function convertSettingsForBackend(data) {
	    data.notification_convert_contact = data.notification_convert_contact == true ? 1 : 0;
	
	    return data;
	  };
	
	  SchoolInformationForm.prototype.convertSettingsForFrontend = function convertSettingsForFrontend() {
	    var data = _extends({}, this.state.settingFormData, {
	      notification_convert_contact: this.state.settingFormData.notification_convert_contact == 1 ? true : false
	    });
	
	    return data;
	  };
	
	  SchoolInformationForm.prototype.beforeSubmit = function beforeSubmit(data) {
	
	    var newData = {
	      title: data.title,
	      logo: data.logo,
	      description: data.description,
	      phone: data.phone_parsed.country_code.toString() + data.phone_parsed.national_number.toString(),
	      email: data.email,
	      homepage: data.homepage,
	      categories: Array.isArray(data.categories) ? data.categories : [data.categories],
	      suitAgeLower: data.suitAgeLower,
	      suitAgeUpper: data.suitAgeUpper,
	      country: data.country,
	      city: data.city,
	      province: data.province,
	      address: data.address,
	      suit_number: data.suit_number,
	      postcode: data.postcode,
	      openHours: data.openHours
	    };
	
	    return newData;
	  };
	
	  SchoolInformationForm.prototype.onSubmit = function onSubmit() {
	    var _this3 = this;
	
	    var dataToSubmit = this.beforeSubmit(this.state.formData);
	    var settingDataToSubmit = this.convertSettingsForBackend(this.state.settingFormData);
	    var schoolId = localStorage.getItem('schoolId');
	
	    this.setState({
	      fetching: true
	    });
	
	    if (dataToSubmit.logo.file) {
	      (0, _logoUploader2.default)(schoolId, dataToSubmit.logo.file).then(function (res) {
	        if (res.result == 'success') {
	          dataToSubmit.logo = res.save_to;
	          _this3.updateSchool(dataToSubmit);
	        }
	      }).catch(function (err) {});
	    } else {
	      this.updateSchool(dataToSubmit, settingDataToSubmit);
	    }
	  };
	
	  SchoolInformationForm.prototype.updateSchool = function updateSchool(data, settingData) {
	    var _this4 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    (0, _updateSchoolDetail2.default)(schoolId, data).then(function (data) {
	      _this4.setState({
	        fetching: false,
	        formData: data.updated
	      });
	      if (data.result === 'success') {
	        (0, _updateSchoolSettings2.default)(schoolId, settingData).then(function (data) {
	          _this4.props.updateSchoolInfo(data.updated);
	        });
	      }
	    }).catch(function (e) {
	
	      _this4.setState({
	        fetching: false
	      });
	      console.error(e);
	    });
	  };
	
	  SchoolInformationForm.prototype.onChange = function onChange(newFormData) {
	    this.setState({
	      formData: _extends({}, this.state.formData, this.convertForSubmit(newFormData))
	    });
	  };
	
	  SchoolInformationForm.prototype.onSettingChange = function onSettingChange(newFormData) {
	    this.setState({
	      settingFormData: _extends({}, this.state.settingFormData, newFormData)
	    });
	  };
	
	  SchoolInformationForm.prototype.render = function render() {
	    var _state = this.state,
	        formData = _state.formData,
	        fetching = _state.fetching;
	
	
	    this.getSchema();
	
	    if (fetching) {
	      return _react2.default.createElement(_Loading2.default, { onPanel: true });
	    }
	
	    return _react2.default.createElement(
	      _Transition2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'school-information-form-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'title-section' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            __("School Information", "schoolInformation", null, true)
	          ),
	          _react2.default.createElement(
	            'h4',
	            null,
	            __("Add all information that will help your target audience better understand your school on our Yellow Pages advertisements", "schoolInformation")
	          )
	        ),
	        _react2.default.createElement(_Form2.default, {
	          onChange: this.onChange,
	          schema: this.schema,
	          formData: this.convertForForm(formData),
	          formStyle: 'inline',
	          getValidationRef: this.props.getValidationRef
	        }),
	        _react2.default.createElement(_Form2.default, {
	          onChange: this.onSettingChange,
	          schema: this.settingSchema,
	          formData: this.convertSettingsForFrontend(),
	          formStyle: 'inline',
	          getValidationRef: this.props.getValidationRef
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'submit-field' },
	          _react2.default.createElement(
	            _R2.default,
	            { can: 'edit_school_setting', by: 'alert' },
	            _react2.default.createElement(
	              _UI.Button,
	              { disabled: fetching, bsStyle: 'primary', onClick: this.onSubmit },
	              __('Update Info', 'schoolInformation.form')
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return SchoolInformationForm;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(SchoolInformationForm);
	module.exports = exports['default'];

/***/ },

/***/ "1arY":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getSchoolTypes;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	* GET
	* all the school types
	**/
	function getSchoolTypes() {
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': "/g_categories/",
				'method': 'GET',
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res.data);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports["default"];

/***/ },

/***/ "k5ft":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.schema = undefined;
	exports.default = updateSchoolDetail;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schema = exports.schema = _joiBrowser2.default.object().keys({
	  logo: _joiBrowser2.default.string().allow('').allow(null),
	  title: _joiBrowser2.default.string().allow('').allow(null),
	  description: _joiBrowser2.default.string().allow('').allow(null),
	  chineseTitle: _joiBrowser2.default.string().allow('').allow(null),
	  chineseDescription: _joiBrowser2.default.string().allow('').allow(null),
	  schoolType: _joiBrowser2.default.number().integer().allow(null),
	  rating: _joiBrowser2.default.string().allow('').allow(null),
	  totalNumberOfRatings: _joiBrowser2.default.number().integer(),
	  suitAgeLower: _joiBrowser2.default.number().integer().allow(null),
	  suitAgeUpper: _joiBrowser2.default.number().integer().allow(null),
	  openHours: _joiBrowser2.default.string().allow('').allow(null),
	  address: _joiBrowser2.default.string().allow('').allow(null),
	  suit_number: _joiBrowser2.default.string().allow('').allow(null),
	  postcode: _joiBrowser2.default.string().allow('').allow(null),
	  city: _joiBrowser2.default.string().allow('').allow(null),
	  province: _joiBrowser2.default.string().allow('').allow(null),
	  country: _joiBrowser2.default.string().allow('').allow(null),
	  timezone: _joiBrowser2.default.string().allow('').allow(null),
	  currency: _joiBrowser2.default.string().allow('').allow(null),
	  homepage: _joiBrowser2.default.string().allow('').allow(null),
	  phone: _joiBrowser2.default.string().allow('').allow(null),
	  email: _joiBrowser2.default.string().allow('').allow(null),
	  image: _joiBrowser2.default.string().allow('').allow(null),
	  numberOfViews: _joiBrowser2.default.number().integer().allow(null),
	  enable: _joiBrowser2.default.boolean(),
	  approval: _joiBrowser2.default.number().integer(),
	  remark: _joiBrowser2.default.string().allow('').allow(null),
	  ownerUser: _joiBrowser2.default.number().integer(),
	  tags: _joiBrowser2.default.array().items(_joiBrowser2.default.string()),
	  categories: _joiBrowser2.default.array().items(_joiBrowser2.default.number().integer())
	});
	
	/**
	* PUT 
	* Return the information of school.
	**/
	function updateSchoolDetail(schoolID, schoolDetail) {
	  if (!schoolID) {
	    throw "ERROR getSchoolDetail(): schoolID is missing";
	  }
	
	  var validateResult = _joiBrowser2.default.validate(schoolDetail, schema);
	
	  if (validateResult.error) {
	    return new Promise(function (resolve, reject) {
	      reject(validateResult);
	    });
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, {
	      'uri': "/u_school/" + schoolID + "/",
	      'method': 'PUT',
	      'token': localStorage.getItem('token'),
	      'data': JSON.stringify(schoolDetail)
	    }).then(function (res) {
	      var toReturn = res.data;
	      resolve(toReturn);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}

/***/ },

/***/ "1rEC":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"school-information-form-wrapper":"school-information-form-wrapper","title-section":"title-section","form-field":"form-field","form-group":"form-group","field-object":"field-object","submit-field":"submit-field","form-control":"form-control"};

/***/ },

/***/ "Hq4q":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = __webpack_require__("C8DA");
	module.exports = exports["default"];

/***/ },

/***/ "aSEF":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Permissions":"Permissions","Form":"Form","outline":"outline","Field":"Field","hasNoLabel":"hasNoLabel","col-xs-2":"col-xs-2","btn":"btn","Permissions-list-column":"Permissions-list-column","PermissionList":"PermissionList","Permissions--header":"Permissions--header","form-group":"form-group","icon-cog":"icon-cog","Permissions--header__edit":"Permissions--header__edit","form-control":"form-control","mode-read":"mode-read","children--checkbox":"children--checkbox","control":"control","checkmark":"checkmark","group--checkbox":"group--checkbox","active":"active","mode-edit":"mode-edit","dep":"dep","depOn":"depOn","permissions--group":"permissions--group","group--header":"group--header","grant-all":"grant-all","btn-link":"btn-link","permissions--group--children":"permissions--group--children","expanded":"expanded","Members":"Members","groupList":"groupList","GroupList--item":"GroupList--item","icon-angle-right":"icon-angle-right","MemberList":"MemberList","MemberList--item":"MemberList--item","pull-right":"pull-right","col-xs-10":"col-xs-10"};

/***/ },

/***/ "eCVO":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _locale = __webpack_require__("mLe8");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _lodash = __webpack_require__("M4fF");
	
	var _alert = __webpack_require__("BGi1");
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _SelectTeacher = __webpack_require__("okp6");
	
	var _SelectTeacher2 = _interopRequireDefault(_SelectTeacher);
	
	var _runParallel = __webpack_require__("HPjn");
	
	var _runParallel2 = _interopRequireDefault(_runParallel);
	
	__webpack_require__("aSEF");
	
	var _getPermissionGroupList2 = __webpack_require__("3tPD");
	
	var _getPermissionGroupList3 = _interopRequireDefault(_getPermissionGroupList2);
	
	var _getPermissionGroupDetail2 = __webpack_require__("aktW");
	
	var _getPermissionGroupDetail3 = _interopRequireDefault(_getPermissionGroupDetail2);
	
	var _getPermissionList2 = __webpack_require__("Gnol");
	
	var _getPermissionList3 = _interopRequireDefault(_getPermissionList2);
	
	var _registerPermissionGroup = __webpack_require__("/Jya");
	
	var _registerPermissionGroup2 = _interopRequireDefault(_registerPermissionGroup);
	
	var _updatePermissionGroupTeacher = __webpack_require__("LFjV");
	
	var _updatePermissionGroupTeacher2 = _interopRequireDefault(_updatePermissionGroupTeacher);
	
	var _deletePermissionGroup = __webpack_require__("NCSu");
	
	var _deletePermissionGroup2 = _interopRequireDefault(_deletePermissionGroup);
	
	var _updatePermissionGroup = __webpack_require__("lJJu");
	
	var _updatePermissionGroup2 = _interopRequireDefault(_updatePermissionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Permissions 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is ...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @redux
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var GROUP_ORDER = ['timetable_channel', 'student_channel', 'read_student_detail', 'class_channel', 'private_class_channel', 'teacher_channel', 'classroom_channel', 'announcement_channel', 'finance_channel', 'poster_channel', 'contact_channel', 'school_setting_channel', 'group_perm_channel', 'nav_bar', 'operation_log_channel'];
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var Permissions = function (_React$Component) {
	  _inherits(Permissions, _React$Component);
	
	  function Permissions(props) {
	    _classCallCheck(this, Permissions);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.schoolId = localStorage.getItem('schoolId');
	
	    _this.state = {
	      currentGroup: {},
	      groupList: [],
	      permissionList: [],
	      mode: 'read',
	      permissionGroups: {},
	
	      permissionFormData: [],
	      teachersFormData: [],
	      schema: [],
	
	      expandedGroup: {}
	    };
	
	    _this.propagatedPermissionChange = {};
	
	    _this.toggleMode = _this.toggleMode.bind(_this);
	    _this.addMember = _this.addMember.bind(_this);
	    _this.removeMember = _this.removeMember.bind(_this);
	    _this.onPermissionChange = _this.onPermissionChange.bind(_this);
	    _this.onPermissionNameChange = _this.onPermissionNameChange.bind(_this);
	    _this.onSelectGroup = _this.onSelectGroup.bind(_this);
	    _this.save = _this.save.bind(_this);
	    _this.remove = _this.remove.bind(_this);
	    _this.savePermissions = _this.savePermissions.bind(_this);
	    _this.saveTeachers = _this.saveTeachers.bind(_this);
	    _this.createGroup = _this.createGroup.bind(_this);
	    return _this;
	  }
	
	  Permissions.prototype.componentWillMount = function componentWillMount() {
	    this.getPermissionGroupList();
	    this.getPermissionList();
	  };
	
	  Permissions.prototype.getPermissionGroupDetail = function getPermissionGroupDetail(groupId) {
	    var _this2 = this;
	
	    (0, _getPermissionGroupDetail3.default)(groupId).then(function (res) {
	
	      var currentGroup = (0, _lodash.cloneDeep)(res.data);
	
	      currentGroup.teachers = currentGroup.teachers || [];
	
	      _this2.setState({
	        currentGroup: currentGroup,
	        // we will basically merge group in group list with the new group detail
	        groupList: _this2.state.groupList.map(function (group) {
	          if (groupId === group.id) {
	            return _extends({}, currentGroup);
	          }
	          return group;
	        })
	      }, function () {
	        _this2.prepareEdit();
	      });
	    }).catch(function (error) {
	      console.error(error);
	    });
	  };
	
	  Permissions.prototype.prepareEdit = function prepareEdit() {
	    var currentGroup = this.state.currentGroup;
	
	
	    var newExpandedGroup = {};
	
	    var permissionFormData = {};
	
	    currentGroup.permissions.map(function (id, index) {
	      permissionFormData[id] = true;
	      if (typeof newExpandedGroup[id] == 'undefined') {
	        newExpandedGroup[id] = true;
	      }
	    });
	
	    var teachersFormData = [];
	
	    currentGroup.teachers.map(function (_ref) {
	      var id = _ref.id,
	          stName = _ref.stName,
	          stGender = _ref.stGender;
	
	      teachersFormData.push({
	        id: id,
	        name: stName,
	        gender: stGender
	      });
	    });
	
	    this.setState({
	      currentGroup: currentGroup,
	      expandedGroup: _extends({}, this.state.expandedGroup, newExpandedGroup),
	      permissionName: currentGroup.name,
	      permissionFormData: permissionFormData,
	      teachersFormData: teachersFormData
	    });
	  };
	
	  Permissions.prototype.getPermissionGroupList = function getPermissionGroupList() {
	    var _this3 = this;
	
	    (0, _getPermissionGroupList3.default)(this.schoolId).then(function (res) {
	      if (Array.isArray(res.data)) {
	        _this3.setState({
	          groupList: res.data
	        }, function () {
	
	          if (!_this3.state.currentGroup.id) {
	            _this3.getPermissionGroupDetail(res.data[0].id);
	          }
	        });
	      }
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  Permissions.prototype.getPermissionList = function getPermissionList() {
	    var _this4 = this;
	
	    var BY_CHANNEL = false;
	    (0, _getPermissionList3.default)(BY_CHANNEL).then(function (res) {
	      if (Array.isArray(res.data)) {
	        var _getPermissionDep = _this4.getPermissionDep(res.data),
	            permissionDep = _getPermissionDep.permissionDep,
	            permissionsDepOn = _getPermissionDep.permissionsDepOn;
	
	        var permissionsPerId = {};
	
	        res.data.map(function (perm) {
	          permissionsPerId[perm.id] = perm;
	        });
	
	        _this4.setState({
	          permissionList: res.data,
	          permissionsPerId: permissionsPerId,
	          permissionDep: permissionDep,
	          permissionsDepOn: permissionsDepOn
	        }, function () {
	          var schema = _this4.reorderPermissionGroups();
	        });
	      }
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  Permissions.prototype.reorderPermissionGroups = function reorderPermissionGroups() {
	    var permissionList = this.state.permissionList;
	
	    var permissionGroups = {};
	
	    var types = {
	      read: [],
	      create: [],
	      update: [],
	      delete: [],
	      others: []
	      // Step 1. Put permissions in read, create, update, delete order
	    };permissionList.map(function (perm) {
	      if (perm.codename.indexOf('read') > -1) {
	        types.read.push(perm);
	      } else if (perm.codename.indexOf('create') > -1) {
	        types.create.push(perm);
	      } else if (perm.codename.indexOf('edit') > -1) {
	        types.update.push(perm);
	      } else if (perm.codename.indexOf('delete') > -1) {
	        types.delete.push(perm);
	      } else {
	        types.others.push(perm);
	      }
	    });
	
	    var sortedPermissionList = [].concat(types.read, types.create, types.update, types.delete, types.others);
	
	    // Step 2. Allocate permissions into each group
	    sortedPermissionList.map(function (perm, idx) {
	      if (Array.isArray(perm.belong_to)) {
	        perm.belong_to.map(function (parent, idx) {
	          if (!permissionGroups[parent]) {
	            permissionGroups[parent] = {
	              children: []
	            };
	          }
	
	          // if the perm's belong_to's name is same as code_name
	          // we assuem this perm is a parent(channel) perm
	          if (parent === perm.codename) {
	            permissionGroups[parent] = _extends({}, permissionGroups[parent], perm);
	          } else {
	            permissionGroups[parent].children.push(perm);
	          }
	        });
	      }
	    });
	
	    // Step 3. Reorder permission groups according to menu order
	    var ordered = {};
	    GROUP_ORDER.map(function (name) {
	      if (permissionGroups[name]) {
	        ordered[name] = permissionGroups[name];
	      }
	    });
	
	    (0, _lodash.each)(permissionGroups, function (value, name) {
	      if (!ordered[name]) {
	        ordered[name] = value;
	      }
	    });
	
	    this.setState({
	      permissionGroups: ordered
	    });
	  };
	
	  Permissions.prototype.getPermissionDep = function getPermissionDep(permissions) {
	
	    // flat out permissions to {name}: {id} format
	    var idPerName = {};
	    permissions.map(function (perm) {
	      idPerName[perm.codename] = perm.id;
	    });
	
	    // dependency
	    var permissionDep = {};
	    permissions.map(function (perm) {
	      var depend_on = perm.depend_on;
	
	
	      var depArray = [];
	      depend_on.map(function (name) {
	        if (idPerName[name]) {
	          depArray.push(idPerName[name]);
	        }
	      });
	
	      permissionDep[perm.id] = depArray;
	    });
	
	    // affect
	    var permissionsDepOn = {};
	    (0, _lodash.each)(permissionDep, function (deps, id) {
	      deps.map(function (depId) {
	        if (!permissionsDepOn[depId]) {
	          permissionsDepOn[depId] = [];
	        }
	
	        permissionsDepOn[depId].push(parseInt(id));
	      });
	    });
	
	    return {
	      permissionDep: permissionDep,
	      permissionsDepOn: permissionsDepOn
	    };
	  };
	
	  Permissions.prototype.onPermissionChange = function onPermissionChange(permissionFormData) {
	    var _this5 = this;
	
	    this.setState({
	      permissionFormData: _extends({}, this.state.permissionFormData, permissionFormData, this.propagatedPermissionChange),
	      expandedGroup: _extends({}, this.state.expandedGroup, permissionFormData)
	    }, function () {
	      _this5.propagatedPermissionChange = {};
	    });
	  };
	
	  Permissions.prototype.onTogglePermission = function onTogglePermission(e, id, value) {
	    var _this6 = this;
	
	    var _state = this.state,
	        _state$permissionForm = _state.permissionFormData,
	        permissionFormData = _state$permissionForm === undefined ? {} : _state$permissionForm,
	        _state$currentDep = _state.currentDep,
	        currentDep = _state$currentDep === undefined ? [] : _state$currentDep,
	        _state$currentDepOn = _state.currentDepOn,
	        currentDepOn = _state$currentDepOn === undefined ? [] : _state$currentDepOn,
	        permissionsPerId = _state.permissionsPerId;
	
	    var onPermissionChange = this.onPermissionChange;
	
	    var affectedDep = currentDep.filter(function (id, key) {
	      return permissionFormData[id] !== true;
	    });
	
	    var affectedDepOn = currentDepOn.filter(function (id, key) {
	      return permissionFormData[id] === true;
	    });
	
	    if (value === true && affectedDepOn.length > 0) {
	      e.preventDefault();
	      (0, _confirm2.default)(_react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          __('The following permissions will be disabled in order to complete your request.', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          affectedDepOn.map(function (id, key) {
	            return _react2.default.createElement(
	              'li',
	              { key: key },
	              key + 1,
	              '. ',
	              __(permissionsPerId[id].description, _locale2.default)
	            );
	          })
	        )
	      ), __('Warning', _locale2.default)).then(function () {
	        var _onPermissionChange;
	
	        currentDepOn.map(function (id) {
	          _this6.propagatedPermissionChange[id] = false;
	        });
	        onPermissionChange((_onPermissionChange = {}, _onPermissionChange[id] = false, _onPermissionChange));
	      }).catch(function () {});
	    } else if (value !== true && affectedDep.length > 0) {
	      e.preventDefault();
	
	      (0, _confirm2.default)(_react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          __('The following permissions will be enabled in order to complete your request.', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          affectedDep.map(function (id, key) {
	            return _react2.default.createElement(
	              'li',
	              { key: key },
	              key + 1,
	              '. ',
	              __(permissionsPerId[id].description, _locale2.default)
	            );
	          })
	        )
	      ), __('Warning', _locale2.default)).then(function () {
	        var _onPermissionChange2;
	
	        currentDep.map(function (id) {
	          _this6.propagatedPermissionChange[id] = true;
	        });
	        onPermissionChange((_onPermissionChange2 = {}, _onPermissionChange2[id] = true, _onPermissionChange2));
	      }).catch(function () {});
	    } else {
	      var _onPermissionChange3;
	
	      onPermissionChange((_onPermissionChange3 = {}, _onPermissionChange3[id] = value !== true, _onPermissionChange3));
	    }
	  };
	
	  Permissions.prototype.generatePermissionForm = function generatePermissionForm() {
	    var _this7 = this;
	
	    var _state2 = this.state,
	        permissionGroups = _state2.permissionGroups,
	        mode = _state2.mode,
	        _state2$currentDep = _state2.currentDep,
	        currentDep = _state2$currentDep === undefined ? [] : _state2$currentDep,
	        _state2$currentDepOn = _state2.currentDepOn,
	        currentDepOn = _state2$currentDepOn === undefined ? [] : _state2$currentDepOn,
	        permissionDep = _state2.permissionDep,
	        permissionsDepOn = _state2.permissionsDepOn,
	        permissionFormData = _state2.permissionFormData,
	        expandedGroup = _state2.expandedGroup;
	    // TODO: refactor it as a separate component
	
	    var CheckBox = function CheckBox(_ref2) {
	      var id = _ref2.id,
	          hideCheckbox = _ref2.hideCheckbox,
	          description = _ref2.description,
	          value = _ref2.value,
	          className = _ref2.className,
	          disabled = _ref2.disabled,
	          codename = _ref2.codename;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(className, 'codename--' + codename, 'Field form-group field-style-outline') },
	        _react2.default.createElement(
	          'label',
	          {
	            className: (0, _classnames2.default)({
	              'control': true,
	              active: value,
	              dep: value !== true && currentDep.indexOf(id) > -1,
	              depOn: value == true && currentDepOn.indexOf(id) > -1
	            }),
	            onMouseEnter: function onMouseEnter() {
	              _this7.setState(_extends({}, _this7.state, {
	                currentDep: value != true ? permissionDep[id] || [] : [],
	                currentDepOn: value == true ? permissionsDepOn[id] || [] : []
	              }));
	            },
	            onMouseLeave: function onMouseLeave() {
	              _this7.setState(_extends({}, _this7.state, {
	                currentDep: [],
	                currentDepOn: []
	              }));
	            },
	            onClick: function onClick() {
	              if (hideCheckbox) {
	                var _extends2;
	
	                _this7.setState({
	                  expandedGroup: _extends({}, expandedGroup, (_extends2 = {}, _extends2[id] = expandedGroup[id] !== true, _extends2))
	                });
	              }
	            }
	          },
	          hideCheckbox !== true && _react2.default.createElement('input', {
	            type: 'checkbox',
	            checked: value,
	            value: value,
	            disabled: disabled,
	            onChange: function onChange(e) {
	              _this7.onTogglePermission(e, id, value);
	            }
	          }),
	          hideCheckbox !== true && _react2.default.createElement('span', { className: 'checkmark' }),
	          __(description, _locale2.default)
	        )
	      );
	    };
	
	    var formItems = [];
	
	    var disabled = mode !== 'edit';
	
	    (0, _lodash.each)(permissionGroups, function (group, codename) {
	      var id = group.id,
	          children = group.children,
	          description = group.description;
	
	
	      var groupValue = permissionFormData[id];
	      //
	      // "nav_bar" is always checked and cannot be modified: START
	      //
	      var isNavBar = codename === 'nav_bar';
	      if (isNavBar) {
	        groupValue = true;
	      }
	      //
	      // "nav_bar" is always checked: END
	      //
	
	      var expanded = expandedGroup[id] == true;
	
	      formItems.push(_react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)({ active: groupValue || isNavBar }, 'permissions--group', 'codename--' + codename) },
	        _react2.default.createElement(
	          'div',
	          { className: 'group--header' },
	          CheckBox(_extends({}, group, { hideCheckbox: isNavBar, codename: codename, value: groupValue, disabled: disabled, className: 'group--checkbox' })),
	          _react2.default.createElement(
	            'a',
	            { className: 'btn-link toggle-expand', onClick: function onClick() {
	                var _extends3;
	
	                _this7.setState({
	                  expandedGroup: _extends({}, expandedGroup, (_extends3 = {}, _extends3[id] = expandedGroup[id] !== true, _extends3))
	                });
	              } },
	            _react2.default.createElement('i', { className: (0, _classnames2.default)('fa', { 'icon-angle-right': !expanded, 'icon-angle-down': expanded }) })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('permissions--group--children', { expanded: expanded }) },
	          children.map(function (perm) {
	            var id = perm.id,
	                description = perm.description,
	                codename = perm.codename;
	
	
	            var value = permissionFormData[id];
	
	            return CheckBox(_extends({}, perm, { value: value, codename: codename, disabled: disabled, className: 'children--checkbox' }));
	          })
	        )
	      ));
	    });
	
	    return _react2.default.createElement(
	      'form',
	      { className: 'Form' },
	      formItems
	    );
	  };
	
	  Permissions.prototype.createGroup = function createGroup() {
	    var _this8 = this;
	
	    this.setState({
	      currentGroup: {
	        id: -1,
	        description: '',
	        name: '',
	        permissions: [],
	        teachers: []
	      }
	    }, function () {
	      _this8.toggleMode();
	    });
	  };
	
	  Permissions.prototype.addMember = function addMember() {
	    var _this9 = this;
	
	    var teachersFormData = this.state.teachersFormData;
	
	
	    (0, _SelectTeacher2.default)({
	      schoolId: this.schoolId,
	      selected: (0, _lodash.cloneDeep)(teachersFormData),
	      selectMultiple: true
	    }).then(function (selected) {
	      var teachersFormData = selected.map(function (_ref3) {
	        var name = _ref3.name,
	            id = _ref3.id,
	            gender = _ref3.gender;
	
	        return {
	          name: name, id: id, gender: gender
	        };
	      });
	
	      _this9.setState({
	        teachersFormData: teachersFormData
	      });
	    });
	  };
	
	  Permissions.prototype.onSelectGroup = function onSelectGroup(currentGroup) {
	    var _this10 = this;
	
	    return function () {
	      _this10.setState({
	        currentGroup: currentGroup
	      });
	
	      _this10.getPermissionGroupDetail(currentGroup.id);
	    };
	  };
	
	  Permissions.prototype.toggleMode = function toggleMode() {
	    var _this11 = this;
	
	    var mode = this.state.mode === 'edit' ? 'read' : 'edit';
	
	    var _state3 = this.state,
	        currentGroup = _state3.currentGroup,
	        groupList = _state3.groupList;
	
	
	    this.setState({
	      mode: mode
	    }, function () {
	      if (mode == 'edit') {
	        _this11.prepareEdit();
	        _this11.reorderPermissionGroups();
	
	        if (currentGroup.id === -1 && _this11.permissionNameRef) {
	          _this11.permissionNameRef.focus();
	        }
	      }
	
	      if (mode == 'read') {
	
	        // when currentGroup id is -1 which means it's temporary group for "create"
	        // we go back to the last group
	        if (currentGroup.id === -1) {
	          _this11.setState({
	            currentGroup: groupList[0]
	          }, function () {
	            _this11.prepareEdit();
	          });
	        } else {
	
	          _this11.prepareEdit();
	        }
	      }
	    });
	  };
	
	  Permissions.prototype.removeMember = function removeMember(index) {
	    var _this12 = this;
	
	    return function () {
	      _this12.setState({
	        teachersFormData: _this12.state.teachersFormData.filter(function (data, i) {
	          return i != index;
	        })
	      });
	    };
	  };
	
	  Permissions.prototype.onPermissionNameChange = function onPermissionNameChange(e) {
	    this.setState({
	      permissionName: e.target.value
	    });
	  };
	
	  Permissions.prototype.remove = function remove() {
	    var _this13 = this;
	
	    var currentGroup = this.state.currentGroup;
	
	
	    (0, _confirm2.default)(__('This permission group will be deleted permanently.', _locale2.default), __('Deleting Permission Group', _locale2.default)).then(function () {
	      (0, _deletePermissionGroup2.default)(currentGroup.id).then(function (res) {
	        if (res.data && res.data.result === 'success') {
	          _this13.setState({
	            currentGroup: {}
	          }, function () {
	            _this13.toggleMode();
	            _this13.getPermissionGroupList();
	          });
	        } else {
	          console.error(res);
	        }
	      }).catch(function (err) {
	        console.error(err);
	      });
	    });
	  };
	
	  Permissions.prototype.save = function save() {
	    var _this14 = this;
	
	    var _state4 = this.state,
	        currentGroup = _state4.currentGroup,
	        permissionFormData = _state4.permissionFormData;
	
	
	    this.setState({
	      saving: true
	    });
	
	    // Step 1: START
	    var permissions = [];
	
	    Object.keys(permissionFormData).map(function (id) {
	      if (permissionFormData[id]) {
	        permissions.push(parseInt(id));
	      }
	    });
	
	    if (permissions.length == 0) {
	      _alert2.default.warning(__('Permission must not be empty.', _locale2.default), '');
	      this.setState({
	        saving: false
	      });
	      return;
	    }
	    // Step 1: END
	
	    // updating
	    if (currentGroup.id > -1) {
	      (0, _runParallel2.default)([function (done) {
	        _this14.savePermissions(permissions, done);
	      }, this.saveTeachers], function (err, result) {
	
	        if (result.indexOf(false) > -1 || err) {
	          _alert2.default.warning(__('There is an error, please try again', _locale2.default), __('Failed to save', _locale2.default));
	          _this14.setState({
	            saving: false
	          });
	        } else {
	          _alert2.default.success('', __('Settings Saved', _locale2.default));
	          _this14.setState({
	            saving: false
	          });
	
	          _this14.getPermissionGroupDetail(currentGroup.id);
	
	          _this14.toggleMode();
	        }
	      });
	    }
	
	    if (currentGroup.id === -1) {
	      // registering
	      this.registerPermissions(permissions);
	    }
	  };
	
	  Permissions.prototype.registerPermissions = function registerPermissions(permissions) {
	    var _this15 = this;
	
	    var permissionName = this.state.permissionName;
	
	
	    (0, _registerPermissionGroup2.default)(this.schoolId, {
	      name: permissionName,
	      description: '--', // it's empty for now
	      permissions: permissions
	    }).then(function (res) {
	      _this15.setState({
	        saving: false
	      });
	
	      if (res && res.data && res.data.group_id) {
	        _this15.setState({
	          currentGroup: _extends({}, _this15.state.currentGroup, {
	            id: res.data.group_id
	          })
	        }, function () {
	          _this15.saveTeachers(function (err, result) {
	
	            if (err) {
	              console.error(err);
	            } else if (result) {
	              _alert2.default.success('', __('New permission group created', _locale2.default));
	              _this15.getPermissionGroupDetail(_this15.state.currentGroup.id);
	              _this15.getPermissionGroupList();
	              _this15.toggleMode();
	            }
	          });
	        });
	      } else {
	        console.error(res);
	      }
	    }).catch(function () {
	      console.error(err);
	    });
	  };
	
	  Permissions.prototype.savePermissions = function savePermissions(permissions, done) {
	    var _state5 = this.state,
	        permissionName = _state5.permissionName,
	        _state5$permissionFor = _state5.permissionFormData,
	        permissionFormData = _state5$permissionFor === undefined ? {} : _state5$permissionFor,
	        currentGroup = _state5.currentGroup;
	
	
	    (0, _updatePermissionGroup2.default)(currentGroup.id, {
	      name: permissionName,
	      description: currentGroup.desciption,
	      permissions: permissions
	    }).then(function (res) {
	      if (res.data) {
	        var _res$data = res.data,
	            result = _res$data.result,
	            reason = _res$data.reason;
	
	        // failed
	
	        if (result === 'failure') {
	          done(res.data, false);
	        } else {
	          // success
	          done(null, true);
	        }
	      }
	    }).catch(function (err) {
	      console.error(err);
	      done(err, false);
	    });
	  };
	
	  Permissions.prototype.saveTeachers = function saveTeachers(done) {
	    var _state6 = this.state,
	        _state6$teachersFormD = _state6.teachersFormData,
	        teachersFormData = _state6$teachersFormD === undefined ? {} : _state6$teachersFormD,
	        currentGroup = _state6.currentGroup;
	
	
	    (0, _updatePermissionGroupTeacher2.default)(this.schoolId, {
	      teacher_id_list: teachersFormData.map(function (teacher) {
	        return teacher.id;
	      }),
	      group_id_list: [currentGroup.id]
	    }).then(function (res) {
	      if (res.data && res.data.result && res.data.result.indexOf('success') > -1) {
	        done(null, true);
	      } else {
	        done(res.data, false);
	      }
	    }).catch(function (error) {
	      done(error, false);
	    });
	  };
	
	  Permissions.prototype.render = function render() {
	    var _this16 = this;
	
	    var _state7 = this.state,
	        mode = _state7.mode,
	        groupList = _state7.groupList,
	        currentGroup = _state7.currentGroup,
	        teachersFormData = _state7.teachersFormData,
	        saving = _state7.saving;
	    var name = currentGroup.name;
	
	
	    var isCreating = currentGroup.id === -1;
	
	    var permissionName = this.state.permissionName;
	
	
	    if (permissionName === 'Teachers') {
	      permissionName = __('Teachers', _locale2.default);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('Permissions', 'mode-' + mode) },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-2 Permissions-list-column' },
	          mode === 'read' && _react2.default.createElement(
	            'a',
	            { className: 'btn btn-primary', onClick: this.createGroup },
	            _react2.default.createElement('i', { className: 'fa icon-plus' }),
	            __('Create Group', _locale2.default)
	          ),
	          mode === 'read' && _react2.default.createElement(
	            'ul',
	            { className: 'groupList' },
	            groupList.map(function (group, key) {
	              var name = group.name;
	
	              if (name === 'Teachers') {
	                name = __('Teachers', _locale2.default);
	              }
	              return _react2.default.createElement(
	                'li',
	                { className: (0, _classnames2.default)('GroupList--item', { active: group.id == currentGroup.id }), key: key, onClick: _this16.onSelectGroup(group) },
	                name,
	                _react2.default.createElement('i', { className: 'fa icon-angle-right' })
	              );
	            })
	          ),
	          !isCreating && mode === 'edit' && _react2.default.createElement(
	            'h3',
	            null,
	            __('Edit Group', _locale2.default)
	          ),
	          isCreating && _react2.default.createElement(
	            'h3',
	            null,
	            __('Create Group', _locale2.default)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-10 Permissions-content-column' },
	          mode === 'read' && _react2.default.createElement(
	            'section',
	            { className: 'Permissions--header Permissions--header__read' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              permissionName
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary pull-right', onClick: this.toggleMode },
	              _react2.default.createElement('i', { className: 'fa icon-cog' }),
	              __('Edit Group', _locale2.default)
	            )
	          ),
	          mode === 'edit' && _react2.default.createElement(
	            'section',
	            { className: 'Permissions--header Permissions--header__edit' },
	            name !== 'Teachers' && _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement('input', { className: 'form-control', placeholder: __('Permission Group Name', _locale2.default), ref: function ref(r) {
	                  _this16.permissionNameRef = r;
	                }, onChange: this.onPermissionNameChange, value: permissionName })
	            ),
	            name === 'Teachers' && _react2.default.createElement(
	              'h2',
	              null,
	              permissionName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'pull-right' },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary', disabled: saving, onClick: this.save },
	                __('Save', _locale2.default)
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn', onClick: this.toggleMode },
	                __('Cancel', _locale2.default)
	              ),
	              !isCreating && name !== 'Teachers' && _react2.default.createElement(
	                'button',
	                { className: 'btn btn-danger pull-right', onClick: this.remove },
	                __('Delete Permission Group', _locale2.default)
	              )
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: 'PermissionList' },
	            this.generatePermissionForm()
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: 'Members' },
	            mode === 'edit' && _react2.default.createElement(
	              'button',
	              { className: 'pull-right btn btn-primary', onClick: this.addMember },
	              __('Add Member', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'h4',
	              null,
	              __('Group Member', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'MemberList' },
	              Array.isArray(currentGroup.teachers) && teachersFormData.map(function (member, key) {
	                var id = member.id,
	                    name = member.name,
	                    gender = member.gender;
	
	                return _react2.default.createElement(
	                  'li',
	                  { className: 'col-sm-3 MemberList--item', key: key },
	                  name,
	                  mode === 'edit' && _react2.default.createElement(
	                    'a',
	                    { onClick: _this16.removeMember(key) },
	                    _react2.default.createElement('i', { className: 'fa icon-cancel' })
	                  )
	                );
	              })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Permissions;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Permissions);
	module.exports = exports['default'];

/***/ },

/***/ "mLe8":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _text;
	
	exports.default = {
	  id: 'Permissions',
	  code: 'CN',
	  text: (_text = {
	    'Permissions': '权限设置',
	    'Warning': '警告',
	    'The following permissions will be disabled in order to complete your request.': '以下权限将会关闭',
	    'New permission group created': '新权限组生成',
	    'Create Group': '添加新权限组',
	    'Add Member': '添加成员',
	    'This permission group will be deleted permanently.': '此权限组将会永久删除',
	    'Permission must not be empty.': '权限设置不能为空',
	    'Failed to save': '保存失败',
	    'There is an error, please try again': '发生了一个错误',
	    'Settings Saved': '设置已保存',
	    'Save': '保存',
	    'Permission Group Name': '新权限组名称',
	    'Cancel': '取消',
	    'Edit Group': '编辑权限组',
	    'Teachers': '老师',
	    'Delete Permission Group': '删除权限组',
	    'Group Member': '权限组成员',
	    'Deleting Permission Group': '删除权限组',
	    'View student channel': '查看学生频道',
	    'Edit student': '编辑学生',
	    'Edit classroom': '编辑教室',
	    'Edit teacher': '编辑老师',
	    'View student task': '查看学生规划',
	    'Edit student notes': '编辑学生备注',
	    'Assign student to class': '将学生分配到班级',
	    'Recover student in school': '恢复本校学生',
	    'Export student to excel': '导出学生至 Excel',
	    'View student trade record': '查看学生缴费记录',
	    'Create private class': '新建私课',
	    'View student detail': '查看学生详细信息',
	    'View student check in record': '查看学生签到记录',
	    'Create class and assign multiple student': '新建班级并分配多个学生',
	    'Edit student task': '编辑学生规划',
	    'Edit transaction notes': '编辑缴费备注',
	    'Archive student from class': '从班级里归档学生',
	    'Charge student fee': '对学生进行收费',
	    'Send transaction email': '发送缴费记录邮件',
	    'View class of student': '查看学生所在班级',
	    'Create student': '新建学生',
	    'Create student task': '新建学生规划',
	    'Edit school information and student registration field': '修改学校信息以及注册自定义',
	    'Delete student task': '删除学生规划',
	    'Archive student from school': '从学校里归档学生',
	    'Refund for student': '给学生退款',
	    'Change student task status': '完成学生规划',
	    'View class channel': '查看班级频道',
	    'View class detail': '查看班级信息',
	    'Create class': '创建班级',
	    'Edit, delete lesson': '编辑，删除课节',
	    'Archive teacher from class': '从班级里归档老师',
	    'View student in class': '查看班级里的学生',
	    'Create lesson': '新建课节',
	    'Manually check in for student and teacher': '手动给学生老师签到',
	    'View teacher in class': '查看班级里的老师',
	    'Edit class': '编辑班级',
	    'Close/archive class': '关闭、归档班级',
	    'Assign teacher to class': '将老师分配到班级',
	    'View private class channel': '查看私课频道',
	    'View private class detail': '查看私课信息',
	    'Create private lesson': '新建私课课节',
	    'Archive teacher from private class': '从私课里归档老师',
	    'View teacher of private class lesson': '查看私课里的老师',
	    'Edit private class': '编辑私课',
	    'Assign teacher to private class': '将老师分配到私课',
	    'Edit private lesson': '编辑私课课节',
	    'Close/archive private class': '关闭、归档私课',
	    'View teacher channel': '查看老师频道',
	    'View teacher check in record': '查看老师签到',
	    'Invite teacher to school': '邀请老师',
	    'Create teacher': '新建老师',
	    'Archive teacher from school': '从学校里归档老师',
	    'Recover teacher in school': '从学校里恢复老师'
	  }, _text['Assign teacher to private class'] = '将老师分配到私课', _text['Navigation'] = '查看导航栏', _text['Create and publish poster'] = '新建发布海报', _text['View contact channel'] = '查看联系人频道', _text['Create classroom'] = '新建班级', _text['Create contact'] = '新建联系人', _text['Create and publish announcement'] = '新建发布公告', _text['Start smart check in'] = '使用智能签到', _text['Staff operation log notification in web browser'] = '教务操作记录通知', _text['View classroom channel'] = '查看教室频道', _text['Delete classroom'] = '删除班级', _text['View announcement channel'] = '查看公告频道', _text['Edit announcement'] = '编辑公告', _text['Delete announcement'] = '删除公告', _text['View poster channel'] = '查看海报频道', _text['Edit, publish, un-publish, delete poster'] = '编辑、发布、下架、删除海报', _text['Convert attendee to student'] = '转换海报报名人为学生', _text['Edit contact'] = '编辑联系人', _text['Edit contact notes'] = '编辑联系人备注', _text['Edit contact tag'] = '编辑联系人标签', _text['Convert contact to student'] = '转换联系人为学生', _text['View group and permission setting channel'] = '查看权限频道', _text['Create group and permission'] = '新建权限组', _text['Edit group and permission'] = ' 编辑权限组权限', _text['View timetable channel'] = '查看课表频道', _text['View school settings channel'] = '查看学校设置频道', _text['View finance channel'] = '查看财务频道', _text['Export transaction to excel'] = '导出财务记录为 Excel', _text['View operation log channel'] = '查看操作记录频道', _text['View teacher app'] = '使用老师 app', _text['Change student task status in teacher app'] = '在老师 app 中更改学生规划状态', _text['Manually check in for student and teacher in teacher app'] = '在老师 app 中手动给学生老师签到', _text['The following permissions will be enabled in order to complete your request.'] = '如果你想完成此操作，以下权限将会自动开启', _text['View contact detail'] = '查看联系人详情', _text['View teacher detail'] = '查看老师详情', _text['View class of teacher'] = '查看老师所在班级', _text['Edit contact custom fields'] = '编辑联系人自定义字段', _text['Read teacher punch card record'] = '查看老师打卡记录', _text['Create, edit and delete teacher punch card record'] = '新建, 修改, 删除老师打卡记录', _text)
	};
	module.exports = exports['default'];

/***/ },

/***/ "8y+r":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _Permissions = __webpack_require__("eCVO");
	
	var _Permissions2 = _interopRequireDefault(_Permissions);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _locale = __webpack_require__("e4m9");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _UI = __webpack_require__("OM1Z");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SchoolSettings = function (_Component) {
	  _inherits(SchoolSettings, _Component);
	
	  function SchoolSettings(props) {
	    _classCallCheck(this, SchoolSettings);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  SchoolSettings.prototype.render = function render() {
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        __("Permissions", _locale2.default)
	      ),
	      _react2.default.createElement(_Permissions2.default, null)
	    );
	  };
	
	  return SchoolSettings;
	}(_react.Component);
	
	exports.default = SchoolSettings;
	module.exports = exports['default'];

/***/ },

/***/ "e4m9":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'SchoolSettings',
	  code: 'CN',
	  text: {
	    'Permissions': '权限设置',
	    'School Settings': '学校设置'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "psoL":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp; /**
	                    * <BasicInfo	/>
	                    *
	                    *
	                    * @parent anybody
	                    * @children 
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _basicInfoFields = __webpack_require__("jAvG");
	
	var _basicInfoFields2 = _interopRequireDefault(_basicInfoFields);
	
	var _FieldItem = __webpack_require__("3NyY");
	
	var _FieldItem2 = _interopRequireDefault(_FieldItem);
	
	var _Panel = __webpack_require__("6jUu");
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _locale = __webpack_require__("NFNt");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BasicInfo = (_temp = _class = function (_React$Component) {
	  _inherits(BasicInfo, _React$Component);
	
	  function BasicInfo(props) {
	    _classCallCheck(this, BasicInfo);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  BasicInfo.prototype.componentWillMount = function componentWillMount() {};
	
	  BasicInfo.prototype.render = function render() {
	    var FieldItems = [];
	
	    _basicInfoFields2.default.map(function (field, index) {
	      var label = field.label,
	          required = field.required,
	          isSettingItem = field.isSettingItem;
	
	      if (isSettingItem) {
	        FieldItems.push(_react2.default.createElement(_FieldItem2.default, { key: index,
	          label: label,
	          required: required
	        }));
	      }
	    });
	
	    return _react2.default.createElement(
	      _Panel2.default,
	      { title: __('Basic Info', _locale2.default) },
	      _react2.default.createElement(
	        'div',
	        { className: 'basic-info' },
	        FieldItems
	      )
	    );
	  };
	
	  return BasicInfo;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = BasicInfo;
	module.exports = exports['default'];

/***/ },

/***/ "xv0/":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"student-settings":"student-settings","classtop-panel":"classtop-panel","content-section":"content-section","bread-crumbs":"bread-crumbs"};

/***/ },

/***/ "ai00":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp; /**
	                    * <StudentSettings />
	                    *
	                    *
	                    * @parent anybody
	                    * @children
	                    * @stateful
	                    * @stateless
	                    */
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PanelWrapper = __webpack_require__("VPji");
	
	var _PanelWrapper2 = _interopRequireDefault(_PanelWrapper);
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _Panel = __webpack_require__("6jUu");
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _CustomField = __webpack_require__("CEBJ");
	
	var _CustomField2 = _interopRequireDefault(_CustomField);
	
	var _getStudentCustomFields = __webpack_require__("61c/");
	
	var _getStudentCustomFields2 = _interopRequireDefault(_getStudentCustomFields);
	
	var _updateStudentCustomFields = __webpack_require__("oKwu");
	
	var _updateStudentCustomFields2 = _interopRequireDefault(_updateStudentCustomFields);
	
	var _BasicInfo = __webpack_require__("psoL");
	
	var _BasicInfo2 = _interopRequireDefault(_BasicInfo);
	
	var _locale = __webpack_require__("NFNt");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("xv0/");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StudentSettings = (_temp = _class = function (_React$Component) {
	  _inherits(StudentSettings, _React$Component);
	
	  function StudentSettings(props) {
	    _classCallCheck(this, StudentSettings);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      fetchingCustomField: false,
	      setting: {}
	    };
	    return _this;
	  }
	
	  StudentSettings.prototype.componentWillMount = function componentWillMount() {
	    this.fetchSetting();
	  };
	
	  StudentSettings.prototype.fetchSetting = function fetchSetting() {
	    var _this2 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    (0, _getStudentCustomFields2.default)(schoolId).then(function (res) {
	      var setting = void 0;
	      if (res.student_fields_setting && res.student_fields_setting.fields) {
	        setting = _extends({}, res.student_fields_setting);
	      } else {
	        setting = {
	          fields: []
	        };
	      }
	      _this2.setState({
	        setting: setting,
	        fetchingCustomField: false
	      });
	    });
	  };
	
	  StudentSettings.prototype.updateSetting = function updateSetting() {
	    var schoolId = localStorage.getItem('schoolId');
	    var toServer = this.state.setting;
	
	    (0, _updateStudentCustomFields2.default)(schoolId, toServer).then(function (res) {});
	  };
	
	  StudentSettings.prototype.onChange = function onChange(opts) {
	
	    var newFields = this.state.setting.fields;
	
	    var index = opts.index,
	        fieldValue = opts.fieldValue;
	
	
	    newFields[index] = _extends({}, newFields[index], fieldValue);
	
	    this.setState({
	      setting: _extends({}, this.state.setting, {
	        fields: newFields
	      })
	    });
	  };
	
	  StudentSettings.prototype.updateField = function updateField(newFields) {
	    var _this3 = this;
	
	    this.setState({
	      setting: _extends({}, this.state.setting, {
	        fields: newFields
	      })
	    }, function () {
	      _this3.updateSetting();
	    });
	  };
	
	  StudentSettings.prototype.render = function render() {
	    var _this4 = this;
	
	    var _state = this.state,
	        setting = _state.setting,
	        fetchingCustomField = _state.fetchingCustomField;
	    var fields = setting.fields;
	
	    return _react2.default.createElement(
	      _PanelWrapper2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'student-settings' },
	        _react2.default.createElement(
	          'div',
	          { className: 'bread-crumbs' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/student' },
	            __('Student', _locale2.default)
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            ' / '
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            __('Input Fields Setting', _locale2.default)
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { className: 'registration-table-close pull-right', to: '/student' },
	            _react2.default.createElement('i', { className: 'fa icon-cancel' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(_BasicInfo2.default, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(_CustomField2.default, {
	              fields: fields,
	              closeEditorsWhenAddNewItem: true,
	              isSortable: true //if it is able to drag and drop
	              , fetching: fetchingCustomField,
	              onChange: function onChange(opts) {
	                return _this4.onChange(opts);
	              },
	              updateField: function updateField(newFields) {
	                return _this4.updateField(newFields);
	              },
	              saveField: function saveField() {
	                return _this4.updateSetting();
	              }
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return StudentSettings;
	}(_react2.default.Component), _class.defaultProps = {}, _temp);
	exports.default = StudentSettings;
	module.exports = exports['default'];

/***/ },

/***/ "oKwu":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = updateStudentCustomFields;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateStudentCustomFields(schoolId, setting) {
	
	  if (!schoolId) {
	    throw 'missing student ID';
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/stu_custom_fields/' + schoolId + '/',
	      'method': 'PUT',
	      'data': JSON.stringify({
	        student_fields_setting: setting
	      }),
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "2Mtk":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Attendance = __webpack_require__("gjj1");
	
	var _Attendance2 = _interopRequireDefault(_Attendance);
	
	__webpack_require__("sfhh");
	
	var _UI = __webpack_require__("OM1Z");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var teacherAttendance = function (_React$Component) {
	  _inherits(teacherAttendance, _React$Component);
	
	  function teacherAttendance(props) {
	    _classCallCheck(this, teacherAttendance);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  teacherAttendance.prototype.render = function render() {
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      null,
	      _react2.default.createElement(_Attendance2.default, _extends({ state: 'teacher' }, this.props))
	    );
	  };
	
	  return teacherAttendance;
	}(_react2.default.Component);
	
	exports.default = teacherAttendance;
	module.exports = exports['default'];

/***/ },

/***/ "Avda":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _OnBoardingNatural = __webpack_require__("PwUp");
	
	var _OnBoardingNatural2 = _interopRequireDefault(_OnBoardingNatural);
	
	var _constant = __webpack_require__("wCrB");
	
	var _ducks = __webpack_require__("yDaX");
	
	var _subscription = __webpack_require__("ue3W");
	
	var _TeacherTable = __webpack_require__("+FMu");
	
	var _TeacherTable2 = _interopRequireDefault(_TeacherTable);
	
	var _tableSettings = __webpack_require__("dwer");
	
	var _tableSettings2 = _interopRequireDefault(_tableSettings);
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    gSubscription: state.gSubscription,
	    teacherList: state.teacherList
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchTeacher: function fetchTeacher(opts, state) {
	      return dispatch((0, _ducks.fetchTeacher)(opts, state));
	    },
	    getSubscription: function getSubscription(schoolId) {
	      return dispatch((0, _subscription.getSubscription)(schoolId));
	    }
	  };
	};
	
	var DefaultTab = function (_Component) {
	  _inherits(DefaultTab, _Component);
	
	  function DefaultTab(props) {
	    _classCallCheck(this, DefaultTab);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.fetchTeacherList = _this.fetchTeacherList.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.onItemsCountPerPageChange = _this.onItemsCountPerPageChange.bind(_this);
	    return _this;
	  }
	
	  DefaultTab.prototype.componentWillMount = function componentWillMount() {
	    this.fetchTeacherList(1);
	  };
	
	  DefaultTab.prototype.fetchTeacherList = function fetchTeacherList(newPageNumber, newAmountPerPage) {
	    var _props = this.props,
	        teacherState = _props.teacherState,
	        orderBy = _props.orderBy,
	        keyword = _props.keyword;
	    var itemsCountPerPage = this.props.teacherList.pagination.itemsCountPerPage;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    this.props.fetchTeacher({
	      schoolId: schoolId,
	      amount_per_page: newAmountPerPage || itemsCountPerPage,
	      current_page_number: newPageNumber,
	      order_by: orderBy,
	      keyword: keyword
	    }, teacherState);
	  };
	
	  DefaultTab.prototype.onPageChange = function onPageChange(activePage) {
	    if (activePage == this.props.teacherList.pagination.activePage) {
	      return;
	    }
	
	    this.fetchTeacherList(activePage);
	  };
	
	  DefaultTab.prototype.onItemsCountPerPageChange = function onItemsCountPerPageChange(itemsCountPerPage) {
	    this.fetchTeacherList(1, itemsCountPerPage);
	  };
	
	  DefaultTab.prototype.render = function render() {
	    var _props2 = this.props,
	        teacherList = _props2.teacherList,
	        teacherState = _props2.teacherState;
	    var fetching = teacherList.fetching,
	        hasPermission = teacherList.hasPermission,
	        school_has_teacher = teacherList.school_has_teacher,
	        pagination = teacherList.pagination;
	
	
	    this.tableSettings = _tableSettings2.default.call(this, teacherState);
	    var content = _constant.onBoardingContents[teacherState];
	
	    if (fetching) {
	      return _react2.default.createElement(_Loading2.default, null);
	    }
	
	    if (school_has_teacher == false && content || hasPermission == false) {
	      return _react2.default.createElement(_OnBoardingNatural2.default, {
	        isShown: true,
	        title: content.title,
	        text: content.text,
	        image: content.image,
	        showArrow: content.showArrow
	      });
	    } else {
	      return _react2.default.createElement(_TeacherTable2.default, {
	        tableData: teacherList.list,
	        settings: this.tableSettings,
	        pagination: pagination,
	        onItemsCountPerPageChange: this.onItemsCountPerPageChange,
	        onPageChange: this.onPageChange
	      });
	    }
	  };
	
	  return DefaultTab;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DefaultTab);
	module.exports = exports['default'];

/***/ },

/***/ "wCrB":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var locale = {
	  id: 'TeacherConstant',
	  code: 'CN',
	  text: {
	    "./images/teacher_en@2x.png": "./images/teacher@2x.png",
	    'Administration Management': '多角色教务管理',
	    'Administration Management allows you to create teachers, which you can appoint them in different classes. You could also send an invitation via text to teachers, which allows them to join this platform and help you management your school. Teachers could also download ClassTopBase for School Staff app on both Apple Store and Google Play to help them better manage their classes': '学校可直接创建并保存一个教务角色，也可以邀请一名老师加入学校的教学管理，配合着专为老师定制的APP一起用，可提高数倍教学效率。'
	  }
	};
	
	var onBoardingContents = exports.onBoardingContents = {
	  // we show this when student state is 'current'
	  current: {
	    title: __('Administration Management', locale),
	    text: __('Administration Management allows you to create teachers, which you can appoint them in different classes. You could also send an invitation via text to teachers, which allows them to join this platform and help you management your school. Teachers could also download ClassTopBase for School Staff app on both Apple Store and Google Play to help them better manage their classes', locale),
	    image: __webpack_require__(19)(__('./images/teacher_en@2x.png', locale)),
	    showArrow: true
	  }
	};

/***/ },

/***/ 19:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./Attendance/AttendTime": "dg0h",
		"./Attendance/AttendTime.js": "dg0h",
		"./Attendance/Attendance": "gjj1",
		"./Attendance/Attendance.js": "gjj1",
		"./Attendance/AttendanceLessonTime": "4Kje",
		"./Attendance/AttendanceLessonTime.js": "4Kje",
		"./Attendance/AttendanceStatus": "zeU0",
		"./Attendance/AttendanceStatus.js": "zeU0",
		"./Attendance/attendance.scss": "sfhh",
		"./Attendance/ducks": "vw3Y",
		"./Attendance/ducks.js": "vw3Y",
		"./Attendance/index": "2Mtk",
		"./Attendance/index.js": "2Mtk",
		"./Attendance/locale": "wqLs",
		"./Attendance/locale.js": "wqLs",
		"./DefaultTab": "Avda",
		"./DefaultTab.js": "Avda",
		"./Teacher.scss": "zMdR",
		"./TeacherTable/TeacherNameTd": "4OTs",
		"./TeacherTable/TeacherNameTd.js": "4OTs",
		"./TeacherTable/TeacherStatusTd": "KpAq",
		"./TeacherTable/TeacherStatusTd.js": "KpAq",
		"./TeacherTable/TeacherTable.scss": "2rzK",
		"./TeacherTable/index": "+FMu",
		"./TeacherTable/index.js": "+FMu",
		"./constant": "wCrB",
		"./constant.js": "wCrB",
		"./ducks": "yDaX",
		"./ducks.js": "yDaX",
		"./images/teacher@2x.png": "iITC",
		"./images/teacher_en@2x.png": "hvBK",
		"./index": "BTGU",
		"./index.js": "BTGU",
		"./locale": "+Qis",
		"./locale.js": "+Qis",
		"./table-settings": "dwer",
		"./table-settings.js": "dwer"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 19;


/***/ },

/***/ "zMdR":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"teacher-container":"teacher-container","Select--single":"Select--single","react-tabs__tab-list":"react-tabs__tab-list","sort-by":"sort-by","sort-by-label":"sort-by-label","createBtn":"createBtn"};

/***/ },

/***/ "4OTs":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TeacherInfo = __webpack_require__("fPvc");
	
	var _TeacherInfo2 = _interopRequireDefault(_TeacherInfo);
	
	var _Teacher = __webpack_require__("xSer");
	
	var _Teacher2 = _interopRequireDefault(_Teacher);
	
	var _Photo = __webpack_require__("7PAg");
	
	var _Photo2 = _interopRequireDefault(_Photo);
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MALE_USER_PORTRAIT = __webpack_require__("njhv");
	var FEMALE_USER_PORTRAIT = __webpack_require__("iEF/");
	var NEUTRAL_IMG = __webpack_require__("bReY");
	
	var TeacherNameTd = function (_Component) {
	  _inherits(TeacherNameTd, _Component);
	
	  function TeacherNameTd(props) {
	    _classCallCheck(this, TeacherNameTd);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  TeacherNameTd.prototype.viewPhoto = function viewPhoto(image) {
	    if (!image) {
	      return;
	    }
	
	    (0, _Photo2.default)({ photo: image });
	  };
	
	  TeacherNameTd.prototype.render = function render() {
	    var _this2 = this;
	
	    var teacher = this.props.teacher;
	    var id = teacher.id,
	        tName = teacher.tName;
	
	    // 0 = male, 1 = female
	
	    var hasPhoto = teacher.profile_photo_thumbnail_8x != '';
	    var image = void 0;
	    if (teacher.profile_photo_thumbnail_2x) {
	      image = 'url(' + teacher.profile_photo_thumbnail_2x + ')';
	    } else {
	      if (teacher.tGender == 0) {
	        image = 'url(' + MALE_USER_PORTRAIT + ')';
	      } else if (teacher.tGender == 1) {
	        image = 'url(' + FEMALE_USER_PORTRAIT + ')';
	      } else {
	        image = 'url(' + NEUTRAL_IMG + ')';
	      }
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: 'teacher-name' },
	      _react2.default.createElement('div', { className: (0, _classnames2.default)("portrait", { hasPhoto: hasPhoto }), style: {
	          backgroundImage: image
	        }, onClick: function onClick() {
	          if (hasPhoto) {
	            _this2.viewPhoto(teacher.profile_photo_thumbnail_8x);
	          }
	        } }),
	      _react2.default.createElement(
	        _R2.default,
	        { can: 'read_teacher_detail', by: 'disable' },
	        _react2.default.createElement(
	          'button',
	          { className: 'btn-link', onClick: function onClick() {
	              (0, _TeacherInfo2.default)({ id: id, name: tName });
	            } },
	          teacher.tName
	        )
	      )
	    );
	  };
	
	  return TeacherNameTd;
	}(_react.Component);
	
	exports.default = TeacherNameTd;
	module.exports = exports['default'];

/***/ },

/***/ "KpAq":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STATUS = [__('Created', 'teacher'), __('Invited', 'teacher'), __('Confirm', 'teacher'), __('Declined', 'teacher')];
	
	var STATUS_CLASS = ['created', 'invited', 'confirm', 'declined'];
	
	var TeacherStatusTd = function (_Component) {
	  _inherits(TeacherStatusTd, _Component);
	
	  function TeacherStatusTd(props) {
	    _classCallCheck(this, TeacherStatusTd);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  TeacherStatusTd.prototype.render = function render() {
	    var teacher = this.props.teacher;
	
	
	    var status = STATUS[teacher.stState];
	    var classname = STATUS_CLASS[teacher.stState];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'teacher-name' },
	      _react2.default.createElement(
	        'div',
	        { className: 'text-center ' + 'teacher-invite-status ' + classname },
	        status
	      )
	    );
	  };
	
	  return TeacherStatusTd;
	}(_react.Component);
	
	exports.default = TeacherStatusTd;
	module.exports = exports['default'];

/***/ },

/***/ "2rzK":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"portrait":"portrait","hasPhoto":"hasPhoto","teacher-invite-status":"teacher-invite-status","created":"created","invited":"invited","confirm":"confirm","declined":"declined"};

/***/ },

/***/ "+FMu":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _UI = __webpack_require__("OM1Z");
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _TeacherNameTd = __webpack_require__("4OTs");
	
	var _TeacherNameTd2 = _interopRequireDefault(_TeacherNameTd);
	
	var _TeacherStatusTd = __webpack_require__("KpAq");
	
	var _TeacherStatusTd2 = _interopRequireDefault(_TeacherStatusTd);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	var _archiveTeacher = __webpack_require__("ug+x");
	
	var _archiveTeacher2 = _interopRequireDefault(_archiveTeacher);
	
	var _inviteTeacher = __webpack_require__("vkEA");
	
	var _inviteTeacher2 = _interopRequireDefault(_inviteTeacher);
	
	var _ducks = __webpack_require__("yDaX");
	
	__webpack_require__("2rzK");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CONTROLLER_WIDTH = '170px';
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var TeacherTable = function (_Component) {
	  _inherits(TeacherTable, _Component);
	
	  function TeacherTable(props) {
	    _classCallCheck(this, TeacherTable);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  TeacherTable.prototype.render = function render() {
	    var _props = this.props,
	        tableData = _props.tableData,
	        settings = _props.settings,
	        pagination = _props.pagination,
	        onItemsCountPerPageChange = _props.onItemsCountPerPageChange,
	        onPageChange = _props.onPageChange;
	
	
	    var fields = [{
	      name: 'tName',
	      title: __('Teacher Name', 'teacher'),
	      getTdProps: function getTdProps(_ref) {
	        var tbodyData = _ref.tbodyData;
	
	        return {
	          className: "student-info",
	          style: {
	            width: "20%"
	          }
	        };
	      },
	      getTdContent: function getTdContent(_ref2) {
	        var teacher = _ref2.trData;
	
	        return _react2.default.createElement(_TeacherNameTd2.default, { teacher: teacher });
	      }
	    }, {
	      name: 'tPhone',
	      title: __('Phone Number', 'teacher'),
	      getTdProps: function getTdProps(_ref3) {
	        var tbodyData = _ref3.tbodyData;
	
	        return {
	          style: {
	            width: "15%"
	          }
	        };
	      }
	
	    }, {
	      name: 'tEmail',
	      title: __('Email', 'createstudent'),
	      getTdProps: function getTdProps(_ref4) {
	        var tbodyData = _ref4.tbodyData;
	
	        return {
	          style: {
	            width: "20%"
	          }
	        };
	      }
	    }, {
	      name: 'taughttimes',
	      title: __('Lessons Taught Count', 'teacher'),
	      getTdProps: function getTdProps(_ref5) {
	        var tbodyData = _ref5.tbodyData;
	
	        return {
	          style: {
	            width: "10%"
	          }
	        };
	      }
	    }, {
	      name: 'taughthours',
	      title: __('Lessons Taught Hours', 'teacher'),
	      getTdProps: function getTdProps(_ref6) {
	        var tbodyData = _ref6.tbodyData;
	
	        return {
	          style: {
	            width: "10%"
	          }
	        };
	      }
	    }, {
	      name: 'stState',
	      title: __('Status', 'class'),
	      getTdContent: function getTdContent(_ref7) {
	        var teacher = _ref7.trData;
	
	        return _react2.default.createElement(_TeacherStatusTd2.default, { teacher: teacher });
	      },
	      getTdProps: function getTdProps(_ref8) {
	        var tbodyData = _ref8.tbodyData;
	
	        return {
	          style: {
	            width: "12%"
	          }
	        };
	      }
	    }];
	
	    return _react2.default.createElement(_UI.Table, {
	      data: tableData,
	      fields: fields,
	      className: 'teacher-table',
	      settingThTitle: __('Settings', 'class', null, true),
	      settingWidth: CONTROLLER_WIDTH,
	      settings: settings,
	      useMultiSelection: false,
	      oneSettingPerRow: false,
	
	      dropdownGuideWidth: 160,
	      dropdownGuideHeight: 228,
	
	      usePagination: true,
	      pagination: pagination,
	      onPageChange: onPageChange,
	      onItemsCountPerPageChange: onItemsCountPerPageChange
	    });
	  };
	
	  return TeacherTable;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(TeacherTable);
	module.exports = exports['default'];

/***/ },

/***/ "ug+x":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = archiveTeacher;
	
	var _config = __webpack_require__("hxne");
	
	var _updateTeacher = __webpack_require__("6VVj");
	
	var _updateTeacher2 = _interopRequireDefault(_updateTeacher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function archiveTeacher(teacherId) {
	
	  if (!teacherId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing teacher Id (number)')
	      });
	    });
	  }
	
	  return (0, _updateTeacher2.default)(teacherId, { archived: true });
	}
	module.exports = exports["default"];

/***/ },

/***/ "vkEA":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = inviteTeacher;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _queryString = __webpack_require__("OAwv");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _joiBrowser = __webpack_require__("+iOt");
	
	var _joiBrowser2 = _interopRequireDefault(_joiBrowser);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function inviteTeacher(teacherId) {
	
	  if (!teacherId) {
	    throw 'Missing teacher ID';
	  }
	
	  return new Promise(function (resolve, reject) {
	    _axios2.default.put(_config.APIAddress, { 'uri': '/invite_tch/' + teacherId + '/',
	      'method': 'GET',
	      'token': localStorage.getItem('token') }).then(function (res) {
	      resolve(res.data);
	    }).catch(function (err) {
	      reject(err);
	    });
	  });
	}
	module.exports = exports['default'];

/***/ },

/***/ "iITC":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "teacher@2x.1d305346.png";

/***/ },

/***/ "hvBK":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "teacher_en@2x.70dd0eb8.png";

/***/ },

/***/ "BTGU":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DefaultTab = __webpack_require__("Avda");
	
	var _DefaultTab2 = _interopRequireDefault(_DefaultTab);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _alert = __webpack_require__("BGi1");
	
	var _UI = __webpack_require__("OM1Z");
	
	var _CreateTeacher = __webpack_require__("dZ0O");
	
	var _CreateTeacher2 = _interopRequireDefault(_CreateTeacher);
	
	var _subscription = __webpack_require__("ue3W");
	
	var _R = __webpack_require__("nRUD");
	
	var _R2 = _interopRequireDefault(_R);
	
	var _FilterBy = __webpack_require__("SdD8");
	
	var _FilterBy2 = _interopRequireDefault(_FilterBy);
	
	var _ducks = __webpack_require__("yDaX");
	
	var _locale = __webpack_require__("+Qis");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("zMdR");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FILTERS = ['text:searchKeyword'];
	
	var FILTER_OPTIONS = {
	  'text:searchKeyword': {
	    placeholder: __('Search Teacher', _locale2.default),
	    valueMinLength: 2
	  }
	};
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    gSubscription: state.gSubscription,
	    teacherList: state.teacherList
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchTeacher: function fetchTeacher(opts, state) {
	      return dispatch((0, _ducks.fetchTeacher)(opts, state));
	    },
	    getSubscription: function getSubscription(schoolId) {
	      return dispatch((0, _subscription.getSubscription)(schoolId));
	    }
	  };
	};
	
	var Teacher = function (_Component) {
	  _inherits(Teacher, _Component);
	
	  function Teacher(props) {
	    _classCallCheck(this, Teacher);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      currentTeacherCount: 0,
	      archivedTeacherCount: 0,
	      options: [],
	      selectedOption: '',
	      selectedIndex: 0,
	      orderBy: 0,
	      filterData: {},
	      keyword: ''
	    };
	
	    _this.onFilterChange = _this.onFilterChange.bind(_this);
	    _this.onSelectTab = _this.onSelectTab.bind(_this);
	    _this.addNewTeacher = _this.addNewTeacher.bind(_this);
	    return _this;
	  }
	
	  Teacher.prototype.componentWillMount = function componentWillMount() {
	    // temporary solution to redirect to deleted teacher tab when exit out of teacher attendance
	    if (window.location.search == '?tab=1') {
	      this.setState({ selectedIndex: 1 });
	    }
	  };
	
	  Teacher.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.teacherList) {
	      var _nextProps$teacherLis = nextProps.teacherList,
	          fetching = _nextProps$teacherLis.fetching,
	          teacherState = _nextProps$teacherLis.teacherState,
	          pagination = _nextProps$teacherLis.pagination;
	      var totalItemsCount = pagination.totalItemsCount;
	      // for a breif moment, when fetching is true, the count can be a number
	      // from the previous state
	
	      if (teacherState == 'current' && fetching == false) {
	        this.setState({
	          currentTeacherCount: totalItemsCount
	        });
	      } else if (teacherState == 'archived' && fetching == false) {
	        this.setState({
	          archivedTeacherCount: totalItemsCount
	        });
	      }
	    }
	  };
	
	  Teacher.prototype.onFilterChange = function onFilterChange(_ref) {
	    var _this2 = this;
	
	    var filterData = _ref.filterData;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _state = this.state,
	        selectedIndex = _state.selectedIndex,
	        orderBy = _state.orderBy;
	    var pagination = this.props.teacherList.pagination;
	    var activePage = pagination.activePage,
	        itemsCountPerPage = pagination.itemsCountPerPage;
	
	    var teacherState = selectedIndex == 0 ? 'current' : 'archived';
	
	    this.setState({
	      filterData: filterData,
	      keyword: filterData['searchKeyword']
	    }, function () {
	      _this2.props.fetchTeacher({
	        schoolId: schoolId,
	        amount_per_page: itemsCountPerPage,
	        current_page_number: activePage,
	        order_by: orderBy,
	        keyword: _this2.state.keyword
	      }, teacherState);
	    });
	  };
	
	  Teacher.prototype.addNewTeacher = function addNewTeacher() {
	    var _this3 = this;
	
	    var _state2 = this.state,
	        selectedIndex = _state2.selectedIndex,
	        orderBy = _state2.orderBy;
	
	    var teacherState = selectedIndex == 0 ? 'current' : 'archived';
	    var _props = this.props,
	        teacherList = _props.teacherList,
	        gSubscription = _props.gSubscription,
	        getSubscription = _props.getSubscription;
	    var pagination = teacherList.pagination;
	    var _gSubscription$result = gSubscription.result,
	        is_valid = _gSubscription$result.is_valid,
	        maximum_amount = _gSubscription$result.maximum_amount,
	        existing_amount = _gSubscription$result.existing_amount,
	        saas_version = _gSubscription$result.saas_version;
	    var maximum_teacher = maximum_amount.maximum_teacher;
	    var teacher_amount = existing_amount.teacher_amount;
	    var activePage = pagination.activePage,
	        itemsCountPerPage = pagination.itemsCountPerPage;
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    if (is_valid && (saas_version === 1 || maximum_teacher === null || teacher_amount < maximum_teacher)) {
	      (0, _CreateTeacher2.default)({ mode: 'create' }).then(function () {
	        getSubscription(schoolId);
	        _this3.setState({
	          filterData: _extends({}, _this3.state.filterData, {
	            searchKeyword: ''
	          }),
	          keyword: ''
	        }, function () {
	          _this3.props.fetchTeacher({
	            schoolId: schoolId,
	            amount_per_page: itemsCountPerPage,
	            current_page_number: activePage,
	            order_by: orderBy
	          }, teacherState);
	        });
	      });
	    } else {
	      _alert.alert.message(__('You are about go over the teacher limit, please upgrade to higher subscription plan to add more teachers', 'header'), __('Upgrade Subscription Plan', 'header'));
	    }
	  };
	
	  Teacher.prototype.renderAddTeacherButton = function renderAddTeacherButton() {
	    var _this4 = this;
	
	    return _react2.default.createElement(
	      _R2.default,
	      { can: 'create_teacher', by: 'disable' },
	      _react2.default.createElement(
	        _UI.Button,
	        { bsStyle: 'primary', className: 'pull-right createBtn', onClick: function onClick() {
	            _this4.addNewTeacher();
	          } },
	        __('New Teacher', _locale2.default)
	      )
	    );
	  };
	
	  Teacher.prototype.onSelectTab = function onSelectTab(selectedIndex) {
	    var orderBy = this.state.orderBy;
	
	
	    this.setState({
	      selectedIndex: selectedIndex,
	      orderBy: orderBy,
	      filterData: _extends({}, this.state.filterData, {
	        searchKeyword: ''
	      }),
	      keyword: ''
	    });
	  };
	
	  Teacher.prototype.render = function render() {
	    var _this5 = this;
	
	    var schoolId = localStorage.getItem('schoolId');
	    var _props$teacherList$pa = this.props.teacherList.pagination,
	        activePage = _props$teacherList$pa.activePage,
	        itemsCountPerPage = _props$teacherList$pa.itemsCountPerPage;
	    var _state3 = this.state,
	        currentTeacherCount = _state3.currentTeacherCount,
	        archivedTeacherCount = _state3.archivedTeacherCount,
	        selectedIndex = _state3.selectedIndex,
	        selectedOption = _state3.selectedOption,
	        filterData = _state3.filterData,
	        keyword = _state3.keyword,
	        orderBy = _state3.orderBy;
	
	    var teacherState = selectedIndex == 0 ? 'current' : 'archived';
	
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      { className: 'teacher-container' },
	      _react2.default.createElement(
	        'div',
	        null,
	        __("Teacher List", "teacher")
	      ),
	      _react2.default.createElement(
	        _UI.Tabs,
	        { defaultIndex: selectedIndex, onSelect: this.onSelectTab },
	        _react2.default.createElement(
	          _UI.TabList,
	          null,
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('Current', _locale2.default),
	            currentTeacherCount > 0 && selectedIndex == 0 && _react2.default.createElement(
	              _UI.CountBadge,
	              null,
	              currentTeacherCount
	            )
	          ),
	          _react2.default.createElement(
	            _UI.Tab,
	            null,
	            __('Archived', _locale2.default),
	            archivedTeacherCount > 0 && selectedIndex == 1 && _react2.default.createElement(
	              _UI.CountBadge,
	              null,
	              archivedTeacherCount
	            )
	          ),
	          this.renderAddTeacherButton(),
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-right' },
	            _react2.default.createElement(_FilterBy2.default, {
	              filterData: filterData,
	              filters: FILTERS,
	              options: FILTER_OPTIONS,
	              onChange: this.onFilterChange })
	          ),
	          _react2.default.createElement(
	            'select',
	            { className: 'form-control sort-by pull-right', value: orderBy, disabled: selectedOption, onChange: function onChange(e) {
	                _this5.setState({ orderBy: e.target.value }, function () {
	                  _this5.props.fetchTeacher({
	                    schoolId: schoolId,
	                    amount_per_page: itemsCountPerPage,
	                    current_page_number: activePage,
	                    order_by: _this5.state.orderBy,
	                    keyword: keyword
	                  }, teacherState);
	                });
	              } },
	            _react2.default.createElement(
	              'option',
	              { key: '0', value: '0' },
	              __('Creation Time: Newest to Oldest', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'option',
	              { key: '1', value: '1' },
	              __('Creation Time: Oldest to Newest', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'option',
	              { key: '2', value: '2' },
	              __('Name: A-Z', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'option',
	              { key: '3', value: '3' },
	              __('Name: Z-A', _locale2.default)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-right sort-by-label' },
	            __('Sort by', _locale2.default)
	          )
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { teacherState: 'current', orderBy: orderBy, keyword: keyword })
	        ),
	        _react2.default.createElement(
	          _UI.TabPanel,
	          null,
	          _react2.default.createElement(_DefaultTab2.default, { teacherState: 'archived', orderBy: orderBy, keyword: keyword })
	        )
	      )
	    );
	  };
	
	  return Teacher;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Teacher);
	module.exports = exports['default'];

/***/ },

/***/ "+Qis":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'TeacherPage',
	  code: 'CN',
	  text: {
	    'Search Teacher': '搜索老师名称',
	    'Please exit all classes in order to archived teacher': '请您先在班级中退班，才能转为历史老师',
	    'Sort by': '排序',
	    'Creation Time: Newest to Oldest': '按创建时间：由新到旧',
	    'Creation Time: Oldest to Newest': '按创建时间：由旧到新',
	    'Name: A-Z': '按名称：由A到Z',
	    'Name: Z-A': '按名称：由Z到A',
	    'Current': '当期老师',
	    'Archived': '历史老师',
	    'Archive Teacher': '转为历史老师',
	    'Proceed to archive teacher?': '确认要转为历史老师？',
	    'New Teacher': '新增老师'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "dwer":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (teacherState) {
	
	  if (teacherState == 'archived') {
	    return getArchivedTeacherTableSettings.call(this);
	  }
	
	  return getDefaultTableSettings.call(this);
	};
	
	var _reactRouter = __webpack_require__("Zfgq");
	
	var _archiveTeacher = __webpack_require__("ug+x");
	
	var _archiveTeacher2 = _interopRequireDefault(_archiveTeacher);
	
	var _unarchiveTeacher = __webpack_require__("hkdS");
	
	var _unarchiveTeacher2 = _interopRequireDefault(_unarchiveTeacher);
	
	var _inviteTeacher = __webpack_require__("vkEA");
	
	var _inviteTeacher2 = _interopRequireDefault(_inviteTeacher);
	
	var _confirm = __webpack_require__("yMGN");
	
	var _alert = __webpack_require__("BGi1");
	
	var _ducks = __webpack_require__("yDaX");
	
	var _CreateTeacher = __webpack_require__("dZ0O");
	
	var _CreateTeacher2 = _interopRequireDefault(_CreateTeacher);
	
	var _R = __webpack_require__("nRUD");
	
	var _locale = __webpack_require__("+Qis");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDefaultTableSettings() {
	  var _this = this;
	
	  var TabComponent = this;
	  var _props = this.props,
	      dispatch = _props.dispatch,
	      teacherState = _props.teacherState,
	      getSubscription = _props.getSubscription;
	
	  return [{
	    title: __('Invite', 'teacher'),
	    onClick: function onClick(_ref) {
	      var teacher = _ref.trData;
	
	      (0, _confirm.confirm)(__('Send Invitation To Teacher: {tname}?', 'teacher', { tname: teacher.tName })).then(function () {
	        (0, _inviteTeacher2.default)(teacher.id).then(function (result) {
	          if (result.result == 'failure') {
	            _alert.alert.fail(__('Invitation Failure: please enter a valid phone number', 'teacher'));
	          } else {
	            var schoolId = localStorage.getItem('schoolId');
	            _this.props.fetchTeacher({ schoolId: schoolId, amount_per_page: 25, current_page_number: 1 }, teacherState);
	          }
	        });
	      }).catch(function () {});
	    },
	    isDisabled: function isDisabled(_ref2) {
	      var teacher = _ref2.trData;
	
	      return teacher.stState == 2 || !(0, _R.userCan)('invite_teacher');
	    }
	  }, {
	    title: __("Archive Teacher", _locale2.default),
	    onClick: function onClick(_ref3) {
	      var teacher = _ref3.trData;
	
	      (0, _confirm.confirm)(__('Proceed to archive teacher?', _locale2.default), __("Archive Teacher", _locale2.default)).then(function () {
	        (0, _archiveTeacher2.default)(teacher.id).then(function (result) {
	          if (result.status == 'Archive failed') {
	            _alert.alert.fail(__('Please exit all classes in order to archived teacher', _locale2.default));
	          } else {
	            var schoolId = localStorage.getItem('schoolId');
	            getSubscription(schoolId);
	            _this.props.fetchTeacher({ schoolId: schoolId, amount_per_page: 25, current_page_number: 1 }, teacherState);
	          }
	        });
	      }).catch(function () {});
	    },
	    isDisabled: function isDisabled() {
	      return !(0, _R.userCan)('archive_teacher_from_school');
	    }
	  }];
	}
	
	// Specifically used for archived student table
	function getArchivedTeacherTableSettings() {
	  var _this2 = this;
	
	  var TabComponent = this;
	  var _props2 = this.props,
	      dispatch = _props2.dispatch,
	      teacherState = _props2.teacherState,
	      gSubscription = _props2.gSubscription,
	      getSubscription = _props2.getSubscription;
	  var _gSubscription$result = gSubscription.result,
	      is_valid = _gSubscription$result.is_valid,
	      maximum_amount = _gSubscription$result.maximum_amount,
	      existing_amount = _gSubscription$result.existing_amount,
	      saas_version = _gSubscription$result.saas_version;
	  var maximum_teacher = maximum_amount.maximum_teacher;
	  var teacher_amount = existing_amount.teacher_amount;
	
	  return [{
	    title: __('Restore', 'teacher'),
	    onClick: function onClick(_ref4) {
	      var teacher = _ref4.trData;
	
	      (0, _confirm.confirm)(__('Proceed to unarchive teacher?', 'teacher'), __("Restore", "teacher")).then(function () {
	        if (is_valid && (saas_version === 1 || maximum_teacher === null || teacher_amount + 1 <= maximum_teacher)) {
	          (0, _unarchiveTeacher2.default)(teacher.id).then(function (result) {
	            var schoolId = localStorage.getItem('schoolId');
	            getSubscription(schoolId);
	            _this2.props.fetchTeacher({ schoolId: schoolId, amount_per_page: 25, current_page_number: 1 }, teacherState);
	          });
	        } else {
	          _alert.alert.message(__('You are about go over the teacher limit, please upgrade to higher subscription plan to add more teachers', 'header'), __('Upgrade Subscription Plan', 'header'));
	        }
	      }).catch(function () {});
	    },
	    isDisabled: function isDisabled() {
	      return !(0, _R.userCan)('recover_teacher_in_school');
	    }
	  }];
	}
	module.exports = exports['default'];

/***/ },

/***/ "hkdS":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = unarchiveTeacher;
	
	var _config = __webpack_require__("hxne");
	
	var _updateTeacher = __webpack_require__("6VVj");
	
	var _updateTeacher2 = _interopRequireDefault(_updateTeacher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function unarchiveTeacher(teacherId) {
	
	  if (!teacherId) {
	    return new Promise(function (resolve, reject) {
	      reject({
	        error: new Error('Missing teacher Id (number)')
	      });
	    });
	  }
	
	  return (0, _updateTeacher2.default)(teacherId, { archived: false });
	}
	module.exports = exports["default"];

/***/ },

/***/ "xIJ8":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "NlCa":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("kqyU");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("xIJ8");
	
	var _UI = __webpack_require__("OM1Z");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeacherCareer = function (_Component) {
	  _inherits(TeacherCareer, _Component);
	
	  function TeacherCareer(props) {
	    _classCallCheck(this, TeacherCareer);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {};
	
	    return _this;
	  }
	
	  TeacherCareer.prototype.componentDidMount = function componentDidMount() {};
	
	  TeacherCareer.prototype.render = function render() {
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      { className: 'teacher-career-container' },
	      _react2.default.createElement(
	        'div',
	        null,
	        'teacher career'
	      )
	    );
	  };
	
	  return TeacherCareer;
	}(_react.Component);
	
	exports.default = TeacherCareer;
	module.exports = exports['default'];

/***/ },

/***/ "kqyU":
/***/ function(module, exports) {

	"use strict";

/***/ },

/***/ "nDiK":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = [[{ sName: "Ryan", sAge: 35, sGender: 0, className: "现代舞少儿", classTotalFee: 500, settings: "" }, { className: "法语绘画", classTotalFee: 3500 }], [{
		sName: "Billy", sAge: 23, sGender: 0, className: "麻将高手", classTotalFee: 1000, settings: ""
	}, {
		className: "吃饭绝招儿", classTotalFee: 350
	}], [{
		sName: "April", sAge: 22, sGender: 1, className: "韩式料理", classTotalFee: 8500, settings: ""
	}], [{
		sName: "Nick", sAge: 22, sGender: 0, className: "墨西哥舞", classTotalFee: 8500, settings: ""
	}]];
	
	
	var defaultFields = [{ title: "班级名称", name: "a" }, { title: "日期", name: "b" }, { title: "上课进度", name: "c" }, { title: "老师", name: "d" }, { title: "学员", name: "e" }];
	
	var defaultData = [{ a: "狂吃韩国料理", b: "2018 3月15日", c: "15/25", d: "金正恩", e: "352万人" }, { a: "狂吃韩国料理", b: "2018 3月15日", c: "15/25", d: "金正恩", e: "352万人" }, { a: "狂吃韩国料理", b: "2018 3月15日", c: "15/25", d: "金正恩", e: "352万人" }, { a: "狂吃韩国料理", b: "2018 3月15日", c: "15/25", d: "金正恩", e: "352万人" }];
	module.exports = exports["default"];

/***/ },

/***/ "vjG/":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
		title: "Student",
		name: "sName",
		getTdProps: function getTdProps(_ref) {
			var tbodyData = _ref.tbodyData;
	
			return {
				className: "student-info",
				style: {
					width: "20%"
				}
			};
		},
		getTdContent: function getTdContent(_ref2) {
			var student = _ref2.trData;
	
			var maleImg = __webpack_require__("X56S");
			var femaleImg = __webpack_require__("Irbd");
	
			if (!student.sName) {
				return "";
			}
	
			return _react2.default.createElement(
				"div",
				{ className: "student-info-container" },
				_react2.default.createElement("div", { className: "portrait", style: {
						backgroundImage: student.sGender == 0 ? "url(" + maleImg + ")" : "url(" + femaleImg + ")"
					} }),
				_react2.default.createElement(
					"div",
					{ className: "text-container" },
					_react2.default.createElement(
						"div",
						{ className: "name" },
						student.sName
					),
					_react2.default.createElement(
						"small",
						null,
						student.sAge,
						" yrs old"
					)
				)
			);
		}
	}, {
		title: "Class",
		name: "className",
		getTdProps: function getTdProps(_ref3) {
			var tbodyData = _ref3.tbodyData;
	
			return {
				className: "class-info",
				style: {
					width: "20%"
				}
			};
		},
		getTdContent: function getTdContent(_ref4) {
			var student = _ref4.trData;
	
			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(
					"div",
					{ className: "class-info-name" },
					student.className
				),
				_react2.default.createElement(
					"small",
					null,
					"$",
					student.classTotalFee
				)
			);
		}
	}, {
		title: "Class Status",
		name: "classStatus"
	}, {
		title: "Payment",
		name: "paidTotalFee"
	}, {
		title: "Settings",
		name: "settings",
		getTdProps: function getTdProps(_ref5) {
			var tbodyData = _ref5.tbodyData;
	
			return {
				className: "table-controller",
				style: {
					width: "25%"
				}
			};
		},
		getTdContent: function getTdContent(_ref6) {
			var student = _ref6.trData;
	
			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(
					Button,
					{ bsStyle: "link" },
					"\u6863\u6848"
				),
				_react2.default.createElement(
					Button,
					{ bsStyle: "link" },
					"\u6392\u73ED"
				),
				_react2.default.createElement(
					Button,
					{ bsStyle: "link" },
					"\u6536\u8D39"
				),
				_react2.default.createElement(
					Button,
					{ bsStyle: "link" },
					"\u66F4\u591A",
					_react2.default.createElement("i", { className: "fa icon-angle-down dropdown-caret" })
				)
			);
		}
	
	}];
	module.exports = exports["default"];

/***/ },

/***/ "2+Qn":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	var _Modal = __webpack_require__("jXlm");
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PanelWrapper = __webpack_require__("VPji");
	
	var _PanelWrapper2 = _interopRequireDefault(_PanelWrapper);
	
	var _util = __webpack_require__("ZoQJ");
	
	var _UI = __webpack_require__("OM1Z");
	
	__webpack_require__("A9k/");
	
	var _Loading = __webpack_require__("0D4V");
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UIExamples = function (_React$Component) {
		_inherits(UIExamples, _React$Component);
	
		function UIExamples(props) {
			_classCallCheck(this, UIExamples);
	
			return _possibleConstructorReturn(this, _React$Component.call(this, props));
		}
	
		UIExamples.prototype.componentDidMount = function componentDidMount() {};
	
		UIExamples.prototype.render = function render() {
			var fields = [{
				title: "Student",
				name: "sName",
				getTdProps: function getTdProps(_ref) {
					var tbodyData = _ref.tbodyData;
	
					return {
						className: "student-info",
						style: {
							width: "20%"
						}
					};
				},
				getTdContent: function getTdContent(_ref2) {
					var student = _ref2.trData;
	
					var maleImg = __webpack_require__("X56S");
					var femaleImg = __webpack_require__("Irbd");
	
					if (!student.sName) {
						return "";
					}
	
					return _react2.default.createElement(
						'div',
						{ className: 'student-info-container' },
						_react2.default.createElement('div', { className: 'portrait', style: {
								backgroundImage: student.sGender == 0 ? 'url(' + maleImg + ')' : 'url(' + femaleImg + ')'
							} }),
						_react2.default.createElement(
							'div',
							{ className: 'text-container' },
							_react2.default.createElement(
								'div',
								{ className: 'name' },
								student.sName
							),
							_react2.default.createElement(
								'small',
								null,
								student.sAge,
								' yrs old'
							)
						)
					);
				}
			}, {
				title: "Class",
				name: "className",
				getTdProps: function getTdProps(_ref3) {
					var tbodyData = _ref3.tbodyData;
	
					return {
						className: "class-info",
						style: {
							width: "20%"
						}
					};
				},
				getTdContent: function getTdContent(_ref4) {
					var student = _ref4.trData;
	
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'class-info-name' },
							student.className
						),
						_react2.default.createElement(
							'small',
							null,
							'$',
							student.classTotalFee
						)
					);
				}
			}, {
				title: "Class Status",
				name: "classStatus"
			}, {
				title: "Payment",
				name: "paidTotalFee"
			}, {
				title: "Settings",
				name: "settings",
				getTdProps: function getTdProps(_ref5) {
					var tbodyData = _ref5.tbodyData;
	
					return {
						className: "table-setting",
						style: {
							width: "25%"
						}
					};
				},
				getTdContent: function getTdContent(_ref6) {
					var student = _ref6.trData;
	
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_UI.Button,
							{ bsStyle: 'link' },
							'\u6863\u6848'
						),
						_react2.default.createElement(
							_UI.Button,
							{ bsStyle: 'link' },
							'\u6392\u73ED'
						),
						_react2.default.createElement(
							_UI.Button,
							{ bsStyle: 'link' },
							'\u6536\u8D39'
						),
						_react2.default.createElement(
							_UI.Button,
							{ bsStyle: 'link' },
							'\u66F4\u591A',
							_react2.default.createElement('i', { className: 'fa icon-angle-down dropdown-caret' })
						)
					);
				}
	
			}];
	
			var data = [[{ sName: "Ryan", sAge: 35, sGender: 0, className: "现代舞少儿", classTotalFee: 500, settings: "" }, { className: "法语绘画", classTotalFee: 3500 }], [{
				sName: "Billy", sAge: 23, sGender: 0, className: "麻将高手", classTotalFee: 1000, settings: ""
			}, {
				className: "吃饭绝招儿", classTotalFee: 350
			}], [{
				sName: "April", sAge: 22, sGender: 1, className: "韩式料理", classTotalFee: 8500, settings: ""
			}], [{
				sName: "Nick", sAge: 22, sGender: 0, className: "墨西哥舞", classTotalFee: 8500, settings: ""
			}]];
	
			var defaultFields = [{ title: "班级名称", name: "a" }, { title: "日期", name: "b" }, { title: "上课进度", name: "c" }, { title: "老师", name: "d" }, { title: "学员", name: "e" }];
	
			var defaultData = [{ a: "狂吃韩国料理", b: "2018 3月15日", c: "15/25", d: "金正恩", e: "352万人" }, { a: "狂吃韩国料理", b: "2018 3月15日", c: "15/25", d: "金正恩", e: "352万人" }, { a: "狂吃韩国料理", b: "2018 3月15日", c: "15/25", d: "金正恩", e: "352万人" }, { a: "狂吃韩国料理", b: "2018 3月15日", c: "15/25", d: "金正恩", e: "352万人" }];
	
			return _react2.default.createElement(
				_PanelWrapper2.default,
				null,
				_react2.default.createElement(
					'h1',
					null,
					'Native UI Components'
				),
				_react2.default.createElement(
					'div',
					{ style: { height: 300 } },
					_react2.default.createElement(_Loading2.default, null)
				),
				_react2.default.createElement(
					_Modal2.default,
					{
						isShowingModal: false,
						hasFooter: true // flase to hide
						, hasHeader: true // false to hide 
	
						, headerType: 'bold',
						headerTitle: '\u5347\u7EA7\u9AD8\u7EA7\u7248',
						headerIcon: 'fa icon-credit-card',
	
						footerType: 'bold',
						footerButtons: [{
							title: "升级高级版",
							className: "btn btn-primary pull-right",
							onClick: function onClick() {}
						}]
					},
					_react2.default.createElement(
						'div',
						{ style: { textAlign: "center", fontSize: 18, color: "#A0A4A5" } },
						'\u60A8\u76EE\u524D\u7684\u5728\u804C\u8001\u5E08\u4E0A\u9650\u4E3A20\u4EBA\uFF0C\u6DFB\u52A0\u66F4\u591A\u8001\u5E08\u8BF7\u5347\u7EA7\u4E3A\u9AD8\u7EA7\u7248'
					)
				),
				_react2.default.createElement(_UI.Table, {
					fields: fields,
					data: data,
					className: 'student-table',
					useTbodyAsRow: true,
					useMultiSelection: true,
					usePagination: false,
					onTrSelectionToggled: function onTrSelectionToggled(params) {}
				}),
				_react2.default.createElement(_UI.Table, {
					fields: defaultFields,
					data: defaultData,
					useMultiSelection: true,
					usePagination: false,
					settingWidth: 225,
					settings: [{ title: "加入班级", onClick: function onClick(opts) {} }, { title: "签到", onClick: function onClick(opts) {} }, { title: "更多", id: "table1-modify", onClick: function onClick(opts) {}, dropdown: [{ title: "修改", onClick: function onClick(opts) {} }, { title: "归档", onClick: function onClick(opts) {} }] }],
					onTrSelectionToggled: function onTrSelectionToggled(params) {}
				}),
				_react2.default.createElement(
					'h3',
					null,
					'Alerts'
				),
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_UI.Button,
						{ bsStyle: 'warning', onClick: function onClick() {
								_util.alert.warning("", "请输入电话号码", { okButtonTitle: "好的" });
							} },
						'warning'
					),
					_react2.default.createElement(
						_UI.Button,
						{ bsStyle: 'primary', onClick: function onClick() {
								_util.alert.message("您目前的在读学员上限为50人，添加更多学员请升级为高级版", "升级高级版", { okButtonTitle: "升级高级版" });
							} },
						'message'
					),
					_react2.default.createElement(
						_UI.Button,
						{ bsStyle: 'success', onClick: function onClick() {
								_util.alert.success("高级版本为您开放了更多的功能，赶快去体验吧！", "升级成功", { okButtonTitle: "好的" });
							} },
						'success'
					),
					_react2.default.createElement(
						_UI.Button,
						{ bsStyle: 'danger', onClick: function onClick() {
								_util.alert.fail("无法链接服务器", "登录失败", { okButtonTitle: "好的" });
							} },
						'fail'
					),
					_react2.default.createElement(
						_UI.Button,
						{ bsStyle: 'default', onClick: function onClick() {
								_util.alert.error("", "无法链接服务器", { okButtonTitle: "好的" });
							} },
						'error'
					)
				),
				_react2.default.createElement(
					'h1',
					null,
					'Bootstrap UI components'
				),
				_react2.default.createElement(
					'p',
					null,
					'We put these components just to check out their looks. For detailed documentation, please visit ',
					_react2.default.createElement(
						'a',
						{ href: 'https://react-bootstrap.github.io/components.html', target: '_blank' },
						'react-boostrap documentation.'
					)
				),
				_react2.default.createElement(
					'h3',
					null,
					'Buttons'
				),
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_UI.Button,
						{ bsStyle: 'primary' },
						'primary'
					),
					_react2.default.createElement(
						_UI.Button,
						{ bsStyle: 'default' },
						'default'
					),
					_react2.default.createElement(
						_UI.Button,
						{ bsStyle: 'success' },
						'success'
					),
					_react2.default.createElement(
						_UI.Button,
						{ bsStyle: 'info' },
						'info'
					),
					_react2.default.createElement(
						_UI.Button,
						{ bsStyle: 'warning' },
						'warning'
					)
				),
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'h3',
						null,
						'DropdownButtons'
					),
					_react2.default.createElement(
						_UI.DropdownButton,
						{ bsStyle: 'default', title: __("Change Language", "header", null, true), id: 'demo-dropdown' },
						_react2.default.createElement(
							_UI.MenuItem,
							{ eventKey: '1' },
							'English'
						),
						_react2.default.createElement(_UI.MenuItem, { divider: true }),
						_react2.default.createElement(
							_UI.MenuItem,
							{ eventKey: '1' },
							'\u7B80\u4F53\u4E2D\u6587'
						),
						_react2.default.createElement(
							_UI.MenuItem,
							{ eventKey: '2' },
							'\uD55C\uAD6D\uC5B4'
						)
					),
					_react2.default.createElement(
						_UI.DropdownButton,
						{ bsStyle: 'default', className: 'btn-language', noCaret: true, title: __("Change Language", "header", null, true), id: 'demo-dropdown' },
						_react2.default.createElement(
							_UI.MenuItem,
							{ eventKey: '1' },
							'English'
						),
						_react2.default.createElement(_UI.MenuItem, { divider: true }),
						_react2.default.createElement(
							_UI.MenuItem,
							{ eventKey: '1' },
							'\u7B80\u4F53\u4E2D\u6587'
						),
						_react2.default.createElement(
							_UI.MenuItem,
							{ eventKey: '2' },
							'\uD55C\uAD6D\uC5B4'
						)
					)
				)
			);
		};
	
		return UIExamples;
	}(_react2.default.Component);
	
	exports.default = UIExamples;
	module.exports = exports['default'];

/***/ },

/***/ "P1vu":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Upgrade--content":"Upgrade--content","Upgrade--content--section":"Upgrade--content--section","align-right":"align-right","Panel":"Panel"};

/***/ },

/***/ "mwYU":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "community.96205780.jpg";

/***/ },

/***/ "xZ00":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "handshake.0b665a7d.jpg";

/***/ },

/***/ "KV/b":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("4n+p");
	
	__webpack_require__("P1vu");
	
	var _handshake = __webpack_require__("xZ00");
	
	var _handshake2 = _interopRequireDefault(_handshake);
	
	var _community = __webpack_require__("mwYU");
	
	var _community2 = _interopRequireDefault(_community);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Upgrade 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is ...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - When there is a nesting tr, we use tbody as a row.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @redux
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var Upgrade = function (_React$Component) {
	  _inherits(Upgrade, _React$Component);
	
	  function Upgrade(props) {
	    _classCallCheck(this, Upgrade);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Upgrade.prototype.componentWillMount = function componentWillMount() {};
	
	  Upgrade.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'Upgrade' },
	      _react2.default.createElement(
	        'div',
	        { className: 'Upgrade--content' },
	        _react2.default.createElement('div', { className: 'Upgrade--content--section', style: { backgroundImage: 'url(' + _handshake2.default + ')' } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'Upgrade--content--section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'Panel' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Secure Payment Area'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Pellentesque egestas, neque sit amet convallis pulvinar, justo nulla eleifend augue, ac auctor orci leo non est. Sed hendrerit. Vivamus quis mi. Nam adipiscing. Maecenas vestibulum mollis diam.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'Upgrade--content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Upgrade--content--section align-right' },
	          _react2.default.createElement(
	            'div',
	            { className: 'Panel' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              '\u6CA1\u6709ClasstopBase\u5C31\u522B\u60F3\u5F00\u5B66\u6821\u4E86\u3002',
	              _react2.default.createElement('br', null),
	              '\u5DF2\u7ECF\u6709\u5B66\u6821\u4E86\uFF1F',
	              _react2.default.createElement('br', null),
	              '\u5173\u4E86\u5F97\u4E86\u3002'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Pellentesque egestas, neque sit amet convallis pulvinar, justo nulla eleifend augue, ac auctor orci leo non est. Sed hendrerit. Vivamus quis mi. Nam adipiscing. Maecenas vestibulum mollis diam.'
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'Upgrade--content--section', style: { backgroundImage: 'url(' + _community2.default + ')' } })
	      )
	    );
	  };
	
	  return Upgrade;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Upgrade);
	module.exports = exports['default'];

/***/ },

/***/ "FE8H":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "AUQq":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__("Dqj5");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("FE8H");
	
	var _UI = __webpack_require__("OM1Z");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WaitingList = function (_Component) {
	  _inherits(WaitingList, _Component);
	
	  function WaitingList(props) {
	    _classCallCheck(this, WaitingList);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {};
	
	    return _this;
	  }
	
	  WaitingList.prototype.componentDidMount = function componentDidMount() {};
	
	  WaitingList.prototype.render = function render() {
	    return _react2.default.createElement(
	      _UI.PanelWrapper,
	      { className: 'waiting-list-container' },
	      _react2.default.createElement(
	        'div',
	        null,
	        'waiting list'
	      )
	    );
	  };
	
	  return WaitingList;
	}(_react.Component);
	
	exports.default = WaitingList;
	module.exports = exports['default'];

/***/ },

/***/ "Dqj5":
/***/ function(module, exports) {

	"use strict";

/***/ },

/***/ "IMk+":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"AddComponent":"AddComponent","isEdit":"isEdit","AddComponent--content":"AddComponent--content","AddComponent--formWrapper":"AddComponent--formWrapper","btn-wrapper":"btn-wrapper"};

/***/ },

/***/ "WHlH":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("IMk+");
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _locale = __webpack_require__("eYxN");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <AddComponent 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var AddComponent = function (_React$Component) {
	  _inherits(AddComponent, _React$Component);
	
	  function AddComponent(props) {
	    _classCallCheck(this, AddComponent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.addToPage = _this.addToPage.bind(_this);
	    return _this;
	  }
	
	  AddComponent.prototype.componentWillMount = function componentWillMount() {};
	
	  AddComponent.prototype.addToPage = function addToPage(item) {
	    var _this2 = this;
	
	    return function () {
	      _this2.props.onSubmit(item);
	    };
	  };
	
	  AddComponent.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        isEdit = _props.isEdit,
	        onCloseEditor = _props.onCloseEditor,
	        _props$componentFormS = _props.componentFormSchemas,
	        componentFormSchemas = _props$componentFormS === undefined ? {} : _props$componentFormS;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('AddComponent', { isEdit: isEdit }) },
	      _react2.default.createElement(
	        'div',
	        { className: 'AddComponent--content', ref: function ref(r) {
	            _this3.scrollingContainerRef = r;
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'ComponentEditor--formWrapper' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            Object.keys(componentFormSchemas).map(function (name, index) {
	              var item = componentFormSchemas[name];
	              return _react2.default.createElement(
	                'li',
	                { key: index },
	                item.label,
	                ' ',
	                _react2.default.createElement('i', { className: 'fa icon-plus add-to-page', onClick: _this3.addToPage(item) })
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: onCloseEditor, className: 'btn btn-default' },
	            __('Cancel', _locale2.default)
	          )
	        )
	      )
	    );
	  };
	
	  return AddComponent;
	}(_react2.default.Component);
	
	exports.default = AddComponent;
	module.exports = exports['default'];

/***/ },

/***/ "eYxN":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'AddComponent',
	  code: 'CN',
	  text: {}
	};
	module.exports = exports['default'];

/***/ },

/***/ "pPi2":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ComponentEditor":"ComponentEditor","isEdit":"isEdit","ComponentEditor--content":"ComponentEditor--content","ComponentEditor--formWrapper":"ComponentEditor--formWrapper","btn-wrapper":"btn-wrapper"};

/***/ },

/***/ "pxxT":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("pPi2");
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _locale = __webpack_require__("O9nS");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ComponentEditor 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ComponentEditor = function (_React$Component) {
	  _inherits(ComponentEditor, _React$Component);
	
	  function ComponentEditor(props) {
	    _classCallCheck(this, ComponentEditor);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ComponentEditor.prototype.componentWillMount = function componentWillMount() {};
	
	  ComponentEditor.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        _props$editFormSchema = _props.editFormSchema,
	        editFormSchema = _props$editFormSchema === undefined ? {} : _props$editFormSchema,
	        editFormData = _props.editFormData,
	        isEdit = _props.isEdit,
	        onComponentChange = _props.onComponentChange,
	        getValidationRef = _props.getValidationRef,
	        onSubmit = _props.onSubmit,
	        onCloseEditor = _props.onCloseEditor;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('ComponentEditor', { isEdit: isEdit }) },
	      _react2.default.createElement(
	        'div',
	        { className: 'ComponentEditor--content', ref: function ref(r) {
	            _this2.scrollingContainerRef = r;
	          } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          editFormSchema.label
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ComponentEditor--formWrapper' },
	          _react2.default.createElement(_Form2.default, {
	            onChange: onComponentChange,
	            schema: editFormSchema.fields || [],
	            formData: editFormData,
	            formStyle: 'outline',
	            getValidationRef: getValidationRef,
	            scrollingContainerRef: this.scrollingContainerRef
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'btn-wrapper' },
	            _react2.default.createElement(
	              'button',
	              { onClick: onCloseEditor, className: 'btn btn-default' },
	              __('Cancel', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'button',
	              { onClick: onSubmit, className: 'btn btn-primary' },
	              __('Submit', _locale2.default)
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ComponentEditor;
	}(_react2.default.Component);
	
	exports.default = ComponentEditor;
	module.exports = exports['default'];

/***/ },

/***/ "O9nS":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'ComponentEditor',
	  code: 'CN',
	  text: {}
	};
	module.exports = exports['default'];

/***/ },

/***/ "lGU1":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"EditPageOnSideMenu--menu":"EditPageOnSideMenu--menu","addPage":"addPage","EditPageOnSideMenu--pageList":"EditPageOnSideMenu--pageList","activePages":"activePages","EditPageOnSideMenu--page":"EditPageOnSideMenu--page","content":"content","editPage":"editPage","viewPage":"viewPage","active":"active"};

/***/ },

/***/ "y9jc":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _locale = __webpack_require__("ro1o");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("lGU1");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <EditPageOnSideMenu 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var EditPageOnSideMenu = function (_React$Component) {
	  _inherits(EditPageOnSideMenu, _React$Component);
	
	  function EditPageOnSideMenu(props) {
	    _classCallCheck(this, EditPageOnSideMenu);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.addPage = _this.addPage.bind(_this);
	    _this.editPage = _this.editPage.bind(_this);
	    _this.onCurrentPageChange = _this.onCurrentPageChange.bind(_this);
	    return _this;
	  }
	
	  EditPageOnSideMenu.prototype.componentWillMount = function componentWillMount() {};
	
	  EditPageOnSideMenu.prototype.addPage = function addPage() {
	    this.props.onStartEdit({
	      title: ''
	    });
	  };
	
	  EditPageOnSideMenu.prototype.onCurrentPageChange = function onCurrentPageChange(page) {
	    var _this2 = this;
	
	    return function () {
	      if (page && page.page_setting && typeof page.page_setting.slug !== "undefined") {
	        _this2.props.onChange(page.page_setting.slug);
	      }
	    };
	  };
	
	  EditPageOnSideMenu.prototype.editPage = function editPage(page) {
	    var _this3 = this;
	
	    return function () {
	      _this3.props.onStartEdit(page);
	    };
	  };
	
	  EditPageOnSideMenu.prototype.render = function render() {
	    var _this4 = this,
	        _React$createElement2;
	
	    var _props = this.props,
	        _props$pages = _props.pages,
	        pages = _props$pages === undefined ? [] : _props$pages,
	        _props$page = _props.page,
	        page = _props$page === undefined ? {} : _props$page,
	        site = _props.site;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'EditPageOnSideMenu' },
	      _react2.default.createElement(
	        'div',
	        { className: 'EditPageOnSideMenu--menu' },
	        _react2.default.createElement(
	          'span',
	          null,
	          __('Active Pages', _locale2.default)
	        ),
	        _react2.default.createElement('i', { className: 'fa icon-plus addPage', onClick: this.addPage })
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'EditPageOnSideMenu--pageList activePages' },
	        Object.keys(pages).map(function (key, index) {
	          var _React$createElement;
	
	          var thisPage = pages[key];
	          var title = thisPage.title,
	              id = thisPage.id;
	
	
	          var active = id == page.id ? 'active' : '';
	
	          return _react2.default.createElement(
	            'li',
	            { className: (0, _classnames2.default)('EditPageOnSideMenu--page', { active: active }), key: index, onClick: _this4.onCurrentPageChange(thisPage) },
	            _react2.default.createElement(
	              'div',
	              { className: 'content' },
	              title,
	              _react2.default.createElement('i', (_React$createElement = { className: 'fa icon-cog editPage', onClick: _this4.addPage }, _React$createElement['onClick'] = _this4.editPage(thisPage), _React$createElement))
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'EditPageOnSideMenu--menu' },
	        _react2.default.createElement(
	          'span',
	          null,
	          __('Inactive Pages', _locale2.default)
	        ),
	        _react2.default.createElement('i', (_React$createElement2 = { className: 'fa icon-plus addPage', onClick: this.addPage }, _React$createElement2['onClick'] = this.addPage, _React$createElement2))
	      ),
	      _react2.default.createElement('ul', { className: 'EditPageOnSideMenu--pageList' })
	    );
	  };
	
	  return EditPageOnSideMenu;
	}(_react2.default.Component);
	
	exports.default = EditPageOnSideMenu;
	module.exports = exports['default'];

/***/ },

/***/ "ro1o":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'WebsiteEditPage',
	  code: 'CN',
	  text: {
	    'Active Pages': '在线页面',
	    'Inactive Pages': '下线页面',
	    'Home Page': '主页'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "H94+":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"NavSetting":"NavSetting","btn-wrapper":"btn-wrapper","NavSetting--content":"NavSetting--content"};

/***/ },

/***/ "CUBd":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _locale = __webpack_require__("aEdv");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("H94+");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <NavSetting 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var NavSetting = function (_React$Component) {
	  _inherits(NavSetting, _React$Component);
	
	  function NavSetting(props) {
	    _classCallCheck(this, NavSetting);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.getValidationRef = _this.getValidationRef.bind(_this);
	
	    _this.state = {
	      site: {}
	    };
	
	    return _this;
	  }
	
	  NavSetting.prototype.componentWillMount = function componentWillMount() {};
	
	  NavSetting.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (props.site) {
	      this.setState({
	        site: props.site
	      });
	    }
	  };
	
	  NavSetting.prototype.getValidationRef = function getValidationRef(validateFn) {
	    this.validateFn = validateFn;
	  };
	
	  NavSetting.prototype.onChange = function onChange(nav) {
	    this.setState({
	      site: _extends({}, this.state.site, {
	        nav: nav
	      })
	    });
	  };
	
	  NavSetting.prototype.onSubmit = function onSubmit() {
	    this.props.onSubmit(this.state.site);
	  };
	
	  NavSetting.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        onClose = _props.onClose,
	        onSubmit = _props.onSubmit,
	        selectOptionForPages = _props.selectOptionForPages;
	    var site = this.state.site;
	
	
	    this.schema = [{
	      label: __('Header Navigation', _locale2.default),
	      name: "header",
	      type: "objectArray",
	      required: false,
	      max: 10,
	      objectSchema: [{
	        name: 'pageId',
	        label: __('Page', _locale2.default),
	        type: 'select',
	        options: selectOptionForPages
	      }]
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'NavSetting' },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('NavSetting--content'), ref: function ref(r) {
	            _this2.scrollingContainerRef = r;
	          } },
	        _react2.default.createElement(_Form2.default, {
	          onChange: this.onChange,
	          schema: this.schema,
	          formData: site.nav || {},
	          formStyle: 'outline',
	          getValidationRef: this.getValidationRef,
	          scrollingContainerRef: this.scrollingContainerRef
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'btn-wrapper' },
	        _react2.default.createElement(
	          'button',
	          { onClick: onClose, className: 'btn btn-default' },
	          __('Cancel', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'button',
	          { onClick: this.onSubmit, className: 'btn btn-primary' },
	          __('Submit', _locale2.default)
	        )
	      )
	    );
	  };
	
	  return NavSetting;
	}(_react2.default.Component);
	
	exports.default = NavSetting;
	module.exports = exports['default'];

/***/ },

/***/ "aEdv":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'WebsiteSideMenu',
	  code: 'CN',
	  text: {
	    'Language': '网站语言',
	    'Website Settings': '网站设置',
	    'Website URL': '网站地址',
	    'Nav Settings': '导航设置',
	    'Theme Settings': '模版设置',
	    'Select Theme': '模版选择',
	    'Edit Page': '页面编辑',
	    'Edit Form': '表格编辑',
	    'Header Navigation': '顶部导航'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ "O2q3":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PageEditor":"PageEditor","isEdit":"isEdit","PageEditor--deletePage":"PageEditor--deletePage","PageEditor--content":"PageEditor--content","PageEditor--formWrapper":"PageEditor--formWrapper","btn-wrapper":"btn-wrapper"};

/***/ },

/***/ "qZd9":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("O2q3");
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _locale = __webpack_require__("bsDf");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <PageEditor 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var PageEditor = function (_React$Component) {
	  _inherits(PageEditor, _React$Component);
	
	  function PageEditor(props) {
	    _classCallCheck(this, PageEditor);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      page: {}
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    return _this;
	  }
	
	  PageEditor.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var page = _ref.page;
	
	    if (page) {
	      this.setState({
	        page: page
	      });
	    }
	  };
	
	  PageEditor.prototype.componentWillMount = function componentWillMount() {};
	
	  PageEditor.prototype.onSubmit = function onSubmit() {
	    this.props.onSubmit(this.state.page);
	  };
	
	  PageEditor.prototype.onChange = function onChange(page) {
	    this.setState({
	      page: page
	    });
	  };
	
	  PageEditor.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        isEdit = _props.isEdit,
	        onSubmit = _props.onSubmit,
	        onClose = _props.onClose;
	    var page = this.state.page;
	
	
	    var editPageSchema = [{
	      name: 'title',
	      label: __('Page Title', _locale2.default),
	      type: "text"
	    }, {
	      name: 'page_setting.slug',
	      label: __('Slug', _locale2.default),
	      placeholder: '/example',
	      type: "text"
	    }, {
	      name: 'page_setting.meta',
	      label: __('Meta Data', _locale2.default),
	      type: "objectArray",
	      max: 50,
	      objectSchema: [{
	        name: 'name',
	        label: __('Name', _locale2.default),
	        type: 'text'
	      }, {
	        name: 'content',
	        label: __('Content', _locale2.default),
	        type: 'textarea'
	      }]
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('PageEditor', { isEdit: isEdit }) },
	      _react2.default.createElement(
	        'div',
	        { className: 'PageEditor--content', ref: function ref(r) {
	            _this2.scrollingContainerRef = r;
	          } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          page.title || __('New Page', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'PageEditor--formWrapper' },
	          _react2.default.createElement(_Form2.default, {
	            onChange: this.onChange,
	            schema: editPageSchema,
	            formData: page,
	            formStyle: 'outline'
	            // getValidationRef={getValidationRef}
	            , scrollingContainerRef: this.scrollingContainerRef
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'btn-wrapper' },
	            _react2.default.createElement(
	              'button',
	              { onClick: onClose, className: 'btn btn-default' },
	              __('Cancel', _locale2.default)
	            ),
	            _react2.default.createElement(
	              'button',
	              { onClick: this.onSubmit, className: 'btn btn-primary' },
	              __('Submit', _locale2.default)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'a',
	                { onClick: this.onDelete, className: 'btn-link PageEditor--deletePage' },
	                __('Delete this page', _locale2.default)
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return PageEditor;
	}(_react2.default.Component);
	
	exports.default = PageEditor;
	module.exports = exports['default'];

/***/ },

/***/ "bsDf":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  id: 'PageEditor',
	  code: 'CN',
	  text: {}
	};
	module.exports = exports['default'];

/***/ },

/***/ "aDmQ":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"WebsitePreview":"WebsitePreview"};

/***/ },

/***/ "/OJU":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("aDmQ");
	
	var _urlJoin = __webpack_require__("mTx5");
	
	var _urlJoin2 = _interopRequireDefault(_urlJoin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <Preview 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Preview = function (_React$Component) {
	  _inherits(Preview, _React$Component);
	
	  function Preview(props) {
	    _classCallCheck(this, Preview);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleMessageFromIframe = _this.handleMessageFromIframe.bind(_this);
	    return _this;
	  }
	
	  Preview.prototype.componentWillMount = function componentWillMount() {
	    window.addEventListener('message', this.handleMessageFromIframe, false);
	  };
	
	  Preview.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('message', this.handleMessageFromIframe);
	  };
	
	  Preview.prototype.handleMessageFromIframe = function handleMessageFromIframe(e) {
	    if (e.data && e.data.type) {
	      switch (e.data.type) {
	        case "startEdit":
	          {
	            this.props.onStartEdit(e.data);
	            break;
	          }
	        case "addComponent":
	          {
	            this.props.onAddComponent(e.data);
	            break;
	          }
	        case "moveComponent":
	          {
	            this.props.onMoveComponent(e.data);
	            break;
	          }
	        case "deleteComponent":
	          {
	            this.props.onDeleteComponent(e.data);
	            break;
	          }
	        case "LOADED":
	          {
	            this.props.onIframeLoaded(e.data);
	            break;
	          }
	
	      }
	    }
	  };
	
	  Preview.prototype.render = function render() {
	    var _props = this.props,
	        isEdit = _props.isEdit,
	        registerIframeRef = _props.registerIframeRef,
	        currentPagePath = _props.currentPagePath;
	
	
	    var schoolId = localStorage.getItem('schoolId');
	
	    var token = localStorage.getItem('token');
	
	    var origin = window.location.origin;
	
	    var src = (0, _urlJoin2.default)(origin + ':8081', schoolId, currentPagePath);
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('WebsitePreview') },
	      _react2.default.createElement('iframe', { src: src + '?mode=edit&t=' + token, ref: registerIframeRef })
	    );
	  };
	
	  return Preview;
	}(_react2.default.Component);
	
	exports.default = Preview;
	module.exports = exports['default'];

/***/ },

/***/ "Ao9G":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"SelectTheme--item":"SelectTheme--item","selected":"selected","SelectTheme--image":"SelectTheme--image","SelectTheme--list":"SelectTheme--list"};

/***/ },

/***/ "7yNn":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "theme1.55c47379.jpg";

/***/ },

/***/ "u3wL":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("Ao9G");
	
	var _theme = __webpack_require__("7yNn");
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <SelectTheme 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	// temp
	
	
	var SelectTheme = function (_React$Component) {
	  _inherits(SelectTheme, _React$Component);
	
	  function SelectTheme(props) {
	    _classCallCheck(this, SelectTheme);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  SelectTheme.prototype.componentWillMount = function componentWillMount() {};
	
	  SelectTheme.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'SelectTheme' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'SelectTheme--list' },
	        _react2.default.createElement(
	          'li',
	          { className: (0, _classnames2.default)('SelectTheme--item', 'selected') },
	          _react2.default.createElement('div', { className: 'SelectTheme--image', style: { backgroundImage: 'url(' + _theme2.default + ')' } })
	        )
	      )
	    );
	  };
	
	  return SelectTheme;
	}(_react2.default.Component);
	
	exports.default = SelectTheme;
	module.exports = exports['default'];

/***/ },

/***/ "d2qg":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ThemeSetting":"ThemeSetting","btn-wrapper":"btn-wrapper","ThemeSetting--content":"ThemeSetting--content"};

/***/ },

/***/ "ZtKT":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _locale = __webpack_require__("aEdv");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("d2qg");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <ThemeSetting 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ThemeSetting = function (_React$Component) {
	  _inherits(ThemeSetting, _React$Component);
	
	  function ThemeSetting(props) {
	    _classCallCheck(this, ThemeSetting);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onSubmit = _this.onSubmit.bind(_this);
	
	    _this.state = {
	      site: {}
	    };
	
	    _this.getValidationRef = _this.getValidationRef.bind(_this);
	    return _this;
	  }
	
	  ThemeSetting.prototype.onChange = function onChange(themeSetting) {
	    this.setState({
	      site: _extends({}, this.state.site, {
	        themeSetting: themeSetting
	      })
	    });
	  };
	
	  ThemeSetting.prototype.componentWillMount = function componentWillMount() {};
	
	  ThemeSetting.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (props.site) {
	      this.setState({
	        site: props.site
	      });
	    }
	  };
	
	  ThemeSetting.prototype.getValidationRef = function getValidationRef(validateFn) {
	    this.validateFn = validateFn;
	  };
	
	  ThemeSetting.prototype.onSubmit = function onSubmit() {
	    this.props.onSubmitThemeSetting(this.state.site);
	  };
	
	  ThemeSetting.prototype.onChange = function onChange(themeSetting) {
	    this.setState({
	      site: _extends({}, this.state.site, {
	        themeSetting: themeSetting
	      })
	    });
	  };
	
	  ThemeSetting.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        settingSchema = _props.settingSchema,
	        onCloseThemeSetting = _props.onCloseThemeSetting,
	        onSubmitThemeSetting = _props.onSubmitThemeSetting;
	    var site = this.state.site;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'ThemeSetting' },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('ThemeSetting--content'), ref: function ref(r) {
	            _this2.scrollingContainerRef = r;
	          } },
	        settingSchema.map(function (schema, index) {
	          return _react2.default.createElement(_Form2.default, {
	            key: index,
	            onChange: _this2.onChange,
	            schema: schema.fields,
	            formData: site.themeSetting,
	            formStyle: 'outline',
	            getValidationRef: _this2.getValidationRef,
	            scrollingContainerRef: _this2.scrollingContainerRef
	          });
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'btn-wrapper' },
	        _react2.default.createElement(
	          'button',
	          { onClick: onCloseThemeSetting, className: 'btn btn-default' },
	          __('Cancel', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'button',
	          { onClick: this.onSubmit, className: 'btn btn-primary' },
	          __('Submit', _locale2.default)
	        )
	      )
	    );
	  };
	
	  return ThemeSetting;
	}(_react2.default.Component);
	
	exports.default = ThemeSetting;
	module.exports = exports['default'];

/***/ },

/***/ "D/tK":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Website":"Website","editMask":"editMask","isEdit":"isEdit"};

/***/ },

/***/ "sKzI":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"WebsiteSetting":"WebsiteSetting","btn-wrapper":"btn-wrapper","WebsiteSetting--content":"WebsiteSetting--content"};

/***/ },

/***/ "DEdD":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Form = __webpack_require__("RYFX");
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _locale = __webpack_require__("aEdv");
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__("sKzI");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <WebsiteSetting 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var WebsiteSetting = function (_React$Component) {
	  _inherits(WebsiteSetting, _React$Component);
	
	  function WebsiteSetting(props) {
	    _classCallCheck(this, WebsiteSetting);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.getValidationRef = _this.getValidationRef.bind(_this);
	
	    _this.state = {
	      site: {}
	    };
	
	    _this.schema = [{
	      label: __('Language', _locale2.default),
	      name: "locale",
	      type: "select",
	      options: [{ label: "English", value: "en" }, { label: "简体中文", value: "zh-Hans" }]
	    }, {
	      label: __('Website URL', _locale2.default),
	      name: "siteUrl",
	      type: "text"
	    }];
	    return _this;
	  }
	
	  WebsiteSetting.prototype.componentWillMount = function componentWillMount() {};
	
	  WebsiteSetting.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (props.site) {
	      this.setState({
	        site: props.site
	      });
	    }
	  };
	
	  WebsiteSetting.prototype.getValidationRef = function getValidationRef(validateFn) {
	    this.validateFn = validateFn;
	  };
	
	  WebsiteSetting.prototype.onChange = function onChange(changes) {
	    this.setState({
	      site: _extends({}, this.state.site, changes)
	    });
	  };
	
	  WebsiteSetting.prototype.onSubmit = function onSubmit() {
	    this.props.onSubmit(this.state.site);
	  };
	
	  WebsiteSetting.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        onClose = _props.onClose,
	        onSubmit = _props.onSubmit;
	    var site = this.state.site;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'WebsiteSetting' },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('WebsiteSetting--content'), ref: function ref(r) {
	            _this2.scrollingContainerRef = r;
	          } },
	        _react2.default.createElement(_Form2.default, {
	          onChange: this.onChange,
	          schema: this.schema,
	          formData: site,
	          formStyle: 'outline',
	          getValidationRef: this.getValidationRef,
	          scrollingContainerRef: this.scrollingContainerRef
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'btn-wrapper' },
	        _react2.default.createElement(
	          'button',
	          { onClick: onClose, className: 'btn btn-default' },
	          __('Cancel', _locale2.default)
	        ),
	        _react2.default.createElement(
	          'button',
	          { onClick: this.onSubmit, className: 'btn btn-primary' },
	          __('Submit', _locale2.default)
	        )
	      )
	    );
	  };
	
	  return WebsiteSetting;
	}(_react2.default.Component);
	
	exports.default = WebsiteSetting;
	module.exports = exports['default'];

/***/ },

/***/ "eSMJ":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"MultiLevelSideMenu":"MultiLevelSideMenu","MultiLevelSideMenu--content":"MultiLevelSideMenu--content","MultiLevelSideMenu--menu":"MultiLevelSideMenu--menu","MultiLevelSideMenu--menu--item":"MultiLevelSideMenu--menu--item","MultiLevelSideMenu--back":"MultiLevelSideMenu--back","MultiLevelSideMenu--slidable":"MultiLevelSideMenu--slidable","transitionBack":"transitionBack"};

/***/ },

/***/ "fU3o":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("HW6M");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectPath = __webpack_require__("SeUI");
	
	var _objectPath2 = _interopRequireDefault(_objectPath);
	
	__webpack_require__("eSMJ");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <MultiLevelSideMenu 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *		// please describe props here
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *	/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @parent anybody
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @children 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateful
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @stateless
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var MultiLevelSideMenu = function (_React$Component) {
	  _inherits(MultiLevelSideMenu, _React$Component);
	
	  function MultiLevelSideMenu(props) {
	    _classCallCheck(this, MultiLevelSideMenu);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      currentMenu: props.menu,
	      menuHistory: []
	    };
	
	    _this.backToPrevious = _this.backToPrevious.bind(_this);
	    return _this;
	  }
	
	  MultiLevelSideMenu.prototype.componentWillMount = function componentWillMount() {
	    this.props.getMethodsOnLoad({
	      getPreviousMenu: this.getPreviousMenu.bind(this),
	      backToPrevious: this.backToPrevious.bind(this)
	    });
	  };
	
	  MultiLevelSideMenu.prototype.getPreviousMenu = function getPreviousMenu() {
	    var menuHistory = this.state.menuHistory;
	
	
	    if (menuHistory.length > 0) {
	      return menuHistory[menuHistory.length - 1];
	    } else {
	      return;
	    }
	  };
	
	  MultiLevelSideMenu.prototype.backToPrevious = function backToPrevious() {
	    var _this2 = this;
	
	    var menuHistory = _.cloneDeep(this.state.menuHistory);
	
	    var previousMenu = this.getPreviousMenu();
	
	    var currentMenu = _.cloneDeep(previousMenu);
	
	    this.setState({
	      transitionBack: true
	    });
	
	    setTimeout(function () {
	      menuHistory.splice(menuHistory.length - 1, 1);
	      _this2.setState({
	        menuHistory: menuHistory,
	        currentMenu: currentMenu
	      });
	      setTimeout(function () {
	        _this2.setState({
	          transitionBack: false
	        });
	      }, 50);
	    }, 500);
	  };
	
	  MultiLevelSideMenu.prototype.selectSideMenu = function selectSideMenu(currentMenu) {
	    var _this3 = this;
	
	    return function () {
	      _this3.setState({
	        transitionBack: true
	      });
	
	      setTimeout(function () {
	        _this3.setState({
	          menuHistory: [].concat(_this3.state.previousMenu, [_.cloneDeep(_this3.state.currentMenu)]),
	          currentMenu: currentMenu
	        });
	        setTimeout(function () {
	          _this3.setState({
	            transitionBack: false
	          });
	        }, 50);
	      }, 500);
	    };
	  };
	
	  MultiLevelSideMenu.prototype.render = function render() {
	    var _this4 = this;
	
	    var _state = this.state,
	        currentMenu = _state.currentMenu,
	        transitionBack = _state.transitionBack;
	    var _state$currentMenu = this.state.currentMenu,
	        _state$currentMenu$it = _state$currentMenu.items,
	        items = _state$currentMenu$it === undefined ? [] : _state$currentMenu$it,
	        title = _state$currentMenu.title,
	        component = _state$currentMenu.component,
	        width = _state$currentMenu.width;
	
	
	    var previousMenu = this.getPreviousMenu();
	
	    var style = typeof width == 'undefined' ? {} : { width: width };
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'MultiLevelSideMenu', style: style },
	      _react2.default.createElement(
	        'div',
	        { className: 'MultiLevelSideMenu--content' },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('MultiLevelSideMenu--slidable', { transitionBack: transitionBack }) },
	          _react2.default.createElement(
	            'div',
	            { className: 'MultiLevelSideMenu--back' },
	            previousMenu && _react2.default.createElement(
	              'a',
	              { onClick: this.backToPrevious },
	              previousMenu.title
	            )
	          ),
	          _react2.default.createElement(
	            'label',
	            null,
	            title
	          ),
	          typeof component == 'function' && component(),
	          items.length > 0 && _react2.default.createElement(
	            'ul',
	            { className: 'MultiLevelSideMenu--menu' },
	            items.map(function (menu) {
	              var title = menu.title,
	                  icon = menu.icon;
	
	              return _react2.default.createElement(
	                'li',
	                { className: 'MultiLevelSideMenu--menu--item' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'MultiLevelSideMnu--label', onClick: _this4.selectSideMenu(menu) },
	                  title
	                ),
	                _react2.default.createElement('i', { className: (0, _classnames2.default)('icon', icon) })
	              );
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return MultiLevelSideMenu;
	}(_react2.default.Component);
	
	exports.default = MultiLevelSideMenu;
	module.exports = exports['default'];

/***/ },

/***/ "Wa4b":
/***/ function(module, exports) {

	"use strict";

/***/ },

/***/ "s4Vs":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = startTrial;
	
	var _axios = __webpack_require__("mtWM");
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__("hxne");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function startTrial() {
		return new Promise(function (resolve, reject) {
			_axios2.default.put(_config.APIAddress, { 'uri': '/trial/',
				'method': 'POST',
				'token': localStorage.getItem('token') }).then(function (res) {
				resolve(res.data);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
	module.exports = exports["default"];

/***/ }

});


// WEBPACK FOOTER //
// app.84ac2a1c.js